(self["webpackChunkapp_bedrock_rdk"] = self["webpackChunkapp_bedrock_rdk"] || []).push([[736],{

/***/ 6927:
/***/ (function(module) {

/*! algoliasearch.umd.js | 4.12.1 | © Algolia, inc. | https://github.com/algolia/algoliasearch-client-javascript */
!function(t,e){ true?module.exports=e():0}(this,(function(){"use strict";function t(t,e,r){return e in t?Object.defineProperty(t,e,{value:r,enumerable:!0,configurable:!0,writable:!0}):t[e]=r,t}function e(t,e){var r=Object.keys(t);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(t);e&&(n=n.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),r.push.apply(r,n)}return r}function r(r){for(var n=1;n<arguments.length;n++){var a=null!=arguments[n]?arguments[n]:{};n%2?e(Object(a),!0).forEach((function(e){t(r,e,a[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(r,Object.getOwnPropertyDescriptors(a)):e(Object(a)).forEach((function(t){Object.defineProperty(r,t,Object.getOwnPropertyDescriptor(a,t))}))}return r}function n(t,e){if(null==t)return{};var r,n,a=function(t,e){if(null==t)return{};var r,n,a={},o=Object.keys(t);for(n=0;n<o.length;n++)r=o[n],e.indexOf(r)>=0||(a[r]=t[r]);return a}(t,e);if(Object.getOwnPropertySymbols){var o=Object.getOwnPropertySymbols(t);for(n=0;n<o.length;n++)r=o[n],e.indexOf(r)>=0||Object.prototype.propertyIsEnumerable.call(t,r)&&(a[r]=t[r])}return a}function a(t,e){return function(t){if(Array.isArray(t))return t}(t)||function(t,e){if(!(Symbol.iterator in Object(t)||"[object Arguments]"===Object.prototype.toString.call(t)))return;var r=[],n=!0,a=!1,o=void 0;try{for(var i,u=t[Symbol.iterator]();!(n=(i=u.next()).done)&&(r.push(i.value),!e||r.length!==e);n=!0);}catch(t){a=!0,o=t}finally{try{n||null==u.return||u.return()}finally{if(a)throw o}}return r}(t,e)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}()}function o(t){return function(t){if(Array.isArray(t)){for(var e=0,r=new Array(t.length);e<t.length;e++)r[e]=t[e];return r}}(t)||function(t){if(Symbol.iterator in Object(t)||"[object Arguments]"===Object.prototype.toString.call(t))return Array.from(t)}(t)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}function i(t){var e,r="algoliasearch-client-js-".concat(t.key),n=function(){return void 0===e&&(e=t.localStorage||window.localStorage),e},o=function(){return JSON.parse(n().getItem(r)||"{}")};return{get:function(t,e){var r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{miss:function(){return Promise.resolve()}};return Promise.resolve().then((function(){var r=JSON.stringify(t),n=o()[r];return Promise.all([n||e(),void 0!==n])})).then((function(t){var e=a(t,2),n=e[0],o=e[1];return Promise.all([n,o||r.miss(n)])})).then((function(t){return a(t,1)[0]}))},set:function(t,e){return Promise.resolve().then((function(){var a=o();return a[JSON.stringify(t)]=e,n().setItem(r,JSON.stringify(a)),e}))},delete:function(t){return Promise.resolve().then((function(){var e=o();delete e[JSON.stringify(t)],n().setItem(r,JSON.stringify(e))}))},clear:function(){return Promise.resolve().then((function(){n().removeItem(r)}))}}}function u(t){var e=o(t.caches),r=e.shift();return void 0===r?{get:function(t,e){var r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{miss:function(){return Promise.resolve()}},n=e();return n.then((function(t){return Promise.all([t,r.miss(t)])})).then((function(t){return a(t,1)[0]}))},set:function(t,e){return Promise.resolve(e)},delete:function(t){return Promise.resolve()},clear:function(){return Promise.resolve()}}:{get:function(t,n){var a=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{miss:function(){return Promise.resolve()}};return r.get(t,n,a).catch((function(){return u({caches:e}).get(t,n,a)}))},set:function(t,n){return r.set(t,n).catch((function(){return u({caches:e}).set(t,n)}))},delete:function(t){return r.delete(t).catch((function(){return u({caches:e}).delete(t)}))},clear:function(){return r.clear().catch((function(){return u({caches:e}).clear()}))}}}function s(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{serializable:!0},e={};return{get:function(r,n){var a=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{miss:function(){return Promise.resolve()}},o=JSON.stringify(r);if(o in e)return Promise.resolve(t.serializable?JSON.parse(e[o]):e[o]);var i=n(),u=a&&a.miss||function(){return Promise.resolve()};return i.then((function(t){return u(t)})).then((function(){return i}))},set:function(r,n){return e[JSON.stringify(r)]=t.serializable?JSON.stringify(n):n,Promise.resolve(n)},delete:function(t){return delete e[JSON.stringify(t)],Promise.resolve()},clear:function(){return e={},Promise.resolve()}}}function c(t,e,r){var n={"x-algolia-api-key":r,"x-algolia-application-id":e};return{headers:function(){return t===m.WithinHeaders?n:{}},queryParameters:function(){return t===m.WithinQueryParameters?n:{}}}}function f(t){var e=0;return t((function r(){return e++,new Promise((function(n){setTimeout((function(){n(t(r))}),Math.min(100*e,1e3))}))}))}function d(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:function(t,e){return Promise.resolve()};return Object.assign(t,{wait:function(r){return d(t.then((function(t){return Promise.all([e(t,r),t])})).then((function(t){return t[1]})))}})}function l(t){for(var e=t.length-1;e>0;e--){var r=Math.floor(Math.random()*(e+1)),n=t[e];t[e]=t[r],t[r]=n}return t}function p(t,e){return e?(Object.keys(e).forEach((function(r){t[r]=e[r](t)})),t):t}function h(t){for(var e=arguments.length,r=new Array(e>1?e-1:0),n=1;n<e;n++)r[n-1]=arguments[n];var a=0;return t.replace(/%s/g,(function(){return encodeURIComponent(r[a++])}))}var m={WithinQueryParameters:0,WithinHeaders:1};function y(t,e){var r=t||{},n=r.data||{};return Object.keys(r).forEach((function(t){-1===["timeout","headers","queryParameters","data","cacheable"].indexOf(t)&&(n[t]=r[t])})),{data:Object.entries(n).length>0?n:void 0,timeout:r.timeout||e,headers:r.headers||{},queryParameters:r.queryParameters||{},cacheable:r.cacheable}}var g={Read:1,Write:2,Any:3},v=1,b=2,P=3;function w(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:v;return r(r({},t),{},{status:e,lastUpdate:Date.now()})}function O(t){return"string"==typeof t?{protocol:"https",url:t,accept:g.Any}:{protocol:t.protocol||"https",url:t.url,accept:t.accept||g.Any}}var I="DELETE",x="GET",j="POST",D="PUT";function q(t,e){return Promise.all(e.map((function(e){return t.get(e,(function(){return Promise.resolve(w(e))}))}))).then((function(t){var r=t.filter((function(t){return function(t){return t.status===v||Date.now()-t.lastUpdate>12e4}(t)})),n=t.filter((function(t){return function(t){return t.status===P&&Date.now()-t.lastUpdate<=12e4}(t)})),a=[].concat(o(r),o(n));return{getTimeout:function(t,e){return(0===n.length&&0===t?1:n.length+3+t)*e},statelessHosts:a.length>0?a.map((function(t){return O(t)})):e}}))}function S(t,e,n,a){var i=[],u=function(t,e){if(t.method===x||void 0===t.data&&void 0===e.data)return;var n=Array.isArray(t.data)?t.data:r(r({},t.data),e.data);return JSON.stringify(n)}(n,a),s=function(t,e){var n=r(r({},t.headers),e.headers),a={};return Object.keys(n).forEach((function(t){var e=n[t];a[t.toLowerCase()]=e})),a}(t,a),c=n.method,f=n.method!==x?{}:r(r({},n.data),a.data),d=r(r(r({"x-algolia-agent":t.userAgent.value},t.queryParameters),f),a.queryParameters),l=0,p=function e(r,o){var f=r.pop();if(void 0===f)throw{name:"RetryError",message:"Unreachable hosts - your application id may be incorrect. If the error persists, contact support@algolia.com.",transporterStackTrace:R(i)};var p={data:u,headers:s,method:c,url:N(f,n.path,d),connectTimeout:o(l,t.timeouts.connect),responseTimeout:o(l,a.timeout)},h=function(t){var e={request:p,response:t,host:f,triesLeft:r.length};return i.push(e),e},m={onSuccess:function(t){return function(t){try{return JSON.parse(t.content)}catch(e){throw function(t,e){return{name:"DeserializationError",message:t,response:e}}(e.message,t)}}(t)},onRetry:function(n){var a=h(n);return n.isTimedOut&&l++,Promise.all([t.logger.info("Retryable failure",A(a)),t.hostsCache.set(f,w(f,n.isTimedOut?P:b))]).then((function(){return e(r,o)}))},onFail:function(t){throw h(t),function(t,e){var r=t.content,n=t.status,a=r;try{a=JSON.parse(r).message}catch(t){}return function(t,e,r){return{name:"ApiError",message:t,status:e,transporterStackTrace:r}}(a,n,e)}(t,R(i))}};return t.requester.send(p).then((function(t){return function(t,e){return function(t){var e=t.status;return t.isTimedOut||function(t){var e=t.isTimedOut,r=t.status;return!e&&0==~~r}(t)||2!=~~(e/100)&&4!=~~(e/100)}(t)?e.onRetry(t):2==~~(t.status/100)?e.onSuccess(t):e.onFail(t)}(t,m)}))};return q(t.hostsCache,e).then((function(t){return p(o(t.statelessHosts).reverse(),t.getTimeout)}))}function k(t){var e=t.hostsCache,r=t.logger,n=t.requester,o=t.requestsCache,i=t.responsesCache,u=t.timeouts,s=t.userAgent,c=t.hosts,f=t.queryParameters,d={hostsCache:e,logger:r,requester:n,requestsCache:o,responsesCache:i,timeouts:u,userAgent:s,headers:t.headers,queryParameters:f,hosts:c.map((function(t){return O(t)})),read:function(t,e){var r=y(e,d.timeouts.read),n=function(){return S(d,d.hosts.filter((function(t){return 0!=(t.accept&g.Read)})),t,r)};if(!0!==(void 0!==r.cacheable?r.cacheable:t.cacheable))return n();var o={request:t,mappedRequestOptions:r,transporter:{queryParameters:d.queryParameters,headers:d.headers}};return d.responsesCache.get(o,(function(){return d.requestsCache.get(o,(function(){return d.requestsCache.set(o,n()).then((function(t){return Promise.all([d.requestsCache.delete(o),t])}),(function(t){return Promise.all([d.requestsCache.delete(o),Promise.reject(t)])})).then((function(t){var e=a(t,2);e[0];return e[1]}))}))}),{miss:function(t){return d.responsesCache.set(o,t)}})},write:function(t,e){return S(d,d.hosts.filter((function(t){return 0!=(t.accept&g.Write)})),t,y(e,d.timeouts.write))}};return d}function T(t){var e={value:"Algolia for JavaScript (".concat(t,")"),add:function(t){var r="; ".concat(t.segment).concat(void 0!==t.version?" (".concat(t.version,")"):"");return-1===e.value.indexOf(r)&&(e.value="".concat(e.value).concat(r)),e}};return e}function N(t,e,r){var n=E(r),a="".concat(t.protocol,"://").concat(t.url,"/").concat("/"===e.charAt(0)?e.substr(1):e);return n.length&&(a+="?".concat(n)),a}function E(t){return Object.keys(t).map((function(e){return h("%s=%s",e,(r=t[e],"[object Object]"===Object.prototype.toString.call(r)||"[object Array]"===Object.prototype.toString.call(r)?JSON.stringify(t[e]):t[e]));var r})).join("&")}function R(t){return t.map((function(t){return A(t)}))}function A(t){var e=t.request.headers["x-algolia-api-key"]?{"x-algolia-api-key":"*****"}:{};return r(r({},t),{},{request:r(r({},t.request),{},{headers:r(r({},t.request.headers),e)})})}var C=function(t){return function(e,r){return t.transporter.write({method:j,path:"2/abtests",data:e},r)}},U=function(t){return function(e,r){return t.transporter.write({method:I,path:h("2/abtests/%s",e)},r)}},z=function(t){return function(e,r){return t.transporter.read({method:x,path:h("2/abtests/%s",e)},r)}},J=function(t){return function(e){return t.transporter.read({method:x,path:"2/abtests"},e)}},F=function(t){return function(e,r){return t.transporter.write({method:j,path:h("2/abtests/%s/stop",e)},r)}},H=function(t){return function(e){return t.transporter.read({method:x,path:"1/strategies/personalization"},e)}},M=function(t){return function(e,r){return t.transporter.write({method:j,path:"1/strategies/personalization",data:e},r)}};function K(t){return function e(r){return t.request(r).then((function(n){if(void 0!==t.batch&&t.batch(n.hits),!t.shouldStop(n))return n.cursor?e({cursor:n.cursor}):e({page:(r.page||0)+1})}))}({})}var W=function(t){return function(e,a){var o=a||{},i=o.queryParameters,u=n(o,["queryParameters"]),s=r({acl:e},void 0!==i?{queryParameters:i}:{});return d(t.transporter.write({method:j,path:"1/keys",data:s},u),(function(e,r){return f((function(n){return tt(t)(e.key,r).catch((function(t){if(404!==t.status)throw t;return n()}))}))}))}},B=function(t){return function(e,r,n){var a=y(n);return a.queryParameters["X-Algolia-User-ID"]=e,t.transporter.write({method:j,path:"1/clusters/mapping",data:{cluster:r}},a)}},Q=function(t){return function(e,r,n){return t.transporter.write({method:j,path:"1/clusters/mapping/batch",data:{users:e,cluster:r}},n)}},G=function(t){return function(e,r){return d(t.transporter.write({method:j,path:h("/1/dictionaries/%s/batch",e),data:{clearExistingDictionaryEntries:!0,requests:{action:"addEntry",body:[]}}},r),(function(e,r){return jt(t)(e.taskID,r)}))}},L=function(t){return function(e,r,n){return d(t.transporter.write({method:j,path:h("1/indexes/%s/operation",e),data:{operation:"copy",destination:r}},n),(function(r,n){return ut(t)(e,{methods:{waitTask:de}}).waitTask(r.taskID,n)}))}},V=function(t){return function(e,n,a){return L(t)(e,n,r(r({},a),{},{scope:[pe.Rules]}))}},_=function(t){return function(e,n,a){return L(t)(e,n,r(r({},a),{},{scope:[pe.Settings]}))}},X=function(t){return function(e,n,a){return L(t)(e,n,r(r({},a),{},{scope:[pe.Synonyms]}))}},Y=function(t){return function(e,r){return e.method===x?t.transporter.read(e,r):t.transporter.write(e,r)}},Z=function(t){return function(e,r){return d(t.transporter.write({method:I,path:h("1/keys/%s",e)},r),(function(r,n){return f((function(r){return tt(t)(e,n).then(r).catch((function(t){if(404!==t.status)throw t}))}))}))}},$=function(t){return function(e,r,n){var a=r.map((function(t){return{action:"deleteEntry",body:{objectID:t}}}));return d(t.transporter.write({method:j,path:h("/1/dictionaries/%s/batch",e),data:{clearExistingDictionaryEntries:!1,requests:a}},n),(function(e,r){return jt(t)(e.taskID,r)}))}},tt=function(t){return function(e,r){return t.transporter.read({method:x,path:h("1/keys/%s",e)},r)}},et=function(t){return function(e,r){return t.transporter.read({method:x,path:h("1/task/%s",e.toString())},r)}},rt=function(t){return function(e){return t.transporter.read({method:x,path:"/1/dictionaries/*/settings"},e)}},nt=function(t){return function(e){return t.transporter.read({method:x,path:"1/logs"},e)}},at=function(t){return function(e){return t.transporter.read({method:x,path:"1/clusters/mapping/top"},e)}},ot=function(t){return function(e,r){return t.transporter.read({method:x,path:h("1/clusters/mapping/%s",e)},r)}},it=function(t){return function(e){var r=e||{},a=r.retrieveMappings,o=n(r,["retrieveMappings"]);return!0===a&&(o.getClusters=!0),t.transporter.read({method:x,path:"1/clusters/mapping/pending"},o)}},ut=function(t){return function(e){var r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n={transporter:t.transporter,appId:t.appId,indexName:e};return p(n,r.methods)}},st=function(t){return function(e){return t.transporter.read({method:x,path:"1/keys"},e)}},ct=function(t){return function(e){return t.transporter.read({method:x,path:"1/clusters"},e)}},ft=function(t){return function(e){return t.transporter.read({method:x,path:"1/indexes"},e)}},dt=function(t){return function(e){return t.transporter.read({method:x,path:"1/clusters/mapping"},e)}},lt=function(t){return function(e,r,n){return d(t.transporter.write({method:j,path:h("1/indexes/%s/operation",e),data:{operation:"move",destination:r}},n),(function(r,n){return ut(t)(e,{methods:{waitTask:de}}).waitTask(r.taskID,n)}))}},pt=function(t){return function(e,r){return d(t.transporter.write({method:j,path:"1/indexes/*/batch",data:{requests:e}},r),(function(e,r){return Promise.all(Object.keys(e.taskID).map((function(n){return ut(t)(n,{methods:{waitTask:de}}).waitTask(e.taskID[n],r)})))}))}},ht=function(t){return function(e,r){return t.transporter.read({method:j,path:"1/indexes/*/objects",data:{requests:e}},r)}},mt=function(t){return function(e,n){var a=e.map((function(t){return r(r({},t),{},{params:E(t.params||{})})}));return t.transporter.read({method:j,path:"1/indexes/*/queries",data:{requests:a},cacheable:!0},n)}},yt=function(t){return function(e,a){return Promise.all(e.map((function(e){var o=e.params,i=o.facetName,u=o.facetQuery,s=n(o,["facetName","facetQuery"]);return ut(t)(e.indexName,{methods:{searchForFacetValues:ue}}).searchForFacetValues(i,u,r(r({},a),s))})))}},gt=function(t){return function(e,r){var n=y(r);return n.queryParameters["X-Algolia-User-ID"]=e,t.transporter.write({method:I,path:"1/clusters/mapping"},n)}},vt=function(t){return function(e,r,n){var a=r.map((function(t){return{action:"addEntry",body:t}}));return d(t.transporter.write({method:j,path:h("/1/dictionaries/%s/batch",e),data:{clearExistingDictionaryEntries:!0,requests:a}},n),(function(e,r){return jt(t)(e.taskID,r)}))}},bt=function(t){return function(e,r){return d(t.transporter.write({method:j,path:h("1/keys/%s/restore",e)},r),(function(r,n){return f((function(r){return tt(t)(e,n).catch((function(t){if(404!==t.status)throw t;return r()}))}))}))}},Pt=function(t){return function(e,r,n){var a=r.map((function(t){return{action:"addEntry",body:t}}));return d(t.transporter.write({method:j,path:h("/1/dictionaries/%s/batch",e),data:{clearExistingDictionaryEntries:!1,requests:a}},n),(function(e,r){return jt(t)(e.taskID,r)}))}},wt=function(t){return function(e,r,n){return t.transporter.read({method:j,path:h("/1/dictionaries/%s/search",e),data:{query:r},cacheable:!0},n)}},Ot=function(t){return function(e,r){return t.transporter.read({method:j,path:"1/clusters/mapping/search",data:{query:e}},r)}},It=function(t){return function(e,r){return d(t.transporter.write({method:D,path:"/1/dictionaries/*/settings",data:e},r),(function(e,r){return jt(t)(e.taskID,r)}))}},xt=function(t){return function(e,r){var a=Object.assign({},r),o=r||{},i=o.queryParameters,u=n(o,["queryParameters"]),s=i?{queryParameters:i}:{},c=["acl","indexes","referers","restrictSources","queryParameters","description","maxQueriesPerIPPerHour","maxHitsPerQuery"];return d(t.transporter.write({method:D,path:h("1/keys/%s",e),data:s},u),(function(r,n){return f((function(r){return tt(t)(e,n).then((function(t){return function(t){return Object.keys(a).filter((function(t){return-1!==c.indexOf(t)})).every((function(e){return t[e]===a[e]}))}(t)?Promise.resolve():r()}))}))}))}},jt=function(t){return function(e,r){return f((function(n){return et(t)(e,r).then((function(t){return"published"!==t.status?n():void 0}))}))}},Dt=function(t){return function(e,r){return d(t.transporter.write({method:j,path:h("1/indexes/%s/batch",t.indexName),data:{requests:e}},r),(function(e,r){return de(t)(e.taskID,r)}))}},qt=function(t){return function(e){return K(r(r({shouldStop:function(t){return void 0===t.cursor}},e),{},{request:function(r){return t.transporter.read({method:j,path:h("1/indexes/%s/browse",t.indexName),data:r},e)}}))}},St=function(t){return function(e){var n=r({hitsPerPage:1e3},e);return K(r(r({shouldStop:function(t){return t.hits.length<n.hitsPerPage}},n),{},{request:function(e){return se(t)("",r(r({},n),e)).then((function(t){return r(r({},t),{},{hits:t.hits.map((function(t){return delete t._highlightResult,t}))})}))}}))}},kt=function(t){return function(e){var n=r({hitsPerPage:1e3},e);return K(r(r({shouldStop:function(t){return t.hits.length<n.hitsPerPage}},n),{},{request:function(e){return ce(t)("",r(r({},n),e)).then((function(t){return r(r({},t),{},{hits:t.hits.map((function(t){return delete t._highlightResult,t}))})}))}}))}},Tt=function(t){return function(e,r,a){var o=a||{},i=o.batchSize,u=n(o,["batchSize"]),s={taskIDs:[],objectIDs:[]};return d(function n(){var a,o=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,c=[];for(a=o;a<e.length&&(c.push(e[a]),c.length!==(i||1e3));a++);return 0===c.length?Promise.resolve(s):Dt(t)(c.map((function(t){return{action:r,body:t}})),u).then((function(t){return s.objectIDs=s.objectIDs.concat(t.objectIDs),s.taskIDs.push(t.taskID),a++,n(a)}))}(),(function(e,r){return Promise.all(e.taskIDs.map((function(e){return de(t)(e,r)})))}))}},Nt=function(t){return function(e){return d(t.transporter.write({method:j,path:h("1/indexes/%s/clear",t.indexName)},e),(function(e,r){return de(t)(e.taskID,r)}))}},Et=function(t){return function(e){var r=e||{},a=r.forwardToReplicas,o=y(n(r,["forwardToReplicas"]));return a&&(o.queryParameters.forwardToReplicas=1),d(t.transporter.write({method:j,path:h("1/indexes/%s/rules/clear",t.indexName)},o),(function(e,r){return de(t)(e.taskID,r)}))}},Rt=function(t){return function(e){var r=e||{},a=r.forwardToReplicas,o=y(n(r,["forwardToReplicas"]));return a&&(o.queryParameters.forwardToReplicas=1),d(t.transporter.write({method:j,path:h("1/indexes/%s/synonyms/clear",t.indexName)},o),(function(e,r){return de(t)(e.taskID,r)}))}},At=function(t){return function(e,r){return d(t.transporter.write({method:j,path:h("1/indexes/%s/deleteByQuery",t.indexName),data:e},r),(function(e,r){return de(t)(e.taskID,r)}))}},Ct=function(t){return function(e){return d(t.transporter.write({method:I,path:h("1/indexes/%s",t.indexName)},e),(function(e,r){return de(t)(e.taskID,r)}))}},Ut=function(t){return function(e,r){return d(zt(t)([e],r).then((function(t){return{taskID:t.taskIDs[0]}})),(function(e,r){return de(t)(e.taskID,r)}))}},zt=function(t){return function(e,r){var n=e.map((function(t){return{objectID:t}}));return Tt(t)(n,le.DeleteObject,r)}},Jt=function(t){return function(e,r){var a=r||{},o=a.forwardToReplicas,i=y(n(a,["forwardToReplicas"]));return o&&(i.queryParameters.forwardToReplicas=1),d(t.transporter.write({method:I,path:h("1/indexes/%s/rules/%s",t.indexName,e)},i),(function(e,r){return de(t)(e.taskID,r)}))}},Ft=function(t){return function(e,r){var a=r||{},o=a.forwardToReplicas,i=y(n(a,["forwardToReplicas"]));return o&&(i.queryParameters.forwardToReplicas=1),d(t.transporter.write({method:I,path:h("1/indexes/%s/synonyms/%s",t.indexName,e)},i),(function(e,r){return de(t)(e.taskID,r)}))}},Ht=function(t){return function(e){return Lt(t)(e).then((function(){return!0})).catch((function(t){if(404!==t.status)throw t;return!1}))}},Mt=function(t){return function(e,r,n){return t.transporter.read({method:j,path:h("1/answers/%s/prediction",t.indexName),data:{query:e,queryLanguages:r},cacheable:!0},n)}},Kt=function(t){return function(e,o){var i=o||{},u=i.query,s=i.paginate,c=n(i,["query","paginate"]),f=0;return function n(){return ie(t)(u||"",r(r({},c),{},{page:f})).then((function(t){for(var r=0,o=Object.entries(t.hits);r<o.length;r++){var i=a(o[r],2),u=i[0],c=i[1];if(e(c))return{object:c,position:parseInt(u,10),page:f}}if(f++,!1===s||f>=t.nbPages)throw{name:"ObjectNotFoundError",message:"Object not found."};return n()}))}()}},Wt=function(t){return function(e,r){return t.transporter.read({method:x,path:h("1/indexes/%s/%s",t.indexName,e)},r)}},Bt=function(){return function(t,e){for(var r=0,n=Object.entries(t.hits);r<n.length;r++){var o=a(n[r],2),i=o[0];if(o[1].objectID===e)return parseInt(i,10)}return-1}},Qt=function(t){return function(e,a){var o=a||{},i=o.attributesToRetrieve,u=n(o,["attributesToRetrieve"]),s=e.map((function(e){return r({indexName:t.indexName,objectID:e},i?{attributesToRetrieve:i}:{})}));return t.transporter.read({method:j,path:"1/indexes/*/objects",data:{requests:s}},u)}},Gt=function(t){return function(e,r){return t.transporter.read({method:x,path:h("1/indexes/%s/rules/%s",t.indexName,e)},r)}},Lt=function(t){return function(e){return t.transporter.read({method:x,path:h("1/indexes/%s/settings",t.indexName),data:{getVersion:2}},e)}},Vt=function(t){return function(e,r){return t.transporter.read({method:x,path:h("1/indexes/%s/synonyms/%s",t.indexName,e)},r)}},_t=function(t){return function(e,r){return d(Xt(t)([e],r).then((function(t){return{objectID:t.objectIDs[0],taskID:t.taskIDs[0]}})),(function(e,r){return de(t)(e.taskID,r)}))}},Xt=function(t){return function(e,r){var a=r||{},o=a.createIfNotExists,i=n(a,["createIfNotExists"]),u=o?le.PartialUpdateObject:le.PartialUpdateObjectNoCreate;return Tt(t)(e,u,i)}},Yt=function(t){return function(e,i){var u=i||{},s=u.safe,c=u.autoGenerateObjectIDIfNotExist,f=u.batchSize,l=n(u,["safe","autoGenerateObjectIDIfNotExist","batchSize"]),p=function(e,r,n,a){return d(t.transporter.write({method:j,path:h("1/indexes/%s/operation",e),data:{operation:n,destination:r}},a),(function(e,r){return de(t)(e.taskID,r)}))},m=Math.random().toString(36).substring(7),y="".concat(t.indexName,"_tmp_").concat(m),g=ee({appId:t.appId,transporter:t.transporter,indexName:y}),v=[],b=p(t.indexName,y,"copy",r(r({},l),{},{scope:["settings","synonyms","rules"]}));return v.push(b),d((s?b.wait(l):b).then((function(){var t=g(e,r(r({},l),{},{autoGenerateObjectIDIfNotExist:c,batchSize:f}));return v.push(t),s?t.wait(l):t})).then((function(){var e=p(y,t.indexName,"move",l);return v.push(e),s?e.wait(l):e})).then((function(){return Promise.all(v)})).then((function(t){var e=a(t,3),r=e[0],n=e[1],i=e[2];return{objectIDs:n.objectIDs,taskIDs:[r.taskID].concat(o(n.taskIDs),[i.taskID])}})),(function(t,e){return Promise.all(v.map((function(t){return t.wait(e)})))}))}},Zt=function(t){return function(e,n){return ne(t)(e,r(r({},n),{},{clearExistingRules:!0}))}},$t=function(t){return function(e,n){return oe(t)(e,r(r({},n),{},{clearExistingSynonyms:!0}))}},te=function(t){return function(e,r){return d(ee(t)([e],r).then((function(t){return{objectID:t.objectIDs[0],taskID:t.taskIDs[0]}})),(function(e,r){return de(t)(e.taskID,r)}))}},ee=function(t){return function(e,r){var a=r||{},o=a.autoGenerateObjectIDIfNotExist,i=n(a,["autoGenerateObjectIDIfNotExist"]),u=o?le.AddObject:le.UpdateObject;if(u===le.UpdateObject){var s=!0,c=!1,f=void 0;try{for(var l,p=e[Symbol.iterator]();!(s=(l=p.next()).done);s=!0){if(void 0===l.value.objectID)return d(Promise.reject({name:"MissingObjectIDError",message:"All objects must have an unique objectID (like a primary key) to be valid. Algolia is also able to generate objectIDs automatically but *it's not recommended*. To do it, use the `{'autoGenerateObjectIDIfNotExist': true}` option."}))}}catch(t){c=!0,f=t}finally{try{s||null==p.return||p.return()}finally{if(c)throw f}}}return Tt(t)(e,u,i)}},re=function(t){return function(e,r){return ne(t)([e],r)}},ne=function(t){return function(e,r){var a=r||{},o=a.forwardToReplicas,i=a.clearExistingRules,u=y(n(a,["forwardToReplicas","clearExistingRules"]));return o&&(u.queryParameters.forwardToReplicas=1),i&&(u.queryParameters.clearExistingRules=1),d(t.transporter.write({method:j,path:h("1/indexes/%s/rules/batch",t.indexName),data:e},u),(function(e,r){return de(t)(e.taskID,r)}))}},ae=function(t){return function(e,r){return oe(t)([e],r)}},oe=function(t){return function(e,r){var a=r||{},o=a.forwardToReplicas,i=a.clearExistingSynonyms,u=a.replaceExistingSynonyms,s=y(n(a,["forwardToReplicas","clearExistingSynonyms","replaceExistingSynonyms"]));return o&&(s.queryParameters.forwardToReplicas=1),(u||i)&&(s.queryParameters.replaceExistingSynonyms=1),d(t.transporter.write({method:j,path:h("1/indexes/%s/synonyms/batch",t.indexName),data:e},s),(function(e,r){return de(t)(e.taskID,r)}))}},ie=function(t){return function(e,r){return t.transporter.read({method:j,path:h("1/indexes/%s/query",t.indexName),data:{query:e},cacheable:!0},r)}},ue=function(t){return function(e,r,n){return t.transporter.read({method:j,path:h("1/indexes/%s/facets/%s/query",t.indexName,e),data:{facetQuery:r},cacheable:!0},n)}},se=function(t){return function(e,r){return t.transporter.read({method:j,path:h("1/indexes/%s/rules/search",t.indexName),data:{query:e}},r)}},ce=function(t){return function(e,r){return t.transporter.read({method:j,path:h("1/indexes/%s/synonyms/search",t.indexName),data:{query:e}},r)}},fe=function(t){return function(e,r){var a=r||{},o=a.forwardToReplicas,i=y(n(a,["forwardToReplicas"]));return o&&(i.queryParameters.forwardToReplicas=1),d(t.transporter.write({method:D,path:h("1/indexes/%s/settings",t.indexName),data:e},i),(function(e,r){return de(t)(e.taskID,r)}))}},de=function(t){return function(e,r){return f((function(n){return function(t){return function(e,r){return t.transporter.read({method:x,path:h("1/indexes/%s/task/%s",t.indexName,e.toString())},r)}}(t)(e,r).then((function(t){return"published"!==t.status?n():void 0}))}))}},le={AddObject:"addObject",UpdateObject:"updateObject",PartialUpdateObject:"partialUpdateObject",PartialUpdateObjectNoCreate:"partialUpdateObjectNoCreate",DeleteObject:"deleteObject",DeleteIndex:"delete",ClearIndex:"clear"},pe={Settings:"settings",Synonyms:"synonyms",Rules:"rules"},he=1,me=2,ye=3;function ge(t,e,n){var a,o={appId:t,apiKey:e,timeouts:{connect:1,read:2,write:30},requester:{send:function(t){return new Promise((function(e){var r=new XMLHttpRequest;r.open(t.method,t.url,!0),Object.keys(t.headers).forEach((function(e){return r.setRequestHeader(e,t.headers[e])}));var n,a=function(t,n){return setTimeout((function(){r.abort(),e({status:0,content:n,isTimedOut:!0})}),1e3*t)},o=a(t.connectTimeout,"Connection timeout");r.onreadystatechange=function(){r.readyState>r.OPENED&&void 0===n&&(clearTimeout(o),n=a(t.responseTimeout,"Socket timeout"))},r.onerror=function(){0===r.status&&(clearTimeout(o),clearTimeout(n),e({content:r.responseText||"Network request failed",status:r.status,isTimedOut:!1}))},r.onload=function(){clearTimeout(o),clearTimeout(n),e({content:r.responseText,status:r.status,isTimedOut:!1})},r.send(t.data)}))}},logger:(a=ye,{debug:function(t,e){return he>=a&&console.debug(t,e),Promise.resolve()},info:function(t,e){return me>=a&&console.info(t,e),Promise.resolve()},error:function(t,e){return console.error(t,e),Promise.resolve()}}),responsesCache:s(),requestsCache:s({serializable:!1}),hostsCache:u({caches:[i({key:"".concat("4.12.1","-").concat(t)}),s()]}),userAgent:T("4.12.1").add({segment:"Browser"})},f=r(r({},o),n),d=function(){return function(t){return function(t){var e=t.region||"us",n=c(m.WithinHeaders,t.appId,t.apiKey),a=k(r(r({hosts:[{url:"personalization.".concat(e,".algolia.com")}]},t),{},{headers:r(r(r({},n.headers()),{"content-type":"application/json"}),t.headers),queryParameters:r(r({},n.queryParameters()),t.queryParameters)}));return p({appId:t.appId,transporter:a},t.methods)}(r(r(r({},o),t),{},{methods:{getPersonalizationStrategy:H,setPersonalizationStrategy:M}}))}};return function(t){var e=t.appId,n=c(void 0!==t.authMode?t.authMode:m.WithinHeaders,e,t.apiKey),a=k(r(r({hosts:[{url:"".concat(e,"-dsn.algolia.net"),accept:g.Read},{url:"".concat(e,".algolia.net"),accept:g.Write}].concat(l([{url:"".concat(e,"-1.algolianet.com")},{url:"".concat(e,"-2.algolianet.com")},{url:"".concat(e,"-3.algolianet.com")}]))},t),{},{headers:r(r(r({},n.headers()),{"content-type":"application/x-www-form-urlencoded"}),t.headers),queryParameters:r(r({},n.queryParameters()),t.queryParameters)}));return p({transporter:a,appId:e,addAlgoliaAgent:function(t,e){a.userAgent.add({segment:t,version:e})},clearCache:function(){return Promise.all([a.requestsCache.clear(),a.responsesCache.clear()]).then((function(){}))}},t.methods)}(r(r({},f),{},{methods:{search:mt,searchForFacetValues:yt,multipleBatch:pt,multipleGetObjects:ht,multipleQueries:mt,copyIndex:L,copySettings:_,copySynonyms:X,copyRules:V,moveIndex:lt,listIndices:ft,getLogs:nt,listClusters:ct,multipleSearchForFacetValues:yt,getApiKey:tt,addApiKey:W,listApiKeys:st,updateApiKey:xt,deleteApiKey:Z,restoreApiKey:bt,assignUserID:B,assignUserIDs:Q,getUserID:ot,searchUserIDs:Ot,listUserIDs:dt,getTopUserIDs:at,removeUserID:gt,hasPendingMappings:it,clearDictionaryEntries:G,deleteDictionaryEntries:$,getDictionarySettings:rt,getAppTask:et,replaceDictionaryEntries:vt,saveDictionaryEntries:Pt,searchDictionaryEntries:wt,setDictionarySettings:It,waitAppTask:jt,customRequest:Y,initIndex:function(t){return function(e){return ut(t)(e,{methods:{batch:Dt,delete:Ct,findAnswers:Mt,getObject:Wt,getObjects:Qt,saveObject:te,saveObjects:ee,search:ie,searchForFacetValues:ue,waitTask:de,setSettings:fe,getSettings:Lt,partialUpdateObject:_t,partialUpdateObjects:Xt,deleteObject:Ut,deleteObjects:zt,deleteBy:At,clearObjects:Nt,browseObjects:qt,getObjectPosition:Bt,findObject:Kt,exists:Ht,saveSynonym:ae,saveSynonyms:oe,getSynonym:Vt,searchSynonyms:ce,browseSynonyms:kt,deleteSynonym:Ft,clearSynonyms:Rt,replaceAllObjects:Yt,replaceAllSynonyms:$t,searchRules:se,getRule:Gt,deleteRule:Jt,saveRule:re,saveRules:ne,replaceAllRules:Zt,browseRules:St,clearRules:Et}})}},initAnalytics:function(){return function(t){return function(t){var e=t.region||"us",n=c(m.WithinHeaders,t.appId,t.apiKey),a=k(r(r({hosts:[{url:"analytics.".concat(e,".algolia.com")}]},t),{},{headers:r(r(r({},n.headers()),{"content-type":"application/json"}),t.headers),queryParameters:r(r({},n.queryParameters()),t.queryParameters)}));return p({appId:t.appId,transporter:a},t.methods)}(r(r(r({},o),t),{},{methods:{addABTest:C,getABTest:z,getABTests:J,stopABTest:F,deleteABTest:U}}))}},initPersonalization:d,initRecommendation:function(){return function(t){return f.logger.info("The `initRecommendation` method is deprecated. Use `initPersonalization` instead."),d()(t)}}}}))}return ge.version="4.12.1",ge}));


/***/ }),

/***/ 63099:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var GetIntrinsic = __webpack_require__(72870);

var callBind = __webpack_require__(72755);

var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));

module.exports = function callBoundIntrinsic(name, allowMissing) {
	var intrinsic = GetIntrinsic(name, !!allowMissing);
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBind(intrinsic);
	}
	return intrinsic;
};


/***/ }),

/***/ 72755:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var bind = __webpack_require__(48794);
var GetIntrinsic = __webpack_require__(72870);

var $apply = GetIntrinsic('%Function.prototype.apply%');
var $call = GetIntrinsic('%Function.prototype.call%');
var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);

var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);
var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);
var $max = GetIntrinsic('%Math.max%');

if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = null;
	}
}

module.exports = function callBind(originalFunction) {
	var func = $reflectApply(bind, $call, arguments);
	if ($gOPD && $defineProperty) {
		var desc = $gOPD(func, 'length');
		if (desc.configurable) {
			// original length, plus the receiver, minus any additional arguments (after the receiver)
			$defineProperty(
				func,
				'length',
				{ value: 1 + $max(0, originalFunction.length - (arguments.length - 1)) }
			);
		}
	}
	return func;
};

var applyBind = function applyBind() {
	return $reflectApply(bind, $apply, arguments);
};

if ($defineProperty) {
	$defineProperty(module.exports, 'apply', { value: applyBind });
} else {
	module.exports.apply = applyBind;
}


/***/ }),

/***/ 14907:
/***/ ((module) => {


/**
 * Expose `Emitter`.
 */

if (true) {
  module.exports = Emitter;
}

/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */

function Emitter(obj) {
  if (obj) return mixin(obj);
};

/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in Emitter.prototype) {
    obj[key] = Emitter.prototype[key];
  }
  return obj;
}

/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.on =
Emitter.prototype.addEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};
  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
    .push(fn);
  return this;
};

/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.once = function(event, fn){
  function on() {
    this.off(event, on);
    fn.apply(this, arguments);
  }

  on.fn = fn;
  this.on(event, on);
  return this;
};

/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.off =
Emitter.prototype.removeListener =
Emitter.prototype.removeAllListeners =
Emitter.prototype.removeEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};

  // all
  if (0 == arguments.length) {
    this._callbacks = {};
    return this;
  }

  // specific event
  var callbacks = this._callbacks['$' + event];
  if (!callbacks) return this;

  // remove all handlers
  if (1 == arguments.length) {
    delete this._callbacks['$' + event];
    return this;
  }

  // remove specific handler
  var cb;
  for (var i = 0; i < callbacks.length; i++) {
    cb = callbacks[i];
    if (cb === fn || cb.fn === fn) {
      callbacks.splice(i, 1);
      break;
    }
  }

  // Remove event specific arrays for event types that no
  // one is subscribed for to avoid memory leak.
  if (callbacks.length === 0) {
    delete this._callbacks['$' + event];
  }

  return this;
};

/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */

Emitter.prototype.emit = function(event){
  this._callbacks = this._callbacks || {};

  var args = new Array(arguments.length - 1)
    , callbacks = this._callbacks['$' + event];

  for (var i = 1; i < arguments.length; i++) {
    args[i - 1] = arguments[i];
  }

  if (callbacks) {
    callbacks = callbacks.slice(0);
    for (var i = 0, len = callbacks.length; i < len; ++i) {
      callbacks[i].apply(this, args);
    }
  }

  return this;
};

/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */

Emitter.prototype.listeners = function(event){
  this._callbacks = this._callbacks || {};
  return this._callbacks['$' + event] || [];
};

/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */

Emitter.prototype.hasListeners = function(event){
  return !! this.listeners(event).length;
};


/***/ }),

/***/ 44596:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var isCallable = __webpack_require__(31808);
var tryToString = __webpack_require__(38151);

var $TypeError = TypeError;

// `Assert: IsCallable(argument) is true`
module.exports = function (argument) {
  if (isCallable(argument)) return argument;
  throw $TypeError(tryToString(argument) + ' is not a function');
};


/***/ }),

/***/ 58521:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var wellKnownSymbol = __webpack_require__(15537);
var create = __webpack_require__(91026);
var defineProperty = (__webpack_require__(3002).f);

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] === undefined) {
  defineProperty(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create(null)
  });
}

// add a key to Array.prototype[@@unscopables]
module.exports = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};


/***/ }),

/***/ 79308:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var isObject = __webpack_require__(27627);

var $String = String;
var $TypeError = TypeError;

// `Assert: Type(argument) is Object`
module.exports = function (argument) {
  if (isObject(argument)) return argument;
  throw $TypeError($String(argument) + ' is not an object');
};


/***/ }),

/***/ 96039:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var toIndexedObject = __webpack_require__(17794);
var toAbsoluteIndex = __webpack_require__(97913);
var lengthOfArrayLike = __webpack_require__(2103);

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = lengthOfArrayLike(O);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el !== el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value !== value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),

/***/ 39287:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var bind = __webpack_require__(82144);
var IndexedObject = __webpack_require__(29860);
var toObject = __webpack_require__(76075);
var lengthOfArrayLike = __webpack_require__(2103);

// `Array.prototype.{ findLast, findLastIndex }` methods implementation
var createMethod = function (TYPE) {
  var IS_FIND_LAST_INDEX = TYPE === 1;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IndexedObject(O);
    var boundFunction = bind(callbackfn, that);
    var index = lengthOfArrayLike(self);
    var value, result;
    while (index-- > 0) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (result) switch (TYPE) {
        case 0: return value; // findLast
        case 1: return index; // findLastIndex
      }
    }
    return IS_FIND_LAST_INDEX ? -1 : undefined;
  };
};

module.exports = {
  // `Array.prototype.findLast` method
  // https://github.com/tc39/proposal-array-find-from-last
  findLast: createMethod(0),
  // `Array.prototype.findLastIndex` method
  // https://github.com/tc39/proposal-array-find-from-last
  findLastIndex: createMethod(1)
};


/***/ }),

/***/ 28695:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var bind = __webpack_require__(82144);
var uncurryThis = __webpack_require__(52058);
var IndexedObject = __webpack_require__(29860);
var toObject = __webpack_require__(76075);
var lengthOfArrayLike = __webpack_require__(2103);
var arraySpeciesCreate = __webpack_require__(87745);

var push = uncurryThis([].push);

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var createMethod = function (TYPE) {
  var IS_MAP = TYPE === 1;
  var IS_FILTER = TYPE === 2;
  var IS_SOME = TYPE === 3;
  var IS_EVERY = TYPE === 4;
  var IS_FIND_INDEX = TYPE === 6;
  var IS_FILTER_REJECT = TYPE === 7;
  var NO_HOLES = TYPE === 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = IndexedObject(O);
    var boundFunction = bind(callbackfn, that);
    var length = lengthOfArrayLike(self);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push(target, value);      // filter
        } else switch (TYPE) {
          case 4: return false;             // every
          case 7: push(target, value);      // filterReject
        }
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

module.exports = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: createMethod(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: createMethod(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: createMethod(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: createMethod(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: createMethod(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod(6),
  // `Array.prototype.filterReject` method
  // https://github.com/tc39/proposal-array-filtering
  filterReject: createMethod(7)
};


/***/ }),

/***/ 14501:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var toAbsoluteIndex = __webpack_require__(97913);
var lengthOfArrayLike = __webpack_require__(2103);
var createProperty = __webpack_require__(88990);

var $Array = Array;
var max = Math.max;

module.exports = function (O, start, end) {
  var length = lengthOfArrayLike(O);
  var k = toAbsoluteIndex(start, length);
  var fin = toAbsoluteIndex(end === undefined ? length : end, length);
  var result = $Array(max(fin - k, 0));
  var n = 0;
  for (; k < fin; k++, n++) createProperty(result, n, O[k]);
  result.length = n;
  return result;
};


/***/ }),

/***/ 59591:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var uncurryThis = __webpack_require__(52058);

module.exports = uncurryThis([].slice);


/***/ }),

/***/ 57747:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var isArray = __webpack_require__(81113);
var isConstructor = __webpack_require__(92701);
var isObject = __webpack_require__(27627);
var wellKnownSymbol = __webpack_require__(15537);

var SPECIES = wellKnownSymbol('species');
var $Array = Array;

// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (isConstructor(C) && (C === $Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? $Array : C;
};


/***/ }),

/***/ 87745:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var arraySpeciesConstructor = __webpack_require__(57747);

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray, length) {
  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};


/***/ }),

/***/ 27506:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var wellKnownSymbol = __webpack_require__(15537);

var ITERATOR = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR] = function () {
    return this;
  };
  // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

module.exports = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};


/***/ }),

/***/ 38555:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var uncurryThis = __webpack_require__(52058);

var toString = uncurryThis({}.toString);
var stringSlice = uncurryThis(''.slice);

module.exports = function (it) {
  return stringSlice(toString(it), 8, -1);
};


/***/ }),

/***/ 25786:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__(32709);
var isCallable = __webpack_require__(31808);
var classofRaw = __webpack_require__(38555);
var wellKnownSymbol = __webpack_require__(15537);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var $Object = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) === 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) === 'Object' && isCallable(O.callee) ? 'Arguments' : result;
};


/***/ }),

/***/ 85609:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var hasOwn = __webpack_require__(48496);
var ownKeys = __webpack_require__(7464);
var getOwnPropertyDescriptorModule = __webpack_require__(94086);
var definePropertyModule = __webpack_require__(3002);

module.exports = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn(target, key) && !(exceptions && hasOwn(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};


/***/ }),

/***/ 16382:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var fails = __webpack_require__(79645);

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});


/***/ }),

/***/ 60859:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var DESCRIPTORS = __webpack_require__(40369);
var definePropertyModule = __webpack_require__(3002);
var createPropertyDescriptor = __webpack_require__(56373);

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ 56373:
/***/ ((module) => {

"use strict";

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ 88990:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var toPropertyKey = __webpack_require__(7171);
var definePropertyModule = __webpack_require__(3002);
var createPropertyDescriptor = __webpack_require__(56373);

module.exports = function (object, key, value) {
  var propertyKey = toPropertyKey(key);
  if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};


/***/ }),

/***/ 4259:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var makeBuiltIn = __webpack_require__(32303);
var defineProperty = __webpack_require__(3002);

module.exports = function (target, name, descriptor) {
  if (descriptor.get) makeBuiltIn(descriptor.get, name, { getter: true });
  if (descriptor.set) makeBuiltIn(descriptor.set, name, { setter: true });
  return defineProperty.f(target, name, descriptor);
};


/***/ }),

/***/ 96561:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var isCallable = __webpack_require__(31808);
var definePropertyModule = __webpack_require__(3002);
var makeBuiltIn = __webpack_require__(32303);
var defineGlobalProperty = __webpack_require__(91105);

module.exports = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable(value)) makeBuiltIn(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else definePropertyModule.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};


/***/ }),

/***/ 91105:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var global = __webpack_require__(27990);

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;

module.exports = function (key, value) {
  try {
    defineProperty(global, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),

/***/ 40369:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var fails = __webpack_require__(79645);

// Detect IE8's incomplete defineProperty implementation
module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] !== 7;
});


/***/ }),

/***/ 71857:
/***/ ((module) => {

"use strict";

var documentAll = typeof document == 'object' && document.all;

// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var IS_HTMLDDA = typeof documentAll == 'undefined' && documentAll !== undefined;

module.exports = {
  all: documentAll,
  IS_HTMLDDA: IS_HTMLDDA
};


/***/ }),

/***/ 54799:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var global = __webpack_require__(27990);
var isObject = __webpack_require__(27627);

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),

/***/ 64023:
/***/ ((module) => {

"use strict";

var $TypeError = TypeError;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991

module.exports = function (it) {
  if (it > MAX_SAFE_INTEGER) throw $TypeError('Maximum allowed index exceeded');
  return it;
};


/***/ }),

/***/ 39422:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var IS_DENO = __webpack_require__(98194);
var IS_NODE = __webpack_require__(28018);

module.exports = !IS_DENO && !IS_NODE
  && typeof window == 'object'
  && typeof document == 'object';


/***/ }),

/***/ 98194:
/***/ ((module) => {

"use strict";

/* global Deno -- Deno case */
module.exports = typeof Deno == 'object' && Deno && typeof Deno.version == 'object';


/***/ }),

/***/ 28018:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var global = __webpack_require__(27990);
var classof = __webpack_require__(38555);

module.exports = classof(global.process) === 'process';


/***/ }),

/***/ 17366:
/***/ ((module) => {

"use strict";

module.exports = typeof navigator != 'undefined' && String(navigator.userAgent) || '';


/***/ }),

/***/ 1579:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var global = __webpack_require__(27990);
var userAgent = __webpack_require__(17366);

var process = global.process;
var Deno = global.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

module.exports = version;


/***/ }),

/***/ 54577:
/***/ ((module) => {

"use strict";

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),

/***/ 88903:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var global = __webpack_require__(27990);
var getOwnPropertyDescriptor = (__webpack_require__(94086).f);
var createNonEnumerableProperty = __webpack_require__(60859);
var defineBuiltIn = __webpack_require__(96561);
var defineGlobalProperty = __webpack_require__(91105);
var copyConstructorProperties = __webpack_require__(85609);
var isForced = __webpack_require__(69168);

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = (global[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    defineBuiltIn(target, key, sourceProperty, options);
  }
};


/***/ }),

/***/ 79645:
/***/ ((module) => {

"use strict";

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),

/***/ 45598:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var isArray = __webpack_require__(81113);
var lengthOfArrayLike = __webpack_require__(2103);
var doesNotExceedSafeInteger = __webpack_require__(64023);
var bind = __webpack_require__(82144);

// `FlattenIntoArray` abstract operation
// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var flattenIntoArray = function (target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? bind(mapper, thisArg) : false;
  var element, elementLen;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      if (depth > 0 && isArray(element)) {
        elementLen = lengthOfArrayLike(element);
        targetIndex = flattenIntoArray(target, original, element, elementLen, targetIndex, depth - 1) - 1;
      } else {
        doesNotExceedSafeInteger(targetIndex + 1);
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
};

module.exports = flattenIntoArray;


/***/ }),

/***/ 59878:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var NATIVE_BIND = __webpack_require__(62023);

var FunctionPrototype = Function.prototype;
var apply = FunctionPrototype.apply;
var call = FunctionPrototype.call;

// eslint-disable-next-line es/no-reflect -- safe
module.exports = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND ? call.bind(apply) : function () {
  return call.apply(apply, arguments);
});


/***/ }),

/***/ 82144:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var uncurryThis = __webpack_require__(2330);
var aCallable = __webpack_require__(44596);
var NATIVE_BIND = __webpack_require__(62023);

var bind = uncurryThis(uncurryThis.bind);

// optional / simple context binding
module.exports = function (fn, that) {
  aCallable(fn);
  return that === undefined ? fn : NATIVE_BIND ? bind(fn, that) : function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ 62023:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var fails = __webpack_require__(79645);

module.exports = !fails(function () {
  // eslint-disable-next-line es/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});


/***/ }),

/***/ 17725:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var NATIVE_BIND = __webpack_require__(62023);

var call = Function.prototype.call;

module.exports = NATIVE_BIND ? call.bind(call) : function () {
  return call.apply(call, arguments);
};


/***/ }),

/***/ 92697:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var DESCRIPTORS = __webpack_require__(40369);
var hasOwn = __webpack_require__(48496);

var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS || (DESCRIPTORS && getDescriptor(FunctionPrototype, 'name').configurable));

module.exports = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};


/***/ }),

/***/ 2330:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var classofRaw = __webpack_require__(38555);
var uncurryThis = __webpack_require__(52058);

module.exports = function (fn) {
  // Nashorn bug:
  //   https://github.com/zloirock/core-js/issues/1128
  //   https://github.com/zloirock/core-js/issues/1130
  if (classofRaw(fn) === 'Function') return uncurryThis(fn);
};


/***/ }),

/***/ 52058:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var NATIVE_BIND = __webpack_require__(62023);

var FunctionPrototype = Function.prototype;
var call = FunctionPrototype.call;
var uncurryThisWithBind = NATIVE_BIND && FunctionPrototype.bind.bind(call, call);

module.exports = NATIVE_BIND ? uncurryThisWithBind : function (fn) {
  return function () {
    return call.apply(fn, arguments);
  };
};


/***/ }),

/***/ 91553:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var global = __webpack_require__(27990);
var isCallable = __webpack_require__(31808);

var aFunction = function (argument) {
  return isCallable(argument) ? argument : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global[namespace]) : global[namespace] && global[namespace][method];
};


/***/ }),

/***/ 19463:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var classof = __webpack_require__(25786);
var getMethod = __webpack_require__(30692);
var isNullOrUndefined = __webpack_require__(80276);
var Iterators = __webpack_require__(33820);
var wellKnownSymbol = __webpack_require__(15537);

var ITERATOR = wellKnownSymbol('iterator');

module.exports = function (it) {
  if (!isNullOrUndefined(it)) return getMethod(it, ITERATOR)
    || getMethod(it, '@@iterator')
    || Iterators[classof(it)];
};


/***/ }),

/***/ 34431:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var call = __webpack_require__(17725);
var aCallable = __webpack_require__(44596);
var anObject = __webpack_require__(79308);
var tryToString = __webpack_require__(38151);
var getIteratorMethod = __webpack_require__(19463);

var $TypeError = TypeError;

module.exports = function (argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod(argument) : usingIterator;
  if (aCallable(iteratorMethod)) return anObject(call(iteratorMethod, argument));
  throw $TypeError(tryToString(argument) + ' is not iterable');
};


/***/ }),

/***/ 17061:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var uncurryThis = __webpack_require__(52058);
var isArray = __webpack_require__(81113);
var isCallable = __webpack_require__(31808);
var classof = __webpack_require__(38555);
var toString = __webpack_require__(70158);

var push = uncurryThis([].push);

module.exports = function (replacer) {
  if (isCallable(replacer)) return replacer;
  if (!isArray(replacer)) return;
  var rawLength = replacer.length;
  var keys = [];
  for (var i = 0; i < rawLength; i++) {
    var element = replacer[i];
    if (typeof element == 'string') push(keys, element);
    else if (typeof element == 'number' || classof(element) === 'Number' || classof(element) === 'String') push(keys, toString(element));
  }
  var keysLength = keys.length;
  var root = true;
  return function (key, value) {
    if (root) {
      root = false;
      return value;
    }
    if (isArray(this)) return value;
    for (var j = 0; j < keysLength; j++) if (keys[j] === key) return value;
  };
};


/***/ }),

/***/ 30692:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var aCallable = __webpack_require__(44596);
var isNullOrUndefined = __webpack_require__(80276);

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports = function (V, P) {
  var func = V[P];
  return isNullOrUndefined(func) ? undefined : aCallable(func);
};


/***/ }),

/***/ 27990:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var check = function (it) {
  return it && it.Math === Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof __webpack_require__.g == 'object' && __webpack_require__.g) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || this || Function('return this')();


/***/ }),

/***/ 48496:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var uncurryThis = __webpack_require__(52058);
var toObject = __webpack_require__(76075);

var hasOwnProperty = uncurryThis({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
module.exports = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject(it), key);
};


/***/ }),

/***/ 80642:
/***/ ((module) => {

"use strict";

module.exports = {};


/***/ }),

/***/ 62086:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var getBuiltIn = __webpack_require__(91553);

module.exports = getBuiltIn('document', 'documentElement');


/***/ }),

/***/ 16938:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var DESCRIPTORS = __webpack_require__(40369);
var fails = __webpack_require__(79645);
var createElement = __webpack_require__(54799);

// Thanks to IE8 for its funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a !== 7;
});


/***/ }),

/***/ 29860:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var uncurryThis = __webpack_require__(52058);
var fails = __webpack_require__(79645);
var classof = __webpack_require__(38555);

var $Object = Object;
var split = uncurryThis(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) === 'String' ? split(it, '') : $Object(it);
} : $Object;


/***/ }),

/***/ 30449:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var uncurryThis = __webpack_require__(52058);
var isCallable = __webpack_require__(31808);
var store = __webpack_require__(57322);

var functionToString = uncurryThis(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable(store.inspectSource)) {
  store.inspectSource = function (it) {
    return functionToString(it);
  };
}

module.exports = store.inspectSource;


/***/ }),

/***/ 47776:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var NATIVE_WEAK_MAP = __webpack_require__(19514);
var global = __webpack_require__(27990);
var isObject = __webpack_require__(27627);
var createNonEnumerableProperty = __webpack_require__(60859);
var hasOwn = __webpack_require__(48496);
var shared = __webpack_require__(57322);
var sharedKey = __webpack_require__(53273);
var hiddenKeys = __webpack_require__(80642);

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError = global.TypeError;
var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  /* eslint-disable no-self-assign -- prototype methods protection */
  store.get = store.get;
  store.has = store.has;
  store.set = store.set;
  /* eslint-enable no-self-assign -- prototype methods protection */
  set = function (it, metadata) {
    if (store.has(it)) throw TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    store.set(it, metadata);
    return metadata;
  };
  get = function (it) {
    return store.get(it) || {};
  };
  has = function (it) {
    return store.has(it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    if (hasOwn(it, STATE)) throw TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),

/***/ 95409:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var wellKnownSymbol = __webpack_require__(15537);
var Iterators = __webpack_require__(33820);

var ITERATOR = wellKnownSymbol('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};


/***/ }),

/***/ 81113:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var classof = __webpack_require__(38555);

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
module.exports = Array.isArray || function isArray(argument) {
  return classof(argument) === 'Array';
};


/***/ }),

/***/ 31808:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $documentAll = __webpack_require__(71857);

var documentAll = $documentAll.all;

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
module.exports = $documentAll.IS_HTMLDDA ? function (argument) {
  return typeof argument == 'function' || argument === documentAll;
} : function (argument) {
  return typeof argument == 'function';
};


/***/ }),

/***/ 92701:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var uncurryThis = __webpack_require__(52058);
var fails = __webpack_require__(79645);
var isCallable = __webpack_require__(31808);
var classof = __webpack_require__(25786);
var getBuiltIn = __webpack_require__(91553);
var inspectSource = __webpack_require__(30449);

var noop = function () { /* empty */ };
var empty = [];
var construct = getBuiltIn('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec = uncurryThis(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.exec(noop);

var isConstructorModern = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  try {
    construct(noop, empty, argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  switch (classof(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
  }
  try {
    // we can't check .prototype since constructors produced by .bind haven't it
    // `Function#toString` throws on some built-it function in some legacy engines
    // (for example, `DOMQuad` and similar in FF41-)
    return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource(argument));
  } catch (error) {
    return true;
  }
};

isConstructorLegacy.sham = true;

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
module.exports = !construct || fails(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;


/***/ }),

/***/ 69168:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var fails = __webpack_require__(79645);
var isCallable = __webpack_require__(31808);

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value === POLYFILL ? true
    : value === NATIVE ? false
    : isCallable(detection) ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),

/***/ 80276:
/***/ ((module) => {

"use strict";

// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
module.exports = function (it) {
  return it === null || it === undefined;
};


/***/ }),

/***/ 27627:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var isCallable = __webpack_require__(31808);
var $documentAll = __webpack_require__(71857);

var documentAll = $documentAll.all;

module.exports = $documentAll.IS_HTMLDDA ? function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it) || it === documentAll;
} : function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it);
};


/***/ }),

/***/ 81566:
/***/ ((module) => {

"use strict";

module.exports = false;


/***/ }),

/***/ 44003:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var getBuiltIn = __webpack_require__(91553);
var isCallable = __webpack_require__(31808);
var isPrototypeOf = __webpack_require__(88304);
var USE_SYMBOL_AS_UID = __webpack_require__(40144);

var $Object = Object;

module.exports = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn('Symbol');
  return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, $Object(it));
};


/***/ }),

/***/ 41851:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var bind = __webpack_require__(82144);
var call = __webpack_require__(17725);
var anObject = __webpack_require__(79308);
var tryToString = __webpack_require__(38151);
var isArrayIteratorMethod = __webpack_require__(95409);
var lengthOfArrayLike = __webpack_require__(2103);
var isPrototypeOf = __webpack_require__(88304);
var getIterator = __webpack_require__(34431);
var getIteratorMethod = __webpack_require__(19463);
var iteratorClose = __webpack_require__(55887);

var $TypeError = TypeError;

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var ResultPrototype = Result.prototype;

module.exports = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_RECORD = !!(options && options.IS_RECORD);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = bind(unboundFunction, that);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function (condition) {
    if (iterator) iteratorClose(iterator, 'normal', condition);
    return new Result(true, condition);
  };

  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    } return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_RECORD) {
    iterator = iterable.iterator;
  } else if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (!iterFn) throw $TypeError(tryToString(iterable) + ' is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = lengthOfArrayLike(iterable); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && isPrototypeOf(ResultPrototype, result)) return result;
      } return new Result(false);
    }
    iterator = getIterator(iterable, iterFn);
  }

  next = IS_RECORD ? iterable.next : iterator.next;
  while (!(step = call(next, iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose(iterator, 'throw', error);
    }
    if (typeof result == 'object' && result && isPrototypeOf(ResultPrototype, result)) return result;
  } return new Result(false);
};


/***/ }),

/***/ 55887:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var call = __webpack_require__(17725);
var anObject = __webpack_require__(79308);
var getMethod = __webpack_require__(30692);

module.exports = function (iterator, kind, value) {
  var innerResult, innerError;
  anObject(iterator);
  try {
    innerResult = getMethod(iterator, 'return');
    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }
    innerResult = call(innerResult, iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject(innerResult);
  return value;
};


/***/ }),

/***/ 33820:
/***/ ((module) => {

"use strict";

module.exports = {};


/***/ }),

/***/ 2103:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var toLength = __webpack_require__(60468);

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
module.exports = function (obj) {
  return toLength(obj.length);
};


/***/ }),

/***/ 32303:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var uncurryThis = __webpack_require__(52058);
var fails = __webpack_require__(79645);
var isCallable = __webpack_require__(31808);
var hasOwn = __webpack_require__(48496);
var DESCRIPTORS = __webpack_require__(40369);
var CONFIGURABLE_FUNCTION_NAME = (__webpack_require__(92697).CONFIGURABLE);
var inspectSource = __webpack_require__(30449);
var InternalStateModule = __webpack_require__(47776);

var enforceInternalState = InternalStateModule.enforce;
var getInternalState = InternalStateModule.get;
var $String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;
var stringSlice = uncurryThis(''.slice);
var replace = uncurryThis(''.replace);
var join = uncurryThis([].join);

var CONFIGURABLE_LENGTH = DESCRIPTORS && !fails(function () {
  return defineProperty(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn = module.exports = function (value, name, options) {
  if (stringSlice($String(name), 0, 7) === 'Symbol(') {
    name = '[' + replace($String(name), /^Symbol\(([^)]*)\)/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
    if (DESCRIPTORS) defineProperty(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn(options, 'arity') && value.length !== options.arity) {
    defineProperty(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwn(options, 'constructor') && options.constructor) {
      if (DESCRIPTORS) defineProperty(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState(value);
  if (!hasOwn(state, 'source')) {
    state.source = join(TEMPLATE, typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn(function toString() {
  return isCallable(this) && getInternalState(this).source || inspectSource(this);
}, 'toString');


/***/ }),

/***/ 6357:
/***/ ((module) => {

"use strict";

var ceil = Math.ceil;
var floor = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
module.exports = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor : ceil)(n);
};


/***/ }),

/***/ 50606:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var aCallable = __webpack_require__(44596);

var $TypeError = TypeError;

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw $TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aCallable(resolve);
  this.reject = aCallable(reject);
};

// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),

/***/ 91026:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

/* global ActiveXObject -- old IE, WSH */
var anObject = __webpack_require__(79308);
var definePropertiesModule = __webpack_require__(48065);
var enumBugKeys = __webpack_require__(54577);
var hiddenKeys = __webpack_require__(80642);
var html = __webpack_require__(62086);
var documentCreateElement = __webpack_require__(54799);
var sharedKey = __webpack_require__(53273);

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};


/***/ }),

/***/ 48065:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

var DESCRIPTORS = __webpack_require__(40369);
var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__(30446);
var definePropertyModule = __webpack_require__(3002);
var anObject = __webpack_require__(79308);
var toIndexedObject = __webpack_require__(17794);
var objectKeys = __webpack_require__(88071);

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
exports.f = DESCRIPTORS && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var props = toIndexedObject(Properties);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], props[key]);
  return O;
};


/***/ }),

/***/ 3002:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

var DESCRIPTORS = __webpack_require__(40369);
var IE8_DOM_DEFINE = __webpack_require__(16938);
var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__(30446);
var anObject = __webpack_require__(79308);
var toPropertyKey = __webpack_require__(7171);

var $TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? V8_PROTOTYPE_DEFINE_BUG ? function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE in Attributes ? Attributes[CONFIGURABLE] : current[CONFIGURABLE],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw $TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ 94086:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

var DESCRIPTORS = __webpack_require__(40369);
var call = __webpack_require__(17725);
var propertyIsEnumerableModule = __webpack_require__(43740);
var createPropertyDescriptor = __webpack_require__(56373);
var toIndexedObject = __webpack_require__(17794);
var toPropertyKey = __webpack_require__(7171);
var hasOwn = __webpack_require__(48496);
var IE8_DOM_DEFINE = __webpack_require__(16938);

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPropertyKey(P);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
};


/***/ }),

/***/ 47092:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

/* eslint-disable es/no-object-getownpropertynames -- safe */
var classof = __webpack_require__(38555);
var toIndexedObject = __webpack_require__(17794);
var $getOwnPropertyNames = (__webpack_require__(88766).f);
var arraySlice = __webpack_require__(14501);

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return $getOwnPropertyNames(it);
  } catch (error) {
    return arraySlice(windowNames);
  }
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && classof(it) === 'Window'
    ? getWindowNames(it)
    : $getOwnPropertyNames(toIndexedObject(it));
};


/***/ }),

/***/ 88766:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

var internalObjectKeys = __webpack_require__(15848);
var enumBugKeys = __webpack_require__(54577);

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),

/***/ 28559:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ 56285:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var hasOwn = __webpack_require__(48496);
var isCallable = __webpack_require__(31808);
var toObject = __webpack_require__(76075);
var sharedKey = __webpack_require__(53273);
var CORRECT_PROTOTYPE_GETTER = __webpack_require__(16382);

var IE_PROTO = sharedKey('IE_PROTO');
var $Object = Object;
var ObjectPrototype = $Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
module.exports = CORRECT_PROTOTYPE_GETTER ? $Object.getPrototypeOf : function (O) {
  var object = toObject(O);
  if (hasOwn(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof $Object ? ObjectPrototype : null;
};


/***/ }),

/***/ 88304:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var uncurryThis = __webpack_require__(52058);

module.exports = uncurryThis({}.isPrototypeOf);


/***/ }),

/***/ 15848:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var uncurryThis = __webpack_require__(52058);
var hasOwn = __webpack_require__(48496);
var toIndexedObject = __webpack_require__(17794);
var indexOf = (__webpack_require__(96039).indexOf);
var hiddenKeys = __webpack_require__(80642);

var push = uncurryThis([].push);

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn(O, key = names[i++])) {
    ~indexOf(result, key) || push(result, key);
  }
  return result;
};


/***/ }),

/***/ 88071:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var internalObjectKeys = __webpack_require__(15848);
var enumBugKeys = __webpack_require__(54577);

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


/***/ }),

/***/ 43740:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;


/***/ }),

/***/ 99842:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var DESCRIPTORS = __webpack_require__(40369);
var fails = __webpack_require__(79645);
var uncurryThis = __webpack_require__(52058);
var objectGetPrototypeOf = __webpack_require__(56285);
var objectKeys = __webpack_require__(88071);
var toIndexedObject = __webpack_require__(17794);
var $propertyIsEnumerable = (__webpack_require__(43740).f);

var propertyIsEnumerable = uncurryThis($propertyIsEnumerable);
var push = uncurryThis([].push);

// in some IE versions, `propertyIsEnumerable` returns incorrect result on integer keys
// of `null` prototype objects
var IE_BUG = DESCRIPTORS && fails(function () {
  // eslint-disable-next-line es/no-object-create -- safe
  var O = Object.create(null);
  O[2] = 2;
  return !propertyIsEnumerable(O, 2);
});

// `Object.{ entries, values }` methods implementation
var createMethod = function (TO_ENTRIES) {
  return function (it) {
    var O = toIndexedObject(it);
    var keys = objectKeys(O);
    var IE_WORKAROUND = IE_BUG && objectGetPrototypeOf(O) === null;
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || (IE_WORKAROUND ? key in O : propertyIsEnumerable(O, key))) {
        push(result, TO_ENTRIES ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};

module.exports = {
  // `Object.entries` method
  // https://tc39.es/ecma262/#sec-object.entries
  entries: createMethod(true),
  // `Object.values` method
  // https://tc39.es/ecma262/#sec-object.values
  values: createMethod(false)
};


/***/ }),

/***/ 30173:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var call = __webpack_require__(17725);
var isCallable = __webpack_require__(31808);
var isObject = __webpack_require__(27627);

var $TypeError = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
  if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  throw $TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ 7464:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var getBuiltIn = __webpack_require__(91553);
var uncurryThis = __webpack_require__(52058);
var getOwnPropertyNamesModule = __webpack_require__(88766);
var getOwnPropertySymbolsModule = __webpack_require__(28559);
var anObject = __webpack_require__(79308);

var concat = uncurryThis([].concat);

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
};


/***/ }),

/***/ 84231:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var global = __webpack_require__(27990);

module.exports = global;


/***/ }),

/***/ 43639:
/***/ ((module) => {

"use strict";

module.exports = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};


/***/ }),

/***/ 32862:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var global = __webpack_require__(27990);
var NativePromiseConstructor = __webpack_require__(29952);
var isCallable = __webpack_require__(31808);
var isForced = __webpack_require__(69168);
var inspectSource = __webpack_require__(30449);
var wellKnownSymbol = __webpack_require__(15537);
var IS_BROWSER = __webpack_require__(39422);
var IS_DENO = __webpack_require__(98194);
var IS_PURE = __webpack_require__(81566);
var V8_VERSION = __webpack_require__(1579);

var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;
var SPECIES = wellKnownSymbol('species');
var SUBCLASSING = false;
var NATIVE_PROMISE_REJECTION_EVENT = isCallable(global.PromiseRejectionEvent);

var FORCED_PROMISE_CONSTRUCTOR = isForced('Promise', function () {
  var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(NativePromiseConstructor);
  var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(NativePromiseConstructor);
  // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
  // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
  // We can't detect it synchronously, so just check versions
  if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION === 66) return true;
  // We need Promise#{ catch, finally } in the pure version for preventing prototype pollution
  if (IS_PURE && !(NativePromisePrototype['catch'] && NativePromisePrototype['finally'])) return true;
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (!V8_VERSION || V8_VERSION < 51 || !/native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) {
    // Detect correctness of subclassing with @@species support
    var promise = new NativePromiseConstructor(function (resolve) { resolve(1); });
    var FakePromise = function (exec) {
      exec(function () { /* empty */ }, function () { /* empty */ });
    };
    var constructor = promise.constructor = {};
    constructor[SPECIES] = FakePromise;
    SUBCLASSING = promise.then(function () { /* empty */ }) instanceof FakePromise;
    if (!SUBCLASSING) return true;
  // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
  } return !GLOBAL_CORE_JS_PROMISE && (IS_BROWSER || IS_DENO) && !NATIVE_PROMISE_REJECTION_EVENT;
});

module.exports = {
  CONSTRUCTOR: FORCED_PROMISE_CONSTRUCTOR,
  REJECTION_EVENT: NATIVE_PROMISE_REJECTION_EVENT,
  SUBCLASSING: SUBCLASSING
};


/***/ }),

/***/ 29952:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var global = __webpack_require__(27990);

module.exports = global.Promise;


/***/ }),

/***/ 95289:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var NativePromiseConstructor = __webpack_require__(29952);
var checkCorrectnessOfIteration = __webpack_require__(27506);
var FORCED_PROMISE_CONSTRUCTOR = (__webpack_require__(32862).CONSTRUCTOR);

module.exports = FORCED_PROMISE_CONSTRUCTOR || !checkCorrectnessOfIteration(function (iterable) {
  NativePromiseConstructor.all(iterable).then(undefined, function () { /* empty */ });
});


/***/ }),

/***/ 98622:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var isNullOrUndefined = __webpack_require__(80276);

var $TypeError = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (isNullOrUndefined(it)) throw $TypeError("Can't call method on " + it);
  return it;
};


/***/ }),

/***/ 71508:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var defineProperty = (__webpack_require__(3002).f);
var hasOwn = __webpack_require__(48496);
var wellKnownSymbol = __webpack_require__(15537);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

module.exports = function (target, TAG, STATIC) {
  if (target && !STATIC) target = target.prototype;
  if (target && !hasOwn(target, TO_STRING_TAG)) {
    defineProperty(target, TO_STRING_TAG, { configurable: true, value: TAG });
  }
};


/***/ }),

/***/ 53273:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var shared = __webpack_require__(69808);
var uid = __webpack_require__(40160);

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),

/***/ 57322:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var global = __webpack_require__(27990);
var defineGlobalProperty = __webpack_require__(91105);

var SHARED = '__core-js_shared__';
var store = global[SHARED] || defineGlobalProperty(SHARED, {});

module.exports = store;


/***/ }),

/***/ 69808:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var IS_PURE = __webpack_require__(81566);
var store = __webpack_require__(57322);

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.32.1',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2014-2023 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.32.1/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});


/***/ }),

/***/ 97987:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION = __webpack_require__(1579);
var fails = __webpack_require__(79645);
var global = __webpack_require__(27990);

var $String = global.String;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol('symbol detection');
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
  // of course, fail.
  return !$String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});


/***/ }),

/***/ 52411:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var call = __webpack_require__(17725);
var getBuiltIn = __webpack_require__(91553);
var wellKnownSymbol = __webpack_require__(15537);
var defineBuiltIn = __webpack_require__(96561);

module.exports = function () {
  var Symbol = getBuiltIn('Symbol');
  var SymbolPrototype = Symbol && Symbol.prototype;
  var valueOf = SymbolPrototype && SymbolPrototype.valueOf;
  var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

  if (SymbolPrototype && !SymbolPrototype[TO_PRIMITIVE]) {
    // `Symbol.prototype[@@toPrimitive]` method
    // https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
    // eslint-disable-next-line no-unused-vars -- required for .length
    defineBuiltIn(SymbolPrototype, TO_PRIMITIVE, function (hint) {
      return call(valueOf, this);
    }, { arity: 1 });
  }
};


/***/ }),

/***/ 53482:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var NATIVE_SYMBOL = __webpack_require__(97987);

/* eslint-disable es/no-symbol -- safe */
module.exports = NATIVE_SYMBOL && !!Symbol['for'] && !!Symbol.keyFor;


/***/ }),

/***/ 97913:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var toIntegerOrInfinity = __webpack_require__(9163);

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toIntegerOrInfinity(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),

/***/ 17794:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__(29860);
var requireObjectCoercible = __webpack_require__(98622);

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),

/***/ 9163:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var trunc = __webpack_require__(6357);

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
module.exports = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};


/***/ }),

/***/ 60468:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var toIntegerOrInfinity = __webpack_require__(9163);

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),

/***/ 76075:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var requireObjectCoercible = __webpack_require__(98622);

var $Object = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function (argument) {
  return $Object(requireObjectCoercible(argument));
};


/***/ }),

/***/ 69182:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var call = __webpack_require__(17725);
var isObject = __webpack_require__(27627);
var isSymbol = __webpack_require__(44003);
var getMethod = __webpack_require__(30692);
var ordinaryToPrimitive = __webpack_require__(30173);
var wellKnownSymbol = __webpack_require__(15537);

var $TypeError = TypeError;
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports = function (input, pref) {
  if (!isObject(input) || isSymbol(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call(exoticToPrim, input, pref);
    if (!isObject(result) || isSymbol(result)) return result;
    throw $TypeError("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};


/***/ }),

/***/ 7171:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var toPrimitive = __webpack_require__(69182);
var isSymbol = __webpack_require__(44003);

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};


/***/ }),

/***/ 32709:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var wellKnownSymbol = __webpack_require__(15537);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


/***/ }),

/***/ 70158:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var classof = __webpack_require__(25786);

var $String = String;

module.exports = function (argument) {
  if (classof(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
  return $String(argument);
};


/***/ }),

/***/ 38151:
/***/ ((module) => {

"use strict";

var $String = String;

module.exports = function (argument) {
  try {
    return $String(argument);
  } catch (error) {
    return 'Object';
  }
};


/***/ }),

/***/ 40160:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var uncurryThis = __webpack_require__(52058);

var id = 0;
var postfix = Math.random();
var toString = uncurryThis(1.0.toString);

module.exports = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
};


/***/ }),

/***/ 40144:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL = __webpack_require__(97987);

module.exports = NATIVE_SYMBOL
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';


/***/ }),

/***/ 30446:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var DESCRIPTORS = __webpack_require__(40369);
var fails = __webpack_require__(79645);

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
module.exports = DESCRIPTORS && fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype !== 42;
});


/***/ }),

/***/ 19514:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var global = __webpack_require__(27990);
var isCallable = __webpack_require__(31808);

var WeakMap = global.WeakMap;

module.exports = isCallable(WeakMap) && /native code/.test(String(WeakMap));


/***/ }),

/***/ 94534:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var path = __webpack_require__(84231);
var hasOwn = __webpack_require__(48496);
var wrappedWellKnownSymbolModule = __webpack_require__(45134);
var defineProperty = (__webpack_require__(3002).f);

module.exports = function (NAME) {
  var Symbol = path.Symbol || (path.Symbol = {});
  if (!hasOwn(Symbol, NAME)) defineProperty(Symbol, NAME, {
    value: wrappedWellKnownSymbolModule.f(NAME)
  });
};


/***/ }),

/***/ 45134:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

var wellKnownSymbol = __webpack_require__(15537);

exports.f = wellKnownSymbol;


/***/ }),

/***/ 15537:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var global = __webpack_require__(27990);
var shared = __webpack_require__(69808);
var hasOwn = __webpack_require__(48496);
var uid = __webpack_require__(40160);
var NATIVE_SYMBOL = __webpack_require__(97987);
var USE_SYMBOL_AS_UID = __webpack_require__(40144);

var Symbol = global.Symbol;
var WellKnownSymbolsStore = shared('wks');
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol['for'] || Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!hasOwn(WellKnownSymbolsStore, name)) {
    WellKnownSymbolsStore[name] = NATIVE_SYMBOL && hasOwn(Symbol, name)
      ? Symbol[name]
      : createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};


/***/ }),

/***/ 37815:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(88903);
var $findLastIndex = (__webpack_require__(39287).findLastIndex);
var addToUnscopables = __webpack_require__(58521);

// `Array.prototype.findLastIndex` method
// https://tc39.es/ecma262/#sec-array.prototype.findlastindex
$({ target: 'Array', proto: true }, {
  findLastIndex: function findLastIndex(callbackfn /* , that = undefined */) {
    return $findLastIndex(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

addToUnscopables('findLastIndex');


/***/ }),

/***/ 45538:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(88903);
var flattenIntoArray = __webpack_require__(45598);
var aCallable = __webpack_require__(44596);
var toObject = __webpack_require__(76075);
var lengthOfArrayLike = __webpack_require__(2103);
var arraySpeciesCreate = __webpack_require__(87745);

// `Array.prototype.flatMap` method
// https://tc39.es/ecma262/#sec-array.prototype.flatmap
$({ target: 'Array', proto: true }, {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen = lengthOfArrayLike(O);
    var A;
    aCallable(callbackfn);
    A = arraySpeciesCreate(O, 0);
    A.length = flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    return A;
  }
});


/***/ }),

/***/ 83066:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(88903);
var getBuiltIn = __webpack_require__(91553);
var apply = __webpack_require__(59878);
var call = __webpack_require__(17725);
var uncurryThis = __webpack_require__(52058);
var fails = __webpack_require__(79645);
var isCallable = __webpack_require__(31808);
var isSymbol = __webpack_require__(44003);
var arraySlice = __webpack_require__(59591);
var getReplacerFunction = __webpack_require__(17061);
var NATIVE_SYMBOL = __webpack_require__(97987);

var $String = String;
var $stringify = getBuiltIn('JSON', 'stringify');
var exec = uncurryThis(/./.exec);
var charAt = uncurryThis(''.charAt);
var charCodeAt = uncurryThis(''.charCodeAt);
var replace = uncurryThis(''.replace);
var numberToString = uncurryThis(1.0.toString);

var tester = /[\uD800-\uDFFF]/g;
var low = /^[\uD800-\uDBFF]$/;
var hi = /^[\uDC00-\uDFFF]$/;

var WRONG_SYMBOLS_CONVERSION = !NATIVE_SYMBOL || fails(function () {
  var symbol = getBuiltIn('Symbol')('stringify detection');
  // MS Edge converts symbol values to JSON as {}
  return $stringify([symbol]) !== '[null]'
    // WebKit converts symbol values to JSON as null
    || $stringify({ a: symbol }) !== '{}'
    // V8 throws on boxed symbols
    || $stringify(Object(symbol)) !== '{}';
});

// https://github.com/tc39/proposal-well-formed-stringify
var ILL_FORMED_UNICODE = fails(function () {
  return $stringify('\uDF06\uD834') !== '"\\udf06\\ud834"'
    || $stringify('\uDEAD') !== '"\\udead"';
});

var stringifyWithSymbolsFix = function (it, replacer) {
  var args = arraySlice(arguments);
  var $replacer = getReplacerFunction(replacer);
  if (!isCallable($replacer) && (it === undefined || isSymbol(it))) return; // IE8 returns string on undefined
  args[1] = function (key, value) {
    // some old implementations (like WebKit) could pass numbers as keys
    if (isCallable($replacer)) value = call($replacer, this, $String(key), value);
    if (!isSymbol(value)) return value;
  };
  return apply($stringify, null, args);
};

var fixIllFormed = function (match, offset, string) {
  var prev = charAt(string, offset - 1);
  var next = charAt(string, offset + 1);
  if ((exec(low, match) && !exec(hi, next)) || (exec(hi, match) && !exec(low, prev))) {
    return '\\u' + numberToString(charCodeAt(match, 0), 16);
  } return match;
};

if ($stringify) {
  // `JSON.stringify` method
  // https://tc39.es/ecma262/#sec-json.stringify
  $({ target: 'JSON', stat: true, arity: 3, forced: WRONG_SYMBOLS_CONVERSION || ILL_FORMED_UNICODE }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function stringify(it, replacer, space) {
      var args = arraySlice(arguments);
      var result = apply(WRONG_SYMBOLS_CONVERSION ? stringifyWithSymbolsFix : $stringify, null, args);
      return ILL_FORMED_UNICODE && typeof result == 'string' ? replace(result, tester, fixIllFormed) : result;
    }
  });
}


/***/ }),

/***/ 88801:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(88903);
var $entries = (__webpack_require__(99842).entries);

// `Object.entries` method
// https://tc39.es/ecma262/#sec-object.entries
$({ target: 'Object', stat: true }, {
  entries: function entries(O) {
    return $entries(O);
  }
});


/***/ }),

/***/ 60530:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(88903);
var NATIVE_SYMBOL = __webpack_require__(97987);
var fails = __webpack_require__(79645);
var getOwnPropertySymbolsModule = __webpack_require__(28559);
var toObject = __webpack_require__(76075);

// V8 ~ Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FORCED = !NATIVE_SYMBOL || fails(function () { getOwnPropertySymbolsModule.f(1); });

// `Object.getOwnPropertySymbols` method
// https://tc39.es/ecma262/#sec-object.getownpropertysymbols
$({ target: 'Object', stat: true, forced: FORCED }, {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    var $getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
    return $getOwnPropertySymbols ? $getOwnPropertySymbols(toObject(it)) : [];
  }
});


/***/ }),

/***/ 65759:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(88903);
var toObject = __webpack_require__(76075);
var nativeKeys = __webpack_require__(88071);
var fails = __webpack_require__(79645);

var FAILS_ON_PRIMITIVES = fails(function () { nativeKeys(1); });

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  keys: function keys(it) {
    return nativeKeys(toObject(it));
  }
});


/***/ }),

/***/ 42578:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(88903);
var $values = (__webpack_require__(99842).values);

// `Object.values` method
// https://tc39.es/ecma262/#sec-object.values
$({ target: 'Object', stat: true }, {
  values: function values(O) {
    return $values(O);
  }
});


/***/ }),

/***/ 3009:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(88903);
var call = __webpack_require__(17725);
var aCallable = __webpack_require__(44596);
var newPromiseCapabilityModule = __webpack_require__(50606);
var perform = __webpack_require__(43639);
var iterate = __webpack_require__(41851);
var PROMISE_STATICS_INCORRECT_ITERATION = __webpack_require__(95289);

// `Promise.allSettled` method
// https://tc39.es/ecma262/#sec-promise.allsettled
$({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
  allSettled: function allSettled(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var promiseResolve = aCallable(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        remaining++;
        call(promiseResolve, C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = { status: 'fulfilled', value: value };
          --remaining || resolve(values);
        }, function (error) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = { status: 'rejected', reason: error };
          --remaining || resolve(values);
        });
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});


/***/ }),

/***/ 4482:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(88903);
var global = __webpack_require__(27990);
var call = __webpack_require__(17725);
var uncurryThis = __webpack_require__(52058);
var IS_PURE = __webpack_require__(81566);
var DESCRIPTORS = __webpack_require__(40369);
var NATIVE_SYMBOL = __webpack_require__(97987);
var fails = __webpack_require__(79645);
var hasOwn = __webpack_require__(48496);
var isPrototypeOf = __webpack_require__(88304);
var anObject = __webpack_require__(79308);
var toIndexedObject = __webpack_require__(17794);
var toPropertyKey = __webpack_require__(7171);
var $toString = __webpack_require__(70158);
var createPropertyDescriptor = __webpack_require__(56373);
var nativeObjectCreate = __webpack_require__(91026);
var objectKeys = __webpack_require__(88071);
var getOwnPropertyNamesModule = __webpack_require__(88766);
var getOwnPropertyNamesExternal = __webpack_require__(47092);
var getOwnPropertySymbolsModule = __webpack_require__(28559);
var getOwnPropertyDescriptorModule = __webpack_require__(94086);
var definePropertyModule = __webpack_require__(3002);
var definePropertiesModule = __webpack_require__(48065);
var propertyIsEnumerableModule = __webpack_require__(43740);
var defineBuiltIn = __webpack_require__(96561);
var defineBuiltInAccessor = __webpack_require__(4259);
var shared = __webpack_require__(69808);
var sharedKey = __webpack_require__(53273);
var hiddenKeys = __webpack_require__(80642);
var uid = __webpack_require__(40160);
var wellKnownSymbol = __webpack_require__(15537);
var wrappedWellKnownSymbolModule = __webpack_require__(45134);
var defineWellKnownSymbol = __webpack_require__(94534);
var defineSymbolToPrimitive = __webpack_require__(52411);
var setToStringTag = __webpack_require__(71508);
var InternalStateModule = __webpack_require__(47776);
var $forEach = (__webpack_require__(28695).forEach);

var HIDDEN = sharedKey('hidden');
var SYMBOL = 'Symbol';
var PROTOTYPE = 'prototype';

var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(SYMBOL);

var ObjectPrototype = Object[PROTOTYPE];
var $Symbol = global.Symbol;
var SymbolPrototype = $Symbol && $Symbol[PROTOTYPE];
var TypeError = global.TypeError;
var QObject = global.QObject;
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var nativeDefineProperty = definePropertyModule.f;
var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
var nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
var push = uncurryThis([].push);

var AllSymbols = shared('symbols');
var ObjectPrototypeSymbols = shared('op-symbols');
var WellKnownSymbolsStore = shared('wks');

// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDescriptor = DESCRIPTORS && fails(function () {
  return nativeObjectCreate(nativeDefineProperty({}, 'a', {
    get: function () { return nativeDefineProperty(this, 'a', { value: 7 }).a; }
  })).a !== 7;
}) ? function (O, P, Attributes) {
  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype, P);
  if (ObjectPrototypeDescriptor) delete ObjectPrototype[P];
  nativeDefineProperty(O, P, Attributes);
  if (ObjectPrototypeDescriptor && O !== ObjectPrototype) {
    nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor);
  }
} : nativeDefineProperty;

var wrap = function (tag, description) {
  var symbol = AllSymbols[tag] = nativeObjectCreate(SymbolPrototype);
  setInternalState(symbol, {
    type: SYMBOL,
    tag: tag,
    description: description
  });
  if (!DESCRIPTORS) symbol.description = description;
  return symbol;
};

var $defineProperty = function defineProperty(O, P, Attributes) {
  if (O === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
  anObject(O);
  var key = toPropertyKey(P);
  anObject(Attributes);
  if (hasOwn(AllSymbols, key)) {
    if (!Attributes.enumerable) {
      if (!hasOwn(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {}));
      O[HIDDEN][key] = true;
    } else {
      if (hasOwn(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
      Attributes = nativeObjectCreate(Attributes, { enumerable: createPropertyDescriptor(0, false) });
    } return setSymbolDescriptor(O, key, Attributes);
  } return nativeDefineProperty(O, key, Attributes);
};

var $defineProperties = function defineProperties(O, Properties) {
  anObject(O);
  var properties = toIndexedObject(Properties);
  var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
  $forEach(keys, function (key) {
    if (!DESCRIPTORS || call($propertyIsEnumerable, properties, key)) $defineProperty(O, key, properties[key]);
  });
  return O;
};

var $create = function create(O, Properties) {
  return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
};

var $propertyIsEnumerable = function propertyIsEnumerable(V) {
  var P = toPropertyKey(V);
  var enumerable = call(nativePropertyIsEnumerable, this, P);
  if (this === ObjectPrototype && hasOwn(AllSymbols, P) && !hasOwn(ObjectPrototypeSymbols, P)) return false;
  return enumerable || !hasOwn(this, P) || !hasOwn(AllSymbols, P) || hasOwn(this, HIDDEN) && this[HIDDEN][P]
    ? enumerable : true;
};

var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
  var it = toIndexedObject(O);
  var key = toPropertyKey(P);
  if (it === ObjectPrototype && hasOwn(AllSymbols, key) && !hasOwn(ObjectPrototypeSymbols, key)) return;
  var descriptor = nativeGetOwnPropertyDescriptor(it, key);
  if (descriptor && hasOwn(AllSymbols, key) && !(hasOwn(it, HIDDEN) && it[HIDDEN][key])) {
    descriptor.enumerable = true;
  }
  return descriptor;
};

var $getOwnPropertyNames = function getOwnPropertyNames(O) {
  var names = nativeGetOwnPropertyNames(toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (!hasOwn(AllSymbols, key) && !hasOwn(hiddenKeys, key)) push(result, key);
  });
  return result;
};

var $getOwnPropertySymbols = function (O) {
  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
  var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (hasOwn(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || hasOwn(ObjectPrototype, key))) {
      push(result, AllSymbols[key]);
    }
  });
  return result;
};

// `Symbol` constructor
// https://tc39.es/ecma262/#sec-symbol-constructor
if (!NATIVE_SYMBOL) {
  $Symbol = function Symbol() {
    if (isPrototypeOf(SymbolPrototype, this)) throw TypeError('Symbol is not a constructor');
    var description = !arguments.length || arguments[0] === undefined ? undefined : $toString(arguments[0]);
    var tag = uid(description);
    var setter = function (value) {
      if (this === ObjectPrototype) call(setter, ObjectPrototypeSymbols, value);
      if (hasOwn(this, HIDDEN) && hasOwn(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
    };
    if (DESCRIPTORS && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, { configurable: true, set: setter });
    return wrap(tag, description);
  };

  SymbolPrototype = $Symbol[PROTOTYPE];

  defineBuiltIn(SymbolPrototype, 'toString', function toString() {
    return getInternalState(this).tag;
  });

  defineBuiltIn($Symbol, 'withoutSetter', function (description) {
    return wrap(uid(description), description);
  });

  propertyIsEnumerableModule.f = $propertyIsEnumerable;
  definePropertyModule.f = $defineProperty;
  definePropertiesModule.f = $defineProperties;
  getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
  getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
  getOwnPropertySymbolsModule.f = $getOwnPropertySymbols;

  wrappedWellKnownSymbolModule.f = function (name) {
    return wrap(wellKnownSymbol(name), name);
  };

  if (DESCRIPTORS) {
    // https://github.com/tc39/proposal-Symbol-description
    defineBuiltInAccessor(SymbolPrototype, 'description', {
      configurable: true,
      get: function description() {
        return getInternalState(this).description;
      }
    });
    if (!IS_PURE) {
      defineBuiltIn(ObjectPrototype, 'propertyIsEnumerable', $propertyIsEnumerable, { unsafe: true });
    }
  }
}

$({ global: true, constructor: true, wrap: true, forced: !NATIVE_SYMBOL, sham: !NATIVE_SYMBOL }, {
  Symbol: $Symbol
});

$forEach(objectKeys(WellKnownSymbolsStore), function (name) {
  defineWellKnownSymbol(name);
});

$({ target: SYMBOL, stat: true, forced: !NATIVE_SYMBOL }, {
  useSetter: function () { USE_SETTER = true; },
  useSimple: function () { USE_SETTER = false; }
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL, sham: !DESCRIPTORS }, {
  // `Object.create` method
  // https://tc39.es/ecma262/#sec-object.create
  create: $create,
  // `Object.defineProperty` method
  // https://tc39.es/ecma262/#sec-object.defineproperty
  defineProperty: $defineProperty,
  // `Object.defineProperties` method
  // https://tc39.es/ecma262/#sec-object.defineproperties
  defineProperties: $defineProperties,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.es/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: $getOwnPropertyNames
});

// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
defineSymbolToPrimitive();

// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag($Symbol, SYMBOL);

hiddenKeys[HIDDEN] = true;


/***/ }),

/***/ 98840:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(88903);
var getBuiltIn = __webpack_require__(91553);
var hasOwn = __webpack_require__(48496);
var toString = __webpack_require__(70158);
var shared = __webpack_require__(69808);
var NATIVE_SYMBOL_REGISTRY = __webpack_require__(53482);

var StringToSymbolRegistry = shared('string-to-symbol-registry');
var SymbolToStringRegistry = shared('symbol-to-string-registry');

// `Symbol.for` method
// https://tc39.es/ecma262/#sec-symbol.for
$({ target: 'Symbol', stat: true, forced: !NATIVE_SYMBOL_REGISTRY }, {
  'for': function (key) {
    var string = toString(key);
    if (hasOwn(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
    var symbol = getBuiltIn('Symbol')(string);
    StringToSymbolRegistry[string] = symbol;
    SymbolToStringRegistry[symbol] = string;
    return symbol;
  }
});


/***/ }),

/***/ 52318:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

// TODO: Remove this module from `core-js@4` since it's split to modules listed below
__webpack_require__(4482);
__webpack_require__(98840);
__webpack_require__(19573);
__webpack_require__(83066);
__webpack_require__(60530);


/***/ }),

/***/ 19573:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__(88903);
var hasOwn = __webpack_require__(48496);
var isSymbol = __webpack_require__(44003);
var tryToString = __webpack_require__(38151);
var shared = __webpack_require__(69808);
var NATIVE_SYMBOL_REGISTRY = __webpack_require__(53482);

var SymbolToStringRegistry = shared('symbol-to-string-registry');

// `Symbol.keyFor` method
// https://tc39.es/ecma262/#sec-symbol.keyfor
$({ target: 'Symbol', stat: true, forced: !NATIVE_SYMBOL_REGISTRY }, {
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(tryToString(sym) + ' is not a symbol');
    if (hasOwn(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
  }
});


/***/ }),

/***/ 41182:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory();
	}
	else {}
}(this, function () {

	/*globals window, global, require*/

	/**
	 * CryptoJS core components.
	 */
	var CryptoJS = CryptoJS || (function (Math, undefined) {

	    var crypto;

	    // Native crypto from window (Browser)
	    if (typeof window !== 'undefined' && window.crypto) {
	        crypto = window.crypto;
	    }

	    // Native crypto in web worker (Browser)
	    if (typeof self !== 'undefined' && self.crypto) {
	        crypto = self.crypto;
	    }

	    // Native crypto from worker
	    if (typeof globalThis !== 'undefined' && globalThis.crypto) {
	        crypto = globalThis.crypto;
	    }

	    // Native (experimental IE 11) crypto from window (Browser)
	    if (!crypto && typeof window !== 'undefined' && window.msCrypto) {
	        crypto = window.msCrypto;
	    }

	    // Native crypto from global (NodeJS)
	    if (!crypto && typeof __webpack_require__.g !== 'undefined' && __webpack_require__.g.crypto) {
	        crypto = __webpack_require__.g.crypto;
	    }

	    // Native crypto import via require (NodeJS)
	    if (!crypto && "function" === 'function') {
	        try {
	            crypto = __webpack_require__(91054);
	        } catch (err) {}
	    }

	    /*
	     * Cryptographically secure pseudorandom number generator
	     *
	     * As Math.random() is cryptographically not safe to use
	     */
	    var cryptoSecureRandomInt = function () {
	        if (crypto) {
	            // Use getRandomValues method (Browser)
	            if (typeof crypto.getRandomValues === 'function') {
	                try {
	                    return crypto.getRandomValues(new Uint32Array(1))[0];
	                } catch (err) {}
	            }

	            // Use randomBytes method (NodeJS)
	            if (typeof crypto.randomBytes === 'function') {
	                try {
	                    return crypto.randomBytes(4).readInt32LE();
	                } catch (err) {}
	            }
	        }

	        throw new Error('Native crypto module could not be used to get secure random number.');
	    };

	    /*
	     * Local polyfill of Object.create

	     */
	    var create = Object.create || (function () {
	        function F() {}

	        return function (obj) {
	            var subtype;

	            F.prototype = obj;

	            subtype = new F();

	            F.prototype = null;

	            return subtype;
	        };
	    }());

	    /**
	     * CryptoJS namespace.
	     */
	    var C = {};

	    /**
	     * Library namespace.
	     */
	    var C_lib = C.lib = {};

	    /**
	     * Base object for prototypal inheritance.
	     */
	    var Base = C_lib.Base = (function () {


	        return {
	            /**
	             * Creates a new object that inherits from this object.
	             *
	             * @param {Object} overrides Properties to copy into the new object.
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         field: 'value',
	             *
	             *         method: function () {
	             *         }
	             *     });
	             */
	            extend: function (overrides) {
	                // Spawn
	                var subtype = create(this);

	                // Augment
	                if (overrides) {
	                    subtype.mixIn(overrides);
	                }

	                // Create default initializer
	                if (!subtype.hasOwnProperty('init') || this.init === subtype.init) {
	                    subtype.init = function () {
	                        subtype.$super.init.apply(this, arguments);
	                    };
	                }

	                // Initializer's prototype is the subtype object
	                subtype.init.prototype = subtype;

	                // Reference supertype
	                subtype.$super = this;

	                return subtype;
	            },

	            /**
	             * Extends this object and runs the init method.
	             * Arguments to create() will be passed to init().
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var instance = MyType.create();
	             */
	            create: function () {
	                var instance = this.extend();
	                instance.init.apply(instance, arguments);

	                return instance;
	            },

	            /**
	             * Initializes a newly created object.
	             * Override this method to add some logic when your objects are created.
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         init: function () {
	             *             // ...
	             *         }
	             *     });
	             */
	            init: function () {
	            },

	            /**
	             * Copies properties into this object.
	             *
	             * @param {Object} properties The properties to mix in.
	             *
	             * @example
	             *
	             *     MyType.mixIn({
	             *         field: 'value'
	             *     });
	             */
	            mixIn: function (properties) {
	                for (var propertyName in properties) {
	                    if (properties.hasOwnProperty(propertyName)) {
	                        this[propertyName] = properties[propertyName];
	                    }
	                }

	                // IE won't copy toString using the loop above
	                if (properties.hasOwnProperty('toString')) {
	                    this.toString = properties.toString;
	                }
	            },

	            /**
	             * Creates a copy of this object.
	             *
	             * @return {Object} The clone.
	             *
	             * @example
	             *
	             *     var clone = instance.clone();
	             */
	            clone: function () {
	                return this.init.prototype.extend(this);
	            }
	        };
	    }());

	    /**
	     * An array of 32-bit words.
	     *
	     * @property {Array} words The array of 32-bit words.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */
	    var WordArray = C_lib.WordArray = Base.extend({
	        /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of 32-bit words.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.create();
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
	         */
	        init: function (words, sigBytes) {
	            words = this.words = words || [];

	            if (sigBytes != undefined) {
	                this.sigBytes = sigBytes;
	            } else {
	                this.sigBytes = words.length * 4;
	            }
	        },

	        /**
	         * Converts this word array to a string.
	         *
	         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
	         *
	         * @return {string} The stringified word array.
	         *
	         * @example
	         *
	         *     var string = wordArray + '';
	         *     var string = wordArray.toString();
	         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
	         */
	        toString: function (encoder) {
	            return (encoder || Hex).stringify(this);
	        },

	        /**
	         * Concatenates a word array to this word array.
	         *
	         * @param {WordArray} wordArray The word array to append.
	         *
	         * @return {WordArray} This word array.
	         *
	         * @example
	         *
	         *     wordArray1.concat(wordArray2);
	         */
	        concat: function (wordArray) {
	            // Shortcuts
	            var thisWords = this.words;
	            var thatWords = wordArray.words;
	            var thisSigBytes = this.sigBytes;
	            var thatSigBytes = wordArray.sigBytes;

	            // Clamp excess bits
	            this.clamp();

	            // Concat
	            if (thisSigBytes % 4) {
	                // Copy one byte at a time
	                for (var i = 0; i < thatSigBytes; i++) {
	                    var thatByte = (thatWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                    thisWords[(thisSigBytes + i) >>> 2] |= thatByte << (24 - ((thisSigBytes + i) % 4) * 8);
	                }
	            } else {
	                // Copy one word at a time
	                for (var j = 0; j < thatSigBytes; j += 4) {
	                    thisWords[(thisSigBytes + j) >>> 2] = thatWords[j >>> 2];
	                }
	            }
	            this.sigBytes += thatSigBytes;

	            // Chainable
	            return this;
	        },

	        /**
	         * Removes insignificant bits.
	         *
	         * @example
	         *
	         *     wordArray.clamp();
	         */
	        clamp: function () {
	            // Shortcuts
	            var words = this.words;
	            var sigBytes = this.sigBytes;

	            // Clamp
	            words[sigBytes >>> 2] &= 0xffffffff << (32 - (sigBytes % 4) * 8);
	            words.length = Math.ceil(sigBytes / 4);
	        },

	        /**
	         * Creates a copy of this word array.
	         *
	         * @return {WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = wordArray.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);
	            clone.words = this.words.slice(0);

	            return clone;
	        },

	        /**
	         * Creates a word array filled with random bytes.
	         *
	         * @param {number} nBytes The number of random bytes to generate.
	         *
	         * @return {WordArray} The random word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.random(16);
	         */
	        random: function (nBytes) {
	            var words = [];

	            for (var i = 0; i < nBytes; i += 4) {
	                words.push(cryptoSecureRandomInt());
	            }

	            return new WordArray.init(words, nBytes);
	        }
	    });

	    /**
	     * Encoder namespace.
	     */
	    var C_enc = C.enc = {};

	    /**
	     * Hex encoding strategy.
	     */
	    var Hex = C_enc.Hex = {
	        /**
	         * Converts a word array to a hex string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The hex string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var hexChars = [];
	            for (var i = 0; i < sigBytes; i++) {
	                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                hexChars.push((bite >>> 4).toString(16));
	                hexChars.push((bite & 0x0f).toString(16));
	            }

	            return hexChars.join('');
	        },

	        /**
	         * Converts a hex string to a word array.
	         *
	         * @param {string} hexStr The hex string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
	         */
	        parse: function (hexStr) {
	            // Shortcut
	            var hexStrLength = hexStr.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < hexStrLength; i += 2) {
	                words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << (24 - (i % 8) * 4);
	            }

	            return new WordArray.init(words, hexStrLength / 2);
	        }
	    };

	    /**
	     * Latin1 encoding strategy.
	     */
	    var Latin1 = C_enc.Latin1 = {
	        /**
	         * Converts a word array to a Latin1 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Latin1 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var latin1Chars = [];
	            for (var i = 0; i < sigBytes; i++) {
	                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                latin1Chars.push(String.fromCharCode(bite));
	            }

	            return latin1Chars.join('');
	        },

	        /**
	         * Converts a Latin1 string to a word array.
	         *
	         * @param {string} latin1Str The Latin1 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
	         */
	        parse: function (latin1Str) {
	            // Shortcut
	            var latin1StrLength = latin1Str.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < latin1StrLength; i++) {
	                words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << (24 - (i % 4) * 8);
	            }

	            return new WordArray.init(words, latin1StrLength);
	        }
	    };

	    /**
	     * UTF-8 encoding strategy.
	     */
	    var Utf8 = C_enc.Utf8 = {
	        /**
	         * Converts a word array to a UTF-8 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-8 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            try {
	                return decodeURIComponent(escape(Latin1.stringify(wordArray)));
	            } catch (e) {
	                throw new Error('Malformed UTF-8 data');
	            }
	        },

	        /**
	         * Converts a UTF-8 string to a word array.
	         *
	         * @param {string} utf8Str The UTF-8 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
	         */
	        parse: function (utf8Str) {
	            return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
	        }
	    };

	    /**
	     * Abstract buffered block algorithm template.
	     *
	     * The property blockSize must be implemented in a concrete subtype.
	     *
	     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
	     */
	    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
	        /**
	         * Resets this block algorithm's data buffer to its initial state.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm.reset();
	         */
	        reset: function () {
	            // Initial values
	            this._data = new WordArray.init();
	            this._nDataBytes = 0;
	        },

	        /**
	         * Adds new data to this block algorithm's buffer.
	         *
	         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm._append('data');
	         *     bufferedBlockAlgorithm._append(wordArray);
	         */
	        _append: function (data) {
	            // Convert string to WordArray, else assume WordArray already
	            if (typeof data == 'string') {
	                data = Utf8.parse(data);
	            }

	            // Append
	            this._data.concat(data);
	            this._nDataBytes += data.sigBytes;
	        },

	        /**
	         * Processes available data blocks.
	         *
	         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
	         *
	         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
	         *
	         * @return {WordArray} The processed data.
	         *
	         * @example
	         *
	         *     var processedData = bufferedBlockAlgorithm._process();
	         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
	         */
	        _process: function (doFlush) {
	            var processedWords;

	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;
	            var dataSigBytes = data.sigBytes;
	            var blockSize = this.blockSize;
	            var blockSizeBytes = blockSize * 4;

	            // Count blocks ready
	            var nBlocksReady = dataSigBytes / blockSizeBytes;
	            if (doFlush) {
	                // Round up to include partial blocks
	                nBlocksReady = Math.ceil(nBlocksReady);
	            } else {
	                // Round down to include only full blocks,
	                // less the number of blocks that must remain in the buffer
	                nBlocksReady = Math.max((nBlocksReady | 0) - this._minBufferSize, 0);
	            }

	            // Count words ready
	            var nWordsReady = nBlocksReady * blockSize;

	            // Count bytes ready
	            var nBytesReady = Math.min(nWordsReady * 4, dataSigBytes);

	            // Process blocks
	            if (nWordsReady) {
	                for (var offset = 0; offset < nWordsReady; offset += blockSize) {
	                    // Perform concrete-algorithm logic
	                    this._doProcessBlock(dataWords, offset);
	                }

	                // Remove processed words
	                processedWords = dataWords.splice(0, nWordsReady);
	                data.sigBytes -= nBytesReady;
	            }

	            // Return processed words
	            return new WordArray.init(processedWords, nBytesReady);
	        },

	        /**
	         * Creates a copy of this object.
	         *
	         * @return {Object} The clone.
	         *
	         * @example
	         *
	         *     var clone = bufferedBlockAlgorithm.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);
	            clone._data = this._data.clone();

	            return clone;
	        },

	        _minBufferSize: 0
	    });

	    /**
	     * Abstract hasher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
	     */
	    var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
	        /**
	         * Configuration options.
	         */
	        cfg: Base.extend(),

	        /**
	         * Initializes a newly created hasher.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
	         *
	         * @example
	         *
	         *     var hasher = CryptoJS.algo.SHA256.create();
	         */
	        init: function (cfg) {
	            // Apply config defaults
	            this.cfg = this.cfg.extend(cfg);

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this hasher to its initial state.
	         *
	         * @example
	         *
	         *     hasher.reset();
	         */
	        reset: function () {
	            // Reset data buffer
	            BufferedBlockAlgorithm.reset.call(this);

	            // Perform concrete-hasher logic
	            this._doReset();
	        },

	        /**
	         * Updates this hasher with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {Hasher} This hasher.
	         *
	         * @example
	         *
	         *     hasher.update('message');
	         *     hasher.update(wordArray);
	         */
	        update: function (messageUpdate) {
	            // Append
	            this._append(messageUpdate);

	            // Update the hash
	            this._process();

	            // Chainable
	            return this;
	        },

	        /**
	         * Finalizes the hash computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The hash.
	         *
	         * @example
	         *
	         *     var hash = hasher.finalize();
	         *     var hash = hasher.finalize('message');
	         *     var hash = hasher.finalize(wordArray);
	         */
	        finalize: function (messageUpdate) {
	            // Final message update
	            if (messageUpdate) {
	                this._append(messageUpdate);
	            }

	            // Perform concrete-hasher logic
	            var hash = this._doFinalize();

	            return hash;
	        },

	        blockSize: 512/32,

	        /**
	         * Creates a shortcut function to a hasher's object interface.
	         *
	         * @param {Hasher} hasher The hasher to create a helper for.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
	         */
	        _createHelper: function (hasher) {
	            return function (message, cfg) {
	                return new hasher.init(cfg).finalize(message);
	            };
	        },

	        /**
	         * Creates a shortcut function to the HMAC's object interface.
	         *
	         * @param {Hasher} hasher The hasher to use in this HMAC helper.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
	         */
	        _createHmacHelper: function (hasher) {
	            return function (message, key) {
	                return new C_algo.HMAC.init(hasher, key).finalize(message);
	            };
	        }
	    });

	    /**
	     * Algorithm namespace.
	     */
	    var C_algo = C.algo = {};

	    return C;
	}(Math));


	return CryptoJS;

}));

/***/ }),

/***/ 33490:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(41182));
	}
	else {}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var C_enc = C.enc;

	    /**
	     * Base64 encoding strategy.
	     */
	    var Base64 = C_enc.Base64 = {
	        /**
	         * Converts a word array to a Base64 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Base64 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;
	            var map = this._map;

	            // Clamp excess bits
	            wordArray.clamp();

	            // Convert
	            var base64Chars = [];
	            for (var i = 0; i < sigBytes; i += 3) {
	                var byte1 = (words[i >>> 2]       >>> (24 - (i % 4) * 8))       & 0xff;
	                var byte2 = (words[(i + 1) >>> 2] >>> (24 - ((i + 1) % 4) * 8)) & 0xff;
	                var byte3 = (words[(i + 2) >>> 2] >>> (24 - ((i + 2) % 4) * 8)) & 0xff;

	                var triplet = (byte1 << 16) | (byte2 << 8) | byte3;

	                for (var j = 0; (j < 4) && (i + j * 0.75 < sigBytes); j++) {
	                    base64Chars.push(map.charAt((triplet >>> (6 * (3 - j))) & 0x3f));
	                }
	            }

	            // Add padding
	            var paddingChar = map.charAt(64);
	            if (paddingChar) {
	                while (base64Chars.length % 4) {
	                    base64Chars.push(paddingChar);
	                }
	            }

	            return base64Chars.join('');
	        },

	        /**
	         * Converts a Base64 string to a word array.
	         *
	         * @param {string} base64Str The Base64 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
	         */
	        parse: function (base64Str) {
	            // Shortcuts
	            var base64StrLength = base64Str.length;
	            var map = this._map;
	            var reverseMap = this._reverseMap;

	            if (!reverseMap) {
	                    reverseMap = this._reverseMap = [];
	                    for (var j = 0; j < map.length; j++) {
	                        reverseMap[map.charCodeAt(j)] = j;
	                    }
	            }

	            // Ignore padding
	            var paddingChar = map.charAt(64);
	            if (paddingChar) {
	                var paddingIndex = base64Str.indexOf(paddingChar);
	                if (paddingIndex !== -1) {
	                    base64StrLength = paddingIndex;
	                }
	            }

	            // Convert
	            return parseLoop(base64Str, base64StrLength, reverseMap);

	        },

	        _map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
	    };

	    function parseLoop(base64Str, base64StrLength, reverseMap) {
	      var words = [];
	      var nBytes = 0;
	      for (var i = 0; i < base64StrLength; i++) {
	          if (i % 4) {
	              var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << ((i % 4) * 2);
	              var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> (6 - (i % 4) * 2);
	              var bitsCombined = bits1 | bits2;
	              words[nBytes >>> 2] |= bitsCombined << (24 - (nBytes % 4) * 8);
	              nBytes++;
	          }
	      }
	      return WordArray.create(words, nBytes);
	    }
	}());


	return CryptoJS.enc.Base64;

}));

/***/ }),

/***/ 2447:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(41182));
	}
	else {}
}(this, function (CryptoJS) {

	return CryptoJS.enc.Hex;

}));

/***/ }),

/***/ 26551:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(41182));
	}
	else {}
}(this, function (CryptoJS) {

	return CryptoJS.enc.Utf8;

}));

/***/ }),

/***/ 69764:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(41182), __webpack_require__(99968), __webpack_require__(77892));
	}
	else {}
}(this, function (CryptoJS) {

	return CryptoJS.HmacSHA1;

}));

/***/ }),

/***/ 77892:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(41182));
	}
	else {}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var C_enc = C.enc;
	    var Utf8 = C_enc.Utf8;
	    var C_algo = C.algo;

	    /**
	     * HMAC algorithm.
	     */
	    var HMAC = C_algo.HMAC = Base.extend({
	        /**
	         * Initializes a newly created HMAC.
	         *
	         * @param {Hasher} hasher The hash algorithm to use.
	         * @param {WordArray|string} key The secret key.
	         *
	         * @example
	         *
	         *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
	         */
	        init: function (hasher, key) {
	            // Init hasher
	            hasher = this._hasher = new hasher.init();

	            // Convert string to WordArray, else assume WordArray already
	            if (typeof key == 'string') {
	                key = Utf8.parse(key);
	            }

	            // Shortcuts
	            var hasherBlockSize = hasher.blockSize;
	            var hasherBlockSizeBytes = hasherBlockSize * 4;

	            // Allow arbitrary length keys
	            if (key.sigBytes > hasherBlockSizeBytes) {
	                key = hasher.finalize(key);
	            }

	            // Clamp excess bits
	            key.clamp();

	            // Clone key for inner and outer pads
	            var oKey = this._oKey = key.clone();
	            var iKey = this._iKey = key.clone();

	            // Shortcuts
	            var oKeyWords = oKey.words;
	            var iKeyWords = iKey.words;

	            // XOR keys with pad constants
	            for (var i = 0; i < hasherBlockSize; i++) {
	                oKeyWords[i] ^= 0x5c5c5c5c;
	                iKeyWords[i] ^= 0x36363636;
	            }
	            oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this HMAC to its initial state.
	         *
	         * @example
	         *
	         *     hmacHasher.reset();
	         */
	        reset: function () {
	            // Shortcut
	            var hasher = this._hasher;

	            // Reset
	            hasher.reset();
	            hasher.update(this._iKey);
	        },

	        /**
	         * Updates this HMAC with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {HMAC} This HMAC instance.
	         *
	         * @example
	         *
	         *     hmacHasher.update('message');
	         *     hmacHasher.update(wordArray);
	         */
	        update: function (messageUpdate) {
	            this._hasher.update(messageUpdate);

	            // Chainable
	            return this;
	        },

	        /**
	         * Finalizes the HMAC computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The HMAC.
	         *
	         * @example
	         *
	         *     var hmac = hmacHasher.finalize();
	         *     var hmac = hmacHasher.finalize('message');
	         *     var hmac = hmacHasher.finalize(wordArray);
	         */
	        finalize: function (messageUpdate) {
	            // Shortcut
	            var hasher = this._hasher;

	            // Compute HMAC
	            var innerHash = hasher.finalize(messageUpdate);
	            hasher.reset();
	            var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));

	            return hmac;
	        }
	    });
	}());


}));

/***/ }),

/***/ 59834:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(41182));
	}
	else {}
}(this, function (CryptoJS) {

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Constants table
	    var T = [];

	    // Compute constants
	    (function () {
	        for (var i = 0; i < 64; i++) {
	            T[i] = (Math.abs(Math.sin(i + 1)) * 0x100000000) | 0;
	        }
	    }());

	    /**
	     * MD5 hash algorithm.
	     */
	    var MD5 = C_algo.MD5 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init([
	                0x67452301, 0xefcdab89,
	                0x98badcfe, 0x10325476
	            ]);
	        },

	        _doProcessBlock: function (M, offset) {
	            // Swap endian
	            for (var i = 0; i < 16; i++) {
	                // Shortcuts
	                var offset_i = offset + i;
	                var M_offset_i = M[offset_i];

	                M[offset_i] = (
	                    (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
	                    (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
	                );
	            }

	            // Shortcuts
	            var H = this._hash.words;

	            var M_offset_0  = M[offset + 0];
	            var M_offset_1  = M[offset + 1];
	            var M_offset_2  = M[offset + 2];
	            var M_offset_3  = M[offset + 3];
	            var M_offset_4  = M[offset + 4];
	            var M_offset_5  = M[offset + 5];
	            var M_offset_6  = M[offset + 6];
	            var M_offset_7  = M[offset + 7];
	            var M_offset_8  = M[offset + 8];
	            var M_offset_9  = M[offset + 9];
	            var M_offset_10 = M[offset + 10];
	            var M_offset_11 = M[offset + 11];
	            var M_offset_12 = M[offset + 12];
	            var M_offset_13 = M[offset + 13];
	            var M_offset_14 = M[offset + 14];
	            var M_offset_15 = M[offset + 15];

	            // Working variables
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];

	            // Computation
	            a = FF(a, b, c, d, M_offset_0,  7,  T[0]);
	            d = FF(d, a, b, c, M_offset_1,  12, T[1]);
	            c = FF(c, d, a, b, M_offset_2,  17, T[2]);
	            b = FF(b, c, d, a, M_offset_3,  22, T[3]);
	            a = FF(a, b, c, d, M_offset_4,  7,  T[4]);
	            d = FF(d, a, b, c, M_offset_5,  12, T[5]);
	            c = FF(c, d, a, b, M_offset_6,  17, T[6]);
	            b = FF(b, c, d, a, M_offset_7,  22, T[7]);
	            a = FF(a, b, c, d, M_offset_8,  7,  T[8]);
	            d = FF(d, a, b, c, M_offset_9,  12, T[9]);
	            c = FF(c, d, a, b, M_offset_10, 17, T[10]);
	            b = FF(b, c, d, a, M_offset_11, 22, T[11]);
	            a = FF(a, b, c, d, M_offset_12, 7,  T[12]);
	            d = FF(d, a, b, c, M_offset_13, 12, T[13]);
	            c = FF(c, d, a, b, M_offset_14, 17, T[14]);
	            b = FF(b, c, d, a, M_offset_15, 22, T[15]);

	            a = GG(a, b, c, d, M_offset_1,  5,  T[16]);
	            d = GG(d, a, b, c, M_offset_6,  9,  T[17]);
	            c = GG(c, d, a, b, M_offset_11, 14, T[18]);
	            b = GG(b, c, d, a, M_offset_0,  20, T[19]);
	            a = GG(a, b, c, d, M_offset_5,  5,  T[20]);
	            d = GG(d, a, b, c, M_offset_10, 9,  T[21]);
	            c = GG(c, d, a, b, M_offset_15, 14, T[22]);
	            b = GG(b, c, d, a, M_offset_4,  20, T[23]);
	            a = GG(a, b, c, d, M_offset_9,  5,  T[24]);
	            d = GG(d, a, b, c, M_offset_14, 9,  T[25]);
	            c = GG(c, d, a, b, M_offset_3,  14, T[26]);
	            b = GG(b, c, d, a, M_offset_8,  20, T[27]);
	            a = GG(a, b, c, d, M_offset_13, 5,  T[28]);
	            d = GG(d, a, b, c, M_offset_2,  9,  T[29]);
	            c = GG(c, d, a, b, M_offset_7,  14, T[30]);
	            b = GG(b, c, d, a, M_offset_12, 20, T[31]);

	            a = HH(a, b, c, d, M_offset_5,  4,  T[32]);
	            d = HH(d, a, b, c, M_offset_8,  11, T[33]);
	            c = HH(c, d, a, b, M_offset_11, 16, T[34]);
	            b = HH(b, c, d, a, M_offset_14, 23, T[35]);
	            a = HH(a, b, c, d, M_offset_1,  4,  T[36]);
	            d = HH(d, a, b, c, M_offset_4,  11, T[37]);
	            c = HH(c, d, a, b, M_offset_7,  16, T[38]);
	            b = HH(b, c, d, a, M_offset_10, 23, T[39]);
	            a = HH(a, b, c, d, M_offset_13, 4,  T[40]);
	            d = HH(d, a, b, c, M_offset_0,  11, T[41]);
	            c = HH(c, d, a, b, M_offset_3,  16, T[42]);
	            b = HH(b, c, d, a, M_offset_6,  23, T[43]);
	            a = HH(a, b, c, d, M_offset_9,  4,  T[44]);
	            d = HH(d, a, b, c, M_offset_12, 11, T[45]);
	            c = HH(c, d, a, b, M_offset_15, 16, T[46]);
	            b = HH(b, c, d, a, M_offset_2,  23, T[47]);

	            a = II(a, b, c, d, M_offset_0,  6,  T[48]);
	            d = II(d, a, b, c, M_offset_7,  10, T[49]);
	            c = II(c, d, a, b, M_offset_14, 15, T[50]);
	            b = II(b, c, d, a, M_offset_5,  21, T[51]);
	            a = II(a, b, c, d, M_offset_12, 6,  T[52]);
	            d = II(d, a, b, c, M_offset_3,  10, T[53]);
	            c = II(c, d, a, b, M_offset_10, 15, T[54]);
	            b = II(b, c, d, a, M_offset_1,  21, T[55]);
	            a = II(a, b, c, d, M_offset_8,  6,  T[56]);
	            d = II(d, a, b, c, M_offset_15, 10, T[57]);
	            c = II(c, d, a, b, M_offset_6,  15, T[58]);
	            b = II(b, c, d, a, M_offset_13, 21, T[59]);
	            a = II(a, b, c, d, M_offset_4,  6,  T[60]);
	            d = II(d, a, b, c, M_offset_11, 10, T[61]);
	            c = II(c, d, a, b, M_offset_2,  15, T[62]);
	            b = II(b, c, d, a, M_offset_9,  21, T[63]);

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);

	            var nBitsTotalH = Math.floor(nBitsTotal / 0x100000000);
	            var nBitsTotalL = nBitsTotal;
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = (
	                (((nBitsTotalH << 8)  | (nBitsTotalH >>> 24)) & 0x00ff00ff) |
	                (((nBitsTotalH << 24) | (nBitsTotalH >>> 8))  & 0xff00ff00)
	            );
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
	                (((nBitsTotalL << 8)  | (nBitsTotalL >>> 24)) & 0x00ff00ff) |
	                (((nBitsTotalL << 24) | (nBitsTotalL >>> 8))  & 0xff00ff00)
	            );

	            data.sigBytes = (dataWords.length + 1) * 4;

	            // Hash final blocks
	            this._process();

	            // Shortcuts
	            var hash = this._hash;
	            var H = hash.words;

	            // Swap endian
	            for (var i = 0; i < 4; i++) {
	                // Shortcut
	                var H_i = H[i];

	                H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
	                       (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
	            }

	            // Return final computed hash
	            return hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    function FF(a, b, c, d, x, s, t) {
	        var n = a + ((b & c) | (~b & d)) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    function GG(a, b, c, d, x, s, t) {
	        var n = a + ((b & d) | (c & ~d)) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    function HH(a, b, c, d, x, s, t) {
	        var n = a + (b ^ c ^ d) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    function II(a, b, c, d, x, s, t) {
	        var n = a + (c ^ (b | ~d)) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.MD5('message');
	     *     var hash = CryptoJS.MD5(wordArray);
	     */
	    C.MD5 = Hasher._createHelper(MD5);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacMD5(message, key);
	     */
	    C.HmacMD5 = Hasher._createHmacHelper(MD5);
	}(Math));


	return CryptoJS.MD5;

}));

/***/ }),

/***/ 99968:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(41182));
	}
	else {}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Reusable object
	    var W = [];

	    /**
	     * SHA-1 hash algorithm.
	     */
	    var SHA1 = C_algo.SHA1 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init([
	                0x67452301, 0xefcdab89,
	                0x98badcfe, 0x10325476,
	                0xc3d2e1f0
	            ]);
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var H = this._hash.words;

	            // Working variables
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];
	            var e = H[4];

	            // Computation
	            for (var i = 0; i < 80; i++) {
	                if (i < 16) {
	                    W[i] = M[offset + i] | 0;
	                } else {
	                    var n = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
	                    W[i] = (n << 1) | (n >>> 31);
	                }

	                var t = ((a << 5) | (a >>> 27)) + e + W[i];
	                if (i < 20) {
	                    t += ((b & c) | (~b & d)) + 0x5a827999;
	                } else if (i < 40) {
	                    t += (b ^ c ^ d) + 0x6ed9eba1;
	                } else if (i < 60) {
	                    t += ((b & c) | (b & d) | (c & d)) - 0x70e44324;
	                } else /* if (i < 80) */ {
	                    t += (b ^ c ^ d) - 0x359d3e2a;
	                }

	                e = d;
	                d = c;
	                c = (b << 30) | (b >>> 2);
	                b = a;
	                a = t;
	            }

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	            H[4] = (H[4] + e) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Return final computed hash
	            return this._hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA1('message');
	     *     var hash = CryptoJS.SHA1(wordArray);
	     */
	    C.SHA1 = Hasher._createHelper(SHA1);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA1(message, key);
	     */
	    C.HmacSHA1 = Hasher._createHmacHelper(SHA1);
	}());


	return CryptoJS.SHA1;

}));

/***/ }),

/***/ 57735:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(41182));
	}
	else {}
}(this, function (CryptoJS) {

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Initialization and round constants tables
	    var H = [];
	    var K = [];

	    // Compute constants
	    (function () {
	        function isPrime(n) {
	            var sqrtN = Math.sqrt(n);
	            for (var factor = 2; factor <= sqrtN; factor++) {
	                if (!(n % factor)) {
	                    return false;
	                }
	            }

	            return true;
	        }

	        function getFractionalBits(n) {
	            return ((n - (n | 0)) * 0x100000000) | 0;
	        }

	        var n = 2;
	        var nPrime = 0;
	        while (nPrime < 64) {
	            if (isPrime(n)) {
	                if (nPrime < 8) {
	                    H[nPrime] = getFractionalBits(Math.pow(n, 1 / 2));
	                }
	                K[nPrime] = getFractionalBits(Math.pow(n, 1 / 3));

	                nPrime++;
	            }

	            n++;
	        }
	    }());

	    // Reusable object
	    var W = [];

	    /**
	     * SHA-256 hash algorithm.
	     */
	    var SHA256 = C_algo.SHA256 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init(H.slice(0));
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var H = this._hash.words;

	            // Working variables
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];
	            var e = H[4];
	            var f = H[5];
	            var g = H[6];
	            var h = H[7];

	            // Computation
	            for (var i = 0; i < 64; i++) {
	                if (i < 16) {
	                    W[i] = M[offset + i] | 0;
	                } else {
	                    var gamma0x = W[i - 15];
	                    var gamma0  = ((gamma0x << 25) | (gamma0x >>> 7))  ^
	                                  ((gamma0x << 14) | (gamma0x >>> 18)) ^
	                                   (gamma0x >>> 3);

	                    var gamma1x = W[i - 2];
	                    var gamma1  = ((gamma1x << 15) | (gamma1x >>> 17)) ^
	                                  ((gamma1x << 13) | (gamma1x >>> 19)) ^
	                                   (gamma1x >>> 10);

	                    W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
	                }

	                var ch  = (e & f) ^ (~e & g);
	                var maj = (a & b) ^ (a & c) ^ (b & c);

	                var sigma0 = ((a << 30) | (a >>> 2)) ^ ((a << 19) | (a >>> 13)) ^ ((a << 10) | (a >>> 22));
	                var sigma1 = ((e << 26) | (e >>> 6)) ^ ((e << 21) | (e >>> 11)) ^ ((e << 7)  | (e >>> 25));

	                var t1 = h + sigma1 + ch + K[i] + W[i];
	                var t2 = sigma0 + maj;

	                h = g;
	                g = f;
	                f = e;
	                e = (d + t1) | 0;
	                d = c;
	                c = b;
	                b = a;
	                a = (t1 + t2) | 0;
	            }

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	            H[4] = (H[4] + e) | 0;
	            H[5] = (H[5] + f) | 0;
	            H[6] = (H[6] + g) | 0;
	            H[7] = (H[7] + h) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Return final computed hash
	            return this._hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA256('message');
	     *     var hash = CryptoJS.SHA256(wordArray);
	     */
	    C.SHA256 = Hasher._createHelper(SHA256);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA256(message, key);
	     */
	    C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
	}(Math));


	return CryptoJS.SHA256;

}));

/***/ }),

/***/ 37970:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (/* binding */ getTimezoneOffsetInMilliseconds)
/* harmony export */ });
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}

/***/ }),

/***/ 99157:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (/* binding */ requiredArgs)
/* harmony export */ });
function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}

/***/ }),

/***/ 71621:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (/* binding */ toInteger)
/* harmony export */ });
function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }

  var number = Number(dirtyNumber);

  if (isNaN(number)) {
    return number;
  }

  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

/***/ }),

/***/ 65018:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ addDays)
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71621);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22340);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99157);



/**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} - the new date with the days added
 * @throws {TypeError} - 2 arguments required
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * const result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */

function addDays(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyAmount);

  if (isNaN(amount)) {
    return new Date(NaN);
  }

  if (!amount) {
    // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
  }

  date.setDate(date.getDate() + amount);
  return date;
}

/***/ }),

/***/ 18964:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ addHours)
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71621);
/* harmony import */ var _addMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61344);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99157);



var MILLISECONDS_IN_HOUR = 3600000;
/**
 * @name addHours
 * @category Hour Helpers
 * @summary Add the specified number of hours to the given date.
 *
 * @description
 * Add the specified number of hours to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of hours to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the hours added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 2 hours to 10 July 2014 23:00:00:
 * const result = addHours(new Date(2014, 6, 10, 23, 0), 2)
 * //=> Fri Jul 11 2014 01:00:00
 */

function addHours(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyAmount);
  return (0,_addMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyDate, amount * MILLISECONDS_IN_HOUR);
}

/***/ }),

/***/ 61344:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (/* binding */ addMilliseconds)
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71621);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22340);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99157);



/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */

function addMilliseconds(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var timestamp = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate).getTime();
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyAmount);
  return new Date(timestamp + amount);
}

/***/ }),

/***/ 61005:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ addWeeks)
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71621);
/* harmony import */ var _addDays_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65018);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99157);



/**
 * @name addWeeks
 * @category Week Helpers
 * @summary Add the specified number of weeks to the given date.
 *
 * @description
 * Add the specified number of week to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of weeks to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the weeks added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 4 weeks to 1 September 2014:
 * const result = addWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Sep 29 2014 00:00:00
 */

function addWeeks(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyAmount);
  var days = amount * 7;
  return (0,_addDays_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(dirtyDate, days);
}

/***/ }),

/***/ 84034:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ differenceInCalendarWeeks)
/* harmony export */ });
/* harmony import */ var _startOfWeek_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6737);
/* harmony import */ var _lib_getTimezoneOffsetInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37970);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99157);



var MILLISECONDS_IN_WEEK = 604800000;
/**
 * @name differenceInCalendarWeeks
 * @category Week Helpers
 * @summary Get the number of calendar weeks between the given dates.
 *
 * @description
 * Get the number of calendar weeks between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Number} the number of calendar weeks
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // How many calendar weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5)
 * )
 * //=> 3
 *
 * @example
 * // If the week starts on Monday,
 * // how many calendar weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5),
 *   { weekStartsOn: 1 }
 * )
 * //=> 2
 */

function differenceInCalendarWeeks(dirtyDateLeft, dirtyDateRight, dirtyOptions) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var startOfWeekLeft = (0,_startOfWeek_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateLeft, dirtyOptions);
  var startOfWeekRight = (0,_startOfWeek_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateRight, dirtyOptions);
  var timestampLeft = startOfWeekLeft.getTime() - (0,_lib_getTimezoneOffsetInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(startOfWeekLeft);
  var timestampRight = startOfWeekRight.getTime() - (0,_lib_getTimezoneOffsetInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(startOfWeekRight); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_WEEK);
}

/***/ }),

/***/ 5729:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ differenceInSeconds)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__(22340);
// EXTERNAL MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(99157);
;// CONCATENATED MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/differenceInMilliseconds/index.js


/**
 * @name differenceInMilliseconds
 * @category Millisecond Helpers
 * @summary Get the number of milliseconds between the given dates.
 *
 * @description
 * Get the number of milliseconds between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of milliseconds
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many milliseconds are between
 * // 2 July 2014 12:30:20.600 and 2 July 2014 12:30:21.700?
 * const result = differenceInMilliseconds(
 *   new Date(2014, 6, 2, 12, 30, 21, 700),
 *   new Date(2014, 6, 2, 12, 30, 20, 600)
 * )
 * //=> 1100
 */

function differenceInMilliseconds(dateLeft, dateRight) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  return (0,toDate/* default */.Z)(dateLeft).getTime() - (0,toDate/* default */.Z)(dateRight).getTime();
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/_lib/roundingMethods/index.js
var roundingMap = {
  ceil: Math.ceil,
  round: Math.round,
  floor: Math.floor,
  trunc: function (value) {
    return value < 0 ? Math.ceil(value) : Math.floor(value);
  } // Math.trunc is not supported by IE

};
var defaultRoundingMethod = 'trunc';
function getRoundingMethod(method) {
  return method ? roundingMap[method] : roundingMap[defaultRoundingMethod];
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/differenceInSeconds/index.js



/**
 * @name differenceInSeconds
 * @category Second Helpers
 * @summary Get the number of seconds between the given dates.
 *
 * @description
 * Get the number of seconds between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @param {Object} [options] - an object with options.
 * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
 * @returns {Number} the number of seconds
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many seconds are between
 * // 2 July 2014 12:30:07.999 and 2 July 2014 12:30:20.000?
 * const result = differenceInSeconds(
 *   new Date(2014, 6, 2, 12, 30, 20, 0),
 *   new Date(2014, 6, 2, 12, 30, 7, 999)
 * )
 * //=> 12
 */

function differenceInSeconds(dateLeft, dateRight, options) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var diff = differenceInMilliseconds(dateLeft, dateRight) / 1000;
  return getRoundingMethod(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

/***/ }),

/***/ 43069:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ format)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/isValid/index.js + 1 modules
var isValid = __webpack_require__(43842);
;// CONCATENATED MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/locale/en-US/_lib/formatDistance/index.js
var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXWeeks: {
    one: 'about 1 week',
    other: 'about {{count}} weeks'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weeks'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};

var formatDistance = function (token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale[token];

  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }

  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }

  return result;
};

/* harmony default export */ const _lib_formatDistance = (formatDistance);
;// CONCATENATED MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/locale/_lib/buildFormatLongFn/index.js
function buildFormatLongFn(args) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // TODO: Remove String()
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/locale/en-US/_lib/formatLong/index.js

var dateFormats = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};
/* harmony default export */ const _lib_formatLong = (formatLong);
;// CONCATENATED MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/locale/en-US/_lib/formatRelative/index.js
var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};

var formatRelative = function (token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
};

/* harmony default export */ const _lib_formatRelative = (formatRelative);
;// CONCATENATED MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/locale/_lib/buildLocalizeFn/index.js
function buildLocalizeFn(args) {
  return function (dirtyIndex, dirtyOptions) {
    var options = dirtyOptions || {};
    var context = options.context ? String(options.context) : 'standalone';
    var valuesArray;

    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;

      var _width = options.width ? String(options.width) : args.defaultWidth;

      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }

    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex; // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!

    return valuesArray[index];
  };
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/locale/en-US/_lib/localize/index.js

var eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
}; // Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.

var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
var dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};

var ordinalNumber = function (dirtyNumber, _options) {
  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`.
  //
  // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'.

  var rem100 = number % 100;

  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';

      case 2:
        return number + 'nd';

      case 3:
        return number + 'rd';
    }
  }

  return number + 'th';
};

var localize = {
  ordinalNumber: ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
/* harmony default export */ const _lib_localize = (localize);
;// CONCATENATED MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/locale/_lib/buildMatchFn/index.js
function buildMatchFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);

    if (!matchResult) {
      return null;
    }

    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }

  return undefined;
}

function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }

  return undefined;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/locale/_lib/buildMatchPatternFn/index.js
function buildMatchPatternFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/locale/en-US/_lib/match/index.js


var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
/* harmony default export */ const _lib_match = (match);
;// CONCATENATED MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/locale/en-US/index.js






/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */
var locale = {
  code: 'en-US',
  formatDistance: _lib_formatDistance,
  formatLong: _lib_formatLong,
  formatRelative: _lib_formatRelative,
  localize: _lib_localize,
  match: _lib_match,
  options: {
    weekStartsOn: 0
    /* Sunday */
    ,
    firstWeekContainsDate: 1
  }
};
/* harmony default export */ const en_US = (locale);
// EXTERNAL MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/_lib/toInteger/index.js
var toInteger = __webpack_require__(71621);
// EXTERNAL MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/addMilliseconds/index.js
var addMilliseconds = __webpack_require__(61344);
// EXTERNAL MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(99157);
;// CONCATENATED MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/subMilliseconds/index.js



/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */

function subMilliseconds(dirtyDate, dirtyAmount) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var amount = (0,toInteger/* default */.Z)(dirtyAmount);
  return (0,addMilliseconds/* default */.Z)(dirtyDate, -amount);
}
// EXTERNAL MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__(22340);
;// CONCATENATED MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/_lib/getUTCDayOfYear/index.js


var MILLISECONDS_IN_DAY = 86400000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCDayOfYear(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/_lib/startOfUTCISOWeek/index.js

 // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCISOWeek(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var weekStartsOn = 1;
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/_lib/getUTCISOWeekYear/index.js


 // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCISOWeekYear(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/_lib/startOfUTCISOWeekYear/index.js


 // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCISOWeekYear(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var year = getUTCISOWeekYear(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCISOWeek(fourthOfJanuary);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/_lib/getUTCISOWeek/index.js




var MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCISOWeek(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var diff = startOfUTCISOWeek(date).getTime() - startOfUTCISOWeekYear(date).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/_lib/startOfUTCWeek/index.js


 // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCWeek(dirtyDate, dirtyOptions) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0,toInteger/* default */.Z)(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0,toInteger/* default */.Z)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = (0,toDate/* default */.Z)(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/_lib/getUTCWeekYear/index.js



 // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCWeekYear(dirtyDate, dirtyOptions) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var year = date.getUTCFullYear();
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0,toInteger/* default */.Z)(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0,toInteger/* default */.Z)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, dirtyOptions);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, dirtyOptions);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/_lib/startOfUTCWeekYear/index.js



 // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCWeekYear(dirtyDate, dirtyOptions) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0,toInteger/* default */.Z)(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0,toInteger/* default */.Z)(options.firstWeekContainsDate);
  var year = getUTCWeekYear(dirtyDate, dirtyOptions);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCWeek(firstWeek, dirtyOptions);
  return date;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/_lib/getUTCWeek/index.js




var getUTCWeek_MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCWeek(dirtyDate, options) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var diff = startOfUTCWeek(date, options).getTime() - startOfUTCWeekYear(date, options).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / getUTCWeek_MILLISECONDS_IN_WEEK) + 1;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/_lib/addLeadingZeros/index.js
function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();

  while (output.length < targetLength) {
    output = '0' + output;
  }

  return sign + output;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/_lib/format/lightFormatters/index.js

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */

var formatters = {
  // Year
  y: function (date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
    var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === 'yy' ? year % 100 : year, token.length);
  },
  // Month
  M: function (date, token) {
    var month = date.getUTCMonth();
    return token === 'M' ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  // Day of the month
  d: function (date, token) {
    return addLeadingZeros(date.getUTCDate(), token.length);
  },
  // AM or PM
  a: function (date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
        return dayPeriodEnumValue.toUpperCase();

      case 'aaa':
        return dayPeriodEnumValue;

      case 'aaaaa':
        return dayPeriodEnumValue[0];

      case 'aaaa':
      default:
        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
    }
  },
  // Hour [1-12]
  h: function (date, token) {
    return addLeadingZeros(date.getUTCHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H: function (date, token) {
    return addLeadingZeros(date.getUTCHours(), token.length);
  },
  // Minute
  m: function (date, token) {
    return addLeadingZeros(date.getUTCMinutes(), token.length);
  },
  // Second
  s: function (date, token) {
    return addLeadingZeros(date.getUTCSeconds(), token.length);
  },
  // Fraction of second
  S: function (date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, token.length);
  }
};
/* harmony default export */ const lightFormatters = (formatters);
;// CONCATENATED MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/_lib/format/formatters/index.js







var dayPeriodEnum = {
  am: 'am',
  pm: 'pm',
  midnight: 'midnight',
  noon: 'noon',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */

var formatters_formatters = {
  // Era
  G: function (date, token, localize) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;

    switch (token) {
      // AD, BC
      case 'G':
      case 'GG':
      case 'GGG':
        return localize.era(era, {
          width: 'abbreviated'
        });
      // A, B

      case 'GGGGG':
        return localize.era(era, {
          width: 'narrow'
        });
      // Anno Domini, Before Christ

      case 'GGGG':
      default:
        return localize.era(era, {
          width: 'wide'
        });
    }
  },
  // Year
  y: function (date, token, localize) {
    // Ordinal number
    if (token === 'yo') {
      var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, {
        unit: 'year'
      });
    }

    return lightFormatters.y(date, token);
  },
  // Local week-numbering year
  Y: function (date, token, localize, options) {
    var signedWeekYear = getUTCWeekYear(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year

    if (token === 'YY') {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    } // Ordinal number


    if (token === 'Yo') {
      return localize.ordinalNumber(weekYear, {
        unit: 'year'
      });
    } // Padding


    return addLeadingZeros(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function (date, token) {
    var isoWeekYear = getUTCISOWeekYear(date); // Padding

    return addLeadingZeros(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function (date, token) {
    var year = date.getUTCFullYear();
    return addLeadingZeros(year, token.length);
  },
  // Quarter
  Q: function (date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'Q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'QQ':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'Qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'QQQ':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'QQQQQ':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'formatting'
        });
      // 1st quarter, 2nd quarter, ...

      case 'QQQQ':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone quarter
  q: function (date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'qq':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'qqq':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'qqqqq':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'standalone'
        });
      // 1st quarter, 2nd quarter, ...

      case 'qqqq':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Month
  M: function (date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      case 'M':
      case 'MM':
        return lightFormatters.M(date, token);
      // 1st, 2nd, ..., 12th

      case 'Mo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'MMM':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // J, F, ..., D

      case 'MMMMM':
        return localize.month(month, {
          width: 'narrow',
          context: 'formatting'
        });
      // January, February, ..., December

      case 'MMMM':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone month
  L: function (date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      // 1, 2, ..., 12
      case 'L':
        return String(month + 1);
      // 01, 02, ..., 12

      case 'LL':
        return addLeadingZeros(month + 1, 2);
      // 1st, 2nd, ..., 12th

      case 'Lo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'LLL':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // J, F, ..., D

      case 'LLLLL':
        return localize.month(month, {
          width: 'narrow',
          context: 'standalone'
        });
      // January, February, ..., December

      case 'LLLL':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Local week of year
  w: function (date, token, localize, options) {
    var week = getUTCWeek(date, options);

    if (token === 'wo') {
      return localize.ordinalNumber(week, {
        unit: 'week'
      });
    }

    return addLeadingZeros(week, token.length);
  },
  // ISO week of year
  I: function (date, token, localize) {
    var isoWeek = getUTCISOWeek(date);

    if (token === 'Io') {
      return localize.ordinalNumber(isoWeek, {
        unit: 'week'
      });
    }

    return addLeadingZeros(isoWeek, token.length);
  },
  // Day of the month
  d: function (date, token, localize) {
    if (token === 'do') {
      return localize.ordinalNumber(date.getUTCDate(), {
        unit: 'date'
      });
    }

    return lightFormatters.d(date, token);
  },
  // Day of year
  D: function (date, token, localize) {
    var dayOfYear = getUTCDayOfYear(date);

    if (token === 'Do') {
      return localize.ordinalNumber(dayOfYear, {
        unit: 'dayOfYear'
      });
    }

    return addLeadingZeros(dayOfYear, token.length);
  },
  // Day of week
  E: function (date, token, localize) {
    var dayOfWeek = date.getUTCDay();

    switch (token) {
      // Tue
      case 'E':
      case 'EE':
      case 'EEE':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'EEEEE':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'EEEEEE':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'EEEE':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Local day of week
  e: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case 'e':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'ee':
        return addLeadingZeros(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th

      case 'eo':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'eee':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'eeeee':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'eeeeee':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'eeee':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone local day of week
  c: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (same as in `e`)
      case 'c':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'cc':
        return addLeadingZeros(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th

      case 'co':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'ccc':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // T

      case 'ccccc':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'standalone'
        });
      // Tu

      case 'cccccc':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'standalone'
        });
      // Tuesday

      case 'cccc':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // ISO day of week
  i: function (date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;

    switch (token) {
      // 2
      case 'i':
        return String(isoDayOfWeek);
      // 02

      case 'ii':
        return addLeadingZeros(isoDayOfWeek, token.length);
      // 2nd

      case 'io':
        return localize.ordinalNumber(isoDayOfWeek, {
          unit: 'day'
        });
      // Tue

      case 'iii':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'iiiii':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'iiiiii':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'iiii':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM or PM
  a: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'aaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();

      case 'aaaaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'aaaa':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM, PM, midnight, noon
  b: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    }

    switch (token) {
      case 'b':
      case 'bb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'bbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();

      case 'bbbbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'bbbb':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }

    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'BBBBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'BBBB':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Hour [1-12]
  h: function (date, token, localize) {
    if (token === 'ho') {
      var hours = date.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return lightFormatters.h(date, token);
  },
  // Hour [0-23]
  H: function (date, token, localize) {
    if (token === 'Ho') {
      return localize.ordinalNumber(date.getUTCHours(), {
        unit: 'hour'
      });
    }

    return lightFormatters.H(date, token);
  },
  // Hour [0-11]
  K: function (date, token, localize) {
    var hours = date.getUTCHours() % 12;

    if (token === 'Ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return addLeadingZeros(hours, token.length);
  },
  // Hour [1-24]
  k: function (date, token, localize) {
    var hours = date.getUTCHours();
    if (hours === 0) hours = 24;

    if (token === 'ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return addLeadingZeros(hours, token.length);
  },
  // Minute
  m: function (date, token, localize) {
    if (token === 'mo') {
      return localize.ordinalNumber(date.getUTCMinutes(), {
        unit: 'minute'
      });
    }

    return lightFormatters.m(date, token);
  },
  // Second
  s: function (date, token, localize) {
    if (token === 'so') {
      return localize.ordinalNumber(date.getUTCSeconds(), {
        unit: 'second'
      });
    }

    return lightFormatters.s(date, token);
  },
  // Fraction of second
  S: function (date, token) {
    return lightFormatters.S(date, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    if (timezoneOffset === 0) {
      return 'Z';
    }

    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`

      case 'XXXX':
      case 'XX':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`

      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`

      case 'xxxx':
      case 'xx':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`

      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (GMT)
  O: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (specific non-location)
  z: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'zzzz':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Seconds timestamp
  t: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1000);
    return addLeadingZeros(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return addLeadingZeros(timestamp, token.length);
  }
};

function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;

  if (minutes === 0) {
    return sign + String(hours);
  }

  var delimiter = dirtyDelimiter || '';
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}

function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }

  return formatTimezone(offset, dirtyDelimiter);
}

function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}

/* harmony default export */ const format_formatters = (formatters_formatters);
;// CONCATENATED MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/_lib/format/longFormatters/index.js
function dateLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'P':
      return formatLong.date({
        width: 'short'
      });

    case 'PP':
      return formatLong.date({
        width: 'medium'
      });

    case 'PPP':
      return formatLong.date({
        width: 'long'
      });

    case 'PPPP':
    default:
      return formatLong.date({
        width: 'full'
      });
  }
}

function timeLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'p':
      return formatLong.time({
        width: 'short'
      });

    case 'pp':
      return formatLong.time({
        width: 'medium'
      });

    case 'ppp':
      return formatLong.time({
        width: 'long'
      });

    case 'pppp':
    default:
      return formatLong.time({
        width: 'full'
      });
  }
}

function dateTimeLongFormatter(pattern, formatLong) {
  var matchResult = pattern.match(/(P+)(p+)?/) || [];
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];

  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }

  var dateTimeFormat;

  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({
        width: 'short'
      });
      break;

    case 'PP':
      dateTimeFormat = formatLong.dateTime({
        width: 'medium'
      });
      break;

    case 'PPP':
      dateTimeFormat = formatLong.dateTime({
        width: 'long'
      });
      break;

    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({
        width: 'full'
      });
      break;
  }

  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
}

var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
/* harmony default export */ const format_longFormatters = (longFormatters);
// EXTERNAL MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/_lib/getTimezoneOffsetInMilliseconds/index.js
var getTimezoneOffsetInMilliseconds = __webpack_require__(37970);
;// CONCATENATED MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/_lib/protectedTokens/index.js
var protectedDayOfYearTokens = ['D', 'DD'];
var protectedWeekYearTokens = ['YY', 'YYYY'];
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
  if (token === 'YYYY') {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'YY') {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'D') {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'DD') {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  }
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/format/index.js









 // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps

var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`

var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://git.io/fxCyr
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The second argument is now required for the sake of explicitness.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   format(new Date(2016, 0, 1))
 *
 *   // v2.0.0 onward
 *   format(new Date(2016, 0, 1), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
 *   ```
 *
 * - New format string API for `format` function
 *   which is based on [Unicode Technical Standard #35](https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table).
 *   See [this post](https://blog.date-fns.org/post/unicode-tokens-in-date-fns-v2-sreatyki91jg) for more details.
 *
 * - Characters are now escaped using single quote symbols (`'`) instead of square brackets.
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://git.io/fxCyr
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://git.io/fxCyr
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * var result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * var result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * var result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */

function format(dirtyDate, dirtyFormatStr, dirtyOptions) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var options = dirtyOptions || {};
  var locale = options.locale || en_US;
  var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0,toInteger/* default */.Z)(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0,toInteger/* default */.Z)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0,toInteger/* default */.Z)(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0,toInteger/* default */.Z)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  if (!locale.localize) {
    throw new RangeError('locale must contain localize property');
  }

  if (!locale.formatLong) {
    throw new RangeError('locale must contain formatLong property');
  }

  var originalDate = (0,toDate/* default */.Z)(dirtyDate);

  if (!(0,isValid["default"])(originalDate)) {
    throw new RangeError('Invalid time value');
  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376


  var timezoneOffset = (0,getTimezoneOffsetInMilliseconds/* default */.Z)(originalDate);
  var utcDate = subMilliseconds(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];

    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = format_longFormatters[firstCharacter];
      return longFormatter(substring, locale.formatLong, formatterOptions);
    }

    return substring;
  }).join('').match(formattingTokensRegExp).map(function (substring) {
    // Replace two single quote characters with one single quote character
    if (substring === "''") {
      return "'";
    }

    var firstCharacter = substring[0];

    if (firstCharacter === "'") {
      return cleanEscapedString(substring);
    }

    var formatter = format_formatters[firstCharacter];

    if (formatter) {
      if (!options.useAdditionalWeekYearTokens && isProtectedWeekYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, dirtyDate);
      }

      if (!options.useAdditionalDayOfYearTokens && isProtectedDayOfYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, dirtyDate);
      }

      return formatter(utcDate, substring, locale.localize, formatterOptions);
    }

    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
    }

    return substring;
  }).join('');
  return result;
}

function cleanEscapedString(input) {
  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}

/***/ }),

/***/ 81843:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ getUnixTime)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__(22340);
// EXTERNAL MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(99157);
;// CONCATENATED MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/getTime/index.js


/**
 * @name getTime
 * @category Timestamp Helpers
 * @summary Get the milliseconds timestamp of the given date.
 *
 * @description
 * Get the milliseconds timestamp of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the timestamp
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05.123:
 * const result = getTime(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 1330515905123
 */

function getTime(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var timestamp = date.getTime();
  return timestamp;
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/getUnixTime/index.js


/**
 * @name getUnixTime
 * @category Timestamp Helpers
 * @summary Get the seconds timestamp of the given date.
 *
 * @description
 * Get the seconds timestamp of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the timestamp
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05 CET:
 * const result = getUnixTime(new Date(2012, 1, 29, 11, 45, 5))
 * //=> 1330512305
 */

function getUnixTime(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return Math.floor(getTime(dirtyDate) / 1000);
}

/***/ }),

/***/ 15878:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ isSameDay)
/* harmony export */ });
/* harmony import */ var _startOfDay_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35780);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99157);


/**
 * @name isSameDay
 * @category Day Helpers
 * @summary Are the given dates in the same day (and year and month)?
 *
 * @description
 * Are the given dates in the same day (and year and month)?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same day (and year and month)
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * var result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
 * //=> true
 * 
 * @example
 * // Are 4 September and 4 October in the same day?
 * var result = isSameDay(new Date(2014, 8, 4), new Date(2014, 9, 4))
 * //=> false
 * 
 * @example
 * // Are 4 September, 2014 and 4 September, 2015 in the same day?
 * var result = isSameDay(new Date(2014, 8, 4), new Date(2015, 8, 4))
 * //=> false
 */

function isSameDay(dirtyDateLeft, dirtyDateRight) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var dateLeftStartOfDay = (0,_startOfDay_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateLeft);
  var dateRightStartOfDay = (0,_startOfDay_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateRight);
  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}

/***/ }),

/***/ 66854:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ isToday)
/* harmony export */ });
/* harmony import */ var _isSameDay_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15878);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99157);


/**
 * @name isToday
 * @category Day Helpers
 * @summary Is the given date today?
 * @pure false
 *
 * @description
 * Is the given date today?
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `Date.now()` internally hence impure and can't be safely curried.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is today
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // If today is 6 October 2014, is 6 October 14:00:00 today?
 * var result = isToday(new Date(2014, 9, 6, 14, 0))
 * //=> true
 */

function isToday(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  return (0,_isSameDay_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate, Date.now());
}

/***/ }),

/***/ 43842:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ isValid)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(99157);
;// CONCATENATED MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/isDate/index.js

/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {*} value - the value to check
 * @returns {boolean} true if the given value is a date
 * @throws {TypeError} 1 arguments required
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */

function isDate(value) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return value instanceof Date || typeof value === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}
// EXTERNAL MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__(22340);
;// CONCATENATED MODULE: ./node_modules/.pnpm/date-fns@2.28.0/node_modules/date-fns/esm/isValid/index.js



/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - Now `isValid` doesn't throw an exception
 *   if the first argument is not an instance of Date.
 *   Instead, argument is converted beforehand using `toDate`.
 *
 *   Examples:
 *
 *   | `isValid` argument        | Before v2.0.0 | v2.0.0 onward |
 *   |---------------------------|---------------|---------------|
 *   | `new Date()`              | `true`        | `true`        |
 *   | `new Date('2016-01-01')`  | `true`        | `true`        |
 *   | `new Date('')`            | `false`       | `false`       |
 *   | `new Date(1488370835081)` | `true`        | `true`        |
 *   | `new Date(NaN)`           | `false`       | `false`       |
 *   | `'2016-01-01'`            | `TypeError`   | `false`       |
 *   | `''`                      | `TypeError`   | `false`       |
 *   | `1488370835081`           | `TypeError`   | `true`        |
 *   | `NaN`                     | `TypeError`   | `false`       |
 *
 *   We introduce this change to make *date-fns* consistent with ECMAScript behavior
 *   that try to coerce arguments to the expected type
 *   (which is also the case with other *date-fns* functions).
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */

function isValid(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);

  if (!isDate(dirtyDate) && typeof dirtyDate !== 'number') {
    return false;
  }

  var date = (0,toDate/* default */.Z)(dirtyDate);
  return !isNaN(Number(date));
}

/***/ }),

/***/ 35780:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ startOfDay)
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22340);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99157);


/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */

function startOfDay(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate);
  date.setHours(0, 0, 0, 0);
  return date;
}

/***/ }),

/***/ 6737:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ startOfWeek)
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22340);
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71621);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99157);



/**
 * @name startOfWeek
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the start of a week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Mon Sep 01 2014 00:00:00
 */

function startOfWeek(dirtyDate, dirtyOptions) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setDate(date.getDate() - diff);
  date.setHours(0, 0, 0, 0);
  return date;
}

/***/ }),

/***/ 22340:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (/* binding */ toDate)
/* harmony export */ });
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99157);

/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */

function toDate(argument) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var argStr = Object.prototype.toString.call(argument); // Clone the date

  if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"); // eslint-disable-next-line no-console

      console.warn(new Error().stack);
    }

    return new Date(NaN);
  }
}

/***/ }),

/***/ 12454:
/***/ ((module) => {

"use strict";


var isMergeableObject = function isMergeableObject(value) {
	return isNonNullObject(value)
		&& !isSpecial(value)
};

function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}

function isSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement(value)
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE
}

function emptyTarget(val) {
	return Array.isArray(val) ? [] : {}
}

function cloneUnlessOtherwiseSpecified(value, options) {
	return (options.clone !== false && options.isMergeableObject(value))
		? deepmerge(emptyTarget(value), value, options)
		: value
}

function defaultArrayMerge(target, source, options) {
	return target.concat(source).map(function(element) {
		return cloneUnlessOtherwiseSpecified(element, options)
	})
}

function getMergeFunction(key, options) {
	if (!options.customMerge) {
		return deepmerge
	}
	var customMerge = options.customMerge(key);
	return typeof customMerge === 'function' ? customMerge : deepmerge
}

function getEnumerableOwnPropertySymbols(target) {
	return Object.getOwnPropertySymbols
		? Object.getOwnPropertySymbols(target).filter(function(symbol) {
			return Object.propertyIsEnumerable.call(target, symbol)
		})
		: []
}

function getKeys(target) {
	return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target))
}

function propertyIsOnObject(object, property) {
	try {
		return property in object
	} catch(_) {
		return false
	}
}

// Protects from prototype poisoning and unexpected merging up the prototype chain.
function propertyIsUnsafe(target, key) {
	return propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
		&& !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
			&& Object.propertyIsEnumerable.call(target, key)) // and also unsafe if they're nonenumerable.
}

function mergeObject(target, source, options) {
	var destination = {};
	if (options.isMergeableObject(target)) {
		getKeys(target).forEach(function(key) {
			destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
		});
	}
	getKeys(source).forEach(function(key) {
		if (propertyIsUnsafe(target, key)) {
			return
		}

		if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) {
			destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
		} else {
			destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
		}
	});
	return destination
}

function deepmerge(target, source, options) {
	options = options || {};
	options.arrayMerge = options.arrayMerge || defaultArrayMerge;
	options.isMergeableObject = options.isMergeableObject || isMergeableObject;
	// cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
	// implementations can use it. The caller may not replace it.
	options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;

	var sourceIsArray = Array.isArray(source);
	var targetIsArray = Array.isArray(target);
	var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

	if (!sourceAndTargetTypesMatch) {
		return cloneUnlessOtherwiseSpecified(source, options)
	} else if (sourceIsArray) {
		return options.arrayMerge(target, source, options)
	} else {
		return mergeObject(target, source, options)
	}
}

deepmerge.all = function deepmergeAll(array, options) {
	if (!Array.isArray(array)) {
		throw new Error('first argument should be an array')
	}

	return array.reduce(function(prev, next) {
		return deepmerge(prev, next, options)
	}, {})
};

var deepmerge_1 = deepmerge;

module.exports = deepmerge_1;


/***/ }),

/***/ 35376:
/***/ ((module) => {

"use strict";


/******************************************************************************
 * Created 2008-08-19.
 *
 * Dijkstra path-finding functions. Adapted from the Dijkstar Python project.
 *
 * Copyright (C) 2008
 *   Wyatt Baldwin <self@wyattbaldwin.com>
 *   All rights reserved
 *
 * Licensed under the MIT license.
 *
 *   http://www.opensource.org/licenses/mit-license.php
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 *****************************************************************************/
var dijkstra = {
  single_source_shortest_paths: function(graph, s, d) {
    // Predecessor map for each node that has been encountered.
    // node ID => predecessor node ID
    var predecessors = {};

    // Costs of shortest paths from s to all nodes encountered.
    // node ID => cost
    var costs = {};
    costs[s] = 0;

    // Costs of shortest paths from s to all nodes encountered; differs from
    // `costs` in that it provides easy access to the node that currently has
    // the known shortest path from s.
    // XXX: Do we actually need both `costs` and `open`?
    var open = dijkstra.PriorityQueue.make();
    open.push(s, 0);

    var closest,
        u, v,
        cost_of_s_to_u,
        adjacent_nodes,
        cost_of_e,
        cost_of_s_to_u_plus_cost_of_e,
        cost_of_s_to_v,
        first_visit;
    while (!open.empty()) {
      // In the nodes remaining in graph that have a known cost from s,
      // find the node, u, that currently has the shortest path from s.
      closest = open.pop();
      u = closest.value;
      cost_of_s_to_u = closest.cost;

      // Get nodes adjacent to u...
      adjacent_nodes = graph[u] || {};

      // ...and explore the edges that connect u to those nodes, updating
      // the cost of the shortest paths to any or all of those nodes as
      // necessary. v is the node across the current edge from u.
      for (v in adjacent_nodes) {
        if (adjacent_nodes.hasOwnProperty(v)) {
          // Get the cost of the edge running from u to v.
          cost_of_e = adjacent_nodes[v];

          // Cost of s to u plus the cost of u to v across e--this is *a*
          // cost from s to v that may or may not be less than the current
          // known cost to v.
          cost_of_s_to_u_plus_cost_of_e = cost_of_s_to_u + cost_of_e;

          // If we haven't visited v yet OR if the current known cost from s to
          // v is greater than the new cost we just found (cost of s to u plus
          // cost of u to v across e), update v's cost in the cost list and
          // update v's predecessor in the predecessor list (it's now u).
          cost_of_s_to_v = costs[v];
          first_visit = (typeof costs[v] === 'undefined');
          if (first_visit || cost_of_s_to_v > cost_of_s_to_u_plus_cost_of_e) {
            costs[v] = cost_of_s_to_u_plus_cost_of_e;
            open.push(v, cost_of_s_to_u_plus_cost_of_e);
            predecessors[v] = u;
          }
        }
      }
    }

    if (typeof d !== 'undefined' && typeof costs[d] === 'undefined') {
      var msg = ['Could not find a path from ', s, ' to ', d, '.'].join('');
      throw new Error(msg);
    }

    return predecessors;
  },

  extract_shortest_path_from_predecessor_list: function(predecessors, d) {
    var nodes = [];
    var u = d;
    var predecessor;
    while (u) {
      nodes.push(u);
      predecessor = predecessors[u];
      u = predecessors[u];
    }
    nodes.reverse();
    return nodes;
  },

  find_path: function(graph, s, d) {
    var predecessors = dijkstra.single_source_shortest_paths(graph, s, d);
    return dijkstra.extract_shortest_path_from_predecessor_list(
      predecessors, d);
  },

  /**
   * A very naive priority queue implementation.
   */
  PriorityQueue: {
    make: function (opts) {
      var T = dijkstra.PriorityQueue,
          t = {},
          key;
      opts = opts || {};
      for (key in T) {
        if (T.hasOwnProperty(key)) {
          t[key] = T[key];
        }
      }
      t.queue = [];
      t.sorter = opts.sorter || T.default_sorter;
      return t;
    },

    default_sorter: function (a, b) {
      return a.cost - b.cost;
    },

    /**
     * Add a new item to the queue and ensure the highest priority element
     * is at the front of the queue.
     */
    push: function (value, cost) {
      var item = {value: value, cost: cost};
      this.queue.push(item);
      this.queue.sort(this.sorter);
    },

    /**
     * Return the highest priority element in the queue.
     */
    pop: function () {
      return this.queue.shift();
    },

    empty: function () {
      return this.queue.length === 0;
    }
  }
};


// node.js module exports
if (true) {
  module.exports = dijkstra;
}


/***/ }),

/***/ 72100:
/***/ ((module) => {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var R = typeof Reflect === 'object' ? Reflect : null
var ReflectApply = R && typeof R.apply === 'function'
  ? R.apply
  : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
  }

var ReflectOwnKeys
if (R && typeof R.ownKeys === 'function') {
  ReflectOwnKeys = R.ownKeys
} else if (Object.getOwnPropertySymbols) {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target)
      .concat(Object.getOwnPropertySymbols(target));
  };
} else {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
  };
}

function ProcessEmitWarning(warning) {
  if (console && console.warn) console.warn(warning);
}

var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
  return value !== value;
}

function EventEmitter() {
  EventEmitter.init.call(this);
}
module.exports = EventEmitter;
module.exports.once = once;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;

function checkListener(listener) {
  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }
}

Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
  enumerable: true,
  get: function() {
    return defaultMaxListeners;
  },
  set: function(arg) {
    if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
    }
    defaultMaxListeners = arg;
  }
});

EventEmitter.init = function() {

  if (this._events === undefined ||
      this._events === Object.getPrototypeOf(this)._events) {
    this._events = Object.create(null);
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
};

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
  }
  this._maxListeners = n;
  return this;
};

function _getMaxListeners(that) {
  if (that._maxListeners === undefined)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return _getMaxListeners(this);
};

EventEmitter.prototype.emit = function emit(type) {
  var args = [];
  for (var i = 1; i < arguments.length; i++) args.push(arguments[i]);
  var doError = (type === 'error');

  var events = this._events;
  if (events !== undefined)
    doError = (doError && events.error === undefined);
  else if (!doError)
    return false;

  // If there is no 'error' event listener then throw.
  if (doError) {
    var er;
    if (args.length > 0)
      er = args[0];
    if (er instanceof Error) {
      // Note: The comments on the `throw` lines are intentional, they show
      // up in Node's output if this results in an unhandled exception.
      throw er; // Unhandled 'error' event
    }
    // At least give some kind of context to the user
    var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
    err.context = er;
    throw err; // Unhandled 'error' event
  }

  var handler = events[type];

  if (handler === undefined)
    return false;

  if (typeof handler === 'function') {
    ReflectApply(handler, this, args);
  } else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      ReflectApply(listeners[i], this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  checkListener(listener);

  events = target._events;
  if (events === undefined) {
    events = target._events = Object.create(null);
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener !== undefined) {
      target.emit('newListener', type,
                  listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (existing === undefined) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] =
        prepend ? [listener, existing] : [existing, listener];
      // If we've already got an array, just append.
    } else if (prepend) {
      existing.unshift(listener);
    } else {
      existing.push(listener);
    }

    // Check for listener leak
    m = _getMaxListeners(target);
    if (m > 0 && existing.length > m && !existing.warned) {
      existing.warned = true;
      // No error code for this since it is a Warning
      // eslint-disable-next-line no-restricted-syntax
      var w = new Error('Possible EventEmitter memory leak detected. ' +
                          existing.length + ' ' + String(type) + ' listeners ' +
                          'added. Use emitter.setMaxListeners() to ' +
                          'increase limit');
      w.name = 'MaxListenersExceededWarning';
      w.emitter = target;
      w.type = type;
      w.count = existing.length;
      ProcessEmitWarning(w);
    }
  }

  return target;
}

EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener =
    function prependListener(type, listener) {
      return _addListener(this, type, listener, true);
    };

function onceWrapper() {
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    if (arguments.length === 0)
      return this.listener.call(this.target);
    return this.listener.apply(this.target, arguments);
  }
}

function _onceWrap(target, type, listener) {
  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
  var wrapped = onceWrapper.bind(state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}

EventEmitter.prototype.once = function once(type, listener) {
  checkListener(listener);
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener =
    function prependOnceListener(type, listener) {
      checkListener(listener);
      this.prependListener(type, _onceWrap(this, type, listener));
      return this;
    };

// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener =
    function removeListener(type, listener) {
      var list, events, position, i, originalListener;

      checkListener(listener);

      events = this._events;
      if (events === undefined)
        return this;

      list = events[type];
      if (list === undefined)
        return this;

      if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0)
          this._events = Object.create(null);
        else {
          delete events[type];
          if (events.removeListener)
            this.emit('removeListener', type, list.listener || listener);
        }
      } else if (typeof list !== 'function') {
        position = -1;

        for (i = list.length - 1; i >= 0; i--) {
          if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }

        if (position < 0)
          return this;

        if (position === 0)
          list.shift();
        else {
          spliceOne(list, position);
        }

        if (list.length === 1)
          events[type] = list[0];

        if (events.removeListener !== undefined)
          this.emit('removeListener', type, originalListener || listener);
      }

      return this;
    };

EventEmitter.prototype.off = EventEmitter.prototype.removeListener;

EventEmitter.prototype.removeAllListeners =
    function removeAllListeners(type) {
      var listeners, events, i;

      events = this._events;
      if (events === undefined)
        return this;

      // not listening for removeListener, no need to emit
      if (events.removeListener === undefined) {
        if (arguments.length === 0) {
          this._events = Object.create(null);
          this._eventsCount = 0;
        } else if (events[type] !== undefined) {
          if (--this._eventsCount === 0)
            this._events = Object.create(null);
          else
            delete events[type];
        }
        return this;
      }

      // emit removeListener for all listeners on all events
      if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for (i = 0; i < keys.length; ++i) {
          key = keys[i];
          if (key === 'removeListener') continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
      }

      listeners = events[type];

      if (typeof listeners === 'function') {
        this.removeListener(type, listeners);
      } else if (listeners !== undefined) {
        // LIFO order
        for (i = listeners.length - 1; i >= 0; i--) {
          this.removeListener(type, listeners[i]);
        }
      }

      return this;
    };

function _listeners(target, type, unwrap) {
  var events = target._events;

  if (events === undefined)
    return [];

  var evlistener = events[type];
  if (evlistener === undefined)
    return [];

  if (typeof evlistener === 'function')
    return unwrap ? [evlistener.listener || evlistener] : [evlistener];

  return unwrap ?
    unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}

EventEmitter.prototype.listeners = function listeners(type) {
  return _listeners(this, type, true);
};

EventEmitter.prototype.rawListeners = function rawListeners(type) {
  return _listeners(this, type, false);
};

EventEmitter.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events !== undefined) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener !== undefined) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};

function arrayClone(arr, n) {
  var copy = new Array(n);
  for (var i = 0; i < n; ++i)
    copy[i] = arr[i];
  return copy;
}

function spliceOne(list, index) {
  for (; index + 1 < list.length; index++)
    list[index] = list[index + 1];
  list.pop();
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}

function once(emitter, name) {
  return new Promise(function (resolve, reject) {
    function errorListener(err) {
      emitter.removeListener(name, resolver);
      reject(err);
    }

    function resolver() {
      if (typeof emitter.removeListener === 'function') {
        emitter.removeListener('error', errorListener);
      }
      resolve([].slice.call(arguments));
    };

    eventTargetAgnosticAddListener(emitter, name, resolver, { once: true });
    if (name !== 'error') {
      addErrorHandlerIfEventEmitter(emitter, errorListener, { once: true });
    }
  });
}

function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
  if (typeof emitter.on === 'function') {
    eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
  }
}

function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
  if (typeof emitter.on === 'function') {
    if (flags.once) {
      emitter.once(name, listener);
    } else {
      emitter.on(name, listener);
    }
  } else if (typeof emitter.addEventListener === 'function') {
    // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
      // IE does not have builtin `{ once: true }` support so we
      // have to do it manually.
      if (flags.once) {
        emitter.removeEventListener(name, wrapListener);
      }
      listener(arg);
    });
  } else {
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
  }
}


/***/ }),

/***/ 61406:
/***/ ((module) => {

module.exports = stringify
stringify.default = stringify
stringify.stable = deterministicStringify
stringify.stableStringify = deterministicStringify

var LIMIT_REPLACE_NODE = '[...]'
var CIRCULAR_REPLACE_NODE = '[Circular]'

var arr = []
var replacerStack = []

function defaultOptions () {
  return {
    depthLimit: Number.MAX_SAFE_INTEGER,
    edgesLimit: Number.MAX_SAFE_INTEGER
  }
}

// Regular stringify
function stringify (obj, replacer, spacer, options) {
  if (typeof options === 'undefined') {
    options = defaultOptions()
  }

  decirc(obj, '', 0, [], undefined, 0, options)
  var res
  try {
    if (replacerStack.length === 0) {
      res = JSON.stringify(obj, replacer, spacer)
    } else {
      res = JSON.stringify(obj, replaceGetterValues(replacer), spacer)
    }
  } catch (_) {
    return JSON.stringify('[unable to serialize, circular reference is too complex to analyze]')
  } finally {
    while (arr.length !== 0) {
      var part = arr.pop()
      if (part.length === 4) {
        Object.defineProperty(part[0], part[1], part[3])
      } else {
        part[0][part[1]] = part[2]
      }
    }
  }
  return res
}

function setReplace (replace, val, k, parent) {
  var propertyDescriptor = Object.getOwnPropertyDescriptor(parent, k)
  if (propertyDescriptor.get !== undefined) {
    if (propertyDescriptor.configurable) {
      Object.defineProperty(parent, k, { value: replace })
      arr.push([parent, k, val, propertyDescriptor])
    } else {
      replacerStack.push([val, k, replace])
    }
  } else {
    parent[k] = replace
    arr.push([parent, k, val])
  }
}

function decirc (val, k, edgeIndex, stack, parent, depth, options) {
  depth += 1
  var i
  if (typeof val === 'object' && val !== null) {
    for (i = 0; i < stack.length; i++) {
      if (stack[i] === val) {
        setReplace(CIRCULAR_REPLACE_NODE, val, k, parent)
        return
      }
    }

    if (
      typeof options.depthLimit !== 'undefined' &&
      depth > options.depthLimit
    ) {
      setReplace(LIMIT_REPLACE_NODE, val, k, parent)
      return
    }

    if (
      typeof options.edgesLimit !== 'undefined' &&
      edgeIndex + 1 > options.edgesLimit
    ) {
      setReplace(LIMIT_REPLACE_NODE, val, k, parent)
      return
    }

    stack.push(val)
    // Optimize for Arrays. Big arrays could kill the performance otherwise!
    if (Array.isArray(val)) {
      for (i = 0; i < val.length; i++) {
        decirc(val[i], i, i, stack, val, depth, options)
      }
    } else {
      var keys = Object.keys(val)
      for (i = 0; i < keys.length; i++) {
        var key = keys[i]
        decirc(val[key], key, i, stack, val, depth, options)
      }
    }
    stack.pop()
  }
}

// Stable-stringify
function compareFunction (a, b) {
  if (a < b) {
    return -1
  }
  if (a > b) {
    return 1
  }
  return 0
}

function deterministicStringify (obj, replacer, spacer, options) {
  if (typeof options === 'undefined') {
    options = defaultOptions()
  }

  var tmp = deterministicDecirc(obj, '', 0, [], undefined, 0, options) || obj
  var res
  try {
    if (replacerStack.length === 0) {
      res = JSON.stringify(tmp, replacer, spacer)
    } else {
      res = JSON.stringify(tmp, replaceGetterValues(replacer), spacer)
    }
  } catch (_) {
    return JSON.stringify('[unable to serialize, circular reference is too complex to analyze]')
  } finally {
    // Ensure that we restore the object as it was.
    while (arr.length !== 0) {
      var part = arr.pop()
      if (part.length === 4) {
        Object.defineProperty(part[0], part[1], part[3])
      } else {
        part[0][part[1]] = part[2]
      }
    }
  }
  return res
}

function deterministicDecirc (val, k, edgeIndex, stack, parent, depth, options) {
  depth += 1
  var i
  if (typeof val === 'object' && val !== null) {
    for (i = 0; i < stack.length; i++) {
      if (stack[i] === val) {
        setReplace(CIRCULAR_REPLACE_NODE, val, k, parent)
        return
      }
    }
    try {
      if (typeof val.toJSON === 'function') {
        return
      }
    } catch (_) {
      return
    }

    if (
      typeof options.depthLimit !== 'undefined' &&
      depth > options.depthLimit
    ) {
      setReplace(LIMIT_REPLACE_NODE, val, k, parent)
      return
    }

    if (
      typeof options.edgesLimit !== 'undefined' &&
      edgeIndex + 1 > options.edgesLimit
    ) {
      setReplace(LIMIT_REPLACE_NODE, val, k, parent)
      return
    }

    stack.push(val)
    // Optimize for Arrays. Big arrays could kill the performance otherwise!
    if (Array.isArray(val)) {
      for (i = 0; i < val.length; i++) {
        deterministicDecirc(val[i], i, i, stack, val, depth, options)
      }
    } else {
      // Create a temporary object in the required way
      var tmp = {}
      var keys = Object.keys(val).sort(compareFunction)
      for (i = 0; i < keys.length; i++) {
        var key = keys[i]
        deterministicDecirc(val[key], key, i, stack, val, depth, options)
        tmp[key] = val[key]
      }
      if (typeof parent !== 'undefined') {
        arr.push([parent, k, val])
        parent[k] = tmp
      } else {
        return tmp
      }
    }
    stack.pop()
  }
}

// wraps replacer function to handle values we couldn't replace
// and mark them as replaced value
function replaceGetterValues (replacer) {
  replacer =
    typeof replacer !== 'undefined'
      ? replacer
      : function (k, v) {
        return v
      }
  return function (key, val) {
    if (replacerStack.length > 0) {
      for (var i = 0; i < replacerStack.length; i++) {
        var part = replacerStack[i]
        if (part[1] === key && part[0] === val) {
          val = part[2]
          replacerStack.splice(i, 1)
          break
        }
      }
    }
    return replacer.call(this, key, val)
  }
}


/***/ }),

/***/ 60059:
/***/ ((module) => {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var toStr = Object.prototype.toString;
var max = Math.max;
var funcType = '[object Function]';

var concatty = function concatty(a, b) {
    var arr = [];

    for (var i = 0; i < a.length; i += 1) {
        arr[i] = a[i];
    }
    for (var j = 0; j < b.length; j += 1) {
        arr[j + a.length] = b[j];
    }

    return arr;
};

var slicy = function slicy(arrLike, offset) {
    var arr = [];
    for (var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1) {
        arr[j] = arrLike[i];
    }
    return arr;
};

var joiny = function (arr, joiner) {
    var str = '';
    for (var i = 0; i < arr.length; i += 1) {
        str += arr[i];
        if (i + 1 < arr.length) {
            str += joiner;
        }
    }
    return str;
};

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.apply(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slicy(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                concatty(args, arguments)
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        }
        return target.apply(
            that,
            concatty(args, arguments)
        );

    };

    var boundLength = max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs[i] = '$' + i;
    }

    bound = Function('binder', 'return function (' + joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


/***/ }),

/***/ 48794:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var implementation = __webpack_require__(60059);

module.exports = Function.prototype.bind || implementation;


/***/ }),

/***/ 72870:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var undefined;

var $SyntaxError = SyntaxError;
var $Function = Function;
var $TypeError = TypeError;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
	try {
		$gOPD({}, '');
	} catch (e) {
		$gOPD = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function () {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = __webpack_require__(91143)();
var hasProto = __webpack_require__(43413)();

var getProto = Object.getPrototypeOf || (
	hasProto
		? function (x) { return x.__proto__; } // eslint-disable-line no-proto
		: null
);

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' || !getProto ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
	'%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': EvalError,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': Object,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': RangeError,
	'%ReferenceError%': ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols && getProto ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
};

if (getProto) {
	try {
		null.error; // eslint-disable-line no-unused-expressions
	} catch (e) {
		// https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
		var errorProto = getProto(getProto(e));
		INTRINSICS['%Error.prototype%'] = errorProto;
	}
}

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen && getProto) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = __webpack_require__(48794);
var hasOwn = __webpack_require__(79545);
var $concat = bind.call(Function.call, Array.prototype.concat);
var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
var $replace = bind.call(Function.call, String.prototype.replace);
var $strSlice = bind.call(Function.call, String.prototype.slice);
var $exec = bind.call(Function.call, RegExp.prototype.exec);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	if ($exec(/^%?[^%]*%?$/, name) === null) {
		throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
	}
	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};


/***/ }),

/***/ 43413:
/***/ ((module) => {

"use strict";


var test = {
	foo: {}
};

var $Object = Object;

module.exports = function hasProto() {
	return { __proto__: test }.foo === test.foo && !({ __proto__: null } instanceof $Object);
};


/***/ }),

/***/ 91143:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = __webpack_require__(79985);

module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};


/***/ }),

/***/ 79985:
/***/ ((module) => {

"use strict";


/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};


/***/ }),

/***/ 79545:
/***/ ((module) => {

"use strict";


var hasOwnProperty = {}.hasOwnProperty;
var call = Function.prototype.call;

module.exports = call.bind ? call.bind(hasOwnProperty) : function (O, P) {
  return call.call(hasOwnProperty, O, P);
};


/***/ }),

/***/ 36449:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports["default"] = safeSet;

var _utils = __webpack_require__(60364);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * Compute next base in recursion
 * @param base current base
 * @param key current key in the path
 * @param nextKey next key in the path
 * @param withArrays create arrays instead of object when nextKey is a number and key has no value in the current base
 */
var nextBase = function nextBase(base, key, nextKey, withArrays) {
  return base[key] || (withArrays && typeof nextKey === 'number' ? [] : {});
};

/**
 * Reduce multiple elements in the accumulator using the setFunction when base is an Array
 * @param setFunction
 */
var reduceWithArray = function reduceWithArray(setFunction) {
  return (
    /**
     * Reduce multiple elements in the accumulator
     * @param base current base
     * @param path current path
     * @param keys list of keys ; we know there that keys is an array or set
     * @param nextKey next key in the path
     * @param values list of values, has to be an array
     * @param withArrays
     * @param accumulator new instance of the array at the current level
     * @returns {*} the accumulator with the new elements
     */
    function (base, path, keys, nextKey, values, _ref, accumulator) {
      var withArrays = _ref.withArrays,
          sameValue = _ref.sameValue;

      if (!Array.isArray(values) && !sameValue) {
        throw new Error('Can not use object values with array in path');
      }

      return keys.reduce(function (acc, key, index) {
        var value = sameValue ? values : values[index];
        var newValue = setFunction(nextBase(base, key, nextKey, withArrays), path.slice(1), value, {
          withArrays: withArrays,
          sameValue: sameValue
        });

        if (key < acc.length) {
          acc[key] = newValue;
        } else {
          acc.push(newValue);
        }

        return acc;
      }, accumulator);
    }
  );
};

/**
 * Reduce multiple elements in an new Object using the setFunction when base is an Object
 * @param setFunction
 */
var reduceWithObject = function reduceWithObject(fn) {
  return (
    /**
     * Reduce multiple elements in an new Object
     * @param base current base
     * @param path current path
     * @param keys list of keys ; we know there that keys is an array or set
     * @param nextKey next key in the path
     * @param values list of values, could be an array or an object
     * @param withArrays
     * @returns {*} a set of the new elements
     */
    function (base, path, keys, nextKey, values, _ref2) {
      var withArrays = _ref2.withArrays,
          sameValue = _ref2.sameValue;

      if (Array.isArray(values)) {
        return keys.reduce(function (acc, key, index) {
          var value = sameValue ? values : values[index];
          acc[key] = fn(nextBase(base, key, nextKey, withArrays), path.slice(1), value, { withArrays: withArrays, sameValue: sameValue });

          return acc;
        }, {});
      }

      return keys.reduce(function (acc, key) {
        var value = sameValue ? values : values[key];
        acc[key] = fn(nextBase(base, key, nextKey, withArrays), path.slice(1), value, { withArrays: withArrays, sameValue: sameValue });

        return acc;
      }, {});
    }
  );
};

/**
 * Recursive immutable set
 * @param base current base
 * @param path current path
 * @param value current value
 * @param config
 *  - withArrays create arrays instead of object when nextKey is a number and key has no value in the current base
 *  - sameValue use the same value for each element
 * @returns {*} a new instance of the given level
 */
function set(base, path, value, _ref3) {
  var withArrays = _ref3.withArrays,
      sameValue = _ref3.sameValue;

  if (path.length === 0) {
    return value;
  }

  var _path = _slicedToArray(path, 2),
      key = _path[0],
      nextKey = _path[1];

  var isArrayKeys = Array.isArray(key);
  var currentBase = base;

  if (!base || (typeof base === 'undefined' ? 'undefined' : _typeof(base)) !== 'object') {
    currentBase = isArrayKeys && typeof key[0] === 'number' || withArrays && typeof key === 'number' ? [] : {};
  }

  if (isArrayKeys) {
    if (Array.isArray(currentBase)) {
      return reduceWithArray(set)(currentBase, path, key, nextKey, value, { withArrays: withArrays, sameValue: sameValue }, [].concat(_toConsumableArray(currentBase)));
    }

    return _extends({}, currentBase, reduceWithObject(set)(currentBase, path, key, nextKey, value, { withArrays: withArrays, sameValue: sameValue }, {}));
  }

  if (Array.isArray(currentBase)) {
    return [].concat(_toConsumableArray(currentBase.slice(0, key)), [set(nextBase(currentBase, key, nextKey, withArrays), path.slice(1), value, { withArrays: withArrays, sameValue: sameValue })], _toConsumableArray(currentBase.slice(key + 1)));
  }

  return _extends({}, currentBase, _defineProperty({}, key, set(nextBase(currentBase, key, nextKey, withArrays), path.slice(1), value, { withArrays: withArrays, sameValue: sameValue })));
}

/**
 * Main function, recursive immutable set
 * @param base base object
 * @param initialPath path to the place where the value is going to be set
 * @param value value to set
 * @param options options
 * @returns {*} new instance of the base if it has been modified, the base otherwise
 */
function safeSet(base, initialPath, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var _options$withArrays = options.withArrays,
      withArrays = _options$withArrays === undefined ? false : _options$withArrays,
      equality = options.equality,
      _options$sameValue = options.sameValue,
      sameValue = _options$sameValue === undefined ? false : _options$sameValue;

  var path = initialPath;

  // Handle string path
  if (typeof path === 'string' && path.length > 0) {
    path = path.split('.');
    path = path.reduce(function (acc, key) {
      var groupe = /\[([0-9]*)\]/.exec(key);

      if (groupe) {
        acc.push(key.substr(0, groupe.index), Number(groupe[1]));
      } else {
        acc.push(key);
      }

      return acc;
    }, []);
  }

  if (!Array.isArray(path) || path.length < 1) {
    return base === value ? base : value;
  }

  // If the value is already here we just need to return the base
  if ((0, _utils.isSafe)(value, options) && (0, _utils.recursiveEqual)(base, path, value, equality)) {
    return base;
  }

  return set(base, path, value, { withArrays: withArrays, sameValue: sameValue });
}

/***/ }),

/***/ 60364:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.isSafe = isSafe;
exports.recursiveEqual = recursiveEqual;
function isSafe(value) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$safe = _ref.safe,
      safe = _ref$safe === undefined ? false : _ref$safe;

  if (safe) return true;

  if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value !== null) {
    if (value.length) {
      return !value.find(function (subValue) {
        return !isSafe(subValue);
      });
    }

    return safe;
  }

  return true;
}

/**
 * Recursive equality tester. Return true if the top down element of the path in the base is equal to the given value
 * @param base current base
 * @param path current path
 * @param value value to verify
 * @param equality override the equality assertion
 * @returns {boolean} true if the value is in the base at the end of the path
 */
function recursiveEqual(base, path, value, equality) {
  if (!base || (typeof base === 'undefined' ? 'undefined' : _typeof(base)) !== 'object') {
    return false;
  }

  var _path = _slicedToArray(path, 2),
      key = _path[0],
      nextKey = _path[1];

  if (nextKey === undefined) {
    return equality ? equality(base[key], value) : base[key] === value;
  }

  return recursiveEqual(base[key], path.slice(1), value, equality);
}

/***/ }),

/***/ 85459:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

try {
  var util = __webpack_require__(53827);
  /* istanbul ignore next */
  if (typeof util.inherits !== 'function') throw '';
  module.exports = util.inherits;
} catch (e) {
  /* istanbul ignore next */
  module.exports = __webpack_require__(2937);
}


/***/ }),

/***/ 2937:
/***/ ((module) => {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
          value: ctor,
          enumerable: false,
          writable: true,
          configurable: true
        }
      })
    }
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      var TempCtor = function () {}
      TempCtor.prototype = superCtor.prototype
      ctor.prototype = new TempCtor()
      ctor.prototype.constructor = ctor
    }
  }
}


/***/ }),

/***/ 83056:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({ value: true }));

/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */

function isObject(o) {
  return Object.prototype.toString.call(o) === '[object Object]';
}

function isPlainObject(o) {
  var ctor,prot;

  if (isObject(o) === false) return false;

  // If has modified constructor
  ctor = o.constructor;
  if (ctor === undefined) return true;

  // If has modified prototype
  prot = ctor.prototype;
  if (isObject(prot) === false) return false;

  // If constructor does not have an Object-specific method
  if (prot.hasOwnProperty('isPrototypeOf') === false) {
    return false;
  }

  // Most likely a plain Object
  return true;
}

exports.isPlainObject = isPlainObject;


/***/ }),

/***/ 99580:
/***/ ((module) => {

/**
 * The code was extracted from:
 * https://github.com/davidchambers/Base64.js
 */

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function InvalidCharacterError(message) {
  this.message = message;
}

InvalidCharacterError.prototype = new Error();
InvalidCharacterError.prototype.name = 'InvalidCharacterError';

function polyfill (input) {
  var str = String(input).replace(/=+$/, '');
  if (str.length % 4 == 1) {
    throw new InvalidCharacterError("'atob' failed: The string to be decoded is not correctly encoded.");
  }
  for (
    // initialize result and counters
    var bc = 0, bs, buffer, idx = 0, output = '';
    // get next character
    buffer = str.charAt(idx++);
    // character found in table? initialize bit storage and add its ascii value;
    ~buffer && (bs = bc % 4 ? bs * 64 + buffer : buffer,
      // and if not first of each 4 characters,
      // convert the first 8 bits to one ascii character
      bc++ % 4) ? output += String.fromCharCode(255 & bs >> (-2 * bc & 6)) : 0
  ) {
    // try to find character in table (0-63, not found => -1)
    buffer = chars.indexOf(buffer);
  }
  return output;
}


module.exports = typeof window !== 'undefined' && window.atob && window.atob.bind(window) || polyfill;


/***/ }),

/***/ 4727:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var atob = __webpack_require__(99580);

function b64DecodeUnicode(str) {
  return decodeURIComponent(atob(str).replace(/(.)/g, function (m, p) {
    var code = p.charCodeAt(0).toString(16).toUpperCase();
    if (code.length < 2) {
      code = '0' + code;
    }
    return '%' + code;
  }));
}

module.exports = function(str) {
  var output = str.replace(/-/g, "+").replace(/_/g, "/");
  switch (output.length % 4) {
    case 0:
      break;
    case 2:
      output += "==";
      break;
    case 3:
      output += "=";
      break;
    default:
      throw "Illegal base64url string!";
  }

  try{
    return b64DecodeUnicode(output);
  } catch (err) {
    return atob(output);
  }
};


/***/ }),

/***/ 30588:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var base64_url_decode = __webpack_require__(4727);

function InvalidTokenError(message) {
  this.message = message;
}

InvalidTokenError.prototype = new Error();
InvalidTokenError.prototype.name = 'InvalidTokenError';

module.exports = function (token,options) {
  if (typeof token !== 'string') {
    throw new InvalidTokenError('Invalid token specified');
  }

  options = options || {};
  var pos = options.header === true ? 0 : 1;
  try {
    return JSON.parse(base64_url_decode(token.split('.')[pos]));
  } catch (e) {
    throw new InvalidTokenError('Invalid token specified: ' + e.message);
  }
};

module.exports.InvalidTokenError = InvalidTokenError;


/***/ }),

/***/ 70870:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";



////////////////////////////////////////////////////////////////////////////////
// Helpers

// Merge objects
//
function assign(obj /*from1, from2, from3, ...*/) {
  var sources = Array.prototype.slice.call(arguments, 1);

  sources.forEach(function (source) {
    if (!source) { return; }

    Object.keys(source).forEach(function (key) {
      obj[key] = source[key];
    });
  });

  return obj;
}

function _class(obj) { return Object.prototype.toString.call(obj); }
function isString(obj) { return _class(obj) === '[object String]'; }
function isObject(obj) { return _class(obj) === '[object Object]'; }
function isRegExp(obj) { return _class(obj) === '[object RegExp]'; }
function isFunction(obj) { return _class(obj) === '[object Function]'; }


function escapeRE(str) { return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&'); }

////////////////////////////////////////////////////////////////////////////////


var defaultOptions = {
  fuzzyLink: true,
  fuzzyEmail: true,
  fuzzyIP: false
};


function isOptionsObj(obj) {
  return Object.keys(obj || {}).reduce(function (acc, k) {
    return acc || defaultOptions.hasOwnProperty(k);
  }, false);
}


var defaultSchemas = {
  'http:': {
    validate: function (text, pos, self) {
      var tail = text.slice(pos);

      if (!self.re.http) {
        // compile lazily, because "host"-containing variables can change on tlds update.
        self.re.http =  new RegExp(
          '^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i'
        );
      }
      if (self.re.http.test(tail)) {
        return tail.match(self.re.http)[0].length;
      }
      return 0;
    }
  },
  'https:':  'http:',
  'ftp:':    'http:',
  '//':      {
    validate: function (text, pos, self) {
      var tail = text.slice(pos);

      if (!self.re.no_http) {
      // compile lazily, because "host"-containing variables can change on tlds update.
        self.re.no_http =  new RegExp(
          '^' +
          self.re.src_auth +
          // Don't allow single-level domains, because of false positives like '//test'
          // with code comments
          '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' +
          self.re.src_port +
          self.re.src_host_terminator +
          self.re.src_path,

          'i'
        );
      }

      if (self.re.no_http.test(tail)) {
        // should not be `://` & `///`, that protects from errors in protocol name
        if (pos >= 3 && text[pos - 3] === ':') { return 0; }
        if (pos >= 3 && text[pos - 3] === '/') { return 0; }
        return tail.match(self.re.no_http)[0].length;
      }
      return 0;
    }
  },
  'mailto:': {
    validate: function (text, pos, self) {
      var tail = text.slice(pos);

      if (!self.re.mailto) {
        self.re.mailto =  new RegExp(
          '^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i'
        );
      }
      if (self.re.mailto.test(tail)) {
        return tail.match(self.re.mailto)[0].length;
      }
      return 0;
    }
  }
};

/*eslint-disable max-len*/

// RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
var tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';

// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
var tlds_default = 'biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф'.split('|');

/*eslint-enable max-len*/

////////////////////////////////////////////////////////////////////////////////

function resetScanCache(self) {
  self.__index__ = -1;
  self.__text_cache__   = '';
}

function createValidator(re) {
  return function (text, pos) {
    var tail = text.slice(pos);

    if (re.test(tail)) {
      return tail.match(re)[0].length;
    }
    return 0;
  };
}

function createNormalizer() {
  return function (match, self) {
    self.normalize(match);
  };
}

// Schemas compiler. Build regexps.
//
function compile(self) {

  // Load & clone RE patterns.
  var re = self.re = __webpack_require__(87028)(self.__opts__);

  // Define dynamic patterns
  var tlds = self.__tlds__.slice();

  self.onCompile();

  if (!self.__tlds_replaced__) {
    tlds.push(tlds_2ch_src_re);
  }
  tlds.push(re.src_xn);

  re.src_tlds = tlds.join('|');

  function untpl(tpl) { return tpl.replace('%TLDS%', re.src_tlds); }

  re.email_fuzzy      = RegExp(untpl(re.tpl_email_fuzzy), 'i');
  re.link_fuzzy       = RegExp(untpl(re.tpl_link_fuzzy), 'i');
  re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
  re.host_fuzzy_test  = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');

  //
  // Compile each schema
  //

  var aliases = [];

  self.__compiled__ = {}; // Reset compiled data

  function schemaError(name, val) {
    throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
  }

  Object.keys(self.__schemas__).forEach(function (name) {
    var val = self.__schemas__[name];

    // skip disabled methods
    if (val === null) { return; }

    var compiled = { validate: null, link: null };

    self.__compiled__[name] = compiled;

    if (isObject(val)) {
      if (isRegExp(val.validate)) {
        compiled.validate = createValidator(val.validate);
      } else if (isFunction(val.validate)) {
        compiled.validate = val.validate;
      } else {
        schemaError(name, val);
      }

      if (isFunction(val.normalize)) {
        compiled.normalize = val.normalize;
      } else if (!val.normalize) {
        compiled.normalize = createNormalizer();
      } else {
        schemaError(name, val);
      }

      return;
    }

    if (isString(val)) {
      aliases.push(name);
      return;
    }

    schemaError(name, val);
  });

  //
  // Compile postponed aliases
  //

  aliases.forEach(function (alias) {
    if (!self.__compiled__[self.__schemas__[alias]]) {
      // Silently fail on missed schemas to avoid errons on disable.
      // schemaError(alias, self.__schemas__[alias]);
      return;
    }

    self.__compiled__[alias].validate =
      self.__compiled__[self.__schemas__[alias]].validate;
    self.__compiled__[alias].normalize =
      self.__compiled__[self.__schemas__[alias]].normalize;
  });

  //
  // Fake record for guessed links
  //
  self.__compiled__[''] = { validate: null, normalize: createNormalizer() };

  //
  // Build schema condition
  //
  var slist = Object.keys(self.__compiled__)
                      .filter(function (name) {
                        // Filter disabled & fake schemas
                        return name.length > 0 && self.__compiled__[name];
                      })
                      .map(escapeRE)
                      .join('|');
  // (?!_) cause 1.5x slowdown
  self.re.schema_test   = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
  self.re.schema_search = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');

  self.re.pretest = RegExp(
    '(' + self.re.schema_test.source + ')|(' + self.re.host_fuzzy_test.source + ')|@',
    'i'
  );

  //
  // Cleanup
  //

  resetScanCache(self);
}

/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/
function Match(self, shift) {
  var start = self.__index__,
      end   = self.__last_index__,
      text  = self.__text_cache__.slice(start, end);

  /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/
  this.schema    = self.__schema__.toLowerCase();
  /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/
  this.index     = start + shift;
  /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/
  this.lastIndex = end + shift;
  /**
   * Match#raw -> String
   *
   * Matched string.
   **/
  this.raw       = text;
  /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/
  this.text      = text;
  /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/
  this.url       = text;
}

function createMatch(self, shift) {
  var match = new Match(self, shift);

  self.__compiled__[match.schema].normalize(match, self);

  return match;
}


/**
 * class LinkifyIt
 **/

/**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/
function LinkifyIt(schemas, options) {
  if (!(this instanceof LinkifyIt)) {
    return new LinkifyIt(schemas, options);
  }

  if (!options) {
    if (isOptionsObj(schemas)) {
      options = schemas;
      schemas = {};
    }
  }

  this.__opts__           = assign({}, defaultOptions, options);

  // Cache last tested result. Used to skip repeating steps on next `match` call.
  this.__index__          = -1;
  this.__last_index__     = -1; // Next scan position
  this.__schema__         = '';
  this.__text_cache__     = '';

  this.__schemas__        = assign({}, defaultSchemas, schemas);
  this.__compiled__       = {};

  this.__tlds__           = tlds_default;
  this.__tlds_replaced__  = false;

  this.re = {};

  compile(this);
}


/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/
LinkifyIt.prototype.add = function add(schema, definition) {
  this.__schemas__[schema] = definition;
  compile(this);
  return this;
};


/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/
LinkifyIt.prototype.set = function set(options) {
  this.__opts__ = assign(this.__opts__, options);
  return this;
};


/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/
LinkifyIt.prototype.test = function test(text) {
  // Reset scan cache
  this.__text_cache__ = text;
  this.__index__      = -1;

  if (!text.length) { return false; }

  var m, ml, me, len, shift, next, re, tld_pos, at_pos;

  // try to scan for link with schema - that's the most simple rule
  if (this.re.schema_test.test(text)) {
    re = this.re.schema_search;
    re.lastIndex = 0;
    while ((m = re.exec(text)) !== null) {
      len = this.testSchemaAt(text, m[2], re.lastIndex);
      if (len) {
        this.__schema__     = m[2];
        this.__index__      = m.index + m[1].length;
        this.__last_index__ = m.index + m[0].length + len;
        break;
      }
    }
  }

  if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
    // guess schemaless links
    tld_pos = text.search(this.re.host_fuzzy_test);
    if (tld_pos >= 0) {
      // if tld is located after found link - no need to check fuzzy pattern
      if (this.__index__ < 0 || tld_pos < this.__index__) {
        if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {

          shift = ml.index + ml[1].length;

          if (this.__index__ < 0 || shift < this.__index__) {
            this.__schema__     = '';
            this.__index__      = shift;
            this.__last_index__ = ml.index + ml[0].length;
          }
        }
      }
    }
  }

  if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
    // guess schemaless emails
    at_pos = text.indexOf('@');
    if (at_pos >= 0) {
      // We can't skip this check, because this cases are possible:
      // 192.168.1.1@gmail.com, my.in@example.com
      if ((me = text.match(this.re.email_fuzzy)) !== null) {

        shift = me.index + me[1].length;
        next  = me.index + me[0].length;

        if (this.__index__ < 0 || shift < this.__index__ ||
            (shift === this.__index__ && next > this.__last_index__)) {
          this.__schema__     = 'mailto:';
          this.__index__      = shift;
          this.__last_index__ = next;
        }
      }
    }
  }

  return this.__index__ >= 0;
};


/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/
LinkifyIt.prototype.pretest = function pretest(text) {
  return this.re.pretest.test(text);
};


/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/
LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
  // If not supported schema check requested - terminate
  if (!this.__compiled__[schema.toLowerCase()]) {
    return 0;
  }
  return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};


/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/
LinkifyIt.prototype.match = function match(text) {
  var shift = 0, result = [];

  // Try to take previous element from cache, if .test() called before
  if (this.__index__ >= 0 && this.__text_cache__ === text) {
    result.push(createMatch(this, shift));
    shift = this.__last_index__;
  }

  // Cut head if cache was used
  var tail = shift ? text.slice(shift) : text;

  // Scan string until end reached
  while (this.test(tail)) {
    result.push(createMatch(this, shift));

    tail = tail.slice(this.__last_index__);
    shift += this.__last_index__;
  }

  if (result.length) {
    return result;
  }

  return null;
};


/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/
LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
  list = Array.isArray(list) ? list : [ list ];

  if (!keepOld) {
    this.__tlds__ = list.slice();
    this.__tlds_replaced__ = true;
    compile(this);
    return this;
  }

  this.__tlds__ = this.__tlds__.concat(list)
                                  .sort()
                                  .filter(function (el, idx, arr) {
                                    return el !== arr[idx - 1];
                                  })
                                  .reverse();

  compile(this);
  return this;
};

/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/
LinkifyIt.prototype.normalize = function normalize(match) {

  // Do minimal possible changes by default. Need to collect feedback prior
  // to move forward https://github.com/markdown-it/linkify-it/issues/1

  if (!match.schema) { match.url = 'http://' + match.url; }

  if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) {
    match.url = 'mailto:' + match.url;
  }
};


/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/
LinkifyIt.prototype.onCompile = function onCompile() {
};


module.exports = LinkifyIt;


/***/ }),

/***/ 87028:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";



module.exports = function (opts) {
  var re = {};

  // Use direct extract instead of `regenerate` to reduse browserified size
  re.src_Any = (__webpack_require__(50757).source);
  re.src_Cc  = (__webpack_require__(18436).source);
  re.src_Z   = (__webpack_require__(87613).source);
  re.src_P   = (__webpack_require__(97942).source);

  // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
  re.src_ZPCc = [ re.src_Z, re.src_P, re.src_Cc ].join('|');

  // \p{\Z\Cc} (white spaces + control)
  re.src_ZCc = [ re.src_Z, re.src_Cc ].join('|');

  // Experimental. List of chars, completely prohibited in links
  // because can separate it from other part of text
  var text_separators = '[><\uff5c]';

  // All possible word characters (everything without punctuation, spaces & controls)
  // Defined via punctuation & spaces to save space
  // Should be something like \p{\L\N\S\M} (\w but without `_`)
  re.src_pseudo_letter       = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
  // The same as abothe but without [0-9]
  // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';

  ////////////////////////////////////////////////////////////////////////////////

  re.src_ip4 =

    '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';

  // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
  re.src_auth    = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';

  re.src_port =

    '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';

  re.src_host_terminator =

    '(?=$|' + text_separators + '|' + re.src_ZPCc + ')(?!-|_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';

  re.src_path =

    '(?:' +
      '[/?#]' +
        '(?:' +
          '(?!' + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-;]).|' +
          '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' +
          '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' +
          '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' +
          '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' +
          "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" +
          "\\'(?=" + re.src_pseudo_letter + '|[-]).|' +  // allow `I'm_king` if no pair found
          '\\.{2,}[a-zA-Z0-9%/&]|' + // google has many dots in "google search" links (#66, #81).
                                     // github has ... in commit range links,
                                     // Restrict to
                                     // - english
                                     // - percent-encoded
                                     // - parts of file path
                                     // - params separator
                                     // until more examples found.
          '\\.(?!' + re.src_ZCc + '|[.]).|' +
          (opts && opts['---'] ?
            '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
            :
            '\\-+|'
          ) +
          ',(?!' + re.src_ZCc + ').|' +       // allow `,,,` in paths
          ';(?!' + re.src_ZCc + ').|' +       // allow `;` if not followed by space-like char
          '\\!+(?!' + re.src_ZCc + '|[!]).|' +  // allow `!!!` in paths, but not at the end
          '\\?(?!' + re.src_ZCc + '|[?]).' +
        ')+' +
      '|\\/' +
    ')?';

  // Allow anything in markdown spec, forbid quote (") at the first position
  // because emails enclosed in quotes are far more common
  re.src_email_name =

    '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*';

  re.src_xn =

    'xn--[a-z0-9\\-]{1,59}';

  // More to read about domain names
  // http://serverfault.com/questions/638260/

  re.src_domain_root =

    // Allow letters & digits (http://test1)
    '(?:' +
      re.src_xn +
      '|' +
      re.src_pseudo_letter + '{1,63}' +
    ')';

  re.src_domain =

    '(?:' +
      re.src_xn +
      '|' +
      '(?:' + re.src_pseudo_letter + ')' +
      '|' +
      '(?:' + re.src_pseudo_letter + '(?:-|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' +
    ')';

  re.src_host =

    '(?:' +
    // Don't need IP check, because digits are already allowed in normal domain names
    //   src_ip4 +
    // '|' +
      '(?:(?:(?:' + re.src_domain + ')\\.)*' + re.src_domain/*_root*/ + ')' +
    ')';

  re.tpl_host_fuzzy =

    '(?:' +
      re.src_ip4 +
    '|' +
      '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' +
    ')';

  re.tpl_host_no_ip_fuzzy =

    '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';

  re.src_host_strict =

    re.src_host + re.src_host_terminator;

  re.tpl_host_fuzzy_strict =

    re.tpl_host_fuzzy + re.src_host_terminator;

  re.src_host_port_strict =

    re.src_host + re.src_port + re.src_host_terminator;

  re.tpl_host_port_fuzzy_strict =

    re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;

  re.tpl_host_port_no_ip_fuzzy_strict =

    re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;


  ////////////////////////////////////////////////////////////////////////////////
  // Main rules

  // Rude test fuzzy links by host, for quick deny
  re.tpl_host_fuzzy_test =

    'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';

  re.tpl_email_fuzzy =

      '(^|' + text_separators + '|"|\\(|' + re.src_ZCc + ')' +
      '(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';

  re.tpl_link_fuzzy =
      // Fuzzy link can't be prepended with .:/\- and non punctuation.
      // but can start with > (markdown blockquote)
      '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' +
      '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';

  re.tpl_link_no_ip_fuzzy =
      // Fuzzy link can't be prepended with .:/\- and non punctuation.
      // but can start with > (markdown blockquote)
      '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' +
      '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';

  return re;
};


/***/ }),

/***/ 19404:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";



module.exports = __webpack_require__(73109);


/***/ }),

/***/ 83630:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// HTML5 entities map: { name -> utf16string }
//


/*eslint quotes:0*/
module.exports = __webpack_require__(83992);


/***/ }),

/***/ 57932:
/***/ ((module) => {

"use strict";
// List of valid html blocks names, accorting to commonmark spec
// http://jgm.github.io/CommonMark/spec.html#html-blocks




module.exports = [
  'address',
  'article',
  'aside',
  'base',
  'basefont',
  'blockquote',
  'body',
  'caption',
  'center',
  'col',
  'colgroup',
  'dd',
  'details',
  'dialog',
  'dir',
  'div',
  'dl',
  'dt',
  'fieldset',
  'figcaption',
  'figure',
  'footer',
  'form',
  'frame',
  'frameset',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'head',
  'header',
  'hr',
  'html',
  'iframe',
  'legend',
  'li',
  'link',
  'main',
  'menu',
  'menuitem',
  'nav',
  'noframes',
  'ol',
  'optgroup',
  'option',
  'p',
  'param',
  'section',
  'source',
  'summary',
  'table',
  'tbody',
  'td',
  'tfoot',
  'th',
  'thead',
  'title',
  'tr',
  'track',
  'ul'
];


/***/ }),

/***/ 26517:
/***/ ((module) => {

"use strict";
// Regexps to match html elements



var attr_name     = '[a-zA-Z_:][a-zA-Z0-9:._-]*';

var unquoted      = '[^"\'=<>`\\x00-\\x20]+';
var single_quoted = "'[^']*'";
var double_quoted = '"[^"]*"';

var attr_value  = '(?:' + unquoted + '|' + single_quoted + '|' + double_quoted + ')';

var attribute   = '(?:\\s+' + attr_name + '(?:\\s*=\\s*' + attr_value + ')?)';

var open_tag    = '<[A-Za-z][A-Za-z0-9\\-]*' + attribute + '*\\s*\\/?>';

var close_tag   = '<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>';
var comment     = '<!---->|<!--(?:-?[^>-])(?:-?[^-])*-->';
var processing  = '<[?][\\s\\S]*?[?]>';
var declaration = '<![A-Z]+\\s+[^>]*>';
var cdata       = '<!\\[CDATA\\[[\\s\\S]*?\\]\\]>';

var HTML_TAG_RE = new RegExp('^(?:' + open_tag + '|' + close_tag + '|' + comment +
                        '|' + processing + '|' + declaration + '|' + cdata + ')');
var HTML_OPEN_CLOSE_TAG_RE = new RegExp('^(?:' + open_tag + '|' + close_tag + ')');

module.exports.n = HTML_TAG_RE;
module.exports.q = HTML_OPEN_CLOSE_TAG_RE;


/***/ }),

/***/ 26212:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
// Utilities
//



function _class(obj) { return Object.prototype.toString.call(obj); }

function isString(obj) { return _class(obj) === '[object String]'; }

var _hasOwnProperty = Object.prototype.hasOwnProperty;

function has(object, key) {
  return _hasOwnProperty.call(object, key);
}

// Merge objects
//
function assign(obj /*from1, from2, from3, ...*/) {
  var sources = Array.prototype.slice.call(arguments, 1);

  sources.forEach(function (source) {
    if (!source) { return; }

    if (typeof source !== 'object') {
      throw new TypeError(source + 'must be object');
    }

    Object.keys(source).forEach(function (key) {
      obj[key] = source[key];
    });
  });

  return obj;
}

// Remove element from array and put another array at those position.
// Useful for some operations with tokens
function arrayReplaceAt(src, pos, newElements) {
  return [].concat(src.slice(0, pos), newElements, src.slice(pos + 1));
}

////////////////////////////////////////////////////////////////////////////////

function isValidEntityCode(c) {
  /*eslint no-bitwise:0*/
  // broken sequence
  if (c >= 0xD800 && c <= 0xDFFF) { return false; }
  // never used
  if (c >= 0xFDD0 && c <= 0xFDEF) { return false; }
  if ((c & 0xFFFF) === 0xFFFF || (c & 0xFFFF) === 0xFFFE) { return false; }
  // control codes
  if (c >= 0x00 && c <= 0x08) { return false; }
  if (c === 0x0B) { return false; }
  if (c >= 0x0E && c <= 0x1F) { return false; }
  if (c >= 0x7F && c <= 0x9F) { return false; }
  // out of range
  if (c > 0x10FFFF) { return false; }
  return true;
}

function fromCodePoint(c) {
  /*eslint no-bitwise:0*/
  if (c > 0xffff) {
    c -= 0x10000;
    var surrogate1 = 0xd800 + (c >> 10),
        surrogate2 = 0xdc00 + (c & 0x3ff);

    return String.fromCharCode(surrogate1, surrogate2);
  }
  return String.fromCharCode(c);
}


var UNESCAPE_MD_RE  = /\\([!"#$%&'()*+,\-.\/:;<=>?@[\\\]^_`{|}~])/g;
var ENTITY_RE       = /&([a-z#][a-z0-9]{1,31});/gi;
var UNESCAPE_ALL_RE = new RegExp(UNESCAPE_MD_RE.source + '|' + ENTITY_RE.source, 'gi');

var DIGITAL_ENTITY_TEST_RE = /^#((?:x[a-f0-9]{1,8}|[0-9]{1,8}))/i;

var entities = __webpack_require__(83630);

function replaceEntityPattern(match, name) {
  var code = 0;

  if (has(entities, name)) {
    return entities[name];
  }

  if (name.charCodeAt(0) === 0x23/* # */ && DIGITAL_ENTITY_TEST_RE.test(name)) {
    code = name[1].toLowerCase() === 'x' ?
      parseInt(name.slice(2), 16) : parseInt(name.slice(1), 10);

    if (isValidEntityCode(code)) {
      return fromCodePoint(code);
    }
  }

  return match;
}

/*function replaceEntities(str) {
  if (str.indexOf('&') < 0) { return str; }

  return str.replace(ENTITY_RE, replaceEntityPattern);
}*/

function unescapeMd(str) {
  if (str.indexOf('\\') < 0) { return str; }
  return str.replace(UNESCAPE_MD_RE, '$1');
}

function unescapeAll(str) {
  if (str.indexOf('\\') < 0 && str.indexOf('&') < 0) { return str; }

  return str.replace(UNESCAPE_ALL_RE, function (match, escaped, entity) {
    if (escaped) { return escaped; }
    return replaceEntityPattern(match, entity);
  });
}

////////////////////////////////////////////////////////////////////////////////

var HTML_ESCAPE_TEST_RE = /[&<>"]/;
var HTML_ESCAPE_REPLACE_RE = /[&<>"]/g;
var HTML_REPLACEMENTS = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;'
};

function replaceUnsafeChar(ch) {
  return HTML_REPLACEMENTS[ch];
}

function escapeHtml(str) {
  if (HTML_ESCAPE_TEST_RE.test(str)) {
    return str.replace(HTML_ESCAPE_REPLACE_RE, replaceUnsafeChar);
  }
  return str;
}

////////////////////////////////////////////////////////////////////////////////

var REGEXP_ESCAPE_RE = /[.?*+^$[\]\\(){}|-]/g;

function escapeRE(str) {
  return str.replace(REGEXP_ESCAPE_RE, '\\$&');
}

////////////////////////////////////////////////////////////////////////////////

function isSpace(code) {
  switch (code) {
    case 0x09:
    case 0x20:
      return true;
  }
  return false;
}

// Zs (unicode class) || [\t\f\v\r\n]
function isWhiteSpace(code) {
  if (code >= 0x2000 && code <= 0x200A) { return true; }
  switch (code) {
    case 0x09: // \t
    case 0x0A: // \n
    case 0x0B: // \v
    case 0x0C: // \f
    case 0x0D: // \r
    case 0x20:
    case 0xA0:
    case 0x1680:
    case 0x202F:
    case 0x205F:
    case 0x3000:
      return true;
  }
  return false;
}

////////////////////////////////////////////////////////////////////////////////

/*eslint-disable max-len*/
var UNICODE_PUNCT_RE = __webpack_require__(97942);

// Currently without astral characters support.
function isPunctChar(ch) {
  return UNICODE_PUNCT_RE.test(ch);
}


// Markdown ASCII punctuation characters.
//
// !, ", #, $, %, &, ', (, ), *, +, ,, -, ., /, :, ;, <, =, >, ?, @, [, \, ], ^, _, `, {, |, }, or ~
// http://spec.commonmark.org/0.15/#ascii-punctuation-character
//
// Don't confuse with unicode punctuation !!! It lacks some chars in ascii range.
//
function isMdAsciiPunct(ch) {
  switch (ch) {
    case 0x21/* ! */:
    case 0x22/* " */:
    case 0x23/* # */:
    case 0x24/* $ */:
    case 0x25/* % */:
    case 0x26/* & */:
    case 0x27/* ' */:
    case 0x28/* ( */:
    case 0x29/* ) */:
    case 0x2A/* * */:
    case 0x2B/* + */:
    case 0x2C/* , */:
    case 0x2D/* - */:
    case 0x2E/* . */:
    case 0x2F/* / */:
    case 0x3A/* : */:
    case 0x3B/* ; */:
    case 0x3C/* < */:
    case 0x3D/* = */:
    case 0x3E/* > */:
    case 0x3F/* ? */:
    case 0x40/* @ */:
    case 0x5B/* [ */:
    case 0x5C/* \ */:
    case 0x5D/* ] */:
    case 0x5E/* ^ */:
    case 0x5F/* _ */:
    case 0x60/* ` */:
    case 0x7B/* { */:
    case 0x7C/* | */:
    case 0x7D/* } */:
    case 0x7E/* ~ */:
      return true;
    default:
      return false;
  }
}

// Hepler to unify [reference labels].
//
function normalizeReference(str) {
  // Trim and collapse whitespace
  //
  str = str.trim().replace(/\s+/g, ' ');

  // In node v10 'ẞ'.toLowerCase() === 'Ṿ', which is presumed to be a bug
  // fixed in v12 (couldn't find any details).
  //
  // So treat this one as a special case
  // (remove this when node v10 is no longer supported).
  //
  if ('ẞ'.toLowerCase() === 'Ṿ') {
    str = str.replace(/ẞ/g, 'ß');
  }

  // .toLowerCase().toUpperCase() should get rid of all differences
  // between letter variants.
  //
  // Simple .toLowerCase() doesn't normalize 125 code points correctly,
  // and .toUpperCase doesn't normalize 6 of them (list of exceptions:
  // İ, ϴ, ẞ, Ω, K, Å - those are already uppercased, but have differently
  // uppercased versions).
  //
  // Here's an example showing how it happens. Lets take greek letter omega:
  // uppercase U+0398 (Θ), U+03f4 (ϴ) and lowercase U+03b8 (θ), U+03d1 (ϑ)
  //
  // Unicode entries:
  // 0398;GREEK CAPITAL LETTER THETA;Lu;0;L;;;;;N;;;;03B8;
  // 03B8;GREEK SMALL LETTER THETA;Ll;0;L;;;;;N;;;0398;;0398
  // 03D1;GREEK THETA SYMBOL;Ll;0;L;<compat> 03B8;;;;N;GREEK SMALL LETTER SCRIPT THETA;;0398;;0398
  // 03F4;GREEK CAPITAL THETA SYMBOL;Lu;0;L;<compat> 0398;;;;N;;;;03B8;
  //
  // Case-insensitive comparison should treat all of them as equivalent.
  //
  // But .toLowerCase() doesn't change ϑ (it's already lowercase),
  // and .toUpperCase() doesn't change ϴ (already uppercase).
  //
  // Applying first lower then upper case normalizes any character:
  // '\u0398\u03f4\u03b8\u03d1'.toLowerCase().toUpperCase() === '\u0398\u0398\u0398\u0398'
  //
  // Note: this is equivalent to unicode case folding; unicode normalization
  // is a different step that is not required here.
  //
  // Final result should be uppercased, because it's later stored in an object
  // (this avoid a conflict with Object.prototype members,
  // most notably, `__proto__`)
  //
  return str.toLowerCase().toUpperCase();
}

////////////////////////////////////////////////////////////////////////////////

// Re-export libraries commonly used in both markdown-it and its plugins,
// so plugins won't have to depend on them explicitly, which reduces their
// bundled size (e.g. a browser build).
//
exports.lib                 = {};
exports.lib.mdurl = __webpack_require__(12449);
exports.lib.ucmicro = __webpack_require__(21977);

exports.assign              = assign;
exports.isString            = isString;
exports.has                 = has;
exports.unescapeMd          = unescapeMd;
exports.unescapeAll         = unescapeAll;
exports.isValidEntityCode   = isValidEntityCode;
exports.fromCodePoint       = fromCodePoint;
// exports.replaceEntities     = replaceEntities;
exports.escapeHtml          = escapeHtml;
exports.arrayReplaceAt      = arrayReplaceAt;
exports.isSpace             = isSpace;
exports.isWhiteSpace        = isWhiteSpace;
exports.isMdAsciiPunct      = isMdAsciiPunct;
exports.isPunctChar         = isPunctChar;
exports.escapeRE            = escapeRE;
exports.normalizeReference  = normalizeReference;


/***/ }),

/***/ 29060:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
// Just a shortcut for bulk export



exports.parseLinkLabel = __webpack_require__(78430);
exports.parseLinkDestination = __webpack_require__(87951);
exports.parseLinkTitle = __webpack_require__(63973);


/***/ }),

/***/ 87951:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Parse link destination
//



var unescapeAll = (__webpack_require__(26212).unescapeAll);


module.exports = function parseLinkDestination(str, pos, max) {
  var code, level,
      lines = 0,
      start = pos,
      result = {
        ok: false,
        pos: 0,
        lines: 0,
        str: ''
      };

  if (str.charCodeAt(pos) === 0x3C /* < */) {
    pos++;
    while (pos < max) {
      code = str.charCodeAt(pos);
      if (code === 0x0A /* \n */) { return result; }
      if (code === 0x3C /* < */) { return result; }
      if (code === 0x3E /* > */) {
        result.pos = pos + 1;
        result.str = unescapeAll(str.slice(start + 1, pos));
        result.ok = true;
        return result;
      }
      if (code === 0x5C /* \ */ && pos + 1 < max) {
        pos += 2;
        continue;
      }

      pos++;
    }

    // no closing '>'
    return result;
  }

  // this should be ... } else { ... branch

  level = 0;
  while (pos < max) {
    code = str.charCodeAt(pos);

    if (code === 0x20) { break; }

    // ascii control characters
    if (code < 0x20 || code === 0x7F) { break; }

    if (code === 0x5C /* \ */ && pos + 1 < max) {
      if (str.charCodeAt(pos + 1) === 0x20) { break; }
      pos += 2;
      continue;
    }

    if (code === 0x28 /* ( */) {
      level++;
      if (level > 32) { return result; }
    }

    if (code === 0x29 /* ) */) {
      if (level === 0) { break; }
      level--;
    }

    pos++;
  }

  if (start === pos) { return result; }
  if (level !== 0) { return result; }

  result.str = unescapeAll(str.slice(start, pos));
  result.lines = lines;
  result.pos = pos;
  result.ok = true;
  return result;
};


/***/ }),

/***/ 78430:
/***/ ((module) => {

"use strict";
// Parse link label
//
// this function assumes that first character ("[") already matches;
// returns the end of the label
//


module.exports = function parseLinkLabel(state, start, disableNested) {
  var level, found, marker, prevPos,
      labelEnd = -1,
      max = state.posMax,
      oldPos = state.pos;

  state.pos = start + 1;
  level = 1;

  while (state.pos < max) {
    marker = state.src.charCodeAt(state.pos);
    if (marker === 0x5D /* ] */) {
      level--;
      if (level === 0) {
        found = true;
        break;
      }
    }

    prevPos = state.pos;
    state.md.inline.skipToken(state);
    if (marker === 0x5B /* [ */) {
      if (prevPos === state.pos - 1) {
        // increase level if we find text `[`, which is not a part of any token
        level++;
      } else if (disableNested) {
        state.pos = oldPos;
        return -1;
      }
    }
  }

  if (found) {
    labelEnd = state.pos;
  }

  // restore old state
  state.pos = oldPos;

  return labelEnd;
};


/***/ }),

/***/ 63973:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Parse link title
//



var unescapeAll = (__webpack_require__(26212).unescapeAll);


module.exports = function parseLinkTitle(str, pos, max) {
  var code,
      marker,
      lines = 0,
      start = pos,
      result = {
        ok: false,
        pos: 0,
        lines: 0,
        str: ''
      };

  if (pos >= max) { return result; }

  marker = str.charCodeAt(pos);

  if (marker !== 0x22 /* " */ && marker !== 0x27 /* ' */ && marker !== 0x28 /* ( */) { return result; }

  pos++;

  // if opening marker is "(", switch it to closing marker ")"
  if (marker === 0x28) { marker = 0x29; }

  while (pos < max) {
    code = str.charCodeAt(pos);
    if (code === marker) {
      result.pos = pos + 1;
      result.lines = lines;
      result.str = unescapeAll(str.slice(start + 1, pos));
      result.ok = true;
      return result;
    } else if (code === 0x28 /* ( */ && marker === 0x29 /* ) */) {
      return result;
    } else if (code === 0x0A) {
      lines++;
    } else if (code === 0x5C /* \ */ && pos + 1 < max) {
      pos++;
      if (str.charCodeAt(pos) === 0x0A) {
        lines++;
      }
    }

    pos++;
  }

  return result;
};


/***/ }),

/***/ 73109:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Main parser class




var utils        = __webpack_require__(26212);
var helpers      = __webpack_require__(29060);
var Renderer     = __webpack_require__(30247);
var ParserCore   = __webpack_require__(54439);
var ParserBlock  = __webpack_require__(95168);
var ParserInline = __webpack_require__(50442);
var LinkifyIt    = __webpack_require__(70870);
var mdurl        = __webpack_require__(12449);
var punycode     = __webpack_require__(79711);


var config = {
  default: __webpack_require__(74333),
  zero: __webpack_require__(29142),
  commonmark: __webpack_require__(43648)
};

////////////////////////////////////////////////////////////////////////////////
//
// This validator can prohibit more than really needed to prevent XSS. It's a
// tradeoff to keep code simple and to be secure by default.
//
// If you need different setup - override validator method as you wish. Or
// replace it with dummy function and use external sanitizer.
//

var BAD_PROTO_RE = /^(vbscript|javascript|file|data):/;
var GOOD_DATA_RE = /^data:image\/(gif|png|jpeg|webp);/;

function validateLink(url) {
  // url should be normalized at this point, and existing entities are decoded
  var str = url.trim().toLowerCase();

  return BAD_PROTO_RE.test(str) ? (GOOD_DATA_RE.test(str) ? true : false) : true;
}

////////////////////////////////////////////////////////////////////////////////


var RECODE_HOSTNAME_FOR = [ 'http:', 'https:', 'mailto:' ];

function normalizeLink(url) {
  var parsed = mdurl.parse(url, true);

  if (parsed.hostname) {
    // Encode hostnames in urls like:
    // `http://host/`, `https://host/`, `mailto:user@host`, `//host/`
    //
    // We don't encode unknown schemas, because it's likely that we encode
    // something we shouldn't (e.g. `skype:name` treated as `skype:host`)
    //
    if (!parsed.protocol || RECODE_HOSTNAME_FOR.indexOf(parsed.protocol) >= 0) {
      try {
        parsed.hostname = punycode.toASCII(parsed.hostname);
      } catch (er) { /**/ }
    }
  }

  return mdurl.encode(mdurl.format(parsed));
}

function normalizeLinkText(url) {
  var parsed = mdurl.parse(url, true);

  if (parsed.hostname) {
    // Encode hostnames in urls like:
    // `http://host/`, `https://host/`, `mailto:user@host`, `//host/`
    //
    // We don't encode unknown schemas, because it's likely that we encode
    // something we shouldn't (e.g. `skype:name` treated as `skype:host`)
    //
    if (!parsed.protocol || RECODE_HOSTNAME_FOR.indexOf(parsed.protocol) >= 0) {
      try {
        parsed.hostname = punycode.toUnicode(parsed.hostname);
      } catch (er) { /**/ }
    }
  }

  // add '%' to exclude list because of https://github.com/markdown-it/markdown-it/issues/720
  return mdurl.decode(mdurl.format(parsed), mdurl.decode.defaultChars + '%');
}


/**
 * class MarkdownIt
 *
 * Main parser/renderer class.
 *
 * ##### Usage
 *
 * ```javascript
 * // node.js, "classic" way:
 * var MarkdownIt = require('markdown-it'),
 *     md = new MarkdownIt();
 * var result = md.render('# markdown-it rulezz!');
 *
 * // node.js, the same, but with sugar:
 * var md = require('markdown-it')();
 * var result = md.render('# markdown-it rulezz!');
 *
 * // browser without AMD, added to "window" on script load
 * // Note, there are no dash.
 * var md = window.markdownit();
 * var result = md.render('# markdown-it rulezz!');
 * ```
 *
 * Single line rendering, without paragraph wrap:
 *
 * ```javascript
 * var md = require('markdown-it')();
 * var result = md.renderInline('__markdown-it__ rulezz!');
 * ```
 **/

/**
 * new MarkdownIt([presetName, options])
 * - presetName (String): optional, `commonmark` / `zero`
 * - options (Object)
 *
 * Creates parser instanse with given config. Can be called without `new`.
 *
 * ##### presetName
 *
 * MarkdownIt provides named presets as a convenience to quickly
 * enable/disable active syntax rules and options for common use cases.
 *
 * - ["commonmark"](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/commonmark.js) -
 *   configures parser to strict [CommonMark](http://commonmark.org/) mode.
 * - [default](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/default.js) -
 *   similar to GFM, used when no preset name given. Enables all available rules,
 *   but still without html, typographer & autolinker.
 * - ["zero"](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/zero.js) -
 *   all rules disabled. Useful to quickly setup your config via `.enable()`.
 *   For example, when you need only `bold` and `italic` markup and nothing else.
 *
 * ##### options:
 *
 * - __html__ - `false`. Set `true` to enable HTML tags in source. Be careful!
 *   That's not safe! You may need external sanitizer to protect output from XSS.
 *   It's better to extend features via plugins, instead of enabling HTML.
 * - __xhtmlOut__ - `false`. Set `true` to add '/' when closing single tags
 *   (`<br />`). This is needed only for full CommonMark compatibility. In real
 *   world you will need HTML output.
 * - __breaks__ - `false`. Set `true` to convert `\n` in paragraphs into `<br>`.
 * - __langPrefix__ - `language-`. CSS language class prefix for fenced blocks.
 *   Can be useful for external highlighters.
 * - __linkify__ - `false`. Set `true` to autoconvert URL-like text to links.
 * - __typographer__  - `false`. Set `true` to enable [some language-neutral
 *   replacement](https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/replacements.js) +
 *   quotes beautification (smartquotes).
 * - __quotes__ - `“”‘’`, String or Array. Double + single quotes replacement
 *   pairs, when typographer enabled and smartquotes on. For example, you can
 *   use `'«»„“'` for Russian, `'„“‚‘'` for German, and
 *   `['«\xA0', '\xA0»', '‹\xA0', '\xA0›']` for French (including nbsp).
 * - __highlight__ - `null`. Highlighter function for fenced code blocks.
 *   Highlighter `function (str, lang)` should return escaped HTML. It can also
 *   return empty string if the source was not changed and should be escaped
 *   externaly. If result starts with <pre... internal wrapper is skipped.
 *
 * ##### Example
 *
 * ```javascript
 * // commonmark mode
 * var md = require('markdown-it')('commonmark');
 *
 * // default mode
 * var md = require('markdown-it')();
 *
 * // enable everything
 * var md = require('markdown-it')({
 *   html: true,
 *   linkify: true,
 *   typographer: true
 * });
 * ```
 *
 * ##### Syntax highlighting
 *
 * ```js
 * var hljs = require('highlight.js') // https://highlightjs.org/
 *
 * var md = require('markdown-it')({
 *   highlight: function (str, lang) {
 *     if (lang && hljs.getLanguage(lang)) {
 *       try {
 *         return hljs.highlight(str, { language: lang, ignoreIllegals: true }).value;
 *       } catch (__) {}
 *     }
 *
 *     return ''; // use external default escaping
 *   }
 * });
 * ```
 *
 * Or with full wrapper override (if you need assign class to `<pre>`):
 *
 * ```javascript
 * var hljs = require('highlight.js') // https://highlightjs.org/
 *
 * // Actual default values
 * var md = require('markdown-it')({
 *   highlight: function (str, lang) {
 *     if (lang && hljs.getLanguage(lang)) {
 *       try {
 *         return '<pre class="hljs"><code>' +
 *                hljs.highlight(str, { language: lang, ignoreIllegals: true }).value +
 *                '</code></pre>';
 *       } catch (__) {}
 *     }
 *
 *     return '<pre class="hljs"><code>' + md.utils.escapeHtml(str) + '</code></pre>';
 *   }
 * });
 * ```
 *
 **/
function MarkdownIt(presetName, options) {
  if (!(this instanceof MarkdownIt)) {
    return new MarkdownIt(presetName, options);
  }

  if (!options) {
    if (!utils.isString(presetName)) {
      options = presetName || {};
      presetName = 'default';
    }
  }

  /**
   * MarkdownIt#inline -> ParserInline
   *
   * Instance of [[ParserInline]]. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/
  this.inline = new ParserInline();

  /**
   * MarkdownIt#block -> ParserBlock
   *
   * Instance of [[ParserBlock]]. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/
  this.block = new ParserBlock();

  /**
   * MarkdownIt#core -> Core
   *
   * Instance of [[Core]] chain executor. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/
  this.core = new ParserCore();

  /**
   * MarkdownIt#renderer -> Renderer
   *
   * Instance of [[Renderer]]. Use it to modify output look. Or to add rendering
   * rules for new token types, generated by plugins.
   *
   * ##### Example
   *
   * ```javascript
   * var md = require('markdown-it')();
   *
   * function myToken(tokens, idx, options, env, self) {
   *   //...
   *   return result;
   * };
   *
   * md.renderer.rules['my_token'] = myToken
   * ```
   *
   * See [[Renderer]] docs and [source code](https://github.com/markdown-it/markdown-it/blob/master/lib/renderer.js).
   **/
  this.renderer = new Renderer();

  /**
   * MarkdownIt#linkify -> LinkifyIt
   *
   * [linkify-it](https://github.com/markdown-it/linkify-it) instance.
   * Used by [linkify](https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/linkify.js)
   * rule.
   **/
  this.linkify = new LinkifyIt();

  /**
   * MarkdownIt#validateLink(url) -> Boolean
   *
   * Link validation function. CommonMark allows too much in links. By default
   * we disable `javascript:`, `vbscript:`, `file:` schemas, and almost all `data:...` schemas
   * except some embedded image types.
   *
   * You can change this behaviour:
   *
   * ```javascript
   * var md = require('markdown-it')();
   * // enable everything
   * md.validateLink = function () { return true; }
   * ```
   **/
  this.validateLink = validateLink;

  /**
   * MarkdownIt#normalizeLink(url) -> String
   *
   * Function used to encode link url to a machine-readable format,
   * which includes url-encoding, punycode, etc.
   **/
  this.normalizeLink = normalizeLink;

  /**
   * MarkdownIt#normalizeLinkText(url) -> String
   *
   * Function used to decode link url to a human-readable format`
   **/
  this.normalizeLinkText = normalizeLinkText;


  // Expose utils & helpers for easy acces from plugins

  /**
   * MarkdownIt#utils -> utils
   *
   * Assorted utility functions, useful to write plugins. See details
   * [here](https://github.com/markdown-it/markdown-it/blob/master/lib/common/utils.js).
   **/
  this.utils = utils;

  /**
   * MarkdownIt#helpers -> helpers
   *
   * Link components parser functions, useful to write plugins. See details
   * [here](https://github.com/markdown-it/markdown-it/blob/master/lib/helpers).
   **/
  this.helpers = utils.assign({}, helpers);


  this.options = {};
  this.configure(presetName);

  if (options) { this.set(options); }
}


/** chainable
 * MarkdownIt.set(options)
 *
 * Set parser options (in the same format as in constructor). Probably, you
 * will never need it, but you can change options after constructor call.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')()
 *             .set({ html: true, breaks: true })
 *             .set({ typographer, true });
 * ```
 *
 * __Note:__ To achieve the best possible performance, don't modify a
 * `markdown-it` instance options on the fly. If you need multiple configurations
 * it's best to create multiple instances and initialize each with separate
 * config.
 **/
MarkdownIt.prototype.set = function (options) {
  utils.assign(this.options, options);
  return this;
};


/** chainable, internal
 * MarkdownIt.configure(presets)
 *
 * Batch load of all options and compenent settings. This is internal method,
 * and you probably will not need it. But if you will - see available presets
 * and data structure [here](https://github.com/markdown-it/markdown-it/tree/master/lib/presets)
 *
 * We strongly recommend to use presets instead of direct config loads. That
 * will give better compatibility with next versions.
 **/
MarkdownIt.prototype.configure = function (presets) {
  var self = this, presetName;

  if (utils.isString(presets)) {
    presetName = presets;
    presets = config[presetName];
    if (!presets) { throw new Error('Wrong `markdown-it` preset "' + presetName + '", check name'); }
  }

  if (!presets) { throw new Error('Wrong `markdown-it` preset, can\'t be empty'); }

  if (presets.options) { self.set(presets.options); }

  if (presets.components) {
    Object.keys(presets.components).forEach(function (name) {
      if (presets.components[name].rules) {
        self[name].ruler.enableOnly(presets.components[name].rules);
      }
      if (presets.components[name].rules2) {
        self[name].ruler2.enableOnly(presets.components[name].rules2);
      }
    });
  }
  return this;
};


/** chainable
 * MarkdownIt.enable(list, ignoreInvalid)
 * - list (String|Array): rule name or list of rule names to enable
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable list or rules. It will automatically find appropriate components,
 * containing rules with given names. If rule not found, and `ignoreInvalid`
 * not set - throws exception.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')()
 *             .enable(['sub', 'sup'])
 *             .disable('smartquotes');
 * ```
 **/
MarkdownIt.prototype.enable = function (list, ignoreInvalid) {
  var result = [];

  if (!Array.isArray(list)) { list = [ list ]; }

  [ 'core', 'block', 'inline' ].forEach(function (chain) {
    result = result.concat(this[chain].ruler.enable(list, true));
  }, this);

  result = result.concat(this.inline.ruler2.enable(list, true));

  var missed = list.filter(function (name) { return result.indexOf(name) < 0; });

  if (missed.length && !ignoreInvalid) {
    throw new Error('MarkdownIt. Failed to enable unknown rule(s): ' + missed);
  }

  return this;
};


/** chainable
 * MarkdownIt.disable(list, ignoreInvalid)
 * - list (String|Array): rule name or list of rule names to disable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * The same as [[MarkdownIt.enable]], but turn specified rules off.
 **/
MarkdownIt.prototype.disable = function (list, ignoreInvalid) {
  var result = [];

  if (!Array.isArray(list)) { list = [ list ]; }

  [ 'core', 'block', 'inline' ].forEach(function (chain) {
    result = result.concat(this[chain].ruler.disable(list, true));
  }, this);

  result = result.concat(this.inline.ruler2.disable(list, true));

  var missed = list.filter(function (name) { return result.indexOf(name) < 0; });

  if (missed.length && !ignoreInvalid) {
    throw new Error('MarkdownIt. Failed to disable unknown rule(s): ' + missed);
  }
  return this;
};


/** chainable
 * MarkdownIt.use(plugin, params)
 *
 * Load specified plugin with given params into current parser instance.
 * It's just a sugar to call `plugin(md, params)` with curring.
 *
 * ##### Example
 *
 * ```javascript
 * var iterator = require('markdown-it-for-inline');
 * var md = require('markdown-it')()
 *             .use(iterator, 'foo_replace', 'text', function (tokens, idx) {
 *               tokens[idx].content = tokens[idx].content.replace(/foo/g, 'bar');
 *             });
 * ```
 **/
MarkdownIt.prototype.use = function (plugin /*, params, ... */) {
  var args = [ this ].concat(Array.prototype.slice.call(arguments, 1));
  plugin.apply(plugin, args);
  return this;
};


/** internal
 * MarkdownIt.parse(src, env) -> Array
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Parse input string and return list of block tokens (special token type
 * "inline" will contain list of inline tokens). You should not call this
 * method directly, until you write custom renderer (for example, to produce
 * AST).
 *
 * `env` is used to pass data between "distributed" rules and return additional
 * metadata like reference info, needed for the renderer. It also can be used to
 * inject data in specific cases. Usually, you will be ok to pass `{}`,
 * and then pass updated object to renderer.
 **/
MarkdownIt.prototype.parse = function (src, env) {
  if (typeof src !== 'string') {
    throw new Error('Input data should be a String');
  }

  var state = new this.core.State(src, this, env);

  this.core.process(state);

  return state.tokens;
};


/**
 * MarkdownIt.render(src [, env]) -> String
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Render markdown string into html. It does all magic for you :).
 *
 * `env` can be used to inject additional metadata (`{}` by default).
 * But you will not need it with high probability. See also comment
 * in [[MarkdownIt.parse]].
 **/
MarkdownIt.prototype.render = function (src, env) {
  env = env || {};

  return this.renderer.render(this.parse(src, env), this.options, env);
};


/** internal
 * MarkdownIt.parseInline(src, env) -> Array
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * The same as [[MarkdownIt.parse]] but skip all block rules. It returns the
 * block tokens list with the single `inline` element, containing parsed inline
 * tokens in `children` property. Also updates `env` object.
 **/
MarkdownIt.prototype.parseInline = function (src, env) {
  var state = new this.core.State(src, this, env);

  state.inlineMode = true;
  this.core.process(state);

  return state.tokens;
};


/**
 * MarkdownIt.renderInline(src [, env]) -> String
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Similar to [[MarkdownIt.render]] but for single paragraph content. Result
 * will NOT be wrapped into `<p>` tags.
 **/
MarkdownIt.prototype.renderInline = function (src, env) {
  env = env || {};

  return this.renderer.render(this.parseInline(src, env), this.options, env);
};


module.exports = MarkdownIt;


/***/ }),

/***/ 95168:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
/** internal
 * class ParserBlock
 *
 * Block-level tokenizer.
 **/



var Ruler           = __webpack_require__(81284);


var _rules = [
  // First 2 params - rule name & source. Secondary array - list of rules,
  // which can be terminated by this one.
  [ 'table',      __webpack_require__(83010),      [ 'paragraph', 'reference' ] ],
  [ 'code',       __webpack_require__(60148) ],
  [ 'fence',      __webpack_require__(10130),      [ 'paragraph', 'reference', 'blockquote', 'list' ] ],
  [ 'blockquote', __webpack_require__(74599), [ 'paragraph', 'reference', 'blockquote', 'list' ] ],
  [ 'hr',         __webpack_require__(17242),         [ 'paragraph', 'reference', 'blockquote', 'list' ] ],
  [ 'list',       __webpack_require__(3557),       [ 'paragraph', 'reference', 'blockquote' ] ],
  [ 'reference',  __webpack_require__(2534) ],
  [ 'html_block', __webpack_require__(29690), [ 'paragraph', 'reference', 'blockquote' ] ],
  [ 'heading',    __webpack_require__(40899),    [ 'paragraph', 'reference', 'blockquote' ] ],
  [ 'lheading',   __webpack_require__(76091) ],
  [ 'paragraph',  __webpack_require__(37370) ]
];


/**
 * new ParserBlock()
 **/
function ParserBlock() {
  /**
   * ParserBlock#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of block rules.
   **/
  this.ruler = new Ruler();

  for (var i = 0; i < _rules.length; i++) {
    this.ruler.push(_rules[i][0], _rules[i][1], { alt: (_rules[i][2] || []).slice() });
  }
}


// Generate tokens for input range
//
ParserBlock.prototype.tokenize = function (state, startLine, endLine) {
  var ok, i,
      rules = this.ruler.getRules(''),
      len = rules.length,
      line = startLine,
      hasEmptyLines = false,
      maxNesting = state.md.options.maxNesting;

  while (line < endLine) {
    state.line = line = state.skipEmptyLines(line);
    if (line >= endLine) { break; }

    // Termination condition for nested calls.
    // Nested calls currently used for blockquotes & lists
    if (state.sCount[line] < state.blkIndent) { break; }

    // If nesting level exceeded - skip tail to the end. That's not ordinary
    // situation and we should not care about content.
    if (state.level >= maxNesting) {
      state.line = endLine;
      break;
    }

    // Try all possible rules.
    // On success, rule should:
    //
    // - update `state.line`
    // - update `state.tokens`
    // - return true

    for (i = 0; i < len; i++) {
      ok = rules[i](state, line, endLine, false);
      if (ok) { break; }
    }

    // set state.tight if we had an empty line before current tag
    // i.e. latest empty line should not count
    state.tight = !hasEmptyLines;

    // paragraph might "eat" one newline after it in nested lists
    if (state.isEmpty(state.line - 1)) {
      hasEmptyLines = true;
    }

    line = state.line;

    if (line < endLine && state.isEmpty(line)) {
      hasEmptyLines = true;
      line++;
      state.line = line;
    }
  }
};


/**
 * ParserBlock.parse(str, md, env, outTokens)
 *
 * Process input string and push block tokens into `outTokens`
 **/
ParserBlock.prototype.parse = function (src, md, env, outTokens) {
  var state;

  if (!src) { return; }

  state = new this.State(src, md, env, outTokens);

  this.tokenize(state, state.line, state.lineMax);
};


ParserBlock.prototype.State = __webpack_require__(49677);


module.exports = ParserBlock;


/***/ }),

/***/ 54439:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
/** internal
 * class Core
 *
 * Top-level rules executor. Glues block/inline parsers and does intermediate
 * transformations.
 **/



var Ruler  = __webpack_require__(81284);


var _rules = [
  [ 'normalize',      __webpack_require__(75272)      ],
  [ 'block',          __webpack_require__(84965)          ],
  [ 'inline',         __webpack_require__(80458)         ],
  [ 'linkify',        __webpack_require__(68961)        ],
  [ 'replacements',   __webpack_require__(30806)   ],
  [ 'smartquotes',    __webpack_require__(62839)    ]
];


/**
 * new Core()
 **/
function Core() {
  /**
   * Core#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of core rules.
   **/
  this.ruler = new Ruler();

  for (var i = 0; i < _rules.length; i++) {
    this.ruler.push(_rules[i][0], _rules[i][1]);
  }
}


/**
 * Core.process(state)
 *
 * Executes core chain rules.
 **/
Core.prototype.process = function (state) {
  var i, l, rules;

  rules = this.ruler.getRules('');

  for (i = 0, l = rules.length; i < l; i++) {
    rules[i](state);
  }
};

Core.prototype.State = __webpack_require__(36455);


module.exports = Core;


/***/ }),

/***/ 50442:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
/** internal
 * class ParserInline
 *
 * Tokenizes paragraph content.
 **/



var Ruler           = __webpack_require__(81284);


////////////////////////////////////////////////////////////////////////////////
// Parser rules

var _rules = [
  [ 'text',            __webpack_require__(11854) ],
  [ 'newline',         __webpack_require__(40183) ],
  [ 'escape',          __webpack_require__(626) ],
  [ 'backticks',       __webpack_require__(5691) ],
  [ 'strikethrough',   (__webpack_require__(26472)/* .tokenize */ .w) ],
  [ 'emphasis',        (__webpack_require__(36522)/* .tokenize */ .w) ],
  [ 'link',            __webpack_require__(70027) ],
  [ 'image',           __webpack_require__(29192) ],
  [ 'autolink',        __webpack_require__(34627) ],
  [ 'html_inline',     __webpack_require__(97845) ],
  [ 'entity',          __webpack_require__(72105) ]
];

var _rules2 = [
  [ 'balance_pairs',   __webpack_require__(40469) ],
  [ 'strikethrough',   (__webpack_require__(26472)/* .postProcess */ .g) ],
  [ 'emphasis',        (__webpack_require__(36522)/* .postProcess */ .g) ],
  [ 'text_collapse',   __webpack_require__(83514) ]
];


/**
 * new ParserInline()
 **/
function ParserInline() {
  var i;

  /**
   * ParserInline#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of inline rules.
   **/
  this.ruler = new Ruler();

  for (i = 0; i < _rules.length; i++) {
    this.ruler.push(_rules[i][0], _rules[i][1]);
  }

  /**
   * ParserInline#ruler2 -> Ruler
   *
   * [[Ruler]] instance. Second ruler used for post-processing
   * (e.g. in emphasis-like rules).
   **/
  this.ruler2 = new Ruler();

  for (i = 0; i < _rules2.length; i++) {
    this.ruler2.push(_rules2[i][0], _rules2[i][1]);
  }
}


// Skip single token by running all rules in validation mode;
// returns `true` if any rule reported success
//
ParserInline.prototype.skipToken = function (state) {
  var ok, i, pos = state.pos,
      rules = this.ruler.getRules(''),
      len = rules.length,
      maxNesting = state.md.options.maxNesting,
      cache = state.cache;


  if (typeof cache[pos] !== 'undefined') {
    state.pos = cache[pos];
    return;
  }

  if (state.level < maxNesting) {
    for (i = 0; i < len; i++) {
      // Increment state.level and decrement it later to limit recursion.
      // It's harmless to do here, because no tokens are created. But ideally,
      // we'd need a separate private state variable for this purpose.
      //
      state.level++;
      ok = rules[i](state, true);
      state.level--;

      if (ok) { break; }
    }
  } else {
    // Too much nesting, just skip until the end of the paragraph.
    //
    // NOTE: this will cause links to behave incorrectly in the following case,
    //       when an amount of `[` is exactly equal to `maxNesting + 1`:
    //
    //       [[[[[[[[[[[[[[[[[[[[[foo]()
    //
    // TODO: remove this workaround when CM standard will allow nested links
    //       (we can replace it by preventing links from being parsed in
    //       validation mode)
    //
    state.pos = state.posMax;
  }

  if (!ok) { state.pos++; }
  cache[pos] = state.pos;
};


// Generate tokens for input range
//
ParserInline.prototype.tokenize = function (state) {
  var ok, i,
      rules = this.ruler.getRules(''),
      len = rules.length,
      end = state.posMax,
      maxNesting = state.md.options.maxNesting;

  while (state.pos < end) {
    // Try all possible rules.
    // On success, rule should:
    //
    // - update `state.pos`
    // - update `state.tokens`
    // - return true

    if (state.level < maxNesting) {
      for (i = 0; i < len; i++) {
        ok = rules[i](state, false);
        if (ok) { break; }
      }
    }

    if (ok) {
      if (state.pos >= end) { break; }
      continue;
    }

    state.pending += state.src[state.pos++];
  }

  if (state.pending) {
    state.pushPending();
  }
};


/**
 * ParserInline.parse(str, md, env, outTokens)
 *
 * Process input string and push inline tokens into `outTokens`
 **/
ParserInline.prototype.parse = function (str, md, env, outTokens) {
  var i, rules, len;
  var state = new this.State(str, md, env, outTokens);

  this.tokenize(state);

  rules = this.ruler2.getRules('');
  len = rules.length;

  for (i = 0; i < len; i++) {
    rules[i](state);
  }
};


ParserInline.prototype.State = __webpack_require__(62418);


module.exports = ParserInline;


/***/ }),

/***/ 43648:
/***/ ((module) => {

"use strict";
// Commonmark default options




module.exports = {
  options: {
    html:         true,         // Enable HTML tags in source
    xhtmlOut:     true,         // Use '/' to close single tags (<br />)
    breaks:       false,        // Convert '\n' in paragraphs into <br>
    langPrefix:   'language-',  // CSS language prefix for fenced blocks
    linkify:      false,        // autoconvert URL-like texts to links

    // Enable some language-neutral replacements + quotes beautification
    typographer:  false,

    // Double + single quotes replacement pairs, when typographer enabled,
    // and smartquotes on. Could be either a String or an Array.
    //
    // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
    // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
    quotes: '\u201c\u201d\u2018\u2019', /* “”‘’ */

    // Highlighter function. Should return escaped HTML,
    // or '' if the source string is not changed and should be escaped externaly.
    // If result starts with <pre... internal wrapper is skipped.
    //
    // function (/*str, lang*/) { return ''; }
    //
    highlight: null,

    maxNesting:   20            // Internal protection, recursion limit
  },

  components: {

    core: {
      rules: [
        'normalize',
        'block',
        'inline'
      ]
    },

    block: {
      rules: [
        'blockquote',
        'code',
        'fence',
        'heading',
        'hr',
        'html_block',
        'lheading',
        'list',
        'reference',
        'paragraph'
      ]
    },

    inline: {
      rules: [
        'autolink',
        'backticks',
        'emphasis',
        'entity',
        'escape',
        'html_inline',
        'image',
        'link',
        'newline',
        'text'
      ],
      rules2: [
        'balance_pairs',
        'emphasis',
        'text_collapse'
      ]
    }
  }
};


/***/ }),

/***/ 74333:
/***/ ((module) => {

"use strict";
// markdown-it default options




module.exports = {
  options: {
    html:         false,        // Enable HTML tags in source
    xhtmlOut:     false,        // Use '/' to close single tags (<br />)
    breaks:       false,        // Convert '\n' in paragraphs into <br>
    langPrefix:   'language-',  // CSS language prefix for fenced blocks
    linkify:      false,        // autoconvert URL-like texts to links

    // Enable some language-neutral replacements + quotes beautification
    typographer:  false,

    // Double + single quotes replacement pairs, when typographer enabled,
    // and smartquotes on. Could be either a String or an Array.
    //
    // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
    // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
    quotes: '\u201c\u201d\u2018\u2019', /* “”‘’ */

    // Highlighter function. Should return escaped HTML,
    // or '' if the source string is not changed and should be escaped externaly.
    // If result starts with <pre... internal wrapper is skipped.
    //
    // function (/*str, lang*/) { return ''; }
    //
    highlight: null,

    maxNesting:   100            // Internal protection, recursion limit
  },

  components: {

    core: {},
    block: {},
    inline: {}
  }
};


/***/ }),

/***/ 29142:
/***/ ((module) => {

"use strict";
// "Zero" preset, with nothing enabled. Useful for manual configuring of simple
// modes. For example, to parse bold/italic only.




module.exports = {
  options: {
    html:         false,        // Enable HTML tags in source
    xhtmlOut:     false,        // Use '/' to close single tags (<br />)
    breaks:       false,        // Convert '\n' in paragraphs into <br>
    langPrefix:   'language-',  // CSS language prefix for fenced blocks
    linkify:      false,        // autoconvert URL-like texts to links

    // Enable some language-neutral replacements + quotes beautification
    typographer:  false,

    // Double + single quotes replacement pairs, when typographer enabled,
    // and smartquotes on. Could be either a String or an Array.
    //
    // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
    // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
    quotes: '\u201c\u201d\u2018\u2019', /* “”‘’ */

    // Highlighter function. Should return escaped HTML,
    // or '' if the source string is not changed and should be escaped externaly.
    // If result starts with <pre... internal wrapper is skipped.
    //
    // function (/*str, lang*/) { return ''; }
    //
    highlight: null,

    maxNesting:   20            // Internal protection, recursion limit
  },

  components: {

    core: {
      rules: [
        'normalize',
        'block',
        'inline'
      ]
    },

    block: {
      rules: [
        'paragraph'
      ]
    },

    inline: {
      rules: [
        'text'
      ],
      rules2: [
        'balance_pairs',
        'text_collapse'
      ]
    }
  }
};


/***/ }),

/***/ 30247:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
/**
 * class Renderer
 *
 * Generates HTML from parsed token stream. Each instance has independent
 * copy of rules. Those can be rewritten with ease. Also, you can add new
 * rules if you create plugin and adds new token types.
 **/



var assign          = (__webpack_require__(26212).assign);
var unescapeAll     = (__webpack_require__(26212).unescapeAll);
var escapeHtml      = (__webpack_require__(26212).escapeHtml);


////////////////////////////////////////////////////////////////////////////////

var default_rules = {};


default_rules.code_inline = function (tokens, idx, options, env, slf) {
  var token = tokens[idx];

  return  '<code' + slf.renderAttrs(token) + '>' +
          escapeHtml(tokens[idx].content) +
          '</code>';
};


default_rules.code_block = function (tokens, idx, options, env, slf) {
  var token = tokens[idx];

  return  '<pre' + slf.renderAttrs(token) + '><code>' +
          escapeHtml(tokens[idx].content) +
          '</code></pre>\n';
};


default_rules.fence = function (tokens, idx, options, env, slf) {
  var token = tokens[idx],
      info = token.info ? unescapeAll(token.info).trim() : '',
      langName = '',
      langAttrs = '',
      highlighted, i, arr, tmpAttrs, tmpToken;

  if (info) {
    arr = info.split(/(\s+)/g);
    langName = arr[0];
    langAttrs = arr.slice(2).join('');
  }

  if (options.highlight) {
    highlighted = options.highlight(token.content, langName, langAttrs) || escapeHtml(token.content);
  } else {
    highlighted = escapeHtml(token.content);
  }

  if (highlighted.indexOf('<pre') === 0) {
    return highlighted + '\n';
  }

  // If language exists, inject class gently, without modifying original token.
  // May be, one day we will add .deepClone() for token and simplify this part, but
  // now we prefer to keep things local.
  if (info) {
    i        = token.attrIndex('class');
    tmpAttrs = token.attrs ? token.attrs.slice() : [];

    if (i < 0) {
      tmpAttrs.push([ 'class', options.langPrefix + langName ]);
    } else {
      tmpAttrs[i] = tmpAttrs[i].slice();
      tmpAttrs[i][1] += ' ' + options.langPrefix + langName;
    }

    // Fake token just to render attributes
    tmpToken = {
      attrs: tmpAttrs
    };

    return  '<pre><code' + slf.renderAttrs(tmpToken) + '>'
          + highlighted
          + '</code></pre>\n';
  }


  return  '<pre><code' + slf.renderAttrs(token) + '>'
        + highlighted
        + '</code></pre>\n';
};


default_rules.image = function (tokens, idx, options, env, slf) {
  var token = tokens[idx];

  // "alt" attr MUST be set, even if empty. Because it's mandatory and
  // should be placed on proper position for tests.
  //
  // Replace content with actual value

  token.attrs[token.attrIndex('alt')][1] =
    slf.renderInlineAsText(token.children, options, env);

  return slf.renderToken(tokens, idx, options);
};


default_rules.hardbreak = function (tokens, idx, options /*, env */) {
  return options.xhtmlOut ? '<br />\n' : '<br>\n';
};
default_rules.softbreak = function (tokens, idx, options /*, env */) {
  return options.breaks ? (options.xhtmlOut ? '<br />\n' : '<br>\n') : '\n';
};


default_rules.text = function (tokens, idx /*, options, env */) {
  return escapeHtml(tokens[idx].content);
};


default_rules.html_block = function (tokens, idx /*, options, env */) {
  return tokens[idx].content;
};
default_rules.html_inline = function (tokens, idx /*, options, env */) {
  return tokens[idx].content;
};


/**
 * new Renderer()
 *
 * Creates new [[Renderer]] instance and fill [[Renderer#rules]] with defaults.
 **/
function Renderer() {

  /**
   * Renderer#rules -> Object
   *
   * Contains render rules for tokens. Can be updated and extended.
   *
   * ##### Example
   *
   * ```javascript
   * var md = require('markdown-it')();
   *
   * md.renderer.rules.strong_open  = function () { return '<b>'; };
   * md.renderer.rules.strong_close = function () { return '</b>'; };
   *
   * var result = md.renderInline(...);
   * ```
   *
   * Each rule is called as independent static function with fixed signature:
   *
   * ```javascript
   * function my_token_render(tokens, idx, options, env, renderer) {
   *   // ...
   *   return renderedHTML;
   * }
   * ```
   *
   * See [source code](https://github.com/markdown-it/markdown-it/blob/master/lib/renderer.js)
   * for more details and examples.
   **/
  this.rules = assign({}, default_rules);
}


/**
 * Renderer.renderAttrs(token) -> String
 *
 * Render token attributes to string.
 **/
Renderer.prototype.renderAttrs = function renderAttrs(token) {
  var i, l, result;

  if (!token.attrs) { return ''; }

  result = '';

  for (i = 0, l = token.attrs.length; i < l; i++) {
    result += ' ' + escapeHtml(token.attrs[i][0]) + '="' + escapeHtml(token.attrs[i][1]) + '"';
  }

  return result;
};


/**
 * Renderer.renderToken(tokens, idx, options) -> String
 * - tokens (Array): list of tokens
 * - idx (Numbed): token index to render
 * - options (Object): params of parser instance
 *
 * Default token renderer. Can be overriden by custom function
 * in [[Renderer#rules]].
 **/
Renderer.prototype.renderToken = function renderToken(tokens, idx, options) {
  var nextToken,
      result = '',
      needLf = false,
      token = tokens[idx];

  // Tight list paragraphs
  if (token.hidden) {
    return '';
  }

  // Insert a newline between hidden paragraph and subsequent opening
  // block-level tag.
  //
  // For example, here we should insert a newline before blockquote:
  //  - a
  //    >
  //
  if (token.block && token.nesting !== -1 && idx && tokens[idx - 1].hidden) {
    result += '\n';
  }

  // Add token name, e.g. `<img`
  result += (token.nesting === -1 ? '</' : '<') + token.tag;

  // Encode attributes, e.g. `<img src="foo"`
  result += this.renderAttrs(token);

  // Add a slash for self-closing tags, e.g. `<img src="foo" /`
  if (token.nesting === 0 && options.xhtmlOut) {
    result += ' /';
  }

  // Check if we need to add a newline after this tag
  if (token.block) {
    needLf = true;

    if (token.nesting === 1) {
      if (idx + 1 < tokens.length) {
        nextToken = tokens[idx + 1];

        if (nextToken.type === 'inline' || nextToken.hidden) {
          // Block-level tag containing an inline tag.
          //
          needLf = false;

        } else if (nextToken.nesting === -1 && nextToken.tag === token.tag) {
          // Opening tag + closing tag of the same type. E.g. `<li></li>`.
          //
          needLf = false;
        }
      }
    }
  }

  result += needLf ? '>\n' : '>';

  return result;
};


/**
 * Renderer.renderInline(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to renter
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * The same as [[Renderer.render]], but for single token of `inline` type.
 **/
Renderer.prototype.renderInline = function (tokens, options, env) {
  var type,
      result = '',
      rules = this.rules;

  for (var i = 0, len = tokens.length; i < len; i++) {
    type = tokens[i].type;

    if (typeof rules[type] !== 'undefined') {
      result += rules[type](tokens, i, options, env, this);
    } else {
      result += this.renderToken(tokens, i, options);
    }
  }

  return result;
};


/** internal
 * Renderer.renderInlineAsText(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to renter
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * Special kludge for image `alt` attributes to conform CommonMark spec.
 * Don't try to use it! Spec requires to show `alt` content with stripped markup,
 * instead of simple escaping.
 **/
Renderer.prototype.renderInlineAsText = function (tokens, options, env) {
  var result = '';

  for (var i = 0, len = tokens.length; i < len; i++) {
    if (tokens[i].type === 'text') {
      result += tokens[i].content;
    } else if (tokens[i].type === 'image') {
      result += this.renderInlineAsText(tokens[i].children, options, env);
    } else if (tokens[i].type === 'softbreak') {
      result += '\n';
    }
  }

  return result;
};


/**
 * Renderer.render(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to renter
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * Takes token stream and generates HTML. Probably, you will never need to call
 * this method directly.
 **/
Renderer.prototype.render = function (tokens, options, env) {
  var i, len, type,
      result = '',
      rules = this.rules;

  for (i = 0, len = tokens.length; i < len; i++) {
    type = tokens[i].type;

    if (type === 'inline') {
      result += this.renderInline(tokens[i].children, options, env);
    } else if (typeof rules[type] !== 'undefined') {
      result += rules[tokens[i].type](tokens, i, options, env, this);
    } else {
      result += this.renderToken(tokens, i, options, env);
    }
  }

  return result;
};

module.exports = Renderer;


/***/ }),

/***/ 81284:
/***/ ((module) => {

"use strict";
/**
 * class Ruler
 *
 * Helper class, used by [[MarkdownIt#core]], [[MarkdownIt#block]] and
 * [[MarkdownIt#inline]] to manage sequences of functions (rules):
 *
 * - keep rules in defined order
 * - assign the name to each rule
 * - enable/disable rules
 * - add/replace rules
 * - allow assign rules to additional named chains (in the same)
 * - cacheing lists of active rules
 *
 * You will not need use this class directly until write plugins. For simple
 * rules control use [[MarkdownIt.disable]], [[MarkdownIt.enable]] and
 * [[MarkdownIt.use]].
 **/



/**
 * new Ruler()
 **/
function Ruler() {
  // List of added rules. Each element is:
  //
  // {
  //   name: XXX,
  //   enabled: Boolean,
  //   fn: Function(),
  //   alt: [ name2, name3 ]
  // }
  //
  this.__rules__ = [];

  // Cached rule chains.
  //
  // First level - chain name, '' for default.
  // Second level - diginal anchor for fast filtering by charcodes.
  //
  this.__cache__ = null;
}

////////////////////////////////////////////////////////////////////////////////
// Helper methods, should not be used directly


// Find rule index by name
//
Ruler.prototype.__find__ = function (name) {
  for (var i = 0; i < this.__rules__.length; i++) {
    if (this.__rules__[i].name === name) {
      return i;
    }
  }
  return -1;
};


// Build rules lookup cache
//
Ruler.prototype.__compile__ = function () {
  var self = this;
  var chains = [ '' ];

  // collect unique names
  self.__rules__.forEach(function (rule) {
    if (!rule.enabled) { return; }

    rule.alt.forEach(function (altName) {
      if (chains.indexOf(altName) < 0) {
        chains.push(altName);
      }
    });
  });

  self.__cache__ = {};

  chains.forEach(function (chain) {
    self.__cache__[chain] = [];
    self.__rules__.forEach(function (rule) {
      if (!rule.enabled) { return; }

      if (chain && rule.alt.indexOf(chain) < 0) { return; }

      self.__cache__[chain].push(rule.fn);
    });
  });
};


/**
 * Ruler.at(name, fn [, options])
 * - name (String): rule name to replace.
 * - fn (Function): new rule function.
 * - options (Object): new rule options (not mandatory).
 *
 * Replace rule by name with new function & options. Throws error if name not
 * found.
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * Replace existing typographer replacement rule with new one:
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.core.ruler.at('replacements', function replace(state) {
 *   //...
 * });
 * ```
 **/
Ruler.prototype.at = function (name, fn, options) {
  var index = this.__find__(name);
  var opt = options || {};

  if (index === -1) { throw new Error('Parser rule not found: ' + name); }

  this.__rules__[index].fn = fn;
  this.__rules__[index].alt = opt.alt || [];
  this.__cache__ = null;
};


/**
 * Ruler.before(beforeName, ruleName, fn [, options])
 * - beforeName (String): new rule will be added before this one.
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Add new rule to chain before one with given name. See also
 * [[Ruler.after]], [[Ruler.push]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.block.ruler.before('paragraph', 'my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/
Ruler.prototype.before = function (beforeName, ruleName, fn, options) {
  var index = this.__find__(beforeName);
  var opt = options || {};

  if (index === -1) { throw new Error('Parser rule not found: ' + beforeName); }

  this.__rules__.splice(index, 0, {
    name: ruleName,
    enabled: true,
    fn: fn,
    alt: opt.alt || []
  });

  this.__cache__ = null;
};


/**
 * Ruler.after(afterName, ruleName, fn [, options])
 * - afterName (String): new rule will be added after this one.
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Add new rule to chain after one with given name. See also
 * [[Ruler.before]], [[Ruler.push]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.inline.ruler.after('text', 'my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/
Ruler.prototype.after = function (afterName, ruleName, fn, options) {
  var index = this.__find__(afterName);
  var opt = options || {};

  if (index === -1) { throw new Error('Parser rule not found: ' + afterName); }

  this.__rules__.splice(index + 1, 0, {
    name: ruleName,
    enabled: true,
    fn: fn,
    alt: opt.alt || []
  });

  this.__cache__ = null;
};

/**
 * Ruler.push(ruleName, fn [, options])
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Push new rule to the end of chain. See also
 * [[Ruler.before]], [[Ruler.after]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.core.ruler.push('my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/
Ruler.prototype.push = function (ruleName, fn, options) {
  var opt = options || {};

  this.__rules__.push({
    name: ruleName,
    enabled: true,
    fn: fn,
    alt: opt.alt || []
  });

  this.__cache__ = null;
};


/**
 * Ruler.enable(list [, ignoreInvalid]) -> Array
 * - list (String|Array): list of rule names to enable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable rules with given names. If any rule name not found - throw Error.
 * Errors can be disabled by second param.
 *
 * Returns list of found rule names (if no exception happened).
 *
 * See also [[Ruler.disable]], [[Ruler.enableOnly]].
 **/
Ruler.prototype.enable = function (list, ignoreInvalid) {
  if (!Array.isArray(list)) { list = [ list ]; }

  var result = [];

  // Search by name and enable
  list.forEach(function (name) {
    var idx = this.__find__(name);

    if (idx < 0) {
      if (ignoreInvalid) { return; }
      throw new Error('Rules manager: invalid rule name ' + name);
    }
    this.__rules__[idx].enabled = true;
    result.push(name);
  }, this);

  this.__cache__ = null;
  return result;
};


/**
 * Ruler.enableOnly(list [, ignoreInvalid])
 * - list (String|Array): list of rule names to enable (whitelist).
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable rules with given names, and disable everything else. If any rule name
 * not found - throw Error. Errors can be disabled by second param.
 *
 * See also [[Ruler.disable]], [[Ruler.enable]].
 **/
Ruler.prototype.enableOnly = function (list, ignoreInvalid) {
  if (!Array.isArray(list)) { list = [ list ]; }

  this.__rules__.forEach(function (rule) { rule.enabled = false; });

  this.enable(list, ignoreInvalid);
};


/**
 * Ruler.disable(list [, ignoreInvalid]) -> Array
 * - list (String|Array): list of rule names to disable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Disable rules with given names. If any rule name not found - throw Error.
 * Errors can be disabled by second param.
 *
 * Returns list of found rule names (if no exception happened).
 *
 * See also [[Ruler.enable]], [[Ruler.enableOnly]].
 **/
Ruler.prototype.disable = function (list, ignoreInvalid) {
  if (!Array.isArray(list)) { list = [ list ]; }

  var result = [];

  // Search by name and disable
  list.forEach(function (name) {
    var idx = this.__find__(name);

    if (idx < 0) {
      if (ignoreInvalid) { return; }
      throw new Error('Rules manager: invalid rule name ' + name);
    }
    this.__rules__[idx].enabled = false;
    result.push(name);
  }, this);

  this.__cache__ = null;
  return result;
};


/**
 * Ruler.getRules(chainName) -> Array
 *
 * Return array of active functions (rules) for given chain name. It analyzes
 * rules configuration, compiles caches if not exists and returns result.
 *
 * Default chain name is `''` (empty string). It can't be skipped. That's
 * done intentionally, to keep signature monomorphic for high speed.
 **/
Ruler.prototype.getRules = function (chainName) {
  if (this.__cache__ === null) {
    this.__compile__();
  }

  // Chain can be empty, if rules disabled. But we still have to return Array.
  return this.__cache__[chainName] || [];
};

module.exports = Ruler;


/***/ }),

/***/ 74599:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Block quotes



var isSpace = (__webpack_require__(26212).isSpace);


module.exports = function blockquote(state, startLine, endLine, silent) {
  var adjustTab,
      ch,
      i,
      initial,
      l,
      lastLineEmpty,
      lines,
      nextLine,
      offset,
      oldBMarks,
      oldBSCount,
      oldIndent,
      oldParentType,
      oldSCount,
      oldTShift,
      spaceAfterMarker,
      terminate,
      terminatorRules,
      token,
      isOutdented,
      oldLineMax = state.lineMax,
      pos = state.bMarks[startLine] + state.tShift[startLine],
      max = state.eMarks[startLine];

  // if it's indented more than 3 spaces, it should be a code block
  if (state.sCount[startLine] - state.blkIndent >= 4) { return false; }

  // check the block quote marker
  if (state.src.charCodeAt(pos++) !== 0x3E/* > */) { return false; }

  // we know that it's going to be a valid blockquote,
  // so no point trying to find the end of it in silent mode
  if (silent) { return true; }

  // set offset past spaces and ">"
  initial = offset = state.sCount[startLine] + 1;

  // skip one optional space after '>'
  if (state.src.charCodeAt(pos) === 0x20 /* space */) {
    // ' >   test '
    //     ^ -- position start of line here:
    pos++;
    initial++;
    offset++;
    adjustTab = false;
    spaceAfterMarker = true;
  } else if (state.src.charCodeAt(pos) === 0x09 /* tab */) {
    spaceAfterMarker = true;

    if ((state.bsCount[startLine] + offset) % 4 === 3) {
      // '  >\t  test '
      //       ^ -- position start of line here (tab has width===1)
      pos++;
      initial++;
      offset++;
      adjustTab = false;
    } else {
      // ' >\t  test '
      //    ^ -- position start of line here + shift bsCount slightly
      //         to make extra space appear
      adjustTab = true;
    }
  } else {
    spaceAfterMarker = false;
  }

  oldBMarks = [ state.bMarks[startLine] ];
  state.bMarks[startLine] = pos;

  while (pos < max) {
    ch = state.src.charCodeAt(pos);

    if (isSpace(ch)) {
      if (ch === 0x09) {
        offset += 4 - (offset + state.bsCount[startLine] + (adjustTab ? 1 : 0)) % 4;
      } else {
        offset++;
      }
    } else {
      break;
    }

    pos++;
  }

  oldBSCount = [ state.bsCount[startLine] ];
  state.bsCount[startLine] = state.sCount[startLine] + 1 + (spaceAfterMarker ? 1 : 0);

  lastLineEmpty = pos >= max;

  oldSCount = [ state.sCount[startLine] ];
  state.sCount[startLine] = offset - initial;

  oldTShift = [ state.tShift[startLine] ];
  state.tShift[startLine] = pos - state.bMarks[startLine];

  terminatorRules = state.md.block.ruler.getRules('blockquote');

  oldParentType = state.parentType;
  state.parentType = 'blockquote';

  // Search the end of the block
  //
  // Block ends with either:
  //  1. an empty line outside:
  //     ```
  //     > test
  //
  //     ```
  //  2. an empty line inside:
  //     ```
  //     >
  //     test
  //     ```
  //  3. another tag:
  //     ```
  //     > test
  //      - - -
  //     ```
  for (nextLine = startLine + 1; nextLine < endLine; nextLine++) {
    // check if it's outdented, i.e. it's inside list item and indented
    // less than said list item:
    //
    // ```
    // 1. anything
    //    > current blockquote
    // 2. checking this line
    // ```
    isOutdented = state.sCount[nextLine] < state.blkIndent;

    pos = state.bMarks[nextLine] + state.tShift[nextLine];
    max = state.eMarks[nextLine];

    if (pos >= max) {
      // Case 1: line is not inside the blockquote, and this line is empty.
      break;
    }

    if (state.src.charCodeAt(pos++) === 0x3E/* > */ && !isOutdented) {
      // This line is inside the blockquote.

      // set offset past spaces and ">"
      initial = offset = state.sCount[nextLine] + 1;

      // skip one optional space after '>'
      if (state.src.charCodeAt(pos) === 0x20 /* space */) {
        // ' >   test '
        //     ^ -- position start of line here:
        pos++;
        initial++;
        offset++;
        adjustTab = false;
        spaceAfterMarker = true;
      } else if (state.src.charCodeAt(pos) === 0x09 /* tab */) {
        spaceAfterMarker = true;

        if ((state.bsCount[nextLine] + offset) % 4 === 3) {
          // '  >\t  test '
          //       ^ -- position start of line here (tab has width===1)
          pos++;
          initial++;
          offset++;
          adjustTab = false;
        } else {
          // ' >\t  test '
          //    ^ -- position start of line here + shift bsCount slightly
          //         to make extra space appear
          adjustTab = true;
        }
      } else {
        spaceAfterMarker = false;
      }

      oldBMarks.push(state.bMarks[nextLine]);
      state.bMarks[nextLine] = pos;

      while (pos < max) {
        ch = state.src.charCodeAt(pos);

        if (isSpace(ch)) {
          if (ch === 0x09) {
            offset += 4 - (offset + state.bsCount[nextLine] + (adjustTab ? 1 : 0)) % 4;
          } else {
            offset++;
          }
        } else {
          break;
        }

        pos++;
      }

      lastLineEmpty = pos >= max;

      oldBSCount.push(state.bsCount[nextLine]);
      state.bsCount[nextLine] = state.sCount[nextLine] + 1 + (spaceAfterMarker ? 1 : 0);

      oldSCount.push(state.sCount[nextLine]);
      state.sCount[nextLine] = offset - initial;

      oldTShift.push(state.tShift[nextLine]);
      state.tShift[nextLine] = pos - state.bMarks[nextLine];
      continue;
    }

    // Case 2: line is not inside the blockquote, and the last line was empty.
    if (lastLineEmpty) { break; }

    // Case 3: another tag found.
    terminate = false;
    for (i = 0, l = terminatorRules.length; i < l; i++) {
      if (terminatorRules[i](state, nextLine, endLine, true)) {
        terminate = true;
        break;
      }
    }

    if (terminate) {
      // Quirk to enforce "hard termination mode" for paragraphs;
      // normally if you call `tokenize(state, startLine, nextLine)`,
      // paragraphs will look below nextLine for paragraph continuation,
      // but if blockquote is terminated by another tag, they shouldn't
      state.lineMax = nextLine;

      if (state.blkIndent !== 0) {
        // state.blkIndent was non-zero, we now set it to zero,
        // so we need to re-calculate all offsets to appear as
        // if indent wasn't changed
        oldBMarks.push(state.bMarks[nextLine]);
        oldBSCount.push(state.bsCount[nextLine]);
        oldTShift.push(state.tShift[nextLine]);
        oldSCount.push(state.sCount[nextLine]);
        state.sCount[nextLine] -= state.blkIndent;
      }

      break;
    }

    oldBMarks.push(state.bMarks[nextLine]);
    oldBSCount.push(state.bsCount[nextLine]);
    oldTShift.push(state.tShift[nextLine]);
    oldSCount.push(state.sCount[nextLine]);

    // A negative indentation means that this is a paragraph continuation
    //
    state.sCount[nextLine] = -1;
  }

  oldIndent = state.blkIndent;
  state.blkIndent = 0;

  token        = state.push('blockquote_open', 'blockquote', 1);
  token.markup = '>';
  token.map    = lines = [ startLine, 0 ];

  state.md.block.tokenize(state, startLine, nextLine);

  token        = state.push('blockquote_close', 'blockquote', -1);
  token.markup = '>';

  state.lineMax = oldLineMax;
  state.parentType = oldParentType;
  lines[1] = state.line;

  // Restore original tShift; this might not be necessary since the parser
  // has already been here, but just to make sure we can do that.
  for (i = 0; i < oldTShift.length; i++) {
    state.bMarks[i + startLine] = oldBMarks[i];
    state.tShift[i + startLine] = oldTShift[i];
    state.sCount[i + startLine] = oldSCount[i];
    state.bsCount[i + startLine] = oldBSCount[i];
  }
  state.blkIndent = oldIndent;

  return true;
};


/***/ }),

/***/ 60148:
/***/ ((module) => {

"use strict";
// Code block (4 spaces padded)




module.exports = function code(state, startLine, endLine/*, silent*/) {
  var nextLine, last, token;

  if (state.sCount[startLine] - state.blkIndent < 4) { return false; }

  last = nextLine = startLine + 1;

  while (nextLine < endLine) {
    if (state.isEmpty(nextLine)) {
      nextLine++;
      continue;
    }

    if (state.sCount[nextLine] - state.blkIndent >= 4) {
      nextLine++;
      last = nextLine;
      continue;
    }
    break;
  }

  state.line = last;

  token         = state.push('code_block', 'code', 0);
  token.content = state.getLines(startLine, last, 4 + state.blkIndent, false) + '\n';
  token.map     = [ startLine, state.line ];

  return true;
};


/***/ }),

/***/ 10130:
/***/ ((module) => {

"use strict";
// fences (``` lang, ~~~ lang)




module.exports = function fence(state, startLine, endLine, silent) {
  var marker, len, params, nextLine, mem, token, markup,
      haveEndMarker = false,
      pos = state.bMarks[startLine] + state.tShift[startLine],
      max = state.eMarks[startLine];

  // if it's indented more than 3 spaces, it should be a code block
  if (state.sCount[startLine] - state.blkIndent >= 4) { return false; }

  if (pos + 3 > max) { return false; }

  marker = state.src.charCodeAt(pos);

  if (marker !== 0x7E/* ~ */ && marker !== 0x60 /* ` */) {
    return false;
  }

  // scan marker length
  mem = pos;
  pos = state.skipChars(pos, marker);

  len = pos - mem;

  if (len < 3) { return false; }

  markup = state.src.slice(mem, pos);
  params = state.src.slice(pos, max);

  if (marker === 0x60 /* ` */) {
    if (params.indexOf(String.fromCharCode(marker)) >= 0) {
      return false;
    }
  }

  // Since start is found, we can report success here in validation mode
  if (silent) { return true; }

  // search end of block
  nextLine = startLine;

  for (;;) {
    nextLine++;
    if (nextLine >= endLine) {
      // unclosed block should be autoclosed by end of document.
      // also block seems to be autoclosed by end of parent
      break;
    }

    pos = mem = state.bMarks[nextLine] + state.tShift[nextLine];
    max = state.eMarks[nextLine];

    if (pos < max && state.sCount[nextLine] < state.blkIndent) {
      // non-empty line with negative indent should stop the list:
      // - ```
      //  test
      break;
    }

    if (state.src.charCodeAt(pos) !== marker) { continue; }

    if (state.sCount[nextLine] - state.blkIndent >= 4) {
      // closing fence should be indented less than 4 spaces
      continue;
    }

    pos = state.skipChars(pos, marker);

    // closing code fence must be at least as long as the opening one
    if (pos - mem < len) { continue; }

    // make sure tail has spaces only
    pos = state.skipSpaces(pos);

    if (pos < max) { continue; }

    haveEndMarker = true;
    // found!
    break;
  }

  // If a fence has heading spaces, they should be removed from its inner block
  len = state.sCount[startLine];

  state.line = nextLine + (haveEndMarker ? 1 : 0);

  token         = state.push('fence', 'code', 0);
  token.info    = params;
  token.content = state.getLines(startLine + 1, nextLine, len, true);
  token.markup  = markup;
  token.map     = [ startLine, state.line ];

  return true;
};


/***/ }),

/***/ 40899:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// heading (#, ##, ...)



var isSpace = (__webpack_require__(26212).isSpace);


module.exports = function heading(state, startLine, endLine, silent) {
  var ch, level, tmp, token,
      pos = state.bMarks[startLine] + state.tShift[startLine],
      max = state.eMarks[startLine];

  // if it's indented more than 3 spaces, it should be a code block
  if (state.sCount[startLine] - state.blkIndent >= 4) { return false; }

  ch  = state.src.charCodeAt(pos);

  if (ch !== 0x23/* # */ || pos >= max) { return false; }

  // count heading level
  level = 1;
  ch = state.src.charCodeAt(++pos);
  while (ch === 0x23/* # */ && pos < max && level <= 6) {
    level++;
    ch = state.src.charCodeAt(++pos);
  }

  if (level > 6 || (pos < max && !isSpace(ch))) { return false; }

  if (silent) { return true; }

  // Let's cut tails like '    ###  ' from the end of string

  max = state.skipSpacesBack(max, pos);
  tmp = state.skipCharsBack(max, 0x23, pos); // #
  if (tmp > pos && isSpace(state.src.charCodeAt(tmp - 1))) {
    max = tmp;
  }

  state.line = startLine + 1;

  token        = state.push('heading_open', 'h' + String(level), 1);
  token.markup = '########'.slice(0, level);
  token.map    = [ startLine, state.line ];

  token          = state.push('inline', '', 0);
  token.content  = state.src.slice(pos, max).trim();
  token.map      = [ startLine, state.line ];
  token.children = [];

  token        = state.push('heading_close', 'h' + String(level), -1);
  token.markup = '########'.slice(0, level);

  return true;
};


/***/ }),

/***/ 17242:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Horizontal rule



var isSpace = (__webpack_require__(26212).isSpace);


module.exports = function hr(state, startLine, endLine, silent) {
  var marker, cnt, ch, token,
      pos = state.bMarks[startLine] + state.tShift[startLine],
      max = state.eMarks[startLine];

  // if it's indented more than 3 spaces, it should be a code block
  if (state.sCount[startLine] - state.blkIndent >= 4) { return false; }

  marker = state.src.charCodeAt(pos++);

  // Check hr marker
  if (marker !== 0x2A/* * */ &&
      marker !== 0x2D/* - */ &&
      marker !== 0x5F/* _ */) {
    return false;
  }

  // markers can be mixed with spaces, but there should be at least 3 of them

  cnt = 1;
  while (pos < max) {
    ch = state.src.charCodeAt(pos++);
    if (ch !== marker && !isSpace(ch)) { return false; }
    if (ch === marker) { cnt++; }
  }

  if (cnt < 3) { return false; }

  if (silent) { return true; }

  state.line = startLine + 1;

  token        = state.push('hr', 'hr', 0);
  token.map    = [ startLine, state.line ];
  token.markup = Array(cnt + 1).join(String.fromCharCode(marker));

  return true;
};


/***/ }),

/***/ 29690:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// HTML block




var block_names = __webpack_require__(57932);
var HTML_OPEN_CLOSE_TAG_RE = (__webpack_require__(26517)/* .HTML_OPEN_CLOSE_TAG_RE */ .q);

// An array of opening and corresponding closing sequences for html tags,
// last argument defines whether it can terminate a paragraph or not
//
var HTML_SEQUENCES = [
  [ /^<(script|pre|style|textarea)(?=(\s|>|$))/i, /<\/(script|pre|style|textarea)>/i, true ],
  [ /^<!--/,        /-->/,   true ],
  [ /^<\?/,         /\?>/,   true ],
  [ /^<![A-Z]/,     />/,     true ],
  [ /^<!\[CDATA\[/, /\]\]>/, true ],
  [ new RegExp('^</?(' + block_names.join('|') + ')(?=(\\s|/?>|$))', 'i'), /^$/, true ],
  [ new RegExp(HTML_OPEN_CLOSE_TAG_RE.source + '\\s*$'),  /^$/, false ]
];


module.exports = function html_block(state, startLine, endLine, silent) {
  var i, nextLine, token, lineText,
      pos = state.bMarks[startLine] + state.tShift[startLine],
      max = state.eMarks[startLine];

  // if it's indented more than 3 spaces, it should be a code block
  if (state.sCount[startLine] - state.blkIndent >= 4) { return false; }

  if (!state.md.options.html) { return false; }

  if (state.src.charCodeAt(pos) !== 0x3C/* < */) { return false; }

  lineText = state.src.slice(pos, max);

  for (i = 0; i < HTML_SEQUENCES.length; i++) {
    if (HTML_SEQUENCES[i][0].test(lineText)) { break; }
  }

  if (i === HTML_SEQUENCES.length) { return false; }

  if (silent) {
    // true if this sequence can be a terminator, false otherwise
    return HTML_SEQUENCES[i][2];
  }

  nextLine = startLine + 1;

  // If we are here - we detected HTML block.
  // Let's roll down till block end.
  if (!HTML_SEQUENCES[i][1].test(lineText)) {
    for (; nextLine < endLine; nextLine++) {
      if (state.sCount[nextLine] < state.blkIndent) { break; }

      pos = state.bMarks[nextLine] + state.tShift[nextLine];
      max = state.eMarks[nextLine];
      lineText = state.src.slice(pos, max);

      if (HTML_SEQUENCES[i][1].test(lineText)) {
        if (lineText.length !== 0) { nextLine++; }
        break;
      }
    }
  }

  state.line = nextLine;

  token         = state.push('html_block', '', 0);
  token.map     = [ startLine, nextLine ];
  token.content = state.getLines(startLine, nextLine, state.blkIndent, true);

  return true;
};


/***/ }),

/***/ 76091:
/***/ ((module) => {

"use strict";
// lheading (---, ===)




module.exports = function lheading(state, startLine, endLine/*, silent*/) {
  var content, terminate, i, l, token, pos, max, level, marker,
      nextLine = startLine + 1, oldParentType,
      terminatorRules = state.md.block.ruler.getRules('paragraph');

  // if it's indented more than 3 spaces, it should be a code block
  if (state.sCount[startLine] - state.blkIndent >= 4) { return false; }

  oldParentType = state.parentType;
  state.parentType = 'paragraph'; // use paragraph to match terminatorRules

  // jump line-by-line until empty one or EOF
  for (; nextLine < endLine && !state.isEmpty(nextLine); nextLine++) {
    // this would be a code block normally, but after paragraph
    // it's considered a lazy continuation regardless of what's there
    if (state.sCount[nextLine] - state.blkIndent > 3) { continue; }

    //
    // Check for underline in setext header
    //
    if (state.sCount[nextLine] >= state.blkIndent) {
      pos = state.bMarks[nextLine] + state.tShift[nextLine];
      max = state.eMarks[nextLine];

      if (pos < max) {
        marker = state.src.charCodeAt(pos);

        if (marker === 0x2D/* - */ || marker === 0x3D/* = */) {
          pos = state.skipChars(pos, marker);
          pos = state.skipSpaces(pos);

          if (pos >= max) {
            level = (marker === 0x3D/* = */ ? 1 : 2);
            break;
          }
        }
      }
    }

    // quirk for blockquotes, this line should already be checked by that rule
    if (state.sCount[nextLine] < 0) { continue; }

    // Some tags can terminate paragraph without empty line.
    terminate = false;
    for (i = 0, l = terminatorRules.length; i < l; i++) {
      if (terminatorRules[i](state, nextLine, endLine, true)) {
        terminate = true;
        break;
      }
    }
    if (terminate) { break; }
  }

  if (!level) {
    // Didn't find valid underline
    return false;
  }

  content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();

  state.line = nextLine + 1;

  token          = state.push('heading_open', 'h' + String(level), 1);
  token.markup   = String.fromCharCode(marker);
  token.map      = [ startLine, state.line ];

  token          = state.push('inline', '', 0);
  token.content  = content;
  token.map      = [ startLine, state.line - 1 ];
  token.children = [];

  token          = state.push('heading_close', 'h' + String(level), -1);
  token.markup   = String.fromCharCode(marker);

  state.parentType = oldParentType;

  return true;
};


/***/ }),

/***/ 3557:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Lists



var isSpace = (__webpack_require__(26212).isSpace);


// Search `[-+*][\n ]`, returns next pos after marker on success
// or -1 on fail.
function skipBulletListMarker(state, startLine) {
  var marker, pos, max, ch;

  pos = state.bMarks[startLine] + state.tShift[startLine];
  max = state.eMarks[startLine];

  marker = state.src.charCodeAt(pos++);
  // Check bullet
  if (marker !== 0x2A/* * */ &&
      marker !== 0x2D/* - */ &&
      marker !== 0x2B/* + */) {
    return -1;
  }

  if (pos < max) {
    ch = state.src.charCodeAt(pos);

    if (!isSpace(ch)) {
      // " -test " - is not a list item
      return -1;
    }
  }

  return pos;
}

// Search `\d+[.)][\n ]`, returns next pos after marker on success
// or -1 on fail.
function skipOrderedListMarker(state, startLine) {
  var ch,
      start = state.bMarks[startLine] + state.tShift[startLine],
      pos = start,
      max = state.eMarks[startLine];

  // List marker should have at least 2 chars (digit + dot)
  if (pos + 1 >= max) { return -1; }

  ch = state.src.charCodeAt(pos++);

  if (ch < 0x30/* 0 */ || ch > 0x39/* 9 */) { return -1; }

  for (;;) {
    // EOL -> fail
    if (pos >= max) { return -1; }

    ch = state.src.charCodeAt(pos++);

    if (ch >= 0x30/* 0 */ && ch <= 0x39/* 9 */) {

      // List marker should have no more than 9 digits
      // (prevents integer overflow in browsers)
      if (pos - start >= 10) { return -1; }

      continue;
    }

    // found valid marker
    if (ch === 0x29/* ) */ || ch === 0x2e/* . */) {
      break;
    }

    return -1;
  }


  if (pos < max) {
    ch = state.src.charCodeAt(pos);

    if (!isSpace(ch)) {
      // " 1.test " - is not a list item
      return -1;
    }
  }
  return pos;
}

function markTightParagraphs(state, idx) {
  var i, l,
      level = state.level + 2;

  for (i = idx + 2, l = state.tokens.length - 2; i < l; i++) {
    if (state.tokens[i].level === level && state.tokens[i].type === 'paragraph_open') {
      state.tokens[i + 2].hidden = true;
      state.tokens[i].hidden = true;
      i += 2;
    }
  }
}


module.exports = function list(state, startLine, endLine, silent) {
  var ch,
      contentStart,
      i,
      indent,
      indentAfterMarker,
      initial,
      isOrdered,
      itemLines,
      l,
      listLines,
      listTokIdx,
      markerCharCode,
      markerValue,
      max,
      nextLine,
      offset,
      oldListIndent,
      oldParentType,
      oldSCount,
      oldTShift,
      oldTight,
      pos,
      posAfterMarker,
      prevEmptyEnd,
      start,
      terminate,
      terminatorRules,
      token,
      isTerminatingParagraph = false,
      tight = true;

  // if it's indented more than 3 spaces, it should be a code block
  if (state.sCount[startLine] - state.blkIndent >= 4) { return false; }

  // Special case:
  //  - item 1
  //   - item 2
  //    - item 3
  //     - item 4
  //      - this one is a paragraph continuation
  if (state.listIndent >= 0 &&
      state.sCount[startLine] - state.listIndent >= 4 &&
      state.sCount[startLine] < state.blkIndent) {
    return false;
  }

  // limit conditions when list can interrupt
  // a paragraph (validation mode only)
  if (silent && state.parentType === 'paragraph') {
    // Next list item should still terminate previous list item;
    //
    // This code can fail if plugins use blkIndent as well as lists,
    // but I hope the spec gets fixed long before that happens.
    //
    if (state.tShift[startLine] >= state.blkIndent) {
      isTerminatingParagraph = true;
    }
  }

  // Detect list type and position after marker
  if ((posAfterMarker = skipOrderedListMarker(state, startLine)) >= 0) {
    isOrdered = true;
    start = state.bMarks[startLine] + state.tShift[startLine];
    markerValue = Number(state.src.slice(start, posAfterMarker - 1));

    // If we're starting a new ordered list right after
    // a paragraph, it should start with 1.
    if (isTerminatingParagraph && markerValue !== 1) return false;

  } else if ((posAfterMarker = skipBulletListMarker(state, startLine)) >= 0) {
    isOrdered = false;

  } else {
    return false;
  }

  // If we're starting a new unordered list right after
  // a paragraph, first line should not be empty.
  if (isTerminatingParagraph) {
    if (state.skipSpaces(posAfterMarker) >= state.eMarks[startLine]) return false;
  }

  // We should terminate list on style change. Remember first one to compare.
  markerCharCode = state.src.charCodeAt(posAfterMarker - 1);

  // For validation mode we can terminate immediately
  if (silent) { return true; }

  // Start list
  listTokIdx = state.tokens.length;

  if (isOrdered) {
    token       = state.push('ordered_list_open', 'ol', 1);
    if (markerValue !== 1) {
      token.attrs = [ [ 'start', markerValue ] ];
    }

  } else {
    token       = state.push('bullet_list_open', 'ul', 1);
  }

  token.map    = listLines = [ startLine, 0 ];
  token.markup = String.fromCharCode(markerCharCode);

  //
  // Iterate list items
  //

  nextLine = startLine;
  prevEmptyEnd = false;
  terminatorRules = state.md.block.ruler.getRules('list');

  oldParentType = state.parentType;
  state.parentType = 'list';

  while (nextLine < endLine) {
    pos = posAfterMarker;
    max = state.eMarks[nextLine];

    initial = offset = state.sCount[nextLine] + posAfterMarker - (state.bMarks[startLine] + state.tShift[startLine]);

    while (pos < max) {
      ch = state.src.charCodeAt(pos);

      if (ch === 0x09) {
        offset += 4 - (offset + state.bsCount[nextLine]) % 4;
      } else if (ch === 0x20) {
        offset++;
      } else {
        break;
      }

      pos++;
    }

    contentStart = pos;

    if (contentStart >= max) {
      // trimming space in "-    \n  3" case, indent is 1 here
      indentAfterMarker = 1;
    } else {
      indentAfterMarker = offset - initial;
    }

    // If we have more than 4 spaces, the indent is 1
    // (the rest is just indented code block)
    if (indentAfterMarker > 4) { indentAfterMarker = 1; }

    // "  -  test"
    //  ^^^^^ - calculating total length of this thing
    indent = initial + indentAfterMarker;

    // Run subparser & write tokens
    token        = state.push('list_item_open', 'li', 1);
    token.markup = String.fromCharCode(markerCharCode);
    token.map    = itemLines = [ startLine, 0 ];
    if (isOrdered) {
      token.info = state.src.slice(start, posAfterMarker - 1);
    }

    // change current state, then restore it after parser subcall
    oldTight = state.tight;
    oldTShift = state.tShift[startLine];
    oldSCount = state.sCount[startLine];

    //  - example list
    // ^ listIndent position will be here
    //   ^ blkIndent position will be here
    //
    oldListIndent = state.listIndent;
    state.listIndent = state.blkIndent;
    state.blkIndent = indent;

    state.tight = true;
    state.tShift[startLine] = contentStart - state.bMarks[startLine];
    state.sCount[startLine] = offset;

    if (contentStart >= max && state.isEmpty(startLine + 1)) {
      // workaround for this case
      // (list item is empty, list terminates before "foo"):
      // ~~~~~~~~
      //   -
      //
      //     foo
      // ~~~~~~~~
      state.line = Math.min(state.line + 2, endLine);
    } else {
      state.md.block.tokenize(state, startLine, endLine, true);
    }

    // If any of list item is tight, mark list as tight
    if (!state.tight || prevEmptyEnd) {
      tight = false;
    }
    // Item become loose if finish with empty line,
    // but we should filter last element, because it means list finish
    prevEmptyEnd = (state.line - startLine) > 1 && state.isEmpty(state.line - 1);

    state.blkIndent = state.listIndent;
    state.listIndent = oldListIndent;
    state.tShift[startLine] = oldTShift;
    state.sCount[startLine] = oldSCount;
    state.tight = oldTight;

    token        = state.push('list_item_close', 'li', -1);
    token.markup = String.fromCharCode(markerCharCode);

    nextLine = startLine = state.line;
    itemLines[1] = nextLine;
    contentStart = state.bMarks[startLine];

    if (nextLine >= endLine) { break; }

    //
    // Try to check if list is terminated or continued.
    //
    if (state.sCount[nextLine] < state.blkIndent) { break; }

    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) { break; }

    // fail if terminating block found
    terminate = false;
    for (i = 0, l = terminatorRules.length; i < l; i++) {
      if (terminatorRules[i](state, nextLine, endLine, true)) {
        terminate = true;
        break;
      }
    }
    if (terminate) { break; }

    // fail if list has another type
    if (isOrdered) {
      posAfterMarker = skipOrderedListMarker(state, nextLine);
      if (posAfterMarker < 0) { break; }
      start = state.bMarks[nextLine] + state.tShift[nextLine];
    } else {
      posAfterMarker = skipBulletListMarker(state, nextLine);
      if (posAfterMarker < 0) { break; }
    }

    if (markerCharCode !== state.src.charCodeAt(posAfterMarker - 1)) { break; }
  }

  // Finalize list
  if (isOrdered) {
    token = state.push('ordered_list_close', 'ol', -1);
  } else {
    token = state.push('bullet_list_close', 'ul', -1);
  }
  token.markup = String.fromCharCode(markerCharCode);

  listLines[1] = nextLine;
  state.line = nextLine;

  state.parentType = oldParentType;

  // mark paragraphs tight if needed
  if (tight) {
    markTightParagraphs(state, listTokIdx);
  }

  return true;
};


/***/ }),

/***/ 37370:
/***/ ((module) => {

"use strict";
// Paragraph




module.exports = function paragraph(state, startLine/*, endLine*/) {
  var content, terminate, i, l, token, oldParentType,
      nextLine = startLine + 1,
      terminatorRules = state.md.block.ruler.getRules('paragraph'),
      endLine = state.lineMax;

  oldParentType = state.parentType;
  state.parentType = 'paragraph';

  // jump line-by-line until empty one or EOF
  for (; nextLine < endLine && !state.isEmpty(nextLine); nextLine++) {
    // this would be a code block normally, but after paragraph
    // it's considered a lazy continuation regardless of what's there
    if (state.sCount[nextLine] - state.blkIndent > 3) { continue; }

    // quirk for blockquotes, this line should already be checked by that rule
    if (state.sCount[nextLine] < 0) { continue; }

    // Some tags can terminate paragraph without empty line.
    terminate = false;
    for (i = 0, l = terminatorRules.length; i < l; i++) {
      if (terminatorRules[i](state, nextLine, endLine, true)) {
        terminate = true;
        break;
      }
    }
    if (terminate) { break; }
  }

  content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();

  state.line = nextLine;

  token          = state.push('paragraph_open', 'p', 1);
  token.map      = [ startLine, state.line ];

  token          = state.push('inline', '', 0);
  token.content  = content;
  token.map      = [ startLine, state.line ];
  token.children = [];

  token          = state.push('paragraph_close', 'p', -1);

  state.parentType = oldParentType;

  return true;
};


/***/ }),

/***/ 2534:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";



var normalizeReference   = (__webpack_require__(26212).normalizeReference);
var isSpace              = (__webpack_require__(26212).isSpace);


module.exports = function reference(state, startLine, _endLine, silent) {
  var ch,
      destEndPos,
      destEndLineNo,
      endLine,
      href,
      i,
      l,
      label,
      labelEnd,
      oldParentType,
      res,
      start,
      str,
      terminate,
      terminatorRules,
      title,
      lines = 0,
      pos = state.bMarks[startLine] + state.tShift[startLine],
      max = state.eMarks[startLine],
      nextLine = startLine + 1;

  // if it's indented more than 3 spaces, it should be a code block
  if (state.sCount[startLine] - state.blkIndent >= 4) { return false; }

  if (state.src.charCodeAt(pos) !== 0x5B/* [ */) { return false; }

  // Simple check to quickly interrupt scan on [link](url) at the start of line.
  // Can be useful on practice: https://github.com/markdown-it/markdown-it/issues/54
  while (++pos < max) {
    if (state.src.charCodeAt(pos) === 0x5D /* ] */ &&
        state.src.charCodeAt(pos - 1) !== 0x5C/* \ */) {
      if (pos + 1 === max) { return false; }
      if (state.src.charCodeAt(pos + 1) !== 0x3A/* : */) { return false; }
      break;
    }
  }

  endLine = state.lineMax;

  // jump line-by-line until empty one or EOF
  terminatorRules = state.md.block.ruler.getRules('reference');

  oldParentType = state.parentType;
  state.parentType = 'reference';

  for (; nextLine < endLine && !state.isEmpty(nextLine); nextLine++) {
    // this would be a code block normally, but after paragraph
    // it's considered a lazy continuation regardless of what's there
    if (state.sCount[nextLine] - state.blkIndent > 3) { continue; }

    // quirk for blockquotes, this line should already be checked by that rule
    if (state.sCount[nextLine] < 0) { continue; }

    // Some tags can terminate paragraph without empty line.
    terminate = false;
    for (i = 0, l = terminatorRules.length; i < l; i++) {
      if (terminatorRules[i](state, nextLine, endLine, true)) {
        terminate = true;
        break;
      }
    }
    if (terminate) { break; }
  }

  str = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
  max = str.length;

  for (pos = 1; pos < max; pos++) {
    ch = str.charCodeAt(pos);
    if (ch === 0x5B /* [ */) {
      return false;
    } else if (ch === 0x5D /* ] */) {
      labelEnd = pos;
      break;
    } else if (ch === 0x0A /* \n */) {
      lines++;
    } else if (ch === 0x5C /* \ */) {
      pos++;
      if (pos < max && str.charCodeAt(pos) === 0x0A) {
        lines++;
      }
    }
  }

  if (labelEnd < 0 || str.charCodeAt(labelEnd + 1) !== 0x3A/* : */) { return false; }

  // [label]:   destination   'title'
  //         ^^^ skip optional whitespace here
  for (pos = labelEnd + 2; pos < max; pos++) {
    ch = str.charCodeAt(pos);
    if (ch === 0x0A) {
      lines++;
    } else if (isSpace(ch)) {
      /*eslint no-empty:0*/
    } else {
      break;
    }
  }

  // [label]:   destination   'title'
  //            ^^^^^^^^^^^ parse this
  res = state.md.helpers.parseLinkDestination(str, pos, max);
  if (!res.ok) { return false; }

  href = state.md.normalizeLink(res.str);
  if (!state.md.validateLink(href)) { return false; }

  pos = res.pos;
  lines += res.lines;

  // save cursor state, we could require to rollback later
  destEndPos = pos;
  destEndLineNo = lines;

  // [label]:   destination   'title'
  //                       ^^^ skipping those spaces
  start = pos;
  for (; pos < max; pos++) {
    ch = str.charCodeAt(pos);
    if (ch === 0x0A) {
      lines++;
    } else if (isSpace(ch)) {
      /*eslint no-empty:0*/
    } else {
      break;
    }
  }

  // [label]:   destination   'title'
  //                          ^^^^^^^ parse this
  res = state.md.helpers.parseLinkTitle(str, pos, max);
  if (pos < max && start !== pos && res.ok) {
    title = res.str;
    pos = res.pos;
    lines += res.lines;
  } else {
    title = '';
    pos = destEndPos;
    lines = destEndLineNo;
  }

  // skip trailing spaces until the rest of the line
  while (pos < max) {
    ch = str.charCodeAt(pos);
    if (!isSpace(ch)) { break; }
    pos++;
  }

  if (pos < max && str.charCodeAt(pos) !== 0x0A) {
    if (title) {
      // garbage at the end of the line after title,
      // but it could still be a valid reference if we roll back
      title = '';
      pos = destEndPos;
      lines = destEndLineNo;
      while (pos < max) {
        ch = str.charCodeAt(pos);
        if (!isSpace(ch)) { break; }
        pos++;
      }
    }
  }

  if (pos < max && str.charCodeAt(pos) !== 0x0A) {
    // garbage at the end of the line
    return false;
  }

  label = normalizeReference(str.slice(1, labelEnd));
  if (!label) {
    // CommonMark 0.20 disallows empty labels
    return false;
  }

  // Reference can not terminate anything. This check is for safety only.
  /*istanbul ignore if*/
  if (silent) { return true; }

  if (typeof state.env.references === 'undefined') {
    state.env.references = {};
  }
  if (typeof state.env.references[label] === 'undefined') {
    state.env.references[label] = { title: title, href: href };
  }

  state.parentType = oldParentType;

  state.line = startLine + lines + 1;
  return true;
};


/***/ }),

/***/ 49677:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Parser state class



var Token = __webpack_require__(98114);
var isSpace = (__webpack_require__(26212).isSpace);


function StateBlock(src, md, env, tokens) {
  var ch, s, start, pos, len, indent, offset, indent_found;

  this.src = src;

  // link to parser instance
  this.md     = md;

  this.env = env;

  //
  // Internal state vartiables
  //

  this.tokens = tokens;

  this.bMarks = [];  // line begin offsets for fast jumps
  this.eMarks = [];  // line end offsets for fast jumps
  this.tShift = [];  // offsets of the first non-space characters (tabs not expanded)
  this.sCount = [];  // indents for each line (tabs expanded)

  // An amount of virtual spaces (tabs expanded) between beginning
  // of each line (bMarks) and real beginning of that line.
  //
  // It exists only as a hack because blockquotes override bMarks
  // losing information in the process.
  //
  // It's used only when expanding tabs, you can think about it as
  // an initial tab length, e.g. bsCount=21 applied to string `\t123`
  // means first tab should be expanded to 4-21%4 === 3 spaces.
  //
  this.bsCount = [];

  // block parser variables
  this.blkIndent  = 0; // required block content indent (for example, if we are
                       // inside a list, it would be positioned after list marker)
  this.line       = 0; // line index in src
  this.lineMax    = 0; // lines count
  this.tight      = false;  // loose/tight mode for lists
  this.ddIndent   = -1; // indent of the current dd block (-1 if there isn't any)
  this.listIndent = -1; // indent of the current list block (-1 if there isn't any)

  // can be 'blockquote', 'list', 'root', 'paragraph' or 'reference'
  // used in lists to determine if they interrupt a paragraph
  this.parentType = 'root';

  this.level = 0;

  // renderer
  this.result = '';

  // Create caches
  // Generate markers.
  s = this.src;
  indent_found = false;

  for (start = pos = indent = offset = 0, len = s.length; pos < len; pos++) {
    ch = s.charCodeAt(pos);

    if (!indent_found) {
      if (isSpace(ch)) {
        indent++;

        if (ch === 0x09) {
          offset += 4 - offset % 4;
        } else {
          offset++;
        }
        continue;
      } else {
        indent_found = true;
      }
    }

    if (ch === 0x0A || pos === len - 1) {
      if (ch !== 0x0A) { pos++; }
      this.bMarks.push(start);
      this.eMarks.push(pos);
      this.tShift.push(indent);
      this.sCount.push(offset);
      this.bsCount.push(0);

      indent_found = false;
      indent = 0;
      offset = 0;
      start = pos + 1;
    }
  }

  // Push fake entry to simplify cache bounds checks
  this.bMarks.push(s.length);
  this.eMarks.push(s.length);
  this.tShift.push(0);
  this.sCount.push(0);
  this.bsCount.push(0);

  this.lineMax = this.bMarks.length - 1; // don't count last fake line
}

// Push new token to "stream".
//
StateBlock.prototype.push = function (type, tag, nesting) {
  var token = new Token(type, tag, nesting);
  token.block = true;

  if (nesting < 0) this.level--; // closing tag
  token.level = this.level;
  if (nesting > 0) this.level++; // opening tag

  this.tokens.push(token);
  return token;
};

StateBlock.prototype.isEmpty = function isEmpty(line) {
  return this.bMarks[line] + this.tShift[line] >= this.eMarks[line];
};

StateBlock.prototype.skipEmptyLines = function skipEmptyLines(from) {
  for (var max = this.lineMax; from < max; from++) {
    if (this.bMarks[from] + this.tShift[from] < this.eMarks[from]) {
      break;
    }
  }
  return from;
};

// Skip spaces from given position.
StateBlock.prototype.skipSpaces = function skipSpaces(pos) {
  var ch;

  for (var max = this.src.length; pos < max; pos++) {
    ch = this.src.charCodeAt(pos);
    if (!isSpace(ch)) { break; }
  }
  return pos;
};

// Skip spaces from given position in reverse.
StateBlock.prototype.skipSpacesBack = function skipSpacesBack(pos, min) {
  if (pos <= min) { return pos; }

  while (pos > min) {
    if (!isSpace(this.src.charCodeAt(--pos))) { return pos + 1; }
  }
  return pos;
};

// Skip char codes from given position
StateBlock.prototype.skipChars = function skipChars(pos, code) {
  for (var max = this.src.length; pos < max; pos++) {
    if (this.src.charCodeAt(pos) !== code) { break; }
  }
  return pos;
};

// Skip char codes reverse from given position - 1
StateBlock.prototype.skipCharsBack = function skipCharsBack(pos, code, min) {
  if (pos <= min) { return pos; }

  while (pos > min) {
    if (code !== this.src.charCodeAt(--pos)) { return pos + 1; }
  }
  return pos;
};

// cut lines range from source.
StateBlock.prototype.getLines = function getLines(begin, end, indent, keepLastLF) {
  var i, lineIndent, ch, first, last, queue, lineStart,
      line = begin;

  if (begin >= end) {
    return '';
  }

  queue = new Array(end - begin);

  for (i = 0; line < end; line++, i++) {
    lineIndent = 0;
    lineStart = first = this.bMarks[line];

    if (line + 1 < end || keepLastLF) {
      // No need for bounds check because we have fake entry on tail.
      last = this.eMarks[line] + 1;
    } else {
      last = this.eMarks[line];
    }

    while (first < last && lineIndent < indent) {
      ch = this.src.charCodeAt(first);

      if (isSpace(ch)) {
        if (ch === 0x09) {
          lineIndent += 4 - (lineIndent + this.bsCount[line]) % 4;
        } else {
          lineIndent++;
        }
      } else if (first - lineStart < this.tShift[line]) {
        // patched tShift masked characters to look like spaces (blockquotes, list markers)
        lineIndent++;
      } else {
        break;
      }

      first++;
    }

    if (lineIndent > indent) {
      // partially expanding tabs in code blocks, e.g '\t\tfoobar'
      // with indent=2 becomes '  \tfoobar'
      queue[i] = new Array(lineIndent - indent + 1).join(' ') + this.src.slice(first, last);
    } else {
      queue[i] = this.src.slice(first, last);
    }
  }

  return queue.join('');
};

// re-export Token class to use in block rules
StateBlock.prototype.Token = Token;


module.exports = StateBlock;


/***/ }),

/***/ 83010:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// GFM table, https://github.github.com/gfm/#tables-extension-



var isSpace = (__webpack_require__(26212).isSpace);


function getLine(state, line) {
  var pos = state.bMarks[line] + state.tShift[line],
      max = state.eMarks[line];

  return state.src.substr(pos, max - pos);
}

function escapedSplit(str) {
  var result = [],
      pos = 0,
      max = str.length,
      ch,
      isEscaped = false,
      lastPos = 0,
      current = '';

  ch  = str.charCodeAt(pos);

  while (pos < max) {
    if (ch === 0x7c/* | */) {
      if (!isEscaped) {
        // pipe separating cells, '|'
        result.push(current + str.substring(lastPos, pos));
        current = '';
        lastPos = pos + 1;
      } else {
        // escaped pipe, '\|'
        current += str.substring(lastPos, pos - 1);
        lastPos = pos;
      }
    }

    isEscaped = (ch === 0x5c/* \ */);
    pos++;

    ch = str.charCodeAt(pos);
  }

  result.push(current + str.substring(lastPos));

  return result;
}


module.exports = function table(state, startLine, endLine, silent) {
  var ch, lineText, pos, i, l, nextLine, columns, columnCount, token,
      aligns, t, tableLines, tbodyLines, oldParentType, terminate,
      terminatorRules, firstCh, secondCh;

  // should have at least two lines
  if (startLine + 2 > endLine) { return false; }

  nextLine = startLine + 1;

  if (state.sCount[nextLine] < state.blkIndent) { return false; }

  // if it's indented more than 3 spaces, it should be a code block
  if (state.sCount[nextLine] - state.blkIndent >= 4) { return false; }

  // first character of the second line should be '|', '-', ':',
  // and no other characters are allowed but spaces;
  // basically, this is the equivalent of /^[-:|][-:|\s]*$/ regexp

  pos = state.bMarks[nextLine] + state.tShift[nextLine];
  if (pos >= state.eMarks[nextLine]) { return false; }

  firstCh = state.src.charCodeAt(pos++);
  if (firstCh !== 0x7C/* | */ && firstCh !== 0x2D/* - */ && firstCh !== 0x3A/* : */) { return false; }

  if (pos >= state.eMarks[nextLine]) { return false; }

  secondCh = state.src.charCodeAt(pos++);
  if (secondCh !== 0x7C/* | */ && secondCh !== 0x2D/* - */ && secondCh !== 0x3A/* : */ && !isSpace(secondCh)) {
    return false;
  }

  // if first character is '-', then second character must not be a space
  // (due to parsing ambiguity with list)
  if (firstCh === 0x2D/* - */ && isSpace(secondCh)) { return false; }

  while (pos < state.eMarks[nextLine]) {
    ch = state.src.charCodeAt(pos);

    if (ch !== 0x7C/* | */ && ch !== 0x2D/* - */ && ch !== 0x3A/* : */ && !isSpace(ch)) { return false; }

    pos++;
  }

  lineText = getLine(state, startLine + 1);

  columns = lineText.split('|');
  aligns = [];
  for (i = 0; i < columns.length; i++) {
    t = columns[i].trim();
    if (!t) {
      // allow empty columns before and after table, but not in between columns;
      // e.g. allow ` |---| `, disallow ` ---||--- `
      if (i === 0 || i === columns.length - 1) {
        continue;
      } else {
        return false;
      }
    }

    if (!/^:?-+:?$/.test(t)) { return false; }
    if (t.charCodeAt(t.length - 1) === 0x3A/* : */) {
      aligns.push(t.charCodeAt(0) === 0x3A/* : */ ? 'center' : 'right');
    } else if (t.charCodeAt(0) === 0x3A/* : */) {
      aligns.push('left');
    } else {
      aligns.push('');
    }
  }

  lineText = getLine(state, startLine).trim();
  if (lineText.indexOf('|') === -1) { return false; }
  if (state.sCount[startLine] - state.blkIndent >= 4) { return false; }
  columns = escapedSplit(lineText);
  if (columns.length && columns[0] === '') columns.shift();
  if (columns.length && columns[columns.length - 1] === '') columns.pop();

  // header row will define an amount of columns in the entire table,
  // and align row should be exactly the same (the rest of the rows can differ)
  columnCount = columns.length;
  if (columnCount === 0 || columnCount !== aligns.length) { return false; }

  if (silent) { return true; }

  oldParentType = state.parentType;
  state.parentType = 'table';

  // use 'blockquote' lists for termination because it's
  // the most similar to tables
  terminatorRules = state.md.block.ruler.getRules('blockquote');

  token     = state.push('table_open', 'table', 1);
  token.map = tableLines = [ startLine, 0 ];

  token     = state.push('thead_open', 'thead', 1);
  token.map = [ startLine, startLine + 1 ];

  token     = state.push('tr_open', 'tr', 1);
  token.map = [ startLine, startLine + 1 ];

  for (i = 0; i < columns.length; i++) {
    token          = state.push('th_open', 'th', 1);
    if (aligns[i]) {
      token.attrs  = [ [ 'style', 'text-align:' + aligns[i] ] ];
    }

    token          = state.push('inline', '', 0);
    token.content  = columns[i].trim();
    token.children = [];

    token          = state.push('th_close', 'th', -1);
  }

  token     = state.push('tr_close', 'tr', -1);
  token     = state.push('thead_close', 'thead', -1);

  for (nextLine = startLine + 2; nextLine < endLine; nextLine++) {
    if (state.sCount[nextLine] < state.blkIndent) { break; }

    terminate = false;
    for (i = 0, l = terminatorRules.length; i < l; i++) {
      if (terminatorRules[i](state, nextLine, endLine, true)) {
        terminate = true;
        break;
      }
    }

    if (terminate) { break; }
    lineText = getLine(state, nextLine).trim();
    if (!lineText) { break; }
    if (state.sCount[nextLine] - state.blkIndent >= 4) { break; }
    columns = escapedSplit(lineText);
    if (columns.length && columns[0] === '') columns.shift();
    if (columns.length && columns[columns.length - 1] === '') columns.pop();

    if (nextLine === startLine + 2) {
      token     = state.push('tbody_open', 'tbody', 1);
      token.map = tbodyLines = [ startLine + 2, 0 ];
    }

    token     = state.push('tr_open', 'tr', 1);
    token.map = [ nextLine, nextLine + 1 ];

    for (i = 0; i < columnCount; i++) {
      token          = state.push('td_open', 'td', 1);
      if (aligns[i]) {
        token.attrs  = [ [ 'style', 'text-align:' + aligns[i] ] ];
      }

      token          = state.push('inline', '', 0);
      token.content  = columns[i] ? columns[i].trim() : '';
      token.children = [];

      token          = state.push('td_close', 'td', -1);
    }
    token = state.push('tr_close', 'tr', -1);
  }

  if (tbodyLines) {
    token = state.push('tbody_close', 'tbody', -1);
    tbodyLines[1] = nextLine;
  }

  token = state.push('table_close', 'table', -1);
  tableLines[1] = nextLine;

  state.parentType = oldParentType;
  state.line = nextLine;
  return true;
};


/***/ }),

/***/ 84965:
/***/ ((module) => {

"use strict";



module.exports = function block(state) {
  var token;

  if (state.inlineMode) {
    token          = new state.Token('inline', '', 0);
    token.content  = state.src;
    token.map      = [ 0, 1 ];
    token.children = [];
    state.tokens.push(token);
  } else {
    state.md.block.parse(state.src, state.md, state.env, state.tokens);
  }
};


/***/ }),

/***/ 80458:
/***/ ((module) => {

"use strict";


module.exports = function inline(state) {
  var tokens = state.tokens, tok, i, l;

  // Parse inlines
  for (i = 0, l = tokens.length; i < l; i++) {
    tok = tokens[i];
    if (tok.type === 'inline') {
      state.md.inline.parse(tok.content, state.md, state.env, tok.children);
    }
  }
};


/***/ }),

/***/ 68961:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Replace link-like texts with link nodes.
//
// Currently restricted by `md.validateLink()` to http/https/ftp
//



var arrayReplaceAt = (__webpack_require__(26212).arrayReplaceAt);


function isLinkOpen(str) {
  return /^<a[>\s]/i.test(str);
}
function isLinkClose(str) {
  return /^<\/a\s*>/i.test(str);
}


module.exports = function linkify(state) {
  var i, j, l, tokens, token, currentToken, nodes, ln, text, pos, lastPos,
      level, htmlLinkLevel, url, fullUrl, urlText,
      blockTokens = state.tokens,
      links;

  if (!state.md.options.linkify) { return; }

  for (j = 0, l = blockTokens.length; j < l; j++) {
    if (blockTokens[j].type !== 'inline' ||
        !state.md.linkify.pretest(blockTokens[j].content)) {
      continue;
    }

    tokens = blockTokens[j].children;

    htmlLinkLevel = 0;

    // We scan from the end, to keep position when new tags added.
    // Use reversed logic in links start/end match
    for (i = tokens.length - 1; i >= 0; i--) {
      currentToken = tokens[i];

      // Skip content of markdown links
      if (currentToken.type === 'link_close') {
        i--;
        while (tokens[i].level !== currentToken.level && tokens[i].type !== 'link_open') {
          i--;
        }
        continue;
      }

      // Skip content of html tag links
      if (currentToken.type === 'html_inline') {
        if (isLinkOpen(currentToken.content) && htmlLinkLevel > 0) {
          htmlLinkLevel--;
        }
        if (isLinkClose(currentToken.content)) {
          htmlLinkLevel++;
        }
      }
      if (htmlLinkLevel > 0) { continue; }

      if (currentToken.type === 'text' && state.md.linkify.test(currentToken.content)) {

        text = currentToken.content;
        links = state.md.linkify.match(text);

        // Now split string to nodes
        nodes = [];
        level = currentToken.level;
        lastPos = 0;

        for (ln = 0; ln < links.length; ln++) {

          url = links[ln].url;
          fullUrl = state.md.normalizeLink(url);
          if (!state.md.validateLink(fullUrl)) { continue; }

          urlText = links[ln].text;

          // Linkifier might send raw hostnames like "example.com", where url
          // starts with domain name. So we prepend http:// in those cases,
          // and remove it afterwards.
          //
          if (!links[ln].schema) {
            urlText = state.md.normalizeLinkText('http://' + urlText).replace(/^http:\/\//, '');
          } else if (links[ln].schema === 'mailto:' && !/^mailto:/i.test(urlText)) {
            urlText = state.md.normalizeLinkText('mailto:' + urlText).replace(/^mailto:/, '');
          } else {
            urlText = state.md.normalizeLinkText(urlText);
          }

          pos = links[ln].index;

          if (pos > lastPos) {
            token         = new state.Token('text', '', 0);
            token.content = text.slice(lastPos, pos);
            token.level   = level;
            nodes.push(token);
          }

          token         = new state.Token('link_open', 'a', 1);
          token.attrs   = [ [ 'href', fullUrl ] ];
          token.level   = level++;
          token.markup  = 'linkify';
          token.info    = 'auto';
          nodes.push(token);

          token         = new state.Token('text', '', 0);
          token.content = urlText;
          token.level   = level;
          nodes.push(token);

          token         = new state.Token('link_close', 'a', -1);
          token.level   = --level;
          token.markup  = 'linkify';
          token.info    = 'auto';
          nodes.push(token);

          lastPos = links[ln].lastIndex;
        }
        if (lastPos < text.length) {
          token         = new state.Token('text', '', 0);
          token.content = text.slice(lastPos);
          token.level   = level;
          nodes.push(token);
        }

        // replace current node
        blockTokens[j].children = tokens = arrayReplaceAt(tokens, i, nodes);
      }
    }
  }
};


/***/ }),

/***/ 75272:
/***/ ((module) => {

"use strict";
// Normalize input string




// https://spec.commonmark.org/0.29/#line-ending
var NEWLINES_RE  = /\r\n?|\n/g;
var NULL_RE      = /\0/g;


module.exports = function normalize(state) {
  var str;

  // Normalize newlines
  str = state.src.replace(NEWLINES_RE, '\n');

  // Replace NULL characters
  str = str.replace(NULL_RE, '\uFFFD');

  state.src = str;
};


/***/ }),

/***/ 30806:
/***/ ((module) => {

"use strict";
// Simple typographic replacements
//
// (c) (C) → ©
// (tm) (TM) → ™
// (r) (R) → ®
// +- → ±
// (p) (P) -> §
// ... → … (also ?.... → ?.., !.... → !..)
// ???????? → ???, !!!!! → !!!, `,,` → `,`
// -- → &ndash;, --- → &mdash;
//


// TODO:
// - fractionals 1/2, 1/4, 3/4 -> ½, ¼, ¾
// - miltiplication 2 x 4 -> 2 × 4

var RARE_RE = /\+-|\.\.|\?\?\?\?|!!!!|,,|--/;

// Workaround for phantomjs - need regex without /g flag,
// or root check will fail every second time
var SCOPED_ABBR_TEST_RE = /\((c|tm|r|p)\)/i;

var SCOPED_ABBR_RE = /\((c|tm|r|p)\)/ig;
var SCOPED_ABBR = {
  c: '©',
  r: '®',
  p: '§',
  tm: '™'
};

function replaceFn(match, name) {
  return SCOPED_ABBR[name.toLowerCase()];
}

function replace_scoped(inlineTokens) {
  var i, token, inside_autolink = 0;

  for (i = inlineTokens.length - 1; i >= 0; i--) {
    token = inlineTokens[i];

    if (token.type === 'text' && !inside_autolink) {
      token.content = token.content.replace(SCOPED_ABBR_RE, replaceFn);
    }

    if (token.type === 'link_open' && token.info === 'auto') {
      inside_autolink--;
    }

    if (token.type === 'link_close' && token.info === 'auto') {
      inside_autolink++;
    }
  }
}

function replace_rare(inlineTokens) {
  var i, token, inside_autolink = 0;

  for (i = inlineTokens.length - 1; i >= 0; i--) {
    token = inlineTokens[i];

    if (token.type === 'text' && !inside_autolink) {
      if (RARE_RE.test(token.content)) {
        token.content = token.content
          .replace(/\+-/g, '±')
          // .., ..., ....... -> …
          // but ?..... & !..... -> ?.. & !..
          .replace(/\.{2,}/g, '…').replace(/([?!])…/g, '$1..')
          .replace(/([?!]){4,}/g, '$1$1$1').replace(/,{2,}/g, ',')
          // em-dash
          .replace(/(^|[^-])---(?=[^-]|$)/mg, '$1\u2014')
          // en-dash
          .replace(/(^|\s)--(?=\s|$)/mg, '$1\u2013')
          .replace(/(^|[^-\s])--(?=[^-\s]|$)/mg, '$1\u2013');
      }
    }

    if (token.type === 'link_open' && token.info === 'auto') {
      inside_autolink--;
    }

    if (token.type === 'link_close' && token.info === 'auto') {
      inside_autolink++;
    }
  }
}


module.exports = function replace(state) {
  var blkIdx;

  if (!state.md.options.typographer) { return; }

  for (blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--) {

    if (state.tokens[blkIdx].type !== 'inline') { continue; }

    if (SCOPED_ABBR_TEST_RE.test(state.tokens[blkIdx].content)) {
      replace_scoped(state.tokens[blkIdx].children);
    }

    if (RARE_RE.test(state.tokens[blkIdx].content)) {
      replace_rare(state.tokens[blkIdx].children);
    }

  }
};


/***/ }),

/***/ 62839:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Convert straight quotation marks to typographic ones
//



var isWhiteSpace   = (__webpack_require__(26212).isWhiteSpace);
var isPunctChar    = (__webpack_require__(26212).isPunctChar);
var isMdAsciiPunct = (__webpack_require__(26212).isMdAsciiPunct);

var QUOTE_TEST_RE = /['"]/;
var QUOTE_RE = /['"]/g;
var APOSTROPHE = '\u2019'; /* ’ */


function replaceAt(str, index, ch) {
  return str.substr(0, index) + ch + str.substr(index + 1);
}

function process_inlines(tokens, state) {
  var i, token, text, t, pos, max, thisLevel, item, lastChar, nextChar,
      isLastPunctChar, isNextPunctChar, isLastWhiteSpace, isNextWhiteSpace,
      canOpen, canClose, j, isSingle, stack, openQuote, closeQuote;

  stack = [];

  for (i = 0; i < tokens.length; i++) {
    token = tokens[i];

    thisLevel = tokens[i].level;

    for (j = stack.length - 1; j >= 0; j--) {
      if (stack[j].level <= thisLevel) { break; }
    }
    stack.length = j + 1;

    if (token.type !== 'text') { continue; }

    text = token.content;
    pos = 0;
    max = text.length;

    /*eslint no-labels:0,block-scoped-var:0*/
    OUTER:
    while (pos < max) {
      QUOTE_RE.lastIndex = pos;
      t = QUOTE_RE.exec(text);
      if (!t) { break; }

      canOpen = canClose = true;
      pos = t.index + 1;
      isSingle = (t[0] === "'");

      // Find previous character,
      // default to space if it's the beginning of the line
      //
      lastChar = 0x20;

      if (t.index - 1 >= 0) {
        lastChar = text.charCodeAt(t.index - 1);
      } else {
        for (j = i - 1; j >= 0; j--) {
          if (tokens[j].type === 'softbreak' || tokens[j].type === 'hardbreak') break; // lastChar defaults to 0x20
          if (!tokens[j].content) continue; // should skip all tokens except 'text', 'html_inline' or 'code_inline'

          lastChar = tokens[j].content.charCodeAt(tokens[j].content.length - 1);
          break;
        }
      }

      // Find next character,
      // default to space if it's the end of the line
      //
      nextChar = 0x20;

      if (pos < max) {
        nextChar = text.charCodeAt(pos);
      } else {
        for (j = i + 1; j < tokens.length; j++) {
          if (tokens[j].type === 'softbreak' || tokens[j].type === 'hardbreak') break; // nextChar defaults to 0x20
          if (!tokens[j].content) continue; // should skip all tokens except 'text', 'html_inline' or 'code_inline'

          nextChar = tokens[j].content.charCodeAt(0);
          break;
        }
      }

      isLastPunctChar = isMdAsciiPunct(lastChar) || isPunctChar(String.fromCharCode(lastChar));
      isNextPunctChar = isMdAsciiPunct(nextChar) || isPunctChar(String.fromCharCode(nextChar));

      isLastWhiteSpace = isWhiteSpace(lastChar);
      isNextWhiteSpace = isWhiteSpace(nextChar);

      if (isNextWhiteSpace) {
        canOpen = false;
      } else if (isNextPunctChar) {
        if (!(isLastWhiteSpace || isLastPunctChar)) {
          canOpen = false;
        }
      }

      if (isLastWhiteSpace) {
        canClose = false;
      } else if (isLastPunctChar) {
        if (!(isNextWhiteSpace || isNextPunctChar)) {
          canClose = false;
        }
      }

      if (nextChar === 0x22 /* " */ && t[0] === '"') {
        if (lastChar >= 0x30 /* 0 */ && lastChar <= 0x39 /* 9 */) {
          // special case: 1"" - count first quote as an inch
          canClose = canOpen = false;
        }
      }

      if (canOpen && canClose) {
        // Replace quotes in the middle of punctuation sequence, but not
        // in the middle of the words, i.e.:
        //
        // 1. foo " bar " baz - not replaced
        // 2. foo-"-bar-"-baz - replaced
        // 3. foo"bar"baz     - not replaced
        //
        canOpen = isLastPunctChar;
        canClose = isNextPunctChar;
      }

      if (!canOpen && !canClose) {
        // middle of word
        if (isSingle) {
          token.content = replaceAt(token.content, t.index, APOSTROPHE);
        }
        continue;
      }

      if (canClose) {
        // this could be a closing quote, rewind the stack to get a match
        for (j = stack.length - 1; j >= 0; j--) {
          item = stack[j];
          if (stack[j].level < thisLevel) { break; }
          if (item.single === isSingle && stack[j].level === thisLevel) {
            item = stack[j];

            if (isSingle) {
              openQuote = state.md.options.quotes[2];
              closeQuote = state.md.options.quotes[3];
            } else {
              openQuote = state.md.options.quotes[0];
              closeQuote = state.md.options.quotes[1];
            }

            // replace token.content *before* tokens[item.token].content,
            // because, if they are pointing at the same token, replaceAt
            // could mess up indices when quote length != 1
            token.content = replaceAt(token.content, t.index, closeQuote);
            tokens[item.token].content = replaceAt(
              tokens[item.token].content, item.pos, openQuote);

            pos += closeQuote.length - 1;
            if (item.token === i) { pos += openQuote.length - 1; }

            text = token.content;
            max = text.length;

            stack.length = j;
            continue OUTER;
          }
        }
      }

      if (canOpen) {
        stack.push({
          token: i,
          pos: t.index,
          single: isSingle,
          level: thisLevel
        });
      } else if (canClose && isSingle) {
        token.content = replaceAt(token.content, t.index, APOSTROPHE);
      }
    }
  }
}


module.exports = function smartquotes(state) {
  /*eslint max-depth:0*/
  var blkIdx;

  if (!state.md.options.typographer) { return; }

  for (blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--) {

    if (state.tokens[blkIdx].type !== 'inline' ||
        !QUOTE_TEST_RE.test(state.tokens[blkIdx].content)) {
      continue;
    }

    process_inlines(state.tokens[blkIdx].children, state);
  }
};


/***/ }),

/***/ 36455:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Core state object
//


var Token = __webpack_require__(98114);


function StateCore(src, md, env) {
  this.src = src;
  this.env = env;
  this.tokens = [];
  this.inlineMode = false;
  this.md = md; // link to parser instance
}

// re-export Token class to use in core rules
StateCore.prototype.Token = Token;


module.exports = StateCore;


/***/ }),

/***/ 34627:
/***/ ((module) => {

"use strict";
// Process autolinks '<protocol:...>'




/*eslint max-len:0*/
var EMAIL_RE    = /^([a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)$/;
var AUTOLINK_RE = /^([a-zA-Z][a-zA-Z0-9+.\-]{1,31}):([^<>\x00-\x20]*)$/;


module.exports = function autolink(state, silent) {
  var url, fullUrl, token, ch, start, max,
      pos = state.pos;

  if (state.src.charCodeAt(pos) !== 0x3C/* < */) { return false; }

  start = state.pos;
  max = state.posMax;

  for (;;) {
    if (++pos >= max) return false;

    ch = state.src.charCodeAt(pos);

    if (ch === 0x3C /* < */) return false;
    if (ch === 0x3E /* > */) break;
  }

  url = state.src.slice(start + 1, pos);

  if (AUTOLINK_RE.test(url)) {
    fullUrl = state.md.normalizeLink(url);
    if (!state.md.validateLink(fullUrl)) { return false; }

    if (!silent) {
      token         = state.push('link_open', 'a', 1);
      token.attrs   = [ [ 'href', fullUrl ] ];
      token.markup  = 'autolink';
      token.info    = 'auto';

      token         = state.push('text', '', 0);
      token.content = state.md.normalizeLinkText(url);

      token         = state.push('link_close', 'a', -1);
      token.markup  = 'autolink';
      token.info    = 'auto';
    }

    state.pos += url.length + 2;
    return true;
  }

  if (EMAIL_RE.test(url)) {
    fullUrl = state.md.normalizeLink('mailto:' + url);
    if (!state.md.validateLink(fullUrl)) { return false; }

    if (!silent) {
      token         = state.push('link_open', 'a', 1);
      token.attrs   = [ [ 'href', fullUrl ] ];
      token.markup  = 'autolink';
      token.info    = 'auto';

      token         = state.push('text', '', 0);
      token.content = state.md.normalizeLinkText(url);

      token         = state.push('link_close', 'a', -1);
      token.markup  = 'autolink';
      token.info    = 'auto';
    }

    state.pos += url.length + 2;
    return true;
  }

  return false;
};


/***/ }),

/***/ 5691:
/***/ ((module) => {

"use strict";
// Parse backticks




module.exports = function backtick(state, silent) {
  var start, max, marker, token, matchStart, matchEnd, openerLength, closerLength,
      pos = state.pos,
      ch = state.src.charCodeAt(pos);

  if (ch !== 0x60/* ` */) { return false; }

  start = pos;
  pos++;
  max = state.posMax;

  // scan marker length
  while (pos < max && state.src.charCodeAt(pos) === 0x60/* ` */) { pos++; }

  marker = state.src.slice(start, pos);
  openerLength = marker.length;

  if (state.backticksScanned && (state.backticks[openerLength] || 0) <= start) {
    if (!silent) state.pending += marker;
    state.pos += openerLength;
    return true;
  }

  matchStart = matchEnd = pos;

  // Nothing found in the cache, scan until the end of the line (or until marker is found)
  while ((matchStart = state.src.indexOf('`', matchEnd)) !== -1) {
    matchEnd = matchStart + 1;

    // scan marker length
    while (matchEnd < max && state.src.charCodeAt(matchEnd) === 0x60/* ` */) { matchEnd++; }

    closerLength = matchEnd - matchStart;

    if (closerLength === openerLength) {
      // Found matching closer length.
      if (!silent) {
        token     = state.push('code_inline', 'code', 0);
        token.markup  = marker;
        token.content = state.src.slice(pos, matchStart)
          .replace(/\n/g, ' ')
          .replace(/^ (.+) $/, '$1');
      }
      state.pos = matchEnd;
      return true;
    }

    // Some different length found, put it in cache as upper limit of where closer can be found
    state.backticks[closerLength] = matchStart;
  }

  // Scanned through the end, didn't find anything
  state.backticksScanned = true;

  if (!silent) state.pending += marker;
  state.pos += openerLength;
  return true;
};


/***/ }),

/***/ 40469:
/***/ ((module) => {

"use strict";
// For each opening emphasis-like marker find a matching closing one
//



function processDelimiters(state, delimiters) {
  var closerIdx, openerIdx, closer, opener, minOpenerIdx, newMinOpenerIdx,
      isOddMatch, lastJump,
      openersBottom = {},
      max = delimiters.length;

  for (closerIdx = 0; closerIdx < max; closerIdx++) {
    closer = delimiters[closerIdx];

    // Length is only used for emphasis-specific "rule of 3",
    // if it's not defined (in strikethrough or 3rd party plugins),
    // we can default it to 0 to disable those checks.
    //
    closer.length = closer.length || 0;

    if (!closer.close) continue;

    // Previously calculated lower bounds (previous fails)
    // for each marker, each delimiter length modulo 3,
    // and for whether this closer can be an opener;
    // https://github.com/commonmark/cmark/commit/34250e12ccebdc6372b8b49c44fab57c72443460
    if (!openersBottom.hasOwnProperty(closer.marker)) {
      openersBottom[closer.marker] = [ -1, -1, -1, -1, -1, -1 ];
    }

    minOpenerIdx = openersBottom[closer.marker][(closer.open ? 3 : 0) + (closer.length % 3)];

    openerIdx = closerIdx - closer.jump - 1;

    // avoid crash if `closer.jump` is pointing outside of the array, see #742
    if (openerIdx < -1) openerIdx = -1;

    newMinOpenerIdx = openerIdx;

    for (; openerIdx > minOpenerIdx; openerIdx -= opener.jump + 1) {
      opener = delimiters[openerIdx];

      if (opener.marker !== closer.marker) continue;

      if (opener.open && opener.end < 0) {

        isOddMatch = false;

        // from spec:
        //
        // If one of the delimiters can both open and close emphasis, then the
        // sum of the lengths of the delimiter runs containing the opening and
        // closing delimiters must not be a multiple of 3 unless both lengths
        // are multiples of 3.
        //
        if (opener.close || closer.open) {
          if ((opener.length + closer.length) % 3 === 0) {
            if (opener.length % 3 !== 0 || closer.length % 3 !== 0) {
              isOddMatch = true;
            }
          }
        }

        if (!isOddMatch) {
          // If previous delimiter cannot be an opener, we can safely skip
          // the entire sequence in future checks. This is required to make
          // sure algorithm has linear complexity (see *_*_*_*_*_... case).
          //
          lastJump = openerIdx > 0 && !delimiters[openerIdx - 1].open ?
            delimiters[openerIdx - 1].jump + 1 :
            0;

          closer.jump  = closerIdx - openerIdx + lastJump;
          closer.open  = false;
          opener.end   = closerIdx;
          opener.jump  = lastJump;
          opener.close = false;
          newMinOpenerIdx = -1;
          break;
        }
      }
    }

    if (newMinOpenerIdx !== -1) {
      // If match for this delimiter run failed, we want to set lower bound for
      // future lookups. This is required to make sure algorithm has linear
      // complexity.
      //
      // See details here:
      // https://github.com/commonmark/cmark/issues/178#issuecomment-270417442
      //
      openersBottom[closer.marker][(closer.open ? 3 : 0) + ((closer.length || 0) % 3)] = newMinOpenerIdx;
    }
  }
}


module.exports = function link_pairs(state) {
  var curr,
      tokens_meta = state.tokens_meta,
      max = state.tokens_meta.length;

  processDelimiters(state, state.delimiters);

  for (curr = 0; curr < max; curr++) {
    if (tokens_meta[curr] && tokens_meta[curr].delimiters) {
      processDelimiters(state, tokens_meta[curr].delimiters);
    }
  }
};


/***/ }),

/***/ 36522:
/***/ ((module) => {

"use strict";
// Process *this* and _that_
//



// Insert each marker as a separate text token, and add it to delimiter list
//
module.exports.w = function emphasis(state, silent) {
  var i, scanned, token,
      start = state.pos,
      marker = state.src.charCodeAt(start);

  if (silent) { return false; }

  if (marker !== 0x5F /* _ */ && marker !== 0x2A /* * */) { return false; }

  scanned = state.scanDelims(state.pos, marker === 0x2A);

  for (i = 0; i < scanned.length; i++) {
    token         = state.push('text', '', 0);
    token.content = String.fromCharCode(marker);

    state.delimiters.push({
      // Char code of the starting marker (number).
      //
      marker: marker,

      // Total length of these series of delimiters.
      //
      length: scanned.length,

      // An amount of characters before this one that's equivalent to
      // current one. In plain English: if this delimiter does not open
      // an emphasis, neither do previous `jump` characters.
      //
      // Used to skip sequences like "*****" in one step, for 1st asterisk
      // value will be 0, for 2nd it's 1 and so on.
      //
      jump:   i,

      // A position of the token this delimiter corresponds to.
      //
      token:  state.tokens.length - 1,

      // If this delimiter is matched as a valid opener, `end` will be
      // equal to its position, otherwise it's `-1`.
      //
      end:    -1,

      // Boolean flags that determine if this delimiter could open or close
      // an emphasis.
      //
      open:   scanned.can_open,
      close:  scanned.can_close
    });
  }

  state.pos += scanned.length;

  return true;
};


function postProcess(state, delimiters) {
  var i,
      startDelim,
      endDelim,
      token,
      ch,
      isStrong,
      max = delimiters.length;

  for (i = max - 1; i >= 0; i--) {
    startDelim = delimiters[i];

    if (startDelim.marker !== 0x5F/* _ */ && startDelim.marker !== 0x2A/* * */) {
      continue;
    }

    // Process only opening markers
    if (startDelim.end === -1) {
      continue;
    }

    endDelim = delimiters[startDelim.end];

    // If the previous delimiter has the same marker and is adjacent to this one,
    // merge those into one strong delimiter.
    //
    // `<em><em>whatever</em></em>` -> `<strong>whatever</strong>`
    //
    isStrong = i > 0 &&
               delimiters[i - 1].end === startDelim.end + 1 &&
               delimiters[i - 1].token === startDelim.token - 1 &&
               delimiters[startDelim.end + 1].token === endDelim.token + 1 &&
               delimiters[i - 1].marker === startDelim.marker;

    ch = String.fromCharCode(startDelim.marker);

    token         = state.tokens[startDelim.token];
    token.type    = isStrong ? 'strong_open' : 'em_open';
    token.tag     = isStrong ? 'strong' : 'em';
    token.nesting = 1;
    token.markup  = isStrong ? ch + ch : ch;
    token.content = '';

    token         = state.tokens[endDelim.token];
    token.type    = isStrong ? 'strong_close' : 'em_close';
    token.tag     = isStrong ? 'strong' : 'em';
    token.nesting = -1;
    token.markup  = isStrong ? ch + ch : ch;
    token.content = '';

    if (isStrong) {
      state.tokens[delimiters[i - 1].token].content = '';
      state.tokens[delimiters[startDelim.end + 1].token].content = '';
      i--;
    }
  }
}


// Walk through delimiter list and replace text tokens with tags
//
module.exports.g = function emphasis(state) {
  var curr,
      tokens_meta = state.tokens_meta,
      max = state.tokens_meta.length;

  postProcess(state, state.delimiters);

  for (curr = 0; curr < max; curr++) {
    if (tokens_meta[curr] && tokens_meta[curr].delimiters) {
      postProcess(state, tokens_meta[curr].delimiters);
    }
  }
};


/***/ }),

/***/ 72105:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Process html entity - &#123;, &#xAF;, &quot;, ...



var entities          = __webpack_require__(83630);
var has               = (__webpack_require__(26212).has);
var isValidEntityCode = (__webpack_require__(26212).isValidEntityCode);
var fromCodePoint     = (__webpack_require__(26212).fromCodePoint);


var DIGITAL_RE = /^&#((?:x[a-f0-9]{1,6}|[0-9]{1,7}));/i;
var NAMED_RE   = /^&([a-z][a-z0-9]{1,31});/i;


module.exports = function entity(state, silent) {
  var ch, code, match, pos = state.pos, max = state.posMax;

  if (state.src.charCodeAt(pos) !== 0x26/* & */) { return false; }

  if (pos + 1 < max) {
    ch = state.src.charCodeAt(pos + 1);

    if (ch === 0x23 /* # */) {
      match = state.src.slice(pos).match(DIGITAL_RE);
      if (match) {
        if (!silent) {
          code = match[1][0].toLowerCase() === 'x' ? parseInt(match[1].slice(1), 16) : parseInt(match[1], 10);
          state.pending += isValidEntityCode(code) ? fromCodePoint(code) : fromCodePoint(0xFFFD);
        }
        state.pos += match[0].length;
        return true;
      }
    } else {
      match = state.src.slice(pos).match(NAMED_RE);
      if (match) {
        if (has(entities, match[1])) {
          if (!silent) { state.pending += entities[match[1]]; }
          state.pos += match[0].length;
          return true;
        }
      }
    }
  }

  if (!silent) { state.pending += '&'; }
  state.pos++;
  return true;
};


/***/ }),

/***/ 626:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Process escaped chars and hardbreaks



var isSpace = (__webpack_require__(26212).isSpace);

var ESCAPED = [];

for (var i = 0; i < 256; i++) { ESCAPED.push(0); }

'\\!"#$%&\'()*+,./:;<=>?@[]^_`{|}~-'
  .split('').forEach(function (ch) { ESCAPED[ch.charCodeAt(0)] = 1; });


module.exports = function escape(state, silent) {
  var ch, pos = state.pos, max = state.posMax;

  if (state.src.charCodeAt(pos) !== 0x5C/* \ */) { return false; }

  pos++;

  if (pos < max) {
    ch = state.src.charCodeAt(pos);

    if (ch < 256 && ESCAPED[ch] !== 0) {
      if (!silent) { state.pending += state.src[pos]; }
      state.pos += 2;
      return true;
    }

    if (ch === 0x0A) {
      if (!silent) {
        state.push('hardbreak', 'br', 0);
      }

      pos++;
      // skip leading whitespaces from next line
      while (pos < max) {
        ch = state.src.charCodeAt(pos);
        if (!isSpace(ch)) { break; }
        pos++;
      }

      state.pos = pos;
      return true;
    }
  }

  if (!silent) { state.pending += '\\'; }
  state.pos++;
  return true;
};


/***/ }),

/***/ 97845:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Process html tags




var HTML_TAG_RE = (__webpack_require__(26517)/* .HTML_TAG_RE */ .n);


function isLetter(ch) {
  /*eslint no-bitwise:0*/
  var lc = ch | 0x20; // to lower case
  return (lc >= 0x61/* a */) && (lc <= 0x7a/* z */);
}


module.exports = function html_inline(state, silent) {
  var ch, match, max, token,
      pos = state.pos;

  if (!state.md.options.html) { return false; }

  // Check start
  max = state.posMax;
  if (state.src.charCodeAt(pos) !== 0x3C/* < */ ||
      pos + 2 >= max) {
    return false;
  }

  // Quick fail on second char
  ch = state.src.charCodeAt(pos + 1);
  if (ch !== 0x21/* ! */ &&
      ch !== 0x3F/* ? */ &&
      ch !== 0x2F/* / */ &&
      !isLetter(ch)) {
    return false;
  }

  match = state.src.slice(pos).match(HTML_TAG_RE);
  if (!match) { return false; }

  if (!silent) {
    token         = state.push('html_inline', '', 0);
    token.content = state.src.slice(pos, pos + match[0].length);
  }
  state.pos += match[0].length;
  return true;
};


/***/ }),

/***/ 29192:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Process ![image](<src> "title")



var normalizeReference   = (__webpack_require__(26212).normalizeReference);
var isSpace              = (__webpack_require__(26212).isSpace);


module.exports = function image(state, silent) {
  var attrs,
      code,
      content,
      label,
      labelEnd,
      labelStart,
      pos,
      ref,
      res,
      title,
      token,
      tokens,
      start,
      href = '',
      oldPos = state.pos,
      max = state.posMax;

  if (state.src.charCodeAt(state.pos) !== 0x21/* ! */) { return false; }
  if (state.src.charCodeAt(state.pos + 1) !== 0x5B/* [ */) { return false; }

  labelStart = state.pos + 2;
  labelEnd = state.md.helpers.parseLinkLabel(state, state.pos + 1, false);

  // parser failed to find ']', so it's not a valid link
  if (labelEnd < 0) { return false; }

  pos = labelEnd + 1;
  if (pos < max && state.src.charCodeAt(pos) === 0x28/* ( */) {
    //
    // Inline link
    //

    // [link](  <href>  "title"  )
    //        ^^ skipping these spaces
    pos++;
    for (; pos < max; pos++) {
      code = state.src.charCodeAt(pos);
      if (!isSpace(code) && code !== 0x0A) { break; }
    }
    if (pos >= max) { return false; }

    // [link](  <href>  "title"  )
    //          ^^^^^^ parsing link destination
    start = pos;
    res = state.md.helpers.parseLinkDestination(state.src, pos, state.posMax);
    if (res.ok) {
      href = state.md.normalizeLink(res.str);
      if (state.md.validateLink(href)) {
        pos = res.pos;
      } else {
        href = '';
      }
    }

    // [link](  <href>  "title"  )
    //                ^^ skipping these spaces
    start = pos;
    for (; pos < max; pos++) {
      code = state.src.charCodeAt(pos);
      if (!isSpace(code) && code !== 0x0A) { break; }
    }

    // [link](  <href>  "title"  )
    //                  ^^^^^^^ parsing link title
    res = state.md.helpers.parseLinkTitle(state.src, pos, state.posMax);
    if (pos < max && start !== pos && res.ok) {
      title = res.str;
      pos = res.pos;

      // [link](  <href>  "title"  )
      //                         ^^ skipping these spaces
      for (; pos < max; pos++) {
        code = state.src.charCodeAt(pos);
        if (!isSpace(code) && code !== 0x0A) { break; }
      }
    } else {
      title = '';
    }

    if (pos >= max || state.src.charCodeAt(pos) !== 0x29/* ) */) {
      state.pos = oldPos;
      return false;
    }
    pos++;
  } else {
    //
    // Link reference
    //
    if (typeof state.env.references === 'undefined') { return false; }

    if (pos < max && state.src.charCodeAt(pos) === 0x5B/* [ */) {
      start = pos + 1;
      pos = state.md.helpers.parseLinkLabel(state, pos);
      if (pos >= 0) {
        label = state.src.slice(start, pos++);
      } else {
        pos = labelEnd + 1;
      }
    } else {
      pos = labelEnd + 1;
    }

    // covers label === '' and label === undefined
    // (collapsed reference link and shortcut reference link respectively)
    if (!label) { label = state.src.slice(labelStart, labelEnd); }

    ref = state.env.references[normalizeReference(label)];
    if (!ref) {
      state.pos = oldPos;
      return false;
    }
    href = ref.href;
    title = ref.title;
  }

  //
  // We found the end of the link, and know for a fact it's a valid link;
  // so all that's left to do is to call tokenizer.
  //
  if (!silent) {
    content = state.src.slice(labelStart, labelEnd);

    state.md.inline.parse(
      content,
      state.md,
      state.env,
      tokens = []
    );

    token          = state.push('image', 'img', 0);
    token.attrs    = attrs = [ [ 'src', href ], [ 'alt', '' ] ];
    token.children = tokens;
    token.content  = content;

    if (title) {
      attrs.push([ 'title', title ]);
    }
  }

  state.pos = pos;
  state.posMax = max;
  return true;
};


/***/ }),

/***/ 70027:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Process [link](<to> "stuff")



var normalizeReference   = (__webpack_require__(26212).normalizeReference);
var isSpace              = (__webpack_require__(26212).isSpace);


module.exports = function link(state, silent) {
  var attrs,
      code,
      label,
      labelEnd,
      labelStart,
      pos,
      res,
      ref,
      token,
      href = '',
      title = '',
      oldPos = state.pos,
      max = state.posMax,
      start = state.pos,
      parseReference = true;

  if (state.src.charCodeAt(state.pos) !== 0x5B/* [ */) { return false; }

  labelStart = state.pos + 1;
  labelEnd = state.md.helpers.parseLinkLabel(state, state.pos, true);

  // parser failed to find ']', so it's not a valid link
  if (labelEnd < 0) { return false; }

  pos = labelEnd + 1;
  if (pos < max && state.src.charCodeAt(pos) === 0x28/* ( */) {
    //
    // Inline link
    //

    // might have found a valid shortcut link, disable reference parsing
    parseReference = false;

    // [link](  <href>  "title"  )
    //        ^^ skipping these spaces
    pos++;
    for (; pos < max; pos++) {
      code = state.src.charCodeAt(pos);
      if (!isSpace(code) && code !== 0x0A) { break; }
    }
    if (pos >= max) { return false; }

    // [link](  <href>  "title"  )
    //          ^^^^^^ parsing link destination
    start = pos;
    res = state.md.helpers.parseLinkDestination(state.src, pos, state.posMax);
    if (res.ok) {
      href = state.md.normalizeLink(res.str);
      if (state.md.validateLink(href)) {
        pos = res.pos;
      } else {
        href = '';
      }

      // [link](  <href>  "title"  )
      //                ^^ skipping these spaces
      start = pos;
      for (; pos < max; pos++) {
        code = state.src.charCodeAt(pos);
        if (!isSpace(code) && code !== 0x0A) { break; }
      }

      // [link](  <href>  "title"  )
      //                  ^^^^^^^ parsing link title
      res = state.md.helpers.parseLinkTitle(state.src, pos, state.posMax);
      if (pos < max && start !== pos && res.ok) {
        title = res.str;
        pos = res.pos;

        // [link](  <href>  "title"  )
        //                         ^^ skipping these spaces
        for (; pos < max; pos++) {
          code = state.src.charCodeAt(pos);
          if (!isSpace(code) && code !== 0x0A) { break; }
        }
      }
    }

    if (pos >= max || state.src.charCodeAt(pos) !== 0x29/* ) */) {
      // parsing a valid shortcut link failed, fallback to reference
      parseReference = true;
    }
    pos++;
  }

  if (parseReference) {
    //
    // Link reference
    //
    if (typeof state.env.references === 'undefined') { return false; }

    if (pos < max && state.src.charCodeAt(pos) === 0x5B/* [ */) {
      start = pos + 1;
      pos = state.md.helpers.parseLinkLabel(state, pos);
      if (pos >= 0) {
        label = state.src.slice(start, pos++);
      } else {
        pos = labelEnd + 1;
      }
    } else {
      pos = labelEnd + 1;
    }

    // covers label === '' and label === undefined
    // (collapsed reference link and shortcut reference link respectively)
    if (!label) { label = state.src.slice(labelStart, labelEnd); }

    ref = state.env.references[normalizeReference(label)];
    if (!ref) {
      state.pos = oldPos;
      return false;
    }
    href = ref.href;
    title = ref.title;
  }

  //
  // We found the end of the link, and know for a fact it's a valid link;
  // so all that's left to do is to call tokenizer.
  //
  if (!silent) {
    state.pos = labelStart;
    state.posMax = labelEnd;

    token        = state.push('link_open', 'a', 1);
    token.attrs  = attrs = [ [ 'href', href ] ];
    if (title) {
      attrs.push([ 'title', title ]);
    }

    state.md.inline.tokenize(state);

    token        = state.push('link_close', 'a', -1);
  }

  state.pos = pos;
  state.posMax = max;
  return true;
};


/***/ }),

/***/ 40183:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Proceess '\n'



var isSpace = (__webpack_require__(26212).isSpace);


module.exports = function newline(state, silent) {
  var pmax, max, pos = state.pos;

  if (state.src.charCodeAt(pos) !== 0x0A/* \n */) { return false; }

  pmax = state.pending.length - 1;
  max = state.posMax;

  // '  \n' -> hardbreak
  // Lookup in pending chars is bad practice! Don't copy to other rules!
  // Pending string is stored in concat mode, indexed lookups will cause
  // convertion to flat mode.
  if (!silent) {
    if (pmax >= 0 && state.pending.charCodeAt(pmax) === 0x20) {
      if (pmax >= 1 && state.pending.charCodeAt(pmax - 1) === 0x20) {
        state.pending = state.pending.replace(/ +$/, '');
        state.push('hardbreak', 'br', 0);
      } else {
        state.pending = state.pending.slice(0, -1);
        state.push('softbreak', 'br', 0);
      }

    } else {
      state.push('softbreak', 'br', 0);
    }
  }

  pos++;

  // skip heading spaces for next line
  while (pos < max && isSpace(state.src.charCodeAt(pos))) { pos++; }

  state.pos = pos;
  return true;
};


/***/ }),

/***/ 62418:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Inline parser state




var Token          = __webpack_require__(98114);
var isWhiteSpace   = (__webpack_require__(26212).isWhiteSpace);
var isPunctChar    = (__webpack_require__(26212).isPunctChar);
var isMdAsciiPunct = (__webpack_require__(26212).isMdAsciiPunct);


function StateInline(src, md, env, outTokens) {
  this.src = src;
  this.env = env;
  this.md = md;
  this.tokens = outTokens;
  this.tokens_meta = Array(outTokens.length);

  this.pos = 0;
  this.posMax = this.src.length;
  this.level = 0;
  this.pending = '';
  this.pendingLevel = 0;

  // Stores { start: end } pairs. Useful for backtrack
  // optimization of pairs parse (emphasis, strikes).
  this.cache = {};

  // List of emphasis-like delimiters for current tag
  this.delimiters = [];

  // Stack of delimiter lists for upper level tags
  this._prev_delimiters = [];

  // backtick length => last seen position
  this.backticks = {};
  this.backticksScanned = false;
}


// Flush pending text
//
StateInline.prototype.pushPending = function () {
  var token = new Token('text', '', 0);
  token.content = this.pending;
  token.level = this.pendingLevel;
  this.tokens.push(token);
  this.pending = '';
  return token;
};


// Push new token to "stream".
// If pending text exists - flush it as text token
//
StateInline.prototype.push = function (type, tag, nesting) {
  if (this.pending) {
    this.pushPending();
  }

  var token = new Token(type, tag, nesting);
  var token_meta = null;

  if (nesting < 0) {
    // closing tag
    this.level--;
    this.delimiters = this._prev_delimiters.pop();
  }

  token.level = this.level;

  if (nesting > 0) {
    // opening tag
    this.level++;
    this._prev_delimiters.push(this.delimiters);
    this.delimiters = [];
    token_meta = { delimiters: this.delimiters };
  }

  this.pendingLevel = this.level;
  this.tokens.push(token);
  this.tokens_meta.push(token_meta);
  return token;
};


// Scan a sequence of emphasis-like markers, and determine whether
// it can start an emphasis sequence or end an emphasis sequence.
//
//  - start - position to scan from (it should point at a valid marker);
//  - canSplitWord - determine if these markers can be found inside a word
//
StateInline.prototype.scanDelims = function (start, canSplitWord) {
  var pos = start, lastChar, nextChar, count, can_open, can_close,
      isLastWhiteSpace, isLastPunctChar,
      isNextWhiteSpace, isNextPunctChar,
      left_flanking = true,
      right_flanking = true,
      max = this.posMax,
      marker = this.src.charCodeAt(start);

  // treat beginning of the line as a whitespace
  lastChar = start > 0 ? this.src.charCodeAt(start - 1) : 0x20;

  while (pos < max && this.src.charCodeAt(pos) === marker) { pos++; }

  count = pos - start;

  // treat end of the line as a whitespace
  nextChar = pos < max ? this.src.charCodeAt(pos) : 0x20;

  isLastPunctChar = isMdAsciiPunct(lastChar) || isPunctChar(String.fromCharCode(lastChar));
  isNextPunctChar = isMdAsciiPunct(nextChar) || isPunctChar(String.fromCharCode(nextChar));

  isLastWhiteSpace = isWhiteSpace(lastChar);
  isNextWhiteSpace = isWhiteSpace(nextChar);

  if (isNextWhiteSpace) {
    left_flanking = false;
  } else if (isNextPunctChar) {
    if (!(isLastWhiteSpace || isLastPunctChar)) {
      left_flanking = false;
    }
  }

  if (isLastWhiteSpace) {
    right_flanking = false;
  } else if (isLastPunctChar) {
    if (!(isNextWhiteSpace || isNextPunctChar)) {
      right_flanking = false;
    }
  }

  if (!canSplitWord) {
    can_open  = left_flanking  && (!right_flanking || isLastPunctChar);
    can_close = right_flanking && (!left_flanking  || isNextPunctChar);
  } else {
    can_open  = left_flanking;
    can_close = right_flanking;
  }

  return {
    can_open:  can_open,
    can_close: can_close,
    length:    count
  };
};


// re-export Token class to use in block rules
StateInline.prototype.Token = Token;


module.exports = StateInline;


/***/ }),

/***/ 26472:
/***/ ((module) => {

"use strict";
// ~~strike through~~
//



// Insert each marker as a separate text token, and add it to delimiter list
//
module.exports.w = function strikethrough(state, silent) {
  var i, scanned, token, len, ch,
      start = state.pos,
      marker = state.src.charCodeAt(start);

  if (silent) { return false; }

  if (marker !== 0x7E/* ~ */) { return false; }

  scanned = state.scanDelims(state.pos, true);
  len = scanned.length;
  ch = String.fromCharCode(marker);

  if (len < 2) { return false; }

  if (len % 2) {
    token         = state.push('text', '', 0);
    token.content = ch;
    len--;
  }

  for (i = 0; i < len; i += 2) {
    token         = state.push('text', '', 0);
    token.content = ch + ch;

    state.delimiters.push({
      marker: marker,
      length: 0,     // disable "rule of 3" length checks meant for emphasis
      jump:   i / 2, // for `~~` 1 marker = 2 characters
      token:  state.tokens.length - 1,
      end:    -1,
      open:   scanned.can_open,
      close:  scanned.can_close
    });
  }

  state.pos += scanned.length;

  return true;
};


function postProcess(state, delimiters) {
  var i, j,
      startDelim,
      endDelim,
      token,
      loneMarkers = [],
      max = delimiters.length;

  for (i = 0; i < max; i++) {
    startDelim = delimiters[i];

    if (startDelim.marker !== 0x7E/* ~ */) {
      continue;
    }

    if (startDelim.end === -1) {
      continue;
    }

    endDelim = delimiters[startDelim.end];

    token         = state.tokens[startDelim.token];
    token.type    = 's_open';
    token.tag     = 's';
    token.nesting = 1;
    token.markup  = '~~';
    token.content = '';

    token         = state.tokens[endDelim.token];
    token.type    = 's_close';
    token.tag     = 's';
    token.nesting = -1;
    token.markup  = '~~';
    token.content = '';

    if (state.tokens[endDelim.token - 1].type === 'text' &&
        state.tokens[endDelim.token - 1].content === '~') {

      loneMarkers.push(endDelim.token - 1);
    }
  }

  // If a marker sequence has an odd number of characters, it's splitted
  // like this: `~~~~~` -> `~` + `~~` + `~~`, leaving one marker at the
  // start of the sequence.
  //
  // So, we have to move all those markers after subsequent s_close tags.
  //
  while (loneMarkers.length) {
    i = loneMarkers.pop();
    j = i + 1;

    while (j < state.tokens.length && state.tokens[j].type === 's_close') {
      j++;
    }

    j--;

    if (i !== j) {
      token = state.tokens[j];
      state.tokens[j] = state.tokens[i];
      state.tokens[i] = token;
    }
  }
}


// Walk through delimiter list and replace text tokens with tags
//
module.exports.g = function strikethrough(state) {
  var curr,
      tokens_meta = state.tokens_meta,
      max = state.tokens_meta.length;

  postProcess(state, state.delimiters);

  for (curr = 0; curr < max; curr++) {
    if (tokens_meta[curr] && tokens_meta[curr].delimiters) {
      postProcess(state, tokens_meta[curr].delimiters);
    }
  }
};


/***/ }),

/***/ 11854:
/***/ ((module) => {

"use strict";
// Skip text characters for text token, place those to pending buffer
// and increment current pos




// Rule to skip pure text
// '{}$%@~+=:' reserved for extentions

// !, ", #, $, %, &, ', (, ), *, +, ,, -, ., /, :, ;, <, =, >, ?, @, [, \, ], ^, _, `, {, |, }, or ~

// !!!! Don't confuse with "Markdown ASCII Punctuation" chars
// http://spec.commonmark.org/0.15/#ascii-punctuation-character
function isTerminatorChar(ch) {
  switch (ch) {
    case 0x0A/* \n */:
    case 0x21/* ! */:
    case 0x23/* # */:
    case 0x24/* $ */:
    case 0x25/* % */:
    case 0x26/* & */:
    case 0x2A/* * */:
    case 0x2B/* + */:
    case 0x2D/* - */:
    case 0x3A/* : */:
    case 0x3C/* < */:
    case 0x3D/* = */:
    case 0x3E/* > */:
    case 0x40/* @ */:
    case 0x5B/* [ */:
    case 0x5C/* \ */:
    case 0x5D/* ] */:
    case 0x5E/* ^ */:
    case 0x5F/* _ */:
    case 0x60/* ` */:
    case 0x7B/* { */:
    case 0x7D/* } */:
    case 0x7E/* ~ */:
      return true;
    default:
      return false;
  }
}

module.exports = function text(state, silent) {
  var pos = state.pos;

  while (pos < state.posMax && !isTerminatorChar(state.src.charCodeAt(pos))) {
    pos++;
  }

  if (pos === state.pos) { return false; }

  if (!silent) { state.pending += state.src.slice(state.pos, pos); }

  state.pos = pos;

  return true;
};

// Alternative implementation, for memory.
//
// It costs 10% of performance, but allows extend terminators list, if place it
// to `ParcerInline` property. Probably, will switch to it sometime, such
// flexibility required.

/*
var TERMINATOR_RE = /[\n!#$%&*+\-:<=>@[\\\]^_`{}~]/;

module.exports = function text(state, silent) {
  var pos = state.pos,
      idx = state.src.slice(pos).search(TERMINATOR_RE);

  // first char is terminator -> empty text
  if (idx === 0) { return false; }

  // no terminator -> text till end of string
  if (idx < 0) {
    if (!silent) { state.pending += state.src.slice(pos); }
    state.pos = state.src.length;
    return true;
  }

  if (!silent) { state.pending += state.src.slice(pos, pos + idx); }

  state.pos += idx;

  return true;
};*/


/***/ }),

/***/ 83514:
/***/ ((module) => {

"use strict";
// Clean up tokens after emphasis and strikethrough postprocessing:
// merge adjacent text nodes into one and re-calculate all token levels
//
// This is necessary because initially emphasis delimiter markers (*, _, ~)
// are treated as their own separate text tokens. Then emphasis rule either
// leaves them as text (needed to merge with adjacent text) or turns them
// into opening/closing tags (which messes up levels inside).
//



module.exports = function text_collapse(state) {
  var curr, last,
      level = 0,
      tokens = state.tokens,
      max = state.tokens.length;

  for (curr = last = 0; curr < max; curr++) {
    // re-calculate levels after emphasis/strikethrough turns some text nodes
    // into opening/closing tags
    if (tokens[curr].nesting < 0) level--; // closing tag
    tokens[curr].level = level;
    if (tokens[curr].nesting > 0) level++; // opening tag

    if (tokens[curr].type === 'text' &&
        curr + 1 < max &&
        tokens[curr + 1].type === 'text') {

      // collapse two adjacent text nodes
      tokens[curr + 1].content = tokens[curr].content + tokens[curr + 1].content;
    } else {
      if (curr !== last) { tokens[last] = tokens[curr]; }

      last++;
    }
  }

  if (curr !== last) {
    tokens.length = last;
  }
};


/***/ }),

/***/ 98114:
/***/ ((module) => {

"use strict";
// Token class




/**
 * class Token
 **/

/**
 * new Token(type, tag, nesting)
 *
 * Create new token and fill passed properties.
 **/
function Token(type, tag, nesting) {
  /**
   * Token#type -> String
   *
   * Type of the token (string, e.g. "paragraph_open")
   **/
  this.type     = type;

  /**
   * Token#tag -> String
   *
   * html tag name, e.g. "p"
   **/
  this.tag      = tag;

  /**
   * Token#attrs -> Array
   *
   * Html attributes. Format: `[ [ name1, value1 ], [ name2, value2 ] ]`
   **/
  this.attrs    = null;

  /**
   * Token#map -> Array
   *
   * Source map info. Format: `[ line_begin, line_end ]`
   **/
  this.map      = null;

  /**
   * Token#nesting -> Number
   *
   * Level change (number in {-1, 0, 1} set), where:
   *
   * -  `1` means the tag is opening
   * -  `0` means the tag is self-closing
   * - `-1` means the tag is closing
   **/
  this.nesting  = nesting;

  /**
   * Token#level -> Number
   *
   * nesting level, the same as `state.level`
   **/
  this.level    = 0;

  /**
   * Token#children -> Array
   *
   * An array of child nodes (inline and img tokens)
   **/
  this.children = null;

  /**
   * Token#content -> String
   *
   * In a case of self-closing tag (code, html, fence, etc.),
   * it has contents of this tag.
   **/
  this.content  = '';

  /**
   * Token#markup -> String
   *
   * '*' or '_' for emphasis, fence string for fence, etc.
   **/
  this.markup   = '';

  /**
   * Token#info -> String
   *
   * Additional information:
   *
   * - Info string for "fence" tokens
   * - The value "auto" for autolink "link_open" and "link_close" tokens
   * - The string value of the item marker for ordered-list "list_item_open" tokens
   **/
  this.info     = '';

  /**
   * Token#meta -> Object
   *
   * A place for plugins to store an arbitrary data
   **/
  this.meta     = null;

  /**
   * Token#block -> Boolean
   *
   * True for block-level tokens, false for inline tokens.
   * Used in renderer to calculate line breaks
   **/
  this.block    = false;

  /**
   * Token#hidden -> Boolean
   *
   * If it's true, ignore this element when rendering. Used for tight lists
   * to hide paragraphs.
   **/
  this.hidden   = false;
}


/**
 * Token.attrIndex(name) -> Number
 *
 * Search attribute index by name.
 **/
Token.prototype.attrIndex = function attrIndex(name) {
  var attrs, i, len;

  if (!this.attrs) { return -1; }

  attrs = this.attrs;

  for (i = 0, len = attrs.length; i < len; i++) {
    if (attrs[i][0] === name) { return i; }
  }
  return -1;
};


/**
 * Token.attrPush(attrData)
 *
 * Add `[ name, value ]` attribute to list. Init attrs if necessary
 **/
Token.prototype.attrPush = function attrPush(attrData) {
  if (this.attrs) {
    this.attrs.push(attrData);
  } else {
    this.attrs = [ attrData ];
  }
};


/**
 * Token.attrSet(name, value)
 *
 * Set `name` attribute to `value`. Override old value if exists.
 **/
Token.prototype.attrSet = function attrSet(name, value) {
  var idx = this.attrIndex(name),
      attrData = [ name, value ];

  if (idx < 0) {
    this.attrPush(attrData);
  } else {
    this.attrs[idx] = attrData;
  }
};


/**
 * Token.attrGet(name)
 *
 * Get the value of attribute `name`, or null if it does not exist.
 **/
Token.prototype.attrGet = function attrGet(name) {
  var idx = this.attrIndex(name), value = null;
  if (idx >= 0) {
    value = this.attrs[idx][1];
  }
  return value;
};


/**
 * Token.attrJoin(name, value)
 *
 * Join value to existing attribute via space. Or create new attribute if not
 * exists. Useful to operate with token classes.
 **/
Token.prototype.attrJoin = function attrJoin(name, value) {
  var idx = this.attrIndex(name);

  if (idx < 0) {
    this.attrPush([ name, value ]);
  } else {
    this.attrs[idx][1] = this.attrs[idx][1] + ' ' + value;
  }
};


module.exports = Token;


/***/ }),

/***/ 18585:
/***/ ((module) => {

"use strict";




/* eslint-disable no-bitwise */

var decodeCache = {};

function getDecodeCache(exclude) {
  var i, ch, cache = decodeCache[exclude];
  if (cache) { return cache; }

  cache = decodeCache[exclude] = [];

  for (i = 0; i < 128; i++) {
    ch = String.fromCharCode(i);
    cache.push(ch);
  }

  for (i = 0; i < exclude.length; i++) {
    ch = exclude.charCodeAt(i);
    cache[ch] = '%' + ('0' + ch.toString(16).toUpperCase()).slice(-2);
  }

  return cache;
}


// Decode percent-encoded string.
//
function decode(string, exclude) {
  var cache;

  if (typeof exclude !== 'string') {
    exclude = decode.defaultChars;
  }

  cache = getDecodeCache(exclude);

  return string.replace(/(%[a-f0-9]{2})+/gi, function(seq) {
    var i, l, b1, b2, b3, b4, chr,
        result = '';

    for (i = 0, l = seq.length; i < l; i += 3) {
      b1 = parseInt(seq.slice(i + 1, i + 3), 16);

      if (b1 < 0x80) {
        result += cache[b1];
        continue;
      }

      if ((b1 & 0xE0) === 0xC0 && (i + 3 < l)) {
        // 110xxxxx 10xxxxxx
        b2 = parseInt(seq.slice(i + 4, i + 6), 16);

        if ((b2 & 0xC0) === 0x80) {
          chr = ((b1 << 6) & 0x7C0) | (b2 & 0x3F);

          if (chr < 0x80) {
            result += '\ufffd\ufffd';
          } else {
            result += String.fromCharCode(chr);
          }

          i += 3;
          continue;
        }
      }

      if ((b1 & 0xF0) === 0xE0 && (i + 6 < l)) {
        // 1110xxxx 10xxxxxx 10xxxxxx
        b2 = parseInt(seq.slice(i + 4, i + 6), 16);
        b3 = parseInt(seq.slice(i + 7, i + 9), 16);

        if ((b2 & 0xC0) === 0x80 && (b3 & 0xC0) === 0x80) {
          chr = ((b1 << 12) & 0xF000) | ((b2 << 6) & 0xFC0) | (b3 & 0x3F);

          if (chr < 0x800 || (chr >= 0xD800 && chr <= 0xDFFF)) {
            result += '\ufffd\ufffd\ufffd';
          } else {
            result += String.fromCharCode(chr);
          }

          i += 6;
          continue;
        }
      }

      if ((b1 & 0xF8) === 0xF0 && (i + 9 < l)) {
        // 111110xx 10xxxxxx 10xxxxxx 10xxxxxx
        b2 = parseInt(seq.slice(i + 4, i + 6), 16);
        b3 = parseInt(seq.slice(i + 7, i + 9), 16);
        b4 = parseInt(seq.slice(i + 10, i + 12), 16);

        if ((b2 & 0xC0) === 0x80 && (b3 & 0xC0) === 0x80 && (b4 & 0xC0) === 0x80) {
          chr = ((b1 << 18) & 0x1C0000) | ((b2 << 12) & 0x3F000) | ((b3 << 6) & 0xFC0) | (b4 & 0x3F);

          if (chr < 0x10000 || chr > 0x10FFFF) {
            result += '\ufffd\ufffd\ufffd\ufffd';
          } else {
            chr -= 0x10000;
            result += String.fromCharCode(0xD800 + (chr >> 10), 0xDC00 + (chr & 0x3FF));
          }

          i += 9;
          continue;
        }
      }

      result += '\ufffd';
    }

    return result;
  });
}


decode.defaultChars   = ';/?:@&=+$,#';
decode.componentChars = '';


module.exports = decode;


/***/ }),

/***/ 5704:
/***/ ((module) => {

"use strict";




var encodeCache = {};


// Create a lookup array where anything but characters in `chars` string
// and alphanumeric chars is percent-encoded.
//
function getEncodeCache(exclude) {
  var i, ch, cache = encodeCache[exclude];
  if (cache) { return cache; }

  cache = encodeCache[exclude] = [];

  for (i = 0; i < 128; i++) {
    ch = String.fromCharCode(i);

    if (/^[0-9a-z]$/i.test(ch)) {
      // always allow unencoded alphanumeric characters
      cache.push(ch);
    } else {
      cache.push('%' + ('0' + i.toString(16).toUpperCase()).slice(-2));
    }
  }

  for (i = 0; i < exclude.length; i++) {
    cache[exclude.charCodeAt(i)] = exclude[i];
  }

  return cache;
}


// Encode unsafe characters with percent-encoding, skipping already
// encoded sequences.
//
//  - string       - string to encode
//  - exclude      - list of characters to ignore (in addition to a-zA-Z0-9)
//  - keepEscaped  - don't encode '%' in a correct escape sequence (default: true)
//
function encode(string, exclude, keepEscaped) {
  var i, l, code, nextCode, cache,
      result = '';

  if (typeof exclude !== 'string') {
    // encode(string, keepEscaped)
    keepEscaped  = exclude;
    exclude = encode.defaultChars;
  }

  if (typeof keepEscaped === 'undefined') {
    keepEscaped = true;
  }

  cache = getEncodeCache(exclude);

  for (i = 0, l = string.length; i < l; i++) {
    code = string.charCodeAt(i);

    if (keepEscaped && code === 0x25 /* % */ && i + 2 < l) {
      if (/^[0-9a-f]{2}$/i.test(string.slice(i + 1, i + 3))) {
        result += string.slice(i, i + 3);
        i += 2;
        continue;
      }
    }

    if (code < 128) {
      result += cache[code];
      continue;
    }

    if (code >= 0xD800 && code <= 0xDFFF) {
      if (code >= 0xD800 && code <= 0xDBFF && i + 1 < l) {
        nextCode = string.charCodeAt(i + 1);
        if (nextCode >= 0xDC00 && nextCode <= 0xDFFF) {
          result += encodeURIComponent(string[i] + string[i + 1]);
          i++;
          continue;
        }
      }
      result += '%EF%BF%BD';
      continue;
    }

    result += encodeURIComponent(string[i]);
  }

  return result;
}

encode.defaultChars   = ";/?:@&=+$,-_.!~*'()#";
encode.componentChars = "-_.!~*'()";


module.exports = encode;


/***/ }),

/***/ 39481:
/***/ ((module) => {

"use strict";




module.exports = function format(url) {
  var result = '';

  result += url.protocol || '';
  result += url.slashes ? '//' : '';
  result += url.auth ? url.auth + '@' : '';

  if (url.hostname && url.hostname.indexOf(':') !== -1) {
    // ipv6 address
    result += '[' + url.hostname + ']';
  } else {
    result += url.hostname || '';
  }

  result += url.port ? ':' + url.port : '';
  result += url.pathname || '';
  result += url.search || '';
  result += url.hash || '';

  return result;
};


/***/ }),

/***/ 12449:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";



module.exports.encode = __webpack_require__(5704);
module.exports.decode = __webpack_require__(18585);
module.exports.format = __webpack_require__(39481);
module.exports.parse = __webpack_require__(25979);


/***/ }),

/***/ 25979:
/***/ ((module) => {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



//
// Changes from joyent/node:
//
// 1. No leading slash in paths,
//    e.g. in `url.parse('http://foo?bar')` pathname is ``, not `/`
//
// 2. Backslashes are not replaced with slashes,
//    so `http:\\example.org\` is treated like a relative path
//
// 3. Trailing colon is treated like a part of the path,
//    i.e. in `http://example.org:foo` pathname is `:foo`
//
// 4. Nothing is URL-encoded in the resulting object,
//    (in joyent/node some chars in auth and paths are encoded)
//
// 5. `url.parse()` does not have `parseQueryString` argument
//
// 6. Removed extraneous result properties: `host`, `path`, `query`, etc.,
//    which can be constructed using other parts of the url.
//


function Url() {
  this.protocol = null;
  this.slashes = null;
  this.auth = null;
  this.port = null;
  this.hostname = null;
  this.hash = null;
  this.search = null;
  this.pathname = null;
}

// Reference: RFC 3986, RFC 1808, RFC 2396

// define these here so at least they only have to be
// compiled once on the first module load.
var protocolPattern = /^([a-z0-9.+-]+:)/i,
    portPattern = /:[0-9]*$/,

    // Special case for a simple path URL
    simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,

    // RFC 2396: characters reserved for delimiting URLs.
    // We actually just auto-escape these.
    delims = [ '<', '>', '"', '`', ' ', '\r', '\n', '\t' ],

    // RFC 2396: characters not allowed for various reasons.
    unwise = [ '{', '}', '|', '\\', '^', '`' ].concat(delims),

    // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
    autoEscape = [ '\'' ].concat(unwise),
    // Characters that are never ever allowed in a hostname.
    // Note that any invalid chars are also handled, but these
    // are the ones that are *expected* to be seen, so we fast-path
    // them.
    nonHostChars = [ '%', '/', '?', ';', '#' ].concat(autoEscape),
    hostEndingChars = [ '/', '?', '#' ],
    hostnameMaxLen = 255,
    hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
    hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
    // protocols that can allow "unsafe" and "unwise" chars.
    /* eslint-disable no-script-url */
    // protocols that never have a hostname.
    hostlessProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that always contain a // bit.
    slashedProtocol = {
      'http': true,
      'https': true,
      'ftp': true,
      'gopher': true,
      'file': true,
      'http:': true,
      'https:': true,
      'ftp:': true,
      'gopher:': true,
      'file:': true
    };
    /* eslint-enable no-script-url */

function urlParse(url, slashesDenoteHost) {
  if (url && url instanceof Url) { return url; }

  var u = new Url();
  u.parse(url, slashesDenoteHost);
  return u;
}

Url.prototype.parse = function(url, slashesDenoteHost) {
  var i, l, lowerProto, hec, slashes,
      rest = url;

  // trim before proceeding.
  // This is to support parse stuff like "  http://foo.com  \n"
  rest = rest.trim();

  if (!slashesDenoteHost && url.split('#').length === 1) {
    // Try fast path regexp
    var simplePath = simplePathPattern.exec(rest);
    if (simplePath) {
      this.pathname = simplePath[1];
      if (simplePath[2]) {
        this.search = simplePath[2];
      }
      return this;
    }
  }

  var proto = protocolPattern.exec(rest);
  if (proto) {
    proto = proto[0];
    lowerProto = proto.toLowerCase();
    this.protocol = proto;
    rest = rest.substr(proto.length);
  }

  // figure out if it's got a host
  // user@server is *always* interpreted as a hostname, and url
  // resolution will treat //foo/bar as host=foo,path=bar because that's
  // how the browser resolves relative URLs.
  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
    slashes = rest.substr(0, 2) === '//';
    if (slashes && !(proto && hostlessProtocol[proto])) {
      rest = rest.substr(2);
      this.slashes = true;
    }
  }

  if (!hostlessProtocol[proto] &&
      (slashes || (proto && !slashedProtocol[proto]))) {

    // there's a hostname.
    // the first instance of /, ?, ;, or # ends the host.
    //
    // If there is an @ in the hostname, then non-host chars *are* allowed
    // to the left of the last @ sign, unless some host-ending character
    // comes *before* the @-sign.
    // URLs are obnoxious.
    //
    // ex:
    // http://a@b@c/ => user:a@b host:c
    // http://a@b?@c => user:a host:c path:/?@c

    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
    // Review our test case against browsers more comprehensively.

    // find the first instance of any hostEndingChars
    var hostEnd = -1;
    for (i = 0; i < hostEndingChars.length; i++) {
      hec = rest.indexOf(hostEndingChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) {
        hostEnd = hec;
      }
    }

    // at this point, either we have an explicit point where the
    // auth portion cannot go past, or the last @ char is the decider.
    var auth, atSign;
    if (hostEnd === -1) {
      // atSign can be anywhere.
      atSign = rest.lastIndexOf('@');
    } else {
      // atSign must be in auth portion.
      // http://a@b/c@d => host:b auth:a path:/c@d
      atSign = rest.lastIndexOf('@', hostEnd);
    }

    // Now we have a portion which is definitely the auth.
    // Pull that off.
    if (atSign !== -1) {
      auth = rest.slice(0, atSign);
      rest = rest.slice(atSign + 1);
      this.auth = auth;
    }

    // the host is the remaining to the left of the first non-host char
    hostEnd = -1;
    for (i = 0; i < nonHostChars.length; i++) {
      hec = rest.indexOf(nonHostChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) {
        hostEnd = hec;
      }
    }
    // if we still have not hit it, then the entire thing is a host.
    if (hostEnd === -1) {
      hostEnd = rest.length;
    }

    if (rest[hostEnd - 1] === ':') { hostEnd--; }
    var host = rest.slice(0, hostEnd);
    rest = rest.slice(hostEnd);

    // pull out port.
    this.parseHost(host);

    // we've indicated that there is a hostname,
    // so even if it's empty, it has to be present.
    this.hostname = this.hostname || '';

    // if hostname begins with [ and ends with ]
    // assume that it's an IPv6 address.
    var ipv6Hostname = this.hostname[0] === '[' &&
        this.hostname[this.hostname.length - 1] === ']';

    // validate a little.
    if (!ipv6Hostname) {
      var hostparts = this.hostname.split(/\./);
      for (i = 0, l = hostparts.length; i < l; i++) {
        var part = hostparts[i];
        if (!part) { continue; }
        if (!part.match(hostnamePartPattern)) {
          var newpart = '';
          for (var j = 0, k = part.length; j < k; j++) {
            if (part.charCodeAt(j) > 127) {
              // we replace non-ASCII char with a temporary placeholder
              // we need this to make sure size of hostname is not
              // broken by replacing non-ASCII by nothing
              newpart += 'x';
            } else {
              newpart += part[j];
            }
          }
          // we test again with ASCII char only
          if (!newpart.match(hostnamePartPattern)) {
            var validParts = hostparts.slice(0, i);
            var notHost = hostparts.slice(i + 1);
            var bit = part.match(hostnamePartStart);
            if (bit) {
              validParts.push(bit[1]);
              notHost.unshift(bit[2]);
            }
            if (notHost.length) {
              rest = notHost.join('.') + rest;
            }
            this.hostname = validParts.join('.');
            break;
          }
        }
      }
    }

    if (this.hostname.length > hostnameMaxLen) {
      this.hostname = '';
    }

    // strip [ and ] from the hostname
    // the host field still retains them, though
    if (ipv6Hostname) {
      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
    }
  }

  // chop off from the tail first.
  var hash = rest.indexOf('#');
  if (hash !== -1) {
    // got a fragment string.
    this.hash = rest.substr(hash);
    rest = rest.slice(0, hash);
  }
  var qm = rest.indexOf('?');
  if (qm !== -1) {
    this.search = rest.substr(qm);
    rest = rest.slice(0, qm);
  }
  if (rest) { this.pathname = rest; }
  if (slashedProtocol[lowerProto] &&
      this.hostname && !this.pathname) {
    this.pathname = '';
  }

  return this;
};

Url.prototype.parseHost = function(host) {
  var port = portPattern.exec(host);
  if (port) {
    port = port[0];
    if (port !== ':') {
      this.port = port.substr(1);
    }
    host = host.substr(0, host.length - port.length);
  }
  if (host) { this.hostname = host; }
};

module.exports = urlParse;


/***/ }),

/***/ 34538:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var hasMap = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match = String.prototype.match;
var $slice = String.prototype.slice;
var $replace = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor = Math.floor;
var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? 'object' : 'symbol')
    ? Symbol.toStringTag
    : null;
var isEnumerable = Object.prototype.propertyIsEnumerable;

var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || (
    [].__proto__ === Array.prototype // eslint-disable-line no-proto
        ? function (O) {
            return O.__proto__; // eslint-disable-line no-proto
        }
        : null
);

function addNumericSeparator(num, str) {
    if (
        num === Infinity
        || num === -Infinity
        || num !== num
        || (num && num > -1000 && num < 1000)
        || $test.call(/e/, str)
    ) {
        return str;
    }
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $slice.call(str, intStr.length + 1);
            return $replace.call(intStr, sepRegex, '$&_') + '.' + $replace.call($replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $replace.call(str, sepRegex, '$&_');
}

var utilInspect = __webpack_require__(57002);
var inspectCustom = utilInspect.custom;
var inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null;

module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};

    if (has(opts, 'quoteStyle') && (opts.quoteStyle !== 'single' && opts.quoteStyle !== 'double')) {
        throw new TypeError('option "quoteStyle" must be "single" or "double"');
    }
    if (
        has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number'
            ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity
            : opts.maxStringLength !== null
        )
    ) {
        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    }
    var customInspect = has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
        throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    }

    if (
        has(opts, 'indent')
        && opts.indent !== null
        && opts.indent !== '\t'
        && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)
    ) {
        throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    }
    if (has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') {
        throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    }
    var numericSeparator = opts.numericSeparator;

    if (typeof obj === 'undefined') {
        return 'undefined';
    }
    if (obj === null) {
        return 'null';
    }
    if (typeof obj === 'boolean') {
        return obj ? 'true' : 'false';
    }

    if (typeof obj === 'string') {
        return inspectString(obj, opts);
    }
    if (typeof obj === 'number') {
        if (obj === 0) {
            return Infinity / obj > 0 ? '0' : '-0';
        }
        var str = String(obj);
        return numericSeparator ? addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }

    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') { depth = 0; }
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
        return isArray(obj) ? '[Array]' : '[Object]';
    }

    var indent = getIndent(opts, depth);

    if (typeof seen === 'undefined') {
        seen = [];
    } else if (indexOf(seen, obj) >= 0) {
        return '[Circular]';
    }

    function inspect(value, from, noIndent) {
        if (from) {
            seen = $arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if (has(opts, 'quoteStyle')) {
                newOpts.quoteStyle = opts.quoteStyle;
            }
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }

    if (typeof obj === 'function' && !isRegExp(obj)) { // in older engines, regexes are callable
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $join.call(keys, ', ') + ' }' : '');
    }
    if (isSymbol(obj)) {
        var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
        return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
        var s = '<' + $toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for (var i = 0; i < attrs.length; i++) {
            s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
        }
        s += '>';
        if (obj.childNodes && obj.childNodes.length) { s += '...'; }
        s += '</' + $toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if (isArray(obj)) {
        if (obj.length === 0) { return '[]'; }
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) {
            return '[' + indentedJoin(xs, indent) + ']';
        }
        return '[ ' + $join.call(xs, ', ') + ' ]';
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !isEnumerable.call(obj, 'cause')) {
            return '{ [' + String(obj) + '] ' + $join.call($concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        }
        if (parts.length === 0) { return '[' + String(obj) + ']'; }
        return '{ [' + String(obj) + '] ' + $join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === 'function' && utilInspect) {
            return utilInspect(obj, { depth: maxDepth - depth });
        } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
            return obj.inspect();
        }
    }
    if (isMap(obj)) {
        var mapParts = [];
        if (mapForEach) {
            mapForEach.call(obj, function (value, key) {
                mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
            });
        }
        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
    }
    if (isSet(obj)) {
        var setParts = [];
        if (setForEach) {
            setForEach.call(obj, function (value) {
                setParts.push(inspect(value, obj));
            });
        }
        return collectionOf('Set', setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) {
        return weakCollectionOf('WeakMap');
    }
    if (isWeakSet(obj)) {
        return weakCollectionOf('WeakSet');
    }
    if (isWeakRef(obj)) {
        return weakCollectionOf('WeakRef');
    }
    if (isNumber(obj)) {
        return markBoxed(inspect(Number(obj)));
    }
    if (isBigInt(obj)) {
        return markBoxed(inspect(bigIntValueOf.call(obj)));
    }
    if (isBoolean(obj)) {
        return markBoxed(booleanValueOf.call(obj));
    }
    if (isString(obj)) {
        return markBoxed(inspect(String(obj)));
    }
    if (!isDate(obj) && !isRegExp(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $join.call($concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) { return tag + '{}'; }
        if (indent) {
            return tag + '{' + indentedJoin(ys, indent) + '}';
        }
        return tag + '{ ' + $join.call(ys, ', ') + ' }';
    }
    return String(obj);
};

function wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === 'double' ? '"' : "'";
    return quoteChar + s + quoteChar;
}

function quote(s) {
    return $replace.call(String(s), /"/g, '&quot;');
}

function isArray(obj) { return toStr(obj) === '[object Array]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isDate(obj) { return toStr(obj) === '[object Date]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isRegExp(obj) { return toStr(obj) === '[object RegExp]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isError(obj) { return toStr(obj) === '[object Error]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isString(obj) { return toStr(obj) === '[object String]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isNumber(obj) { return toStr(obj) === '[object Number]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isBoolean(obj) { return toStr(obj) === '[object Boolean]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }

// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol(obj) {
    if (hasShammedSymbols) {
        return obj && typeof obj === 'object' && obj instanceof Symbol;
    }
    if (typeof obj === 'symbol') {
        return true;
    }
    if (!obj || typeof obj !== 'object' || !symToString) {
        return false;
    }
    try {
        symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}

function isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !bigIntValueOf) {
        return false;
    }
    try {
        bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}

var hasOwn = Object.prototype.hasOwnProperty || function (key) { return key in this; };
function has(obj, key) {
    return hasOwn.call(obj, key);
}

function toStr(obj) {
    return objectToString.call(obj);
}

function nameOf(f) {
    if (f.name) { return f.name; }
    var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) { return m[1]; }
    return null;
}

function indexOf(xs, x) {
    if (xs.indexOf) { return xs.indexOf(x); }
    for (var i = 0, l = xs.length; i < l; i++) {
        if (xs[i] === x) { return i; }
    }
    return -1;
}

function isMap(x) {
    if (!mapSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakRef(x) {
    if (!weakRefDeref || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}

function isSet(x) {
    if (!setSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isElement(x) {
    if (!x || typeof x !== 'object') { return false; }
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
        return true;
    }
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}

function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = $replace.call($replace.call(str, /(['\\])/g, '\\$1'), /[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, 'single', opts);
}

function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) { return '\\' + x; }
    return '\\x' + (n < 0x10 ? '0' : '') + $toUpperCase.call(n.toString(16));
}

function markBoxed(str) {
    return 'Object(' + str + ')';
}

function weakCollectionOf(type) {
    return type + ' { ? }';
}

function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}

function singleLineValues(xs) {
    for (var i = 0; i < xs.length; i++) {
        if (indexOf(xs[i], '\n') >= 0) {
            return false;
        }
    }
    return true;
}

function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') {
        baseIndent = '\t';
    } else if (typeof opts.indent === 'number' && opts.indent > 0) {
        baseIndent = $join.call(Array(opts.indent + 1), ' ');
    } else {
        return null;
    }
    return {
        base: baseIndent,
        prev: $join.call(Array(depth + 1), baseIndent)
    };
}

function indentedJoin(xs, indent) {
    if (xs.length === 0) { return ''; }
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}

function arrObjKeys(obj, inspect) {
    var isArr = isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for (var i = 0; i < obj.length; i++) {
            xs[i] = has(obj, i) ? inspect(obj[i], obj) : '';
        }
    }
    var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
        symMap = {};
        for (var k = 0; k < syms.length; k++) {
            symMap['$' + syms[k]] = syms[k];
        }
    }

    for (var key in obj) { // eslint-disable-line no-restricted-syntax
        if (!has(obj, key)) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
            // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
            continue; // eslint-disable-line no-restricted-syntax, no-continue
        } else if ($test.call(/[^\w$]/, key)) {
            xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        } else {
            xs.push(key + ': ' + inspect(obj[key], obj));
        }
    }
    if (typeof gOPS === 'function') {
        for (var j = 0; j < syms.length; j++) {
            if (isEnumerable.call(obj, syms[j])) {
                xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
            }
        }
    }
    return xs;
}


/***/ }),

/***/ 14224:
/***/ ((module) => {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ 20061:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


const canPromise = __webpack_require__(2999)

const QRCode = __webpack_require__(43451)
const CanvasRenderer = __webpack_require__(42513)
const SvgRenderer = __webpack_require__(51478)

function renderCanvas (renderFunc, canvas, text, opts, cb) {
  const args = [].slice.call(arguments, 1)
  const argsNum = args.length
  const isLastArgCb = typeof args[argsNum - 1] === 'function'

  if (!isLastArgCb && !canPromise()) {
    throw new Error('Callback required as last argument')
  }

  if (isLastArgCb) {
    if (argsNum < 2) {
      throw new Error('Too few arguments provided')
    }

    if (argsNum === 2) {
      cb = text
      text = canvas
      canvas = opts = undefined
    } else if (argsNum === 3) {
      if (canvas.getContext && typeof cb === 'undefined') {
        cb = opts
        opts = undefined
      } else {
        cb = opts
        opts = text
        text = canvas
        canvas = undefined
      }
    }
  } else {
    if (argsNum < 1) {
      throw new Error('Too few arguments provided')
    }

    if (argsNum === 1) {
      text = canvas
      canvas = opts = undefined
    } else if (argsNum === 2 && !canvas.getContext) {
      opts = text
      text = canvas
      canvas = undefined
    }

    return new Promise(function (resolve, reject) {
      try {
        const data = QRCode.create(text, opts)
        resolve(renderFunc(data, canvas, opts))
      } catch (e) {
        reject(e)
      }
    })
  }

  try {
    const data = QRCode.create(text, opts)
    cb(null, renderFunc(data, canvas, opts))
  } catch (e) {
    cb(e)
  }
}

exports.create = QRCode.create
exports.toCanvas = renderCanvas.bind(null, CanvasRenderer.render)
exports.toDataURL = renderCanvas.bind(null, CanvasRenderer.renderToDataURL)

// only svg for now.
exports.toString = renderCanvas.bind(null, function (data, _, opts) {
  return SvgRenderer.render(data, opts)
})


/***/ }),

/***/ 2999:
/***/ ((module) => {

// can-promise has a crash in some versions of react native that dont have
// standard global objects
// https://github.com/soldair/node-qrcode/issues/157

module.exports = function () {
  return typeof Promise === 'function' && Promise.prototype && Promise.prototype.then
}


/***/ }),

/***/ 96684:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/**
 * Alignment pattern are fixed reference pattern in defined positions
 * in a matrix symbology, which enables the decode software to re-synchronise
 * the coordinate mapping of the image modules in the event of moderate amounts
 * of distortion of the image.
 *
 * Alignment patterns are present only in QR Code symbols of version 2 or larger
 * and their number depends on the symbol version.
 */

const getSymbolSize = (__webpack_require__(79006).getSymbolSize)

/**
 * Calculate the row/column coordinates of the center module of each alignment pattern
 * for the specified QR Code version.
 *
 * The alignment patterns are positioned symmetrically on either side of the diagonal
 * running from the top left corner of the symbol to the bottom right corner.
 *
 * Since positions are simmetrical only half of the coordinates are returned.
 * Each item of the array will represent in turn the x and y coordinate.
 * @see {@link getPositions}
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinate
 */
exports.getRowColCoords = function getRowColCoords (version) {
  if (version === 1) return []

  const posCount = Math.floor(version / 7) + 2
  const size = getSymbolSize(version)
  const intervals = size === 145 ? 26 : Math.ceil((size - 13) / (2 * posCount - 2)) * 2
  const positions = [size - 7] // Last coord is always (size - 7)

  for (let i = 1; i < posCount - 1; i++) {
    positions[i] = positions[i - 1] - intervals
  }

  positions.push(6) // First coord is always 6

  return positions.reverse()
}

/**
 * Returns an array containing the positions of each alignment pattern.
 * Each array's element represent the center point of the pattern as (x, y) coordinates
 *
 * Coordinates are calculated expanding the row/column coordinates returned by {@link getRowColCoords}
 * and filtering out the items that overlaps with finder pattern
 *
 * @example
 * For a Version 7 symbol {@link getRowColCoords} returns values 6, 22 and 38.
 * The alignment patterns, therefore, are to be centered on (row, column)
 * positions (6,22), (22,6), (22,22), (22,38), (38,22), (38,38).
 * Note that the coordinates (6,6), (6,38), (38,6) are occupied by finder patterns
 * and are not therefore used for alignment patterns.
 *
 * let pos = getPositions(7)
 * // [[6,22], [22,6], [22,22], [22,38], [38,22], [38,38]]
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */
exports.getPositions = function getPositions (version) {
  const coords = []
  const pos = exports.getRowColCoords(version)
  const posLength = pos.length

  for (let i = 0; i < posLength; i++) {
    for (let j = 0; j < posLength; j++) {
      // Skip if position is occupied by finder patterns
      if ((i === 0 && j === 0) || // top-left
          (i === 0 && j === posLength - 1) || // bottom-left
          (i === posLength - 1 && j === 0)) { // top-right
        continue
      }

      coords.push([pos[i], pos[j]])
    }
  }

  return coords
}


/***/ }),

/***/ 89012:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

const Mode = __webpack_require__(21493)

/**
 * Array of characters available in alphanumeric mode
 *
 * As per QR Code specification, to each character
 * is assigned a value from 0 to 44 which in this case coincides
 * with the array index
 *
 * @type {Array}
 */
const ALPHA_NUM_CHARS = [
  '0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
  'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M',
  'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z',
  ' ', '$', '%', '*', '+', '-', '.', '/', ':'
]

function AlphanumericData (data) {
  this.mode = Mode.ALPHANUMERIC
  this.data = data
}

AlphanumericData.getBitsLength = function getBitsLength (length) {
  return 11 * Math.floor(length / 2) + 6 * (length % 2)
}

AlphanumericData.prototype.getLength = function getLength () {
  return this.data.length
}

AlphanumericData.prototype.getBitsLength = function getBitsLength () {
  return AlphanumericData.getBitsLength(this.data.length)
}

AlphanumericData.prototype.write = function write (bitBuffer) {
  let i

  // Input data characters are divided into groups of two characters
  // and encoded as 11-bit binary codes.
  for (i = 0; i + 2 <= this.data.length; i += 2) {
    // The character value of the first character is multiplied by 45
    let value = ALPHA_NUM_CHARS.indexOf(this.data[i]) * 45

    // The character value of the second digit is added to the product
    value += ALPHA_NUM_CHARS.indexOf(this.data[i + 1])

    // The sum is then stored as 11-bit binary number
    bitBuffer.put(value, 11)
  }

  // If the number of input data characters is not a multiple of two,
  // the character value of the final character is encoded as a 6-bit binary number.
  if (this.data.length % 2) {
    bitBuffer.put(ALPHA_NUM_CHARS.indexOf(this.data[i]), 6)
  }
}

module.exports = AlphanumericData


/***/ }),

/***/ 16597:
/***/ ((module) => {

function BitBuffer () {
  this.buffer = []
  this.length = 0
}

BitBuffer.prototype = {

  get: function (index) {
    const bufIndex = Math.floor(index / 8)
    return ((this.buffer[bufIndex] >>> (7 - index % 8)) & 1) === 1
  },

  put: function (num, length) {
    for (let i = 0; i < length; i++) {
      this.putBit(((num >>> (length - i - 1)) & 1) === 1)
    }
  },

  getLengthInBits: function () {
    return this.length
  },

  putBit: function (bit) {
    const bufIndex = Math.floor(this.length / 8)
    if (this.buffer.length <= bufIndex) {
      this.buffer.push(0)
    }

    if (bit) {
      this.buffer[bufIndex] |= (0x80 >>> (this.length % 8))
    }

    this.length++
  }
}

module.exports = BitBuffer


/***/ }),

/***/ 79913:
/***/ ((module) => {

/**
 * Helper class to handle QR Code symbol modules
 *
 * @param {Number} size Symbol size
 */
function BitMatrix (size) {
  if (!size || size < 1) {
    throw new Error('BitMatrix size must be defined and greater than 0')
  }

  this.size = size
  this.data = new Uint8Array(size * size)
  this.reservedBit = new Uint8Array(size * size)
}

/**
 * Set bit value at specified location
 * If reserved flag is set, this bit will be ignored during masking process
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 * @param {Boolean} reserved
 */
BitMatrix.prototype.set = function (row, col, value, reserved) {
  const index = row * this.size + col
  this.data[index] = value
  if (reserved) this.reservedBit[index] = true
}

/**
 * Returns bit value at specified location
 *
 * @param  {Number}  row
 * @param  {Number}  col
 * @return {Boolean}
 */
BitMatrix.prototype.get = function (row, col) {
  return this.data[row * this.size + col]
}

/**
 * Applies xor operator at specified location
 * (used during masking process)
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 */
BitMatrix.prototype.xor = function (row, col, value) {
  this.data[row * this.size + col] ^= value
}

/**
 * Check if bit at specified location is reserved
 *
 * @param {Number}   row
 * @param {Number}   col
 * @return {Boolean}
 */
BitMatrix.prototype.isReserved = function (row, col) {
  return this.reservedBit[row * this.size + col]
}

module.exports = BitMatrix


/***/ }),

/***/ 89735:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

const Mode = __webpack_require__(21493)

function ByteData (data) {
  this.mode = Mode.BYTE
  if (typeof (data) === 'string') {
    this.data = new TextEncoder().encode(data)
  } else {
    this.data = new Uint8Array(data)
  }
}

ByteData.getBitsLength = function getBitsLength (length) {
  return length * 8
}

ByteData.prototype.getLength = function getLength () {
  return this.data.length
}

ByteData.prototype.getBitsLength = function getBitsLength () {
  return ByteData.getBitsLength(this.data.length)
}

ByteData.prototype.write = function (bitBuffer) {
  for (let i = 0, l = this.data.length; i < l; i++) {
    bitBuffer.put(this.data[i], 8)
  }
}

module.exports = ByteData


/***/ }),

/***/ 13675:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

const ECLevel = __webpack_require__(17630)

const EC_BLOCKS_TABLE = [
// L  M  Q  H
  1, 1, 1, 1,
  1, 1, 1, 1,
  1, 1, 2, 2,
  1, 2, 2, 4,
  1, 2, 4, 4,
  2, 4, 4, 4,
  2, 4, 6, 5,
  2, 4, 6, 6,
  2, 5, 8, 8,
  4, 5, 8, 8,
  4, 5, 8, 11,
  4, 8, 10, 11,
  4, 9, 12, 16,
  4, 9, 16, 16,
  6, 10, 12, 18,
  6, 10, 17, 16,
  6, 11, 16, 19,
  6, 13, 18, 21,
  7, 14, 21, 25,
  8, 16, 20, 25,
  8, 17, 23, 25,
  9, 17, 23, 34,
  9, 18, 25, 30,
  10, 20, 27, 32,
  12, 21, 29, 35,
  12, 23, 34, 37,
  12, 25, 34, 40,
  13, 26, 35, 42,
  14, 28, 38, 45,
  15, 29, 40, 48,
  16, 31, 43, 51,
  17, 33, 45, 54,
  18, 35, 48, 57,
  19, 37, 51, 60,
  19, 38, 53, 63,
  20, 40, 56, 66,
  21, 43, 59, 70,
  22, 45, 62, 74,
  24, 47, 65, 77,
  25, 49, 68, 81
]

const EC_CODEWORDS_TABLE = [
// L  M  Q  H
  7, 10, 13, 17,
  10, 16, 22, 28,
  15, 26, 36, 44,
  20, 36, 52, 64,
  26, 48, 72, 88,
  36, 64, 96, 112,
  40, 72, 108, 130,
  48, 88, 132, 156,
  60, 110, 160, 192,
  72, 130, 192, 224,
  80, 150, 224, 264,
  96, 176, 260, 308,
  104, 198, 288, 352,
  120, 216, 320, 384,
  132, 240, 360, 432,
  144, 280, 408, 480,
  168, 308, 448, 532,
  180, 338, 504, 588,
  196, 364, 546, 650,
  224, 416, 600, 700,
  224, 442, 644, 750,
  252, 476, 690, 816,
  270, 504, 750, 900,
  300, 560, 810, 960,
  312, 588, 870, 1050,
  336, 644, 952, 1110,
  360, 700, 1020, 1200,
  390, 728, 1050, 1260,
  420, 784, 1140, 1350,
  450, 812, 1200, 1440,
  480, 868, 1290, 1530,
  510, 924, 1350, 1620,
  540, 980, 1440, 1710,
  570, 1036, 1530, 1800,
  570, 1064, 1590, 1890,
  600, 1120, 1680, 1980,
  630, 1204, 1770, 2100,
  660, 1260, 1860, 2220,
  720, 1316, 1950, 2310,
  750, 1372, 2040, 2430
]

/**
 * Returns the number of error correction block that the QR Code should contain
 * for the specified version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction blocks
 */
exports.getBlocksCount = function getBlocksCount (version, errorCorrectionLevel) {
  switch (errorCorrectionLevel) {
    case ECLevel.L:
      return EC_BLOCKS_TABLE[(version - 1) * 4 + 0]
    case ECLevel.M:
      return EC_BLOCKS_TABLE[(version - 1) * 4 + 1]
    case ECLevel.Q:
      return EC_BLOCKS_TABLE[(version - 1) * 4 + 2]
    case ECLevel.H:
      return EC_BLOCKS_TABLE[(version - 1) * 4 + 3]
    default:
      return undefined
  }
}

/**
 * Returns the number of error correction codewords to use for the specified
 * version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction codewords
 */
exports.getTotalCodewordsCount = function getTotalCodewordsCount (version, errorCorrectionLevel) {
  switch (errorCorrectionLevel) {
    case ECLevel.L:
      return EC_CODEWORDS_TABLE[(version - 1) * 4 + 0]
    case ECLevel.M:
      return EC_CODEWORDS_TABLE[(version - 1) * 4 + 1]
    case ECLevel.Q:
      return EC_CODEWORDS_TABLE[(version - 1) * 4 + 2]
    case ECLevel.H:
      return EC_CODEWORDS_TABLE[(version - 1) * 4 + 3]
    default:
      return undefined
  }
}


/***/ }),

/***/ 17630:
/***/ ((__unused_webpack_module, exports) => {

exports.L = { bit: 1 }
exports.M = { bit: 0 }
exports.Q = { bit: 3 }
exports.H = { bit: 2 }

function fromString (string) {
  if (typeof string !== 'string') {
    throw new Error('Param is not a string')
  }

  const lcStr = string.toLowerCase()

  switch (lcStr) {
    case 'l':
    case 'low':
      return exports.L

    case 'm':
    case 'medium':
      return exports.M

    case 'q':
    case 'quartile':
      return exports.Q

    case 'h':
    case 'high':
      return exports.H

    default:
      throw new Error('Unknown EC Level: ' + string)
  }
}

exports.isValid = function isValid (level) {
  return level && typeof level.bit !== 'undefined' &&
    level.bit >= 0 && level.bit < 4
}

exports.from = function from (value, defaultValue) {
  if (exports.isValid(value)) {
    return value
  }

  try {
    return fromString(value)
  } catch (e) {
    return defaultValue
  }
}


/***/ }),

/***/ 80844:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

const getSymbolSize = (__webpack_require__(79006).getSymbolSize)
const FINDER_PATTERN_SIZE = 7

/**
 * Returns an array containing the positions of each finder pattern.
 * Each array's element represent the top-left point of the pattern as (x, y) coordinates
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */
exports.getPositions = function getPositions (version) {
  const size = getSymbolSize(version)

  return [
    // top-left
    [0, 0],
    // top-right
    [size - FINDER_PATTERN_SIZE, 0],
    // bottom-left
    [0, size - FINDER_PATTERN_SIZE]
  ]
}


/***/ }),

/***/ 20114:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

const Utils = __webpack_require__(79006)

const G15 = (1 << 10) | (1 << 8) | (1 << 5) | (1 << 4) | (1 << 2) | (1 << 1) | (1 << 0)
const G15_MASK = (1 << 14) | (1 << 12) | (1 << 10) | (1 << 4) | (1 << 1)
const G15_BCH = Utils.getBCHDigit(G15)

/**
 * Returns format information with relative error correction bits
 *
 * The format information is a 15-bit sequence containing 5 data bits,
 * with 10 error correction bits calculated using the (15, 5) BCH code.
 *
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Number} mask                 Mask pattern
 * @return {Number}                      Encoded format information bits
 */
exports.getEncodedBits = function getEncodedBits (errorCorrectionLevel, mask) {
  const data = ((errorCorrectionLevel.bit << 3) | mask)
  let d = data << 10

  while (Utils.getBCHDigit(d) - G15_BCH >= 0) {
    d ^= (G15 << (Utils.getBCHDigit(d) - G15_BCH))
  }

  // xor final data with mask pattern in order to ensure that
  // no combination of Error Correction Level and data mask pattern
  // will result in an all-zero data string
  return ((data << 10) | d) ^ G15_MASK
}


/***/ }),

/***/ 63278:
/***/ ((__unused_webpack_module, exports) => {

const EXP_TABLE = new Uint8Array(512)
const LOG_TABLE = new Uint8Array(256)
/**
 * Precompute the log and anti-log tables for faster computation later
 *
 * For each possible value in the galois field 2^8, we will pre-compute
 * the logarithm and anti-logarithm (exponential) of this value
 *
 * ref {@link https://en.wikiversity.org/wiki/Reed%E2%80%93Solomon_codes_for_coders#Introduction_to_mathematical_fields}
 */
;(function initTables () {
  let x = 1
  for (let i = 0; i < 255; i++) {
    EXP_TABLE[i] = x
    LOG_TABLE[x] = i

    x <<= 1 // multiply by 2

    // The QR code specification says to use byte-wise modulo 100011101 arithmetic.
    // This means that when a number is 256 or larger, it should be XORed with 0x11D.
    if (x & 0x100) { // similar to x >= 256, but a lot faster (because 0x100 == 256)
      x ^= 0x11D
    }
  }

  // Optimization: double the size of the anti-log table so that we don't need to mod 255 to
  // stay inside the bounds (because we will mainly use this table for the multiplication of
  // two GF numbers, no more).
  // @see {@link mul}
  for (let i = 255; i < 512; i++) {
    EXP_TABLE[i] = EXP_TABLE[i - 255]
  }
}())

/**
 * Returns log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */
exports.log = function log (n) {
  if (n < 1) throw new Error('log(' + n + ')')
  return LOG_TABLE[n]
}

/**
 * Returns anti-log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */
exports.exp = function exp (n) {
  return EXP_TABLE[n]
}

/**
 * Multiplies two number inside Galois Field
 *
 * @param  {Number} x
 * @param  {Number} y
 * @return {Number}
 */
exports.mul = function mul (x, y) {
  if (x === 0 || y === 0) return 0

  // should be EXP_TABLE[(LOG_TABLE[x] + LOG_TABLE[y]) % 255] if EXP_TABLE wasn't oversized
  // @see {@link initTables}
  return EXP_TABLE[LOG_TABLE[x] + LOG_TABLE[y]]
}


/***/ }),

/***/ 59359:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

const Mode = __webpack_require__(21493)
const Utils = __webpack_require__(79006)

function KanjiData (data) {
  this.mode = Mode.KANJI
  this.data = data
}

KanjiData.getBitsLength = function getBitsLength (length) {
  return length * 13
}

KanjiData.prototype.getLength = function getLength () {
  return this.data.length
}

KanjiData.prototype.getBitsLength = function getBitsLength () {
  return KanjiData.getBitsLength(this.data.length)
}

KanjiData.prototype.write = function (bitBuffer) {
  let i

  // In the Shift JIS system, Kanji characters are represented by a two byte combination.
  // These byte values are shifted from the JIS X 0208 values.
  // JIS X 0208 gives details of the shift coded representation.
  for (i = 0; i < this.data.length; i++) {
    let value = Utils.toSJIS(this.data[i])

    // For characters with Shift JIS values from 0x8140 to 0x9FFC:
    if (value >= 0x8140 && value <= 0x9FFC) {
      // Subtract 0x8140 from Shift JIS value
      value -= 0x8140

    // For characters with Shift JIS values from 0xE040 to 0xEBBF
    } else if (value >= 0xE040 && value <= 0xEBBF) {
      // Subtract 0xC140 from Shift JIS value
      value -= 0xC140
    } else {
      throw new Error(
        'Invalid SJIS character: ' + this.data[i] + '\n' +
        'Make sure your charset is UTF-8')
    }

    // Multiply most significant byte of result by 0xC0
    // and add least significant byte to product
    value = (((value >>> 8) & 0xff) * 0xC0) + (value & 0xff)

    // Convert result to a 13-bit binary string
    bitBuffer.put(value, 13)
  }
}

module.exports = KanjiData


/***/ }),

/***/ 95040:
/***/ ((__unused_webpack_module, exports) => {

/**
 * Data mask pattern reference
 * @type {Object}
 */
exports.Patterns = {
  PATTERN000: 0,
  PATTERN001: 1,
  PATTERN010: 2,
  PATTERN011: 3,
  PATTERN100: 4,
  PATTERN101: 5,
  PATTERN110: 6,
  PATTERN111: 7
}

/**
 * Weighted penalty scores for the undesirable features
 * @type {Object}
 */
const PenaltyScores = {
  N1: 3,
  N2: 3,
  N3: 40,
  N4: 10
}

/**
 * Check if mask pattern value is valid
 *
 * @param  {Number}  mask    Mask pattern
 * @return {Boolean}         true if valid, false otherwise
 */
exports.isValid = function isValid (mask) {
  return mask != null && mask !== '' && !isNaN(mask) && mask >= 0 && mask <= 7
}

/**
 * Returns mask pattern from a value.
 * If value is not valid, returns undefined
 *
 * @param  {Number|String} value        Mask pattern value
 * @return {Number}                     Valid mask pattern or undefined
 */
exports.from = function from (value) {
  return exports.isValid(value) ? parseInt(value, 10) : undefined
}

/**
* Find adjacent modules in row/column with the same color
* and assign a penalty value.
*
* Points: N1 + i
* i is the amount by which the number of adjacent modules of the same color exceeds 5
*/
exports.getPenaltyN1 = function getPenaltyN1 (data) {
  const size = data.size
  let points = 0
  let sameCountCol = 0
  let sameCountRow = 0
  let lastCol = null
  let lastRow = null

  for (let row = 0; row < size; row++) {
    sameCountCol = sameCountRow = 0
    lastCol = lastRow = null

    for (let col = 0; col < size; col++) {
      let module = data.get(row, col)
      if (module === lastCol) {
        sameCountCol++
      } else {
        if (sameCountCol >= 5) points += PenaltyScores.N1 + (sameCountCol - 5)
        lastCol = module
        sameCountCol = 1
      }

      module = data.get(col, row)
      if (module === lastRow) {
        sameCountRow++
      } else {
        if (sameCountRow >= 5) points += PenaltyScores.N1 + (sameCountRow - 5)
        lastRow = module
        sameCountRow = 1
      }
    }

    if (sameCountCol >= 5) points += PenaltyScores.N1 + (sameCountCol - 5)
    if (sameCountRow >= 5) points += PenaltyScores.N1 + (sameCountRow - 5)
  }

  return points
}

/**
 * Find 2x2 blocks with the same color and assign a penalty value
 *
 * Points: N2 * (m - 1) * (n - 1)
 */
exports.getPenaltyN2 = function getPenaltyN2 (data) {
  const size = data.size
  let points = 0

  for (let row = 0; row < size - 1; row++) {
    for (let col = 0; col < size - 1; col++) {
      const last = data.get(row, col) +
        data.get(row, col + 1) +
        data.get(row + 1, col) +
        data.get(row + 1, col + 1)

      if (last === 4 || last === 0) points++
    }
  }

  return points * PenaltyScores.N2
}

/**
 * Find 1:1:3:1:1 ratio (dark:light:dark:light:dark) pattern in row/column,
 * preceded or followed by light area 4 modules wide
 *
 * Points: N3 * number of pattern found
 */
exports.getPenaltyN3 = function getPenaltyN3 (data) {
  const size = data.size
  let points = 0
  let bitsCol = 0
  let bitsRow = 0

  for (let row = 0; row < size; row++) {
    bitsCol = bitsRow = 0
    for (let col = 0; col < size; col++) {
      bitsCol = ((bitsCol << 1) & 0x7FF) | data.get(row, col)
      if (col >= 10 && (bitsCol === 0x5D0 || bitsCol === 0x05D)) points++

      bitsRow = ((bitsRow << 1) & 0x7FF) | data.get(col, row)
      if (col >= 10 && (bitsRow === 0x5D0 || bitsRow === 0x05D)) points++
    }
  }

  return points * PenaltyScores.N3
}

/**
 * Calculate proportion of dark modules in entire symbol
 *
 * Points: N4 * k
 *
 * k is the rating of the deviation of the proportion of dark modules
 * in the symbol from 50% in steps of 5%
 */
exports.getPenaltyN4 = function getPenaltyN4 (data) {
  let darkCount = 0
  const modulesCount = data.data.length

  for (let i = 0; i < modulesCount; i++) darkCount += data.data[i]

  const k = Math.abs(Math.ceil((darkCount * 100 / modulesCount) / 5) - 10)

  return k * PenaltyScores.N4
}

/**
 * Return mask value at given position
 *
 * @param  {Number} maskPattern Pattern reference value
 * @param  {Number} i           Row
 * @param  {Number} j           Column
 * @return {Boolean}            Mask value
 */
function getMaskAt (maskPattern, i, j) {
  switch (maskPattern) {
    case exports.Patterns.PATTERN000: return (i + j) % 2 === 0
    case exports.Patterns.PATTERN001: return i % 2 === 0
    case exports.Patterns.PATTERN010: return j % 3 === 0
    case exports.Patterns.PATTERN011: return (i + j) % 3 === 0
    case exports.Patterns.PATTERN100: return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 === 0
    case exports.Patterns.PATTERN101: return (i * j) % 2 + (i * j) % 3 === 0
    case exports.Patterns.PATTERN110: return ((i * j) % 2 + (i * j) % 3) % 2 === 0
    case exports.Patterns.PATTERN111: return ((i * j) % 3 + (i + j) % 2) % 2 === 0

    default: throw new Error('bad maskPattern:' + maskPattern)
  }
}

/**
 * Apply a mask pattern to a BitMatrix
 *
 * @param  {Number}    pattern Pattern reference number
 * @param  {BitMatrix} data    BitMatrix data
 */
exports.applyMask = function applyMask (pattern, data) {
  const size = data.size

  for (let col = 0; col < size; col++) {
    for (let row = 0; row < size; row++) {
      if (data.isReserved(row, col)) continue
      data.xor(row, col, getMaskAt(pattern, row, col))
    }
  }
}

/**
 * Returns the best mask pattern for data
 *
 * @param  {BitMatrix} data
 * @return {Number} Mask pattern reference number
 */
exports.getBestMask = function getBestMask (data, setupFormatFunc) {
  const numPatterns = Object.keys(exports.Patterns).length
  let bestPattern = 0
  let lowerPenalty = Infinity

  for (let p = 0; p < numPatterns; p++) {
    setupFormatFunc(p)
    exports.applyMask(p, data)

    // Calculate penalty
    const penalty =
      exports.getPenaltyN1(data) +
      exports.getPenaltyN2(data) +
      exports.getPenaltyN3(data) +
      exports.getPenaltyN4(data)

    // Undo previously applied mask
    exports.applyMask(p, data)

    if (penalty < lowerPenalty) {
      lowerPenalty = penalty
      bestPattern = p
    }
  }

  return bestPattern
}


/***/ }),

/***/ 21493:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

const VersionCheck = __webpack_require__(43327)
const Regex = __webpack_require__(95270)

/**
 * Numeric mode encodes data from the decimal digit set (0 - 9)
 * (byte values 30HEX to 39HEX).
 * Normally, 3 data characters are represented by 10 bits.
 *
 * @type {Object}
 */
exports.NUMERIC = {
  id: 'Numeric',
  bit: 1 << 0,
  ccBits: [10, 12, 14]
}

/**
 * Alphanumeric mode encodes data from a set of 45 characters,
 * i.e. 10 numeric digits (0 - 9),
 *      26 alphabetic characters (A - Z),
 *   and 9 symbols (SP, $, %, *, +, -, ., /, :).
 * Normally, two input characters are represented by 11 bits.
 *
 * @type {Object}
 */
exports.ALPHANUMERIC = {
  id: 'Alphanumeric',
  bit: 1 << 1,
  ccBits: [9, 11, 13]
}

/**
 * In byte mode, data is encoded at 8 bits per character.
 *
 * @type {Object}
 */
exports.BYTE = {
  id: 'Byte',
  bit: 1 << 2,
  ccBits: [8, 16, 16]
}

/**
 * The Kanji mode efficiently encodes Kanji characters in accordance with
 * the Shift JIS system based on JIS X 0208.
 * The Shift JIS values are shifted from the JIS X 0208 values.
 * JIS X 0208 gives details of the shift coded representation.
 * Each two-byte character value is compacted to a 13-bit binary codeword.
 *
 * @type {Object}
 */
exports.KANJI = {
  id: 'Kanji',
  bit: 1 << 3,
  ccBits: [8, 10, 12]
}

/**
 * Mixed mode will contain a sequences of data in a combination of any of
 * the modes described above
 *
 * @type {Object}
 */
exports.MIXED = {
  bit: -1
}

/**
 * Returns the number of bits needed to store the data length
 * according to QR Code specifications.
 *
 * @param  {Mode}   mode    Data mode
 * @param  {Number} version QR Code version
 * @return {Number}         Number of bits
 */
exports.getCharCountIndicator = function getCharCountIndicator (mode, version) {
  if (!mode.ccBits) throw new Error('Invalid mode: ' + mode)

  if (!VersionCheck.isValid(version)) {
    throw new Error('Invalid version: ' + version)
  }

  if (version >= 1 && version < 10) return mode.ccBits[0]
  else if (version < 27) return mode.ccBits[1]
  return mode.ccBits[2]
}

/**
 * Returns the most efficient mode to store the specified data
 *
 * @param  {String} dataStr Input data string
 * @return {Mode}           Best mode
 */
exports.getBestModeForData = function getBestModeForData (dataStr) {
  if (Regex.testNumeric(dataStr)) return exports.NUMERIC
  else if (Regex.testAlphanumeric(dataStr)) return exports.ALPHANUMERIC
  else if (Regex.testKanji(dataStr)) return exports.KANJI
  else return exports.BYTE
}

/**
 * Return mode name as string
 *
 * @param {Mode} mode Mode object
 * @returns {String}  Mode name
 */
exports.toString = function toString (mode) {
  if (mode && mode.id) return mode.id
  throw new Error('Invalid mode')
}

/**
 * Check if input param is a valid mode object
 *
 * @param   {Mode}    mode Mode object
 * @returns {Boolean} True if valid mode, false otherwise
 */
exports.isValid = function isValid (mode) {
  return mode && mode.bit && mode.ccBits
}

/**
 * Get mode object from its name
 *
 * @param   {String} string Mode name
 * @returns {Mode}          Mode object
 */
function fromString (string) {
  if (typeof string !== 'string') {
    throw new Error('Param is not a string')
  }

  const lcStr = string.toLowerCase()

  switch (lcStr) {
    case 'numeric':
      return exports.NUMERIC
    case 'alphanumeric':
      return exports.ALPHANUMERIC
    case 'kanji':
      return exports.KANJI
    case 'byte':
      return exports.BYTE
    default:
      throw new Error('Unknown mode: ' + string)
  }
}

/**
 * Returns mode from a value.
 * If value is not a valid mode, returns defaultValue
 *
 * @param  {Mode|String} value        Encoding mode
 * @param  {Mode}        defaultValue Fallback value
 * @return {Mode}                     Encoding mode
 */
exports.from = function from (value, defaultValue) {
  if (exports.isValid(value)) {
    return value
  }

  try {
    return fromString(value)
  } catch (e) {
    return defaultValue
  }
}


/***/ }),

/***/ 92818:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

const Mode = __webpack_require__(21493)

function NumericData (data) {
  this.mode = Mode.NUMERIC
  this.data = data.toString()
}

NumericData.getBitsLength = function getBitsLength (length) {
  return 10 * Math.floor(length / 3) + ((length % 3) ? ((length % 3) * 3 + 1) : 0)
}

NumericData.prototype.getLength = function getLength () {
  return this.data.length
}

NumericData.prototype.getBitsLength = function getBitsLength () {
  return NumericData.getBitsLength(this.data.length)
}

NumericData.prototype.write = function write (bitBuffer) {
  let i, group, value

  // The input data string is divided into groups of three digits,
  // and each group is converted to its 10-bit binary equivalent.
  for (i = 0; i + 3 <= this.data.length; i += 3) {
    group = this.data.substr(i, 3)
    value = parseInt(group, 10)

    bitBuffer.put(value, 10)
  }

  // If the number of input digits is not an exact multiple of three,
  // the final one or two digits are converted to 4 or 7 bits respectively.
  const remainingNum = this.data.length - i
  if (remainingNum > 0) {
    group = this.data.substr(i)
    value = parseInt(group, 10)

    bitBuffer.put(value, remainingNum * 3 + 1)
  }
}

module.exports = NumericData


/***/ }),

/***/ 42631:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

const GF = __webpack_require__(63278)

/**
 * Multiplies two polynomials inside Galois Field
 *
 * @param  {Uint8Array} p1 Polynomial
 * @param  {Uint8Array} p2 Polynomial
 * @return {Uint8Array}    Product of p1 and p2
 */
exports.mul = function mul (p1, p2) {
  const coeff = new Uint8Array(p1.length + p2.length - 1)

  for (let i = 0; i < p1.length; i++) {
    for (let j = 0; j < p2.length; j++) {
      coeff[i + j] ^= GF.mul(p1[i], p2[j])
    }
  }

  return coeff
}

/**
 * Calculate the remainder of polynomials division
 *
 * @param  {Uint8Array} divident Polynomial
 * @param  {Uint8Array} divisor  Polynomial
 * @return {Uint8Array}          Remainder
 */
exports.mod = function mod (divident, divisor) {
  let result = new Uint8Array(divident)

  while ((result.length - divisor.length) >= 0) {
    const coeff = result[0]

    for (let i = 0; i < divisor.length; i++) {
      result[i] ^= GF.mul(divisor[i], coeff)
    }

    // remove all zeros from buffer head
    let offset = 0
    while (offset < result.length && result[offset] === 0) offset++
    result = result.slice(offset)
  }

  return result
}

/**
 * Generate an irreducible generator polynomial of specified degree
 * (used by Reed-Solomon encoder)
 *
 * @param  {Number} degree Degree of the generator polynomial
 * @return {Uint8Array}    Buffer containing polynomial coefficients
 */
exports.generateECPolynomial = function generateECPolynomial (degree) {
  let poly = new Uint8Array([1])
  for (let i = 0; i < degree; i++) {
    poly = exports.mul(poly, new Uint8Array([1, GF.exp(i)]))
  }

  return poly
}


/***/ }),

/***/ 43451:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

const Utils = __webpack_require__(79006)
const ECLevel = __webpack_require__(17630)
const BitBuffer = __webpack_require__(16597)
const BitMatrix = __webpack_require__(79913)
const AlignmentPattern = __webpack_require__(96684)
const FinderPattern = __webpack_require__(80844)
const MaskPattern = __webpack_require__(95040)
const ECCode = __webpack_require__(13675)
const ReedSolomonEncoder = __webpack_require__(87057)
const Version = __webpack_require__(13761)
const FormatInfo = __webpack_require__(20114)
const Mode = __webpack_require__(21493)
const Segments = __webpack_require__(17506)

/**
 * QRCode for JavaScript
 *
 * modified by Ryan Day for nodejs support
 * Copyright (c) 2011 Ryan Day
 *
 * Licensed under the MIT license:
 *   http://www.opensource.org/licenses/mit-license.php
 *
//---------------------------------------------------------------------
// QRCode for JavaScript
//
// Copyright (c) 2009 Kazuhiko Arase
//
// URL: http://www.d-project.com/
//
// Licensed under the MIT license:
//   http://www.opensource.org/licenses/mit-license.php
//
// The word "QR Code" is registered trademark of
// DENSO WAVE INCORPORATED
//   http://www.denso-wave.com/qrcode/faqpatent-e.html
//
//---------------------------------------------------------------------
*/

/**
 * Add finder patterns bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */
function setupFinderPattern (matrix, version) {
  const size = matrix.size
  const pos = FinderPattern.getPositions(version)

  for (let i = 0; i < pos.length; i++) {
    const row = pos[i][0]
    const col = pos[i][1]

    for (let r = -1; r <= 7; r++) {
      if (row + r <= -1 || size <= row + r) continue

      for (let c = -1; c <= 7; c++) {
        if (col + c <= -1 || size <= col + c) continue

        if ((r >= 0 && r <= 6 && (c === 0 || c === 6)) ||
          (c >= 0 && c <= 6 && (r === 0 || r === 6)) ||
          (r >= 2 && r <= 4 && c >= 2 && c <= 4)) {
          matrix.set(row + r, col + c, true, true)
        } else {
          matrix.set(row + r, col + c, false, true)
        }
      }
    }
  }
}

/**
 * Add timing pattern bits to matrix
 *
 * Note: this function must be called before {@link setupAlignmentPattern}
 *
 * @param  {BitMatrix} matrix Modules matrix
 */
function setupTimingPattern (matrix) {
  const size = matrix.size

  for (let r = 8; r < size - 8; r++) {
    const value = r % 2 === 0
    matrix.set(r, 6, value, true)
    matrix.set(6, r, value, true)
  }
}

/**
 * Add alignment patterns bits to matrix
 *
 * Note: this function must be called after {@link setupTimingPattern}
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */
function setupAlignmentPattern (matrix, version) {
  const pos = AlignmentPattern.getPositions(version)

  for (let i = 0; i < pos.length; i++) {
    const row = pos[i][0]
    const col = pos[i][1]

    for (let r = -2; r <= 2; r++) {
      for (let c = -2; c <= 2; c++) {
        if (r === -2 || r === 2 || c === -2 || c === 2 ||
          (r === 0 && c === 0)) {
          matrix.set(row + r, col + c, true, true)
        } else {
          matrix.set(row + r, col + c, false, true)
        }
      }
    }
  }
}

/**
 * Add version info bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */
function setupVersionInfo (matrix, version) {
  const size = matrix.size
  const bits = Version.getEncodedBits(version)
  let row, col, mod

  for (let i = 0; i < 18; i++) {
    row = Math.floor(i / 3)
    col = i % 3 + size - 8 - 3
    mod = ((bits >> i) & 1) === 1

    matrix.set(row, col, mod, true)
    matrix.set(col, row, mod, true)
  }
}

/**
 * Add format info bits to matrix
 *
 * @param  {BitMatrix} matrix               Modules matrix
 * @param  {ErrorCorrectionLevel}    errorCorrectionLevel Error correction level
 * @param  {Number}    maskPattern          Mask pattern reference value
 */
function setupFormatInfo (matrix, errorCorrectionLevel, maskPattern) {
  const size = matrix.size
  const bits = FormatInfo.getEncodedBits(errorCorrectionLevel, maskPattern)
  let i, mod

  for (i = 0; i < 15; i++) {
    mod = ((bits >> i) & 1) === 1

    // vertical
    if (i < 6) {
      matrix.set(i, 8, mod, true)
    } else if (i < 8) {
      matrix.set(i + 1, 8, mod, true)
    } else {
      matrix.set(size - 15 + i, 8, mod, true)
    }

    // horizontal
    if (i < 8) {
      matrix.set(8, size - i - 1, mod, true)
    } else if (i < 9) {
      matrix.set(8, 15 - i - 1 + 1, mod, true)
    } else {
      matrix.set(8, 15 - i - 1, mod, true)
    }
  }

  // fixed module
  matrix.set(size - 8, 8, 1, true)
}

/**
 * Add encoded data bits to matrix
 *
 * @param  {BitMatrix}  matrix Modules matrix
 * @param  {Uint8Array} data   Data codewords
 */
function setupData (matrix, data) {
  const size = matrix.size
  let inc = -1
  let row = size - 1
  let bitIndex = 7
  let byteIndex = 0

  for (let col = size - 1; col > 0; col -= 2) {
    if (col === 6) col--

    while (true) {
      for (let c = 0; c < 2; c++) {
        if (!matrix.isReserved(row, col - c)) {
          let dark = false

          if (byteIndex < data.length) {
            dark = (((data[byteIndex] >>> bitIndex) & 1) === 1)
          }

          matrix.set(row, col - c, dark)
          bitIndex--

          if (bitIndex === -1) {
            byteIndex++
            bitIndex = 7
          }
        }
      }

      row += inc

      if (row < 0 || size <= row) {
        row -= inc
        inc = -inc
        break
      }
    }
  }
}

/**
 * Create encoded codewords from data input
 *
 * @param  {Number}   version              QR Code version
 * @param  {ErrorCorrectionLevel}   errorCorrectionLevel Error correction level
 * @param  {ByteData} data                 Data input
 * @return {Uint8Array}                    Buffer containing encoded codewords
 */
function createData (version, errorCorrectionLevel, segments) {
  // Prepare data buffer
  const buffer = new BitBuffer()

  segments.forEach(function (data) {
    // prefix data with mode indicator (4 bits)
    buffer.put(data.mode.bit, 4)

    // Prefix data with character count indicator.
    // The character count indicator is a string of bits that represents the
    // number of characters that are being encoded.
    // The character count indicator must be placed after the mode indicator
    // and must be a certain number of bits long, depending on the QR version
    // and data mode
    // @see {@link Mode.getCharCountIndicator}.
    buffer.put(data.getLength(), Mode.getCharCountIndicator(data.mode, version))

    // add binary data sequence to buffer
    data.write(buffer)
  })

  // Calculate required number of bits
  const totalCodewords = Utils.getSymbolTotalCodewords(version)
  const ecTotalCodewords = ECCode.getTotalCodewordsCount(version, errorCorrectionLevel)
  const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8

  // Add a terminator.
  // If the bit string is shorter than the total number of required bits,
  // a terminator of up to four 0s must be added to the right side of the string.
  // If the bit string is more than four bits shorter than the required number of bits,
  // add four 0s to the end.
  if (buffer.getLengthInBits() + 4 <= dataTotalCodewordsBits) {
    buffer.put(0, 4)
  }

  // If the bit string is fewer than four bits shorter, add only the number of 0s that
  // are needed to reach the required number of bits.

  // After adding the terminator, if the number of bits in the string is not a multiple of 8,
  // pad the string on the right with 0s to make the string's length a multiple of 8.
  while (buffer.getLengthInBits() % 8 !== 0) {
    buffer.putBit(0)
  }

  // Add pad bytes if the string is still shorter than the total number of required bits.
  // Extend the buffer to fill the data capacity of the symbol corresponding to
  // the Version and Error Correction Level by adding the Pad Codewords 11101100 (0xEC)
  // and 00010001 (0x11) alternately.
  const remainingByte = (dataTotalCodewordsBits - buffer.getLengthInBits()) / 8
  for (let i = 0; i < remainingByte; i++) {
    buffer.put(i % 2 ? 0x11 : 0xEC, 8)
  }

  return createCodewords(buffer, version, errorCorrectionLevel)
}

/**
 * Encode input data with Reed-Solomon and return codewords with
 * relative error correction bits
 *
 * @param  {BitBuffer} bitBuffer            Data to encode
 * @param  {Number}    version              QR Code version
 * @param  {ErrorCorrectionLevel} errorCorrectionLevel Error correction level
 * @return {Uint8Array}                     Buffer containing encoded codewords
 */
function createCodewords (bitBuffer, version, errorCorrectionLevel) {
  // Total codewords for this QR code version (Data + Error correction)
  const totalCodewords = Utils.getSymbolTotalCodewords(version)

  // Total number of error correction codewords
  const ecTotalCodewords = ECCode.getTotalCodewordsCount(version, errorCorrectionLevel)

  // Total number of data codewords
  const dataTotalCodewords = totalCodewords - ecTotalCodewords

  // Total number of blocks
  const ecTotalBlocks = ECCode.getBlocksCount(version, errorCorrectionLevel)

  // Calculate how many blocks each group should contain
  const blocksInGroup2 = totalCodewords % ecTotalBlocks
  const blocksInGroup1 = ecTotalBlocks - blocksInGroup2

  const totalCodewordsInGroup1 = Math.floor(totalCodewords / ecTotalBlocks)

  const dataCodewordsInGroup1 = Math.floor(dataTotalCodewords / ecTotalBlocks)
  const dataCodewordsInGroup2 = dataCodewordsInGroup1 + 1

  // Number of EC codewords is the same for both groups
  const ecCount = totalCodewordsInGroup1 - dataCodewordsInGroup1

  // Initialize a Reed-Solomon encoder with a generator polynomial of degree ecCount
  const rs = new ReedSolomonEncoder(ecCount)

  let offset = 0
  const dcData = new Array(ecTotalBlocks)
  const ecData = new Array(ecTotalBlocks)
  let maxDataSize = 0
  const buffer = new Uint8Array(bitBuffer.buffer)

  // Divide the buffer into the required number of blocks
  for (let b = 0; b < ecTotalBlocks; b++) {
    const dataSize = b < blocksInGroup1 ? dataCodewordsInGroup1 : dataCodewordsInGroup2

    // extract a block of data from buffer
    dcData[b] = buffer.slice(offset, offset + dataSize)

    // Calculate EC codewords for this data block
    ecData[b] = rs.encode(dcData[b])

    offset += dataSize
    maxDataSize = Math.max(maxDataSize, dataSize)
  }

  // Create final data
  // Interleave the data and error correction codewords from each block
  const data = new Uint8Array(totalCodewords)
  let index = 0
  let i, r

  // Add data codewords
  for (i = 0; i < maxDataSize; i++) {
    for (r = 0; r < ecTotalBlocks; r++) {
      if (i < dcData[r].length) {
        data[index++] = dcData[r][i]
      }
    }
  }

  // Apped EC codewords
  for (i = 0; i < ecCount; i++) {
    for (r = 0; r < ecTotalBlocks; r++) {
      data[index++] = ecData[r][i]
    }
  }

  return data
}

/**
 * Build QR Code symbol
 *
 * @param  {String} data                 Input string
 * @param  {Number} version              QR Code version
 * @param  {ErrorCorretionLevel} errorCorrectionLevel Error level
 * @param  {MaskPattern} maskPattern     Mask pattern
 * @return {Object}                      Object containing symbol data
 */
function createSymbol (data, version, errorCorrectionLevel, maskPattern) {
  let segments

  if (Array.isArray(data)) {
    segments = Segments.fromArray(data)
  } else if (typeof data === 'string') {
    let estimatedVersion = version

    if (!estimatedVersion) {
      const rawSegments = Segments.rawSplit(data)

      // Estimate best version that can contain raw splitted segments
      estimatedVersion = Version.getBestVersionForData(rawSegments, errorCorrectionLevel)
    }

    // Build optimized segments
    // If estimated version is undefined, try with the highest version
    segments = Segments.fromString(data, estimatedVersion || 40)
  } else {
    throw new Error('Invalid data')
  }

  // Get the min version that can contain data
  const bestVersion = Version.getBestVersionForData(segments, errorCorrectionLevel)

  // If no version is found, data cannot be stored
  if (!bestVersion) {
    throw new Error('The amount of data is too big to be stored in a QR Code')
  }

  // If not specified, use min version as default
  if (!version) {
    version = bestVersion

  // Check if the specified version can contain the data
  } else if (version < bestVersion) {
    throw new Error('\n' +
      'The chosen QR Code version cannot contain this amount of data.\n' +
      'Minimum version required to store current data is: ' + bestVersion + '.\n'
    )
  }

  const dataBits = createData(version, errorCorrectionLevel, segments)

  // Allocate matrix buffer
  const moduleCount = Utils.getSymbolSize(version)
  const modules = new BitMatrix(moduleCount)

  // Add function modules
  setupFinderPattern(modules, version)
  setupTimingPattern(modules)
  setupAlignmentPattern(modules, version)

  // Add temporary dummy bits for format info just to set them as reserved.
  // This is needed to prevent these bits from being masked by {@link MaskPattern.applyMask}
  // since the masking operation must be performed only on the encoding region.
  // These blocks will be replaced with correct values later in code.
  setupFormatInfo(modules, errorCorrectionLevel, 0)

  if (version >= 7) {
    setupVersionInfo(modules, version)
  }

  // Add data codewords
  setupData(modules, dataBits)

  if (isNaN(maskPattern)) {
    // Find best mask pattern
    maskPattern = MaskPattern.getBestMask(modules,
      setupFormatInfo.bind(null, modules, errorCorrectionLevel))
  }

  // Apply mask pattern
  MaskPattern.applyMask(maskPattern, modules)

  // Replace format info bits with correct values
  setupFormatInfo(modules, errorCorrectionLevel, maskPattern)

  return {
    modules: modules,
    version: version,
    errorCorrectionLevel: errorCorrectionLevel,
    maskPattern: maskPattern,
    segments: segments
  }
}

/**
 * QR Code
 *
 * @param {String | Array} data                 Input data
 * @param {Object} options                      Optional configurations
 * @param {Number} options.version              QR Code version
 * @param {String} options.errorCorrectionLevel Error correction level
 * @param {Function} options.toSJISFunc         Helper func to convert utf8 to sjis
 */
exports.create = function create (data, options) {
  if (typeof data === 'undefined' || data === '') {
    throw new Error('No input text')
  }

  let errorCorrectionLevel = ECLevel.M
  let version
  let mask

  if (typeof options !== 'undefined') {
    // Use higher error correction level as default
    errorCorrectionLevel = ECLevel.from(options.errorCorrectionLevel, ECLevel.M)
    version = Version.from(options.version)
    mask = MaskPattern.from(options.maskPattern)

    if (options.toSJISFunc) {
      Utils.setToSJISFunction(options.toSJISFunc)
    }
  }

  return createSymbol(data, version, errorCorrectionLevel, mask)
}


/***/ }),

/***/ 87057:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

const Polynomial = __webpack_require__(42631)

function ReedSolomonEncoder (degree) {
  this.genPoly = undefined
  this.degree = degree

  if (this.degree) this.initialize(this.degree)
}

/**
 * Initialize the encoder.
 * The input param should correspond to the number of error correction codewords.
 *
 * @param  {Number} degree
 */
ReedSolomonEncoder.prototype.initialize = function initialize (degree) {
  // create an irreducible generator polynomial
  this.degree = degree
  this.genPoly = Polynomial.generateECPolynomial(this.degree)
}

/**
 * Encodes a chunk of data
 *
 * @param  {Uint8Array} data Buffer containing input data
 * @return {Uint8Array}      Buffer containing encoded data
 */
ReedSolomonEncoder.prototype.encode = function encode (data) {
  if (!this.genPoly) {
    throw new Error('Encoder not initialized')
  }

  // Calculate EC for this data block
  // extends data size to data+genPoly size
  const paddedData = new Uint8Array(data.length + this.degree)
  paddedData.set(data)

  // The error correction codewords are the remainder after dividing the data codewords
  // by a generator polynomial
  const remainder = Polynomial.mod(paddedData, this.genPoly)

  // return EC data blocks (last n byte, where n is the degree of genPoly)
  // If coefficients number in remainder are less than genPoly degree,
  // pad with 0s to the left to reach the needed number of coefficients
  const start = this.degree - remainder.length
  if (start > 0) {
    const buff = new Uint8Array(this.degree)
    buff.set(remainder, start)

    return buff
  }

  return remainder
}

module.exports = ReedSolomonEncoder


/***/ }),

/***/ 95270:
/***/ ((__unused_webpack_module, exports) => {

const numeric = '[0-9]+'
const alphanumeric = '[A-Z $%*+\\-./:]+'
let kanji = '(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|' +
  '[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|' +
  '[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|' +
  '[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+'
kanji = kanji.replace(/u/g, '\\u')

const byte = '(?:(?![A-Z0-9 $%*+\\-./:]|' + kanji + ')(?:.|[\r\n]))+'

exports.KANJI = new RegExp(kanji, 'g')
exports.BYTE_KANJI = new RegExp('[^A-Z0-9 $%*+\\-./:]+', 'g')
exports.BYTE = new RegExp(byte, 'g')
exports.NUMERIC = new RegExp(numeric, 'g')
exports.ALPHANUMERIC = new RegExp(alphanumeric, 'g')

const TEST_KANJI = new RegExp('^' + kanji + '$')
const TEST_NUMERIC = new RegExp('^' + numeric + '$')
const TEST_ALPHANUMERIC = new RegExp('^[A-Z0-9 $%*+\\-./:]+$')

exports.testKanji = function testKanji (str) {
  return TEST_KANJI.test(str)
}

exports.testNumeric = function testNumeric (str) {
  return TEST_NUMERIC.test(str)
}

exports.testAlphanumeric = function testAlphanumeric (str) {
  return TEST_ALPHANUMERIC.test(str)
}


/***/ }),

/***/ 17506:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

const Mode = __webpack_require__(21493)
const NumericData = __webpack_require__(92818)
const AlphanumericData = __webpack_require__(89012)
const ByteData = __webpack_require__(89735)
const KanjiData = __webpack_require__(59359)
const Regex = __webpack_require__(95270)
const Utils = __webpack_require__(79006)
const dijkstra = __webpack_require__(35376)

/**
 * Returns UTF8 byte length
 *
 * @param  {String} str Input string
 * @return {Number}     Number of byte
 */
function getStringByteLength (str) {
  return unescape(encodeURIComponent(str)).length
}

/**
 * Get a list of segments of the specified mode
 * from a string
 *
 * @param  {Mode}   mode Segment mode
 * @param  {String} str  String to process
 * @return {Array}       Array of object with segments data
 */
function getSegments (regex, mode, str) {
  const segments = []
  let result

  while ((result = regex.exec(str)) !== null) {
    segments.push({
      data: result[0],
      index: result.index,
      mode: mode,
      length: result[0].length
    })
  }

  return segments
}

/**
 * Extracts a series of segments with the appropriate
 * modes from a string
 *
 * @param  {String} dataStr Input string
 * @return {Array}          Array of object with segments data
 */
function getSegmentsFromString (dataStr) {
  const numSegs = getSegments(Regex.NUMERIC, Mode.NUMERIC, dataStr)
  const alphaNumSegs = getSegments(Regex.ALPHANUMERIC, Mode.ALPHANUMERIC, dataStr)
  let byteSegs
  let kanjiSegs

  if (Utils.isKanjiModeEnabled()) {
    byteSegs = getSegments(Regex.BYTE, Mode.BYTE, dataStr)
    kanjiSegs = getSegments(Regex.KANJI, Mode.KANJI, dataStr)
  } else {
    byteSegs = getSegments(Regex.BYTE_KANJI, Mode.BYTE, dataStr)
    kanjiSegs = []
  }

  const segs = numSegs.concat(alphaNumSegs, byteSegs, kanjiSegs)

  return segs
    .sort(function (s1, s2) {
      return s1.index - s2.index
    })
    .map(function (obj) {
      return {
        data: obj.data,
        mode: obj.mode,
        length: obj.length
      }
    })
}

/**
 * Returns how many bits are needed to encode a string of
 * specified length with the specified mode
 *
 * @param  {Number} length String length
 * @param  {Mode} mode     Segment mode
 * @return {Number}        Bit length
 */
function getSegmentBitsLength (length, mode) {
  switch (mode) {
    case Mode.NUMERIC:
      return NumericData.getBitsLength(length)
    case Mode.ALPHANUMERIC:
      return AlphanumericData.getBitsLength(length)
    case Mode.KANJI:
      return KanjiData.getBitsLength(length)
    case Mode.BYTE:
      return ByteData.getBitsLength(length)
  }
}

/**
 * Merges adjacent segments which have the same mode
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */
function mergeSegments (segs) {
  return segs.reduce(function (acc, curr) {
    const prevSeg = acc.length - 1 >= 0 ? acc[acc.length - 1] : null
    if (prevSeg && prevSeg.mode === curr.mode) {
      acc[acc.length - 1].data += curr.data
      return acc
    }

    acc.push(curr)
    return acc
  }, [])
}

/**
 * Generates a list of all possible nodes combination which
 * will be used to build a segments graph.
 *
 * Nodes are divided by groups. Each group will contain a list of all the modes
 * in which is possible to encode the given text.
 *
 * For example the text '12345' can be encoded as Numeric, Alphanumeric or Byte.
 * The group for '12345' will contain then 3 objects, one for each
 * possible encoding mode.
 *
 * Each node represents a possible segment.
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */
function buildNodes (segs) {
  const nodes = []
  for (let i = 0; i < segs.length; i++) {
    const seg = segs[i]

    switch (seg.mode) {
      case Mode.NUMERIC:
        nodes.push([seg,
          { data: seg.data, mode: Mode.ALPHANUMERIC, length: seg.length },
          { data: seg.data, mode: Mode.BYTE, length: seg.length }
        ])
        break
      case Mode.ALPHANUMERIC:
        nodes.push([seg,
          { data: seg.data, mode: Mode.BYTE, length: seg.length }
        ])
        break
      case Mode.KANJI:
        nodes.push([seg,
          { data: seg.data, mode: Mode.BYTE, length: getStringByteLength(seg.data) }
        ])
        break
      case Mode.BYTE:
        nodes.push([
          { data: seg.data, mode: Mode.BYTE, length: getStringByteLength(seg.data) }
        ])
    }
  }

  return nodes
}

/**
 * Builds a graph from a list of nodes.
 * All segments in each node group will be connected with all the segments of
 * the next group and so on.
 *
 * At each connection will be assigned a weight depending on the
 * segment's byte length.
 *
 * @param  {Array} nodes    Array of object with segments data
 * @param  {Number} version QR Code version
 * @return {Object}         Graph of all possible segments
 */
function buildGraph (nodes, version) {
  const table = {}
  const graph = { start: {} }
  let prevNodeIds = ['start']

  for (let i = 0; i < nodes.length; i++) {
    const nodeGroup = nodes[i]
    const currentNodeIds = []

    for (let j = 0; j < nodeGroup.length; j++) {
      const node = nodeGroup[j]
      const key = '' + i + j

      currentNodeIds.push(key)
      table[key] = { node: node, lastCount: 0 }
      graph[key] = {}

      for (let n = 0; n < prevNodeIds.length; n++) {
        const prevNodeId = prevNodeIds[n]

        if (table[prevNodeId] && table[prevNodeId].node.mode === node.mode) {
          graph[prevNodeId][key] =
            getSegmentBitsLength(table[prevNodeId].lastCount + node.length, node.mode) -
            getSegmentBitsLength(table[prevNodeId].lastCount, node.mode)

          table[prevNodeId].lastCount += node.length
        } else {
          if (table[prevNodeId]) table[prevNodeId].lastCount = node.length

          graph[prevNodeId][key] = getSegmentBitsLength(node.length, node.mode) +
            4 + Mode.getCharCountIndicator(node.mode, version) // switch cost
        }
      }
    }

    prevNodeIds = currentNodeIds
  }

  for (let n = 0; n < prevNodeIds.length; n++) {
    graph[prevNodeIds[n]].end = 0
  }

  return { map: graph, table: table }
}

/**
 * Builds a segment from a specified data and mode.
 * If a mode is not specified, the more suitable will be used.
 *
 * @param  {String} data             Input data
 * @param  {Mode | String} modesHint Data mode
 * @return {Segment}                 Segment
 */
function buildSingleSegment (data, modesHint) {
  let mode
  const bestMode = Mode.getBestModeForData(data)

  mode = Mode.from(modesHint, bestMode)

  // Make sure data can be encoded
  if (mode !== Mode.BYTE && mode.bit < bestMode.bit) {
    throw new Error('"' + data + '"' +
      ' cannot be encoded with mode ' + Mode.toString(mode) +
      '.\n Suggested mode is: ' + Mode.toString(bestMode))
  }

  // Use Mode.BYTE if Kanji support is disabled
  if (mode === Mode.KANJI && !Utils.isKanjiModeEnabled()) {
    mode = Mode.BYTE
  }

  switch (mode) {
    case Mode.NUMERIC:
      return new NumericData(data)

    case Mode.ALPHANUMERIC:
      return new AlphanumericData(data)

    case Mode.KANJI:
      return new KanjiData(data)

    case Mode.BYTE:
      return new ByteData(data)
  }
}

/**
 * Builds a list of segments from an array.
 * Array can contain Strings or Objects with segment's info.
 *
 * For each item which is a string, will be generated a segment with the given
 * string and the more appropriate encoding mode.
 *
 * For each item which is an object, will be generated a segment with the given
 * data and mode.
 * Objects must contain at least the property "data".
 * If property "mode" is not present, the more suitable mode will be used.
 *
 * @param  {Array} array Array of objects with segments data
 * @return {Array}       Array of Segments
 */
exports.fromArray = function fromArray (array) {
  return array.reduce(function (acc, seg) {
    if (typeof seg === 'string') {
      acc.push(buildSingleSegment(seg, null))
    } else if (seg.data) {
      acc.push(buildSingleSegment(seg.data, seg.mode))
    }

    return acc
  }, [])
}

/**
 * Builds an optimized sequence of segments from a string,
 * which will produce the shortest possible bitstream.
 *
 * @param  {String} data    Input string
 * @param  {Number} version QR Code version
 * @return {Array}          Array of segments
 */
exports.fromString = function fromString (data, version) {
  const segs = getSegmentsFromString(data, Utils.isKanjiModeEnabled())

  const nodes = buildNodes(segs)
  const graph = buildGraph(nodes, version)
  const path = dijkstra.find_path(graph.map, 'start', 'end')

  const optimizedSegs = []
  for (let i = 1; i < path.length - 1; i++) {
    optimizedSegs.push(graph.table[path[i]].node)
  }

  return exports.fromArray(mergeSegments(optimizedSegs))
}

/**
 * Splits a string in various segments with the modes which
 * best represent their content.
 * The produced segments are far from being optimized.
 * The output of this function is only used to estimate a QR Code version
 * which may contain the data.
 *
 * @param  {string} data Input string
 * @return {Array}       Array of segments
 */
exports.rawSplit = function rawSplit (data) {
  return exports.fromArray(
    getSegmentsFromString(data, Utils.isKanjiModeEnabled())
  )
}


/***/ }),

/***/ 79006:
/***/ ((__unused_webpack_module, exports) => {

let toSJISFunction
const CODEWORDS_COUNT = [
  0, // Not used
  26, 44, 70, 100, 134, 172, 196, 242, 292, 346,
  404, 466, 532, 581, 655, 733, 815, 901, 991, 1085,
  1156, 1258, 1364, 1474, 1588, 1706, 1828, 1921, 2051, 2185,
  2323, 2465, 2611, 2761, 2876, 3034, 3196, 3362, 3532, 3706
]

/**
 * Returns the QR Code size for the specified version
 *
 * @param  {Number} version QR Code version
 * @return {Number}         size of QR code
 */
exports.getSymbolSize = function getSymbolSize (version) {
  if (!version) throw new Error('"version" cannot be null or undefined')
  if (version < 1 || version > 40) throw new Error('"version" should be in range from 1 to 40')
  return version * 4 + 17
}

/**
 * Returns the total number of codewords used to store data and EC information.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Data length in bits
 */
exports.getSymbolTotalCodewords = function getSymbolTotalCodewords (version) {
  return CODEWORDS_COUNT[version]
}

/**
 * Encode data with Bose-Chaudhuri-Hocquenghem
 *
 * @param  {Number} data Value to encode
 * @return {Number}      Encoded value
 */
exports.getBCHDigit = function (data) {
  let digit = 0

  while (data !== 0) {
    digit++
    data >>>= 1
  }

  return digit
}

exports.setToSJISFunction = function setToSJISFunction (f) {
  if (typeof f !== 'function') {
    throw new Error('"toSJISFunc" is not a valid function.')
  }

  toSJISFunction = f
}

exports.isKanjiModeEnabled = function () {
  return typeof toSJISFunction !== 'undefined'
}

exports.toSJIS = function toSJIS (kanji) {
  return toSJISFunction(kanji)
}


/***/ }),

/***/ 43327:
/***/ ((__unused_webpack_module, exports) => {

/**
 * Check if QR Code version is valid
 *
 * @param  {Number}  version QR Code version
 * @return {Boolean}         true if valid version, false otherwise
 */
exports.isValid = function isValid (version) {
  return !isNaN(version) && version >= 1 && version <= 40
}


/***/ }),

/***/ 13761:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

const Utils = __webpack_require__(79006)
const ECCode = __webpack_require__(13675)
const ECLevel = __webpack_require__(17630)
const Mode = __webpack_require__(21493)
const VersionCheck = __webpack_require__(43327)

// Generator polynomial used to encode version information
const G18 = (1 << 12) | (1 << 11) | (1 << 10) | (1 << 9) | (1 << 8) | (1 << 5) | (1 << 2) | (1 << 0)
const G18_BCH = Utils.getBCHDigit(G18)

function getBestVersionForDataLength (mode, length, errorCorrectionLevel) {
  for (let currentVersion = 1; currentVersion <= 40; currentVersion++) {
    if (length <= exports.getCapacity(currentVersion, errorCorrectionLevel, mode)) {
      return currentVersion
    }
  }

  return undefined
}

function getReservedBitsCount (mode, version) {
  // Character count indicator + mode indicator bits
  return Mode.getCharCountIndicator(mode, version) + 4
}

function getTotalBitsFromDataArray (segments, version) {
  let totalBits = 0

  segments.forEach(function (data) {
    const reservedBits = getReservedBitsCount(data.mode, version)
    totalBits += reservedBits + data.getBitsLength()
  })

  return totalBits
}

function getBestVersionForMixedData (segments, errorCorrectionLevel) {
  for (let currentVersion = 1; currentVersion <= 40; currentVersion++) {
    const length = getTotalBitsFromDataArray(segments, currentVersion)
    if (length <= exports.getCapacity(currentVersion, errorCorrectionLevel, Mode.MIXED)) {
      return currentVersion
    }
  }

  return undefined
}

/**
 * Returns version number from a value.
 * If value is not a valid version, returns defaultValue
 *
 * @param  {Number|String} value        QR Code version
 * @param  {Number}        defaultValue Fallback value
 * @return {Number}                     QR Code version number
 */
exports.from = function from (value, defaultValue) {
  if (VersionCheck.isValid(value)) {
    return parseInt(value, 10)
  }

  return defaultValue
}

/**
 * Returns how much data can be stored with the specified QR code version
 * and error correction level
 *
 * @param  {Number} version              QR Code version (1-40)
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Mode}   mode                 Data mode
 * @return {Number}                      Quantity of storable data
 */
exports.getCapacity = function getCapacity (version, errorCorrectionLevel, mode) {
  if (!VersionCheck.isValid(version)) {
    throw new Error('Invalid QR Code version')
  }

  // Use Byte mode as default
  if (typeof mode === 'undefined') mode = Mode.BYTE

  // Total codewords for this QR code version (Data + Error correction)
  const totalCodewords = Utils.getSymbolTotalCodewords(version)

  // Total number of error correction codewords
  const ecTotalCodewords = ECCode.getTotalCodewordsCount(version, errorCorrectionLevel)

  // Total number of data codewords
  const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8

  if (mode === Mode.MIXED) return dataTotalCodewordsBits

  const usableBits = dataTotalCodewordsBits - getReservedBitsCount(mode, version)

  // Return max number of storable codewords
  switch (mode) {
    case Mode.NUMERIC:
      return Math.floor((usableBits / 10) * 3)

    case Mode.ALPHANUMERIC:
      return Math.floor((usableBits / 11) * 2)

    case Mode.KANJI:
      return Math.floor(usableBits / 13)

    case Mode.BYTE:
    default:
      return Math.floor(usableBits / 8)
  }
}

/**
 * Returns the minimum version needed to contain the amount of data
 *
 * @param  {Segment} data                    Segment of data
 * @param  {Number} [errorCorrectionLevel=H] Error correction level
 * @param  {Mode} mode                       Data mode
 * @return {Number}                          QR Code version
 */
exports.getBestVersionForData = function getBestVersionForData (data, errorCorrectionLevel) {
  let seg

  const ecl = ECLevel.from(errorCorrectionLevel, ECLevel.M)

  if (Array.isArray(data)) {
    if (data.length > 1) {
      return getBestVersionForMixedData(data, ecl)
    }

    if (data.length === 0) {
      return 1
    }

    seg = data[0]
  } else {
    seg = data
  }

  return getBestVersionForDataLength(seg.mode, seg.getLength(), ecl)
}

/**
 * Returns version information with relative error correction bits
 *
 * The version information is included in QR Code symbols of version 7 or larger.
 * It consists of an 18-bit sequence containing 6 data bits,
 * with 12 error correction bits calculated using the (18, 6) Golay code.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Encoded version info bits
 */
exports.getEncodedBits = function getEncodedBits (version) {
  if (!VersionCheck.isValid(version) || version < 7) {
    throw new Error('Invalid QR Code version')
  }

  let d = version << 12

  while (Utils.getBCHDigit(d) - G18_BCH >= 0) {
    d ^= (G18 << (Utils.getBCHDigit(d) - G18_BCH))
  }

  return (version << 12) | d
}


/***/ }),

/***/ 42513:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

const Utils = __webpack_require__(93878)

function clearCanvas (ctx, canvas, size) {
  ctx.clearRect(0, 0, canvas.width, canvas.height)

  if (!canvas.style) canvas.style = {}
  canvas.height = size
  canvas.width = size
  canvas.style.height = size + 'px'
  canvas.style.width = size + 'px'
}

function getCanvasElement () {
  try {
    return document.createElement('canvas')
  } catch (e) {
    throw new Error('You need to specify a canvas element')
  }
}

exports.render = function render (qrData, canvas, options) {
  let opts = options
  let canvasEl = canvas

  if (typeof opts === 'undefined' && (!canvas || !canvas.getContext)) {
    opts = canvas
    canvas = undefined
  }

  if (!canvas) {
    canvasEl = getCanvasElement()
  }

  opts = Utils.getOptions(opts)
  const size = Utils.getImageWidth(qrData.modules.size, opts)

  const ctx = canvasEl.getContext('2d')
  const image = ctx.createImageData(size, size)
  Utils.qrToImageData(image.data, qrData, opts)

  clearCanvas(ctx, canvasEl, size)
  ctx.putImageData(image, 0, 0)

  return canvasEl
}

exports.renderToDataURL = function renderToDataURL (qrData, canvas, options) {
  let opts = options

  if (typeof opts === 'undefined' && (!canvas || !canvas.getContext)) {
    opts = canvas
    canvas = undefined
  }

  if (!opts) opts = {}

  const canvasEl = exports.render(qrData, canvas, opts)

  const type = opts.type || 'image/png'
  const rendererOpts = opts.rendererOpts || {}

  return canvasEl.toDataURL(type, rendererOpts.quality)
}


/***/ }),

/***/ 51478:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

const Utils = __webpack_require__(93878)

function getColorAttrib (color, attrib) {
  const alpha = color.a / 255
  const str = attrib + '="' + color.hex + '"'

  return alpha < 1
    ? str + ' ' + attrib + '-opacity="' + alpha.toFixed(2).slice(1) + '"'
    : str
}

function svgCmd (cmd, x, y) {
  let str = cmd + x
  if (typeof y !== 'undefined') str += ' ' + y

  return str
}

function qrToPath (data, size, margin) {
  let path = ''
  let moveBy = 0
  let newRow = false
  let lineLength = 0

  for (let i = 0; i < data.length; i++) {
    const col = Math.floor(i % size)
    const row = Math.floor(i / size)

    if (!col && !newRow) newRow = true

    if (data[i]) {
      lineLength++

      if (!(i > 0 && col > 0 && data[i - 1])) {
        path += newRow
          ? svgCmd('M', col + margin, 0.5 + row + margin)
          : svgCmd('m', moveBy, 0)

        moveBy = 0
        newRow = false
      }

      if (!(col + 1 < size && data[i + 1])) {
        path += svgCmd('h', lineLength)
        lineLength = 0
      }
    } else {
      moveBy++
    }
  }

  return path
}

exports.render = function render (qrData, options, cb) {
  const opts = Utils.getOptions(options)
  const size = qrData.modules.size
  const data = qrData.modules.data
  const qrcodesize = size + opts.margin * 2

  const bg = !opts.color.light.a
    ? ''
    : '<path ' + getColorAttrib(opts.color.light, 'fill') +
      ' d="M0 0h' + qrcodesize + 'v' + qrcodesize + 'H0z"/>'

  const path =
    '<path ' + getColorAttrib(opts.color.dark, 'stroke') +
    ' d="' + qrToPath(data, size, opts.margin) + '"/>'

  const viewBox = 'viewBox="' + '0 0 ' + qrcodesize + ' ' + qrcodesize + '"'

  const width = !opts.width ? '' : 'width="' + opts.width + '" height="' + opts.width + '" '

  const svgTag = '<svg xmlns="http://www.w3.org/2000/svg" ' + width + viewBox + ' shape-rendering="crispEdges">' + bg + path + '</svg>\n'

  if (typeof cb === 'function') {
    cb(null, svgTag)
  }

  return svgTag
}


/***/ }),

/***/ 93878:
/***/ ((__unused_webpack_module, exports) => {

function hex2rgba (hex) {
  if (typeof hex === 'number') {
    hex = hex.toString()
  }

  if (typeof hex !== 'string') {
    throw new Error('Color should be defined as hex string')
  }

  let hexCode = hex.slice().replace('#', '').split('')
  if (hexCode.length < 3 || hexCode.length === 5 || hexCode.length > 8) {
    throw new Error('Invalid hex color: ' + hex)
  }

  // Convert from short to long form (fff -> ffffff)
  if (hexCode.length === 3 || hexCode.length === 4) {
    hexCode = Array.prototype.concat.apply([], hexCode.map(function (c) {
      return [c, c]
    }))
  }

  // Add default alpha value
  if (hexCode.length === 6) hexCode.push('F', 'F')

  const hexValue = parseInt(hexCode.join(''), 16)

  return {
    r: (hexValue >> 24) & 255,
    g: (hexValue >> 16) & 255,
    b: (hexValue >> 8) & 255,
    a: hexValue & 255,
    hex: '#' + hexCode.slice(0, 6).join('')
  }
}

exports.getOptions = function getOptions (options) {
  if (!options) options = {}
  if (!options.color) options.color = {}

  const margin = typeof options.margin === 'undefined' ||
    options.margin === null ||
    options.margin < 0
    ? 4
    : options.margin

  const width = options.width && options.width >= 21 ? options.width : undefined
  const scale = options.scale || 4

  return {
    width: width,
    scale: width ? 4 : scale,
    margin: margin,
    color: {
      dark: hex2rgba(options.color.dark || '#000000ff'),
      light: hex2rgba(options.color.light || '#ffffffff')
    },
    type: options.type,
    rendererOpts: options.rendererOpts || {}
  }
}

exports.getScale = function getScale (qrSize, opts) {
  return opts.width && opts.width >= qrSize + opts.margin * 2
    ? opts.width / (qrSize + opts.margin * 2)
    : opts.scale
}

exports.getImageWidth = function getImageWidth (qrSize, opts) {
  const scale = exports.getScale(qrSize, opts)
  return Math.floor((qrSize + opts.margin * 2) * scale)
}

exports.qrToImageData = function qrToImageData (imgData, qr, opts) {
  const size = qr.modules.size
  const data = qr.modules.data
  const scale = exports.getScale(size, opts)
  const symbolSize = Math.floor((size + opts.margin * 2) * scale)
  const scaledMargin = opts.margin * scale
  const palette = [opts.color.light, opts.color.dark]

  for (let i = 0; i < symbolSize; i++) {
    for (let j = 0; j < symbolSize; j++) {
      let posDst = (i * symbolSize + j) * 4
      let pxColor = opts.color.light

      if (i >= scaledMargin && j >= scaledMargin &&
        i < symbolSize - scaledMargin && j < symbolSize - scaledMargin) {
        const iSrc = Math.floor((i - scaledMargin) / scale)
        const jSrc = Math.floor((j - scaledMargin) / scale)
        pxColor = palette[data[iSrc * size + jSrc] ? 1 : 0]
      }

      imgData[posDst++] = pxColor.r
      imgData[posDst++] = pxColor.g
      imgData[posDst++] = pxColor.b
      imgData[posDst] = pxColor.a
    }
  }
}


/***/ }),

/***/ 82382:
/***/ ((module) => {

"use strict";


var replace = String.prototype.replace;
var percentTwenties = /%20/g;

var Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};

module.exports = {
    'default': Format.RFC3986,
    formatters: {
        RFC1738: function (value) {
            return replace.call(value, percentTwenties, '+');
        },
        RFC3986: function (value) {
            return String(value);
        }
    },
    RFC1738: Format.RFC1738,
    RFC3986: Format.RFC3986
};


/***/ }),

/***/ 69787:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var stringify = __webpack_require__(10977);
var parse = __webpack_require__(62106);
var formats = __webpack_require__(82382);

module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};


/***/ }),

/***/ 62106:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(90471);

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var defaults = {
    allowDots: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};

var interpretNumericEntities = function (str) {
    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};

var parseArrayValue = function (val, options) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
        return val.split(',');
    }

    return val;
};

// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')

// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

var parseValues = function parseQueryStringValues(str, options) {
    var obj = { __proto__: null };

    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;

    var charset = options.charset;
    if (options.charsetSentinel) {
        for (i = 0; i < parts.length; ++i) {
            if (parts[i].indexOf('utf8=') === 0) {
                if (parts[i] === charsetSentinel) {
                    charset = 'utf-8';
                } else if (parts[i] === isoSentinel) {
                    charset = 'iso-8859-1';
                }
                skipIndex = i;
                i = parts.length; // The eslint settings do not allow break;
            }
        }
    }

    for (i = 0; i < parts.length; ++i) {
        if (i === skipIndex) {
            continue;
        }
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key, val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder, charset, 'key');
            val = utils.maybeMap(
                parseArrayValue(part.slice(pos + 1), options),
                function (encodedVal) {
                    return options.decoder(encodedVal, defaults.decoder, charset, 'value');
                }
            );
        }

        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
            val = interpretNumericEntities(val);
        }

        if (part.indexOf('[]=') > -1) {
            val = isArray(val) ? [val] : val;
        }

        if (has.call(obj, key)) {
            obj[key] = utils.combine(obj[key], val);
        } else {
            obj[key] = val;
        }
    }

    return obj;
};

var parseObject = function (chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : parseArrayValue(val, options);

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]' && options.parseArrays) {
            obj = [].concat(leaf);
        } else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (!options.parseArrays && cleanRoot === '') {
                obj = { 0: leaf };
            } else if (
                !isNaN(index)
                && root !== cleanRoot
                && String(index) === cleanRoot
                && index >= 0
                && (options.parseArrays && index <= options.arrayLimit)
            ) {
                obj = [];
                obj[index] = leaf;
            } else if (cleanRoot !== '__proto__') {
                obj[cleanRoot] = leaf;
            }
        }

        leaf = obj;
    }

    return leaf;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) {
        return;
    }

    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    // The regex chunks

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    // Get the parent

    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    // Stash the parent if it exists

    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(parent);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
                return;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, just add whatever is left

    if (segment) {
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return parseObject(keys, val, options, valuesParsed);
};

var normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }
    var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;

    return {
        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: (typeof opts.depth === 'number' || opts.depth === false) ? +opts.depth : defaults.depth,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (str, opts) {
    var options = normalizeParseOptions(opts);

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? Object.create(null) : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = utils.merge(obj, newObj, options);
    }

    if (options.allowSparse === true) {
        return obj;
    }

    return utils.compact(obj);
};


/***/ }),

/***/ 10977:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var getSideChannel = __webpack_require__(65714);
var utils = __webpack_require__(90471);
var formats = __webpack_require__(82382);
var has = Object.prototype.hasOwnProperty;

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};

var isArray = Array.isArray;
var push = Array.prototype.push;
var pushToArray = function (arr, valueOrArray) {
    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
};

var toISO = Date.prototype.toISOString;

var defaultFormat = formats['default'];
var defaults = {
    addQueryPrefix: false,
    allowDots: false,
    charset: 'utf-8',
    charsetSentinel: false,
    delimiter: '&',
    encode: true,
    encoder: utils.encode,
    encodeValuesOnly: false,
    format: defaultFormat,
    formatter: formats.formatters[defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string'
        || typeof v === 'number'
        || typeof v === 'boolean'
        || typeof v === 'symbol'
        || typeof v === 'bigint';
};

var sentinel = {};

var stringify = function stringify(
    object,
    prefix,
    generateArrayPrefix,
    commaRoundTrip,
    strictNullHandling,
    skipNulls,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    format,
    formatter,
    encodeValuesOnly,
    charset,
    sideChannel
) {
    var obj = object;

    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while ((tmpSc = tmpSc.get(sentinel)) !== void undefined && !findFlag) {
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) {
                throw new RangeError('Cyclic object value');
            } else {
                findFlag = true; // Break while
            }
        }
        if (typeof tmpSc.get(sentinel) === 'undefined') {
            step = 0;
        }
    }

    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (generateArrayPrefix === 'comma' && isArray(obj)) {
        obj = utils.maybeMap(obj, function (value) {
            if (value instanceof Date) {
                return serializeDate(value);
            }
            return value;
        });
    }

    if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, 'key', format) : prefix;
        }

        obj = '';
    }

    if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, 'key', format);
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset, 'value', format))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (generateArrayPrefix === 'comma' && isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) {
            obj = utils.maybeMap(obj, encoder);
        }
        objKeys = [{ value: obj.length > 0 ? obj.join(',') || null : void undefined }];
    } else if (isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    var adjustedPrefix = commaRoundTrip && isArray(obj) && obj.length === 1 ? prefix + '[]' : prefix;

    for (var j = 0; j < objKeys.length; ++j) {
        var key = objKeys[j];
        var value = typeof key === 'object' && typeof key.value !== 'undefined' ? key.value : obj[key];

        if (skipNulls && value === null) {
            continue;
        }

        var keyPrefix = isArray(obj)
            ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, key) : adjustedPrefix
            : adjustedPrefix + (allowDots ? '.' + key : '[' + key + ']');

        sideChannel.set(object, step);
        var valueSideChannel = getSideChannel();
        valueSideChannel.set(sentinel, sideChannel);
        pushToArray(values, stringify(
            value,
            keyPrefix,
            generateArrayPrefix,
            commaRoundTrip,
            strictNullHandling,
            skipNulls,
            generateArrayPrefix === 'comma' && encodeValuesOnly && isArray(obj) ? null : encoder,
            filter,
            sort,
            allowDots,
            serializeDate,
            format,
            formatter,
            encodeValuesOnly,
            charset,
            valueSideChannel
        ));
    }

    return values;
};

var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var charset = opts.charset || defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    var format = formats['default'];
    if (typeof opts.format !== 'undefined') {
        if (!has.call(formats.formatters, opts.format)) {
            throw new TypeError('Unknown format option provided.');
        }
        format = opts.format;
    }
    var formatter = formats.formatters[format];

    var filter = defaults.filter;
    if (typeof opts.filter === 'function' || isArray(opts.filter)) {
        filter = opts.filter;
    }

    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults.addQueryPrefix,
        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        delimiter: typeof opts.delimiter === 'undefined' ? defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : defaults.encode,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (object, opts) {
    var obj = object;
    var options = normalizeStringifyOptions(opts);

    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var arrayFormat;
    if (opts && opts.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = opts.arrayFormat;
    } else if (opts && 'indices' in opts) {
        arrayFormat = opts.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = 'indices';
    }

    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];
    if (opts && 'commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') {
        throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    }
    var commaRoundTrip = generateArrayPrefix === 'comma' && opts && opts.commaRoundTrip;

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (options.sort) {
        objKeys.sort(options.sort);
    }

    var sideChannel = getSideChannel();
    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (options.skipNulls && obj[key] === null) {
            continue;
        }
        pushToArray(keys, stringify(
            obj[key],
            key,
            generateArrayPrefix,
            commaRoundTrip,
            options.strictNullHandling,
            options.skipNulls,
            options.encode ? options.encoder : null,
            options.filter,
            options.sort,
            options.allowDots,
            options.serializeDate,
            options.format,
            options.formatter,
            options.encodeValuesOnly,
            options.charset,
            sideChannel
        ));
    }

    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') {
            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
            prefix += 'utf8=%26%2310003%3B&';
        } else {
            // encodeURIComponent('✓')
            prefix += 'utf8=%E2%9C%93&';
        }
    }

    return joined.length > 0 ? prefix + joined : '';
};


/***/ }),

/***/ 90471:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var formats = __webpack_require__(82382);

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    }

    return array;
}());

var compactQueue = function compactQueue(queue) {
    while (queue.length > 1) {
        var item = queue.pop();
        var obj = item.obj[item.prop];

        if (isArray(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted.push(obj[j]);
                }
            }

            item.obj[item.prop] = compacted;
        }
    }
};

var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

var merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */
    if (!source) {
        return target;
    }

    if (typeof source !== 'object') {
        if (isArray(target)) {
            target.push(source);
        } else if (target && typeof target === 'object') {
            if ((options && (options.plainObjects || options.allowPrototypes)) || !has.call(Object.prototype, source)) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (!target || typeof target !== 'object') {
        return [target].concat(source);
    }

    var mergeTarget = target;
    if (isArray(target) && !isArray(source)) {
        mergeTarget = arrayToObject(target, options);
    }

    if (isArray(target) && isArray(source)) {
        source.forEach(function (item, i) {
            if (has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
                    target[i] = merge(targetItem, item, options);
                } else {
                    target.push(item);
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has.call(acc, key)) {
            acc[key] = merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }
        return acc;
    }, mergeTarget);
};

var assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};

var decode = function (str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') {
        // unescape never throws, no try...catch needed:
        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    }
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};

var encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = str;
    if (typeof str === 'symbol') {
        string = Symbol.prototype.toString.call(str);
    } else if (typeof str !== 'string') {
        string = String(str);
    }

    if (charset === 'iso-8859-1') {
        return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
        });
    }

    var out = '';
    for (var i = 0; i < string.length; ++i) {
        var c = string.charCodeAt(i);

        if (
            c === 0x2D // -
            || c === 0x2E // .
            || c === 0x5F // _
            || c === 0x7E // ~
            || (c >= 0x30 && c <= 0x39) // 0-9
            || (c >= 0x41 && c <= 0x5A) // a-z
            || (c >= 0x61 && c <= 0x7A) // A-Z
            || (format === formats.RFC1738 && (c === 0x28 || c === 0x29)) // ( )
        ) {
            out += string.charAt(i);
            continue;
        }

        if (c < 0x80) {
            out = out + hexTable[c];
            continue;
        }

        if (c < 0x800) {
            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        if (c < 0xD800 || c >= 0xE000) {
            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        i += 1;
        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
        /* eslint operator-linebreak: [2, "before"] */
        out += hexTable[0xF0 | (c >> 18)]
            + hexTable[0x80 | ((c >> 12) & 0x3F)]
            + hexTable[0x80 | ((c >> 6) & 0x3F)]
            + hexTable[0x80 | (c & 0x3F)];
    }

    return out;
};

var compact = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = [];

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({ obj: obj, prop: key });
                refs.push(val);
            }
        }
    }

    compactQueue(queue);

    return value;
};

var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};

var combine = function combine(a, b) {
    return [].concat(a, b);
};

var maybeMap = function maybeMap(val, fn) {
    if (isArray(val)) {
        var mapped = [];
        for (var i = 0; i < val.length; i += 1) {
            mapped.push(fn(val[i]));
        }
        return mapped;
    }
    return fn(val);
};

module.exports = {
    arrayToObject: arrayToObject,
    assign: assign,
    combine: combine,
    compact: compact,
    decode: decode,
    encode: encode,
    isBuffer: isBuffer,
    isRegExp: isRegExp,
    maybeMap: maybeMap,
    merge: merge
};


/***/ }),

/***/ 60981:
/***/ ((module) => {

"use strict";


function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var codes = {};

function createErrorType(code, message, Base) {
  if (!Base) {
    Base = Error;
  }

  function getMessage(arg1, arg2, arg3) {
    if (typeof message === 'string') {
      return message;
    } else {
      return message(arg1, arg2, arg3);
    }
  }

  var NodeError =
  /*#__PURE__*/
  function (_Base) {
    _inheritsLoose(NodeError, _Base);

    function NodeError(arg1, arg2, arg3) {
      return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
    }

    return NodeError;
  }(Base);

  NodeError.prototype.name = Base.name;
  NodeError.prototype.code = code;
  codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js


function oneOf(expected, thing) {
  if (Array.isArray(expected)) {
    var len = expected.length;
    expected = expected.map(function (i) {
      return String(i);
    });

    if (len > 2) {
      return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
    } else if (len === 2) {
      return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
    } else {
      return "of ".concat(thing, " ").concat(expected[0]);
    }
  } else {
    return "of ".concat(thing, " ").concat(String(expected));
  }
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith


function startsWith(str, search, pos) {
  return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith


function endsWith(str, search, this_len) {
  if (this_len === undefined || this_len > str.length) {
    this_len = str.length;
  }

  return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes


function includes(str, search, start) {
  if (typeof start !== 'number') {
    start = 0;
  }

  if (start + search.length > str.length) {
    return false;
  } else {
    return str.indexOf(search, start) !== -1;
  }
}

createErrorType('ERR_INVALID_OPT_VALUE', function (name, value) {
  return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
createErrorType('ERR_INVALID_ARG_TYPE', function (name, expected, actual) {
  // determiner: 'must be' or 'must not be'
  var determiner;

  if (typeof expected === 'string' && startsWith(expected, 'not ')) {
    determiner = 'must not be';
    expected = expected.replace(/^not /, '');
  } else {
    determiner = 'must be';
  }

  var msg;

  if (endsWith(name, ' argument')) {
    // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat(oneOf(expected, 'type'));
  } else {
    var type = includes(name, '.') ? 'property' : 'argument';
    msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat(oneOf(expected, 'type'));
  }

  msg += ". Received type ".concat(typeof actual);
  return msg;
}, TypeError);
createErrorType('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF');
createErrorType('ERR_METHOD_NOT_IMPLEMENTED', function (name) {
  return 'The ' + name + ' method is not implemented';
});
createErrorType('ERR_STREAM_PREMATURE_CLOSE', 'Premature close');
createErrorType('ERR_STREAM_DESTROYED', function (name) {
  return 'Cannot call ' + name + ' after a stream was destroyed';
});
createErrorType('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times');
createErrorType('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable');
createErrorType('ERR_STREAM_WRITE_AFTER_END', 'write after end');
createErrorType('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
createErrorType('ERR_UNKNOWN_ENCODING', function (arg) {
  return 'Unknown encoding: ' + arg;
}, TypeError);
createErrorType('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event');
module.exports.q = codes;


/***/ }),

/***/ 93337:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
/* provided dependency */ var process = __webpack_require__(14224);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.



/*<replacement>*/
var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) keys.push(key);
  return keys;
};
/*</replacement>*/

module.exports = Duplex;
var Readable = __webpack_require__(25294);
var Writable = __webpack_require__(86481);
__webpack_require__(85459)(Duplex, Readable);
{
  // Allow the keys array to be GC'ed.
  var keys = objectKeys(Writable.prototype);
  for (var v = 0; v < keys.length; v++) {
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
  }
}
function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options);
  Readable.call(this, options);
  Writable.call(this, options);
  this.allowHalfOpen = true;
  if (options) {
    if (options.readable === false) this.readable = false;
    if (options.writable === false) this.writable = false;
    if (options.allowHalfOpen === false) {
      this.allowHalfOpen = false;
      this.once('end', onend);
    }
  }
}
Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.highWaterMark;
  }
});
Object.defineProperty(Duplex.prototype, 'writableBuffer', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState && this._writableState.getBuffer();
  }
});
Object.defineProperty(Duplex.prototype, 'writableLength', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.length;
  }
});

// the no-half-open enforcer
function onend() {
  // If the writable side ended, then we're ok.
  if (this._writableState.ended) return;

  // no more data can be written.
  // But allow more writes to happen in this tick.
  process.nextTick(onEndNT, this);
}
function onEndNT(self) {
  self.end();
}
Object.defineProperty(Duplex.prototype, 'destroyed', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    if (this._readableState === undefined || this._writableState === undefined) {
      return false;
    }
    return this._readableState.destroyed && this._writableState.destroyed;
  },
  set: function set(value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (this._readableState === undefined || this._writableState === undefined) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
    this._writableState.destroyed = value;
  }
});

/***/ }),

/***/ 68797:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.



module.exports = PassThrough;
var Transform = __webpack_require__(41683);
__webpack_require__(85459)(PassThrough, Transform);
function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options);
  Transform.call(this, options);
}
PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk);
};

/***/ }),

/***/ 25294:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
/* provided dependency */ var process = __webpack_require__(14224);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



module.exports = Readable;

/*<replacement>*/
var Duplex;
/*</replacement>*/

Readable.ReadableState = ReadableState;

/*<replacement>*/
var EE = (__webpack_require__(72100).EventEmitter);
var EElistenerCount = function EElistenerCount(emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__(26922);
/*</replacement>*/

var Buffer = (__webpack_require__(12611).Buffer);
var OurUint8Array = (typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*<replacement>*/
var debugUtil = __webpack_require__(82880);
var debug;
if (debugUtil && debugUtil.debuglog) {
  debug = debugUtil.debuglog('stream');
} else {
  debug = function debug() {};
}
/*</replacement>*/

var BufferList = __webpack_require__(96292);
var destroyImpl = __webpack_require__(33591);
var _require = __webpack_require__(16084),
  getHighWaterMark = _require.getHighWaterMark;
var _require$codes = (__webpack_require__(60981)/* .codes */ .q),
  ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE,
  ERR_STREAM_PUSH_AFTER_EOF = _require$codes.ERR_STREAM_PUSH_AFTER_EOF,
  ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
  ERR_STREAM_UNSHIFT_AFTER_END_EVENT = _require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;

// Lazy loaded to improve the startup performance.
var StringDecoder;
var createReadableStreamAsyncIterator;
var from;
__webpack_require__(85459)(Readable, Stream);
var errorOrDestroy = destroyImpl.errorOrDestroy;
var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];
function prependListener(emitter, event, fn) {
  // Sadly this is not cacheable as some libraries bundle their own
  // event emitter implementation with them.
  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);

  // This is a hack to make sure that our error handler is attached before any
  // userland ones.  NEVER DO THIS. This is here only because this code needs
  // to continue to work with older versions of Node.js that do not include
  // the prependListener() method. The goal is to eventually remove this hack.
  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
}
function ReadableState(options, stream, isDuplex) {
  Duplex = Duplex || __webpack_require__(93337);
  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof Duplex;

  // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away
  this.objectMode = !!options.objectMode;
  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

  // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  this.highWaterMark = getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex);

  // A linked list is used to store data chunks instead of an array because the
  // linked list can remove elements from the beginning faster than
  // array.shift()
  this.buffer = new BufferList();
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false;

  // a flag to be able to tell if the event 'readable'/'data' is emitted
  // immediately, or on a later tick.  We set this to true at first, because
  // any actions that shouldn't happen until "later" should generally also
  // not happen before the first read call.
  this.sync = true;

  // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;
  this.resumeScheduled = false;
  this.paused = true;

  // Should close be emitted on destroy. Defaults to true.
  this.emitClose = options.emitClose !== false;

  // Should .destroy() be called after 'end' (and potentially 'finish')
  this.autoDestroy = !!options.autoDestroy;

  // has it been destroyed
  this.destroyed = false;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // the number of writers that are awaiting a drain event in .pipe()s
  this.awaitDrain = 0;

  // if true, a maybeReadMore has been scheduled
  this.readingMore = false;
  this.decoder = null;
  this.encoding = null;
  if (options.encoding) {
    if (!StringDecoder) StringDecoder = (__webpack_require__(72699)/* .StringDecoder */ .s);
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}
function Readable(options) {
  Duplex = Duplex || __webpack_require__(93337);
  if (!(this instanceof Readable)) return new Readable(options);

  // Checking for a Stream.Duplex instance is faster here instead of inside
  // the ReadableState constructor, at least with V8 6.5
  var isDuplex = this instanceof Duplex;
  this._readableState = new ReadableState(options, this, isDuplex);

  // legacy
  this.readable = true;
  if (options) {
    if (typeof options.read === 'function') this._read = options.read;
    if (typeof options.destroy === 'function') this._destroy = options.destroy;
  }
  Stream.call(this);
}
Object.defineProperty(Readable.prototype, 'destroyed', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    if (this._readableState === undefined) {
      return false;
    }
    return this._readableState.destroyed;
  },
  set: function set(value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._readableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
  }
});
Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;
Readable.prototype._destroy = function (err, cb) {
  cb(err);
};

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function (chunk, encoding) {
  var state = this._readableState;
  var skipChunkCheck;
  if (!state.objectMode) {
    if (typeof chunk === 'string') {
      encoding = encoding || state.defaultEncoding;
      if (encoding !== state.encoding) {
        chunk = Buffer.from(chunk, encoding);
        encoding = '';
      }
      skipChunkCheck = true;
    }
  } else {
    skipChunkCheck = true;
  }
  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};

// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function (chunk) {
  return readableAddChunk(this, chunk, null, true, false);
};
function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
  debug('readableAddChunk', chunk);
  var state = stream._readableState;
  if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else {
    var er;
    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
    if (er) {
      errorOrDestroy(stream, er);
    } else if (state.objectMode || chunk && chunk.length > 0) {
      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
        chunk = _uint8ArrayToBuffer(chunk);
      }
      if (addToFront) {
        if (state.endEmitted) errorOrDestroy(stream, new ERR_STREAM_UNSHIFT_AFTER_END_EVENT());else addChunk(stream, state, chunk, true);
      } else if (state.ended) {
        errorOrDestroy(stream, new ERR_STREAM_PUSH_AFTER_EOF());
      } else if (state.destroyed) {
        return false;
      } else {
        state.reading = false;
        if (state.decoder && !encoding) {
          chunk = state.decoder.write(chunk);
          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
        } else {
          addChunk(stream, state, chunk, false);
        }
      }
    } else if (!addToFront) {
      state.reading = false;
      maybeReadMore(stream, state);
    }
  }

  // We can push more data if we are below the highWaterMark.
  // Also, if we have no data yet, we can stand some more bytes.
  // This is to work around cases where hwm=0, such as the repl.
  return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function addChunk(stream, state, chunk, addToFront) {
  if (state.flowing && state.length === 0 && !state.sync) {
    state.awaitDrain = 0;
    stream.emit('data', chunk);
  } else {
    // update the buffer info.
    state.length += state.objectMode ? 1 : chunk.length;
    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);
    if (state.needReadable) emitReadable(stream);
  }
  maybeReadMore(stream, state);
}
function chunkInvalid(state, chunk) {
  var er;
  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new ERR_INVALID_ARG_TYPE('chunk', ['string', 'Buffer', 'Uint8Array'], chunk);
  }
  return er;
}
Readable.prototype.isPaused = function () {
  return this._readableState.flowing === false;
};

// backwards compatibility.
Readable.prototype.setEncoding = function (enc) {
  if (!StringDecoder) StringDecoder = (__webpack_require__(72699)/* .StringDecoder */ .s);
  var decoder = new StringDecoder(enc);
  this._readableState.decoder = decoder;
  // If setEncoding(null), decoder.encoding equals utf8
  this._readableState.encoding = this._readableState.decoder.encoding;

  // Iterate over current buffer to convert already stored Buffers:
  var p = this._readableState.buffer.head;
  var content = '';
  while (p !== null) {
    content += decoder.write(p.data);
    p = p.next;
  }
  this._readableState.buffer.clear();
  if (content !== '') this._readableState.buffer.push(content);
  this._readableState.length = content.length;
  return this;
};

// Don't raise the hwm > 1GB
var MAX_HWM = 0x40000000;
function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2 to prevent increasing hwm excessively in
    // tiny amounts
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }
  return n;
}

// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
  if (n <= 0 || state.length === 0 && state.ended) return 0;
  if (state.objectMode) return 1;
  if (n !== n) {
    // Only flow one buffer at a time
    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
  }
  // If we're asking for more than the current hwm, then raise the hwm.
  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
  if (n <= state.length) return n;
  // Don't have enough
  if (!state.ended) {
    state.needReadable = true;
    return 0;
  }
  return state.length;
}

// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function (n) {
  debug('read', n);
  n = parseInt(n, 10);
  var state = this._readableState;
  var nOrig = n;
  if (n !== 0) state.emittedReadable = false;

  // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    return null;
  }
  n = howMuchToRead(n, state);

  // if we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this);
    return null;
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  var doRead = state.needReadable;
  debug('need readable', doRead);

  // if we currently have less than the highWaterMark, then also read some
  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  }

  // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.
  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  } else if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true;
    // if the length is currently zero, then we *need* a readable event.
    if (state.length === 0) state.needReadable = true;
    // call internal read method
    this._read(state.highWaterMark);
    state.sync = false;
    // If _read pushed data synchronously, then `reading` will be false,
    // and we need to re-evaluate how much data we can return to the user.
    if (!state.reading) n = howMuchToRead(nOrig, state);
  }
  var ret;
  if (n > 0) ret = fromList(n, state);else ret = null;
  if (ret === null) {
    state.needReadable = state.length <= state.highWaterMark;
    n = 0;
  } else {
    state.length -= n;
    state.awaitDrain = 0;
  }
  if (state.length === 0) {
    // If we have nothing in the buffer, then we want to know
    // as soon as we *do* get something into the buffer.
    if (!state.ended) state.needReadable = true;

    // If we tried to read() past the EOF, then emit end on the next tick.
    if (nOrig !== n && state.ended) endReadable(this);
  }
  if (ret !== null) this.emit('data', ret);
  return ret;
};
function onEofChunk(stream, state) {
  debug('onEofChunk');
  if (state.ended) return;
  if (state.decoder) {
    var chunk = state.decoder.end();
    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }
  state.ended = true;
  if (state.sync) {
    // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    emitReadable(stream);
  } else {
    // emit 'readable' now to make sure it gets picked up.
    state.needReadable = false;
    if (!state.emittedReadable) {
      state.emittedReadable = true;
      emitReadable_(stream);
    }
  }
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  var state = stream._readableState;
  debug('emitReadable', state.needReadable, state.emittedReadable);
  state.needReadable = false;
  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    process.nextTick(emitReadable_, stream);
  }
}
function emitReadable_(stream) {
  var state = stream._readableState;
  debug('emitReadable_', state.destroyed, state.length, state.ended);
  if (!state.destroyed && (state.length || state.ended)) {
    stream.emit('readable');
    state.emittedReadable = false;
  }

  // The stream needs another readable event if
  // 1. It is not flowing, as the flow mechanism will take
  //    care of it.
  // 2. It is not ended.
  // 3. It is below the highWaterMark, so we can schedule
  //    another readable later.
  state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
  flow(stream);
}

// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    process.nextTick(maybeReadMore_, stream, state);
  }
}
function maybeReadMore_(stream, state) {
  // Attempt to read more data if we should.
  //
  // The conditions for reading more data are (one of):
  // - Not enough data buffered (state.length < state.highWaterMark). The loop
  //   is responsible for filling the buffer with enough data if such data
  //   is available. If highWaterMark is 0 and we are not in the flowing mode
  //   we should _not_ attempt to buffer any extra data. We'll get more data
  //   when the stream consumer calls read() instead.
  // - No data in the buffer, and the stream is in flowing mode. In this mode
  //   the loop below is responsible for ensuring read() is called. Failing to
  //   call read here would abort the flow and there's no other mechanism for
  //   continuing the flow if the stream consumer has just subscribed to the
  //   'data' event.
  //
  // In addition to the above conditions to keep reading data, the following
  // conditions prevent the data from being read:
  // - The stream has ended (state.ended).
  // - There is already a pending 'read' operation (state.reading). This is a
  //   case where the the stream has called the implementation defined _read()
  //   method, but they are processing the call asynchronously and have _not_
  //   called push() with new data. In this case we skip performing more
  //   read()s. The execution ends in this method again after the _read() ends
  //   up calling push() with more data.
  while (!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)) {
    var len = state.length;
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length)
      // didn't get any data, stop spinning.
      break;
  }
  state.readingMore = false;
}

// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function (n) {
  errorOrDestroy(this, new ERR_METHOD_NOT_IMPLEMENTED('_read()'));
};
Readable.prototype.pipe = function (dest, pipeOpts) {
  var src = this;
  var state = this._readableState;
  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;
    case 1:
      state.pipes = [state.pipes, dest];
      break;
    default:
      state.pipes.push(dest);
      break;
  }
  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
  var endFn = doEnd ? onend : unpipe;
  if (state.endEmitted) process.nextTick(endFn);else src.once('end', endFn);
  dest.on('unpipe', onunpipe);
  function onunpipe(readable, unpipeInfo) {
    debug('onunpipe');
    if (readable === src) {
      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
        unpipeInfo.hasUnpiped = true;
        cleanup();
      }
    }
  }
  function onend() {
    debug('onend');
    dest.end();
  }

  // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.
  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);
  var cleanedUp = false;
  function cleanup() {
    debug('cleanup');
    // cleanup event handlers once the pipe is broken
    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', unpipe);
    src.removeListener('data', ondata);
    cleanedUp = true;

    // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
  }
  src.on('data', ondata);
  function ondata(chunk) {
    debug('ondata');
    var ret = dest.write(chunk);
    debug('dest.write', ret);
    if (ret === false) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      // => Check whether `dest` is still a piping destination.
      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
        debug('false write response, pause', state.awaitDrain);
        state.awaitDrain++;
      }
      src.pause();
    }
  }

  // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.
  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EElistenerCount(dest, 'error') === 0) errorOrDestroy(dest, er);
  }

  // Make sure our error handler is attached before userland ones.
  prependListener(dest, 'error', onerror);

  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }
  dest.once('close', onclose);
  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }
  dest.once('finish', onfinish);
  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  }

  // tell the dest that it's being piped to
  dest.emit('pipe', src);

  // start the flow if it hasn't been started already.
  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }
  return dest;
};
function pipeOnDrain(src) {
  return function pipeOnDrainFunctionResult() {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain) state.awaitDrain--;
    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}
Readable.prototype.unpipe = function (dest) {
  var state = this._readableState;
  var unpipeInfo = {
    hasUnpiped: false
  };

  // if we're not piping anywhere, then do nothing.
  if (state.pipesCount === 0) return this;

  // just one destination.  most common case.
  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes) return this;
    if (!dest) dest = state.pipes;

    // got a match.
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest) dest.emit('unpipe', this, unpipeInfo);
    return this;
  }

  // slow case. multiple pipe destinations.

  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    for (var i = 0; i < len; i++) dests[i].emit('unpipe', this, {
      hasUnpiped: false
    });
    return this;
  }

  // try to find the right one.
  var index = indexOf(state.pipes, dest);
  if (index === -1) return this;
  state.pipes.splice(index, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1) state.pipes = state.pipes[0];
  dest.emit('unpipe', this, unpipeInfo);
  return this;
};

// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function (ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);
  var state = this._readableState;
  if (ev === 'data') {
    // update readableListening so that resume() may be a no-op
    // a few lines down. This is needed to support once('readable').
    state.readableListening = this.listenerCount('readable') > 0;

    // Try start flowing on next tick if stream isn't explicitly paused
    if (state.flowing !== false) this.resume();
  } else if (ev === 'readable') {
    if (!state.endEmitted && !state.readableListening) {
      state.readableListening = state.needReadable = true;
      state.flowing = false;
      state.emittedReadable = false;
      debug('on readable', state.length, state.reading);
      if (state.length) {
        emitReadable(this);
      } else if (!state.reading) {
        process.nextTick(nReadingNextTick, this);
      }
    }
  }
  return res;
};
Readable.prototype.addListener = Readable.prototype.on;
Readable.prototype.removeListener = function (ev, fn) {
  var res = Stream.prototype.removeListener.call(this, ev, fn);
  if (ev === 'readable') {
    // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    process.nextTick(updateReadableListening, this);
  }
  return res;
};
Readable.prototype.removeAllListeners = function (ev) {
  var res = Stream.prototype.removeAllListeners.apply(this, arguments);
  if (ev === 'readable' || ev === undefined) {
    // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    process.nextTick(updateReadableListening, this);
  }
  return res;
};
function updateReadableListening(self) {
  var state = self._readableState;
  state.readableListening = self.listenerCount('readable') > 0;
  if (state.resumeScheduled && !state.paused) {
    // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;

    // crude way to check if we should resume
  } else if (self.listenerCount('data') > 0) {
    self.resume();
  }
}
function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
}

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function () {
  var state = this._readableState;
  if (!state.flowing) {
    debug('resume');
    // we flow only if there is no one listening
    // for readable, but we still have to call
    // resume()
    state.flowing = !state.readableListening;
    resume(this, state);
  }
  state.paused = false;
  return this;
};
function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    process.nextTick(resume_, stream, state);
  }
}
function resume_(stream, state) {
  debug('resume', state.reading);
  if (!state.reading) {
    stream.read(0);
  }
  state.resumeScheduled = false;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading) stream.read(0);
}
Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing);
  if (this._readableState.flowing !== false) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }
  this._readableState.paused = true;
  return this;
};
function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);
  while (state.flowing && stream.read() !== null);
}

// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function (stream) {
  var _this = this;
  var state = this._readableState;
  var paused = false;
  stream.on('end', function () {
    debug('wrapped end');
    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) _this.push(chunk);
    }
    _this.push(null);
  });
  stream.on('data', function (chunk) {
    debug('wrapped data');
    if (state.decoder) chunk = state.decoder.write(chunk);

    // don't skip over falsy values in objectMode
    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;
    var ret = _this.push(chunk);
    if (!ret) {
      paused = true;
      stream.pause();
    }
  });

  // proxy all the other methods.
  // important when wrapping filters and duplexes.
  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
          return stream[method].apply(stream, arguments);
        };
      }(i);
    }
  }

  // proxy certain important events.
  for (var n = 0; n < kProxyEvents.length; n++) {
    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
  }

  // when we try to consume some more bytes, simply unpause the
  // underlying stream.
  this._read = function (n) {
    debug('wrapped _read', n);
    if (paused) {
      paused = false;
      stream.resume();
    }
  };
  return this;
};
if (typeof Symbol === 'function') {
  Readable.prototype[Symbol.asyncIterator] = function () {
    if (createReadableStreamAsyncIterator === undefined) {
      createReadableStreamAsyncIterator = __webpack_require__(29954);
    }
    return createReadableStreamAsyncIterator(this);
  };
}
Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState.highWaterMark;
  }
});
Object.defineProperty(Readable.prototype, 'readableBuffer', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState && this._readableState.buffer;
  }
});
Object.defineProperty(Readable.prototype, 'readableFlowing', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState.flowing;
  },
  set: function set(state) {
    if (this._readableState) {
      this._readableState.flowing = state;
    }
  }
});

// exposed for testing purposes only.
Readable._fromList = fromList;
Object.defineProperty(Readable.prototype, 'readableLength', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState.length;
  }
});

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
  // nothing buffered
  if (state.length === 0) return null;
  var ret;
  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
    // read it all, truncate the list
    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.first();else ret = state.buffer.concat(state.length);
    state.buffer.clear();
  } else {
    // read part of list
    ret = state.buffer.consume(n, state.decoder);
  }
  return ret;
}
function endReadable(stream) {
  var state = stream._readableState;
  debug('endReadable', state.endEmitted);
  if (!state.endEmitted) {
    state.ended = true;
    process.nextTick(endReadableNT, state, stream);
  }
}
function endReadableNT(state, stream) {
  debug('endReadableNT', state.endEmitted, state.length);

  // Check that we didn't get one last unshift.
  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');
    if (state.autoDestroy) {
      // In case of duplex streams we need a way to detect
      // if the writable side is ready for autoDestroy as well
      var wState = stream._writableState;
      if (!wState || wState.autoDestroy && wState.finished) {
        stream.destroy();
      }
    }
  }
}
if (typeof Symbol === 'function') {
  Readable.from = function (iterable, opts) {
    if (from === undefined) {
      from = __webpack_require__(82037);
    }
    return from(Readable, iterable, opts);
  };
}
function indexOf(xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }
  return -1;
}

/***/ }),

/***/ 41683:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.



module.exports = Transform;
var _require$codes = (__webpack_require__(60981)/* .codes */ .q),
  ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
  ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK,
  ERR_TRANSFORM_ALREADY_TRANSFORMING = _require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING,
  ERR_TRANSFORM_WITH_LENGTH_0 = _require$codes.ERR_TRANSFORM_WITH_LENGTH_0;
var Duplex = __webpack_require__(93337);
__webpack_require__(85459)(Transform, Duplex);
function afterTransform(er, data) {
  var ts = this._transformState;
  ts.transforming = false;
  var cb = ts.writecb;
  if (cb === null) {
    return this.emit('error', new ERR_MULTIPLE_CALLBACK());
  }
  ts.writechunk = null;
  ts.writecb = null;
  if (data != null)
    // single equals check for both `null` and `undefined`
    this.push(data);
  cb(er);
  var rs = this._readableState;
  rs.reading = false;
  if (rs.needReadable || rs.length < rs.highWaterMark) {
    this._read(rs.highWaterMark);
  }
}
function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options);
  Duplex.call(this, options);
  this._transformState = {
    afterTransform: afterTransform.bind(this),
    needTransform: false,
    transforming: false,
    writecb: null,
    writechunk: null,
    writeencoding: null
  };

  // start out asking for a readable event once data is transformed.
  this._readableState.needReadable = true;

  // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false;
  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform;
    if (typeof options.flush === 'function') this._flush = options.flush;
  }

  // When the writable side finishes, then flush out anything remaining.
  this.on('prefinish', prefinish);
}
function prefinish() {
  var _this = this;
  if (typeof this._flush === 'function' && !this._readableState.destroyed) {
    this._flush(function (er, data) {
      done(_this, er, data);
    });
  } else {
    done(this, null, null);
  }
}
Transform.prototype.push = function (chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
};

// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function (chunk, encoding, cb) {
  cb(new ERR_METHOD_NOT_IMPLEMENTED('_transform()'));
};
Transform.prototype._write = function (chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;
  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
  }
};

// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function (n) {
  var ts = this._transformState;
  if (ts.writechunk !== null && !ts.transforming) {
    ts.transforming = true;
    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};
Transform.prototype._destroy = function (err, cb) {
  Duplex.prototype._destroy.call(this, err, function (err2) {
    cb(err2);
  });
};
function done(stream, er, data) {
  if (er) return stream.emit('error', er);
  if (data != null)
    // single equals check for both `null` and `undefined`
    stream.push(data);

  // TODO(BridgeAR): Write a test for these two error cases
  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided
  if (stream._writableState.length) throw new ERR_TRANSFORM_WITH_LENGTH_0();
  if (stream._transformState.transforming) throw new ERR_TRANSFORM_ALREADY_TRANSFORMING();
  return stream.push(null);
}

/***/ }),

/***/ 86481:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
/* provided dependency */ var process = __webpack_require__(14224);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.



module.exports = Writable;

/* <replacement> */
function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
}

// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
  var _this = this;
  this.next = null;
  this.entry = null;
  this.finish = function () {
    onCorkedFinish(_this, state);
  };
}
/* </replacement> */

/*<replacement>*/
var Duplex;
/*</replacement>*/

Writable.WritableState = WritableState;

/*<replacement>*/
var internalUtil = {
  deprecate: __webpack_require__(30403)
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__(26922);
/*</replacement>*/

var Buffer = (__webpack_require__(12611).Buffer);
var OurUint8Array = (typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}
var destroyImpl = __webpack_require__(33591);
var _require = __webpack_require__(16084),
  getHighWaterMark = _require.getHighWaterMark;
var _require$codes = (__webpack_require__(60981)/* .codes */ .q),
  ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE,
  ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
  ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK,
  ERR_STREAM_CANNOT_PIPE = _require$codes.ERR_STREAM_CANNOT_PIPE,
  ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED,
  ERR_STREAM_NULL_VALUES = _require$codes.ERR_STREAM_NULL_VALUES,
  ERR_STREAM_WRITE_AFTER_END = _require$codes.ERR_STREAM_WRITE_AFTER_END,
  ERR_UNKNOWN_ENCODING = _require$codes.ERR_UNKNOWN_ENCODING;
var errorOrDestroy = destroyImpl.errorOrDestroy;
__webpack_require__(85459)(Writable, Stream);
function nop() {}
function WritableState(options, stream, isDuplex) {
  Duplex = Duplex || __webpack_require__(93337);
  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream,
  // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
  if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof Duplex;

  // object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!options.objectMode;
  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

  // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()
  this.highWaterMark = getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex);

  // if _final has been called
  this.finalCalled = false;

  // drain event flag.
  this.needDrain = false;
  // at the start of calling end()
  this.ending = false;
  // when end() has been called, and returned
  this.ended = false;
  // when 'finish' is emitted
  this.finished = false;

  // has it been destroyed
  this.destroyed = false;

  // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0;

  // a flag to see when we're in the middle of a write.
  this.writing = false;

  // when true all writes will be buffered until .uncork() call
  this.corked = 0;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false;

  // the callback that's passed to _write(chunk,cb)
  this.onwrite = function (er) {
    onwrite(stream, er);
  };

  // the callback that the user supplies to write(chunk,encoding,cb)
  this.writecb = null;

  // the amount that is being written when _write is called.
  this.writelen = 0;
  this.bufferedRequest = null;
  this.lastBufferedRequest = null;

  // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted
  this.pendingcb = 0;

  // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams
  this.prefinished = false;

  // True if the error was already emitted and should not be thrown again
  this.errorEmitted = false;

  // Should close be emitted on destroy. Defaults to true.
  this.emitClose = options.emitClose !== false;

  // Should .destroy() be called after 'finish' (and potentially 'end')
  this.autoDestroy = !!options.autoDestroy;

  // count buffered requests
  this.bufferedRequestCount = 0;

  // allocate the first CorkedRequest, there is always
  // one allocated and free to use, and we maintain at most two
  this.corkedRequestsFree = new CorkedRequest(this);
}
WritableState.prototype.getBuffer = function getBuffer() {
  var current = this.bufferedRequest;
  var out = [];
  while (current) {
    out.push(current);
    current = current.next;
  }
  return out;
};
(function () {
  try {
    Object.defineProperty(WritableState.prototype, 'buffer', {
      get: internalUtil.deprecate(function writableStateBufferGetter() {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
    });
  } catch (_) {}
})();

// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
  realHasInstance = Function.prototype[Symbol.hasInstance];
  Object.defineProperty(Writable, Symbol.hasInstance, {
    value: function value(object) {
      if (realHasInstance.call(this, object)) return true;
      if (this !== Writable) return false;
      return object && object._writableState instanceof WritableState;
    }
  });
} else {
  realHasInstance = function realHasInstance(object) {
    return object instanceof this;
  };
}
function Writable(options) {
  Duplex = Duplex || __webpack_require__(93337);

  // Writable ctor is applied to Duplexes, too.
  // `realHasInstance` is necessary because using plain `instanceof`
  // would return false, as no `_writableState` property is attached.

  // Trying to use the custom `instanceof` for Writable here will also break the
  // Node.js LazyTransform implementation, which has a non-trivial getter for
  // `_writableState` that would lead to infinite recursion.

  // Checking for a Stream.Duplex instance is faster here instead of inside
  // the WritableState constructor, at least with V8 6.5
  var isDuplex = this instanceof Duplex;
  if (!isDuplex && !realHasInstance.call(Writable, this)) return new Writable(options);
  this._writableState = new WritableState(options, this, isDuplex);

  // legacy.
  this.writable = true;
  if (options) {
    if (typeof options.write === 'function') this._write = options.write;
    if (typeof options.writev === 'function') this._writev = options.writev;
    if (typeof options.destroy === 'function') this._destroy = options.destroy;
    if (typeof options.final === 'function') this._final = options.final;
  }
  Stream.call(this);
}

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function () {
  errorOrDestroy(this, new ERR_STREAM_CANNOT_PIPE());
};
function writeAfterEnd(stream, cb) {
  var er = new ERR_STREAM_WRITE_AFTER_END();
  // TODO: defer error events consistently everywhere, not just the cb
  errorOrDestroy(stream, er);
  process.nextTick(cb, er);
}

// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
  var er;
  if (chunk === null) {
    er = new ERR_STREAM_NULL_VALUES();
  } else if (typeof chunk !== 'string' && !state.objectMode) {
    er = new ERR_INVALID_ARG_TYPE('chunk', ['string', 'Buffer'], chunk);
  }
  if (er) {
    errorOrDestroy(stream, er);
    process.nextTick(cb, er);
    return false;
  }
  return true;
}
Writable.prototype.write = function (chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;
  var isBuf = !state.objectMode && _isUint8Array(chunk);
  if (isBuf && !Buffer.isBuffer(chunk)) {
    chunk = _uint8ArrayToBuffer(chunk);
  }
  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }
  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;
  if (typeof cb !== 'function') cb = nop;
  if (state.ending) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
  }
  return ret;
};
Writable.prototype.cork = function () {
  this._writableState.corked++;
};
Writable.prototype.uncork = function () {
  var state = this._writableState;
  if (state.corked) {
    state.corked--;
    if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
  }
};
Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new ERR_UNKNOWN_ENCODING(encoding);
  this._writableState.defaultEncoding = encoding;
  return this;
};
Object.defineProperty(Writable.prototype, 'writableBuffer', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState && this._writableState.getBuffer();
  }
});
function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    chunk = Buffer.from(chunk, encoding);
  }
  return chunk;
}
Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.highWaterMark;
  }
});

// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
  if (!isBuf) {
    var newChunk = decodeChunk(state, chunk, encoding);
    if (chunk !== newChunk) {
      isBuf = true;
      encoding = 'buffer';
      chunk = newChunk;
    }
  }
  var len = state.objectMode ? 1 : chunk.length;
  state.length += len;
  var ret = state.length < state.highWaterMark;
  // we must ensure that previous needDrain will not be reset to false.
  if (!ret) state.needDrain = true;
  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = {
      chunk: chunk,
      encoding: encoding,
      isBuf: isBuf,
      callback: cb,
      next: null
    };
    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }
    state.bufferedRequestCount += 1;
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }
  return ret;
}
function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (state.destroyed) state.onwrite(new ERR_STREAM_DESTROYED('write'));else if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}
function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;
  if (sync) {
    // defer the callback if we are being called synchronously
    // to avoid piling up things on the stack
    process.nextTick(cb, er);
    // this can emit finish, and it will always happen
    // after error
    process.nextTick(finishMaybe, stream, state);
    stream._writableState.errorEmitted = true;
    errorOrDestroy(stream, er);
  } else {
    // the caller expect this to happen before if
    // it is async
    cb(er);
    stream._writableState.errorEmitted = true;
    errorOrDestroy(stream, er);
    // this can emit finish, but finish must
    // always follow error
    finishMaybe(stream, state);
  }
}
function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}
function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;
  if (typeof cb !== 'function') throw new ERR_MULTIPLE_CALLBACK();
  onwriteStateUpdate(state);
  if (er) onwriteError(stream, state, sync, er, cb);else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state) || stream.destroyed;
    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
      clearBuffer(stream, state);
    }
    if (sync) {
      process.nextTick(afterWrite, stream, state, finished, cb);
    } else {
      afterWrite(stream, state, finished, cb);
    }
  }
}
function afterWrite(stream, state, finished, cb) {
  if (!finished) onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
}

// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
}

// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;
  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var l = state.bufferedRequestCount;
    var buffer = new Array(l);
    var holder = state.corkedRequestsFree;
    holder.entry = entry;
    var count = 0;
    var allBuffers = true;
    while (entry) {
      buffer[count] = entry;
      if (!entry.isBuf) allBuffers = false;
      entry = entry.next;
      count += 1;
    }
    buffer.allBuffers = allBuffers;
    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

    // doWrite is almost always async, defer these to save a bit of time
    // as the hot path ends with doWrite
    state.pendingcb++;
    state.lastBufferedRequest = null;
    if (holder.next) {
      state.corkedRequestsFree = holder.next;
      holder.next = null;
    } else {
      state.corkedRequestsFree = new CorkedRequest(state);
    }
    state.bufferedRequestCount = 0;
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;
      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      state.bufferedRequestCount--;
      // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.
      if (state.writing) {
        break;
      }
    }
    if (entry === null) state.lastBufferedRequest = null;
  }
  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}
Writable.prototype._write = function (chunk, encoding, cb) {
  cb(new ERR_METHOD_NOT_IMPLEMENTED('_write()'));
};
Writable.prototype._writev = null;
Writable.prototype.end = function (chunk, encoding, cb) {
  var state = this._writableState;
  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }
  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

  // .end() fully uncorks
  if (state.corked) {
    state.corked = 1;
    this.uncork();
  }

  // ignore unnecessary end() calls.
  if (!state.ending) endWritable(this, state, cb);
  return this;
};
Object.defineProperty(Writable.prototype, 'writableLength', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.length;
  }
});
function needFinish(state) {
  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function callFinal(stream, state) {
  stream._final(function (err) {
    state.pendingcb--;
    if (err) {
      errorOrDestroy(stream, err);
    }
    state.prefinished = true;
    stream.emit('prefinish');
    finishMaybe(stream, state);
  });
}
function prefinish(stream, state) {
  if (!state.prefinished && !state.finalCalled) {
    if (typeof stream._final === 'function' && !state.destroyed) {
      state.pendingcb++;
      state.finalCalled = true;
      process.nextTick(callFinal, stream, state);
    } else {
      state.prefinished = true;
      stream.emit('prefinish');
    }
  }
}
function finishMaybe(stream, state) {
  var need = needFinish(state);
  if (need) {
    prefinish(stream, state);
    if (state.pendingcb === 0) {
      state.finished = true;
      stream.emit('finish');
      if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well
        var rState = stream._readableState;
        if (!rState || rState.autoDestroy && rState.endEmitted) {
          stream.destroy();
        }
      }
    }
  }
  return need;
}
function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);
  if (cb) {
    if (state.finished) process.nextTick(cb);else stream.once('finish', cb);
  }
  state.ended = true;
  stream.writable = false;
}
function onCorkedFinish(corkReq, state, err) {
  var entry = corkReq.entry;
  corkReq.entry = null;
  while (entry) {
    var cb = entry.callback;
    state.pendingcb--;
    cb(err);
    entry = entry.next;
  }

  // reuse the free corkReq.
  state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty(Writable.prototype, 'destroyed', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    if (this._writableState === undefined) {
      return false;
    }
    return this._writableState.destroyed;
  },
  set: function set(value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._writableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._writableState.destroyed = value;
  }
});
Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;
Writable.prototype._destroy = function (err, cb) {
  cb(err);
};

/***/ }),

/***/ 29954:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
/* provided dependency */ var process = __webpack_require__(14224);


var _Object$setPrototypeO;
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var finished = __webpack_require__(43675);
var kLastResolve = Symbol('lastResolve');
var kLastReject = Symbol('lastReject');
var kError = Symbol('error');
var kEnded = Symbol('ended');
var kLastPromise = Symbol('lastPromise');
var kHandlePromise = Symbol('handlePromise');
var kStream = Symbol('stream');
function createIterResult(value, done) {
  return {
    value: value,
    done: done
  };
}
function readAndResolve(iter) {
  var resolve = iter[kLastResolve];
  if (resolve !== null) {
    var data = iter[kStream].read();
    // we defer if data is null
    // we can be expecting either 'end' or
    // 'error'
    if (data !== null) {
      iter[kLastPromise] = null;
      iter[kLastResolve] = null;
      iter[kLastReject] = null;
      resolve(createIterResult(data, false));
    }
  }
}
function onReadable(iter) {
  // we wait for the next tick, because it might
  // emit an error with process.nextTick
  process.nextTick(readAndResolve, iter);
}
function wrapForNext(lastPromise, iter) {
  return function (resolve, reject) {
    lastPromise.then(function () {
      if (iter[kEnded]) {
        resolve(createIterResult(undefined, true));
        return;
      }
      iter[kHandlePromise](resolve, reject);
    }, reject);
  };
}
var AsyncIteratorPrototype = Object.getPrototypeOf(function () {});
var ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf((_Object$setPrototypeO = {
  get stream() {
    return this[kStream];
  },
  next: function next() {
    var _this = this;
    // if we have detected an error in the meanwhile
    // reject straight away
    var error = this[kError];
    if (error !== null) {
      return Promise.reject(error);
    }
    if (this[kEnded]) {
      return Promise.resolve(createIterResult(undefined, true));
    }
    if (this[kStream].destroyed) {
      // We need to defer via nextTick because if .destroy(err) is
      // called, the error will be emitted via nextTick, and
      // we cannot guarantee that there is no error lingering around
      // waiting to be emitted.
      return new Promise(function (resolve, reject) {
        process.nextTick(function () {
          if (_this[kError]) {
            reject(_this[kError]);
          } else {
            resolve(createIterResult(undefined, true));
          }
        });
      });
    }

    // if we have multiple next() calls
    // we will wait for the previous Promise to finish
    // this logic is optimized to support for await loops,
    // where next() is only called once at a time
    var lastPromise = this[kLastPromise];
    var promise;
    if (lastPromise) {
      promise = new Promise(wrapForNext(lastPromise, this));
    } else {
      // fast path needed to support multiple this.push()
      // without triggering the next() queue
      var data = this[kStream].read();
      if (data !== null) {
        return Promise.resolve(createIterResult(data, false));
      }
      promise = new Promise(this[kHandlePromise]);
    }
    this[kLastPromise] = promise;
    return promise;
  }
}, _defineProperty(_Object$setPrototypeO, Symbol.asyncIterator, function () {
  return this;
}), _defineProperty(_Object$setPrototypeO, "return", function _return() {
  var _this2 = this;
  // destroy(err, cb) is a private API
  // we can guarantee we have that here, because we control the
  // Readable class this is attached to
  return new Promise(function (resolve, reject) {
    _this2[kStream].destroy(null, function (err) {
      if (err) {
        reject(err);
        return;
      }
      resolve(createIterResult(undefined, true));
    });
  });
}), _Object$setPrototypeO), AsyncIteratorPrototype);
var createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
  var _Object$create;
  var iterator = Object.create(ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, _defineProperty(_Object$create, kStream, {
    value: stream,
    writable: true
  }), _defineProperty(_Object$create, kLastResolve, {
    value: null,
    writable: true
  }), _defineProperty(_Object$create, kLastReject, {
    value: null,
    writable: true
  }), _defineProperty(_Object$create, kError, {
    value: null,
    writable: true
  }), _defineProperty(_Object$create, kEnded, {
    value: stream._readableState.endEmitted,
    writable: true
  }), _defineProperty(_Object$create, kHandlePromise, {
    value: function value(resolve, reject) {
      var data = iterator[kStream].read();
      if (data) {
        iterator[kLastPromise] = null;
        iterator[kLastResolve] = null;
        iterator[kLastReject] = null;
        resolve(createIterResult(data, false));
      } else {
        iterator[kLastResolve] = resolve;
        iterator[kLastReject] = reject;
      }
    },
    writable: true
  }), _Object$create));
  iterator[kLastPromise] = null;
  finished(stream, function (err) {
    if (err && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') {
      var reject = iterator[kLastReject];
      // reject if we are waiting for data in the Promise
      // returned by next() and store the error
      if (reject !== null) {
        iterator[kLastPromise] = null;
        iterator[kLastResolve] = null;
        iterator[kLastReject] = null;
        reject(err);
      }
      iterator[kError] = err;
      return;
    }
    var resolve = iterator[kLastResolve];
    if (resolve !== null) {
      iterator[kLastPromise] = null;
      iterator[kLastResolve] = null;
      iterator[kLastReject] = null;
      resolve(createIterResult(undefined, true));
    }
    iterator[kEnded] = true;
  });
  stream.on('readable', onReadable.bind(null, iterator));
  return iterator;
};
module.exports = createReadableStreamAsyncIterator;

/***/ }),

/***/ 96292:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var _require = __webpack_require__(12611),
  Buffer = _require.Buffer;
var _require2 = __webpack_require__(87942),
  inspect = _require2.inspect;
var custom = inspect && inspect.custom || 'inspect';
function copyBuffer(src, target, offset) {
  Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/function () {
  function BufferList() {
    _classCallCheck(this, BufferList);
    this.head = null;
    this.tail = null;
    this.length = 0;
  }
  _createClass(BufferList, [{
    key: "push",
    value: function push(v) {
      var entry = {
        data: v,
        next: null
      };
      if (this.length > 0) this.tail.next = entry;else this.head = entry;
      this.tail = entry;
      ++this.length;
    }
  }, {
    key: "unshift",
    value: function unshift(v) {
      var entry = {
        data: v,
        next: this.head
      };
      if (this.length === 0) this.tail = entry;
      this.head = entry;
      ++this.length;
    }
  }, {
    key: "shift",
    value: function shift() {
      if (this.length === 0) return;
      var ret = this.head.data;
      if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
      --this.length;
      return ret;
    }
  }, {
    key: "clear",
    value: function clear() {
      this.head = this.tail = null;
      this.length = 0;
    }
  }, {
    key: "join",
    value: function join(s) {
      if (this.length === 0) return '';
      var p = this.head;
      var ret = '' + p.data;
      while (p = p.next) ret += s + p.data;
      return ret;
    }
  }, {
    key: "concat",
    value: function concat(n) {
      if (this.length === 0) return Buffer.alloc(0);
      var ret = Buffer.allocUnsafe(n >>> 0);
      var p = this.head;
      var i = 0;
      while (p) {
        copyBuffer(p.data, ret, i);
        i += p.data.length;
        p = p.next;
      }
      return ret;
    }

    // Consumes a specified amount of bytes or characters from the buffered data.
  }, {
    key: "consume",
    value: function consume(n, hasStrings) {
      var ret;
      if (n < this.head.data.length) {
        // `slice` is the same for buffers and strings.
        ret = this.head.data.slice(0, n);
        this.head.data = this.head.data.slice(n);
      } else if (n === this.head.data.length) {
        // First chunk is a perfect match.
        ret = this.shift();
      } else {
        // Result spans more than one buffer.
        ret = hasStrings ? this._getString(n) : this._getBuffer(n);
      }
      return ret;
    }
  }, {
    key: "first",
    value: function first() {
      return this.head.data;
    }

    // Consumes a specified amount of characters from the buffered data.
  }, {
    key: "_getString",
    value: function _getString(n) {
      var p = this.head;
      var c = 1;
      var ret = p.data;
      n -= ret.length;
      while (p = p.next) {
        var str = p.data;
        var nb = n > str.length ? str.length : n;
        if (nb === str.length) ret += str;else ret += str.slice(0, n);
        n -= nb;
        if (n === 0) {
          if (nb === str.length) {
            ++c;
            if (p.next) this.head = p.next;else this.head = this.tail = null;
          } else {
            this.head = p;
            p.data = str.slice(nb);
          }
          break;
        }
        ++c;
      }
      this.length -= c;
      return ret;
    }

    // Consumes a specified amount of bytes from the buffered data.
  }, {
    key: "_getBuffer",
    value: function _getBuffer(n) {
      var ret = Buffer.allocUnsafe(n);
      var p = this.head;
      var c = 1;
      p.data.copy(ret);
      n -= p.data.length;
      while (p = p.next) {
        var buf = p.data;
        var nb = n > buf.length ? buf.length : n;
        buf.copy(ret, ret.length - n, 0, nb);
        n -= nb;
        if (n === 0) {
          if (nb === buf.length) {
            ++c;
            if (p.next) this.head = p.next;else this.head = this.tail = null;
          } else {
            this.head = p;
            p.data = buf.slice(nb);
          }
          break;
        }
        ++c;
      }
      this.length -= c;
      return ret;
    }

    // Make sure the linked list only shows the minimal necessary information.
  }, {
    key: custom,
    value: function value(_, options) {
      return inspect(this, _objectSpread(_objectSpread({}, options), {}, {
        // Only inspect one level.
        depth: 0,
        // It should not recurse.
        customInspect: false
      }));
    }
  }]);
  return BufferList;
}();

/***/ }),

/***/ 33591:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
/* provided dependency */ var process = __webpack_require__(14224);


// undocumented cb() API, needed for core, not for public API
function destroy(err, cb) {
  var _this = this;
  var readableDestroyed = this._readableState && this._readableState.destroyed;
  var writableDestroyed = this._writableState && this._writableState.destroyed;
  if (readableDestroyed || writableDestroyed) {
    if (cb) {
      cb(err);
    } else if (err) {
      if (!this._writableState) {
        process.nextTick(emitErrorNT, this, err);
      } else if (!this._writableState.errorEmitted) {
        this._writableState.errorEmitted = true;
        process.nextTick(emitErrorNT, this, err);
      }
    }
    return this;
  }

  // we set destroyed to true before firing error callbacks in order
  // to make it re-entrance safe in case destroy() is called within callbacks

  if (this._readableState) {
    this._readableState.destroyed = true;
  }

  // if this is a duplex stream mark the writable part as destroyed as well
  if (this._writableState) {
    this._writableState.destroyed = true;
  }
  this._destroy(err || null, function (err) {
    if (!cb && err) {
      if (!_this._writableState) {
        process.nextTick(emitErrorAndCloseNT, _this, err);
      } else if (!_this._writableState.errorEmitted) {
        _this._writableState.errorEmitted = true;
        process.nextTick(emitErrorAndCloseNT, _this, err);
      } else {
        process.nextTick(emitCloseNT, _this);
      }
    } else if (cb) {
      process.nextTick(emitCloseNT, _this);
      cb(err);
    } else {
      process.nextTick(emitCloseNT, _this);
    }
  });
  return this;
}
function emitErrorAndCloseNT(self, err) {
  emitErrorNT(self, err);
  emitCloseNT(self);
}
function emitCloseNT(self) {
  if (self._writableState && !self._writableState.emitClose) return;
  if (self._readableState && !self._readableState.emitClose) return;
  self.emit('close');
}
function undestroy() {
  if (this._readableState) {
    this._readableState.destroyed = false;
    this._readableState.reading = false;
    this._readableState.ended = false;
    this._readableState.endEmitted = false;
  }
  if (this._writableState) {
    this._writableState.destroyed = false;
    this._writableState.ended = false;
    this._writableState.ending = false;
    this._writableState.finalCalled = false;
    this._writableState.prefinished = false;
    this._writableState.finished = false;
    this._writableState.errorEmitted = false;
  }
}
function emitErrorNT(self, err) {
  self.emit('error', err);
}
function errorOrDestroy(stream, err) {
  // We have tests that rely on errors being emitted
  // in the same tick, so changing this is semver major.
  // For now when you opt-in to autoDestroy we allow
  // the error to be emitted nextTick. In a future
  // semver major update we should change the default to this.

  var rState = stream._readableState;
  var wState = stream._writableState;
  if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);else stream.emit('error', err);
}
module.exports = {
  destroy: destroy,
  undestroy: undestroy,
  errorOrDestroy: errorOrDestroy
};

/***/ }),

/***/ 43675:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).



var ERR_STREAM_PREMATURE_CLOSE = (__webpack_require__(60981)/* .codes.ERR_STREAM_PREMATURE_CLOSE */ .q.ERR_STREAM_PREMATURE_CLOSE);
function once(callback) {
  var called = false;
  return function () {
    if (called) return;
    called = true;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    callback.apply(this, args);
  };
}
function noop() {}
function isRequest(stream) {
  return stream.setHeader && typeof stream.abort === 'function';
}
function eos(stream, opts, callback) {
  if (typeof opts === 'function') return eos(stream, null, opts);
  if (!opts) opts = {};
  callback = once(callback || noop);
  var readable = opts.readable || opts.readable !== false && stream.readable;
  var writable = opts.writable || opts.writable !== false && stream.writable;
  var onlegacyfinish = function onlegacyfinish() {
    if (!stream.writable) onfinish();
  };
  var writableEnded = stream._writableState && stream._writableState.finished;
  var onfinish = function onfinish() {
    writable = false;
    writableEnded = true;
    if (!readable) callback.call(stream);
  };
  var readableEnded = stream._readableState && stream._readableState.endEmitted;
  var onend = function onend() {
    readable = false;
    readableEnded = true;
    if (!writable) callback.call(stream);
  };
  var onerror = function onerror(err) {
    callback.call(stream, err);
  };
  var onclose = function onclose() {
    var err;
    if (readable && !readableEnded) {
      if (!stream._readableState || !stream._readableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
      return callback.call(stream, err);
    }
    if (writable && !writableEnded) {
      if (!stream._writableState || !stream._writableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
      return callback.call(stream, err);
    }
  };
  var onrequest = function onrequest() {
    stream.req.on('finish', onfinish);
  };
  if (isRequest(stream)) {
    stream.on('complete', onfinish);
    stream.on('abort', onclose);
    if (stream.req) onrequest();else stream.on('request', onrequest);
  } else if (writable && !stream._writableState) {
    // legacy streams
    stream.on('end', onlegacyfinish);
    stream.on('close', onlegacyfinish);
  }
  stream.on('end', onend);
  stream.on('finish', onfinish);
  if (opts.error !== false) stream.on('error', onerror);
  stream.on('close', onclose);
  return function () {
    stream.removeListener('complete', onfinish);
    stream.removeListener('abort', onclose);
    stream.removeListener('request', onrequest);
    if (stream.req) stream.req.removeListener('finish', onfinish);
    stream.removeListener('end', onlegacyfinish);
    stream.removeListener('close', onlegacyfinish);
    stream.removeListener('finish', onfinish);
    stream.removeListener('end', onend);
    stream.removeListener('error', onerror);
    stream.removeListener('close', onclose);
  };
}
module.exports = eos;

/***/ }),

/***/ 82037:
/***/ ((module) => {

module.exports = function () {
  throw new Error('Readable.from is not available in the browser')
};


/***/ }),

/***/ 95597:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).



var eos;
function once(callback) {
  var called = false;
  return function () {
    if (called) return;
    called = true;
    callback.apply(void 0, arguments);
  };
}
var _require$codes = (__webpack_require__(60981)/* .codes */ .q),
  ERR_MISSING_ARGS = _require$codes.ERR_MISSING_ARGS,
  ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED;
function noop(err) {
  // Rethrow the error if it exists to avoid swallowing it
  if (err) throw err;
}
function isRequest(stream) {
  return stream.setHeader && typeof stream.abort === 'function';
}
function destroyer(stream, reading, writing, callback) {
  callback = once(callback);
  var closed = false;
  stream.on('close', function () {
    closed = true;
  });
  if (eos === undefined) eos = __webpack_require__(43675);
  eos(stream, {
    readable: reading,
    writable: writing
  }, function (err) {
    if (err) return callback(err);
    closed = true;
    callback();
  });
  var destroyed = false;
  return function (err) {
    if (closed) return;
    if (destroyed) return;
    destroyed = true;

    // request.destroy just do .end - .abort is what we want
    if (isRequest(stream)) return stream.abort();
    if (typeof stream.destroy === 'function') return stream.destroy();
    callback(err || new ERR_STREAM_DESTROYED('pipe'));
  };
}
function call(fn) {
  fn();
}
function pipe(from, to) {
  return from.pipe(to);
}
function popCallback(streams) {
  if (!streams.length) return noop;
  if (typeof streams[streams.length - 1] !== 'function') return noop;
  return streams.pop();
}
function pipeline() {
  for (var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++) {
    streams[_key] = arguments[_key];
  }
  var callback = popCallback(streams);
  if (Array.isArray(streams[0])) streams = streams[0];
  if (streams.length < 2) {
    throw new ERR_MISSING_ARGS('streams');
  }
  var error;
  var destroys = streams.map(function (stream, i) {
    var reading = i < streams.length - 1;
    var writing = i > 0;
    return destroyer(stream, reading, writing, function (err) {
      if (!error) error = err;
      if (err) destroys.forEach(call);
      if (reading) return;
      destroys.forEach(call);
      callback(error);
    });
  });
  return streams.reduce(pipe);
}
module.exports = pipeline;

/***/ }),

/***/ 16084:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var ERR_INVALID_OPT_VALUE = (__webpack_require__(60981)/* .codes.ERR_INVALID_OPT_VALUE */ .q.ERR_INVALID_OPT_VALUE);
function highWaterMarkFrom(options, isDuplex, duplexKey) {
  return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function getHighWaterMark(state, options, duplexKey, isDuplex) {
  var hwm = highWaterMarkFrom(options, isDuplex, duplexKey);
  if (hwm != null) {
    if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
      var name = isDuplex ? duplexKey : 'highWaterMark';
      throw new ERR_INVALID_OPT_VALUE(name, hwm);
    }
    return Math.floor(hwm);
  }

  // Default value
  return state.objectMode ? 16 : 16 * 1024;
}
module.exports = {
  getHighWaterMark: getHighWaterMark
};

/***/ }),

/***/ 26922:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__(72100).EventEmitter;


/***/ }),

/***/ 50536:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (thunk);

/***/ }),

/***/ 4238:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   __DO_NOT_USE__ActionTypes: () => (/* binding */ ActionTypes),
/* harmony export */   applyMiddleware: () => (/* binding */ applyMiddleware),
/* harmony export */   bindActionCreators: () => (/* binding */ bindActionCreators),
/* harmony export */   combineReducers: () => (/* binding */ combineReducers),
/* harmony export */   compose: () => (/* binding */ compose),
/* harmony export */   createStore: () => (/* binding */ createStore)
/* harmony export */ });
/* harmony import */ var symbol_observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61603);


/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var randomString = function randomString() {
  return Math.random().toString(36).substring(7).split('').join('.');
};

var ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString(),
  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
  }
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = obj;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}

/**
 * Creates a Redux store that holds the state tree.
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */

function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
    throw new Error('It looks like you are passing several store enhancers to ' + 'createStore(). This is not supported. Instead, compose them ' + 'together to a single function.');
  }

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;
  /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }
  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */


  function getState() {
    if (isDispatching) {
      throw new Error('You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
    }

    return currentState;
  }
  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */


  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected the listener to be a function.');
    }

    if (isDispatching) {
      throw new Error('You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api-reference/store#subscribelistener for more details.');
    }

    var isSubscribed = true;
    ensureCanMutateNextListeners();
    nextListeners.push(listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error('You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api-reference/store#subscribelistener for more details.');
      }

      isSubscribed = false;
      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
      currentListeners = null;
    };
  }
  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */


  function dispatch(action) {
    if (!isPlainObject(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;

    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }
  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */


  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
    // Any reducers that existed in both the new and old rootReducer
    // will receive the previous state. This effectively populates
    // the new state tree with any relevant data from the old one.

    dispatch({
      type: ActionTypes.REPLACE
    });
  }
  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */


  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe: unsubscribe
        };
      }
    }, _ref[symbol_observable__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z] = function () {
      return this;
    }, _ref;
  } // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.


  dispatch({
    type: ActionTypes.INIT
  });
  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[symbol_observable__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z] = observable, _ref2;
}

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty

}

function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionDescription = actionType && "action \"" + String(actionType) + "\"" || 'an action';
  return "Given " + actionDescription + ", reducer \"" + key + "\" returned undefined. " + "To ignore an action, you must explicitly return the previous state. " + "If you want this reducer to hold no value, you can return null instead of undefined.";
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!isPlainObject(inputState)) {
    return "The " + argumentName + " has unexpected type of \"" + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });
  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });
  if (action && action.type === ActionTypes.REPLACE) return;

  if (unexpectedKeys.length > 0) {
    return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, {
      type: ActionTypes.INIT
    });

    if (typeof initialState === 'undefined') {
      throw new Error("Reducer \"" + key + "\" returned undefined during initialization. " + "If the state passed to the reducer is undefined, you must " + "explicitly return the initial state. The initial state may " + "not be undefined. If you don't want to set a value for this reducer, " + "you can use null instead of undefined.");
    }

    if (typeof reducer(undefined, {
      type: ActionTypes.PROBE_UNKNOWN_ACTION()
    }) === 'undefined') {
      throw new Error("Reducer \"" + key + "\" returned undefined when probed with a random type. " + ("Don't try to handle " + ActionTypes.INIT + " or other actions in \"redux/*\" ") + "namespace. They are considered private. Instead, you must return the " + "current state for any unknown actions, unless it is undefined, " + "in which case you must return the initial state, regardless of the " + "action type. The initial state may not be undefined, but can be null.");
    }
  });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */


function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};

  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {}

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }

  var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
  // keys multiple times.

  var unexpectedKeyCache;

  if (false) {}

  var shapeAssertionError;

  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination(state, action) {
    if (state === void 0) {
      state = {};
    }

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) { var warningMessage; }

    var hasChanged = false;
    var nextState = {};

    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);

      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }

      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }

    hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
    return hasChanged ? nextState : state;
  };
}

function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(this, arguments));
  };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */


function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error("bindActionCreators expected an object or a function, instead received " + (actionCreators === null ? 'null' : typeof actionCreators) + ". " + "Did you write \"import ActionCreators from\" instead of \"import * as ActionCreators from\"?");
  }

  var boundActionCreators = {};

  for (var key in actionCreators) {
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }

  return boundActionCreators;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    keys.push.apply(keys, Object.getOwnPropertySymbols(object));
  }

  if (enumerableOnly) keys = keys.filter(function (sym) {
    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
  });
  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */
function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  });
}

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */

function applyMiddleware() {
  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function () {
      var store = createStore.apply(void 0, arguments);

      var _dispatch = function dispatch() {
        throw new Error('Dispatching while constructing your middleware is not allowed. ' + 'Other middleware would not be applied to this dispatch.');
      };

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(void 0, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(void 0, chain)(store.dispatch);
      return _objectSpread2({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */

function isCrushed() {}

if (false) {}




/***/ }),

/***/ 61874:
/***/ ((module, exports, __webpack_require__) => {

/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__(12611)
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.prototype = Object.create(Buffer.prototype)

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),

/***/ 69499:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

;(function (sax) { // wrapper for non-node envs
  sax.parser = function (strict, opt) { return new SAXParser(strict, opt) }
  sax.SAXParser = SAXParser
  sax.SAXStream = SAXStream
  sax.createStream = createStream

  // When we pass the MAX_BUFFER_LENGTH position, start checking for buffer overruns.
  // When we check, schedule the next check for MAX_BUFFER_LENGTH - (max(buffer lengths)),
  // since that's the earliest that a buffer overrun could occur.  This way, checks are
  // as rare as required, but as often as necessary to ensure never crossing this bound.
  // Furthermore, buffers are only tested at most once per write(), so passing a very
  // large string into write() might have undesirable effects, but this is manageable by
  // the caller, so it is assumed to be safe.  Thus, a call to write() may, in the extreme
  // edge case, result in creating at most one complete copy of the string passed in.
  // Set to Infinity to have unlimited buffers.
  sax.MAX_BUFFER_LENGTH = 64 * 1024

  var buffers = [
    'comment', 'sgmlDecl', 'textNode', 'tagName', 'doctype',
    'procInstName', 'procInstBody', 'entity', 'attribName',
    'attribValue', 'cdata', 'script'
  ]

  sax.EVENTS = [
    'text',
    'processinginstruction',
    'sgmldeclaration',
    'doctype',
    'comment',
    'opentagstart',
    'attribute',
    'opentag',
    'closetag',
    'opencdata',
    'cdata',
    'closecdata',
    'error',
    'end',
    'ready',
    'script',
    'opennamespace',
    'closenamespace'
  ]

  function SAXParser (strict, opt) {
    if (!(this instanceof SAXParser)) {
      return new SAXParser(strict, opt)
    }

    var parser = this
    clearBuffers(parser)
    parser.q = parser.c = ''
    parser.bufferCheckPosition = sax.MAX_BUFFER_LENGTH
    parser.opt = opt || {}
    parser.opt.lowercase = parser.opt.lowercase || parser.opt.lowercasetags
    parser.looseCase = parser.opt.lowercase ? 'toLowerCase' : 'toUpperCase'
    parser.tags = []
    parser.closed = parser.closedRoot = parser.sawRoot = false
    parser.tag = parser.error = null
    parser.strict = !!strict
    parser.noscript = !!(strict || parser.opt.noscript)
    parser.state = S.BEGIN
    parser.strictEntities = parser.opt.strictEntities
    parser.ENTITIES = parser.strictEntities ? Object.create(sax.XML_ENTITIES) : Object.create(sax.ENTITIES)
    parser.attribList = []

    // namespaces form a prototype chain.
    // it always points at the current tag,
    // which protos to its parent tag.
    if (parser.opt.xmlns) {
      parser.ns = Object.create(rootNS)
    }

    // mostly just for error reporting
    parser.trackPosition = parser.opt.position !== false
    if (parser.trackPosition) {
      parser.position = parser.line = parser.column = 0
    }
    emit(parser, 'onready')
  }

  if (!Object.create) {
    Object.create = function (o) {
      function F () {}
      F.prototype = o
      var newf = new F()
      return newf
    }
  }

  if (!Object.keys) {
    Object.keys = function (o) {
      var a = []
      for (var i in o) if (o.hasOwnProperty(i)) a.push(i)
      return a
    }
  }

  function checkBufferLength (parser) {
    var maxAllowed = Math.max(sax.MAX_BUFFER_LENGTH, 10)
    var maxActual = 0
    for (var i = 0, l = buffers.length; i < l; i++) {
      var len = parser[buffers[i]].length
      if (len > maxAllowed) {
        // Text/cdata nodes can get big, and since they're buffered,
        // we can get here under normal conditions.
        // Avoid issues by emitting the text node now,
        // so at least it won't get any bigger.
        switch (buffers[i]) {
          case 'textNode':
            closeText(parser)
            break

          case 'cdata':
            emitNode(parser, 'oncdata', parser.cdata)
            parser.cdata = ''
            break

          case 'script':
            emitNode(parser, 'onscript', parser.script)
            parser.script = ''
            break

          default:
            error(parser, 'Max buffer length exceeded: ' + buffers[i])
        }
      }
      maxActual = Math.max(maxActual, len)
    }
    // schedule the next check for the earliest possible buffer overrun.
    var m = sax.MAX_BUFFER_LENGTH - maxActual
    parser.bufferCheckPosition = m + parser.position
  }

  function clearBuffers (parser) {
    for (var i = 0, l = buffers.length; i < l; i++) {
      parser[buffers[i]] = ''
    }
  }

  function flushBuffers (parser) {
    closeText(parser)
    if (parser.cdata !== '') {
      emitNode(parser, 'oncdata', parser.cdata)
      parser.cdata = ''
    }
    if (parser.script !== '') {
      emitNode(parser, 'onscript', parser.script)
      parser.script = ''
    }
  }

  SAXParser.prototype = {
    end: function () { end(this) },
    write: write,
    resume: function () { this.error = null; return this },
    close: function () { return this.write(null) },
    flush: function () { flushBuffers(this) }
  }

  var Stream
  try {
    Stream = (__webpack_require__(76835).Stream)
  } catch (ex) {
    Stream = function () {}
  }

  var streamWraps = sax.EVENTS.filter(function (ev) {
    return ev !== 'error' && ev !== 'end'
  })

  function createStream (strict, opt) {
    return new SAXStream(strict, opt)
  }

  function SAXStream (strict, opt) {
    if (!(this instanceof SAXStream)) {
      return new SAXStream(strict, opt)
    }

    Stream.apply(this)

    this._parser = new SAXParser(strict, opt)
    this.writable = true
    this.readable = true

    var me = this

    this._parser.onend = function () {
      me.emit('end')
    }

    this._parser.onerror = function (er) {
      me.emit('error', er)

      // if didn't throw, then means error was handled.
      // go ahead and clear error, so we can write again.
      me._parser.error = null
    }

    this._decoder = null

    streamWraps.forEach(function (ev) {
      Object.defineProperty(me, 'on' + ev, {
        get: function () {
          return me._parser['on' + ev]
        },
        set: function (h) {
          if (!h) {
            me.removeAllListeners(ev)
            me._parser['on' + ev] = h
            return h
          }
          me.on(ev, h)
        },
        enumerable: true,
        configurable: false
      })
    })
  }

  SAXStream.prototype = Object.create(Stream.prototype, {
    constructor: {
      value: SAXStream
    }
  })

  SAXStream.prototype.write = function (data) {
    if (typeof Buffer === 'function' &&
      typeof Buffer.isBuffer === 'function' &&
      Buffer.isBuffer(data)) {
      if (!this._decoder) {
        var SD = (__webpack_require__(72699)/* .StringDecoder */ .s)
        this._decoder = new SD('utf8')
      }
      data = this._decoder.write(data)
    }

    this._parser.write(data.toString())
    this.emit('data', data)
    return true
  }

  SAXStream.prototype.end = function (chunk) {
    if (chunk && chunk.length) {
      this.write(chunk)
    }
    this._parser.end()
    return true
  }

  SAXStream.prototype.on = function (ev, handler) {
    var me = this
    if (!me._parser['on' + ev] && streamWraps.indexOf(ev) !== -1) {
      me._parser['on' + ev] = function () {
        var args = arguments.length === 1 ? [arguments[0]] : Array.apply(null, arguments)
        args.splice(0, 0, ev)
        me.emit.apply(me, args)
      }
    }

    return Stream.prototype.on.call(me, ev, handler)
  }

  // this really needs to be replaced with character classes.
  // XML allows all manner of ridiculous numbers and digits.
  var CDATA = '[CDATA['
  var DOCTYPE = 'DOCTYPE'
  var XML_NAMESPACE = 'http://www.w3.org/XML/1998/namespace'
  var XMLNS_NAMESPACE = 'http://www.w3.org/2000/xmlns/'
  var rootNS = { xml: XML_NAMESPACE, xmlns: XMLNS_NAMESPACE }

  // http://www.w3.org/TR/REC-xml/#NT-NameStartChar
  // This implementation works on strings, a single character at a time
  // as such, it cannot ever support astral-plane characters (10000-EFFFF)
  // without a significant breaking change to either this  parser, or the
  // JavaScript language.  Implementation of an emoji-capable xml parser
  // is left as an exercise for the reader.
  var nameStart = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/

  var nameBody = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040.\d-]/

  var entityStart = /[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/
  var entityBody = /[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040.\d-]/

  function isWhitespace (c) {
    return c === ' ' || c === '\n' || c === '\r' || c === '\t'
  }

  function isQuote (c) {
    return c === '"' || c === '\''
  }

  function isAttribEnd (c) {
    return c === '>' || isWhitespace(c)
  }

  function isMatch (regex, c) {
    return regex.test(c)
  }

  function notMatch (regex, c) {
    return !isMatch(regex, c)
  }

  var S = 0
  sax.STATE = {
    BEGIN: S++, // leading byte order mark or whitespace
    BEGIN_WHITESPACE: S++, // leading whitespace
    TEXT: S++, // general stuff
    TEXT_ENTITY: S++, // &amp and such.
    OPEN_WAKA: S++, // <
    SGML_DECL: S++, // <!BLARG
    SGML_DECL_QUOTED: S++, // <!BLARG foo "bar
    DOCTYPE: S++, // <!DOCTYPE
    DOCTYPE_QUOTED: S++, // <!DOCTYPE "//blah
    DOCTYPE_DTD: S++, // <!DOCTYPE "//blah" [ ...
    DOCTYPE_DTD_QUOTED: S++, // <!DOCTYPE "//blah" [ "foo
    COMMENT_STARTING: S++, // <!-
    COMMENT: S++, // <!--
    COMMENT_ENDING: S++, // <!-- blah -
    COMMENT_ENDED: S++, // <!-- blah --
    CDATA: S++, // <![CDATA[ something
    CDATA_ENDING: S++, // ]
    CDATA_ENDING_2: S++, // ]]
    PROC_INST: S++, // <?hi
    PROC_INST_BODY: S++, // <?hi there
    PROC_INST_ENDING: S++, // <?hi "there" ?
    OPEN_TAG: S++, // <strong
    OPEN_TAG_SLASH: S++, // <strong /
    ATTRIB: S++, // <a
    ATTRIB_NAME: S++, // <a foo
    ATTRIB_NAME_SAW_WHITE: S++, // <a foo _
    ATTRIB_VALUE: S++, // <a foo=
    ATTRIB_VALUE_QUOTED: S++, // <a foo="bar
    ATTRIB_VALUE_CLOSED: S++, // <a foo="bar"
    ATTRIB_VALUE_UNQUOTED: S++, // <a foo=bar
    ATTRIB_VALUE_ENTITY_Q: S++, // <foo bar="&quot;"
    ATTRIB_VALUE_ENTITY_U: S++, // <foo bar=&quot
    CLOSE_TAG: S++, // </a
    CLOSE_TAG_SAW_WHITE: S++, // </a   >
    SCRIPT: S++, // <script> ...
    SCRIPT_ENDING: S++ // <script> ... <
  }

  sax.XML_ENTITIES = {
    'amp': '&',
    'gt': '>',
    'lt': '<',
    'quot': '"',
    'apos': "'"
  }

  sax.ENTITIES = {
    'amp': '&',
    'gt': '>',
    'lt': '<',
    'quot': '"',
    'apos': "'",
    'AElig': 198,
    'Aacute': 193,
    'Acirc': 194,
    'Agrave': 192,
    'Aring': 197,
    'Atilde': 195,
    'Auml': 196,
    'Ccedil': 199,
    'ETH': 208,
    'Eacute': 201,
    'Ecirc': 202,
    'Egrave': 200,
    'Euml': 203,
    'Iacute': 205,
    'Icirc': 206,
    'Igrave': 204,
    'Iuml': 207,
    'Ntilde': 209,
    'Oacute': 211,
    'Ocirc': 212,
    'Ograve': 210,
    'Oslash': 216,
    'Otilde': 213,
    'Ouml': 214,
    'THORN': 222,
    'Uacute': 218,
    'Ucirc': 219,
    'Ugrave': 217,
    'Uuml': 220,
    'Yacute': 221,
    'aacute': 225,
    'acirc': 226,
    'aelig': 230,
    'agrave': 224,
    'aring': 229,
    'atilde': 227,
    'auml': 228,
    'ccedil': 231,
    'eacute': 233,
    'ecirc': 234,
    'egrave': 232,
    'eth': 240,
    'euml': 235,
    'iacute': 237,
    'icirc': 238,
    'igrave': 236,
    'iuml': 239,
    'ntilde': 241,
    'oacute': 243,
    'ocirc': 244,
    'ograve': 242,
    'oslash': 248,
    'otilde': 245,
    'ouml': 246,
    'szlig': 223,
    'thorn': 254,
    'uacute': 250,
    'ucirc': 251,
    'ugrave': 249,
    'uuml': 252,
    'yacute': 253,
    'yuml': 255,
    'copy': 169,
    'reg': 174,
    'nbsp': 160,
    'iexcl': 161,
    'cent': 162,
    'pound': 163,
    'curren': 164,
    'yen': 165,
    'brvbar': 166,
    'sect': 167,
    'uml': 168,
    'ordf': 170,
    'laquo': 171,
    'not': 172,
    'shy': 173,
    'macr': 175,
    'deg': 176,
    'plusmn': 177,
    'sup1': 185,
    'sup2': 178,
    'sup3': 179,
    'acute': 180,
    'micro': 181,
    'para': 182,
    'middot': 183,
    'cedil': 184,
    'ordm': 186,
    'raquo': 187,
    'frac14': 188,
    'frac12': 189,
    'frac34': 190,
    'iquest': 191,
    'times': 215,
    'divide': 247,
    'OElig': 338,
    'oelig': 339,
    'Scaron': 352,
    'scaron': 353,
    'Yuml': 376,
    'fnof': 402,
    'circ': 710,
    'tilde': 732,
    'Alpha': 913,
    'Beta': 914,
    'Gamma': 915,
    'Delta': 916,
    'Epsilon': 917,
    'Zeta': 918,
    'Eta': 919,
    'Theta': 920,
    'Iota': 921,
    'Kappa': 922,
    'Lambda': 923,
    'Mu': 924,
    'Nu': 925,
    'Xi': 926,
    'Omicron': 927,
    'Pi': 928,
    'Rho': 929,
    'Sigma': 931,
    'Tau': 932,
    'Upsilon': 933,
    'Phi': 934,
    'Chi': 935,
    'Psi': 936,
    'Omega': 937,
    'alpha': 945,
    'beta': 946,
    'gamma': 947,
    'delta': 948,
    'epsilon': 949,
    'zeta': 950,
    'eta': 951,
    'theta': 952,
    'iota': 953,
    'kappa': 954,
    'lambda': 955,
    'mu': 956,
    'nu': 957,
    'xi': 958,
    'omicron': 959,
    'pi': 960,
    'rho': 961,
    'sigmaf': 962,
    'sigma': 963,
    'tau': 964,
    'upsilon': 965,
    'phi': 966,
    'chi': 967,
    'psi': 968,
    'omega': 969,
    'thetasym': 977,
    'upsih': 978,
    'piv': 982,
    'ensp': 8194,
    'emsp': 8195,
    'thinsp': 8201,
    'zwnj': 8204,
    'zwj': 8205,
    'lrm': 8206,
    'rlm': 8207,
    'ndash': 8211,
    'mdash': 8212,
    'lsquo': 8216,
    'rsquo': 8217,
    'sbquo': 8218,
    'ldquo': 8220,
    'rdquo': 8221,
    'bdquo': 8222,
    'dagger': 8224,
    'Dagger': 8225,
    'bull': 8226,
    'hellip': 8230,
    'permil': 8240,
    'prime': 8242,
    'Prime': 8243,
    'lsaquo': 8249,
    'rsaquo': 8250,
    'oline': 8254,
    'frasl': 8260,
    'euro': 8364,
    'image': 8465,
    'weierp': 8472,
    'real': 8476,
    'trade': 8482,
    'alefsym': 8501,
    'larr': 8592,
    'uarr': 8593,
    'rarr': 8594,
    'darr': 8595,
    'harr': 8596,
    'crarr': 8629,
    'lArr': 8656,
    'uArr': 8657,
    'rArr': 8658,
    'dArr': 8659,
    'hArr': 8660,
    'forall': 8704,
    'part': 8706,
    'exist': 8707,
    'empty': 8709,
    'nabla': 8711,
    'isin': 8712,
    'notin': 8713,
    'ni': 8715,
    'prod': 8719,
    'sum': 8721,
    'minus': 8722,
    'lowast': 8727,
    'radic': 8730,
    'prop': 8733,
    'infin': 8734,
    'ang': 8736,
    'and': 8743,
    'or': 8744,
    'cap': 8745,
    'cup': 8746,
    'int': 8747,
    'there4': 8756,
    'sim': 8764,
    'cong': 8773,
    'asymp': 8776,
    'ne': 8800,
    'equiv': 8801,
    'le': 8804,
    'ge': 8805,
    'sub': 8834,
    'sup': 8835,
    'nsub': 8836,
    'sube': 8838,
    'supe': 8839,
    'oplus': 8853,
    'otimes': 8855,
    'perp': 8869,
    'sdot': 8901,
    'lceil': 8968,
    'rceil': 8969,
    'lfloor': 8970,
    'rfloor': 8971,
    'lang': 9001,
    'rang': 9002,
    'loz': 9674,
    'spades': 9824,
    'clubs': 9827,
    'hearts': 9829,
    'diams': 9830
  }

  Object.keys(sax.ENTITIES).forEach(function (key) {
    var e = sax.ENTITIES[key]
    var s = typeof e === 'number' ? String.fromCharCode(e) : e
    sax.ENTITIES[key] = s
  })

  for (var s in sax.STATE) {
    sax.STATE[sax.STATE[s]] = s
  }

  // shorthand
  S = sax.STATE

  function emit (parser, event, data) {
    parser[event] && parser[event](data)
  }

  function emitNode (parser, nodeType, data) {
    if (parser.textNode) closeText(parser)
    emit(parser, nodeType, data)
  }

  function closeText (parser) {
    parser.textNode = textopts(parser.opt, parser.textNode)
    if (parser.textNode) emit(parser, 'ontext', parser.textNode)
    parser.textNode = ''
  }

  function textopts (opt, text) {
    if (opt.trim) text = text.trim()
    if (opt.normalize) text = text.replace(/\s+/g, ' ')
    return text
  }

  function error (parser, er) {
    closeText(parser)
    if (parser.trackPosition) {
      er += '\nLine: ' + parser.line +
        '\nColumn: ' + parser.column +
        '\nChar: ' + parser.c
    }
    er = new Error(er)
    parser.error = er
    emit(parser, 'onerror', er)
    return parser
  }

  function end (parser) {
    if (parser.sawRoot && !parser.closedRoot) strictFail(parser, 'Unclosed root tag')
    if ((parser.state !== S.BEGIN) &&
      (parser.state !== S.BEGIN_WHITESPACE) &&
      (parser.state !== S.TEXT)) {
      error(parser, 'Unexpected end')
    }
    closeText(parser)
    parser.c = ''
    parser.closed = true
    emit(parser, 'onend')
    SAXParser.call(parser, parser.strict, parser.opt)
    return parser
  }

  function strictFail (parser, message) {
    if (typeof parser !== 'object' || !(parser instanceof SAXParser)) {
      throw new Error('bad call to strictFail')
    }
    if (parser.strict) {
      error(parser, message)
    }
  }

  function newTag (parser) {
    if (!parser.strict) parser.tagName = parser.tagName[parser.looseCase]()
    var parent = parser.tags[parser.tags.length - 1] || parser
    var tag = parser.tag = { name: parser.tagName, attributes: {} }

    // will be overridden if tag contails an xmlns="foo" or xmlns:foo="bar"
    if (parser.opt.xmlns) {
      tag.ns = parent.ns
    }
    parser.attribList.length = 0
    emitNode(parser, 'onopentagstart', tag)
  }

  function qname (name, attribute) {
    var i = name.indexOf(':')
    var qualName = i < 0 ? [ '', name ] : name.split(':')
    var prefix = qualName[0]
    var local = qualName[1]

    // <x "xmlns"="http://foo">
    if (attribute && name === 'xmlns') {
      prefix = 'xmlns'
      local = ''
    }

    return { prefix: prefix, local: local }
  }

  function attrib (parser) {
    if (!parser.strict) {
      parser.attribName = parser.attribName[parser.looseCase]()
    }

    if (parser.attribList.indexOf(parser.attribName) !== -1 ||
      parser.tag.attributes.hasOwnProperty(parser.attribName)) {
      parser.attribName = parser.attribValue = ''
      return
    }

    if (parser.opt.xmlns) {
      var qn = qname(parser.attribName, true)
      var prefix = qn.prefix
      var local = qn.local

      if (prefix === 'xmlns') {
        // namespace binding attribute. push the binding into scope
        if (local === 'xml' && parser.attribValue !== XML_NAMESPACE) {
          strictFail(parser,
            'xml: prefix must be bound to ' + XML_NAMESPACE + '\n' +
            'Actual: ' + parser.attribValue)
        } else if (local === 'xmlns' && parser.attribValue !== XMLNS_NAMESPACE) {
          strictFail(parser,
            'xmlns: prefix must be bound to ' + XMLNS_NAMESPACE + '\n' +
            'Actual: ' + parser.attribValue)
        } else {
          var tag = parser.tag
          var parent = parser.tags[parser.tags.length - 1] || parser
          if (tag.ns === parent.ns) {
            tag.ns = Object.create(parent.ns)
          }
          tag.ns[local] = parser.attribValue
        }
      }

      // defer onattribute events until all attributes have been seen
      // so any new bindings can take effect. preserve attribute order
      // so deferred events can be emitted in document order
      parser.attribList.push([parser.attribName, parser.attribValue])
    } else {
      // in non-xmlns mode, we can emit the event right away
      parser.tag.attributes[parser.attribName] = parser.attribValue
      emitNode(parser, 'onattribute', {
        name: parser.attribName,
        value: parser.attribValue
      })
    }

    parser.attribName = parser.attribValue = ''
  }

  function openTag (parser, selfClosing) {
    if (parser.opt.xmlns) {
      // emit namespace binding events
      var tag = parser.tag

      // add namespace info to tag
      var qn = qname(parser.tagName)
      tag.prefix = qn.prefix
      tag.local = qn.local
      tag.uri = tag.ns[qn.prefix] || ''

      if (tag.prefix && !tag.uri) {
        strictFail(parser, 'Unbound namespace prefix: ' +
          JSON.stringify(parser.tagName))
        tag.uri = qn.prefix
      }

      var parent = parser.tags[parser.tags.length - 1] || parser
      if (tag.ns && parent.ns !== tag.ns) {
        Object.keys(tag.ns).forEach(function (p) {
          emitNode(parser, 'onopennamespace', {
            prefix: p,
            uri: tag.ns[p]
          })
        })
      }

      // handle deferred onattribute events
      // Note: do not apply default ns to attributes:
      //   http://www.w3.org/TR/REC-xml-names/#defaulting
      for (var i = 0, l = parser.attribList.length; i < l; i++) {
        var nv = parser.attribList[i]
        var name = nv[0]
        var value = nv[1]
        var qualName = qname(name, true)
        var prefix = qualName.prefix
        var local = qualName.local
        var uri = prefix === '' ? '' : (tag.ns[prefix] || '')
        var a = {
          name: name,
          value: value,
          prefix: prefix,
          local: local,
          uri: uri
        }

        // if there's any attributes with an undefined namespace,
        // then fail on them now.
        if (prefix && prefix !== 'xmlns' && !uri) {
          strictFail(parser, 'Unbound namespace prefix: ' +
            JSON.stringify(prefix))
          a.uri = prefix
        }
        parser.tag.attributes[name] = a
        emitNode(parser, 'onattribute', a)
      }
      parser.attribList.length = 0
    }

    parser.tag.isSelfClosing = !!selfClosing

    // process the tag
    parser.sawRoot = true
    parser.tags.push(parser.tag)
    emitNode(parser, 'onopentag', parser.tag)
    if (!selfClosing) {
      // special case for <script> in non-strict mode.
      if (!parser.noscript && parser.tagName.toLowerCase() === 'script') {
        parser.state = S.SCRIPT
      } else {
        parser.state = S.TEXT
      }
      parser.tag = null
      parser.tagName = ''
    }
    parser.attribName = parser.attribValue = ''
    parser.attribList.length = 0
  }

  function closeTag (parser) {
    if (!parser.tagName) {
      strictFail(parser, 'Weird empty close tag.')
      parser.textNode += '</>'
      parser.state = S.TEXT
      return
    }

    if (parser.script) {
      if (parser.tagName !== 'script') {
        parser.script += '</' + parser.tagName + '>'
        parser.tagName = ''
        parser.state = S.SCRIPT
        return
      }
      emitNode(parser, 'onscript', parser.script)
      parser.script = ''
    }

    // first make sure that the closing tag actually exists.
    // <a><b></c></b></a> will close everything, otherwise.
    var t = parser.tags.length
    var tagName = parser.tagName
    if (!parser.strict) {
      tagName = tagName[parser.looseCase]()
    }
    var closeTo = tagName
    while (t--) {
      var close = parser.tags[t]
      if (close.name !== closeTo) {
        // fail the first time in strict mode
        strictFail(parser, 'Unexpected close tag')
      } else {
        break
      }
    }

    // didn't find it.  we already failed for strict, so just abort.
    if (t < 0) {
      strictFail(parser, 'Unmatched closing tag: ' + parser.tagName)
      parser.textNode += '</' + parser.tagName + '>'
      parser.state = S.TEXT
      return
    }
    parser.tagName = tagName
    var s = parser.tags.length
    while (s-- > t) {
      var tag = parser.tag = parser.tags.pop()
      parser.tagName = parser.tag.name
      emitNode(parser, 'onclosetag', parser.tagName)

      var x = {}
      for (var i in tag.ns) {
        x[i] = tag.ns[i]
      }

      var parent = parser.tags[parser.tags.length - 1] || parser
      if (parser.opt.xmlns && tag.ns !== parent.ns) {
        // remove namespace bindings introduced by tag
        Object.keys(tag.ns).forEach(function (p) {
          var n = tag.ns[p]
          emitNode(parser, 'onclosenamespace', { prefix: p, uri: n })
        })
      }
    }
    if (t === 0) parser.closedRoot = true
    parser.tagName = parser.attribValue = parser.attribName = ''
    parser.attribList.length = 0
    parser.state = S.TEXT
  }

  function parseEntity (parser) {
    var entity = parser.entity
    var entityLC = entity.toLowerCase()
    var num
    var numStr = ''

    if (parser.ENTITIES[entity]) {
      return parser.ENTITIES[entity]
    }
    if (parser.ENTITIES[entityLC]) {
      return parser.ENTITIES[entityLC]
    }
    entity = entityLC
    if (entity.charAt(0) === '#') {
      if (entity.charAt(1) === 'x') {
        entity = entity.slice(2)
        num = parseInt(entity, 16)
        numStr = num.toString(16)
      } else {
        entity = entity.slice(1)
        num = parseInt(entity, 10)
        numStr = num.toString(10)
      }
    }
    entity = entity.replace(/^0+/, '')
    if (isNaN(num) || numStr.toLowerCase() !== entity) {
      strictFail(parser, 'Invalid character entity')
      return '&' + parser.entity + ';'
    }

    return String.fromCodePoint(num)
  }

  function beginWhiteSpace (parser, c) {
    if (c === '<') {
      parser.state = S.OPEN_WAKA
      parser.startTagPosition = parser.position
    } else if (!isWhitespace(c)) {
      // have to process this as a text node.
      // weird, but happens.
      strictFail(parser, 'Non-whitespace before first tag.')
      parser.textNode = c
      parser.state = S.TEXT
    }
  }

  function charAt (chunk, i) {
    var result = ''
    if (i < chunk.length) {
      result = chunk.charAt(i)
    }
    return result
  }

  function write (chunk) {
    var parser = this
    if (this.error) {
      throw this.error
    }
    if (parser.closed) {
      return error(parser,
        'Cannot write after close. Assign an onready handler.')
    }
    if (chunk === null) {
      return end(parser)
    }
    if (typeof chunk === 'object') {
      chunk = chunk.toString()
    }
    var i = 0
    var c = ''
    while (true) {
      c = charAt(chunk, i++)
      parser.c = c

      if (!c) {
        break
      }

      if (parser.trackPosition) {
        parser.position++
        if (c === '\n') {
          parser.line++
          parser.column = 0
        } else {
          parser.column++
        }
      }

      switch (parser.state) {
        case S.BEGIN:
          parser.state = S.BEGIN_WHITESPACE
          if (c === '\uFEFF') {
            continue
          }
          beginWhiteSpace(parser, c)
          continue

        case S.BEGIN_WHITESPACE:
          beginWhiteSpace(parser, c)
          continue

        case S.TEXT:
          if (parser.sawRoot && !parser.closedRoot) {
            var starti = i - 1
            while (c && c !== '<' && c !== '&') {
              c = charAt(chunk, i++)
              if (c && parser.trackPosition) {
                parser.position++
                if (c === '\n') {
                  parser.line++
                  parser.column = 0
                } else {
                  parser.column++
                }
              }
            }
            parser.textNode += chunk.substring(starti, i - 1)
          }
          if (c === '<' && !(parser.sawRoot && parser.closedRoot && !parser.strict)) {
            parser.state = S.OPEN_WAKA
            parser.startTagPosition = parser.position
          } else {
            if (!isWhitespace(c) && (!parser.sawRoot || parser.closedRoot)) {
              strictFail(parser, 'Text data outside of root node.')
            }
            if (c === '&') {
              parser.state = S.TEXT_ENTITY
            } else {
              parser.textNode += c
            }
          }
          continue

        case S.SCRIPT:
          // only non-strict
          if (c === '<') {
            parser.state = S.SCRIPT_ENDING
          } else {
            parser.script += c
          }
          continue

        case S.SCRIPT_ENDING:
          if (c === '/') {
            parser.state = S.CLOSE_TAG
          } else {
            parser.script += '<' + c
            parser.state = S.SCRIPT
          }
          continue

        case S.OPEN_WAKA:
          // either a /, ?, !, or text is coming next.
          if (c === '!') {
            parser.state = S.SGML_DECL
            parser.sgmlDecl = ''
          } else if (isWhitespace(c)) {
            // wait for it...
          } else if (isMatch(nameStart, c)) {
            parser.state = S.OPEN_TAG
            parser.tagName = c
          } else if (c === '/') {
            parser.state = S.CLOSE_TAG
            parser.tagName = ''
          } else if (c === '?') {
            parser.state = S.PROC_INST
            parser.procInstName = parser.procInstBody = ''
          } else {
            strictFail(parser, 'Unencoded <')
            // if there was some whitespace, then add that in.
            if (parser.startTagPosition + 1 < parser.position) {
              var pad = parser.position - parser.startTagPosition
              c = new Array(pad).join(' ') + c
            }
            parser.textNode += '<' + c
            parser.state = S.TEXT
          }
          continue

        case S.SGML_DECL:
          if ((parser.sgmlDecl + c).toUpperCase() === CDATA) {
            emitNode(parser, 'onopencdata')
            parser.state = S.CDATA
            parser.sgmlDecl = ''
            parser.cdata = ''
          } else if (parser.sgmlDecl + c === '--') {
            parser.state = S.COMMENT
            parser.comment = ''
            parser.sgmlDecl = ''
          } else if ((parser.sgmlDecl + c).toUpperCase() === DOCTYPE) {
            parser.state = S.DOCTYPE
            if (parser.doctype || parser.sawRoot) {
              strictFail(parser,
                'Inappropriately located doctype declaration')
            }
            parser.doctype = ''
            parser.sgmlDecl = ''
          } else if (c === '>') {
            emitNode(parser, 'onsgmldeclaration', parser.sgmlDecl)
            parser.sgmlDecl = ''
            parser.state = S.TEXT
          } else if (isQuote(c)) {
            parser.state = S.SGML_DECL_QUOTED
            parser.sgmlDecl += c
          } else {
            parser.sgmlDecl += c
          }
          continue

        case S.SGML_DECL_QUOTED:
          if (c === parser.q) {
            parser.state = S.SGML_DECL
            parser.q = ''
          }
          parser.sgmlDecl += c
          continue

        case S.DOCTYPE:
          if (c === '>') {
            parser.state = S.TEXT
            emitNode(parser, 'ondoctype', parser.doctype)
            parser.doctype = true // just remember that we saw it.
          } else {
            parser.doctype += c
            if (c === '[') {
              parser.state = S.DOCTYPE_DTD
            } else if (isQuote(c)) {
              parser.state = S.DOCTYPE_QUOTED
              parser.q = c
            }
          }
          continue

        case S.DOCTYPE_QUOTED:
          parser.doctype += c
          if (c === parser.q) {
            parser.q = ''
            parser.state = S.DOCTYPE
          }
          continue

        case S.DOCTYPE_DTD:
          parser.doctype += c
          if (c === ']') {
            parser.state = S.DOCTYPE
          } else if (isQuote(c)) {
            parser.state = S.DOCTYPE_DTD_QUOTED
            parser.q = c
          }
          continue

        case S.DOCTYPE_DTD_QUOTED:
          parser.doctype += c
          if (c === parser.q) {
            parser.state = S.DOCTYPE_DTD
            parser.q = ''
          }
          continue

        case S.COMMENT:
          if (c === '-') {
            parser.state = S.COMMENT_ENDING
          } else {
            parser.comment += c
          }
          continue

        case S.COMMENT_ENDING:
          if (c === '-') {
            parser.state = S.COMMENT_ENDED
            parser.comment = textopts(parser.opt, parser.comment)
            if (parser.comment) {
              emitNode(parser, 'oncomment', parser.comment)
            }
            parser.comment = ''
          } else {
            parser.comment += '-' + c
            parser.state = S.COMMENT
          }
          continue

        case S.COMMENT_ENDED:
          if (c !== '>') {
            strictFail(parser, 'Malformed comment')
            // allow <!-- blah -- bloo --> in non-strict mode,
            // which is a comment of " blah -- bloo "
            parser.comment += '--' + c
            parser.state = S.COMMENT
          } else {
            parser.state = S.TEXT
          }
          continue

        case S.CDATA:
          if (c === ']') {
            parser.state = S.CDATA_ENDING
          } else {
            parser.cdata += c
          }
          continue

        case S.CDATA_ENDING:
          if (c === ']') {
            parser.state = S.CDATA_ENDING_2
          } else {
            parser.cdata += ']' + c
            parser.state = S.CDATA
          }
          continue

        case S.CDATA_ENDING_2:
          if (c === '>') {
            if (parser.cdata) {
              emitNode(parser, 'oncdata', parser.cdata)
            }
            emitNode(parser, 'onclosecdata')
            parser.cdata = ''
            parser.state = S.TEXT
          } else if (c === ']') {
            parser.cdata += ']'
          } else {
            parser.cdata += ']]' + c
            parser.state = S.CDATA
          }
          continue

        case S.PROC_INST:
          if (c === '?') {
            parser.state = S.PROC_INST_ENDING
          } else if (isWhitespace(c)) {
            parser.state = S.PROC_INST_BODY
          } else {
            parser.procInstName += c
          }
          continue

        case S.PROC_INST_BODY:
          if (!parser.procInstBody && isWhitespace(c)) {
            continue
          } else if (c === '?') {
            parser.state = S.PROC_INST_ENDING
          } else {
            parser.procInstBody += c
          }
          continue

        case S.PROC_INST_ENDING:
          if (c === '>') {
            emitNode(parser, 'onprocessinginstruction', {
              name: parser.procInstName,
              body: parser.procInstBody
            })
            parser.procInstName = parser.procInstBody = ''
            parser.state = S.TEXT
          } else {
            parser.procInstBody += '?' + c
            parser.state = S.PROC_INST_BODY
          }
          continue

        case S.OPEN_TAG:
          if (isMatch(nameBody, c)) {
            parser.tagName += c
          } else {
            newTag(parser)
            if (c === '>') {
              openTag(parser)
            } else if (c === '/') {
              parser.state = S.OPEN_TAG_SLASH
            } else {
              if (!isWhitespace(c)) {
                strictFail(parser, 'Invalid character in tag name')
              }
              parser.state = S.ATTRIB
            }
          }
          continue

        case S.OPEN_TAG_SLASH:
          if (c === '>') {
            openTag(parser, true)
            closeTag(parser)
          } else {
            strictFail(parser, 'Forward-slash in opening tag not followed by >')
            parser.state = S.ATTRIB
          }
          continue

        case S.ATTRIB:
          // haven't read the attribute name yet.
          if (isWhitespace(c)) {
            continue
          } else if (c === '>') {
            openTag(parser)
          } else if (c === '/') {
            parser.state = S.OPEN_TAG_SLASH
          } else if (isMatch(nameStart, c)) {
            parser.attribName = c
            parser.attribValue = ''
            parser.state = S.ATTRIB_NAME
          } else {
            strictFail(parser, 'Invalid attribute name')
          }
          continue

        case S.ATTRIB_NAME:
          if (c === '=') {
            parser.state = S.ATTRIB_VALUE
          } else if (c === '>') {
            strictFail(parser, 'Attribute without value')
            parser.attribValue = parser.attribName
            attrib(parser)
            openTag(parser)
          } else if (isWhitespace(c)) {
            parser.state = S.ATTRIB_NAME_SAW_WHITE
          } else if (isMatch(nameBody, c)) {
            parser.attribName += c
          } else {
            strictFail(parser, 'Invalid attribute name')
          }
          continue

        case S.ATTRIB_NAME_SAW_WHITE:
          if (c === '=') {
            parser.state = S.ATTRIB_VALUE
          } else if (isWhitespace(c)) {
            continue
          } else {
            strictFail(parser, 'Attribute without value')
            parser.tag.attributes[parser.attribName] = ''
            parser.attribValue = ''
            emitNode(parser, 'onattribute', {
              name: parser.attribName,
              value: ''
            })
            parser.attribName = ''
            if (c === '>') {
              openTag(parser)
            } else if (isMatch(nameStart, c)) {
              parser.attribName = c
              parser.state = S.ATTRIB_NAME
            } else {
              strictFail(parser, 'Invalid attribute name')
              parser.state = S.ATTRIB
            }
          }
          continue

        case S.ATTRIB_VALUE:
          if (isWhitespace(c)) {
            continue
          } else if (isQuote(c)) {
            parser.q = c
            parser.state = S.ATTRIB_VALUE_QUOTED
          } else {
            strictFail(parser, 'Unquoted attribute value')
            parser.state = S.ATTRIB_VALUE_UNQUOTED
            parser.attribValue = c
          }
          continue

        case S.ATTRIB_VALUE_QUOTED:
          if (c !== parser.q) {
            if (c === '&') {
              parser.state = S.ATTRIB_VALUE_ENTITY_Q
            } else {
              parser.attribValue += c
            }
            continue
          }
          attrib(parser)
          parser.q = ''
          parser.state = S.ATTRIB_VALUE_CLOSED
          continue

        case S.ATTRIB_VALUE_CLOSED:
          if (isWhitespace(c)) {
            parser.state = S.ATTRIB
          } else if (c === '>') {
            openTag(parser)
          } else if (c === '/') {
            parser.state = S.OPEN_TAG_SLASH
          } else if (isMatch(nameStart, c)) {
            strictFail(parser, 'No whitespace between attributes')
            parser.attribName = c
            parser.attribValue = ''
            parser.state = S.ATTRIB_NAME
          } else {
            strictFail(parser, 'Invalid attribute name')
          }
          continue

        case S.ATTRIB_VALUE_UNQUOTED:
          if (!isAttribEnd(c)) {
            if (c === '&') {
              parser.state = S.ATTRIB_VALUE_ENTITY_U
            } else {
              parser.attribValue += c
            }
            continue
          }
          attrib(parser)
          if (c === '>') {
            openTag(parser)
          } else {
            parser.state = S.ATTRIB
          }
          continue

        case S.CLOSE_TAG:
          if (!parser.tagName) {
            if (isWhitespace(c)) {
              continue
            } else if (notMatch(nameStart, c)) {
              if (parser.script) {
                parser.script += '</' + c
                parser.state = S.SCRIPT
              } else {
                strictFail(parser, 'Invalid tagname in closing tag.')
              }
            } else {
              parser.tagName = c
            }
          } else if (c === '>') {
            closeTag(parser)
          } else if (isMatch(nameBody, c)) {
            parser.tagName += c
          } else if (parser.script) {
            parser.script += '</' + parser.tagName
            parser.tagName = ''
            parser.state = S.SCRIPT
          } else {
            if (!isWhitespace(c)) {
              strictFail(parser, 'Invalid tagname in closing tag')
            }
            parser.state = S.CLOSE_TAG_SAW_WHITE
          }
          continue

        case S.CLOSE_TAG_SAW_WHITE:
          if (isWhitespace(c)) {
            continue
          }
          if (c === '>') {
            closeTag(parser)
          } else {
            strictFail(parser, 'Invalid characters in closing tag')
          }
          continue

        case S.TEXT_ENTITY:
        case S.ATTRIB_VALUE_ENTITY_Q:
        case S.ATTRIB_VALUE_ENTITY_U:
          var returnState
          var buffer
          switch (parser.state) {
            case S.TEXT_ENTITY:
              returnState = S.TEXT
              buffer = 'textNode'
              break

            case S.ATTRIB_VALUE_ENTITY_Q:
              returnState = S.ATTRIB_VALUE_QUOTED
              buffer = 'attribValue'
              break

            case S.ATTRIB_VALUE_ENTITY_U:
              returnState = S.ATTRIB_VALUE_UNQUOTED
              buffer = 'attribValue'
              break
          }

          if (c === ';') {
            parser[buffer] += parseEntity(parser)
            parser.entity = ''
            parser.state = returnState
          } else if (isMatch(parser.entity.length ? entityBody : entityStart, c)) {
            parser.entity += c
          } else {
            strictFail(parser, 'Invalid character in entity name')
            parser[buffer] += '&' + parser.entity + c
            parser.entity = ''
            parser.state = returnState
          }

          continue

        default:
          throw new Error(parser, 'Unknown state: ' + parser.state)
      }
    } // while

    if (parser.position >= parser.bufferCheckPosition) {
      checkBufferLength(parser)
    }
    return parser
  }

  /*! http://mths.be/fromcodepoint v0.1.0 by @mathias */
  /* istanbul ignore next */
  if (!String.fromCodePoint) {
    (function () {
      var stringFromCharCode = String.fromCharCode
      var floor = Math.floor
      var fromCodePoint = function () {
        var MAX_SIZE = 0x4000
        var codeUnits = []
        var highSurrogate
        var lowSurrogate
        var index = -1
        var length = arguments.length
        if (!length) {
          return ''
        }
        var result = ''
        while (++index < length) {
          var codePoint = Number(arguments[index])
          if (
            !isFinite(codePoint) || // `NaN`, `+Infinity`, or `-Infinity`
            codePoint < 0 || // not a valid Unicode code point
            codePoint > 0x10FFFF || // not a valid Unicode code point
            floor(codePoint) !== codePoint // not an integer
          ) {
            throw RangeError('Invalid code point: ' + codePoint)
          }
          if (codePoint <= 0xFFFF) { // BMP code point
            codeUnits.push(codePoint)
          } else { // Astral code point; split in surrogate halves
            // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
            codePoint -= 0x10000
            highSurrogate = (codePoint >> 10) + 0xD800
            lowSurrogate = (codePoint % 0x400) + 0xDC00
            codeUnits.push(highSurrogate, lowSurrogate)
          }
          if (index + 1 === length || codeUnits.length > MAX_SIZE) {
            result += stringFromCharCode.apply(null, codeUnits)
            codeUnits.length = 0
          }
        }
        return result
      }
      /* istanbul ignore next */
      if (Object.defineProperty) {
        Object.defineProperty(String, 'fromCodePoint', {
          value: fromCodePoint,
          configurable: true,
          writable: true
        })
      } else {
        String.fromCodePoint = fromCodePoint
      }
    }())
  }
})( false ? 0 : exports)


/***/ }),

/***/ 65714:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var GetIntrinsic = __webpack_require__(72870);
var callBound = __webpack_require__(63099);
var inspect = __webpack_require__(34538);

var $TypeError = GetIntrinsic('%TypeError%');
var $WeakMap = GetIntrinsic('%WeakMap%', true);
var $Map = GetIntrinsic('%Map%', true);

var $weakMapGet = callBound('WeakMap.prototype.get', true);
var $weakMapSet = callBound('WeakMap.prototype.set', true);
var $weakMapHas = callBound('WeakMap.prototype.has', true);
var $mapGet = callBound('Map.prototype.get', true);
var $mapSet = callBound('Map.prototype.set', true);
var $mapHas = callBound('Map.prototype.has', true);

/*
 * This function traverses the list returning the node corresponding to the
 * given key.
 *
 * That node is also moved to the head of the list, so that if it's accessed
 * again we don't need to traverse the whole list. By doing so, all the recently
 * used nodes can be accessed relatively quickly.
 */
var listGetNode = function (list, key) { // eslint-disable-line consistent-return
	for (var prev = list, curr; (curr = prev.next) !== null; prev = curr) {
		if (curr.key === key) {
			prev.next = curr.next;
			curr.next = list.next;
			list.next = curr; // eslint-disable-line no-param-reassign
			return curr;
		}
	}
};

var listGet = function (objects, key) {
	var node = listGetNode(objects, key);
	return node && node.value;
};
var listSet = function (objects, key, value) {
	var node = listGetNode(objects, key);
	if (node) {
		node.value = value;
	} else {
		// Prepend the new node to the beginning of the list
		objects.next = { // eslint-disable-line no-param-reassign
			key: key,
			next: objects.next,
			value: value
		};
	}
};
var listHas = function (objects, key) {
	return !!listGetNode(objects, key);
};

module.exports = function getSideChannel() {
	var $wm;
	var $m;
	var $o;
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		get: function (key) { // eslint-disable-line consistent-return
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapGet($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapGet($m, key);
				}
			} else {
				if ($o) { // eslint-disable-line no-lonely-if
					return listGet($o, key);
				}
			}
		},
		has: function (key) {
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapHas($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapHas($m, key);
				}
			} else {
				if ($o) { // eslint-disable-line no-lonely-if
					return listHas($o, key);
				}
			}
			return false;
		},
		set: function (key, value) {
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if (!$wm) {
					$wm = new $WeakMap();
				}
				$weakMapSet($wm, key, value);
			} else if ($Map) {
				if (!$m) {
					$m = new $Map();
				}
				$mapSet($m, key, value);
			} else {
				if (!$o) {
					/*
					 * Initialize the linked list as an empty node, so that we don't have
					 * to special-case handling of the first node: we can always refer to
					 * it as (previous node).next, instead of something like (list).head
					 */
					$o = { key: {}, next: null };
				}
				listSet($o, key, value);
			}
		}
	};
	return channel;
};


/***/ }),

/***/ 24131:
/***/ ((module, exports, __webpack_require__) => {

var __WEBPACK_AMD_DEFINE_RESULT__;/* global window, exports, define */

!function() {
    'use strict'

    var re = {
        not_string: /[^s]/,
        not_bool: /[^t]/,
        not_type: /[^T]/,
        not_primitive: /[^v]/,
        number: /[diefg]/,
        numeric_arg: /[bcdiefguxX]/,
        json: /[j]/,
        not_json: /[^j]/,
        text: /^[^\x25]+/,
        modulo: /^\x25{2}/,
        placeholder: /^\x25(?:([1-9]\d*)\$|\(([^)]+)\))?(\+)?(0|'[^$])?(-)?(\d+)?(?:\.(\d+))?([b-gijostTuvxX])/,
        key: /^([a-z_][a-z_\d]*)/i,
        key_access: /^\.([a-z_][a-z_\d]*)/i,
        index_access: /^\[(\d+)\]/,
        sign: /^[+-]/
    }

    function sprintf(key) {
        // `arguments` is not an array, but should be fine for this call
        return sprintf_format(sprintf_parse(key), arguments)
    }

    function vsprintf(fmt, argv) {
        return sprintf.apply(null, [fmt].concat(argv || []))
    }

    function sprintf_format(parse_tree, argv) {
        var cursor = 1, tree_length = parse_tree.length, arg, output = '', i, k, ph, pad, pad_character, pad_length, is_positive, sign
        for (i = 0; i < tree_length; i++) {
            if (typeof parse_tree[i] === 'string') {
                output += parse_tree[i]
            }
            else if (typeof parse_tree[i] === 'object') {
                ph = parse_tree[i] // convenience purposes only
                if (ph.keys) { // keyword argument
                    arg = argv[cursor]
                    for (k = 0; k < ph.keys.length; k++) {
                        if (arg == undefined) {
                            throw new Error(sprintf('[sprintf] Cannot access property "%s" of undefined value "%s"', ph.keys[k], ph.keys[k-1]))
                        }
                        arg = arg[ph.keys[k]]
                    }
                }
                else if (ph.param_no) { // positional argument (explicit)
                    arg = argv[ph.param_no]
                }
                else { // positional argument (implicit)
                    arg = argv[cursor++]
                }

                if (re.not_type.test(ph.type) && re.not_primitive.test(ph.type) && arg instanceof Function) {
                    arg = arg()
                }

                if (re.numeric_arg.test(ph.type) && (typeof arg !== 'number' && isNaN(arg))) {
                    throw new TypeError(sprintf('[sprintf] expecting number but found %T', arg))
                }

                if (re.number.test(ph.type)) {
                    is_positive = arg >= 0
                }

                switch (ph.type) {
                    case 'b':
                        arg = parseInt(arg, 10).toString(2)
                        break
                    case 'c':
                        arg = String.fromCharCode(parseInt(arg, 10))
                        break
                    case 'd':
                    case 'i':
                        arg = parseInt(arg, 10)
                        break
                    case 'j':
                        arg = JSON.stringify(arg, null, ph.width ? parseInt(ph.width) : 0)
                        break
                    case 'e':
                        arg = ph.precision ? parseFloat(arg).toExponential(ph.precision) : parseFloat(arg).toExponential()
                        break
                    case 'f':
                        arg = ph.precision ? parseFloat(arg).toFixed(ph.precision) : parseFloat(arg)
                        break
                    case 'g':
                        arg = ph.precision ? String(Number(arg.toPrecision(ph.precision))) : parseFloat(arg)
                        break
                    case 'o':
                        arg = (parseInt(arg, 10) >>> 0).toString(8)
                        break
                    case 's':
                        arg = String(arg)
                        arg = (ph.precision ? arg.substring(0, ph.precision) : arg)
                        break
                    case 't':
                        arg = String(!!arg)
                        arg = (ph.precision ? arg.substring(0, ph.precision) : arg)
                        break
                    case 'T':
                        arg = Object.prototype.toString.call(arg).slice(8, -1).toLowerCase()
                        arg = (ph.precision ? arg.substring(0, ph.precision) : arg)
                        break
                    case 'u':
                        arg = parseInt(arg, 10) >>> 0
                        break
                    case 'v':
                        arg = arg.valueOf()
                        arg = (ph.precision ? arg.substring(0, ph.precision) : arg)
                        break
                    case 'x':
                        arg = (parseInt(arg, 10) >>> 0).toString(16)
                        break
                    case 'X':
                        arg = (parseInt(arg, 10) >>> 0).toString(16).toUpperCase()
                        break
                }
                if (re.json.test(ph.type)) {
                    output += arg
                }
                else {
                    if (re.number.test(ph.type) && (!is_positive || ph.sign)) {
                        sign = is_positive ? '+' : '-'
                        arg = arg.toString().replace(re.sign, '')
                    }
                    else {
                        sign = ''
                    }
                    pad_character = ph.pad_char ? ph.pad_char === '0' ? '0' : ph.pad_char.charAt(1) : ' '
                    pad_length = ph.width - (sign + arg).length
                    pad = ph.width ? (pad_length > 0 ? pad_character.repeat(pad_length) : '') : ''
                    output += ph.align ? sign + arg + pad : (pad_character === '0' ? sign + pad + arg : pad + sign + arg)
                }
            }
        }
        return output
    }

    var sprintf_cache = Object.create(null)

    function sprintf_parse(fmt) {
        if (sprintf_cache[fmt]) {
            return sprintf_cache[fmt]
        }

        var _fmt = fmt, match, parse_tree = [], arg_names = 0
        while (_fmt) {
            if ((match = re.text.exec(_fmt)) !== null) {
                parse_tree.push(match[0])
            }
            else if ((match = re.modulo.exec(_fmt)) !== null) {
                parse_tree.push('%')
            }
            else if ((match = re.placeholder.exec(_fmt)) !== null) {
                if (match[2]) {
                    arg_names |= 1
                    var field_list = [], replacement_field = match[2], field_match = []
                    if ((field_match = re.key.exec(replacement_field)) !== null) {
                        field_list.push(field_match[1])
                        while ((replacement_field = replacement_field.substring(field_match[0].length)) !== '') {
                            if ((field_match = re.key_access.exec(replacement_field)) !== null) {
                                field_list.push(field_match[1])
                            }
                            else if ((field_match = re.index_access.exec(replacement_field)) !== null) {
                                field_list.push(field_match[1])
                            }
                            else {
                                throw new SyntaxError('[sprintf] failed to parse named argument key')
                            }
                        }
                    }
                    else {
                        throw new SyntaxError('[sprintf] failed to parse named argument key')
                    }
                    match[2] = field_list
                }
                else {
                    arg_names |= 2
                }
                if (arg_names === 3) {
                    throw new Error('[sprintf] mixing positional and named placeholders is not (yet) supported')
                }

                parse_tree.push(
                    {
                        placeholder: match[0],
                        param_no:    match[1],
                        keys:        match[2],
                        sign:        match[3],
                        pad_char:    match[4],
                        align:       match[5],
                        width:       match[6],
                        precision:   match[7],
                        type:        match[8]
                    }
                )
            }
            else {
                throw new SyntaxError('[sprintf] unexpected placeholder')
            }
            _fmt = _fmt.substring(match[0].length)
        }
        return sprintf_cache[fmt] = parse_tree
    }

    /**
     * export to either browser or node.js
     */
    /* eslint-disable quote-props */
    if (true) {
        exports.sprintf = sprintf
        exports.vsprintf = vsprintf
    }
    if (typeof window !== 'undefined') {
        window['sprintf'] = sprintf
        window['vsprintf'] = vsprintf

        if (true) {
            !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
                return {
                    'sprintf': sprintf,
                    'vsprintf': vsprintf
                }
            }).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
        }
    }
    /* eslint-enable quote-props */
}(); // eslint-disable-line


/***/ }),

/***/ 76835:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

module.exports = Stream;

var EE = (__webpack_require__(72100).EventEmitter);
var inherits = __webpack_require__(85459);

inherits(Stream, EE);
Stream.Readable = __webpack_require__(25294);
Stream.Writable = __webpack_require__(86481);
Stream.Duplex = __webpack_require__(93337);
Stream.Transform = __webpack_require__(41683);
Stream.PassThrough = __webpack_require__(68797);
Stream.finished = __webpack_require__(43675)
Stream.pipeline = __webpack_require__(95597)

// Backwards-compat with node 0.4.x
Stream.Stream = Stream;



// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.

function Stream() {
  EE.call(this);
}

Stream.prototype.pipe = function(dest, options) {
  var source = this;

  function ondata(chunk) {
    if (dest.writable) {
      if (false === dest.write(chunk) && source.pause) {
        source.pause();
      }
    }
  }

  source.on('data', ondata);

  function ondrain() {
    if (source.readable && source.resume) {
      source.resume();
    }
  }

  dest.on('drain', ondrain);

  // If the 'end' option is not supplied, dest.end() will be called when
  // source gets the 'end' or 'close' events.  Only dest.end() once.
  if (!dest._isStdio && (!options || options.end !== false)) {
    source.on('end', onend);
    source.on('close', onclose);
  }

  var didOnEnd = false;
  function onend() {
    if (didOnEnd) return;
    didOnEnd = true;

    dest.end();
  }


  function onclose() {
    if (didOnEnd) return;
    didOnEnd = true;

    if (typeof dest.destroy === 'function') dest.destroy();
  }

  // don't leave dangling pipes when there are errors.
  function onerror(er) {
    cleanup();
    if (EE.listenerCount(this, 'error') === 0) {
      throw er; // Unhandled stream error in pipe.
    }
  }

  source.on('error', onerror);
  dest.on('error', onerror);

  // remove all the event listeners that were added.
  function cleanup() {
    source.removeListener('data', ondata);
    dest.removeListener('drain', ondrain);

    source.removeListener('end', onend);
    source.removeListener('close', onclose);

    source.removeListener('error', onerror);
    dest.removeListener('error', onerror);

    source.removeListener('end', cleanup);
    source.removeListener('close', cleanup);

    dest.removeListener('close', cleanup);
  }

  source.on('end', cleanup);
  source.on('close', cleanup);

  dest.on('close', cleanup);

  dest.emit('pipe', source);

  // Allow for unix-like usage: A.pipe(B).pipe(C)
  return dest;
};


/***/ }),

/***/ 72699:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var Buffer = (__webpack_require__(61874).Buffer);
/*</replacement>*/

var isEncoding = Buffer.isEncoding || function (encoding) {
  encoding = '' + encoding;
  switch (encoding && encoding.toLowerCase()) {
    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
      return true;
    default:
      return false;
  }
};

function _normalizeEncoding(enc) {
  if (!enc) return 'utf8';
  var retried;
  while (true) {
    switch (enc) {
      case 'utf8':
      case 'utf-8':
        return 'utf8';
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return 'utf16le';
      case 'latin1':
      case 'binary':
        return 'latin1';
      case 'base64':
      case 'ascii':
      case 'hex':
        return enc;
      default:
        if (retried) return; // undefined
        enc = ('' + enc).toLowerCase();
        retried = true;
    }
  }
};

// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
  var nenc = _normalizeEncoding(enc);
  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
  return nenc || enc;
}

// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
exports.s = StringDecoder;
function StringDecoder(encoding) {
  this.encoding = normalizeEncoding(encoding);
  var nb;
  switch (this.encoding) {
    case 'utf16le':
      this.text = utf16Text;
      this.end = utf16End;
      nb = 4;
      break;
    case 'utf8':
      this.fillLast = utf8FillLast;
      nb = 4;
      break;
    case 'base64':
      this.text = base64Text;
      this.end = base64End;
      nb = 3;
      break;
    default:
      this.write = simpleWrite;
      this.end = simpleEnd;
      return;
  }
  this.lastNeed = 0;
  this.lastTotal = 0;
  this.lastChar = Buffer.allocUnsafe(nb);
}

StringDecoder.prototype.write = function (buf) {
  if (buf.length === 0) return '';
  var r;
  var i;
  if (this.lastNeed) {
    r = this.fillLast(buf);
    if (r === undefined) return '';
    i = this.lastNeed;
    this.lastNeed = 0;
  } else {
    i = 0;
  }
  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
  return r || '';
};

StringDecoder.prototype.end = utf8End;

// Returns only complete characters in a Buffer
StringDecoder.prototype.text = utf8Text;

// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder.prototype.fillLast = function (buf) {
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
  this.lastNeed -= buf.length;
};

// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function utf8CheckByte(byte) {
  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
  return byte >> 6 === 0x02 ? -1 : -2;
}

// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self, buf, i) {
  var j = buf.length - 1;
  if (j < i) return 0;
  var nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 1;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 2;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) {
      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
    }
    return nb;
  }
  return 0;
}

// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self, buf, p) {
  if ((buf[0] & 0xC0) !== 0x80) {
    self.lastNeed = 0;
    return '\ufffd';
  }
  if (self.lastNeed > 1 && buf.length > 1) {
    if ((buf[1] & 0xC0) !== 0x80) {
      self.lastNeed = 1;
      return '\ufffd';
    }
    if (self.lastNeed > 2 && buf.length > 2) {
      if ((buf[2] & 0xC0) !== 0x80) {
        self.lastNeed = 2;
        return '\ufffd';
      }
    }
  }
}

// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
  var p = this.lastTotal - this.lastNeed;
  var r = utf8CheckExtraBytes(this, buf, p);
  if (r !== undefined) return r;
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, p, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, p, 0, buf.length);
  this.lastNeed -= buf.length;
}

// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
  var total = utf8CheckIncomplete(this, buf, i);
  if (!this.lastNeed) return buf.toString('utf8', i);
  this.lastTotal = total;
  var end = buf.length - (total - this.lastNeed);
  buf.copy(this.lastChar, 0, end);
  return buf.toString('utf8', i, end);
}

// For UTF-8, a replacement character is added when ending on a partial
// character.
function utf8End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + '\ufffd';
  return r;
}

// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
  if ((buf.length - i) % 2 === 0) {
    var r = buf.toString('utf16le', i);
    if (r) {
      var c = r.charCodeAt(r.length - 1);
      if (c >= 0xD800 && c <= 0xDBFF) {
        this.lastNeed = 2;
        this.lastTotal = 4;
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
        return r.slice(0, -1);
      }
    }
    return r;
  }
  this.lastNeed = 1;
  this.lastTotal = 2;
  this.lastChar[0] = buf[buf.length - 1];
  return buf.toString('utf16le', i, buf.length - 1);
}

// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) {
    var end = this.lastTotal - this.lastNeed;
    return r + this.lastChar.toString('utf16le', 0, end);
  }
  return r;
}

function base64Text(buf, i) {
  var n = (buf.length - i) % 3;
  if (n === 0) return buf.toString('base64', i);
  this.lastNeed = 3 - n;
  this.lastTotal = 3;
  if (n === 1) {
    this.lastChar[0] = buf[buf.length - 1];
  } else {
    this.lastChar[0] = buf[buf.length - 2];
    this.lastChar[1] = buf[buf.length - 1];
  }
  return buf.toString('base64', i, buf.length - n);
}

function base64End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
  return r;
}

// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
  return buf.toString(this.encoding);
}

function simpleEnd(buf) {
  return buf && buf.length ? this.write(buf) : '';
}

/***/ }),

/***/ 95856:
/***/ ((module) => {

"use strict";


function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function Agent() {
  this._defaults = [];
}
for (var _i = 0, _arr = ['use', 'on', 'once', 'set', 'query', 'type', 'accept', 'auth', 'withCredentials', 'sortQuery', 'retry', 'ok', 'redirects', 'timeout', 'buffer', 'serialize', 'parse', 'ca', 'key', 'pfx', 'cert', 'disableTLSCerts']; _i < _arr.length; _i++) {
  const fn = _arr[_i];
  // Default setting for all requests from this agent
  Agent.prototype[fn] = function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    this._defaults.push({
      fn,
      args
    });
    return this;
  };
}
Agent.prototype._setDefaults = function (request) {
  var _iterator = _createForOfIteratorHelper(this._defaults),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      const def = _step.value;
      request[def.fn](...def.args);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
};
module.exports = Agent;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJBZ2VudCIsIl9kZWZhdWx0cyIsImZuIiwicHJvdG90eXBlIiwiYXJncyIsInB1c2giLCJfc2V0RGVmYXVsdHMiLCJyZXF1ZXN0IiwiZGVmIiwibW9kdWxlIiwiZXhwb3J0cyJdLCJzb3VyY2VzIjpbIi4uL3NyYy9hZ2VudC1iYXNlLmpzIl0sInNvdXJjZXNDb250ZW50IjpbImZ1bmN0aW9uIEFnZW50KCkge1xuICB0aGlzLl9kZWZhdWx0cyA9IFtdO1xufVxuXG5mb3IgKGNvbnN0IGZuIG9mIFtcbiAgJ3VzZScsXG4gICdvbicsXG4gICdvbmNlJyxcbiAgJ3NldCcsXG4gICdxdWVyeScsXG4gICd0eXBlJyxcbiAgJ2FjY2VwdCcsXG4gICdhdXRoJyxcbiAgJ3dpdGhDcmVkZW50aWFscycsXG4gICdzb3J0UXVlcnknLFxuICAncmV0cnknLFxuICAnb2snLFxuICAncmVkaXJlY3RzJyxcbiAgJ3RpbWVvdXQnLFxuICAnYnVmZmVyJyxcbiAgJ3NlcmlhbGl6ZScsXG4gICdwYXJzZScsXG4gICdjYScsXG4gICdrZXknLFxuICAncGZ4JyxcbiAgJ2NlcnQnLFxuICAnZGlzYWJsZVRMU0NlcnRzJ1xuXSkge1xuICAvLyBEZWZhdWx0IHNldHRpbmcgZm9yIGFsbCByZXF1ZXN0cyBmcm9tIHRoaXMgYWdlbnRcbiAgQWdlbnQucHJvdG90eXBlW2ZuXSA9IGZ1bmN0aW9uICguLi5hcmdzKSB7XG4gICAgdGhpcy5fZGVmYXVsdHMucHVzaCh7IGZuLCBhcmdzIH0pO1xuICAgIHJldHVybiB0aGlzO1xuICB9O1xufVxuXG5BZ2VudC5wcm90b3R5cGUuX3NldERlZmF1bHRzID0gZnVuY3Rpb24gKHJlcXVlc3QpIHtcbiAgZm9yIChjb25zdCBkZWYgb2YgdGhpcy5fZGVmYXVsdHMpIHtcbiAgICByZXF1ZXN0W2RlZi5mbl0oLi4uZGVmLmFyZ3MpO1xuICB9XG59O1xuXG5tb2R1bGUuZXhwb3J0cyA9IEFnZW50O1xuIl0sIm1hcHBpbmdzIjoiOzs7OztBQUFBLFNBQVNBLEtBQUssR0FBRztFQUNmLElBQUksQ0FBQ0MsU0FBUyxHQUFHLEVBQUU7QUFDckI7QUFFQSx3QkFBaUIsQ0FDZixLQUFLLEVBQ0wsSUFBSSxFQUNKLE1BQU0sRUFDTixLQUFLLEVBQ0wsT0FBTyxFQUNQLE1BQU0sRUFDTixRQUFRLEVBQ1IsTUFBTSxFQUNOLGlCQUFpQixFQUNqQixXQUFXLEVBQ1gsT0FBTyxFQUNQLElBQUksRUFDSixXQUFXLEVBQ1gsU0FBUyxFQUNULFFBQVEsRUFDUixXQUFXLEVBQ1gsT0FBTyxFQUNQLElBQUksRUFDSixLQUFLLEVBQ0wsS0FBSyxFQUNMLE1BQU0sRUFDTixpQkFBaUIsQ0FDbEIsMEJBQUU7RUF2QkUsTUFBTUMsRUFBRTtFQXdCWDtFQUNBRixLQUFLLENBQUNHLFNBQVMsQ0FBQ0QsRUFBRSxDQUFDLEdBQUcsWUFBbUI7SUFBQSxrQ0FBTkUsSUFBSTtNQUFKQSxJQUFJO0lBQUE7SUFDckMsSUFBSSxDQUFDSCxTQUFTLENBQUNJLElBQUksQ0FBQztNQUFFSCxFQUFFO01BQUVFO0lBQUssQ0FBQyxDQUFDO0lBQ2pDLE9BQU8sSUFBSTtFQUNiLENBQUM7QUFDSDtBQUVBSixLQUFLLENBQUNHLFNBQVMsQ0FBQ0csWUFBWSxHQUFHLFVBQVVDLE9BQU8sRUFBRTtFQUFBLDJDQUM5QixJQUFJLENBQUNOLFNBQVM7SUFBQTtFQUFBO0lBQWhDLG9EQUFrQztNQUFBLE1BQXZCTyxHQUFHO01BQ1pELE9BQU8sQ0FBQ0MsR0FBRyxDQUFDTixFQUFFLENBQUMsQ0FBQyxHQUFHTSxHQUFHLENBQUNKLElBQUksQ0FBQztJQUM5QjtFQUFDO0lBQUE7RUFBQTtJQUFBO0VBQUE7QUFDSCxDQUFDO0FBRURLLE1BQU0sQ0FBQ0MsT0FBTyxHQUFHVixLQUFLIn0=

/***/ }),

/***/ 54247:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/**
 * Root reference for iframes.
 */

let root;
if (typeof window !== 'undefined') {
  // Browser window
  root = window;
} else if (typeof self === 'undefined') {
  // Other environments
  console.warn('Using browser-only version of superagent in non-browser environment');
  root = void 0;
} else {
  // Web Worker
  root = self;
}
const Emitter = __webpack_require__(14907);
const safeStringify = __webpack_require__(61406);
const qs = __webpack_require__(69787);
const RequestBase = __webpack_require__(39745);
const _require = __webpack_require__(73316),
  isObject = _require.isObject,
  mixin = _require.mixin,
  hasOwn = _require.hasOwn;
const ResponseBase = __webpack_require__(76031);
const Agent = __webpack_require__(95856);

/**
 * Noop.
 */

function noop() {}

/**
 * Expose `request`.
 */

module.exports = function (method, url) {
  // callback
  if (typeof url === 'function') {
    return new exports.Request('GET', method).end(url);
  }

  // url first
  if (arguments.length === 1) {
    return new exports.Request('GET', method);
  }
  return new exports.Request(method, url);
};
exports = module.exports;
const request = exports;
exports.Request = Request;

/**
 * Determine XHR.
 */

request.getXHR = () => {
  if (root.XMLHttpRequest) {
    return new root.XMLHttpRequest();
  }
  throw new Error('Browser-only version of superagent could not find XHR');
};

/**
 * Removes leading and trailing whitespace, added to support IE.
 *
 * @param {String} s
 * @return {String}
 * @api private
 */

const trim = ''.trim ? s => s.trim() : s => s.replace(/(^\s*|\s*$)/g, '');

/**
 * Serialize the given `obj`.
 *
 * @param {Object} obj
 * @return {String}
 * @api private
 */

function serialize(object) {
  if (!isObject(object)) return object;
  const pairs = [];
  for (const key in object) {
    if (hasOwn(object, key)) pushEncodedKeyValuePair(pairs, key, object[key]);
  }
  return pairs.join('&');
}

/**
 * Helps 'serialize' with serializing arrays.
 * Mutates the pairs array.
 *
 * @param {Array} pairs
 * @param {String} key
 * @param {Mixed} val
 */

function pushEncodedKeyValuePair(pairs, key, value) {
  if (value === undefined) return;
  if (value === null) {
    pairs.push(encodeURI(key));
    return;
  }
  if (Array.isArray(value)) {
    var _iterator = _createForOfIteratorHelper(value),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        const v = _step.value;
        pushEncodedKeyValuePair(pairs, key, v);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  } else if (isObject(value)) {
    for (const subkey in value) {
      if (hasOwn(value, subkey)) pushEncodedKeyValuePair(pairs, `${key}[${subkey}]`, value[subkey]);
    }
  } else {
    pairs.push(encodeURI(key) + '=' + encodeURIComponent(value));
  }
}

/**
 * Expose serialization method.
 */

request.serializeObject = serialize;

/**
 * Parse the given x-www-form-urlencoded `str`.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

function parseString(string_) {
  const object = {};
  const pairs = string_.split('&');
  let pair;
  let pos;
  for (let i = 0, length_ = pairs.length; i < length_; ++i) {
    pair = pairs[i];
    pos = pair.indexOf('=');
    if (pos === -1) {
      object[decodeURIComponent(pair)] = '';
    } else {
      object[decodeURIComponent(pair.slice(0, pos))] = decodeURIComponent(pair.slice(pos + 1));
    }
  }
  return object;
}

/**
 * Expose parser.
 */

request.parseString = parseString;

/**
 * Default MIME type map.
 *
 *     superagent.types.xml = 'application/xml';
 *
 */

request.types = {
  html: 'text/html',
  json: 'application/json',
  xml: 'text/xml',
  urlencoded: 'application/x-www-form-urlencoded',
  form: 'application/x-www-form-urlencoded',
  'form-data': 'application/x-www-form-urlencoded'
};

/**
 * Default serialization map.
 *
 *     superagent.serialize['application/xml'] = function(obj){
 *       return 'generated xml here';
 *     };
 *
 */

request.serialize = {
  'application/x-www-form-urlencoded': qs.stringify,
  'application/json': safeStringify
};

/**
 * Default parsers.
 *
 *     superagent.parse['application/xml'] = function(str){
 *       return { object parsed from str };
 *     };
 *
 */

request.parse = {
  'application/x-www-form-urlencoded': parseString,
  'application/json': JSON.parse
};

/**
 * Parse the given header `str` into
 * an object containing the mapped fields.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

function parseHeader(string_) {
  const lines = string_.split(/\r?\n/);
  const fields = {};
  let index;
  let line;
  let field;
  let value;
  for (let i = 0, length_ = lines.length; i < length_; ++i) {
    line = lines[i];
    index = line.indexOf(':');
    if (index === -1) {
      // could be empty line, just skip it
      continue;
    }
    field = line.slice(0, index).toLowerCase();
    value = trim(line.slice(index + 1));
    fields[field] = value;
  }
  return fields;
}

/**
 * Check if `mime` is json or has +json structured syntax suffix.
 *
 * @param {String} mime
 * @return {Boolean}
 * @api private
 */

function isJSON(mime) {
  // should match /json or +json
  // but not /json-seq
  return /[/+]json($|[^-\w])/i.test(mime);
}

/**
 * Initialize a new `Response` with the given `xhr`.
 *
 *  - set flags (.ok, .error, etc)
 *  - parse header
 *
 * Examples:
 *
 *  Aliasing `superagent` as `request` is nice:
 *
 *      request = superagent;
 *
 *  We can use the promise-like API, or pass callbacks:
 *
 *      request.get('/').end(function(res){});
 *      request.get('/', function(res){});
 *
 *  Sending data can be chained:
 *
 *      request
 *        .post('/user')
 *        .send({ name: 'tj' })
 *        .end(function(res){});
 *
 *  Or passed to `.send()`:
 *
 *      request
 *        .post('/user')
 *        .send({ name: 'tj' }, function(res){});
 *
 *  Or passed to `.post()`:
 *
 *      request
 *        .post('/user', { name: 'tj' })
 *        .end(function(res){});
 *
 * Or further reduced to a single call for simple cases:
 *
 *      request
 *        .post('/user', { name: 'tj' }, function(res){});
 *
 * @param {XMLHTTPRequest} xhr
 * @param {Object} options
 * @api private
 */

function Response(request_) {
  this.req = request_;
  this.xhr = this.req.xhr;
  // responseText is accessible only if responseType is '' or 'text' and on older browsers
  this.text = this.req.method !== 'HEAD' && (this.xhr.responseType === '' || this.xhr.responseType === 'text') || typeof this.xhr.responseType === 'undefined' ? this.xhr.responseText : null;
  this.statusText = this.req.xhr.statusText;
  let status = this.xhr.status;
  // handle IE9 bug: http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
  if (status === 1223) {
    status = 204;
  }
  this._setStatusProperties(status);
  this.headers = parseHeader(this.xhr.getAllResponseHeaders());
  this.header = this.headers;
  // getAllResponseHeaders sometimes falsely returns "" for CORS requests, but
  // getResponseHeader still works. so we get content-type even if getting
  // other headers fails.
  this.header['content-type'] = this.xhr.getResponseHeader('content-type');
  this._setHeaderProperties(this.header);
  if (this.text === null && request_._responseType) {
    this.body = this.xhr.response;
  } else {
    this.body = this.req.method === 'HEAD' ? null : this._parseBody(this.text ? this.text : this.xhr.response);
  }
}
mixin(Response.prototype, ResponseBase.prototype);

/**
 * Parse the given body `str`.
 *
 * Used for auto-parsing of bodies. Parsers
 * are defined on the `superagent.parse` object.
 *
 * @param {String} str
 * @return {Mixed}
 * @api private
 */

Response.prototype._parseBody = function (string_) {
  let parse = request.parse[this.type];
  if (this.req._parser) {
    return this.req._parser(this, string_);
  }
  if (!parse && isJSON(this.type)) {
    parse = request.parse['application/json'];
  }
  return parse && string_ && (string_.length > 0 || string_ instanceof Object) ? parse(string_) : null;
};

/**
 * Return an `Error` representative of this response.
 *
 * @return {Error}
 * @api public
 */

Response.prototype.toError = function () {
  const req = this.req;
  const method = req.method;
  const url = req.url;
  const message = `cannot ${method} ${url} (${this.status})`;
  const error = new Error(message);
  error.status = this.status;
  error.method = method;
  error.url = url;
  return error;
};

/**
 * Expose `Response`.
 */

request.Response = Response;

/**
 * Initialize a new `Request` with the given `method` and `url`.
 *
 * @param {String} method
 * @param {String} url
 * @api public
 */

function Request(method, url) {
  const self = this;
  this._query = this._query || [];
  this.method = method;
  this.url = url;
  this.header = {}; // preserves header name case
  this._header = {}; // coerces header names to lowercase
  this.on('end', () => {
    let error = null;
    let res = null;
    try {
      res = new Response(self);
    } catch (err) {
      error = new Error('Parser is unable to parse the response');
      error.parse = true;
      error.original = err;
      // issue #675: return the raw response if the response parsing fails
      if (self.xhr) {
        // ie9 doesn't have 'response' property
        error.rawResponse = typeof self.xhr.responseType === 'undefined' ? self.xhr.responseText : self.xhr.response;
        // issue #876: return the http status code if the response parsing fails
        error.status = self.xhr.status ? self.xhr.status : null;
        error.statusCode = error.status; // backwards-compat only
      } else {
        error.rawResponse = null;
        error.status = null;
      }
      return self.callback(error);
    }
    self.emit('response', res);
    let new_error;
    try {
      if (!self._isResponseOK(res)) {
        new_error = new Error(res.statusText || res.text || 'Unsuccessful HTTP response');
      }
    } catch (err) {
      new_error = err; // ok() callback can throw
    }

    // #1000 don't catch errors from the callback to avoid double calling it
    if (new_error) {
      new_error.original = error;
      new_error.response = res;
      new_error.status = new_error.status || res.status;
      self.callback(new_error, res);
    } else {
      self.callback(null, res);
    }
  });
}

/**
 * Mixin `Emitter` and `RequestBase`.
 */

// eslint-disable-next-line new-cap
Emitter(Request.prototype);
mixin(Request.prototype, RequestBase.prototype);

/**
 * Set Content-Type to `type`, mapping values from `request.types`.
 *
 * Examples:
 *
 *      superagent.types.xml = 'application/xml';
 *
 *      request.post('/')
 *        .type('xml')
 *        .send(xmlstring)
 *        .end(callback);
 *
 *      request.post('/')
 *        .type('application/xml')
 *        .send(xmlstring)
 *        .end(callback);
 *
 * @param {String} type
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.type = function (type) {
  this.set('Content-Type', request.types[type] || type);
  return this;
};

/**
 * Set Accept to `type`, mapping values from `request.types`.
 *
 * Examples:
 *
 *      superagent.types.json = 'application/json';
 *
 *      request.get('/agent')
 *        .accept('json')
 *        .end(callback);
 *
 *      request.get('/agent')
 *        .accept('application/json')
 *        .end(callback);
 *
 * @param {String} accept
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.accept = function (type) {
  this.set('Accept', request.types[type] || type);
  return this;
};

/**
 * Set Authorization field value with `user` and `pass`.
 *
 * @param {String} user
 * @param {String} [pass] optional in case of using 'bearer' as type
 * @param {Object} options with 'type' property 'auto', 'basic' or 'bearer' (default 'basic')
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.auth = function (user, pass, options) {
  if (arguments.length === 1) pass = '';
  if (typeof pass === 'object' && pass !== null) {
    // pass is optional and can be replaced with options
    options = pass;
    pass = '';
  }
  if (!options) {
    options = {
      type: typeof btoa === 'function' ? 'basic' : 'auto'
    };
  }
  const encoder = options.encoder ? options.encoder : string => {
    if (typeof btoa === 'function') {
      return btoa(string);
    }
    throw new Error('Cannot use basic auth, btoa is not a function');
  };
  return this._auth(user, pass, options, encoder);
};

/**
 * Add query-string `val`.
 *
 * Examples:
 *
 *   request.get('/shoes')
 *     .query('size=10')
 *     .query({ color: 'blue' })
 *
 * @param {Object|String} val
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.query = function (value) {
  if (typeof value !== 'string') value = serialize(value);
  if (value) this._query.push(value);
  return this;
};

/**
 * Queue the given `file` as an attachment to the specified `field`,
 * with optional `options` (or filename).
 *
 * ``` js
 * request.post('/upload')
 *   .attach('content', new Blob(['<a id="a"><b id="b">hey!</b></a>'], { type: "text/html"}))
 *   .end(callback);
 * ```
 *
 * @param {String} field
 * @param {Blob|File} file
 * @param {String|Object} options
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.attach = function (field, file, options) {
  if (file) {
    if (this._data) {
      throw new Error("superagent can't mix .send() and .attach()");
    }
    this._getFormData().append(field, file, options || file.name);
  }
  return this;
};
Request.prototype._getFormData = function () {
  if (!this._formData) {
    this._formData = new root.FormData();
  }
  return this._formData;
};

/**
 * Invoke the callback with `err` and `res`
 * and handle arity check.
 *
 * @param {Error} err
 * @param {Response} res
 * @api private
 */

Request.prototype.callback = function (error, res) {
  if (this._shouldRetry(error, res)) {
    return this._retry();
  }
  const fn = this._callback;
  this.clearTimeout();
  if (error) {
    if (this._maxRetries) error.retries = this._retries - 1;
    this.emit('error', error);
  }
  fn(error, res);
};

/**
 * Invoke callback with x-domain error.
 *
 * @api private
 */

Request.prototype.crossDomainError = function () {
  const error = new Error('Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.');
  error.crossDomain = true;
  error.status = this.status;
  error.method = this.method;
  error.url = this.url;
  this.callback(error);
};

// This only warns, because the request is still likely to work
Request.prototype.agent = function () {
  console.warn('This is not supported in browser version of superagent');
  return this;
};
Request.prototype.ca = Request.prototype.agent;
Request.prototype.buffer = Request.prototype.ca;

// This throws, because it can't send/receive data as expected
Request.prototype.write = () => {
  throw new Error('Streaming is not supported in browser version of superagent');
};
Request.prototype.pipe = Request.prototype.write;

/**
 * Check if `obj` is a host object,
 * we don't want to serialize these :)
 *
 * @param {Object} obj host object
 * @return {Boolean} is a host object
 * @api private
 */
Request.prototype._isHost = function (object) {
  // Native objects stringify to [object File], [object Blob], [object FormData], etc.
  return object && typeof object === 'object' && !Array.isArray(object) && Object.prototype.toString.call(object) !== '[object Object]';
};

/**
 * Initiate request, invoking callback `fn(res)`
 * with an instanceof `Response`.
 *
 * @param {Function} fn
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.end = function (fn) {
  if (this._endCalled) {
    console.warn('Warning: .end() was called twice. This is not supported in superagent');
  }
  this._endCalled = true;

  // store callback
  this._callback = fn || noop;

  // querystring
  this._finalizeQueryString();
  this._end();
};
Request.prototype._setUploadTimeout = function () {
  const self = this;

  // upload timeout it's wokrs only if deadline timeout is off
  if (this._uploadTimeout && !this._uploadTimeoutTimer) {
    this._uploadTimeoutTimer = setTimeout(() => {
      self._timeoutError('Upload timeout of ', self._uploadTimeout, 'ETIMEDOUT');
    }, this._uploadTimeout);
  }
};

// eslint-disable-next-line complexity
Request.prototype._end = function () {
  if (this._aborted) return this.callback(new Error('The request has been aborted even before .end() was called'));
  const self = this;
  this.xhr = request.getXHR();
  const xhr = this.xhr;
  let data = this._formData || this._data;
  this._setTimeouts();

  // state change
  xhr.addEventListener('readystatechange', () => {
    const readyState = xhr.readyState;
    if (readyState >= 2 && self._responseTimeoutTimer) {
      clearTimeout(self._responseTimeoutTimer);
    }
    if (readyState !== 4) {
      return;
    }

    // In IE9, reads to any property (e.g. status) off of an aborted XHR will
    // result in the error "Could not complete the operation due to error c00c023f"
    let status;
    try {
      status = xhr.status;
    } catch (err) {
      status = 0;
    }
    if (!status) {
      if (self.timedout || self._aborted) return;
      return self.crossDomainError();
    }
    self.emit('end');
  });

  // progress
  const handleProgress = (direction, e) => {
    if (e.total > 0) {
      e.percent = e.loaded / e.total * 100;
      if (e.percent === 100) {
        clearTimeout(self._uploadTimeoutTimer);
      }
    }
    e.direction = direction;
    self.emit('progress', e);
  };
  if (this.hasListeners('progress')) {
    try {
      xhr.addEventListener('progress', handleProgress.bind(null, 'download'));
      if (xhr.upload) {
        xhr.upload.addEventListener('progress', handleProgress.bind(null, 'upload'));
      }
    } catch (err) {
      // Accessing xhr.upload fails in IE from a web worker, so just pretend it doesn't exist.
      // Reported here:
      // https://connect.microsoft.com/IE/feedback/details/837245/xmlhttprequest-upload-throws-invalid-argument-when-used-from-web-worker-context
    }
  }
  if (xhr.upload) {
    this._setUploadTimeout();
  }

  // initiate request
  try {
    if (this.username && this.password) {
      xhr.open(this.method, this.url, true, this.username, this.password);
    } else {
      xhr.open(this.method, this.url, true);
    }
  } catch (err) {
    // see #1149
    return this.callback(err);
  }

  // CORS
  if (this._withCredentials) xhr.withCredentials = true;

  // body
  if (!this._formData && this.method !== 'GET' && this.method !== 'HEAD' && typeof data !== 'string' && !this._isHost(data)) {
    // serialize stuff
    const contentType = this._header['content-type'];
    let serialize = this._serializer || request.serialize[contentType ? contentType.split(';')[0] : ''];
    if (!serialize && isJSON(contentType)) {
      serialize = request.serialize['application/json'];
    }
    if (serialize) data = serialize(data);
  }

  // set header fields
  for (const field in this.header) {
    if (this.header[field] === null) continue;
    if (hasOwn(this.header, field)) xhr.setRequestHeader(field, this.header[field]);
  }
  if (this._responseType) {
    xhr.responseType = this._responseType;
  }

  // send stuff
  this.emit('request', this);

  // IE11 xhr.send(undefined) sends 'undefined' string as POST payload (instead of nothing)
  // We need null here if data is undefined
  xhr.send(typeof data === 'undefined' ? null : data);
};
request.agent = () => new Agent();
for (var _i = 0, _arr = ['GET', 'POST', 'OPTIONS', 'PATCH', 'PUT', 'DELETE']; _i < _arr.length; _i++) {
  const method = _arr[_i];
  Agent.prototype[method.toLowerCase()] = function (url, fn) {
    const request_ = new request.Request(method, url);
    this._setDefaults(request_);
    if (fn) {
      request_.end(fn);
    }
    return request_;
  };
}
Agent.prototype.del = Agent.prototype.delete;

/**
 * GET `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.get = (url, data, fn) => {
  const request_ = request('GET', url);
  if (typeof data === 'function') {
    fn = data;
    data = null;
  }
  if (data) request_.query(data);
  if (fn) request_.end(fn);
  return request_;
};

/**
 * HEAD `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.head = (url, data, fn) => {
  const request_ = request('HEAD', url);
  if (typeof data === 'function') {
    fn = data;
    data = null;
  }
  if (data) request_.query(data);
  if (fn) request_.end(fn);
  return request_;
};

/**
 * OPTIONS query to `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.options = (url, data, fn) => {
  const request_ = request('OPTIONS', url);
  if (typeof data === 'function') {
    fn = data;
    data = null;
  }
  if (data) request_.send(data);
  if (fn) request_.end(fn);
  return request_;
};

/**
 * DELETE `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

function del(url, data, fn) {
  const request_ = request('DELETE', url);
  if (typeof data === 'function') {
    fn = data;
    data = null;
  }
  if (data) request_.send(data);
  if (fn) request_.end(fn);
  return request_;
}
request.del = del;
request.delete = del;

/**
 * PATCH `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.patch = (url, data, fn) => {
  const request_ = request('PATCH', url);
  if (typeof data === 'function') {
    fn = data;
    data = null;
  }
  if (data) request_.send(data);
  if (fn) request_.end(fn);
  return request_;
};

/**
 * POST `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.post = (url, data, fn) => {
  const request_ = request('POST', url);
  if (typeof data === 'function') {
    fn = data;
    data = null;
  }
  if (data) request_.send(data);
  if (fn) request_.end(fn);
  return request_;
};

/**
 * PUT `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.put = (url, data, fn) => {
  const request_ = request('PUT', url);
  if (typeof data === 'function') {
    fn = data;
    data = null;
  }
  if (data) request_.send(data);
  if (fn) request_.end(fn);
  return request_;
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 39745:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
/* provided dependency */ var process = __webpack_require__(14224);


const semver = __webpack_require__(47401);

/**
 * Module of mixed-in functions shared between node and client code
 */
const _require = __webpack_require__(73316),
  isObject = _require.isObject,
  hasOwn = _require.hasOwn;

/**
 * Expose `RequestBase`.
 */

module.exports = RequestBase;

/**
 * Initialize a new `RequestBase`.
 *
 * @api public
 */

function RequestBase() {}

/**
 * Clear previous timeout.
 *
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.clearTimeout = function () {
  clearTimeout(this._timer);
  clearTimeout(this._responseTimeoutTimer);
  clearTimeout(this._uploadTimeoutTimer);
  delete this._timer;
  delete this._responseTimeoutTimer;
  delete this._uploadTimeoutTimer;
  return this;
};

/**
 * Override default response body parser
 *
 * This function will be called to convert incoming data into request.body
 *
 * @param {Function}
 * @api public
 */

RequestBase.prototype.parse = function (fn) {
  this._parser = fn;
  return this;
};

/**
 * Set format of binary response body.
 * In browser valid formats are 'blob' and 'arraybuffer',
 * which return Blob and ArrayBuffer, respectively.
 *
 * In Node all values result in Buffer.
 *
 * Examples:
 *
 *      req.get('/')
 *        .responseType('blob')
 *        .end(callback);
 *
 * @param {String} val
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.responseType = function (value) {
  this._responseType = value;
  return this;
};

/**
 * Override default request body serializer
 *
 * This function will be called to convert data set via .send or .attach into payload to send
 *
 * @param {Function}
 * @api public
 */

RequestBase.prototype.serialize = function (fn) {
  this._serializer = fn;
  return this;
};

/**
 * Set timeouts.
 *
 * - response timeout is time between sending request and receiving the first byte of the response. Includes DNS and connection time.
 * - deadline is the time from start of the request to receiving response body in full. If the deadline is too short large files may not load at all on slow connections.
 * - upload is the time  since last bit of data was sent or received. This timeout works only if deadline timeout is off
 *
 * Value of 0 or false means no timeout.
 *
 * @param {Number|Object} ms or {response, deadline}
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.timeout = function (options) {
  if (!options || typeof options !== 'object') {
    this._timeout = options;
    this._responseTimeout = 0;
    this._uploadTimeout = 0;
    return this;
  }
  for (const option in options) {
    if (hasOwn(options, option)) {
      switch (option) {
        case 'deadline':
          this._timeout = options.deadline;
          break;
        case 'response':
          this._responseTimeout = options.response;
          break;
        case 'upload':
          this._uploadTimeout = options.upload;
          break;
        default:
          console.warn('Unknown timeout option', option);
      }
    }
  }
  return this;
};

/**
 * Set number of retry attempts on error.
 *
 * Failed requests will be retried 'count' times if timeout or err.code >= 500.
 *
 * @param {Number} count
 * @param {Function} [fn]
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.retry = function (count, fn) {
  // Default to 1 if no count passed or true
  if (arguments.length === 0 || count === true) count = 1;
  if (count <= 0) count = 0;
  this._maxRetries = count;
  this._retries = 0;
  this._retryCallback = fn;
  return this;
};

//
// NOTE: we do not include ESOCKETTIMEDOUT because that is from `request` package
//       <https://github.com/sindresorhus/got/pull/537>
//
// NOTE: we do not include EADDRINFO because it was removed from libuv in 2014
//       <https://github.com/libuv/libuv/commit/02e1ebd40b807be5af46343ea873331b2ee4e9c1>
//       <https://github.com/request/request/search?q=ESOCKETTIMEDOUT&unscoped_q=ESOCKETTIMEDOUT>
//
//
// TODO: expose these as configurable defaults
//
const ERROR_CODES = new Set(['ETIMEDOUT', 'ECONNRESET', 'EADDRINUSE', 'ECONNREFUSED', 'EPIPE', 'ENOTFOUND', 'ENETUNREACH', 'EAI_AGAIN']);
const STATUS_CODES = new Set([408, 413, 429, 500, 502, 503, 504, 521, 522, 524]);

// TODO: we would need to make this easily configurable before adding it in (e.g. some might want to add POST)
// const METHODS = new Set(['GET', 'PUT', 'HEAD', 'DELETE', 'OPTIONS', 'TRACE']);

/**
 * Determine if a request should be retried.
 * (Inspired by https://github.com/sindresorhus/got#retry)
 *
 * @param {Error} err an error
 * @param {Response} [res] response
 * @returns {Boolean} if segment should be retried
 */
RequestBase.prototype._shouldRetry = function (error, res) {
  if (!this._maxRetries || this._retries++ >= this._maxRetries) {
    return false;
  }
  if (this._retryCallback) {
    try {
      const override = this._retryCallback(error, res);
      if (override === true) return true;
      if (override === false) return false;
      // undefined falls back to defaults
    } catch (err) {
      console.error(err);
    }
  }

  // TODO: we would need to make this easily configurable before adding it in (e.g. some might want to add POST)
  /*
  if (
    this.req &&
    this.req.method &&
    !METHODS.has(this.req.method.toUpperCase())
  )
    return false;
  */
  if (res && res.status && STATUS_CODES.has(res.status)) return true;
  if (error) {
    if (error.code && ERROR_CODES.has(error.code)) return true;
    // Superagent timeout
    if (error.timeout && error.code === 'ECONNABORTED') return true;
    if (error.crossDomain) return true;
  }
  return false;
};

/**
 * Retry request
 *
 * @return {Request} for chaining
 * @api private
 */

RequestBase.prototype._retry = function () {
  this.clearTimeout();

  // node
  if (this.req) {
    this.req = null;
    this.req = this.request();
  }
  this._aborted = false;
  this.timedout = false;
  this.timedoutError = null;
  return this._end();
};

/**
 * Promise support
 *
 * @param {Function} resolve
 * @param {Function} [reject]
 * @return {Request}
 */

RequestBase.prototype.then = function (resolve, reject) {
  if (!this._fullfilledPromise) {
    const self = this;
    if (this._endCalled) {
      console.warn('Warning: superagent request was sent twice, because both .end() and .then() were called. Never call .end() if you use promises');
    }
    this._fullfilledPromise = new Promise((resolve, reject) => {
      self.on('abort', () => {
        if (this._maxRetries && this._maxRetries > this._retries) {
          return;
        }
        if (this.timedout && this.timedoutError) {
          reject(this.timedoutError);
          return;
        }
        const error = new Error('Aborted');
        error.code = 'ABORTED';
        error.status = this.status;
        error.method = this.method;
        error.url = this.url;
        reject(error);
      });
      self.end((error, res) => {
        if (error) reject(error);else resolve(res);
      });
    });
  }
  return this._fullfilledPromise.then(resolve, reject);
};
RequestBase.prototype.catch = function (callback) {
  return this.then(undefined, callback);
};

/**
 * Allow for extension
 */

RequestBase.prototype.use = function (fn) {
  fn(this);
  return this;
};
RequestBase.prototype.ok = function (callback) {
  if (typeof callback !== 'function') throw new Error('Callback required');
  this._okCallback = callback;
  return this;
};
RequestBase.prototype._isResponseOK = function (res) {
  if (!res) {
    return false;
  }
  if (this._okCallback) {
    return this._okCallback(res);
  }
  return res.status >= 200 && res.status < 300;
};

/**
 * Get request header `field`.
 * Case-insensitive.
 *
 * @param {String} field
 * @return {String}
 * @api public
 */

RequestBase.prototype.get = function (field) {
  return this._header[field.toLowerCase()];
};

/**
 * Get case-insensitive header `field` value.
 * This is a deprecated internal API. Use `.get(field)` instead.
 *
 * (getHeader is no longer used internally by the superagent code base)
 *
 * @param {String} field
 * @return {String}
 * @api private
 * @deprecated
 */

RequestBase.prototype.getHeader = RequestBase.prototype.get;

/**
 * Set header `field` to `val`, or multiple fields with one object.
 * Case-insensitive.
 *
 * Examples:
 *
 *      req.get('/')
 *        .set('Accept', 'application/json')
 *        .set('X-API-Key', 'foobar')
 *        .end(callback);
 *
 *      req.get('/')
 *        .set({ Accept: 'application/json', 'X-API-Key': 'foobar' })
 *        .end(callback);
 *
 * @param {String|Object} field
 * @param {String} val
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.set = function (field, value) {
  if (isObject(field)) {
    for (const key in field) {
      if (hasOwn(field, key)) this.set(key, field[key]);
    }
    return this;
  }
  this._header[field.toLowerCase()] = value;
  this.header[field] = value;
  return this;
};

/**
 * Remove header `field`.
 * Case-insensitive.
 *
 * Example:
 *
 *      req.get('/')
 *        .unset('User-Agent')
 *        .end(callback);
 *
 * @param {String} field field name
 */
RequestBase.prototype.unset = function (field) {
  delete this._header[field.toLowerCase()];
  delete this.header[field];
  return this;
};

/**
 * Write the field `name` and `val`, or multiple fields with one object
 * for "multipart/form-data" request bodies.
 *
 * ``` js
 * request.post('/upload')
 *   .field('foo', 'bar')
 *   .end(callback);
 *
 * request.post('/upload')
 *   .field({ foo: 'bar', baz: 'qux' })
 *   .end(callback);
 * ```
 *
 * @param {String|Object} name name of field
 * @param {String|Blob|File|Buffer|fs.ReadStream} val value of field
 * @param {String} options extra options, e.g. 'blob'
 * @return {Request} for chaining
 * @api public
 */
RequestBase.prototype.field = function (name, value, options) {
  // name should be either a string or an object.
  if (name === null || undefined === name) {
    throw new Error('.field(name, val) name can not be empty');
  }
  if (this._data) {
    throw new Error(".field() can't be used if .send() is used. Please use only .send() or only .field() & .attach()");
  }
  if (isObject(name)) {
    for (const key in name) {
      if (hasOwn(name, key)) this.field(key, name[key]);
    }
    return this;
  }
  if (Array.isArray(value)) {
    for (const i in value) {
      if (hasOwn(value, i)) this.field(name, value[i]);
    }
    return this;
  }

  // val should be defined now
  if (value === null || undefined === value) {
    throw new Error('.field(name, val) val can not be empty');
  }
  if (typeof value === 'boolean') {
    value = String(value);
  }

  // fix https://github.com/ladjs/superagent/issues/1680
  if (options) this._getFormData().append(name, value, options);else this._getFormData().append(name, value);
  return this;
};

/**
 * Abort the request, and clear potential timeout.
 *
 * @return {Request} request
 * @api public
 */
RequestBase.prototype.abort = function () {
  if (this._aborted) {
    return this;
  }
  this._aborted = true;
  if (this.xhr) this.xhr.abort(); // browser
  if (this.req) {
    // Node v13 has major differences in `abort()`
    // https://github.com/nodejs/node/blob/v12.x/lib/internal/streams/end-of-stream.js
    // https://github.com/nodejs/node/blob/v13.x/lib/internal/streams/end-of-stream.js
    // https://github.com/nodejs/node/blob/v14.x/lib/internal/streams/end-of-stream.js
    // (if you run a diff across these you will see the differences)
    //
    // References:
    // <https://github.com/nodejs/node/issues/31630>
    // <https://github.com/ladjs/superagent/pull/1084/commits/dc18679a7c5ccfc6046d882015e5126888973bc8>
    //
    // Thanks to @shadowgate15 and @niftylettuce
    if (semver.gte(process.version, 'v13.0.0') && semver.lt(process.version, 'v14.0.0')) {
      // Note that the reason this doesn't work is because in v13 as compared to v14
      // there is no `callback = nop` set in end-of-stream.js above
      throw new Error('Superagent does not work in v13 properly with abort() due to Node.js core changes');
    } else if (semver.gte(process.version, 'v14.0.0')) {
      // We have to manually set `destroyed` to `true` in order for this to work
      // (see core internals of end-of-stream.js above in v14 branch as compared to v12)
      this.req.destroyed = true;
    }
    this.req.abort(); // node
  }

  this.clearTimeout();
  this.emit('abort');
  return this;
};
RequestBase.prototype._auth = function (user, pass, options, base64Encoder) {
  switch (options.type) {
    case 'basic':
      this.set('Authorization', `Basic ${base64Encoder(`${user}:${pass}`)}`);
      break;
    case 'auto':
      this.username = user;
      this.password = pass;
      break;
    case 'bearer':
      // usage would be .auth(accessToken, { type: 'bearer' })
      this.set('Authorization', `Bearer ${user}`);
      break;
    default:
      break;
  }
  return this;
};

/**
 * Enable transmission of cookies with x-domain requests.
 *
 * Note that for this to work the origin must not be
 * using "Access-Control-Allow-Origin" with a wildcard,
 * and also must set "Access-Control-Allow-Credentials"
 * to "true".
 * @param {Boolean} [on=true] - Set 'withCredentials' state
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.withCredentials = function (on) {
  // This is browser-only functionality. Node side is no-op.
  if (on === undefined) on = true;
  this._withCredentials = on;
  return this;
};

/**
 * Set the max redirects to `n`. Does nothing in browser XHR implementation.
 *
 * @param {Number} n
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.redirects = function (n) {
  this._maxRedirects = n;
  return this;
};

/**
 * Maximum size of buffered response body, in bytes. Counts uncompressed size.
 * Default 200MB.
 *
 * @param {Number} n number of bytes
 * @return {Request} for chaining
 */
RequestBase.prototype.maxResponseSize = function (n) {
  if (typeof n !== 'number') {
    throw new TypeError('Invalid argument');
  }
  this._maxResponseSize = n;
  return this;
};

/**
 * Convert to a plain javascript object (not JSON string) of scalar properties.
 * Note as this method is designed to return a useful non-this value,
 * it cannot be chained.
 *
 * @return {Object} describing method, url, and data of this request
 * @api public
 */

RequestBase.prototype.toJSON = function () {
  return {
    method: this.method,
    url: this.url,
    data: this._data,
    headers: this._header
  };
};

/**
 * Send `data` as the request body, defaulting the `.type()` to "json" when
 * an object is given.
 *
 * Examples:
 *
 *       // manual json
 *       request.post('/user')
 *         .type('json')
 *         .send('{"name":"tj"}')
 *         .end(callback)
 *
 *       // auto json
 *       request.post('/user')
 *         .send({ name: 'tj' })
 *         .end(callback)
 *
 *       // manual x-www-form-urlencoded
 *       request.post('/user')
 *         .type('form')
 *         .send('name=tj')
 *         .end(callback)
 *
 *       // auto x-www-form-urlencoded
 *       request.post('/user')
 *         .type('form')
 *         .send({ name: 'tj' })
 *         .end(callback)
 *
 *       // defaults to x-www-form-urlencoded
 *      request.post('/user')
 *        .send('name=tobi')
 *        .send('species=ferret')
 *        .end(callback)
 *
 * @param {String|Object} data
 * @return {Request} for chaining
 * @api public
 */

// eslint-disable-next-line complexity
RequestBase.prototype.send = function (data) {
  const isObject_ = isObject(data);
  let type = this._header['content-type'];
  if (this._formData) {
    throw new Error(".send() can't be used if .attach() or .field() is used. Please use only .send() or only .field() & .attach()");
  }
  if (isObject_ && !this._data) {
    if (Array.isArray(data)) {
      this._data = [];
    } else if (!this._isHost(data)) {
      this._data = {};
    }
  } else if (data && this._data && this._isHost(this._data)) {
    throw new Error("Can't merge these send calls");
  }

  // merge
  if (isObject_ && isObject(this._data)) {
    for (const key in data) {
      if (hasOwn(data, key)) this._data[key] = data[key];
    }
  } else if (typeof data === 'string') {
    // default to x-www-form-urlencoded
    if (!type) this.type('form');
    type = this._header['content-type'];
    if (type) type = type.toLowerCase().trim();
    if (type === 'application/x-www-form-urlencoded') {
      this._data = this._data ? `${this._data}&${data}` : data;
    } else {
      this._data = (this._data || '') + data;
    }
  } else {
    this._data = data;
  }
  if (!isObject_ || this._isHost(data)) {
    return this;
  }

  // default to json
  if (!type) this.type('json');
  return this;
};

/**
 * Sort `querystring` by the sort function
 *
 *
 * Examples:
 *
 *       // default order
 *       request.get('/user')
 *         .query('name=Nick')
 *         .query('search=Manny')
 *         .sortQuery()
 *         .end(callback)
 *
 *       // customized sort function
 *       request.get('/user')
 *         .query('name=Nick')
 *         .query('search=Manny')
 *         .sortQuery(function(a, b){
 *           return a.length - b.length;
 *         })
 *         .end(callback)
 *
 *
 * @param {Function} sort
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.sortQuery = function (sort) {
  // _sort default to true but otherwise can be a function or boolean
  this._sort = typeof sort === 'undefined' ? true : sort;
  return this;
};

/**
 * Compose querystring to append to req.url
 *
 * @api private
 */
RequestBase.prototype._finalizeQueryString = function () {
  const query = this._query.join('&');
  if (query) {
    this.url += (this.url.includes('?') ? '&' : '?') + query;
  }
  this._query.length = 0; // Makes the call idempotent

  if (this._sort) {
    const index = this.url.indexOf('?');
    if (index >= 0) {
      const queryArray = this.url.slice(index + 1).split('&');
      if (typeof this._sort === 'function') {
        queryArray.sort(this._sort);
      } else {
        queryArray.sort();
      }
      this.url = this.url.slice(0, index) + '?' + queryArray.join('&');
    }
  }
};

// For backwards compat only
RequestBase.prototype._appendQueryString = () => {
  console.warn('Unsupported');
};

/**
 * Invoke callback with timeout error.
 *
 * @api private
 */

RequestBase.prototype._timeoutError = function (reason, timeout, errno) {
  if (this._aborted) {
    return;
  }
  const error = new Error(`${reason + timeout}ms exceeded`);
  error.timeout = timeout;
  error.code = 'ECONNABORTED';
  error.errno = errno;
  this.timedout = true;
  this.timedoutError = error;
  this.abort();
  this.callback(error);
};
RequestBase.prototype._setTimeouts = function () {
  const self = this;

  // deadline
  if (this._timeout && !this._timer) {
    this._timer = setTimeout(() => {
      self._timeoutError('Timeout of ', self._timeout, 'ETIME');
    }, this._timeout);
  }

  // response timeout
  if (this._responseTimeout && !this._responseTimeoutTimer) {
    this._responseTimeoutTimer = setTimeout(() => {
      self._timeoutError('Response timeout of ', self._responseTimeout, 'ETIMEDOUT');
    }, this._responseTimeout);
  }
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJzZW12ZXIiLCJyZXF1aXJlIiwiaXNPYmplY3QiLCJoYXNPd24iLCJtb2R1bGUiLCJleHBvcnRzIiwiUmVxdWVzdEJhc2UiLCJwcm90b3R5cGUiLCJjbGVhclRpbWVvdXQiLCJfdGltZXIiLCJfcmVzcG9uc2VUaW1lb3V0VGltZXIiLCJfdXBsb2FkVGltZW91dFRpbWVyIiwicGFyc2UiLCJmbiIsIl9wYXJzZXIiLCJyZXNwb25zZVR5cGUiLCJ2YWx1ZSIsIl9yZXNwb25zZVR5cGUiLCJzZXJpYWxpemUiLCJfc2VyaWFsaXplciIsInRpbWVvdXQiLCJvcHRpb25zIiwiX3RpbWVvdXQiLCJfcmVzcG9uc2VUaW1lb3V0IiwiX3VwbG9hZFRpbWVvdXQiLCJvcHRpb24iLCJkZWFkbGluZSIsInJlc3BvbnNlIiwidXBsb2FkIiwiY29uc29sZSIsIndhcm4iLCJyZXRyeSIsImNvdW50IiwiYXJndW1lbnRzIiwibGVuZ3RoIiwiX21heFJldHJpZXMiLCJfcmV0cmllcyIsIl9yZXRyeUNhbGxiYWNrIiwiRVJST1JfQ09ERVMiLCJTZXQiLCJTVEFUVVNfQ09ERVMiLCJfc2hvdWxkUmV0cnkiLCJlcnJvciIsInJlcyIsIm92ZXJyaWRlIiwiZXJyIiwic3RhdHVzIiwiaGFzIiwiY29kZSIsImNyb3NzRG9tYWluIiwiX3JldHJ5IiwicmVxIiwicmVxdWVzdCIsIl9hYm9ydGVkIiwidGltZWRvdXQiLCJ0aW1lZG91dEVycm9yIiwiX2VuZCIsInRoZW4iLCJyZXNvbHZlIiwicmVqZWN0IiwiX2Z1bGxmaWxsZWRQcm9taXNlIiwic2VsZiIsIl9lbmRDYWxsZWQiLCJQcm9taXNlIiwib24iLCJFcnJvciIsIm1ldGhvZCIsInVybCIsImVuZCIsImNhdGNoIiwiY2FsbGJhY2siLCJ1bmRlZmluZWQiLCJ1c2UiLCJvayIsIl9va0NhbGxiYWNrIiwiX2lzUmVzcG9uc2VPSyIsImdldCIsImZpZWxkIiwiX2hlYWRlciIsInRvTG93ZXJDYXNlIiwiZ2V0SGVhZGVyIiwic2V0Iiwia2V5IiwiaGVhZGVyIiwidW5zZXQiLCJuYW1lIiwiX2RhdGEiLCJBcnJheSIsImlzQXJyYXkiLCJpIiwiU3RyaW5nIiwiX2dldEZvcm1EYXRhIiwiYXBwZW5kIiwiYWJvcnQiLCJ4aHIiLCJndGUiLCJwcm9jZXNzIiwidmVyc2lvbiIsImx0IiwiZGVzdHJveWVkIiwiZW1pdCIsIl9hdXRoIiwidXNlciIsInBhc3MiLCJiYXNlNjRFbmNvZGVyIiwidHlwZSIsInVzZXJuYW1lIiwicGFzc3dvcmQiLCJ3aXRoQ3JlZGVudGlhbHMiLCJfd2l0aENyZWRlbnRpYWxzIiwicmVkaXJlY3RzIiwibiIsIl9tYXhSZWRpcmVjdHMiLCJtYXhSZXNwb25zZVNpemUiLCJUeXBlRXJyb3IiLCJfbWF4UmVzcG9uc2VTaXplIiwidG9KU09OIiwiZGF0YSIsImhlYWRlcnMiLCJzZW5kIiwiaXNPYmplY3RfIiwiX2Zvcm1EYXRhIiwiX2lzSG9zdCIsInRyaW0iLCJzb3J0UXVlcnkiLCJzb3J0IiwiX3NvcnQiLCJfZmluYWxpemVRdWVyeVN0cmluZyIsInF1ZXJ5IiwiX3F1ZXJ5Iiwiam9pbiIsImluY2x1ZGVzIiwiaW5kZXgiLCJpbmRleE9mIiwicXVlcnlBcnJheSIsInNsaWNlIiwic3BsaXQiLCJfYXBwZW5kUXVlcnlTdHJpbmciLCJfdGltZW91dEVycm9yIiwicmVhc29uIiwiZXJybm8iLCJfc2V0VGltZW91dHMiLCJzZXRUaW1lb3V0Il0sInNvdXJjZXMiOlsiLi4vc3JjL3JlcXVlc3QtYmFzZS5qcyJdLCJzb3VyY2VzQ29udGVudCI6WyJjb25zdCBzZW12ZXIgPSByZXF1aXJlKCdzZW12ZXInKTtcblxuLyoqXG4gKiBNb2R1bGUgb2YgbWl4ZWQtaW4gZnVuY3Rpb25zIHNoYXJlZCBiZXR3ZWVuIG5vZGUgYW5kIGNsaWVudCBjb2RlXG4gKi9cbmNvbnN0IHsgaXNPYmplY3QsIGhhc093biB9ID0gcmVxdWlyZSgnLi91dGlscycpO1xuXG4vKipcbiAqIEV4cG9zZSBgUmVxdWVzdEJhc2VgLlxuICovXG5cbm1vZHVsZS5leHBvcnRzID0gUmVxdWVzdEJhc2U7XG5cbi8qKlxuICogSW5pdGlhbGl6ZSBhIG5ldyBgUmVxdWVzdEJhc2VgLlxuICpcbiAqIEBhcGkgcHVibGljXG4gKi9cblxuZnVuY3Rpb24gUmVxdWVzdEJhc2UoKSB7fVxuXG4vKipcbiAqIENsZWFyIHByZXZpb3VzIHRpbWVvdXQuXG4gKlxuICogQHJldHVybiB7UmVxdWVzdH0gZm9yIGNoYWluaW5nXG4gKiBAYXBpIHB1YmxpY1xuICovXG5cblJlcXVlc3RCYXNlLnByb3RvdHlwZS5jbGVhclRpbWVvdXQgPSBmdW5jdGlvbiAoKSB7XG4gIGNsZWFyVGltZW91dCh0aGlzLl90aW1lcik7XG4gIGNsZWFyVGltZW91dCh0aGlzLl9yZXNwb25zZVRpbWVvdXRUaW1lcik7XG4gIGNsZWFyVGltZW91dCh0aGlzLl91cGxvYWRUaW1lb3V0VGltZXIpO1xuICBkZWxldGUgdGhpcy5fdGltZXI7XG4gIGRlbGV0ZSB0aGlzLl9yZXNwb25zZVRpbWVvdXRUaW1lcjtcbiAgZGVsZXRlIHRoaXMuX3VwbG9hZFRpbWVvdXRUaW1lcjtcbiAgcmV0dXJuIHRoaXM7XG59O1xuXG4vKipcbiAqIE92ZXJyaWRlIGRlZmF1bHQgcmVzcG9uc2UgYm9keSBwYXJzZXJcbiAqXG4gKiBUaGlzIGZ1bmN0aW9uIHdpbGwgYmUgY2FsbGVkIHRvIGNvbnZlcnQgaW5jb21pbmcgZGF0YSBpbnRvIHJlcXVlc3QuYm9keVxuICpcbiAqIEBwYXJhbSB7RnVuY3Rpb259XG4gKiBAYXBpIHB1YmxpY1xuICovXG5cblJlcXVlc3RCYXNlLnByb3RvdHlwZS5wYXJzZSA9IGZ1bmN0aW9uIChmbikge1xuICB0aGlzLl9wYXJzZXIgPSBmbjtcbiAgcmV0dXJuIHRoaXM7XG59O1xuXG4vKipcbiAqIFNldCBmb3JtYXQgb2YgYmluYXJ5IHJlc3BvbnNlIGJvZHkuXG4gKiBJbiBicm93c2VyIHZhbGlkIGZvcm1hdHMgYXJlICdibG9iJyBhbmQgJ2FycmF5YnVmZmVyJyxcbiAqIHdoaWNoIHJldHVybiBCbG9iIGFuZCBBcnJheUJ1ZmZlciwgcmVzcGVjdGl2ZWx5LlxuICpcbiAqIEluIE5vZGUgYWxsIHZhbHVlcyByZXN1bHQgaW4gQnVmZmVyLlxuICpcbiAqIEV4YW1wbGVzOlxuICpcbiAqICAgICAgcmVxLmdldCgnLycpXG4gKiAgICAgICAgLnJlc3BvbnNlVHlwZSgnYmxvYicpXG4gKiAgICAgICAgLmVuZChjYWxsYmFjayk7XG4gKlxuICogQHBhcmFtIHtTdHJpbmd9IHZhbFxuICogQHJldHVybiB7UmVxdWVzdH0gZm9yIGNoYWluaW5nXG4gKiBAYXBpIHB1YmxpY1xuICovXG5cblJlcXVlc3RCYXNlLnByb3RvdHlwZS5yZXNwb25zZVR5cGUgPSBmdW5jdGlvbiAodmFsdWUpIHtcbiAgdGhpcy5fcmVzcG9uc2VUeXBlID0gdmFsdWU7XG4gIHJldHVybiB0aGlzO1xufTtcblxuLyoqXG4gKiBPdmVycmlkZSBkZWZhdWx0IHJlcXVlc3QgYm9keSBzZXJpYWxpemVyXG4gKlxuICogVGhpcyBmdW5jdGlvbiB3aWxsIGJlIGNhbGxlZCB0byBjb252ZXJ0IGRhdGEgc2V0IHZpYSAuc2VuZCBvciAuYXR0YWNoIGludG8gcGF5bG9hZCB0byBzZW5kXG4gKlxuICogQHBhcmFtIHtGdW5jdGlvbn1cbiAqIEBhcGkgcHVibGljXG4gKi9cblxuUmVxdWVzdEJhc2UucHJvdG90eXBlLnNlcmlhbGl6ZSA9IGZ1bmN0aW9uIChmbikge1xuICB0aGlzLl9zZXJpYWxpemVyID0gZm47XG4gIHJldHVybiB0aGlzO1xufTtcblxuLyoqXG4gKiBTZXQgdGltZW91dHMuXG4gKlxuICogLSByZXNwb25zZSB0aW1lb3V0IGlzIHRpbWUgYmV0d2VlbiBzZW5kaW5nIHJlcXVlc3QgYW5kIHJlY2VpdmluZyB0aGUgZmlyc3QgYnl0ZSBvZiB0aGUgcmVzcG9uc2UuIEluY2x1ZGVzIEROUyBhbmQgY29ubmVjdGlvbiB0aW1lLlxuICogLSBkZWFkbGluZSBpcyB0aGUgdGltZSBmcm9tIHN0YXJ0IG9mIHRoZSByZXF1ZXN0IHRvIHJlY2VpdmluZyByZXNwb25zZSBib2R5IGluIGZ1bGwuIElmIHRoZSBkZWFkbGluZSBpcyB0b28gc2hvcnQgbGFyZ2UgZmlsZXMgbWF5IG5vdCBsb2FkIGF0IGFsbCBvbiBzbG93IGNvbm5lY3Rpb25zLlxuICogLSB1cGxvYWQgaXMgdGhlIHRpbWUgIHNpbmNlIGxhc3QgYml0IG9mIGRhdGEgd2FzIHNlbnQgb3IgcmVjZWl2ZWQuIFRoaXMgdGltZW91dCB3b3JrcyBvbmx5IGlmIGRlYWRsaW5lIHRpbWVvdXQgaXMgb2ZmXG4gKlxuICogVmFsdWUgb2YgMCBvciBmYWxzZSBtZWFucyBubyB0aW1lb3V0LlxuICpcbiAqIEBwYXJhbSB7TnVtYmVyfE9iamVjdH0gbXMgb3Ige3Jlc3BvbnNlLCBkZWFkbGluZX1cbiAqIEByZXR1cm4ge1JlcXVlc3R9IGZvciBjaGFpbmluZ1xuICogQGFwaSBwdWJsaWNcbiAqL1xuXG5SZXF1ZXN0QmFzZS5wcm90b3R5cGUudGltZW91dCA9IGZ1bmN0aW9uIChvcHRpb25zKSB7XG4gIGlmICghb3B0aW9ucyB8fCB0eXBlb2Ygb3B0aW9ucyAhPT0gJ29iamVjdCcpIHtcbiAgICB0aGlzLl90aW1lb3V0ID0gb3B0aW9ucztcbiAgICB0aGlzLl9yZXNwb25zZVRpbWVvdXQgPSAwO1xuICAgIHRoaXMuX3VwbG9hZFRpbWVvdXQgPSAwO1xuICAgIHJldHVybiB0aGlzO1xuICB9XG5cbiAgZm9yIChjb25zdCBvcHRpb24gaW4gb3B0aW9ucykge1xuICAgIGlmIChoYXNPd24ob3B0aW9ucywgb3B0aW9uKSkge1xuICAgICAgc3dpdGNoIChvcHRpb24pIHtcbiAgICAgICAgY2FzZSAnZGVhZGxpbmUnOlxuICAgICAgICAgIHRoaXMuX3RpbWVvdXQgPSBvcHRpb25zLmRlYWRsaW5lO1xuICAgICAgICAgIGJyZWFrO1xuICAgICAgICBjYXNlICdyZXNwb25zZSc6XG4gICAgICAgICAgdGhpcy5fcmVzcG9uc2VUaW1lb3V0ID0gb3B0aW9ucy5yZXNwb25zZTtcbiAgICAgICAgICBicmVhaztcbiAgICAgICAgY2FzZSAndXBsb2FkJzpcbiAgICAgICAgICB0aGlzLl91cGxvYWRUaW1lb3V0ID0gb3B0aW9ucy51cGxvYWQ7XG4gICAgICAgICAgYnJlYWs7XG4gICAgICAgIGRlZmF1bHQ6XG4gICAgICAgICAgY29uc29sZS53YXJuKCdVbmtub3duIHRpbWVvdXQgb3B0aW9uJywgb3B0aW9uKTtcbiAgICAgIH1cbiAgICB9XG4gIH1cblxuICByZXR1cm4gdGhpcztcbn07XG5cbi8qKlxuICogU2V0IG51bWJlciBvZiByZXRyeSBhdHRlbXB0cyBvbiBlcnJvci5cbiAqXG4gKiBGYWlsZWQgcmVxdWVzdHMgd2lsbCBiZSByZXRyaWVkICdjb3VudCcgdGltZXMgaWYgdGltZW91dCBvciBlcnIuY29kZSA+PSA1MDAuXG4gKlxuICogQHBhcmFtIHtOdW1iZXJ9IGNvdW50XG4gKiBAcGFyYW0ge0Z1bmN0aW9ufSBbZm5dXG4gKiBAcmV0dXJuIHtSZXF1ZXN0fSBmb3IgY2hhaW5pbmdcbiAqIEBhcGkgcHVibGljXG4gKi9cblxuUmVxdWVzdEJhc2UucHJvdG90eXBlLnJldHJ5ID0gZnVuY3Rpb24gKGNvdW50LCBmbikge1xuICAvLyBEZWZhdWx0IHRvIDEgaWYgbm8gY291bnQgcGFzc2VkIG9yIHRydWVcbiAgaWYgKGFyZ3VtZW50cy5sZW5ndGggPT09IDAgfHwgY291bnQgPT09IHRydWUpIGNvdW50ID0gMTtcbiAgaWYgKGNvdW50IDw9IDApIGNvdW50ID0gMDtcbiAgdGhpcy5fbWF4UmV0cmllcyA9IGNvdW50O1xuICB0aGlzLl9yZXRyaWVzID0gMDtcbiAgdGhpcy5fcmV0cnlDYWxsYmFjayA9IGZuO1xuICByZXR1cm4gdGhpcztcbn07XG5cbi8vXG4vLyBOT1RFOiB3ZSBkbyBub3QgaW5jbHVkZSBFU09DS0VUVElNRURPVVQgYmVjYXVzZSB0aGF0IGlzIGZyb20gYHJlcXVlc3RgIHBhY2thZ2Vcbi8vICAgICAgIDxodHRwczovL2dpdGh1Yi5jb20vc2luZHJlc29yaHVzL2dvdC9wdWxsLzUzNz5cbi8vXG4vLyBOT1RFOiB3ZSBkbyBub3QgaW5jbHVkZSBFQUREUklORk8gYmVjYXVzZSBpdCB3YXMgcmVtb3ZlZCBmcm9tIGxpYnV2IGluIDIwMTRcbi8vICAgICAgIDxodHRwczovL2dpdGh1Yi5jb20vbGlidXYvbGlidXYvY29tbWl0LzAyZTFlYmQ0MGI4MDdiZTVhZjQ2MzQzZWE4NzMzMzFiMmVlNGU5YzE+XG4vLyAgICAgICA8aHR0cHM6Ly9naXRodWIuY29tL3JlcXVlc3QvcmVxdWVzdC9zZWFyY2g/cT1FU09DS0VUVElNRURPVVQmdW5zY29wZWRfcT1FU09DS0VUVElNRURPVVQ+XG4vL1xuLy9cbi8vIFRPRE86IGV4cG9zZSB0aGVzZSBhcyBjb25maWd1cmFibGUgZGVmYXVsdHNcbi8vXG5jb25zdCBFUlJPUl9DT0RFUyA9IG5ldyBTZXQoW1xuICAnRVRJTUVET1VUJyxcbiAgJ0VDT05OUkVTRVQnLFxuICAnRUFERFJJTlVTRScsXG4gICdFQ09OTlJFRlVTRUQnLFxuICAnRVBJUEUnLFxuICAnRU5PVEZPVU5EJyxcbiAgJ0VORVRVTlJFQUNIJyxcbiAgJ0VBSV9BR0FJTidcbl0pO1xuXG5jb25zdCBTVEFUVVNfQ09ERVMgPSBuZXcgU2V0KFtcbiAgNDA4LCA0MTMsIDQyOSwgNTAwLCA1MDIsIDUwMywgNTA0LCA1MjEsIDUyMiwgNTI0XG5dKTtcblxuLy8gVE9ETzogd2Ugd291bGQgbmVlZCB0byBtYWtlIHRoaXMgZWFzaWx5IGNvbmZpZ3VyYWJsZSBiZWZvcmUgYWRkaW5nIGl0IGluIChlLmcuIHNvbWUgbWlnaHQgd2FudCB0byBhZGQgUE9TVClcbi8vIGNvbnN0IE1FVEhPRFMgPSBuZXcgU2V0KFsnR0VUJywgJ1BVVCcsICdIRUFEJywgJ0RFTEVURScsICdPUFRJT05TJywgJ1RSQUNFJ10pO1xuXG4vKipcbiAqIERldGVybWluZSBpZiBhIHJlcXVlc3Qgc2hvdWxkIGJlIHJldHJpZWQuXG4gKiAoSW5zcGlyZWQgYnkgaHR0cHM6Ly9naXRodWIuY29tL3NpbmRyZXNvcmh1cy9nb3QjcmV0cnkpXG4gKlxuICogQHBhcmFtIHtFcnJvcn0gZXJyIGFuIGVycm9yXG4gKiBAcGFyYW0ge1Jlc3BvbnNlfSBbcmVzXSByZXNwb25zZVxuICogQHJldHVybnMge0Jvb2xlYW59IGlmIHNlZ21lbnQgc2hvdWxkIGJlIHJldHJpZWRcbiAqL1xuUmVxdWVzdEJhc2UucHJvdG90eXBlLl9zaG91bGRSZXRyeSA9IGZ1bmN0aW9uIChlcnJvciwgcmVzKSB7XG4gIGlmICghdGhpcy5fbWF4UmV0cmllcyB8fCB0aGlzLl9yZXRyaWVzKysgPj0gdGhpcy5fbWF4UmV0cmllcykge1xuICAgIHJldHVybiBmYWxzZTtcbiAgfVxuXG4gIGlmICh0aGlzLl9yZXRyeUNhbGxiYWNrKSB7XG4gICAgdHJ5IHtcbiAgICAgIGNvbnN0IG92ZXJyaWRlID0gdGhpcy5fcmV0cnlDYWxsYmFjayhlcnJvciwgcmVzKTtcbiAgICAgIGlmIChvdmVycmlkZSA9PT0gdHJ1ZSkgcmV0dXJuIHRydWU7XG4gICAgICBpZiAob3ZlcnJpZGUgPT09IGZhbHNlKSByZXR1cm4gZmFsc2U7XG4gICAgICAvLyB1bmRlZmluZWQgZmFsbHMgYmFjayB0byBkZWZhdWx0c1xuICAgIH0gY2F0Y2ggKGVycikge1xuICAgICAgY29uc29sZS5lcnJvcihlcnIpO1xuICAgIH1cbiAgfVxuXG4gIC8vIFRPRE86IHdlIHdvdWxkIG5lZWQgdG8gbWFrZSB0aGlzIGVhc2lseSBjb25maWd1cmFibGUgYmVmb3JlIGFkZGluZyBpdCBpbiAoZS5nLiBzb21lIG1pZ2h0IHdhbnQgdG8gYWRkIFBPU1QpXG4gIC8qXG4gIGlmIChcbiAgICB0aGlzLnJlcSAmJlxuICAgIHRoaXMucmVxLm1ldGhvZCAmJlxuICAgICFNRVRIT0RTLmhhcyh0aGlzLnJlcS5tZXRob2QudG9VcHBlckNhc2UoKSlcbiAgKVxuICAgIHJldHVybiBmYWxzZTtcbiAgKi9cbiAgaWYgKHJlcyAmJiByZXMuc3RhdHVzICYmIFNUQVRVU19DT0RFUy5oYXMocmVzLnN0YXR1cykpIHJldHVybiB0cnVlO1xuICBpZiAoZXJyb3IpIHtcbiAgICBpZiAoZXJyb3IuY29kZSAmJiBFUlJPUl9DT0RFUy5oYXMoZXJyb3IuY29kZSkpIHJldHVybiB0cnVlO1xuICAgIC8vIFN1cGVyYWdlbnQgdGltZW91dFxuICAgIGlmIChlcnJvci50aW1lb3V0ICYmIGVycm9yLmNvZGUgPT09ICdFQ09OTkFCT1JURUQnKSByZXR1cm4gdHJ1ZTtcbiAgICBpZiAoZXJyb3IuY3Jvc3NEb21haW4pIHJldHVybiB0cnVlO1xuICB9XG5cbiAgcmV0dXJuIGZhbHNlO1xufTtcblxuLyoqXG4gKiBSZXRyeSByZXF1ZXN0XG4gKlxuICogQHJldHVybiB7UmVxdWVzdH0gZm9yIGNoYWluaW5nXG4gKiBAYXBpIHByaXZhdGVcbiAqL1xuXG5SZXF1ZXN0QmFzZS5wcm90b3R5cGUuX3JldHJ5ID0gZnVuY3Rpb24gKCkge1xuICB0aGlzLmNsZWFyVGltZW91dCgpO1xuXG4gIC8vIG5vZGVcbiAgaWYgKHRoaXMucmVxKSB7XG4gICAgdGhpcy5yZXEgPSBudWxsO1xuICAgIHRoaXMucmVxID0gdGhpcy5yZXF1ZXN0KCk7XG4gIH1cblxuICB0aGlzLl9hYm9ydGVkID0gZmFsc2U7XG4gIHRoaXMudGltZWRvdXQgPSBmYWxzZTtcbiAgdGhpcy50aW1lZG91dEVycm9yID0gbnVsbDtcblxuICByZXR1cm4gdGhpcy5fZW5kKCk7XG59O1xuXG4vKipcbiAqIFByb21pc2Ugc3VwcG9ydFxuICpcbiAqIEBwYXJhbSB7RnVuY3Rpb259IHJlc29sdmVcbiAqIEBwYXJhbSB7RnVuY3Rpb259IFtyZWplY3RdXG4gKiBAcmV0dXJuIHtSZXF1ZXN0fVxuICovXG5cblJlcXVlc3RCYXNlLnByb3RvdHlwZS50aGVuID0gZnVuY3Rpb24gKHJlc29sdmUsIHJlamVjdCkge1xuICBpZiAoIXRoaXMuX2Z1bGxmaWxsZWRQcm9taXNlKSB7XG4gICAgY29uc3Qgc2VsZiA9IHRoaXM7XG4gICAgaWYgKHRoaXMuX2VuZENhbGxlZCkge1xuICAgICAgY29uc29sZS53YXJuKFxuICAgICAgICAnV2FybmluZzogc3VwZXJhZ2VudCByZXF1ZXN0IHdhcyBzZW50IHR3aWNlLCBiZWNhdXNlIGJvdGggLmVuZCgpIGFuZCAudGhlbigpIHdlcmUgY2FsbGVkLiBOZXZlciBjYWxsIC5lbmQoKSBpZiB5b3UgdXNlIHByb21pc2VzJ1xuICAgICAgKTtcbiAgICB9XG5cbiAgICB0aGlzLl9mdWxsZmlsbGVkUHJvbWlzZSA9IG5ldyBQcm9taXNlKChyZXNvbHZlLCByZWplY3QpID0+IHtcbiAgICAgIHNlbGYub24oJ2Fib3J0JywgKCkgPT4ge1xuICAgICAgICBpZiAodGhpcy5fbWF4UmV0cmllcyAmJiB0aGlzLl9tYXhSZXRyaWVzID4gdGhpcy5fcmV0cmllcykge1xuICAgICAgICAgIHJldHVybjtcbiAgICAgICAgfVxuXG4gICAgICAgIGlmICh0aGlzLnRpbWVkb3V0ICYmIHRoaXMudGltZWRvdXRFcnJvcikge1xuICAgICAgICAgIHJlamVjdCh0aGlzLnRpbWVkb3V0RXJyb3IpO1xuICAgICAgICAgIHJldHVybjtcbiAgICAgICAgfVxuXG4gICAgICAgIGNvbnN0IGVycm9yID0gbmV3IEVycm9yKCdBYm9ydGVkJyk7XG4gICAgICAgIGVycm9yLmNvZGUgPSAnQUJPUlRFRCc7XG4gICAgICAgIGVycm9yLnN0YXR1cyA9IHRoaXMuc3RhdHVzO1xuICAgICAgICBlcnJvci5tZXRob2QgPSB0aGlzLm1ldGhvZDtcbiAgICAgICAgZXJyb3IudXJsID0gdGhpcy51cmw7XG4gICAgICAgIHJlamVjdChlcnJvcik7XG4gICAgICB9KTtcbiAgICAgIHNlbGYuZW5kKChlcnJvciwgcmVzKSA9PiB7XG4gICAgICAgIGlmIChlcnJvcikgcmVqZWN0KGVycm9yKTtcbiAgICAgICAgZWxzZSByZXNvbHZlKHJlcyk7XG4gICAgICB9KTtcbiAgICB9KTtcbiAgfVxuXG4gIHJldHVybiB0aGlzLl9mdWxsZmlsbGVkUHJvbWlzZS50aGVuKHJlc29sdmUsIHJlamVjdCk7XG59O1xuXG5SZXF1ZXN0QmFzZS5wcm90b3R5cGUuY2F0Y2ggPSBmdW5jdGlvbiAoY2FsbGJhY2spIHtcbiAgcmV0dXJuIHRoaXMudGhlbih1bmRlZmluZWQsIGNhbGxiYWNrKTtcbn07XG5cbi8qKlxuICogQWxsb3cgZm9yIGV4dGVuc2lvblxuICovXG5cblJlcXVlc3RCYXNlLnByb3RvdHlwZS51c2UgPSBmdW5jdGlvbiAoZm4pIHtcbiAgZm4odGhpcyk7XG4gIHJldHVybiB0aGlzO1xufTtcblxuUmVxdWVzdEJhc2UucHJvdG90eXBlLm9rID0gZnVuY3Rpb24gKGNhbGxiYWNrKSB7XG4gIGlmICh0eXBlb2YgY2FsbGJhY2sgIT09ICdmdW5jdGlvbicpIHRocm93IG5ldyBFcnJvcignQ2FsbGJhY2sgcmVxdWlyZWQnKTtcbiAgdGhpcy5fb2tDYWxsYmFjayA9IGNhbGxiYWNrO1xuICByZXR1cm4gdGhpcztcbn07XG5cblJlcXVlc3RCYXNlLnByb3RvdHlwZS5faXNSZXNwb25zZU9LID0gZnVuY3Rpb24gKHJlcykge1xuICBpZiAoIXJlcykge1xuICAgIHJldHVybiBmYWxzZTtcbiAgfVxuXG4gIGlmICh0aGlzLl9va0NhbGxiYWNrKSB7XG4gICAgcmV0dXJuIHRoaXMuX29rQ2FsbGJhY2socmVzKTtcbiAgfVxuXG4gIHJldHVybiByZXMuc3RhdHVzID49IDIwMCAmJiByZXMuc3RhdHVzIDwgMzAwO1xufTtcblxuLyoqXG4gKiBHZXQgcmVxdWVzdCBoZWFkZXIgYGZpZWxkYC5cbiAqIENhc2UtaW5zZW5zaXRpdmUuXG4gKlxuICogQHBhcmFtIHtTdHJpbmd9IGZpZWxkXG4gKiBAcmV0dXJuIHtTdHJpbmd9XG4gKiBAYXBpIHB1YmxpY1xuICovXG5cblJlcXVlc3RCYXNlLnByb3RvdHlwZS5nZXQgPSBmdW5jdGlvbiAoZmllbGQpIHtcbiAgcmV0dXJuIHRoaXMuX2hlYWRlcltmaWVsZC50b0xvd2VyQ2FzZSgpXTtcbn07XG5cbi8qKlxuICogR2V0IGNhc2UtaW5zZW5zaXRpdmUgaGVhZGVyIGBmaWVsZGAgdmFsdWUuXG4gKiBUaGlzIGlzIGEgZGVwcmVjYXRlZCBpbnRlcm5hbCBBUEkuIFVzZSBgLmdldChmaWVsZClgIGluc3RlYWQuXG4gKlxuICogKGdldEhlYWRlciBpcyBubyBsb25nZXIgdXNlZCBpbnRlcm5hbGx5IGJ5IHRoZSBzdXBlcmFnZW50IGNvZGUgYmFzZSlcbiAqXG4gKiBAcGFyYW0ge1N0cmluZ30gZmllbGRcbiAqIEByZXR1cm4ge1N0cmluZ31cbiAqIEBhcGkgcHJpdmF0ZVxuICogQGRlcHJlY2F0ZWRcbiAqL1xuXG5SZXF1ZXN0QmFzZS5wcm90b3R5cGUuZ2V0SGVhZGVyID0gUmVxdWVzdEJhc2UucHJvdG90eXBlLmdldDtcblxuLyoqXG4gKiBTZXQgaGVhZGVyIGBmaWVsZGAgdG8gYHZhbGAsIG9yIG11bHRpcGxlIGZpZWxkcyB3aXRoIG9uZSBvYmplY3QuXG4gKiBDYXNlLWluc2Vuc2l0aXZlLlxuICpcbiAqIEV4YW1wbGVzOlxuICpcbiAqICAgICAgcmVxLmdldCgnLycpXG4gKiAgICAgICAgLnNldCgnQWNjZXB0JywgJ2FwcGxpY2F0aW9uL2pzb24nKVxuICogICAgICAgIC5zZXQoJ1gtQVBJLUtleScsICdmb29iYXInKVxuICogICAgICAgIC5lbmQoY2FsbGJhY2spO1xuICpcbiAqICAgICAgcmVxLmdldCgnLycpXG4gKiAgICAgICAgLnNldCh7IEFjY2VwdDogJ2FwcGxpY2F0aW9uL2pzb24nLCAnWC1BUEktS2V5JzogJ2Zvb2JhcicgfSlcbiAqICAgICAgICAuZW5kKGNhbGxiYWNrKTtcbiAqXG4gKiBAcGFyYW0ge1N0cmluZ3xPYmplY3R9IGZpZWxkXG4gKiBAcGFyYW0ge1N0cmluZ30gdmFsXG4gKiBAcmV0dXJuIHtSZXF1ZXN0fSBmb3IgY2hhaW5pbmdcbiAqIEBhcGkgcHVibGljXG4gKi9cblxuUmVxdWVzdEJhc2UucHJvdG90eXBlLnNldCA9IGZ1bmN0aW9uIChmaWVsZCwgdmFsdWUpIHtcbiAgaWYgKGlzT2JqZWN0KGZpZWxkKSkge1xuICAgIGZvciAoY29uc3Qga2V5IGluIGZpZWxkKSB7XG4gICAgICBpZiAoaGFzT3duKGZpZWxkLCBrZXkpKSB0aGlzLnNldChrZXksIGZpZWxkW2tleV0pO1xuICAgIH1cblxuICAgIHJldHVybiB0aGlzO1xuICB9XG5cbiAgdGhpcy5faGVhZGVyW2ZpZWxkLnRvTG93ZXJDYXNlKCldID0gdmFsdWU7XG4gIHRoaXMuaGVhZGVyW2ZpZWxkXSA9IHZhbHVlO1xuICByZXR1cm4gdGhpcztcbn07XG5cbi8qKlxuICogUmVtb3ZlIGhlYWRlciBgZmllbGRgLlxuICogQ2FzZS1pbnNlbnNpdGl2ZS5cbiAqXG4gKiBFeGFtcGxlOlxuICpcbiAqICAgICAgcmVxLmdldCgnLycpXG4gKiAgICAgICAgLnVuc2V0KCdVc2VyLUFnZW50JylcbiAqICAgICAgICAuZW5kKGNhbGxiYWNrKTtcbiAqXG4gKiBAcGFyYW0ge1N0cmluZ30gZmllbGQgZmllbGQgbmFtZVxuICovXG5SZXF1ZXN0QmFzZS5wcm90b3R5cGUudW5zZXQgPSBmdW5jdGlvbiAoZmllbGQpIHtcbiAgZGVsZXRlIHRoaXMuX2hlYWRlcltmaWVsZC50b0xvd2VyQ2FzZSgpXTtcbiAgZGVsZXRlIHRoaXMuaGVhZGVyW2ZpZWxkXTtcbiAgcmV0dXJuIHRoaXM7XG59O1xuXG4vKipcbiAqIFdyaXRlIHRoZSBmaWVsZCBgbmFtZWAgYW5kIGB2YWxgLCBvciBtdWx0aXBsZSBmaWVsZHMgd2l0aCBvbmUgb2JqZWN0XG4gKiBmb3IgXCJtdWx0aXBhcnQvZm9ybS1kYXRhXCIgcmVxdWVzdCBib2RpZXMuXG4gKlxuICogYGBgIGpzXG4gKiByZXF1ZXN0LnBvc3QoJy91cGxvYWQnKVxuICogICAuZmllbGQoJ2ZvbycsICdiYXInKVxuICogICAuZW5kKGNhbGxiYWNrKTtcbiAqXG4gKiByZXF1ZXN0LnBvc3QoJy91cGxvYWQnKVxuICogICAuZmllbGQoeyBmb286ICdiYXInLCBiYXo6ICdxdXgnIH0pXG4gKiAgIC5lbmQoY2FsbGJhY2spO1xuICogYGBgXG4gKlxuICogQHBhcmFtIHtTdHJpbmd8T2JqZWN0fSBuYW1lIG5hbWUgb2YgZmllbGRcbiAqIEBwYXJhbSB7U3RyaW5nfEJsb2J8RmlsZXxCdWZmZXJ8ZnMuUmVhZFN0cmVhbX0gdmFsIHZhbHVlIG9mIGZpZWxkXG4gKiBAcGFyYW0ge1N0cmluZ30gb3B0aW9ucyBleHRyYSBvcHRpb25zLCBlLmcuICdibG9iJ1xuICogQHJldHVybiB7UmVxdWVzdH0gZm9yIGNoYWluaW5nXG4gKiBAYXBpIHB1YmxpY1xuICovXG5SZXF1ZXN0QmFzZS5wcm90b3R5cGUuZmllbGQgPSBmdW5jdGlvbiAobmFtZSwgdmFsdWUsIG9wdGlvbnMpIHtcbiAgLy8gbmFtZSBzaG91bGQgYmUgZWl0aGVyIGEgc3RyaW5nIG9yIGFuIG9iamVjdC5cbiAgaWYgKG5hbWUgPT09IG51bGwgfHwgdW5kZWZpbmVkID09PSBuYW1lKSB7XG4gICAgdGhyb3cgbmV3IEVycm9yKCcuZmllbGQobmFtZSwgdmFsKSBuYW1lIGNhbiBub3QgYmUgZW1wdHknKTtcbiAgfVxuXG4gIGlmICh0aGlzLl9kYXRhKSB7XG4gICAgdGhyb3cgbmV3IEVycm9yKFxuICAgICAgXCIuZmllbGQoKSBjYW4ndCBiZSB1c2VkIGlmIC5zZW5kKCkgaXMgdXNlZC4gUGxlYXNlIHVzZSBvbmx5IC5zZW5kKCkgb3Igb25seSAuZmllbGQoKSAmIC5hdHRhY2goKVwiXG4gICAgKTtcbiAgfVxuXG4gIGlmIChpc09iamVjdChuYW1lKSkge1xuICAgIGZvciAoY29uc3Qga2V5IGluIG5hbWUpIHtcbiAgICAgIGlmIChoYXNPd24obmFtZSwga2V5KSkgdGhpcy5maWVsZChrZXksIG5hbWVba2V5XSk7XG4gICAgfVxuXG4gICAgcmV0dXJuIHRoaXM7XG4gIH1cblxuICBpZiAoQXJyYXkuaXNBcnJheSh2YWx1ZSkpIHtcbiAgICBmb3IgKGNvbnN0IGkgaW4gdmFsdWUpIHtcbiAgICAgIGlmIChoYXNPd24odmFsdWUsIGkpKSB0aGlzLmZpZWxkKG5hbWUsIHZhbHVlW2ldKTtcbiAgICB9XG5cbiAgICByZXR1cm4gdGhpcztcbiAgfVxuXG4gIC8vIHZhbCBzaG91bGQgYmUgZGVmaW5lZCBub3dcbiAgaWYgKHZhbHVlID09PSBudWxsIHx8IHVuZGVmaW5lZCA9PT0gdmFsdWUpIHtcbiAgICB0aHJvdyBuZXcgRXJyb3IoJy5maWVsZChuYW1lLCB2YWwpIHZhbCBjYW4gbm90IGJlIGVtcHR5Jyk7XG4gIH1cblxuICBpZiAodHlwZW9mIHZhbHVlID09PSAnYm9vbGVhbicpIHtcbiAgICB2YWx1ZSA9IFN0cmluZyh2YWx1ZSk7XG4gIH1cblxuICAvLyBmaXggaHR0cHM6Ly9naXRodWIuY29tL2xhZGpzL3N1cGVyYWdlbnQvaXNzdWVzLzE2ODBcbiAgaWYgKG9wdGlvbnMpIHRoaXMuX2dldEZvcm1EYXRhKCkuYXBwZW5kKG5hbWUsIHZhbHVlLCBvcHRpb25zKTtcbiAgZWxzZSB0aGlzLl9nZXRGb3JtRGF0YSgpLmFwcGVuZChuYW1lLCB2YWx1ZSk7XG5cbiAgcmV0dXJuIHRoaXM7XG59O1xuXG4vKipcbiAqIEFib3J0IHRoZSByZXF1ZXN0LCBhbmQgY2xlYXIgcG90ZW50aWFsIHRpbWVvdXQuXG4gKlxuICogQHJldHVybiB7UmVxdWVzdH0gcmVxdWVzdFxuICogQGFwaSBwdWJsaWNcbiAqL1xuUmVxdWVzdEJhc2UucHJvdG90eXBlLmFib3J0ID0gZnVuY3Rpb24gKCkge1xuICBpZiAodGhpcy5fYWJvcnRlZCkge1xuICAgIHJldHVybiB0aGlzO1xuICB9XG5cbiAgdGhpcy5fYWJvcnRlZCA9IHRydWU7XG4gIGlmICh0aGlzLnhocikgdGhpcy54aHIuYWJvcnQoKTsgLy8gYnJvd3NlclxuICBpZiAodGhpcy5yZXEpIHtcbiAgICAvLyBOb2RlIHYxMyBoYXMgbWFqb3IgZGlmZmVyZW5jZXMgaW4gYGFib3J0KClgXG4gICAgLy8gaHR0cHM6Ly9naXRodWIuY29tL25vZGVqcy9ub2RlL2Jsb2IvdjEyLngvbGliL2ludGVybmFsL3N0cmVhbXMvZW5kLW9mLXN0cmVhbS5qc1xuICAgIC8vIGh0dHBzOi8vZ2l0aHViLmNvbS9ub2RlanMvbm9kZS9ibG9iL3YxMy54L2xpYi9pbnRlcm5hbC9zdHJlYW1zL2VuZC1vZi1zdHJlYW0uanNcbiAgICAvLyBodHRwczovL2dpdGh1Yi5jb20vbm9kZWpzL25vZGUvYmxvYi92MTQueC9saWIvaW50ZXJuYWwvc3RyZWFtcy9lbmQtb2Ytc3RyZWFtLmpzXG4gICAgLy8gKGlmIHlvdSBydW4gYSBkaWZmIGFjcm9zcyB0aGVzZSB5b3Ugd2lsbCBzZWUgdGhlIGRpZmZlcmVuY2VzKVxuICAgIC8vXG4gICAgLy8gUmVmZXJlbmNlczpcbiAgICAvLyA8aHR0cHM6Ly9naXRodWIuY29tL25vZGVqcy9ub2RlL2lzc3Vlcy8zMTYzMD5cbiAgICAvLyA8aHR0cHM6Ly9naXRodWIuY29tL2xhZGpzL3N1cGVyYWdlbnQvcHVsbC8xMDg0L2NvbW1pdHMvZGMxODY3OWE3YzVjY2ZjNjA0NmQ4ODIwMTVlNTEyNjg4ODk3M2JjOD5cbiAgICAvL1xuICAgIC8vIFRoYW5rcyB0byBAc2hhZG93Z2F0ZTE1IGFuZCBAbmlmdHlsZXR0dWNlXG4gICAgaWYgKFxuICAgICAgc2VtdmVyLmd0ZShwcm9jZXNzLnZlcnNpb24sICd2MTMuMC4wJykgJiZcbiAgICAgIHNlbXZlci5sdChwcm9jZXNzLnZlcnNpb24sICd2MTQuMC4wJylcbiAgICApIHtcbiAgICAgIC8vIE5vdGUgdGhhdCB0aGUgcmVhc29uIHRoaXMgZG9lc24ndCB3b3JrIGlzIGJlY2F1c2UgaW4gdjEzIGFzIGNvbXBhcmVkIHRvIHYxNFxuICAgICAgLy8gdGhlcmUgaXMgbm8gYGNhbGxiYWNrID0gbm9wYCBzZXQgaW4gZW5kLW9mLXN0cmVhbS5qcyBhYm92ZVxuICAgICAgdGhyb3cgbmV3IEVycm9yKFxuICAgICAgICAnU3VwZXJhZ2VudCBkb2VzIG5vdCB3b3JrIGluIHYxMyBwcm9wZXJseSB3aXRoIGFib3J0KCkgZHVlIHRvIE5vZGUuanMgY29yZSBjaGFuZ2VzJ1xuICAgICAgKTtcbiAgICB9IGVsc2UgaWYgKHNlbXZlci5ndGUocHJvY2Vzcy52ZXJzaW9uLCAndjE0LjAuMCcpKSB7XG4gICAgICAvLyBXZSBoYXZlIHRvIG1hbnVhbGx5IHNldCBgZGVzdHJveWVkYCB0byBgdHJ1ZWAgaW4gb3JkZXIgZm9yIHRoaXMgdG8gd29ya1xuICAgICAgLy8gKHNlZSBjb3JlIGludGVybmFscyBvZiBlbmQtb2Ytc3RyZWFtLmpzIGFib3ZlIGluIHYxNCBicmFuY2ggYXMgY29tcGFyZWQgdG8gdjEyKVxuICAgICAgdGhpcy5yZXEuZGVzdHJveWVkID0gdHJ1ZTtcbiAgICB9XG5cbiAgICB0aGlzLnJlcS5hYm9ydCgpOyAvLyBub2RlXG4gIH1cblxuICB0aGlzLmNsZWFyVGltZW91dCgpO1xuICB0aGlzLmVtaXQoJ2Fib3J0Jyk7XG4gIHJldHVybiB0aGlzO1xufTtcblxuUmVxdWVzdEJhc2UucHJvdG90eXBlLl9hdXRoID0gZnVuY3Rpb24gKHVzZXIsIHBhc3MsIG9wdGlvbnMsIGJhc2U2NEVuY29kZXIpIHtcbiAgc3dpdGNoIChvcHRpb25zLnR5cGUpIHtcbiAgICBjYXNlICdiYXNpYyc6XG4gICAgICB0aGlzLnNldCgnQXV0aG9yaXphdGlvbicsIGBCYXNpYyAke2Jhc2U2NEVuY29kZXIoYCR7dXNlcn06JHtwYXNzfWApfWApO1xuICAgICAgYnJlYWs7XG5cbiAgICBjYXNlICdhdXRvJzpcbiAgICAgIHRoaXMudXNlcm5hbWUgPSB1c2VyO1xuICAgICAgdGhpcy5wYXNzd29yZCA9IHBhc3M7XG4gICAgICBicmVhaztcblxuICAgIGNhc2UgJ2JlYXJlcic6IC8vIHVzYWdlIHdvdWxkIGJlIC5hdXRoKGFjY2Vzc1Rva2VuLCB7IHR5cGU6ICdiZWFyZXInIH0pXG4gICAgICB0aGlzLnNldCgnQXV0aG9yaXphdGlvbicsIGBCZWFyZXIgJHt1c2VyfWApO1xuICAgICAgYnJlYWs7XG4gICAgZGVmYXVsdDpcbiAgICAgIGJyZWFrO1xuICB9XG5cbiAgcmV0dXJuIHRoaXM7XG59O1xuXG4vKipcbiAqIEVuYWJsZSB0cmFuc21pc3Npb24gb2YgY29va2llcyB3aXRoIHgtZG9tYWluIHJlcXVlc3RzLlxuICpcbiAqIE5vdGUgdGhhdCBmb3IgdGhpcyB0byB3b3JrIHRoZSBvcmlnaW4gbXVzdCBub3QgYmVcbiAqIHVzaW5nIFwiQWNjZXNzLUNvbnRyb2wtQWxsb3ctT3JpZ2luXCIgd2l0aCBhIHdpbGRjYXJkLFxuICogYW5kIGFsc28gbXVzdCBzZXQgXCJBY2Nlc3MtQ29udHJvbC1BbGxvdy1DcmVkZW50aWFsc1wiXG4gKiB0byBcInRydWVcIi5cbiAqIEBwYXJhbSB7Qm9vbGVhbn0gW29uPXRydWVdIC0gU2V0ICd3aXRoQ3JlZGVudGlhbHMnIHN0YXRlXG4gKiBAcmV0dXJuIHtSZXF1ZXN0fSBmb3IgY2hhaW5pbmdcbiAqIEBhcGkgcHVibGljXG4gKi9cblxuUmVxdWVzdEJhc2UucHJvdG90eXBlLndpdGhDcmVkZW50aWFscyA9IGZ1bmN0aW9uIChvbikge1xuICAvLyBUaGlzIGlzIGJyb3dzZXItb25seSBmdW5jdGlvbmFsaXR5LiBOb2RlIHNpZGUgaXMgbm8tb3AuXG4gIGlmIChvbiA9PT0gdW5kZWZpbmVkKSBvbiA9IHRydWU7XG4gIHRoaXMuX3dpdGhDcmVkZW50aWFscyA9IG9uO1xuICByZXR1cm4gdGhpcztcbn07XG5cbi8qKlxuICogU2V0IHRoZSBtYXggcmVkaXJlY3RzIHRvIGBuYC4gRG9lcyBub3RoaW5nIGluIGJyb3dzZXIgWEhSIGltcGxlbWVudGF0aW9uLlxuICpcbiAqIEBwYXJhbSB7TnVtYmVyfSBuXG4gKiBAcmV0dXJuIHtSZXF1ZXN0fSBmb3IgY2hhaW5pbmdcbiAqIEBhcGkgcHVibGljXG4gKi9cblxuUmVxdWVzdEJhc2UucHJvdG90eXBlLnJlZGlyZWN0cyA9IGZ1bmN0aW9uIChuKSB7XG4gIHRoaXMuX21heFJlZGlyZWN0cyA9IG47XG4gIHJldHVybiB0aGlzO1xufTtcblxuLyoqXG4gKiBNYXhpbXVtIHNpemUgb2YgYnVmZmVyZWQgcmVzcG9uc2UgYm9keSwgaW4gYnl0ZXMuIENvdW50cyB1bmNvbXByZXNzZWQgc2l6ZS5cbiAqIERlZmF1bHQgMjAwTUIuXG4gKlxuICogQHBhcmFtIHtOdW1iZXJ9IG4gbnVtYmVyIG9mIGJ5dGVzXG4gKiBAcmV0dXJuIHtSZXF1ZXN0fSBmb3IgY2hhaW5pbmdcbiAqL1xuUmVxdWVzdEJhc2UucHJvdG90eXBlLm1heFJlc3BvbnNlU2l6ZSA9IGZ1bmN0aW9uIChuKSB7XG4gIGlmICh0eXBlb2YgbiAhPT0gJ251bWJlcicpIHtcbiAgICB0aHJvdyBuZXcgVHlwZUVycm9yKCdJbnZhbGlkIGFyZ3VtZW50Jyk7XG4gIH1cblxuICB0aGlzLl9tYXhSZXNwb25zZVNpemUgPSBuO1xuICByZXR1cm4gdGhpcztcbn07XG5cbi8qKlxuICogQ29udmVydCB0byBhIHBsYWluIGphdmFzY3JpcHQgb2JqZWN0IChub3QgSlNPTiBzdHJpbmcpIG9mIHNjYWxhciBwcm9wZXJ0aWVzLlxuICogTm90ZSBhcyB0aGlzIG1ldGhvZCBpcyBkZXNpZ25lZCB0byByZXR1cm4gYSB1c2VmdWwgbm9uLXRoaXMgdmFsdWUsXG4gKiBpdCBjYW5ub3QgYmUgY2hhaW5lZC5cbiAqXG4gKiBAcmV0dXJuIHtPYmplY3R9IGRlc2NyaWJpbmcgbWV0aG9kLCB1cmwsIGFuZCBkYXRhIG9mIHRoaXMgcmVxdWVzdFxuICogQGFwaSBwdWJsaWNcbiAqL1xuXG5SZXF1ZXN0QmFzZS5wcm90b3R5cGUudG9KU09OID0gZnVuY3Rpb24gKCkge1xuICByZXR1cm4ge1xuICAgIG1ldGhvZDogdGhpcy5tZXRob2QsXG4gICAgdXJsOiB0aGlzLnVybCxcbiAgICBkYXRhOiB0aGlzLl9kYXRhLFxuICAgIGhlYWRlcnM6IHRoaXMuX2hlYWRlclxuICB9O1xufTtcblxuLyoqXG4gKiBTZW5kIGBkYXRhYCBhcyB0aGUgcmVxdWVzdCBib2R5LCBkZWZhdWx0aW5nIHRoZSBgLnR5cGUoKWAgdG8gXCJqc29uXCIgd2hlblxuICogYW4gb2JqZWN0IGlzIGdpdmVuLlxuICpcbiAqIEV4YW1wbGVzOlxuICpcbiAqICAgICAgIC8vIG1hbnVhbCBqc29uXG4gKiAgICAgICByZXF1ZXN0LnBvc3QoJy91c2VyJylcbiAqICAgICAgICAgLnR5cGUoJ2pzb24nKVxuICogICAgICAgICAuc2VuZCgne1wibmFtZVwiOlwidGpcIn0nKVxuICogICAgICAgICAuZW5kKGNhbGxiYWNrKVxuICpcbiAqICAgICAgIC8vIGF1dG8ganNvblxuICogICAgICAgcmVxdWVzdC5wb3N0KCcvdXNlcicpXG4gKiAgICAgICAgIC5zZW5kKHsgbmFtZTogJ3RqJyB9KVxuICogICAgICAgICAuZW5kKGNhbGxiYWNrKVxuICpcbiAqICAgICAgIC8vIG1hbnVhbCB4LXd3dy1mb3JtLXVybGVuY29kZWRcbiAqICAgICAgIHJlcXVlc3QucG9zdCgnL3VzZXInKVxuICogICAgICAgICAudHlwZSgnZm9ybScpXG4gKiAgICAgICAgIC5zZW5kKCduYW1lPXRqJylcbiAqICAgICAgICAgLmVuZChjYWxsYmFjaylcbiAqXG4gKiAgICAgICAvLyBhdXRvIHgtd3d3LWZvcm0tdXJsZW5jb2RlZFxuICogICAgICAgcmVxdWVzdC5wb3N0KCcvdXNlcicpXG4gKiAgICAgICAgIC50eXBlKCdmb3JtJylcbiAqICAgICAgICAgLnNlbmQoeyBuYW1lOiAndGonIH0pXG4gKiAgICAgICAgIC5lbmQoY2FsbGJhY2spXG4gKlxuICogICAgICAgLy8gZGVmYXVsdHMgdG8geC13d3ctZm9ybS11cmxlbmNvZGVkXG4gKiAgICAgIHJlcXVlc3QucG9zdCgnL3VzZXInKVxuICogICAgICAgIC5zZW5kKCduYW1lPXRvYmknKVxuICogICAgICAgIC5zZW5kKCdzcGVjaWVzPWZlcnJldCcpXG4gKiAgICAgICAgLmVuZChjYWxsYmFjaylcbiAqXG4gKiBAcGFyYW0ge1N0cmluZ3xPYmplY3R9IGRhdGFcbiAqIEByZXR1cm4ge1JlcXVlc3R9IGZvciBjaGFpbmluZ1xuICogQGFwaSBwdWJsaWNcbiAqL1xuXG4vLyBlc2xpbnQtZGlzYWJsZS1uZXh0LWxpbmUgY29tcGxleGl0eVxuUmVxdWVzdEJhc2UucHJvdG90eXBlLnNlbmQgPSBmdW5jdGlvbiAoZGF0YSkge1xuICBjb25zdCBpc09iamVjdF8gPSBpc09iamVjdChkYXRhKTtcbiAgbGV0IHR5cGUgPSB0aGlzLl9oZWFkZXJbJ2NvbnRlbnQtdHlwZSddO1xuXG4gIGlmICh0aGlzLl9mb3JtRGF0YSkge1xuICAgIHRocm93IG5ldyBFcnJvcihcbiAgICAgIFwiLnNlbmQoKSBjYW4ndCBiZSB1c2VkIGlmIC5hdHRhY2goKSBvciAuZmllbGQoKSBpcyB1c2VkLiBQbGVhc2UgdXNlIG9ubHkgLnNlbmQoKSBvciBvbmx5IC5maWVsZCgpICYgLmF0dGFjaCgpXCJcbiAgICApO1xuICB9XG5cbiAgaWYgKGlzT2JqZWN0XyAmJiAhdGhpcy5fZGF0YSkge1xuICAgIGlmIChBcnJheS5pc0FycmF5KGRhdGEpKSB7XG4gICAgICB0aGlzLl9kYXRhID0gW107XG4gICAgfSBlbHNlIGlmICghdGhpcy5faXNIb3N0KGRhdGEpKSB7XG4gICAgICB0aGlzLl9kYXRhID0ge307XG4gICAgfVxuICB9IGVsc2UgaWYgKGRhdGEgJiYgdGhpcy5fZGF0YSAmJiB0aGlzLl9pc0hvc3QodGhpcy5fZGF0YSkpIHtcbiAgICB0aHJvdyBuZXcgRXJyb3IoXCJDYW4ndCBtZXJnZSB0aGVzZSBzZW5kIGNhbGxzXCIpO1xuICB9XG5cbiAgLy8gbWVyZ2VcbiAgaWYgKGlzT2JqZWN0XyAmJiBpc09iamVjdCh0aGlzLl9kYXRhKSkge1xuICAgIGZvciAoY29uc3Qga2V5IGluIGRhdGEpIHtcbiAgICAgIGlmIChoYXNPd24oZGF0YSwga2V5KSkgdGhpcy5fZGF0YVtrZXldID0gZGF0YVtrZXldO1xuICAgIH1cbiAgfSBlbHNlIGlmICh0eXBlb2YgZGF0YSA9PT0gJ3N0cmluZycpIHtcbiAgICAvLyBkZWZhdWx0IHRvIHgtd3d3LWZvcm0tdXJsZW5jb2RlZFxuICAgIGlmICghdHlwZSkgdGhpcy50eXBlKCdmb3JtJyk7XG4gICAgdHlwZSA9IHRoaXMuX2hlYWRlclsnY29udGVudC10eXBlJ107XG4gICAgaWYgKHR5cGUpIHR5cGUgPSB0eXBlLnRvTG93ZXJDYXNlKCkudHJpbSgpO1xuICAgIGlmICh0eXBlID09PSAnYXBwbGljYXRpb24veC13d3ctZm9ybS11cmxlbmNvZGVkJykge1xuICAgICAgdGhpcy5fZGF0YSA9IHRoaXMuX2RhdGEgPyBgJHt0aGlzLl9kYXRhfSYke2RhdGF9YCA6IGRhdGE7XG4gICAgfSBlbHNlIHtcbiAgICAgIHRoaXMuX2RhdGEgPSAodGhpcy5fZGF0YSB8fCAnJykgKyBkYXRhO1xuICAgIH1cbiAgfSBlbHNlIHtcbiAgICB0aGlzLl9kYXRhID0gZGF0YTtcbiAgfVxuXG4gIGlmICghaXNPYmplY3RfIHx8IHRoaXMuX2lzSG9zdChkYXRhKSkge1xuICAgIHJldHVybiB0aGlzO1xuICB9XG5cbiAgLy8gZGVmYXVsdCB0byBqc29uXG4gIGlmICghdHlwZSkgdGhpcy50eXBlKCdqc29uJyk7XG4gIHJldHVybiB0aGlzO1xufTtcblxuLyoqXG4gKiBTb3J0IGBxdWVyeXN0cmluZ2AgYnkgdGhlIHNvcnQgZnVuY3Rpb25cbiAqXG4gKlxuICogRXhhbXBsZXM6XG4gKlxuICogICAgICAgLy8gZGVmYXVsdCBvcmRlclxuICogICAgICAgcmVxdWVzdC5nZXQoJy91c2VyJylcbiAqICAgICAgICAgLnF1ZXJ5KCduYW1lPU5pY2snKVxuICogICAgICAgICAucXVlcnkoJ3NlYXJjaD1NYW5ueScpXG4gKiAgICAgICAgIC5zb3J0UXVlcnkoKVxuICogICAgICAgICAuZW5kKGNhbGxiYWNrKVxuICpcbiAqICAgICAgIC8vIGN1c3RvbWl6ZWQgc29ydCBmdW5jdGlvblxuICogICAgICAgcmVxdWVzdC5nZXQoJy91c2VyJylcbiAqICAgICAgICAgLnF1ZXJ5KCduYW1lPU5pY2snKVxuICogICAgICAgICAucXVlcnkoJ3NlYXJjaD1NYW5ueScpXG4gKiAgICAgICAgIC5zb3J0UXVlcnkoZnVuY3Rpb24oYSwgYil7XG4gKiAgICAgICAgICAgcmV0dXJuIGEubGVuZ3RoIC0gYi5sZW5ndGg7XG4gKiAgICAgICAgIH0pXG4gKiAgICAgICAgIC5lbmQoY2FsbGJhY2spXG4gKlxuICpcbiAqIEBwYXJhbSB7RnVuY3Rpb259IHNvcnRcbiAqIEByZXR1cm4ge1JlcXVlc3R9IGZvciBjaGFpbmluZ1xuICogQGFwaSBwdWJsaWNcbiAqL1xuXG5SZXF1ZXN0QmFzZS5wcm90b3R5cGUuc29ydFF1ZXJ5ID0gZnVuY3Rpb24gKHNvcnQpIHtcbiAgLy8gX3NvcnQgZGVmYXVsdCB0byB0cnVlIGJ1dCBvdGhlcndpc2UgY2FuIGJlIGEgZnVuY3Rpb24gb3IgYm9vbGVhblxuICB0aGlzLl9zb3J0ID0gdHlwZW9mIHNvcnQgPT09ICd1bmRlZmluZWQnID8gdHJ1ZSA6IHNvcnQ7XG4gIHJldHVybiB0aGlzO1xufTtcblxuLyoqXG4gKiBDb21wb3NlIHF1ZXJ5c3RyaW5nIHRvIGFwcGVuZCB0byByZXEudXJsXG4gKlxuICogQGFwaSBwcml2YXRlXG4gKi9cblJlcXVlc3RCYXNlLnByb3RvdHlwZS5fZmluYWxpemVRdWVyeVN0cmluZyA9IGZ1bmN0aW9uICgpIHtcbiAgY29uc3QgcXVlcnkgPSB0aGlzLl9xdWVyeS5qb2luKCcmJyk7XG4gIGlmIChxdWVyeSkge1xuICAgIHRoaXMudXJsICs9ICh0aGlzLnVybC5pbmNsdWRlcygnPycpID8gJyYnIDogJz8nKSArIHF1ZXJ5O1xuICB9XG5cbiAgdGhpcy5fcXVlcnkubGVuZ3RoID0gMDsgLy8gTWFrZXMgdGhlIGNhbGwgaWRlbXBvdGVudFxuXG4gIGlmICh0aGlzLl9zb3J0KSB7XG4gICAgY29uc3QgaW5kZXggPSB0aGlzLnVybC5pbmRleE9mKCc/Jyk7XG4gICAgaWYgKGluZGV4ID49IDApIHtcbiAgICAgIGNvbnN0IHF1ZXJ5QXJyYXkgPSB0aGlzLnVybC5zbGljZShpbmRleCArIDEpLnNwbGl0KCcmJyk7XG4gICAgICBpZiAodHlwZW9mIHRoaXMuX3NvcnQgPT09ICdmdW5jdGlvbicpIHtcbiAgICAgICAgcXVlcnlBcnJheS5zb3J0KHRoaXMuX3NvcnQpO1xuICAgICAgfSBlbHNlIHtcbiAgICAgICAgcXVlcnlBcnJheS5zb3J0KCk7XG4gICAgICB9XG5cbiAgICAgIHRoaXMudXJsID0gdGhpcy51cmwuc2xpY2UoMCwgaW5kZXgpICsgJz8nICsgcXVlcnlBcnJheS5qb2luKCcmJyk7XG4gICAgfVxuICB9XG59O1xuXG4vLyBGb3IgYmFja3dhcmRzIGNvbXBhdCBvbmx5XG5SZXF1ZXN0QmFzZS5wcm90b3R5cGUuX2FwcGVuZFF1ZXJ5U3RyaW5nID0gKCkgPT4ge1xuICBjb25zb2xlLndhcm4oJ1Vuc3VwcG9ydGVkJyk7XG59O1xuXG4vKipcbiAqIEludm9rZSBjYWxsYmFjayB3aXRoIHRpbWVvdXQgZXJyb3IuXG4gKlxuICogQGFwaSBwcml2YXRlXG4gKi9cblxuUmVxdWVzdEJhc2UucHJvdG90eXBlLl90aW1lb3V0RXJyb3IgPSBmdW5jdGlvbiAocmVhc29uLCB0aW1lb3V0LCBlcnJubykge1xuICBpZiAodGhpcy5fYWJvcnRlZCkge1xuICAgIHJldHVybjtcbiAgfVxuXG4gIGNvbnN0IGVycm9yID0gbmV3IEVycm9yKGAke3JlYXNvbiArIHRpbWVvdXR9bXMgZXhjZWVkZWRgKTtcbiAgZXJyb3IudGltZW91dCA9IHRpbWVvdXQ7XG4gIGVycm9yLmNvZGUgPSAnRUNPTk5BQk9SVEVEJztcbiAgZXJyb3IuZXJybm8gPSBlcnJubztcbiAgdGhpcy50aW1lZG91dCA9IHRydWU7XG4gIHRoaXMudGltZWRvdXRFcnJvciA9IGVycm9yO1xuICB0aGlzLmFib3J0KCk7XG4gIHRoaXMuY2FsbGJhY2soZXJyb3IpO1xufTtcblxuUmVxdWVzdEJhc2UucHJvdG90eXBlLl9zZXRUaW1lb3V0cyA9IGZ1bmN0aW9uICgpIHtcbiAgY29uc3Qgc2VsZiA9IHRoaXM7XG5cbiAgLy8gZGVhZGxpbmVcbiAgaWYgKHRoaXMuX3RpbWVvdXQgJiYgIXRoaXMuX3RpbWVyKSB7XG4gICAgdGhpcy5fdGltZXIgPSBzZXRUaW1lb3V0KCgpID0+IHtcbiAgICAgIHNlbGYuX3RpbWVvdXRFcnJvcignVGltZW91dCBvZiAnLCBzZWxmLl90aW1lb3V0LCAnRVRJTUUnKTtcbiAgICB9LCB0aGlzLl90aW1lb3V0KTtcbiAgfVxuXG4gIC8vIHJlc3BvbnNlIHRpbWVvdXRcbiAgaWYgKHRoaXMuX3Jlc3BvbnNlVGltZW91dCAmJiAhdGhpcy5fcmVzcG9uc2VUaW1lb3V0VGltZXIpIHtcbiAgICB0aGlzLl9yZXNwb25zZVRpbWVvdXRUaW1lciA9IHNldFRpbWVvdXQoKCkgPT4ge1xuICAgICAgc2VsZi5fdGltZW91dEVycm9yKFxuICAgICAgICAnUmVzcG9uc2UgdGltZW91dCBvZiAnLFxuICAgICAgICBzZWxmLl9yZXNwb25zZVRpbWVvdXQsXG4gICAgICAgICdFVElNRURPVVQnXG4gICAgICApO1xuICAgIH0sIHRoaXMuX3Jlc3BvbnNlVGltZW91dCk7XG4gIH1cbn07XG4iXSwibWFwcGluZ3MiOiI7O0FBQUEsTUFBTUEsTUFBTSxHQUFHQyxPQUFPLENBQUMsUUFBUSxDQUFDOztBQUVoQztBQUNBO0FBQ0E7QUFDQSxpQkFBNkJBLE9BQU8sQ0FBQyxTQUFTLENBQUM7RUFBdkNDLFFBQVEsWUFBUkEsUUFBUTtFQUFFQyxNQUFNLFlBQU5BLE1BQU07O0FBRXhCO0FBQ0E7QUFDQTs7QUFFQUMsTUFBTSxDQUFDQyxPQUFPLEdBQUdDLFdBQVc7O0FBRTVCO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7O0FBRUEsU0FBU0EsV0FBVyxHQUFHLENBQUM7O0FBRXhCO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTs7QUFFQUEsV0FBVyxDQUFDQyxTQUFTLENBQUNDLFlBQVksR0FBRyxZQUFZO0VBQy9DQSxZQUFZLENBQUMsSUFBSSxDQUFDQyxNQUFNLENBQUM7RUFDekJELFlBQVksQ0FBQyxJQUFJLENBQUNFLHFCQUFxQixDQUFDO0VBQ3hDRixZQUFZLENBQUMsSUFBSSxDQUFDRyxtQkFBbUIsQ0FBQztFQUN0QyxPQUFPLElBQUksQ0FBQ0YsTUFBTTtFQUNsQixPQUFPLElBQUksQ0FBQ0MscUJBQXFCO0VBQ2pDLE9BQU8sSUFBSSxDQUFDQyxtQkFBbUI7RUFDL0IsT0FBTyxJQUFJO0FBQ2IsQ0FBQzs7QUFFRDtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBOztBQUVBTCxXQUFXLENBQUNDLFNBQVMsQ0FBQ0ssS0FBSyxHQUFHLFVBQVVDLEVBQUUsRUFBRTtFQUMxQyxJQUFJLENBQUNDLE9BQU8sR0FBR0QsRUFBRTtFQUNqQixPQUFPLElBQUk7QUFDYixDQUFDOztBQUVEO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7O0FBRUFQLFdBQVcsQ0FBQ0MsU0FBUyxDQUFDUSxZQUFZLEdBQUcsVUFBVUMsS0FBSyxFQUFFO0VBQ3BELElBQUksQ0FBQ0MsYUFBYSxHQUFHRCxLQUFLO0VBQzFCLE9BQU8sSUFBSTtBQUNiLENBQUM7O0FBRUQ7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTs7QUFFQVYsV0FBVyxDQUFDQyxTQUFTLENBQUNXLFNBQVMsR0FBRyxVQUFVTCxFQUFFLEVBQUU7RUFDOUMsSUFBSSxDQUFDTSxXQUFXLEdBQUdOLEVBQUU7RUFDckIsT0FBTyxJQUFJO0FBQ2IsQ0FBQzs7QUFFRDtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTs7QUFFQVAsV0FBVyxDQUFDQyxTQUFTLENBQUNhLE9BQU8sR0FBRyxVQUFVQyxPQUFPLEVBQUU7RUFDakQsSUFBSSxDQUFDQSxPQUFPLElBQUksT0FBT0EsT0FBTyxLQUFLLFFBQVEsRUFBRTtJQUMzQyxJQUFJLENBQUNDLFFBQVEsR0FBR0QsT0FBTztJQUN2QixJQUFJLENBQUNFLGdCQUFnQixHQUFHLENBQUM7SUFDekIsSUFBSSxDQUFDQyxjQUFjLEdBQUcsQ0FBQztJQUN2QixPQUFPLElBQUk7RUFDYjtFQUVBLEtBQUssTUFBTUMsTUFBTSxJQUFJSixPQUFPLEVBQUU7SUFDNUIsSUFBSWxCLE1BQU0sQ0FBQ2tCLE9BQU8sRUFBRUksTUFBTSxDQUFDLEVBQUU7TUFDM0IsUUFBUUEsTUFBTTtRQUNaLEtBQUssVUFBVTtVQUNiLElBQUksQ0FBQ0gsUUFBUSxHQUFHRCxPQUFPLENBQUNLLFFBQVE7VUFDaEM7UUFDRixLQUFLLFVBQVU7VUFDYixJQUFJLENBQUNILGdCQUFnQixHQUFHRixPQUFPLENBQUNNLFFBQVE7VUFDeEM7UUFDRixLQUFLLFFBQVE7VUFDWCxJQUFJLENBQUNILGNBQWMsR0FBR0gsT0FBTyxDQUFDTyxNQUFNO1VBQ3BDO1FBQ0Y7VUFDRUMsT0FBTyxDQUFDQyxJQUFJLENBQUMsd0JBQXdCLEVBQUVMLE1BQU0sQ0FBQztNQUFDO0lBRXJEO0VBQ0Y7RUFFQSxPQUFPLElBQUk7QUFDYixDQUFDOztBQUVEO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBOztBQUVBbkIsV0FBVyxDQUFDQyxTQUFTLENBQUN3QixLQUFLLEdBQUcsVUFBVUMsS0FBSyxFQUFFbkIsRUFBRSxFQUFFO0VBQ2pEO0VBQ0EsSUFBSW9CLFNBQVMsQ0FBQ0MsTUFBTSxLQUFLLENBQUMsSUFBSUYsS0FBSyxLQUFLLElBQUksRUFBRUEsS0FBSyxHQUFHLENBQUM7RUFDdkQsSUFBSUEsS0FBSyxJQUFJLENBQUMsRUFBRUEsS0FBSyxHQUFHLENBQUM7RUFDekIsSUFBSSxDQUFDRyxXQUFXLEdBQUdILEtBQUs7RUFDeEIsSUFBSSxDQUFDSSxRQUFRLEdBQUcsQ0FBQztFQUNqQixJQUFJLENBQUNDLGNBQWMsR0FBR3hCLEVBQUU7RUFDeEIsT0FBTyxJQUFJO0FBQ2IsQ0FBQzs7QUFFRDtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0EsTUFBTXlCLFdBQVcsR0FBRyxJQUFJQyxHQUFHLENBQUMsQ0FDMUIsV0FBVyxFQUNYLFlBQVksRUFDWixZQUFZLEVBQ1osY0FBYyxFQUNkLE9BQU8sRUFDUCxXQUFXLEVBQ1gsYUFBYSxFQUNiLFdBQVcsQ0FDWixDQUFDO0FBRUYsTUFBTUMsWUFBWSxHQUFHLElBQUlELEdBQUcsQ0FBQyxDQUMzQixHQUFHLEVBQUUsR0FBRyxFQUFFLEdBQUcsRUFBRSxHQUFHLEVBQUUsR0FBRyxFQUFFLEdBQUcsRUFBRSxHQUFHLEVBQUUsR0FBRyxFQUFFLEdBQUcsRUFBRSxHQUFHLENBQ2pELENBQUM7O0FBRUY7QUFDQTs7QUFFQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0FqQyxXQUFXLENBQUNDLFNBQVMsQ0FBQ2tDLFlBQVksR0FBRyxVQUFVQyxLQUFLLEVBQUVDLEdBQUcsRUFBRTtFQUN6RCxJQUFJLENBQUMsSUFBSSxDQUFDUixXQUFXLElBQUksSUFBSSxDQUFDQyxRQUFRLEVBQUUsSUFBSSxJQUFJLENBQUNELFdBQVcsRUFBRTtJQUM1RCxPQUFPLEtBQUs7RUFDZDtFQUVBLElBQUksSUFBSSxDQUFDRSxjQUFjLEVBQUU7SUFDdkIsSUFBSTtNQUNGLE1BQU1PLFFBQVEsR0FBRyxJQUFJLENBQUNQLGNBQWMsQ0FBQ0ssS0FBSyxFQUFFQyxHQUFHLENBQUM7TUFDaEQsSUFBSUMsUUFBUSxLQUFLLElBQUksRUFBRSxPQUFPLElBQUk7TUFDbEMsSUFBSUEsUUFBUSxLQUFLLEtBQUssRUFBRSxPQUFPLEtBQUs7TUFDcEM7SUFDRixDQUFDLENBQUMsT0FBT0MsR0FBRyxFQUFFO01BQ1poQixPQUFPLENBQUNhLEtBQUssQ0FBQ0csR0FBRyxDQUFDO0lBQ3BCO0VBQ0Y7O0VBRUE7RUFDQTtBQUNGO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0VBQ0UsSUFBSUYsR0FBRyxJQUFJQSxHQUFHLENBQUNHLE1BQU0sSUFBSU4sWUFBWSxDQUFDTyxHQUFHLENBQUNKLEdBQUcsQ0FBQ0csTUFBTSxDQUFDLEVBQUUsT0FBTyxJQUFJO0VBQ2xFLElBQUlKLEtBQUssRUFBRTtJQUNULElBQUlBLEtBQUssQ0FBQ00sSUFBSSxJQUFJVixXQUFXLENBQUNTLEdBQUcsQ0FBQ0wsS0FBSyxDQUFDTSxJQUFJLENBQUMsRUFBRSxPQUFPLElBQUk7SUFDMUQ7SUFDQSxJQUFJTixLQUFLLENBQUN0QixPQUFPLElBQUlzQixLQUFLLENBQUNNLElBQUksS0FBSyxjQUFjLEVBQUUsT0FBTyxJQUFJO0lBQy9ELElBQUlOLEtBQUssQ0FBQ08sV0FBVyxFQUFFLE9BQU8sSUFBSTtFQUNwQztFQUVBLE9BQU8sS0FBSztBQUNkLENBQUM7O0FBRUQ7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBOztBQUVBM0MsV0FBVyxDQUFDQyxTQUFTLENBQUMyQyxNQUFNLEdBQUcsWUFBWTtFQUN6QyxJQUFJLENBQUMxQyxZQUFZLEVBQUU7O0VBRW5CO0VBQ0EsSUFBSSxJQUFJLENBQUMyQyxHQUFHLEVBQUU7SUFDWixJQUFJLENBQUNBLEdBQUcsR0FBRyxJQUFJO0lBQ2YsSUFBSSxDQUFDQSxHQUFHLEdBQUcsSUFBSSxDQUFDQyxPQUFPLEVBQUU7RUFDM0I7RUFFQSxJQUFJLENBQUNDLFFBQVEsR0FBRyxLQUFLO0VBQ3JCLElBQUksQ0FBQ0MsUUFBUSxHQUFHLEtBQUs7RUFDckIsSUFBSSxDQUFDQyxhQUFhLEdBQUcsSUFBSTtFQUV6QixPQUFPLElBQUksQ0FBQ0MsSUFBSSxFQUFFO0FBQ3BCLENBQUM7O0FBRUQ7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7O0FBRUFsRCxXQUFXLENBQUNDLFNBQVMsQ0FBQ2tELElBQUksR0FBRyxVQUFVQyxPQUFPLEVBQUVDLE1BQU0sRUFBRTtFQUN0RCxJQUFJLENBQUMsSUFBSSxDQUFDQyxrQkFBa0IsRUFBRTtJQUM1QixNQUFNQyxJQUFJLEdBQUcsSUFBSTtJQUNqQixJQUFJLElBQUksQ0FBQ0MsVUFBVSxFQUFFO01BQ25CakMsT0FBTyxDQUFDQyxJQUFJLENBQ1YsZ0lBQWdJLENBQ2pJO0lBQ0g7SUFFQSxJQUFJLENBQUM4QixrQkFBa0IsR0FBRyxJQUFJRyxPQUFPLENBQUMsQ0FBQ0wsT0FBTyxFQUFFQyxNQUFNLEtBQUs7TUFDekRFLElBQUksQ0FBQ0csRUFBRSxDQUFDLE9BQU8sRUFBRSxNQUFNO1FBQ3JCLElBQUksSUFBSSxDQUFDN0IsV0FBVyxJQUFJLElBQUksQ0FBQ0EsV0FBVyxHQUFHLElBQUksQ0FBQ0MsUUFBUSxFQUFFO1VBQ3hEO1FBQ0Y7UUFFQSxJQUFJLElBQUksQ0FBQ2tCLFFBQVEsSUFBSSxJQUFJLENBQUNDLGFBQWEsRUFBRTtVQUN2Q0ksTUFBTSxDQUFDLElBQUksQ0FBQ0osYUFBYSxDQUFDO1VBQzFCO1FBQ0Y7UUFFQSxNQUFNYixLQUFLLEdBQUcsSUFBSXVCLEtBQUssQ0FBQyxTQUFTLENBQUM7UUFDbEN2QixLQUFLLENBQUNNLElBQUksR0FBRyxTQUFTO1FBQ3RCTixLQUFLLENBQUNJLE1BQU0sR0FBRyxJQUFJLENBQUNBLE1BQU07UUFDMUJKLEtBQUssQ0FBQ3dCLE1BQU0sR0FBRyxJQUFJLENBQUNBLE1BQU07UUFDMUJ4QixLQUFLLENBQUN5QixHQUFHLEdBQUcsSUFBSSxDQUFDQSxHQUFHO1FBQ3BCUixNQUFNLENBQUNqQixLQUFLLENBQUM7TUFDZixDQUFDLENBQUM7TUFDRm1CLElBQUksQ0FBQ08sR0FBRyxDQUFDLENBQUMxQixLQUFLLEVBQUVDLEdBQUcsS0FBSztRQUN2QixJQUFJRCxLQUFLLEVBQUVpQixNQUFNLENBQUNqQixLQUFLLENBQUMsQ0FBQyxLQUNwQmdCLE9BQU8sQ0FBQ2YsR0FBRyxDQUFDO01BQ25CLENBQUMsQ0FBQztJQUNKLENBQUMsQ0FBQztFQUNKO0VBRUEsT0FBTyxJQUFJLENBQUNpQixrQkFBa0IsQ0FBQ0gsSUFBSSxDQUFDQyxPQUFPLEVBQUVDLE1BQU0sQ0FBQztBQUN0RCxDQUFDO0FBRURyRCxXQUFXLENBQUNDLFNBQVMsQ0FBQzhELEtBQUssR0FBRyxVQUFVQyxRQUFRLEVBQUU7RUFDaEQsT0FBTyxJQUFJLENBQUNiLElBQUksQ0FBQ2MsU0FBUyxFQUFFRCxRQUFRLENBQUM7QUFDdkMsQ0FBQzs7QUFFRDtBQUNBO0FBQ0E7O0FBRUFoRSxXQUFXLENBQUNDLFNBQVMsQ0FBQ2lFLEdBQUcsR0FBRyxVQUFVM0QsRUFBRSxFQUFFO0VBQ3hDQSxFQUFFLENBQUMsSUFBSSxDQUFDO0VBQ1IsT0FBTyxJQUFJO0FBQ2IsQ0FBQztBQUVEUCxXQUFXLENBQUNDLFNBQVMsQ0FBQ2tFLEVBQUUsR0FBRyxVQUFVSCxRQUFRLEVBQUU7RUFDN0MsSUFBSSxPQUFPQSxRQUFRLEtBQUssVUFBVSxFQUFFLE1BQU0sSUFBSUwsS0FBSyxDQUFDLG1CQUFtQixDQUFDO0VBQ3hFLElBQUksQ0FBQ1MsV0FBVyxHQUFHSixRQUFRO0VBQzNCLE9BQU8sSUFBSTtBQUNiLENBQUM7QUFFRGhFLFdBQVcsQ0FBQ0MsU0FBUyxDQUFDb0UsYUFBYSxHQUFHLFVBQVVoQyxHQUFHLEVBQUU7RUFDbkQsSUFBSSxDQUFDQSxHQUFHLEVBQUU7SUFDUixPQUFPLEtBQUs7RUFDZDtFQUVBLElBQUksSUFBSSxDQUFDK0IsV0FBVyxFQUFFO0lBQ3BCLE9BQU8sSUFBSSxDQUFDQSxXQUFXLENBQUMvQixHQUFHLENBQUM7RUFDOUI7RUFFQSxPQUFPQSxHQUFHLENBQUNHLE1BQU0sSUFBSSxHQUFHLElBQUlILEdBQUcsQ0FBQ0csTUFBTSxHQUFHLEdBQUc7QUFDOUMsQ0FBQzs7QUFFRDtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBOztBQUVBeEMsV0FBVyxDQUFDQyxTQUFTLENBQUNxRSxHQUFHLEdBQUcsVUFBVUMsS0FBSyxFQUFFO0VBQzNDLE9BQU8sSUFBSSxDQUFDQyxPQUFPLENBQUNELEtBQUssQ0FBQ0UsV0FBVyxFQUFFLENBQUM7QUFDMUMsQ0FBQzs7QUFFRDtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBOztBQUVBekUsV0FBVyxDQUFDQyxTQUFTLENBQUN5RSxTQUFTLEdBQUcxRSxXQUFXLENBQUNDLFNBQVMsQ0FBQ3FFLEdBQUc7O0FBRTNEO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7O0FBRUF0RSxXQUFXLENBQUNDLFNBQVMsQ0FBQzBFLEdBQUcsR0FBRyxVQUFVSixLQUFLLEVBQUU3RCxLQUFLLEVBQUU7RUFDbEQsSUFBSWQsUUFBUSxDQUFDMkUsS0FBSyxDQUFDLEVBQUU7SUFDbkIsS0FBSyxNQUFNSyxHQUFHLElBQUlMLEtBQUssRUFBRTtNQUN2QixJQUFJMUUsTUFBTSxDQUFDMEUsS0FBSyxFQUFFSyxHQUFHLENBQUMsRUFBRSxJQUFJLENBQUNELEdBQUcsQ0FBQ0MsR0FBRyxFQUFFTCxLQUFLLENBQUNLLEdBQUcsQ0FBQyxDQUFDO0lBQ25EO0lBRUEsT0FBTyxJQUFJO0VBQ2I7RUFFQSxJQUFJLENBQUNKLE9BQU8sQ0FBQ0QsS0FBSyxDQUFDRSxXQUFXLEVBQUUsQ0FBQyxHQUFHL0QsS0FBSztFQUN6QyxJQUFJLENBQUNtRSxNQUFNLENBQUNOLEtBQUssQ0FBQyxHQUFHN0QsS0FBSztFQUMxQixPQUFPLElBQUk7QUFDYixDQUFDOztBQUVEO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBVixXQUFXLENBQUNDLFNBQVMsQ0FBQzZFLEtBQUssR0FBRyxVQUFVUCxLQUFLLEVBQUU7RUFDN0MsT0FBTyxJQUFJLENBQUNDLE9BQU8sQ0FBQ0QsS0FBSyxDQUFDRSxXQUFXLEVBQUUsQ0FBQztFQUN4QyxPQUFPLElBQUksQ0FBQ0ksTUFBTSxDQUFDTixLQUFLLENBQUM7RUFDekIsT0FBTyxJQUFJO0FBQ2IsQ0FBQzs7QUFFRDtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0F2RSxXQUFXLENBQUNDLFNBQVMsQ0FBQ3NFLEtBQUssR0FBRyxVQUFVUSxJQUFJLEVBQUVyRSxLQUFLLEVBQUVLLE9BQU8sRUFBRTtFQUM1RDtFQUNBLElBQUlnRSxJQUFJLEtBQUssSUFBSSxJQUFJZCxTQUFTLEtBQUtjLElBQUksRUFBRTtJQUN2QyxNQUFNLElBQUlwQixLQUFLLENBQUMseUNBQXlDLENBQUM7RUFDNUQ7RUFFQSxJQUFJLElBQUksQ0FBQ3FCLEtBQUssRUFBRTtJQUNkLE1BQU0sSUFBSXJCLEtBQUssQ0FDYixpR0FBaUcsQ0FDbEc7RUFDSDtFQUVBLElBQUkvRCxRQUFRLENBQUNtRixJQUFJLENBQUMsRUFBRTtJQUNsQixLQUFLLE1BQU1ILEdBQUcsSUFBSUcsSUFBSSxFQUFFO01BQ3RCLElBQUlsRixNQUFNLENBQUNrRixJQUFJLEVBQUVILEdBQUcsQ0FBQyxFQUFFLElBQUksQ0FBQ0wsS0FBSyxDQUFDSyxHQUFHLEVBQUVHLElBQUksQ0FBQ0gsR0FBRyxDQUFDLENBQUM7SUFDbkQ7SUFFQSxPQUFPLElBQUk7RUFDYjtFQUVBLElBQUlLLEtBQUssQ0FBQ0MsT0FBTyxDQUFDeEUsS0FBSyxDQUFDLEVBQUU7SUFDeEIsS0FBSyxNQUFNeUUsQ0FBQyxJQUFJekUsS0FBSyxFQUFFO01BQ3JCLElBQUliLE1BQU0sQ0FBQ2EsS0FBSyxFQUFFeUUsQ0FBQyxDQUFDLEVBQUUsSUFBSSxDQUFDWixLQUFLLENBQUNRLElBQUksRUFBRXJFLEtBQUssQ0FBQ3lFLENBQUMsQ0FBQyxDQUFDO0lBQ2xEO0lBRUEsT0FBTyxJQUFJO0VBQ2I7O0VBRUE7RUFDQSxJQUFJekUsS0FBSyxLQUFLLElBQUksSUFBSXVELFNBQVMsS0FBS3ZELEtBQUssRUFBRTtJQUN6QyxNQUFNLElBQUlpRCxLQUFLLENBQUMsd0NBQXdDLENBQUM7RUFDM0Q7RUFFQSxJQUFJLE9BQU9qRCxLQUFLLEtBQUssU0FBUyxFQUFFO0lBQzlCQSxLQUFLLEdBQUcwRSxNQUFNLENBQUMxRSxLQUFLLENBQUM7RUFDdkI7O0VBRUE7RUFDQSxJQUFJSyxPQUFPLEVBQUUsSUFBSSxDQUFDc0UsWUFBWSxFQUFFLENBQUNDLE1BQU0sQ0FBQ1AsSUFBSSxFQUFFckUsS0FBSyxFQUFFSyxPQUFPLENBQUMsQ0FBQyxLQUN6RCxJQUFJLENBQUNzRSxZQUFZLEVBQUUsQ0FBQ0MsTUFBTSxDQUFDUCxJQUFJLEVBQUVyRSxLQUFLLENBQUM7RUFFNUMsT0FBTyxJQUFJO0FBQ2IsQ0FBQzs7QUFFRDtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQVYsV0FBVyxDQUFDQyxTQUFTLENBQUNzRixLQUFLLEdBQUcsWUFBWTtFQUN4QyxJQUFJLElBQUksQ0FBQ3hDLFFBQVEsRUFBRTtJQUNqQixPQUFPLElBQUk7RUFDYjtFQUVBLElBQUksQ0FBQ0EsUUFBUSxHQUFHLElBQUk7RUFDcEIsSUFBSSxJQUFJLENBQUN5QyxHQUFHLEVBQUUsSUFBSSxDQUFDQSxHQUFHLENBQUNELEtBQUssRUFBRSxDQUFDLENBQUM7RUFDaEMsSUFBSSxJQUFJLENBQUMxQyxHQUFHLEVBQUU7SUFDWjtJQUNBO0lBQ0E7SUFDQTtJQUNBO0lBQ0E7SUFDQTtJQUNBO0lBQ0E7SUFDQTtJQUNBO0lBQ0EsSUFDRW5ELE1BQU0sQ0FBQytGLEdBQUcsQ0FBQ0MsT0FBTyxDQUFDQyxPQUFPLEVBQUUsU0FBUyxDQUFDLElBQ3RDakcsTUFBTSxDQUFDa0csRUFBRSxDQUFDRixPQUFPLENBQUNDLE9BQU8sRUFBRSxTQUFTLENBQUMsRUFDckM7TUFDQTtNQUNBO01BQ0EsTUFBTSxJQUFJaEMsS0FBSyxDQUNiLG1GQUFtRixDQUNwRjtJQUNILENBQUMsTUFBTSxJQUFJakUsTUFBTSxDQUFDK0YsR0FBRyxDQUFDQyxPQUFPLENBQUNDLE9BQU8sRUFBRSxTQUFTLENBQUMsRUFBRTtNQUNqRDtNQUNBO01BQ0EsSUFBSSxDQUFDOUMsR0FBRyxDQUFDZ0QsU0FBUyxHQUFHLElBQUk7SUFDM0I7SUFFQSxJQUFJLENBQUNoRCxHQUFHLENBQUMwQyxLQUFLLEVBQUUsQ0FBQyxDQUFDO0VBQ3BCOztFQUVBLElBQUksQ0FBQ3JGLFlBQVksRUFBRTtFQUNuQixJQUFJLENBQUM0RixJQUFJLENBQUMsT0FBTyxDQUFDO0VBQ2xCLE9BQU8sSUFBSTtBQUNiLENBQUM7QUFFRDlGLFdBQVcsQ0FBQ0MsU0FBUyxDQUFDOEYsS0FBSyxHQUFHLFVBQVVDLElBQUksRUFBRUMsSUFBSSxFQUFFbEYsT0FBTyxFQUFFbUYsYUFBYSxFQUFFO0VBQzFFLFFBQVFuRixPQUFPLENBQUNvRixJQUFJO0lBQ2xCLEtBQUssT0FBTztNQUNWLElBQUksQ0FBQ3hCLEdBQUcsQ0FBQyxlQUFlLEVBQUcsU0FBUXVCLGFBQWEsQ0FBRSxHQUFFRixJQUFLLElBQUdDLElBQUssRUFBQyxDQUFFLEVBQUMsQ0FBQztNQUN0RTtJQUVGLEtBQUssTUFBTTtNQUNULElBQUksQ0FBQ0csUUFBUSxHQUFHSixJQUFJO01BQ3BCLElBQUksQ0FBQ0ssUUFBUSxHQUFHSixJQUFJO01BQ3BCO0lBRUYsS0FBSyxRQUFRO01BQUU7TUFDYixJQUFJLENBQUN0QixHQUFHLENBQUMsZUFBZSxFQUFHLFVBQVNxQixJQUFLLEVBQUMsQ0FBQztNQUMzQztJQUNGO01BQ0U7RUFBTTtFQUdWLE9BQU8sSUFBSTtBQUNiLENBQUM7O0FBRUQ7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTs7QUFFQWhHLFdBQVcsQ0FBQ0MsU0FBUyxDQUFDcUcsZUFBZSxHQUFHLFVBQVU1QyxFQUFFLEVBQUU7RUFDcEQ7RUFDQSxJQUFJQSxFQUFFLEtBQUtPLFNBQVMsRUFBRVAsRUFBRSxHQUFHLElBQUk7RUFDL0IsSUFBSSxDQUFDNkMsZ0JBQWdCLEdBQUc3QyxFQUFFO0VBQzFCLE9BQU8sSUFBSTtBQUNiLENBQUM7O0FBRUQ7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7O0FBRUExRCxXQUFXLENBQUNDLFNBQVMsQ0FBQ3VHLFNBQVMsR0FBRyxVQUFVQyxDQUFDLEVBQUU7RUFDN0MsSUFBSSxDQUFDQyxhQUFhLEdBQUdELENBQUM7RUFDdEIsT0FBTyxJQUFJO0FBQ2IsQ0FBQzs7QUFFRDtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBekcsV0FBVyxDQUFDQyxTQUFTLENBQUMwRyxlQUFlLEdBQUcsVUFBVUYsQ0FBQyxFQUFFO0VBQ25ELElBQUksT0FBT0EsQ0FBQyxLQUFLLFFBQVEsRUFBRTtJQUN6QixNQUFNLElBQUlHLFNBQVMsQ0FBQyxrQkFBa0IsQ0FBQztFQUN6QztFQUVBLElBQUksQ0FBQ0MsZ0JBQWdCLEdBQUdKLENBQUM7RUFDekIsT0FBTyxJQUFJO0FBQ2IsQ0FBQzs7QUFFRDtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBOztBQUVBekcsV0FBVyxDQUFDQyxTQUFTLENBQUM2RyxNQUFNLEdBQUcsWUFBWTtFQUN6QyxPQUFPO0lBQ0xsRCxNQUFNLEVBQUUsSUFBSSxDQUFDQSxNQUFNO0lBQ25CQyxHQUFHLEVBQUUsSUFBSSxDQUFDQSxHQUFHO0lBQ2JrRCxJQUFJLEVBQUUsSUFBSSxDQUFDL0IsS0FBSztJQUNoQmdDLE9BQU8sRUFBRSxJQUFJLENBQUN4QztFQUNoQixDQUFDO0FBQ0gsQ0FBQzs7QUFFRDtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7O0FBRUE7QUFDQXhFLFdBQVcsQ0FBQ0MsU0FBUyxDQUFDZ0gsSUFBSSxHQUFHLFVBQVVGLElBQUksRUFBRTtFQUMzQyxNQUFNRyxTQUFTLEdBQUd0SCxRQUFRLENBQUNtSCxJQUFJLENBQUM7RUFDaEMsSUFBSVosSUFBSSxHQUFHLElBQUksQ0FBQzNCLE9BQU8sQ0FBQyxjQUFjLENBQUM7RUFFdkMsSUFBSSxJQUFJLENBQUMyQyxTQUFTLEVBQUU7SUFDbEIsTUFBTSxJQUFJeEQsS0FBSyxDQUNiLDhHQUE4RyxDQUMvRztFQUNIO0VBRUEsSUFBSXVELFNBQVMsSUFBSSxDQUFDLElBQUksQ0FBQ2xDLEtBQUssRUFBRTtJQUM1QixJQUFJQyxLQUFLLENBQUNDLE9BQU8sQ0FBQzZCLElBQUksQ0FBQyxFQUFFO01BQ3ZCLElBQUksQ0FBQy9CLEtBQUssR0FBRyxFQUFFO0lBQ2pCLENBQUMsTUFBTSxJQUFJLENBQUMsSUFBSSxDQUFDb0MsT0FBTyxDQUFDTCxJQUFJLENBQUMsRUFBRTtNQUM5QixJQUFJLENBQUMvQixLQUFLLEdBQUcsQ0FBQyxDQUFDO0lBQ2pCO0VBQ0YsQ0FBQyxNQUFNLElBQUkrQixJQUFJLElBQUksSUFBSSxDQUFDL0IsS0FBSyxJQUFJLElBQUksQ0FBQ29DLE9BQU8sQ0FBQyxJQUFJLENBQUNwQyxLQUFLLENBQUMsRUFBRTtJQUN6RCxNQUFNLElBQUlyQixLQUFLLENBQUMsOEJBQThCLENBQUM7RUFDakQ7O0VBRUE7RUFDQSxJQUFJdUQsU0FBUyxJQUFJdEgsUUFBUSxDQUFDLElBQUksQ0FBQ29GLEtBQUssQ0FBQyxFQUFFO0lBQ3JDLEtBQUssTUFBTUosR0FBRyxJQUFJbUMsSUFBSSxFQUFFO01BQ3RCLElBQUlsSCxNQUFNLENBQUNrSCxJQUFJLEVBQUVuQyxHQUFHLENBQUMsRUFBRSxJQUFJLENBQUNJLEtBQUssQ0FBQ0osR0FBRyxDQUFDLEdBQUdtQyxJQUFJLENBQUNuQyxHQUFHLENBQUM7SUFDcEQ7RUFDRixDQUFDLE1BQU0sSUFBSSxPQUFPbUMsSUFBSSxLQUFLLFFBQVEsRUFBRTtJQUNuQztJQUNBLElBQUksQ0FBQ1osSUFBSSxFQUFFLElBQUksQ0FBQ0EsSUFBSSxDQUFDLE1BQU0sQ0FBQztJQUM1QkEsSUFBSSxHQUFHLElBQUksQ0FBQzNCLE9BQU8sQ0FBQyxjQUFjLENBQUM7SUFDbkMsSUFBSTJCLElBQUksRUFBRUEsSUFBSSxHQUFHQSxJQUFJLENBQUMxQixXQUFXLEVBQUUsQ0FBQzRDLElBQUksRUFBRTtJQUMxQyxJQUFJbEIsSUFBSSxLQUFLLG1DQUFtQyxFQUFFO01BQ2hELElBQUksQ0FBQ25CLEtBQUssR0FBRyxJQUFJLENBQUNBLEtBQUssR0FBSSxHQUFFLElBQUksQ0FBQ0EsS0FBTSxJQUFHK0IsSUFBSyxFQUFDLEdBQUdBLElBQUk7SUFDMUQsQ0FBQyxNQUFNO01BQ0wsSUFBSSxDQUFDL0IsS0FBSyxHQUFHLENBQUMsSUFBSSxDQUFDQSxLQUFLLElBQUksRUFBRSxJQUFJK0IsSUFBSTtJQUN4QztFQUNGLENBQUMsTUFBTTtJQUNMLElBQUksQ0FBQy9CLEtBQUssR0FBRytCLElBQUk7RUFDbkI7RUFFQSxJQUFJLENBQUNHLFNBQVMsSUFBSSxJQUFJLENBQUNFLE9BQU8sQ0FBQ0wsSUFBSSxDQUFDLEVBQUU7SUFDcEMsT0FBTyxJQUFJO0VBQ2I7O0VBRUE7RUFDQSxJQUFJLENBQUNaLElBQUksRUFBRSxJQUFJLENBQUNBLElBQUksQ0FBQyxNQUFNLENBQUM7RUFDNUIsT0FBTyxJQUFJO0FBQ2IsQ0FBQzs7QUFFRDtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7O0FBRUFuRyxXQUFXLENBQUNDLFNBQVMsQ0FBQ3FILFNBQVMsR0FBRyxVQUFVQyxJQUFJLEVBQUU7RUFDaEQ7RUFDQSxJQUFJLENBQUNDLEtBQUssR0FBRyxPQUFPRCxJQUFJLEtBQUssV0FBVyxHQUFHLElBQUksR0FBR0EsSUFBSTtFQUN0RCxPQUFPLElBQUk7QUFDYixDQUFDOztBQUVEO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQXZILFdBQVcsQ0FBQ0MsU0FBUyxDQUFDd0gsb0JBQW9CLEdBQUcsWUFBWTtFQUN2RCxNQUFNQyxLQUFLLEdBQUcsSUFBSSxDQUFDQyxNQUFNLENBQUNDLElBQUksQ0FBQyxHQUFHLENBQUM7RUFDbkMsSUFBSUYsS0FBSyxFQUFFO0lBQ1QsSUFBSSxDQUFDN0QsR0FBRyxJQUFJLENBQUMsSUFBSSxDQUFDQSxHQUFHLENBQUNnRSxRQUFRLENBQUMsR0FBRyxDQUFDLEdBQUcsR0FBRyxHQUFHLEdBQUcsSUFBSUgsS0FBSztFQUMxRDtFQUVBLElBQUksQ0FBQ0MsTUFBTSxDQUFDL0YsTUFBTSxHQUFHLENBQUMsQ0FBQyxDQUFDOztFQUV4QixJQUFJLElBQUksQ0FBQzRGLEtBQUssRUFBRTtJQUNkLE1BQU1NLEtBQUssR0FBRyxJQUFJLENBQUNqRSxHQUFHLENBQUNrRSxPQUFPLENBQUMsR0FBRyxDQUFDO0lBQ25DLElBQUlELEtBQUssSUFBSSxDQUFDLEVBQUU7TUFDZCxNQUFNRSxVQUFVLEdBQUcsSUFBSSxDQUFDbkUsR0FBRyxDQUFDb0UsS0FBSyxDQUFDSCxLQUFLLEdBQUcsQ0FBQyxDQUFDLENBQUNJLEtBQUssQ0FBQyxHQUFHLENBQUM7TUFDdkQsSUFBSSxPQUFPLElBQUksQ0FBQ1YsS0FBSyxLQUFLLFVBQVUsRUFBRTtRQUNwQ1EsVUFBVSxDQUFDVCxJQUFJLENBQUMsSUFBSSxDQUFDQyxLQUFLLENBQUM7TUFDN0IsQ0FBQyxNQUFNO1FBQ0xRLFVBQVUsQ0FBQ1QsSUFBSSxFQUFFO01BQ25CO01BRUEsSUFBSSxDQUFDMUQsR0FBRyxHQUFHLElBQUksQ0FBQ0EsR0FBRyxDQUFDb0UsS0FBSyxDQUFDLENBQUMsRUFBRUgsS0FBSyxDQUFDLEdBQUcsR0FBRyxHQUFHRSxVQUFVLENBQUNKLElBQUksQ0FBQyxHQUFHLENBQUM7SUFDbEU7RUFDRjtBQUNGLENBQUM7O0FBRUQ7QUFDQTVILFdBQVcsQ0FBQ0MsU0FBUyxDQUFDa0ksa0JBQWtCLEdBQUcsTUFBTTtFQUMvQzVHLE9BQU8sQ0FBQ0MsSUFBSSxDQUFDLGFBQWEsQ0FBQztBQUM3QixDQUFDOztBQUVEO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7O0FBRUF4QixXQUFXLENBQUNDLFNBQVMsQ0FBQ21JLGFBQWEsR0FBRyxVQUFVQyxNQUFNLEVBQUV2SCxPQUFPLEVBQUV3SCxLQUFLLEVBQUU7RUFDdEUsSUFBSSxJQUFJLENBQUN2RixRQUFRLEVBQUU7SUFDakI7RUFDRjtFQUVBLE1BQU1YLEtBQUssR0FBRyxJQUFJdUIsS0FBSyxDQUFFLEdBQUUwRSxNQUFNLEdBQUd2SCxPQUFRLGFBQVksQ0FBQztFQUN6RHNCLEtBQUssQ0FBQ3RCLE9BQU8sR0FBR0EsT0FBTztFQUN2QnNCLEtBQUssQ0FBQ00sSUFBSSxHQUFHLGNBQWM7RUFDM0JOLEtBQUssQ0FBQ2tHLEtBQUssR0FBR0EsS0FBSztFQUNuQixJQUFJLENBQUN0RixRQUFRLEdBQUcsSUFBSTtFQUNwQixJQUFJLENBQUNDLGFBQWEsR0FBR2IsS0FBSztFQUMxQixJQUFJLENBQUNtRCxLQUFLLEVBQUU7RUFDWixJQUFJLENBQUN2QixRQUFRLENBQUM1QixLQUFLLENBQUM7QUFDdEIsQ0FBQztBQUVEcEMsV0FBVyxDQUFDQyxTQUFTLENBQUNzSSxZQUFZLEdBQUcsWUFBWTtFQUMvQyxNQUFNaEYsSUFBSSxHQUFHLElBQUk7O0VBRWpCO0VBQ0EsSUFBSSxJQUFJLENBQUN2QyxRQUFRLElBQUksQ0FBQyxJQUFJLENBQUNiLE1BQU0sRUFBRTtJQUNqQyxJQUFJLENBQUNBLE1BQU0sR0FBR3FJLFVBQVUsQ0FBQyxNQUFNO01BQzdCakYsSUFBSSxDQUFDNkUsYUFBYSxDQUFDLGFBQWEsRUFBRTdFLElBQUksQ0FBQ3ZDLFFBQVEsRUFBRSxPQUFPLENBQUM7SUFDM0QsQ0FBQyxFQUFFLElBQUksQ0FBQ0EsUUFBUSxDQUFDO0VBQ25COztFQUVBO0VBQ0EsSUFBSSxJQUFJLENBQUNDLGdCQUFnQixJQUFJLENBQUMsSUFBSSxDQUFDYixxQkFBcUIsRUFBRTtJQUN4RCxJQUFJLENBQUNBLHFCQUFxQixHQUFHb0ksVUFBVSxDQUFDLE1BQU07TUFDNUNqRixJQUFJLENBQUM2RSxhQUFhLENBQ2hCLHNCQUFzQixFQUN0QjdFLElBQUksQ0FBQ3RDLGdCQUFnQixFQUNyQixXQUFXLENBQ1o7SUFDSCxDQUFDLEVBQUUsSUFBSSxDQUFDQSxnQkFBZ0IsQ0FBQztFQUMzQjtBQUNGLENBQUMifQ==

/***/ }),

/***/ 76031:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


/**
 * Module dependencies.
 */

const utils = __webpack_require__(73316);

/**
 * Expose `ResponseBase`.
 */

module.exports = ResponseBase;

/**
 * Initialize a new `ResponseBase`.
 *
 * @api public
 */

function ResponseBase() {}

/**
 * Get case-insensitive `field` value.
 *
 * @param {String} field
 * @return {String}
 * @api public
 */

ResponseBase.prototype.get = function (field) {
  return this.header[field.toLowerCase()];
};

/**
 * Set header related properties:
 *
 *   - `.type` the content type without params
 *
 * A response of "Content-Type: text/plain; charset=utf-8"
 * will provide you with a `.type` of "text/plain".
 *
 * @param {Object} header
 * @api private
 */

ResponseBase.prototype._setHeaderProperties = function (header) {
  // TODO: moar!
  // TODO: make this a util

  // content-type
  const ct = header['content-type'] || '';
  this.type = utils.type(ct);

  // params
  const parameters = utils.params(ct);
  for (const key in parameters) {
    if (Object.prototype.hasOwnProperty.call(parameters, key)) this[key] = parameters[key];
  }
  this.links = {};

  // links
  try {
    if (header.link) {
      this.links = utils.parseLinks(header.link);
    }
  } catch (err) {
    // ignore
  }
};

/**
 * Set flags such as `.ok` based on `status`.
 *
 * For example a 2xx response will give you a `.ok` of __true__
 * whereas 5xx will be __false__ and `.error` will be __true__. The
 * `.clientError` and `.serverError` are also available to be more
 * specific, and `.statusType` is the class of error ranging from 1..5
 * sometimes useful for mapping respond colors etc.
 *
 * "sugar" properties are also defined for common cases. Currently providing:
 *
 *   - .noContent
 *   - .badRequest
 *   - .unauthorized
 *   - .notAcceptable
 *   - .notFound
 *
 * @param {Number} status
 * @api private
 */

ResponseBase.prototype._setStatusProperties = function (status) {
  const type = Math.trunc(status / 100);

  // status / class
  this.statusCode = status;
  this.status = this.statusCode;
  this.statusType = type;

  // basics
  this.info = type === 1;
  this.ok = type === 2;
  this.redirect = type === 3;
  this.clientError = type === 4;
  this.serverError = type === 5;
  this.error = type === 4 || type === 5 ? this.toError() : false;

  // sugar
  this.created = status === 201;
  this.accepted = status === 202;
  this.noContent = status === 204;
  this.badRequest = status === 400;
  this.unauthorized = status === 401;
  this.notAcceptable = status === 406;
  this.forbidden = status === 403;
  this.notFound = status === 404;
  this.unprocessableEntity = status === 422;
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 73316:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/**
 * Return the mime type for the given `str`.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */

exports.type = string_ => string_.split(/ *; */).shift();

/**
 * Return header field parameters.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

exports.params = value => {
  const object = {};
  var _iterator = _createForOfIteratorHelper(value.split(/ *; */)),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      const string_ = _step.value;
      const parts = string_.split(/ *= */);
      const key = parts.shift();
      const value = parts.shift();
      if (key && value) object[key] = value;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return object;
};

/**
 * Parse Link header fields.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

exports.parseLinks = value => {
  const object = {};
  var _iterator2 = _createForOfIteratorHelper(value.split(/ *, */)),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      const string_ = _step2.value;
      const parts = string_.split(/ *; */);
      const url = parts[0].slice(1, -1);
      const rel = parts[1].split(/ *= */)[1].slice(1, -1);
      object[rel] = url;
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return object;
};

/**
 * Strip content related fields from `header`.
 *
 * @param {Object} header
 * @return {Object} header
 * @api private
 */

exports.cleanHeader = (header, changesOrigin) => {
  delete header['content-type'];
  delete header['content-length'];
  delete header['transfer-encoding'];
  delete header.host;
  // secuirty
  if (changesOrigin) {
    delete header.authorization;
    delete header.cookie;
  }
  return header;
};

/**
 * Check if `obj` is an object.
 *
 * @param {Object} object
 * @return {Boolean}
 * @api private
 */
exports.isObject = object => {
  return object !== null && typeof object === 'object';
};

/**
 * Object.hasOwn fallback/polyfill.
 *
 * @type {(object: object, property: string) => boolean} object
 * @api private
 */
exports.hasOwn = Object.hasOwn || function (object, property) {
  if (object == null) {
    throw new TypeError('Cannot convert undefined or null to object');
  }
  return Object.prototype.hasOwnProperty.call(new Object(object), property);
};
exports.mixin = (target, source) => {
  for (const key in source) {
    if (exports.hasOwn(source, key)) {
      target[key] = source[key];
    }
  }
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJleHBvcnRzIiwidHlwZSIsInN0cmluZ18iLCJzcGxpdCIsInNoaWZ0IiwicGFyYW1zIiwidmFsdWUiLCJvYmplY3QiLCJwYXJ0cyIsImtleSIsInBhcnNlTGlua3MiLCJ1cmwiLCJzbGljZSIsInJlbCIsImNsZWFuSGVhZGVyIiwiaGVhZGVyIiwiY2hhbmdlc09yaWdpbiIsImhvc3QiLCJhdXRob3JpemF0aW9uIiwiY29va2llIiwiaXNPYmplY3QiLCJoYXNPd24iLCJPYmplY3QiLCJwcm9wZXJ0eSIsIlR5cGVFcnJvciIsInByb3RvdHlwZSIsImhhc093blByb3BlcnR5IiwiY2FsbCIsIm1peGluIiwidGFyZ2V0Iiwic291cmNlIl0sInNvdXJjZXMiOlsiLi4vc3JjL3V0aWxzLmpzIl0sInNvdXJjZXNDb250ZW50IjpbIi8qKlxuICogUmV0dXJuIHRoZSBtaW1lIHR5cGUgZm9yIHRoZSBnaXZlbiBgc3RyYC5cbiAqXG4gKiBAcGFyYW0ge1N0cmluZ30gc3RyXG4gKiBAcmV0dXJuIHtTdHJpbmd9XG4gKiBAYXBpIHByaXZhdGVcbiAqL1xuXG5leHBvcnRzLnR5cGUgPSAoc3RyaW5nXykgPT4gc3RyaW5nXy5zcGxpdCgvICo7ICovKS5zaGlmdCgpO1xuXG4vKipcbiAqIFJldHVybiBoZWFkZXIgZmllbGQgcGFyYW1ldGVycy5cbiAqXG4gKiBAcGFyYW0ge1N0cmluZ30gc3RyXG4gKiBAcmV0dXJuIHtPYmplY3R9XG4gKiBAYXBpIHByaXZhdGVcbiAqL1xuXG5leHBvcnRzLnBhcmFtcyA9ICh2YWx1ZSkgPT4ge1xuICBjb25zdCBvYmplY3QgPSB7fTtcbiAgZm9yIChjb25zdCBzdHJpbmdfIG9mIHZhbHVlLnNwbGl0KC8gKjsgKi8pKSB7XG4gICAgY29uc3QgcGFydHMgPSBzdHJpbmdfLnNwbGl0KC8gKj0gKi8pO1xuICAgIGNvbnN0IGtleSA9IHBhcnRzLnNoaWZ0KCk7XG4gICAgY29uc3QgdmFsdWUgPSBwYXJ0cy5zaGlmdCgpO1xuXG4gICAgaWYgKGtleSAmJiB2YWx1ZSkgb2JqZWN0W2tleV0gPSB2YWx1ZTtcbiAgfVxuXG4gIHJldHVybiBvYmplY3Q7XG59O1xuXG4vKipcbiAqIFBhcnNlIExpbmsgaGVhZGVyIGZpZWxkcy5cbiAqXG4gKiBAcGFyYW0ge1N0cmluZ30gc3RyXG4gKiBAcmV0dXJuIHtPYmplY3R9XG4gKiBAYXBpIHByaXZhdGVcbiAqL1xuXG5leHBvcnRzLnBhcnNlTGlua3MgPSAodmFsdWUpID0+IHtcbiAgY29uc3Qgb2JqZWN0ID0ge307XG4gIGZvciAoY29uc3Qgc3RyaW5nXyBvZiB2YWx1ZS5zcGxpdCgvICosICovKSkge1xuICAgIGNvbnN0IHBhcnRzID0gc3RyaW5nXy5zcGxpdCgvICo7ICovKTtcbiAgICBjb25zdCB1cmwgPSBwYXJ0c1swXS5zbGljZSgxLCAtMSk7XG4gICAgY29uc3QgcmVsID0gcGFydHNbMV0uc3BsaXQoLyAqPSAqLylbMV0uc2xpY2UoMSwgLTEpO1xuICAgIG9iamVjdFtyZWxdID0gdXJsO1xuICB9XG5cbiAgcmV0dXJuIG9iamVjdDtcbn07XG5cbi8qKlxuICogU3RyaXAgY29udGVudCByZWxhdGVkIGZpZWxkcyBmcm9tIGBoZWFkZXJgLlxuICpcbiAqIEBwYXJhbSB7T2JqZWN0fSBoZWFkZXJcbiAqIEByZXR1cm4ge09iamVjdH0gaGVhZGVyXG4gKiBAYXBpIHByaXZhdGVcbiAqL1xuXG5leHBvcnRzLmNsZWFuSGVhZGVyID0gKGhlYWRlciwgY2hhbmdlc09yaWdpbikgPT4ge1xuICBkZWxldGUgaGVhZGVyWydjb250ZW50LXR5cGUnXTtcbiAgZGVsZXRlIGhlYWRlclsnY29udGVudC1sZW5ndGgnXTtcbiAgZGVsZXRlIGhlYWRlclsndHJhbnNmZXItZW5jb2RpbmcnXTtcbiAgZGVsZXRlIGhlYWRlci5ob3N0O1xuICAvLyBzZWN1aXJ0eVxuICBpZiAoY2hhbmdlc09yaWdpbikge1xuICAgIGRlbGV0ZSBoZWFkZXIuYXV0aG9yaXphdGlvbjtcbiAgICBkZWxldGUgaGVhZGVyLmNvb2tpZTtcbiAgfVxuXG4gIHJldHVybiBoZWFkZXI7XG59O1xuXG4vKipcbiAqIENoZWNrIGlmIGBvYmpgIGlzIGFuIG9iamVjdC5cbiAqXG4gKiBAcGFyYW0ge09iamVjdH0gb2JqZWN0XG4gKiBAcmV0dXJuIHtCb29sZWFufVxuICogQGFwaSBwcml2YXRlXG4gKi9cbmV4cG9ydHMuaXNPYmplY3QgPSAob2JqZWN0KSA9PiB7XG4gIHJldHVybiBvYmplY3QgIT09IG51bGwgJiYgdHlwZW9mIG9iamVjdCA9PT0gJ29iamVjdCc7XG59O1xuXG4vKipcbiAqIE9iamVjdC5oYXNPd24gZmFsbGJhY2svcG9seWZpbGwuXG4gKlxuICogQHR5cGUgeyhvYmplY3Q6IG9iamVjdCwgcHJvcGVydHk6IHN0cmluZykgPT4gYm9vbGVhbn0gb2JqZWN0XG4gKiBAYXBpIHByaXZhdGVcbiAqL1xuZXhwb3J0cy5oYXNPd24gPVxuICBPYmplY3QuaGFzT3duIHx8XG4gIGZ1bmN0aW9uIChvYmplY3QsIHByb3BlcnR5KSB7XG4gICAgaWYgKG9iamVjdCA9PSBudWxsKSB7XG4gICAgICB0aHJvdyBuZXcgVHlwZUVycm9yKCdDYW5ub3QgY29udmVydCB1bmRlZmluZWQgb3IgbnVsbCB0byBvYmplY3QnKTtcbiAgICB9XG5cbiAgICByZXR1cm4gT2JqZWN0LnByb3RvdHlwZS5oYXNPd25Qcm9wZXJ0eS5jYWxsKG5ldyBPYmplY3Qob2JqZWN0KSwgcHJvcGVydHkpO1xuICB9O1xuXG5leHBvcnRzLm1peGluID0gKHRhcmdldCwgc291cmNlKSA9PiB7XG4gIGZvciAoY29uc3Qga2V5IGluIHNvdXJjZSkge1xuICAgIGlmIChleHBvcnRzLmhhc093bihzb3VyY2UsIGtleSkpIHtcbiAgICAgIHRhcmdldFtrZXldID0gc291cmNlW2tleV07XG4gICAgfVxuICB9XG59O1xuIl0sIm1hcHBpbmdzIjoiOzs7OztBQUFBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBOztBQUVBQSxPQUFPLENBQUNDLElBQUksR0FBSUMsT0FBTyxJQUFLQSxPQUFPLENBQUNDLEtBQUssQ0FBQyxPQUFPLENBQUMsQ0FBQ0MsS0FBSyxFQUFFOztBQUUxRDtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTs7QUFFQUosT0FBTyxDQUFDSyxNQUFNLEdBQUlDLEtBQUssSUFBSztFQUMxQixNQUFNQyxNQUFNLEdBQUcsQ0FBQyxDQUFDO0VBQUMsMkNBQ0lELEtBQUssQ0FBQ0gsS0FBSyxDQUFDLE9BQU8sQ0FBQztJQUFBO0VBQUE7SUFBMUMsb0RBQTRDO01BQUEsTUFBakNELE9BQU87TUFDaEIsTUFBTU0sS0FBSyxHQUFHTixPQUFPLENBQUNDLEtBQUssQ0FBQyxPQUFPLENBQUM7TUFDcEMsTUFBTU0sR0FBRyxHQUFHRCxLQUFLLENBQUNKLEtBQUssRUFBRTtNQUN6QixNQUFNRSxLQUFLLEdBQUdFLEtBQUssQ0FBQ0osS0FBSyxFQUFFO01BRTNCLElBQUlLLEdBQUcsSUFBSUgsS0FBSyxFQUFFQyxNQUFNLENBQUNFLEdBQUcsQ0FBQyxHQUFHSCxLQUFLO0lBQ3ZDO0VBQUM7SUFBQTtFQUFBO0lBQUE7RUFBQTtFQUVELE9BQU9DLE1BQU07QUFDZixDQUFDOztBQUVEO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBOztBQUVBUCxPQUFPLENBQUNVLFVBQVUsR0FBSUosS0FBSyxJQUFLO0VBQzlCLE1BQU1DLE1BQU0sR0FBRyxDQUFDLENBQUM7RUFBQyw0Q0FDSUQsS0FBSyxDQUFDSCxLQUFLLENBQUMsT0FBTyxDQUFDO0lBQUE7RUFBQTtJQUExQyx1REFBNEM7TUFBQSxNQUFqQ0QsT0FBTztNQUNoQixNQUFNTSxLQUFLLEdBQUdOLE9BQU8sQ0FBQ0MsS0FBSyxDQUFDLE9BQU8sQ0FBQztNQUNwQyxNQUFNUSxHQUFHLEdBQUdILEtBQUssQ0FBQyxDQUFDLENBQUMsQ0FBQ0ksS0FBSyxDQUFDLENBQUMsRUFBRSxDQUFDLENBQUMsQ0FBQztNQUNqQyxNQUFNQyxHQUFHLEdBQUdMLEtBQUssQ0FBQyxDQUFDLENBQUMsQ0FBQ0wsS0FBSyxDQUFDLE9BQU8sQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDUyxLQUFLLENBQUMsQ0FBQyxFQUFFLENBQUMsQ0FBQyxDQUFDO01BQ25ETCxNQUFNLENBQUNNLEdBQUcsQ0FBQyxHQUFHRixHQUFHO0lBQ25CO0VBQUM7SUFBQTtFQUFBO0lBQUE7RUFBQTtFQUVELE9BQU9KLE1BQU07QUFDZixDQUFDOztBQUVEO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBOztBQUVBUCxPQUFPLENBQUNjLFdBQVcsR0FBRyxDQUFDQyxNQUFNLEVBQUVDLGFBQWEsS0FBSztFQUMvQyxPQUFPRCxNQUFNLENBQUMsY0FBYyxDQUFDO0VBQzdCLE9BQU9BLE1BQU0sQ0FBQyxnQkFBZ0IsQ0FBQztFQUMvQixPQUFPQSxNQUFNLENBQUMsbUJBQW1CLENBQUM7RUFDbEMsT0FBT0EsTUFBTSxDQUFDRSxJQUFJO0VBQ2xCO0VBQ0EsSUFBSUQsYUFBYSxFQUFFO0lBQ2pCLE9BQU9ELE1BQU0sQ0FBQ0csYUFBYTtJQUMzQixPQUFPSCxNQUFNLENBQUNJLE1BQU07RUFDdEI7RUFFQSxPQUFPSixNQUFNO0FBQ2YsQ0FBQzs7QUFFRDtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBZixPQUFPLENBQUNvQixRQUFRLEdBQUliLE1BQU0sSUFBSztFQUM3QixPQUFPQSxNQUFNLEtBQUssSUFBSSxJQUFJLE9BQU9BLE1BQU0sS0FBSyxRQUFRO0FBQ3RELENBQUM7O0FBRUQ7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0FQLE9BQU8sQ0FBQ3FCLE1BQU0sR0FDWkMsTUFBTSxDQUFDRCxNQUFNLElBQ2IsVUFBVWQsTUFBTSxFQUFFZ0IsUUFBUSxFQUFFO0VBQzFCLElBQUloQixNQUFNLElBQUksSUFBSSxFQUFFO0lBQ2xCLE1BQU0sSUFBSWlCLFNBQVMsQ0FBQyw0Q0FBNEMsQ0FBQztFQUNuRTtFQUVBLE9BQU9GLE1BQU0sQ0FBQ0csU0FBUyxDQUFDQyxjQUFjLENBQUNDLElBQUksQ0FBQyxJQUFJTCxNQUFNLENBQUNmLE1BQU0sQ0FBQyxFQUFFZ0IsUUFBUSxDQUFDO0FBQzNFLENBQUM7QUFFSHZCLE9BQU8sQ0FBQzRCLEtBQUssR0FBRyxDQUFDQyxNQUFNLEVBQUVDLE1BQU0sS0FBSztFQUNsQyxLQUFLLE1BQU1yQixHQUFHLElBQUlxQixNQUFNLEVBQUU7SUFDeEIsSUFBSTlCLE9BQU8sQ0FBQ3FCLE1BQU0sQ0FBQ1MsTUFBTSxFQUFFckIsR0FBRyxDQUFDLEVBQUU7TUFDL0JvQixNQUFNLENBQUNwQixHQUFHLENBQUMsR0FBR3FCLE1BQU0sQ0FBQ3JCLEdBQUcsQ0FBQztJQUMzQjtFQUNGO0FBQ0YsQ0FBQyJ9

/***/ }),

/***/ 27774:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "AdError", ({
    enumerable: true,
    get: function() {
        return AdError;
    }
}));
var _class_call_check = __webpack_require__(67818);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(3009);
var _aderrors = __webpack_require__(16174);
var AdError = function AdError() {
    "use strict";
    var type = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : _aderrors.AD_UNKNOWN_ERROR, details = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "UNKNOWN", fatal = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true, context = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", reason = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "", content = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "", monitored = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : true;
    _class_call_check._(this, AdError);
    this.type = type;
    this.details = details;
    this.fatal = fatal;
    this.monitored = monitored;
    this.context = context;
    this.reason = reason;
    this.content = content;
};


/***/ }),

/***/ 2264:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "AbstractAdExtendedBridge", ({
    enumerable: true,
    get: function() {
        return AbstractAdExtendedBridge;
    }
}));
var _assert_this_initialized = __webpack_require__(99561);
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _get = __webpack_require__(60528);
var _get_prototype_of = __webpack_require__(35196);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _to_consumable_array = __webpack_require__(30005);
var _create_super = __webpack_require__(6400);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(37815);
var _lodash = /*#__PURE__*/ _interop_require_default._(__webpack_require__(32699));
var _html5engine = __webpack_require__(93344);
var _adbridge = __webpack_require__(35859);
var _adengine = __webpack_require__(90877);
var _loggerutils = /*#__PURE__*/ _interop_require_default._(__webpack_require__(11905));
var _AdError = __webpack_require__(27774);
var _adengineevents = __webpack_require__(78725);
var _adtypes = __webpack_require__(28648);
var _constants = __webpack_require__(92851);
var _types = __webpack_require__(19783);
var _slotutils = __webpack_require__(90200);
var AbstractAdExtendedBridge = /*#__PURE__*/ function(AdBridge) {
    "use strict";
    _inherits._(AbstractAdExtendedBridge, AdBridge);
    var _super = _create_super._(AbstractAdExtendedBridge);
    function AbstractAdExtendedBridge(config, eventsHandlers, contentHandlers) {
        var _ref = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, _ref_VideoEngine = _ref.VideoEngine, VideoEngine = _ref_VideoEngine === void 0 ? _html5engine.HTML5Engine : _ref_VideoEngine, _ref_storage = _ref.storage, storage = _ref_storage === void 0 ? window.localStorage : _ref_storage;
        _class_call_check._(this, AbstractAdExtendedBridge);
        var _this;
        _this = _super.call(this, config, eventsHandlers, contentHandlers, {
            VideoEngine: VideoEngine,
            storage: storage
        });
        _this.onRequestComplete = function(response) {
            if (_this.released) {
                return;
            }
            if (response.success) {
                var newCuePoints = response.slots.filter(function(slot) {
                    return !slot.ended && !_lodash.default.isNaN(slot.cuePoint);
                }).map(function(slot) {
                    return slot.cuePoint;
                });
                _this.updateCuePoints(_lodash.default.uniq(_to_consumable_array._(_this.cuePoints).concat(_to_consumable_array._(newCuePoints))));
                if (_this.shouldAutoPlay) {
                    var slot;
                    if (response.forCuePoint) {
                        slot = _this.engine.getSlot(response.forCuePoint);
                    } else {
                        slot = _this.engine.getSlot(0);
                    }
                    _this.eventsHandlers.onProviderLoaded();
                    if (slot && !slot.pending && (slot.adTagURI || (0, _slotutils.hasAds)(slot))) {
                        _this.startSlot(slot, {
                            triggerTime: slot.cuePoint
                        });
                    } else {
                        if (slot && slot.ads && slot.ads.length) {
                            slot.ads.forEach(function(ad) {
                                if (ad.errorStack && ad.errorStack.length) {
                                    ad.errorStack.forEach(function(errorCode) {
                                        _this.engine.sendVASTError(ad, errorCode);
                                    });
                                    ad.errorStack = null;
                                }
                            });
                        }
                        _this.contentHandlers.playerPlay();
                    }
                }
            } else {
                _this.eventsHandlers.onProviderLoaded();
                if (_this.shouldAutoPlay) {
                    // We have to play the content as the first request to retrieve the ads is in error
                    _this.contentHandlers.playerPlay();
                }
            }
        };
        var _this1 = _assert_this_initialized._(_this);
        _this.onAdError = function() {
            var _ref = _async_to_generator._(function(event) {
                var error, ad, asset, creative, creativeId, _creativeId_toLowerCase;
                return _ts_generator._(this, function(_state) {
                    error = new _AdError.AdError(_adengineevents.adEvents.AD_ERROR, _lodash.default.get(event, "error.code"), !!event.error.fatal, _lodash.default.get(event, "error.module"), _lodash.default.get(event, "error.message"));
                    // Do not monitor when there was an error because programmatic did not served ads
                    error.monitored = error.details !== 1009;
                    ad = _this1.engine.getCurrentAd();
                    asset = _this1.engine.getCurrentAsset();
                    creative = _this1.engine.getActiveCreative();
                    creativeId = _this1.getAdCreativeId(creative);
                    if (ad) {
                        ;
                        error.content = {
                            ad: {
                                id: ad.id || ad.adid,
                                creativeId: (creativeId === null || creativeId === void 0 ? void 0 : (_creativeId_toLowerCase = creativeId.toLowerCase) === null || _creativeId_toLowerCase === void 0 ? void 0 : _creativeId_toLowerCase.call(creativeId)) === "unknown" && (ad === null || ad === void 0 ? void 0 : ad.adid) ? ad === null || ad === void 0 ? void 0 : ad.adid : creativeId,
                                mediaFile: {
                                    url: _lodash.default.get(asset, "src"),
                                    mimeType: _lodash.default.get(asset, "type")
                                }
                            }
                        };
                    }
                    error.adRequestUrl = _lodash.default.get(_this1.engine, "options.host");
                    _this1.eventsHandlers.onError(error);
                    return [
                        2
                    ];
                });
            });
            return function(event) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.onAdStarted = function(event) {
            var currentAd = _this.engine.getCurrentAd();
            var creative = _this.engine.getActiveCreative();
            var creativeId = _this.getAdCreativeId(creative);
            _this.eventsHandlers.onStarted({
                type: _lodash.default.get(_this.engine.getCurrentSlot(), "type"),
                creativeId: creativeId,
                mimeType: _lodash.default.get(creative, "currentAsset.type"),
                hasCompanions: !!_lodash.default.get(currentAd, "companions", []).length,
                linear: event.target.linear,
                title: currentAd === null || currentAd === void 0 ? void 0 : currentAd.title,
                duration: creative === null || creative === void 0 ? void 0 : creative.duration,
                adId: currentAd === null || currentAd === void 0 ? void 0 : currentAd.id,
                skipOffset: creative === null || creative === void 0 ? void 0 : creative.skipoffset,
                ssaiClickThroughURL: creative === null || creative === void 0 ? void 0 : creative.clickThroughUrl
            });
        };
        _this.onAdEnded = function(event) {
            _this.endedAdsDuration = _this.endedAdsDuration + event.target.duration;
            _this.eventsHandlers.onEnded(event);
        };
        _this.onAdSkipped = function(event) {
            _this.endedAdsDuration = _this.endedAdsDuration + event.target.duration;
            _this.eventsHandlers.onSkipped(event);
        };
        _this.getAdCreativeId = function(creative) {
            return (creative === null || creative === void 0 ? void 0 : creative.adid) || "unknown";
        };
        _this.shouldLaunchAdJingle = function(slot) {
            return (0, _slotutils.hasAds)(slot) && _to_consumable_array._(slot.ads).concat(_to_consumable_array._(slot.buffet || [])).some(function(ad) {
                var _ad_creatives;
                return (_ad_creatives = ad.creatives) === null || _ad_creatives === void 0 ? void 0 : _ad_creatives.some(function(creative) {
                    var _creative_assets;
                    return (_creative_assets = creative.assets) === null || _creative_assets === void 0 ? void 0 : _creative_assets.length;
                });
            });
        };
        var _this2 = _assert_this_initialized._(_this);
        _this.beforeSlotStart = function() {
            var _ref = _async_to_generator._(function(param) {
                var slot, type;
                return _ts_generator._(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            slot = param.slot;
                            type = slot.type;
                            if (![
                                _adtypes.PREROLL,
                                _adtypes.MIDROLL,
                                _adtypes.DAI
                            ].includes(type)) {
                                return [
                                    2
                                ];
                            }
                            if (!_this2.shouldLaunchAdJingle(slot)) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                _this2.contentHandlers.jingleDisplay("ads")
                            ];
                        case 1:
                            _state.sent();
                            _state.label = 2;
                        case 2:
                            _this2.updateSlotsDuration();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this3 = _assert_this_initialized._(_this);
        _this.onSlotStart = function() {
            var _ref = _async_to_generator._(function(param) {
                var slot, ads, type, reference;
                return _ts_generator._(this, function(_state) {
                    slot = param.slot;
                    ads = slot.ads, type = slot.type, reference = slot.reference;
                    if (![
                        _adtypes.PREROLL,
                        _adtypes.MIDROLL,
                        _adtypes.DAI,
                        _types.Advertising.SlotType.LBANNER
                    ].includes(type)) {
                        return [
                            2
                        ];
                    }
                    if ((0, _slotutils.isLinearSlot)(slot) && (0, _slotutils.hasAds)(slot)) {
                        _this3.contentHandlers.playerPause();
                    }
                    ads.forEach(function(ad) {
                        if (ad.errorStack && ad.errorStack.length) {
                            ad.errorStack.forEach(function(errorCode) {
                                _this3.engine.sendVASTError(ad, errorCode);
                            });
                        }
                    });
                    _this3.eventsHandlers.onBreakStarted({
                        type: type,
                        silent: !(0, _slotutils.hasAds)(slot),
                        creativeIds: ads.map(_this3.getAdCreativeId),
                        reference: reference
                    });
                    return [
                        2
                    ];
                });
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.onSlotEnded = function(param) {
            var slot = param.slot, completed = param.completed;
            var silent = !(0, _slotutils.hasAds)(slot);
            _this.eventsHandlers.onBreakEnded({
                silent: silent,
                duration: _this.slotsDuration
            });
            _this.removeCuePoint(slot.cuePoint);
            if ((0, _slotutils.isLinearSlot)(slot) && !silent || slot.type === _adtypes.PREROLL) {
                _this.contentHandlers.playerPlay();
            }
            if (!silent && completed) {
                _this.capping.saveLastBreak();
            }
            _this.endedAdsDuration = 0;
        };
        _this.onAdClick = function(event) {
            if (_this.__onAdClick(event.url)) {
                _this.engine.interactionMade();
            }
        };
        _this.requestAds = function() {
            var extraConfig = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, start = _ref.start, duration = _ref.duration;
            return _this.engine.submitRequest(_object_spread._({
                duration: duration
            }, _this.getRequestParameters(0, extraConfig)), Math.round(start));
        };
        _this.AdEngine = _adengine.AdEngine;
        _this.VideoEngine = VideoEngine;
        _this.slotsDuration = 0;
        _this.endedAdsDuration = 0;
        return _this;
    }
    _create_class._(AbstractAdExtendedBridge, [
        {
            key: "init",
            value: function init() {
                var _this = this;
                return _get._(_get_prototype_of._(AbstractAdExtendedBridge.prototype), "init", this).call(this).then(function() {
                    _this.engine = new _this.AdEngine(_this.config, {
                        VideoEngine: _this.VideoEngine,
                        videoEngineConfig: _this.videoEngineConfig,
                        sendEvent: _this.config.sendEvent
                    });
                    _this.engine.registerDisplayBase({
                        base: _this.containerRef,
                        lbanner: _this.lBannerContainerRef,
                        video: _this.videoRef,
                        companion: _this.companionRef,
                        vpaid: _this.vpaidRef || _this.containerRef
                    });
                    _this.manageEventListeners("add");
                });
            }
        },
        {
            /**
     * Will try to retrieve pre-load a slot in the 5 seconds time window given with the lowerCuePoint
     *
     * @param lowerCuePoint
     */ key: "preloadSlotAhead",
            value: function preloadSlotAhead(lowerCuePoint) {
                var higherCuePoint = lowerCuePoint + 5;
                var actualCuePoint = this.cuePoints.find(function(cuePoint) {
                    return cuePoint >= lowerCuePoint && cuePoint <= higherCuePoint;
                });
                if (actualCuePoint) {
                    var slot = this.engine.getSlot(actualCuePoint);
                    var canBreak = this.canBreak(higherCuePoint - actualCuePoint);
                    if (!slot && canBreak) {
                        _loggerutils.default.debug("ad.extended.bridge", "preloadSlotAhead", "Pre-loading slot for cuePoint ".concat(actualCuePoint));
                        this.engine.submitRequest(this.getRequestParameters(actualCuePoint, {}), actualCuePoint);
                    } else if (!canBreak) {
                        this.removeCuePoint(actualCuePoint);
                    }
                }
            }
        },
        {
            key: "triggerSlotOnSeek",
            value: function triggerSlotOnSeek(cuePoint) {
                var _this_engine_triggerSlotOnSeek, _this_engine;
                if (!this.canBreak()) {
                    return;
                }
                (_this_engine_triggerSlotOnSeek = (_this_engine = this.engine).triggerSlotOnSeek) === null || _this_engine_triggerSlotOnSeek === void 0 ? void 0 : _this_engine_triggerSlotOnSeek.call(_this_engine, cuePoint, {
                    before: this.beforeSlotStart
                });
            }
        },
        {
            key: "handleInteraction",
            value: function handleInteraction() {
                var ad = this.engine.getCurrentAd();
                if (ad && this.__onAdClick(_lodash.default.get(ad, "creatives.0.clickThroughUrl"))) {
                    this.engine.interactionMade();
                }
            }
        },
        {
            /**
     * In case of wrapperVAST, we don't want to add DEFAULT_CREATIVE_DURATION if wrapperVAST.ads is empty.
     */ key: "getSlotsDurationWithWrapperVAST",
            value: function getSlotsDurationWithWrapperVAST(currentSlot) {
                var isWrapperVAST = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var _this = this;
                return currentSlot.ads.reduce(function(acc, ad) {
                    if (!ad.creatives.length) {
                        if (ad === null || ad === void 0 ? void 0 : ad.wrapperVAST) {
                            return acc + _this.getSlotsDurationWithWrapperVAST(ad.wrapperVAST, true);
                        }
                        return acc;
                    }
                    var _ad_creatives__duration;
                    return acc + ((_ad_creatives__duration = ad.creatives[0].duration) !== null && _ad_creatives__duration !== void 0 ? _ad_creatives__duration : _constants.DEFAULT_CREATIVE_DURATION);
                }, 0) || (isWrapperVAST ? 0 : _constants.DEFAULT_CREATIVE_DURATION * currentSlot.ads.length);
            }
        },
        {
            key: "updateSlotsDuration",
            value: function updateSlotsDuration() {
                var _currentSlot_ads;
                if (!this.engine) {
                    return;
                }
                var currentSlot = this.engine.getCurrentSlot();
                if (!currentSlot || !currentSlot.loaded || !((_currentSlot_ads = currentSlot.ads) === null || _currentSlot_ads === void 0 ? void 0 : _currentSlot_ads.length)) {
                    this.slotsDuration = 0;
                    return;
                }
                this.slotsDuration = this.getSlotsDurationWithWrapperVAST(currentSlot);
            }
        },
        {
            key: "getSlotsDuration",
            value: function getSlotsDuration() {
                return this.slotsDuration;
            }
        },
        {
            /**
     * Total durations of ads of the current slot that have been already watched
     */ key: "getEndedAdsDuration",
            value: function getEndedAdsDuration() {
                return this.endedAdsDuration;
            }
        },
        {
            key: "startSlot",
            value: function startSlot(slot, param) {
                var triggerTime = param.triggerTime;
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(!slot || !_this.canBreak())) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.contentHandlers.playerPlay()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                            case 2:
                                _loggerutils.default.debug("abstract.ad.extended.bridge", "startSlot", "About to start slot", slot);
                                _this.removeCuePoint(slot.cuePoint);
                                slot.pending = false;
                                if (_this.released) {
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    4,
                                    _this.engine.playSlot(slot, {
                                        before: _this.beforeSlotStart,
                                        triggerTime: triggerTime
                                    })
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "manageEventListeners",
            value: function manageEventListeners() {
                var prefix = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "add";
                var method = "".concat(prefix, "EventListener");
                this.engine[method](_adengineevents.adEvents.REQUEST_COMPLETE, this.onRequestComplete);
                /**
         * Slot events.
         */ this.engine[method](_adengineevents.adEvents.SLOT_START, this.onSlotStart);
                this.engine[method](_adengineevents.adEvents.SLOT_ENDED, this.onSlotEnded);
                /**
         * Ad events.
         */ this.engine[method](_adengineevents.adEvents.AD_LOADED, this.eventsHandlers.onAdLoaded);
                this.engine[method](_adengineevents.adEvents.AD_STARTED, this.onAdStarted);
                this.engine[method](_adengineevents.adEvents.AD_PLAYING, this.eventsHandlers.onPlaying);
                this.engine[method](_adengineevents.adEvents.AD_PAUSED, this.eventsHandlers.onPaused);
                this.engine[method](_adengineevents.adEvents.AD_ERROR, this.onAdError);
                this.engine[method](_adengineevents.adEvents.ENGINE_ERROR, this.onAdError);
                this.engine[method](_adengineevents.adEvents.AD_CLICK_THRU, this.onAdClick);
                this.engine[method](_adengineevents.adEvents.AD_STOPPED, this.onAdEnded);
                this.engine[method](_adengineevents.adEvents.AD_SKIPPED, this.onAdSkipped);
                this.engine[method](_adengineevents.adEvents.AD_VIDEO_FIRST_QUARTILE, this.eventsHandlers.onFirstQuartile);
                this.engine[method](_adengineevents.adEvents.AD_VIDEO_MIDPOINT, this.eventsHandlers.onMidPoint);
                this.engine[method](_adengineevents.adEvents.AD_VIDEO_THIRD_QUARTILE, this.eventsHandlers.onThirdQuartile);
                this.engine[method](_adengineevents.adEvents.AD_EXPANDED_CHANGE, this.onExpandToggle);
                /**
         * Jingle events.
         */ this.engine[method](_adengineevents.jingleEvents.JINGLE_STARTED, this.eventsHandlers.onJingleStarted);
                this.engine[method](_adengineevents.jingleEvents.JINGLE_PLAYING, this.eventsHandlers.onJinglePlaying);
                this.engine[method](_adengineevents.jingleEvents.JINGLE_PAUSED, this.eventsHandlers.onJinglePaused);
                this.engine[method](_adengineevents.jingleEvents.JINGLE_SKIPPED, this.eventsHandlers.onJingleSkipped);
                this.engine[method](_adengineevents.jingleEvents.JINGLE_ERROR, this.eventsHandlers.onJingleError);
                this.engine[method](_adengineevents.jingleEvents.JINGLE_STOPPED, this.eventsHandlers.onJingleStopped);
            }
        },
        {
            key: "onExpandToggle",
            value: function onExpandToggle() {
                this.eventsHandlers.onExpandToggle(true);
            }
        },
        {
            key: "getOptionalTargeting",
            value: function getOptionalTargeting() {
                return {};
            }
        },
        {
            key: "buildTargeting",
            value: function buildTargeting(targeting) {
                var targetingKeysSeparator = this.config.targetingKeysSeparator;
                return Object.keys(targeting).map(function(key) {
                    return "".concat(key, "=").concat(targeting[key]);
                }).join(targetingKeysSeparator);
            }
        },
        {
            key: "getRequestParameters",
            value: function getRequestParameters() {
                var cuePoint = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, extraConfig = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var _this_config = this.config, _this_config_breaks = _this_config.breaks, breaks = _this_config_breaks === void 0 ? [] : _this_config_breaks, contentTargeting = _this_config.targeting, host = _this_config.host;
                var _ref = breaks.find(function(param) {
                    var breakCuePoint = param.cuePoint;
                    return breakCuePoint === cuePoint;
                }) || {}, breakTargeting = _ref.targeting;
                var targeting = _object_spread._({}, breakTargeting, contentTargeting, this.getOptionalTargeting());
                return _object_spread._({
                    cacheBusting: Date.now(),
                    host: host,
                    targeting: this.buildTargeting(targeting)
                }, extraConfig);
            }
        },
        {
            key: "removeCuePoint",
            value: function removeCuePoint(cuePoint) {
                this.updateCuePoints(this.cuePoints.filter(function(point) {
                    return point !== cuePoint;
                }));
            }
        },
        {
            key: "contentHasProgressed",
            value: function contentHasProgressed(currentTime) {
                if (!this.engine) {
                    return;
                }
                this.engine.onCuePointUpdate(currentTime);
                // Pre-load the next slot available in five seconds from now (if the cue point matches)
                // It's legacy code and is only usefull for vast loaded by cuepoint given by a backend.
                this.preloadSlotAhead(currentTime);
                var slot;
                if (this.cuePoints.indexOf(currentTime) === -1) {
                    // There is no actual cue point matching, let's check if there is a pending slot to play
                    slot = this.engine.getPendingSlot(currentTime);
                } else {
                    slot = this.engine.getSlot(currentTime);
                }
                if (slot && !slot.ended && !slot.loading) {
                    this.startSlot(slot, {
                        triggerTime: currentTime
                    });
                }
            }
        },
        {
            key: "contentHasStarted",
            value: function contentHasStarted() {
                // The content has started, we can autoPlay the next ads
                this.shouldAutoPlay = true;
            }
        },
        {
            key: "play",
            value: function play() {
                if (this.engine) {
                    var _this_engine_getRequestState = this.engine.getRequestState(), pending = _this_engine_getRequestState.pending, loaded = _this_engine_getRequestState.loaded;
                    if (this.engine.getResource()) {
                        this.engine.play();
                    } else if (pending) {
                        this.shouldAutoPlay = true;
                    } else if (loaded) {
                        this.eventsHandlers.onProviderLoaded();
                        var slot = this.engine.getSlot(0);
                        if (slot && !slot.ended) {
                            this.startSlot(slot, {
                                triggerTime: 0
                            });
                        } else {
                            this.contentHandlers.playerPlay();
                        }
                    }
                }
            }
        },
        {
            key: "isPaused",
            value: function isPaused() {
                if (this.engine) {
                    return this.engine.isPaused();
                }
                return true;
            }
        },
        {
            key: "pause",
            value: function pause() {
                if (this.engine) {
                    this.engine.pause();
                }
            }
        },
        {
            key: "stop",
            value: function stop() {
                if (this.engine) {
                    this.engine.stop();
                }
            }
        },
        {
            key: "skipAd",
            value: function skipAd() {
                if (this.engine) {
                    this.engine.skipAd();
                }
            }
        },
        {
            key: "skipBreak",
            value: function skipBreak() {
                if (this.engine) {
                    this.engine.skipBreak();
                }
            }
        },
        {
            key: "setVolume",
            value: function setVolume(volume) {
                _get._(_get_prototype_of._(AbstractAdExtendedBridge.prototype), "setVolume", this).call(this, volume);
                if (this.engine) {
                    this.engine.setVolume(volume);
                }
            }
        },
        {
            key: "resize",
            value: function resize() {
                var fullscreen = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                if (this.engine) {
                    this.engine.registerDisplayBase({
                        base: this.containerRef,
                        lbanner: this.lBannerContainerRef,
                        video: this.videoRef,
                        companion: this.companionRef
                    }, fullscreen);
                }
            }
        },
        {
            key: "reload",
            value: function reload(config) {
                _get._(_get_prototype_of._(AbstractAdExtendedBridge.prototype), "reload", this).call(this, config);
                this.release();
            }
        },
        {
            key: "release",
            value: function release() {
                _get._(_get_prototype_of._(AbstractAdExtendedBridge.prototype), "release", this).call(this);
                if (this.engine) {
                    this.manageEventListeners("remove");
                    this.engine.release();
                    this.engine = null;
                    delete this.engine;
                    this.slotsDuration = 0;
                    this.endedAdsDuration = 0;
                }
            }
        },
        {
            key: "addProvider",
            value: function addProvider(provider) {
                this.engine.addProvider(provider);
                this.updateCuePoints(_to_consumable_array._(this.cuePoints).concat(_to_consumable_array._(provider.cuePoints)));
            }
        }
    ]);
    return AbstractAdExtendedBridge;
}(_adbridge.AdBridge);


/***/ }),

/***/ 35859:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "AdBridge", ({
    enumerable: true,
    get: function() {
        return AdBridge;
    }
}));
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _to_consumable_array = __webpack_require__(30005);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(45538);
var _lodash = /*#__PURE__*/ _interop_require_default._(__webpack_require__(32699));
var _cappingutils = /*#__PURE__*/ _interop_require_default._(__webpack_require__(20329));
var _netutil = __webpack_require__(16802);
var _types = __webpack_require__(19783);
var defaultConfig = {
    capping: {
        type: "default",
        duration: 0
    },
    desiredBitrate: 0,
    hostTargetingSeparator: "?",
    minOverlayWidth: 1360,
    targetingKeysSeparator: "&"
};
var AdBridge = /*#__PURE__*/ function() {
    "use strict";
    function AdBridge(config, eventsHandlers, contentHandlers) {
        var storage = (arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}).storage;
        var _this = this;
        _class_call_check._(this, AdBridge);
        this.setAutoPlay = function(autoPlay) {
            _this.shouldAutoPlay = autoPlay;
        };
        this.onTimeUpdate = function() {
            var target = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).target;
            // Prevent external speed up for the advertisement
            if (target.playbackRate > 1) {
                target.playbackRate = 1;
            }
        };
        if (!storage.setItem || !storage.getItem) {
            throw new Error("Storage must implement setItem and getItem methods.");
        }
        this.storage = storage;
        this.released = false;
        this.config = _lodash.default.merge({}, defaultConfig, config);
        this.eventsHandlers = _object_spread._({}, eventsHandlers);
        this.contentHandlers = _object_spread._({}, contentHandlers);
        this.handleInteraction = this.handleInteraction.bind(this);
        this.eventsHandlers.__onBreakEnded = this.eventsHandlers.onBreakEnded;
        this.eventsHandlers.onBreakEnded = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var _this_eventsHandlers;
            _this.jingles.breakDisplayed = false;
            _this.jingles.sponsorDisplayed = false;
            (_this_eventsHandlers = _this.eventsHandlers).__onBreakEnded.apply(_this_eventsHandlers, _to_consumable_array._(args));
        };
        // Really important here, to not break other ad servers implementation
        this.cuePoints = [];
    }
    _create_class._(AdBridge, [
        {
            key: "canBreak",
            value: function canBreak() {
                var aheadOf = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
                if (!this.capping.canBreak(aheadOf)) {
                    this.eventsHandlers.onBreakCapping();
                    return false;
                }
                return true;
            }
        },
        {
            key: "triggerSlotOnSeek",
            value: function triggerSlotOnSeek() {}
        },
        {
            key: "setContainerRef",
            value: function setContainerRef(containerRef) {
                this.containerRef = containerRef;
            }
        },
        {
            key: "setLBannerContainerRef",
            value: function setLBannerContainerRef(lBannerContainerRef) {
                this.lBannerContainerRef = lBannerContainerRef;
            }
        },
        {
            key: "setVideoRef",
            value: function setVideoRef(videoRef) {
                this.videoRef = videoRef;
                this.videoEl = videoRef;
                if (this.videoRef && _lodash.default.get(this.config, "options.optiExpo.enabled", false)) {
                    this.videoRef.addEventListener("timeupdate", this.onTimeUpdate);
                }
            }
        },
        {
            key: "setVpaidRef",
            value: function setVpaidRef(vpaidRef) {
                this.vpaidRef = vpaidRef;
            }
        },
        {
            key: "setCompanionRef",
            value: function setCompanionRef(companionRef) {
                this.companionRef = companionRef;
            }
        },
        {
            key: "setEventSender",
            value: function setEventSender(sendEvent) {
                this.sendEvent = sendEvent;
            }
        },
        {
            key: "__onAdClick",
            value: function __onAdClick(url, callback) {
                var pauseAd = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
                var trimmedUrl = url.trim();
                if (/^https?:\/\//.test(trimmedUrl)) {
                    window.open(trimmedUrl, "_blank");
                    if (typeof callback === "function") {
                        callback();
                    }
                    if (pauseAd) {
                        this.pause();
                    }
                    this.eventsHandlers.onClicked(trimmedUrl);
                    return true;
                }
                return false;
            }
        },
        {
            key: "handleInteraction",
            value: function handleInteraction() {}
        },
        {
            key: "updateCuePoints",
            value: function updateCuePoints(newCuePoints) {
                var _this_eventsHandlers;
                this.cuePoints = newCuePoints;
                if ((_this_eventsHandlers = this.eventsHandlers) === null || _this_eventsHandlers === void 0 ? void 0 : _this_eventsHandlers.onAdBreakListUpdate) {
                    var _this_engine;
                    var _this_engine_getSlots_filter_map;
                    var nonLinearCuePoints = (_this_engine_getSlots_filter_map = (_this_engine = this.engine) === null || _this_engine === void 0 ? void 0 : _this_engine.getSlots().filter(function(slot) {
                        return slot.type === _types.Advertising.SlotType.LBANNER;
                    }).map(function(slot) {
                        return slot.cuePoint;
                    })) !== null && _this_engine_getSlots_filter_map !== void 0 ? _this_engine_getSlots_filter_map : [];
                    var isLinearCuePoint = function(cuePoint) {
                        return !nonLinearCuePoints.includes(cuePoint);
                    };
                    // Specific to mid-rolls
                    this.eventsHandlers.onAdBreakListUpdate(newCuePoints.filter(isLinearCuePoint));
                }
            }
        },
        {
            key: "init",
            value: function init() {
                var _this = this;
                return _async_to_generator._(function() {
                    var _;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.eventsHandlers.onProviderLoading();
                                _this.jingles = {
                                    breakDisplayed: false,
                                    sponsorDisplayed: false
                                };
                                // Always do config related initialization here, so it gets reloaded if there is a navigation
                                _this.capping = new _cappingutils.default(_this.config.capping, {
                                    storage: _this.storage
                                });
                                _this.updateCuePoints((_this.config.breaks || []).map(function(param) {
                                    var cuePoint = param.cuePoint;
                                    return cuePoint;
                                }));
                                _this.released = false;
                                if (!!_this.config.desiredBitrate) return [
                                    3,
                                    2
                                ];
                                _ = _this.config;
                                return [
                                    4,
                                    (0, _netutil.calculateBandwidth)()
                                ];
                            case 1:
                                _.desiredBitrate = _state.sent();
                                _state.label = 2;
                            case 2:
                                // Backward compatibility
                                _this.desiredBitrate = _this.config.desiredBitrate;
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getEstimatedDesiredBitrate",
            value: function getEstimatedDesiredBitrate() {
                return this.config.desiredBitrate;
            }
        },
        {
            key: "reload",
            value: function reload() {
                var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.config;
                this.config = _lodash.default.merge({}, defaultConfig, config);
            }
        },
        {
            key: "release",
            value: function release() {
                this.released = true;
                if (this.videoRef) {
                    this.videoRef.removeEventListener("timeupdate", this.onTimeUpdate);
                }
            }
        },
        {
            key: "contentHasEnded",
            value: function contentHasEnded() {}
        },
        {
            key: "contentHasPaused",
            value: function contentHasPaused() {}
        },
        {
            key: "contentHasStarted",
            value: function contentHasStarted() {}
        },
        {
            key: "contentHasProgressed",
            value: function contentHasProgressed() {}
        },
        {
            key: "requestAds",
            value: function requestAds() {}
        },
        {
            key: "setVolume",
            value: function setVolume(volume) {
                this.config.volume = volume;
            }
        },
        {
            key: "isEnded",
            value: function isEnded() {}
        },
        {
            key: "isPaused",
            value: function isPaused() {}
        },
        {
            key: "pause",
            value: function pause() {}
        },
        {
            key: "play",
            value: function play() {}
        },
        {
            key: "stop",
            value: function stop() {}
        },
        {
            key: "skipAd",
            value: function skipAd() {}
        },
        {
            key: "skipBreak",
            value: function skipBreak() {}
        },
        {
            key: "resize",
            value: function resize() {}
        },
        {
            key: "addProvider",
            value: function addProvider() {}
        }
    ]);
    return AdBridge;
}();


/***/ }),

/***/ 13738:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "jingleMapper", ({
    enumerable: true,
    get: function() {
        return jingleMapper;
    }
}));
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(42578);
var jingleMapper = {
    preroll: "pre-roll",
    midroll: "mid-roll"
};


/***/ }),

/***/ 78725:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    adEvents: function() {
        return adEvents;
    },
    jingleEvents: function() {
        return jingleEvents;
    }
});
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(45538);
var adEvents = {
    REQUEST_COMPLETE: "REQUEST_COMPLETE",
    SLOT_ENDED: "SLOT_ENDED",
    SLOT_START: "SLOT_START",
    ENGINE_ERROR: "ENGINE_ERROR",
    ERROR_NO_RENDERER: "ERROR_NO_RENDERER",
    ERROR_PARSE_VAST: "ERROR_PARSE_VAST",
    ERROR_TIMEOUT: "ERROR_TIMEOUT",
    AD_ERROR: "AD_ERROR",
    NO_DURATION_IN_CREATIVE: "NO_DURATION_IN_CREATIVE",
    // content from deleted ad.vpaid.events.js
    // DO NOT change the values of the following constants, as they're used by VPAID 3rd parties
    AD_INIT: "AdInit",
    AD_STARTED: "AdStarted",
    AD_VIDEO_START: "AdVideoStart",
    AD_STOPPED: "AdStopped",
    AD_SKIPPED: "AdSkipped",
    AD_LOADED: "AdLoaded",
    AD_LINEAR_CHANGE: "AdLinearChange",
    AD_SIZE_CHANGE: "AdSizeChange",
    AD_EXPANDED_CHANGE: "AdExpandedChange",
    AD_DURATION_CHANGE: "AdDurationChange",
    AD_VOLUME_CHANGE: "AdVolumeChange",
    AD_IMPRESSION: "AdImpression",
    AD_CLICK_THRU: "AdClickThru",
    AD_VIDEO_FIRST_QUARTILE: "AdVideoFirstQuartile",
    AD_VIDEO_MIDPOINT: "AdVideoMidpoint",
    AD_VIDEO_THIRD_QUARTILE: "AdVideoThirdQuartile",
    AD_VIDEO_COMPLETE: "AdVideoComplete",
    AD_USER_ACCEPT_INVITATION: "AdUserAcceptInvitation",
    AD_USER_MINIMIZE: "AdUserMinimize",
    AD_USER_CLOSE: "AdUserClose",
    AD_PAUSED: "AdPaused",
    AD_PLAYING: "AdPlaying",
    AD_LOG: "AdLog"
};
var jingleEvents = {
    JINGLE_STARTED: "JINGLE_STARTED",
    JINGLE_PLAYING: "JINGLE_PLAYING",
    JINGLE_PAUSED: "JINGLE_PAUSED",
    JINGLE_SKIPPED: "JINGLE_SKIPPED",
    JINGLE_STOPPED: "JINGLE_STOPPED",
    JINGLE_ERROR: "JINGLE_ERROR"
};


/***/ }),

/***/ 90877:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "AdEngine", ({
    enumerable: true,
    get: function() {
        return AdEngine;
    }
}));
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _to_consumable_array = __webpack_require__(30005);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(45538);
var _parserutils = __webpack_require__(7375);
var _adengineevents = __webpack_require__(78725);
var _superagent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(54247));
var _loggerutils = /*#__PURE__*/ _interop_require_default._(__webpack_require__(11905));
var _slotsmanager = __webpack_require__(16831);
var _types = __webpack_require__(19783);
var _trackingmanager = __webpack_require__(27769);
var _lodash = /*#__PURE__*/ _interop_require_default._(__webpack_require__(32699));
var _renderermanager = __webpack_require__(98570);
var _constants = __webpack_require__(92851);
var _omconstants = __webpack_require__(20784);
var _assetsutils = __webpack_require__(56565);
var _slotutils = __webpack_require__(90200);
var _aderrors = __webpack_require__(16174);
var _adtypes = __webpack_require__(28648);
var _version = __webpack_require__(60065);
var _sequence = __webpack_require__(7199);
var _renderertype = __webpack_require__(73035);
var _adengineconstant = __webpack_require__(13738);
var _adengineutils = __webpack_require__(79147);
var _renderersconstants = __webpack_require__(62048);
_parserutils.Parser.setLogger(_loggerutils.default);
var AdEngine = /*#__PURE__*/ function() {
    "use strict";
    function AdEngine(options, param) {
        var VideoEngine = param.VideoEngine, videoRef = param.videoRef, videoBase = param.videoBase, vpaidRef = param.vpaidRef, sendEvent = param.sendEvent;
        var _this = this;
        _class_call_check._(this, AdEngine);
        this.currentSlot = null;
        this.sequence = null;
        this.triggerSlotOnSeek = null;
        this.endSlot = function(slot) {
            var completed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
            if (slot && !slot.ended) {
                _this.triggerEvent({
                    type: _adengineevents.adEvents.SLOT_ENDED,
                    slot: slot,
                    completed: completed
                });
                _this.trackingManager.track(slot, "breakEnd");
                slot.ended = true;
            }
            _this.currentSlot = null;
            _this.sequence = null;
        };
        this.getThresholdLastBreak = function() {
            // We calculate the threshold with the max delay between the setup value or the seek trigger delay (to avoid play after end)
            var threshold = _this.options.contentDuration - Math.max(_this.options.features.lastBreakBeforeEndDelay || 0, _this.options.features.triggerSlotOnSeek.seekTriggerDelay / 1000, 0);
            return Math.max(threshold, 0);
        };
        this.triggerEvent = function(event) {
            _lodash.default.get(_this.subscribers, event.type, []).forEach(function(listener) {
                try {
                    listener(event);
                } catch (exception) {
                    _loggerutils.default.error("Ad Engine", "triggerEvent", "Exception occurred executing listener for ".concat(event.type), exception);
                }
            });
        };
        this.display = {
            video: videoRef,
            base: videoBase,
            vpaid: vpaidRef
        };
        this.released = false;
        this.state = {
            request: {
                pending: false,
                loaded: false
            }
        };
        this.subscribers = {};
        this.sequence = null;
        this.currentSlot = null;
        this.triggerSlotOnSeek = null;
        this.slotsManager = new _slotsmanager.SlotsManager();
        this.trackingManager = new _trackingmanager.TrackingManager(_lodash.default.get(options, "options.debug", false), undefined, sendEvent);
        this.trackingManager.configure({
            video: videoBase
        });
        this.options = _lodash.default.merge({
            desiredBitrate: 3000,
            cuePoints: [],
            volume: 0.5,
            features: {
                lazy: false,
                preloadTime: 5,
                trackWithHttps: true,
                withCredentials: true,
                triggerSlotOnSeek: {
                    enabled: false,
                    preventDelayWhenFutureBreak: 300,
                    seekTriggerDelay: 10000
                }
            }
        }, options);
        this.triggerSlotOnSeek = this.options.features.triggerSlotOnSeek.enabled ? _lodash.default.debounce(this._triggerSlotOnSeek.bind(this), this.options.features.triggerSlotOnSeek.seekTriggerDelay) : null;
        this.trackingManager.configure({
            video: videoBase,
            withHttps: this.options.features.trackWithHttps,
            deviceCategory: this.options.deviceCategory || "desktop",
            sendEvent: this.options.sendEvent
        });
        this.rendererManager = new _renderermanager.RendererManager({
            display: this.display,
            options: this.options,
            trackingManager: this.trackingManager,
            VideoEngine: VideoEngine,
            triggerEvent: this.triggerEvent
        });
        _loggerutils.default.debug("Ad Engine", "constructor", "AdEngine has been built with options", this.options);
        /**
         * Event listeners
         */ this.addEventListener(_adengineevents.adEvents.AD_IMPRESSION, function() {
            if (!_this.sequence) {
                return;
            }
            var currentAd = _this.sequence.getCurrentAd();
            _this.trackingManager.track(currentAd, "impression");
        });
        this.addEventListener(_adengineevents.adEvents.AD_ERROR, function(param) {
            var _param_error = param.error, code = _param_error.code, fatal = _param_error.fatal, firstPlayPassed = _param_error.firstPlayPassed;
            if (!_this.sequence) {
                return;
            }
            var currentAd = _this.sequence.getCurrentAd();
            if (currentAd) {
                _this.trackingManager.track(currentAd, "error", {
                    ERRORCODE: code || 900,
                    ASSETURI: _lodash.default.get(_this.getActiveCreative(), "currentAsset.src", ""),
                    CONTENTPLAYHEAD: _this.getCurrentTime()
                });
            }
            if (fatal) {
                // Wait for the next tick, and for other listeners to trigger before playing the next step.
                setTimeout(function() {
                    if (firstPlayPassed) {
                        var // ≥1 frame displayed + crash → no FB, move to next ad
                        _this_sequence;
                        (_this_sequence = _this.sequence) === null || _this_sequence === void 0 ? void 0 : _this_sequence.playNextStep(true);
                    } else {
                        var // 0 frames displayed + failure → FB applicable
                        _this_sequence1;
                        (_this_sequence1 = _this.sequence) === null || _this_sequence1 === void 0 ? void 0 : _this_sequence1.playFallbackOrNext();
                    }
                }, 0);
            }
        });
        this.addEventListener(_adengineevents.adEvents.AD_SKIPPED, function() {
            if (!_this.sequence) {
                return;
            }
            // Wait for the next tick, and for other listeners to trigger before playing the next step.
            setTimeout(function() {
                if (!_this.sequence) {
                    _loggerutils.default.warn("Ad Engine", "AD_SKIPPED", "Sequence is not initialized, cannot play next step");
                    _this.triggerEvent({
                        type: _adengineevents.adEvents.ENGINE_ERROR,
                        error: {
                            code: _aderrors.AD_SEQUENCE_NOT_INITIALIZED,
                            module: "Ad Engine",
                            message: "Sequence is not initialized when trying to play next step after skip"
                        }
                    });
                    return;
                }
                _this.sequence.playNextStep(true);
            }, 0);
        });
        this.addEventListener(_adengineevents.adEvents.AD_VIDEO_COMPLETE, function() {
            if (!_this.sequence) {
                return;
            }
            var creative = _this.getActiveCreative();
            creative.completed = true;
            _this.rendererManager.stopRenderers();
        });
        var _this1 = this;
        this.addEventListener(_adengineevents.adEvents.AD_STOPPED, /*#__PURE__*/ _async_to_generator._(function() {
            var currentAd;
            return _ts_generator._(this, function(_state) {
                if (!_this1.sequence) {
                    return [
                        2
                    ];
                }
                currentAd = _this1.sequence.getCurrentAd();
                _this1.trackingManager.track(currentAd, "impressionEnd");
                // Wait for the next tick, and for other listeners to trigger before playing the next step.
                setTimeout(function() {
                    if (!_this1.sequence) {
                        _loggerutils.default.warn("Ad Engine", "AD_STOPPED", "Sequence is not initialized, cannot play next step");
                        _this1.triggerEvent({
                            type: _adengineevents.adEvents.ENGINE_ERROR,
                            error: {
                                code: _aderrors.AD_SEQUENCE_NOT_INITIALIZED,
                                module: "Ad Engine",
                                message: "Sequence is not initialized when trying to play next step"
                            }
                        });
                        return;
                    }
                    _this1.sequence.playNextStep();
                }, 0);
                return [
                    2
                ];
            });
        }));
        this.addEventListener(_adengineevents.jingleEvents.JINGLE_ERROR, function(param) {
            var fatal = param.error.fatal;
            if (!_this.sequence) {
                return;
            }
            if (fatal) {
                setTimeout(function() {
                    var _this_sequence;
                    return (_this_sequence = _this.sequence) === null || _this_sequence === void 0 ? void 0 : _this_sequence.playFallbackOrNext();
                }, 0);
            }
        });
        this.addEventListener(_adengineevents.jingleEvents.JINGLE_SKIPPED, function() {
            if (!_this.sequence) {
                return;
            }
            setTimeout(function() {
                var _this_sequence;
                return (_this_sequence = _this.sequence) === null || _this_sequence === void 0 ? void 0 : _this_sequence.playNextStep(true);
            }, 0);
        });
        var _this2 = this;
        this.addEventListener(_adengineevents.jingleEvents.JINGLE_STOPPED, /*#__PURE__*/ _async_to_generator._(function() {
            return _ts_generator._(this, function(_state) {
                if (!_this2.sequence) {
                    return [
                        2
                    ];
                }
                setTimeout(function() {
                    var _this_sequence;
                    return (_this_sequence = _this2.sequence) === null || _this_sequence === void 0 ? void 0 : _this_sequence.playNextStep();
                }, 0);
                return [
                    2
                ];
            });
        }));
    }
    _create_class._(AdEngine, [
        {
            key: "_triggerSlotOnSeek",
            value: function _triggerSlotOnSeek(cuePoint, options) {
                var previousSlot = this.slotsManager.findFirstPreviousMidroll(cuePoint);
                var nextSlot = this.slotsManager.findFirstNextMidroll(cuePoint);
                if (this.currentSlot) {
                    _loggerutils.default.debug("Ad Engine", "_triggerSlotOnSeek", "Current slot is not null");
                    return;
                }
                if (nextSlot && !nextSlot.ended && nextSlot.cuePoint - cuePoint <= this.options.features.triggerSlotOnSeek.preventDelayWhenFutureBreak) {
                    _loggerutils.default.debug("Ad Engine", "_triggerSlotOnSeek", "Next slot is not null nor ended and close enough to be played according to config.");
                    return;
                }
                if (previousSlot && !previousSlot.ended) {
                    this.playSlot(previousSlot, _object_spread_props._(_object_spread._({}, options), {
                        triggerTime: cuePoint
                    }));
                }
            }
        },
        {
            key: "onCuePointUpdate",
            value: function onCuePointUpdate(cuePoint) {
                var _this = this;
                return _async_to_generator._(function() {
                    var _this_options_features, _this_options, _this_options1, preloadTime;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                preloadTime = (_this_options = _this.options) === null || _this_options === void 0 ? void 0 : (_this_options_features = _this_options.features) === null || _this_options_features === void 0 ? void 0 : _this_options_features.preloadTime;
                                return [
                                    4,
                                    _this.slotsManager.preloadLoadSlot(cuePoint, {
                                        preloadTime: preloadTime,
                                        withCredentials: _this.options.features.withCredentials
                                    }, ((_this_options1 = _this.options) === null || _this_options1 === void 0 ? void 0 : _this_options1.queryParams) || {})
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
     * Trigger an AD_ERROR event (wrapper around track with the current parsed VAST error URI)
     * List of VAST Errors : https://support.google.com/dfp_premium/answer/4442429
     */ key: "sendVASTError",
            value: function sendVASTError(payload, code) {
                this.trackingManager.track(payload, "error", {
                    ERRORCODE: code || 900
                });
            }
        },
        {
            key: "getRequestState",
            value: function getRequestState() {
                return this.state.request;
            }
        },
        {
            key: "getCurrentTime",
            value: function getCurrentTime() {
                if (this.getRenderer()) {
                    return this.getRenderer().getCurrentTime();
                }
                return 0;
            }
        },
        {
            key: "getContentId",
            value: function getContentId() {
                var _this_sequence;
                var currentContent = (_this_sequence = this.sequence) === null || _this_sequence === void 0 ? void 0 : _this_sequence.getCurrentContent();
                switch(currentContent === null || currentContent === void 0 ? void 0 : currentContent.type){
                    case "ad":
                    case "jingle":
                        {
                            var _currentContent_content;
                            return (_currentContent_content = currentContent.content) === null || _currentContent_content === void 0 ? void 0 : _currentContent_content.id;
                        }
                    default:
                        return "unknown";
                }
            }
        },
        {
            key: "getTitle",
            value: function getTitle() {
                var _this_sequence;
                var currentContent = (_this_sequence = this.sequence) === null || _this_sequence === void 0 ? void 0 : _this_sequence.getCurrentContent();
                switch(currentContent === null || currentContent === void 0 ? void 0 : currentContent.type){
                    case "ad":
                        {
                            var _currentContent_content;
                            return (_currentContent_content = currentContent.content) === null || _currentContent_content === void 0 ? void 0 : _currentContent_content.title;
                        }
                    case "jingle":
                        {
                            return "jingle";
                        }
                    default:
                        return "unknown";
                }
            }
        },
        {
            key: "getResource",
            value: function getResource() {
                var _this_rendererManager_getActiveRenderer;
                return ((_this_rendererManager_getActiveRenderer = this.rendererManager.getActiveRenderer()) === null || _this_rendererManager_getActiveRenderer === void 0 ? void 0 : _this_rendererManager_getActiveRenderer.getResource()) || "";
            }
        },
        {
            key: "getPlayrate",
            value: function getPlayrate() {
                if (!this.getRenderer()) return _renderersconstants.DEFAULT_PLAYBACKRATE;
                var ref = this.getRenderer().getDisplayRef();
                if (!(0, _adengineutils.isVideoElement)(ref)) {
                    return _renderersconstants.DEFAULT_PLAYBACKRATE;
                }
                return ref.playbackRate;
            }
        },
        {
            key: "getDuration",
            value: function getDuration() {
                if (this.getRenderer()) {
                    return this.getRenderer().getDuration();
                }
                return 0;
            }
        },
        {
            key: "getVersion",
            value: function getVersion() {
                return (0, _version.getPackageVersion)();
            }
        },
        {
            key: "validateSlot",
            value: function validateSlot(parsedVAST) {
                var _this = this;
                parsedVAST.ads = parsedVAST.ads.filter(function(ad) {
                    if (ad.redirects === _constants.MAX_VAST_RECURSIVITY) {
                        // 302 | Wrapper limit reached, as defined by the video player.
                        // Too many wrapper responses have been received with no InLine response
                        _this.sendVASTError(ad, 302);
                        return false;
                    }
                    return true;
                });
                // Send error for VAST version
                if (!_parserutils.Parser.validateVASTVersion(parsedVAST)) {
                    this.sendVASTError(parsedVAST, 102);
                }
            }
        },
        {
            key: "submitRequest",
            value: function submitRequest() {
                var params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, forCuePoint = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, headers = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, withCredentials = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
                var _this = this;
                _loggerutils.default.debug("Ad Engine", "submitRequest", "Submitting request to the ad server");
                this.state.request.pending = true;
                var slotIndex = null;
                var type = params.type || _adtypes.PREROLL;
                if (forCuePoint) {
                    type = _adtypes.MIDROLL;
                    if (params.duration) {
                        type = _adtypes.DAI;
                    }
                }
                if (forCuePoint !== null) {
                    slotIndex = this.slotsManager.createLoadingSlot(forCuePoint, type);
                }
                var _this_options = this.options, _this_options_host = _this_options.host, host = _this_options_host === void 0 ? "" : _this_options_host, contentDuration = _this_options.contentDuration, hostTargetingSeparator = _this_options.hostTargetingSeparator, features = _this_options.features, _this_options_queryParams = _this_options.queryParams, queryParams = _this_options_queryParams === void 0 ? {} : _this_options_queryParams;
                var _params_targeting = params.targeting, targeting = _params_targeting === void 0 ? "" : _params_targeting;
                var path = targeting ? "".concat(host).concat(hostTargetingSeparator).concat(targeting) : host;
                var currentRequest = _superagent.default.get(path).timeout(5000);
                if (headers) {
                    currentRequest.set(headers);
                }
                if (typeof withCredentials === "boolean" ? withCredentials : this.options.features.withCredentials) {
                    currentRequest.withCredentials();
                }
                return currentRequest.then(function(response) {
                    switch(response.type){
                        case "application/xml":
                        case "text/xml":
                            {
                                return _parserutils.Parser.parse(response.text, {
                                    contentDuration: contentDuration,
                                    features: features,
                                    queryParams: queryParams
                                }).then(function(param) {
                                    var slots = param.slots, format = param.format;
                                    _this.state.request.pending = false;
                                    _this.state.request.loaded = true;
                                    if (format === _types.Advertising.AD_FORMAT.VAST && forCuePoint !== null) {
                                        _this.slotsManager.loadingSuccess(slotIndex, slots[0]);
                                    } else {
                                        _this.slotsManager.updateSlots(slots);
                                    }
                                    _loggerutils.default.debug("Ad Engine", "submitRequest", "Retrieved ".concat(slots.length, " slot(s) to play"), format, _this.slotsManager.getSlots());
                                    _this.triggerEvent({
                                        type: _adengineevents.adEvents.REQUEST_COMPLETE,
                                        success: true,
                                        slots: slots,
                                        forCuePoint: forCuePoint
                                    });
                                }).catch(function(error) {
                                    _this.triggerEvent({
                                        type: _adengineevents.adEvents.ENGINE_ERROR,
                                        error: {
                                            code: _adengineevents.adEvents.ERROR_PARSE_VAST,
                                            module: "Ad Engine",
                                            message: error.message
                                        }
                                    });
                                    _this.triggerEvent({
                                        type: _adengineevents.adEvents.REQUEST_COMPLETE,
                                        success: false
                                    });
                                });
                            }
                        default:
                            _this.state.request.pending = false;
                            _this.state.request.loaded = true;
                            _loggerutils.default.error("Ad Engine", "submitRequest", "Received an unsupported Content-Type: ".concat(response.type));
                            _this.triggerEvent({
                                type: _adengineevents.adEvents.REQUEST_COMPLETE,
                                success: false
                            });
                            break;
                    }
                }).catch(function(error) {
                    _loggerutils.default.error("Ad Engine", "submitRequest", "An error has occurred trying to retrieve the ads", error);
                    var message = error.message;
                    _this.triggerEvent({
                        type: _adengineevents.adEvents.ENGINE_ERROR,
                        error: {
                            code: _aderrors.AD_REQUEST_FAILED,
                            module: "Ad Engine",
                            message: message
                        }
                    });
                    _this.triggerEvent({
                        type: _adengineevents.adEvents.REQUEST_COMPLETE,
                        success: false
                    });
                });
            }
        },
        {
            key: "registerDisplayBase",
            value: function registerDisplayBase(displayBase) {
                var fullscreen = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                this.display = displayBase;
                this.trackingManager.configure({
                    video: displayBase.video
                });
                if (this.rendererManager) {
                    this.rendererManager.configureDisplay(displayBase, fullscreen);
                }
            }
        },
        {
            key: "createSequence",
            value: function createSequence(slot) {
                var _this = this;
                this.validateSlot(slot);
                var jingles = this.getJingles(slot);
                this.trackingManager.configure({
                    slot: slot
                });
                var _this1 = this;
                var onResume = function() {
                    var _ref = _async_to_generator._(function(param) {
                        var content, type;
                        return _ts_generator._(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    content = param.content, type = param.type;
                                    // Ensure the renderers have all been reset before playing the next content
                                    return [
                                        4,
                                        _this1.rendererManager.resetRenderers()
                                    ];
                                case 1:
                                    _state.sent();
                                    if (!content) {
                                        _loggerutils.default.debug("Ad Engine", "onResume", "No current resource to play");
                                        _this1.sequence.playNextStep();
                                        return [
                                            2
                                        ];
                                    }
                                    if (type === "ad") {
                                        _this1.loadAdvertisement(content);
                                        return [
                                            2
                                        ];
                                    }
                                    _this1.loadJingle(content);
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function onResume(_) {
                        return _ref.apply(this, arguments);
                    };
                }();
                var onCompleted = function(allStepsPlayed) {
                    _this.rendererManager.resetRenderers();
                    _this.endSlot(slot, allStepsPlayed);
                };
                return new _sequence.SequenceRunner(slot, jingles, onResume, onCompleted);
            }
        },
        {
            key: "loadJingle",
            value: function loadJingle(jingle) {
                var _this_display = this.display, base = _this_display.base, video = _this_display.video;
                if (!base || !video) {
                    this.triggerEvent({
                        type: _adengineevents.jingleEvents.JINGLE_ERROR,
                        error: {
                            message: "Could not find video or base element in the display object",
                            fatal: true
                        }
                    });
                    return;
                }
                if (!jingle || !jingle.url) {
                    this.triggerEvent({
                        type: _adengineevents.jingleEvents.JINGLE_ERROR,
                        error: {
                            message: "Could not find jingle or jingle url to load",
                            fatal: true
                        }
                    });
                    return;
                }
                this.rendererManager.loadJingle(jingle);
            }
        },
        {
            key: "loadAdvertisement",
            value: function loadAdvertisement(ad) {
                var creative = this.getActiveCreative();
                var _this_display = this.display, base = _this_display.base, video = _this_display.video;
                if (!creative) {
                    this.sequence.playFallbackOrNext();
                    return;
                }
                if (!base || !video) {
                    this.triggerEvent({
                        type: _adengineevents.adEvents.AD_ERROR,
                        error: {
                            message: "Could not find video or base element in the display object",
                            fatal: true
                        }
                    });
                    return;
                }
                this.trackingManager.configure({
                    ad: ad
                });
                this.triggerEvent({
                    type: _adengineevents.adEvents.AD_INIT
                });
                this.trackingManager.track(ad, _omconstants.AD_INIT);
                var desiredBitrate = this.options.desiredBitrate;
                var linear = creative.linear, assets = creative.assets;
                var width = base.offsetWidth, height = base.offsetHeight;
                try {
                    creative.currentAsset = linear ? (0, _assetsutils.chooseLinearAsset)(assets, {
                        video: video,
                        width: width,
                        height: height,
                        desiredBitrate: desiredBitrate
                    }) : (0, _assetsutils.chooseNonLinearAsset)(assets);
                } catch (error) {
                    this.triggerEvent({
                        type: _adengineevents.adEvents.AD_ERROR,
                        error: {
                            message: error.message,
                            fatal: true,
                            code: error.code || 200
                        }
                    });
                    return;
                }
                var currentAsset = creative.currentAsset;
                if (currentAsset) {
                    if (linear && currentAsset.height !== currentAsset.width * 9 / 16) {
                        // 203 - Player expecting different size
                        this.trackingManager.track(ad, "error", {
                            ERRORCODE: 203
                        });
                    }
                    this.rendererManager.loadCreative(creative);
                    if (_lodash.default.get(ad, "companions.length", 0) > 0) {
                        this.handleCompanion(_lodash.default.last(ad.companions));
                    }
                    return;
                }
            }
        },
        {
            key: "handleCompanion",
            value: function handleCompanion(companion) {
                companion.currentAsset = (0, _assetsutils.chooseNonLinearAsset)(companion.assets);
                if (companion.currentAsset) {
                    this.rendererManager.loadCompanion(companion);
                } else {
                    _loggerutils.default.warn("Ad Engine", "playCompanions", "No playable asset has been found for the companion", companion);
                }
            }
        },
        {
            key: "getActiveCreative",
            value: function getActiveCreative() {
                var _ref = this.getCurrentAd() || {}, _ref_creatives = _ref.creatives, creatives = _ref_creatives === void 0 ? [] : _ref_creatives;
                return creatives.find(function(param) {
                    var assets = param.assets;
                    return assets && assets.length;
                });
            }
        },
        {
            key: "getCurrentAsset",
            value: function getCurrentAsset() {
                var activeCreative = this.getActiveCreative();
                return activeCreative && activeCreative.currentAsset;
            }
        },
        {
            key: "getJingles",
            value: function getJingles(slot) {
                var jingles = this.options.jingles || {};
                return {
                    before: jingles["before-" + _adengineconstant.jingleMapper[slot.type]] || [],
                    after: jingles["after-" + _adengineconstant.jingleMapper[slot.type]] || []
                };
            }
        },
        {
            key: "playSlot",
            value: function playSlot(slot, options) {
                var _this = this;
                return _async_to_generator._(function() {
                    var _this_options, error;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (options && options.triggerTime && _this.getThresholdLastBreak()) {
                                    if (options.triggerTime > _this.getThresholdLastBreak()) {
                                        _loggerutils.default.debug("Ad Engine", "playSlot", "No break, trigger time after no break threshold", _this.options);
                                        return [
                                            2
                                        ];
                                    }
                                }
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    6,
                                    ,
                                    7
                                ]);
                                return [
                                    4,
                                    _this.slotsManager.loadSlot(slot, ((_this_options = _this.options) === null || _this_options === void 0 ? void 0 : _this_options.queryParams) || {}, _this.options.features.withCredentials)
                                ];
                            case 2:
                                _this.currentSlot = _state.sent();
                                if (!_this.currentSlot) {
                                    _loggerutils.default.debug("Ad Engine", "playSlot", "No slot to play");
                                    return [
                                        2
                                    ];
                                }
                                _this.sequence = _this.createSequence(_this.currentSlot);
                                if (!(options && typeof options.before === "function")) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    options.before({
                                        slot: _this.currentSlot
                                    })
                                ];
                            case 3:
                                _state.sent();
                                _state.label = 4;
                            case 4:
                                if (_this.currentSlot && !_this.released) {
                                    _this.trackingManager.track(_this.currentSlot, "breakStart");
                                    _this.triggerEvent({
                                        type: _adengineevents.adEvents.SLOT_START,
                                        slot: _this.currentSlot
                                    });
                                }
                                return [
                                    4,
                                    _this.sequence.start()
                                ];
                            case 5:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 6:
                                error = _state.sent();
                                // Should we end the slot here too?
                                _loggerutils.default.error("Ad Engine", "playSlot", "An error occurred while trying to play the slot", error);
                                _this.endSlot(_this.currentSlot, false);
                                return [
                                    3,
                                    7
                                ];
                            case 7:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getSlot",
            value: function getSlot(cuePoint) {
                return this.slotsManager.find(cuePoint);
            }
        },
        {
            key: "getSlots",
            value: function getSlots() {
                return this.slotsManager.getSlots();
            }
        },
        {
            key: "getPendingSlot",
            value: function getPendingSlot(contentTimePosition) {
                return this.slotsManager.findPending(contentTimePosition);
            }
        },
        {
            key: "getCurrentAd",
            value: function getCurrentAd() {
                if (!this.sequence) {
                    return null;
                }
                return this.sequence.getCurrentAd();
            }
        },
        {
            key: "getCurrentSlot",
            value: function getCurrentSlot() {
                return this.currentSlot;
            }
        },
        {
            key: "interactionMade",
            value: function interactionMade() {
                if (this.getRenderer()) {
                    this.getRenderer().interactionMade();
                }
            }
        },
        {
            key: "isPaused",
            value: function isPaused() {
                var renderer = this.getRenderer();
                if ((0, _renderertype.isPausable)(renderer)) {
                    return renderer.isPaused();
                }
                return true;
            }
        },
        {
            key: "getAudioEnabled",
            value: function getAudioEnabled() {
                var renderer = this.getRenderer();
                if ((0, _renderertype.isAudioGetterEnabled)(renderer)) {
                    return renderer.getAudioEnabled();
                }
                return false;
            }
        },
        {
            key: "play",
            value: function play() {
                if (this.getRenderer()) {
                    this.getRenderer().play();
                }
            }
        },
        {
            key: "pause",
            value: function pause() {
                if (this.getRenderer()) {
                    this.getRenderer().pause();
                }
            }
        },
        {
            key: "stop",
            value: function stop() {
                var _this_triggerSlotOnSeek_cancel, _this_triggerSlotOnSeek;
                if (this.currentSlot) {
                    this.getRenderer().stop();
                    this.endSlot(this.currentSlot, false);
                }
                (_this_triggerSlotOnSeek = this.triggerSlotOnSeek) === null || _this_triggerSlotOnSeek === void 0 ? void 0 : (_this_triggerSlotOnSeek_cancel = _this_triggerSlotOnSeek.cancel) === null || _this_triggerSlotOnSeek_cancel === void 0 ? void 0 : _this_triggerSlotOnSeek_cancel.call(_this_triggerSlotOnSeek);
            }
        },
        {
            key: "skipAd",
            value: function skipAd() {
                if (this.getRenderer()) {
                    this.getRenderer().skip();
                }
            }
        },
        {
            key: "skipBreak",
            value: function skipBreak() {
                var _this_sequence;
                if (!this.sequence) {
                    return;
                }
                (_this_sequence = this.sequence) === null || _this_sequence === void 0 ? void 0 : _this_sequence.skipFutureSteps();
                this.skipAd();
                if (this.currentSlot) {
                    this.sendVASTError(this.currentSlot, 206);
                }
            }
        },
        {
            key: "setVolume",
            value: function setVolume(volume) {
                this.options.volume = volume;
                if (this.getRenderer()) {
                    this.getRenderer().setVolume(volume);
                }
            }
        },
        {
            key: "release",
            value: function release() {
                var _this_triggerSlotOnSeek_cancel, _this_triggerSlotOnSeek;
                this.released = true;
                this.subscribers = {};
                this.rendererManager.releaseRenderers();
                this.rendererManager = null;
                (_this_triggerSlotOnSeek = this.triggerSlotOnSeek) === null || _this_triggerSlotOnSeek === void 0 ? void 0 : (_this_triggerSlotOnSeek_cancel = _this_triggerSlotOnSeek.cancel) === null || _this_triggerSlotOnSeek_cancel === void 0 ? void 0 : _this_triggerSlotOnSeek_cancel.call(_this_triggerSlotOnSeek);
                this.sequence = null;
            }
        },
        {
            key: "addEventListener",
            value: function addEventListener(event, callback) {
                if (!this.subscribers[event]) {
                    this.subscribers[event] = [];
                }
                this.subscribers[event].push(callback);
            }
        },
        {
            key: "removeEventListener",
            value: function removeEventListener(event, callback) {
                var _this = this;
                if (this.subscribers[event]) {
                    this.subscribers[event].forEach(function(listener, key) {
                        if (callback === listener) {
                            delete _this.subscribers[event][key];
                        }
                    });
                }
            }
        },
        {
            key: "getRenderer",
            value: function getRenderer() {
                if (!this.rendererManager) {
                    return null;
                }
                return this.rendererManager.getActiveRenderer();
            }
        },
        {
            key: "addProvider",
            value: function addProvider(provider) {
                var slotType = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _types.Advertising.SlotType.LBANNER;
                if (slotType !== _types.Advertising.SlotType.LBANNER) {
                    return;
                }
                var _provider_host = provider.host, host = _provider_host === void 0 ? "" : _provider_host, hostTargetingSeparator = provider.hostTargetingSeparator, targetingKeysSeparator = provider.targetingKeysSeparator, targeting = provider.targeting, duration = provider.duration;
                var path = targeting ? "".concat(host).concat(hostTargetingSeparator).concat(Object.keys(targeting).map(function(key) {
                    return "".concat(key, "=").concat(targeting[key]);
                }).join(targetingKeysSeparator)) : host;
                var newSlots = provider.cuePoints.map(function(cuePoint) {
                    return _object_spread_props._(_object_spread._({}, (0, _slotutils.createEmptySlot)()), {
                        type: _types.Advertising.SlotType.LBANNER,
                        cuePoint: cuePoint,
                        adTagURI: path,
                        id: "lbanner-".concat(cuePoint),
                        options: {
                            creative: {
                                duration: duration
                            }
                        }
                    });
                });
                this.slotsManager.updateSlots(_to_consumable_array._(this.slotsManager.getSlots()).concat(_to_consumable_array._(newSlots)));
            }
        }
    ]);
    return AdEngine;
}();


/***/ }),

/***/ 79147:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "isVideoElement", ({
    enumerable: true,
    get: function() {
        return isVideoElement;
    }
}));
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(88801);
var isVideoElement = function(element) {
    return element && "playbackRate" in element;
};


/***/ }),

/***/ 16174:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    AD_COULD_NOT_PLAY: function() {
        return AD_COULD_NOT_PLAY;
    },
    AD_NO_AD_RESPONSE: function() {
        return AD_NO_AD_RESPONSE;
    },
    AD_NO_SUPPORTED_MEDIA_FILE: function() {
        return AD_NO_SUPPORTED_MEDIA_FILE;
    },
    AD_REQUEST_FAILED: function() {
        return AD_REQUEST_FAILED;
    },
    AD_SEQUENCE_NOT_INITIALIZED: function() {
        return AD_SEQUENCE_NOT_INITIALIZED;
    },
    AD_TIMED_OUT: function() {
        return AD_TIMED_OUT;
    },
    AD_UNKNOWN_ERROR: function() {
        return AD_UNKNOWN_ERROR;
    },
    vastErrorMessage: function() {
        return vastErrorMessage;
    }
});
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(65759);
var AD_UNKNOWN_ERROR = "AD_UNKNOWN_ERROR";
var AD_REQUEST_FAILED = "AD_REQUEST_FAILED";
var AD_TIMED_OUT = "AD_TIMED_OUT";
var AD_NO_SUPPORTED_MEDIA_FILE = "AD_NO_SUPPORTED_MEDIA_FILE";
var AD_COULD_NOT_PLAY = "AD_COULD_NOT_PLAY";
var AD_NO_AD_RESPONSE = "AD_NO_AD_RESPONSE";
var AD_SEQUENCE_NOT_INITIALIZED = "AD_SEQUENCE_NOT_INITIALIZED";
var vastErrorMessage = {
    100: "VAST_XML_PARSING_ERROR",
    101: "VAST_SCHEMA_VALIDATION_ERROR",
    102: "VAST_VERSION_NOT_SUPPORTED",
    200: "VAST_TRAFFICKING_ERROR",
    201: "LINEARITY_MISMATCH",
    202: "DURATION_MISMATCH",
    203: "SIZE_MISMATCH",
    206: "BREAK_SHORTENED",
    300: "VAST_GENERAL_WRAPPER_ERROR",
    301: "VAST_URI_TIMEOUT",
    302: "VAST_WRAPPER_LIMIT_REACHED",
    303: "VAST_NO_ADS_RESPONSE",
    400: "VAST_GENERAL_LINEAR_ERROR",
    401: "VAST_MEDIAFILE_NOT_FOUND",
    402: "VAST_UNABLE_TO_DOWNLOAD_MEDIAFILE",
    403: "VAST_UNSUPPORTED_MEDIATYPE_OR_CODEC",
    405: "VAST_PROGRESSIVE_DOWNLOAD_TIMEOUT",
    406: "VAST_MISSING_OR_INVALID_MEDIAFILE",
    407: "VAST_LOADING_RESOURCE_TIMEOUT",
    408: "VAST_ASSET_LOAD_ERROR",
    409: "VAST_MEDIA_INITIALIZATION_ERROR",
    410: "VAST_MEDIA_PLAYBACK_ERROR",
    500: "VAST_GENERAL_NONLINEAR_ERROR",
    501: "VAST_NONLINEAR_AD_UNSUPPORTED",
    502: "VAST_NONLINEAR_ASSET_UNSUPPORTED",
    503: "VAST_NONLINEAR_SIZE_MISMATCH",
    600: "VAST_GENERAL_COMPANION_ERROR",
    601: "VAST_COMPANION_RENDER_ERROR",
    602: "VAST_COMPANION_CREATIVE_UNSUPPORTED",
    603: "VAST_COMPANION_SIZE_MISMATCH",
    604: "VAST_COMPANION_DISPLAY_ERROR",
    900: "VAST_UNDEFINED_ERROR",
    901: "VAST_UNDEFINED_ERROR_PLAYER_SPECIFIC",
    1009: "VAST_RESOURCE_REQUIRED"
};


/***/ }),

/***/ 30927:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "StepStatus", ({
    enumerable: true,
    get: function() {
        return StepStatus;
    }
}));
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(52318);
var StepStatus = {
    READY: "ready",
    PLAYING: "playing",
    ENDED: "ended",
    SKIPPED: "skipped"
};


/***/ }),

/***/ 28648:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
//TODO: burn this file (already defined in Slot.ts)

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    DAI: function() {
        return DAI;
    },
    DISPLAY: function() {
        return DISPLAY;
    },
    MIDROLL: function() {
        return MIDROLL;
    },
    OVERLAY: function() {
        return OVERLAY;
    },
    POSTROLL: function() {
        return POSTROLL;
    },
    PREROLL: function() {
        return PREROLL;
    },
    SPONSOR: function() {
        return SPONSOR;
    }
});
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(88801);
var PREROLL = "preroll";
var MIDROLL = "midroll";
var POSTROLL = "postroll";
var DISPLAY = "display";
var OVERLAY = "overlay";
var DAI = "dai";
var SPONSOR = "sponsor";


/***/ }),

/***/ 20329:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(52318);
var _loggerutils = /*#__PURE__*/ _interop_require_default._(__webpack_require__(11905));
var Capping = /*#__PURE__*/ function() {
    "use strict";
    function Capping(config, param) {
        var storage = param.storage;
        _class_call_check._(this, Capping);
        this.config = config;
        this.storage = storage;
    }
    _create_class._(Capping, [
        {
            key: "saveLastBreak",
            value: function saveLastBreak() {
                var type = this.config.type;
                var lastBreakTimestamp = this.getBreakTimestamps();
                lastBreakTimestamp[type] = Date.now();
                this.storage.setItem("lastBreakTimestamp", JSON.stringify(lastBreakTimestamp));
            }
        },
        {
            key: "retrieveLastBreakTimestamp",
            value: function retrieveLastBreakTimestamp(type) {
                return this.getBreakTimestamps()[type];
            }
        },
        {
            key: "getBreakTimestamps",
            value: function getBreakTimestamps() {
                try {
                    return JSON.parse(this.storage.getItem("lastBreakTimestamp")) || {};
                } catch (exception) {
                    _loggerutils.default.error("Capping", "saveLastBreak", exception);
                }
                return {};
            }
        },
        {
            /**
     * Check if the ad provider could add a break
     *
     * @param aheadOf Test if the cue point in x seconds would break or no (in case of a pre-loading)
     *
     * @returns {boolean}
     */ key: "canBreak",
            value: function canBreak() {
                var aheadOf = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
                var _this_config = this.config, type = _this_config.type, duration = _this_config.duration;
                var lastBreakTimestamp = this.retrieveLastBreakTimestamp(type);
                var breakTime = Date.now() + aheadOf * 1000;
                if (lastBreakTimestamp && lastBreakTimestamp < breakTime) {
                    var cappingLimit = lastBreakTimestamp / 1000 + duration;
                    if (breakTime / 1000 < cappingLimit) {
                        _loggerutils.default.debug("Capping", "canBreak", "Minimum time between breaks not elapsed");
                        return false;
                    }
                }
                return true;
            }
        }
    ]);
    return Capping;
}();
var _default = Capping;


/***/ }),

/***/ 30642:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "styleCompanionImage", ({
    enumerable: true,
    get: function() {
        return styleCompanionImage;
    }
}));
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(37815);
var styleCompanionImage = function(ref) {
    ref.removeAttribute("width");
    ref.removeAttribute("height");
    ref.style.position = "absolute";
    ref.style.width = "100%";
    ref.style.height = "100%";
    ref.style["object-fit"] = "cover";
    ref.style.left = "50%";
    ref.style.top = "50%";
    ref.style.transform = "translate(-50%, -50%)";
};


/***/ }),

/***/ 92851:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    DEFAULT_CREATIVE_DURATION: function() {
        return DEFAULT_CREATIVE_DURATION;
    },
    MAX_VAST_RECURSIVITY: function() {
        return MAX_VAST_RECURSIVITY;
    },
    REQUEST_TIMEOUT_MS: function() {
        return REQUEST_TIMEOUT_MS;
    }
});
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(3009);
var DEFAULT_CREATIVE_DURATION = 20; // Seconds
var MAX_VAST_RECURSIVITY = 5;
var REQUEST_TIMEOUT_MS = 5000;


/***/ }),

/***/ 16802:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    calculateBandwidth: function() {
        return calculateBandwidth;
    },
    flattenBandwidths: function() {
        return flattenBandwidths;
    }
});
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(42578);
var _lodash = /*#__PURE__*/ _interop_require_default._(__webpack_require__(32699));
var _superagent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(54247));
var _loggerutils = /*#__PURE__*/ _interop_require_default._(__webpack_require__(11905));
var DEFAULT_MAX_BIT_RATE = 635;
var bandwidthTestImages = [
    "https://static.6cloud.fr/m6group_web/player/bw.jpg"
];
var requestWithoutCache = function(url) {
    return _superagent.default.get("".concat(url, "?t=").concat(Date.now())).set({
        "Cache-Control": "no-cache,no-store,must-revalidate,max-age=-1,private",
        Expires: "-1"
    }).responseType("blob").timeout(1000);
};
function estimateBandwidthFor(url) {
    var startTime = Date.now();
    return requestWithoutCache(url).then(function(response) {
        var delta = (Date.now() - startTime) / 1000;
        // response.body.size (bytes) * 8 (bits) / 1000 (Kbits) / delta (Kbits per second)
        return Math.max(Math.floor(8 * response.body.size / 1000 / delta), DEFAULT_MAX_BIT_RATE);
    })// Defaulting to minimum value in case of error
    .catch(function() {
        return null;
    });
}
var flattenBandwidths = function(bandwidths) {
    var successfulBandwidths = bandwidths.filter(function(bandwidth) {
        return !!bandwidth;
    });
    if (successfulBandwidths.length) {
        return successfulBandwidths.reduce(function(accumulator, value) {
            return accumulator + value;
        }, 0) / successfulBandwidths.length;
    }
    return DEFAULT_MAX_BIT_RATE;
};
var calculateBandwidth = function() {
    var downlink = _lodash.default.get(navigator, "connection.downlink");
    if (downlink) {
        var calculatedBandwidth = Math.max(downlink * 1000, DEFAULT_MAX_BIT_RATE);
        _loggerutils.default.debug("Bandwidth", "calculateBandwidth", "Browser returned a calculated bandwidth of ".concat(calculatedBandwidth, "Kbps"));
        return Promise.resolve(calculatedBandwidth);
    }
    return Promise.all(bandwidthTestImages.map(function(url) {
        return estimateBandwidthFor(url);
    })).then(function(bandwidths) {
        var bandwidth = flattenBandwidths(bandwidths);
        _loggerutils.default.debug("Bandwidth", "calculateBandwidth", "Calculated a ".concat(bandwidth, "Kbps bandwidth"));
        return bandwidth;
    })// Defaulting to minimum value in case of error
    .catch(function() {
        return DEFAULT_MAX_BIT_RATE;
    });
};


/***/ }),

/***/ 7199:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "SequenceRunner", ({
    enumerable: true,
    get: function() {
        return SequenceRunner;
    }
}));
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _interop_require_default = __webpack_require__(81200);
var _to_consumable_array = __webpack_require__(30005);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
var _adsequenceconstants = __webpack_require__(30927);
var _loggerutils = /*#__PURE__*/ _interop_require_default._(__webpack_require__(11905));
var _a;
var SequenceRunner = /*#__PURE__*/ function() {
    "use strict";
    function SequenceRunner(slot) {
        var jingles = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
            before: [],
            after: []
        }, onResume = arguments.length > 2 ? arguments[2] : void 0, onCompleted = arguments.length > 3 ? arguments[3] : void 0;
        _class_call_check._(this, SequenceRunner);
        this.steps = [];
        this.steps = _a.createSteps(slot, jingles);
        this.onResume = onResume;
        this.onCompleted = onCompleted;
        _loggerutils.default.debug("SequenceRunner", "constructor", "SequenceRunner has been built with steps:", this.steps);
    }
    _create_class._(SequenceRunner, [
        {
            key: "resume",
            value: function resume(step) {
                var _this = this;
                return _async_to_generator._(function() {
                    var _this_onResume, _this1, currentContent;
                    return _ts_generator._(this, function(_state) {
                        currentContent = _this.getStepContent(step);
                        _loggerutils.default.debug("SequenceRunner", "resume", "Resuming sequence", currentContent);
                        return [
                            2,
                            (_this_onResume = (_this1 = _this).onResume) === null || _this_onResume === void 0 ? void 0 : _this_onResume.call(_this1, {
                                content: currentContent,
                                type: step.type
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "getNextStep",
            value: function getNextStep() {
                return this.steps.find(function(step) {
                    return step.status === _adsequenceconstants.StepStatus.READY;
                });
            }
        },
        {
            key: "getCurrentStep",
            value: function getCurrentStep() {
                return this.steps.find(function(step) {
                    return step.status === _adsequenceconstants.StepStatus.PLAYING;
                });
            }
        },
        {
            key: "onContentEnded",
            value: function onContentEnded() {
                var currentAd = this.getCurrentAd();
                // Early return if no ad is found meaning it could be a jingle.
                if (!currentAd) return;
                // Clear played ad from all fallbacks in next steps
                this.steps.forEach(function(step) {
                    if (step.type === "ad" && step.status === _adsequenceconstants.StepStatus.READY) {
                        step.fallback = step.fallback.filter(function(ad) {
                            return ad !== currentAd;
                        });
                    }
                });
            }
        },
        {
            key: "getStepContent",
            value: function getStepContent(step) {
                if (!step.resourceNotPlayable) {
                    return step.resource;
                }
                return step.fallback[0];
            }
        },
        {
            key: "start",
            value: function start() {
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        _loggerutils.default.debug("SequenceRunner", "start", "Starting sequence");
                        return [
                            2,
                            _this.playNextStep()
                        ];
                    });
                })();
            }
        },
        {
            key: "getCurrentAd",
            value: function getCurrentAd() {
                var currentContent = this.getCurrentContent();
                if (!currentContent || currentContent.type !== "ad") return undefined;
                return currentContent.content;
            }
        },
        {
            key: "getCurrentContent",
            value: function getCurrentContent() {
                var currentStep = this.getCurrentStep();
                if (!currentStep) return undefined;
                return {
                    content: this.getStepContent(currentStep),
                    type: currentStep === null || currentStep === void 0 ? void 0 : currentStep.type
                };
            }
        },
        {
            key: "playNextStep",
            value: function playNextStep() {
                var skipped = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                var _this = this;
                return _async_to_generator._(function() {
                    var currentStep, nextStep, allStepsPlayed;
                    return _ts_generator._(this, function(_state) {
                        // Handle end of current step
                        _this.onContentEnded();
                        currentStep = _this.getCurrentStep();
                        if (currentStep) {
                            currentStep.status = skipped ? _adsequenceconstants.StepStatus.SKIPPED : _adsequenceconstants.StepStatus.ENDED;
                        }
                        // Start next step
                        nextStep = _this.getNextStep();
                        if (!nextStep) {
                            allStepsPlayed = _this.steps.every(function(step) {
                                return step.status === _adsequenceconstants.StepStatus.ENDED;
                            });
                            _this.onCompleted(allStepsPlayed);
                            return [
                                2
                            ];
                        }
                        _loggerutils.default.debug("SequenceRunner", "playNextStep", "Next step", nextStep);
                        nextStep.status = _adsequenceconstants.StepStatus.PLAYING;
                        return [
                            2,
                            _this.resume(nextStep)
                        ];
                    });
                })();
            }
        },
        {
            key: "playFallbackOrNext",
            value: function playFallbackOrNext() {
                var _this = this;
                return _async_to_generator._(function() {
                    var _currentStep_fallback, currentStep;
                    return _ts_generator._(this, function(_state) {
                        currentStep = _this.getCurrentStep();
                        // Skip to the next step if no fallback or resource has already failed
                        // Otherwise, mark resource as not playable and resume with fallback
                        if (!currentStep || currentStep.resourceNotPlayable || !((_currentStep_fallback = currentStep.fallback) === null || _currentStep_fallback === void 0 ? void 0 : _currentStep_fallback.length)) {
                            _loggerutils.default.debug("SequenceRunner", "playFallbackOrNext", "No fallback or resource has already failed");
                            return [
                                2,
                                _this.playNextStep()
                            ];
                        }
                        _this.onContentEnded();
                        currentStep.resourceNotPlayable = true;
                        _loggerutils.default.debug("SequenceRunner", "playFallbackOrNext", "Playing fallback for current step:", currentStep);
                        return [
                            2,
                            _this.resume(currentStep)
                        ];
                    });
                })();
            }
        },
        {
            key: "skipFutureSteps",
            value: function skipFutureSteps() {
                _loggerutils.default.debug("SequenceRunner", "skipFutureSteps", "Skipping future ad steps");
                this.steps.forEach(function(step) {
                    // For now only AdSteps are skippable
                    if (step.type === "ad" && step.status === _adsequenceconstants.StepStatus.READY) {
                        step.status = _adsequenceconstants.StepStatus.SKIPPED;
                    }
                });
            }
        }
    ], [
        {
            key: "createSteps",
            value: function createSteps(slot, jingles) {
                var slotSteps = _a.processSlot(slot);
                // Don't add jingle steps if there is no ad to play in bewtween
                if (!slotSteps.length) {
                    return [];
                }
                return _to_consumable_array._(_a.processJingles(jingles.before)).concat(_to_consumable_array._(slotSteps), _to_consumable_array._(_a.processJingles(jingles.after)));
            }
        }
    ]);
    return SequenceRunner;
}();
_a = SequenceRunner;
/**
 * Generic traversal over an Ad[] that classifies each ad and delegates to callbacks:
 * - onLeaf: called for inline ads (not a wrapper)
 * - onWrapper: called for wrapper ads whose inner slot contains ads
 * - onEmptyWrapper: called for wrapper ads whose inner slot is empty (defaults to skipping)
 */ SequenceRunner.resolveWrapper = function(param) {
    var ads = param.ads, onLeaf = param.onLeaf, onWrapper = param.onWrapper, _param_onEmptyWrapper = param.onEmptyWrapper, onEmptyWrapper = _param_onEmptyWrapper === void 0 ? function() {
        return [];
    } : _param_onEmptyWrapper;
    return ads.flatMap(function(ad) {
        var _innerSlot_ads;
        if (!ad.isWrapper) return onLeaf(ad);
        var innerSlot = ad.wrapperVAST;
        if (!(innerSlot === null || innerSlot === void 0 ? void 0 : (_innerSlot_ads = innerSlot.ads) === null || _innerSlot_ads === void 0 ? void 0 : _innerSlot_ads.length)) {
            return onEmptyWrapper(ad);
        }
        return onWrapper(innerSlot);
    });
};
SequenceRunner.resolveAds = function() {
    var ads = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return _a.resolveWrapper({
        ads: ads,
        onLeaf: function(ad) {
            return [
                ad
            ];
        },
        onWrapper: function(innerSlot) {
            return _a.resolveAds(innerSlot.ads);
        }
    });
};
SequenceRunner.processSlot = function(slot) {
    var _slot_buffet;
    var resolvedBuffets = _a.resolveAds((_slot_buffet = slot.buffet) !== null && _slot_buffet !== void 0 ? _slot_buffet : []);
    return _a.resolveWrapper({
        ads: slot.ads,
        onLeaf: function(ad) {
            return [
                {
                    resource: ad,
                    fallback: resolvedBuffets,
                    status: _adsequenceconstants.StepStatus.READY,
                    resourceNotPlayable: false,
                    type: "ad"
                }
            ];
        },
        onWrapper: function(innerSlot) {
            return _a.processSlot(innerSlot);
        },
        onEmptyWrapper: function(wrapperAd) {
            if (!wrapperAd.fallbackonnoad) return [];
            return [
                {
                    resource: undefined,
                    fallback: resolvedBuffets,
                    status: _adsequenceconstants.StepStatus.READY,
                    resourceNotPlayable: true,
                    type: "ad"
                }
            ];
        }
    });
};
SequenceRunner.processJingles = function() {
    var jingles = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return jingles.map(function(jingle) {
        return {
            resource: jingle,
            fallback: [],
            status: _adsequenceconstants.StepStatus.READY,
            resourceNotPlayable: false,
            type: "jingle"
        };
    });
};


/***/ }),

/***/ 90200:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    createEmptySlot: function() {
        return createEmptySlot;
    },
    hasAds: function() {
        return hasAds;
    },
    isEmpty: function() {
        return isEmpty;
    },
    isLinearSlot: function() {
        return isLinearSlot;
    }
});
var _to_consumable_array = __webpack_require__(30005);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(88801);
var _types = __webpack_require__(19783);
var _adtypes = __webpack_require__(28648);
var isEmpty = function(value) {
    return !value || value.length <= 0;
};
var hasAds = function(slot) {
    if (!slot || isEmpty(slot.ads) && isEmpty(slot.buffet)) {
        return false;
    }
    return _to_consumable_array._(slot.ads).concat(_to_consumable_array._(slot.buffet || [])).some(function(ad) {
        if (!ad) {
            return false;
        }
        if (!isEmpty(ad.creatives) || !isEmpty(ad.companions)) {
            return true;
        }
        if (ad.wrapperVAST) {
            return hasAds(ad.wrapperVAST);
        }
        return false;
    });
};
var isLinearSlot = function(slot) {
    return ![
        _adtypes.DAI,
        _types.Advertising.SlotType.LBANNER
    ].includes(slot.type);
};
var createEmptySlot = function() {
    return {
        cuePoint: null,
        ads: [],
        buffet: [],
        id: undefined,
        type: _types.Advertising.SlotType.UNKNOWN,
        loaded: false,
        loading: false,
        pending: false,
        tracking: {
            error: []
        }
    };
};


/***/ }),

/***/ 64913:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    appendTagsPixel: function() {
        return appendTagsPixel;
    },
    createPixel: function() {
        return createPixel;
    },
    getTrackingUrl: function() {
        return getTrackingUrl;
    },
    track: function() {
        return track;
    }
});
var _interop_require_default = __webpack_require__(81200);
var _to_consumable_array = __webpack_require__(30005);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
var _lodash = /*#__PURE__*/ _interop_require_default._(__webpack_require__(32699));
var _loggerutils = /*#__PURE__*/ _interop_require_default._(__webpack_require__(11905));
var getTrackingUrl = function(tracking) {
    var replacements = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, withHttps = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    var url = tracking;
    _lodash.default.forOwn(replacements, function(value, key) {
        url = url.replace("[".concat(key, "]"), value);
    });
    var random = Date.now().toString();
    url = url.replace("[RANDOM]", random);
    url = url.replace("[CACHEBUSTING]", random);
    url = withHttps ? url : url.replace("https", "http");
    return url;
};
var createPixel = function(src) {
    var image = new Image();
    image.src = src;
};
var appendTagsPixel = function(pixelConfig, tags) {
    var endpoint = pixelConfig.endpoint, paramName = pixelConfig.paramName, _pixelConfig_params = pixelConfig.params, params = _pixelConfig_params === void 0 ? {} : _pixelConfig_params;
    var queryParameters = Object.keys(params).map(function(key) {
        return "".concat(key, "=").concat(encodeURIComponent(params[key]));
    });
    if (paramName) {
        queryParameters.push("".concat(paramName, "=").concat(encodeURIComponent(tags.join(","))));
    } else {
        var _queryParameters;
        (_queryParameters = queryParameters).push.apply(_queryParameters, _to_consumable_array._(tags));
    }
    createPixel("".concat(endpoint, "?").concat(queryParameters.join("&")));
};
var track = function(target, event) {
    var replacements = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var tracking = _lodash.default.get(target, "tracking.".concat(event));
    var id = _lodash.default.get(target, "id") || _lodash.default.get(target, "adid");
    _loggerutils.default.warn("tracking.util", "track", "DEPRECATED METHOD, Use tracking manager instead");
    _loggerutils.default.debug("tracking.util", "track", "Tracking event <".concat(event, "> for entity ").concat(id));
    if (tracking instanceof Array) {
        tracking.forEach(function(tr) {
            return createPixel(getTrackingUrl(tr, replacements));
        });
    } else if (tracking) {
        createPixel(getTrackingUrl(tracking, replacements));
    }
};


/***/ }),

/***/ 16831:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    SLOT_ERRORS: function() {
        return SLOT_ERRORS;
    },
    SlotsManager: function() {
        return SlotsManager;
    }
});
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _to_consumable_array = __webpack_require__(30005);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(42578);
var _lodash = /*#__PURE__*/ _interop_require_default._(__webpack_require__(32699));
var _types = __webpack_require__(19783);
var _adtypes = __webpack_require__(28648);
var _parserutils = __webpack_require__(7375);
var _loggerutils = /*#__PURE__*/ _interop_require_default._(__webpack_require__(11905));
var _referenceutils = __webpack_require__(75339);
var _slotutils = __webpack_require__(90200);
var getSlotType = function(slot) {
    if (slot.type === _adtypes.OVERLAY) {
        return _types.Advertising.SlotType.OVERLAY;
    }
    if (slot.type === _types.Advertising.SlotType.LBANNER) {
        return slot.type;
    }
    return slot.cuePoint === 0 ? _types.Advertising.SlotType.PREROLL : _types.Advertising.SlotType.MIDROLL;
};
var SLOT_ERRORS;
(function(SLOT_ERRORS) {
    SLOT_ERRORS["UNREFERENCED_SLOT_LOAD"] = "Slot should be referenced before being loaded";
    SLOT_ERRORS["UNKNOWN_REFERENCED_SLOT_LOAD"] = "No referenced slot found with given slot.";
    SLOT_ERRORS["EMPTY_SLOT_LOAD"] = "Slot should be given in params for loading an slot";
})(SLOT_ERRORS || (SLOT_ERRORS = {}));
var SlotsManager = /*#__PURE__*/ function() {
    "use strict";
    function SlotsManager() {
        _class_call_check._(this, SlotsManager);
        this.slots = [];
        this.inProgress = {};
    }
    _create_class._(SlotsManager, [
        {
            key: "getSlots",
            value: function getSlots() {
                return this.slots;
            }
        },
        {
            key: "patchSlot",
            value: function patchSlot(reference, patch) {
                var slot = this.get(reference);
                this.updateSlot(reference, _lodash.default.merge({}, slot, patch));
            }
        },
        {
            key: "updateSlot",
            value: function updateSlot(reference, updatedSlot) {
                this.slots = this.slots.map(function(item) {
                    return item.reference === reference ? updatedSlot : item;
                });
            }
        },
        {
            key: "get",
            value: function get(reference) {
                return this.slots.find(function(slot) {
                    return slot.reference === reference;
                });
            }
        },
        {
            key: "find",
            value: function find(cuePoint, options) {
                if (options && options.preloadTime) {
                    return this.slots.find(function(slot) {
                        return cuePoint <= slot.cuePoint && slot.cuePoint <= cuePoint + options.preloadTime;
                    });
                }
                return this.slots.find(function(slot) {
                    return slot.cuePoint === cuePoint;
                });
            }
        },
        {
            key: "findFirstPreviousMidroll",
            value: function findFirstPreviousMidroll(cuePoint) {
                return _to_consumable_array._(this.slots)// Order slots by cuepoint (descending order)
                .sort(function(slot1, slot2) {
                    return slot2.cuePoint - slot1.cuePoint;
                }).find(function(slot) {
                    return slot.type === _types.Advertising.SlotType.MIDROLL && slot.cuePoint <= cuePoint;
                });
            }
        },
        {
            key: "findFirstNextMidroll",
            value: function findFirstNextMidroll(cuePoint) {
                return _to_consumable_array._(this.slots)// Order slots by cuepoint (descending order)
                .sort(function(slot1, slot2) {
                    return slot1.cuePoint - slot2.cuePoint;
                }).find(function(slot) {
                    return slot.type === _types.Advertising.SlotType.MIDROLL && slot.cuePoint >= cuePoint;
                });
            }
        },
        {
            key: "findPending",
            value: function findPending(timeCode) {
                return this.slots.find(function(slot) {
                    return slot.pending && !slot.loading && timeCode >= slot.cuePoint;
                });
            }
        },
        {
            key: "updateSlots",
            value: function updateSlots(slots) {
                this.slots = slots.map(function(parsedResponseSlot) {
                    return _object_spread_props._(_object_spread._({}, _lodash.default.cloneDeep(parsedResponseSlot)), {
                        reference: (parsedResponseSlot === null || parsedResponseSlot === void 0 ? void 0 : parsedResponseSlot.reference) || (0, _referenceutils.uniqueReference)(),
                        // keep to not change the logic but should not exist
                        type: getSlotType(parsedResponseSlot)
                    });
                });
            }
        },
        {
            key: "slotLoader",
            value: function slotLoader(slot, queryParams) {
                var withCredentials = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
                var _this = this;
                return _async_to_generator._(function() {
                    var loadedSlot;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!slot || slot.loaded || !slot.adTagURI) {
                                    return [
                                        2,
                                        slot
                                    ];
                                }
                                _loggerutils.default.debug("SlotsManager", "loadSlot", "Loading Slot (".concat(slot.reference, ") for cuePoint ").concat(slot.cuePoint, " /n url: ").concat(slot.adTagURI));
                                return [
                                    4,
                                    _parserutils.Parser.retrieveSlot(slot, queryParams, withCredentials)
                                ];
                            case 1:
                                loadedSlot = _state.sent();
                                if (!loadedSlot) {
                                    _loggerutils.default.debug("SlotsManager", "loadSlot", "Fail when loading slot (".concat(slot.reference, ") for cuePoint ").concat(slot.cuePoint, " /n url: ").concat(slot.adTagURI));
                                    _this.patchSlot(slot.reference, {
                                        loaded: true,
                                        loadFailed: true
                                    });
                                    return [
                                        2,
                                        _this.get(slot.reference)
                                    ];
                                }
                                loadedSlot.reference = slot.reference;
                                // replace the loaded slot in the same position
                                _this.updateSlot(slot.reference, loadedSlot);
                                _loggerutils.default.debug("SlotsManager", "loadSlot", "Successfully load of Slot (".concat(slot.reference, ") for cuePoint ").concat(slot.cuePoint));
                                return [
                                    2,
                                    loadedSlot
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "preloadLoadSlot",
            value: function preloadLoadSlot(cuePoint, options, queryParams) {
                var _this = this;
                return _async_to_generator._(function() {
                    var slotToPreload;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                slotToPreload = _this.find(cuePoint, options);
                                if (!slotToPreload || slotToPreload.loaded) {
                                    return [
                                        2
                                    ];
                                }
                                _loggerutils.default.debug("SlotsManager", "loadSlot", "Preloading Slot (".concat(slotToPreload.reference, ") for cuePoint ").concat(slotToPreload.cuePoint));
                                return [
                                    4,
                                    _this.loadSlot(slotToPreload, queryParams, options === null || options === void 0 ? void 0 : options.withCredentials)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "loadSlot",
            value: function loadSlot(slot, queryParams) {
                var withCredentials = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
                var _this = this;
                return _async_to_generator._(function() {
                    var lastSlotVersion, loadedSlot;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!slot) {
                                    throw new Error(SLOT_ERRORS.EMPTY_SLOT_LOAD);
                                }
                                if (!slot.reference) {
                                    throw new Error(SLOT_ERRORS.UNREFERENCED_SLOT_LOAD);
                                }
                                lastSlotVersion = _this.get(slot.reference);
                                if (!lastSlotVersion) {
                                    throw new Error(SLOT_ERRORS.UNKNOWN_REFERENCED_SLOT_LOAD);
                                }
                                if (!_this.inProgress[slot.reference]) {
                                    _this.inProgress[slot.reference] = _this.slotLoader(lastSlotVersion, queryParams, withCredentials);
                                }
                                return [
                                    4,
                                    _this.inProgress[slot.reference]
                                ];
                            case 1:
                                loadedSlot = _state.sent();
                                delete _this.inProgress[slot.reference];
                                return [
                                    2,
                                    loadedSlot
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
     * Legacy Methode
     * Usage with Vast
     */ key: "createLoadingSlot",
            value: function createLoadingSlot(cuePoint, type) {
                var slot = _object_spread_props._(_object_spread._({}, (0, _slotutils.createEmptySlot)()), {
                    reference: (0, _referenceutils.uniqueReference)(),
                    cuePoint: cuePoint,
                    ads: [],
                    loading: true,
                    // in case of mid-rolls, the slot is pre-loaded before its own cuePoint
                    pending: cuePoint !== 0,
                    type: type
                });
                this.slots = [
                    slot
                ].concat(_to_consumable_array._(this.slots));
                return slot.reference;
            }
        },
        {
            key: "loadingSuccess",
            value: function loadingSuccess(reference, patch) {
                var updatedSlot = _object_spread_props._(_object_spread._({}, this.get(reference), _lodash.default.cloneDeep(patch)), {
                    loading: false
                });
                this.updateSlot(reference, updatedSlot);
            }
        }
    ]);
    return SlotsManager;
}();


/***/ }),

/***/ 60065:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "getPackageVersion", ({
    enumerable: true,
    get: function() {
        return getPackageVersion;
    }
}));
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
var _packagejson = /*#__PURE__*/ _interop_require_default._(__webpack_require__(13700));
var getPackageVersion = function() {
    return _packagejson.default.version;
};


/***/ }),

/***/ 25854:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    AbstractAdExtendedBridge: function() {
        return _abstractadextendedbridge.AbstractAdExtendedBridge;
    },
    AdBridge: function() {
        return _adbridge.AdBridge;
    },
    AdEngine: function() {
        return _adengine.AdEngine;
    },
    OM_CONSTANTS: function() {
        return _omconstants;
    },
    OmTracking: function() {
        return _omtracking.OmTracking;
    },
    Parser: function() {
        return _parserutils.Parser;
    },
    TrackingManager: function() {
        return _trackingmanager.TrackingManager;
    },
    adEvents: function() {
        return _adengineevents.adEvents;
    },
    adTypes: function() {
        return _adtypes;
    },
    appendTagsPixel: function() {
        return _trackingutil.appendTagsPixel;
    },
    chooseLinearAsset: function() {
        return _assetsutils.chooseLinearAsset;
    },
    jingleEvents: function() {
        return _adengineevents.jingleEvents;
    },
    styleCompanionImage: function() {
        return _companionutil.styleCompanionImage;
    },
    track: function() {
        return _trackingutil.track;
    }
});
var _interop_require_wildcard = __webpack_require__(95316);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(37815);
var _parserutils = __webpack_require__(7375);
var _assetsutils = __webpack_require__(56565);
var _abstractadextendedbridge = __webpack_require__(2264);
var _adbridge = __webpack_require__(35859);
var _adengine = __webpack_require__(90877);
var _adengineevents = __webpack_require__(78725);
var _adtypes = /*#__PURE__*/ _interop_require_wildcard._(__webpack_require__(28648));
var _trackingutil = __webpack_require__(64913);
var _companionutil = __webpack_require__(30642);
var _omtracking = __webpack_require__(36780);
var _trackingmanager = __webpack_require__(27769);
var _omconstants = /*#__PURE__*/ _interop_require_wildcard._(__webpack_require__(20784));


/***/ }),

/***/ 48227:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _class_call_check = __webpack_require__(67818);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(3009);
var BaseRenderer = function BaseRenderer() {
    "use strict";
    _class_call_check._(this, BaseRenderer);
};
var _default = BaseRenderer;


/***/ }),

/***/ 89061:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _get = __webpack_require__(60528);
var _get_prototype_of = __webpack_require__(35196);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _create_super = __webpack_require__(6400);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(65759);
__webpack_require__(3009);
var _renderer = /*#__PURE__*/ _interop_require_default._(__webpack_require__(2549));
var _constants = __webpack_require__(97440);
var _adengineevents = __webpack_require__(78725);
var _loggerutils = /*#__PURE__*/ _interop_require_default._(__webpack_require__(11905));
var _companionutil = __webpack_require__(30642);
var CompanionRenderer = /*#__PURE__*/ function(Renderer) {
    "use strict";
    _inherits._(CompanionRenderer, Renderer);
    var _super = _create_super._(CompanionRenderer);
    function CompanionRenderer() {
        _class_call_check._(this, CompanionRenderer);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.eventsHandler = function(event) {
            var clickThroughUrl = _this.creative.clickThroughUrl;
            if (clickThroughUrl) {
                // Do not let the event propagate to the parent container
                event.preventDefault();
                event.stopPropagation();
                _this.dispatcher({
                    type: _adengineevents.adEvents.AD_CLICK_THRU,
                    url: clickThroughUrl
                });
            }
        };
        _this.onLoad = function() {
            _this.dispatcher({
                type: _adengineevents.adEvents.AD_LOADED
            });
        };
        return _this;
    }
    _create_class._(CompanionRenderer, [
        {
            key: "setSource",
            value: function setSource(asset) {
                var _this = this;
                switch(asset.type){
                    case "iframe":
                        this.element = document.createElement("iframe");
                        this.element.src = asset.src;
                        this.element.onload = this.onLoad;
                        break;
                    case "html":
                        this.element = document.createElement("div");
                        this.element.innerHTML = asset.src;
                        break;
                    case "static":
                        switch(asset.creativetype){
                            case "image/gif":
                            case "image/jpeg":
                            case "image/png":
                                this.element = document.createElement("img");
                                this.element.src = asset.src;
                                this.element.addEventListener("load", this.onLoad);
                                (0, _companionutil.styleCompanionImage)(this.element);
                                break;
                            case "application/javascript":
                            case "application/x-javascript":
                                this.element = document.createElement("script");
                                this.element.src = asset.src;
                                this.element.onload = this.onLoad;
                                break;
                            default:
                                break;
                        }
                        break;
                    default:
                        _loggerutils.default.error("Companion Renderer", "setSource", "".concat(asset.type, " is not a valid companion type"));
                        break;
                }
                if (this.element) {
                    _loggerutils.default.debug("Companion Renderer", "setSource", "Appending companion element to the companions div", this.element);
                    // Create both click and touch event.
                    // So we cover every case (mobile and desktop)
                    _constants.LISTENED_EVENTS.forEach(function(interaction) {
                        return _this.element.addEventListener(interaction, _this.eventsHandler);
                    });
                    this.ref.appendChild(this.element);
                }
            }
        },
        {
            key: "tracking",
            value: function tracking(event) {
                if (event.type === _adengineevents.adEvents.AD_LOADED) {
                    return _get._(_get_prototype_of._(CompanionRenderer.prototype), "tracking", this).call(this, _object_spread_props._(_object_spread._({}, event), {
                        type: _adengineevents.adEvents.AD_STARTED
                    }));
                }
                return _get._(_get_prototype_of._(CompanionRenderer.prototype), "tracking", this).call(this, event);
            }
        },
        {
            key: "clearElement",
            value: function clearElement() {
                var _this = this;
                if (this.element) {
                    _constants.LISTENED_EVENTS.forEach(function(interaction) {
                        return _this.element.removeEventListener(interaction, _this.eventsHandler);
                    });
                    this.element.removeEventListener("load", this.onLoad);
                    this.element.onload = null;
                    this.ref.removeChild(this.element);
                    this.element = null;
                }
            }
        },
        {
            key: "release",
            value: function release() {
                var _this = this;
                var _this1 = this, _superprop_get_release = function() {
                    return _get._(_get_prototype_of._(CompanionRenderer.prototype), "release", _this);
                };
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        _this1.clearElement();
                        _superprop_get_release().call(_this1);
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "reset",
            value: function reset() {
                var _this = this;
                var _this1 = this, _superprop_get_reset = function() {
                    return _get._(_get_prototype_of._(CompanionRenderer.prototype), "reset", _this);
                };
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        _this1.clearElement();
                        _superprop_get_reset().call(_this1);
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "getResource",
            value: function getResource() {
                var _this_creative_currentAsset, _this_creative;
                return (_this_creative = this.creative) === null || _this_creative === void 0 ? void 0 : (_this_creative_currentAsset = _this_creative.currentAsset) === null || _this_creative_currentAsset === void 0 ? void 0 : _this_creative_currentAsset.src;
            }
        }
    ]);
    return CompanionRenderer;
}(_renderer.default);
var _default = CompanionRenderer;


/***/ }),

/***/ 97440:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "LISTENED_EVENTS", ({
    enumerable: true,
    get: function() {
        return LISTENED_EVENTS;
    }
}));
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(65759);
var LISTENED_EVENTS = [
    "touchend",
    "click"
];


/***/ }),

/***/ 89630:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _assert_this_initialized = __webpack_require__(99561);
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _create_super = __webpack_require__(6400);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(52318);
var _baseRender = /*#__PURE__*/ _interop_require_default._(__webpack_require__(48227));
var _loggerutils = /*#__PURE__*/ _interop_require_default._(__webpack_require__(11905));
var _mediaengine = __webpack_require__(62221);
var _adengineevents = __webpack_require__(78725);
var _promiseutils = __webpack_require__(69827);
var _renderersconstants = __webpack_require__(62048);
var JingleRenderer = /*#__PURE__*/ function(BaseRenderer) {
    "use strict";
    _inherits._(JingleRenderer, BaseRenderer);
    var _super = _create_super._(JingleRenderer);
    function JingleRenderer(ref, dispatcher, options) {
        _class_call_check._(this, JingleRenderer);
        var _this;
        _this = _super.call(this);
        var _this1 = _assert_this_initialized._(_this);
        _this.eventHandler = function() {
            var _ref = _async_to_generator._(function(event) {
                var e;
                return _ts_generator._(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            switch(event){
                                case _mediaengine.VIDEO_EVENTS.LOAD_START:
                                    return [
                                        3,
                                        1
                                    ];
                                case _mediaengine.VIDEO_EVENTS.ERROR:
                                    return [
                                        3,
                                        6
                                    ];
                                case _mediaengine.VIDEO_EVENTS.CAN_PLAY:
                                    return [
                                        3,
                                        7
                                    ];
                                case _mediaengine.VIDEO_EVENTS.PAUSE:
                                    return [
                                        3,
                                        8
                                    ];
                                case _mediaengine.VIDEO_EVENTS.PLAYING:
                                    return [
                                        3,
                                        9
                                    ];
                                case _mediaengine.VIDEO_EVENTS.ENDED:
                                    return [
                                        3,
                                        10
                                    ];
                            }
                            return [
                                3,
                                11
                            ];
                        case 1:
                            if (_this1.ref.autoplay) return [
                                2
                            ];
                            _state.label = 2;
                        case 2:
                            _state.trys.push([
                                2,
                                4,
                                ,
                                5
                            ]);
                            return [
                                4,
                                (0, _promiseutils.timedOutPromise)(Promise.resolve(_this1.play()), _renderersconstants.AD_PLAY_TIMEOUT_MS)
                            ];
                        case 3:
                            _state.sent();
                            return [
                                3,
                                5
                            ];
                        case 4:
                            e = _state.sent();
                            _this1.dispatcher({
                                type: _adengineevents.jingleEvents.JINGLE_ERROR,
                                error: {
                                    module: "Jingle Renderer",
                                    fatal: true
                                }
                            });
                            return [
                                3,
                                5
                            ];
                        case 5:
                            return [
                                3,
                                12
                            ];
                        case 6:
                            {
                                _this1.dispatcher({
                                    type: _adengineevents.jingleEvents.JINGLE_ERROR,
                                    error: {
                                        module: "Jingle Renderer",
                                        fatal: true
                                    }
                                });
                                return [
                                    3,
                                    12
                                ];
                            }
                            _state.label = 7;
                        case 7:
                            _this1.play();
                            return [
                                3,
                                12
                            ];
                        case 8:
                            _this1.dispatcher({
                                type: _adengineevents.jingleEvents.JINGLE_PAUSED
                            });
                            return [
                                3,
                                12
                            ];
                        case 9:
                            if (_this1.firstPlayPassed) {
                                _this1.dispatcher({
                                    type: _adengineevents.jingleEvents.JINGLE_PLAYING
                                });
                            } else {
                                _this1.dispatcher({
                                    type: _adengineevents.jingleEvents.JINGLE_STARTED
                                });
                                _this1.firstPlayPassed = true;
                            }
                            return [
                                3,
                                12
                            ];
                        case 10:
                            _this1.stop();
                            return [
                                3,
                                12
                            ];
                        case 11:
                            return [
                                3,
                                12
                            ];
                        case 12:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(event) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.ref = ref;
        _this.firstPlayPassed = false;
        _this.options = options;
        _this.fullscreen = false;
        _this.dispatcher = function(event) {
            _loggerutils.default.debug("Renderer", "dispatcher", event);
            // @TODO
            // this.tracking(event);
            return dispatcher(_object_spread_props._(_object_spread._({}, event), {
                target: _this.jingle
            }));
        };
        return _this;
    }
    _create_class._(JingleRenderer, [
        {
            key: "getDisplayRef",
            value: function getDisplayRef() {
                return this.ref;
            }
        },
        {
            key: "getResource",
            value: function getResource() {
                var _this_jingle;
                return (_this_jingle = this.jingle) === null || _this_jingle === void 0 ? void 0 : _this_jingle.url;
            }
        },
        {
            key: "getCurrentTime",
            value: function getCurrentTime() {
                if (this.engine) {
                    return this.engine.getCurrentTime();
                }
                return 0;
            }
        },
        {
            key: "getDuration",
            value: function getDuration() {
                if (this.engine) {
                    return this.engine.getDuration();
                }
                return 0;
            }
        },
        {
            key: "play",
            value: function play() {
                if (this.engine) {
                    this.engine.play();
                }
            }
        },
        {
            key: "pause",
            value: function pause() {
                if (this.engine) {
                    this.engine.pause();
                }
            }
        },
        {
            key: "stop",
            value: function stop() {
                if (this.jingle) {
                    this.dispatcher({
                        type: _adengineevents.jingleEvents.JINGLE_STOPPED
                    });
                }
            }
        },
        {
            key: "skip",
            value: function skip() {
            // @TODO: Implement skip logic once defined in specs
            }
        },
        {
            key: "resize",
            value: function resize(fullscreen) {
                if (this.fullscreen !== fullscreen) {
                    this.fullscreen = fullscreen;
                // @TODO
                // this.track(this.jingle, fullscreen ? 'fullscreen' : 'exitFullscreen');
                }
            }
        },
        {
            key: "cleanRenderer",
            value: function cleanRenderer() {
                this.jingle = undefined;
                this.fullscreen = false;
                this.firstPlayPassed = false;
            }
        },
        {
            key: "release",
            value: function release() {
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // @TODO
                                // this.trackStop();
                                return [
                                    4,
                                    _this.engine.release()
                                ];
                            case 1:
                                _state.sent();
                                _this.stop();
                                _this.cleanRenderer();
                                _this.ref = null;
                                _loggerutils.default.debug("Jingle Renderer", "release", "The renderer is now released");
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "reset",
            value: function reset() {
                var _this = this;
                return _async_to_generator._(function() {
                    var error;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this.jingle) return [
                                    2
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                _this.engine.removeEventListeners();
                                return [
                                    4,
                                    _this.engine.reset()
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                error = _state.sent();
                                _loggerutils.default.error("Jingle Renderer", "Failed to reset jingle engine", error);
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                // @TODO
                                // this.trackStop();
                                _this.cleanRenderer();
                                _loggerutils.default.debug("Jingle Renderer", "reset", "The renderer is now reset");
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "load",
            value: function load(item) {
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this.engine) {
                                    _this.jingle = item;
                                    _this.engine = new _this.options.VideoEngine();
                                    _this.engine.configure(_object_spread_props._(_object_spread._({}, _mediaengine.defaultEngineOptions), {
                                        dispatcher: _this.eventHandler
                                    }));
                                    _this.engine.init(_this.ref);
                                    _this.engine.setVolume(_this.options.volume);
                                }
                                _this.engine.setEventListeners();
                                return [
                                    4,
                                    _this.setSource(item)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "setSource",
            value: function setSource(source) {
                var _this = this;
                return _async_to_generator._(function() {
                    var asset, error;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.jingle = source;
                                asset = {
                                    src: _this.jingle.url,
                                    type: "video/mp4"
                                };
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    _this.engine.setSource(asset)
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                error = _state.sent();
                                _loggerutils.default.error("Jingle Renderer", "Failed to set source", error);
                                // Dispatch fatal error to trigger next jingle/ad
                                _this.dispatcher({
                                    type: _adengineevents.jingleEvents.JINGLE_ERROR,
                                    error: {
                                        module: "Jingle Renderer",
                                        fatal: true
                                    }
                                });
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "interactionMade",
            value: function interactionMade() {
                throw new Error("Method not implemented.");
            }
        },
        {
            key: "isPaused",
            value: function isPaused() {
                if (this.engine) {
                    return this.engine.isPaused();
                }
                return true;
            }
        },
        {
            key: "setVolume",
            value: function setVolume(volume) {
                this.options.volume = volume;
                if (this.engine) {
                    this.engine.setVolume(volume);
                }
            }
        },
        {
            key: "getAudioEnabled",
            value: function getAudioEnabled() {
                if (this.ref) {
                    return this.ref.volume !== 0 && !this.ref.muted;
                }
                return false;
            }
        }
    ]);
    return JingleRenderer;
}(_baseRender.default);
var _default = JingleRenderer;


/***/ }),

/***/ 79951:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    default: function() {
        return _default;
    },
    getDefaultOptions: function() {
        return getDefaultOptions;
    }
});
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _get = __webpack_require__(60528);
var _get_prototype_of = __webpack_require__(35196);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(88801);
var _lodash = /*#__PURE__*/ _interop_require_default._(__webpack_require__(32699));
var _companionrenderer = /*#__PURE__*/ _interop_require_default._(__webpack_require__(89061));
var _constants = __webpack_require__(97440);
var _adengineevents = __webpack_require__(78725);
var _loggerutils = /*#__PURE__*/ _interop_require_default._(__webpack_require__(11905));
var getDefaultOptions = function() {
    return {
        timeouts: {
            nonLinearAvailability: 8
        }
    };
};
var NonLinearRenderer = /*#__PURE__*/ function(CompanionRenderer) {
    "use strict";
    _inherits._(NonLinearRenderer, CompanionRenderer);
    var _super = _create_super._(NonLinearRenderer);
    function NonLinearRenderer(ref, dispatcher) {
        var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        _class_call_check._(this, NonLinearRenderer);
        var _this;
        _this = _super.call(this, ref, dispatcher, options);
        _this.nonLinearAvailabilityTimeout = 0;
        _this.removeWithDelayTimeout = null;
        _this.stop = function() {
            _loggerutils.default.debug("Non Linear Renderer", "setSource", "Non Linear creative is in timeout zone, cleaning the renderer");
            if (_this.nonLinearAvailabilityTimeout) {
                clearTimeout(_this.nonLinearAvailabilityTimeout);
                _this.nonLinearAvailabilityTimeout = null;
            }
            _this.onStop();
        };
        _this.onStop = function() {
            _this.dispatcher({
                type: _adengineevents.adEvents.AD_STOPPED
            });
        };
        _this.onLoad = function() {
            _this.dispatcher({
                type: _adengineevents.adEvents.AD_LOADED
            });
            _this.nonLinearAvailabilityTimeout = setTimeout(_this.stop, (_this.creative.duration || _this.options.timeouts.nonLinearAvailability) * 1000);
            _this.dispatcher({
                type: _adengineevents.adEvents.AD_IMPRESSION
            });
            _this.dispatcher({
                type: _adengineevents.adEvents.AD_STARTED
            });
        };
        _this.options = _lodash.default.merge(getDefaultOptions(), options);
        _this.nonLinearAvailabilityTimeout = null;
        return _this;
    }
    _create_class._(NonLinearRenderer, [
        {
            key: "isPaused",
            value: function isPaused() {
                return true;
            }
        },
        {
            key: "clear",
            value: function clear() {
                if (this.nonLinearAvailabilityTimeout) {
                    clearTimeout(this.nonLinearAvailabilityTimeout);
                    this.nonLinearAvailabilityTimeout = null;
                }
                if (this.removeWithDelayTimeout) {
                    clearTimeout(this.removeWithDelayTimeout);
                    this.removeWithDelayTimeout = null;
                }
            }
        },
        {
            key: "release",
            value: function release() {
                var _this = this;
                var _this1 = this, _superprop_get_release = function() {
                    return _get._(_get_prototype_of._(NonLinearRenderer.prototype), "release", _this);
                };
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        _this1.clear();
                        _superprop_get_release().call(_this1);
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "reset",
            value: function reset() {
                var _this = this;
                var _this1 = this, _superprop_get_reset = function() {
                    return _get._(_get_prototype_of._(NonLinearRenderer.prototype), "reset", _this);
                };
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        _this1.clear();
                        _superprop_get_reset().call(_this1);
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "clearElement",
            value: function clearElement() {
                var _this = this;
                if (!this.element) {
                    return;
                }
                var element = this.element;
                var ref = this.ref;
                _constants.LISTENED_EVENTS.forEach(function(interaction) {
                    return element.removeEventListener(interaction, _this.eventsHandler);
                });
                element.removeEventListener("load", this.onLoad);
                element.onload = null;
                if (isFinite(this.options.removeWithDelay) && this.options.removeWithDelay > 0) {
                    this.removeWithDelayTimeout = setTimeout(function() {
                        if (ref && element.parentNode === ref) {
                            ref.removeChild(element);
                        }
                        _this.removeWithDelayTimeout = null;
                    }, this.options.removeWithDelay);
                } else {
                    ref.removeChild(element);
                }
                this.element = null;
            }
        }
    ]);
    return NonLinearRenderer;
}(_companionrenderer.default);
var _default = NonLinearRenderer;


/***/ }),

/***/ 2549:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _to_consumable_array = __webpack_require__(30005);
var _create_super = __webpack_require__(6400);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(37815);
var _adengineevents = __webpack_require__(78725);
var _loggerutils = /*#__PURE__*/ _interop_require_default._(__webpack_require__(11905));
var _baseRender = /*#__PURE__*/ _interop_require_default._(__webpack_require__(48227));
var Renderer = /*#__PURE__*/ function(BaseRenderer) {
    "use strict";
    _inherits._(Renderer, BaseRenderer);
    var _super = _create_super._(Renderer);
    function Renderer(ref, dispatcher, options) {
        _class_call_check._(this, Renderer);
        var _this;
        _this = _super.call(this);
        _this.ref = ref;
        _this.options = options;
        _this.firstPlayPassed = false;
        _this.fullscreen = false;
        _this.muted = false;
        _this.dispatcher = function(event) {
            _loggerutils.default.debug("Renderer", "dispatcher", event);
            _this.tracking(event);
            return dispatcher(_object_spread_props._(_object_spread._({}, event), {
                target: _this.creative
            }));
        };
        return _this;
    }
    _create_class._(Renderer, [
        {
            key: "track",
            value: function track() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var tracking = this.options.tracking;
                if (tracking) {
                    var _tracking;
                    (_tracking = tracking).track.apply(_tracking, _to_consumable_array._(args));
                }
            }
        },
        {
            key: "play",
            value: function play() {}
        },
        {
            key: "pause",
            value: function pause() {}
        },
        {
            key: "setVolume",
            value: function setVolume(volume) {
                this.options.volume = volume;
            }
        },
        {
            key: "getResource",
            value: function getResource() {
                return undefined;
            }
        },
        {
            key: "getCurrentTime",
            value: function getCurrentTime() {
                return 0;
            }
        },
        {
            key: "getDuration",
            value: function getDuration() {
                return 0;
            }
        },
        {
            key: "resize",
            value: function resize(fullscreen) {
                if (this.fullscreen !== fullscreen) {
                    this.fullscreen = fullscreen;
                    this.track(this.creative, fullscreen ? "fullscreen" : "exitFullscreen");
                }
            }
        },
        {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            key: "setSource",
            value: function setSource(asset) {}
        },
        {
            key: "cleanRenderer",
            value: function cleanRenderer() {
                this.creative = null;
                this.fullscreen = false;
                this.muted = false;
            }
        },
        {
            key: "stop",
            value: function stop() {}
        },
        {
            key: "getDisplayRef",
            value: function getDisplayRef() {
                return this.ref;
            }
        },
        {
            key: "getAudioEnabled",
            value: function getAudioEnabled() {
                return false;
            }
        },
        {
            key: "isPaused",
            value: function isPaused() {
                return true;
            }
        },
        {
            key: "trackStop",
            value: function trackStop() {
                if (this.creative && !this.creative.completed) {
                    this.track(this.creative, "stop");
                }
            }
        },
        {
            key: "release",
            value: function release() {
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        _this.trackStop();
                        _this.stop();
                        _this.cleanRenderer();
                        _this.ref = null;
                        _loggerutils.default.debug("Renderer", "release", "The renderer is now released");
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "reset",
            value: function reset() {
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        if (!_this.creative) return [
                            2
                        ];
                        _this.trackStop();
                        _this.cleanRenderer();
                        _this.firstPlayPassed = false;
                        _loggerutils.default.debug("Renderer", "reset", "The renderer is now reset");
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "load",
            value: function load(creative) {
                this.creative = creative;
                this.setSource(this.creative.currentAsset);
            }
        },
        {
            key: "interactionMade",
            value: function interactionMade() {
                if (this.creative) {
                    this.track(this.creative, "click");
                }
            }
        },
        {
            key: "skip",
            value: function skip() {
                if (this.creative) {
                    this.dispatcher({
                        type: _adengineevents.adEvents.AD_SKIPPED
                    });
                }
            }
        },
        {
            key: "tracking",
            value: function tracking(event) {
                switch(event.type){
                    case _adengineevents.adEvents.AD_STARTED:
                        this.track(this.creative, "creativeView");
                        this.firstPlayPassed = true;
                        break;
                    case _adengineevents.adEvents.AD_PLAYING:
                        if (this.firstPlayPassed) {
                            this.track(this.creative, "resume");
                        }
                        this.firstPlayPassed = true;
                        break;
                    case _adengineevents.adEvents.AD_PAUSED:
                        this.track(this.creative, "pause");
                        break;
                    case _adengineevents.adEvents.AD_STOPPED:
                        this.track(this.creative, "stop");
                        break;
                    case _adengineevents.adEvents.AD_VOLUME_CHANGE:
                        if (this.muted !== event.muted) {
                            this.muted = event.muted;
                            this.track(this.creative, event.muted ? "mute" : "unmute");
                        }
                        break;
                    case _adengineevents.adEvents.AD_VIDEO_START:
                        this.track(this.creative, "start");
                        this.firstPlayPassed = true;
                        break;
                    case _adengineevents.adEvents.AD_VIDEO_FIRST_QUARTILE:
                        this.track(this.creative, "firstQuartile");
                        break;
                    case _adengineevents.adEvents.AD_VIDEO_MIDPOINT:
                        this.track(this.creative, "midpoint");
                        break;
                    case _adengineevents.adEvents.AD_VIDEO_THIRD_QUARTILE:
                        this.track(this.creative, "thirdQuartile");
                        break;
                    case _adengineevents.adEvents.AD_VIDEO_COMPLETE:
                        this.track(this.creative, "complete");
                        break;
                    case _adengineevents.adEvents.AD_USER_ACCEPT_INVITATION:
                        this.track(this.creative, "acceptInvitation");
                        break;
                    case _adengineevents.adEvents.AD_USER_MINIMIZE:
                        this.track(this.creative, "collapse");
                        break;
                    case _adengineevents.adEvents.AD_USER_CLOSE:
                        this.track(this.creative, "close");
                        break;
                    case _adengineevents.adEvents.AD_LOADED:
                        this.track(this.creative, "adLoaded");
                        break;
                    case _adengineevents.adEvents.AD_SKIPPED:
                        this.track(this.creative, "skip");
                        break;
                    default:
                        break;
                }
            }
        }
    ]);
    return Renderer;
}(_baseRender.default);
var _default = Renderer;


/***/ }),

/***/ 98570:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "RendererManager", ({
    enumerable: true,
    get: function() {
        return RendererManager;
    }
}));
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _interop_require_default = __webpack_require__(81200);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(3009);
var _videorenderer = /*#__PURE__*/ _interop_require_default._(__webpack_require__(47272));
var _vpaidrenderer = /*#__PURE__*/ _interop_require_default._(__webpack_require__(40108));
var _nonLinearrenderer = /*#__PURE__*/ _interop_require_default._(__webpack_require__(79951));
var _companionrenderer = /*#__PURE__*/ _interop_require_default._(__webpack_require__(89061));
var _jinglerenderer = /*#__PURE__*/ _interop_require_default._(__webpack_require__(89630));
var _loggerutils = /*#__PURE__*/ _interop_require_default._(__webpack_require__(11905));
var LOG_TAG = "Renderer Manager";
var RendererManager = /*#__PURE__*/ function() {
    "use strict";
    function RendererManager(param) {
        var display = param.display, options = param.options, trackingManager = param.trackingManager, VideoEngine = param.VideoEngine, triggerEvent = param.triggerEvent;
        _class_call_check._(this, RendererManager);
        this.renderers = {};
        this.currentRenderer = null;
        this.display = display;
        this.options = options;
        this.trackingManager = trackingManager;
        this.VideoEngine = VideoEngine;
        this.triggerEvent = triggerEvent;
    }
    _create_class._(RendererManager, [
        {
            key: "configureDisplay",
            value: function configureDisplay(display) {
                var fullscreen = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                this.display = display;
                if (this.currentRenderer) {
                    this.currentRenderer.resize(fullscreen);
                }
            }
        },
        {
            key: "createRenderer",
            value: function createRenderer(rendererType) {
                _loggerutils.default.debug(LOG_TAG, "createRenderer", "".concat(rendererType, "Renderer requested"));
                switch(rendererType){
                    case "video":
                        return new _videorenderer.default(this.display.video, this.triggerEvent, {
                            volume: this.options.volume,
                            VideoEngine: this.VideoEngine,
                            tracking: this.trackingManager
                        });
                    case "vpaid":
                        return new _vpaidrenderer.default(this.display.vpaid, this.display.video, this.triggerEvent, {
                            volume: this.options.volume,
                            desiredBitrate: this.options.desiredBitrate,
                            tracking: this.trackingManager
                        });
                    case "companion":
                        return new _companionrenderer.default(this.display.companion, this.triggerEvent, {
                            tracking: this.trackingManager
                        });
                    case "nonlinear":
                        return new _nonLinearrenderer.default(this.display.base, this.triggerEvent, {
                            tracking: this.trackingManager
                        });
                    case "lbanner":
                        var _this_options_features, _this_options;
                        return new _nonLinearrenderer.default(this.display.lbanner || this.display.base, this.triggerEvent, {
                            tracking: this.trackingManager,
                            removeWithDelay: (_this_options = this.options) === null || _this_options === void 0 ? void 0 : (_this_options_features = _this_options.features) === null || _this_options_features === void 0 ? void 0 : _this_options_features.removeNonLinearElementDelay
                        });
                    case "jingle":
                        return new _jinglerenderer.default(this.display.video, this.triggerEvent, {
                            volume: this.options.volume,
                            VideoEngine: this.VideoEngine,
                            tracking: this.trackingManager
                        });
                }
            }
        },
        {
            key: "getRendererType",
            value: function getRendererType(creative) {
                var linear = creative.linear, id = creative.id;
                if (linear) {
                    var _creative_currentAsset;
                    return (creative === null || creative === void 0 ? void 0 : (_creative_currentAsset = creative.currentAsset) === null || _creative_currentAsset === void 0 ? void 0 : _creative_currentAsset.apiframework) === "VPAID" ? "vpaid" : "video";
                }
                if (id === "contentframe") {
                    return "lbanner";
                }
                return "nonlinear";
            }
        },
        {
            key: "getRenderer",
            value: function getRenderer(rendererType) {
                return this.renderers[rendererType];
            }
        },
        {
            key: "storeRenderer",
            value: function storeRenderer(rendererType, renderer) {
                this.renderers[rendererType] = renderer;
            }
        },
        {
            key: "selectCompanionRenderer",
            value: function selectCompanionRenderer() {
                var companionRenderer = this.getRenderer("companion");
                if (!companionRenderer) {
                    companionRenderer = this.createRenderer("companion");
                    this.storeRenderer("companion", companionRenderer);
                }
                return companionRenderer;
            }
        },
        {
            key: "selectRenderer",
            value: function selectRenderer(creative) {
                var rendererType = this.getRendererType(creative);
                this.currentRenderer = this.getRenderer(rendererType);
                _loggerutils.default.debug(LOG_TAG, "selectRenderer", this.currentRenderer);
                if (!this.currentRenderer) {
                    var renderer = this.createRenderer(rendererType);
                    this.currentRenderer = renderer;
                    this.storeRenderer(rendererType, renderer);
                }
            }
        },
        {
            // Shouldn't be called on a Companion type creative
            key: "loadCreative",
            value: function loadCreative(creative) {
                this.selectRenderer(creative);
                _loggerutils.default.debug(LOG_TAG, "load", "Beginning linear ad playback through the renderer");
                this.currentRenderer.load(creative);
            }
        },
        {
            key: "loadCompanion",
            value: function loadCompanion(creative) {
                var companionRenderer = this.selectCompanionRenderer();
                companionRenderer.load(creative);
            }
        },
        {
            key: "selectJingleRenderer",
            value: function selectJingleRenderer() {
                this.currentRenderer = this.getRenderer("jingle");
                if (!this.currentRenderer) {
                    var jingleRenderer = this.createRenderer("jingle");
                    this.currentRenderer = jingleRenderer;
                    this.storeRenderer("jingle", jingleRenderer);
                }
            }
        },
        {
            key: "loadJingle",
            value: function loadJingle(jingle) {
                this.selectJingleRenderer();
                this.currentRenderer.load(jingle);
            }
        },
        {
            key: "stopRenderers",
            value: function stopRenderers() {
                _loggerutils.default.debug(LOG_TAG, "stopRenderers", "Stop the renderers", this.renderers);
                Object.values(this.renderers).forEach(function(renderer) {
                    return renderer.stop();
                });
            }
        },
        {
            key: "resetRenderers",
            value: function resetRenderers() {
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _loggerutils.default.debug(LOG_TAG, "resetRenderers", "Reset the renderers", _this.renderers);
                                return [
                                    4,
                                    Promise.allSettled(Object.values(_this.renderers).map(function(renderer) {
                                        return renderer.reset();
                                    }))
                                ];
                            case 1:
                                _state.sent();
                                _this.currentRenderer = null;
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "releaseRenderers",
            value: function releaseRenderers() {
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _loggerutils.default.debug(LOG_TAG, "releaseRenderers", "Release the renderers");
                                _this.currentRenderer = null;
                                return [
                                    4,
                                    Promise.all(Object.keys(_this.renderers).map(function() {
                                        var _ref = _async_to_generator._(function(rendererType) {
                                            return _ts_generator._(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        return [
                                                            4,
                                                            _this.renderers[rendererType].release()
                                                        ];
                                                    case 1:
                                                        _state.sent();
                                                        delete _this.renderers[rendererType];
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        });
                                        return function(rendererType) {
                                            return _ref.apply(this, arguments);
                                        };
                                    }()))
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getActiveRenderer",
            value: function getActiveRenderer() {
                return this.currentRenderer;
            }
        }
    ]);
    return RendererManager;
}();


/***/ }),

/***/ 73035:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    isAudioGetterEnabled: function() {
        return isAudioGetterEnabled;
    },
    isPausable: function() {
        return isPausable;
    }
});
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(88801);
var isPausable = function(renderer) {
    return !!renderer && typeof renderer.isPaused === "function";
};
var isAudioGetterEnabled = function(renderer) {
    return !!renderer && typeof renderer.getAudioEnabled === "function";
};


/***/ }),

/***/ 62048:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    AD_MEDIA_LOAD_TIMEOUT_MS: function() {
        return AD_MEDIA_LOAD_TIMEOUT_MS;
    },
    AD_PLAY_TIMEOUT_MS: function() {
        return AD_PLAY_TIMEOUT_MS;
    },
    DEFAULT_PLAYBACKRATE: function() {
        return DEFAULT_PLAYBACKRATE;
    }
});
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(3009);
__webpack_require__(52318);
var AD_PLAY_TIMEOUT_MS = 10000;
var AD_MEDIA_LOAD_TIMEOUT_MS = 8000;
var DEFAULT_PLAYBACKRATE = 1;


/***/ }),

/***/ 47272:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    default: function() {
        return _default;
    },
    getDefaultQuartiles: function() {
        return getDefaultQuartiles;
    }
});
var _assert_this_initialized = __webpack_require__(99561);
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _get = __webpack_require__(60528);
var _get_prototype_of = __webpack_require__(35196);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _create_super = __webpack_require__(6400);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(65759);
var _mediaengine = __webpack_require__(62221);
var _renderer = /*#__PURE__*/ _interop_require_default._(__webpack_require__(2549));
var _loggerutils = /*#__PURE__*/ _interop_require_default._(__webpack_require__(11905));
var _promiseutils = __webpack_require__(69827);
var _adengineevents = __webpack_require__(78725);
var _html5engine = __webpack_require__(93344);
var _renderersconstants = __webpack_require__(62048);
var getDefaultQuartiles = function() {
    return {
        first: false,
        mid: false,
        third: false
    };
};
var VideoRenderer = /*#__PURE__*/ function(Renderer) {
    "use strict";
    _inherits._(VideoRenderer, Renderer);
    var _super = _create_super._(VideoRenderer);
    function VideoRenderer(ref, dispatcher) {
        var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        _class_call_check._(this, VideoRenderer);
        var _this;
        _this = _super.call(this, ref, dispatcher, options);
        var _this1 = _assert_this_initialized._(_this);
        _this.eventHandler = function() {
            var _ref = _async_to_generator._(function(event) {
                var target, e, position, _target_error, error, code;
                var _arguments = arguments;
                return _ts_generator._(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            target = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                            switch(event){
                                case _mediaengine.VIDEO_EVENTS.LOAD_START:
                                    return [
                                        3,
                                        1
                                    ];
                                case _mediaengine.VIDEO_EVENTS.TIME_UPDATE:
                                    return [
                                        3,
                                        6
                                    ];
                                case _mediaengine.VIDEO_EVENTS.ERROR:
                                    return [
                                        3,
                                        7
                                    ];
                                case _mediaengine.VIDEO_EVENTS.CAN_PLAY:
                                    return [
                                        3,
                                        8
                                    ];
                                case _mediaengine.VIDEO_EVENTS.PAUSE:
                                    return [
                                        3,
                                        9
                                    ];
                                case _mediaengine.VIDEO_EVENTS.PLAYING:
                                    return [
                                        3,
                                        10
                                    ];
                                case _mediaengine.VIDEO_EVENTS.DURATION_CHANGE:
                                    return [
                                        3,
                                        11
                                    ];
                                case _mediaengine.VIDEO_EVENTS.VOLUME_CHANGE:
                                    return [
                                        3,
                                        12
                                    ];
                                case _mediaengine.VIDEO_EVENTS.ENDED:
                                    return [
                                        3,
                                        13
                                    ];
                            }
                            return [
                                3,
                                14
                            ];
                        case 1:
                            if (_this1.ref.autoplay) return [
                                2
                            ];
                            _state.label = 2;
                        case 2:
                            _state.trys.push([
                                2,
                                4,
                                ,
                                5
                            ]);
                            return [
                                4,
                                (0, _promiseutils.timedOutPromise)(Promise.resolve(_this1.play()), _renderersconstants.AD_PLAY_TIMEOUT_MS)
                            ];
                        case 3:
                            _state.sent();
                            return [
                                3,
                                5
                            ];
                        case 4:
                            e = _state.sent();
                            _this1.dispatcher({
                                type: _adengineevents.adEvents.AD_ERROR,
                                error: {
                                    module: "Video Renderer",
                                    fatal: true,
                                    code: 400
                                }
                            });
                            return [
                                3,
                                5
                            ];
                        case 5:
                            return [
                                3,
                                15
                            ];
                        case 6:
                            {
                                position = parseFloat((_this1.engine.getCurrentTime() / _this1.engine.getDuration()).toFixed(2));
                                switch(true){
                                    case position >= 0.25 && !_this1.quartiles.first:
                                        _this1.quartiles.first = true;
                                        _this1.dispatcher({
                                            type: _adengineevents.adEvents.AD_VIDEO_FIRST_QUARTILE
                                        });
                                        break;
                                    case position >= 0.5 && !_this1.quartiles.mid:
                                        _this1.quartiles.mid = true;
                                        _this1.dispatcher({
                                            type: _adengineevents.adEvents.AD_VIDEO_MIDPOINT
                                        });
                                        break;
                                    case position >= 0.75 && !_this1.quartiles.third:
                                        _this1.quartiles.third = true;
                                        _this1.dispatcher({
                                            type: _adengineevents.adEvents.AD_VIDEO_THIRD_QUARTILE
                                        });
                                        break;
                                    default:
                                        break;
                                }
                                return [
                                    3,
                                    15
                                ];
                            }
                            _state.label = 7;
                        case 7:
                            {
                                _target_error = target.error, error = _target_error === void 0 ? {} : _target_error;
                                code = 400;
                                if (error.code === _html5engine.HTML5_ERROR.MEDIA_ERR_SRC_NOT_SUPPORTED && error.message.includes("MEDIA_ELEMENT_ERROR")) {
                                    code = 401;
                                } else if (error.code === _html5engine.HTML5_ERROR.MEDIA_ERR_DECODE) {
                                    code = 405;
                                }
                                _this1.dispatcher({
                                    type: _adengineevents.adEvents.AD_ERROR,
                                    error: _object_spread_props._(_object_spread._({}, error), {
                                        module: "Video Renderer",
                                        fatal: true,
                                        code: code,
                                        firstPlayPassed: _this1.firstPlayPassed
                                    })
                                });
                                return [
                                    3,
                                    15
                                ];
                            }
                            _state.label = 8;
                        case 8:
                            // Clear media load timeout on successful load
                            _this1.clearMediaLoadTimeout();
                            _this1.dispatcher({
                                type: _adengineevents.adEvents.AD_LOADED
                            });
                            _this1.engine.play();
                            return [
                                3,
                                15
                            ];
                        case 9:
                            // We want to prevent sending the pause if the video engine send it close to the end of the ad
                            // 250ms of buffer right before the end of the ad would be enough to prevent someone doing a pause
                            // right before the end of the ad and asking why we don't send that tracker :D
                            if (_this1.getCurrentTime() < _this1.getDuration() - 0.25 && !_this1.engine.isEnded()) {
                                _this1.dispatcher({
                                    type: _adengineevents.adEvents.AD_PAUSED
                                });
                            }
                            return [
                                3,
                                15
                            ];
                        case 10:
                            if (_this1.firstPlayPassed) {
                                _this1.dispatcher({
                                    type: _adengineevents.adEvents.AD_PLAYING
                                });
                            } else {
                                _this1.dispatcher({
                                    type: _adengineevents.adEvents.AD_IMPRESSION
                                });
                                _this1.dispatcher({
                                    type: _adengineevents.adEvents.AD_STARTED
                                });
                                _this1.dispatcher({
                                    type: _adengineevents.adEvents.AD_VIDEO_START
                                });
                                _this1.firstPlayPassed = true;
                            }
                            return [
                                3,
                                15
                            ];
                        case 11:
                            _this1.dispatcher({
                                type: _adengineevents.adEvents.AD_DURATION_CHANGE,
                                duration: _this1.engine.getDuration()
                            });
                            return [
                                3,
                                15
                            ];
                        case 12:
                            _this1.dispatcher({
                                type: _adengineevents.adEvents.AD_VOLUME_CHANGE,
                                volume: _this1.engine.getVolume(),
                                muted: _this1.engine.isMuted()
                            });
                            return [
                                3,
                                15
                            ];
                        case 13:
                            _this1.dispatcher({
                                type: _adengineevents.adEvents.AD_VIDEO_COMPLETE
                            });
                            return [
                                3,
                                15
                            ];
                        case 14:
                            return [
                                3,
                                15
                            ];
                        case 15:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(event) {
                return _ref.apply(this, arguments);
            };
        }();
        // these values are used to trigger mediafile timeout (402 VAST error)
        _this.mediaLoadTimeout = null;
        _this.hasMediaLoadTimedOut = false;
        return _this;
    }
    _create_class._(VideoRenderer, [
        {
            key: "handleMediaLoadTimeout",
            value: function handleMediaLoadTimeout(asset) {
                this.hasMediaLoadTimedOut = true;
                _loggerutils.default.error("VideoRenderer", "Media file fetch timeout", {
                    timeout: _renderersconstants.AD_MEDIA_LOAD_TIMEOUT_MS,
                    mediaFile: (asset === null || asset === void 0 ? void 0 : asset.src) || "unknown"
                });
                this.dispatcher({
                    type: _adengineevents.adEvents.AD_ERROR,
                    error: {
                        module: "Video Renderer",
                        fatal: true,
                        code: 402,
                        message: "Unable to download MediaFile within ".concat(_renderersconstants.AD_MEDIA_LOAD_TIMEOUT_MS, "ms")
                    }
                });
            }
        },
        {
            key: "clearMediaLoadTimeout",
            value: function clearMediaLoadTimeout() {
                if (this.mediaLoadTimeout) {
                    clearTimeout(this.mediaLoadTimeout);
                    this.mediaLoadTimeout = null;
                }
            }
        },
        {
            key: "setSource",
            value: function setSource(asset) {
                var _this = this;
                return _async_to_generator._(function() {
                    var error, e;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // Clear any existing media load timeout before starting new asset loading
                                _this.clearMediaLoadTimeout();
                                _this.quartiles = getDefaultQuartiles();
                                _this.hasMediaLoadTimedOut = false;
                                if (!!_this.engine) return [
                                    3,
                                    2
                                ];
                                _this.engine = new _this.options.VideoEngine();
                                _this.engine.configure({
                                    dispatcher: _this.eventHandler,
                                    streaming: {
                                        retry: {
                                            max: 0
                                        }
                                    }
                                });
                                return [
                                    4,
                                    _this.engine.init(_this.ref)
                                ];
                            case 1:
                                _state.sent();
                                _this.engine.setVolume(_this.options.volume);
                                _state.label = 2;
                            case 2:
                                _this.mediaLoadTimeout = setTimeout(function() {
                                    if (!_this.hasMediaLoadTimedOut) {
                                        _this.handleMediaLoadTimeout(asset);
                                    }
                                }, _renderersconstants.AD_MEDIA_LOAD_TIMEOUT_MS);
                                _state.label = 3;
                            case 3:
                                _state.trys.push([
                                    3,
                                    5,
                                    ,
                                    6
                                ]);
                                _this.engine.setEventListeners();
                                return [
                                    4,
                                    _this.engine.setSource(asset)
                                ];
                            case 4:
                                _state.sent();
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                error = _state.sent();
                                _this.clearMediaLoadTimeout();
                                if (!_this.hasMediaLoadTimedOut) {
                                    _loggerutils.default.error("VideoRenderer", "Media file setSource failed", {
                                        error: error.message || "Unknown error",
                                        mediaFile: (asset === null || asset === void 0 ? void 0 : asset.src) || "unknown"
                                    });
                                }
                                return [
                                    2
                                ];
                            case 6:
                                if (_this.ref.autoplay) return [
                                    2
                                ];
                                _state.label = 7;
                            case 7:
                                _state.trys.push([
                                    7,
                                    9,
                                    ,
                                    10
                                ]);
                                return [
                                    4,
                                    (0, _promiseutils.timedOutPromise)(Promise.resolve(_this.engine.play()), _renderersconstants.AD_PLAY_TIMEOUT_MS)
                                ];
                            case 8:
                                _state.sent();
                                // Clear media load timeout if play completes successfully
                                _this.clearMediaLoadTimeout();
                                return [
                                    3,
                                    10
                                ];
                            case 9:
                                e = _state.sent();
                                // Check if this is a media loading timeout (402) or play timeout (400)
                                if (_this.hasMediaLoadTimedOut) {
                                    _this.handleMediaLoadTimeout(asset);
                                    return [
                                        2
                                    ];
                                }
                                _this.dispatcher({
                                    type: _adengineevents.adEvents.AD_ERROR,
                                    error: {
                                        module: "Video Renderer",
                                        fatal: true,
                                        code: 400
                                    }
                                });
                                return [
                                    3,
                                    10
                                ];
                            case 10:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "stop",
            value: function stop() {
                if (this.creative) {
                    this.dispatcher({
                        type: _adengineevents.adEvents.AD_STOPPED
                    });
                }
            }
        },
        {
            key: "release",
            value: function release() {
                var _this = this;
                var _this1 = this, _superprop_get_release = function() {
                    return _get._(_get_prototype_of._(VideoRenderer.prototype), "release", _this);
                };
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this1.clearMediaLoadTimeout();
                                return [
                                    4,
                                    _this1.engine.release()
                                ];
                            case 1:
                                _state.sent();
                                _superprop_get_release().call(_this1);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "reset",
            value: function reset() {
                var _this = this;
                var _this1 = this, _superprop_get_reset = function() {
                    return _get._(_get_prototype_of._(VideoRenderer.prototype), "reset", _this);
                };
                return _async_to_generator._(function() {
                    var error;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this1.quartiles = getDefaultQuartiles();
                                _this1.clearMediaLoadTimeout();
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                _this1.engine.removeEventListeners();
                                return [
                                    4,
                                    _this1.engine.reset()
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                error = _state.sent();
                                _loggerutils.default.error("VideoRenderer", "Failed to reset video engine", error);
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                _superprop_get_reset().call(_this1);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "isPaused",
            value: function isPaused() {
                if (this.engine) {
                    return this.engine.isPaused();
                }
                return true;
            }
        },
        {
            key: "play",
            value: function play() {
                if (this.engine) {
                    this.engine.play();
                }
            }
        },
        {
            key: "pause",
            value: function pause() {
                if (this.engine) {
                    this.engine.pause();
                }
            }
        },
        {
            key: "setVolume",
            value: function setVolume(volume) {
                _get._(_get_prototype_of._(VideoRenderer.prototype), "setVolume", this).call(this, volume);
                if (this.engine) {
                    this.engine.setVolume(volume);
                }
            }
        },
        {
            key: "getCurrentTime",
            value: function getCurrentTime() {
                if (this.engine) {
                    return this.engine.getCurrentTime();
                }
                return 0;
            }
        },
        {
            key: "getDuration",
            value: function getDuration() {
                if (this.engine) {
                    var _this_creative;
                    return this.engine.getDuration() || ((_this_creative = this.creative) === null || _this_creative === void 0 ? void 0 : _this_creative.duration) || 0;
                }
                return 0;
            }
        },
        {
            key: "getAudioEnabled",
            value: function getAudioEnabled() {
                if (this.ref) {
                    return this.ref.volume !== 0 && !this.ref.muted;
                }
            }
        },
        {
            key: "getResource",
            value: function getResource() {
                if (this.ref) {
                    // For <object> elements (HBBTV), the URL is in .data, for <video> it's in .src
                    return this.ref.src || this.ref.data;
                }
                return undefined;
            }
        }
    ]);
    return VideoRenderer;
}(_renderer.default);
var _default = VideoRenderer;


/***/ }),

/***/ 40108:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    default: function() {
        return _default;
    },
    getDefaultOptions: function() {
        return getDefaultOptions;
    },
    ucfirst: function() {
        return ucfirst;
    }
});
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _get = __webpack_require__(60528);
var _get_prototype_of = __webpack_require__(35196);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _sliced_to_array = __webpack_require__(28966);
var _create_super = __webpack_require__(6400);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(88801);
var _lodash = /*#__PURE__*/ _interop_require_default._(__webpack_require__(32699));
var _renderer = /*#__PURE__*/ _interop_require_default._(__webpack_require__(2549));
var _loggerutils = /*#__PURE__*/ _interop_require_default._(__webpack_require__(11905));
var _adengineevents = __webpack_require__(78725);
var ucfirst = function(string) {
    return "".concat(string.charAt(0).toUpperCase()).concat(string.substr(1));
};
var getDefaultOptions = function() {
    return {
        creativeData: {
            AdParameters: null
        },
        desiredBitrate: 635,
        volume: 0.5,
        timeouts: {
            vpaidAvailability: 8000,
            vpaidAvailabilityInterval: 100,
            vpaidStarted: 5000,
            vpaidLoaded: 5000,
            vpaidStopped: 5000
        }
    };
};
var VPAIDRenderer = /*#__PURE__*/ function(Renderer) {
    "use strict";
    _inherits._(VPAIDRenderer, Renderer);
    var _super = _create_super._(VPAIDRenderer);
    function VPAIDRenderer(ref, videoRef, dispatcher) {
        var options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
        _class_call_check._(this, VPAIDRenderer);
        var _this;
        _this = _super.call(this, ref, dispatcher, options);
        _this.setUp = function() {
            _this.vpaid = _this.getVPAIDAd();
            if (!_this.vpaid) {
                _loggerutils.default.warn("VPAID Renderer", "setUp", "VPAID is still unavailable, waiting again for ".concat(_this.options.timeouts.vpaidAvailabilityInterval, "ms"));
                clearTimeout(_this.getVpaidAdTimeout);
                _this.getVpaidAdTimeout = setTimeout(_this.setUp, _this.options.timeouts.vpaidAvailabilityInterval);
                return;
            }
            _loggerutils.default.debug("VPAID Renderer", "setUp", "VPAID is available, proceeding", _this.vpaid);
            clearTimeout(_this.getVpaidAdTimeout);
            _lodash.default.forOwn(_adengineevents.adEvents, function(adEvent) {
                _this.vpaid.subscribe(_this.getEventHandler(adEvent), adEvent);
            });
            _loggerutils.default.debug("VPAID Renderer", "setUp", "Initiating the VPAID");
            clearTimeout(_this.vpaidLoadedTimeout);
            _this.vpaidLoadedTimeout = setTimeout(function() {
                _loggerutils.default.error("VPAID Renderer", "setUp", "VPAID has not been loaded in the time given");
                _this.dispatcher({
                    type: _adengineevents.adEvents.AD_ERROR,
                    error: {
                        message: "VPAID Loaded Timeout",
                        module: "VPAIDRenderer",
                        fatal: true,
                        code: 402
                    }
                });
            }, _this.options.timeouts.vpaidLoaded);
            _this.vpaid.initAd(_this.ref.offsetWidth, _this.ref.offsetHeight, "normal", _this.options.desiredBitrate, _this.options.creativeData, _this.options.environmentVars);
            _this.ignoreStopEvent = false;
        };
        /**
         * Event Handlers
         */ _this.onAdLoaded = function(event) {
            _this.vpaidLoadedTimeout = clearTimeout(_this.vpaidLoadedTimeout);
            _loggerutils.default.debug("VPAID Renderer", "onAdLoaded", "VPAID is loaded and ready to play");
            var _this_options_environmentVars = _this.options.environmentVars, videoSlot = _this_options_environmentVars.videoSlot, slot = _this_options_environmentVars.slot;
            var videoElement = videoSlot;
            // Some vpaids can generate their own video element, so we need to keep the bridge updated about
            // which video to track, for the player controls (remaining time, play/pause, etc.).
            if (slot.querySelector("video")) {
                videoElement = slot.querySelector("video");
            }
            if (!videoElement) {
                _loggerutils.default.warn("VPAID Renderer", "onAdLoaded", "Could not find video element");
                return;
            }
            _this.dispatcher(_object_spread_props._(_object_spread._({}, event), {
                type: _adengineevents.adEvents.AD_LOADED,
                videoRef: videoElement
            }));
            _this.play();
        };
        _this.onAdStarted = function(event) {
            _this.vpaidStartedTimeout = clearTimeout(_this.vpaidStartedTimeout);
            _this.paused = false;
            _this.dispatcher(_object_spread_props._(_object_spread._({}, event), {
                type: _adengineevents.adEvents.AD_STARTED
            }));
        };
        _this.onAdError = function(event) {
            _this.clean();
            var code = 900;
            var message = "";
            if (typeof event === "string") {
                var matches = event.match(/AdError ([0-9]+) \((.+)\)/);
                if (matches && matches.length) {
                    var _$ref;
                    _$ref = _sliced_to_array._(matches, 3), code = _$ref[1], message = _$ref[2], _$ref;
                    code = parseInt(code, 10);
                }
            }
            _this.dispatcher({
                type: _adengineevents.adEvents.AD_ERROR,
                error: _object_spread_props._(_object_spread._({
                    message: message,
                    code: code
                }, _lodash.default.get(event, "error", {}), _lodash.default.get(event, {})), {
                    module: "VPAID Renderer",
                    fatal: true
                })
            });
        };
        _this.onAdClickThru = function(url) {
            _this.dispatcher({
                url: url,
                type: _adengineevents.adEvents.AD_CLICK_THRU
            });
        };
        _this.onAdSkipped = function() {
            _this.dispatcher({
                type: _adengineevents.adEvents.AD_SKIPPED
            });
            _this.clean();
        };
        _this.onAdStopped = function() {
            // Ensures that AD_STOPPED is not dispatched twice (can happen with some VPAID), which can
            // trigger unexpected behaviors in ad.engine.js (calling `playNextAd` twice, potentially skipping an ad).
            if (_this.ignoreStopEvent) return;
            _this.ignoreStopEvent = true;
            // Some vpaids can generate their own video element, so after they have cleaned up everything, we need to
            // fallback on our own video element for the next ads
            _this.dispatcher({
                type: _adengineevents.adEvents.AD_STOPPED,
                videoRef: _this.options.environmentVars.videoSlot
            });
            _this.clean();
        };
        _this.onAdPlaying = function() {
            _this.paused = false;
            _this.dispatcher({
                type: _adengineevents.adEvents.AD_PLAYING
            });
        };
        _this.onAdPaused = function() {
            _this.paused = true;
            _this.dispatcher({
                type: _adengineevents.adEvents.AD_PAUSED
            });
        };
        _this.onAdVideoComplete = function() {
            if (_this.creative) {
                _this.dispatcher({
                    type: _adengineevents.adEvents.AD_VIDEO_COMPLETE
                });
            }
        };
        _this.iframeRef = null;
        _this.getVpaidAdTimeout = null;
        _this.vpaidStartedTimeout = null;
        _this.vpaidAvailabilityTimeout = null;
        _this.vpaidLoadedTimeout = null;
        _this.vpaid = null;
        _this.paused = true;
        _this.src = null;
        _this.ignoreStopEvent = false;
        _this.options = _lodash.default.merge(getDefaultOptions(), options);
        _this.options.environmentVars = {
            slot: _this.ref,
            videoSlot: videoRef,
            // REVIEW: does it make sens to set it to false for mobile ? We will have an interaction anyway, right ?
            videoSlotCanAutoPlay: true
        };
        _loggerutils.default.debug("VPAID Renderer", "constructor", "VPAID has been built with options", _this.options);
        return _this;
    }
    _create_class._(VPAIDRenderer, [
        {
            key: "getEventHandler",
            value: function getEventHandler(rawEventName) {
                var _this = this;
                var eventName = _lodash.default.camelCase(rawEventName).replace(/^./, function(firstLetter) {
                    return firstLetter.toUpperCase();
                });
                var handlerName = "on".concat(eventName);
                if (!this[handlerName]) {
                    // We have to force the type, because some VPAID send empty event type
                    this[handlerName] = function(event) {
                        return _this.dispatcher(_object_spread_props._(_object_spread._({}, event), {
                            type: eventName
                        }));
                    };
                }
                return this[handlerName];
            }
        },
        {
            key: "setSource",
            value: function setSource(asset) {
                var _this = this;
                _loggerutils.default.debug("VPAID Renderer", "setSource", "Loading source", asset);
                var creativeParameters = undefined;
                if (this.creative && this.creative.parameters) {
                    creativeParameters = this.creative.parameters;
                }
                this.options = _lodash.default.merge(this.options, {
                    creativeData: {
                        AdParameters: creativeParameters
                    }
                });
                this.iframeRef = document.createElement("iframe");
                this.iframeRef.id = "vpaidFrame";
                this.iframeRef.allowfullscreen = true;
                this.iframeRef.width = 0;
                this.iframeRef.height = 0;
                this.iframeRef.style.display = "none";
                this.iframeRef.onload = this.setUp;
                document.body.appendChild(this.iframeRef);
                this.iframeRef.contentWindow.document.open();
                this.iframeRef.contentWindow.document.write('<body><script src="'.concat(asset.src, '"></script></body>'));
                this.iframeRef.contentWindow.document.close();
                _loggerutils.default.debug("VPAID Renderer", "setSource", "Waiting for the VPAID to be loaded and accessible");
                clearTimeout(this.vpaidAvailabilityTimeout);
                this.vpaidAvailabilityTimeout = setTimeout(function() {
                    if (!_this.getVPAIDAd()) {
                        _loggerutils.default.error("VPAID Renderer", "setSource", "VPAID is in timeout zone, cleaning the renderer");
                        _this.dispatcher({
                            type: _adengineevents.adEvents.AD_ERROR,
                            error: {
                                message: "VPAID Availability Timeout",
                                module: "VPAIDRenderer",
                                fatal: true,
                                code: 402
                            }
                        });
                    }
                }, this.options.timeouts.vpaidAvailability);
            }
        },
        {
            key: "getVPAIDAd",
            value: function getVPAIDAd() {
                var getVPAIDAd = _lodash.default.get(this.iframeRef, "contentWindow.getVPAIDAd");
                return getVPAIDAd && typeof getVPAIDAd === "function" && getVPAIDAd();
            }
        },
        {
            key: "stop",
            value: function stop() {
                try {
                    if (this.vpaid) {
                        clearTimeout(this.vpaidStoppedTimeout);
                        this.vpaidStoppedTimeout = setTimeout(this.onAdStopped, this.options.timeouts.vpaidStopped);
                        this.vpaid.stopAd();
                    } else {
                        this.clean();
                    }
                } catch (exception) {
                    _loggerutils.default.error("VPAID Renderer", "stop", exception);
                }
            }
        },
        {
            key: "skip",
            value: function skip() {
                if (!this.vpaid) {
                    return;
                }
                try {
                    // Some VPAID do not allow skipping, so we have to force the skip in that case
                    if (!this.vpaid.getAdSkippableState()) {
                        this.forceUnhandledSkip();
                        return;
                    }
                    this.vpaid.skipAd();
                } catch (exception) {
                    _loggerutils.default.error("VPAID Renderer", "skip", exception);
                }
            }
        },
        {
            key: "forceUnhandledSkip",
            value: function forceUnhandledSkip() {
                this.ignoreStopEvent = true;
                this.stop();
                this.onAdSkipped();
            }
        },
        {
            key: "reset",
            value: function reset() {
                var _this = this;
                var _this1 = this, _superprop_get_reset = function() {
                    return _get._(_get_prototype_of._(VPAIDRenderer.prototype), "reset", _this);
                };
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        _superprop_get_reset().call(_this1);
                        _this1.options = _lodash.default.merge(_this1.options, {
                            creativeData: getDefaultOptions().creativeData
                        });
                        _this1.paused = true;
                        _this1.src = null;
                        _this1.clean();
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "clean",
            value: function clean() {
                var _this = this;
                if (this.vpaid) {
                    try {
                        _lodash.default.forOwn(_adengineevents.adEvents, function(adEvent) {
                            _this.vpaid.unsubscribe(_this.getEventHandler(adEvent), adEvent);
                        });
                    } catch (exception) {
                        _loggerutils.default.error("VPAID Renderer", "clean", exception);
                    }
                }
                this.getVpaidAdTimeout = clearTimeout(this.getVpaidAdTimeout);
                this.vpaidStartedTimeout = clearTimeout(this.vpaidStartedTimeout);
                this.vpaidAvailabilityTimeout = clearTimeout(this.vpaidAvailabilityTimeout);
                this.vpaidLoadedTimeout = clearTimeout(this.vpaidLoadedTimeout);
                this.vpaidStoppedTimeout = clearTimeout(this.vpaidStoppedTimeout);
                if (this.iframeRef) {
                    document.body.removeChild(this.iframeRef);
                }
                this.iframeRef = null;
                this.vpaid = null;
                this.firstPlayPassed = false;
                this.ignoreStopEvent = false;
            }
        },
        {
            /**
     * VPAID Direct Methods
     */ key: "getDuration",
            value: function getDuration() {
                if (this.vpaid) {
                    var _this_creative;
                    return this.vpaid.getAdDuration() || ((_this_creative = this.creative) === null || _this_creative === void 0 ? void 0 : _this_creative.duration) || 0;
                }
            }
        },
        {
            key: "getCurrentTime",
            value: function getCurrentTime() {
                try {
                    if (this.vpaid) {
                        return Math.round(this.getDuration() - this.vpaid.getAdRemainingTime());
                    }
                } catch (exception) {
                    _loggerutils.default.error("VPAID Renderer", "getCurrentTime", "There was an error trying to get the currentTime", exception);
                }
                return 0;
            }
        },
        {
            key: "getAudioEnabled",
            value: function getAudioEnabled() {
                if (this.vpaid) {
                    return this.vpaid.getAdVolume() !== 0;
                }
            }
        },
        {
            key: "getResource",
            value: function getResource() {
                if (this.src) {
                    return this.src;
                }
            }
        },
        {
            key: "isPaused",
            value: function isPaused() {
                if (this.vpaid) {
                    return this.paused;
                }
                return true;
            }
        },
        {
            key: "play",
            value: function play() {
                var _this = this;
                if (this.vpaid) {
                    if (this.firstPlayPassed) {
                        this.vpaid.resumeAd();
                    } else {
                        _loggerutils.default.debug("VPAID Renderer", "play", "Starting VPAID");
                        clearTimeout(this.vpaidStartedTimeout);
                        this.vpaidStartedTimeout = setTimeout(function() {
                            if (!_this.vpaid) {
                                _loggerutils.default.warn("VPAID Renderer", "stopAd", "VPAID has not started in less than ".concat(_this.options.timeouts.vpaidStarted, "ms, and has already been clean up"));
                                return;
                            }
                            _loggerutils.default.warn("VPAID Renderer", "stopAd", "VPAID has not started in less than ".concat(_this.options.timeouts.vpaidStarted, "ms, stopping it"));
                            try {
                                _this.vpaid.stopAd();
                            } catch (exception) {
                                _loggerutils.default.error("VPAID Renderer", "stopAd", "An error occurred when trying to stop the VPAID", exception);
                            }
                        }, this.options.timeouts.vpaidStarted);
                        this.setVolume(this.options.volume);
                        this.vpaid.startAd();
                    }
                }
            }
        },
        {
            key: "pause",
            value: function pause() {
                if (this.vpaid) {
                    this.vpaid.pauseAd();
                }
            }
        },
        {
            key: "setVolume",
            value: function setVolume(volume) {
                _get._(_get_prototype_of._(VPAIDRenderer.prototype), "setVolume", this).call(this, volume);
                if (this.vpaid) {
                    this.vpaid.setAdVolume(volume);
                }
            }
        },
        {
            key: "resize",
            value: function resize(fullscreen) {
                _get._(_get_prototype_of._(VPAIDRenderer.prototype), "resize", this).call(this, fullscreen);
                if (this.vpaid) {
                    this.vpaid.resizeAd(this.ref.offsetWidth, this.ref.offsetHeight, fullscreen ? "fullscreen" : "normal");
                }
            }
        }
    ]);
    return VPAIDRenderer;
}(_renderer.default);
var _default = VPAIDRenderer;


/***/ }),

/***/ 20784:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ACCESS_MODE: function() {
        return ACCESS_MODE;
    },
    AD_INIT: function() {
        return AD_INIT;
    },
    AD_LOADED: function() {
        return AD_LOADED;
    },
    BEFORE_UNLOAD: function() {
        return BEFORE_UNLOAD;
    },
    BREAK_END: function() {
        return BREAK_END;
    },
    CLICK: function() {
        return CLICK;
    },
    CLICK_TRACKING: function() {
        return CLICK_TRACKING;
    },
    CLOSE_LINEAR: function() {
        return CLOSE_LINEAR;
    },
    COMPLETE: function() {
        return COMPLETE;
    },
    ERROR: function() {
        return ERROR;
    },
    ERROR_TYPE_GENERIC: function() {
        return ERROR_TYPE_GENERIC;
    },
    ERROR_TYPE_MEDIA: function() {
        return ERROR_TYPE_MEDIA;
    },
    ERROR_TYPE_VIDEO: function() {
        return ERROR_TYPE_VIDEO;
    },
    FIRST_QUARTILE: function() {
        return FIRST_QUARTILE;
    },
    FULLSCREEN_CHANGE: function() {
        return FULLSCREEN_CHANGE;
    },
    LOADED: function() {
        return LOADED;
    },
    MIDPOINT: function() {
        return MIDPOINT;
    },
    MOZ_FULLSCREEN_CHANGE: function() {
        return MOZ_FULLSCREEN_CHANGE;
    },
    MS_FULLSCREEN_CHANGE: function() {
        return MS_FULLSCREEN_CHANGE;
    },
    MUTE: function() {
        return MUTE;
    },
    PARTNER_NAME: function() {
        return PARTNER_NAME;
    },
    PAUSE: function() {
        return PAUSE;
    },
    RESUME: function() {
        return RESUME;
    },
    SCREEN_MODE_FULLSCREEN: function() {
        return SCREEN_MODE_FULLSCREEN;
    },
    SCREEN_MODE_NORMAL: function() {
        return SCREEN_MODE_NORMAL;
    },
    START: function() {
        return START;
    },
    STOP: function() {
        return STOP;
    },
    THIRD_QUARTILE: function() {
        return THIRD_QUARTILE;
    },
    UNMUTE: function() {
        return UNMUTE;
    },
    VOLUME_CHANGE: function() {
        return VOLUME_CHANGE;
    },
    WEBKIT_FULLSCREEN_CHANGE: function() {
        return WEBKIT_FULLSCREEN_CHANGE;
    }
});
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(42578);
var PARTNER_NAME = "bedrockstreaming";
var ACCESS_MODE = "full";
var AD_LOADED = "adLoaded";
var LOADED = "loaded";
var AD_INIT = "adInit";
var START = "start";
var FIRST_QUARTILE = "firstQuartile";
var MIDPOINT = "midpoint";
var THIRD_QUARTILE = "thirdQuartile";
var COMPLETE = "complete";
var STOP = "stop";
var BREAK_END = "breakEnd";
var CLOSE_LINEAR = "closeLinear";
var CLICK_TRACKING = "ClickTracking";
var PAUSE = "pause";
var RESUME = "resume";
var MUTE = "mute";
var UNMUTE = "unmute";
var VOLUME_CHANGE = "volumechange";
var FULLSCREEN_CHANGE = "fullscreenchange";
var WEBKIT_FULLSCREEN_CHANGE = "webkitfullscreenchange";
var MOZ_FULLSCREEN_CHANGE = "mozfullscreenchange";
var MS_FULLSCREEN_CHANGE = "msfullscreenchange";
var SCREEN_MODE_FULLSCREEN = "fullscreen";
var SCREEN_MODE_NORMAL = "normal";
var CLICK = "click";
var ERROR = "error";
var ERROR_TYPE_VIDEO = "video";
var ERROR_TYPE_GENERIC = "generic";
var ERROR_TYPE_MEDIA = "media";
var BEFORE_UNLOAD = "beforeunload"; // AdEventType:{IMPRESSION:"impression", LOADED:"loaded", GEOMETRY_CHANGE:"geometryChange", SESSION_START:"sessionStart", SESSION_ERROR:"sessionError", SESSION_FINISH:"sessionFinish", MEDIA:"media", VIDEO:"video", START:"start", FIRST_QUARTILE:"firstQuartile", MIDPOINT:"midpoint", THIRD_QUARTILE:"thirdQuartile", COMPLETE:"complete", PAUSE:"pause", RESUME:"resume", BUFFER_START:"bufferStart", BUFFER_FINISH:"bufferFinish", SKIPPED:"skipped", VOLUME_CHANGE:"volumeChange", PLAYER_STATE_CHANGE:"playerStateChange", AD_USER_INTERACTION:"adUserInteraction", STATE_CHANGE:"stateChange"},
 // MediaEventType:{LOADED:"loaded", START:"start", FIRST_QUARTILE:"firstQuartile", MIDPOINT:"midpoint", THIRD_QUARTILE:"thirdQuartile", COMPLETE:"complete", PAUSE:"pause", RESUME:"resume", BUFFER_START:"bufferStart", BUFFER_FINISH:"bufferFinish", SKIPPED:"skipped", VOLUME_CHANGE:"volumeChange", PLAYER_STATE_CHANGE:"playerStateChange", AD_USER_INTERACTION:"adUserInteraction"},
 // ImpressionType:{DEFINED_BY_JAVASCRIPT:"definedByJavaScript", UNSPECIFIED:"unspecified", LOADED:"loaded", BEGIN_TO_RENDER:"beginToRender", ONE_PIXEL:"onePixel", VIEWABLE:"viewable", AUDIBLE:"audible", OTHER:"other"},
 // ErrorType:{GENERIC:"generic", VIDEO:"video", MEDIA:"media"},
 // AdSessionType:{NATIVE:"native", HTML:"html", JAVASCRIPT:"javascript"},
 // EventOwner:{NATIVE:"native", JAVASCRIPT:"javascript", NONE:"none"},
 // AccessMode:{FULL:"full", DOMAIN:"domain", LIMITED:"limited"},
 // AppState:{BACKGROUNDED:"backgrounded", FOREGROUNDED:"foregrounded"},
 // Environment:{APP:"app", WEB:"web"},
 // DeviceCategory:{CTV:"ctv", DESKTOP:"desktop", MOBILE:"mobile", OTHER:"other"},
 // InteractionType:{CLICK:"click", INVITATION_ACCEPT:"invitationAccept"},
 // CreativeType:{DEFINED_BY_JAVASCRIPT:"definedByJavaScript", HTML_DISPLAY:"htmlDisplay", NATIVE_DISPLAY:"nativeDisplay", VIDEO:"video", AUDIO:"audio"},
 // MediaType:{DISPLAY:"display", VIDEO:"video"},
 // Reason:{NOT_FOUND:"notFound", HIDDEN:"hidden", BACKGROUNDED:"backgrounded", VIEWPORT:"viewport", OBSTRUCTED:"obstructed", CLIPPED:"clipped", UNMEASURABLE:"unmeasurable", NO_WINDOW_FOCUS:"noWindowFocus", NO_OUTPUT_DEVICE:"noOutputDevice"},
 // SupportedFeatures:{CONTAINER:"clid", VIDEO:"vlid"},
 // VideoPosition:{PREROLL:"preroll", MIDROLL:"midroll", POSTROLL:"postroll", STANDALONE:"standalone"},
 // VideoPlayerState:{MINIMIZED:"minimized", COLLAPSED:"collapsed", NORMAL:"normal", EXPANDED:"expanded", FULLSCREEN:"fullscreen"},
 // NativeViewKeys:{X:"x", LEFT:"left", Y:"y", TOP:"top", WIDTH:"width", HEIGHT:"height", AD_SESSION_ID:"adSessionId", IS_FRIENDLY_OBSTRUCTION_FOR:"isFriendlyObstructionFor", CLIPS_TO_BOUNDS:"clipsToBounds", CHILD_VIEWS:"childViews", END_X:"endX", END_Y:"endY", OBSTRUCTIONS:"obstructions", OBSTRUCTION_CLASS:"obstructionClass", OBSTRUCTION_PURPOSE:"obstructionPurpose", OBSTRUCTION_REASON:"obstructionReason", PIXELS:"pixels", HAS_WINDOW_FOCUS:"hasWindowFocus"},
 // MeasurementStateChangeSource:{CONTAINER:"container", CREATIVE:"creative"},
 // ElementMarkup:{OMID_ELEMENT_CLASS_NAME:"omid-element"},
 // CommunicationType:{NONE:"NONE", DIRECT:"DIRECT", POST_MESSAGE:"POST_MESSAGE"},
 // OmidImplementer:{OMSDK:"omsdk"}


/***/ }),

/***/ 36780:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    CLEANUP_EVENTS: function() {
        return CLEANUP_EVENTS;
    },
    DOCUMENT_LISTENED_EVENTS: function() {
        return DOCUMENT_LISTENED_EVENTS;
    },
    NO_SESSION_EVENTS: function() {
        return NO_SESSION_EVENTS;
    },
    OmTracking: function() {
        return OmTracking;
    },
    VIDEO_LISTENED_EVENTS: function() {
        return VIDEO_LISTENED_EVENTS;
    },
    WINDOW_LISTENED_EVENTS: function() {
        return WINDOW_LISTENED_EVENTS;
    }
});
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _define_property = __webpack_require__(21228);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _create_super = __webpack_require__(6400);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(37815);
var _lodash = /*#__PURE__*/ _interop_require_default._(__webpack_require__(32699));
var _omconstants = __webpack_require__(20784);
var _packagejson = /*#__PURE__*/ _interop_require_default._(__webpack_require__(13700));
var _tracking = __webpack_require__(8291);
var _loggerutils = /*#__PURE__*/ _interop_require_default._(__webpack_require__(11905));
var CLEAR_DELAY_TRACKING_IFRAME = 3000;
var NO_SESSION_EVENTS = [
    _omconstants.AD_INIT,
    _omconstants.BREAK_END
];
var VIDEO_LISTENED_EVENTS = [
    _omconstants.VOLUME_CHANGE,
    _omconstants.CLICK,
    _omconstants.ERROR
];
var DOCUMENT_LISTENED_EVENTS = [
    _omconstants.MS_FULLSCREEN_CHANGE,
    _omconstants.MOZ_FULLSCREEN_CHANGE,
    _omconstants.WEBKIT_FULLSCREEN_CHANGE
];
var WINDOW_LISTENED_EVENTS = [
    _omconstants.BEFORE_UNLOAD
];
var CLEANUP_EVENTS = [
    _omconstants.BREAK_END
];
var OmTracking = /*#__PURE__*/ function(Tracking) {
    "use strict";
    _inherits._(OmTracking, Tracking);
    var _super = _create_super._(OmTracking);
    function OmTracking(debug) {
        _class_call_check._(this, OmTracking);
        var _this;
        _this = _super.call(this);
        _this.name = "OmTracking";
        var _obj;
        _this.eventHandlers = (_obj = {}, _define_property._(_obj, _omconstants.VOLUME_CHANGE, function() {
            if (_this.config.video.muted) {
                _loggerutils.default.debug(_this.name, "track", "Tracking event <".concat(_omconstants.VOLUME_CHANGE, "> with volume at 0"));
                _this.mediaEvents.volumeChange(0.0);
            } else {
                _loggerutils.default.debug(_this.name, "track", "Tracking event <".concat(_omconstants.VOLUME_CHANGE, "> with volume at ").concat(_this.config.video.volume));
                _this.mediaEvents.volumeChange(_this.config.video.volume);
            }
        }), _define_property._(_obj, _omconstants.FULLSCREEN_CHANGE, function() {
            var state = document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen || document.msFullScreen;
            var playerState = state ? "fullscreen" : "normal";
            _loggerutils.default.debug(_this.name, "track", "Player state change to ".concat(playerState));
            _this.mediaEvents.playerStateChange(playerState);
        }), _define_property._(_obj, _omconstants.CLICK, function() {
            _loggerutils.default.debug(_this.name, "track", "Tracking event <".concat(_omconstants.CLICK, ">"));
            _this.mediaEvents.adUserInteraction(_omconstants.CLICK);
        }), _define_property._(_obj, _omconstants.ERROR, function() {
            _loggerutils.default.error(_this.name, "track", "Tracking event <".concat(_omconstants.ERROR, ">"));
            _this.adSession.error(_omconstants.ERROR_TYPE_VIDEO, _this.config.video.error.message);
        }), _define_property._(_obj, _omconstants.BEFORE_UNLOAD, function() {
            _loggerutils.default.debug(_this.name, "track", "Tracking event <".concat(_omconstants.BEFORE_UNLOAD, ">"));
            _this.releaseAd();
            _this.timeoutRemoveIFrames();
        }), _obj);
        var _obj1;
        _this.handlers = (_obj1 = {}, _define_property._(_obj1, _omconstants.AD_INIT, function() {
            return _this.createSession();
        }), _define_property._(_obj1, _omconstants.START, function(target) {
            return _this.mediaEvents.start(target.duration, _this.config.video.volume);
        }), _define_property._(_obj1, _omconstants.FIRST_QUARTILE, function() {
            return _this.mediaEvents.firstQuartile();
        }), _define_property._(_obj1, _omconstants.MIDPOINT, function() {
            return _this.mediaEvents.midpoint();
        }), _define_property._(_obj1, _omconstants.THIRD_QUARTILE, function() {
            return _this.mediaEvents.thirdQuartile();
        }), _define_property._(_obj1, _omconstants.COMPLETE, function() {
            return _this.mediaEvents.complete();
        }), _define_property._(_obj1, _omconstants.CLICK, function() {
            return _this.mediaEvents.adUserInteraction(_omconstants.CLICK);
        }), _define_property._(_obj1, _omconstants.CLICK_TRACKING, function() {
            return _this.mediaEvents.adUserInteraction(_omconstants.CLICK);
        }), _define_property._(_obj1, _omconstants.PAUSE, function() {
            return _this.mediaEvents.pause();
        }), _define_property._(_obj1, _omconstants.RESUME, function() {
            return _this.mediaEvents.resume();
        }), _define_property._(_obj1, _omconstants.STOP, function() {
            return _this.releaseAd();
        }), _define_property._(_obj1, _omconstants.BREAK_END, function() {
            return _this.timeoutRemoveIFrames();
        }), _define_property._(_obj1, _omconstants.CLOSE_LINEAR, function() {
            return _this.releaseAd();
        }), _obj1);
        _this.removeIFrames();
        _this.adSession = null;
        _this.adEvents = null;
        _this.mediaEvents = null;
        _this.debug = debug;
        _loggerutils.default.debug(_this.name, "constructor", "Is debug mode activated : ".concat(_this.debug));
        return _this;
    }
    _create_class._(OmTracking, [
        {
            key: "configure",
            value: function configure() {
                var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                config.active = _lodash.default.get(config, "ad.verifications", []).length > 0;
                this.config = _lodash.default.merge({}, this.config, config);
            }
        },
        {
            key: "getSessionClient",
            value: function getSessionClient() {
                return window.OmidSessionClient && window.OmidSessionClient.default;
            }
        },
        {
            key: "createSession",
            value: function createSession() {
                var _this = this;
                if (!this.getSessionClient()) {
                    throw new Error("you should have loaded the om sdk when you create a session");
                }
                if (!this.config.video) {
                    throw new Error("you should have a video element to create a session");
                }
                if (!this.config.ad) {
                    throw new Error("you should have an ad when you create a session");
                }
                var sessionClient = this.getSessionClient();
                var partner = new sessionClient.Partner(_omconstants.PARTNER_NAME, _packagejson.default.version);
                var resources = this.config.ad.verifications.filter(function(verification) {
                    return !!verification;
                }).map(function(verification) {
                    _loggerutils.default.debug(_this.name, "createSession", "Resource URL ".concat(verification.resource));
                    return new sessionClient.VerificationScriptResource(verification.resource, verification.vendor, verification.parameters, _omconstants.ACCESS_MODE);
                });
                if (this.debug) {
                    resources.push(new sessionClient.VerificationScriptResource("".concat(window.location.origin, "/assets/scripts/omsdk/omid-validation-verification-script-v1.js"), "dummyVendor", JSON.stringify({
                        k: "v"
                    }), _omconstants.ACCESS_MODE));
                }
                _loggerutils.default.debug(this.name, "createSession", "Loaded resources ".concat(JSON.stringify(resources)));
                var context = new sessionClient.Context(partner, resources, window.location.href);
                context.deviceCategory = this.config.deviceCategory;
                context.setVideoElement(this.config.video);
                context.setServiceWindow(window.top);
                this.adSession = new sessionClient.AdSession(context);
                this.registerSessionObserver();
                this.adSession.setCreativeType("video");
                // See impression type documentation to determine which type you should use.
                this.adSession.setImpressionType("beginToRender");
                if (!this.adSession.isSupported()) {
                    throw new Error("your client/platform is unsupported");
                }
                this.adEvents = new sessionClient.AdEvents(this.adSession);
                this.mediaEvents = new sessionClient.MediaEvents(this.adSession);
                this.adSession.start();
                this.manageWindowEventHandler("add");
                this.manageVideoElementEventHandler("add");
                this.manageDocumentEventHandler("add");
            }
        },
        {
            key: "registerSessionObserver",
            value: function registerSessionObserver() {
                var _this = this;
                if (!this.adSession) {
                    throw new Error("you should have a valid session created");
                }
                this.adSession.registerSessionObserver(function(event) {
                    _loggerutils.default.debug(_this.name, "registerSessionObserver", "Received a ".concat(event.type, " on adSession"));
                    switch(event.type){
                        case "sessionStart":
                            {
                                var sessionClient = _this.getSessionClient();
                                var vastProperties = new sessionClient.VastProperties(false, null, true, _lodash.default.get(_this.config, "slot.type", "preroll"));
                                _this.adEvents.loaded(vastProperties);
                                _this.adEvents.impressionOccurred();
                                break;
                            }
                        case "sessionError":
                            {
                                _loggerutils.default.error(_this.name, "registerSessionObserver", "Received an ".concat(event.type, " on adSession"));
                                _this.releaseAd();
                                break;
                            }
                        case "sessionFinish":
                            {
                                break;
                            }
                    }
                });
            }
        },
        {
            key: "manageDocumentEventHandler",
            value: function manageDocumentEventHandler() {
                var type = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "remove";
                var _this = this;
                if (!this.adSession || !this.adEvents || !this.mediaEvents) {
                    return;
                }
                var method = "".concat(type, "EventListener");
                _lodash.default.forEach(DOCUMENT_LISTENED_EVENTS, function(event) {
                    var runEvent = event;
                    if (_lodash.default.includes([
                        _omconstants.MS_FULLSCREEN_CHANGE,
                        _omconstants.MOZ_FULLSCREEN_CHANGE,
                        _omconstants.WEBKIT_FULLSCREEN_CHANGE
                    ], event)) {
                        runEvent = _omconstants.FULLSCREEN_CHANGE;
                    }
                    var handler = _this.eventHandlers[runEvent];
                    if (!handler) {
                        return;
                    }
                    _loggerutils.default.debug(_this.name, method, "Document ".concat(method, " for event <").concat(event, ">"));
                    document[method](event, handler);
                });
            }
        },
        {
            key: "manageWindowEventHandler",
            value: function manageWindowEventHandler() {
                var type = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "remove";
                var _this = this;
                if (!this.adSession || !this.adEvents || !this.mediaEvents) {
                    return;
                }
                var method = "".concat(type, "EventListener");
                _lodash.default.forEach(WINDOW_LISTENED_EVENTS, function(event) {
                    var handler = _this.eventHandlers[event];
                    if (!handler) {
                        return;
                    }
                    _loggerutils.default.debug(_this.name, method, "Window ".concat(method, " for event <").concat(event, ">"));
                    window[method](event, handler);
                });
            }
        },
        {
            key: "manageVideoElementEventHandler",
            value: function manageVideoElementEventHandler() {
                var type = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "remove";
                var _this = this;
                if (!this.adSession || !this.adEvents || !this.mediaEvents) {
                    return;
                }
                var method = "".concat(type, "EventListener");
                _lodash.default.forEach(VIDEO_LISTENED_EVENTS, function(event) {
                    var handler = _this.eventHandlers[event];
                    if (!handler) {
                        return;
                    }
                    _loggerutils.default.debug(_this.name, method, "Video element ".concat(method, " for event <").concat(event, ">"));
                    _this.config.video[method](event, handler);
                });
            }
        },
        {
            key: "releaseAdConf",
            value: function releaseAdConf() {
                this.config = _object_spread_props._(_object_spread._({}, this.config), {
                    active: false,
                    ad: {
                        verifications: []
                    }
                });
            }
        },
        {
            key: "releaseAd",
            value: function releaseAd() {
                if (this.adSession) {
                    this.adSession.finish();
                }
                this.manageWindowEventHandler("remove");
                this.manageDocumentEventHandler("remove");
                this.manageVideoElementEventHandler("remove");
                this.releaseAdConf();
                this.adSession = null;
                this.adEvents = null;
                this.mediaEvents = null;
            }
        },
        {
            key: "timeoutRemoveIFrames",
            value: function timeoutRemoveIFrames() {
                var _this = this;
                _loggerutils.default.debug(this.name, "timeoutRemoveIFrames");
                setTimeout(function() {
                    _this.removeIFrames();
                }, CLEAR_DELAY_TRACKING_IFRAME);
            }
        },
        {
            key: "removeIFrames",
            value: function removeIFrames() {
                _loggerutils.default.debug(this.name, "removeIFrames");
                var iframes = Array.from(document.querySelectorAll("iframe")).filter(function(param) {
                    var id = param.id;
                    return id.includes("omid-verification-script");
                });
                iframes.forEach(function(iframe) {
                    return iframe.remove();
                });
            }
        },
        {
            key: "track",
            value: function track(target, event) {
                if (!CLEANUP_EVENTS.includes(event) && (!this.config.active || !this.getSessionClient())) {
                    return;
                }
                var handler = this.handlers[event];
                if (!handler) {
                    return;
                }
                _loggerutils.default.debug(this.name, "track", "Tracking event <".concat(event, ">"));
                if ((!this.adEvents || !this.mediaEvents) && !NO_SESSION_EVENTS.includes(event)) {
                    throw new Error("You should trigger AD_INIT event before triggering other event");
                }
                handler(target);
            }
        }
    ]);
    return OmTracking;
}(_tracking.Tracking);


/***/ }),

/***/ 46970:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "PixelTracking", ({
    enumerable: true,
    get: function() {
        return PixelTracking;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(3009);
__webpack_require__(42578);
var _lodash = /*#__PURE__*/ _interop_require_default._(__webpack_require__(32699));
var _tracking = __webpack_require__(8291);
var _loggerutils = /*#__PURE__*/ _interop_require_default._(__webpack_require__(11905));
var _trackingutil = __webpack_require__(64913);
var PixelTracking = /*#__PURE__*/ function(Tracking) {
    "use strict";
    _inherits._(PixelTracking, Tracking);
    var _super = _create_super._(PixelTracking);
    function PixelTracking() {
        _class_call_check._(this, PixelTracking);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.name = "PixelTracking";
        return _this;
    }
    _create_class._(PixelTracking, [
        {
            key: "track",
            value: function track(target, event) {
                var replacements = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                var _this = this;
                var tracking = _lodash.default.get(target, "tracking.".concat(event));
                if (!tracking) {
                    return;
                }
                var id = _lodash.default.get(target, "id") || _lodash.default.get(target, "adid");
                _loggerutils.default.debug(this.name, "track", "Tracking event <".concat(event, "> for entity ").concat(id));
                if (tracking instanceof Array) {
                    tracking.forEach(function(tr) {
                        return (0, _trackingutil.createPixel)((0, _trackingutil.getTrackingUrl)(tr, replacements, _this.config.withHttps));
                    });
                } else {
                    (0, _trackingutil.createPixel)((0, _trackingutil.getTrackingUrl)(tracking, replacements, this.config.withHttps));
                }
            }
        }
    ]);
    return PixelTracking;
}(_tracking.Tracking);


/***/ }),

/***/ 17437:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "ThirdPartiesTracking", ({
    enumerable: true,
    get: function() {
        return ThirdPartiesTracking;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(88801);
var _tracking = __webpack_require__(8291);
var _loggerutils = /*#__PURE__*/ _interop_require_default._(__webpack_require__(11905));
var ThirdPartiesTracking = /*#__PURE__*/ function(Tracking) {
    "use strict";
    _inherits._(ThirdPartiesTracking, Tracking);
    var _super = _create_super._(ThirdPartiesTracking);
    function ThirdPartiesTracking(debug) {
        _class_call_check._(this, ThirdPartiesTracking);
        var _this;
        _this = _super.call(this);
        _this.name = "ThirdPartiesTracking";
        _this.debug = false;
        _this.enabled = false;
        _this.sendEvent = null;
        _this.debug = debug;
        _loggerutils.default.debug(_this.name, "constructor", "Is debug mode activated : ".concat(_this.debug));
        return _this;
    }
    _create_class._(ThirdPartiesTracking, [
        {
            key: "setEventSender",
            value: function setEventSender(sendEvent) {
                if (!sendEvent) {
                    return;
                }
                this.sendEvent = sendEvent;
                this.enabled = true;
            }
        },
        {
            key: "track",
            value: function track(target, event) {
                _loggerutils.default.debug(this.name, "track", "Tracking event <".concat(event, ">"), target);
                if (this.enabled) {
                    var _this_config_ad, _this_config_ad1, _this_config_slot;
                    this.sendEvent({
                        adId: (_this_config_ad = this.config.ad) === null || _this_config_ad === void 0 ? void 0 : _this_config_ad.id,
                        adTitle: (_this_config_ad1 = this.config.ad) === null || _this_config_ad1 === void 0 ? void 0 : _this_config_ad1.title,
                        breakType: (_this_config_slot = this.config.slot) === null || _this_config_slot === void 0 ? void 0 : _this_config_slot.type,
                        event: event
                    });
                }
            }
        }
    ]);
    return ThirdPartiesTracking;
}(_tracking.Tracking);


/***/ }),

/***/ 8291:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "Tracking", ({
    enumerable: true,
    get: function() {
        return Tracking;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(3009);
var _lodash = /*#__PURE__*/ _interop_require_default._(__webpack_require__(32699));
var Tracking = /*#__PURE__*/ function() {
    "use strict";
    function Tracking() {
        _class_call_check._(this, Tracking);
    }
    _create_class._(Tracking, [
        {
            key: "configure",
            value: function configure(config) {
                this.config = _lodash.default.merge({}, this.config, config);
            }
        },
        {
            key: "setEventSender",
            value: function setEventSender() {
                throw new Error("Not Implemented Exception");
            }
        },
        {
            key: "track",
            value: function track() {
                throw new Error("Not Implemented Exception");
            }
        }
    ]);
    return Tracking;
}();


/***/ }),

/***/ 27769:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "TrackingManager", ({
    enumerable: true,
    get: function() {
        return TrackingManager;
    }
}));
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _interop_require_default = __webpack_require__(81200);
var _to_consumable_array = __webpack_require__(30005);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(65759);
var _pixeltracking = __webpack_require__(46970);
var _omtracking = __webpack_require__(36780);
var _thirdpartiestracking = __webpack_require__(17437);
var _loggerutils = /*#__PURE__*/ _interop_require_default._(__webpack_require__(11905));
var trackings = [
    _pixeltracking.PixelTracking,
    _omtracking.OmTracking,
    _thirdpartiestracking.ThirdPartiesTracking
];
var MAPPING_EVENTS = {
    fullscreen: [
        "fullscreen",
        "expand"
    ],
    exitFullscreen: [
        "exitFullscreen",
        "collapse"
    ]
};
var TrackingManager = /*#__PURE__*/ function() {
    "use strict";
    function TrackingManager() {
        var debug = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, items = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : trackings, sendEvent = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : undefined;
        _class_call_check._(this, TrackingManager);
        this.trackings = items.map(function(Tracking) {
            var trackingService = new Tracking(debug);
            if (trackingService.name === "ThirdPartiesTracking") {
                trackingService.setEventSender(sendEvent);
            }
            return trackingService;
        });
    }
    _create_class._(TrackingManager, [
        {
            key: "configure",
            value: function configure(config) {
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    Promise.all(_this.trackings.map(function(tracking) {
                                        return tracking.configure(config);
                                    }))
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "track",
            value: function track(target, event) {
                for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
                    args[_key - 2] = arguments[_key];
                }
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    Promise.all(_this.trackings.map(function() {
                                        var _ref = _async_to_generator._(function(tracking) {
                                            var _tracking, error;
                                            return _ts_generator._(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        _state.trys.push([
                                                            0,
                                                            5,
                                                            ,
                                                            6
                                                        ]);
                                                        if (!(MAPPING_EVENTS.fullscreen.indexOf(event) >= 0)) return [
                                                            3,
                                                            1
                                                        ];
                                                        MAPPING_EVENTS.fullscreen.forEach(function() {
                                                            var _ref = _async_to_generator._(function(mappedEvent) {
                                                                var _tracking;
                                                                return _ts_generator._(this, function(_state) {
                                                                    switch(_state.label){
                                                                        case 0:
                                                                            return [
                                                                                4,
                                                                                (_tracking = tracking).track.apply(_tracking, [
                                                                                    target,
                                                                                    mappedEvent
                                                                                ].concat(_to_consumable_array._(args)))
                                                                            ];
                                                                        case 1:
                                                                            return [
                                                                                2,
                                                                                _state.sent()
                                                                            ];
                                                                    }
                                                                });
                                                            });
                                                            return function(mappedEvent) {
                                                                return _ref.apply(this, arguments);
                                                            };
                                                        }());
                                                        return [
                                                            3,
                                                            4
                                                        ];
                                                    case 1:
                                                        if (!(MAPPING_EVENTS.exitFullscreen.indexOf(event) >= 0)) return [
                                                            3,
                                                            2
                                                        ];
                                                        MAPPING_EVENTS.exitFullscreen.forEach(function() {
                                                            var _ref = _async_to_generator._(function(mappedEvent) {
                                                                var _tracking;
                                                                return _ts_generator._(this, function(_state) {
                                                                    switch(_state.label){
                                                                        case 0:
                                                                            return [
                                                                                4,
                                                                                (_tracking = tracking).track.apply(_tracking, [
                                                                                    target,
                                                                                    mappedEvent
                                                                                ].concat(_to_consumable_array._(args)))
                                                                            ];
                                                                        case 1:
                                                                            return [
                                                                                2,
                                                                                _state.sent()
                                                                            ];
                                                                    }
                                                                });
                                                            });
                                                            return function(mappedEvent) {
                                                                return _ref.apply(this, arguments);
                                                            };
                                                        }());
                                                        return [
                                                            3,
                                                            4
                                                        ];
                                                    case 2:
                                                        return [
                                                            4,
                                                            (_tracking = tracking).track.apply(_tracking, [
                                                                target,
                                                                event
                                                            ].concat(_to_consumable_array._(args)))
                                                        ];
                                                    case 3:
                                                        _state.sent();
                                                        _state.label = 4;
                                                    case 4:
                                                        return [
                                                            3,
                                                            6
                                                        ];
                                                    case 5:
                                                        error = _state.sent();
                                                        _loggerutils.default.warn("TrackingManager", "".concat(tracking.name, "@track"), error);
                                                        return [
                                                            3,
                                                            6
                                                        ];
                                                    case 6:
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        });
                                        return function(tracking) {
                                            return _ref.apply(this, arguments);
                                        };
                                    }()))
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return TrackingManager;
}();


/***/ }),

/***/ 56565:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/**
 * Will choose the most suitable asset for the current session
 *
 * First, it will remove all the un-playable formats by a HTML5 video element (exception made of the VPAID)
 * Second, it will filter the assets considering their sizes and fillSpaceRatio (the more, the better)
 * At last, it will choose between the remaining assets the one corresponding to the desired bitrate
 *
 * @param assets
 * @param options
 * @param options.video
 * @param options.base
 * @param options.desiredBitrate
 * @returns {Object}
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    chooseLinearAsset: function() {
        return chooseLinearAsset;
    },
    chooseNonLinearAsset: function() {
        return chooseNonLinearAsset;
    }
});
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _sliced_to_array = __webpack_require__(28966);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(37815);
var chooseLinearAsset = function(assets, param) {
    var video = param.video, width = param.width, height = param.height, desiredBitrate = param.desiredBitrate, _param_withJavascript = param.withJavascript, withJavascript = _param_withJavascript === void 0 ? true : _param_withJavascript;
    var playableAssets = assets.filter(function(param) {
        var type = param.type, apiframework = param.apiframework;
        if ((type === "application/javascript" || type === "application/x-javascript") && apiframework === "VPAID") {
            return withJavascript;
        }
        var canPlay = video.canPlayType(type);
        return canPlay === "maybe" || canPlay === "probably";
    });
    var filteredAssets = playableAssets.filter(function(asset) {
        return asset.width <= width && asset.height <= height;
    }).map(function(asset) {
        return _object_spread_props._(_object_spread._({}, asset), {
            fillSpaceRatio: asset.width * asset.height / (width * height)
        });
    }).sort(function(firstItem, secondItem) {
        return secondItem.fillSpaceRatio - firstItem.fillSpaceRatio;
    });
    if (!filteredAssets.length) {
        filteredAssets.push(playableAssets[0]);
    }
    var bitrateFilteredAssets = filteredAssets.filter(function(asset) {
        return asset.bitrate <= desiredBitrate;
    });
    if (!bitrateFilteredAssets.length) {
        var _filteredAssets_slice_sort = _sliced_to_array._(filteredAssets.slice(0).sort(function(firstItem, secondItem) {
            return firstItem.bitrate - secondItem.bitrate;
        }), 1), leastBitrateFilteredAsset = _filteredAssets_slice_sort[0];
        return leastBitrateFilteredAsset || filteredAssets[0];
    }
    return bitrateFilteredAssets[0];
};
var chooseNonLinearAsset = function(assets) {
    var htmlAsset = assets.find(function(asset) {
        return asset.type === "html";
    });
    if (htmlAsset) {
        return htmlAsset;
    }
    var staticAsset = assets.find(function(asset) {
        return asset.type === "static";
    });
    if (staticAsset) {
        return staticAsset;
    }
    var iframeAsset = assets.find(function(asset) {
        return asset.type === "iframe";
    });
    if (iframeAsset) {
        return iframeAsset;
    }
    return assets[0];
};


/***/ }),

/***/ 40311:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "VastError", ({
    enumerable: true,
    get: function() {
        return VastError;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _inherits = __webpack_require__(71648);
var _wrap_native_super = __webpack_require__(69349);
var _create_super = __webpack_require__(6400);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(3009);
var _aderrors = __webpack_require__(16174);
var VastError = /*#__PURE__*/ function(Error1) {
    "use strict";
    _inherits._(VastError, Error1);
    var _super = _create_super._(VastError);
    function VastError(code) {
        var message = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _aderrors.vastErrorMessage[code];
        _class_call_check._(this, VastError);
        var _this;
        _this = _super.call(this, message);
        _this.name = "VastError";
        _this.code = code;
        return _this;
    }
    return VastError;
}(_wrap_native_super._(Error));


/***/ }),

/***/ 11905:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _to_consumable_array = __webpack_require__(30005);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(37815);
var _mediaengine = __webpack_require__(62221);
var executeLog = function() {
    var logLevel = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "info", target = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "Unknown target", method = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "Unknown method";
    for(var _len = arguments.length, messages = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++){
        messages[_key - 3] = arguments[_key];
    }
    if (!_mediaengine.mediaEngineConfig.get("isDebug")) {
        return;
    }
    var fallback = "log";
    var c = (console[logLevel] && typeof console[logLevel] === "function" ? console[logLevel] : console[fallback]).bind(console);
    c.apply(void 0, [
        "[adEngine][".concat(new Date().toLocaleTimeString(), "][").concat(target, "][").concat(method, "] -")
    ].concat(_to_consumable_array._(messages)));
};
var _default = {
    info: function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return executeLog.apply(void 0, [
            "info"
        ].concat(_to_consumable_array._(args)));
    },
    error: function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return executeLog.apply(void 0, [
            "error"
        ].concat(_to_consumable_array._(args)));
    },
    debug: function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return executeLog.apply(void 0, [
            "debug"
        ].concat(_to_consumable_array._(args)));
    },
    warn: function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return executeLog.apply(void 0, [
            "warn"
        ].concat(_to_consumable_array._(args)));
    }
};


/***/ }),

/***/ 84212:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "processAdTagUri", ({
    enumerable: true,
    get: function() {
        return processAdTagUri;
    }
}));
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(45538);
var _format = /*#__PURE__*/ _interop_require_default._(__webpack_require__(43069));
var processAdTagUri = function(adTagUri) {
    var queryParams = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var decodedUri;
    try {
        decodedUri = decodeURI(adTagUri);
    } catch (e) {
        decodedUri = adTagUri;
    }
    var macros = _object_spread._({
        CACHEBUSTING: function() {
            return Math.floor(Math.random() * 100000000).toString().padStart(8, "0");
        },
        TIMESTAMP: function() {
            return (0, _format.default)(new Date(), "yyyy-MM-dd'T'HH:mm:ss.SSSx");
        }
    }, queryParams);
    Object.keys(macros).forEach(function(key) {
        var regex = new RegExp("\\[".concat(key.toUpperCase(), "\\]"), "g");
        decodedUri = decodedUri.replace(regex, macros[key]);
    });
    return decodedUri;
};


/***/ }),

/***/ 7375:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "Parser", ({
    enumerable: true,
    get: function() {
        return Parser;
    }
}));
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _define_property = __webpack_require__(21228);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _object_without_properties = __webpack_require__(46537);
var _sliced_to_array = __webpack_require__(28966);
var _to_consumable_array = __webpack_require__(30005);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(45538);
var _lodash = /*#__PURE__*/ _interop_require_default._(__webpack_require__(32699));
var _superagent = /*#__PURE__*/ _interop_require_default._(__webpack_require__(54247));
var _types = __webpack_require__(19783);
var _utils = __webpack_require__(94607);
var _constants = __webpack_require__(92851);
var _errorutils = __webpack_require__(40311);
var _slotutils = __webpack_require__(90200);
var _macrosutils = __webpack_require__(84212);
var defaultOptions = {
    contentDuration: 0,
    features: {
        withCredentials: true,
        lazy: false
    }
};
var Parser = /*#__PURE__*/ function() {
    "use strict";
    function Parser() {
        _class_call_check._(this, Parser);
    }
    _create_class._(Parser, null, [
        {
            key: "setLogger",
            value: function setLogger(logger) {
                Parser.logger = logger;
                Parser.logger = logger;
            }
        },
        {
            key: "parseElementAttributes",
            value: function parseElementAttributes(element) {
                return Array.from(element.attributes).reduce(function(accumulator, attribute) {
                    var name = attribute.nodeName.toLowerCase();
                    if (attribute.value === "true") {
                        accumulator[name] = true;
                    } else if (attribute.value === "false") {
                        accumulator[name] = false;
                    } else if (_lodash.default.isNaN(Number(attribute.value))) {
                        accumulator[name] = attribute.value;
                    } else {
                        accumulator[name] = parseFloat(attribute.value);
                    }
                    return accumulator;
                }, {});
            }
        },
        {
            key: "getTextContent",
            value: function getTextContent(element) {
                var decodeURI = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var textContent = element === null || element === void 0 ? void 0 : element.textContent;
                if (!textContent) {
                    return null;
                }
                if (decodeURI) {
                    try {
                        textContent = window.decodeURI(textContent);
                    } catch (exception) {
                        Parser.logger.warn("parser.util", "getTextContent", exception, textContent);
                    }
                }
                return textContent;
            }
        },
        {
            key: "validateVASTVersion",
            value: function validateVASTVersion(param) {
                var version = param.version;
                return version > 1 && version < 5;
            }
        },
        {
            key: "parseAdImpression",
            value: function parseAdImpression(ad) {
                return Array.from(ad.getElementsByTagName("Impression")).reduce(function(accumulator, impression) {
                    var attributes = Parser.parseElementAttributes(impression);
                    var uri = Parser.getTextContent(impression, true);
                    // Prevent null or empty strings
                    if (uri && uri.length) {
                        var key = attributes.fullvideo === "true" ? _types.Advertising.TrackingEvent.ImpressionEnd : _types.Advertising.TrackingEvent.Impression;
                        if (!accumulator[key]) {
                            accumulator[key] = [];
                        }
                        accumulator[key].push(uri);
                    }
                    return accumulator;
                }, {});
            }
        },
        {
            key: "parseTracking",
            value: function parseTracking(tracking) {
                return _object_spread_props._(_object_spread._({}, Parser.parseElementAttributes(tracking)), {
                    url: Parser.getTextContent(tracking, true)
                });
            }
        },
        {
            key: "parseTrackingEvents",
            value: function parseTrackingEvents(creative) {
                var tagName = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "Tracking";
                var tracking = Array.from(creative.getElementsByTagName(tagName)).map(Parser.parseTracking).reduce(function(accumulator, param) {
                    var event = param.event, url = param.url;
                    if (!accumulator[event]) {
                        accumulator[event] = [];
                    }
                    if (url && url.length) {
                        accumulator[event].push(url);
                    }
                    return accumulator;
                }, {});
                tracking[_types.Advertising.TrackingEvent.Click] = [].concat(Array.from(creative.getElementsByTagName("ClickTracking")), Array.from(creative.getElementsByTagName("NonLinearClickTracking")), Array.from(creative.getElementsByTagName("CompanionClickTracking"))).map(function(track) {
                    return Parser.getTextContent(track, true);
                });
                return tracking;
            }
        },
        {
            key: "parseVerification",
            value: function parseVerification(verification) {
                var sanitize = function(str) {
                    return typeof str === "string" ? str.replace(/\n/g, "").trim() : "";
                };
                var jsResource = verification.getElementsByTagName("JavaScriptResource")[0];
                var verifParameters = verification.getElementsByTagName("VerificationParameters")[0];
                var parameters = sanitize(Parser.getTextContent(verifParameters, true));
                return {
                    resource: sanitize(Parser.getTextContent(jsResource, true)),
                    vendor: Parser.parseElementAttributes(verification).vendor || "",
                    parameters: parameters
                };
            }
        },
        {
            key: "parseNonLinearCreative",
            value: function parseNonLinearCreative(creative) {
                var assets = [].concat(Array.from(creative.getElementsByTagName("IFrameResource")), Array.from(creative.getElementsByTagName("HTMLResource")), Array.from(creative.getElementsByTagName("StaticResource"))).map(function(asset) {
                    return _object_spread_props._(_object_spread._({}, Parser.parseElementAttributes(asset)), {
                        type: asset.nodeName.replace(/resource/i, "").toLowerCase(),
                        src: Parser.getTextContent(asset, true)
                    });
                });
                var _creative_getElementsByTagName = _sliced_to_array._(creative.getElementsByTagName("NonLinear"), 1), nonLinearTag = _creative_getElementsByTagName[0];
                var _ref = nonLinearTag && Parser.parseElementAttributes(nonLinearTag) || {}, minsuggestedduration = _ref.minsuggestedduration, nonLinearParams = _object_without_properties._(_ref, [
                    "minsuggestedduration"
                ]);
                return _object_spread_props._(_object_spread._({}, Parser.parseElementAttributes(creative), nonLinearParams), {
                    duration: (0, _utils.convertTimeToSeconds)(minsuggestedduration),
                    assets: assets,
                    tracking: Parser.parseTrackingEvents(creative),
                    parameters: Parser.getTextContent(creative.getElementsByTagName("AdParameters")[0]),
                    clickThroughUrl: Parser.getTextContent(creative.getElementsByTagName("NonLinearClickThrough")[0], true) || Parser.getTextContent(creative.getElementsByTagName("CompanionClickThrough")[0], true),
                    linear: false
                });
            }
        },
        {
            key: "validateMediaFile",
            value: function validateMediaFile(mediaFile) {
                var isMediaFileValid = !!mediaFile.delivery && !!mediaFile.type && // Prevents the check to fail when width or height are 0 (VPAID mostly)
                !!Object.prototype.hasOwnProperty.call(mediaFile, "width") && !!Object.prototype.hasOwnProperty.call(mediaFile, "height") && !!mediaFile.src && !!mediaFile.src.length;
                if (!isMediaFileValid) {
                    return _object_spread_props._(_object_spread._({}, mediaFile), {
                        isMediaFileValid: false,
                        errorCode: 400
                    });
                }
                if (mediaFile.type !== "video/mp4" && mediaFile.type !== "application/javascript") {
                    return _object_spread_props._(_object_spread._({}, mediaFile), {
                        isMediaFileValid: false,
                        errorCode: 403
                    });
                }
                return _object_spread_props._(_object_spread._({}, mediaFile), {
                    isMediaFileValid: isMediaFileValid
                });
            }
        },
        {
            key: "parseMediaFile",
            value: function parseMediaFile(mediaFile) {
                return _object_spread_props._(_object_spread._({
                    bitrate: 0
                }, Parser.parseElementAttributes(mediaFile)), {
                    src: Parser.getTextContent(mediaFile, true)
                });
            }
        },
        {
            key: "parseCreative",
            value: function parseCreative(creative) {
                var assets = Array.from(creative.getElementsByTagName("MediaFile")).map(Parser.parseMediaFile).map(Parser.validateMediaFile).sort(function(firstAsset, secondAsset) {
                    return secondAsset.width * secondAsset.height * secondAsset.bitrate - firstAsset.width * firstAsset.height * firstAsset.bitrate;
                });
                var mediaFileErrorStack = Array.from(new Set(assets.filter(function(asset) {
                    return !asset.isMediaFileValid && asset.errorCode !== 403;
                }) // Filter out 403 errors (unsupported media types) that are handled separately.
                .map(function(asset) {
                    return asset.errorCode;
                })));
                // We should track 403 errors (unsupported media types) only if ALL media files are unsupported.
                var areAllMediaFileTypesUnsupported = assets.length > 0 && assets.every(function(asset) {
                    return !asset.isMediaFileValid && asset.errorCode === 403;
                });
                if (areAllMediaFileTypesUnsupported) {
                    mediaFileErrorStack.push(403);
                }
                var duration = (0, _utils.convertTimeToSeconds)(Parser.getTextContent(creative.getElementsByTagName("Duration")[0]));
                var creativeAttributes = Parser.parseElementAttributes(creative);
                if (typeof creativeAttributes.skipoffset === "string") {
                    creativeAttributes.skipoffset = (0, _utils.timeValueToSeconds)(creativeAttributes.skipoffset, duration, Parser.logger);
                }
                return _object_spread_props._(_object_spread._({}, Parser.parseElementAttributes(creative.parentElement), creativeAttributes), {
                    assets: assets.filter(function(asset) {
                        return asset.isMediaFileValid;
                    }),
                    errorStack: mediaFileErrorStack,
                    duration: duration,
                    tracking: Parser.parseTrackingEvents(creative),
                    parameters: Parser.getTextContent(creative.getElementsByTagName("AdParameters")[0]),
                    clickThroughUrl: Parser.getTextContent(creative.getElementsByTagName("ClickThrough")[0], true),
                    linear: true
                });
            }
        },
        {
            key: "getAdId",
            value: function getAdId(ad) {
                var _ad_getElementsByTagName_, _ad_getElementsByTagName, _ad_getElementsByTagName_1, _ad_getElementsByTagName1, _ad_getElementsByTagName_2, _ad_getElementsByTagName2, _adId_split;
                var adId = ad.getAttribute("id") || ((_ad_getElementsByTagName = ad.getElementsByTagName("AdInfo")) === null || _ad_getElementsByTagName === void 0 ? void 0 : (_ad_getElementsByTagName_ = _ad_getElementsByTagName[0]) === null || _ad_getElementsByTagName_ === void 0 ? void 0 : _ad_getElementsByTagName_.getAttribute("crea")) || ((_ad_getElementsByTagName1 = ad.getElementsByTagName("Creative")) === null || _ad_getElementsByTagName1 === void 0 ? void 0 : (_ad_getElementsByTagName_1 = _ad_getElementsByTagName1[0]) === null || _ad_getElementsByTagName_1 === void 0 ? void 0 : _ad_getElementsByTagName_1.getAttribute("adId")) || ((_ad_getElementsByTagName2 = ad.getElementsByTagName("Creative")) === null || _ad_getElementsByTagName2 === void 0 ? void 0 : (_ad_getElementsByTagName_2 = _ad_getElementsByTagName2[0]) === null || _ad_getElementsByTagName_2 === void 0 ? void 0 : _ad_getElementsByTagName_2.getAttribute("id")) || "unknown";
                return (_adId_split = adId.split(/[:.]/)) === null || _adId_split === void 0 ? void 0 : _adId_split[0];
            }
        },
        {
            key: "parseAd",
            value: function parseAd(param) {
                var id = param.id, ad = param.ad, depth = param.depth, _param_redirects = param.redirects, redirects = _param_redirects === void 0 ? 0 : _param_redirects, inheritedProperty = param.inheritedProperty, _param_queryParams = param.queryParams, queryParams = _param_queryParams === void 0 ? {} : _param_queryParams, _param_withCredentials = param.withCredentials, withCredentials = _param_withCredentials === void 0 ? true : _param_withCredentials, onError = param.onError;
                return _async_to_generator._(function() {
                    var _Math, _inheritedProperty_ad, _inheritedProperty_ad1, wrapperAttributes, isValidAd, errorStack, wrapper, linearCreatives, nonLinearCreatives, companions, adTagURIs, hasValidNonLinearAsset, creatives, newTracking, parsedAd, tagUri, _parsedAd_creatives_, _parsedAd_creatives, parsedVAST, nestedAd, hasAssets, hasError502;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                wrapperAttributes = {};
                                isValidAd = Parser.isValidAdElement(ad);
                                errorStack = [];
                                if (!isValidAd) {
                                    errorStack.push(101);
                                }
                                wrapper = ad.getElementsByTagName("Wrapper")[0];
                                if (wrapper) {
                                    wrapperAttributes = Parser.parseElementAttributes(wrapper);
                                }
                                linearCreatives = Array.from(ad.getElementsByTagName("Linear")).map(Parser.parseCreative);
                                nonLinearCreatives = Array.from(ad.getElementsByTagName("NonLinearAds")).map(Parser.parseNonLinearCreative);
                                companions = Array.from(ad.getElementsByTagName("Companion")).map(Parser.parseNonLinearCreative);
                                adTagURIs = Array.from(ad.getElementsByTagName("VASTAdTagURI"));
                                if (isValidAd && !linearCreatives.length && !nonLinearCreatives.length && !companions.length && adTagURIs.length !== 1) {
                                    errorStack.push(303);
                                }
                                if (nonLinearCreatives.length) {
                                    hasValidNonLinearAsset = nonLinearCreatives.some(function(creative) {
                                        return ((creative === null || creative === void 0 ? void 0 : creative.assets) || []).some(function(asset) {
                                            return !!(asset === null || asset === void 0 ? void 0 : asset.src);
                                        });
                                    });
                                    if (!hasValidNonLinearAsset) {
                                        errorStack.push(502);
                                    }
                                }
                                creatives = linearCreatives.concat(nonLinearCreatives).map(function(creative) {
                                    var _inheritedProperty_creative, _inheritedProperty_creative1;
                                    return _object_spread_props._(_object_spread._({}, creative), {
                                        adid: Parser.getAdId(ad),
                                        tracking: _lodash.default.mergeWith(creative.tracking, inheritedProperty === null || inheritedProperty === void 0 ? void 0 : (_inheritedProperty_creative = inheritedProperty.creative) === null || _inheritedProperty_creative === void 0 ? void 0 : _inheritedProperty_creative.tracking, _utils.mergeArrayWithoutDuplicates),
                                        duration: creative.duration || (inheritedProperty === null || inheritedProperty === void 0 ? void 0 : (_inheritedProperty_creative1 = inheritedProperty.creative) === null || _inheritedProperty_creative1 === void 0 ? void 0 : _inheritedProperty_creative1.duration) || 0,
                                        errorStack: creative.errorStack || []
                                    });
                                });
                                newTracking = _object_spread_props._(_object_spread._({}, Parser.parseAdImpression(ad)), _define_property._({}, _types.Advertising.TrackingEvent.Error, Array.from(ad.getElementsByTagName("Error")).map(function(error) {
                                    return Parser.getTextContent(error, true);
                                })));
                                creatives.forEach(function(creative) {
                                    if (creative.errorStack.length) {
                                        if (onError) {
                                            creative.errorStack.forEach(function(error) {
                                                return onError(error);
                                            });
                                        } else {
                                            var _errorStack;
                                            (_errorStack = errorStack).push.apply(_errorStack, _to_consumable_array._(creative.errorStack));
                                        }
                                    }
                                });
                                parsedAd = _object_spread_props._(_object_spread._({}, wrapperAttributes, Parser.parseElementAttributes(ad)), {
                                    id: id,
                                    depth: depth,
                                    isWrapper: !!wrapper,
                                    tracking: _lodash.default.mergeWith(newTracking, inheritedProperty === null || inheritedProperty === void 0 ? void 0 : (_inheritedProperty_ad = inheritedProperty.ad) === null || _inheritedProperty_ad === void 0 ? void 0 : _inheritedProperty_ad.tracking, _utils.mergeArrayWithoutDuplicates),
                                    creatives: creatives,
                                    companions: companions,
                                    duration: (_Math = Math).max.apply(_Math, _to_consumable_array._(creatives.map(function(creative) {
                                        return creative.duration || 0;
                                    })).concat([
                                        0
                                    ])),
                                    title: Parser.getTextContent(ad.getElementsByTagName("AdTitle")[0]),
                                    system: Parser.getTextContent(ad.getElementsByTagName("AdSystem")[0]),
                                    redirects: redirects,
                                    errorStack: errorStack,
                                    verifications: Array.from(ad.getElementsByTagName("Verification")).map(Parser.parseVerification).concat(inheritedProperty === null || inheritedProperty === void 0 ? void 0 : (_inheritedProperty_ad1 = inheritedProperty.ad) === null || _inheritedProperty_ad1 === void 0 ? void 0 : _inheritedProperty_ad1.verifications).filter(function(verification) {
                                        return !!verification;
                                    })
                                });
                                tagUri = Parser.getTextContent(ad.getElementsByTagName("VASTAdTagURI")[0], true);
                                if (!(tagUri && redirects < _constants.MAX_VAST_RECURSIVITY)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    Parser.retrieveAdTagURI({
                                        adTagURI: tagUri,
                                        redirects: redirects + 1,
                                        inheritedProperty: {
                                            creative: {
                                                tracking: parsedAd === null || parsedAd === void 0 ? void 0 : (_parsedAd_creatives = parsedAd.creatives) === null || _parsedAd_creatives === void 0 ? void 0 : (_parsedAd_creatives_ = _parsedAd_creatives[0]) === null || _parsedAd_creatives_ === void 0 ? void 0 : _parsedAd_creatives_.tracking
                                            },
                                            ad: {
                                                tracking: parsedAd.tracking,
                                                verifications: parsedAd.verifications
                                            }
                                        },
                                        queryParams: queryParams,
                                        withCredentials: withCredentials,
                                        onError: function(code) {
                                            parsedAd.errorStack.push(code);
                                            onError === null || onError === void 0 ? void 0 : onError(code);
                                        },
                                        parentAd: parsedAd
                                    })
                                ];
                            case 1:
                                parsedVAST = _state.sent();
                                if (parsedVAST) {
                                    // Hand merge, to avoid mis-merges with lodash
                                    parsedAd.id = _lodash.default.get(parsedVAST, "ads.0.id", parsedAd.id);
                                    parsedAd.title = _lodash.default.get(parsedVAST, "ads.0.title", parsedAd.title);
                                    parsedAd.system = _lodash.default.get(parsedVAST, "ads.0.system", parsedAd.system);
                                    parsedAd.redirects = _lodash.default.get(parsedVAST, "ads.0.redirects", parsedAd.redirects);
                                    // Merge error tracking URLs from nested VAST with parent ad's tracking
                                    nestedAd = _lodash.default.get(parsedVAST, "ads.0");
                                    if (nestedAd && nestedAd.tracking && nestedAd.tracking.error) {
                                        // Merge error tracking URLs from nested ad and remove duplicates
                                        parsedAd.tracking.error = _to_consumable_array._(new Set(_to_consumable_array._(parsedAd.tracking.error).concat(_to_consumable_array._(nestedAd.tracking.error))));
                                    }
                                    // wrapper doesn't have ads but give inherited property
                                    parsedAd.creatives = [];
                                    parsedAd.wrapperVAST = parsedVAST;
                                }
                                _state.label = 2;
                            case 2:
                                hasAssets = parsedAd.creatives.some(function(crea) {
                                    var _crea_assets;
                                    return (_crea_assets = crea.assets) === null || _crea_assets === void 0 ? void 0 : _crea_assets.length;
                                });
                                hasError502 = parsedAd.errorStack.includes(502);
                                if (!hasAssets && !parsedAd.wrapperVAST || hasError502) {
                                    Parser.logger.error("parser.util", "parseAd", hasError502 ? "Could Not Fetch NonLinear Ad" : "Wrong format: no asset in VAST");
                                    parsedAd.creatives = [];
                                }
                                return [
                                    2,
                                    parsedAd
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "parseVAST",
            value: function parseVAST(param) {
                var vast = param.vast, _param_redirects = param.redirects, redirects = _param_redirects === void 0 ? 0 : _param_redirects, inheritedProperty = param.inheritedProperty, _param_queryParams = param.queryParams, queryParams = _param_queryParams === void 0 ? {} : _param_queryParams, onError = param.onError, parentAd = param.parentAd, withCredentials = param.withCredentials;
                var _this = this;
                return _async_to_generator._(function() {
                    var parsedVAST, errorTracking, getVASTElementDepth, AdElements, ads, hasSequencing;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                parsedVAST = _object_spread._(_object_spread_props._(_object_spread._({}, (0, _slotutils.createEmptySlot)()), {
                                    id: 0,
                                    loaded: true,
                                    errorStack: []
                                }), Parser.parseElementAttributes(vast));
                                errorTracking = Parser.getTextContent(vast.getElementsByTagName("Error")[0]);
                                if (errorTracking) {
                                    parsedVAST.tracking.error.push(errorTracking);
                                }
                                getVASTElementDepth = function(element) {
                                    var depth = 0;
                                    var currentElement = element;
                                    while(currentElement.parentElement){
                                        depth++;
                                        if (depth > _constants.MAX_VAST_RECURSIVITY) return -1;
                                        currentElement = currentElement.parentElement;
                                    }
                                    return depth - 1;
                                };
                                AdElements = vast.getElementsByTagName("Ad");
                                if (!AdElements.length) {
                                    // No AdElements, so we need to add the error tracking to the parentAd
                                    if (parsedVAST.tracking.error && errorTracking) {
                                        parentAd.tracking.error.push(errorTracking);
                                    }
                                    onError === null || onError === void 0 ? void 0 : onError(303);
                                }
                                return [
                                    4,
                                    Promise.all(Array.from(AdElements).map(function(adElement) {
                                        return Parser.parseAd({
                                            id: _this.getAdId(adElement),
                                            ad: adElement,
                                            depth: getVASTElementDepth(adElement),
                                            redirects: redirects,
                                            inheritedProperty: inheritedProperty,
                                            queryParams: queryParams,
                                            withCredentials: withCredentials,
                                            onError: onError
                                        });
                                    }))
                                ];
                            case 1:
                                ads = _state.sent();
                                hasSequencing = ads.find(function(param) {
                                    var sequence = param.sequence;
                                    return Number.isInteger(sequence);
                                });
                                if (hasSequencing) {
                                    parsedVAST.ads = ads.filter(function(param) {
                                        var sequence = param.sequence;
                                        return Number.isInteger(sequence);
                                    });
                                    parsedVAST.buffet = ads.filter(function(param) {
                                        var sequence = param.sequence;
                                        return !Number.isInteger(sequence);
                                    });
                                } else {
                                    parsedVAST.ads = ads;
                                }
                                // In any case, sort them out by the sequence
                                parsedVAST.ads.sort(function(first, second) {
                                    return first.sequence - second.sequence;
                                });
                                return [
                                    2,
                                    parsedVAST
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "retrieveAdTagURI",
            value: function retrieveAdTagURI(param) {
                var adTagURI = param.adTagURI, _param_redirects = param.redirects, redirects = _param_redirects === void 0 ? 0 : _param_redirects, _param_inheritedProperty = param.inheritedProperty, inheritedProperty = _param_inheritedProperty === void 0 ? undefined : _param_inheritedProperty, _param_queryParams = param.queryParams, queryParams = _param_queryParams === void 0 ? {} : _param_queryParams, _param_withCredentials = param.withCredentials, withCredentials = _param_withCredentials === void 0 ? true : _param_withCredentials, onError = param.onError, parentAd = param.parentAd;
                var processedAdTagURI = (0, _macrosutils.processAdTagUri)(adTagURI, queryParams);
                var currentRequest = _superagent.default.get(processedAdTagURI);
                if (withCredentials) {
                    currentRequest.withCredentials();
                }
                return currentRequest.timeout(_constants.REQUEST_TIMEOUT_MS)// Let's not sequence the received ads here as it should only return one ad
                .then(function(response) {
                    return (0, _utils.textToHtmlElement)(response.text).then(function(xml) {
                        return Parser.parseVAST({
                            vast: xml.getElementsByTagName("VAST")[0],
                            redirects: redirects,
                            inheritedProperty: inheritedProperty,
                            queryParams: queryParams,
                            onError: onError,
                            parentAd: parentAd,
                            withCredentials: withCredentials
                        });
                    });
                }).catch(function(error) {
                    if (error.code === "ECONNABORTED" && error.timeout) {
                        /* 301 - Timeout of VAST URI provided in wrapper element,
                 * or of VAST URI provided in a subsequent wrapper element.
                 * This includes request errors such as invalid URI, unreachable or request timeout for URI, and security
                 * or other exceptions related to requesting a VAST URI
                 */ Parser.logger.warn("parser.util", "301 - parseAd", error);
                        onError === null || onError === void 0 ? void 0 : onError(301);
                    } else {
                        Parser.logger.warn("parser.util", "100 - parseAd", error);
                        onError === null || onError === void 0 ? void 0 : onError(100);
                    }
                    return null;
                });
            }
        },
        {
            key: "retrieveSlot",
            value: function retrieveSlot(slot, queryParams) {
                var withCredentials = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
                var _this = this;
                return _async_to_generator._(function() {
                    var loadedSlot;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.retrieveAdTagURI({
                                        adTagURI: slot.adTagURI,
                                        redirects: 0,
                                        inheritedProperty: slot.options,
                                        queryParams: queryParams,
                                        withCredentials: withCredentials
                                    })
                                ];
                            case 1:
                                loadedSlot = _state.sent();
                                if (!loadedSlot) {
                                    return [
                                        2,
                                        null
                                    ];
                                }
                                return [
                                    2,
                                    _object_spread_props._(_object_spread._({}, loadedSlot), {
                                        id: slot.id,
                                        cuePoint: slot.cuePoint,
                                        type: slot.type,
                                        allowMultipleAds: slot.allowMultipleAds,
                                        followRedirects: slot.followRedirects,
                                        tracking: (0, _utils.mergeTracking)(slot.tracking, loadedSlot.tracking)
                                    })
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "parseVMAPAdSource",
            value: function parseVMAPAdSource(adSource, options) {
                return _async_to_generator._(function() {
                    var vast, adTag, adTagURI, _options_features, _options_features1;
                    return _ts_generator._(this, function(_state) {
                        vast = adSource.getElementsByTagName("VAST")[0];
                        // The VAST is already present, we just need to parse it
                        if (vast) {
                            return [
                                2,
                                Parser.parseVAST({
                                    vast: vast
                                })
                            ];
                        }
                        adTag = adSource.getElementsByTagName("vmap:AdTagURI")[0];
                        adTagURI = Parser.getTextContent(adTag);
                        // Retrieve the adTagURI and then parses it into a valid VAST
                        if (adTagURI) {
                            ;
                            if (options === null || options === void 0 ? void 0 : (_options_features = options.features) === null || _options_features === void 0 ? void 0 : _options_features.lazy) {
                                return [
                                    2,
                                    _object_spread_props._(_object_spread._({}, (0, _slotutils.createEmptySlot)()), {
                                        adTagURI: adTagURI
                                    })
                                ];
                            }
                            return [
                                2,
                                Parser.retrieveAdTagURI({
                                    adTagURI: adTagURI,
                                    redirects: 0,
                                    queryParams: (options === null || options === void 0 ? void 0 : options.queryParams) || {},
                                    withCredentials: options === null || options === void 0 ? void 0 : (_options_features1 = options.features) === null || _options_features1 === void 0 ? void 0 : _options_features1.withCredentials
                                })
                            ];
                        }
                        return [
                            2,
                            Promise.resolve(null)
                        ];
                    });
                })();
            }
        },
        {
            key: "validateVMAPAdSource",
            value: function validateVMAPAdSource(adSource) {
                if (!adSource) {
                    return false;
                }
                var adSourceVAST = adSource.getElementsByTagName("VAST")[0];
                if (adSourceVAST && adSourceVAST.childNodes.length === 0) {
                    return false;
                }
                var adTagURI = adSource.getElementsByTagName("vmap:AdTagURI")[0];
                if (adTagURI) {
                    var adTagURIAttributes = Parser.parseElementAttributes(adTagURI);
                    // We support vast 2, 3 and 4
                    if (![
                        "vast2",
                        "vast3",
                        "vast4"
                    ].includes(adTagURIAttributes.templatetype)) {
                        return false;
                    }
                }
                return true;
            }
        },
        {
            key: "parseVMAP",
            value: function parseVMAP(vmap, options) {
                return _async_to_generator._(function() {
                    var promises;
                    return _ts_generator._(this, function(_state) {
                        promises = Array.from(vmap.getElementsByTagName("vmap:AdBreak")).map(function() {
                            var _ref = _async_to_generator._(function(slot) {
                                var adSource, adTracking, hasValidatedVMAPAdSource, hasValidatedVMAPTrackingEvents, slotAttributes, tracking, timeoffset, cuePoint, parsedVAST, sourceAttributes;
                                return _ts_generator._(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            adSource = slot.getElementsByTagName("vmap:AdSource")[0];
                                            adTracking = slot.getElementsByTagName("vmap:TrackingEvents")[0];
                                            hasValidatedVMAPAdSource = Parser.validateVMAPAdSource(adSource);
                                            hasValidatedVMAPTrackingEvents = !!adTracking;
                                            if (!hasValidatedVMAPAdSource) {
                                                Parser.logger.error("parser.util", "parseVMAP", "Wrong format: no adSource in VMAP");
                                            }
                                            if (!hasValidatedVMAPTrackingEvents) {
                                                Parser.logger.warn("parser.util", "parseVMAP", "Wrong format: no adTrackingEvents in VMAP");
                                            }
                                            if (!hasValidatedVMAPAdSource && !hasValidatedVMAPTrackingEvents) {
                                                return [
                                                    2
                                                ];
                                            }
                                            Parser.logger.debug("parser.util", "parseVMAP", "VMAP validation complete");
                                            slotAttributes = Parser.parseElementAttributes(slot);
                                            tracking = Parser.parseTrackingEvents(slot, "vmap:Tracking");
                                            if (!tracking[_types.Advertising.TrackingEvent.Error]) {
                                                tracking[_types.Advertising.TrackingEvent.Error] = [];
                                            }
                                            timeoffset = slotAttributes.timeoffset;
                                            cuePoint = (0, _utils.timeValueToSeconds)(timeoffset, options.contentDuration, Parser.logger);
                                            if (!adSource) {
                                                return [
                                                    2,
                                                    _object_spread_props._(_object_spread._({}, (0, _slotutils.createEmptySlot)()), {
                                                        ads: [],
                                                        id: slotAttributes.breakid,
                                                        cuePoint: cuePoint,
                                                        type: slotAttributes.breaktype,
                                                        loaded: true,
                                                        tracking: tracking
                                                    })
                                                ];
                                            }
                                            return [
                                                4,
                                                Parser.parseVMAPAdSource(adSource, options)
                                            ];
                                        case 1:
                                            parsedVAST = _state.sent();
                                            if (!parsedVAST) {
                                                return [
                                                    2,
                                                    null
                                                ];
                                            }
                                            sourceAttributes = Parser.parseElementAttributes(adSource);
                                            return [
                                                2,
                                                _object_spread_props._(_object_spread._({}, parsedVAST), {
                                                    id: slotAttributes.breakid,
                                                    cuePoint: cuePoint,
                                                    type: slotAttributes.breaktype,
                                                    allowMultipleAds: sourceAttributes.allowmultipleads,
                                                    followRedirects: sourceAttributes.followredirects,
                                                    tracking: (0, _utils.mergeTracking)(parsedVAST.tracking, tracking)
                                                })
                                            ];
                                    }
                                });
                            });
                            return function(slot) {
                                return _ref.apply(this, arguments);
                            };
                        }());
                        return [
                            2,
                            Promise.all(promises)
                        ];
                    });
                })();
            }
        },
        {
            key: "parse",
            value: function parse(text, opts) {
                return _async_to_generator._(function() {
                    var options, xml, rootNodeName, slots, _options_features, slot, error;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                options = _lodash.default.merge({}, defaultOptions, opts);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    7,
                                    ,
                                    8
                                ]);
                                return [
                                    4,
                                    (0, _utils.textToHtmlElement)(text)
                                ];
                            case 2:
                                xml = _state.sent();
                                if (!xml.childNodes.length) return [
                                    3,
                                    6
                                ];
                                rootNodeName = xml.childNodes[0].nodeName.toLowerCase();
                                if (!(rootNodeName === _types.Advertising.AD_FORMAT.VMAP)) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    Parser.parseVMAP(xml.childNodes[0], options)
                                ];
                            case 3:
                                slots = _state.sent().filter(function(slot) {
                                    return !!slot;
                                });
                                return [
                                    2,
                                    {
                                        format: _types.Advertising.AD_FORMAT.VMAP,
                                        slots: slots
                                    }
                                ];
                            case 4:
                                if (!(rootNodeName === _types.Advertising.AD_FORMAT.VAST)) return [
                                    3,
                                    6
                                ];
                                return [
                                    4,
                                    Parser.parseVAST({
                                        vast: xml.childNodes[0],
                                        queryParams: (options === null || options === void 0 ? void 0 : options.queryParams) || {},
                                        withCredentials: options === null || options === void 0 ? void 0 : (_options_features = options.features) === null || _options_features === void 0 ? void 0 : _options_features.withCredentials
                                    })
                                ];
                            case 5:
                                slot = _state.sent();
                                return [
                                    2,
                                    {
                                        format: _types.Advertising.AD_FORMAT.VAST,
                                        slots: [
                                            slot
                                        ]
                                    }
                                ];
                            case 6:
                                // HERE potentially a breaking change
                                return [
                                    2,
                                    {
                                        format: _types.Advertising.AD_FORMAT.UNKNOWN,
                                        slots: []
                                    }
                                ];
                            case 7:
                                error = _state.sent();
                                Parser.logger.error("parser.util", "100 - parse", error);
                                // HERE potentially a breaking change
                                throw new _errorutils.VastError(100);
                            case 8:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return Parser;
}();
Parser.logger = {
    info: _lodash.default.noop,
    error: _lodash.default.noop,
    debug: _lodash.default.noop,
    warn: _lodash.default.noop
};
Parser.convertTimeToSeconds = _utils.convertTimeToSeconds;
Parser.isValidAdElement = function(ad) {
    var wrappers = ad.getElementsByTagName("Wrapper");
    var inlines = ad.getElementsByTagName("InLine");
    if (wrappers.length + inlines.length !== 1) {
        return false;
    }
    if (wrappers.length) {
        // Verify that in the case of Wrapper, an AdTagURI is provided
        return !!Parser.getTextContent(wrappers[0].getElementsByTagName("VASTAdTagURI")[0], true);
    }
    return true;
};


/***/ }),

/***/ 94607:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    convertTimeToSeconds: function() {
        return convertTimeToSeconds;
    },
    mergeArrayWithoutDuplicates: function() {
        return mergeArrayWithoutDuplicates;
    },
    mergeTracking: function() {
        return mergeTracking;
    },
    textToHtmlElement: function() {
        return textToHtmlElement;
    },
    timeOffsetRegex: function() {
        return timeOffsetRegex;
    },
    timeValueToSeconds: function() {
        return timeValueToSeconds;
    }
});
var _define_property = __webpack_require__(21228);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _sliced_to_array = __webpack_require__(28966);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(3009);
var _sax = /*#__PURE__*/ _interop_require_default._(__webpack_require__(69499));
var _lodash = /*#__PURE__*/ _interop_require_default._(__webpack_require__(32699));
var _parserutils = __webpack_require__(7375);
var timeOffsetRegex = /^(\d{1,2}):(\d{1,2}):((\d{1,2})(\.\d{1,3})?)$/;
var convertTimeToSeconds = function(time) {
    try {
        var matches = time.match(timeOffsetRegex);
        if (matches) {
            var _matches = _sliced_to_array._(matches, 4), hours = _matches[1], minutes = _matches[2], seconds = _matches[3];
            return Number(hours) * 3600 + Number(minutes) * 60 + Number(seconds);
        }
        return 0;
    } catch (e) {
        return 0;
    }
};
var textToHtmlElement = function(text) {
    return new Promise(function(resolve) {
        /**
         * Some programmatic VAST could return un-CDATA-wrapped URL inside XML elements which could potentially
         * break the strict native DOMParserLegacy. We have to use another parser which does not break parsing when it
         * encounters such an error.
         *
         * Examples:
         * <Creative><![CDATA[http://my-ad.com?key1=1&key2=2]]></Creative> ==> Does not break the native DOMParser
         * <Creative>http://my-ad.com?key1=1&key2=2></Creative> ==> Breaks the native DOMParser
         */ var parser = _sax.default.parser(false);
        var root = document.createElement("xml");
        var tree = [
            root
        ];
        // Prevent upperCasing the names as the sax lib is doing it on non-strict mode
        parser.looseCase = "substr";
        parser.onerror = function() {
            parser.error = null;
            // Keep going the party !
            parser.resume();
        };
        parser.oncdata = function(cdata) {
            tree[tree.length - 1].textContent = cdata;
        };
        parser.ontext = function(nodeText) {
            // Some nodes could have some blank text even if they have children
            var escapedText = nodeText && nodeText.trim().replace(/(\n|\t)/g, "");
            if (escapedText.length > 0) {
                tree[tree.length - 1].textContent = escapedText;
            }
        };
        parser.onopentag = function(node) {
            var parentElement = tree[tree.length - 1];
            var element = document.createElement(node.name);
            _lodash.default.forOwn(node.attributes, function(value, key) {
                return element.setAttribute(key, value);
            });
            parentElement.appendChild(element);
            // We encounter an another hierarchy, the next found tags are children of it
            tree.push(element);
        };
        parser.onclosetag = function() {
            // Closing the tag, so the current parent has no more children
            tree.pop();
        };
        parser.onend = function() {
            resolve(root);
        };
        // A "&" at the end of a non-CDATA string could break the parsing
        parser.write(text.replace(/(&amp;|&)<\//g, "</")).close();
    });
};
var timeValueToSeconds = function(timeValue, contentDuration, logger) {
    // timeOffset can have different values (see IAB documentation)
    if (timeValue === "start") {
        return 0;
    }
    if (timeOffsetRegex.test(timeValue)) {
        return Math.round(convertTimeToSeconds(timeValue));
    }
    if (/^[0-9]+%$/.test(timeValue)) {
        var percentage = parseInt(timeValue.substring(0, timeValue.length - 1), 10);
        if (_lodash.default.isNaN(percentage) || percentage < 0 || percentage > 100) {
            logger.warn("parser.util", "parseVMAP", "cuePoint could not be determined in seconds");
            return null;
        }
        return Math.round(percentage / 100 * contentDuration);
    }
    _parserutils.Parser.logger.warn("parser.util", "parseVMAP", "cuePoint could not be determined in seconds");
    return null;
};
var mergeArrayWithoutDuplicates = function(target, source) {
    if (_lodash.default.isArray(target)) {
        return _lodash.default.concat(target, source);
    }
    return undefined;
};
var uniqueAndValid = function(value, index, self) {
    return !!value && self.indexOf(value) === index;
};
var mergeTracking = function() {
    for(var _len = arguments.length, trackings = new Array(_len), _key = 0; _key < _len; _key++){
        trackings[_key] = arguments[_key];
    }
    var distinctKeys = trackings.flatMap(function(tracking) {
        return Object.keys(tracking);
    }).filter(uniqueAndValid);
    return distinctKeys.reduce(function(acc, key) {
        return _object_spread_props._(_object_spread._({}, acc), _define_property._({}, key, trackings.flatMap(function(tracking) {
            return tracking[key];
        }).filter(uniqueAndValid)));
    }, {});
};


/***/ }),

/***/ 69827:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "timedOutPromise", ({
    enumerable: true,
    get: function() {
        return timedOutPromise;
    }
}));
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
var timedOutPromise = function(promise, time) {
    var timeOutError = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : new Error("timeout");
    var timeoutId;
    return Promise.race([
        promise,
        new Promise(function(_, reject) {
            return timeoutId = setTimeout(function() {
                return reject(timeOutError);
            }, time);
        })
    ]).finally(function() {
        return clearTimeout(timeoutId);
    });
};


/***/ }),

/***/ 75339:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "uniqueReference", ({
    enumerable: true,
    get: function() {
        return uniqueReference;
    }
}));
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(42578);
var uniqueReference = function() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c == "x" ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
};


/***/ }),

/***/ 26577:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _class_call_check = __webpack_require__(67818);
var _inherits = __webpack_require__(71648);
var _wrap_native_super = __webpack_require__(69349);
var _create_super = __webpack_require__(6400);
__webpack_require__(37815);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(52318);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.AuthError = exports.AuthErrorCode = void 0;
/**
 * Authentication error codes used to identify specific auth failure scenarios.
 * @readonly
 * @enum {string}
 */ exports.AuthErrorCode = Object.freeze({
    /** Token refresh operation failed */ REFRESH_FAILED: "REFRESH_FAILED"
});
/**
 * Custom error class for authentication-related failures.
 * Extends the native Error class with additional properties for HTTP status,
 * error codes, and cause tracking.
 *
 * @extends {Error}
 *
 * @example
 * // Throw with a message
 * throw new AuthError('Token expired', { status: 401, code: AuthErrorCode.REFRESH_FAILED });
 *
 * @example
 * // Wrap an existing error
 * try {
 *   await refreshToken();
 * } catch (err) {
 *   throw new AuthError(err, { cause: 'refresh_endpoint_unreachable', status: 503 });
 * }
 */ var AuthError = /*#__PURE__*/ function(Error1) {
    _inherits._(AuthError, Error1);
    var _super = _create_super._(AuthError);
    function AuthError() {
        var error = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, cause = _ref.cause, status = _ref.status, code = _ref.code;
        _class_call_check._(this, AuthError);
        var _this;
        _this = _super.call(this);
        /** @type {string} */ _this.name = _this.constructor.name;
        /** @type {string} */ _this.message = error instanceof Error ? error.toString() : error;
        /** @type {*} */ _this.cause = cause;
        /** @type {number|undefined} */ _this.status = status;
        /** @type {string|undefined} */ _this.code = code;
        /** @type {string|undefined} */ _this.stack = error instanceof Error ? error.stack : new Error().stack;
        return _this;
    }
    return AuthError;
}(_wrap_native_super._(Error));
exports.AuthError = AuthError;


/***/ }),

/***/ 73512:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _class_call_check = __webpack_require__(67818);
var _inherits = __webpack_require__(71648);
var _to_consumable_array = __webpack_require__(30005);
var _wrap_native_super = __webpack_require__(69349);
var _create_super = __webpack_require__(6400);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(65759);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.BaseFidoError = void 0;
var BaseFidoError = /*#__PURE__*/ function(Error1) {
    _inherits._(BaseFidoError, Error1);
    var _super = _create_super._(BaseFidoError);
    function BaseFidoError() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        _class_call_check._(this, BaseFidoError);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(_to_consumable_array._(args)));
        _this.stack = new Error().stack;
        _this.name = _this.constructor.name;
        return _this;
    }
    return BaseFidoError;
}(_wrap_native_super._(Error));
exports.BaseFidoError = BaseFidoError;


/***/ }),

/***/ 41180:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _class_call_check = __webpack_require__(67818);
var _inherits = __webpack_require__(71648);
var _wrap_native_super = __webpack_require__(69349);
var _create_super = __webpack_require__(6400);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(65759);
__webpack_require__(3009);
var __importDefault = (void 0) && (void 0).__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.FetchError = void 0;
var get_1 = __importDefault(__webpack_require__(65439));
var FetchError = /*#__PURE__*/ function(Error1) {
    _inherits._(FetchError, Error1);
    var _super = _create_super._(FetchError);
    function FetchError() {
        var error = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", request = arguments.length > 1 ? arguments[1] : void 0, response = arguments.length > 2 ? arguments[2] : void 0;
        _class_call_check._(this, FetchError);
        var _this;
        _this = _super.call(this);
        try {
            _this.name = _this.constructor.name;
            _this.message = error instanceof Error ? error.toString() : error;
            _this.type = null;
            _this.request = request;
            _this.stack = error instanceof Error ? error.stack : new Error().stack;
        } catch (_a) {
        // nothing
        }
        if (response) {
            var xBackendServer = (0, get_1.default)(response, [
                "headers",
                "x-backend-server"
            ], "");
            _this.response = response;
            _this.status = response.status;
            _this.xBackendServer = xBackendServer;
        }
        return _this;
    }
    return FetchError;
}(_wrap_native_super._(Error));
exports.FetchError = FetchError;


/***/ }),

/***/ 60723:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _class_call_check = __webpack_require__(67818);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(65759);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.UserLastAdultProfileCannotBeDeletedError = exports.UserLastProfileCannotBeKidError = exports.UserFirstProfileCannotBeKidError = exports.UserMaxAuthorizedProfilesCreatedError = void 0;
/* eslint-disable max-classes-per-file */ var base_error_1 = __webpack_require__(73512);
var UserMaxAuthorizedProfilesCreatedError = /*#__PURE__*/ function(_base_error_1_BaseFidoError) {
    _inherits._(UserMaxAuthorizedProfilesCreatedError, _base_error_1_BaseFidoError);
    var _super = _create_super._(UserMaxAuthorizedProfilesCreatedError);
    function UserMaxAuthorizedProfilesCreatedError() {
        _class_call_check._(this, UserMaxAuthorizedProfilesCreatedError);
        return _super.apply(this, arguments);
    }
    return UserMaxAuthorizedProfilesCreatedError;
}(base_error_1.BaseFidoError);
exports.UserMaxAuthorizedProfilesCreatedError = UserMaxAuthorizedProfilesCreatedError;
var UserFirstProfileCannotBeKidError = /*#__PURE__*/ function(_base_error_1_BaseFidoError) {
    _inherits._(UserFirstProfileCannotBeKidError, _base_error_1_BaseFidoError);
    var _super = _create_super._(UserFirstProfileCannotBeKidError);
    function UserFirstProfileCannotBeKidError() {
        _class_call_check._(this, UserFirstProfileCannotBeKidError);
        return _super.apply(this, arguments);
    }
    return UserFirstProfileCannotBeKidError;
}(base_error_1.BaseFidoError);
exports.UserFirstProfileCannotBeKidError = UserFirstProfileCannotBeKidError;
var UserLastProfileCannotBeKidError = /*#__PURE__*/ function(_base_error_1_BaseFidoError) {
    _inherits._(UserLastProfileCannotBeKidError, _base_error_1_BaseFidoError);
    var _super = _create_super._(UserLastProfileCannotBeKidError);
    function UserLastProfileCannotBeKidError() {
        _class_call_check._(this, UserLastProfileCannotBeKidError);
        return _super.apply(this, arguments);
    }
    return UserLastProfileCannotBeKidError;
}(base_error_1.BaseFidoError);
exports.UserLastProfileCannotBeKidError = UserLastProfileCannotBeKidError;
var UserLastAdultProfileCannotBeDeletedError = /*#__PURE__*/ function(_base_error_1_BaseFidoError) {
    _inherits._(UserLastAdultProfileCannotBeDeletedError, _base_error_1_BaseFidoError);
    var _super = _create_super._(UserLastAdultProfileCannotBeDeletedError);
    function UserLastAdultProfileCannotBeDeletedError() {
        _class_call_check._(this, UserLastAdultProfileCannotBeDeletedError);
        return _super.apply(this, arguments);
    }
    return UserLastAdultProfileCannotBeDeletedError;
}(base_error_1.BaseFidoError);
exports.UserLastAdultProfileCannotBeDeletedError = UserLastAdultProfileCannotBeDeletedError;


/***/ }),

/***/ 19322:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _sliced_to_array = __webpack_require__(28966);
var _to_consumable_array = __webpack_require__(30005);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(42578);
var __importDefault = (void 0) && (void 0).__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.fido = void 0;
var forEach_1 = __importDefault(__webpack_require__(17489));
/**
 * @module Fido
 * @description Fido's main singleton is used to store some app's immutable parameters used by Fido's services and override API default base URLs.
 * @tutorial ./doc/fido.md
 */ var Fido = /*#__PURE__*/ function() {
    function Fido() {
        _class_call_check._(this, Fido);
        this._platformCode = null;
        this._customerCode = null;
        this._appVersion = null;
        this._clientCode = null;
        this._localDeviceId = null;
        this._localHomeId = null;
        this._saltAndSugar = null;
        this._getCurrentTime = function() {
            return Date.now();
        };
        this._waitTimeout = 10000;
        this._maxTimeout = 60000;
        this._imageSalt = "54b55408a530954b553ff79e98";
        this._usedCapacityToken = null;
        this.baseUrlsByAPIType = {};
        this.isInitialized = false;
    }
    _create_class._(Fido, [
        {
            /**
     * Initialize Fido and its services. If you don't call this method, no service can be used.
     *
     * @param {Object} immutableProps Contains all immutable properties of the app. See the example to view available properties.
     * @param {Object[]?} services Fido's service instances that should be initialized. If parameters has to be passed to the init method of the service, use an array (see the example).
     * @tutorial ./doc/fidoInit.md
     */ key: "init",
            value: function init() {
                var immutableProps = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, services = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
                var _this = this;
                if (!this.isInitialized) {
                    (0, forEach_1.default)(immutableProps, function(value, key) {
                        var privateKey = "_".concat(key);
                        if (key !== "isInitialized" && key !== "baseUrlsByAPIType" && _this[privateKey] !== undefined) {
                            _this[privateKey] = value;
                        }
                    });
                    if (immutableProps.baseUrlsByAPIType) {
                        this.baseUrlsByAPIType = Object.assign({}, immutableProps.baseUrlsByAPIType);
                    }
                    this.isInitialized = true;
                }
                services.forEach(function(service) {
                    if (Array.isArray(service)) {
                        var _serviceInstance;
                        var _service = _sliced_to_array._(service, 2), serviceInstance = _service[0], tmp = _service[1], params = tmp === void 0 ? [] : tmp;
                        (_serviceInstance = serviceInstance).init.apply(_serviceInstance, _to_consumable_array._(params));
                    } else {
                        service.init();
                    }
                });
            }
        },
        {
            /**
     * Get the value of an immutable property of the app.
     *
     * @param {string} key Name of the property.
     * @tutorial ./doc/fidoGet.md
     * @returns {string} Value of the property.
     */ key: "get",
            value: function get(key) {
                this.checkInit();
                var privateKey = "_".concat(key);
                return this[privateKey];
            }
        },
        {
            key: "set",
            value: function set(key, value) {
                this.checkInit();
                var privateKey = "_".concat(key);
                this[privateKey] = value;
            }
        },
        {
            /**
     * Override default API base URLs.
     *
     * @param {Object} baseUrlsByAPIType Contains the base URLs of some API type. See the example to discover available API types.
     * @tutorial ./doc/fidoSetBaseUrls.md
     */ key: "setBaseUrls",
            value: function setBaseUrls(baseUrlsByAPIType) {
                var _this = this;
                this.checkInit();
                (0, forEach_1.default)(baseUrlsByAPIType, function(value, key) {
                    _this.baseUrlsByAPIType[key] = value;
                });
            }
        },
        {
            /**
     * Get the base URL of an API type.
     *
     * @param {string} apiType Name of the API.
     * @tutorial ./doc/fidoGetBaseUrl.md
     * @returns {string} Current base URL of the API.
     */ key: "getBaseUrl",
            value: function getBaseUrl(apiType) {
                this.checkInit();
                return this.baseUrlsByAPIType[apiType];
            }
        },
        {
            key: "checkInit",
            value: function checkInit() {
                if (!this.isInitialized) {
                    throw new Error("You should init Fido before using it");
                }
            }
        }
    ]);
    return Fido;
}();
exports.fido = new Fido();


/***/ }),

/***/ 19804:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(37815);
var __createBinding = (void 0) && (void 0).__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = {
            enumerable: true,
            get: function get() {
                return m[k];
            }
        };
    }
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __setModuleDefault = (void 0) && (void 0).__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var __importStar = (void 0) && (void 0).__importStar || function() {
    var ownKeys = function ownKeys1(o) {
        ownKeys = Object.getOwnPropertyNames || function(o) {
            var ar = [];
            for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function(mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) {
            for(var k = ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") __createBinding(result, mod, k[i]);
        }
        __setModuleDefault(result, mod);
        return result;
    };
}();
var __exportStar = (void 0) && (void 0).__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) __createBinding(exports1, m, p);
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.PREMIUM_COUPON_STATUS = exports.SUBSCRIPTION_STATUS = exports.thirdPartyWithLayoutService = exports.thirdPartyControllerService = exports.premiumService = exports.iamService = exports.IAMError = exports.GigyaTimeoutError = exports.GigyaFormatError = exports.watchedContentsVisibilityService = exports.videolandPaymentService = exports.videoService = exports.userService = exports.profileService = exports.parentalControlService = exports.pairingService = exports.gdprService = exports.ageRatingService = exports.urlHitterService = exports.upFrontTokenService = exports.timeService = exports.servicesService = exports.searchAiService = exports.programService = exports.statsdMonitoringService = exports.logCollectorService = exports.layoutService = exports.layoutForThirdPartyService = exports.NAVIGATION_TARGETS = exports.LAYOUT_FRONTSPACES = exports.LAYOUT_ENTITIES = exports.LAYOUT_APP_PAGES = exports.LAYOUT_ALIASES = exports.iconService = exports.heartbeatServiceV3 = exports.heartbeatService = exports.geoService = exports.qualifioService = exports.foldersService = exports.creditsService = exports.boxDataService = exports.tokenService = exports.oidcService = exports.batService = exports.applaunchService = exports.adInterceptorService = exports.adgatewayService = exports.IMAGE_SIZES = exports.imageService = exports.fido = void 0;
exports.getSanitizedPageUrl = exports.fidoMiddleware = exports.buildFidoRequest = exports.FetchError = exports.AuthErrorCode = exports.AuthError = exports.security = exports.liveService = exports.broadcastliveService = exports.mergeWithConfig = exports.COUPON_STATUS = exports.freemiumService = void 0;
var freemium_constants_1 = __webpack_require__(1435);
var image_constants_1 = __webpack_require__(49037);
var premium_constants_1 = __webpack_require__(50249);
var security = __importStar(__webpack_require__(11055));
exports.security = security;
var fido_1 = __webpack_require__(19322);
Object.defineProperty(exports, "fido", ({
    enumerable: true,
    get: function get() {
        return fido_1.fido;
    }
}));
var imageService_1 = __webpack_require__(6378);
Object.defineProperty(exports, "imageService", ({
    enumerable: true,
    get: function get() {
        return imageService_1.imageService;
    }
}));
exports.IMAGE_SIZES = {
    panoramicSizes: image_constants_1.panoramicSizes,
    portraitSizes: image_constants_1.portraitSizes
};
var adgateway_1 = __webpack_require__(17538);
Object.defineProperty(exports, "adgatewayService", ({
    enumerable: true,
    get: function get() {
        return adgateway_1.adgatewayService;
    }
}));
var adInterceptorService_1 = __webpack_require__(7939);
Object.defineProperty(exports, "adInterceptorService", ({
    enumerable: true,
    get: function get() {
        return adInterceptorService_1.adInterceptorService;
    }
}));
var applaunchService_1 = __webpack_require__(94320);
Object.defineProperty(exports, "applaunchService", ({
    enumerable: true,
    get: function get() {
        return applaunchService_1.applaunchService;
    }
}));
var batService_1 = __webpack_require__(96072);
Object.defineProperty(exports, "batService", ({
    enumerable: true,
    get: function get() {
        return batService_1.batService;
    }
}));
var oidcService_1 = __webpack_require__(29370);
Object.defineProperty(exports, "oidcService", ({
    enumerable: true,
    get: function get() {
        return oidcService_1.oidcService;
    }
}));
var tokenService_1 = __webpack_require__(96625);
Object.defineProperty(exports, "tokenService", ({
    enumerable: true,
    get: function get() {
        return tokenService_1.tokenService;
    }
}));
var boxDataService_1 = __webpack_require__(94007);
Object.defineProperty(exports, "boxDataService", ({
    enumerable: true,
    get: function get() {
        return boxDataService_1.boxDataService;
    }
}));
var creditsService_1 = __webpack_require__(4748);
Object.defineProperty(exports, "creditsService", ({
    enumerable: true,
    get: function get() {
        return creditsService_1.creditsService;
    }
}));
var foldersService_1 = __webpack_require__(63273);
Object.defineProperty(exports, "foldersService", ({
    enumerable: true,
    get: function get() {
        return foldersService_1.foldersService;
    }
}));
var qualifioService_1 = __webpack_require__(21278);
Object.defineProperty(exports, "qualifioService", ({
    enumerable: true,
    get: function get() {
        return qualifioService_1.qualifioService;
    }
}));
var geoService_1 = __webpack_require__(82556);
Object.defineProperty(exports, "geoService", ({
    enumerable: true,
    get: function get() {
        return geoService_1.geoService;
    }
}));
var heartbeatService_1 = __webpack_require__(72440);
Object.defineProperty(exports, "heartbeatService", ({
    enumerable: true,
    get: function get() {
        return heartbeatService_1.heartbeatService;
    }
}));
var heartbeatService_2 = __webpack_require__(98566);
Object.defineProperty(exports, "heartbeatServiceV3", ({
    enumerable: true,
    get: function get() {
        return heartbeatService_2.heartbeatServiceV3;
    }
}));
var iconService_1 = __webpack_require__(68074);
Object.defineProperty(exports, "iconService", ({
    enumerable: true,
    get: function get() {
        return iconService_1.iconService;
    }
}));
var layout_constants_1 = __webpack_require__(90995);
Object.defineProperty(exports, "LAYOUT_ALIASES", ({
    enumerable: true,
    get: function get() {
        return layout_constants_1.aliases;
    }
}));
Object.defineProperty(exports, "LAYOUT_APP_PAGES", ({
    enumerable: true,
    get: function get() {
        return layout_constants_1.appPages;
    }
}));
Object.defineProperty(exports, "LAYOUT_ENTITIES", ({
    enumerable: true,
    get: function get() {
        return layout_constants_1.entities;
    }
}));
Object.defineProperty(exports, "LAYOUT_FRONTSPACES", ({
    enumerable: true,
    get: function get() {
        return layout_constants_1.frontspaces;
    }
}));
Object.defineProperty(exports, "NAVIGATION_TARGETS", ({
    enumerable: true,
    get: function get() {
        return layout_constants_1.navigationTargets;
    }
}));
var layoutForThirdPartyService_1 = __webpack_require__(75156);
Object.defineProperty(exports, "layoutForThirdPartyService", ({
    enumerable: true,
    get: function get() {
        return layoutForThirdPartyService_1.layoutForThirdPartyService;
    }
}));
var layoutService_1 = __webpack_require__(40547);
Object.defineProperty(exports, "layoutService", ({
    enumerable: true,
    get: function get() {
        return layoutService_1.layoutService;
    }
}));
var logCollectorService_1 = __webpack_require__(33396);
Object.defineProperty(exports, "logCollectorService", ({
    enumerable: true,
    get: function get() {
        return logCollectorService_1.logCollectorService;
    }
}));
var statsdMonitoringService_1 = __webpack_require__(86023);
Object.defineProperty(exports, "statsdMonitoringService", ({
    enumerable: true,
    get: function get() {
        return statsdMonitoringService_1.statsdMonitoringService;
    }
}));
var programService_1 = __webpack_require__(62762);
Object.defineProperty(exports, "programService", ({
    enumerable: true,
    get: function get() {
        return programService_1.programService;
    }
}));
var searchAiService_1 = __webpack_require__(19770);
Object.defineProperty(exports, "searchAiService", ({
    enumerable: true,
    get: function get() {
        return searchAiService_1.searchAiService;
    }
}));
var servicesService_1 = __webpack_require__(72);
Object.defineProperty(exports, "servicesService", ({
    enumerable: true,
    get: function get() {
        return servicesService_1.servicesService;
    }
}));
var timeService_1 = __webpack_require__(99448);
Object.defineProperty(exports, "timeService", ({
    enumerable: true,
    get: function get() {
        return timeService_1.timeService;
    }
}));
var upFrontTokenService_1 = __webpack_require__(84599);
Object.defineProperty(exports, "upFrontTokenService", ({
    enumerable: true,
    get: function get() {
        return upFrontTokenService_1.upFrontTokenService;
    }
}));
var urlHitterService_1 = __webpack_require__(24286);
Object.defineProperty(exports, "urlHitterService", ({
    enumerable: true,
    get: function get() {
        return urlHitterService_1.urlHitterService;
    }
}));
var ageRatingService_1 = __webpack_require__(62284);
Object.defineProperty(exports, "ageRatingService", ({
    enumerable: true,
    get: function get() {
        return ageRatingService_1.ageRatingService;
    }
}));
var gdprService_1 = __webpack_require__(6312);
Object.defineProperty(exports, "gdprService", ({
    enumerable: true,
    get: function get() {
        return gdprService_1.gdprService;
    }
}));
var pairingService_1 = __webpack_require__(8645);
Object.defineProperty(exports, "pairingService", ({
    enumerable: true,
    get: function get() {
        return pairingService_1.pairingService;
    }
}));
var parentalControlService_1 = __webpack_require__(71685);
Object.defineProperty(exports, "parentalControlService", ({
    enumerable: true,
    get: function get() {
        return parentalControlService_1.parentalControlService;
    }
}));
var profileService_1 = __webpack_require__(20100);
Object.defineProperty(exports, "profileService", ({
    enumerable: true,
    get: function get() {
        return profileService_1.profileService;
    }
}));
var userService_1 = __webpack_require__(30169);
Object.defineProperty(exports, "userService", ({
    enumerable: true,
    get: function get() {
        return userService_1.userService;
    }
}));
var videoService_1 = __webpack_require__(58203);
Object.defineProperty(exports, "videoService", ({
    enumerable: true,
    get: function get() {
        return videoService_1.videoService;
    }
}));
var videolandPaymentService_1 = __webpack_require__(61255);
Object.defineProperty(exports, "videolandPaymentService", ({
    enumerable: true,
    get: function get() {
        return videolandPaymentService_1.videolandPaymentService;
    }
}));
var watchedContentsVisibilityService_1 = __webpack_require__(19953);
Object.defineProperty(exports, "watchedContentsVisibilityService", ({
    enumerable: true,
    get: function get() {
        return watchedContentsVisibilityService_1.watchedContentsVisibilityService;
    }
}));
// ThirdParties
var gigya_errors_1 = __webpack_require__(38401);
Object.defineProperty(exports, "GigyaFormatError", ({
    enumerable: true,
    get: function get() {
        return gigya_errors_1.GigyaFormatError;
    }
}));
Object.defineProperty(exports, "GigyaTimeoutError", ({
    enumerable: true,
    get: function get() {
        return gigya_errors_1.GigyaTimeoutError;
    }
}));
var iam_error_1 = __webpack_require__(3422);
Object.defineProperty(exports, "IAMError", ({
    enumerable: true,
    get: function get() {
        return iam_error_1.IAMError;
    }
}));
var iamService_1 = __webpack_require__(346);
Object.defineProperty(exports, "iamService", ({
    enumerable: true,
    get: function get() {
        return iamService_1.iamService;
    }
}));
var premiumService_1 = __webpack_require__(44700);
Object.defineProperty(exports, "premiumService", ({
    enumerable: true,
    get: function get() {
        return premiumService_1.premiumService;
    }
}));
var thirdPartyControllerService_1 = __webpack_require__(59740);
Object.defineProperty(exports, "thirdPartyControllerService", ({
    enumerable: true,
    get: function get() {
        return thirdPartyControllerService_1.thirdPartyControllerService;
    }
}));
var thirdPartyWithLayoutService_1 = __webpack_require__(90724);
Object.defineProperty(exports, "thirdPartyWithLayoutService", ({
    enumerable: true,
    get: function get() {
        return thirdPartyWithLayoutService_1.thirdPartyWithLayoutService;
    }
}));
exports.SUBSCRIPTION_STATUS = premium_constants_1.subscriptionStatus;
exports.PREMIUM_COUPON_STATUS = premium_constants_1.premiumCouponStatus;
var freemiumService_1 = __webpack_require__(75920);
Object.defineProperty(exports, "freemiumService", ({
    enumerable: true,
    get: function get() {
        return freemiumService_1.freemiumService;
    }
}));
exports.COUPON_STATUS = freemium_constants_1.couponStatus;
var utils_1 = __webpack_require__(11803);
Object.defineProperty(exports, "mergeWithConfig", ({
    enumerable: true,
    get: function get() {
        return utils_1.mergeWithConfig;
    }
}));
var broadcastliveService_1 = __webpack_require__(54869);
Object.defineProperty(exports, "broadcastliveService", ({
    enumerable: true,
    get: function get() {
        return broadcastliveService_1.broadcastliveService;
    }
}));
var liveService_1 = __webpack_require__(20250);
Object.defineProperty(exports, "liveService", ({
    enumerable: true,
    get: function get() {
        return liveService_1.liveService;
    }
}));
var auth_error_1 = __webpack_require__(26577);
Object.defineProperty(exports, "AuthError", ({
    enumerable: true,
    get: function get() {
        return auth_error_1.AuthError;
    }
}));
Object.defineProperty(exports, "AuthErrorCode", ({
    enumerable: true,
    get: function get() {
        return auth_error_1.AuthErrorCode;
    }
}));
var fetch_error_1 = __webpack_require__(41180);
Object.defineProperty(exports, "FetchError", ({
    enumerable: true,
    get: function get() {
        return fetch_error_1.FetchError;
    }
}));
__exportStar(__webpack_require__(60723), exports);
var fido_middleware_1 = __webpack_require__(52492);
Object.defineProperty(exports, "buildFidoRequest", ({
    enumerable: true,
    get: function get() {
        return fido_middleware_1.buildFidoRequest;
    }
}));
Object.defineProperty(exports, "fidoMiddleware", ({
    enumerable: true,
    get: function get() {
        return fido_middleware_1.fidoMiddleware;
    }
}));
var utils_2 = __webpack_require__(9942);
Object.defineProperty(exports, "getSanitizedPageUrl", ({
    enumerable: true,
    get: function get() {
        return utils_2.getSanitizedPageUrl;
    }
}));


/***/ }),

/***/ 52492:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _async_to_generator = __webpack_require__(24146);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(37815);
var __rest = (void 0) && (void 0).__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++){
        if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.buildFidoRequest = exports.fidoMiddleware = void 0;
var defaultErrorHandler = function(param) {
    var error = param.error, next = param.next, outputAction = param.outputAction;
    next(Object.assign(Object.assign({}, outputAction), {
        error: error
    }));
    throw error;
};
var fidoMiddleware = function() {
    var onFidoError = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultErrorHandler;
    return function() {
        return function(next) {
            return function() {
                var _ref = _async_to_generator._(function(action) {
                    var _action_fido, service, method, params, transform, outputAction, rawData, data, _tmp, error;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!action.fido) return [
                                    3,
                                    7
                                ];
                                _action_fido = action.fido, service = _action_fido.service, method = _action_fido.method, params = _action_fido.params, transform = _action_fido.transform, outputAction = __rest(action, [
                                    "fido"
                                ]);
                                if (typeof service !== "object" || service === null) {
                                    throw new Error("Service is mandatory, received ".concat(service));
                                }
                                if (typeof service[method] !== "function") {
                                    throw new Error("Service in ".concat(outputAction.type, " action doesn't have a ").concat(method, " method"));
                                }
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    6,
                                    ,
                                    7
                                ]);
                                return [
                                    4,
                                    service[method](params)
                                ];
                            case 2:
                                rawData = _state.sent();
                                if (!(typeof transform === "function")) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    transform(rawData)
                                ];
                            case 3:
                                _tmp = _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                _tmp = rawData;
                                _state.label = 5;
                            case 5:
                                data = _tmp;
                                // Dispatch the action with data
                                next(Object.assign(Object.assign({}, outputAction), {
                                    data: data
                                }));
                                return [
                                    2,
                                    data
                                ];
                            case 6:
                                error = _state.sent();
                                onFidoError({
                                    error: error,
                                    next: next,
                                    outputAction: outputAction
                                });
                                return [
                                    3,
                                    7
                                ];
                            case 7:
                                return [
                                    2,
                                    next(action)
                                ];
                        }
                    });
                });
                return function(action) {
                    return _ref.apply(this, arguments);
                };
            }();
        };
    };
};
exports.fidoMiddleware = fidoMiddleware;
var buildFidoRequest = function(service, method, params, transform) {
    return {
        service: service,
        method: method,
        params: params,
        transform: transform
    };
};
exports.buildFidoRequest = buildFidoRequest;


/***/ }),

/***/ 7939:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(88801);
var __decorate = (void 0) && (void 0).__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __rest = (void 0) && (void 0).__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++){
        if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.adInterceptorService = exports.serializeData = void 0;
var fido_1 = __webpack_require__(19322);
var withJWT_1 = __webpack_require__(56282);
var fetcherService_1 = __webpack_require__(96571);
var withMonitoring_1 = __webpack_require__(97982);
var monitoring = (0, withMonitoring_1.withMonitoring)("adInterceptor");
var serializeData = function(_a) {
    var creativeIds = _a.creativeIds, rest = __rest(_a, [
        "creativeIds"
    ]);
    var serializedContent = new URLSearchParams();
    Object.keys(rest).forEach(function(key) {
        return serializedContent.append(key, rest[key]);
    });
    Object.keys(creativeIds).forEach(function(key) {
        return serializedContent.append("creativeIds[".concat(key, "]"), creativeIds[key]);
    });
    return serializedContent.toString();
};
exports.serializeData = serializeData;
var AdInterceptor = /*#__PURE__*/ function(_fetcherService_1_FetcherService) {
    _inherits._(AdInterceptor, _fetcherService_1_FetcherService);
    var _super = _create_super._(AdInterceptor);
    function AdInterceptor() {
        _class_call_check._(this, AdInterceptor);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.apiType = "interceptor";
        return _this;
    }
    _create_class._(AdInterceptor, [
        {
            key: "init",
            value: function init() {
                if (!this.isInitialized) {
                    this.basePath = "platforms/".concat(fido_1.fido.get("platformCode"), "/services");
                    this.isInitialized = true;
                }
            }
        },
        {
            key: "adSurveyIntercept",
            value: /**
     * Check if a content has to be displayed
     *
     * @async
     * @param {Object} params
     * @param {string} params.serviceCode Service code identifier
     * @param {Object} params.content Content data to send in the request body
     * @param {Object} [params.headers={}] Optional HTTP headers.
     * @returns An empty array if there is nothing to be played, or an object with the content to be played
     * @throws {Error} Throws an error if serviceCode is not provided or is null
     */ function adSurveyIntercept() {
                var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, serviceCode = _ref.serviceCode, _ref_content = _ref.content, content = _ref_content === void 0 ? {} : _ref_content, _ref_headers = _ref.headers, headers = _ref_headers === void 0 ? {} : _ref_headers;
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        if (!serviceCode) {
                            throw new Error("You should provide non null serviceCode");
                        }
                        return [
                            2,
                            _this.fetchWithoutVersionHeaders(_this.getRouteUrl("".concat(serviceCode, "/intercept?").concat((0, exports.serializeData)(content))), {
                                method: "GET",
                                headers: headers
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "adSurveySave",
            value: /**
     * Save the user answer to the survey
     *
     * @async
     * @param {Object} params
     * @param {string} params.serviceCode Service code identifier
     * @param {Object} params.content Content data to send in the request body
     * @param {Object} [params.headers={}] Optional HTTP headers.
     * @returns An empty 204 response if successful
     * @throws {Error} Throws an error if serviceCode is not provided or is null
     */ function adSurveySave() {
                var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, serviceCode = _ref.serviceCode, _ref_content = _ref.content, content = _ref_content === void 0 ? {} : _ref_content, _ref_headers = _ref.headers, headers = _ref_headers === void 0 ? {} : _ref_headers;
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        if (!serviceCode) {
                            throw new Error("You should provide non null serviceCode");
                        }
                        return [
                            2,
                            _this.fetchWithoutVersionHeaders(_this.getRouteUrl("".concat(serviceCode, "/survey/save")), {
                                method: "POST",
                                headers: headers,
                                body: content
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "adSurveySkip",
            value: /**
     * Skip an ad survey if the user didn't answer or chose to skip
     *
     * @async
     * @param {Object} params
     * @param {string} params.serviceCode Service code identifier
     * @param {Object} params.content Content data to send in the request body
     * @param {Object} [params.headers={}] Optional HTTP headers.
     * @returns An empty 204 response if successful
     * @throws {Error} Throws an error if serviceCode is not provided or is null
     */ function adSurveySkip() {
                var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, serviceCode = _ref.serviceCode, _ref_content = _ref.content, content = _ref_content === void 0 ? {} : _ref_content, _ref_headers = _ref.headers, headers = _ref_headers === void 0 ? {} : _ref_headers;
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        if (!serviceCode) {
                            throw new Error("You should provide non null serviceCode");
                        }
                        return [
                            2,
                            _this.fetchWithoutVersionHeaders(_this.getRouteUrl("".concat(serviceCode, "/survey/skip")), {
                                method: "POST",
                                headers: headers,
                                body: content
                            })
                        ];
                    });
                })();
            }
        }
    ]);
    return AdInterceptor;
}(fetcherService_1.FetcherService);
__decorate([
    withJWT_1.withJWT,
    monitoring
], AdInterceptor.prototype, "adSurveyIntercept", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], AdInterceptor.prototype, "adSurveySave", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], AdInterceptor.prototype, "adSurveySkip", null);
exports.adInterceptorService = new AdInterceptor();


/***/ }),

/***/ 17538:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(37815);
var __decorate = (void 0) && (void 0).__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.adgatewayService = void 0;
var fido_1 = __webpack_require__(19322);
var queryParamSerializer_1 = __webpack_require__(19007);
var withJWT_1 = __webpack_require__(56282);
var fetcherService_1 = __webpack_require__(96571);
var withMonitoring_1 = __webpack_require__(97982);
var monitoring = (0, withMonitoring_1.withMonitoring)("adgateway");
/**
 * @module Adgateway
 * @augments FetcherService
 * @description Service used to call the adserver Videoplaza
 * @tutorial ./doc/adgatewayService.md
 */ var Agdateway = /*#__PURE__*/ function(_fetcherService_1_FetcherService) {
    _inherits._(Agdateway, _fetcherService_1_FetcherService);
    var _super = _create_super._(Agdateway);
    function Agdateway() {
        _class_call_check._(this, Agdateway);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.apiType = "adgateway";
        return _this;
    }
    _create_class._(Agdateway, [
        {
            /**
     * Initialize the service. If you don't call this method, no other method can be called.
     *
     */ key: "init",
            value: function init() {
                if (!this.isInitialized) {
                    this.basePath = "platforms/".concat(fido_1.fido.get("platformCode"), "/services");
                    this.isInitialized = true;
                }
            }
        },
        {
            key: "fetchAdsPlaylist",
            value: /**
     * Fetches ads playlist for a specific video asset
     * Additional fields could be specified via the dataToFetch array.
     *
     * @async
     * @param {Object} options Options passed to adgateway: serviceCode, assetId, headers or queryParams
     * @param {string} options.serviceCode serviceCode of the service to what belongs the current asset
     * @param {number} options.assetId Id of the current video asset
     * @param {string} options.trackingmode Tracking mode: allows to trigger an event of tracking. Accepted values : serverfull, clientbytype, clientbyspot
     * @param {object} options.headers
     * @param {string} options.userOffer name of the offer - if any - that the user has subscribed to.
     * @tutorial ./doc/fetchAdsPlaylist.md
     */ function fetchAdsPlaylist(param) {
                var serviceCode = param.serviceCode, assetId = param.assetId, _param_trackingmode = param.trackingmode, trackingmode = _param_trackingmode === void 0 ? "serverfull" : _param_trackingmode, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers, userOffer = param.userOffer;
                var _this = this;
                return _async_to_generator._(function() {
                    var stringQueryParams;
                    return _ts_generator._(this, function(_state) {
                        _this.checkInit();
                        if (!serviceCode) {
                            throw new Error("You should provide a service code");
                        }
                        if (!assetId) {
                            throw new Error("You should provide an assetId");
                        }
                        stringQueryParams = (0, queryParamSerializer_1.serialize)({
                            trackingmode: trackingmode,
                            user_offer: userOffer
                        }, function(param) {
                            var value = param.value;
                            return !!value;
                        });
                        return [
                            2,
                            _this.fetchWithResponse(_this.getRouteUrl("".concat(serviceCode, "/playlist/asset/").concat(assetId, "?").concat(stringQueryParams)), {
                                method: "GET",
                                headers: headers
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "fetchAdsPlaylistWithClipId",
            value: /**
     * Fetches ads playlist for a specific video asset (with its clipId)
     *
     * @async
     * @param {Object} options Options passed to adgateway: serviceCode, clipId, headers or queryParams
     * @param {string} options.serviceCode serviceCode of the service to what belongs the current asset
     * @param {number} options.clipId clipId of the current video asset
     * @param {string} options.trackingmode Tracking mode: allows to trigger an event of tracking. Accepted values : serverfull, clientbytype, clientbyspot
     * @param {object} options.headers
     * @param {string} options.userOffer name of the offer - if any - that the user has subscribed to.
     * @tutorial ./doc/fetchAdsPlaylist.md
     */ function fetchAdsPlaylistWithClipId(param) {
                var serviceCode = param.serviceCode, clipId = param.clipId, _param_trackingmode = param.trackingmode, trackingmode = _param_trackingmode === void 0 ? "serverfull" : _param_trackingmode, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers, userOffer = param.userOffer;
                var _this = this;
                return _async_to_generator._(function() {
                    var stringQueryParams;
                    return _ts_generator._(this, function(_state) {
                        _this.checkInit();
                        if (!serviceCode) {
                            throw new Error("You should provide a service code");
                        }
                        if (!clipId) {
                            throw new Error("You should provide a clipId");
                        }
                        stringQueryParams = (0, queryParamSerializer_1.serialize)({
                            trackingmode: trackingmode,
                            user_offer: userOffer
                        }, function(param) {
                            var value = param.value;
                            return !!value;
                        });
                        return [
                            2,
                            _this.fetchWithResponse(_this.getRouteUrl("".concat(serviceCode, "/playlist/clip/").concat(clipId, "?").concat(stringQueryParams)), {
                                method: "GET",
                                headers: headers
                            })
                        ];
                    });
                })();
            }
        }
    ]);
    return Agdateway;
}(fetcherService_1.FetcherService);
__decorate([
    withJWT_1.withJWT,
    monitoring
], Agdateway.prototype, "fetchAdsPlaylist", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], Agdateway.prototype, "fetchAdsPlaylistWithClipId", null);
exports.adgatewayService = new Agdateway();


/***/ }),

/***/ 94320:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _assert_this_initialized = __webpack_require__(99561);
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(88801);
var __decorate = (void 0) && (void 0).__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (void 0) && (void 0).__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.applaunchService = exports.ApplaunchService = void 0;
var sortBy_1 = __importDefault(__webpack_require__(84715));
var sprintf_js_1 = __webpack_require__(24131);
var fido_1 = __webpack_require__(19322);
var withJWT_1 = __webpack_require__(56282);
var fetcherService_1 = __webpack_require__(96571);
var withMonitoring_1 = __webpack_require__(97982);
var utils_1 = __webpack_require__(11803);
var monitoring = (0, withMonitoring_1.withMonitoring)("applaunch");
var CUSTOMIZER_VARIANTS_TYPE = {
    DEVICE: "deviceCustomizerVariants",
    GIGYA: "gigyaCustomizerVariants",
    PROFILE: "profileCustomizerVariants",
    UNKNOWN: "customizerVariants"
};
/**
 * @module Applaunch
 * @description The applaunch service has been created to retrieve hot configuration from the Applaunch.
 * @tutorial ./doc/applaunch.md
 */ var ApplaunchService = /*#__PURE__*/ function(_fetcherService_1_FetcherService) {
    _inherits._(ApplaunchService, _fetcherService_1_FetcherService);
    var _super = _create_super._(ApplaunchService);
    function ApplaunchService() {
        _class_call_check._(this, ApplaunchService);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.apiType = "applaunch";
        _this.getCustomizerVariants = function() {
            var headers = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, key = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : CUSTOMIZER_VARIANTS_TYPE.UNKNOWN;
            var tmp = headers["x-customizer-variants"], variants = tmp === void 0 ? "" : tmp;
            var value = variants && variants.length ? variants.split(",") : [];
            value.sort();
            return {
                value: JSON.stringify(value),
                key: key,
                type: "jsonpath"
            };
        };
        _this.reset = function() {
            _this.data = _this.defaultData;
        };
        _this.reload = function() {
            var maxAge = _assert_this_initialized._(_this).maxAge;
            if (maxAge) {
                if (typeof maxAge === "string" && _this.data[maxAge]) {
                    maxAge = _this.data[maxAge];
                }
                if (typeof maxAge === "number" && maxAge >= 30) {
                    setTimeout(function() {
                        _this.getApplaunch();
                        _this.reload();
                    }, maxAge * 1000);
                }
            }
        };
        _this.mergeData = function(initialData, newData) {
            // Sorting keys is important to merge shallower jsonpath first, deeper ones last
            var sortedData = (0, sortBy_1.default)(newData, "key");
            _this.rawData = (0, utils_1.generateRawData)(sortedData, initialData);
            _this.data = (0, utils_1.mergeWithConfig)(_this.config.data, _this.rawData);
            return _this.data;
        };
        return _this;
    }
    _create_class._(ApplaunchService, [
        {
            /**
     * Initialize the Applaunch service with configuration and initial data.
     *
     * @param {Object} [config={}] - Configuration object for the service
     * @param {Object} [data={}] - Initial data object
     * @returns {ApplaunchService} The service instance for chaining
     * @throws {Error} If app or version is missing from config
     */ key: "init",
            value: function init() {
                var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, data = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var serviceName = config.app, version = config.version, customizer = config.customizer, customizerFromJWT = config.customizerFromJWT, timeout = config.timeout, maxAge = config.maxAge;
                if (!serviceName) {
                    throw new Error("You should provide a service name");
                }
                if (!version) {
                    throw new Error("You should provide a version");
                }
                // this.basePath has to be defined if endpoint URL requested by this service contains a constant part
                this.applaunchEndPoint = "".concat(serviceName, "-").concat(version, ".json");
                this.config = config;
                this.customizer = customizer;
                this.customizerFromJWT = customizerFromJWT;
                this.timeout = timeout;
                this.maxAge = maxAge;
                this.defaultData = data;
                this.data = data;
                this.isInitialized = true;
                return this;
            }
        },
        {
            /**
     * Get the applaunch config.
     * @async
     *
     * @returns {Object} The remote applaunch config.
     * @tutorial ./doc/getApplaunch.md
     */ key: "getApplaunch",
            value: function getApplaunch() {
                var _this = this;
                if (this.config.disabled) {
                    return this.mergeData();
                }
                var url = this.getRouteUrl(this.applaunchEndPoint);
                return this.fetch(url, {
                    method: "GET"
                }).then(function(dataList) {
                    return _this.mergeData({}, dataList);
                });
            }
        },
        {
            key: "getCustomization",
            value: /**
     * Get the applaunch config by userId or deviceId.
     * @async
     *
     * @param {Object} params
     * @param {string=} params.uid The userId or deviceId.
     * @param {string=} params.localDeviceId The device id
     * @param {string=} params.profileId The profile id
     * @param {Object=} params.headers The headers of the request.
     * @returns {Object} A Jsonpath config who overwrite some fields.
     * @tutorial ./doc/getCustomization.md
     */ function getCustomization(param) {
                var uid = param.uid, localDeviceId = param.localDeviceId, profileId = param.profileId, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                var _this = this;
                return _async_to_generator._(function() {
                    var customizerUrl;
                    return _ts_generator._(this, function(_state) {
                        customizerUrl = (0, sprintf_js_1.sprintf)(_this.customizer, Object.assign({
                            uid: profileId || uid || localDeviceId,
                            platform: fido_1.fido.get("platformCode")
                        }, _this.config));
                        return [
                            2,
                            _this.fetchWithResponse(customizerUrl, {
                                method: "GET",
                                headers: headers
                            }).then(function(param) {
                                var tmp = param.headers, responseHeaders = tmp === void 0 ? {} : tmp, dataObject = param.body;
                                var dataList = Object.keys(dataObject).map(function(key) {
                                    return dataObject[key];
                                });
                                var variantType = "";
                                if (profileId) {
                                    variantType = CUSTOMIZER_VARIANTS_TYPE.PROFILE;
                                } else if (uid) {
                                    variantType = CUSTOMIZER_VARIANTS_TYPE.GIGYA;
                                } else {
                                    variantType = CUSTOMIZER_VARIANTS_TYPE.DEVICE;
                                }
                                dataList.push(_this.getCustomizerVariants(responseHeaders, variantType));
                                return _this.mergeData(_this.data, dataList);
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "getCustomizationFromJWT",
            value: /**
     * Get the customized applaunch from data contained in the JWT token.
     * You should make sure that the app retrieved a JWT with the most information possible (device, user, profile) before calling this method.
     * @async
     *
     * @param {Object} [params={}] - Parameters object
     * @param {Object} [params.headers={}] - The request headers
     * @returns {Promise<Object>} A Jsonpath config who overwrite some fields
     */ function getCustomizationFromJWT() {
                var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_headers = _ref.headers, headers = _ref_headers === void 0 ? {} : _ref_headers;
                var _this = this;
                return _async_to_generator._(function() {
                    var customizerUrl;
                    return _ts_generator._(this, function(_state) {
                        customizerUrl = (0, sprintf_js_1.sprintf)(_this.customizerFromJWT, Object.assign({
                            platform: fido_1.fido.get("platformCode")
                        }, _this.config));
                        return [
                            2,
                            _this.fetchWithResponse(customizerUrl, {
                                method: "GET",
                                headers: headers
                            }).then(function(param) {
                                var tmp = param.headers, responseHeaders = tmp === void 0 ? {} : tmp, dataObject = param.body;
                                var dataList = Object.values(dataObject);
                                dataList.push(_this.getCustomizerVariants(responseHeaders, CUSTOMIZER_VARIANTS_TYPE.UNKNOWN));
                                return _this.mergeData(_this.data, dataList);
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "getData",
            value: function getData() {
                return this.data;
            }
        },
        {
            key: "getRawData",
            value: function getRawData() {
                return this.rawData;
            }
        }
    ]);
    return ApplaunchService;
}(fetcherService_1.FetcherService);
exports.ApplaunchService = ApplaunchService;
__decorate([
    monitoring
], ApplaunchService.prototype, "getApplaunch", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], ApplaunchService.prototype, "getCustomization", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], ApplaunchService.prototype, "getCustomizationFromJWT", null);
exports.applaunchService = new ApplaunchService();


/***/ }),

/***/ 122:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(37815);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(52318);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.configMerger = void 0;
var configMerger = function(objValue, srcValue) {
    // Null and undefined value are ignored
    if (srcValue === null || srcValue === undefined) {
        return objValue;
    }
    // Array are not merged but replaced
    if (Array.isArray(objValue)) {
        return srcValue;
    }
    return undefined;
};
exports.configMerger = configMerger;


/***/ }),

/***/ 11803:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _define_property = __webpack_require__(21228);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(3009);
var __importDefault = (void 0) && (void 0).__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.mergeWithConfig = exports.generateRawData = exports.parse = void 0;
var clone_1 = __importDefault(__webpack_require__(55824));
var mergeWith_1 = __importDefault(__webpack_require__(53954));
var setWith_1 = __importDefault(__webpack_require__(45943));
var config_merger_1 = __webpack_require__(122);
var parse = function(value) {
    try {
        if (typeof value === "string") {
            return JSON.parse(value);
        }
        return value;
    } catch (_a) {
        return value;
    }
};
exports.parse = parse;
var generateRawData = function(sortedData, initialData) {
    return (sortedData || []).reduce(function(reducedData, param) {
        var key = param.key, type = param.type, value = param.value;
        var parsedValue = (0, exports.parse)(value);
        if (type === "jsonpath") {
            return (0, setWith_1.default)((0, clone_1.default)(reducedData), key, parsedValue, clone_1.default);
        }
        return Object.assign(Object.assign({}, reducedData), _define_property._({}, key, parsedValue));
    }, initialData || {});
};
exports.generateRawData = generateRawData;
var mergeWithConfig = function(configData, data) {
    return (0, mergeWith_1.default)({}, configData, data, config_merger_1.configMerger);
};
exports.mergeWithConfig = mergeWithConfig;


/***/ }),

/***/ 96072:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(65759);
var __decorate = (void 0) && (void 0).__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (void 0) && (void 0).__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.batService = void 0;
var jwt_decode_1 = __importDefault(__webpack_require__(30588));
var fido_1 = __webpack_require__(19322);
var caching_1 = __webpack_require__(72345);
var retryPromise_1 = __webpack_require__(10341);
var securityHeaderBuilder_1 = __webpack_require__(79660);
var fetcherService_1 = __webpack_require__(96571);
var withMonitoring_1 = __webpack_require__(97982);
var monitoring = (0, withMonitoring_1.withMonitoring)("bat");
/**
 * This service is used to retrieve a Bedrock Access Token.
 * Warning: use it only server side!
 * @module batService
 * @tutorial ./doc/batService.md
 */ var BatService = /*#__PURE__*/ function(_fetcherService_1_FetcherService) {
    _inherits._(BatService, _fetcherService_1_FetcherService);
    var _super = _create_super._(BatService);
    function BatService() {
        _class_call_check._(this, BatService);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.persistentToken = null;
        _this.credential = null;
        _this.retry = 0;
        _this.maxRetry = 0;
        _this.apiType = "bat";
        _this.retryCooldown = 50;
        return _this;
    }
    _create_class._(BatService, [
        {
            /**
     * Initialize the service.
     * @param {Object} initParams - init params of the service
     * @param {string} initParams.maxRetry - numeric option is to refetch token in case of failure
     * @param {string} initParams.persistentToken - default token to use
     * @param {string} initParams.credential - base64(login:password)
     * @param {number} initParams.retryCooldown - time to wait before two requests in ms
     * @see https://bedrock-enterprise.readme.io/learn/docs/token
     * @tutorial ./doc/batService.init.md
     */ key: "init",
            value: function init() {
                var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_maxRetry = _ref.maxRetry, maxRetry = _ref_maxRetry === void 0 ? 3 : _ref_maxRetry, _ref_persistentToken = _ref.persistentToken, persistentToken = _ref_persistentToken === void 0 ? null : _ref_persistentToken, credential = _ref.credential, _ref_retryCooldown = _ref.retryCooldown, retryCooldown = _ref_retryCooldown === void 0 ? 50 : _ref_retryCooldown;
                if (!this.isInitialized) {
                    this.maxRetry = maxRetry;
                    this.retryCooldown = retryCooldown;
                    this.isInitialized = true;
                    this.persistentToken = persistentToken;
                    this.credential = credential;
                }
            }
        },
        {
            /**
     * Reset the BAT.
     */ key: "resetToken",
            value: function resetToken() {
                this.checkInit();
                this.persistentToken = null;
            }
        },
        {
            key: "isTokenValid",
            value: function isTokenValid(token, realServerTime) {
                this.checkInit();
                try {
                    var exp = (0, jwt_decode_1.default)(token).exp;
                    return realServerTime < exp * 1000;
                } catch (_a) {
                    return false;
                }
            }
        },
        {
            key: "renewToken",
            value: function renewToken() {
                var _this = this;
                this.checkInit();
                var url = fido_1.fido.getBaseUrl(this.apiType);
                return (0, retryPromise_1.retryPromise)(function() {
                    return _this.fetch(url, {
                        method: "GET",
                        headers: Object.assign({
                            Authorization: "Basic ".concat(_this.credential)
                        }, (0, securityHeaderBuilder_1.getHeaders)({
                            path: "bat",
                            body: {}
                        }, {}))
                    });
                }, this.maxRetry, this.retryCooldown).then(function(param) {
                    var token = param.token;
                    _this.persistentToken = token;
                }).catch(function(error) {
                    throw new Error("batService:renewToken:fetch ".concat(error.status, " ").concat(error));
                });
            }
        },
        {
            key: "getToken",
            value: /**
     * Returns a valid BAT. If there is no current or valid BAT token, it gets a new one.
     * @returns {string} A valid BAT.
     * @async
     */ function getToken() {
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.checkInit();
                                if (_this.persistentToken && _this.isTokenValid(_this.persistentToken, fido_1.fido.get("getCurrentTime")())) {
                                    return [
                                        2,
                                        _this.persistentToken
                                    ];
                                }
                                return [
                                    4,
                                    _this.renewToken()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2,
                                    _this.persistentToken
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return BatService;
}(fetcherService_1.FetcherService);
__decorate([
    caching_1.withNoParallelRequest,
    monitoring
], BatService.prototype, "renewToken", null);
exports.batService = new BatService();


/***/ }),

/***/ 23004:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _to_consumable_array = __webpack_require__(30005);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(88801);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.createAddHeaderDecorator = void 0;
/**
 * Decorator builder wich add a header into an argument
 * @param {function} callback, should return an object of headers to be merged
 * @param {number} applyToArgument in which argument headers should be injected
 */ var createAddHeaderDecorator = function() {
    var callback = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {}, applyToArgument = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return function(target, name, descriptor) {
        var fn = descriptor.value;
        descriptor.value = function createAddHeaderDecorator() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var argument = args[applyToArgument] || {
                headers: {}
            };
            var headersToAdd = callback.apply(void 0, _to_consumable_array._(args));
            if (headersToAdd) {
                argument.headers = Object.assign(Object.assign({}, headersToAdd), argument.headers);
                args[applyToArgument] = argument;
            }
            return fn.apply(this, args);
        };
        return descriptor;
    };
};
exports.createAddHeaderDecorator = createAddHeaderDecorator;


/***/ }),

/***/ 41458:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(3009);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.withCustomerHeader = void 0;
var fido_utils_1 = __webpack_require__(42627);
var decorators_builder_1 = __webpack_require__(23004);
/**
 * A decorator which injects the customer header 'x-customer-name' with the configured customer
 * It injects the header in an object under the property 'headers'
 * @param {number} applyToArgument the argument in which it should be injected
 */ var withCustomerHeader = function() {
    var applyToArgument = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return (0, decorators_builder_1.createAddHeaderDecorator)((0, fido_utils_1.addFidoPropertyIfDefined)({}, "customerCode", "X-Customer-Name"), applyToArgument);
};
exports.withCustomerHeader = withCustomerHeader;


/***/ }),

/***/ 13496:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(65759);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.withDeviceHeaders = void 0;
var fido_1 = __webpack_require__(19322);
var withDeviceHeaders = function(target, name, descriptor) {
    var fn = descriptor.value;
    descriptor.value = function withDeviceHeaders() {
        var args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        var headers = Object.assign(Object.assign({}, args.headers), {
            "x-auth-device-id": fido_1.fido.get("localDeviceId"),
            "x-customer-name": fido_1.fido.get("customerCode")
        });
        return fn.apply(this, [
            Object.assign(Object.assign({}, args), {
                headers: headers
            })
        ]);
    };
    return descriptor;
};
exports.withDeviceHeaders = withDeviceHeaders;


/***/ }),

/***/ 56282:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _async_to_generator = __webpack_require__(24146);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(42578);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.withJWT = void 0;
var oidcService_1 = __webpack_require__(29370);
var tokenService_1 = __webpack_require__(96625);
var retrieveAndInjectToken = function() {
    var _ref = _async_to_generator._(function(context, fn) {
        var args, retrying, token, argsSaved, headers, _ref, oidcAccessToken;
        var _arguments = arguments;
        return _ts_generator._(this, function(_state) {
            switch(_state.label){
                case 0:
                    args = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : {}, retrying = _arguments.length > 3 ? _arguments[3] : void 0;
                    return [
                        4,
                        tokenService_1.tokenService.getToken()
                    ];
                case 1:
                    token = _state.sent();
                    argsSaved = Object.assign({}, args);
                    if (!oidcService_1.oidcService.isInitialized) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        oidcService_1.oidcService.getOrFetchOidcTokens()
                    ];
                case 2:
                    _ref = _state.sent(), oidcAccessToken = _ref.accessToken;
                    headers = Object.assign({
                        Authorization: "Bearer ".concat(oidcAccessToken),
                        "X-Bedrock-Token": token
                    }, args.headers);
                    return [
                        3,
                        4
                    ];
                case 3:
                    headers = Object.assign({
                        Authorization: "Bearer ".concat(token)
                    }, args.headers);
                    _state.label = 4;
                case 4:
                    return [
                        2,
                        fn.apply(context, [
                            Object.assign(Object.assign({}, args), {
                                headers: headers
                            })
                        ]).catch(function(error) {
                            if (error.status === 498 && !retrying) {
                                tokenService_1.tokenService.resetToken();
                                return retrieveAndInjectToken(context, fn, argsSaved, true);
                            }
                            throw error;
                        })
                    ];
            }
        });
    });
    return function retrieveAndInjectToken(context, fn) {
        return _ref.apply(this, arguments);
    };
}();
var withJWT = function(target, name, descriptor) {
    var fn = descriptor.value;
    descriptor.value = function withJWT(args) {
        return retrieveAndInjectToken(this, fn, args);
    };
    return descriptor;
};
exports.withJWT = withJWT;


/***/ }),

/***/ 88319:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(88801);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.withRequestTimeoutHeader = void 0;
var fido_1 = __webpack_require__(19322);
var decorators_builder_1 = __webpack_require__(23004);
var withRequestTimeoutHeader = function() {
    var applyToArgument = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
    return (0, decorators_builder_1.createAddHeaderDecorator)(function(url) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        return {
            "Request-Timeout": String(options.waitTimeout || fido_1.fido.get("waitTimeout"))
        };
    }, applyToArgument);
};
exports.withRequestTimeoutHeader = withRequestTimeoutHeader;


/***/ }),

/***/ 47662:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(45538);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.withVersionHeader = void 0;
var fido_utils_1 = __webpack_require__(42627);
var decorators_builder_1 = __webpack_require__(23004);
/**
 * A decorator which injects the customer header 'x-customer-name' with the configured customer
 * It injects the header in an object under the property 'headers'
 * @param {number} applyToArgument the argument in which it should be injected
 */ var withVersionHeader = function() {
    var applyToArgument = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return (0, decorators_builder_1.createAddHeaderDecorator)((0, fido_utils_1.addFidoPropertyIfDefined)({}, "appVersion", "X-Client-Release"), applyToArgument);
};
exports.withVersionHeader = withVersionHeader;


/***/ }),

/***/ 34120:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(52318);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.OidcApiClient = void 0;
var OidcApiClient = /*#__PURE__*/ function() {
    function OidcApiClient(param) {
        var endpoints = param.endpoints, clientId = param.clientId, clientSecret = param.clientSecret, getApiUrl = param.getApiUrl, getCustomApiUrl = param.getCustomApiUrl, externalFetch = param.externalFetch;
        _class_call_check._(this, OidcApiClient);
        this.tokensPromise = null;
        this.endpoints = endpoints;
        this.clientId = clientId;
        this.clientSecret = clientSecret;
        this.getApiUrl = getApiUrl;
        this.getCustomApiUrl = getCustomApiUrl;
        this.externalFetch = externalFetch;
    }
    _create_class._(OidcApiClient, [
        {
            key: "tokenRetrievalMutex",
            value: /**
     * To be called for any method within `OidcApiClient` that retrieves tokens.
     *
     * Note: This is to avoid 2 different methods from `OIDCService` to retrieve tokens in parallel
     * (e.g. `checkSsoSilently` and `fetchConnectedToken`), even though we're using the same mutex
     * between anonymous and non-anonymous tokens. These shouldn't be called in parallel.
     * Also, we are using `@withNoParallelRequest` annotation on `OIDCService` methods, which prevents
     * individual methods to be called multiple times in parallel.
     *
     * Future note: We might want to have one mutex per type of token retrieval (guest/connected)
     */ function tokenRetrievalMutex(tokenRetriever) {
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        if (!_this.tokensPromise) {
                            _this.tokensPromise = tokenRetriever().finally(function() {
                                return _this.tokensPromise = null;
                            });
                        }
                        return [
                            2,
                            _this.tokensPromise
                        ];
                    });
                })();
            }
        },
        {
            key: "fetchTokens",
            value: /**
     * Fetches the different tokens through Keycloak API, using the endpoint provided on init.
     * Do note that this method fetches tokens for a **CONNECTED** user.
     * @see `fetchAnonymousTokens` for fetching unlogged users tokens
     * @async
     * @param {Object} params The params to include in the body of the request
     * @param {string} [params.grant_type] The grant type to use for the token request
     * @param {string} [params.code] The authorization code to exchange for tokens (Web)
     * @param {string} [params.code_verifier] The PKCE code verifier used to generate the code challenge (Web)
     * @param {string} [params.redirect_uri] The redirect URI that define to which app URL to return after redirection (Web)
     * @param {string} [params.scope] Space-separated OIDC scopes to request access to user claims, e.g. `'openid profile'` (Web)
     * @param {string} [params.subject_token] The token to exchange, used with the token-exchange grant type (Web)
     * @param {string} [params.subject_token_type] The type of the token provided in the subject_token parameter (Web)
     * @param {string} [params.subject_issuer] Identifies the issuer of the subject_token (Web)
     * @param {string} [params.device_code] The code that correspond to the device identity (TVJS)
     * Note: `params['x-partner-id']` — The partner ID for the token exchange request (Web)
     * @returns {Promise<OidcTokens>} The token response containing: access token, ID token, and a refresh token.
     */ function fetchTokens() {
                var params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        return [
                            2,
                            _this.tokenRetrievalMutex(function() {
                                return _this.externalFetch(_this.getApiUrl(_this.endpoints.TOKEN), {
                                    method: "POST",
                                    headers: {
                                        "Content-Type": "application/x-www-form-urlencoded"
                                    },
                                    body: Object.assign({
                                        client_id: _this.clientId
                                    }, params)
                                });
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "fetchAnonymousTokens",
            value: /**
     * Fetches the different tokens through Keycloak API, using the endpoint provided on init.
     * Do note that this method fetches tokens for an **UNLOGGED** user.
     * @see `fetchTokens` for fetching unlogged users tokens
     * @async
     * @returns {Promise<OidcTokens>} The token response containing: access token, ID token, and a refresh token.
     */ function fetchAnonymousTokens() {
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        return [
                            2,
                            _this.tokenRetrievalMutex(function() {
                                return _this.externalFetch(_this.getApiUrl(_this.endpoints.TOKEN), {
                                    method: "POST",
                                    headers: {
                                        "Content-Type": "application/x-www-form-urlencoded"
                                    },
                                    body: {
                                        client_id: "anonymous-user",
                                        client_secret: _this.clientSecret,
                                        grant_type: "client_credentials"
                                    }
                                });
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "getUserInfo",
            value: /**
     * Retrieves user information from the userinfo endpoint provided on init.
     * @async
     * @param {string} accessToken The accessToken of the current user
     * @returns {Promise<Object>} A promise that resolves to the userinfo response.
     * @throws {Error} Can throw an error if :
     * - No access token was provided
     * - The API returns an error
     */ function getUserInfo(accessToken) {
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!accessToken || accessToken === "") {
                                    throw new Error("No access token to fetch user info");
                                }
                                return [
                                    4,
                                    _this.externalFetch(_this.getApiUrl(_this.endpoints.USERINFO), {
                                        method: "GET",
                                        headers: {
                                            Authorization: "Bearer ".concat(accessToken)
                                        }
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "authorizeDevice",
            value: /**
     * Try to authorize a given device with the given scopes (Only used by TVJS)
     * @async
     * @param {string} [scopes='openid profile offline_access'] The scopes requested for this device
     * @returns {Promise<Object>} The response of the API as-is
     * @throws {Error} Can throw an error if :
     * - The endpoint was not properly configured on init
     * - The API returns an error
     */ function authorizeDevice() {
                var scopes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "openid profile offline_access";
                var _this = this;
                return _async_to_generator._(function() {
                    var _a;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!((_a = _this.endpoints) === null || _a === void 0 ? void 0 : _a.DEVICE_AUTHORIZATION)) {
                                    throw new Error("Device authorization endpoint is not configured for the current provider.");
                                }
                                return [
                                    4,
                                    _this.externalFetch(_this.getApiUrl(_this.endpoints.DEVICE_AUTHORIZATION), {
                                        method: "POST",
                                        body: "scope=".concat(scopes, "&client_id=").concat(_this.clientId),
                                        headers: {
                                            "Content-Type": "application/x-www-form-urlencoded"
                                        }
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "logout",
            value: /**
     * Logs out the user from the OIDC provider (Only used by TVJS)
     * @async
     * @param {string} accessToken The current valid accessToken of this user
     * @param {string} refreshToken The refresh token that would be used to refresh that accessToken
     * @returns {Promise<Object>} The response from the logout request, as-is.
     * @throws {Error} Will throw an error if any of the following situations :
     * - The endpoint CUSTOM_LOGOUT wasn't configured
     * - No accessToken or refreshToken was provided
     * - The API throws an error
     */ function logout(accessToken, refreshToken) {
                var _this = this;
                return _async_to_generator._(function() {
                    var _a;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!((_a = _this.endpoints) === null || _a === void 0 ? void 0 : _a.CUSTOM_LOGOUT)) {
                                    throw new Error("Custom logout endpoint is not configured for the current provider.");
                                }
                                if (!accessToken || accessToken === "") {
                                    throw new Error("Access token is required to logout");
                                }
                                if (!refreshToken || refreshToken === "") {
                                    throw new Error("Refresh token is required to logout");
                                }
                                return [
                                    4,
                                    _this.externalFetch(_this.getCustomApiUrl(_this.endpoints.CUSTOM_LOGOUT), {
                                        method: "POST",
                                        headers: {
                                            Authorization: "Bearer ".concat(accessToken)
                                        },
                                        body: {
                                            clientId: _this.clientId,
                                            logoutMode: "CLIENT",
                                            refreshToken: refreshToken
                                        }
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return OidcApiClient;
}();
exports.OidcApiClient = OidcApiClient;


/***/ }),

/***/ 67860:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(3009);
var __importDefault = (void 0) && (void 0).__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.PkceService = void 0;
var enc_base64_1 = __importDefault(__webpack_require__(33490));
var sha256_1 = __importDefault(__webpack_require__(57735));
var CODE_VERIFIER_STORAGE_KEY = "oidcCodeVerifier";
var isClient = typeof window !== "undefined";
/**
 * This service handles all key generation for Proof Key for Code Exchange (PKCE)
 * It is used to generate unique keys that identify the user's computer as legitimate
 */ var PkceService = /*#__PURE__*/ function() {
    function PkceService() {
        _class_call_check._(this, PkceService);
        this.codeVerifier = null;
        this.codeChallenge = null;
    }
    _create_class._(PkceService, [
        {
            /**
     * Generate a new codeVerifier, that will be stored in `this.codeVerifier`
     */ key: "generateCodeVerifier",
            value: function generateCodeVerifier() {
                var randomArray = window.crypto.getRandomValues(new Uint32Array(32));
                this.codeVerifier = Array.from(randomArray, function(dec) {
                    return "0".concat(dec.toString(16)).substr(-2);
                }).join("");
            }
        },
        {
            /**
     * Returns the current code verifier to use.
     */ key: "getOrCreateCodeVerifier",
            value: function getOrCreateCodeVerifier() {
                if (this.codeVerifier) {
                    return this.codeVerifier;
                }
                if (isClient && sessionStorage.getItem(CODE_VERIFIER_STORAGE_KEY)) {
                    this.codeVerifier = sessionStorage.getItem(CODE_VERIFIER_STORAGE_KEY);
                    return this.codeVerifier;
                }
                this.generateCodeVerifier();
                if (isClient) {
                    sessionStorage.setItem(CODE_VERIFIER_STORAGE_KEY, this.codeVerifier);
                }
                return this.codeVerifier;
            }
        },
        {
            /**
     * Returns the current code challenge to use.
     */ key: "getOrCreateCodeChallenge",
            value: function getOrCreateCodeChallenge() {
                if (this.codeChallenge) {
                    return this.codeChallenge;
                }
                if (!this.codeVerifier) {
                    this.getOrCreateCodeVerifier();
                }
                var hash = (0, sha256_1.default)(this.codeVerifier);
                this.codeChallenge = enc_base64_1.default.stringify(hash).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
                return this.codeChallenge;
            }
        }
    ]);
    return PkceService;
}();
exports.PkceService = PkceService;


/***/ }),

/***/ 72254:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(42578);
var __importDefault = (void 0) && (void 0).__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.TokenManager = void 0;
var jwt_decode_1 = __importDefault(__webpack_require__(30588));
var STORAGE_KEYS = {
    ACCESS_TOKEN: "oidcAccessToken",
    REFRESH_TOKEN: "oidcRefreshToken",
    ID_TOKEN: "oidcIdToken"
};
var isClient = typeof window !== "undefined";
var TokenManager = /*#__PURE__*/ function() {
    function TokenManager() {
        var useLocalStorageFallback = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        _class_call_check._(this, TokenManager);
        this.shouldUseLocalStorageFallback = false;
        // This is a JWT token, used to communicate with DE (Not to be confused with BR's JWT token). Default validity time of 24h
        this.accessToken = null;
        // This is used to reset the duration of the accessToken, for example if we need to extend its validity time
        this.refreshToken = null;
        // This ID points to the accessToken/refreshToken duo that we generated. It will be used to revoke them once the user logs out
        this.idToken = null;
        this.shouldUseLocalStorageFallback = useLocalStorageFallback;
    }
    _create_class._(TokenManager, [
        {
            key: "getAccessToken",
            value: function getAccessToken() {
                return this.accessToken;
            }
        },
        {
            key: "getRefreshToken",
            value: function getRefreshToken() {
                return this.refreshToken;
            }
        },
        {
            key: "getIdToken",
            value: function getIdToken() {
                return this.idToken;
            }
        },
        {
            key: "setAccessToken",
            value: function setAccessToken(token) {
                this.accessToken = token;
                if (isClient && this.shouldUseLocalStorageFallback) {
                    localStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, token);
                }
            }
        },
        {
            key: "setRefreshToken",
            value: function setRefreshToken(token) {
                this.refreshToken = token;
                if (isClient && this.shouldUseLocalStorageFallback) {
                    localStorage.setItem(STORAGE_KEYS.REFRESH_TOKEN, token);
                }
            }
        },
        {
            key: "setIdToken",
            value: function setIdToken(token) {
                this.idToken = token;
                if (isClient && this.shouldUseLocalStorageFallback) {
                    localStorage.setItem(STORAGE_KEYS.ID_TOKEN, token);
                }
            }
        },
        {
            key: "clearTokens",
            value: function clearTokens() {
                this.accessToken = null;
                this.refreshToken = null;
                this.idToken = null;
                if (isClient && this.shouldUseLocalStorageFallback) {
                    localStorage.removeItem(STORAGE_KEYS.ACCESS_TOKEN);
                    localStorage.removeItem(STORAGE_KEYS.REFRESH_TOKEN);
                    localStorage.removeItem(STORAGE_KEYS.ID_TOKEN);
                }
            }
        },
        {
            key: "isTokenValid",
            value: function isTokenValid(token) {
                if (!token) {
                    return false;
                }
                try {
                    var decodedToken = (0, jwt_decode_1.default)(token);
                    // If the token expires in 10s or less, we deem it invalid (To avoid getting unnecessary 498s)
                    return new Date().getTime() < (decodedToken.exp - 10) * 1000;
                } catch (_a) {
                    return false;
                }
            }
        },
        {
            key: "clearInvalidTokensFromStorage",
            value: function clearInvalidTokensFromStorage() {
                var _this = this;
                [
                    STORAGE_KEYS.ACCESS_TOKEN,
                    STORAGE_KEYS.ID_TOKEN
                ].forEach(function(tokenKey) {
                    if (!_this.isTokenValid(localStorage.getItem(tokenKey))) {
                        localStorage.removeItem(tokenKey);
                    }
                });
            }
        },
        {
            key: "clearInvalidTokensFromMemory",
            value: function clearInvalidTokensFromMemory() {
                if (!this.isTokenValid(this.accessToken)) {
                    this.accessToken = null;
                }
                if (!this.isTokenValid(this.idToken)) {
                    this.idToken = null;
                }
            }
        },
        {
            key: "clearInvalidTokens",
            value: function clearInvalidTokens() {
                if (isClient && this.shouldUseLocalStorageFallback) {
                    this.clearInvalidTokensFromStorage();
                } else {
                    this.clearInvalidTokensFromMemory();
                }
            }
        }
    ]);
    return TokenManager;
}();
exports.TokenManager = TokenManager;


/***/ }),

/***/ 29370:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(3009);
var __decorate = (void 0) && (void 0).__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __rest = (void 0) && (void 0).__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++){
        if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var __importDefault = (void 0) && (void 0).__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.oidcService = void 0;
var jwt_decode_1 = __importDefault(__webpack_require__(30588));
var auth_error_1 = __webpack_require__(26577);
var fido_1 = __webpack_require__(19322);
var caching_1 = __webpack_require__(72345);
var fetcherService_1 = __webpack_require__(96571);
var withMonitoring_1 = __webpack_require__(97982);
var oidcApiClient_1 = __webpack_require__(34120);
var pkceService_1 = __webpack_require__(67860);
var tokenManager_1 = __webpack_require__(72254);
var monitoring = (0, withMonitoring_1.withMonitoring)("oidc");
var isClient = typeof window !== "undefined";
var DEFAULT_RESOLVE_TIMEOUT_DURATION = 2000;
var IFRAME_TIMEOUT_DURATION = 2000;
var IFRAME_CHECK_FREQUENCY = 200;
/**
 * The OIDC service is used to retrieve JWT from OIDC provider in order to use 6play's API.
 * @module Oidc
 */ var OIDCService = /*#__PURE__*/ function(_fetcherService_1_FetcherService) {
    _inherits._(OIDCService, _fetcherService_1_FetcherService);
    var _super = _create_super._(OIDCService);
    function OIDCService() {
        _class_call_check._(this, OIDCService);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.isInitialized = false;
        _this.deviceCode = null;
        /**
         * If `true`, throws an AuthError if the OIDC access token renewal fails
         * @type {boolean}
         */ _this.throwAuthError = false;
        return _this;
    }
    _create_class._(OIDCService, [
        {
            key: "init",
            value: /**
     * @async
     * @param {string} clientId The client ID for OIDC provider
     * @param {string} clientSecret The client secret for OIDC provider
     * @param {string} silentCheckSsoRedirectUri The redirect URI for silent SSO checks
     * @param {Object} endpoints The endpoints for the provider API
     * @param {string} endpoints.TOKEN The token endpoint
     * @param {string} endpoints.REVOCATION The revoke endpoint
     * @param {string} endpoints.USERINFO The user info endpoint
     * @param {string} [endpoints.AUTHORIZATION] The authentication endpoint (Web)
     * @param {string} [endpoints.LOGOUT] The logout endpoint (Web)
     * @param {string} [endpoints.CUSTOM_LOGOUT] The device code endpoint (TV)
     * @param {string} [endpoints.DEVICE_AUTHORIZATION] The device authentication endpoint (TV)
     * @param {string} [endpoints.THIRD_PARTY_COOKIES_IFRAME]  The thirdparty cookies iframe URL (required for thirdparty cookie validation)
     * @param {boolean} forceLocalStorage=true If `true`, disables keycloak and the iframe system entirely (Useful for legacy devices)
     * @param {number} resolveTimeoutDuration=2000 Timeout in ms for the OIDC resolution (silent SSO, 3rd party cookie check)
     * @param {boolean} throwAuthError=false If `true`, throws an AuthError if the OIDC access token renewal fails
     * @throws {AuthError} If the OIDC access token renewal fails and `throwAuthError` is `true`
     */ function init(param) {
                var clientId = param.clientId, clientSecret = param.clientSecret, endpoints = param.endpoints, silentCheckSsoRedirectUri = param.silentCheckSsoRedirectUri, _param_forceLocalStorage = param.forceLocalStorage, forceLocalStorage = _param_forceLocalStorage === void 0 ? true : _param_forceLocalStorage, _param_resolveTimeoutDuration = param.resolveTimeoutDuration, resolveTimeoutDuration = _param_resolveTimeoutDuration === void 0 ? DEFAULT_RESOLVE_TIMEOUT_DURATION : _param_resolveTimeoutDuration, _param_throwAuthError = param.throwAuthError, throwAuthError = _param_throwAuthError === void 0 ? false : _param_throwAuthError;
                var _this = this;
                return _async_to_generator._(function() {
                    var _tmp;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!!_this.isInitialized) return [
                                    3,
                                    4
                                ];
                                _this.isInitialized = true;
                                _this.isThirdPartyCookieCheckDone = false;
                                _this.endpoints = endpoints;
                                _this.clientId = clientId;
                                _this.clientSecret = clientSecret;
                                _this.silentCheckSsoRedirectUri = "";
                                _this.resolveTimeoutDuration = resolveTimeoutDuration;
                                _this.throwAuthError = throwAuthError;
                                _this.pkceService = new pkceService_1.PkceService();
                                _this.tokenManager = new tokenManager_1.TokenManager();
                                _this.oidcApiClient = new oidcApiClient_1.OidcApiClient({
                                    endpoints: endpoints,
                                    clientId: clientId,
                                    clientSecret: clientSecret,
                                    getApiUrl: _this.getApiUrl.bind(_this),
                                    getCustomApiUrl: _this.getCustomApiUrl.bind(_this),
                                    externalFetch: function(url, options) {
                                        return _this.externalFetch(url, Object.assign(Object.assign({}, options), {
                                            waitTimeout: resolveTimeoutDuration,
                                            maxTimeout: resolveTimeoutDuration
                                        }));
                                    }
                                });
                                if (isClient && silentCheckSsoRedirectUri) {
                                    _this.silentCheckSsoRedirectUri = window.location.origin + "/" + silentCheckSsoRedirectUri;
                                }
                                if (!(forceLocalStorage || !endpoints.THIRD_PARTY_COOKIES_IFRAME)) return [
                                    3,
                                    1
                                ];
                                _tmp = false;
                                return [
                                    3,
                                    3
                                ];
                            case 1:
                                return [
                                    4,
                                    _this.checkThirdPartyCookiesSupported()
                                ];
                            case 2:
                                _tmp = _state.sent();
                                _state.label = 3;
                            case 3:
                                _this.areThirdPartyCookiesSupported = _tmp;
                                _this.tokenManager.shouldUseLocalStorageFallback = !_this.areThirdPartyCookiesSupported;
                                _this.isThirdPartyCookieCheckDone = true;
                                if (isClient && !_this.areThirdPartyCookiesSupported) {
                                    _this.setTokens({
                                        accessToken: localStorage.getItem("oidcAccessToken") || "",
                                        refreshToken: localStorage.getItem("oidcRefreshToken") || "",
                                        idToken: localStorage.getItem("oidcIdToken") || ""
                                    });
                                }
                                // After we're done saving tokens config, we ensure that they're valid (Otherwise they're removed)
                                _this.checkTokensValidity();
                                _state.label = 4;
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
     * Return the full API URL for the given endpoint
     * @param {string} endpoint The wanted endpoint
     * @returns {string} API URL
     */ key: "getApiUrl",
            value: function getApiUrl(endpoint) {
                return "".concat(fido_1.fido.getBaseUrl("oidc"), "/").concat(endpoint);
            }
        },
        {
            /**
     * Return the full custom API URL for the given endpoint
     * @param {string} endpoint The wanted endpoint
     * @returns {string} API URL
     */ key: "getCustomApiUrl",
            value: function getCustomApiUrl(endpoint) {
                return "".concat(fido_1.fido.getBaseUrl("oidcCustomApi"), "/").concat(endpoint);
            }
        },
        {
            /**
     * Decode the access token to check if the user is a guest
     * @returns {boolean} True if the user is a guest, false otherwise
     */ key: "isGuestUser",
            value: function isGuestUser() {
                var _a;
                var accessToken = this.getAccessToken();
                try {
                    return accessToken && ((_a = (0, jwt_decode_1.default)(accessToken)) === null || _a === void 0 ? void 0 : _a.isGuest);
                } catch (_b) {
                    return false;
                }
            }
        },
        {
            /**
     * Get or generate a code challenge if it doesn't exist
     * Converts the verifier code into a secure PKCE challenge code
     * Transform the hash into a Base64 safe URL-encoded string
     * @returns {string} The Base64 URL-encoded SHA-256 hash of the code verifier.
     */ key: "getOrCreateCodeChallenge",
            value: function getOrCreateCodeChallenge() {
                return this.pkceService.getOrCreateCodeChallenge();
            }
        },
        {
            key: "getOrCreateCodeVerifier",
            value: function getOrCreateCodeVerifier() {
                return this.pkceService.getOrCreateCodeVerifier();
            }
        },
        {
            /**
     * Get the device code
     * @returns {?string} A string that correspond to the device identity
     */ key: "getDeviceCode",
            value: function getDeviceCode() {
                return this.deviceCode;
            }
        },
        {
            key: "waitForThirdPartyCheck",
            value: /**
     * Blocks execution until the service is initialized, or after a max retry amount has been reached.
     * @param retryIteration=0 The current iteration number.
     * @returns {Promise<boolean>} Indicates `true` if the initialization is complete, or `false` if the maximum retry amount has been reached
     */ function waitForThirdPartyCheck() {
                var retryIteration = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (_this.isThirdPartyCookieCheckDone) {
                                    return [
                                        2,
                                        true
                                    ];
                                }
                                if (retryIteration >= IFRAME_TIMEOUT_DURATION / IFRAME_CHECK_FREQUENCY) {
                                    return [
                                        2,
                                        false
                                    ];
                                }
                                return [
                                    4,
                                    new Promise(function(resolve) {
                                        return setTimeout(resolve, IFRAME_CHECK_FREQUENCY);
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2,
                                    _this.waitForThirdPartyCheck(retryIteration + 1)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getOrFetchOidcTokens",
            value: /**
     * Get or fetch the OIDC access and refresh Tokens
     * If no access token is available, it will fetch a new one.
     * Ensures correct storage is used depending on third-party cookie support.
     * @returns {Object} The response containing: access token and refresh token.
     */ function getOrFetchOidcTokens() {
                var _this = this;
                return _async_to_generator._(function() {
                    var accessToken, accessToken1, tokens, refreshToken, error, ssoResult, _a, error1;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!!isClient) return [
                                    3,
                                    3
                                ];
                                accessToken = _this.getAccessToken();
                                if (!(!accessToken || !_this.isTokenValid(accessToken))) return [
                                    3,
                                    2
                                ];
                                // On server-side, we will always use Anonymous tokens. If invalid, we need to refresh them
                                return [
                                    4,
                                    _this.fetchAnonymousTokens()
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2,
                                    {
                                        accessToken: _this.getAccessToken(),
                                        refreshToken: _this.getRefreshToken()
                                    }
                                ];
                            case 3:
                                return [
                                    4,
                                    _this.waitForThirdPartyCheck()
                                ];
                            case 4:
                                _state.sent();
                                if (!_this.areThirdPartyCookiesSupported) {
                                    // Make sure we'll use the tokens retrieved from the correct place
                                    _this.setTokens({
                                        accessToken: localStorage.getItem("oidcAccessToken"),
                                        refreshToken: localStorage.getItem("oidcRefreshToken"),
                                        idToken: localStorage.getItem("oidcIdToken")
                                    });
                                }
                                accessToken1 = _this.getAccessToken();
                                if (!(!accessToken1 || !_this.isTokenValid(accessToken1))) return [
                                    3,
                                    18
                                ];
                                _state.label = 5;
                            case 5:
                                _state.trys.push([
                                    5,
                                    16,
                                    ,
                                    17
                                ]);
                                refreshToken = _this.getRefreshToken();
                                if (!refreshToken) return [
                                    3,
                                    9
                                ];
                                _state.label = 6;
                            case 6:
                                _state.trys.push([
                                    6,
                                    8,
                                    ,
                                    9
                                ]);
                                return [
                                    4,
                                    _this.renewAccessToken()
                                ];
                            case 7:
                                _state.sent();
                                tokens = {
                                    access_token: _this.getAccessToken(),
                                    refresh_token: _this.getRefreshToken(),
                                    id_token: _this.getIdToken()
                                };
                                return [
                                    3,
                                    9
                                ];
                            case 8:
                                error = _state.sent();
                                _this.clearTokens();
                                if (_this.throwAuthError) {
                                    throw new auth_error_1.AuthError("Failed to refresh OIDC access token", {
                                        cause: error,
                                        status: error === null || error === void 0 ? void 0 : error.status,
                                        code: auth_error_1.AuthErrorCode.REFRESH_FAILED
                                    });
                                }
                                return [
                                    3,
                                    9
                                ];
                            case 9:
                                if (!(!tokens && _this.areThirdPartyCookiesSupported)) return [
                                    3,
                                    13
                                ];
                                _state.label = 10;
                            case 10:
                                _state.trys.push([
                                    10,
                                    12,
                                    ,
                                    13
                                ]);
                                return [
                                    4,
                                    _this.checkSsoSilently()
                                ];
                            case 11:
                                ssoResult = _state.sent();
                                tokens = (ssoResult === null || ssoResult === void 0 ? void 0 : ssoResult.access_token) ? ssoResult : tokens;
                                return [
                                    3,
                                    13
                                ];
                            case 12:
                                _a = _state.sent();
                                return [
                                    3,
                                    13
                                ];
                            case 13:
                                if (!!tokens) return [
                                    3,
                                    15
                                ];
                                return [
                                    4,
                                    _this.oidcApiClient.fetchAnonymousTokens()
                                ];
                            case 14:
                                tokens = _state.sent();
                                _state.label = 15;
                            case 15:
                                return [
                                    3,
                                    17
                                ];
                            case 16:
                                error1 = _state.sent();
                                if (error1 instanceof auth_error_1.AuthError) {
                                    throw error1;
                                }
                                throw new Error("Error fetching OIDC tokens from getOrFetchOidcTokens", {
                                    cause: error1
                                });
                            case 17:
                                _this.setTokens({
                                    accessToken: tokens.access_token || "",
                                    refreshToken: tokens.refresh_token || "",
                                    idToken: tokens.id_token || ""
                                });
                                _state.label = 18;
                            case 18:
                                return [
                                    2,
                                    {
                                        accessToken: _this.getAccessToken(),
                                        refreshToken: _this.getRefreshToken()
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "fetchConnectedTokens",
            value: /**
     * Fetch access and refresh tokens for connected user
     * @async
     * @param {Object} params The params to include in the body of the request
     * @param {string} params.grant_type The grant type to use for the token request
     * @param {string} [params.code] The authorization code to exchange for tokens (Web)
     * @param {string} [params.code_verifier] The PKCE code verifier used to generate the code challenge (Web)
     * @param {string} [params.redirect_uri] The redirect URI that define to which app URL to return after redirection (Web)
     * @param {string} [params.scope] Space-separated OIDC scopes to request access to user claims, e.g. `'openid profile'` (Web)
     * @param {string} [params.subject_token] The token to exchange, used with the token-exchange grant type (Web)
     * @param {string} [params.subject_token_type] The type of the token provided in the subject_token parameter (Web)
     * @param {string} [params.subject_issuer] Identifies the issuer of the subject_token (Web)
     * @param {string} [params.partnerId] The partner ID for the token exchange request (Web)
     * @param {string} [params.device_code] The code that correspond to the device identity (TVJS)
     * @returns {Object} The token response containing: access token, ID token, and a refresh token.
     */ function fetchConnectedTokens() {
                var _a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _async_to_generator._(function() {
                    var partnerId, params, tokens;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                partnerId = _a.partnerId, params = __rest(_a, [
                                    "partnerId"
                                ]);
                                return [
                                    4,
                                    _this.waitForThirdPartyCheck()
                                ];
                            case 1:
                                _state.sent();
                                if (_this.areAllTokensValid() && !_this.isGuestUser()) {
                                    return [
                                        2,
                                        Promise.resolve(_this.getTokens())
                                    ];
                                }
                                return [
                                    4,
                                    _this.oidcApiClient.fetchTokens(Object.assign(Object.assign({}, params), partnerId && {
                                        "x-partner-id": partnerId
                                    }))
                                ];
                            case 2:
                                tokens = _state.sent();
                                _this.setTokens({
                                    accessToken: tokens.access_token,
                                    refreshToken: tokens.refresh_token,
                                    idToken: tokens.id_token
                                });
                                return [
                                    2,
                                    tokens
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "fetchAnonymousTokens",
            value: /**
     * Fetch access and refresh tokens for anonymous user
     * @async
     * @returns {Object} The token response containing: access token, ID token, and a refresh token.
     */ function fetchAnonymousTokens() {
                var _this = this;
                return _async_to_generator._(function() {
                    var tokens;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // No need to check for all tokens to be valid since we only set the access token for guest users
                                if (_this.isGuestUser() && _this.isTokenValid(_this.getAccessToken())) {
                                    return [
                                        2,
                                        Promise.resolve(_this.getTokens())
                                    ];
                                }
                                return [
                                    4,
                                    _this.oidcApiClient.fetchAnonymousTokens()
                                ];
                            case 1:
                                tokens = _state.sent();
                                _this.setTokens({
                                    accessToken: tokens.access_token,
                                    refreshToken: tokens.refresh_token || "",
                                    idToken: tokens.id_token || ""
                                });
                                return [
                                    2,
                                    tokens
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getUserInfo",
            value: /**
     * Retrieves user information from the userinfo endpoint.
     * @returns {Promise<Object>} A promise that resolves to the userinfo response.
     */ function getUserInfo() {
                var _this = this;
                return _async_to_generator._(function() {
                    var _;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    3,
                                    ,
                                    4
                                ]);
                                if (!!_this.getIdToken()) return [
                                    3,
                                    2
                                ];
                                // will fail without a refresh token
                                return [
                                    4,
                                    _this.renewAccessToken()
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2,
                                    (0, jwt_decode_1.default)(_this.getIdToken())
                                ];
                            case 3:
                                _ = _state.sent();
                                // we resolve with nothing if we don't have enough tokens (e.g. guest users)
                                return [
                                    2,
                                    Promise.resolve()
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
     * Retrieves the user's access token
     * @returns {string} The access token
     */ key: "getAccessToken",
            value: function getAccessToken() {
                return this.tokenManager.getAccessToken();
            }
        },
        {
            /**
     * Retrieves the user's refresh token
     * @returns {string} The refresh token
     */ key: "getRefreshToken",
            value: function getRefreshToken() {
                return this.tokenManager.getRefreshToken();
            }
        },
        {
            /**
     * Retrieves the user's id token
     * @returns {string} The id token
     */ key: "getIdToken",
            value: function getIdToken() {
                return this.tokenManager.getIdToken();
            }
        },
        {
            /**
     * Retrieves user information from the userinfo endpoint.
     *
     * @param {Object} options - The options for constructing the authorization URL.
     * @param {string|string[][]|Object} [options.params={}] - Parameters to build an URLSearchParams object of query parameters to include in the URL.
     * @param {string} [options.type='login'] - The type of authorization. Allowed values: `'login'` or `'registration'`.
     * @returns {string} The fully constructed authorization URL to be used for user redirection.
     * @throws {Error} Throws an error in the following cases :
     * - The provided type is not valid (Should be `'login'` or `'registration'`)
     * - The endpoint is not properly configured for the provided type
     */ key: "getAuthorizedUrl",
            value: function getAuthorizedUrl(param) {
                var _param_params = param.params, params = _param_params === void 0 ? {} : _param_params, _param_type = param.type, type = _param_type === void 0 ? "login" : _param_type;
                var _a, _b;
                var endpoint;
                if (type === "registration") {
                    endpoint = (_a = this.endpoints) === null || _a === void 0 ? void 0 : _a.AUTHORIZATION_WITH_REGISTRATION;
                } else if (type === "login") {
                    endpoint = (_b = this.endpoints) === null || _b === void 0 ? void 0 : _b.AUTHORIZATION_WITH_LOGIN;
                } else {
                    throw new Error("Invalid authorization type: ".concat(type, ". Use 'login' or 'registration'."));
                }
                if (!endpoint) {
                    throw new Error("Authorization endpoint for type '".concat(type, "' is not configured for the current provider."));
                }
                var url = new URL(this.getApiUrl(endpoint));
                var searchParams = new URLSearchParams(params);
                url.search = searchParams.toString();
                return url.toString();
            }
        },
        {
            key: "authorizeDevice",
            value: /**
     * Return the device_code and the verification_uri to authorize the device
     * @async
     * @param {string} [scopes='openid profile offline_access'] The scopes requested for this device
     * @returns {Object}
     */ function authorizeDevice() {
                var scopes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "openid profile offline_access";
                var _this = this;
                return _async_to_generator._(function() {
                    var body;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.oidcApiClient.authorizeDevice(scopes)
                                ];
                            case 1:
                                body = _state.sent();
                                _this.deviceCode = body.device_code;
                                return [
                                    2,
                                    body
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
     * Generate the authorized logout redirect URL. (Only used by WEB)
     * @param {string} postLogoutUrl - The URL to which the user should be redirected after logout.
     * @returns {string} - The fully constructed and authorized logout redirect URL.
     * @throws {Error} If:
     * - the logout endpoint is not configured.
     * - the ID Token is invalid.
     */ key: "getLogoutRedirectUrl",
            value: function getLogoutRedirectUrl(postLogoutUrl) {
                var _a;
                if (!((_a = this.endpoints) === null || _a === void 0 ? void 0 : _a.LOGOUT)) {
                    throw new Error("Logout endpoint is not configured for the current provider.");
                }
                var idToken = this.getIdToken();
                var params = new URLSearchParams({
                    id_token_hint: idToken,
                    client_id: this.clientId,
                    post_logout_redirect_uri: postLogoutUrl
                });
                return "".concat(this.getApiUrl(this.endpoints.LOGOUT), "?").concat(params);
            }
        },
        {
            /**
     * Saves all provided tokens into the tokenManager
     * @param {string} accessToken
     * @param {string} refreshToken
     * @param {string} idToken
     */ key: "setTokens",
            value: function setTokens(param) {
                var accessToken = param.accessToken, refreshToken = param.refreshToken, idToken = param.idToken;
                this.tokenManager.setAccessToken(accessToken);
                this.tokenManager.setRefreshToken(refreshToken);
                this.tokenManager.setIdToken(idToken);
            }
        },
        {
            /**
     * Returns all saved tokens
     */ key: "getTokens",
            value: function getTokens() {
                return {
                    access_token: this.tokenManager.getAccessToken(),
                    refresh_token: this.tokenManager.getRefreshToken(),
                    id_token: this.tokenManager.getIdToken()
                };
            }
        },
        {
            /**
     * Checks if all tokens are valid, and returns false if any of them is not valid
     */ key: "areAllTokensValid",
            value: function areAllTokensValid() {
                var _this_getTokens = this.getTokens(), access_token = _this_getTokens.access_token, refresh_token = _this_getTokens.refresh_token, id_token = _this_getTokens.id_token;
                return this.tokenManager.isTokenValid(access_token) && this.tokenManager.isTokenValid(refresh_token) && this.tokenManager.isTokenValid(id_token);
            }
        },
        {
            /**
     * Removes all tokens currently saved within the oidcService.
     */ key: "clearTokens",
            value: function clearTokens() {
                this.tokenManager.clearTokens();
            }
        },
        {
            /**
     * Receives a token, and checks both the token format & the expiration dates.
     * @param {string} token The token that will be checked
     * @return {boolean} The status of the token passed as parameter.
     */ key: "isTokenValid",
            value: function isTokenValid(token) {
                return this.tokenManager.isTokenValid(token);
            }
        },
        {
            /**
     * Check if current tokens are valid, otherwise remove them from localStorage or memory
     * @returns {void}
     */ key: "checkTokensValidity",
            value: function checkTokensValidity() {
                this.tokenManager.clearInvalidTokens();
            }
        },
        {
            key: "renewAccessToken",
            value: /**
     * Renews the current access token using the refresh token.
     * @async
     * @throws {Error} This function can throw 2 kind of errors :
     * - If no refresh token is found, or if the token is invalid
     * - If the refresh request fails
     */ function renewAccessToken() {
                var _this = this;
                return _async_to_generator._(function() {
                    var refreshToken, response;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                refreshToken = _this.getRefreshToken();
                                if (!refreshToken) {
                                    throw new Error("No valid refresh token");
                                }
                                return [
                                    4,
                                    _this.oidcApiClient.fetchTokens({
                                        grant_type: "refresh_token",
                                        refresh_token: refreshToken
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                if (!response.access_token) {
                                    throw new Error("Invalid response");
                                }
                                _this.setTokens({
                                    accessToken: response.access_token,
                                    refreshToken: response.refresh_token,
                                    idToken: response.id_token
                                });
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "logout",
            value: /**
     * Logs out the user from the OIDC provider (Only used by TVJS)
     * @async
     * @returns {Object} The response from the logout request, as-is.
     */ function logout() {
                var _this = this;
                return _async_to_generator._(function() {
                    var accessToken, refreshToken, response;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                accessToken = _this.getAccessToken();
                                refreshToken = _this.getRefreshToken();
                                return [
                                    4,
                                    _this.oidcApiClient.logout(accessToken, refreshToken)
                                ];
                            case 1:
                                response = _state.sent();
                                _this.clearTokens();
                                return [
                                    2,
                                    response
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
     * Handles the message event from the third-party cookies check iframe.
     * @param {{ resolve: Function, cleanup: Function }} context
     * @param {MessageEvent} event
     */ key: "_onThirdPartyCookieMessage",
            value: function _onThirdPartyCookieMessage(param, event) {
                var resolve = param.resolve, cleanup = param.cleanup;
                var targetIframe = document.getElementById("oidc-3p-cookies-check-iframe");
                if (!targetIframe || targetIframe.contentWindow !== event.source) {
                    return;
                }
                if (event.data !== "supported" && event.data !== "unsupported") {
                    return;
                }
                cleanup();
                resolve(event.data === "supported");
            }
        },
        {
            key: "checkThirdPartyCookiesSupported",
            value: /**
     * Checks if third-party cookies are supported using a dedicated iframe endpoint.
     * Will always return `false` on server-side.
     * @async
     * @returns {Promise<boolean>} Promise indicating whether thirdparty cookies are currently supported
     */ function checkThirdPartyCookiesSupported() {
                var _this = this;
                return _async_to_generator._(function() {
                    var iframe, cleanedUp, messageCallback, cleanup, promise, result, _a;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!isClient) {
                                    return [
                                        2,
                                        Promise.resolve(false)
                                    ];
                                }
                                // Return cached result if check was already completed
                                if (_this.isThirdPartyCookieCheckDone) {
                                    return [
                                        2,
                                        Promise.resolve(_this.areThirdPartyCookiesSupported)
                                    ];
                                }
                                // If no redirect URI is configured, return unsupported
                                if (!_this.silentCheckSsoRedirectUri) {
                                    return [
                                        2,
                                        Promise.resolve(false)
                                    ];
                                }
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                // We create & append the iframe that will do the check
                                iframe = document.createElement("iframe");
                                iframe.setAttribute("src", _this.getApiUrl(_this.endpoints.THIRD_PARTY_COOKIES_IFRAME));
                                iframe.setAttribute("sandbox", "allow-storage-access-by-user-activation allow-scripts allow-same-origin");
                                iframe.setAttribute("title", "oidc-3p-cookies-check-iframe");
                                iframe.setAttribute("id", "oidc-3p-cookies-check-iframe");
                                iframe.style.display = "none";
                                document.body.appendChild(iframe);
                                cleanedUp = false;
                                // This function will remove all eventListeners & iframes used to check the supported status
                                cleanup = function() {
                                    if (!cleanedUp) {
                                        cleanedUp = true;
                                        var targetIframe = document.getElementById("oidc-3p-cookies-check-iframe");
                                        if (targetIframe && document.body.contains(targetIframe)) {
                                            document.body.removeChild(targetIframe);
                                        }
                                        if (messageCallback) window.removeEventListener("message", messageCallback);
                                    }
                                };
                                promise = new Promise(function(resolve) {
                                    messageCallback = _this._onThirdPartyCookieMessage.bind(_this, {
                                        resolve: resolve,
                                        cleanup: cleanup
                                    });
                                    window.addEventListener("message", messageCallback, false);
                                });
                                return [
                                    4,
                                    _this.applyTimeoutToPromise(promise, IFRAME_TIMEOUT_DURATION, "Timeout when waiting for 3rd party check iframe message.")
                                ];
                            case 2:
                                result = _state.sent();
                                cleanup();
                                return [
                                    2,
                                    Promise.resolve(result)
                                ];
                            case 3:
                                _a = _state.sent();
                                return [
                                    2,
                                    Promise.resolve(false)
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_onSsoSilentMessage",
            value: /**
     * Handles the message event from the silent SSO check iframe.
     * @param {{ resolve: Function, reject: Function, cleanup: Function }} context
     * @param {MessageEvent} event
     */ function _onSsoSilentMessage(param, event) {
                var resolve = param.resolve, reject = param.reject, cleanup = param.cleanup;
                var _this = this;
                return _async_to_generator._(function() {
                    var dataStr, data, tokens, error;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (event.origin !== window.location.origin) {
                                    return [
                                        2
                                    ];
                                }
                                if (!(typeof event.data === "string" && event.data.startsWith("oidc-silent-sso:"))) return [
                                    3,
                                    7
                                ];
                                cleanup();
                                dataStr = event.data.substring("oidc-silent-sso:".length);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    6,
                                    ,
                                    7
                                ]);
                                data = JSON.parse(dataStr);
                                if (!data.error) return [
                                    3,
                                    2
                                ];
                                resolve();
                                return [
                                    3,
                                    5
                                ];
                            case 2:
                                if (!data.code) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    _this.oidcApiClient.fetchTokens({
                                        grant_type: "authorization_code",
                                        code: data.code,
                                        code_verifier: _this.getOrCreateCodeVerifier(),
                                        redirect_uri: _this.silentCheckSsoRedirectUri
                                    })
                                ];
                            case 3:
                                tokens = _state.sent();
                                resolve(tokens);
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                reject(new Error("Unexpected data received from silent SSO check: " + dataStr));
                                _state.label = 5;
                            case 5:
                                return [
                                    3,
                                    7
                                ];
                            case 6:
                                error = _state.sent();
                                reject(error);
                                return [
                                    3,
                                    7
                                ];
                            case 7:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "checkSsoSilently",
            value: /**
     * Performs a silent SSO check using an iframe to see if the user has an active session
     * with the OIDC provider.
     * @async
     * @returns {Promise<void>} A promise that resolves if the SSO check is successful and tokens are updated,
     * or rejects if an error occurs or the user is not logged in.
     */ function checkSsoSilently() {
                var _this = this;
                return _async_to_generator._(function() {
                    var cleanedUp, iframe, messageCallback, cleanup, promise;
                    return _ts_generator._(this, function(_state) {
                        if (!_this.silentCheckSsoRedirectUri) {
                            return [
                                2,
                                Promise.resolve()
                            ];
                        }
                        cleanedUp = false;
                        cleanup = function() {
                            if (!cleanedUp) {
                                cleanedUp = true;
                                var targetIframe = document.getElementById("oidc-silent-sso-check-iframe");
                                if (targetIframe && document.body.contains(targetIframe)) {
                                    document.body.removeChild(targetIframe);
                                }
                                if (messageCallback) window.removeEventListener("message", messageCallback);
                            }
                        };
                        promise = new Promise(function(resolve, reject) {
                            var _a, _b;
                            iframe = document.createElement("iframe");
                            var authEndpoint = ((_a = _this.endpoints) === null || _a === void 0 ? void 0 : _a.AUTHORIZATION_WITH_LOGIN) || ((_b = _this.endpoints) === null || _b === void 0 ? void 0 : _b.AUTHORIZATION);
                            if (!authEndpoint) {
                                reject(new Error("No authorization endpoint configured for silent SSO check"));
                                return;
                            }
                            var url = new URL(_this.getApiUrl(authEndpoint));
                            var params = new URLSearchParams({
                                prompt: "none",
                                response_type: "code",
                                client_id: _this.clientId,
                                redirect_uri: _this.silentCheckSsoRedirectUri,
                                scope: "openid profile",
                                code_challenge: _this.getOrCreateCodeChallenge(),
                                code_challenge_method: "S256"
                            });
                            url.search = params.toString();
                            iframe.setAttribute("src", url.toString());
                            iframe.setAttribute("sandbox", "allow-storage-access-by-user-activation allow-scripts allow-same-origin");
                            iframe.setAttribute("title", "oidc-silent-sso-check-iframe");
                            iframe.setAttribute("id", "oidc-silent-sso-check-iframe");
                            iframe.style.display = "none";
                            document.body.appendChild(iframe);
                            messageCallback = _this._onSsoSilentMessage.bind(_this, {
                                resolve: resolve,
                                reject: reject,
                                cleanup: cleanup
                            });
                            window.addEventListener("message", messageCallback);
                        });
                        return [
                            2,
                            promise
                        ];
                    });
                })();
            }
        },
        {
            key: "resolveAuthentication",
            value: /**
     * Explicitly resolves the OIDC authentication state before any API call.
     * Must be called during app bootstrap, before any @withJWT-decorated service call.
     *
     * - If an authorization code is present in the URL (login callback), exchanges it for tokens.
     * - If no code is present, attempts a silent SSO check or falls back to anonymous tokens.
     *
     * @async
     * @returns {Promise<void>}
     */ function resolveAuthentication() {
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!isClient) return [
                                    2
                                ];
                                return [
                                    4,
                                    _this.getOrFetchOidcTokens()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "applyTimeoutToPromise",
            value: function applyTimeoutToPromise(promise, timeout, errorMessage) {
                return _async_to_generator._(function() {
                    var timeoutHandle, timeoutPromise;
                    return _ts_generator._(this, function(_state) {
                        timeoutPromise = new Promise(function(resolve, reject) {
                            timeoutHandle = window.setTimeout(function() {
                                reject(new Error(errorMessage || "Promise is not settled within timeout of " + timeout + "ms"));
                            }, timeout);
                        });
                        return [
                            2,
                            Promise.race([
                                promise,
                                timeoutPromise
                            ]).finally(function() {
                                clearTimeout(timeoutHandle);
                            })
                        ];
                    });
                })();
            }
        }
    ]);
    return OIDCService;
}(fetcherService_1.FetcherService);
__decorate([
    caching_1.withNoParallelRequest,
    monitoring
], OIDCService.prototype, "fetchConnectedTokens", null);
__decorate([
    caching_1.withNoParallelRequest,
    monitoring
], OIDCService.prototype, "fetchAnonymousTokens", null);
__decorate([
    caching_1.withNoParallelRequest,
    monitoring
], OIDCService.prototype, "getUserInfo", null);
__decorate([
    caching_1.withNoParallelRequest,
    monitoring
], OIDCService.prototype, "authorizeDevice", null);
__decorate([
    caching_1.withNoParallelRequest,
    monitoring
], OIDCService.prototype, "renewAccessToken", null);
__decorate([
    caching_1.withNoParallelRequest,
    monitoring
], OIDCService.prototype, "logout", null);
__decorate([
    monitoring
], OIDCService.prototype, "_onSsoSilentMessage", null);
__decorate([
    caching_1.withNoParallelRequest
], OIDCService.prototype, "checkSsoSilently", null);
exports.oidcService = new OIDCService();


/***/ }),

/***/ 96625:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
var __decorate = (void 0) && (void 0).__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (void 0) && (void 0).__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.tokenService = void 0;
var jwt_decode_1 = __importDefault(__webpack_require__(30588));
var get_1 = __importDefault(__webpack_require__(65439));
var fetch_error_1 = __webpack_require__(41180);
var fido_1 = __webpack_require__(19322);
var caching_1 = __webpack_require__(72345);
var securityHeaderBuilder_1 = __webpack_require__(79660);
var fetcherService_1 = __webpack_require__(96571);
var withMonitoring_1 = __webpack_require__(97982);
var oidcService_1 = __webpack_require__(29370);
var monitoring = (0, withMonitoring_1.withMonitoring)("token");
/** @import { BackoffOptions } from "../utils/backoff" */ /**
 * The Token service is used to retrieve JWT in order to use 6play's API.
 * @module Token
 * @tutorial ./doc/token.md
 */ var TokenService = /*#__PURE__*/ function(_fetcherService_1_FetcherService) {
    _inherits._(TokenService, _fetcherService_1_FetcherService);
    var _super = _create_super._(TokenService);
    function TokenService() {
        _class_call_check._(this, TokenService);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.persistentToken = null;
        _this.decodedPersistentToken = null;
        _this.advertisingId = null;
        _this.apiType = "auth";
        _this.subscriptionList = null;
        /**
         * Used for the exponential backoff and optional jitter strategy when fetching tokens
         * @type {BackoffOptions}
         * @see {FetcherService.fetch}
         */ _this.backoffOptions = null;
        return _this;
    }
    _create_class._(TokenService, [
        {
            /**
     * Initialize the service.
     * @param {Object} options options to customise headers passed to token service. maxAttempts numeric option is to refetch token in case of failure
     * @tutorial ./doc/tokenInit.md
     */ key: "init",
            value: function init() {
                var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, advertisingId = _ref.advertisingId, _ref_maxAttempts = _ref.maxAttempts, maxAttempts = _ref_maxAttempts === void 0 ? 3 : _ref_maxAttempts, _ref_delay = _ref.delay, delay = _ref_delay === void 0 ? 2500 : _ref_delay, _ref_jitter = _ref.jitter, jitter = _ref_jitter === void 0 ? 250 : _ref_jitter, _ref_persistentToken = _ref.persistentToken, persistentToken = _ref_persistentToken === void 0 ? null : _ref_persistentToken, _ref_boxId = _ref.boxId, boxId = _ref_boxId === void 0 ? null : _ref_boxId, _ref_boxType = _ref.boxType, boxType = _ref_boxType === void 0 ? null : _ref_boxType, _ref_deviceModel = _ref.deviceModel, deviceModel = _ref_deviceModel === void 0 ? null : _ref_deviceModel, _ref_deviceName = _ref.deviceName, deviceName = _ref_deviceName === void 0 ? null : _ref_deviceName, _ref_deviceVersion = _ref.deviceVersion, deviceVersion = _ref_deviceVersion === void 0 ? null : _ref_deviceVersion, _ref_frontStateAppVersion = _ref.frontStateAppVersion, frontStateAppVersion = _ref_frontStateAppVersion === void 0 ? null : _ref_frontStateAppVersion, _ref_subscriptionList = _ref.subscriptionList, subscriptionList = _ref_subscriptionList === void 0 ? null : _ref_subscriptionList, _ref_partnerContext = _ref.partnerContext, partnerContext = _ref_partnerContext === void 0 ? null : _ref_partnerContext;
                if (!this.isInitialized) {
                    this.advertisingId = advertisingId;
                    this.basePath = "platforms/".concat(fido_1.fido.get("platformCode"));
                    this.isInitialized = true;
                    this.boxId = boxId;
                    this.boxType = boxType;
                    this.deviceModel = deviceModel;
                    this.deviceName = deviceName;
                    this.deviceVersion = deviceVersion;
                    this.frontStateAppVersion = frontStateAppVersion;
                    this.subscriptionList = subscriptionList;
                    this.partnerContext = partnerContext;
                    this.backoffOptions = {
                        maxAttempts: maxAttempts,
                        delay: delay,
                        jitter: jitter
                    };
                    this.setToken(persistentToken);
                }
            }
        },
        {
            /**
     * Set the advertisingId property.
     * @param {string} advertisingId
     */ key: "setAdvertisingId",
            value: function setAdvertisingId(advertisingId) {
                this.resetToken();
                this.advertisingId = advertisingId;
            }
        },
        {
            /**
     * Set the user property.
     *
     * @param {Object} user The user used to generate the JWT.
     * @param {string} user.UID The user UID for BR JWT generation
     * @param {string} [user.UIDSignature] The user UID signature for specific Gigya JWT generation
     * @param {string} [user.signatureTimestamp] The timestamp signature for specific Gigya JWT generation
     */ key: "setUser",
            value: function setUser(user) {
                var _a;
                if ((user === null || user === void 0 ? void 0 : user.UID) !== ((_a = this.user) === null || _a === void 0 ? void 0 : _a.UID)) {
                    this.resetToken();
                }
                this.user = user;
            }
        },
        {
            /**
     * Set the profile property. Token is also reset.
     *
     * @param {Object} profile The user profile used to generate the JWT.
     * @param {string} profile.profileUid The profile UID for BR JWT generation
     */ key: "setProfile",
            value: function setProfile(profile) {
                var _a;
                if ((profile === null || profile === void 0 ? void 0 : profile.profileUid) !== ((_a = this.profile) === null || _a === void 0 ? void 0 : _a.profileUid)) {
                    this.resetToken();
                }
                this.profile = profile;
            }
        },
        {
            /**
     * Reset profile property. Token is also reset.
     */ key: "resetProfile",
            value: function resetProfile() {
                this.resetToken();
                this.profile = null;
            }
        },
        {
            /**
     * Reset the JWT.
     */ key: "resetToken",
            value: function resetToken() {
                this.persistentToken = null;
                this.decodedPersistentToken = null;
            }
        },
        {
            /**
     * Set the persistentToken property. Token is also decoded and set in
     * decodedPersistentToken property
     *
     * @param {String} token The JWT to be used
     */ key: "setToken",
            value: function setToken(token) {
                this.persistentToken = token;
                this.decodedPersistentToken = null;
                if (token) {
                    try {
                        this.decodedPersistentToken = (0, jwt_decode_1.default)(token);
                    } catch (_a) {
                    // Don't fail if jwtDecode fails
                    }
                }
            }
        },
        {
            /**
     * Reset the JWT and the user property.
     */ key: "resetUserAndToken",
            value: function resetUserAndToken() {
                this.resetToken();
                this.user = null;
                this.profile = null;
            }
        },
        {
            key: "isTokenValid",
            value: function isTokenValid() {
                if (!this.decodedPersistentToken) {
                    return false;
                }
                return fido_1.fido.get("getCurrentTime")() < (this.decodedPersistentToken.exp - 10) * 1000;
            }
        },
        {
            key: "getToken",
            value: /**
     * Returns a valid JWT. If there is no current or valid JWT token, it gets a new one.
     * @returns {token} A valid JWT.
     * @async
     */ function getToken() {
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(!_this.persistentToken || !_this.isTokenValid())) return [
                                    3,
                                    4
                                ];
                                if (!oidcService_1.oidcService.isInitialized) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.renewOidcToken()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 2:
                                return [
                                    4,
                                    _this.renewToken()
                                ];
                            case 3:
                                _state.sent();
                                _state.label = 4;
                            case 4:
                                return [
                                    2,
                                    _this.persistentToken
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getTokenInformation",
            value: function getTokenInformation() {
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.getToken()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2,
                                    _this.decodedPersistentToken
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
     * Gigya method to retrieve token
     * @returns {Promise<any>} a promise that store the token in the service
     */ key: "renewToken",
            value: function renewToken() {
                var _this = this;
                var url = this.getRouteUrl("getJwt");
                var path = this.getRoutePath("getJwt", true);
                var _this1 = this, advertisingId = _this1.advertisingId, boxType = _this1.boxType, boxId = _this1.boxId, deviceVersion = _this1.deviceVersion, deviceModel = _this1.deviceModel, deviceName = _this1.deviceName, frontStateAppVersion = _this1.frontStateAppVersion, partnerContext = _this1.partnerContext;
                var innerWidth = null;
                var innerHeight = null;
                if (typeof window !== "undefined") {
                    innerWidth = (0, get_1.default)(window, "innerWidth", null);
                    innerHeight = (0, get_1.default)(window, "innerHeight", null);
                }
                return this.fetch(url, {
                    method: "GET",
                    headers: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, boxId && {
                        "x-auth-box-id": boxId
                    }), boxType && {
                        "x-auth-box-type": boxType
                    }), advertisingId ? {
                        "x-auth-advertising-id": advertisingId
                    } : null), deviceVersion ? {
                        "x-auth-device-version": deviceVersion
                    } : null), deviceName ? {
                        "x-auth-device-name": deviceName
                    } : null), deviceModel ? {
                        "x-auth-device-model": deviceModel
                    } : null), frontStateAppVersion ? {
                        "x-auth-frontstate-app-version": frontStateAppVersion
                    } : null), partnerContext ? {
                        "x-auth-device-partner-context": partnerContext
                    } : null), innerWidth ? {
                        "x-auth-device-player-size-width": innerWidth
                    } : null), innerHeight ? {
                        "x-auth-device-player-size-height": innerHeight
                    } : null), this.subscriptionList ? {
                        "x-external-subscription-access": this.subscriptionList
                    } : null), (0, securityHeaderBuilder_1.getHeaders)({
                        path: path,
                        body: {}
                    }, {
                        user: this.user,
                        profile: this.profile
                    }))
                }, this.backoffOptions).then(function(param) {
                    var token = param.token;
                    _this.setToken(token);
                }).catch(function(error) {
                    throw new fetch_error_1.FetchError("tokenService:getJwt:fetch ".concat(error.status, " ").concat(error), null, error.response);
                });
            }
        },
        {
            key: "renewOidcToken",
            value: /**
     * OIDC method to retrieve token
     * @returns {Promise<any>} a promise that store the token in the service
     */ function renewOidcToken() {
                var _this = this;
                return _async_to_generator._(function() {
                    var routePath, routeUrl, url, accessToken, advertisingId, boxType, boxId, deviceVersion, deviceModel, deviceName, frontStateAppVersion, partnerContext, innerWidth, innerHeight;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                /*
         * TODO: find a way to avoid this replacement, it's just a temp workaround
         * We need to call this endpoint https://front-auth.staging.rtlde.bedrock.tech/v2/rtlde/platforms/smarttv/token
         * and this.getRouteUrl('token') returns https://front-auth.staging.rtlde.bedrock.tech/v2/platforms/smarttv/token
         */ routePath = _this.getRoutePath("token");
                                routeUrl = _this.getRouteUrl("token");
                                url = routeUrl.replace(routePath, "/".concat(fido_1.fido.get("customerCode")).concat(routePath));
                                return [
                                    4,
                                    oidcService_1.oidcService.getOrFetchOidcTokens()
                                ];
                            case 1:
                                accessToken = _state.sent().accessToken;
                                // Clear stale state if OIDC fell back to guest
                                if (oidcService_1.oidcService.isGuestUser()) {
                                    _this.user = null;
                                    _this.profile = null;
                                }
                                advertisingId = _this.advertisingId, boxType = _this.boxType, boxId = _this.boxId, deviceVersion = _this.deviceVersion, deviceModel = _this.deviceModel, deviceName = _this.deviceName, frontStateAppVersion = _this.frontStateAppVersion, partnerContext = _this.partnerContext;
                                innerWidth = null;
                                innerHeight = null;
                                if (typeof window !== "undefined") {
                                    innerWidth = (0, get_1.default)(window, "innerWidth", null);
                                    innerHeight = (0, get_1.default)(window, "innerHeight", null);
                                }
                                return [
                                    2,
                                    _this.fetch(url, {
                                        method: "GET",
                                        headers: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
                                            Authorization: "Bearer ".concat(accessToken)
                                        }, boxId ? {
                                            "x-auth-box-id": boxId
                                        } : null), boxType ? {
                                            "x-auth-box-type": boxType
                                        } : null), advertisingId ? {
                                            "x-auth-advertising-id": advertisingId
                                        } : null), deviceVersion ? {
                                            "x-auth-device-version": deviceVersion
                                        } : null), deviceName ? {
                                            "x-auth-device-name": deviceName
                                        } : null), deviceModel ? {
                                            "x-auth-device-model": deviceModel
                                        } : null), frontStateAppVersion ? {
                                            "x-auth-frontstate-app-version": frontStateAppVersion
                                        } : null), partnerContext ? {
                                            "x-auth-device-partner-context": partnerContext
                                        } : null), innerWidth ? {
                                            "x-auth-device-player-size-width": innerWidth
                                        } : null), innerHeight ? {
                                            "x-auth-device-player-size-height": innerHeight
                                        } : null), _this.subscriptionList ? {
                                            "x-external-subscription-access": _this.subscriptionList
                                        } : null), (0, securityHeaderBuilder_1.getHeaders)({
                                            body: {}
                                        }, {
                                            user: _this.user,
                                            profile: _this.profile
                                        }))
                                    }, _this.backoffOptions).then(function(param) {
                                        var token = param.token;
                                        _this.setToken(token);
                                    }).catch(function(error) {
                                        throw new fetch_error_1.FetchError("tokenService:token:fetch ".concat(error.status, " ").concat(error), null, error.response);
                                    })
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "fetchJwtForSearchEngineOptimization",
            value: /**
     * Fetches a JWT from front-auth for SEO crawlers (see getJwtForSearchEngineOptimization).
     * @param {{ accessKey: string }} params
     * @returns {Promise<string>} the raw JWT
     */ function fetchJwtForSearchEngineOptimization(param) {
                var accessKey = param.accessKey;
                var _this = this;
                return _async_to_generator._(function() {
                    var baseUrl, url, headers;
                    return _ts_generator._(this, function(_state) {
                        _this.checkInit("internalAuth");
                        baseUrl = fido_1.fido.getBaseUrl("internalAuth");
                        url = "".concat(baseUrl, "getJwtForSearchEngineOptimization?accessKey=").concat(encodeURIComponent(accessKey));
                        headers = Object.assign({}, fido_1.fido.get("appVersion") ? {
                            "x-client-release": fido_1.fido.get("appVersion")
                        } : {});
                        return [
                            2,
                            _this.fetchWithoutVersionHeaders(url, {
                                method: "GET",
                                headers: headers
                            }).then(function(param) {
                                var token = param.token;
                                return token;
                            }).catch(function(error) {
                                throw new fetch_error_1.FetchError("tokenService:getJwtForSearchEngineOptimization:fetch ".concat(error.status, " ").concat(error), null, error.response);
                            })
                        ];
                    });
                })();
            }
        }
    ]);
    return TokenService;
}(fetcherService_1.FetcherService);
__decorate([
    caching_1.withNoParallelRequest,
    monitoring
], TokenService.prototype, "renewToken", null);
__decorate([
    caching_1.withNoParallelRequest,
    monitoring
], TokenService.prototype, "renewOidcToken", null);
exports.tokenService = new TokenService();


/***/ }),

/***/ 94007:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(37815);
var __decorate = (void 0) && (void 0).__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (void 0) && (void 0).__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.boxDataService = exports.BoxDataService = void 0;
var isObject_1 = __importDefault(__webpack_require__(36838));
var fido_1 = __webpack_require__(19322);
var securityHeaderBuilder_1 = __webpack_require__(79660);
var fetcherService_1 = __webpack_require__(96571);
var withMonitoring_1 = __webpack_require__(97982);
var monitoring = (0, withMonitoring_1.withMonitoring)("boxData");
function formatValue(value) {
    if ((0, isObject_1.default)(value)) {
        return JSON.stringify(value);
    }
    return "".concat(value);
}
function parseValue(value) {
    try {
        return JSON.parse(value);
    } catch (_a) {
        return value;
    }
}
/**
 * @module BoxDataService
 * @description The BoxData API is a very basic key/value remote storage mainly useful when storing data locally is not allowed by the platform
 * @tutorial ./doc/boxDataService.md
 */ var BoxDataService = /*#__PURE__*/ function(_fetcherService_1_FetcherService) {
    _inherits._(BoxDataService, _fetcherService_1_FetcherService);
    var _super = _create_super._(BoxDataService);
    function BoxDataService() {
        _class_call_check._(this, BoxDataService);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.apiType = "userv2";
        return _this;
    }
    _create_class._(BoxDataService, [
        {
            /**
     * Initialize the service.
     *
     * @tutorial ./doc/boxDataServiceInit.md
     */ key: "init",
            value: function init() {
                var boxType = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).boxType;
                if (!this.isInitialized) {
                    this.isInitialized = true;
                    this.basePath = "platforms/".concat(fido_1.fido.get("platformCode"), "/boxTypes/").concat(boxType, "/boxIds/").concat(this.getHomeOrDeviceId());
                    this.boxType = boxType;
                }
            }
        },
        {
            /**
     * Fetch all keys
     *
     * @async
     * @returns {Object[]}
     * @tutorial ./doc/boxDataServiceFetchKeys.md
     */ key: "fetchKeys",
            value: function fetchKeys() {
                var url = this.getRouteUrl("keys");
                var path = this.getRoutePath("keys", true);
                return this.fetch(url, {
                    method: "GET",
                    headers: (0, securityHeaderBuilder_1.getTimestampHeader)(path, {}, fido_1.fido.get("getCurrentTime")(), fido_1.fido.get("saltAndSugar"))
                }).then(function(data) {
                    if (!data || data.length <= 0) {
                        return [];
                    }
                    return data.map(function(item) {
                        return Object.assign(Object.assign({}, item), {
                            value: parseValue(item.value)
                        });
                    });
                });
            }
        },
        {
            /**
     * Fetch a specific key
     *
     * @async
     * @param {string} key Key's name
     * @returns {Object}
     * @tutorial ./doc/boxDataServiceFetchKey.md
     */ key: "fetchKey",
            value: function fetchKey(key) {
                var endpoint = "keys/".concat(key);
                var url = this.getRouteUrl(endpoint);
                var path = this.getRoutePath(endpoint, true);
                return this.fetch(url, {
                    method: "GET",
                    headers: (0, securityHeaderBuilder_1.getTimestampHeader)(path, {}, fido_1.fido.get("getCurrentTime")(), fido_1.fido.get("saltAndSugar"))
                }).then(function(item) {
                    return Object.assign(Object.assign({}, item), {
                        value: parseValue(item.value)
                    });
                });
            }
        },
        {
            /**
     * Add a new key
     *
     * @async
     * @param {string} key Key's name
     * @param {string|number|bool|object} key Key's value
     * @returns {Object}
     * @tutorial ./doc/boxDataServiceSaveKey.md
     */ key: "saveKey",
            value: function saveKey(key, value) {
                var url = this.getRouteUrl("keys");
                var path = this.getRoutePath("keys", true);
                var body = {
                    key: key,
                    value: formatValue(value)
                };
                return this.fetch(url, {
                    method: "POST",
                    body: body,
                    headers: (0, securityHeaderBuilder_1.getTimestampHeader)(path, body, fido_1.fido.get("getCurrentTime")(), fido_1.fido.get("saltAndSugar"))
                });
            }
        },
        {
            /**
     * Delete a key
     *
     * @async
     * @param {string} key Key's name
     * @returns {Object}
     * @tutorial ./doc/boxDataServiceDeleteKey.md
     */ key: "deleteKey",
            value: function deleteKey(key) {
                var endpoint = "keys/".concat(key);
                var url = this.getRouteUrl(endpoint);
                var path = this.getRoutePath(endpoint, true);
                return this.fetch(url, {
                    method: "DELETE",
                    headers: (0, securityHeaderBuilder_1.getTimestampHeader)(path, {}, fido_1.fido.get("getCurrentTime")(), fido_1.fido.get("saltAndSugar"))
                });
            }
        }
    ]);
    return BoxDataService;
}(fetcherService_1.FetcherService);
exports.BoxDataService = BoxDataService;
__decorate([
    monitoring
], BoxDataService.prototype, "fetchKeys", null);
__decorate([
    monitoring
], BoxDataService.prototype, "fetchKey", null);
__decorate([
    monitoring
], BoxDataService.prototype, "saveKey", null);
__decorate([
    monitoring
], BoxDataService.prototype, "deleteKey", null);
exports.boxDataService = new BoxDataService();


/***/ }),

/***/ 54869:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(65759);
var __decorate = (void 0) && (void 0).__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.broadcastliveService = void 0;
var fido_1 = __webpack_require__(19322);
var withJWT_1 = __webpack_require__(56282);
var fetcherService_1 = __webpack_require__(96571);
var withMonitoring_1 = __webpack_require__(97982);
var monitoring = (0, withMonitoring_1.withMonitoring)("broadcastlive");
/**
 * @module BroadcastLive
 * @augments FetcherService
 * @description This service is used to get live current broadcast program with preroll info.
 * @tutorial ./doc/broadcastlive.md
 */ var BroadcastLiveService = /*#__PURE__*/ function(_fetcherService_1_FetcherService) {
    _inherits._(BroadcastLiveService, _fetcherService_1_FetcherService);
    var _super = _create_super._(BroadcastLiveService);
    function BroadcastLiveService() {
        _class_call_check._(this, BroadcastLiveService);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.apiType = "middlewarev2";
        return _this;
    }
    _create_class._(BroadcastLiveService, [
        {
            /**
     * Initialize the service. If you don't call this method, no other method can be called.
     *
     * @tutorial ./doc/broadcastliveInit.md
     */ key: "init",
            value: function init() {
                if (!this.isInitialized) {
                    this.basePath = "platforms/".concat(fido_1.fido.get("platformCode"), "/services");
                    this.isInitialized = true;
                }
            }
        },
        {
            key: "fetchLiveProgram",
            value: /**
     * Get live current broadcast program with preroll info.
     *
     * @async
     * @param {Object} options Options passed to liveProgram serviceCode, channel, clientCode or headers
     * @returns {Object} Information about the live program
     * @tutorial ./doc/broadcastliveFetchLiveProgram.md
     */ function fetchLiveProgram(param) {
                var serviceCode = param.serviceCode, channel = param.channel, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers, clientCode = param.clientCode;
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        if (!channel) {
                            throw new Error("You should provide a non null channel string");
                        }
                        return [
                            2,
                            _this.fetch(_this.getRouteUrl("".concat(serviceCode, "/channels/").concat(channel, "/broadcasts/live"), clientCode), {
                                method: "GET",
                                headers: headers
                            })
                        ];
                    });
                })();
            }
        }
    ]);
    return BroadcastLiveService;
}(fetcherService_1.FetcherService);
__decorate([
    withJWT_1.withJWT,
    monitoring
], BroadcastLiveService.prototype, "fetchLiveProgram", null);
exports.broadcastliveService = new BroadcastLiveService();


/***/ }),

/***/ 4748:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(45538);
var __decorate = (void 0) && (void 0).__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.creditsService = void 0;
var withJWT_1 = __webpack_require__(56282);
var fetcherService_1 = __webpack_require__(96571);
var withMonitoring_1 = __webpack_require__(97982);
var monitoring = (0, withMonitoring_1.withMonitoring)("credits");
/**
 * @module Credits
 * @description Manage credit operations and balances
 * @tutorial ./doc/credits.md
 */ var CreditsService = /*#__PURE__*/ function(_fetcherService_1_FetcherService) {
    _inherits._(CreditsService, _fetcherService_1_FetcherService);
    var _super = _create_super._(CreditsService);
    function CreditsService() {
        _class_call_check._(this, CreditsService);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.apiType = "credits";
        return _this;
    }
    _create_class._(CreditsService, [
        {
            key: "init",
            value: function init() {
                if (!this.isInitialized) {
                    this.isInitialized = true;
                }
            }
        },
        {
            key: "fetchBalance",
            value: /**
     * Retrieves the credit balance for a specified user account
     *
     * @async
     * @param {Object} options - The options object
     * @param {string} options.userUid - The unique identifier of the user
     * @param {Object} [options.headers={}] - Additional HTTP headers to include in the request
     * @returns {Promise<number>} A promise that resolves to the user's available credit amount
     * @throws {Error} Throws an error if userUid is not provided
     */ function fetchBalance(param) {
                var userUid = param.userUid, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                var _this = this;
                return _async_to_generator._(function() {
                    var response;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!userUid) {
                                    throw new Error("You should provide a user uid");
                                }
                                return [
                                    4,
                                    _this.fetch(_this.getRouteUrl("".concat(userUid, "/balance")), {
                                        method: "GET",
                                        headers: headers
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                return [
                                    2,
                                    response.available_credit
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "redeemProduct",
            value: /**
     * Redeems a product using the user's available credits
     *
     * @async
     * @param {Object} options - The options object
     * @param {string} options.userUid - The unique identifier of the user
     * @param {string} options.productId - The identifier of the product to redeem
     * @param {Object} [options.headers={}] - Additional HTTP headers to include in the request
     * @returns {Promise<string>} A promise that resolves to "OK" when redemption is successful
     * @throws {Error} Throws an error if userUid or productId is missing
     */ function redeemProduct() {
                var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, userUid = _ref.userUid, productId = _ref.productId, _ref_headers = _ref.headers, headers = _ref_headers === void 0 ? {} : _ref_headers;
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        if (!userUid || !productId) {
                            throw new Error("You should provide a user uid and product id");
                        }
                        return [
                            2,
                            _this.fetch(_this.getRouteUrl("".concat(userUid, "/redeem")), {
                                method: "PUT",
                                body: {
                                    permission_id: productId
                                },
                                headers: headers
                            })
                        ];
                    });
                })();
            }
        }
    ]);
    return CreditsService;
}(fetcherService_1.FetcherService);
__decorate([
    withJWT_1.withJWT,
    monitoring
], CreditsService.prototype, "fetchBalance", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], CreditsService.prototype, "redeemProduct", null);
exports.creditsService = new CreditsService();


/***/ }),

/***/ 96571:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(52318);
var __decorate = (void 0) && (void 0).__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.FetcherService = void 0;
var fido_1 = __webpack_require__(19322);
var backoff_1 = __webpack_require__(43573);
var fetch_1 = __webpack_require__(27082);
var withCustomerHeader_1 = __webpack_require__(41458);
var withRequestTimeoutHeader_1 = __webpack_require__(88319);
var withVersionHeader_1 = __webpack_require__(47662);
/** @import { BackoffOptions } from "../utils/backoff" */ /**
 * Service for making HTTP requests with retry logic and optional backoff strategy.
 */ var FetcherService = /*#__PURE__*/ function() {
    function FetcherService() {
        _class_call_check._(this, FetcherService);
        this.isInitialized = false;
        this.basePath = "";
        this.apiType = "";
        this.displayName = "";
    }
    _create_class._(FetcherService, [
        {
            key: "init",
            value: function init() {
                throw new Error("You should implement the init function of Fido's ".concat(this.getName()));
            }
        },
        {
            key: "externalFetch",
            value: /**
     * Fetch data from an external URL without adding custom headers and versions headers
     * @param {string} url to call
     * @param {Object} options (method, headers, body, etc.)
     * @returns {Promise<Object>}
     */ function externalFetch(url, options) {
                return _async_to_generator._(function() {
                    var body;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, fetch_1.fetch)(url, options)
                                ];
                            case 1:
                                body = _state.sent().body;
                                return [
                                    2,
                                    body
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "fetch",
            value: /**
     * @param {string} url
     * @param {*} options
     * @param {BackoffOptions} backoffOptions
     */ function fetch(url, options, backoffOptions) {
                var _this = this;
                return _async_to_generator._(function() {
                    var body, body1;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!backoffOptions) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    (0, backoff_1.backoff)(function() {
                                        return _this.fetchWithResponse(url, options);
                                    }, backoffOptions)
                                ];
                            case 1:
                                body = _state.sent().body;
                                return [
                                    2,
                                    body
                                ];
                            case 2:
                                return [
                                    4,
                                    _this.fetchWithResponse(url, options)
                                ];
                            case 3:
                                body1 = _state.sent().body;
                                return [
                                    2,
                                    body1
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "fetchWithoutVersionHeaders",
            value: function fetchWithoutVersionHeaders(url, options) {
                return _async_to_generator._(function() {
                    var body;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, fetch_1.fetch)(url, options)
                                ];
                            case 1:
                                body = _state.sent().body;
                                return [
                                    2,
                                    body
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "fetchWithResponse",
            value: function fetchWithResponse(url, options) {
                return (0, fetch_1.fetch)(url, options);
            }
        },
        {
            key: "fetchWithStatus",
            value: function fetchWithStatus(url, options) {
                return _async_to_generator._(function() {
                    var status, error, response;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    (0, fetch_1.fetch)(url, options)
                                ];
                            case 1:
                                status = _state.sent().status;
                                return [
                                    2,
                                    status
                                ];
                            case 2:
                                error = _state.sent();
                                response = error.response;
                                if (response) {
                                    return [
                                        2,
                                        response.status
                                    ];
                                }
                                return [
                                    2,
                                    0
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getName",
            value: function getName() {
                return this.displayName || this.constructor.name;
            }
        },
        {
            key: "getRoutePath",
            value: function getRoutePath(endpoint) {
                var withVersion = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var path = "/".concat(this.basePath ? "".concat(this.basePath, "/") : "").concat(endpoint);
                if (withVersion) {
                    var baseUrl = fido_1.fido.getBaseUrl(this.apiType);
                    var matches = baseUrl.match(/\/(v[0-9])$/);
                    if (matches) {
                        return "/".concat(matches[1]).concat(path);
                    }
                }
                return path;
            }
        },
        {
            key: "getRouteUrl",
            value: function getRouteUrl() {
                var endpoint = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", clientCode = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : fido_1.fido.get("clientCode"), platformCode = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : fido_1.fido.get("platformCode");
                this.checkInit();
                if (!this.apiType) {
                    throw new Error("You should define an API type for Fido's ".concat(this.getName()));
                }
                return "".concat(fido_1.fido.getBaseUrl(this.apiType).replace("%(clientCode)s", clientCode)).concat(this.getRoutePath(endpoint).replace("%(platformCode)s", platformCode));
            }
        },
        {
            key: "getHomeOrDeviceId",
            value: function getHomeOrDeviceId() {
                var prefixedId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                this.checkInit();
                var deviceId = fido_1.fido.get("localDeviceId");
                var homeId = fido_1.fido.get("localHomeId");
                if (homeId) {
                    return prefixedId ? "homeid-".concat(homeId) : "".concat(homeId);
                }
                return prefixedId ? "deviceid-".concat(deviceId) : "".concat(deviceId);
            }
        },
        {
            key: "checkInit",
            value: function checkInit(apiType) {
                if (!this.isInitialized) {
                    throw new Error("You should init Fido's ".concat(this.getName(), " before using it"));
                }
                if (!fido_1.fido.getBaseUrl(apiType || this.apiType)) {
                    throw new Error("You should set baseUrl for ".concat(this.getName(), " before using it"));
                }
            }
        }
    ]);
    return FetcherService;
}();
exports.FetcherService = FetcherService;
__decorate([
    (0, withVersionHeader_1.withVersionHeader)(1),
    (0, withCustomerHeader_1.withCustomerHeader)(1),
    (0, withRequestTimeoutHeader_1.withRequestTimeoutHeader)(1)
], FetcherService.prototype, "fetch", null);
__decorate([
    (0, withCustomerHeader_1.withCustomerHeader)(1),
    (0, withRequestTimeoutHeader_1.withRequestTimeoutHeader)(1)
], FetcherService.prototype, "fetchWithoutVersionHeaders", null);
__decorate([
    (0, withVersionHeader_1.withVersionHeader)(1),
    (0, withCustomerHeader_1.withCustomerHeader)(1),
    (0, withRequestTimeoutHeader_1.withRequestTimeoutHeader)(1)
], FetcherService.prototype, "fetchWithResponse", null);
__decorate([
    (0, withVersionHeader_1.withVersionHeader)(1),
    (0, withCustomerHeader_1.withCustomerHeader)(1),
    (0, withRequestTimeoutHeader_1.withRequestTimeoutHeader)(1)
], FetcherService.prototype, "fetchWithStatus", null);


/***/ }),

/***/ 63273:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(88801);
var __decorate = (void 0) && (void 0).__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.foldersService = void 0;
var fido_1 = __webpack_require__(19322);
var fetcherService_1 = __webpack_require__(96571);
var withMonitoring_1 = __webpack_require__(97982);
var monitoring = (0, withMonitoring_1.withMonitoring)("folders");
/**
 * @module Folders
 * @description This service is used to get folder list from middleware API
 */ var FoldersService = /*#__PURE__*/ function(_fetcherService_1_FetcherService) {
    _inherits._(FoldersService, _fetcherService_1_FetcherService);
    var _super = _create_super._(FoldersService);
    function FoldersService() {
        _class_call_check._(this, FoldersService);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.apiType = "middlewarev2";
        return _this;
    }
    _create_class._(FoldersService, [
        {
            /**
     * Initialize the service. If you don't call this method, no other method can be called.
     */ key: "init",
            value: function init() {
                if (!this.isInitialized) {
                    this.basePath = "platforms/".concat(fido_1.fido.get("platformCode"), "/services");
                    this.isInitialized = true;
                }
            }
        },
        {
            key: "fetchFolders",
            value: /**
     * Get a list of folders
     *
     * @async
     * @param {Object} options Options for fetching folders.
     * @param {string} options.serviceCode Service where the information should be retrieved from.
     * @param {number} options.offset Starting item for pagination.
     * @param {number} options.limit Maximum number of items to return for pagination.
     * @param {Object} [options.headers={}] Optional HTTP headers.
     * @returns {Promise<Array>} Returns a paginated array of folders, can be empty.
     * @throws {Error} Throws an error if serviceCode is not provided.
     * @throws {Error} Throws an error if offset is not a valid number.
     * @throws {Error} Throws an error if limit is not a valid number.
     */ function fetchFolders(param) {
                var serviceCode = param.serviceCode, offset = param.offset, limit = param.limit, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!serviceCode) {
                                    throw new Error("You should provide a service code");
                                }
                                if (typeof offset !== "number" || isNaN(offset)) {
                                    throw new Error("You should provide a valid numeric offset");
                                }
                                if (typeof limit !== "number" || isNaN(limit)) {
                                    throw new Error("You should provide a valid numeric limit");
                                }
                                return [
                                    4,
                                    _this.fetch(_this.getRouteUrl("".concat(serviceCode, "/folders?limit=").concat(limit, "&offset=").concat(offset)), {
                                        method: "GET",
                                        headers: headers
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return FoldersService;
}(fetcherService_1.FetcherService);
__decorate([
    monitoring
], FoldersService.prototype, "fetchFolders", null);
exports.foldersService = new FoldersService();


/***/ }),

/***/ 1435:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(45538);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.couponStatus = void 0;
exports.couponStatus = {
    VALID: "VALID",
    ALREADY_USED: "ALREADY_USED",
    INVALID: "INVALID"
};


/***/ }),

/***/ 75920:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(45538);
var __decorate = (void 0) && (void 0).__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (void 0) && (void 0).__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.freemiumService = exports.FreemiumService = void 0;
var get_1 = __importDefault(__webpack_require__(65439));
var fido_1 = __webpack_require__(19322);
var caching_1 = __webpack_require__(72345);
var securityHeaderBuilder_1 = __webpack_require__(79660);
var withJWT_1 = __webpack_require__(56282);
var fetcherService_1 = __webpack_require__(96571);
var withMonitoring_1 = __webpack_require__(97982);
var freemium_constants_1 = __webpack_require__(1435);
var monitoring = (0, withMonitoring_1.withMonitoring)("freemium");
/**
 * @module Freemium
 * @description The Freemium service is used for freemium in 6play app
 * @tutorial ./doc/freemium.md
 * @deprecated use PremiumService instead
 */ var FreemiumService = /*#__PURE__*/ function(_fetcherService_1_FetcherService) {
    _inherits._(FreemiumService, _fetcherService_1_FetcherService);
    var _super = _create_super._(FreemiumService);
    function FreemiumService() {
        _class_call_check._(this, FreemiumService);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.apiType = "coupons";
        return _this;
    }
    _create_class._(FreemiumService, [
        {
            /**
     * Initialize the service. If you don't call this method, no other method can be called.
     *
     * @tutorial ./doc/freemiumInit.md
     * @deprecated
     */ key: "init",
            value: function init() {
                if (!this.isInitialized) {
                    this.isInitialized = true;
                }
            }
        },
        {
            key: "getUserSubscriptions",
            value: /**
     * Get the user's freemium subscriptions
     * @async
     *
     * @param {Object} options Object containing the user whose subscriptions are requested
     * @returns {Object}
     * @deprecated Use PremiumService.getUserSubscriptions instead
     */ function getUserSubscriptions(param) {
                var user = param.user, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                var _this = this;
                return _async_to_generator._(function() {
                    var apiURL;
                    return _ts_generator._(this, function(_state) {
                        _this.checkInit("userv2");
                        if (!user.UID) {
                            throw new Error("You should provide a non null uid");
                        }
                        apiURL = "".concat(fido_1.fido.getBaseUrl("userv2"), "/platforms/").concat(fido_1.fido.get("platformCode"), "/users/").concat(user.UID, "/freemiumsubscriptions");
                        return [
                            2,
                            _this.fetch(apiURL, {
                                method: "GET",
                                headers: headers
                            })
                        ];
                    });
                })();
            }
        },
        {
            /**
     * @deprecated
     */ key: "validateSubscriptionWithReceipt",
            value: function validateSubscriptionWithReceipt(receipt, user, param) {
                var _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                this.checkInit("userv2");
                var receiptCheckURL = "".concat(fido_1.fido.getBaseUrl("userv2"), "/platforms/").concat(fido_1.fido.get("platformCode"), "/users/").concat(user.UID, "/stores/bedrock-freecoupons/receiptCheck");
                return this.fetch(receiptCheckURL, {
                    method: "POST",
                    headers: headers,
                    body: {
                        receiptData: receipt.data
                    }
                });
            }
        },
        {
            key: "verifyCoupon",
            value: /**
     * Verify if a couponCode is valid and return the offer id associated to it
     * or throw if it is invalid
     * @async
     *
     * @param {Object} options Contains the couponCode to verify and the
     * headers to transmit during the ajax request
     * @returns {Object} The offer
     * @tutorial ./doc/verifyCoupon.md
     * @deprecated use PremiumService.verifyCoupon instead
     */ function verifyCoupon() {
                var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, couponCode = _ref.couponCode, user = _ref.user;
                var _this = this;
                return _async_to_generator._(function() {
                    var couponVerificationURL, userHeaders, receipt, e, status, result;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.checkInit();
                                if (!couponCode) {
                                    throw new Error("You should provide a non null couponCode");
                                }
                                if (!user.UID) {
                                    throw new Error("You should provide a non null uid");
                                }
                                couponVerificationURL = "".concat(fido_1.fido.getBaseUrl("coupons"), "/platforms/").concat(fido_1.fido.get("platformCode"), "/users/").concat(user.UID, "/coupons");
                                userHeaders = (0, securityHeaderBuilder_1.getGigyaUserHeader)(user);
                                receipt = null;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    _this.fetch(couponVerificationURL, {
                                        method: "POST",
                                        headers: userHeaders,
                                        body: {
                                            code: couponCode
                                        }
                                    })
                                ];
                            case 2:
                                receipt = _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                e = _state.sent();
                                status = e.status;
                                return [
                                    2,
                                    {
                                        status: status === 400 ? freemium_constants_1.couponStatus.ALREADY_USED : freemium_constants_1.couponStatus.INVALID
                                    }
                                ];
                            case 4:
                                return [
                                    4,
                                    _this.validateSubscriptionWithReceipt(receipt, user, {
                                        headers: userHeaders
                                    }).catch(function() {
                                        return null;
                                    })
                                ];
                            case 5:
                                result = _state.sent();
                                return [
                                    2,
                                    {
                                        status: freemium_constants_1.couponStatus.VALID,
                                        subscribedPlanCode: (0, get_1.default)(result, "subscribed_pack.code", null)
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getOffers",
            value: /**
     * Get the freemium Offer list
     * @async
     * @deprecated use Premium.getOffers instead
     */ function getOffers() {
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        _this.checkInit();
                        return [
                            2,
                            _this.fetch("https://static.6cloud.fr/m6group_web/6play/".concat(fido_1.fido.get("customerCode"), "/subscription/plans.json"))
                        ];
                    });
                })();
            }
        },
        {
            key: "getOffersFromLocalServer",
            value: // WARNING: Test method while there is no middleware route to make the job for us
            function getOffersFromLocalServer() {
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        _this.checkInit();
                        return [
                            2,
                            _this.fetch("".concat(window.location.origin, "/get-offers"))
                        ];
                    });
                })();
            }
        }
    ]);
    return FreemiumService;
}(fetcherService_1.FetcherService);
exports.FreemiumService = FreemiumService;
__decorate([
    withJWT_1.withJWT,
    caching_1.withNoParallelRequest,
    monitoring
], FreemiumService.prototype, "getUserSubscriptions", null);
__decorate([
    monitoring
], FreemiumService.prototype, "validateSubscriptionWithReceipt", null);
__decorate([
    monitoring
], FreemiumService.prototype, "verifyCoupon", null);
__decorate([
    monitoring
], FreemiumService.prototype, "getOffers", null);
exports.freemiumService = new FreemiumService();


/***/ }),

/***/ 21278:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(52318);
var __decorate = (void 0) && (void 0).__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.qualifioService = exports.QualifioService = void 0;
var fetcherService_1 = __webpack_require__(96571);
var withMonitoring_1 = __webpack_require__(97982);
var monitoring = (0, withMonitoring_1.withMonitoring)("qualifio");
/**
 * @module Qualifio
 * @description The Qualifio service is used to get data from Qualifio
 * @tutorial ./doc/qualifio.md
 */ var QualifioService = /*#__PURE__*/ function(_fetcherService_1_FetcherService) {
    _inherits._(QualifioService, _fetcherService_1_FetcherService);
    var _super = _create_super._(QualifioService);
    function QualifioService() {
        _class_call_check._(this, QualifioService);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.apiType = "qualifio";
        return _this;
    }
    _create_class._(QualifioService, [
        {
            /**
     * Initialize the service. If you don't call this method, no other method can be called.
     * @tutorial ./doc/qualifioInit.md
     */ key: "init",
            value: function init() {
                if (!this.isInitialized) {
                    this.isInitialized = true;
                }
            }
        },
        {
            /**
     * Get the data from Qualifio API.
     *
     * @async
     * @param {Object} options parameters (campaignKey, clientId, headers)
     * @returns {Object} The JSON feed
     * @tutorial ./doc/fetchQualifioContests.md
     */ key: "fetchQualifioContests",
            value: function fetchQualifioContests(param) {
                var campaignKey = param.campaignKey, clientId = param.clientId, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                if (!campaignKey || !clientId) {
                    throw new Error("You should provide a campaign key and a client id");
                }
                var endpoint = "campaignfeed/channels/".concat(campaignKey, "/json?clientId=").concat(clientId);
                var route = this.getRouteUrl(endpoint);
                return this.fetch(route, {
                    method: "GET",
                    headers: headers
                });
            }
        }
    ]);
    return QualifioService;
}(fetcherService_1.FetcherService);
exports.QualifioService = QualifioService;
__decorate([
    monitoring
], QualifioService.prototype, "fetchQualifioContests", null);
exports.qualifioService = new QualifioService();


/***/ }),

/***/ 82556:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _get = __webpack_require__(60528);
var _get_prototype_of = __webpack_require__(35196);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(45538);
var __decorate = (void 0) && (void 0).__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.geoService = void 0;
var withDeviceHeaders_1 = __webpack_require__(13496);
var simpleFetcherService_1 = __webpack_require__(33415);
/**
 * @module Geo
 * @augments SimpleFetcherService
 * @description The Geo service is used to retrieve the geolocation data from the client.
 * @tutorial ./doc/geo.md
 */ var GeoService = /*#__PURE__*/ function(_simpleFetcherService_1_SimpleFetcherService) {
    _inherits._(GeoService, _simpleFetcherService_1_SimpleFetcherService);
    var _super = _create_super._(GeoService);
    function GeoService() {
        _class_call_check._(this, GeoService);
        return _super.apply(this, arguments);
    }
    _create_class._(GeoService, [
        {
            key: "fetch",
            value: function fetch(options) {
                return _get._(_get_prototype_of._(GeoService.prototype), "fetch", this).call(this, options);
            }
        }
    ]);
    return GeoService;
}(simpleFetcherService_1.SimpleFetcherService);
__decorate([
    withDeviceHeaders_1.withDeviceHeaders
], GeoService.prototype, "fetch", null);
exports.geoService = new GeoService("geo", "geoInfo");


/***/ }),

/***/ 18537:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(42578);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.getUserConfiguration = exports.isLiveSession = void 0;
var fido_1 = __webpack_require__(19322);
var isLiveSession = function(clipType) {
    try {
        return [
            "live",
            "startover"
        ].includes(clipType);
    } catch (_a) {
        throw new Error("Something is wrong with the clipType");
    }
};
exports.isLiveSession = isLiveSession;
var getUserConfiguration = function(user) {
    if (user && user.UID) {
        return {
            uid: user.UID,
            uidType: "gigya"
        };
    }
    return {
        uid: fido_1.fido.get("localDeviceId"),
        uidType: "deviceid"
    };
};
exports.getUserConfiguration = getUserConfiguration;


/***/ }),

/***/ 72440:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(45538);
var __decorate = (void 0) && (void 0).__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.heartbeatService = void 0;
var fido_1 = __webpack_require__(19322);
var syncFetch_1 = __webpack_require__(49721);
var withJWT_1 = __webpack_require__(56282);
var tokenService_1 = __webpack_require__(96625);
var fetcherService_1 = __webpack_require__(96571);
var withMonitoring_1 = __webpack_require__(97982);
var heartbeat_utils_1 = __webpack_require__(18537);
var monitoring = (0, withMonitoring_1.withMonitoring)("heartbeat");
/**
 * @module Heartbeat
 * @description The Heartbeat service is used to monitor the user's video consumption.
 * @tutorial ./doc/heartbeat.md
 */ var HeartbeatService = /*#__PURE__*/ function(_fetcherService_1_FetcherService) {
    _inherits._(HeartbeatService, _fetcherService_1_FetcherService);
    var _super = _create_super._(HeartbeatService);
    function HeartbeatService() {
        _class_call_check._(this, HeartbeatService);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.apiType = "heartbeatv2";
        return _this;
    }
    _create_class._(HeartbeatService, [
        {
            /**
     * Initialize the service. If you don't call this method, no other method can be called.
     *
     * @tutorial ./doc/heartbeatInit.md
     */ key: "init",
            value: function init() {
                if (!this.isInitialized) {
                    this.isInitialized = true;
                    this.basePath = "platforms/".concat(fido_1.fido.get("platformCode"), "/notify");
                    this.platformCode = fido_1.fido.get("platformCode");
                    this.monitoring = monitoring;
                }
            }
        },
        {
            /**
     * Start Heartbeat session for a given program/clip.
     *
     * @async
     * @param {Object} options like { sessionData, user, headers } where sessionData as described in [docs](https://integrateur-6play.m6web.fr/v2/doc_users-resume-video.html), user A Gigya user => `{ UID, UIDSignature, signatureTimestamp }`, headers of the request.
     * @returns {Promise} Resolving as an object with sessionId and sendView as properties.
     * @tutorial ./doc/heartbeatSession.md
     */ key: "createSession",
            value: function createSession() {
                var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_sessionData = _ref.sessionData, sessionData = _ref_sessionData === void 0 ? null : _ref_sessionData, _ref_user = _ref.user, user = _ref_user === void 0 ? null : _ref_user, _ref_headers = _ref.headers, headers = _ref_headers === void 0 ? {} : _ref_headers;
                var _this = this;
                if (!sessionData || !sessionData.clipType) {
                    throw new Error("You should provide a non null sessionData");
                }
                var isLive = (0, heartbeat_utils_1.isLiveSession)(sessionData.clipType);
                var endpoint = "session".concat(isLive ? "_live" : "");
                var url = this.getRouteUrl(endpoint);
                var body = Object.assign(Object.assign({
                    platformCode: this.platformCode
                }, (0, heartbeat_utils_1.getUserConfiguration)(user)), sessionData);
                return this.fetch(url, {
                    method: "POST",
                    body: body,
                    headers: headers
                }).then(function(param) {
                    var sessionId = param.sessionId;
                    return {
                        sessionId: sessionId,
                        sendView: _this.sendView({
                            user: user,
                            isLive: isLive,
                            sessionId: sessionId
                        })
                    };
                });
            }
        },
        {
            /**
     * Send view data to Heartbeat for a given session;
     *
     * @async
     * @param {Object} options like { user, isLive, sessionId, headers } user A Gigya user => `{ UID, UIDSignature, signatureTimestamp }`, isLive Whether the session is live, sessionId  The id for this heartbeat session, headers of the request.
     * @returns {Function} That triggers the http call to heartbeat view API.
     * @tutorial ./doc/heartbeatSendView.md
     */ key: "sendView",
            value: function sendView() {
                var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_user = _ref.user, user = _ref_user === void 0 ? null : _ref_user, _ref_isLive = _ref.isLive, isLive = _ref_isLive === void 0 ? false : _ref_isLive, _ref_sessionId = _ref.sessionId, sessionId = _ref_sessionId === void 0 ? null : _ref_sessionId;
                if (typeof isLive !== "boolean" || !sessionId) {
                    throw new Error("Something went wrong during the session creation");
                }
                var _this = this;
                return function() {
                    var _ref = _async_to_generator._(function(viewData) {
                        var isSync, endpoint, url, body, token, headers, urlWithHeaders, formData;
                        var _arguments = arguments;
                        return _ts_generator._(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    isSync = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : false;
                                    if (!viewData) {
                                        throw new Error("You should provide a non null viewData");
                                    }
                                    endpoint = "view".concat(isLive ? "_live" : "");
                                    url = _this.getRouteUrl(endpoint);
                                    body = Object.assign(Object.assign(Object.assign({
                                        platformCode: _this.platformCode
                                    }, (0, heartbeat_utils_1.getUserConfiguration)(user)), viewData), {
                                        sessionId: sessionId
                                    });
                                    return [
                                        4,
                                        tokenService_1.tokenService.getToken()
                                    ];
                                case 1:
                                    token = _state.sent();
                                    headers = {
                                        Authorization: "Bearer ".concat(token)
                                    };
                                    if (isSync) {
                                        if (navigator.sendBeacon && window.FormData && typeof window.URL === "function") {
                                            urlWithHeaders = new URL(url);
                                            urlWithHeaders.searchParams.append("authorization", token);
                                            urlWithHeaders.searchParams.append("customerName", fido_1.fido.get("customerCode"));
                                            urlWithHeaders.searchParams.append("clientRelease", fido_1.fido.get("appVersion"));
                                            formData = new FormData();
                                            Object.keys(body).forEach(function(key) {
                                                return formData.append(key, body[key]);
                                            });
                                            return [
                                                2,
                                                navigator.sendBeacon(urlWithHeaders.href, formData)
                                            ];
                                        }
                                        return [
                                            2,
                                            (0, syncFetch_1.fetchSync)(url, body, headers)
                                        ];
                                    }
                                    return [
                                        2,
                                        _this.monitoring(HeartbeatService.prototype, "sendView", {
                                            value: function() {
                                                return _this.fetch(url, {
                                                    method: "POST",
                                                    body: body,
                                                    headers: headers
                                                });
                                            }
                                        }).value()
                                    ];
                            }
                        });
                    });
                    return function(viewData) {
                        return _ref.apply(this, arguments);
                    };
                }();
            }
        }
    ]);
    return HeartbeatService;
}(fetcherService_1.FetcherService);
__decorate([
    withJWT_1.withJWT,
    monitoring
], HeartbeatService.prototype, "createSession", null);
exports.heartbeatService = new HeartbeatService();


/***/ }),

/***/ 98566:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
var __decorate = (void 0) && (void 0).__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.heartbeatServiceV3 = void 0;
var fido_1 = __webpack_require__(19322);
var syncFetch_1 = __webpack_require__(49721);
var withJWT_1 = __webpack_require__(56282);
var tokenService_1 = __webpack_require__(96625);
var fetcherService_1 = __webpack_require__(96571);
var withMonitoring_1 = __webpack_require__(97982);
var monitoring = (0, withMonitoring_1.withMonitoring)("heartbeat");
/**
 * @module Heartbeat
 * @description The Heartbeat service is used to monitor the user's video consumption.
 * @tutorial ./doc/heartbeat.md
 */ var HeartbeatService = /*#__PURE__*/ function(_fetcherService_1_FetcherService) {
    _inherits._(HeartbeatService, _fetcherService_1_FetcherService);
    var _super = _create_super._(HeartbeatService);
    function HeartbeatService() {
        _class_call_check._(this, HeartbeatService);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.apiType = "heartbeatv3";
        return _this;
    }
    _create_class._(HeartbeatService, [
        {
            /**
     * Initialize the service. If you don't call this method, no other method can be called.
     *
     * @tutorial ./doc/heartbeatInit.md
     */ key: "init",
            value: function init() {
                if (!this.isInitialized) {
                    this.isInitialized = true;
                    this.basePath = "".concat(fido_1.fido.get("customerCode"), "/").concat(fido_1.fido.get("platformCode"));
                }
            }
        },
        {
            key: "videoStart",
            value: /**
     * Start Heartbeat session for a given program/clip.
     *
     * @async
     * @param {Object} options like { layoutData, metrics, headers } where layoutData as described in [docs](https://integrateur-6play.m6web.fr/v3/openapi/index.html?urls.primaryName=heartbeat-v3#/heartbeat/post__customerCode___platformCode__video_start), user A Gigya user => `{ UID, UIDSignature, signatureTimestamp }`, headers of the request.
     * @returns {Promise} Resolving as an object with refToken and polling as properties. "polling" is the number of seconds on which we'll base he polling. "refToken" needs to be sent back with each following calls, to identify the session.
     * @tutorial ./doc/heartbeatVideoStart.md
     */ function videoStart() {
                var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_layoutData = _ref.layoutData, layoutData = _ref_layoutData === void 0 ? null : _ref_layoutData, _ref_metrics = _ref.metrics, metrics = _ref_metrics === void 0 ? {} : _ref_metrics, _ref_headers = _ref.headers, headers = _ref_headers === void 0 ? {} : _ref_headers;
                var _this = this;
                return _async_to_generator._(function() {
                    var _sourceType, body, url;
                    return _ts_generator._(this, function(_state) {
                        if (!layoutData || !layoutData.contentType) {
                            throw new Error("You should provide a non null contentType");
                        }
                        /*
         * There is a break between layout and heartbeat. In Layout the sourceType for vod is 'video', and in heartbeat it's 'vod'.
         * A fix is currently in review, and will be merged within the week. This line should be removed
         */ _sourceType = layoutData.contentType === "live" ? layoutData.contentType : "vod";
                        body = Object.assign({
                            sourceType: _sourceType,
                            playerContext: _this.createPlayerContext(metrics)
                        }, layoutData);
                        url = _this.getServiceRouteUrl(_this.basePath, "video_start");
                        return [
                            2,
                            _this.fetch(url, {
                                method: "POST",
                                body: body,
                                headers: headers
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "videoConsuming",
            value: /**
     * Send view data to Heartbeat for a given session
     * Data can be sent with sync beacon API, if no response is needed.
     *
     * @async
     * @param {Object} options like { eventType, refToken, timecode, metrics, headers, isSync } where refToken is the data sent back from videoStart call. user A Gigya user => `{ UID, UIDSignature, signatureTimestamp }`, isLive Whether the session is live, sessionId  The id for this heartbeat session, headers of the request.
     * @returns {Promise} That triggers the http call to heartbeat view API.
     * @tutorial ./doc/heartbeatSendView.md
     */ function videoConsuming() {
                var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, eventType = _ref.eventType, refToken = _ref.refToken, timecode = _ref.timecode, metrics = _ref.metrics, _ref_headers = _ref.headers, headers = _ref_headers === void 0 ? {} : _ref_headers, _ref_isSync = _ref.isSync, isSync = _ref_isSync === void 0 ? false : _ref_isSync;
                var _this = this;
                return _async_to_generator._(function() {
                    var body, url, token, urlWithHeaders, formData;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!refToken) {
                                    throw new Error("You should create a session with videoStart before sending events");
                                }
                                body = {
                                    playerContext: _this.createPlayerContext(metrics),
                                    refToken: refToken,
                                    timecode: timecode
                                };
                                url = _this.getServiceRouteUrl(_this.basePath, "video_consuming/".concat(eventType));
                                if (!isSync) {
                                    return [
                                        2,
                                        _this.fetch(url, {
                                            method: "POST",
                                            body: body,
                                            headers: headers
                                        })
                                    ];
                                }
                                if (!navigator.sendBeacon || !window.FormData || typeof window.URL !== "function") {
                                    return [
                                        2,
                                        (0, syncFetch_1.fetchSync)(url, body, headers)
                                    ];
                                }
                                return [
                                    4,
                                    tokenService_1.tokenService.getToken()
                                ];
                            case 1:
                                token = _state.sent();
                                urlWithHeaders = new URL(url);
                                urlWithHeaders.searchParams.append("authorization", token);
                                urlWithHeaders.searchParams.append("customerName", fido_1.fido.get("customerCode"));
                                urlWithHeaders.searchParams.append("clientRelease", fido_1.fido.get("appVersion"));
                                formData = new FormData();
                                formData.append("body", JSON.stringify(body));
                                return [
                                    2,
                                    navigator.sendBeacon(urlWithHeaders.href, formData)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "createPlayerContext",
            value: function createPlayerContext(metrics) {
                return Object.assign({
                    bandwidth: 0,
                    bitrate: 0,
                    bufferSize: 0,
                    droppedFrames: 0,
                    resolution: 0
                }, metrics);
            }
        },
        {
            key: "getServiceRouteUrl",
            value: function getServiceRouteUrl() {
                var basePath = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", endpoint = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", clientCode = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : fido_1.fido.get("clientCode");
                this.checkInit();
                if (!this.apiType) {
                    throw new Error("You should define an API type for Fido's ".concat(this.getName()));
                }
                return "".concat(fido_1.fido.getBaseUrl(this.apiType).replace("%(clientCode)s", clientCode), "/").concat(basePath, "/").concat(endpoint);
            }
        }
    ]);
    return HeartbeatService;
}(fetcherService_1.FetcherService);
__decorate([
    withJWT_1.withJWT,
    monitoring
], HeartbeatService.prototype, "videoStart", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], HeartbeatService.prototype, "videoConsuming", null);
exports.heartbeatServiceV3 = new HeartbeatService();


/***/ }),

/***/ 38401:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _class_call_check = __webpack_require__(67818);
var _inherits = __webpack_require__(71648);
var _wrap_native_super = __webpack_require__(69349);
var _create_super = __webpack_require__(6400);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(37815);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.GigyaFormatError = exports.GigyaTimeoutError = void 0;
/* eslint-disable max-classes-per-file */ var GigyaTimeoutError = /*#__PURE__*/ function(Error1) {
    _inherits._(GigyaTimeoutError, Error1);
    var _super = _create_super._(GigyaTimeoutError);
    function GigyaTimeoutError(message) {
        _class_call_check._(this, GigyaTimeoutError);
        var _this;
        _this = _super.call(this);
        _this.name = _this.constructor.name;
        _this.message = "GigyaTimeoutError: ".concat(message || "unknown error");
        _this.stack = new Error().stack;
        return _this;
    }
    return GigyaTimeoutError;
}(_wrap_native_super._(Error));
exports.GigyaTimeoutError = GigyaTimeoutError;
var GigyaFormatError = /*#__PURE__*/ function(Error1) {
    _inherits._(GigyaFormatError, Error1);
    var _super = _create_super._(GigyaFormatError);
    function GigyaFormatError(message) {
        _class_call_check._(this, GigyaFormatError);
        var _this;
        _this = _super.call(this);
        _this.name = _this.constructor.name;
        _this.message = "GigyaFormatError: ".concat(message || "unknown error");
        _this.stack = new Error().stack;
        return _this;
    }
    return GigyaFormatError;
}(_wrap_native_super._(Error));
exports.GigyaFormatError = GigyaFormatError;


/***/ }),

/***/ 3422:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _assert_this_initialized = __webpack_require__(99561);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _wrap_native_super = __webpack_require__(69349);
var _create_super = __webpack_require__(6400);
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(65759);
var __importDefault = (void 0) && (void 0).__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.IAMError = void 0;
var values_1 = __importDefault(__webpack_require__(61017));
var IAMError = /*#__PURE__*/ function(Error1) {
    _inherits._(IAMError, Error1);
    var _super = _create_super._(IAMError);
    function IAMError(message, extraData, code, listErrors) {
        _class_call_check._(this, IAMError);
        var _this;
        _this = _super.call(this);
        _this.message = message;
        if (typeof Error.captureStackTrace === "function") {
            Error.captureStackTrace(_assert_this_initialized._(_this), _this.constructor);
        } else {
            _this.stack = new Error(_this.message).stack;
        }
        _this.extraData = extraData;
        _this.code = code;
        _this.listErrors = listErrors;
        return _this;
    }
    _create_class._(IAMError, null, [
        {
            key: "create",
            value: function create(request, response, additionalInfo) {
                var listErrors = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [];
                var message = response.errorMessage || "Gigya API error";
                var errorGigya = listErrors.find(function(error) {
                    return IAMError.isGigyaError(error.errorCode);
                });
                [
                    "password",
                    "secret"
                ].forEach(function(key) {
                    if (request.params) {
                        request.params[key] = "hidden";
                    }
                });
                var extraData = {
                    request: request,
                    response: errorGigya ? Object.assign(Object.assign({}, response), {
                        errorCode: errorGigya.errorCode.toString()
                    }) : response,
                    additionalInfo: additionalInfo
                };
                return new IAMError(message, extraData, response.errorCode, listErrors);
            }
        }
    ]);
    return IAMError;
}(_wrap_native_super._(Error));
exports.IAMError = IAMError;
IAMError.errorCodes = {
    CODE_ACCOUNT_PENDING_REGISTRATION: "206001",
    CODE_OPERATION_CANCELED: "200001",
    CODE_UNIQUE_IDENTIFIER_EXISTS: "400003",
    CODE_INVALID_LOGIN_ID: "403042",
    CODE_LOGIN_IDENTIFIER_EXISTS: "403043",
    CODE_LOGIN_IDENTIFIER_DOESNT_EXISTS: "403047"
};
IAMError.errorCodesArray = (0, values_1.default)(IAMError.errorCodes);
IAMError.isGigyaError = function(errorCode) {
    return IAMError.errorCodesArray.includes(errorCode.toString());
};
IAMError.reject = function(request, response, additionalInfo) {
    var listErrors = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [];
    return Promise.reject(IAMError.create(request, response, additionalInfo, listErrors));
};


/***/ }),

/***/ 346:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
var __decorate = (void 0) && (void 0).__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (void 0) && (void 0).__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.iamService = exports.IAMService = void 0;
var get_1 = __importDefault(__webpack_require__(65439));
var fido_1 = __webpack_require__(19322);
var withMonitoring_1 = __webpack_require__(97982);
var gigya_errors_1 = __webpack_require__(38401);
var iam_error_1 = __webpack_require__(3422);
var utils_1 = __webpack_require__(1939);
var monitoring = (0, withMonitoring_1.withMonitoring)("iam");
/**
 * @module IAM Identity Access Management
 * @description The IAM Service is used to interact with our IAM service provider to manage end-user authentication
 * @tutorial ./doc/iam.md
 */ var IAMService = /*#__PURE__*/ function() {
    function IAMService() {
        _class_call_check._(this, IAMService);
        this.isInitialized = false;
        this.options = {
            httpUserTokenMaxAge: 14400000
        };
        this.state = {
            currentUserInfo: null,
            lastLoginCall: null
        };
    }
    _create_class._(IAMService, [
        {
            key: "handleGigyaResponse",
            value: function handleGigyaResponse(sdkFunction, args) {
                return Promise.race([
                    new Promise(function(resolve, reject) {
                        sdkFunction(Object.assign(Object.assign({}, args), {
                            callback: (0, utils_1.handleCallbackRequest)(resolve, reject)
                        }));
                    }),
                    new Promise(function(_, reject) {
                        return setTimeout(function() {
                            return reject(new gigya_errors_1.GigyaTimeoutError("Timeout in handleGigyaResponse"));
                        }, fido_1.fido.get("waitTimeout"));
                    })
                ]);
            }
        },
        {
            /**
     * Initialize the service.
     *
     * @param {Object} sdk Gigya SDK
     * @param {Object} options Contains a set of options to be applied when calling some methods of the service
     * @tutorial ./doc/iamInit.md
     */ key: "init",
            value: function init(sdk) {
                var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                this.sdk = sdk;
                this.options = Object.assign(Object.assign({}, this.options), options);
                this.isInitialized = !!this.sdk;
            }
        },
        {
            /**
     * Set the options to be applied when calling some methods of the service
     *
     * @param {Object} options
     * @tutorial ./doc/iamSetOptions.md
     */ key: "setOptions",
            value: function setOptions() {
                var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                this.options = Object.assign(Object.assign({}, this.options), options);
            }
        },
        {
            /**
     * @private
     */ key: "hasLoginToken",
            value: function hasLoginToken() {
                return (0, utils_1.hasCookie)(this.options.loginTokenCookieName);
            }
        },
        {
            key: "login",
            value: /**
     * Login an user
     *
     * @async
     * @param {string} loginID The login identifier to use, can be an email
     * @param {string} password Password of the user
     * @tutorial ./doc/iamLogin.md
     * @returns {UserInfo}
     */ function login(loginID, password) {
                var _this = this;
                return _async_to_generator._(function() {
                    var userInfo;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.handleGigyaResponse(_this.sdk.accounts.login, {
                                        loginID: loginID,
                                        password: password,
                                        include: _this.options.include,
                                        ignoreInterruptions: true
                                    })
                                ];
                            case 1:
                                userInfo = _state.sent();
                                if (!userInfo || !userInfo.UID) {
                                    throw new gigya_errors_1.GigyaFormatError("Error during login, no UID in response");
                                }
                                _this.storeUserInfo(userInfo);
                                return [
                                    2,
                                    userInfo
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
     * Verify the correctness of a password
     *
     * @async
     * @param {string} password Password
     * @tutorial ./doc/iamVerifyPassword.md
     */ key: "verifyPassword",
            value: function verifyPassword(password) {
                return this.handleGigyaResponse(this.sdk.accounts.login, {
                    password: password,
                    loginMode: "reAuth"
                });
            }
        },
        {
            key: "autoConnect",
            value: /**
     * Auto-connect an user
     *
     * @async
     * @tutorial ./doc/iamAutoConnect.md
     * @returns {UserInfo}
     */ function autoConnect() {
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        if (!_this.hasLoginToken()) {
                            return [
                                2,
                                null
                            ];
                        }
                        return [
                            2,
                            _this.getUpdatedUserInfo()
                        ];
                    });
                })();
            }
        },
        {
            key: "getUpdatedUserInfo",
            value: /**
     * Recall gigya to check new user info that can change, for ex.: `isVerified`
     *
     * @returns Get updated user info
     */ function getUpdatedUserInfo() {
                var _this = this;
                return _async_to_generator._(function() {
                    var userInfo;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.handleGigyaResponse(_this.sdk.accounts.getAccountInfo, {
                                        include: _this.options.include
                                    })
                                ];
                            case 1:
                                userInfo = _state.sent();
                                /**
         * User with a proper UID should always be defined in Gigya responses, otherwise it's a failure
         * https://help.sap.com/viewer/8b8d6fffe113457094a17701f63e3d6a/GIGYA/en-US/417de3e270b21014bbc5a10ce4041860.html
         */ if (!userInfo || !userInfo.UID) {
                                    throw new gigya_errors_1.GigyaFormatError("Error during autoConnect, no UID in response");
                                }
                                _this.storeUserInfo(userInfo);
                                return [
                                    2,
                                    userInfo
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
     * Logout an user
     *
     * @async
     * @tutorial ./doc/iamLogout.md
     */ key: "logout",
            value: function logout() {
                this.clearUserInfo();
                return this.handleGigyaResponse(this.sdk.accounts.logout, {});
            }
        },
        {
            /**
     * Ask to send the account verification code to the specified email
     *
     * @async
     * @param {string} email Email to send the verification code to
     * @tutorial ./doc/iamResendVerificationCode.md
     */ key: "resendVerificationCode",
            value: function resendVerificationCode(email) {
                return this.handleGigyaResponse(this.sdk.accounts.resendVerificationCode, {
                    email: email
                });
            }
        },
        {
            /**
     * @private
     */ key: "initRegistration",
            value: function initRegistration() {
                return this.handleGigyaResponse(this.sdk.accounts.initRegistration, {});
            }
        },
        {
            /**
     * @private
     */ key: "register",
            value: function register(regToken, email, password) {
                var data = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, profile = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
                return this.handleGigyaResponse(this.sdk.accounts.register, {
                    regToken: regToken,
                    email: email,
                    password: password,
                    profile: JSON.stringify(profile),
                    data: JSON.stringify(data),
                    finalizeRegistration: true
                });
            }
        },
        {
            /**
     * @private
     */ key: "finalizeRegistration",
            value: function finalizeRegistration(regToken) {
                return this.handleGigyaResponse(this.sdk.accounts.finalizeRegistration, {
                    regToken: regToken
                });
            }
        },
        {
            key: "registration",
            value: /**
     * Register an user into the IAM provider
     *
     * @async
     * @param {string} email Email
     * @param {string} password Password
     * @param {Object} data A set of useful information not directly linked to the user
     * @param {Object} profile User profile data
     * @tutorial ./doc/iamRegistration.md
     * @returns {UserInfo}
     */ function registration(email, password, data, profile) {
                var _this = this;
                return _async_to_generator._(function() {
                    var responseInitRegistration, responseRegister, errorResponse, errorResponseCode, resp, error, errorCode, isInvalidLogin;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    3,
                                    ,
                                    8
                                ]);
                                return [
                                    4,
                                    _this.initRegistration()
                                ];
                            case 1:
                                responseInitRegistration = _state.sent();
                                return [
                                    4,
                                    _this.register(responseInitRegistration.regToken, email, password, data, profile)
                                ];
                            case 2:
                                responseRegister = _state.sent();
                                _this.storeUserInfo(responseRegister);
                                return [
                                    2,
                                    Object.assign({
                                        action: "REGISTRATION"
                                    }, responseRegister)
                                ];
                            case 3:
                                errorResponse = _state.sent();
                                errorResponseCode = (0, get_1.default)(errorResponse, "extraData.response.errorCode");
                                if (!(iam_error_1.IAMError.errorCodes.CODE_UNIQUE_IDENTIFIER_EXISTS === errorResponseCode)) return [
                                    3,
                                    7
                                ];
                                _state.label = 4;
                            case 4:
                                _state.trys.push([
                                    4,
                                    6,
                                    ,
                                    7
                                ]);
                                return [
                                    4,
                                    _this.login(email, password)
                                ];
                            case 5:
                                resp = _state.sent();
                                return [
                                    2,
                                    resp
                                ];
                            case 6:
                                error = _state.sent();
                                errorCode = (0, get_1.default)(error, "extraData.response.errorCode");
                                isInvalidLogin = iam_error_1.IAMError.errorCodes.CODE_INVALID_LOGIN_ID === errorCode;
                                if (isInvalidLogin) {
                                    throw errorResponse;
                                }
                                throw error;
                            case 7:
                                throw errorResponse;
                            case 8:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "socialRegistration",
            value: /**
     * Social register an user into the IAM provider
     *
     * @async
     * @param {string} provider Social provider to use
     * @tutorial ./doc/iamRegistration.md
     */ function socialRegistration(provider) {
                var _this = this;
                return _async_to_generator._(function() {
                    var _ref, newUser, accountInfo;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    new Promise(function(resolve, reject) {
                                        _this.sdk.socialize.login({
                                            provider: provider,
                                            callback: (0, utils_1.handleCallbackRequest)(resolve, reject)
                                        });
                                    })
                                ];
                            case 1:
                                _ref = _state.sent(), newUser = _ref.user.newUser;
                                return [
                                    4,
                                    _this.autoConnect()
                                ];
                            case 2:
                                accountInfo = _state.sent();
                                return [
                                    2,
                                    Object.assign(Object.assign({}, accountInfo), {
                                        isNewUser: newUser
                                    })
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
     * Link a social account with a standard email account
     *
     * @async
     * @param {string} loginID The login identifier to use, can be an email
     * @param {string} password Password
     * @param {string} regToken Registration token issued when trying to link account
     * @tutorial ./doc/iamLinkSocialAccount.md
     */ key: "linkSocialAccount",
            value: function linkSocialAccount(loginID, password, regToken) {
                return this.handleGigyaResponse(this.sdk.accounts.linkAccounts, {
                    regToken: regToken,
                    loginID: loginID,
                    password: password
                });
            }
        },
        {
            /**
     * Set the user password to a new one if the previous was not known
     *
     * @async
     * @param {string} passwordResetToken Password reset token issued
     * @param {string} newPassword Password to be used
     * @tutorial ./doc/iamResetPassword.md
     */ key: "resetPassword",
            value: function resetPassword(passwordResetToken, newPassword) {
                return this.handleGigyaResponse(this.sdk.accounts.resetPassword, {
                    passwordResetToken: passwordResetToken,
                    newPassword: newPassword
                });
            }
        },
        {
            /**
     * Start the procedure to reset the password
     *
     * @async
     * @param {string} loginID The login identifier to use, can be an email
     * @tutorial ./doc/iamForgotPassword.md
     */ key: "forgotPassword",
            value: function forgotPassword(loginID) {
                return this.handleGigyaResponse(this.sdk.accounts.resetPassword, {
                    loginID: loginID
                });
            }
        },
        {
            /**
     * Update previous password with a new password
     *
     * @async
     * @param {string} password Password in use
     * @param {string} newPassword Password to be used
     * @tutorial ./doc/iamUpdatePassword.md
     */ key: "updatePassword",
            value: function updatePassword(password, newPassword) {
                return this.handleGigyaResponse(this.sdk.accounts.setAccountInfo, {
                    password: password,
                    newPassword: newPassword
                });
            }
        },
        {
            /**
     * Update account info for the connected user
     *
     * @async
     * @param {Object} data Data A set of useful information not directly linked to the user - OBJECT IN DATABASE WON'T BE MERGED
     * @param {Object} profile User profile data - OBJECT IN DATABASE WON'T BE MERGED
     * @param {Object[]} removeLoginEmails Subset of login emails to remove from the user
     * @tutorial ./doc/iamSetAccountInfo.md
     */ key: "setAccountInfo",
            value: function setAccountInfo() {
                var data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, profile = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, removeLoginEmails = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], regToken = arguments.length > 3 ? arguments[3] : void 0;
                return this.handleGigyaResponse(this.sdk.accounts.setAccountInfo, {
                    data: JSON.stringify(data),
                    profile: JSON.stringify(profile),
                    removeLoginEmails: removeLoginEmails.join(","),
                    regToken: regToken
                });
            }
        },
        {
            key: "isLoginAvailable",
            value: /**
     * Tell if a loginId is already registered into the IAM Provider
     *
     * @async
     * @param {string} loginID The login identifier to use, can be an email
     * @tutorial ./doc/iamIsLoginAvailable.md
     */ function isLoginAvailable(loginID) {
                var _this = this;
                return _async_to_generator._(function() {
                    var response;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.handleGigyaResponse(_this.sdk.accounts.isAvailableLoginID, {
                                        loginID: loginID
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                return [
                                    2,
                                    response.isAvailable
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
     * @private
     */ key: "isCurrentUserExpired",
            value: function isCurrentUserExpired() {
                if (!this.state.lastLoginCall || !this.state.currentUserInfo) {
                    return true;
                }
                var httpUserTokenMaxAge = this.options.httpUserTokenMaxAge;
                return Date.now() - this.state.lastLoginCall > httpUserTokenMaxAge;
            }
        },
        {
            /**
     * @private
     */ key: "storeUserInfo",
            value: function storeUserInfo(currentUserInfo) {
                this.state = {
                    currentUserInfo: currentUserInfo,
                    lastLoginCall: new Date()
                };
            }
        },
        {
            /**
     * @private
     */ key: "clearUserInfo",
            value: function clearUserInfo() {
                this.state = {
                    currentUserInfo: null,
                    lastLoginCall: null
                };
            }
        },
        {
            key: "getUser",
            value: /**
     * give the current user
     * if the user is not connected or info expired, it try the autoConnect
     *
     * @async
     * @returns {UserInfo}
     */ function getUser() {
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        if (_this.isCurrentUserExpired()) {
                            return [
                                2,
                                _this.autoConnect()
                            ];
                        }
                        return [
                            2,
                            _this.state.currentUserInfo
                        ];
                    });
                })();
            }
        },
        {
            key: "connectDevice",
            value: /**
     * Create a session on external device
     * https://help.sap.com/docs/SAP_CUSTOMER_DATA_CLOUD/8b8d6fffe113457094a17701f63e3d6a/417729f470b21014bbc5a10ce4041860.html?q=notifyLogin
     *
     * @param UID
     * @param UIDSignature
     * @param UIDSignatureTimestamp
     *
     * @async
     * @returns {Object}
     */ function connectDevice(param) {
                var UID = param.UID, UIDSignature = param.UIDSignature, signatureTimestamp = param.signatureTimestamp;
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.handleGigyaResponse(_this.sdk.socialize.notifyLogin, {
                                        siteUID: UID,
                                        UIDSig: UIDSignature,
                                        UIDTimestamp: signatureTimestamp,
                                        // -2 : it will prevent the expiration of the user
                                        sessionExpiration: -2
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2,
                                    _this.autoConnect()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "sendCode",
            value: /**
     * Send connection code in user mail box
     * @param {Object} param sendCode options
     * @param {string} param.apiKey gigya public api key
     * @param {string} param.email user email address
     * @param {string} param.lang language code
     *
     * @async
     * @returns {string} token use for verify code on the frontend
     */ function sendCode(param) {
                var apiKey = param.apiKey, email = param.email, lang = param.lang;
                var _this = this;
                return _async_to_generator._(function() {
                    var _ref, iamVerificationToken;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.handleGigyaResponse(_this.sdk.accounts.otp.sendCode, {
                                        apiKey: apiKey,
                                        email: email,
                                        lang: lang
                                    })
                                ];
                            case 1:
                                _ref = _state.sent(), iamVerificationToken = _ref.vToken;
                                return [
                                    2,
                                    iamVerificationToken
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "verifyCode",
            value: /**
     * Verify the code the user received by email
     * @param {Object} param verifyCode options
     * @param {string} param.iamVerificationToken token returned by sendCode method
     * @param {string} param.code code received in email for the user
     * @param {string} param.apiKey gigya public api key
     *
     * @async
     * @returns {boolean} true if the validation is successful
     */ function verifyCode(param) {
                var iamVerificationToken = param.iamVerificationToken, code = param.code, apiKey = param.apiKey;
                var _this = this;
                return _async_to_generator._(function() {
                    var status;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.handleGigyaResponse(_this.sdk.accounts.otp.update, {
                                        vToken: iamVerificationToken,
                                        code: code,
                                        apiKey: apiKey
                                    })
                                ];
                            case 1:
                                status = _state.sent().status;
                                return [
                                    2,
                                    status === "OK"
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return IAMService;
}();
exports.IAMService = IAMService;
__decorate([
    monitoring
], IAMService.prototype, "login", null);
__decorate([
    monitoring
], IAMService.prototype, "verifyPassword", null);
__decorate([
    monitoring
], IAMService.prototype, "getUpdatedUserInfo", null);
__decorate([
    monitoring
], IAMService.prototype, "logout", null);
__decorate([
    monitoring
], IAMService.prototype, "resendVerificationCode", null);
__decorate([
    monitoring
], IAMService.prototype, "initRegistration", null);
__decorate([
    monitoring
], IAMService.prototype, "register", null);
__decorate([
    monitoring
], IAMService.prototype, "finalizeRegistration", null);
__decorate([
    monitoring
], IAMService.prototype, "registration", null);
__decorate([
    monitoring
], IAMService.prototype, "socialRegistration", null);
__decorate([
    monitoring
], IAMService.prototype, "linkSocialAccount", null);
__decorate([
    monitoring
], IAMService.prototype, "resetPassword", null);
__decorate([
    monitoring
], IAMService.prototype, "forgotPassword", null);
__decorate([
    monitoring
], IAMService.prototype, "updatePassword", null);
__decorate([
    monitoring
], IAMService.prototype, "setAccountInfo", null);
__decorate([
    monitoring
], IAMService.prototype, "isLoginAvailable", null);
__decorate([
    monitoring
], IAMService.prototype, "connectDevice", null);
__decorate([
    monitoring
], IAMService.prototype, "sendCode", null);
__decorate([
    monitoring
], IAMService.prototype, "verifyCode", null);
exports.iamService = new IAMService();


/***/ }),

/***/ 1939:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(37815);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.hasCookie = exports.handleCallbackRequest = void 0;
var iam_error_1 = __webpack_require__(3422);
var handleCallbackRequest = function(resolve, reject) {
    return function(result) {
        var errorCode = result.errorCode, _result_validationErrors = result.validationErrors, validationErrors = _result_validationErrors === void 0 ? [] : _result_validationErrors;
        if (errorCode === 0) {
            return resolve(result);
        }
        validationErrors.push({
            errorCode: errorCode
        });
        return reject(iam_error_1.IAMError.create(result.requestParams, result, result.errorMessage, validationErrors));
    };
};
exports.handleCallbackRequest = handleCallbackRequest;
var hasCookie = function(cookieName) {
    if (document && document.cookie) {
        return document.cookie.includes(cookieName);
    }
    return false;
};
exports.hasCookie = hasCookie;


/***/ }),

/***/ 68074:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(88801);
var __importDefault = (void 0) && (void 0).__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.iconService = void 0;
var superagent_1 = __importDefault(__webpack_require__(54247));
var fetcherService_1 = __webpack_require__(96571);
/**
 * The Icon Service is used to fetch the icon manifest from app-bedrock-bundle.
 * @module Icon
 * @tutorial ./doc/icon.md
 */ var IconService = /*#__PURE__*/ function(_fetcherService_1_FetcherService) {
    _inherits._(IconService, _fetcherService_1_FetcherService);
    var _super = _create_super._(IconService);
    function IconService() {
        _class_call_check._(this, IconService);
        return _super.apply(this, arguments);
    }
    _create_class._(IconService, [
        {
            key: "init",
            value: function init() {
                this.isInitialized = true;
            }
        },
        {
            key: "fetchManifest",
            value: function fetchManifest(param) {
                var baseUrl = param.baseUrl;
                return _async_to_generator._(function() {
                    var url, _ref, manifest, _a;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = "".concat(baseUrl, "/manifest.json");
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    superagent_1.default.get(url)
                                ];
                            case 2:
                                _ref = _state.sent(), manifest = _ref.body;
                                return [
                                    2,
                                    manifest
                                ];
                            case 3:
                                _a = _state.sent();
                                return [
                                    2,
                                    {}
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return IconService;
}(fetcherService_1.FetcherService);
exports.iconService = new IconService();


/***/ }),

/***/ 49037:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.minimumWidthForAvifInPixels = exports.sizes = exports.ratios = exports.portraitSizes = exports.panoramicSizes = void 0;
/*
 * Those sizes are use as width of panoramic images. The height is calculated by dividing the width by the image ratio.
 * It will be used for all images with a ratio > 1.
 */ exports.panoramicSizes = [
    320,
    480,
    640,
    800,
    960,
    1120,
    1440,
    1760,
    2080,
    2560
];
/*
 * Those sizes are use as height of portrait images. The width is calculated by multiplying the height by the image ratio.
 * It will be used for all images with a ratio < 1.
 * Because the image API actually return an error if the image height is greater than 2048, we do not support taller images.
 */ exports.portraitSizes = [
    320,
    480,
    600,
    768,
    960,
    1080,
    1200,
    1440,
    1600,
    2048
];
exports.ratios = {
    "15:4": 15 / 4,
    "16:9": 16 / 9,
    "5:3": 5 / 3,
    "3:1": 3,
    "4:1": 4,
    "3:4": 3 / 4,
    "9:16": 9 / 16,
    "2:5": 2 / 5,
    "2:3": 2 / 3,
    "1:1": 1,
    default: 16 / 9
};
exports.sizes = {
    "15:4": exports.panoramicSizes,
    "16:9": exports.panoramicSizes,
    "5:3": exports.panoramicSizes,
    "3:1": exports.panoramicSizes,
    "4:1": exports.panoramicSizes,
    "3:4": exports.portraitSizes,
    "9:16": exports.portraitSizes,
    "2:5": exports.portraitSizes,
    "2:3": exports.portraitSizes,
    "1:1": exports.portraitSizes,
    default: exports.panoramicSizes
};
exports.minimumWidthForAvifInPixels = 1080;


/***/ }),

/***/ 6378:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _define_property = __webpack_require__(21228);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(42578);
var __importDefault = (void 0) && (void 0).__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.imageService = void 0;
var sha1_1 = __importDefault(__webpack_require__(99968));
var forEach_1 = __importDefault(__webpack_require__(17489));
var get_1 = __importDefault(__webpack_require__(65439));
var isInteger_1 = __importDefault(__webpack_require__(96789));
var map_1 = __importDefault(__webpack_require__(65512));
var omit_1 = __importDefault(__webpack_require__(59245));
var set_1 = __importDefault(__webpack_require__(35609));
var fido_1 = __webpack_require__(19322);
var queryParamSerializer_1 = __webpack_require__(19007);
var fetcherService_1 = __webpack_require__(96571);
var image_constants_1 = __webpack_require__(49037);
/**
 * The Image Service is used to build the URL of images on the 6play's platform.
 * @module Image
 * @tutorial ./doc/image.md
 */ var ImageService = /*#__PURE__*/ function(_fetcherService_1_FetcherService) {
    _inherits._(ImageService, _fetcherService_1_FetcherService);
    var _super = _create_super._(ImageService);
    function ImageService() {
        _class_call_check._(this, ImageService);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.apiType = "image";
        return _this;
    }
    _create_class._(ImageService, [
        {
            /**
     * Initialize the service.
     * @tutorial ./doc/imageInit.md
     */ key: "init",
            value: function init() {
                if (!this.isInitialized) {
                    this.basePath = "images";
                    this.isInitialized = true;
                }
            }
        },
        {
            /**
     * Return the formatted URL of the image.
     *
     * @param {string} id Image id.
     * @param {number} width Image width in pixels.
     * @param {number} height Image height in pixels.
     * @param {Object=} params Image params (ex: format, optimize, fit, ...). See [available parameters](https://integrateur-6play.m6web.fr/v2/doc_image.html).
     * @returns {string} Url of the image.
     * @tutorial ./doc/imageGetUrl.md
     */ key: "getUrl",
            value: function getUrl(id, width, height, params) {
                var integerId = parseInt(id, 10);
                if (!(0, isInteger_1.default)(integerId)) {
                    return "";
                }
                var rawUrl = this.getRouteUrl("".concat(integerId, "/raw"));
                var builtParams = Object.assign({
                    width: width,
                    height: height,
                    blur: 0,
                    fit: "scale_crop",
                    interlace: 1
                }, params);
                if (builtParams.optimize) {
                    delete builtParams.quality;
                } else if (!builtParams.quality) {
                    builtParams.optimize = builtParams.optimize || "high";
                }
                var defineImageFormat = function(imageParams) {
                    if (imageParams.width >= image_constants_1.minimumWidthForAvifInPixels) {
                        return "avif";
                    }
                    return "webp";
                };
                if (!builtParams.format) {
                    builtParams.auto = defineImageFormat(builtParams);
                }
                var queryString = (0, queryParamSerializer_1.serialize)(builtParams, function(param) {
                    var value = param.value;
                    return value || value === 0;
                });
                if (queryString) {
                    var path = this.getRoutePath("".concat(integerId, "/raw?").concat(queryString), true);
                    var hash = (0, sha1_1.default)("".concat(path).concat(fido_1.fido.get("imageSalt")));
                    return "".concat(rawUrl, "?").concat(queryString, "&hash=").concat(hash);
                }
                return rawUrl;
            }
        },
        {
            /**
     * Receives a ratio as a parameter (such as 0.459123), and returns the closest ratio from the list of predefined ratios that Fastly can handle.
     * The return value may then be passed to prepareImage as-is.
     * If no ratio was provided, the default ratio is used.
     *
     * @param {number} initialRatio The current ratio of the image.
     * @returns {string} The ratio to use when calling imageService.
     */ key: "findBestRatio",
            value: function findBestRatio() {
                var initialRatio = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : image_constants_1.ratios.default;
                return Object.keys(image_constants_1.ratios).reduce(function(prev, curr) {
                    return Math.abs(image_constants_1.ratios[curr] - initialRatio) < Math.abs(image_constants_1.ratios[prev] - initialRatio) ? curr : prev;
                });
            }
        },
        {
            key: "getSources",
            value: function getSources(id, ratio, params) {
                var _this = this;
                var sizeList = image_constants_1.sizes[ratio] || image_constants_1.sizes.default;
                return sizeList.reduce(function(acc, size) {
                    var tau = image_constants_1.ratios[ratio] || image_constants_1.ratios.default;
                    var width;
                    var height;
                    if (tau > 1) {
                        width = size;
                        height = Math.floor(size / tau);
                    } else {
                        width = Math.floor(size * tau);
                        height = size;
                    }
                    return Object.assign(Object.assign({}, acc), _define_property._({}, width, _this.getUrl(id, width, height, params)));
                }, {});
            }
        },
        {
            /**
     * Transform the image sub-object to an usable object within a HTML context. The latter will include `src` and `srcset` props which are calcuted based on the image's ratio.
     *
     * @param {Object} item Item to prepare.
     * @param {Object} options A key-value pairs object where key is the property name of the image item to prepare and value the params that service will use.
     * You can also use a lodash-type path like 'channel.image' or 'epgBox.0.image' as a key.
     * @param {Object} meta A key-value pairs object where meta props are passed to image object
     * @param {Boolean} withWebp when passed, it generates srcSetWebp for Item.
     * @returns {Object} Item with `src` and `srcset`.
     * @tutorial ./doc/imagePrepareItem.md
     */ key: "prepareItem",
            value: function prepareItem(item) {
                var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, meta = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, withWebp = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
                var _this = this;
                var itemContent = (0, get_1.default)(item, "itemContent", item);
                var preparedItem = Object.assign(Object.assign({}, itemContent), Object.keys(options).reduce(function(acc, key) {
                    var itemContentField = (0, get_1.default)(itemContent, key);
                    if (itemContentField) {
                        var option = (0, get_1.default)(options, key);
                        var imageOptions = (0, omit_1.default)(option, [
                            "rotating",
                            "rotatingOptions"
                        ]);
                        var image = _this.prepareImage(itemContentField, imageOptions);
                        if (withWebp) {
                            var imageWebp = _this.prepareImage(itemContentField, Object.assign(Object.assign({}, imageOptions), {
                                format: "webp"
                            }));
                            image.srcSetWebp = imageWebp.srcSet;
                        }
                        if (itemContentField.idsByRatio) {
                            image.srcSetsByRatio = {};
                            (0, forEach_1.default)(itemContentField.idsByRatio, function(id, ratio) {
                                image.srcSetsByRatio[ratio] = _this.prepareImage({
                                    id: id,
                                    ratio: ratio
                                }, imageOptions).srcSet;
                            });
                        }
                        if (option.rotating) {
                            var portrait = _this.prepareImage(Object.assign(Object.assign({}, itemContentField), {
                                ratio: "3:4"
                            }), Object.assign(Object.assign({}, imageOptions), (0, get_1.default)(option, "rotatingOptions", {})));
                            if (withWebp) {
                                var imageWebp1 = _this.prepareImage(Object.assign(Object.assign({}, itemContentField), {
                                    ratio: "3:4"
                                }), Object.assign(Object.assign(Object.assign({}, imageOptions), (0, get_1.default)(option, "rotatingOptions", {})), {
                                    format: "webp"
                                }));
                                portrait.srcSetWebp = imageWebp1.srcSet;
                            }
                            (0, set_1.default)(acc, key, {
                                landscape: image,
                                portrait: portrait
                            });
                        } else {
                            (0, set_1.default)(acc, key, image);
                        }
                        (0, set_1.default)(acc, key, Object.assign(Object.assign({}, (0, get_1.default)(acc, key)), meta));
                    }
                    return acc;
                }, {}));
                return Object.assign(Object.assign({}, preparedItem), {
                    itemContent: preparedItem
                });
            }
        },
        {
            key: "prepareImage",
            value: function prepareImage(param, params) {
                var id = param.id, _param_caption = param.caption, caption = _param_caption === void 0 ? "" : _param_caption, _param_ratio = param.ratio, ratio = _param_ratio === void 0 ? "16:9" : _param_ratio;
                var sources = this.getSources(id, ratio, params);
                return {
                    srcSet: (0, map_1.default)(sources, function(url, width) {
                        return "".concat(url, " ").concat(width, "w");
                    }).join(", "),
                    src: sources[Object.keys(sources)[0]],
                    caption: caption
                };
            }
        },
        {
            /**
     * Same as prepareItem but with an array of items.
     *
     * @param {Object[]} items Collection of items to prepare.
     * @param {Object} options A key-value pairs object where key is the property of the item to prepare and value the params that service will use.
     * @param {Object} meta A key-value pairs object where meta props are passed to image object
     * @param {Boolean} withWebp when passed, it generates srcSetWebp for each Item.
     * @returns {Object[]} Items with `src` and `srcset` defined.
     */ key: "prepareItems",
            value: function prepareItems(items, options) {
                var meta = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, withWebp = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
                var _this = this;
                return items.map(function(item) {
                    return _this.prepareItem(item, options, meta, withWebp);
                });
            }
        }
    ]);
    return ImageService;
}(fetcherService_1.FetcherService);
exports.imageService = new ImageService();


/***/ }),

/***/ 7846:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(65759);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.withLocationHeader = void 0;
var decorators_builder_1 = __webpack_require__(23004);
/**
 * A decorator which injects the header `X-Location`, which contains the current full URL (including query params).
 * It doesn't add the header if window is not defined.
 * @param {number} applyToArgument the argument in which it should be injected.
 */ var withLocationHeader = function() {
    var applyToArgument = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return (0, decorators_builder_1.createAddHeaderDecorator)(function() {
        if (typeof window === "undefined") return;
        /*
         * Note: If the usage expands outside of client side web app, it could be useful to have a config in
         * fido to provide the location value
         */ return {
            "X-Location": window.location.href
        };
    }, applyToArgument);
};
exports.withLocationHeader = withLocationHeader;


/***/ }),

/***/ 90995:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.appPages = exports.navigationTargets = exports.frontspaces = exports.aliases = exports.entities = void 0;
exports.entities = {
    service: "service",
    program: "program",
    folder: "folder",
    frontspace: "frontspace",
    alias: "alias",
    video: "video",
    audio: "audio",
    live: "live",
    radio: "radio",
    app: "app",
    season: "season",
    details: "details"
};
exports.aliases = {
    home: "home",
    kids: "kids"
};
exports.frontspaces = {
    bookmarks: "bookmarks",
    landing: "landing",
    offers: "offers",
    profilesgate: "profilesgate",
    search: "search",
    tvapppreview: "tvapppreview",
    screensaver: "screensaver",
    devicesmanagementcenter: "devicesmanagementcenter",
    devicesgate: "devicesgate",
    epggrid: "epggrid"
};
exports.navigationTargets = {
    desktop: "desktop",
    mobile: "mobile",
    smarttv: "smarttv",
    tv: "tv",
    tvwithoutlive: "tvwithoutlive",
    tvwithoutmax: "tvwithoutmax",
    webview: "webview"
};
exports.appPages = {
    account: "account",
    account_billing: "account_billing",
    account_bookmarks: "account_bookmarks",
    account_informations: "account_informations",
    account_legalconditions: "account_legalconditions",
    account_pairing: "account_pairing",
    account_newsletters: "account_newsletters",
    account_overview: "account_overview",
    account_parentalcontrol: "account_parentalcontrol",
    account_parentalfilter: "account_parentalfilter",
    account_profilesmanagement: "account_profilesmanagement",
    account_profilesmanagement_profilecreation: "account_profilesmanagement_profilecreation",
    account_preferences: "account_preferences",
    consentsmanagement_account: "consentsmanagement_account",
    consentsmanagement_device: "consentsmanagement_device",
    privacy_policy: "privacy_policy"
};


/***/ }),

/***/ 75156:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _get = __webpack_require__(60528);
var _get_prototype_of = __webpack_require__(35196);
var _inherits = __webpack_require__(71648);
var _to_consumable_array = __webpack_require__(30005);
var _create_super = __webpack_require__(6400);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(45538);
var __importDefault = (void 0) && (void 0).__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.layoutForThirdPartyService = void 0;
var get_1 = __importDefault(__webpack_require__(65439));
var isArray_1 = __importDefault(__webpack_require__(24669));
var map_1 = __importDefault(__webpack_require__(65512));
var merge_1 = __importDefault(__webpack_require__(67929));
var thirdPartyWithLayoutService_1 = __webpack_require__(90724);
var layoutService_1 = __webpack_require__(40547);
/**
 * @module LayoutForThirdParty
 * @augments LayoutService
 * @description Same as the Layout service but has to be used in combination with the ThirdPartyWithLayoutService to add layout custom attributes automatically to the third party requests.
 * It also prepares analytics data of each block items in the fetched layout.
 * @tutorial ./doc/layoutForThirdPartyService.md
 */ var LayoutForThirdPartyService = /*#__PURE__*/ function(_layoutService_1_LayoutService) {
    _inherits._(LayoutForThirdPartyService, _layoutService_1_LayoutService);
    var _super = _create_super._(LayoutForThirdPartyService);
    function LayoutForThirdPartyService() {
        _class_call_check._(this, LayoutForThirdPartyService);
        return _super.apply(this, arguments);
    }
    _create_class._(LayoutForThirdPartyService, [
        {
            /**
     * Set the initial layout to use good third party data for the first rendered page with SSR
     *
     * @param {Object} layout Initial layout data.
     */ key: "setInitialLayout",
            value: function setInitialLayout(layout) {
                thirdPartyWithLayoutService_1.thirdPartyWithLayoutService.waitForPromise(Promise.resolve(layout));
            }
        },
        {
            key: "resetLayoutPromise",
            value: function resetLayoutPromise() {
                thirdPartyWithLayoutService_1.thirdPartyWithLayoutService.waitForPromise(Promise.resolve());
            }
        },
        {
            key: "getAlternativeContentAnalytics",
            value: function getAlternativeContentAnalytics(block, blockAnalytics) {
                var alternativeContentAnalytics = (0, get_1.default)(block, "alternativeContent.analytics", {});
                return block.alternativeContent ? Object.assign(Object.assign({}, block.alternativeContent), {
                    analytics: (0, merge_1.default)({}, blockAnalytics, alternativeContentAnalytics),
                    concurrentBlocks: (0, get_1.default)(block, "alternativeContent.concurrentBlocks", []).map(function(alternativeBlock) {
                        return Object.assign(Object.assign({}, alternativeBlock), {
                            analytics: (0, merge_1.default)({}, blockAnalytics, alternativeContentAnalytics, (0, get_1.default)(alternativeBlock, "analytics"))
                        });
                    })
                }) : null;
            }
        },
        {
            key: "mapToBlock",
            value: function mapToBlock(block) {
                var blockAnalytics = (0, get_1.default)(block, "analytics", {});
                var getItemAnalytics = function(item) {
                    return (0, merge_1.default)({}, blockAnalytics, (0, get_1.default)(item, "analytics"));
                };
                var items = (0, get_1.default)(block, "content.items", []).map(function(item) {
                    var itemContent = (0, get_1.default)(item, "itemContent");
                    return Object.assign(Object.assign({}, item), {
                        bookmark: item.bookmark ? Object.assign(Object.assign({}, (0, get_1.default)(item, "bookmark", {})), {
                            analytics: (0, merge_1.default)({}, getItemAnalytics(item), (0, get_1.default)(item, "bookmark.analytics"))
                        }) : null,
                        itemContent: Object.assign(Object.assign({}, itemContent), {
                            bookmark: itemContent.bookmark ? Object.assign(Object.assign({}, (0, get_1.default)(itemContent, "bookmark", {})), {
                                analytics: (0, merge_1.default)({}, getItemAnalytics(itemContent), (0, get_1.default)(itemContent, "bookmark.analytics"))
                            }) : null
                        })
                    });
                });
                return Object.assign(Object.assign({}, block), {
                    content: Object.assign(Object.assign({}, (0, get_1.default)(block, "content")), {
                        items: items
                    })
                });
            }
        },
        {
            key: "mapEntriesV1",
            value: function mapEntriesV1(data) {
                return {
                    entries: (0, map_1.default)(data.entries, function(param) {
                        var entry = param.entry, subEntries = param.subEntries;
                        var entryAnalytics = (0, get_1.default)(entry, "target.analytics", {});
                        var getSubEntryAnalytics = function(object) {
                            return (0, merge_1.default)({}, entryAnalytics, (0, get_1.default)(object, "target.analytics"));
                        };
                        var itemSubEntries = subEntries.map(function(subEntry) {
                            return Object.assign(Object.assign({}, subEntry), {
                                target: Object.assign(Object.assign({}, subEntry.target), {
                                    analytics: getSubEntryAnalytics(subEntry)
                                }),
                                action: subEntry.action ? Object.assign(Object.assign({}, subEntry.action), {
                                    target: Object.assign(Object.assign({}, subEntry.target), {
                                        analytics: getSubEntryAnalytics(subEntry)
                                    })
                                }) : null
                            });
                        });
                        var actionList = itemSubEntries.map(function(subEntry) {
                            return Object.assign(Object.assign({}, subEntry), {
                                action: subEntry.action ? Object.assign(Object.assign({}, subEntry.action), {
                                    target: subEntry.target
                                }) : {
                                    target: subEntry.target
                                }
                            });
                        });
                        var target = Object.assign(Object.assign({}, entry.target), {
                            analytics: entryAnalytics
                        });
                        return {
                            entry: Object.assign(Object.assign({}, entry), {
                                target: target,
                                actionList: actionList
                            }),
                            subEntries: itemSubEntries
                        };
                    })
                };
            }
        },
        {
            /*
     * Link third party events with the layout fetching
     * Inject block analytics in each block item
     * DON'T USE ASYNC/AWAIT HERE WHILE https://github.com/babel/babel/pull/9939 ISN'T MERGED
     */ key: "fetchByEntity",
            value: function fetchByEntity() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var _this = this;
                var _$_get;
                return thirdPartyWithLayoutService_1.thirdPartyWithLayoutService.waitForPromise((_$_get = _get._(_get_prototype_of._(LayoutForThirdPartyService.prototype), "fetchByEntity", this)).call.apply(_$_get, [
                    this
                ].concat(_to_consumable_array._(args)))).then(function(data) {
                    return Object.assign(Object.assign({}, data), {
                        blocks: data.blocks.map(function(block) {
                            return _this.mapToBlock(block);
                        })
                    });
                });
            }
        },
        {
            /*
     * DON'T USE ASYNC/AWAIT HERE WHILE https://github.com/babel/babel/pull/9939 ISN'T MERGED
     * `thirdPartyWithLayoutService.waitForPromise` remove here because there is a conflict with `fetchByEntity`
     * In `fetchByEntity`, we wait the promise of `fetchBlockPage` and vice versa
     * Futhermore, we don't need to wait this promise
     * If we want to send a third party event because we can't send one before the promise be resolved
     */ key: "fetchBlockPage",
            value: function fetchBlockPage() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var _this = this;
                var _$_get;
                return (_$_get = _get._(_get_prototype_of._(LayoutForThirdPartyService.prototype), "fetchBlockPage", this)).call.apply(_$_get, [
                    this
                ].concat(_to_consumable_array._(args))).then(function(data) {
                    return _this.mapToBlock(data);
                });
            }
        },
        {
            /*
     * Link third party events with the layout fetching
     * Inject analytics in each entries and subEntries
     * DON'T USE ASYNC/AWAIT HERE WHILE https://github.com/babel/babel/pull/9939 ISN'T MERGED
     */ key: "fetchNavigation",
            value: function fetchNavigation() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var _this = this;
                var _$_get;
                return (_$_get = _get._(_get_prototype_of._(LayoutForThirdPartyService.prototype), "fetchNavigation", this)).call.apply(_$_get, [
                    this
                ].concat(_to_consumable_array._(args))).then(function(data) {
                    if ((0, isArray_1.default)(data)) {
                        return data;
                    }
                    return _this.mapEntriesV1(data);
                });
            }
        }
    ]);
    return LayoutForThirdPartyService;
}(layoutService_1.LayoutService);
exports.layoutForThirdPartyService = new LayoutForThirdPartyService();


/***/ }),

/***/ 40547:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(52318);
var __decorate = (void 0) && (void 0).__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (void 0) && (void 0).__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.layoutService = exports.LayoutService = void 0;
var get_1 = __importDefault(__webpack_require__(65439));
var includes_1 = __importDefault(__webpack_require__(44840));
var isEmpty_1 = __importDefault(__webpack_require__(82691));
var set_1 = __importDefault(__webpack_require__(35609));
var fido_1 = __webpack_require__(19322);
var queryParamSerializer_1 = __webpack_require__(19007);
var retryRequest_1 = __webpack_require__(26040);
var withJWT_1 = __webpack_require__(56282);
var fetcherService_1 = __webpack_require__(96571);
var withMonitoring_1 = __webpack_require__(97982);
var withLocationDecorator_1 = __webpack_require__(7846);
var layout_constants_1 = __webpack_require__(90995);
var monitoring = (0, withMonitoring_1.withMonitoring)("layout");
var withLocationHeader = (0, withLocationDecorator_1.withLocationHeader)();
/**
 * @module Layout
 * @description The Layout service is used to build the page of a 6play entity (service, program, etc.) on a platform. You can use Fido to retrieve the Layout data of an entity. Then you are responsible to take these data and display the page.
 * @tutorial ./doc/layout.md
 */ var LayoutService = /*#__PURE__*/ function(_fetcherService_1_FetcherService) {
    _inherits._(LayoutService, _fetcherService_1_FetcherService);
    var _super = _create_super._(LayoutService);
    function LayoutService() {
        _class_call_check._(this, LayoutService);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.apiType = "layout";
        _this.defaultSectionCode = "main";
        _this.checkEntity = function(entityId, entityType) {
            if (!entityId) {
                throw new Error("You should provide a non null entityId");
            }
            if (!entityType) {
                throw new Error("You should provide a non null entityType!");
            }
        };
        return _this;
    }
    _create_class._(LayoutService, [
        {
            /**
     * Initialize the service. If you don't call this method, no other method can be called.
     *
     * @param {string} capacityToken A backend generated token that describes the platform capacity.
     * @param {options} options Some additional config parameters.
     * @tutorial ./doc/layoutInit.md
     */ key: "init",
            value: function init(capacityToken) {
                var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_defaultLayoutTheme = _ref.defaultLayoutTheme, defaultLayoutTheme = _ref_defaultLayoutTheme === void 0 ? {} : _ref_defaultLayoutTheme, _ref_retry = _ref.retry, retry = _ref_retry === void 0 ? 0 : _ref_retry;
                if (!this.isInitialized) {
                    this.basePath = "".concat(fido_1.fido.get("customerCode"), "/%(platformCode)s");
                    this.capacityToken = capacityToken;
                    this.defaultLayoutTheme = defaultLayoutTheme;
                    this.isInitialized = true;
                    this.retryOptions = (0, retryRequest_1.buildRetryOptions)({
                        apiType: this.apiType,
                        count: retry
                    });
                }
            }
        },
        {
            /**
     * Set the default layout theme which will be apply if the API return a null backgroundColor or colorScheme
     * @param {Object} layoutTheme Contains the default backgroundColor (Hexa) and the default colorScheme of the layout
     * * @tutorial ./doc/setDefaultLayoutTheme.md
     */ key: "setDefaultLayoutTheme",
            value: function setDefaultLayoutTheme(layoutTheme) {
                if (layoutTheme && layoutTheme.backgroundColor && layoutTheme.colorScheme) {
                    this.defaultLayoutTheme = layoutTheme;
                }
            }
        },
        {
            key: "fetchByEntity",
            value: /**
     * Get a layout for an entity.
     * @async
     *
     * @param {Object} options Contains "entityType (The layout type we want (see Layout Entity part for more info)), entitytId (Entity identifier) and headers (list of headers to add in network call)" values.
     * @returns {Object} The layout retrieved from the API.
     * @tutorial ./doc/layoutFetch.md
     */ function fetchByEntity(param) {
                var entityType = param.entityType, entityId = param.entityId, _param_sectionCode = param.sectionCode, sectionCode = _param_sectionCode === void 0 ? this.defaultSectionCode : _param_sectionCode, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers, _param_nbPages = param.nbPages, nbPages = _param_nbPages === void 0 ? 2 : _param_nbPages, _param_queryParameters = param.queryParameters, queryParameters = _param_queryParameters === void 0 ? {} : _param_queryParameters, _param_withCredentials = param.withCredentials, withCredentials = _param_withCredentials === void 0 ? false : _param_withCredentials, _param_signal = param.signal, signal = _param_signal === void 0 ? undefined : _param_signal, _param_platformCode = param.platformCode, platformCode = _param_platformCode === void 0 ? fido_1.fido.get("platformCode") : _param_platformCode;
                var _this = this;
                return _async_to_generator._(function() {
                    var token, serializedQueryParameters, layout;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.checkEntity(entityId, entityType);
                                token = fido_1.fido.get("usedCapacityToken") || _this.capacityToken;
                                if (token === "beta-all-available") {
                                    queryParameters.blockPage = 1;
                                }
                                serializedQueryParameters = (0, queryParamSerializer_1.serialize)(Object.assign({
                                    nbPages: nbPages
                                }, queryParameters));
                                return [
                                    4,
                                    _this.fetch(_this.getRouteUrl("".concat(sectionCode, "/").concat(fido_1.fido.get("usedCapacityToken") || _this.capacityToken, "/").concat(entityType, "/").concat(entityId, "/layout?").concat(serializedQueryParameters), undefined, platformCode), {
                                        method: "GET",
                                        headers: headers,
                                        retry: _this.retryOptions,
                                        withCredentials: withCredentials,
                                        signal: signal
                                    })
                                ];
                            case 1:
                                layout = _state.sent();
                                return [
                                    2,
                                    _this.applyDefaultLayoutThemeOnLayout(layout)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "fetchHeadByEntity",
            value: /**
     * Head a layout for an entity.
     * @async
     *
     * @param {Object} options Contains "entityType (The layout type we want (see Layout Entity part for more info)), entitytId (Entity identifier) and headers (list of headers to add in network call)" values.
     * @returns {Object} The layout retrieved from the head request.
     * @tutorial ./doc/layoutFetchHead.md
     */ function fetchHeadByEntity(param) {
                var entityType = param.entityType, entityId = param.entityId, _param_sectionCode = param.sectionCode, sectionCode = _param_sectionCode === void 0 ? this.defaultSectionCode : _param_sectionCode, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers, _param_nbPages = param.nbPages, nbPages = _param_nbPages === void 0 ? 2 : _param_nbPages, _param_platformCode = param.platformCode, platformCode = _param_platformCode === void 0 ? fido_1.fido.get("platformCode") : _param_platformCode, _param_withCredentials = param.withCredentials, withCredentials = _param_withCredentials === void 0 ? false : _param_withCredentials;
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        _this.checkEntity(entityId, entityType);
                        return [
                            2,
                            _this.fetchWithStatus(_this.getRouteUrl("".concat(sectionCode, "/").concat(fido_1.fido.get("usedCapacityToken") || _this.capacityToken, "/").concat(entityType, "/").concat(entityId, "/layout?").concat((0, queryParamSerializer_1.serialize)({
                                nbPages: nbPages
                            })), fido_1.fido.get("clientCode"), platformCode), {
                                method: "HEAD",
                                headers: headers,
                                retry: _this.retryOptions,
                                withCredentials: withCredentials
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "fetchBlockPage",
            value: /**
     * Get a block items page for a block in an entity.
     * @async
     *
     * @param {Object} options Contains "entityType (The layout type we want (see Layout Entity part for more info)), entitytId (Entity identifier), blockId, pagination data and headers (list of headers to add in network call)" values.
     * @returns {Object} The block retrieved from the API.
     * @tutorial ./doc/fetchBlockPage.md
     */ function fetchBlockPage(param) {
                var entityType = param.entityType, entityId = param.entityId, blockId = param.blockId, _param_sectionCode = param.sectionCode, sectionCode = _param_sectionCode === void 0 ? this.defaultSectionCode : _param_sectionCode, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers, page = param.page, _param_nbPages = param.nbPages, nbPages = _param_nbPages === void 0 ? 1 : _param_nbPages, _param_queryParameters = param.queryParameters, queryParameters = _param_queryParameters === void 0 ? {} : _param_queryParameters;
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        if (!entityId) {
                            throw new Error("You should provide a non null entityId");
                        }
                        if (!entityType) {
                            throw new Error("You should provide a non null entityType!");
                        }
                        if (!blockId) {
                            throw new Error("You should provide a non null blockId !");
                        }
                        return [
                            2,
                            _this.fetch(_this.getRouteUrl("".concat(sectionCode, "/").concat(fido_1.fido.get("usedCapacityToken") || _this.capacityToken, "/").concat(entityType, "/").concat(entityId, "/block/").concat(blockId, "?").concat((0, queryParamSerializer_1.serialize)(Object.assign({
                                page: page,
                                nbPages: nbPages
                            }, queryParameters)))), {
                                method: "GET",
                                headers: headers,
                                retry: _this.retryOptions
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "fetchNavigation",
            value: /**
     * Get the navigation from the layout API.
     * @async
     *
     * @param {Object} options Contains target (corresponding platform) and "headers (list of headers to add in network call)".
     * @returns {Object} The navigation retrieved from the layout API.
     * @tutorial ./doc/fetchNavigation.md
     */ function fetchNavigation(param) {
                var target = param.target, _param_sectionCode = param.sectionCode, sectionCode = _param_sectionCode === void 0 ? this.defaultSectionCode : _param_sectionCode, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        if (!Object.values(layout_constants_1.navigationTargets).includes(target)) {
                            throw new Error('Parameter "target" must be one of '.concat(Object.values(layout_constants_1.navigationTargets).join(" | ")));
                        }
                        return [
                            2,
                            _this.fetch(_this.getRouteUrl("".concat(sectionCode, "/").concat(fido_1.fido.get("usedCapacityToken") || _this.capacityToken, "/navigation/").concat(target)), {
                                method: "GET",
                                headers: headers,
                                retry: _this.retryOptions
                            })
                        ];
                    });
                })();
            }
        },
        {
            /**
     * Replace the backgroundColor and the colorScheme attributes in `layout.theme` if one is not defined
     * @param {Object} layout the full layout object
     */ key: "applyDefaultLayoutThemeOnLayout",
            value: function applyDefaultLayoutThemeOnLayout(layout) {
                var _ref = (0, get_1.default)(layout, "layout.theme", {}), backgroundColor = _ref.backgroundColor, colorScheme = _ref.colorScheme;
                if ((0, isEmpty_1.default)(this.defaultLayoutTheme) || backgroundColor && colorScheme) {
                    return layout;
                }
                return (0, set_1.default)(layout, "layout.theme", this.defaultLayoutTheme);
            }
        },
        {
            key: "fetchEpgGrid",
            value: /**
     * Get an EPG block content for a given date
     * @async
     *
     * @param {Object} options Contains query parameters (day), nbPages and headers (list of headers to add in network call).
     * @returns {Object} The EPG block from the layout API.
     * @tutorial ./doc/fetchEpgGrid.md
     */ function fetchEpgGrid(param) {
                var _param_sectionCode = param.sectionCode, sectionCode = _param_sectionCode === void 0 ? this.defaultSectionCode : _param_sectionCode, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers, _param_nbPages = param.nbPages, nbPages = _param_nbPages === void 0 ? 2 : _param_nbPages, queryParameters = param.queryParameters;
                var _this = this;
                return _async_to_generator._(function() {
                    var token, serializedQueryParameters;
                    return _ts_generator._(this, function(_state) {
                        token = fido_1.fido.get("usedCapacityToken") || _this.capacityToken;
                        serializedQueryParameters = (0, queryParamSerializer_1.serialize)(Object.assign({
                            nbPages: nbPages
                        }, queryParameters));
                        return [
                            2,
                            _this.fetch(_this.getRouteUrl("".concat(sectionCode, "/").concat(token, "/epg_grid?").concat(serializedQueryParameters)), {
                                method: "GET",
                                headers: headers,
                                retry: _this.retryOptions
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "fetchEpgModal",
            value: /**
     * Get an EPG modal content for a given modal id
     * @async
     *
     * @param {Object} options Contains query parameters, an abort signal and headers (list of headers to add in network call).
     * @returns {Object} A layout of the EPG modal content
     * @tutorial ./doc/fetchEpgModal.md
     */ function fetchEpgModal(param) {
                var _param_sectionCode = param.sectionCode, sectionCode = _param_sectionCode === void 0 ? this.defaultSectionCode : _param_sectionCode, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers, queryParameters = param.queryParameters, id = param.id, signal = param.signal;
                var _this = this;
                return _async_to_generator._(function() {
                    var token, serializedQueryParameters;
                    return _ts_generator._(this, function(_state) {
                        token = fido_1.fido.get("usedCapacityToken") || _this.capacityToken;
                        serializedQueryParameters = (0, queryParamSerializer_1.serialize)(queryParameters);
                        return [
                            2,
                            _this.fetch(_this.getRouteUrl("".concat(sectionCode, "/").concat(token, "/epg_grid/").concat(id, "/modal?").concat(serializedQueryParameters)), {
                                method: "GET",
                                headers: headers,
                                retry: _this.retryOptions,
                                signal: signal
                            })
                        ];
                    });
                })();
            }
        }
    ]);
    return LayoutService;
}(fetcherService_1.FetcherService);
exports.LayoutService = LayoutService;
__decorate([
    withJWT_1.withJWT,
    withLocationHeader,
    monitoring
], LayoutService.prototype, "fetchByEntity", null);
__decorate([
    withJWT_1.withJWT,
    withLocationHeader,
    monitoring
], LayoutService.prototype, "fetchHeadByEntity", null);
__decorate([
    withJWT_1.withJWT,
    withLocationHeader,
    monitoring
], LayoutService.prototype, "fetchBlockPage", null);
__decorate([
    withJWT_1.withJWT,
    withLocationHeader,
    monitoring
], LayoutService.prototype, "fetchNavigation", null);
__decorate([
    withJWT_1.withJWT,
    withLocationHeader,
    monitoring
], LayoutService.prototype, "fetchEpgGrid", null);
__decorate([
    withJWT_1.withJWT,
    withLocationHeader,
    monitoring
], LayoutService.prototype, "fetchEpgModal", null);
exports.layoutService = new LayoutService();


/***/ }),

/***/ 20250:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(3009);
var __decorate = (void 0) && (void 0).__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.liveService = void 0;
var fido_1 = __webpack_require__(19322);
var queryParamSerializer_1 = __webpack_require__(19007);
var withJWT_1 = __webpack_require__(56282);
var fetcherService_1 = __webpack_require__(96571);
var withMonitoring_1 = __webpack_require__(97982);
var monitoring = (0, withMonitoring_1.withMonitoring)("live");
/**
 * @module Live
 * @augments FetcherService
 * @description Service to interact with Live channels middleware
 * @tutorial ./doc/live.md
 */ var LiveService = /*#__PURE__*/ function(_fetcherService_1_FetcherService) {
    _inherits._(LiveService, _fetcherService_1_FetcherService);
    var _super = _create_super._(LiveService);
    function LiveService() {
        _class_call_check._(this, LiveService);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.apiType = "middlewarev2";
        return _this;
    }
    _create_class._(LiveService, [
        {
            /**
     * Initialize the service. If you don't call this method, no other method can be called.
     *
     * @tutorial ./doc/liveInit.md
     */ key: "init",
            value: function init() {
                if (!this.isInitialized) {
                    this.basePath = "platforms/".concat(fido_1.fido.get("platformCode"), "/services");
                    this.isInitialized = true;
                }
            }
        },
        {
            key: "validateChannels",
            value: function validateChannels(channels) {
                if (!Array.isArray(channels) || !channels.length) {
                    throw new Error("You should provide an array containing at least one channel");
                }
            }
        },
        {
            key: "fetchLiveChannels",
            value: /**
     * Fetches Live data for specified channels. Returns an object containing metadata for each requested channel.
     * Additional fields could be specified via the dataToFetch array.
     *
     * @async
     * @param {Object} options Options passed to liveProgram serviceCode, channel, clientCode or headers
     * @param {string} options.serviceCode Should be retrieved from application config
     * @param {string[]} options.channels Channels that should be fetched. Usually this array will contain a single element
     * @param {string[]} options.dataToFetch Additional fields to be fetched, for example: ['freemiumpacks', 'service_display_images', 'nextdiffusion', 'extra_data']
     * @param {String} options.clientCode middleware client code: pc, hbbtv, and so on.
     * @param {Object=} options.headers HTTP headers to add or overwrite, optional parameter
     * @returns {Object} Information about the live channels
     * @tutorial ./doc/fetchLiveChannels.md
     */ function fetchLiveChannels(param) {
                var serviceCode = param.serviceCode, channels = param.channels, _param_dataToFetch = param.dataToFetch, dataToFetch = _param_dataToFetch === void 0 ? [] : _param_dataToFetch, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers, clientCode = param.clientCode;
                var _this = this;
                return _async_to_generator._(function() {
                    var queryParams;
                    return _ts_generator._(this, function(_state) {
                        _this.validateChannels(channels);
                        queryParams = {
                            channel: channels.join(",")
                        };
                        if (Array.isArray(dataToFetch) && Boolean(dataToFetch.length)) {
                            queryParams.with = dataToFetch.join(",");
                        }
                        return [
                            2,
                            _this.fetch(_this.getRouteUrl("".concat(serviceCode, "/live?").concat((0, queryParamSerializer_1.serialize)(queryParams)), clientCode), {
                                method: "GET",
                                headers: headers
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "fetchGuide",
            value: /**
     * Fetches EPG for specified period of time
     *
     * @async
     * @param {Object} options Configuration of the request
     * @param {string} options.serviceCode Should be retrieved from application config
     * @param {string[]} options.channels Channels that should be fetched
     * @param {Date} options.from Start date of schedule
     * @param {Date} options.to End date of schedule
     * @param {Number} options.limit Page limit, maximal amount of items to fetch
     * @param {Number} options.offset Page offset, should be used along with the limit parameter
     * @param {string[]} options.dataToFetch Additional fields to be fetched
     * @param {Object=} options.headers HTTP headers to add or overwrite, optional parameter
     * @param {String} options.clientCode middleware client code: pc, hbbtv, and so on.
     * @returns {Object} Information about the live channels schedule
     * @tutorial ./doc/fetchGuide.md
     */ function fetchGuide(param) {
                var serviceCode = param.serviceCode, channels = param.channels, from = param.from, to = param.to, _param_limit = param.limit, limit = _param_limit === void 0 ? 1 : _param_limit, _param_offset = param.offset, offset = _param_offset === void 0 ? 0 : _param_offset, _param_dataToFetch = param.dataToFetch, dataToFetch = _param_dataToFetch === void 0 ? [] : _param_dataToFetch, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers, clientCode = param.clientCode;
                var _this = this;
                return _async_to_generator._(function() {
                    var queryParams;
                    return _ts_generator._(this, function(_state) {
                        _this.validateChannels(channels);
                        queryParams = {
                            channel: channels.join(","),
                            from: (0, queryParamSerializer_1.formatDate)(from),
                            to: (0, queryParamSerializer_1.formatDate)(to),
                            limit: limit,
                            offset: offset
                        };
                        if (Array.isArray(dataToFetch) && Boolean(dataToFetch.length)) {
                            queryParams.with = dataToFetch.join(",");
                        }
                        return [
                            2,
                            _this.fetch(_this.getRouteUrl("".concat(serviceCode, "/guidetv?").concat((0, queryParamSerializer_1.serialize)(queryParams)), clientCode), {
                                method: "GET",
                                headers: headers
                            })
                        ];
                    });
                })();
            }
        }
    ]);
    return LiveService;
}(fetcherService_1.FetcherService);
__decorate([
    withJWT_1.withJWT,
    monitoring
], LiveService.prototype, "fetchLiveChannels", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], LiveService.prototype, "fetchGuide", null);
exports.liveService = new LiveService();


/***/ }),

/***/ 33396:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _to_consumable_array = __webpack_require__(30005);
var _create_super = __webpack_require__(6400);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(42578);
var __decorate = (void 0) && (void 0).__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (void 0) && (void 0).__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.logCollectorService = void 0;
var enc_hex_1 = __importDefault(__webpack_require__(2447));
var md5_1 = __importDefault(__webpack_require__(59834));
var fido_1 = __webpack_require__(19322);
var fetcherService_1 = __webpack_require__(96571);
var withMonitoring_1 = __webpack_require__(97982);
var monitoring = (0, withMonitoring_1.withMonitoring)("logCollector");
/**
 * @module LogCollector
 * @description Gelf log service is used to track error log.
 * @tutorial ./doc/logCollector.md
 */ var LogCollectorService = /*#__PURE__*/ function(_fetcherService_1_FetcherService) {
    _inherits._(LogCollectorService, _fetcherService_1_FetcherService);
    var _super = _create_super._(LogCollectorService);
    function LogCollectorService() {
        _class_call_check._(this, LogCollectorService);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.apiType = "gelf";
        return _this;
    }
    _create_class._(LogCollectorService, [
        {
            /**
     * Initialize the service. If you don't call this method, no other method can be called.
     *
     * @param {string} salt Salt used to generate request token.
     * @tutorial ./doc/logCollectorInit.md
     */ key: "init",
            value: function init(salt) {
                var platformCode = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : fido_1.fido.get("platformCode");
                if (!this.isInitialized) {
                    this.salt = salt;
                    this.platformCode = platformCode;
                    this.basePath = "gelf/log/pc";
                    this.isInitialized = true;
                }
            }
        },
        {
            key: "generateToken",
            value: function generateToken(node) {
                var hash = (0, md5_1.default)("pc".concat(node).concat(this.salt));
                return hash.toString(enc_hex_1.default);
            }
        },
        {
            /**
     * Send Error to log Collector with nodes.
     *
     * @param {Object[]} nodes Nodes to tag the error.
     * @param {Object} objectToLog Elements to log.
     * @tutorial ./doc/logCollectorSend.md
     */ key: "send",
            value: function send() {
                var nodes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], objectToLog = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var prefixedNodes = [
                    fido_1.fido.get("customerCode"),
                    this.platformCode
                ].concat(_to_consumable_array._(nodes)).join(".");
                var url = this.getRouteUrl("".concat(prefixedNodes, "/?token=").concat(this.generateToken(prefixedNodes)));
                return this.fetch(url, {
                    method: "POST",
                    body: objectToLog
                });
            }
        }
    ]);
    return LogCollectorService;
}(fetcherService_1.FetcherService);
__decorate([
    monitoring
], LogCollectorService.prototype, "send", null);
exports.logCollectorService = new LogCollectorService();


/***/ }),

/***/ 97982:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _async_to_generator = __webpack_require__(24146);
var _to_consumable_array = __webpack_require__(30005);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(42578);
var __importDefault = (void 0) && (void 0).__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.withMonitoring = void 0;
var get_1 = __importDefault(__webpack_require__(65439));
var fetch_error_1 = __webpack_require__(41180);
var statsdMonitoringService_1 = __webpack_require__(86023);
var timer_util_1 = __webpack_require__(50311);
// For unknown status like timeout
var DEFAULT_STATUS_CODE = 0;
/**
 * This decorator allow you to monitor a method
 * IMPORTANT : If you use others decorators with this one then it MUST be at the LAST position
 * To avoid monitoring the others decorators
 * @param  {...any} tags Label of the monitoring's info
 */ var withMonitoring = function() {
    for(var _len = arguments.length, tags = new Array(_len), _key = 0; _key < _len; _key++){
        tags[_key] = arguments[_key];
    }
    return function(target, key, descriptor) {
        var fn = descriptor.value;
        descriptor.value = /*#__PURE__*/ _async_to_generator._(function() {
            var _len, args, _key, returnValue, timer, error;
            var _arguments = arguments;
            return _ts_generator._(this, function(_state) {
                switch(_state.label){
                    case 0:
                        for(_len = _arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                            args[_key] = _arguments[_key];
                        }
                        timer = new timer_util_1.Timer(statsdMonitoringService_1.statsdMonitoringService.getCurrentTime);
                        timer.start();
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            fn.apply(this, args)
                        ];
                    case 2:
                        returnValue = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        if (error instanceof fetch_error_1.FetchError) {
                            statsdMonitoringService_1.statsdMonitoringService.sendIncrement([
                                "error",
                                "fido"
                            ].concat(_to_consumable_array._(tags), [
                                key,
                                (0, get_1.default)(error, "response.status", DEFAULT_STATUS_CODE)
                            ]));
                        } else {
                            statsdMonitoringService_1.statsdMonitoringService.sendIncrement([
                                "error",
                                "fido"
                            ].concat(_to_consumable_array._(tags), [
                                key,
                                "custom_error"
                            ]));
                        }
                        throw error;
                    case 4:
                        timer.stop();
                        statsdMonitoringService_1.statsdMonitoringService.sendTiming([
                            "fido"
                        ].concat(_to_consumable_array._(tags), [
                            key
                        ]), timer.duration());
                        return [
                            2,
                            returnValue
                        ];
                }
            });
        });
        return descriptor;
    };
};
exports.withMonitoring = withMonitoring;


/***/ }),

/***/ 86023:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _sliced_to_array = __webpack_require__(28966);
var _to_consumable_array = __webpack_require__(30005);
var _create_super = __webpack_require__(6400);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(45538);
var __importDefault = (void 0) && (void 0).__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.statsdMonitoringService = void 0;
var enc_base64_1 = __importDefault(__webpack_require__(33490));
var enc_hex_1 = __importDefault(__webpack_require__(2447));
var enc_utf8_1 = __importDefault(__webpack_require__(26551));
var md5_1 = __importDefault(__webpack_require__(59834));
var fido_1 = __webpack_require__(19322);
var fetch_1 = __webpack_require__(27082);
var fetcherService_1 = __webpack_require__(96571);
/**
 * @module StatsdMonitoring
 * @description The Statsd Monitoring service is used to call graphite node in order to count api calls.
 * @tutorial ./doc/statsd.md
 */ var StatsdMonitoringService = /*#__PURE__*/ function(_fetcherService_1_FetcherService) {
    _inherits._(StatsdMonitoringService, _fetcherService_1_FetcherService);
    var _super = _create_super._(StatsdMonitoringService);
    function StatsdMonitoringService() {
        _class_call_check._(this, StatsdMonitoringService);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.apiType = "monitoring";
        _this.stack = [];
        _this.buildPattern = function(basePattern, encoded) {
            return encoded ? "".concat(basePattern, "&encoded=1") : basePattern;
        };
        _this.buildEncodedNode = function(originalNode) {
            return encodeURIComponent(enc_base64_1.default.stringify(enc_utf8_1.default.parse(originalNode)));
        };
        _this.buildNodes = function(tags, encoded) {
            var scope = _this.isClientSide ? "client" : "server";
            var prefixedTags = [
                fido_1.fido.get("customerCode"),
                _this.platformCode,
                scope
            ].concat(_to_consumable_array._(tags));
            var node = prefixedTags.join(".");
            return {
                originalNode: node,
                encodedNode: encoded ? _this.buildEncodedNode(node) : node
            };
        };
        return _this;
    }
    _create_class._(StatsdMonitoringService, [
        {
            /**
     * Initialize the service. If you don't call this method, no other method can be called.
     *
     * @param {boolean} isClientSide Flag to tell if this service is client or server side.
     * @param {Object} options Options to pass to the service. See the example to discover the list of available options.
     * @tutorial ./doc/statsdInit.md
     */ key: "init",
            value: function init(isClientSide, param) {
                var enabled = param.enabled, salt = param.salt, platformCode = param.platformCode;
                this.isClientSide = isClientSide;
                this.enabled = enabled;
                if (!this.isInitialized) {
                    this.basePath = "statsd";
                    this.salt = salt;
                    this.getCurrentTime = fido_1.fido.get("getCurrentTime");
                    this.platformCode = platformCode || fido_1.fido.get("platformCode");
                    this.isInitialized = true;
                    this.processStack();
                }
            }
        },
        {
            key: "generateToken",
            value: function generateToken(node) {
                var isTimingToken = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var template = isTimingToken ? "".concat(node).concat(this.salt) : "".concat(node, "1").concat(this.salt);
                var hash = (0, md5_1.default)(template);
                return hash.toString(enc_hex_1.default);
            }
        },
        {
            /**
     * Send an increment on a specific tag list.
     *
     * @param {string[]} tags List of tags for increment hit.
     * @param {string=} token Increment token.
     * @param {boolean=} [encoded=false] Encoded flag to indicate if the hit is encoded.
     * @tutorial ./doc/statsdIncrement.md
     */ key: "sendIncrement",
            value: function sendIncrement() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var _this = this;
                var _args = _sliced_to_array._(args, 3), tags = _args[0], token = _args[1], tmp = _args[2], encoded = tmp === void 0 ? false : tmp;
                if (!this.isInitialized) {
                    this.stack.push(function() {
                        return _this.sendIncrement.apply(_this, _to_consumable_array._(args));
                    });
                    return;
                }
                if (!this.enabled) {
                    return;
                }
                var _this_buildNodes = this.buildNodes(tags, encoded), originalNode = _this_buildNodes.originalNode, encodedNode = _this_buildNodes.encodedNode;
                var url = this.getRouteUrl("".concat(encodedNode, "/increment?token=").concat(token || this.generateToken(originalNode)));
                (0, fetch_1.fetch)(this.buildPattern(url, encoded)).catch(function() {
                // Fail silently
                });
            }
        },
        {
            /**
     * Send a timing on a specific tag list.
     *
     * @param {string[]} tags List of tags for timing hit.
     * @param {number} duration Timing value.
     * @param {string=} token Timing token.
     * @param {boolean=} [encoded=false] Encoded flag to indicate if the hit is encoded.
     * @tutorial ./doc/statsdTiming.md
     */ key: "sendTiming",
            value: function sendTiming() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var _this = this;
                var _args = _sliced_to_array._(args, 4), tags = _args[0], duration = _args[1], token = _args[2], tmp = _args[3], encoded = tmp === void 0 ? false : tmp;
                if (!this.isInitialized) {
                    this.stack.push(function() {
                        return _this.sendTiming.apply(_this, _to_consumable_array._(args));
                    });
                    return;
                }
                if (!this.enabled) {
                    return;
                }
                var _this_buildNodes = this.buildNodes(tags, encoded), originalNode = _this_buildNodes.originalNode, encodedNode = _this_buildNodes.encodedNode;
                var url = this.getRouteUrl("".concat(encodedNode, "/timer/").concat(duration, "?token=").concat(token || this.generateToken(originalNode, true)));
                // Don't use this.fetch to avoid auto injection of headers
                (0, fetch_1.fetch)(this.buildPattern(url, encoded)).catch(function() {
                // Fail silently
                });
            }
        },
        {
            key: "processStack",
            value: function processStack() {
                if (this.isInitialized) {
                    this.stack.forEach(function(sendTags) {
                        return sendTags();
                    });
                    this.stack = [];
                }
            }
        },
        {
            /**
     * Send tracking hit to monitor app start.
     *
     * @param version string representation of the currently deployed release.
     * @tutorial ./doc/appStart.md
     */ key: "sendAppStart",
            value: function sendAppStart(version) {
                this.sendIncrement([
                    version,
                    "frontend_app_startup_total"
                ]);
            }
        },
        {
            /**
     * Send tracking hit to monitor silent error.
     *
     * @tutorial ./doc/silentError.md
     */ key: "sendSilentError",
            value: function sendSilentError() {
                this.sendIncrement([
                    "frontend_silent_error_total"
                ]);
            }
        },
        {
            /**
     * Send tracking hit to monitor fatal errors.
     *
     * @tutorial ./doc/fatalError.md
     */ key: "sendFatalError",
            value: function sendFatalError() {
                this.sendIncrement([
                    "frontend_fatal_error_total"
                ]);
            }
        },
        {
            /**
     * Send tracking hit to monitor manual login sucess.
     *
     * @tutorial ./doc/manualLoginSuccess.md
     */ key: "sendManualLoginSuccess",
            value: function sendManualLoginSuccess() {
                this.sendIncrement([
                    "frontend_login_total"
                ]);
            }
        },
        {
            /**
     * Send tracking hit to monitor auto login.
     *
     * @tutorial ./doc/autoLoginSuccess.md
     */ key: "sendAutoLoginSuccess",
            value: function sendAutoLoginSuccess() {
                this.sendIncrement([
                    "frontend_auto_login_total"
                ]);
            }
        },
        {
            /**
     * Send tracking hit to monitor manual login errors.
     *
     * @tutorial ./doc/manualLoginError.md
     */ key: "sendManualLoginError",
            value: function sendManualLoginError() {
                this.sendIncrement([
                    "frontend_login_error_total"
                ]);
            }
        },
        {
            /**
     * Send tracking hit to monitor register success.
     *
     * @tutorial ./doc/registerSuccess.md
     */ key: "sendRegisterSuccess",
            value: function sendRegisterSuccess() {
                this.sendIncrement([
                    "frontend_register_total"
                ]);
            }
        },
        {
            /**
     * Send tracking hit to monitor register errors.
     *
     * @tutorial ./doc/registerError.md
     */ key: "sendRegisterError",
            value: function sendRegisterError() {
                this.sendIncrement([
                    "frontend_register_error_total"
                ]);
            }
        },
        {
            /**
     * Send tracking hit to monitor complete registration success.
     *
     * @tutorial ./doc/completeRegistrationSuccess.md
     */ key: "sendCompleteRegistrationSuccess",
            value: function sendCompleteRegistrationSuccess() {
                this.sendIncrement([
                    "frontend_complete_registration_total"
                ]);
            }
        },
        {
            /**
     * Send tracking hit to monitor complete registration errors.
     *
     * @tutorial ./doc/completeRegistrationError.md
     */ key: "sendCompleteRegistrationError",
            value: function sendCompleteRegistrationError() {
                this.sendIncrement([
                    "frontend_complete_registration_error_total"
                ]);
            }
        },
        {
            /**
     * Send tracking hit to monitor when payment is done successfully.
     *
     * @param {string} payment The payment method used.
     * @tutorial ./doc/sendPaymentDone.md
     */ key: "sendPaymentDone",
            value: function sendPaymentDone(payment) {
                this.sendIncrement([
                    payment,
                    "frontend_payment_done_total"
                ]);
            }
        },
        {
            /**
     * Send tracking hit to monitor when payment failed.
     *
     * @param {string} payment The payment method used.
     * @tutorial ./doc/sendPaymentFailure.md
     */ key: "sendPaymentFailure",
            value: function sendPaymentFailure(payment, failure) {
                this.sendIncrement([
                    payment,
                    failure,
                    "frontend_payment_failure_total"
                ]);
            }
        },
        {
            /**
     * Send tracking hit to monitor layout redirection
     *
     * @param {string} frontspace The frontspace we redirect to.
     * @tutorial ./doc/sendLayoutRedirection.md
     */ key: "sendLayoutRedirection",
            value: function sendLayoutRedirection(frontspace) {
                this.sendIncrement([
                    "frontend_layout",
                    frontspace,
                    "redirect_total"
                ]);
            }
        },
        {
            /**
     * Send tracking hit to monitor profile selection.
     *
     * @tutorial ./doc/sendProfileSelection.md
     */ key: "sendProfileSelection",
            value: function sendProfileSelection() {
                this.sendIncrement([
                    "frontend_profile_selection_total"
                ]);
            }
        },
        {
            /**
     * Send tracking hit to monitor profile selection failure.
     *
     * @tutorial ./doc/sendProfileSelectionFailure.md
     */ key: "sendProfileSelectionFailure",
            value: function sendProfileSelectionFailure() {
                this.sendIncrement([
                    "frontend_profile_selection_failure_total"
                ]);
            }
        },
        {
            /**
     * Send tracking hit to monitor profile auto selection.
     *
     * @tutorial ./doc/sendProfileAutoSelection.md
     */ key: "sendProfileAutoSelection",
            value: function sendProfileAutoSelection() {
                this.sendIncrement([
                    "frontend_profile_autoselection_total"
                ]);
            }
        },
        {
            /**
     * Send tracking hit to monitor profile auto selection failure.
     *
     * @tutorial ./doc/sendProfileAutoSelectionFailure.md
     */ key: "sendProfileAutoSelectionFailure",
            value: function sendProfileAutoSelectionFailure() {
                this.sendIncrement([
                    "frontend_profile_autoselection_failure_total"
                ]);
            }
        },
        {
            /**
     * Send tracking hit to monitor algolia search requests.
     *
     * @tutorial ./doc/sendSearchBatchHit.md
     */ key: "sendSearchBatchHit",
            value: function sendSearchBatchHit() {
                this.sendIncrement([
                    "frontend_search_total"
                ]);
            }
        },
        {
            /**
     * Send tracking hit to monitor password succesfully update.
     *
     * @tutorial ./doc/sendUpdatePassword.md
     */ key: "sendUpdatePassword",
            value: function sendUpdatePassword() {
                this.sendIncrement([
                    "frontend_update_password"
                ]);
            }
        }
    ]);
    return StatsdMonitoringService;
}(fetcherService_1.FetcherService);
exports.statsdMonitoringService = new StatsdMonitoringService();


/***/ }),

/***/ 50311:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.Timer = void 0;
var Timer = /*#__PURE__*/ function() {
    function Timer() {
        var getCurrentTime = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Date.now;
        _class_call_check._(this, Timer);
        this.getCurrentTime = getCurrentTime;
        this.startTime = null;
        this.endTime = null;
    }
    _create_class._(Timer, [
        {
            key: "start",
            value: function start() {
                this.startTime = this.getCurrentTime();
            }
        },
        {
            key: "stop",
            value: function stop() {
                this.endTime = this.getCurrentTime();
            }
        },
        {
            key: "duration",
            value: function duration() {
                if (this.startTime === null || this.endTime === null) {
                    throw new Error("You should start and stop the timer before getting duration");
                }
                return this.endTime - this.startTime;
            }
        }
    ]);
    return Timer;
}();
exports.Timer = Timer;


/***/ }),

/***/ 50249:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(3009);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.premiumCouponStatus = exports.subscriptionStatus = void 0;
exports.subscriptionStatus = {
    VALID: "VALID",
    INVALID: "INVALID",
    ALREADY_USED_PAYMENT_METHOD: "ALREADY_USED_PAYMENT_METHOD"
};
exports.premiumCouponStatus = {
    VALID: "VALID",
    INVALID: "INVALID",
    ALREADY_SUBSCRIBED: "ERR_USER_ALREADY_SUBSCRIBED",
    USED: "USED",
    EXPIRED: "EXPIRED",
    LIMIT_REACHED: "LIMIT_REACHED"
};


/***/ }),

/***/ 44700:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _define_property = __webpack_require__(21228);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(42578);
var __decorate = (void 0) && (void 0).__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (void 0) && (void 0).__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.premiumService = exports.PremiumService = void 0;
var pickBy_1 = __importDefault(__webpack_require__(12557));
var snakeCase_1 = __importDefault(__webpack_require__(69113));
var fido_1 = __webpack_require__(19322);
var caching_1 = __webpack_require__(72345);
var withJWT_1 = __webpack_require__(56282);
var fetcherService_1 = __webpack_require__(96571);
var withMonitoring_1 = __webpack_require__(97982);
var premium_constants_1 = __webpack_require__(50249);
var monitoring = (0, withMonitoring_1.withMonitoring)("premium");
/**
 * @module Premium
 * @description The Premium service is used for premium in 6play app
 * @tutorial ./doc/premium.md
 */ var PremiumService = /*#__PURE__*/ function(_fetcherService_1_FetcherService) {
    _inherits._(PremiumService, _fetcherService_1_FetcherService);
    var _super = _create_super._(PremiumService);
    function PremiumService() {
        _class_call_check._(this, PremiumService);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.apiType = "stores";
        return _this;
    }
    _create_class._(PremiumService, [
        {
            /**
     * Initialize the service. If you don't call this method, no other method can be called.
     *
     * @tutorial ./doc/premiumInit.md
     */ key: "init",
            value: function init() {
                if (!this.isInitialized) {
                    this.isInitialized = true;
                }
            }
        },
        {
            key: "getOffers",
            value: /**
     * Get offers list
     * @async
     *
     * @param {Object} options Offers parameters (products: string array of products id, countryCode: ISO country code for offers filtering)
     *
     * @returns {Object[]}
     */ function getOffers(param) {
                var headers = param.headers, products = param.products, countryCode = param.countryCode;
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        _this.checkInit();
                        return [
                            2,
                            _this.fetch("".concat(fido_1.fido.getBaseUrl("stores"), "/customers/").concat(fido_1.fido.get("customerCode"), "/platforms/").concat(fido_1.fido.get("platformCode"), "/offers"), {
                                method: "GET",
                                headers: headers,
                                query: {
                                    products: products === null || products === void 0 ? void 0 : products.join(","),
                                    countryCode: countryCode
                                }
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "getOrder",
            value: /**
     * Generate an order on server side
     * @async
     *
     * @param {Object} options Order parameters
     * @returns {Object}
     * @tutorial ./doc/getOrder.md
     */ function getOrder(param) {
                var locale = param.locale, variantId = param.variantId, couponCode = param.couponCode, user = param.user, headers = param.headers;
                var _this = this;
                return _async_to_generator._(function() {
                    var prepareURL;
                    return _ts_generator._(this, function(_state) {
                        _this.checkInit();
                        prepareURL = "".concat(fido_1.fido.getBaseUrl("stores"), "/customers/").concat(fido_1.fido.get("customerCode"), "/platforms/").concat(fido_1.fido.get("platformCode"), "/users/").concat(user.UID, "/prepare");
                        return [
                            2,
                            _this.fetch(prepareURL, {
                                method: "POST",
                                body: {
                                    locale: locale,
                                    offer_variant_id: variantId,
                                    coupon_code: couponCode
                                },
                                headers: headers
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "changeOffer",
            value: /**
     * Change an offer subscription.
     * @async
     *
     * @param {Object} options Change offer parameter (offerCode, variantId, user, headers)
     * @returns {Object}
     * @tutorial ./doc/changeOffer.md
     */ function changeOffer(param) {
                var offerCode = param.offerCode, variantId = param.variantId, user = param.user, headers = param.headers;
                var _this = this;
                return _async_to_generator._(function() {
                    var prepareURL;
                    return _ts_generator._(this, function(_state) {
                        _this.checkInit();
                        prepareURL = "".concat(fido_1.fido.getBaseUrl("stores"), "/customers/").concat(fido_1.fido.get("customerCode"), "/platforms/").concat(fido_1.fido.get("platformCode"), "/users/").concat(user.UID, "/offers/").concat(offerCode, "/change");
                        return [
                            2,
                            _this.fetch(prepareURL, {
                                method: "POST",
                                body: {
                                    offer_variant_id: variantId
                                },
                                headers: headers
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "cancelDowngrade",
            value: /**
     * Cancel downgrade
     * @async
     *
     * @param {Object} options parameters (offerCode, user, headers)
     * @returns {Object}
     * @tutorial ./doc/cancelDowngrade.md
     */ function cancelDowngrade(param) {
                var offerCode = param.offerCode, user = param.user, headers = param.headers;
                var _this = this;
                return _async_to_generator._(function() {
                    var prepareURL;
                    return _ts_generator._(this, function(_state) {
                        _this.checkInit();
                        prepareURL = "".concat(fido_1.fido.getBaseUrl("stores"), "/customers/").concat(fido_1.fido.get("customerCode"), "/platforms/").concat(fido_1.fido.get("platformCode"), "/users/").concat(user.UID, "/offers/").concat(offerCode, "/change/cancel");
                        return [
                            2,
                            _this.fetch(prepareURL, {
                                method: "POST",
                                headers: headers
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "getUserAccess",
            value: /**
     * Get the user's accesses
     * @async
     *
     * @param user User
     * @returns {Object}
     * @tutorial ./doc/getUserAccess.md
     */ function getUserAccess(param) {
                var user = param.user, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                var _this = this;
                return _async_to_generator._(function() {
                    var prepareURL;
                    return _ts_generator._(this, function(_state) {
                        _this.checkInit();
                        prepareURL = "".concat(fido_1.fido.getBaseUrl("stores"), "/customers/").concat(fido_1.fido.get("customerCode"), "/platforms/").concat(fido_1.fido.get("platformCode"), "/users/").concat(user.UID, "/access");
                        return [
                            2,
                            _this.fetch(prepareURL, {
                                method: "GET",
                                headers: headers
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "getUserSubscriptions",
            value: /**
     * Get the user's subscriptions
     * @async
     *
     * @param {Object} options Object containing the user whose subscriptions are requested
     * @returns {Object}
     * @tutorial ./doc/getUserSubscriptions.md
     */ function getUserSubscriptions(param) {
                var user = param.user, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                var _this = this;
                return _async_to_generator._(function() {
                    var apiURL;
                    return _ts_generator._(this, function(_state) {
                        _this.checkInit();
                        if (!user.UID) {
                            throw new Error("You should provide a non null uid");
                        }
                        apiURL = "".concat(fido_1.fido.getBaseUrl("stores"), "/customers/").concat(fido_1.fido.get("customerCode"), "/platforms/").concat(fido_1.fido.get("platformCode"), "/users/").concat(user.UID, "/subscriptions");
                        return [
                            2,
                            _this.fetch(apiURL, {
                                method: "GET",
                                headers: headers
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "getUserSubscriptionsAfterPaymentUpdate",
            value: /**
     * Get the user's subscription after payment update
     * @async
     *
     * @param {Object} options Object containing the user whose subscriptions are requested
     * @returns {Object}
     * @tutorial ./doc/getUserSubscriptionsAfterPaymentUpdate.md
     */ function getUserSubscriptionsAfterPaymentUpdate(param) {
                var user = param.user, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        headers["X-Refresh"] = true;
                        return [
                            2,
                            _this.getUserSubscriptions({
                                user: user,
                                headers: headers
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "getUserInvoices",
            value: /**
     * Get the user's invoices
     * @async
     *
     * @param {Object} options Object containing the user whose invoices are requested
     * @returns {Object}
     * @tutorial ./doc/getUserInvoices.md
     */ function getUserInvoices(param) {
                var user = param.user, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                var _this = this;
                return _async_to_generator._(function() {
                    var apiURL;
                    return _ts_generator._(this, function(_state) {
                        _this.checkInit();
                        if (!user.UID) {
                            throw new Error("You should provide a non null uid");
                        }
                        apiURL = "".concat(fido_1.fido.getBaseUrl("stores"), "/customers/").concat(fido_1.fido.get("customerCode"), "/platforms/").concat(fido_1.fido.get("platformCode"), "/users/").concat(user.UID, "/invoices");
                        return [
                            2,
                            _this.fetch(apiURL, {
                                method: "GET",
                                headers: headers
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "downloadInvoice",
            value: /**
     * Download the given invoice
     * @async
     *
     * @param {Object} options Object containing the url of the invoice to download
     * @returns {Object}
     * @tutorial ./doc/downloadInvoice.md
     */ function downloadInvoice(param) {
                var url = param.url, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                var _this = this;
                return _async_to_generator._(function() {
                    var downloadWithRedirect, downloadWithManualRedirect, _a;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.checkInit();
                                downloadWithRedirect = function() {
                                    var _ref = _async_to_generator._(function() {
                                        return _ts_generator._(this, function(_state) {
                                            return [
                                                2,
                                                _this.fetch(url, {
                                                    method: "GET",
                                                    headers: headers,
                                                    responseType: "blob"
                                                })
                                            ];
                                        });
                                    });
                                    return function downloadWithRedirect() {
                                        return _ref.apply(this, arguments);
                                    };
                                }();
                                downloadWithManualRedirect = function() {
                                    var _ref = _async_to_generator._(function() {
                                        var returnUrl;
                                        return _ts_generator._(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    return [
                                                        4,
                                                        _this.fetch(url, {
                                                            method: "GET",
                                                            headers: Object.assign(Object.assign({}, headers), {
                                                                "Content-Type": "application/json"
                                                            })
                                                        })
                                                    ];
                                                case 1:
                                                    returnUrl = _state.sent();
                                                    return [
                                                        2,
                                                        _this.fetch(returnUrl.location, {
                                                            method: "GET",
                                                            headers: headers,
                                                            responseType: "blob"
                                                        })
                                                    ];
                                            }
                                        });
                                    });
                                    return function downloadWithManualRedirect() {
                                        return _ref.apply(this, arguments);
                                    };
                                }();
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    downloadWithRedirect()
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 3:
                                _a = _state.sent();
                                return [
                                    2,
                                    downloadWithManualRedirect()
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "cancelSubscription",
            value: /**
     * Cancel user subscription
     * @async
     *
     * @param {Object} options Object containing the user who request the cancellation and the subscription to cancel
     * @returns {Object}
     * @tutorial ./doc/cancelSubscription.md
     */ function cancelSubscription(param) {
                var user = param.user, offerCode = param.offerCode, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                var _this = this;
                return _async_to_generator._(function() {
                    var apiURL;
                    return _ts_generator._(this, function(_state) {
                        _this.checkInit();
                        if (!user.UID) {
                            throw new Error("You should provide a non null user uid");
                        }
                        if (!offerCode) {
                            throw new Error("You should provide a non null offer code");
                        }
                        apiURL = "".concat(fido_1.fido.getBaseUrl("stores"), "/customers/").concat(fido_1.fido.get("customerCode"), "/platforms/").concat(fido_1.fido.get("platformCode"), "/users/").concat(user.UID, "/offers/").concat(offerCode, "/unsubscribe");
                        return [
                            2,
                            _this.fetch(apiURL, {
                                method: "POST",
                                headers: headers
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "resumeSubscription",
            value: /**
     * Resume user subscription
     * @async
     *
     * @param {Object} options Object containing the user who request to resume and the canceled subscription to resume
     * @returns {Object}
     * @tutorial ./doc/resumeSubscription.md
     */ function resumeSubscription(param) {
                var user = param.user, offerCode = param.offerCode, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                var _this = this;
                return _async_to_generator._(function() {
                    var apiURL;
                    return _ts_generator._(this, function(_state) {
                        _this.checkInit();
                        if (!user.UID) {
                            throw new Error("You should provide a non null user uid");
                        }
                        if (!offerCode) {
                            throw new Error("You should provide a non null offer code");
                        }
                        apiURL = "".concat(fido_1.fido.getBaseUrl("stores"), "/customers/").concat(fido_1.fido.get("customerCode"), "/platforms/").concat(fido_1.fido.get("platformCode"), "/users/").concat(user.UID, "/offers/").concat(offerCode, "/resume");
                        return [
                            2,
                            _this.fetch(apiURL, {
                                method: "POST",
                                headers: headers
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "consumeCouponCode",
            value: function consumeCouponCode(param) {
                var user = param.user, couponCode = param.couponCode, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                var _this = this;
                return _async_to_generator._(function() {
                    var response, e, status, receiptResult, e1, status1;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!user) {
                                    throw new Error("You should provide a non null uid");
                                }
                                if (!couponCode) {
                                    throw new Error("You should provide a non null couponCode");
                                }
                                response = null;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    _this.fetchWithResponse("".concat(fido_1.fido.getBaseUrl("coupons"), "/customers/").concat(fido_1.fido.get("customerCode"), "/platforms/").concat(fido_1.fido.get("platformCode"), "/users/").concat(user.UID, "/coupons"), {
                                        method: "POST",
                                        headers: headers,
                                        body: {
                                            code: couponCode
                                        }
                                    })
                                ];
                            case 2:
                                response = _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                e = _state.sent();
                                status = e.status;
                                if (status === 400 || status === 404) return [
                                    2,
                                    {
                                        status: premium_constants_1.premiumCouponStatus.INVALID
                                    }
                                ];
                                throw e;
                            case 4:
                                _state.trys.push([
                                    4,
                                    6,
                                    ,
                                    7
                                ]);
                                return [
                                    4,
                                    _this.fetch("".concat(fido_1.fido.getBaseUrl("stores"), "/customers/").concat(fido_1.fido.get("customerCode"), "/platforms/").concat(fido_1.fido.get("platformCode"), "/users/").concat(user.UID, "/stores/freecoupons/check"), {
                                        method: "POST",
                                        headers: headers,
                                        body: {
                                            receipt: response.text
                                        }
                                    })
                                ];
                            case 5:
                                receiptResult = _state.sent();
                                return [
                                    3,
                                    7
                                ];
                            case 6:
                                e1 = _state.sent();
                                status1 = e1.status;
                                if (status1 === 400) return [
                                    2,
                                    {
                                        status: premium_constants_1.premiumCouponStatus.INVALID
                                    }
                                ];
                                if (status1 === 409) return [
                                    2,
                                    {
                                        status: premium_constants_1.premiumCouponStatus.ALREADY_SUBSCRIBED
                                    }
                                ];
                                throw e1;
                            case 7:
                                return [
                                    2,
                                    {
                                        status: premium_constants_1.premiumCouponStatus.VALID,
                                        subscribedOffer: receiptResult.offer
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "verifyCoupon",
            value: /**
     * Check couponCode status and return the associated offer
     * or throw if no coupon code is provided
     * @async
     *
     * @param {Object} options Contains the couponCode to verify and the
     * headers to transmit during the ajax request
     * @returns {Object} coupon data
     * @tutorial ./doc/verifyCoupon.md
     */ function verifyCoupon(param) {
                var couponCode = param.couponCode, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                var _this = this;
                return _async_to_generator._(function() {
                    var couponVerificationURL, coupon, _a;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.checkInit();
                                if (!couponCode) {
                                    throw new Error("You should provide a non null couponCode");
                                }
                                couponVerificationURL = "".concat(fido_1.fido.getBaseUrl("coupons"), "/premium/platforms/").concat(fido_1.fido.get("platformCode"), "/coupon/").concat(couponCode, "/expose");
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    _this.fetch(couponVerificationURL, {
                                        method: "GET",
                                        headers: headers
                                    })
                                ];
                            case 2:
                                coupon = _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                _a = _state.sent();
                                return [
                                    2,
                                    {
                                        status: premium_constants_1.premiumCouponStatus.INVALID
                                    }
                                ];
                            case 4:
                                return [
                                    2,
                                    coupon
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "pay",
            value: /**
     * Pay order.
     *
     * See {@link https://integrateur-6play.m6web.fr/v2/openapi/index.html?urls.primaryName=stores#/subscription/post_premium_v4_customers__customerCode__platforms__platformCode__users__uid__stores__storeCode__pay|API documentation}.
     *
     * @async
     * @param {Object} options Payment parameters (user, storeCode, returnUrl, paymentMethodType, paymentMethodCode, orderId)
     * @returns {Object}
     * @tutorial ./doc/pay.md
     */ function pay(param) {
                var force = param.force, user = param.user, storeCode = param.storeCode, returnUrl = param.returnUrl, paymentMethodType = param.paymentMethodType, paymentMethodCode = param.paymentMethodCode, orderId = param.orderId, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                var _this = this;
                return _async_to_generator._(function() {
                    var payEndpoint, body, payURL;
                    return _ts_generator._(this, function(_state) {
                        _this.checkInit();
                        if (!user.UID) {
                            throw new Error("You should provide a non null uid");
                        }
                        payEndpoint = force ? "forcePay" : "pay";
                        body = (0, pickBy_1.default)({
                            order_id: orderId,
                            return_url: returnUrl,
                            payment_method_type: paymentMethodType,
                            payment_method_code: paymentMethodCode
                        });
                        payURL = "".concat(fido_1.fido.getBaseUrl("stores"), "/customers/").concat(fido_1.fido.get("customerCode"), "/platforms/").concat(fido_1.fido.get("platformCode"), "/users/").concat(user.UID, "/stores/").concat(storeCode, "/").concat(payEndpoint);
                        return [
                            2,
                            _this.fetch(payURL, {
                                method: "POST",
                                body: body,
                                headers: headers
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "check",
            value: /**
     * Check subscription.
     *
     * See {@link https://integrateur-6play.m6web.fr/v2/openapi/index.html?urls.primaryName=stores#/subscription/post_premium_v4_customers__customerCode__platforms__platformCode__users__uid__stores__storeCode__check|API documentation}.
     *
     * @async
     * @param {Object} options Check parameters (user, storeCode, receipt)
     * @returns {Object}
     * @tutorial ./doc/check.md
     */ function check(param) {
                var UID = param.UID, storeCode = param.storeCode, receipt = param.receipt, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                var _this = this;
                return _async_to_generator._(function() {
                    var body, checkURL;
                    return _ts_generator._(this, function(_state) {
                        _this.checkInit();
                        if (!UID) {
                            throw new Error("You should provide a non null uid");
                        }
                        body = (0, pickBy_1.default)({
                            receipt: receipt
                        });
                        checkURL = "".concat(fido_1.fido.getBaseUrl("stores"), "/customers/").concat(fido_1.fido.get("customerCode"), "/platforms/").concat(fido_1.fido.get("platformCode"), "/users/").concat(UID, "/stores/").concat(storeCode, "/check");
                        return [
                            2,
                            _this.fetch(checkURL, {
                                method: "POST",
                                body: body,
                                headers: headers
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "initPaymentMeanChange",
            value: /**
     * Initiate change of payment mean
     * @async
     *
     * @param {Object} options Object containing the user and the store code
     * @returns {Object}
     * @tutorial ./doc/initPaymentMeanChange.md
     */ function initPaymentMeanChange(param) {
                var user = param.user, offerCode = param.offerCode, storeCode = param.storeCode, returnUrl = param.returnUrl, paymentMethodType = param.paymentMethodType, paymentMethodCode = param.paymentMethodCode, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                var _this = this;
                return _async_to_generator._(function() {
                    var apiURL, filteredParams, body;
                    return _ts_generator._(this, function(_state) {
                        _this.checkInit();
                        if (!user.UID) {
                            throw new Error("You should provide a non null user uid");
                        }
                        if (!storeCode) {
                            throw new Error("You should provide a non null store code");
                        }
                        apiURL = "".concat(fido_1.fido.getBaseUrl("stores"), "/customers/").concat(fido_1.fido.get("customerCode"), "/platforms/").concat(fido_1.fido.get("platformCode"), "/users/").concat(user.UID, "/stores/").concat(storeCode, "/initPaymentChange");
                        // remove unnecessary falsy values
                        filteredParams = (0, pickBy_1.default)({
                            returnUrl: returnUrl,
                            paymentMethodType: paymentMethodType,
                            paymentMethodCode: paymentMethodCode,
                            offerCode: offerCode
                        });
                        body = Object.keys(filteredParams).reduce(function(acc, paramKey) {
                            return Object.assign(Object.assign({}, acc), _define_property._({}, (0, snakeCase_1.default)(paramKey), filteredParams[paramKey]));
                        }, {});
                        return [
                            2,
                            _this.fetch(apiURL, {
                                method: "POST",
                                headers: headers,
                                body: body
                            })
                        ];
                    });
                })();
            }
        }
    ]);
    return PremiumService;
}(fetcherService_1.FetcherService);
exports.PremiumService = PremiumService;
__decorate([
    withJWT_1.withJWT,
    monitoring
], PremiumService.prototype, "getOffers", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], PremiumService.prototype, "getOrder", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], PremiumService.prototype, "changeOffer", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], PremiumService.prototype, "cancelDowngrade", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], PremiumService.prototype, "getUserAccess", null);
__decorate([
    withJWT_1.withJWT,
    caching_1.withNoParallelRequest,
    monitoring
], PremiumService.prototype, "getUserSubscriptions", null);
__decorate([
    withJWT_1.withJWT,
    caching_1.withNoParallelRequest,
    monitoring
], PremiumService.prototype, "getUserSubscriptionsAfterPaymentUpdate", null);
__decorate([
    withJWT_1.withJWT,
    caching_1.withNoParallelRequest,
    monitoring
], PremiumService.prototype, "getUserInvoices", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], PremiumService.prototype, "downloadInvoice", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], PremiumService.prototype, "cancelSubscription", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], PremiumService.prototype, "resumeSubscription", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], PremiumService.prototype, "consumeCouponCode", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], PremiumService.prototype, "verifyCoupon", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], PremiumService.prototype, "pay", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], PremiumService.prototype, "check", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], PremiumService.prototype, "initPaymentMeanChange", null);
exports.premiumService = new PremiumService();


/***/ }),

/***/ 62762:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(88801);
var __decorate = (void 0) && (void 0).__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.programService = void 0;
var fido_1 = __webpack_require__(19322);
var queryParamSerializer_1 = __webpack_require__(19007);
var withJWT_1 = __webpack_require__(56282);
var fetcherService_1 = __webpack_require__(96571);
var withMonitoring_1 = __webpack_require__(97982);
var monitoring = (0, withMonitoring_1.withMonitoring)("program");
/**
 * @module Program
 * @description This service is used to get program details from middleware API
 * @tutorial ./doc/program.md
 */ var ProgramService = /*#__PURE__*/ function(_fetcherService_1_FetcherService) {
    _inherits._(ProgramService, _fetcherService_1_FetcherService);
    var _super = _create_super._(ProgramService);
    function ProgramService() {
        _class_call_check._(this, ProgramService);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.apiType = "middlewarev2";
        return _this;
    }
    _create_class._(ProgramService, [
        {
            /**
     * Initialize the service. If you don't call this method, no other method can be called.
     * @tutorial ./doc/programInit.md
     */ key: "init",
            value: function init() {
                if (!this.isInitialized) {
                    this.basePath = "platforms/".concat(fido_1.fido.get("platformCode"), "/services");
                    this.isInitialized = true;
                }
            }
        },
        {
            key: "fetchByProgramId",
            value: /**
     * Get information about the program designated by the programId.
     *
     * @async
     * @param {Object} options Options for fetching program by ID.
     * @param {string} options.programId Requested program id.
     * @param {string} options.serviceCode Service where the information should be retrieved from.
     * @param {Object} [options.queryParams={}] Extra query parameters. Uses keys/values literally as provided in the object.
     * @param {Object} [options.headers={}] Optional HTTP headers.
     * @returns {Object} Informations about the program.
     * @tutorial ./doc/programFetchByProgramId.md
     */ function fetchByProgramId(param) {
                var programId = param.programId, serviceCode = param.serviceCode, _param_queryParams = param.queryParams, queryParams = _param_queryParams === void 0 ? {} : _param_queryParams, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        if (!programId) {
                            throw new Error("You should provide a non null programId");
                        }
                        return [
                            2,
                            _this.fetch(_this.getRouteUrl("".concat(serviceCode, "/programs/").concat(programId, "?").concat((0, queryParamSerializer_1.serialize)(queryParams))), {
                                method: "GET",
                                headers: headers
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "fetchPrograms",
            value: /**
     * Get a list of programs
     *
     * @async
     * @param {Object} options Options for fetching programs.
     * @param {string} options.serviceCode Service where the information should be retrieved from.
     * @param {string} options.csa Age rating parameter.
     * @param {number} options.offset Starting item for pagination.
     * @param {number} options.limit Maximum number of items to return for pagination.
     * @param {string} [options.firstLetter] Filter programs by their first letter.
     * @param {boolean} [options.withRights=false] Whether to include user rights information.
     * @param {Object} [options.headers={}] Optional HTTP headers.
     * @returns {Object} List of programs.
     * @tutorial ./doc/programFetchPrograms.md
     */ function fetchPrograms(param) {
                var serviceCode = param.serviceCode, csa = param.csa, offset = param.offset, limit = param.limit, firstLetter = param.firstLetter, _param_withRights = param.withRights, withRights = _param_withRights === void 0 ? false : _param_withRights, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!serviceCode) {
                                    throw new Error("You should provide a service code");
                                }
                                if (!csa) {
                                    throw new Error("You should provide a csa code");
                                }
                                if (typeof offset !== "number" || isNaN(offset)) {
                                    throw new Error("You should provide a valid numeric offset");
                                }
                                if (typeof limit !== "number" || isNaN(limit)) {
                                    throw new Error("You should provide a valid numeric limit");
                                }
                                return [
                                    4,
                                    _this.fetchWithResponse(_this.getRouteUrl("".concat(serviceCode, "/programs?csa=").concat(csa, "&offset=").concat(offset, "&limit=").concat(limit).concat(firstLetter ? "&firstLetter=".concat(firstLetter) : "").concat(withRights ? "&with=rights" : "")), {
                                        method: "GET",
                                        headers: headers
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "fetchProgramCountsByLetter",
            value: /**
     * Returns an object containing the numbers of programs for each letter of the alphabet and "@".
     *
     * @async
     * @param {Object} options Options for fetching program counts by letter.
     * @param {string} options.serviceCode Service where the information should be retrieved from.
     * @param {string} options.csa Age rating parameter.
     * @param {Object} [options.headers={}] Optional HTTP headers.
     * @returns {Object} List of programs.
     * @tutorial ./doc/programFetchProgramCountsByLetter.md
     */ function fetchProgramCountsByLetter(param) {
                var serviceCode = param.serviceCode, csa = param.csa, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!serviceCode) {
                                    throw new Error("You should provide a service code");
                                }
                                if (!csa) {
                                    throw new Error("You should provide a csa code");
                                }
                                return [
                                    4,
                                    _this.fetch(_this.getRouteUrl("".concat(serviceCode, "/programs/first-letters?csa=").concat(csa)), {
                                        method: "GET",
                                        headers: headers
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return ProgramService;
}(fetcherService_1.FetcherService);
__decorate([
    withJWT_1.withJWT,
    monitoring
], ProgramService.prototype, "fetchByProgramId", null);
__decorate([
    monitoring
], ProgramService.prototype, "fetchPrograms", null);
__decorate([
    monitoring
], ProgramService.prototype, "fetchProgramCountsByLetter", null);
exports.programService = new ProgramService();


/***/ }),

/***/ 19770:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
var __decorate = (void 0) && (void 0).__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.searchAiService = exports.SearchAiService = void 0;
var fido_1 = __webpack_require__(19322);
var withJWT_1 = __webpack_require__(56282);
var fetcherService_1 = __webpack_require__(96571);
var withMonitoring_1 = __webpack_require__(97982);
var monitoring = (0, withMonitoring_1.withMonitoring)("searchAi");
/**
 * @module SearchAi
 * @description The Search Ai service will return a query and filters
 * @tutorial ./doc/searchAi.md
 */ var SearchAiService = /*#__PURE__*/ function(_fetcherService_1_FetcherService) {
    _inherits._(SearchAiService, _fetcherService_1_FetcherService);
    var _super = _create_super._(SearchAiService);
    function SearchAiService() {
        _class_call_check._(this, SearchAiService);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.apiType = "searchAi";
        return _this;
    }
    _create_class._(SearchAiService, [
        {
            key: "init",
            value: function init() {
                if (!this.isInitialized) {
                    this.isInitialized = true;
                }
            }
        },
        {
            key: "getSearchAiResults",
            value: function getSearchAiResults(param) {
                var headers = param.headers, query = param.query, filters = param.filters, waitTimeout = param.waitTimeout;
                var _this = this;
                return _async_to_generator._(function() {
                    var searchAiUrl;
                    return _ts_generator._(this, function(_state) {
                        _this.checkInit();
                        searchAiUrl = fido_1.fido.getBaseUrl(_this.apiType);
                        return [
                            2,
                            _this.fetch(searchAiUrl, {
                                method: "POST",
                                headers: headers,
                                body: {
                                    query: query,
                                    filters: filters
                                },
                                waitTimeout: waitTimeout
                            })
                        ];
                    });
                })();
            }
        }
    ]);
    return SearchAiService;
}(fetcherService_1.FetcherService);
exports.SearchAiService = SearchAiService;
__decorate([
    withJWT_1.withJWT,
    monitoring
], SearchAiService.prototype, "getSearchAiResults", null);
exports.searchAiService = new SearchAiService();


/***/ }),

/***/ 72:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(37815);
var __decorate = (void 0) && (void 0).__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.servicesService = void 0;
var fido_1 = __webpack_require__(19322);
var fetcherService_1 = __webpack_require__(96571);
var withMonitoring_1 = __webpack_require__(97982);
var monitoring = (0, withMonitoring_1.withMonitoring)("services");
/**
 * @module Services
 * @description This service is used to get the service list from middleware API
 */ var ServicesService = /*#__PURE__*/ function(_fetcherService_1_FetcherService) {
    _inherits._(ServicesService, _fetcherService_1_FetcherService);
    var _super = _create_super._(ServicesService);
    function ServicesService() {
        _class_call_check._(this, ServicesService);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.apiType = "middlewarev2";
        return _this;
    }
    _create_class._(ServicesService, [
        {
            /**
     * Initialize the service. If you don't call this method, no other method can be called.
     */ key: "init",
            value: function init() {
                if (!this.isInitialized) {
                    this.basePath = "platforms/".concat(fido_1.fido.get("platformCode"), "/services");
                    this.isInitialized = true;
                }
            }
        },
        {
            key: "fetchServices",
            value: /**
     * Get a list of children services of your root service
     *
     * @async
     * @param {Object} options Options for fetching services.
     * @param {string} options.rootServiceCode Root service code (main entry point of the application, e.g., "6play").
     * @param {boolean} [options.includeAliased] Filter aliased services. If not provided, only not aliased services are returned.
     *   0: Return only not aliased services. 1: Return all the services.
     * @param {Object} [options.headers={}] Optional HTTP headers.
     * @returns {Promise<Array>} Returns an array of services sorted by priority with channels information, can be empty.
     * @throws {Error} Throws an error if rootServiceCode is not provided.
     * @throws {Error} Throws an error with status 404 if root service is not found.
     */ function fetchServices(param) {
                var rootServiceCode = param.rootServiceCode, includeAliased = param.includeAliased, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!rootServiceCode) {
                                    throw new Error("You should provide a root service code");
                                }
                                return [
                                    4,
                                    _this.fetch(_this.getRouteUrl("".concat(rootServiceCode, "/services?sort=priority&with=channels").concat(includeAliased !== undefined ? "&include_aliased=".concat(includeAliased ? 1 : 0) : "")), {
                                        method: "GET",
                                        headers: headers
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "fetchService",
            value: /**
     * Get a single service from its code
     *
     * @async
     * @param {Object} options Options for fetching a service.
     * @param {string} options.serviceCode Service code to retrieve.
     * @param {Object} [options.headers={}] Optional HTTP headers.
     * @returns {Promise<Object>} Returns a single service with channels information.
     * @throws {Error} Throws an error if serviceCode is not provided.
     * @throws {Error} Throws an error with status 404 if service is not found.
     */ function fetchService(param) {
                var serviceCode = param.serviceCode, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!serviceCode) {
                                    throw new Error("You should provide a service code");
                                }
                                return [
                                    4,
                                    _this.fetch(_this.getRouteUrl("".concat(serviceCode, "?with=channels")), {
                                        method: "GET",
                                        headers: headers
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return ServicesService;
}(fetcherService_1.FetcherService);
__decorate([
    monitoring
], ServicesService.prototype, "fetchServices", null);
__decorate([
    monitoring
], ServicesService.prototype, "fetchService", null);
exports.servicesService = new ServicesService();


/***/ }),

/***/ 33415:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(3009);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.SimpleFetcherService = void 0;
var fetch_1 = __webpack_require__(27082);
var withMonitoring_1 = __webpack_require__(97982);
var fetcherService_1 = __webpack_require__(96571);
var SimpleFetcherService = /*#__PURE__*/ function(_fetcherService_1_FetcherService) {
    _inherits._(SimpleFetcherService, _fetcherService_1_FetcherService);
    var _super = _create_super._(SimpleFetcherService);
    function SimpleFetcherService(serviceName) {
        var basePath = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
        _class_call_check._(this, SimpleFetcherService);
        var _this;
        _this = _super.call(this);
        if (!serviceName) {
            throw new Error("You have to instantiate this Fido's service with its name before using it");
        }
        _this.displayName = "".concat(serviceName.charAt(0).toUpperCase() + serviceName.slice(1), "Service");
        _this.apiType = serviceName;
        _this.basePath = basePath;
        return _this;
    }
    _create_class._(SimpleFetcherService, [
        {
            /**
     * Initialize the service. If you don't call this method, no other method can be called.
     */ key: "init",
            value: function init() {
                if (!this.isInitialized) {
                    this.isInitialized = true;
                    this.monitored = (0, withMonitoring_1.withMonitoring)(this.apiType);
                }
            }
        },
        {
            /**
     * Call the endpoint of the service and return the response.
     *
     * @async
     * @param {Object=} options Contains a `headers` key to add some headers in the request.
     * @returns {Object} The response object.
     */ key: "fetch",
            value: function fetch() {
                var headers = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).headers;
                var url = this.getRouteUrl();
                return this.monitored(SimpleFetcherService.prototype, "fetch", {
                    value: function() {
                        return (0, fetch_1.fetch)(url, {
                            method: "GET",
                            headers: headers
                        }).then(function(param) {
                            var body = param.body;
                            return body;
                        });
                    }
                }).value();
            }
        }
    ]);
    return SimpleFetcherService;
}(fetcherService_1.FetcherService);
exports.SimpleFetcherService = SimpleFetcherService;


/***/ }),

/***/ 44251:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _to_consumable_array = __webpack_require__(30005);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(88801);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.AbstractThirdPartyInterface = void 0;
var constants_1 = __webpack_require__(27668);
/**
 * @module AbstractThirdPartyInterface
 * @description ThirdPartyController engines methods subscriptions.
 * @abstract
 */ // eslint-disable-next-line @typescript-eslint/no-unsafe-declaration-merging
var AbstractThirdPartyInterface = /*#__PURE__*/ function() {
    function AbstractThirdPartyInterface() {
        _class_call_check._(this, AbstractThirdPartyInterface);
    }
    _create_class._(AbstractThirdPartyInterface, [
        {
            key: "getAdTargeting",
            value: /**
     * Triggers every getAdTargeting methods in initialized engines.
     */ function getAdTargeting() {
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        return [
                            2,
                            Promise.all(_this.callEnginesMethod("getAdTargeting")()).then(function(targetings) {
                                return targetings.reduce(function(finalTargeting, targeting) {
                                    return Object.assign(Object.assign({}, finalTargeting), targeting);
                                }, {});
                            })
                        ];
                    });
                })();
            }
        }
    ]);
    return AbstractThirdPartyInterface;
}();
exports.AbstractThirdPartyInterface = AbstractThirdPartyInterface;
Object.keys(constants_1.ENGINES_EVENT_METHODS).forEach(function(key) {
    AbstractThirdPartyInterface.prototype[key] = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return this.callEnginesEventMethod(constants_1.ENGINES_EVENT_METHODS[key]).apply(this, _to_consumable_array._(args));
    };
});
Object.keys(constants_1.ENGINES_METHODS).forEach(function(key) {
    AbstractThirdPartyInterface.prototype[key] = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return this.callEnginesMethod(constants_1.ENGINES_METHODS[key]).apply(this, _to_consumable_array._(args));
    };
});


/***/ }),

/***/ 48771:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(45538);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.AbstractTrackingEngine = void 0;
var utils_1 = __webpack_require__(9942);
var AbstractTrackingEngine = /*#__PURE__*/ function() {
    function AbstractTrackingEngine() {
        _class_call_check._(this, AbstractTrackingEngine);
        this.currentVariants = [];
        this.attributesKeysMapping = {};
        /**
         * List of defined events in the tagging plan.
         */ this.events = {};
        this.userProfile = {};
    }
    _create_class._(AbstractTrackingEngine, [
        {
            /**
     *
     * @param {object} deviceAttributes Key/Value mapping to path attributes to tealium which are releated to the current device of the user on each events (for exemple browser_version)
     * @param {Object} events Tagging plan definition use
     * @param {object=} attributesKeysMapping Mapping of generic Front attributes name with thirdparty related attribute
     * @param {boolean=} isDeviceBrowser Does the device have global object `window` and `document defined`
     * @param {array} initialAbTestVariants Current A/BTests variants for the user.
     */ key: "init",
            value: function init(param) {
                var _param_deviceAttributes = param.deviceAttributes, deviceAttributes = _param_deviceAttributes === void 0 ? {} : _param_deviceAttributes, _param_events = param.events, events = _param_events === void 0 ? {} : _param_events, _param_attributesKeysMapping = param.attributesKeysMapping, attributesKeysMapping = _param_attributesKeysMapping === void 0 ? {} : _param_attributesKeysMapping, _param_isDeviceBrowser = param.isDeviceBrowser, isDeviceBrowser = _param_isDeviceBrowser === void 0 ? false : _param_isDeviceBrowser, _param_initialAbTestVariants = param.initialAbTestVariants, initialAbTestVariants = _param_initialAbTestVariants === void 0 ? [] : _param_initialAbTestVariants;
                this.events = events;
                this.currentVariants = initialAbTestVariants;
                this.isDeviceBrowser = isDeviceBrowser;
                this.deviceAttributes = deviceAttributes;
                this.attributesKeysMapping = attributesKeysMapping;
            }
        },
        {
            /**
     * @param {Object} user Contains the user data including his variants.
     */ key: "setUser",
            value: function setUser(param) {
                var variants = param.variants, profile = param.profile;
                this.userProfile = profile;
                this.currentVariants = variants;
            }
        },
        {
            /**
     * Generator of browser dimensions for devices with `window` and `document` object defined.
     */ key: "getBrowserLayer",
            value: function getBrowserLayer() {
                var getUserAgent = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                if (this.isDeviceBrowser) {
                    var _ref = (0, utils_1.getSanitizedPageUrl)(window.location.href), pageUrl = _ref.url, pageQueryParams = _ref.search;
                    return Object.assign({
                        "dom.url": pageUrl,
                        page_url: pageUrl,
                        page_path: window.location.pathname,
                        page_title: document.title,
                        page_query_params: pageQueryParams,
                        referrer: document.referrer,
                        device_resolution: "".concat(window.screen.width, "x").concat(window.screen.height),
                        viewport_size: "".concat(window.innerWidth, "x").concat(window.innerHeight),
                        pixel_depth: window.screen.pixelDepth,
                        device_language: navigator.language
                    }, getUserAgent && {
                        user_agent: navigator.userAgent
                    });
                }
                return {};
            }
        }
    ]);
    return AbstractTrackingEngine;
}();
exports.AbstractTrackingEngine = AbstractTrackingEngine;


/***/ }),

/***/ 27668:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(37815);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.TEALIUM_MAPPING = exports.ENGINES_METHODS = exports.ENGINES_EVENT_METHODS = exports.DEPENDANT_ENGINES = exports.DEFAULT_INIT_DELAY_IN_MS = exports.NAMESPACE_ERROR = exports.MOCK_THIRDPARTY_OBJECT_KEY = void 0;
exports.MOCK_THIRDPARTY_OBJECT_KEY = "thirdParties";
exports.NAMESPACE_ERROR = "app:thirdParties:error";
exports.DEFAULT_INIT_DELAY_IN_MS = 5000;
exports.DEPENDANT_ENGINES = [
    "googleAds"
];
exports.ENGINES_EVENT_METHODS = {
    sendEvent: "sendEvent",
    sendClickEvent: "sendClickEvent",
    sendPrintEvent: "sendPrintEvent",
    sendImpressionTrackingEvent: "sendImpressionTrackingEvent"
};
exports.ENGINES_METHODS = {
    // Send an error event to the third party engine
    sendErrorEvent: "sendErrorEvent",
    // Track a page display.
    sendPageViewEvent: "sendPageViewEvent",
    // disabledEngine seems to be used to disallow engines when user optout
    disableEngine: "disableEngine",
    getEpics: "getEpics",
    // Called when you login / logout / change profil and provides some data specific for the user like ABTests, UUID, ...
    userChange: "setUser",
    // Called chen the gdpr consents changed
    gdprChange: "gdprChange",
    // Calls the GA engine setContentGroup method with data coming from layout
    setContentGroup: "setContentGroup",
    // Set specific attribute sent to all events
    setCustomAttributes: "setCustomAttributes",
    getCustomAttributes: "getCustomAttributes",
    setEnhancedECommerceAction: "setEnhancedECommerceAction",
    setEnhancedECommerceAddProduct: "setEnhancedECommerceAddProduct",
    setEnhancedECommerceProductCheckout: "setEnhancedECommerceProductCheckout",
    setEnhancedECommerceProductPurchase: "setEnhancedECommerceProductPurchase"
};
/**
 * Definition of mapping between analytics.googleAnalytics parameters to tealium attributes.
 * As Bff is not currently able to return a dedicate analytic node for Server Side Analytics Tealium for now,
 * we need to map attributes names.
 */ exports.TEALIUM_MAPPING = {
    dimension1: "gigya_id",
    dimension2: "device_id",
    dimension3: "ip_hashed",
    dimension4: "bedrock_platform_code",
    dimension5: "authenticated",
    dimension6: "user_type",
    dimension7: "freemium_pack",
    dimension8: "persona",
    dimension9: "auth_method",
    dimension10: "current_entity_type",
    dimension11: "service",
    dimension12: "publication_type",
    dimension13: "clip_type",
    dimension14: "program_category",
    dimension15: "program_title",
    dimension16: "clip_title",
    dimension17: "clip_id",
    dimension18: "player_audio",
    dimension19: "player_subtitles",
    dimension20: "position",
    dimension21: "first_connexion",
    dimension22: "player_screen_mode",
    dimension23: "support",
    dimension24: "template_name",
    dimension25: "cast",
    dimension26: "autoplay",
    dimension27: "switch_language",
    dimension28: "subtitle_active",
    dimension29: "from",
    dimension30: "ad_blocker",
    dimension31: "block_title",
    dimension32: "profile_id",
    dimension33: "layout_id",
    dimension34: "user_status",
    dimension35: "section",
    dimension36: "user_segments",
    dimension37: "operator",
    dimension38: "tv_brand",
    dimension39: "user_agent",
    dimension40: "tv_year",
    dimension41: "connection_type",
    dimension42: "device_orientation",
    dimension43: "app_version",
    dimension44: "app_os_version",
    dimension45: "network_id",
    dimension46: "block_rank",
    dimension47: "box_type",
    dimension48: "survey_id",
    dimension49: "app_referer",
    dimension50: "heartbeat_session",
    dimension51: "a_b_test",
    dimension52: "next_video",
    dimension53: "current_entity_id",
    dimension54: "player_current_timecode",
    dimension55: "airplay",
    dimension56: "picture_in_picture",
    dimension57: "offers_name",
    dimension58: "previous_offers",
    dimension59: "user_age",
    dimension60: "user_gender",
    dimension61: "user_offer",
    dimension62: "user_offers_number",
    dimension63: "gdpr_consent_tracking",
    dimension64: "gdpr_consent_adtargeting",
    dimension65: "age_restriction",
    dimension66: "consent_level",
    dimension67: "timestamp",
    dimension68: "analytics_cookie_value",
    dimension69: "current_page_group_types",
    dimension70: "device_model",
    dimension71: "content_status",
    dimension72: "salesforce_user_id",
    dimension73: "program_customer_key_id",
    dimension74: "special_event_name",
    dimension75: "clip_customer_key_id",
    eventAction: "event_action",
    eventLabel: "event_label",
    eventCategory: "event_category",
    listOfBlockViewed: "list_of_block_viewed",
    listOfItemViewed: "list_of_item_viewed",
    pageName: "page_name"
};


/***/ }),

/***/ 76012:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(37815);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.googleAttributesValuesMapping = void 0;
var yesOrNo = function(value) {
    return value ? "yes" : "no";
};
exports.googleAttributesValuesMapping = {
    adBlockEnabled: yesOrNo,
    isNewUser: yesOrNo
};


/***/ }),

/***/ 33350:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _define_property = __webpack_require__(21228);
var _get = __webpack_require__(60528);
var _get_prototype_of = __webpack_require__(35196);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
var __importDefault = (void 0) && (void 0).__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var get_1 = __importDefault(__webpack_require__(65439));
var isEmpty_1 = __importDefault(__webpack_require__(82691));
var isNil_1 = __importDefault(__webpack_require__(46207));
var omitBy_1 = __importDefault(__webpack_require__(24465));
var fido_1 = __webpack_require__(19322);
var fetch_1 = __webpack_require__(27082);
var queryParamSerializer_1 = __webpack_require__(19007);
var abstractTrackingEngine_1 = __webpack_require__(48771);
var constants_1 = __webpack_require__(27668);
var googleAttributesMappings_constant_1 = __webpack_require__(76012);
var event_utils_1 = __webpack_require__(24859);
var gaAttributesToTealium_1 = __webpack_require__(21164);
var utils_1 = __webpack_require__(9942);
var isBlockerError = function(error) {
    var isTimeout = error && error.message && error.message.includes("timeout");
    /*
     * when there is no status code, there is probability that the call was blocked
     * except in the case of timeout
     */ return !(0, get_1.default)(error, "response.status") && !isTimeout;
};
/**
 * @module SsaTealiumHttp
 * @description A service used to forward data to Server Side Analytics solution tealium hover http
 */ var SsaTealiumHttp = /*#__PURE__*/ function(_abstractTrackingEngine_1_AbstractTrackingEngine) {
    _inherits._(SsaTealiumHttp, _abstractTrackingEngine_1_AbstractTrackingEngine);
    var _super = _create_super._(SsaTealiumHttp);
    function SsaTealiumHttp() {
        _class_call_check._(this, SsaTealiumHttp);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.customAttributes = {};
        _this.tealiumAttributes = {};
        _this.attributesValuesMapping = {};
        _this.snowplowLayer = {};
        _this.eventsWaitingList = [];
        _this.retryingBatchingEvents = false;
        _this.isSendingBatchedEvents = false;
        return _this;
    }
    _create_class._(SsaTealiumHttp, [
        {
            /**
     * Initialization method for the SsaTealiumHttp service
     *
     * @param {Object} params
     * @param {string=} params.endpoint Base url used for sending events to tealium (Could be used for proxying tealium to a new domain)
     * @param {string=} params.batchingEndpoint Base url used for sending batched events to tealium (Can also be used for proxying tealium to another domain)
     * @param {string} params.env Environment passed to Tealium attribute named `teamlium_envrionment`
     * @param {string} params.account Account passed to Tealium attribute named `teamlium_account`
     * @param {string} params.dataSource Datasource id passed to Tealium attribute named `teamlium_datasource`
     * @param {string} params.profile Profile name passed to Tealium attribute named `teamlium_profile`
     * @param {string} params.traceId TraceId passed to Tealium attribute named `teamlium_traceid` for session debugging
     * @param {string=} params.thirdPartyKey Key used in the BFF analytics node to get current attribute (default `googleAnalytics)`
     * @param {object} params.deviceConsents Current device consent fetched from the user consent API.
     * @param {string=} params.backendEventName Name of the generic Backend event when event is completely driven by analytics node from BFF API
     * @param {string=} params.eventNameAttribute Name of the attribute in the tagging plan that refers to the tealium event name that we sent as `tealium_event`
     * @param {string=} params.httpMethod Current HTTP method used.
     * @param {boolean=} params.isBatchingEnabled If true, events will be batched and sent every second.
     * @param {number=} params.batchingInterval Interval in milliseconds between each batched event.
     * @param {object=} params.additionalGenericAttributes Additional generic attributes to send along every tealium call
     *
     * @tutorial ./doc/initSsaTealiumHttp.md
     */ key: "init",
            value: function init(params) {
                var _this = this;
                var _params_endpoint = params.endpoint, endpoint = _params_endpoint === void 0 ? "https://collect.tealiumiq.com/event" : _params_endpoint, _params_batchingEndpoint = params.batchingEndpoint, batchingEndpoint = _params_batchingEndpoint === void 0 ? "https://collect.tealiumiq.com/bulk-event" : _params_batchingEndpoint, env = params.env, account = params.account, dataSource = params.dataSource, profile = params.profile, _params_traceId = params.traceId, traceId = _params_traceId === void 0 ? null : _params_traceId, _params_thirdPartyKey = params.thirdPartyKey, thirdPartyKey = _params_thirdPartyKey === void 0 ? "googleAnalytics" : _params_thirdPartyKey, deviceConsents = params.deviceConsents, _params_backendEventName = params.backendEventName, backendEventName = _params_backendEventName === void 0 ? "layout_event" : _params_backendEventName, _params_eventNameAttribute = params.eventNameAttribute, eventNameAttribute = _params_eventNameAttribute === void 0 ? "eventName" : _params_eventNameAttribute, _params_initialAbTestVariants = params.initialAbTestVariants, initialAbTestVariants = _params_initialAbTestVariants === void 0 ? [] : _params_initialAbTestVariants, _params_httpMethod = params.httpMethod, httpMethod = _params_httpMethod === void 0 ? "GET" : _params_httpMethod, _params_googleAnalyticsTrackersIds = params.googleAnalyticsTrackersIds, googleAnalyticsTrackersIds = _params_googleAnalyticsTrackersIds === void 0 ? [] : _params_googleAnalyticsTrackersIds, _params_isSnowplowEnabled = params.isSnowplowEnabled, isSnowplowEnabled = _params_isSnowplowEnabled === void 0 ? false : _params_isSnowplowEnabled, _params_isBatchingEnabled = params.isBatchingEnabled, isBatchingEnabled = _params_isBatchingEnabled === void 0 ? false : _params_isBatchingEnabled, _params_batchingInterval = params.batchingInterval, batchingInterval = _params_batchingInterval === void 0 ? 1000 : _params_batchingInterval, _params_additionalGenericAttributes = params.additionalGenericAttributes, additionalGenericAttributes = _params_additionalGenericAttributes === void 0 ? {} : _params_additionalGenericAttributes;
                this.isSnowplowEnabled = isSnowplowEnabled;
                this.endpoint = endpoint;
                this.batchingEndpoint = batchingEndpoint;
                this.thirdPartyKey = thirdPartyKey;
                this.attributesValuesMapping = googleAttributesMappings_constant_1.googleAttributesValuesMapping;
                this.backendEventName = backendEventName;
                this.deviceId = fido_1.fido.get("localDeviceId") || fido_1.fido.get("localHomeId");
                this.eventNameAttribute = eventNameAttribute;
                this.gdprChange(deviceConsents);
                this.currentVariants = initialAbTestVariants;
                this.httpMethod = httpMethod;
                this.googleAnalyticsTrackersIds = googleAnalyticsTrackersIds;
                _get._(_get_prototype_of._(SsaTealiumHttp.prototype), "init", this).call(this, params);
                this.sessionId = this.getSessionId();
                this.isBatchingEnabled = isBatchingEnabled;
                this.additionalGenericAttributes = additionalGenericAttributes;
                this.tealiumAttributes = {
                    tealium_account: account,
                    tealium_profile: profile,
                    tealium_environment: env,
                    tealium_visitor_id: this.deviceId,
                    tealium_datasource: dataSource,
                    tealium_trace_id: traceId
                };
                if (isBatchingEnabled) {
                    setInterval(function() {
                        _this.sendBatchedEvent();
                    }, batchingInterval);
                }
            }
        },
        {
            key: "sendBatchedEvent",
            value: /**
     * If batch events are enabled, this method is automatically run every ${batchingInterval} milliseconds.
     * It runs through all stored and yet unsent events, and sends them all at once.
     */ function sendBatchedEvent() {
                var _this = this;
                return _async_to_generator._(function() {
                    var eventsToSend, error;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (_this.eventsWaitingList.length === 0 || _this.isSendingBatchedEvents) {
                                    return [
                                        2,
                                        Promise.resolve()
                                    ];
                                }
                                // We lock down this function while sending, to prevent sending the same event multiple cases when the network is slow
                                _this.isSendingBatchedEvents = true;
                                // We are only allowed to send 10 events at a time
                                eventsToSend = _this.eventsWaitingList.slice(0, 10).map(function(param) {
                                    var allAttributes = param.allAttributes;
                                    return allAttributes;
                                });
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    (0, fetch_1.fetch)(_this.batchingEndpoint, {
                                        method: "POST",
                                        body: JSON.stringify({
                                            events: eventsToSend,
                                            shared: Object.assign({}, _this.tealiumAttributes)
                                        }),
                                        headers: {
                                            "Content-Type": "application/json"
                                        }
                                    }).then(function() {
                                        _this.eventsWaitingList.map(function(param) {
                                            var recordingProps = param.recordingProps;
                                            return (0, utils_1.storeThirdpartyCallForPlayground)(Object.assign({
                                                status: "SUCCESS"
                                            }, recordingProps));
                                        });
                                        // We only empty the list if events were successfully sent.
                                        _this.eventsWaitingList = _this.eventsWaitingList.slice(10);
                                        _this.retryingBatchingEvents = false;
                                        _this.isSendingBatchedEvents = false;
                                    }, function() {
                                        _this.eventsWaitingList.map(function(param) {
                                            var recordingProps = param.recordingProps;
                                            return (0, utils_1.storeThirdpartyCallForPlayground)(Object.assign({
                                                status: "FAILED"
                                            }, recordingProps));
                                        });
                                        if (_this.retryingBatchingEvents) {
                                            /*
                     * This means that it is the second time in a row an issue arose.
                     * In order to prevent overclogging the waiting list, we discard remaining events.
                     */ _this.retryingBatchingEvents = false;
                                            _this.eventsWaitingList = _this.eventsWaitingList.slice(10);
                                        } else {
                                            _this.retryingBatchingEvents = true;
                                        }
                                        _this.isSendingBatchedEvents = false;
                                    })
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 3:
                                error = _state.sent();
                                if (isBlockerError(error)) {
                                    _this.detectBlocker();
                                }
                                _this.eventsWaitingList.map(function(param) {
                                    var recordingProps = param.recordingProps;
                                    return (0, utils_1.storeThirdpartyCallForPlayground)(Object.assign({
                                        status: "FAILED"
                                    }, recordingProps));
                                });
                                if (_this.retryingBatchingEvents) {
                                    /*
                 * This means that it is the second time in a row an issue arose.
                 * In order to prevent overclogging the waiting list, we discard remaining events.
                 */ _this.retryingBatchingEvents = false;
                                    _this.eventsWaitingList = [];
                                } else {
                                    _this.retryingBatchingEvents = true;
                                }
                                _this.isSendingBatchedEvents = false;
                                /*
             * we do not use the error right now
             * so we avoid errors popping up on site on dev mode
             */ return [
                                    2,
                                    Promise.resolve()
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
     * Generic method to generate attributes related to device consents.
     * @see ThirdPartyControllerService
     *
     * @param {Object} deviceConsents Device consents structure received by the User consent API.
     */ key: "gdprChange",
            value: function gdprChange(deviceConsents) {
                if (deviceConsents) {
                    this.deviceConsents = {
                        gdpr_consent_tracking: (0, get_1.default)(deviceConsents, "tracking.consent"),
                        gdpr_consent_adtargeting: (0, get_1.default)(deviceConsents, "adTargeting.consent"),
                        gdpr_consent_multidevice_matching: (0, get_1.default)(deviceConsents, "multiDeviceMatching.consent"),
                        gdpr_consent_personalization: (0, get_1.default)(deviceConsents, "personalization.consent")
                    };
                }
            }
        },
        {
            /**
     * Generic method to either retrieve the user session id, or generate a new one.
     */ key: "getSessionId",
            value: function getSessionId() {
                var sessionId = parseInt(sessionStorage.getItem("tealium_session_id"), 10);
                if (!sessionId) {
                    var tealiumSessionIdLength = 13;
                    sessionId = Math.floor(Math.random() * Math.pow(10, tealiumSessionIdLength));
                    sessionStorage.setItem("tealium_session_id", sessionId);
                }
                return sessionId;
            }
        },
        {
            key: "setSnowplowLayer",
            value: function setSnowplowLayer() {
                var _this = this;
                return _async_to_generator._(function() {
                    var e;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    (0, utils_1.waitForGlobal)("isSnowplowInit")
                                ];
                            case 1:
                                _state.sent();
                                _this.snowplowLayer = {
                                    sp_session_id: (0, utils_1.getDualStorageValue)("sp_session_id"),
                                    sp_user_id: (0, utils_1.getDualStorageValue)("sp_user_id"),
                                    sp_previous_session_id: (0, utils_1.getDualStorageValue)("sp_previous_session_id"),
                                    sp_storage_mechanism: (0, utils_1.getDualStorageValue)("sp_storage_mechanism"),
                                    sp_page_id: (0, utils_1.getDualStorageValue)("sp_page_id"),
                                    sp_session_index: (0, utils_1.getDualStorageValue)("sp_session_index")
                                };
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                e = _state.sent();
                                // eslint-disable-next-line no-console
                                console.warn("Cannot retrieve Snowplow mandatory attributes, sdk is not initialised", e);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getGenericAttributes",
            value: function getGenericAttributes() {
                var gaAttributes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _a;
                return Object.assign(_define_property._({
                    a_b_test: this.currentVariants,
                    device_id: this.deviceId,
                    user_email: ((_a = this.userProfile) === null || _a === void 0 ? void 0 : _a.email) || "undefined"
                }, constants_1.TEALIUM_MAPPING.dimension72, (0, get_1.default)(gaAttributes, "dimension72", null)), this.additionalGenericAttributes);
            }
        },
        {
            key: "sendToTealium",
            value: /**
     * Generate the Http call to tealium http API
     *
     * @private
     * @param genericAttributes
     * @param specificAttributes
     * @returns {Promise | Promise<unknown>}
     */ function sendToTealium() {
                var genericAttributes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, specificAttributes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var _this = this;
                return _async_to_generator._(function() {
                    var allAttributes, recordingProps, queryStrings, error;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this.isSnowplowEnabled) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.setSnowplowLayer()
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                allAttributes = Object.assign(Object.assign({}, genericAttributes), _this.snowplowLayer);
                                recordingProps = {
                                    name: "tealium",
                                    isRecording: _this.isRecording,
                                    data: {
                                        allAttributes: (0, utils_1.sortObject)(allAttributes),
                                        specificAttributes: (0, utils_1.sortObject)(specificAttributes)
                                    }
                                };
                                _state.label = 3;
                            case 3:
                                _state.trys.push([
                                    3,
                                    7,
                                    ,
                                    8
                                ]);
                                if (!(_this.httpMethod === "GET")) return [
                                    3,
                                    5
                                ];
                                queryStrings = (0, queryParamSerializer_1.serialize)(allAttributes, function(param) {
                                    var value = param.value;
                                    return value != null;
                                });
                                return [
                                    4,
                                    (0, fetch_1.fetch)("".concat(_this.endpoint, "?").concat(queryStrings))
                                ];
                            case 4:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 5:
                                if (_this.isBatchingEnabled) {
                                    _this.eventsWaitingList.push({
                                        allAttributes: allAttributes,
                                        recordingProps: recordingProps
                                    });
                                    return [
                                        2,
                                        Promise.resolve()
                                    ];
                                }
                                return [
                                    4,
                                    (0, fetch_1.fetch)(_this.endpoint, {
                                        method: "POST",
                                        body: JSON.stringify(allAttributes),
                                        headers: {
                                            "Content-Type": "application/json"
                                        }
                                    }).then(function() {
                                        return (0, utils_1.storeThirdpartyCallForPlayground)(Object.assign({
                                            status: "SUCCESS"
                                        }, recordingProps));
                                    }, function() {
                                        return (0, utils_1.storeThirdpartyCallForPlayground)(Object.assign({
                                            status: "FAILED"
                                        }, recordingProps));
                                    })
                                ];
                            case 6:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 7:
                                error = _state.sent();
                                if (isBlockerError(error)) {
                                    _this.detectBlocker();
                                }
                                (0, utils_1.storeThirdpartyCallForPlayground)(Object.assign({
                                    status: "FAILED"
                                }, recordingProps));
                                /*
             * we do not use the error right now
             * so we avoid errors popping up on site on dev mode
             */ return [
                                    2,
                                    Promise.resolve()
                                ];
                            case 8:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getGoogleAnalyticsLayer",
            value: function getGoogleAnalyticsLayer() {
                var _a, _b, _c, _d;
                var firstGoogleAnalytics4Id = this.googleAnalyticsTrackersIds.find(function(id) {
                    return id.startsWith("G-");
                });
                var isGoogleAnalyticsVersion4 = !!firstGoogleAnalytics4Id;
                if (!isGoogleAnalyticsVersion4) {
                    return {};
                }
                var clientId = (_a = document.cookie.match(/_ga=GA1\.\d\.(.+?)(?:;|$)/)) === null || _a === void 0 ? void 0 : _a[1];
                var ga4TrackerId = firstGoogleAnalytics4Id.substring(2);
                var ga4SessionCookieRegexp = new RegExp("_ga_".concat(ga4TrackerId, "=GS\\d\\.\\d\\.(.+?)(?:;|$)"));
                var ga4SessionCookieContent = ((_b = document.cookie.match(ga4SessionCookieRegexp)) === null || _b === void 0 ? void 0 : _b[1]) || "";
                var gaData = ga4SessionCookieContent.split("$") || [];
                var sessionId = (_c = gaData.find(function(data) {
                    return data[0] === "s";
                })) === null || _c === void 0 ? void 0 : _c.substring(1);
                var sessionNumber = (_d = gaData.find(function(data) {
                    return data[0] === "o";
                })) === null || _d === void 0 ? void 0 : _d.substring(1);
                if (!sessionId || !sessionNumber) {
                    return {};
                }
                return {
                    ga_session_id: sessionId,
                    client_id: clientId,
                    ga_session_number: sessionNumber
                };
            }
        },
        {
            /**
     * Generic method to send page view event on user navigation.
     */ key: "sendPageViewEvent",
            value: function sendPageViewEvent(params, location) {
                var attributesByThirdParties = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                var basicLayer = Object.assign({
                    timestamp_unix_milliseconds: Date.now(),
                    tealium_session_id: this.sessionId,
                    tealium_event: "page_view"
                }, this.tealiumAttributes);
                this.currentPageLayer = this.getBrowserLayer();
                return this.sendToTealium(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, basicLayer), this.currentPageLayer), this.getGoogleAnalyticsLayer()), (0, gaAttributesToTealium_1.toTealiumAttributes)(this.customAttributes)), (0, gaAttributesToTealium_1.toTealiumAttributes)(attributesByThirdParties[this.thirdPartyKey])), this.deviceAttributes), this.deviceConsents), this.getGenericAttributes(attributesByThirdParties[this.thirdPartyKey])));
            }
        },
        {
            key: "getCustomAttributes",
            value: function getCustomAttributes(key) {
                if (key) {
                    return (0, utils_1.getCustomAttribute)(key, this.customAttributes, this.attributesKeysMapping);
                }
                return this.customAttributes;
            }
        },
        {
            /**
     * Update service custom attributes sent to tealium based on Mapping passed during init.
     * @see init
     * @tutorial ./doc/setCustomAttributes.md
     *
     * @param customAttributes Key/Value mapping of attributes from frontend that should be sent to next events.
     */ key: "setCustomAttributes",
            value: function setCustomAttributes(customAttributes) {
                if (!customAttributes) {
                    return;
                }
                this.customAttributes = Object.assign(Object.assign({}, this.customAttributes), (0, utils_1.transformAttributes)(customAttributes, this.attributesKeysMapping, this.attributesValuesMapping));
            }
        },
        {
            /**
     * Generic method to send event on user navigation.
     * @see ThirdPartyControllerService
     *
     * Events will be filtered with two conditions:
     * - If the event key from `params.key` is found in the tagging plan passed during init.
     * - or if `params` structure match bff analytic node (in this condition `tealium_event` will be
     */ key: "sendEvent",
            value: function sendEvent(params) {
                var action = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "automatic", eventFields = arguments.length > 2 ? arguments[2] : void 0, bffAnalyticAttributes = arguments.length > 3 ? arguments[3] : void 0;
                var isEventInTaggingPlan = params.key && !(0, isEmpty_1.default)(this.events[params.key]);
                var isBackendEvent = params[this.thirdPartyKey];
                if (!isEventInTaggingPlan && !isBackendEvent) {
                    return null;
                }
                var event = {};
                if (isBackendEvent) {
                    event = {
                        tealium_event: isBackendEvent[this.eventNameAttribute] || this.backendEventName
                    };
                }
                if (isEventInTaggingPlan) {
                    var eventInTaggingPlan = this.events[params.key];
                    var templatedEventAttributes = (0, event_utils_1.getTemplatedEvent)(eventInTaggingPlan, params);
                    event = Object.assign({
                        tealium_event: templatedEventAttributes[this.eventNameAttribute]
                    }, templatedEventAttributes);
                }
                var basicLayer = Object.assign(Object.assign({
                    timestamp_unix_milliseconds: Date.now(),
                    tealium_session_id: this.sessionId,
                    tealium_event_type: action
                }, this.tealiumAttributes), event);
                var customAttributes = Object.assign(Object.assign({}, this.customAttributes), (0, omitBy_1.default)(bffAnalyticAttributes[this.thirdPartyKey], isNil_1.default));
                if (isBackendEvent) {
                    customAttributes = Object.assign(Object.assign({}, customAttributes), params[this.thirdPartyKey]);
                }
                return this.sendToTealium(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, basicLayer), this.currentPageLayer || Object.assign({}, this.getBrowserLayer(true))), (0, gaAttributesToTealium_1.toTealiumAttributes)(customAttributes)), this.getGoogleAnalyticsLayer()), this.deviceAttributes), this.deviceConsents), this.getGenericAttributes(bffAnalyticAttributes[this.thirdPartyKey])), event);
            }
        },
        {
            /**
     * Generic method to send print event on user navigation.
     * @see ThirdPartyControllerService
     */ key: "sendPrintEvent",
            value: function sendPrintEvent(params, action, eventFields, attributesByThirdParties) {
                this.sendEvent(params, "automatic", eventFields, attributesByThirdParties);
            }
        },
        {
            /**
     * Generic method to send click event on user navigation.
     * @see ThirdPartyControllerService
     */ key: "sendClickEvent",
            value: function sendClickEvent(params, action, eventFields, attributesByThirdParties) {
                this.sendEvent(params, "click", eventFields, attributesByThirdParties);
            }
        },
        {
            /**
     * Generic method to send impression tracking event
     * @see ThirdPartyControllerService
     */ key: "sendImpressionTrackingEvent",
            value: function sendImpressionTrackingEvent(params, action, eventFields, attributesByThirdParties) {
                var basicLayer = Object.assign({
                    timestamp_unix_milliseconds: Date.now(),
                    tealium_session_id: this.sessionId,
                    tealium_event: "impression"
                }, this.tealiumAttributes);
                this.currentPageLayer = this.getBrowserLayer();
                return this.sendToTealium(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, basicLayer), this.currentPageLayer), this.getGoogleAnalyticsLayer()), (0, gaAttributesToTealium_1.toTealiumAttributes)(params)), (0, gaAttributesToTealium_1.toTealiumAttributes)(this.customAttributes)), (0, gaAttributesToTealium_1.toTealiumAttributes)(attributesByThirdParties[this.thirdPartyKey])), this.deviceAttributes), this.deviceConsents), this.getGenericAttributes(attributesByThirdParties[this.thirdPartyKey])));
            }
        }
    ]);
    return SsaTealiumHttp;
}(abstractTrackingEngine_1.AbstractTrackingEngine);
exports["default"] = new SsaTealiumHttp();


/***/ }),

/***/ 24859:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(65759);
var __importDefault = (void 0) && (void 0).__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.getTemplatedEvent = void 0;
var transform_1 = __importDefault(__webpack_require__(68742));
var sprintf_js_1 = __webpack_require__(24131);
var PARAM_REGEX = /^%\((\w+)\)(.)$/;
/**
 * Our tagging plans events might contain sprintf template strings that we want to replace with the correct values.
 *
 * @param {Object} event The event retrieved from the tagging plan.
 * @param {Object=} params The params passed to the send event method.
 * @returns {Object} The event transformed with templated values if any.
 */ var getTemplatedEvent = function(event, params) {
    return params ? (0, transform_1.default)(event, function(templatedParams, value, key) {
        var paramsRegex = PARAM_REGEX.exec(value);
        if (paramsRegex === null || paramsRegex[2] === "s") {
            templatedParams[key] = (0, sprintf_js_1.sprintf)(value, params);
        } else {
            templatedParams[key] = params[paramsRegex[1]];
        }
    }, {}) : event;
};
exports.getTemplatedEvent = getTemplatedEvent;


/***/ }),

/***/ 97813:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(52318);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.eventQueue = exports.EventQueue = void 0;
/**
 * @module EventQueue
 * @description EventQueue is dealing with the third party events queuing.
 * @abstract
 */ var EventQueue = /*#__PURE__*/ function() {
    function EventQueue() {
        var _this = this;
        _class_call_check._(this, EventQueue);
        /**
         * @param {ThirdParty} thirdParty
         * @returns {Boolean}
         */ this.commitEventQueueIfReady = function(thirdParty) {
            if (typeof thirdParty.engine !== "function" && (typeof thirdParty.engine.isReady !== "function" || thirdParty.engine.isReady() && thirdParty.eventQueue.length)) {
                if (thirdParty.eventQueueTimeout) {
                    clearTimeout(thirdParty.eventQueueTimeout);
                }
                while(thirdParty.eventQueue.length > 0){
                    thirdParty.eventQueue.pop()(thirdParty);
                }
                return true;
            }
            return false;
        };
        /**
         * Push an event to the third party queue
         * @param {ThirdParty} thirdParty
         * @param {any} e event
         */ this.queueEvent = function(thirdParty, e) {
            thirdParty.eventQueue.push(e);
            if (typeof thirdParty.engine !== "function" && typeof thirdParty.engine.isReady === "function" && !thirdParty.engine.isReady() && !thirdParty.eventQueueTimeout) {
                thirdParty.eventQueueTimeout = setTimeout(function() {
                    return _this.commitEventQueueIfReady(thirdParty);
                }, _this.queueDelay);
            }
        };
        /**
         * Clear event queue for each third party
         */ this.flushEvents = function() {
            var thirdParties = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
            return thirdParties.forEach(function(thirdParty) {
                thirdParty.eventQueue = [];
            });
        };
    }
    _create_class._(EventQueue, [
        {
            key: "init",
            value: function init(param) {
                var trackingInitDelay = param.trackingInitDelay;
                this.queueDelay = trackingInitDelay;
            }
        }
    ]);
    return EventQueue;
}();
exports.EventQueue = EventQueue;
exports.eventQueue = new EventQueue();


/***/ }),

/***/ 21164:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(52318);
var __importDefault = (void 0) && (void 0).__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.toTealiumAttributes = void 0;
var forOwn_1 = __importDefault(__webpack_require__(14287));
var get_1 = __importDefault(__webpack_require__(65439));
var constants_1 = __webpack_require__(27668);
/**
 * Utilitary method to transform googleAnalytics node to Tealium attributes.
 *
 * @param {Object} gaAttributes Key/Value object of attributes to map for Tealium.
 * @returns {Object} mapped attributes for server side.
 */ var toTealiumAttributes = function(gaAttributes) {
    var tealiumAttributes = {};
    (0, forOwn_1.default)(gaAttributes, function(value, key) {
        if (value != null) {
            tealiumAttributes[(0, get_1.default)(constants_1.TEALIUM_MAPPING, key, key)] = value;
        }
    });
    return tealiumAttributes;
};
exports.toTealiumAttributes = toTealiumAttributes;


/***/ }),

/***/ 59740:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _assert_this_initialized = __webpack_require__(99561);
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _to_consumable_array = __webpack_require__(30005);
var _create_super = __webpack_require__(6400);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(45538);
var __rest = (void 0) && (void 0).__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++){
        if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var __importDefault = (void 0) && (void 0).__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.thirdPartyControllerService = exports.ThirdPartyControllerService = exports.ENGINE_OVERRIDE_ERROR_MESSAGE = exports.INIT_ERROR_MESSAGE = void 0;
var get_1 = __importDefault(__webpack_require__(65439));
var has_1 = __importDefault(__webpack_require__(56611));
var noop_1 = __importDefault(__webpack_require__(43226));
var set_1 = __importDefault(__webpack_require__(35609));
var uuid_1 = __webpack_require__(16060);
var abstractThirdPartyInterface_1 = __webpack_require__(44251);
var constants_1 = __webpack_require__(27668);
var eventQueue_1 = __webpack_require__(97813);
var utils_1 = __webpack_require__(9942);
var DEFAULT_OPTIONS = {
    // eslint-disable-next-line no-console
    logger: console.info,
    sendErrorToMonitoring: noop_1.default,
    isRecording: false,
    detectBlocker: noop_1.default
};
var DEFAULT_CONFIG = {
    taggingPlans: {},
    initTrackingDelay: constants_1.DEFAULT_INIT_DELAY_IN_MS
};
exports.INIT_ERROR_MESSAGE = 'Every third party should be given a "name" and a "key" property';
exports.ENGINE_OVERRIDE_ERROR_MESSAGE = 'When thirdparty has a pre-defined "engine" property, it must be a function';
/**
 * A third party
 * @typedef {{
 *  name: string,
 *  key: string,
 *  bootMethod: function|Promise<function>,
 *  bootModule: object,
 *  taggingPlan: object,
 *  initParams: object|function,
 *  engine: function
 * }} ThirdParty
 */ /**
 * @module ThirdPartyControllerService
 * @description Third party services controller
 * @tutorial ./doc/thirdPartyControllerService.md
 */ var ThirdPartyControllerService = /*#__PURE__*/ function(_abstractThirdPartyInterface_1_AbstractThirdPartyInterface) {
    _inherits._(ThirdPartyControllerService, _abstractThirdPartyInterface_1_AbstractThirdPartyInterface);
    var _super = _create_super._(ThirdPartyControllerService);
    function ThirdPartyControllerService() {
        var _this = this;
        _class_call_check._(this, ThirdPartyControllerService);
        var _this1;
        _this1 = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this1.thirdParties = [];
        /**
         * Initialize third parties
         * @param {Object[]} thirdParties Third parties objects.
         * @returns {ThirdParty[]}
         */ _this1.initializeThirdParties = function(thirdParties) {
            return thirdParties.map(function(_a) {
                var name = _a.name, bootMethod = _a.bootMethod, engine = _a.engine, rest = __rest(_a, [
                    "name",
                    "bootMethod",
                    "engine"
                ]);
                return Object.assign({
                    name: name,
                    initialized: false,
                    rejected: false,
                    boot: bootMethod,
                    engine: engine || (0, utils_1.lazyLoadEngine)(name),
                    eventQueue: [],
                    eventQueueTimeout: null
                }, rest);
            });
        };
        var _this2 = _assert_this_initialized._(_this1);
        /**
         * The method to use to load and activate engines.
         * @param {string[]} acceptedThirdParties The accepted engines (gdpr consented) to init.
         * @returns {Promise<Object[]>} An array of engines objects.
         */ _this1.initThirdPartyEngines = function() {
            var _ref = _async_to_generator._(function(acceptedThirdParties) {
                var enginesStarting, higherPriorityEngines, lowerPriorityEngines;
                return _ts_generator._(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            enginesStarting = _this2.thirdParties.filter(function(param) {
                                var name = param.name, initialized = param.initialized;
                                return acceptedThirdParties.includes(name) && !initialized;
                            });
                            _this2.logger("Starting engines", enginesStarting);
                            higherPriorityEngines = enginesStarting.filter(function(param) {
                                var name = param.name;
                                return !constants_1.DEPENDANT_ENGINES.includes(name);
                            });
                            lowerPriorityEngines = enginesStarting.filter(function(param) {
                                var name = param.name;
                                return constants_1.DEPENDANT_ENGINES.includes(name);
                            });
                            return [
                                4,
                                _this2.loadThirdParties(higherPriorityEngines)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                4,
                                _this2.loadThirdParties(lowerPriorityEngines)
                            ];
                        case 2:
                            _state.sent();
                            return [
                                2,
                                _to_consumable_array._(higherPriorityEngines).concat(_to_consumable_array._(lowerPriorityEngines)).map(function(thirdParty) {
                                    return eventQueue_1.eventQueue.commitEventQueueIfReady(thirdParty);
                                })
                            ];
                    }
                });
            });
            return function(acceptedThirdParties) {
                return _ref.apply(this, arguments);
            };
        }();
        /**
         * Remove engines passed as params from the third parties list.
         * @param {string[]} removedThirdParties
         */ _this1.removeThirdPartyEngines = function(removedThirdParties) {
            _this1.thirdParties = _this1.thirdParties.filter(function(thirdParty) {
                if (removedThirdParties.includes(thirdParty.name)) {
                    clearTimeout(thirdParty.eventQueueTimeout);
                    thirdParty.eventQueue = [];
                    return false;
                }
                return true;
            });
        };
        /**
         * Set engines passed as params as rejected.
         * They will not be called
         * @param {string[]} rejectedThirdParties
         */ _this1.rejectThirdPartyEngines = function(rejectedThirdParties) {
            _this1.thirdParties.filter(function(param) {
                var name = param.name;
                return rejectedThirdParties.includes(name);
            }).forEach(function(engine) {
                engine.rejected = true;
                engine.eventQueue = [];
            });
        };
        /**
         * callEnginesEventMethod is a bridge to every engines "event" methods.
         * It will call every engines that implement the requested method.
         *
         * @param {string} method the method name.
         * @returns {false|undefined}
         */ _this1.callEnginesEventMethod = function(method) {
            return function(taggingEvent, action, customAttributes) {
                return (0, utils_1.getActiveEngineWithMethod)(_this1.thirdParties, method).map(function(thirdParty) {
                    var taggingPlan = thirdParty.taggingPlan || _this1.config.taggingPlans;
                    var stdEvent = (0, utils_1.getFormattedEvent)(taggingEvent, thirdParty);
                    eventQueue_1.eventQueue.queueEvent(thirdParty, function(latestThirdParty) {
                        if (_this1.isRecording) {
                            (0, utils_1.storeCallForMock)(thirdParty.name, method, stdEvent, action, {
                                eventKey: (0, get_1.default)(taggingPlan, stdEvent.key)
                            }, customAttributes);
                        }
                        // It is important to use latestThirdParty.engine[method] directly otherwise we loose reference of the engine's "this"
                        return (0, get_1.default)(latestThirdParty.engine, method) && latestThirdParty.engine[method](stdEvent, action, (0, get_1.default)(taggingPlan, stdEvent.key), customAttributes);
                    });
                    if (thirdParty.initialized) {
                        return eventQueue_1.eventQueue.commitEventQueueIfReady(thirdParty);
                    }
                    return false;
                });
            };
        };
        _this1.callEnginesMethod = function(method) {
            return function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                return (0, utils_1.getActiveEngineWithMethod)(_this1.thirdParties, method).map(function(thirdParty) {
                    var engine = thirdParty.engine, initialized = thirdParty.initialized, name = thirdParty.name;
                    var engineArgs = (0, get_1.default)(args, [
                        name
                    ], args);
                    if (_this1.isRecording) {
                        engineArgs.push({
                            uuid: (0, uuid_1.v4)()
                        });
                    }
                    if (initialized || engine.doNotQueue) {
                        var _engine;
                        if (_this1.isRecording) {
                            (0, utils_1.storeCallForMock).apply(_this, [
                                name,
                                method
                            ].concat(_to_consumable_array._(engineArgs)));
                        }
                        return (_engine = engine)[method].apply(_engine, _to_consumable_array._(engineArgs));
                    }
                    return eventQueue_1.eventQueue.queueEvent(thirdParty, function(latestThirdParty) {
                        var _latestThirdParty_engine;
                        if (_this1.isRecording) {
                            (0, utils_1.storeCallForMock).apply(_this, [
                                name,
                                method
                            ].concat(_to_consumable_array._(engineArgs)));
                        }
                        // It is important to use latestThirdParty.engine[method] directly otherwise we loose reference of the engine's "this"
                        return (0, get_1.default)(latestThirdParty.engine, method) && (_latestThirdParty_engine = latestThirdParty.engine)[method].apply(_latestThirdParty_engine, _to_consumable_array._(engineArgs));
                    });
                });
            };
        };
        return _this1;
    }
    _create_class._(ThirdPartyControllerService, [
        {
            /**
     * Initialize the service.
     *
     * @param {Object} param The only argument.
     * @param {ThirdParty[]} param.thirdParties A list of third parties object.
     * @param {{taggingPlans: Object, initTrackingDelay: number}} param.config The service config.
     * @param {{logger: Function, sendErrorToMonitoring: Function, isRecording: boolean}} param.options The service options.
     * @return {Promise<void>}
     * @tutorial ./doc/thirdPartyControllerService.md
     */ key: "init",
            value: function init(param) {
                var _param_thirdParties = param.thirdParties, thirdParties = _param_thirdParties === void 0 ? this.thirdParties : _param_thirdParties, _param_config = param.config, config = _param_config === void 0 ? DEFAULT_CONFIG : _param_config, options = param.options;
                this.checkInitParams(thirdParties);
                var mergedOptions = Object.assign(Object.assign({}, DEFAULT_OPTIONS), options);
                this.config = config;
                this.logger = mergedOptions.logger;
                this.isRecording = mergedOptions.isRecording;
                eventQueue_1.eventQueue.init(this.config);
                this.monitoring = function(name) {
                    return function(error, eventType) {
                        var sentryParams = {
                            tags: {
                                context: name
                            }
                        };
                        var statsdParams = [
                            name,
                            "error",
                            eventType
                        ];
                        mergedOptions.sendErrorToMonitoring(constants_1.NAMESPACE_ERROR, error, sentryParams, statsdParams);
                    };
                };
                this.detectBlocker = function(name) {
                    return function(value) {
                        mergedOptions.detectBlocker(name, value);
                    };
                };
                this.thirdParties = this.initializeThirdParties(thirdParties);
            }
        },
        {
            /**
     * Verify third parties contains keys `key` and `name`
     * @param {ThirdParty[]} thirdParties
     */ key: "checkInitParams",
            value: function checkInitParams(thirdParties) {
                thirdParties.forEach(function(_a) {
                    var name = _a.name, key = _a.key, thirdParty = __rest(_a, [
                        "name",
                        "key"
                    ]);
                    if (!key || !name) {
                        throw new Error(exports.INIT_ERROR_MESSAGE);
                    }
                    // make sure engine is not overriden by a falsy value
                    if ((0, has_1.default)(thirdParty, "engine") && typeof thirdParty.engine !== "function") {
                        throw new Error(exports.ENGINE_OVERRIDE_ERROR_MESSAGE);
                    }
                });
            }
        },
        {
            /**
     * Load third parties engines
     * @param enginesStarting
     * @returns {Promise<void>}
     */ key: "loadThirdParties",
            value: function loadThirdParties(enginesStarting) {
                var _this = this;
                return Promise.all(enginesStarting.map(function() {
                    var _ref = _async_to_generator._(function(thirdParty) {
                        var engine, bootModule, boot, name, initParams, key, builtInitParams;
                        return _ts_generator._(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        thirdParty.engine()
                                    ];
                                case 1:
                                    // Load the engine first
                                    thirdParty.engine = _state.sent();
                                    engine = thirdParty.engine, bootModule = thirdParty.bootModule, boot = thirdParty.boot, name = thirdParty.name, initParams = thirdParty.initParams, key = thirdParty.key;
                                    // augments the engine with necessary properties and methods
                                    engine.thirdPartyKey = key;
                                    engine.isRecording = _this.isRecording;
                                    engine.sendErrorToMonitoring = _this.monitoring(name);
                                    engine.detectBlocker = _this.detectBlocker(name);
                                    builtInitParams = typeof initParams === "function" ? initParams() : initParams;
                                    if (!(bootModule && bootModule.default && typeof bootModule.default === "function")) return [
                                        3,
                                        2
                                    ];
                                    bootModule.default(builtInitParams);
                                    return [
                                        3,
                                        4
                                    ];
                                case 2:
                                    if (!boot) return [
                                        3,
                                        4
                                    ];
                                    return [
                                        4,
                                        boot()
                                    ];
                                case 3:
                                    _state.sent();
                                    _state.label = 4;
                                case 4:
                                    _this.logger("app:thirdparty:boot: ".concat(name));
                                    if (_this.isRecording) {
                                        (0, set_1.default)(window, "".concat(constants_1.MOCK_THIRDPARTY_OBJECT_KEY, ".").concat(name), []);
                                    }
                                    if (!(typeof engine.init === "function")) return [
                                        3,
                                        6
                                    ];
                                    if (_this.isRecording) {
                                        (0, utils_1.storeCallForMock)(name, "fido:boot", builtInitParams);
                                    }
                                    return [
                                        4,
                                        engine.init(builtInitParams)
                                    ];
                                case 5:
                                    _state.sent();
                                    return [
                                        3,
                                        7
                                    ];
                                case 6:
                                    if (_this.isRecording) {
                                        (0, utils_1.storeCallForMock)(name, "fido:boot:no-init");
                                    }
                                    _state.label = 7;
                                case 7:
                                    thirdParty.initialized = true;
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(thirdParty) {
                        return _ref.apply(this, arguments);
                    };
                }()));
            }
        },
        {
            key: "flushEvents",
            value: function flushEvents() {
                return eventQueue_1.eventQueue.flushEvents(this.thirdParties);
            }
        }
    ]);
    return ThirdPartyControllerService;
}(abstractThirdPartyInterface_1.AbstractThirdPartyInterface);
exports.ThirdPartyControllerService = ThirdPartyControllerService;
exports.thirdPartyControllerService = new ThirdPartyControllerService();


/***/ }),

/***/ 90724:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _assert_this_initialized = __webpack_require__(99561);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _get = __webpack_require__(60528);
var _get_prototype_of = __webpack_require__(35196);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
__webpack_require__(42578);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(45538);
var __importDefault = (void 0) && (void 0).__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.thirdPartyWithLayoutService = void 0;
var get_1 = __importDefault(__webpack_require__(65439));
var merge_1 = __importDefault(__webpack_require__(67929));
var connectAction_1 = __webpack_require__(70708);
var thirdPartyControllerService_1 = __webpack_require__(59740);
/**
 * @module ThirdPartyWithLayout
 * @description Same as the Third Party service but has to be used in combination with the LayoutForThirdPartyService to add layout custom attributes automatically to the third party requests.
 * @tutorial ./doc/thirdPartyWithLayoutService.md
 */ var ThirdPartyWithLayoutService = /*#__PURE__*/ function(_thirdPartyControllerService_1_ThirdPartyControllerService) {
    _inherits._(ThirdPartyWithLayoutService, _thirdPartyControllerService_1_ThirdPartyControllerService);
    var _super = _create_super._(ThirdPartyWithLayoutService);
    function ThirdPartyWithLayoutService() {
        _class_call_check._(this, ThirdPartyWithLayoutService);
        var _this;
        _this = _super.call(this);
        var _ref = (0, connectAction_1.connectAction)(_this.sendEventWithLayoutThirdPartyData.bind(_assert_this_initialized._(_this))), connectedSendEvent = _ref.connectedAction, waitForSendEventPromise = _ref.waitForPromise;
        var _ref1 = (0, connectAction_1.connectAction)(_this.sendEventWithLayoutThirdPartyDataAsync.bind(_assert_this_initialized._(_this))), connectedSendEventAsync = _ref1.connectedAction, waitForSendEventAsyncPromise = _ref1.waitForPromise;
        var _ref2 = (0, connectAction_1.connectAction)(_this.sendPageViewEventWithLayoutThirdPartyData.bind(_assert_this_initialized._(_this))), connectedSendPageViewEvent = _ref2.connectedAction, waitForSendPageViewEventPromise = _ref2.waitForPromise;
        var _ref3 = (0, connectAction_1.connectAction)(_this.sendClickEventWithLayoutThirdPartyData.bind(_assert_this_initialized._(_this))), connectedSendClickEvent = _ref3.connectedAction, waitForSendClickEvent = _ref3.waitForPromise;
        var _ref4 = (0, connectAction_1.connectAction)(_this.sendPrintEventWithLayoutThirdPartyData.bind(_assert_this_initialized._(_this))), connectedSendPrintEvent = _ref4.connectedAction, waitForSendPrintEvent = _ref4.waitForPromise;
        var _ref5 = (0, connectAction_1.connectAction)(_this.sendImpressionTrackingEventWithLayoutThirdPartyData.bind(_assert_this_initialized._(_this))), connectedSendImpressionTrackingEvent = _ref5.connectedAction, waitForSendImpressionTrackingEvent = _ref5.waitForPromise;
        _this.sendEvent = connectedSendEvent;
        _this.sendEventAsync = connectedSendEventAsync;
        _this.sendPageViewEvent = connectedSendPageViewEvent;
        _this.sendClickEvent = connectedSendClickEvent;
        _this.sendPrintEvent = connectedSendPrintEvent;
        _this.sendImpressionTrackingEvent = connectedSendImpressionTrackingEvent;
        _this.waitForPromise = function(promise) {
            waitForSendEventPromise(promise);
            waitForSendEventAsyncPromise(promise);
            waitForSendPageViewEventPromise(promise);
            waitForSendClickEvent(promise);
            waitForSendPrintEvent(promise);
            waitForSendImpressionTrackingEvent(promise);
            return promise;
        };
        return _this;
    }
    _create_class._(ThirdPartyWithLayoutService, [
        {
            /**
     * DON'T USE, use sendEvent instead
     * @param {*} data
     * @param {*} params
     * @param {*} action
     * @param {*} layoutThirdPartyData
     */ key: "sendEventWithLayoutThirdPartyData",
            value: function sendEventWithLayoutThirdPartyData(data, params, action, layoutThirdPartyData) {
                var _this = this;
                setTimeout(function() {
                    _get._(_get_prototype_of._(ThirdPartyWithLayoutService.prototype), "sendEvent", _this).call(_this, params, action, _this.mergeLayoutThirdPartyData(data, layoutThirdPartyData));
                }, 0);
            }
        },
        {
            /**
     * DON'T USE, use sendEventAsync instead
     * Async variant of sendEventWithLayoutThirdPartyData
     * @param {*} data
     * @param {*} params
     * @param {*} action
     * @param {*} layoutThirdPartyData
     * @returns {Promise<void>}
     */ key: "sendEventWithLayoutThirdPartyDataAsync",
            value: function sendEventWithLayoutThirdPartyDataAsync(data, params, action, layoutThirdPartyData) {
                var _this = this;
                return new Promise(function(resolve) {
                    _get._(_get_prototype_of._(ThirdPartyWithLayoutService.prototype), "sendEvent", _this).call(_this, params, action, _this.mergeLayoutThirdPartyData(data, layoutThirdPartyData));
                    resolve();
                });
            }
        },
        {
            /**
     * DON'T USE, use sendPageViewEvent instead
     * @param {*} data
     * @param {*} location
     * @param {*} layoutThirdPartyData
     */ key: "sendPageViewEventWithLayoutThirdPartyData",
            value: function sendPageViewEventWithLayoutThirdPartyData(data, params, location, layoutThirdPartyData) {
                var mergedLayoutThirdPartyData = this.mergeLayoutThirdPartyData(data, layoutThirdPartyData);
                this.callEnginesMethod("setContentGroupsFromLayout")(data, mergedLayoutThirdPartyData);
                _get._(_get_prototype_of._(ThirdPartyWithLayoutService.prototype), "sendPageViewEvent", this).call(this, params, location, mergedLayoutThirdPartyData);
            }
        },
        {
            /**
     * DON'T USE, use sendClickEvent instead
     * @param {*} data
     * @param {*} params
     * @param {*} layoutThirdPartyData
     */ key: "sendClickEventWithLayoutThirdPartyData",
            value: function sendClickEventWithLayoutThirdPartyData(data, params, action, layoutThirdPartyData) {
                var _this = this;
                setTimeout(function() {
                    _get._(_get_prototype_of._(ThirdPartyWithLayoutService.prototype), "sendClickEvent", _this).call(_this, params, action, _this.mergeLayoutThirdPartyData(data, layoutThirdPartyData));
                }, 0);
            }
        },
        {
            /**
     * DON'T USE, use sendPrintEvent instead
     * @param {*} data
     * @param {*} params
     * @param {*} layoutThirdPartyData
     */ key: "sendPrintEventWithLayoutThirdPartyData",
            value: function sendPrintEventWithLayoutThirdPartyData(data, params, action, layoutThirdPartyData) {
                var _this = this;
                setTimeout(function() {
                    _get._(_get_prototype_of._(ThirdPartyWithLayoutService.prototype), "sendPrintEvent", _this).call(_this, params, action, _this.mergeLayoutThirdPartyData(data, layoutThirdPartyData));
                }, 0);
            }
        },
        {
            /**
     * DON'T USE, use sendImpressionTrackingEvent instead
     * @param {*} data
     * @param {*} params
     * @param {*} layoutThirdPartyData
     */ key: "sendImpressionTrackingEventWithLayoutThirdPartyData",
            value: function sendImpressionTrackingEventWithLayoutThirdPartyData(data, params, action, layoutThirdPartyData) {
                var _this = this;
                setTimeout(function() {
                    _get._(_get_prototype_of._(ThirdPartyWithLayoutService.prototype), "sendImpressionTrackingEvent", _this).call(_this, params, action, _this.mergeLayoutThirdPartyData(data, layoutThirdPartyData));
                }, 0);
            }
        },
        {
            /**
     * Merge layout data and third party data
     * @param {{ analytics: object }} layout
     * @param {object} thirdPartyData
     * @returns {object}
     */ key: "mergeLayoutThirdPartyData",
            value: function mergeLayoutThirdPartyData(layout, thirdPartyData) {
                var layoutAnalytics = (0, get_1.default)(layout, "analytics", {});
                return layout ? (0, merge_1.default)({}, layoutAnalytics, thirdPartyData) : thirdPartyData;
            }
        }
    ]);
    return ThirdPartyWithLayoutService;
}(thirdPartyControllerService_1.ThirdPartyControllerService);
exports.thirdPartyWithLayoutService = new ThirdPartyWithLayoutService();


/***/ }),

/***/ 9942:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _async_to_generator = __webpack_require__(24146);
var _define_property = __webpack_require__(21228);
var _interop_require_wildcard = __webpack_require__(95316);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(3009);
var __importDefault = (void 0) && (void 0).__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.getDualStorageValue = exports.setDualStorageValue = exports.waitForGlobal = exports.getSanitizedPageUrl = exports.storeThirdpartyCallForPlayground = exports.sortObject = exports.getCustomAttribute = exports.transformAttributes = exports.getFormattedEvent = exports.getActiveEngineWithMethod = exports.updateMockEvent = exports.storeCallForMock = exports.lazyLoadEngine = exports.generateImagePixel = void 0;
var get_1 = __importDefault(__webpack_require__(65439));
var identity_1 = __importDefault(__webpack_require__(48148));
var isObject_1 = __importDefault(__webpack_require__(36838));
var merge_1 = __importDefault(__webpack_require__(67929));
var omit_1 = __importDefault(__webpack_require__(59245));
var reduce_1 = __importDefault(__webpack_require__(6355));
var set_1 = __importDefault(__webpack_require__(35609));
var uniqueId_1 = __importDefault(__webpack_require__(53274));
var sprintf_js_1 = __webpack_require__(24131);
var fido_1 = __webpack_require__(19322);
var constants_1 = __webpack_require__(27668);
/**
 * Generate a Image object in memory in order to track user with a pixel way.
 *
 * @param url url of the pixel you want to fetch
 */ var generateImagePixel = function(url) {
    new Image().src = url;
};
exports.generateImagePixel = generateImagePixel;
/**
 * Lazy load engine module, same as `requireEngine` but using async import
 * @param {string} name The name of the engine
 * @returns {Object|undefined} The loaded module
 */ var lazyLoadEngine = function(name) {
    return /*#__PURE__*/ _async_to_generator._(function() {
        var module, _a;
        return _ts_generator._(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        Promise.resolve("./engines/".concat(name, ".engine.js")).then(function(p) {
                            return /*#__PURE__*/ _interop_require_wildcard._(__webpack_require__(57171)(p));
                        })
                    ];
                case 1:
                    module = _state.sent();
                    return [
                        2,
                        module.default
                    ];
                case 2:
                    _a = _state.sent();
                    return [
                        2,
                        undefined
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
};
exports.lazyLoadEngine = lazyLoadEngine;
var mergeObject = function(array) {
    return (0, reduce_1.default)(array, function(accumulator, value) {
        if (!value) return accumulator;
        var param = (0, isObject_1.default)(value) ? value : {
            value: value
        };
        return Object.assign(Object.assign({}, accumulator), param);
    }, {});
};
/**
 * Store calls into a global mock on window object
 * @param {string} name
 * @param {string} method
 * @param  {...any} engineArgs
 */ var storeCallForMock = function(name, method) {
    for(var _len = arguments.length, engineArgs = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
        engineArgs[_key - 2] = arguments[_key];
    }
    if (!(0, isObject_1.default)(window[constants_1.MOCK_THIRDPARTY_OBJECT_KEY])) {
        return;
    }
    if (!window[constants_1.MOCK_THIRDPARTY_OBJECT_KEY][name]) {
        (0, set_1.default)(window[constants_1.MOCK_THIRDPARTY_OBJECT_KEY], name, []);
    }
    var timestamp = fido_1.fido.get("getCurrentTime")();
    var finalArgs = engineArgs.map(function(arg) {
        var eventKey = (0, get_1.default)(arg, "eventKey");
        if (!(0, isObject_1.default)(eventKey)) return arg;
        var stdEvent = engineArgs[0];
        return {
            eventKey: Object.assign(Object.assign({}, eventKey), {
                label: (0, sprintf_js_1.sprintf)(eventKey.label, stdEvent),
                action: (0, sprintf_js_1.sprintf)(eventKey.action, stdEvent)
            })
        };
    });
    window[constants_1.MOCK_THIRDPARTY_OBJECT_KEY][name].push(Object.assign({
        mockUID: (0, uniqueId_1.default)(),
        name: name,
        timestamp: timestamp,
        method: method
    }, mergeObject(finalArgs)));
};
exports.storeCallForMock = storeCallForMock;
/**
 * Update mocked events by id
 * @param {string} uuid
 * @param {object} data
 */ var updateMockEvent = function(param, data) {
    var uuid = param.uuid;
    var mockedEvent = Object.values(window[constants_1.MOCK_THIRDPARTY_OBJECT_KEY]).flat().find(function(event) {
        return event.uuid === uuid;
    });
    (0, merge_1.default)(mockedEvent, data);
};
exports.updateMockEvent = updateMockEvent;
/**
 *
 * @param {ThirdParty[]} thirdParties
 * @param {string} method
 * @returns {ThirdParty[]} Third parties that are allowed by user consents and possess method
 */ var getActiveEngineWithMethod = function() {
    var thirdParties = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], method = arguments.length > 1 ? arguments[1] : void 0;
    return thirdParties.filter(function(param) {
        var engine = param.engine, rejected = param.rejected, initialized = param.initialized;
        return engine && (!initialized || typeof engine[method] === "function") && !rejected;
    });
};
exports.getActiveEngineWithMethod = getActiveEngineWithMethod;
/**
 *
 * @param {any} event
 * @param {ThirdParty} thirdParty
 * @returns {Object} The std event.
 */ var getFormattedEvent = function(event, thirdParty) {
    // We only need to search in the thirdParty static taggingPlan later
    if (typeof event === "string") {
        return {
            key: event
        };
    }
    var eventEngineAnalytics = (0, get_1.default)(event, [
        "analytics",
        thirdParty.key
    ]);
    // We get the event from the layout analytics node, but just in case we spread the event
    if (eventEngineAnalytics) {
        return Object.assign(Object.assign({}, (0, omit_1.default)(event, [
            "analytics"
        ])), eventEngineAnalytics);
    }
    return (0, get_1.default)(event, [
        thirdParty.key
    ], event);
};
exports.getFormattedEvent = getFormattedEvent;
/**
 * Transforms given customAttributes to match the engine schema needs.
 *
 * @param {Object} customAttributes The attributes passed to setCustomAttributes method.
 * @param {Object} attributesKeysMapping An attribute key to engine attribute's key mapping.
 * @param {Object} attributesValuesMapping An attribute key to transformer mapping.
 * @returns {Object} The formatted attributes for a given engines.
 *
 * @tutorial ../doc/transformAttributes.md
 */ var transformAttributes = function(customAttributes, attributesKeysMapping, attributesValuesMapping) {
    return (0, reduce_1.default)(customAttributes, function(acc, attributeValue, attributeKey) {
        var correspondingKey = attributesKeysMapping[attributeKey];
        if (!correspondingKey) return acc;
        var correponspondingValue = (0, get_1.default)(attributesValuesMapping, attributeKey, identity_1.default)(attributeValue);
        return Object.assign(Object.assign({}, acc), _define_property._({}, correspondingKey, correponspondingValue));
    }, {});
};
exports.transformAttributes = transformAttributes;
var getCustomAttribute = function(key, customAttributes, attributesKeysMapping) {
    var targetKey = (0, get_1.default)(attributesKeysMapping, key, key);
    return customAttributes[targetKey] ? customAttributes[targetKey] : undefined;
};
exports.getCustomAttribute = getCustomAttribute;
var sortObject = function(unorderedObject) {
    return Object.keys(unorderedObject).sort().reduce(function(object, key) {
        object[key] = unorderedObject[key];
        return object;
    }, {});
};
exports.sortObject = sortObject;
var storeThirdpartyCallForPlayground = function(param) {
    var name = param.name, isRecording = param.isRecording, status = param.status, data = param.data;
    if (!isRecording) {
        return;
    }
    var THIRD_PARTY_OBJECT = "".concat(name, "Calls");
    if (!(0, isObject_1.default)(window[THIRD_PARTY_OBJECT])) {
        (0, set_1.default)(window, THIRD_PARTY_OBJECT, []);
    }
    var timestamp = fido_1.fido.get("getCurrentTime")();
    window[THIRD_PARTY_OBJECT].push({
        mockUID: (0, uniqueId_1.default)(),
        timestamp: timestamp,
        status: status,
        data: data
    });
};
exports.storeThirdpartyCallForPlayground = storeThirdpartyCallForPlayground;
/**
 * When URL contains Auth callback params (state, session_state, code),
 * returns URL without query string for tracking.
 * @param {string} href
 * @returns {{ url: string, search: string }}
 */ var getSanitizedPageUrl = function(href) {
    try {
        var url = new URL(href);
        var hasAuthCallbackParams = url.searchParams.has("state") && url.searchParams.has("session_state") && url.searchParams.has("code");
        if (hasAuthCallbackParams) {
            url.searchParams.delete("state");
            url.searchParams.delete("session_state");
            url.searchParams.delete("code");
        }
        return {
            url: url.href,
            search: url.search
        };
    } catch (_a) {
        return {
            url: "",
            search: ""
        };
    }
};
exports.getSanitizedPageUrl = getSanitizedPageUrl;
var waitForGlobal = function(globalKey) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_iterationTime = _ref.iterationTime, iterationTime = _ref_iterationTime === void 0 ? 200 : _ref_iterationTime, _ref_retries = _ref.retries, retries = _ref_retries === void 0 ? 10 : _ref_retries;
    return new Promise(function(resolve, reject) {
        var iterations = retries;
        var intervalId = setInterval(function() {
            if (window[globalKey]) {
                clearInterval(intervalId);
                resolve();
            } else {
                iterations -= 1;
                if (iterations === 0) {
                    clearInterval(intervalId);
                    // eslint-disable-next-line prefer-promise-reject-errors
                    reject();
                }
            }
        }, iterationTime);
    });
};
exports.waitForGlobal = waitForGlobal;
/**
 * @param {string} key The key to write to the dual storage.
 * @param {string} value The value to write to the dual storage.
 * @returns {void}
 */ var setDualStorageValue = function(key, value) {
    try {
        localStorage.setItem(key, value);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.warn("localStorage write failed for key: ".concat(key), e);
    }
    try {
        sessionStorage.setItem(key, value);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.warn("sessionStorage write failed for key: ".concat(key), e);
    }
};
exports.setDualStorageValue = setDualStorageValue;
/**
 * @param {string} key The key to read from the dual storage.
 * @returns {string|null} The value of the key in the dual storage.
 */ var getDualStorageValue = function(key) {
    var value = null;
    try {
        value = localStorage.getItem(key);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.warn("Failed to read localStorage for ".concat(key), e);
    }
    if (!value) {
        try {
            value = sessionStorage.getItem(key);
        } catch (e) {
            // eslint-disable-next-line no-console
            console.warn("Failed to read sessionStorage for ".concat(key), e);
        }
    }
    return value;
};
exports.getDualStorageValue = getDualStorageValue;


/***/ }),

/***/ 99448:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(42578);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.timeService = void 0;
var simpleFetcherService_1 = __webpack_require__(33415);
/**
 * @module Time
 * @augments SimpleFetcherService
 * @description The Time service is used to retrieve the server time.
 * @tutorial ./doc/time.md
 */ exports.timeService = new simpleFetcherService_1.SimpleFetcherService("time");


/***/ }),

/***/ 84599:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(3009);
var __decorate = (void 0) && (void 0).__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.upFrontTokenService = void 0;
var fido_1 = __webpack_require__(19322);
var queryParamSerializer_1 = __webpack_require__(19007);
var retryRequest_1 = __webpack_require__(26040);
var security_1 = __webpack_require__(11055);
var withJWT_1 = __webpack_require__(56282);
var fetcherService_1 = __webpack_require__(96571);
var withMonitoring_1 = __webpack_require__(97982);
var monitoring = (0, withMonitoring_1.withMonitoring)("token");
/**
 * @module UpFrontToken
 * @description The UpFrontToken service is used to fetch upFrontToken Token for DRM.
 * @tutorial ./doc/upFrontTokenService.md
 */ var UpFrontTokenService = /*#__PURE__*/ function(_fetcherService_1_FetcherService) {
    _inherits._(UpFrontTokenService, _fetcherService_1_FetcherService);
    var _super = _create_super._(UpFrontTokenService);
    function UpFrontTokenService() {
        _class_call_check._(this, UpFrontTokenService);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.apiType = "drm";
        return _this;
    }
    _create_class._(UpFrontTokenService, [
        {
            /**
     * Initialize the service. If you don't call this method, no other method can be called.
     * This init method will construct an attribute `deviceid`, which will be used to replace the missing user.UID
     * Init also the base path with the current platform
     */ key: "init",
            value: function init() {
                var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_retry = _ref.retry, retry = _ref_retry === void 0 ? 0 : _ref_retry;
                if (!this.isInitialized) {
                    this.basePath = "customers/".concat(fido_1.fido.get("customerCode"), "/platforms/").concat(fido_1.fido.get("platformCode"));
                    this.getCurrentTime = fido_1.fido.get("getCurrentTime");
                    this.isInitialized = true;
                    this.retryOptions = (0, retryRequest_1.buildRetryOptions)({
                        apiType: this.apiType,
                        count: retry
                    });
                }
            }
        },
        {
            /**
     * Fetch a up front token for video
     * @async
     * @param {Object} param to fetch the token
     * @return {Object} with token props
     */ key: "getVideoToken",
            value: function getVideoToken(param) {
                var videoId = param.videoId;
                return this.getToken("/videos/".concat(videoId, "/upfront-token"), param);
            }
        },
        {
            /**
     * Fetch a up front token for live
     * @async
     * @param {Object} param to fetch the token
     * @return {Object} with token props
     */ key: "getLiveToken",
            value: function getLiveToken(param) {
                var channelCode = param.channelCode;
                return this.getToken("/live/".concat(channelCode, "/upfront-token"), param);
            }
        },
        {
            /**
     * Fetch a up front token
     * @async
     * @param {Object} target service to call
     * @param {Object} param to fetch the token
     * @return {Object} with token props
     */ key: "getToken",
            value: function getToken(target, param) {
                var user = param.user, service = param.service, _param_randomize = param.randomize, randomize = _param_randomize === void 0 ? false : _param_randomize, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                var userId = user ? user.UID : this.getHomeOrDeviceId(true);
                var query = randomize ? "?".concat((0, queryParamSerializer_1.serialize)({
                    random: (0, security_1.genGuid)()
                })) : "";
                var endpoint = "services/".concat(service, "/users/").concat(userId);
                var url = this.getRouteUrl(endpoint + target + query);
                return this.fetch(url, {
                    method: "GET",
                    headers: headers,
                    retry: this.retryOptions
                }).then(function(param) {
                    var token = param.token;
                    return token;
                });
            }
        }
    ]);
    return UpFrontTokenService;
}(fetcherService_1.FetcherService);
__decorate([
    withJWT_1.withJWT,
    monitoring
], UpFrontTokenService.prototype, "getVideoToken", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], UpFrontTokenService.prototype, "getLiveToken", null);
exports.upFrontTokenService = new UpFrontTokenService();


/***/ }),

/***/ 24286:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(65759);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.urlHitterService = exports.UrlHitterService = void 0;
var fido_1 = __webpack_require__(19322);
var fetcherService_1 = __webpack_require__(96571);
/**
 * @module UrlHitterService
 * @description The url-hitter service makes possible to group several urls of tracking to hitter in a single call. Convenient for IPTV or mobiles wanting to save calls. You should use one of two routes version : - `/v1` If you send urls through a proxy - `/v2` If you send urls from public IP
 * @tutorial ./doc/urlHitterService.md
 */ var UrlHitterService = /*#__PURE__*/ function(_fetcherService_1_FetcherService) {
    _inherits._(UrlHitterService, _fetcherService_1_FetcherService);
    var _super = _create_super._(UrlHitterService);
    function UrlHitterService() {
        _class_call_check._(this, UrlHitterService);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.apiType = "urlhitter";
        return _this;
    }
    _create_class._(UrlHitterService, [
        {
            /**
     * Initialize the service.
     */ key: "init",
            value: function init() {
                if (!this.isInitialized) {
                    this.isInitialized = true;
                }
            }
        },
        {
            /**
     * Format url to be compatible with urlhitter v1
     *
     * @param {string} url Url to format.
     * @returns {string} formatted url.
     */ key: "formatUrl",
            value: function formatUrl(url) {
                return url.replace(/%/g, "%25").replace(/:/g, "%3A").replace(/\//g, "%2F").replace(/\?/g, "%3F").replace(/=/g, "%3D").replace(/&/g, "%26");
            }
        },
        {
            /**
     * Send hits with v1 through a proxy
     *
     * @param {string[]} urls List of url to hit.
     * @param {string} userAgent of the current platform.
     * @returns {Promise}
     */ key: "hitV1",
            value: function hitV1(urls, userAgent) {
                var _this = this;
                var body = urls.map(function(url) {
                    return "hitUrl[url][]=".concat(_this.formatUrl(url));
                }).join("&");
                body = "".concat(body, "&hitUrl[userAgent]=").concat(userAgent);
                body = body.replace(/\[/g, "%5B").replace(/\]/g, "%5D");
                return this.fetch(this.getRouteUrl("hits"), {
                    method: "POST",
                    body: body,
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded"
                    }
                });
            }
        },
        {
            /**
     * Send hits with v2 from public IP
     *
     * @param {string[]} urls List of url to hit.
     * @param {string} userAgent of the current platform.
     * @returns {Promise}
     */ key: "hitV2",
            value: function hitV2(urls, userAgent) {
                var url = this.getRouteUrl("platforms/".concat(fido_1.fido.get("platformCode"), "/hits"));
                return this.fetch(url, {
                    method: "POST",
                    body: JSON.stringify({
                        userAgent: userAgent,
                        urls: urls
                    })
                });
            }
        },
        {
            /**
     * Dispatch to send hit with v1 or v2 of urlhitter
     *
     * @param {string[]} urls List of url to hit.
     * @param {string} userAgent of the current platform.
     * @returns {Promise}
     */ key: "hit",
            value: function hit() {
                var urls = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], userAgent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : fido_1.fido.get("platformCode");
                this.checkInit();
                if (fido_1.fido.getBaseUrl("urlhitter").includes("/v1")) {
                    return this.hitV1(urls, userAgent);
                }
                return this.hitV2(urls, userAgent);
            }
        }
    ]);
    return UrlHitterService;
}(fetcherService_1.FetcherService);
exports.UrlHitterService = UrlHitterService;
exports.urlHitterService = new UrlHitterService();


/***/ }),

/***/ 62284:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(52318);
var __decorate = (void 0) && (void 0).__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.ageRatingService = void 0;
var fido_1 = __webpack_require__(19322);
var withJWT_1 = __webpack_require__(56282);
var fetcherService_1 = __webpack_require__(96571);
var withMonitoring_1 = __webpack_require__(97982);
var monitoring = (0, withMonitoring_1.withMonitoring)("ageRating");
/**
 * @module AgeRating
 * @description The AgeProfil service is used to age ratings details from middleware API
 * @tutorial ./doc/ageRating.md
 */ var AgeRatingService = /*#__PURE__*/ function(_fetcherService_1_FetcherService) {
    _inherits._(AgeRatingService, _fetcherService_1_FetcherService);
    var _super = _create_super._(AgeRatingService);
    function AgeRatingService() {
        _class_call_check._(this, AgeRatingService);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.apiType = "middlewarev2";
        return _this;
    }
    _create_class._(AgeRatingService, [
        {
            /**
     * Initialize the service. If you don't call this method, no other method can be called.
     * @tutorial ./doc/ageRatingInit.md
     */ key: "init",
            value: function init() {
                if (!this.isInitialized) {
                    this.basePath = "platforms/".concat(fido_1.fido.get("platformCode"), "/services");
                    this.isInitialized = true;
                }
            }
        },
        {
            key: "fetchAgeRatings",
            value: /**
     * Get the list of available age ratings.
     *
     * @async
     * @param {Object} params Must contains the service code. Other params are optionals.
     * @returns {Object} The list of available age ratings.
     * @tutorial ./doc/ageRatingList.md
     */ function fetchAgeRatings(param) {
                var _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers, serviceCode = param.serviceCode;
                var _this = this;
                return _async_to_generator._(function() {
                    var route;
                    return _ts_generator._(this, function(_state) {
                        _this.checkInit();
                        if (!serviceCode) {
                            throw new Error("You should provide a service code");
                        }
                        route = _this.getRouteUrl("".concat(serviceCode, "/csas"));
                        return [
                            2,
                            _this.fetch(route, {
                                method: "GET",
                                headers: headers
                            })
                        ];
                    });
                })();
            }
        }
    ]);
    return AgeRatingService;
}(fetcherService_1.FetcherService);
__decorate([
    withJWT_1.withJWT,
    monitoring
], AgeRatingService.prototype, "fetchAgeRatings", null);
exports.ageRatingService = new AgeRatingService();


/***/ }),

/***/ 6312:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(88801);
var __decorate = (void 0) && (void 0).__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.gdprService = void 0;
var fido_1 = __webpack_require__(19322);
var withJWT_1 = __webpack_require__(56282);
var fetcherService_1 = __webpack_require__(96571);
var withMonitoring_1 = __webpack_require__(97982);
var monitoring = (0, withMonitoring_1.withMonitoring)("user");
/**
 * @module Gdpr
 * @description The Gdpr service is used to interact with the 6play user middleware.
 * @tutorial ./doc/gdpr.md
 */ var GdprService = /*#__PURE__*/ function(_fetcherService_1_FetcherService) {
    _inherits._(GdprService, _fetcherService_1_FetcherService);
    var _super = _create_super._(GdprService);
    function GdprService() {
        _class_call_check._(this, GdprService);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.apiType = "userv2";
        return _this;
    }
    _create_class._(GdprService, [
        {
            /**
     * Initialize the service. If you don't call this method, no other method can be called.
     * @tutorial ./doc/gdprInit.md
     */ key: "init",
            value: function init() {
                if (!this.isInitialized) {
                    this.basePath = "platforms/".concat(fido_1.fido.get("platformCode"));
                    this.isInitialized = true;
                }
            }
        },
        {
            /**
     * Sets the user's gdpr preferences.
     *
     * @async
     * @param {Object} options Must contain uid and consents, can contain a headers key, for additionnal headers to attach to the request.
     * @tutorial ./doc/gdprSetUserConsents.md
     */ key: "setUserConsents",
            value: function setUserConsents(param) {
                var uid = param.uid, consents = param.consents, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                if (!uid || !consents) {
                    throw new Error("You should provide an uid and a consents object");
                }
                var endpoint = "users/".concat(uid, "/consents");
                var url = this.getRouteUrl(endpoint);
                return this.fetch(url, {
                    method: "POST",
                    headers: headers,
                    body: consents
                });
            }
        },
        {
            /**
     * Gets the user's gdpr preferences.
     *
     * @async
     * @param {Object} options Must contain uid, can contain a headers key, for additionnal headers to attach to the request.
     * @tutorial ./doc/gdprGetUserConsents.md
     */ key: "getUserConsents",
            value: function getUserConsents(param) {
                var uid = param.uid, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                if (!uid) {
                    throw new Error("You should provide an uid");
                }
                var endpoint = "users/".concat(uid, "/consents");
                var url = this.getRouteUrl(endpoint);
                return this.fetch(url, {
                    method: "GET",
                    headers: headers
                });
            }
        }
    ]);
    return GdprService;
}(fetcherService_1.FetcherService);
__decorate([
    withJWT_1.withJWT,
    monitoring
], GdprService.prototype, "setUserConsents", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], GdprService.prototype, "getUserConsents", null);
exports.gdprService = new GdprService();


/***/ }),

/***/ 8645:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
var __decorate = (void 0) && (void 0).__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.pairingService = void 0;
var fido_1 = __webpack_require__(19322);
var withJWT_1 = __webpack_require__(56282);
var fetcherService_1 = __webpack_require__(96571);
var withMonitoring_1 = __webpack_require__(97982);
var monitoring = (0, withMonitoring_1.withMonitoring)("user");
/**
 * @module Pairing
 * @description The Pairing service implements methods to deal with users' pairing feature.
 * @tutorial ./doc/pairing.md
 */ var PairingService = /*#__PURE__*/ function(_fetcherService_1_FetcherService) {
    _inherits._(PairingService, _fetcherService_1_FetcherService);
    var _super = _create_super._(PairingService);
    function PairingService() {
        _class_call_check._(this, PairingService);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.apiType = "userv2";
        return _this;
    }
    _create_class._(PairingService, [
        {
            /**
     * Initialize the service. If you don't call this method, no other method can be called.
     *
     * @param {Object} options Service configuration
     * @param {string=} options.boxType Box type used in routes. `clientCode` is used by default
     * @param {boolean=} options.prefixedBoxId Enable prefixing `boxId`
     * @tutorial ./doc/pairingInit.md
     */ key: "init",
            value: function init() {
                var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_boxType = _ref.boxType, boxType = _ref_boxType === void 0 ? fido_1.fido.get("clientCode") : _ref_boxType, _ref_prefixedBoxId = _ref.prefixedBoxId, prefixedBoxId = _ref_prefixedBoxId === void 0 ? false : _ref_prefixedBoxId;
                if (!this.isInitialized) {
                    this.basePath = "platforms/".concat(fido_1.fido.get("platformCode"));
                    this.boxType = boxType;
                    this.prefixedBoxId = prefixedBoxId;
                    this.isInitialized = true;
                }
            }
        },
        {
            /**
     * Return the box ID properly formatted depending on `prefixedBoxId`
     *
     * @return {string} The box ID
     * @tutorial ./doc/pairingGetBoxId.md
     */ key: "getBoxId",
            value: function getBoxId() {
                return this.getHomeOrDeviceId(this.prefixedBoxId);
            }
        },
        {
            /**
     * Get a 5 chars token to show on users device.
     *
     * @async
     * @param {Object=} options Can contain a headers key, with headers to attach to the network call.
     * @param {Object=} options.headers headers to attach to the network call (Optional)
     * @param {String} options.phoneNumber phone number, made of digits, prefixed or not by + (Optional)
     * @param {String} options.boxName Name of the box - will be shown in the account page as the name of the device (Optional)
     * @return {Object} Contains a token key holding the requested token.
     * @tutorial ./doc/pairingGetPairingToken.md
     */ key: "getPairingToken",
            value: function getPairingToken() {
                var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_headers = _ref.headers, headers = _ref_headers === void 0 ? {} : _ref_headers, phoneNumber = _ref.phoneNumber, boxName = _ref.boxName, tokenValidityDurationInMin = _ref.tokenValidityDurationInMin;
                var endpoint = "box";
                var url = this.getRouteUrl(endpoint);
                var body = Object.assign(Object.assign(Object.assign({
                    boxType: this.boxType,
                    boxId: this.getBoxId()
                }, phoneNumber && {
                    phoneNumber: phoneNumber
                }), boxName && {
                    boxName: boxName
                }), tokenValidityDurationInMin && {
                    tokenValidityDurationInMin: tokenValidityDurationInMin
                });
                return this.fetch(url, {
                    method: "POST",
                    body: body,
                    headers: headers
                });
            }
        },
        {
            /**
     * Get the current pairing status of a given token.
     *
     * @async
     * @param {Object} options Contains the token string displayed to the user, and a object of headers to attach to the http request.
     * @return {Object} Contains a status key, eventually an uid, or even a single error object.
     * @tutorial ./doc/pairingGetPairingStatus.md
     */ key: "getPairingStatus",
            value: function getPairingStatus(param) {
                var token = param.token, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                var endpoint = "boxTypes/".concat(this.boxType, "/boxIds/").concat(this.getBoxId(), "/tokens/").concat(token, "/status");
                var url = this.getRouteUrl(endpoint);
                return this.fetch(url, {
                    method: "GET",
                    headers: headers
                });
            }
        },
        {
            /**
     * Add pairing between the given user and the device which received the token.
     *
     * @async
     * @param {Object} params
     * @param {string} params.uid Contains an uid key, the User ID concerned.
     * @param {string} params.token Contains the token string needed to pair the user with the device.
     * @returns {Object} The information about the box paired, including the boxId, boxName and boxType.
     * @tutorial ./doc/pairingPair.md
     */ key: "pair",
            value: function pair(param) {
                var _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers, uid = param.uid, token = param.token;
                if (!uid) {
                    throw new Error("You should provide an uid");
                }
                var endpoint = "users/".concat(uid, "/box");
                var url = this.getRouteUrl(endpoint);
                var body = Object.assign({}, token && {
                    pair_token: token
                });
                return this.fetch(url, {
                    method: "POST",
                    body: body,
                    headers: headers
                });
            }
        },
        {
            /**
     * Delete pairing between the given user and the device running the request. Expect nothing returned but the promise resolution as a confirmation.
     *
     * @async
     * @param {Object} options Contains an uid key, the User ID concerned and can contain a headers key, for additionnal headers to attach to the request.
     * @tutorial ./doc/pairingUnpair.md
     */ key: "unpair",
            value: function unpair(param) {
                var uid = param.uid, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                if (!uid) {
                    throw new Error("You should provide an uid");
                }
                var endpoint = "users/".concat(uid, "/boxTypes/").concat(this.boxType, "/boxIds/").concat(this.getBoxId());
                var url = this.getRouteUrl(endpoint);
                return this.fetch(url, {
                    method: "DELETE",
                    headers: headers
                });
            }
        },
        {
            /**
     * Unpair all devices for the given user
     *
     * @async
     * @param {Object} options Contains an uid key, the User ID concerned and can contain a headers key, for additionnal headers to attach to the request.
     * @tutorial ./doc/pairingUnpairAll.md
     */ key: "unpairAll",
            value: function unpairAll(param) {
                var uid = param.uid, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                if (!uid) {
                    throw new Error("You should provide an uid");
                }
                var endpoint = "users/".concat(uid, "/boxes");
                var url = this.getRouteUrl(endpoint);
                return this.fetch(url, {
                    method: "DELETE",
                    headers: headers
                });
            }
        },
        {
            /**
     * Retrieves the users paired to the deviceId.
     *
     * @async
     * @param {Object} options Can contain a headers key, for additionnal headers to attach to the request.
     * @returns {Object[]} Users paired to this device, as objects.
     * @tutorial ./doc/pairingGetPairedUsers.md
     */ key: "getPairedUsers",
            value: function getPairedUsers(param) {
                var _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                var endpoint = "boxTypes/".concat(this.boxType, "/boxIds/").concat(this.getBoxId(), "/users");
                var url = this.getRouteUrl(endpoint);
                return this.fetch(url, {
                    method: "GET",
                    headers: headers
                });
            }
        },
        {
            /**
     * Retrieves the user profile picture url.
     *
     * @async
     * @param {Object} options Contains an uid key, the User ID concerned and can contain a headers key, for additionnal headers to attach to the request.
     * @returns {string} The user's profile picture url.
     * @tutorial ./doc/pairingGetThumbnail.md
     */ key: "getThumbnail",
            value: function getThumbnail(param) {
                var uid = param.uid, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                if (!uid) {
                    throw new Error("You should provide an uid");
                }
                var endpoint = "boxTypes/".concat(this.boxType, "/boxIds/").concat(this.getBoxId(), "/users/").concat(uid, "/thumbnail");
                var url = this.getRouteUrl(endpoint);
                return this.fetch(url, {
                    method: "GET",
                    headers: headers
                });
            }
        }
    ]);
    return PairingService;
}(fetcherService_1.FetcherService);
__decorate([
    withJWT_1.withJWT,
    monitoring
], PairingService.prototype, "getPairingToken", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], PairingService.prototype, "getPairingStatus", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], PairingService.prototype, "pair", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], PairingService.prototype, "unpair", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], PairingService.prototype, "unpairAll", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], PairingService.prototype, "getPairedUsers", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], PairingService.prototype, "getThumbnail", null);
exports.pairingService = new PairingService();


/***/ }),

/***/ 71685:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(42578);
var __decorate = (void 0) && (void 0).__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.parentalControlService = void 0;
var fido_1 = __webpack_require__(19322);
var withJWT_1 = __webpack_require__(56282);
var fetcherService_1 = __webpack_require__(96571);
var withMonitoring_1 = __webpack_require__(97982);
var monitoring = (0, withMonitoring_1.withMonitoring)("parentalControl");
/**
 * @module ParentalControl
 * @description The ParentalControl service is used to configure the user parental control.
 * @tutorial ./doc/parentalControl.md
 */ var ParentalControlService = /*#__PURE__*/ function(_fetcherService_1_FetcherService) {
    _inherits._(ParentalControlService, _fetcherService_1_FetcherService);
    var _super = _create_super._(ParentalControlService);
    function ParentalControlService() {
        _class_call_check._(this, ParentalControlService);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.apiType = "userv2";
        return _this;
    }
    _create_class._(ParentalControlService, [
        {
            /**
     * Initialize the service. If you don't call this method, no other method can be called.
     * @tutorial ./doc/parentalControlInit.md
     */ key: "init",
            value: function init() {
                if (!this.isInitialized) {
                    this.basePath = "platforms/".concat(fido_1.fido.get("platformCode"));
                    this.isInitialized = true;
                }
            }
        },
        {
            key: "fetchParentalRestriction",
            value: /**
     * Get the current parental restriction applied to the user account
     *
     * @async
     * @param {Object} params Must contains the uid. Other params are optionals.
     * @returns {Object} An object containing the max age rating id and the parental code.
     * @tutorial ./doc/fetchParentalRestriction.md
     */ function fetchParentalRestriction(param) {
                var _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers, uid = param.uid;
                var _this = this;
                return _async_to_generator._(function() {
                    var endpoint, route;
                    return _ts_generator._(this, function(_state) {
                        if (!uid) {
                            throw new Error("You should provide an uid");
                        }
                        endpoint = "users/".concat(uid, "/parentalRestriction?with=code");
                        route = _this.getRouteUrl(endpoint);
                        return [
                            2,
                            _this.fetch(route, {
                                method: "GET",
                                headers: headers
                            }).then(function(data) {
                                return {
                                    code: data.code,
                                    maxCsaCode: data.maxCsaCode,
                                    maxCsaId: data.max_csa_id
                                };
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "applyParentalRestriction",
            value: /**
     * Apply the current parental restriction applied to the user account
     *
     * @async
     * @param {Object} params Must contains the uid of the user, the parental code, the csa max age id and the csa max age code. Other params are optionals.
     * @tutorial ./doc/applyParentalRestriction.md
     */ function applyParentalRestriction(param) {
                var _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers, uid = param.uid, code = param.code, maxCsaCode = param.maxCsaCode, maxCsaId = param.maxCsaId;
                var _this = this;
                return _async_to_generator._(function() {
                    var endpoint, route;
                    return _ts_generator._(this, function(_state) {
                        if (!uid) {
                            throw new Error("You should provide an uid");
                        }
                        endpoint = "users/".concat(uid, "/parentalRestriction");
                        route = _this.getRouteUrl(endpoint);
                        return [
                            2,
                            _this.fetch(route, {
                                method: "POST",
                                headers: headers,
                                body: {
                                    code: code,
                                    maxCsaCode: maxCsaCode,
                                    max_csa_id: maxCsaId
                                }
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "removeParentalRestriction",
            value: /**
     * Remove the current parental restriction applied to the user account
     *
     * @async
     * @param {Object} params Must contains the uid of the user. Other params are optionals.
     * @tutorial ./doc/removeParentalRestriction.md
     */ function removeParentalRestriction(param) {
                var _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers, uid = param.uid;
                var _this = this;
                return _async_to_generator._(function() {
                    var endpoint, route;
                    return _ts_generator._(this, function(_state) {
                        if (!uid) {
                            throw new Error("You should provide an uid");
                        }
                        endpoint = "users/".concat(uid, "/parentalRestriction");
                        route = _this.getRouteUrl(endpoint);
                        return [
                            2,
                            _this.fetch(route, {
                                method: "DELETE",
                                headers: headers
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "checkParentalRestrictionCode",
            value: /**
     * Checks if given code if correct against parental restriction.
     *
     * @async
     * @param {Object} params Must contains the uid, a parental code.
     * @tutorial ./doc/checkParentalRestrictionCode.md
     */ function checkParentalRestrictionCode(param) {
                var _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers, uid = param.uid, code = param.code;
                var _this = this;
                return _async_to_generator._(function() {
                    var endpoint, route;
                    return _ts_generator._(this, function(_state) {
                        if (!uid) {
                            throw new Error("You should provide an uid");
                        }
                        endpoint = "users/".concat(uid, "/parentalRestriction/checkCode");
                        route = _this.getRouteUrl(endpoint);
                        return [
                            2,
                            _this.fetch(route, {
                                method: "POST",
                                headers: headers,
                                body: {
                                    code: code
                                }
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "fetchParentalFilter",
            value: /**
     * Get the current parental filter state applied to the user account
     *
     * @async
     * @param {Object} params Must contains the uid. Other params are optionals.
     * @returns {Object} An object containing the parental filter state
     * @tutorial ./doc/fetchParentalFilter.md
     */ function fetchParentalFilter(param) {
                var _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers, uid = param.uid;
                var _this = this;
                return _async_to_generator._(function() {
                    var endpoint, route;
                    return _ts_generator._(this, function(_state) {
                        if (!uid) {
                            throw new Error("You should provide an uid");
                        }
                        endpoint = "users/".concat(uid, "/parentalfilter");
                        route = _this.getRouteUrl(endpoint);
                        return [
                            2,
                            _this.fetch(route, {
                                method: "GET",
                                headers: headers
                            }).then(function(data) {
                                return {
                                    parentalFilter: data.parental_filter
                                };
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "updateParentalFilter",
            value: /**
     * Change the parental filter applied to the user account
     *
     * @async
     * @param {Object} params Must contains the uid of the user and the parental filter state. Other params are optionals.
     * @tutorial ./doc/updateParentalFilter.md
     */ function updateParentalFilter(param) {
                var _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers, uid = param.uid, parentalFilter = param.parentalFilter;
                var _this = this;
                return _async_to_generator._(function() {
                    var endpoint, route;
                    return _ts_generator._(this, function(_state) {
                        if (!uid) {
                            throw new Error("You should provide an uid");
                        }
                        endpoint = "users/".concat(uid, "/parentalfilter");
                        route = _this.getRouteUrl(endpoint);
                        return [
                            2,
                            _this.fetch(route, {
                                method: "POST",
                                headers: headers,
                                body: {
                                    parental_filter: parentalFilter
                                }
                            })
                        ];
                    });
                })();
            }
        }
    ]);
    return ParentalControlService;
}(fetcherService_1.FetcherService);
__decorate([
    withJWT_1.withJWT,
    monitoring
], ParentalControlService.prototype, "fetchParentalRestriction", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], ParentalControlService.prototype, "applyParentalRestriction", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], ParentalControlService.prototype, "removeParentalRestriction", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], ParentalControlService.prototype, "checkParentalRestrictionCode", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], ParentalControlService.prototype, "fetchParentalFilter", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], ParentalControlService.prototype, "updateParentalFilter", null);
exports.parentalControlService = new ParentalControlService();


/***/ }),

/***/ 20100:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
var __decorate = (void 0) && (void 0).__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.profileService = void 0;
var profile_errors_1 = __webpack_require__(60723);
var fido_1 = __webpack_require__(19322);
var withJWT_1 = __webpack_require__(56282);
var fetcherService_1 = __webpack_require__(96571);
var withMonitoring_1 = __webpack_require__(97982);
var monitoring = (0, withMonitoring_1.withMonitoring)("user");
var buildUserEndpoint = function(uid) {
    return "users/".concat(uid, "/profiles");
};
/**
 * @module User
 * @description The Profile service is used to interact with the user profile middleware.
 * @tutorial ./doc/profile.md
 */ var ProfileService = /*#__PURE__*/ function(_fetcherService_1_FetcherService) {
    _inherits._(ProfileService, _fetcherService_1_FetcherService);
    var _super = _create_super._(ProfileService);
    function ProfileService() {
        _class_call_check._(this, ProfileService);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.apiType = "userv2";
        return _this;
    }
    _create_class._(ProfileService, [
        {
            /**
     * Initialize the service. If you don't call this method, no other method can be called.
     * @tutorial ./doc/profileInit.md
     */ key: "init",
            value: function init() {
                if (!this.isInitialized) {
                    this.basePath = "platforms/".concat(fido_1.fido.get("platformCode"));
                    this.isInitialized = true;
                }
            }
        },
        {
            /**
     * Returns information about a specific user profile.
     *
     * @async
     * @param {Object} params Parameters passed to the function.
     * @param {string} params.profileUid UID of the profile to fetch
     * @param {string} params.userUid UID of the associated user
     * @tutorial ./doc/profileGetProfile.md
     */ key: "getProfile",
            value: function getProfile(param) {
                var profileUid = param.profileUid, userUid = param.userUid, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                var missingIds = [];
                if (!profileUid) missingIds.push("profileUid");
                if (!userUid) missingIds.push("userUid");
                if (missingIds.length > 0) {
                    throw new Error("Missing required parameters: ".concat(missingIds.join(", ")));
                }
                var endpoint = "".concat(buildUserEndpoint(userUid), "/").concat(profileUid);
                var url = this.getRouteUrl(endpoint);
                return this.fetch(url, {
                    method: "GET",
                    headers: headers
                });
            }
        },
        {
            /**
     * Create a new profile
     *
     * @async
     * @param {Object} params Must contains gigya uid, user name. Other params are optionals.
     * @tutorial ./doc/profileCreateProfile.md
     */ key: "createProfile",
            value: function createProfile(param) {
                var uid = param.uid, profileName = param.profileName, profileType = param.profileType, birthDate = param.birthDate, gender = param.gender, avatarId = param.avatarId, headers = param.headers;
                var endpoint = buildUserEndpoint(uid);
                var url = this.getRouteUrl(endpoint);
                return this.fetch(url, {
                    method: "POST",
                    headers: headers,
                    body: {
                        username: profileName,
                        profile_type: profileType,
                        birthdate: birthDate,
                        gender: gender,
                        avatar_id: avatarId
                    }
                }).catch(function(err) {
                    if (err.status === 403) {
                        throw new profile_errors_1.UserFirstProfileCannotBeKidError();
                    }
                    if (err.status === 423) {
                        throw new profile_errors_1.UserMaxAuthorizedProfilesCreatedError();
                    }
                    throw err;
                });
            }
        },
        {
            /**
     * Create a new profile
     *
     * @async
     * @param {Object} params Must contains gigya uid. Other params are optionals.
     * @tutorial ./doc/profileListProfiles.md
     */ key: "listProfiles",
            value: function listProfiles(param) {
                var uid = param.uid, headers = param.headers;
                var endpoint = buildUserEndpoint(uid);
                var url = this.getRouteUrl(endpoint);
                if (!uid) {
                    throw new Error("You must provide a uid");
                }
                return this.fetch(url, {
                    method: "GET",
                    headers: headers
                });
            }
        },
        {
            /**
     * Get the list of available avatar.
     *
     * @async
     * @param {Object} params Must contains gigya uid. Other params are optionals.
     * @tutorial ./doc/getAvailableAvatars.md
     */ key: "getAvailableAvatars",
            value: function getAvailableAvatars(param) {
                var uid = param.uid, headers = param.headers, _param_profileType = param.profileType, profileType = _param_profileType === void 0 ? "adult" : _param_profileType;
                var endpoint = "users/".concat(uid, "/avatars/").concat(profileType);
                var url = this.getRouteUrl(endpoint);
                return this.fetch(url, {
                    method: "GET",
                    headers: headers
                });
            }
        },
        {
            /**
     * Update a profile
     *
     * @async
     * @param {Object} params Must contains gigya uid, profile uid, user name. Other params are optionals.
     * @tutorial ./doc/profileUpdateProfile.md
     */ key: "updateProfile",
            value: function updateProfile(param) {
                var uid = param.uid, profileUid = param.profileUid, profileName = param.profileName, profileType = param.profileType, birthDate = param.birthDate, gender = param.gender, avatarId = param.avatarId, headers = param.headers;
                var endpoint = buildUserEndpoint(uid);
                var url = "".concat(this.getRouteUrl(endpoint), "/").concat(profileUid);
                return this.fetch(url, {
                    method: "PUT",
                    headers: headers,
                    body: {
                        username: profileName,
                        profile_type: profileType,
                        birthdate: birthDate,
                        gender: gender,
                        avatar_id: avatarId
                    }
                }).catch(function(err) {
                    if (err.status === 403) {
                        throw new profile_errors_1.UserLastProfileCannotBeKidError();
                    }
                    throw err;
                });
            }
        },
        {
            /**
     * Delete a profile
     *
     * @async
     * @param {Object} params Must contains gigya uid, profile uid.
     * @tutorial ./doc/profileDeleteProfile.md
     */ key: "deleteProfile",
            value: function deleteProfile(param) {
                var uid = param.uid, profileUid = param.profileUid, headers = param.headers;
                var endpoint = buildUserEndpoint(uid);
                var url = "".concat(this.getRouteUrl(endpoint), "/").concat(profileUid);
                return this.fetch(url, {
                    method: "DELETE",
                    headers: headers
                }).catch(function(err) {
                    if (err.status === 403) {
                        throw new profile_errors_1.UserLastAdultProfileCannotBeDeletedError();
                    }
                    throw err;
                });
            }
        }
    ]);
    return ProfileService;
}(fetcherService_1.FetcherService);
__decorate([
    withJWT_1.withJWT,
    monitoring
], ProfileService.prototype, "getProfile", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], ProfileService.prototype, "createProfile", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], ProfileService.prototype, "listProfiles", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], ProfileService.prototype, "getAvailableAvatars", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], ProfileService.prototype, "updateProfile", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], ProfileService.prototype, "deleteProfile", null);
exports.profileService = new ProfileService();


/***/ }),

/***/ 30169:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(42578);
var __decorate = (void 0) && (void 0).__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (void 0) && (void 0).__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.userService = void 0;
var map_1 = __importDefault(__webpack_require__(65512));
var fido_1 = __webpack_require__(19322);
var securityHeaderBuilder_1 = __webpack_require__(79660);
var withJWT_1 = __webpack_require__(56282);
var fetcherService_1 = __webpack_require__(96571);
var withMonitoring_1 = __webpack_require__(97982);
var monitoring = (0, withMonitoring_1.withMonitoring)("user");
var buildUserEndpoint = function(uid, submodule, action) {
    return "users/".concat(uid, "/").concat(submodule, "/").concat(action);
};
/**
 * @module User
 * @description The User service is used to interact with the 6play user middleware.
 * @tutorial ./doc/user.md
 */ var UserService = /*#__PURE__*/ function(_fetcherService_1_FetcherService) {
    _inherits._(UserService, _fetcherService_1_FetcherService);
    var _super = _create_super._(UserService);
    function UserService() {
        _class_call_check._(this, UserService);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.apiType = "userv2";
        return _this;
    }
    _create_class._(UserService, [
        {
            /**
     * Initialize the service. If you don't call this method, no other method can be called.
     * @param {Object} boxType Used to identify on which device the client is.
     * @tutorial ./doc/userInit.md
     */ key: "init",
            value: function init() {
                var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_boxType = _ref.boxType, boxType = _ref_boxType === void 0 ? fido_1.fido.get("clientCode") : _ref_boxType;
                if (!this.isInitialized) {
                    this.basePath = "platforms/".concat(fido_1.fido.get("platformCode"));
                    this.boxType = boxType;
                    this.isInitialized = true;
                }
            }
        },
        {
            /**
     * Modify the user newsletter status.
     *
     * @async
     * @param {string} uid User ID.
     * @param {string} action Action ('subscribe', 'unsubscribe').
     * @param {Object[]} newsletters to subscribe/unsubscribe.
     * @returns {string} Email of the user.
     * @tutorial ./doc/userPostNewsletter.md
     */ key: "postNewsletter",
            value: function postNewsletter(uid, action, newsletters) {
                var endpoint = buildUserEndpoint(uid, "newsletters", action);
                var url = this.getRouteUrl(endpoint);
                var path = this.getRoutePath(endpoint, true);
                return this.fetch(url, {
                    method: "POST",
                    body: newsletters,
                    headers: (0, securityHeaderBuilder_1.getTimestampHeader)(path, newsletters, fido_1.fido.get("getCurrentTime")(), fido_1.fido.get("saltAndSugar"))
                });
            }
        },
        {
            /**
     * Fetch newsletter subscriptions
     *
     * @async
     * @param {Object} params
     * @param {string} params.uid User ID.
     * @param {Object=} params.headers
     * @tutorial ./doc/getNewsletterSubscriptions.md
     */ key: "getNewsletterSubscriptions",
            value: function getNewsletterSubscriptions(param) {
                var uid = param.uid, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                if (!uid) {
                    throw new Error("You should provide an uid");
                }
                var endpoint = "users/".concat(uid, "/newsletters");
                var url = this.getRouteUrl(endpoint);
                return this.fetch(url, {
                    method: "GET",
                    headers: headers
                });
            }
        },
        {
            /**
     * Set newsletter subscriptions
     *
     * @async
     * @param {Object} params
     * @param {string} params.uid User ID.
     * @param {object} params.newsletters User newsletter subscriptions.
     * @param {Object=} params.headers
     * @tutorial ./doc/setNewsletterSubscriptions.md
     */ key: "setNewsletterSubscriptions",
            value: function setNewsletterSubscriptions(param) {
                var uid = param.uid, newsletters = param.newsletters, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                if (!uid) {
                    throw new Error("You should provide an uid");
                }
                var endpoint = "users/".concat(uid, "/newsletters");
                var url = this.getRouteUrl(endpoint);
                return this.fetch(url, {
                    method: "POST",
                    headers: headers,
                    body: {
                        newsletters: (0, map_1.default)(newsletters, function(value, key) {
                            return {
                                code: key,
                                subscribed: value
                            };
                        })
                    }
                });
            }
        },
        {
            /**
     * Fetch the last recent viewed clips. Items contain some clip and program information but mainly the last timecode seen.
     *
     * @async
     * @param {Object} options Contains an uid key (mandatory), some optionnal headers to link to the request, and a limit (default to 50 items).
     * @return {Object[]} Clips seens lastly, with clipId, programId, clipType, lasttcseen and more.
     * @tutorial ./doc/userGetLastViewedClips.md
     */ key: "getLastViewedClips",
            value: function getLastViewedClips(param) {
                var uid = param.uid, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers, _param_limit = param.limit, limit = _param_limit === void 0 ? 50 : _param_limit;
                if (!uid) {
                    throw new Error("You should provide an uid");
                }
                var endpoint = "users/".concat(uid, "/videos?limit=").concat(limit);
                var url = this.getRouteUrl(endpoint);
                return this.fetch(url, {
                    method: "GET",
                    headers: headers
                });
            }
        },
        {
            /**
     * Add a notifier to the user's list.
     *
     * @async
     * @param {Object} options Must contain entityId and entityType, can contain a headers key, for additionnal headers to attach to the request.
     * @param {string} [options.entityId]
     * @param {number} [options.entityType]
     * @param {Object} [options.headers={}]
     * tutorial ./doc/userAddNotifier.md
     */ key: "addNotifier",
            value: function addNotifier(param) {
                var entityId = param.entityId, entityType = param.entityType, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                if (!entityId || !entityType) {
                    throw new Error("You should provide an entityId and a entityType");
                }
                var url = "".concat(fido_1.fido.getBaseUrl("userv4"), "/").concat(fido_1.fido.get("customerCode"), "/").concat(fido_1.fido.get("platformCode"), "/bookmark/notify");
                return this.fetch(url, {
                    method: "PUT",
                    body: {
                        entityId: entityId,
                        entityType: entityType,
                        notified: true
                    },
                    headers: headers
                });
            }
        },
        {
            /**
     * Remove a notifier from the user's list.
     *
     * @async
     * @param {Object} options Must contain entityId and entityType, can contain a headers key, for additionnal headers to attach to the request.
     * @param {string} [options.entityId]
     * @param {number} [options.entityType]
     * @param {Object} [options.headers={}]
     * @tutorial ./doc/userRemoveNotifier.md
     */ key: "removeNotifier",
            value: function removeNotifier(param) {
                var entityId = param.entityId, entityType = param.entityType, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                if (!entityId || !entityType) {
                    throw new Error("You should provide an entityId and a entityType");
                }
                var url = "".concat(fido_1.fido.getBaseUrl("userv4"), "/").concat(fido_1.fido.get("customerCode"), "/").concat(fido_1.fido.get("platformCode"), "/bookmark/notify");
                return this.fetch(url, {
                    method: "PUT",
                    body: {
                        entityId: entityId,
                        entityType: entityType,
                        notified: false
                    },
                    headers: headers
                });
            }
        },
        {
            /**
     * Add a bookmark to the user's list.
     *
     * @async
     * @param {Object} options Must contain uid and programId, can contain a headers key, for additionnal headers to attach to the request.
     * @tutorial ./doc/userAddBookmark.md
     */ key: "addBookmark",
            value: function addBookmark(param) {
                var entityId = param.entityId, entityType = param.entityType, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                if (!entityId || !entityType) {
                    throw new Error("You should provide an entityId and a entityType");
                }
                var url = "".concat(fido_1.fido.getBaseUrl("userv4"), "/").concat(fido_1.fido.get("customerCode"), "/").concat(fido_1.fido.get("platformCode"), "/bookmark");
                return this.fetch(url, {
                    method: "PUT",
                    body: {
                        entityId: entityId,
                        entityType: entityType,
                        subscribed: true
                    },
                    headers: headers
                });
            }
        },
        {
            /**
     * Remove a bookmark from the user's list.
     *
     * @async
     * @param {Object} options Must contain uid and programId, can contain a headers key, for additionnal headers to attach to the request.
     * @tutorial ./doc/userRemoveBookmark.md
     */ key: "removeBookmark",
            value: function removeBookmark(param) {
                var entityId = param.entityId, entityType = param.entityType, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                if (!entityId || !entityType) {
                    throw new Error("You should provide an entityId and a entityType");
                }
                var url = "".concat(fido_1.fido.getBaseUrl("userv4"), "/").concat(fido_1.fido.get("customerCode"), "/").concat(fido_1.fido.get("platformCode"), "/bookmark");
                return this.fetch(url, {
                    method: "PUT",
                    body: {
                        entityId: entityId,
                        entityType: entityType,
                        subscribed: false
                    },
                    headers: headers
                });
            }
        },
        {
            /**
     * Retrieves the user's bookmarks.
     *
     * @async
     * @param {Object} options Must contain uid, can contain offset, limit or headers key, for additionnal headers to attach to the request.
     * @returns {Object[]} List of programs.
     * @tutorial ./doc/userGetBookmarks.md
     */ key: "getBookmarks",
            value: function getBookmarks(param) {
                var uid = param.uid, _param_offset = param.offset, offset = _param_offset === void 0 ? 0 : _param_offset, _param_limit = param.limit, limit = _param_limit === void 0 ? 50 : _param_limit, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                if (!uid) {
                    throw new Error("You should provide an uid");
                }
                var endpoint = "users/".concat(uid, "/programsubscriptions/programs?offset=").concat(offset, "&limit=").concat(limit);
                var url = this.getRouteUrl(endpoint);
                return this.fetch(url, {
                    method: "GET",
                    headers: headers
                });
            }
        },
        {
            /**
     * Retrieves the user's bookmarks ids.
     *
     * @async
     * @param {Object} options Must contain uid, can contain a headers key, for additionnal headers to attach to the request.
     * @returns {Object[]} A list of program ids.
     * @tutorial ./doc/userGetBookmarksIds.md
     */ key: "getBookmarksIds",
            value: function getBookmarksIds(param) {
                var uid = param.uid, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                if (!uid) {
                    throw new Error("You should provide an uid");
                }
                var endpoint = "users/".concat(uid, "/programsubscriptions");
                var url = this.getRouteUrl(endpoint);
                return this.fetch(url, {
                    method: "GET",
                    headers: headers
                });
            }
        },
        {
            /**
     * Retrieves the user's custom segments
     *
     * @async
     * @param {Object} options Must contain uid and destination
     * @tutorial ./doc/userGetCustomSegments.md
     */ key: "getUserCustomSegments",
            value: function getUserCustomSegments(param) {
                var uid = param.uid, destination = param.destination, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                if (!uid || !destination) {
                    throw new Error("You must provide a valid uid and a destination");
                }
                var endpoint = "users/".concat(uid, "/destinations/").concat(destination, "/segments");
                var url = this.getRouteUrl(endpoint);
                return this.fetch(url, {
                    method: "GET",
                    headers: headers
                });
            }
        },
        {
            /**
     * Retrieves the user's setttings
     * It must use v3 endpoint because there is no v2 endpoint for it.
     * The main difference between v2 and v3 is that uid is removed (to force the use of jwt).
     *
     * @async
     * @tutorial ./doc/userGetUserSettings.md
     */ key: "getUserSettings",
            value: function getUserSettings() {
                var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_headers = _ref.headers, headers = _ref_headers === void 0 ? {} : _ref_headers;
                var route = "".concat(fido_1.fido.getBaseUrl("userv3"), "/").concat(fido_1.fido.get("customerCode"), "/").concat(fido_1.fido.get("platformCode"), "/account");
                return this.fetch(route, {
                    method: "GET",
                    headers: headers
                });
            }
        },
        {
            /**
     * Update the user's settings.
     * It must use v3 endpoint because there is no v2 endpoint for it.
     * The main difference between v2 and v3 is that uid is removed (to force the use of jwt).
     *
     * @async
     * @param {Object} options Must contain greenMode, autoplay, quality, can contain a headers key, for additionnal headers to attach to the request.
     * @tutorial ./doc/userSetUserSettings.md
     */ key: "setUserSettings",
            value: function setUserSettings(param) {
                var greenModeActivated = param.greenModeActivated, videoSettings = param.videoSettings, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                var route = "".concat(fido_1.fido.getBaseUrl("userv3"), "/").concat(fido_1.fido.get("customerCode"), "/").concat(fido_1.fido.get("platformCode"), "/account");
                return this.fetch(route, {
                    method: "PATCH",
                    headers: headers,
                    body: {
                        greenModeActivated: greenModeActivated,
                        videoSettings: {
                            videoMaxQuality: videoSettings && videoSettings.videoMaxQuality,
                            autoplay: videoSettings && videoSettings.autoplay
                        }
                    }
                });
            }
        },
        {
            /**
     * Update the video settings.
     * It must use v3 endpoint because there is no v2 endpoint for it.
     *
     * @async
     * @param {Object} options Must contain videoMaxQuality, autoplay, can contain a headers key, for additionnal headers to attach to the request and trackPreferences.
     * @tutorial ./doc/setVideoSettings.md
     */ key: "setVideoSettings",
            value: function setVideoSettings(param) {
                var videoMaxQuality = param.videoMaxQuality, autoplay = param.autoplay, trackPreferences = param.trackPreferences, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                var route = "".concat(fido_1.fido.getBaseUrl("userv3"), "/").concat(fido_1.fido.get("customerCode"), "/").concat(fido_1.fido.get("platformCode"), "/videoSettings");
                return this.fetch(route, {
                    method: "PATCH",
                    headers: headers,
                    body: {
                        videoMaxQuality: videoMaxQuality,
                        autoplay: autoplay,
                        trackPreferences: trackPreferences && trackPreferences.length > 0 ? trackPreferences : undefined
                    }
                });
            }
        },
        {
            /**
     * @param {Object} params
     * @param {{ audioLanguage: string, audioDescription: boolean } | undefined} params.audioPreference
     * @param {{ subtitleLanguage: string, role: string } | null} params.subtitlesPreference
     * @param {string} params.originalLanguage
     * @param {Object=} params.headers
     *
     * the language code must have 3 characters and respect the standard ISO 639-3
     * subtitlePreference can be null if no track is selected
     *
     * @returns {Promise<*>}
     */ key: "setTrackPreferences",
            value: function setTrackPreferences(param) {
                var audioPreference = param.audioPreference, subtitlesPreference = param.subtitlesPreference, originalLanguage = param.originalLanguage, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                var route = "".concat(fido_1.fido.getBaseUrl("userv3"), "/").concat(fido_1.fido.get("customerCode"), "/").concat(fido_1.fido.get("platformCode"), "/videoSettings");
                return this.fetch(route, {
                    method: "PATCH",
                    headers: headers,
                    body: {
                        trackPreferences: [
                            {
                                originalLanguage: originalLanguage,
                                audioPreference: audioPreference,
                                subtitlesPreference: subtitlesPreference
                            }
                        ]
                    }
                });
            }
        },
        {
            /**
     * Revoke a device.
     *
     * @async
     * @param {Object} params
     * @param {string} params.deviceId the infos about the device to revoke, e.g. "orange_newbox|deviceid-01bbaf51f1b2a050faf2c1bcdc768d66206710f6-1655887222150-Z-154395"
     * @param {Object=} params.headers
     */ key: "revokeDevice",
            value: function revokeDevice() {
                var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, deviceId = _ref.deviceId, _ref_headers = _ref.headers, headers = _ref_headers === void 0 ? {} : _ref_headers;
                var route = "".concat(fido_1.fido.getBaseUrl("userv3"), "/").concat(fido_1.fido.get("customerCode"), "/").concat(fido_1.fido.get("platformCode"), "/devices/toRevoke");
                return this.fetch(route, {
                    method: "PATCH",
                    headers: headers,
                    body: {
                        deviceId: deviceId
                    }
                });
            }
        },
        {
            /**
     * Revoke the current device.
     *
     * @async
     */ key: "revokeCurrentDevice",
            value: function revokeCurrentDevice() {
                var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_headers = _ref.headers, headers = _ref_headers === void 0 ? {} : _ref_headers;
                var route = "".concat(fido_1.fido.getBaseUrl("userv3"), "/").concat(fido_1.fido.get("customerCode"), "/").concat(fido_1.fido.get("platformCode"), "/devices/revokeCurrentDevice");
                return this.fetch(route, {
                    method: "PATCH",
                    headers: headers
                });
            }
        },
        {
            /**
     * Get user subscription type.
     *
     * @async
     */ key: "getUserSubscriptionType",
            value: function getUserSubscriptionType() {
                var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_headers = _ref.headers, headers = _ref_headers === void 0 ? {} : _ref_headers;
                var route = "".concat(fido_1.fido.getBaseUrl("userv3"), "/").concat(fido_1.fido.get("customerCode"), "/").concat(fido_1.fido.get("platformCode"), "/account/subscriptionType");
                return this.fetch(route, {
                    method: "GET",
                    headers: headers
                });
            }
        },
        {
            /**
     * Delete user account
     * Remove account from authentication provider and Bedrock database.
     *
     * @async
     */ key: "deleteAccount",
            value: function deleteAccount() {
                var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_headers = _ref.headers, headers = _ref_headers === void 0 ? {} : _ref_headers;
                var route = "".concat(fido_1.fido.getBaseUrl("userv3"), "/").concat(fido_1.fido.get("customerCode"), "/").concat(fido_1.fido.get("platformCode"), "/account");
                return this.fetch(route, {
                    method: "DELETE",
                    headers: headers
                });
            }
        }
    ]);
    return UserService;
}(fetcherService_1.FetcherService);
__decorate([
    monitoring
], UserService.prototype, "postNewsletter", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], UserService.prototype, "getNewsletterSubscriptions", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], UserService.prototype, "setNewsletterSubscriptions", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], UserService.prototype, "getLastViewedClips", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], UserService.prototype, "addNotifier", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], UserService.prototype, "removeNotifier", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], UserService.prototype, "addBookmark", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], UserService.prototype, "removeBookmark", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], UserService.prototype, "getBookmarks", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], UserService.prototype, "getBookmarksIds", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], UserService.prototype, "getUserCustomSegments", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], UserService.prototype, "getUserSettings", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], UserService.prototype, "setUserSettings", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], UserService.prototype, "setVideoSettings", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], UserService.prototype, "setTrackPreferences", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], UserService.prototype, "revokeDevice", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], UserService.prototype, "revokeCurrentDevice", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], UserService.prototype, "getUserSubscriptionType", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], UserService.prototype, "deleteAccount", null);
exports.userService = new UserService();


/***/ }),

/***/ 58203:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(45538);
var __decorate = (void 0) && (void 0).__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.videoService = void 0;
var fido_1 = __webpack_require__(19322);
var queryParamSerializer_1 = __webpack_require__(19007);
var withJWT_1 = __webpack_require__(56282);
var fetcherService_1 = __webpack_require__(96571);
var withMonitoring_1 = __webpack_require__(97982);
var monitoring = (0, withMonitoring_1.withMonitoring)("video");
/**
 * @module Video
 * @description This service is used to get a video from middleware API
 * @tutorial ./doc/video.md
 */ var VideoService = /*#__PURE__*/ function(_fetcherService_1_FetcherService) {
    _inherits._(VideoService, _fetcherService_1_FetcherService);
    var _super = _create_super._(VideoService);
    function VideoService() {
        _class_call_check._(this, VideoService);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.apiType = "middlewarev2";
        return _this;
    }
    _create_class._(VideoService, [
        {
            /**
     * Initialize the service. If you don't call this method, no other method can be called.
     * @tutorial ./doc/videoInit.md
     */ key: "init",
            value: function init() {
                if (!this.isInitialized) {
                    this.basePath = "platforms/".concat(fido_1.fido.get("platformCode"), "/services");
                    this.isInitialized = true;
                }
            }
        },
        {
            key: "fetchByVideoId",
            value: /**
     * Get information about the video designated by the requested videoId.
     *
     * @async
     * @param {Object} options videoId Requested video id, serviceCode Service where the informations should be retrieved from, queryParams Extra query parameters. Uses keys / values literally as provided in the object.
     * @returns {Object} Informations about the video
     * @tutorial ./doc/videoFetchByVideoId.md
     */ function fetchByVideoId() {
                var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, videoId = _ref.videoId, serviceCode = _ref.serviceCode, _ref_queryParams = _ref.queryParams, queryParams = _ref_queryParams === void 0 ? {} : _ref_queryParams, _ref_headers = _ref.headers, headers = _ref_headers === void 0 ? {} : _ref_headers;
                var _this = this;
                return _async_to_generator._(function() {
                    var error;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!videoId || !serviceCode) {
                                    throw new Error("You should provide non null videoId and serviceCode");
                                }
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    _this.fetch(_this.getRouteUrl("".concat(serviceCode, "/videos/").concat(videoId, "?").concat((0, queryParamSerializer_1.serialize)(queryParams))), {
                                        method: "GET",
                                        headers: headers
                                    })
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 3:
                                error = _state.sent();
                                if (error.response && error.response.status === 410) {
                                    return [
                                        2,
                                        error.response.body
                                    ];
                                }
                                throw error;
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "fetchVideos",
            value: /**
     * Get a list of all available videos.
     *
     * @async
     * @param {Object} options Options for fetching videos.
     * @param {string} options.serviceCode Service where the information should be retrieved from.
     * @param {string} options.csa Age rating parameter.
     * @param {number} options.offset Starting item for pagination.
     * @param {number} options.limit Maximum number of items to return for pagination.
     * @param {string} options.type Filter on video types.
     * @param {string} [options.with] Adds new data nodes to data initially sent (comma-separated values: freemiumpacks, inactivefreemiumpacks, clips, tags, expiration, program_details, program_images, related_content).
     * @param {Object} [options.headers={}] Optional HTTP headers.
     * @returns {Object} Response object with body containing an array of videos (can be empty).
     * @throws Will throw an error if serviceCode is not provided.
     * @throws Will throw an error if csa is not provided.
     * @throws Will throw an error if offset is not a valid number.
     * @throws Will throw an error if limit is not a valid number.
     * @throws Will throw an error if type is not provided.
     */ function fetchVideos() {
                var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, serviceCode = _ref.serviceCode, csa = _ref.csa, offset = _ref.offset, limit = _ref.limit, type = _ref.type, withParam = _ref.with, _ref_headers = _ref.headers, headers = _ref_headers === void 0 ? {} : _ref_headers;
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!serviceCode) {
                                    throw new Error("You should provide a service code");
                                }
                                if (!csa) {
                                    throw new Error("You should provide a csa code");
                                }
                                if (typeof offset !== "number" || isNaN(offset)) {
                                    throw new Error("You should provide a valid numeric offset");
                                }
                                if (typeof limit !== "number" || isNaN(limit)) {
                                    throw new Error("You should provide a valid numeric limit");
                                }
                                if (!type) {
                                    throw new Error("You should provide a video type");
                                }
                                return [
                                    4,
                                    _this.fetchWithResponse(_this.getRouteUrl("".concat(serviceCode, "/videos?csa=").concat(csa, "&offset=").concat(offset, "&limit=").concat(limit, "&type=").concat(type).concat(withParam ? "&with=".concat(withParam) : "")), {
                                        method: "GET",
                                        headers: headers
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "fetchNextVideos",
            value: /**
     *
     * @async
     * @param {Object} options videoId Current video id, serviceCode Service where the informations should be retrieved from, queryParams Extra query parameters. Uses keys / values literally as provided in the object.
     * @return {Object}
     * @tutorial ./doc/videoFetchNextVideos.md
     */ function fetchNextVideos() {
                var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, videoId = _ref.videoId, serviceCode = _ref.serviceCode, _ref_queryParams = _ref.queryParams, queryParams = _ref_queryParams === void 0 ? {
                    csa: 0,
                    type: "vi",
                    with: "clips,freemiumpacks,program_images"
                } : _ref_queryParams, _ref_headers = _ref.headers, headers = _ref_headers === void 0 ? {} : _ref_headers;
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        if (!videoId || !serviceCode) {
                            throw new Error("You should provide non null videoId and serviceCode");
                        }
                        return [
                            2,
                            _this.fetch(_this.getRouteUrl("".concat(serviceCode, "/videos/").concat(videoId, "/nextvideos?").concat((0, queryParamSerializer_1.serialize)(queryParams))), {
                                method: "GET",
                                headers: headers
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "fetchVideosByProgramId",
            value: /**
     * List all videos of a program. Used for example to build recommandations in players.
     *
     * @async
     * @param {Object} options programId Program to fetch videos from, service Service where the informations should be retrieved from, queryParams Extra query parameters. Uses keys / values literally as provided in the object.
     * @return {Object}
     * @tutorial ./doc/videoFetchVideosByProgramId.md
     */ function fetchVideosByProgramId() {
                var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, programId = _ref.programId, serviceCode = _ref.serviceCode, _ref_queryParams = _ref.queryParams, queryParams = _ref_queryParams === void 0 ? {
                    csa: 0,
                    offset: 0,
                    limit: 20,
                    type: "vi"
                } : _ref_queryParams, _ref_headers = _ref.headers, headers = _ref_headers === void 0 ? {} : _ref_headers;
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        if (!programId || !serviceCode) {
                            throw new Error("You should provide non null programId and serviceCode");
                        }
                        return [
                            2,
                            _this.fetch(_this.getRouteUrl("".concat(serviceCode, "/programs/").concat(programId, "/videos?").concat((0, queryParamSerializer_1.serialize)(queryParams))), {
                                method: "GET",
                                headers: headers
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "fetchByExternalKey",
            value: /**
     * Get information about the video with an external key.
     *
     * @async
     * @param {Object} externalKey An external key which allows to identity the video (ex: asset reference)
     * @param {Object} serviceCode Service where the informations should be retrieved from
     * @param {Object} queryParams Extra query parameters (ex: csa)
     * @return {Object} Informations about the video
     * @throws Will throw an error if externalKey or serviceCode are not provided
     * @tutorial ./doc/videoFetchByExternalKey.md
     */ function fetchByExternalKey() {
                var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, externalKey = _ref.externalKey, serviceCode = _ref.serviceCode, _ref_queryParams = _ref.queryParams, queryParams = _ref_queryParams === void 0 ? {
                    csa: 0
                } : _ref_queryParams, _ref_headers = _ref.headers, headers = _ref_headers === void 0 ? {} : _ref_headers;
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        if (!externalKey || !serviceCode) {
                            throw new Error("You should provide non null externalKey or serviceCode");
                        }
                        return [
                            2,
                            _this.fetch(_this.getRouteUrl("".concat(serviceCode, "/videos/external_asset/").concat(externalKey, "?").concat((0, queryParamSerializer_1.serialize)(queryParams))), {
                                method: "GET",
                                headers: headers
                            })
                        ];
                    });
                })();
            }
        }
    ]);
    return VideoService;
}(fetcherService_1.FetcherService);
__decorate([
    withJWT_1.withJWT,
    monitoring
], VideoService.prototype, "fetchByVideoId", null);
__decorate([
    monitoring
], VideoService.prototype, "fetchVideos", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], VideoService.prototype, "fetchNextVideos", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], VideoService.prototype, "fetchVideosByProgramId", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], VideoService.prototype, "fetchByExternalKey", null);
exports.videoService = new VideoService();


/***/ }),

/***/ 61255:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(3009);
var __decorate = (void 0) && (void 0).__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.videolandPaymentService = void 0;
var fetcherService_1 = __webpack_require__(96571);
var withMonitoring_1 = __webpack_require__(97982);
var monitoring = (0, withMonitoring_1.withMonitoring)("videolandPayment");
/**
 * @module Videoland payment
 * @description The Videoland payment service is used to get the supported payment methods.
 * @tutorial ./doc/videolandPayment.md
 */ var VideolandPaymentService = /*#__PURE__*/ function(_fetcherService_1_FetcherService) {
    _inherits._(VideolandPaymentService, _fetcherService_1_FetcherService);
    var _super = _create_super._(VideolandPaymentService);
    function VideolandPaymentService() {
        _class_call_check._(this, VideolandPaymentService);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.apiType = "videolandApi";
        return _this;
    }
    _create_class._(VideolandPaymentService, [
        {
            /**
     * Initialize the service. If you don't call this method, no other method can be called.
     * @tutorial ./doc/videolandPaymentInit.md
     */ key: "init",
            value: function init() {
                if (!this.isInitialized) {
                    this.basePath = "subscribe/payment/v1/payment-methods";
                    this.isInitialized = true;
                }
            }
        },
        {
            /**
     * Gets the list of supported credit card types
     *
     * @async
     * @tutorial ./doc/videolandPaymentGetCreditCards.md
     */ key: "getCreditCards",
            value: function getCreditCards() {
                var endpoint = "creditcard/types";
                var url = this.getRouteUrl(endpoint);
                return this.fetch(url, {
                    method: "GET"
                });
            }
        },
        {
            /**
     * Gets the list of supported banks.
     *
     * @async
     * @tutorial ./doc/videolandPaymentGetBanks.md
     */ key: "getBanks",
            value: function getBanks() {
                var endpoint = "ideal/banks";
                var url = this.getRouteUrl(endpoint);
                return this.fetch(url, {
                    method: "GET"
                });
            }
        }
    ]);
    return VideolandPaymentService;
}(fetcherService_1.FetcherService);
__decorate([
    monitoring
], VideolandPaymentService.prototype, "getCreditCards", null);
__decorate([
    monitoring
], VideolandPaymentService.prototype, "getBanks", null);
exports.videolandPaymentService = new VideolandPaymentService();


/***/ }),

/***/ 19953:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _define_property = __webpack_require__(21228);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(65759);
var __decorate = (void 0) && (void 0).__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.watchedContentsVisibilityService = exports.WatchedContentsVisibilityService = void 0;
var fido_1 = __webpack_require__(19322);
var withJWT_1 = __webpack_require__(56282);
var fetcherService_1 = __webpack_require__(96571);
var withMonitoring_1 = __webpack_require__(97982);
var monitoring = (0, withMonitoring_1.withMonitoring)("watchedContentsVisibility");
/**
 * @module Heartbeat
 * @description A temporary service, needs to be removed when heartbeatv3 service will be production ready
 */ var WatchedContentsVisibilityService = /*#__PURE__*/ function(_fetcherService_1_FetcherService) {
    _inherits._(WatchedContentsVisibilityService, _fetcherService_1_FetcherService);
    var _super = _create_super._(WatchedContentsVisibilityService);
    function WatchedContentsVisibilityService() {
        _class_call_check._(this, WatchedContentsVisibilityService);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.apiType = "heartbeatv3";
        return _this;
    }
    _create_class._(WatchedContentsVisibilityService, [
        {
            key: "init",
            value: function init() {
                if (!this.isInitialized) {
                    this.isInitialized = true;
                    this.basePath = "".concat(fido_1.fido.get("customerCode"), "/").concat(fido_1.fido.get("platformCode"));
                    this.monitoring = monitoring;
                }
            }
        },
        {
            /**
     * Exclude contents from the resume watching list
     * @async
     *
     * @param {Object} headers The headers of the request
     * @param {array} contentIds An array containing content ids of content to remove
     * @returns {Object}
     */ key: "removeContentsFromList",
            value: function removeContentsFromList(param) {
                var _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers, contentIds = param.contentIds;
                if (!Array.isArray(contentIds) || contentIds.length === 0) {
                    throw new Error("You should provide a non-empty array of content IDs");
                }
                var body = contentIds.reduce(function(acc, contentId) {
                    return Object.assign(Object.assign({}, acc), _define_property._({}, contentId, true));
                }, {});
                return this.fetch(this.getRouteUrl("watched_contents_visibility"), {
                    method: "POST",
                    headers: headers,
                    body: body
                });
            }
        }
    ]);
    return WatchedContentsVisibilityService;
}(fetcherService_1.FetcherService);
exports.WatchedContentsVisibilityService = WatchedContentsVisibilityService;
__decorate([
    withJWT_1.withJWT,
    monitoring
], WatchedContentsVisibilityService.prototype, "removeContentsFromList", null);
exports.watchedContentsVisibilityService = new WatchedContentsVisibilityService();


/***/ }),

/***/ 43573:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _async_to_generator = __webpack_require__(24146);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(88801);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.backoff = backoff;
exports.withBackoff = withBackoff;
function wait(delayInMs) {
    return new Promise(function(resolve) {
        return setTimeout(resolve, delayInMs);
    });
}
/**
 * This generate a jitter value between [-delay*coeff;+delay*coeff]
 * E.g. if delay is 250 and coeff is 2, then the resulting jitter is in range [-500;+500]
 * This is useful to create chaos in timing without slowing down timers overall
 */ function generateJitter(delayInMs) {
    var coeff = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    var baseJitter = Math.abs(delayInMs * coeff);
    // generate a value between -1 and 1 inclusive
    var direction = Math.random() * 2 - 1;
    return baseJitter * direction;
}
function backoff(fn) {
    return _backoff.apply(this, arguments);
}
function _backoff() {
    _backoff = _async_to_generator._(function(fn) {
        var _ref, _ref_maxAttempts, maxAttempts, _ref_delay, delay, _ref_jitter, jitter, _attempt, error, exponent, computedJitter, backoffDelay;
        var _arguments = arguments;
        return _ts_generator._(this, function(_state) {
            switch(_state.label){
                case 0:
                    _ref = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {}, _ref_maxAttempts = _ref.maxAttempts, maxAttempts = _ref_maxAttempts === void 0 ? 5 : _ref_maxAttempts, _ref_delay = _ref.delay, delay = _ref_delay === void 0 ? 1000 : _ref_delay, _ref_jitter = _ref.jitter, jitter = _ref_jitter === void 0 ? 0 : _ref_jitter, _attempt = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : 0;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        7
                    ]);
                    return [
                        4,
                        fn()
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
                case 3:
                    error = _state.sent();
                    if (!(_attempt < maxAttempts - 1)) return [
                        3,
                        6
                    ];
                    exponent = Math.pow(2, _attempt);
                    computedJitter = generateJitter(jitter, _attempt + 1);
                    backoffDelay = Math.min(Math.abs(delay) * exponent, 30000) + computedJitter;
                    return [
                        4,
                        wait(backoffDelay)
                    ];
                case 4:
                    _state.sent();
                    return [
                        4,
                        backoff(fn, {
                            maxAttempts: maxAttempts,
                            delay: delay,
                            jitter: jitter
                        }, _attempt + 1)
                    ];
                case 5:
                    return [
                        2,
                        _state.sent()
                    ];
                case 6:
                    return [
                        2,
                        Promise.reject(error)
                    ];
                case 7:
                    return [
                        2
                    ];
            }
        });
    });
    return _backoff.apply(this, arguments);
}
function withBackoff(backoffOptions) {
    return function(target, propertyKey, descriptor) {
        var fn = descriptor.value;
        descriptor.value = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var _this = this;
            return backoff(function() {
                return fn.apply(_this, args);
            }, backoffOptions);
        };
        return descriptor;
    };
}


/***/ }),

/***/ 72345:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _to_consumable_array = __webpack_require__(30005);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(65759);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.withNoParallelRequest = exports.generateCachingKey = void 0;
var generateCachingKey = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return JSON.stringify(args);
};
exports.generateCachingKey = generateCachingKey;
var withNoParallelRequest = function(target, key, descriptor) {
    var cachedValues = {};
    var decoratedFunction = descriptor.value;
    descriptor.value = function withNoParallelRequest() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _decoratedFunction;
        var cachingKey = (0, exports.generateCachingKey)(args);
        var cachedValue = cachedValues[cachingKey];
        if (cachedValue !== undefined) {
            return cachedValue;
        }
        var resultingPromise = (_decoratedFunction = decoratedFunction).call.apply(_decoratedFunction, [
            this
        ].concat(_to_consumable_array._(args)));
        cachedValues[cachingKey] = resultingPromise;
        return resultingPromise.finally(function() {
            delete cachedValues[cachingKey];
        });
    };
};
exports.withNoParallelRequest = withNoParallelRequest;


/***/ }),

/***/ 70708:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _async_to_generator = __webpack_require__(24146);
var _to_consumable_array = __webpack_require__(30005);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(88801);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.connectAction = void 0;
var connectAction = function(resolver) {
    var promise = Promise.resolve();
    var waitForPromise = function(awaitedPromise) {
        promise = awaitedPromise;
        return awaitedPromise;
    };
    var connectedAction = function() {
        var _ref = _async_to_generator._(function() {
            var _len, args, _key, data;
            var _arguments = arguments;
            return _ts_generator._(this, function(_state) {
                switch(_state.label){
                    case 0:
                        for(_len = _arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                            args[_key] = _arguments[_key];
                        }
                        return [
                            4,
                            function() {
                                return promise;
                            }()
                        ];
                    case 1:
                        data = _state.sent();
                        resolver.apply(void 0, [
                            data
                        ].concat(_to_consumable_array._(args)));
                        return [
                            2
                        ];
                }
            });
        });
        return function connectedAction() {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        connectedAction: connectedAction,
        waitForPromise: waitForPromise
    };
};
exports.connectAction = connectAction;


/***/ }),

/***/ 27082:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(52318);
var __importDefault = (void 0) && (void 0).__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.fetch = void 0;
var superagent_1 = __importDefault(__webpack_require__(54247));
var fetch_error_1 = __webpack_require__(41180);
var fido_1 = __webpack_require__(19322);
var canSendBody = {
    PATCH: true,
    POST: true,
    PUT: true
};
var buildRequest = function(url, param) {
    var method = param.method, _param_body = param.body, body = _param_body === void 0 ? {} : _param_body, query = param.query, headers = param.headers, responseType = param.responseType;
    var req = (0, superagent_1.default)(method, url);
    if (headers) {
        req.set(headers);
    }
    if (query) {
        req.query(query);
    }
    if (responseType) {
        req.responseType(responseType);
    }
    if (canSendBody[method]) {
        return req.send(body);
    }
    return req;
};
var fetch = function(url) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return new Promise(function(resolve, reject) {
        options.method = options.method || "GET";
        options.maxTimeout = options.maxTimeout || fido_1.fido.get("maxTimeout");
        options.waitTimeout = options.waitTimeout || fido_1.fido.get("waitTimeout");
        var req = buildRequest(url, options);
        if (options.withCredentials) {
            req.withCredentials();
        }
        if (options.signal) {
            options.signal.addEventListener("abort", function() {
                req.abort();
            });
        }
        if (options.retry) {
            req.retry(options.retry.count, options.retry.callback(options.retry.apiType, options.method));
        }
        req.timeout({
            response: options.waitTimeout,
            deadline: options.maxTimeout
        }).end(function(err, response) {
            if (err) {
                return reject(new fetch_error_1.FetchError(err, {
                    url: url,
                    options: options
                }, response));
            }
            if (response.ok) {
                return resolve(response);
            }
            var error = new fetch_error_1.FetchError("".concat(response.statusText, ":").concat(response.status), {
                url: url,
                options: options
            }, response);
            return reject(error);
        });
    });
};
exports.fetch = fetch;


/***/ }),

/***/ 42627:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(52318);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.addFidoPropertyIfDefined = void 0;
var fido_1 = __webpack_require__(19322);
var addFidoPropertyIfDefined = function() {
    var target = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, fidoConfigKey = arguments.length > 1 ? arguments[1] : void 0, targetPropertyName = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : fidoConfigKey;
    return function() {
        var cloneTarget = Object.assign({}, target);
        if (fido_1.fido.get(fidoConfigKey)) {
            cloneTarget[targetPropertyName] = fido_1.fido.get(fidoConfigKey);
        }
        return cloneTarget;
    };
};
exports.addFidoPropertyIfDefined = addFidoPropertyIfDefined;


/***/ }),

/***/ 19007:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(88801);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.formatDate = exports.serialize = void 0;
/**
 * Serialize params passed in the map to queryParam structure
 *
 * @returns {string} queryparams string matching params
 */ var serialize = function() {
    var params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, filter = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function() {
        return true;
    };
    var paramKeys = Object.keys(params);
    if (!paramKeys.length) {
        return "";
    }
    return paramKeys.map(function(key) {
        return {
            key: key,
            value: params[key]
        };
    }).filter(filter).sort(function(param, param1) {
        var key1 = param.key, key2 = param1.key;
        return key1 <= key2 ? -1 : 1;
    }).map(function(param) {
        var key = param.key, value = param.value;
        return "".concat(key, "=").concat(encodeURIComponent(value));
    }).join("&");
};
exports.serialize = serialize;
var dateElementToString = function(element) {
    return "".concat(element < 10 ? "0" : "").concat(element);
};
/**
 * Converts Date into a string with YYYY-MM-DD HH:MM:SS format
 *
 * @param {Date} date
 */ var formatDate = function(date) {
    if (!(date instanceof Date)) {
        throw Error("The argument should be an instance of Date");
    }
    var dateParts = [
        date.getMonth() + 1,
        date.getDate()
    ].map(dateElementToString);
    dateParts.unshift(date.getFullYear());
    var timeParts = [
        date.getHours(),
        date.getMinutes(),
        date.getSeconds()
    ].map(dateElementToString);
    return "".concat(dateParts.join("-"), " ").concat(timeParts.join(":"));
};
exports.formatDate = formatDate;


/***/ }),

/***/ 10341:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(37815);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.retryPromise = retryPromise;
function retryPromise(fn) {
    var retriesLeft = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 3, delay = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    return new Promise(function(resolve, reject) {
        return fn().then(resolve).catch(function(error) {
            if (retriesLeft <= 1) {
                reject(error);
                return;
            }
            setTimeout(function() {
                retryPromise(fn, retriesLeft - 1, delay * 2).then(resolve, reject);
            }, delay);
        });
    });
}


/***/ }),

/***/ 26040:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(45538);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.buildRetryOptions = exports.retryRequestCallback = exports.RETRY_OPTIONS_ERROR_MESSAGE = exports.MAX_RETRY_COUNT = void 0;
var statsdMonitoringService_1 = __webpack_require__(86023);
exports.MAX_RETRY_COUNT = 2;
exports.RETRY_OPTIONS_ERROR_MESSAGE = "You should provide correct retry options parameters";
var retryRequestCallback = function(apiType, method) {
    return function(error) {
        statsdMonitoringService_1.statsdMonitoringService.sendIncrement([
            "fido",
            "retry",
            error ? "error" : "success",
            method,
            apiType
        ]);
    };
};
exports.retryRequestCallback = retryRequestCallback;
/**
 * @param {{apiType:string, count:Number}} params The build retry options params.
 * @returns {{apiType:string, count:Number, callback:Function}} The retry options.
 */ var buildRetryOptions = function(param) {
    var apiType = param.apiType, count = param.count;
    if (!apiType || typeof count !== "number" || count > exports.MAX_RETRY_COUNT) {
        throw new Error(exports.RETRY_OPTIONS_ERROR_MESSAGE);
    }
    return {
        apiType: apiType,
        count: count,
        callback: exports.retryRequestCallback
    };
};
exports.buildRetryOptions = buildRetryOptions;


/***/ }),

/***/ 11055:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(3009);
var __importDefault = (void 0) && (void 0).__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.genGuid = exports.TOKEN = exports.FREEMIUM = exports.GIGYA = exports.TIMESTAMP = exports.DEVICE = exports.UNSIGNED = void 0;
exports.getParamsString = getParamsString;
exports.genTimestampToken = genTimestampToken;
var hmac_sha1_1 = __importDefault(__webpack_require__(69764));
var flow_1 = __importDefault(__webpack_require__(14459));
var map_1 = __importDefault(__webpack_require__(65512));
var reject_1 = __importDefault(__webpack_require__(8207));
var sortBy_1 = __importDefault(__webpack_require__(84715));
exports.UNSIGNED = "UNSIGNED";
exports.DEVICE = "DEVICE";
exports.TIMESTAMP = "TIMESTAMP";
exports.GIGYA = "GIGYA";
exports.FREEMIUM = "FREEMIUM";
exports.TOKEN = "TOKEN";
function getParamsString(params, prefix) {
    return (0, flow_1.default)(function(x) {
        return (0, map_1.default)(x, function(value, key) {
            return {
                key: key,
                value: value
            };
        });
    }, function(x) {
        return (0, reject_1.default)(x, function(param) {
            var value = param.value;
            return value === undefined;
        });
    }, function(x) {
        return (0, sortBy_1.default)(x, "key");
    }, function(x) {
        return x.reduce(function(result, param) {
            var value = param.value, key = param.key;
            var prefixedKey = prefix ? "".concat(prefix, "[").concat(key, "]") : key;
            var safeValue = typeof value === "boolean" ? Number(value) : value;
            return result.concat(safeValue !== null && typeof safeValue === "object" ? getParamsString(safeValue, prefixedKey) : "".concat(encodeURIComponent(prefixedKey), "=").concat(encodeURIComponent(safeValue)));
        }, []);
    })(params).join("&");
}
function genTimestampToken(path, params, currentTime, saltAndSugar) {
    if (!saltAndSugar) {
        throw new Error("Fido saltAndSugar parameter should be defined to generate token, received: ".concat(saltAndSugar));
    }
    var paramsString = getParamsString(params);
    var timestamp = Math.floor(parseInt(currentTime, 10) / 1000);
    return {
        token: (0, hmac_sha1_1.default)("".concat(path).concat(paramsString).concat(Math.floor(timestamp / 60)), saltAndSugar).toString(),
        timestamp: timestamp
    };
}
var genGuid = function() {
    var time = new Date().getTime();
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(char) {
        // eslint-disable-next-line no-bitwise
        var replacement = (time + Math.random() * 16) % 16 | 0;
        time = Math.floor(time / 16);
        if (char === "x") {
            return replacement.toString(16);
        }
        // eslint-disable-next-line no-bitwise
        return (replacement & 0x3 | 0x8).toString(16);
    });
};
exports.genGuid = genGuid;


/***/ }),

/***/ 79660:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(45538);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.getHeaders = exports.getUidTimestampHeader = exports.hasProfile = exports.isSignedGigyaUser = exports.getGigyaUserHeader = exports.getTimestampHeader = void 0;
var fido_1 = __webpack_require__(19322);
var security_1 = __webpack_require__(11055);
var getTimestampHeader = function(path, params, time, saltAndSugar) {
    var timestampToken = (0, security_1.genTimestampToken)(path, params, time, saltAndSugar);
    return {
        "X-Auth-Token": timestampToken.token,
        "X-Auth-Token-Timestamp": timestampToken.timestamp
    };
};
exports.getTimestampHeader = getTimestampHeader;
var getGigyaUserHeader = function(param) {
    var UID = param.UID, UIDSignature = param.UIDSignature, signatureTimestamp = param.signatureTimestamp;
    return {
        "X-Auth-gigya-uid": UID,
        "X-Auth-gigya-signature": UIDSignature,
        "X-Auth-gigya-signature-timestamp": signatureTimestamp
    };
};
exports.getGigyaUserHeader = getGigyaUserHeader;
var isSignedGigyaUser = function(user) {
    return !!(user && user.UIDSignature);
};
exports.isSignedGigyaUser = isSignedGigyaUser;
var hasProfile = function(profile) {
    return !!(profile && profile.profileUid);
};
exports.hasProfile = hasProfile;
var getUidTimestampHeader = function(path, params, time, saltAndSugar, user) {
    var timestampToken = (0, security_1.genTimestampToken)(path, params, time, saltAndSugar);
    return {
        "X-Auth-Token": timestampToken.token,
        "X-Auth-Token-Timestamp": timestampToken.timestamp,
        "X-Auth-gigya-uid": user.UID
    };
};
exports.getUidTimestampHeader = getUidTimestampHeader;
/**
 * Build Headers for authenticated api requests.
 *
 * @param {Object} requestParams An object containing the body and the route path.
 * @param {Object} idParams An object that could contain the connected user
 * @returns {Object}
 */ var getHeaders = function(param, param1) {
    var path = param.path, body = param.body, user = param1.user, profile = param1.profile;
    var baseHeaders = {
        "X-Customer-Name": fido_1.fido.get("customerCode"),
        "X-Client-Release": fido_1.fido.get("appVersion")
    };
    if (fido_1.fido.get("localDeviceId")) {
        baseHeaders["x-auth-device-id"] = fido_1.fido.get("localDeviceId");
    } else if (fido_1.fido.get("localHomeId")) {
        baseHeaders["x-auth-home-id"] = fido_1.fido.get("localHomeId");
    }
    try {
        if (!user) {
            return Object.assign(Object.assign({}, baseHeaders), (0, exports.getTimestampHeader)(path, body, fido_1.fido.get("getCurrentTime")(), fido_1.fido.get("saltAndSugar")));
        }
        if ((0, exports.hasProfile)(profile)) {
            baseHeaders["X-Auth-profile-id"] = profile.profileUid;
        }
        if ((0, exports.isSignedGigyaUser)(user)) {
            return Object.assign(Object.assign({}, baseHeaders), (0, exports.getGigyaUserHeader)(user));
        }
        return Object.assign(Object.assign({}, baseHeaders), (0, exports.getUidTimestampHeader)(path, body, fido_1.fido.get("getCurrentTime")(), fido_1.fido.get("saltAndSugar"), user));
    } catch (e) {
        throw new Error("Something went wrong while generating headers: ".concat(e.message));
    }
};
exports.getHeaders = getHeaders;


/***/ }),

/***/ 49721:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(45538);
var __importDefault = (void 0) && (void 0).__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.fetchSync = void 0;
var forOwn_1 = __importDefault(__webpack_require__(14287));
/**
 * A Synchronous fetcher, to be used whenever you can't do otherwise.
 *
 * @param {string} url The full url of the resource.
 * @param {Object} body The payload to send.
 * @param {Object} headers All necessary headers.
 */ var fetchSync = function(url, body, headers) {
    var xhr = new XMLHttpRequest();
    xhr.open("POST", url, false);
    xhr.setRequestHeader("Content-Type", "application/json");
    (0, forOwn_1.default)(headers, function(headerValue, headerName) {
        xhr.setRequestHeader(headerName, headerValue);
    });
    return xhr.send(JSON.stringify(body));
};
exports.fetchSync = fetchSync;


/***/ }),

/***/ 93139:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _class_call_check = __webpack_require__(67818);
var _inherits = __webpack_require__(71648);
var _to_consumable_array = __webpack_require__(30005);
var _wrap_native_super = __webpack_require__(69349);
var _create_super = __webpack_require__(6400);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(42578);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.BaseFidoError = void 0;
var BaseFidoError = /*#__PURE__*/ function(Error1) {
    _inherits._(BaseFidoError, Error1);
    var _super = _create_super._(BaseFidoError);
    function BaseFidoError() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        _class_call_check._(this, BaseFidoError);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(_to_consumable_array._(args)));
        _this.stack = new Error().stack;
        _this.name = _this.constructor.name;
        return _this;
    }
    return BaseFidoError;
}(_wrap_native_super._(Error));
exports.BaseFidoError = BaseFidoError;


/***/ }),

/***/ 63378:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _class_call_check = __webpack_require__(67818);
var _inherits = __webpack_require__(71648);
var _wrap_native_super = __webpack_require__(69349);
var _create_super = __webpack_require__(6400);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(37815);
var __importDefault = (void 0) && (void 0).__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.FetchError = void 0;
var get_1 = __importDefault(__webpack_require__(65439));
var FetchError = /*#__PURE__*/ function(Error1) {
    _inherits._(FetchError, Error1);
    var _super = _create_super._(FetchError);
    function FetchError() {
        var error = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", request = arguments.length > 1 ? arguments[1] : void 0, response = arguments.length > 2 ? arguments[2] : void 0;
        _class_call_check._(this, FetchError);
        var _this;
        _this = _super.call(this);
        try {
            _this.name = _this.constructor.name;
            _this.message = error instanceof Error ? error.toString() : error;
            _this.type = null;
            _this.request = request;
            _this.stack = error instanceof Error ? error.stack : new Error().stack;
        } catch (_a) {
        // nothing
        }
        if (response) {
            var xBackendServer = (0, get_1.default)(response, [
                "headers",
                "x-backend-server"
            ], "");
            _this.response = response;
            _this.status = response.status;
            _this.xBackendServer = xBackendServer;
        }
        return _this;
    }
    return FetchError;
}(_wrap_native_super._(Error));
exports.FetchError = FetchError;


/***/ }),

/***/ 84052:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _class_call_check = __webpack_require__(67818);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(3009);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.UserLastAdultProfileCannotBeDeletedError = exports.UserLastProfileCannotBeKidError = exports.UserFirstProfileCannotBeKidError = exports.UserMaxAuthorizedProfilesCreatedError = void 0;
/* eslint-disable max-classes-per-file */ var base_error_1 = __webpack_require__(93139);
var UserMaxAuthorizedProfilesCreatedError = /*#__PURE__*/ function(_base_error_1_BaseFidoError) {
    _inherits._(UserMaxAuthorizedProfilesCreatedError, _base_error_1_BaseFidoError);
    var _super = _create_super._(UserMaxAuthorizedProfilesCreatedError);
    function UserMaxAuthorizedProfilesCreatedError() {
        _class_call_check._(this, UserMaxAuthorizedProfilesCreatedError);
        return _super.apply(this, arguments);
    }
    return UserMaxAuthorizedProfilesCreatedError;
}(base_error_1.BaseFidoError);
exports.UserMaxAuthorizedProfilesCreatedError = UserMaxAuthorizedProfilesCreatedError;
var UserFirstProfileCannotBeKidError = /*#__PURE__*/ function(_base_error_1_BaseFidoError) {
    _inherits._(UserFirstProfileCannotBeKidError, _base_error_1_BaseFidoError);
    var _super = _create_super._(UserFirstProfileCannotBeKidError);
    function UserFirstProfileCannotBeKidError() {
        _class_call_check._(this, UserFirstProfileCannotBeKidError);
        return _super.apply(this, arguments);
    }
    return UserFirstProfileCannotBeKidError;
}(base_error_1.BaseFidoError);
exports.UserFirstProfileCannotBeKidError = UserFirstProfileCannotBeKidError;
var UserLastProfileCannotBeKidError = /*#__PURE__*/ function(_base_error_1_BaseFidoError) {
    _inherits._(UserLastProfileCannotBeKidError, _base_error_1_BaseFidoError);
    var _super = _create_super._(UserLastProfileCannotBeKidError);
    function UserLastProfileCannotBeKidError() {
        _class_call_check._(this, UserLastProfileCannotBeKidError);
        return _super.apply(this, arguments);
    }
    return UserLastProfileCannotBeKidError;
}(base_error_1.BaseFidoError);
exports.UserLastProfileCannotBeKidError = UserLastProfileCannotBeKidError;
var UserLastAdultProfileCannotBeDeletedError = /*#__PURE__*/ function(_base_error_1_BaseFidoError) {
    _inherits._(UserLastAdultProfileCannotBeDeletedError, _base_error_1_BaseFidoError);
    var _super = _create_super._(UserLastAdultProfileCannotBeDeletedError);
    function UserLastAdultProfileCannotBeDeletedError() {
        _class_call_check._(this, UserLastAdultProfileCannotBeDeletedError);
        return _super.apply(this, arguments);
    }
    return UserLastAdultProfileCannotBeDeletedError;
}(base_error_1.BaseFidoError);
exports.UserLastAdultProfileCannotBeDeletedError = UserLastAdultProfileCannotBeDeletedError;


/***/ }),

/***/ 6446:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _sliced_to_array = __webpack_require__(28966);
var _to_consumable_array = __webpack_require__(30005);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(37815);
var __importDefault = (void 0) && (void 0).__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.fido = void 0;
var forEach_1 = __importDefault(__webpack_require__(17489));
/**
 * @module Fido
 * @description Fido's main singleton is used to store some app's immutable parameters used by Fido's services and override API default base URLs.
 * @tutorial ./doc/fido.md
 */ var Fido = /*#__PURE__*/ function() {
    function Fido() {
        _class_call_check._(this, Fido);
        this._platformCode = null;
        this._customerCode = null;
        this._appVersion = null;
        this._clientCode = null;
        this._localDeviceId = null;
        this._localHomeId = null;
        this._saltAndSugar = null;
        this._getCurrentTime = function() {
            return Date.now();
        };
        this._waitTimeout = 10000;
        this._maxTimeout = 60000;
        this._imageSalt = "54b55408a530954b553ff79e98";
        this._usedCapacityToken = null;
        this.baseUrlsByAPIType = {};
        this.isInitialized = false;
    }
    _create_class._(Fido, [
        {
            /**
     * Initialize Fido and its services. If you don't call this method, no service can be used.
     *
     * @param {Object} immutableProps Contains all immutable properties of the app. See the example to view available properties.
     * @param {Object[]?} services Fido's service instances that should be initialized. If parameters has to be passed to the init method of the service, use an array (see the example).
     * @tutorial ./doc/fidoInit.md
     */ key: "init",
            value: function init() {
                var immutableProps = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, services = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
                var _this = this;
                if (!this.isInitialized) {
                    (0, forEach_1.default)(immutableProps, function(value, key) {
                        var privateKey = "_".concat(key);
                        if (key !== "isInitialized" && key !== "baseUrlsByAPIType" && _this[privateKey] !== undefined) {
                            _this[privateKey] = value;
                        }
                    });
                    if (immutableProps.baseUrlsByAPIType) {
                        this.baseUrlsByAPIType = Object.assign({}, immutableProps.baseUrlsByAPIType);
                    }
                    this.isInitialized = true;
                }
                services.forEach(function(service) {
                    if (Array.isArray(service)) {
                        var _serviceInstance;
                        var _service = _sliced_to_array._(service, 2), serviceInstance = _service[0], tmp = _service[1], params = tmp === void 0 ? [] : tmp;
                        (_serviceInstance = serviceInstance).init.apply(_serviceInstance, _to_consumable_array._(params));
                    } else {
                        service.init();
                    }
                });
            }
        },
        {
            /**
     * Get the value of an immutable property of the app.
     *
     * @param {string} key Name of the property.
     * @tutorial ./doc/fidoGet.md
     * @returns {string} Value of the property.
     */ key: "get",
            value: function get(key) {
                this.checkInit();
                var privateKey = "_".concat(key);
                return this[privateKey];
            }
        },
        {
            key: "set",
            value: function set(key, value) {
                this.checkInit();
                var privateKey = "_".concat(key);
                this[privateKey] = value;
            }
        },
        {
            /**
     * Override default API base URLs.
     *
     * @param {Object} baseUrlsByAPIType Contains the base URLs of some API type. See the example to discover available API types.
     * @tutorial ./doc/fidoSetBaseUrls.md
     */ key: "setBaseUrls",
            value: function setBaseUrls(baseUrlsByAPIType) {
                var _this = this;
                this.checkInit();
                (0, forEach_1.default)(baseUrlsByAPIType, function(value, key) {
                    _this.baseUrlsByAPIType[key] = value;
                });
            }
        },
        {
            /**
     * Get the base URL of an API type.
     *
     * @param {string} apiType Name of the API.
     * @tutorial ./doc/fidoGetBaseUrl.md
     * @returns {string} Current base URL of the API.
     */ key: "getBaseUrl",
            value: function getBaseUrl(apiType) {
                this.checkInit();
                return this.baseUrlsByAPIType[apiType];
            }
        },
        {
            key: "checkInit",
            value: function checkInit() {
                if (!this.isInitialized) {
                    throw new Error("You should init Fido before using it");
                }
            }
        }
    ]);
    return Fido;
}();
exports.fido = new Fido();


/***/ }),

/***/ 5225:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(37815);
var __createBinding = (void 0) && (void 0).__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = {
            enumerable: true,
            get: function get() {
                return m[k];
            }
        };
    }
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __setModuleDefault = (void 0) && (void 0).__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var __importStar = (void 0) && (void 0).__importStar || function() {
    var ownKeys = function ownKeys1(o) {
        ownKeys = Object.getOwnPropertyNames || function(o) {
            var ar = [];
            for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function(mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) {
            for(var k = ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") __createBinding(result, mod, k[i]);
        }
        __setModuleDefault(result, mod);
        return result;
    };
}();
var __exportStar = (void 0) && (void 0).__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) __createBinding(exports1, m, p);
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.PREMIUM_COUPON_STATUS = exports.SUBSCRIPTION_STATUS = exports.thirdPartyWithLayoutService = exports.thirdPartyControllerService = exports.premiumService = exports.iamService = exports.IAMError = exports.GigyaTimeoutError = exports.GigyaFormatError = exports.watchedContentsVisibilityService = exports.videolandPaymentService = exports.videoService = exports.userService = exports.profileService = exports.parentalControlService = exports.pairingService = exports.gdprService = exports.ageRatingService = exports.urlHitterService = exports.upFrontTokenService = exports.timeService = exports.servicesService = exports.searchAiService = exports.programService = exports.statsdMonitoringService = exports.logCollectorService = exports.layoutService = exports.layoutForThirdPartyService = exports.NAVIGATION_TARGETS = exports.LAYOUT_FRONTSPACES = exports.LAYOUT_ENTITIES = exports.LAYOUT_APP_PAGES = exports.LAYOUT_ALIASES = exports.iconService = exports.heartbeatServiceV3 = exports.heartbeatService = exports.geoService = exports.qualifioService = exports.foldersService = exports.creditsService = exports.boxDataService = exports.tokenService = exports.oidcService = exports.batService = exports.applaunchService = exports.adInterceptorService = exports.adgatewayService = exports.IMAGE_SIZES = exports.imageService = exports.fido = void 0;
exports.fidoMiddleware = exports.buildFidoRequest = exports.FetchError = exports.security = exports.liveService = exports.broadcastliveService = exports.mergeWithConfig = exports.COUPON_STATUS = exports.freemiumService = void 0;
var freemium_constants_1 = __webpack_require__(87444);
var image_constants_1 = __webpack_require__(52537);
var premium_constants_1 = __webpack_require__(78808);
var security = __importStar(__webpack_require__(6790));
exports.security = security;
var fido_1 = __webpack_require__(6446);
Object.defineProperty(exports, "fido", ({
    enumerable: true,
    get: function get() {
        return fido_1.fido;
    }
}));
var imageService_1 = __webpack_require__(75933);
Object.defineProperty(exports, "imageService", ({
    enumerable: true,
    get: function get() {
        return imageService_1.imageService;
    }
}));
exports.IMAGE_SIZES = {
    panoramicSizes: image_constants_1.panoramicSizes,
    portraitSizes: image_constants_1.portraitSizes
};
var adgateway_1 = __webpack_require__(45383);
Object.defineProperty(exports, "adgatewayService", ({
    enumerable: true,
    get: function get() {
        return adgateway_1.adgatewayService;
    }
}));
var adInterceptorService_1 = __webpack_require__(46590);
Object.defineProperty(exports, "adInterceptorService", ({
    enumerable: true,
    get: function get() {
        return adInterceptorService_1.adInterceptorService;
    }
}));
var applaunchService_1 = __webpack_require__(34616);
Object.defineProperty(exports, "applaunchService", ({
    enumerable: true,
    get: function get() {
        return applaunchService_1.applaunchService;
    }
}));
var batService_1 = __webpack_require__(13177);
Object.defineProperty(exports, "batService", ({
    enumerable: true,
    get: function get() {
        return batService_1.batService;
    }
}));
var oidcService_1 = __webpack_require__(22285);
Object.defineProperty(exports, "oidcService", ({
    enumerable: true,
    get: function get() {
        return oidcService_1.oidcService;
    }
}));
var tokenService_1 = __webpack_require__(9216);
Object.defineProperty(exports, "tokenService", ({
    enumerable: true,
    get: function get() {
        return tokenService_1.tokenService;
    }
}));
var boxDataService_1 = __webpack_require__(15868);
Object.defineProperty(exports, "boxDataService", ({
    enumerable: true,
    get: function get() {
        return boxDataService_1.boxDataService;
    }
}));
var creditsService_1 = __webpack_require__(12267);
Object.defineProperty(exports, "creditsService", ({
    enumerable: true,
    get: function get() {
        return creditsService_1.creditsService;
    }
}));
var foldersService_1 = __webpack_require__(29093);
Object.defineProperty(exports, "foldersService", ({
    enumerable: true,
    get: function get() {
        return foldersService_1.foldersService;
    }
}));
var qualifioService_1 = __webpack_require__(3692);
Object.defineProperty(exports, "qualifioService", ({
    enumerable: true,
    get: function get() {
        return qualifioService_1.qualifioService;
    }
}));
var geoService_1 = __webpack_require__(45112);
Object.defineProperty(exports, "geoService", ({
    enumerable: true,
    get: function get() {
        return geoService_1.geoService;
    }
}));
var heartbeatService_1 = __webpack_require__(95029);
Object.defineProperty(exports, "heartbeatService", ({
    enumerable: true,
    get: function get() {
        return heartbeatService_1.heartbeatService;
    }
}));
var heartbeatService_2 = __webpack_require__(69248);
Object.defineProperty(exports, "heartbeatServiceV3", ({
    enumerable: true,
    get: function get() {
        return heartbeatService_2.heartbeatServiceV3;
    }
}));
var iconService_1 = __webpack_require__(25335);
Object.defineProperty(exports, "iconService", ({
    enumerable: true,
    get: function get() {
        return iconService_1.iconService;
    }
}));
var layout_constants_1 = __webpack_require__(28504);
Object.defineProperty(exports, "LAYOUT_ALIASES", ({
    enumerable: true,
    get: function get() {
        return layout_constants_1.aliases;
    }
}));
Object.defineProperty(exports, "LAYOUT_APP_PAGES", ({
    enumerable: true,
    get: function get() {
        return layout_constants_1.appPages;
    }
}));
Object.defineProperty(exports, "LAYOUT_ENTITIES", ({
    enumerable: true,
    get: function get() {
        return layout_constants_1.entities;
    }
}));
Object.defineProperty(exports, "LAYOUT_FRONTSPACES", ({
    enumerable: true,
    get: function get() {
        return layout_constants_1.frontspaces;
    }
}));
Object.defineProperty(exports, "NAVIGATION_TARGETS", ({
    enumerable: true,
    get: function get() {
        return layout_constants_1.navigationTargets;
    }
}));
var layoutForThirdPartyService_1 = __webpack_require__(65857);
Object.defineProperty(exports, "layoutForThirdPartyService", ({
    enumerable: true,
    get: function get() {
        return layoutForThirdPartyService_1.layoutForThirdPartyService;
    }
}));
var layoutService_1 = __webpack_require__(34217);
Object.defineProperty(exports, "layoutService", ({
    enumerable: true,
    get: function get() {
        return layoutService_1.layoutService;
    }
}));
var logCollectorService_1 = __webpack_require__(26380);
Object.defineProperty(exports, "logCollectorService", ({
    enumerable: true,
    get: function get() {
        return logCollectorService_1.logCollectorService;
    }
}));
var statsdMonitoringService_1 = __webpack_require__(46261);
Object.defineProperty(exports, "statsdMonitoringService", ({
    enumerable: true,
    get: function get() {
        return statsdMonitoringService_1.statsdMonitoringService;
    }
}));
var programService_1 = __webpack_require__(6430);
Object.defineProperty(exports, "programService", ({
    enumerable: true,
    get: function get() {
        return programService_1.programService;
    }
}));
var searchAiService_1 = __webpack_require__(87464);
Object.defineProperty(exports, "searchAiService", ({
    enumerable: true,
    get: function get() {
        return searchAiService_1.searchAiService;
    }
}));
var servicesService_1 = __webpack_require__(30007);
Object.defineProperty(exports, "servicesService", ({
    enumerable: true,
    get: function get() {
        return servicesService_1.servicesService;
    }
}));
var timeService_1 = __webpack_require__(27059);
Object.defineProperty(exports, "timeService", ({
    enumerable: true,
    get: function get() {
        return timeService_1.timeService;
    }
}));
var upFrontTokenService_1 = __webpack_require__(79978);
Object.defineProperty(exports, "upFrontTokenService", ({
    enumerable: true,
    get: function get() {
        return upFrontTokenService_1.upFrontTokenService;
    }
}));
var urlHitterService_1 = __webpack_require__(18632);
Object.defineProperty(exports, "urlHitterService", ({
    enumerable: true,
    get: function get() {
        return urlHitterService_1.urlHitterService;
    }
}));
var ageRatingService_1 = __webpack_require__(74552);
Object.defineProperty(exports, "ageRatingService", ({
    enumerable: true,
    get: function get() {
        return ageRatingService_1.ageRatingService;
    }
}));
var gdprService_1 = __webpack_require__(6360);
Object.defineProperty(exports, "gdprService", ({
    enumerable: true,
    get: function get() {
        return gdprService_1.gdprService;
    }
}));
var pairingService_1 = __webpack_require__(17994);
Object.defineProperty(exports, "pairingService", ({
    enumerable: true,
    get: function get() {
        return pairingService_1.pairingService;
    }
}));
var parentalControlService_1 = __webpack_require__(17989);
Object.defineProperty(exports, "parentalControlService", ({
    enumerable: true,
    get: function get() {
        return parentalControlService_1.parentalControlService;
    }
}));
var profileService_1 = __webpack_require__(27389);
Object.defineProperty(exports, "profileService", ({
    enumerable: true,
    get: function get() {
        return profileService_1.profileService;
    }
}));
var userService_1 = __webpack_require__(19092);
Object.defineProperty(exports, "userService", ({
    enumerable: true,
    get: function get() {
        return userService_1.userService;
    }
}));
var videoService_1 = __webpack_require__(17320);
Object.defineProperty(exports, "videoService", ({
    enumerable: true,
    get: function get() {
        return videoService_1.videoService;
    }
}));
var videolandPaymentService_1 = __webpack_require__(63337);
Object.defineProperty(exports, "videolandPaymentService", ({
    enumerable: true,
    get: function get() {
        return videolandPaymentService_1.videolandPaymentService;
    }
}));
var watchedContentsVisibilityService_1 = __webpack_require__(82279);
Object.defineProperty(exports, "watchedContentsVisibilityService", ({
    enumerable: true,
    get: function get() {
        return watchedContentsVisibilityService_1.watchedContentsVisibilityService;
    }
}));
// ThirdParties
var gigya_errors_1 = __webpack_require__(83255);
Object.defineProperty(exports, "GigyaFormatError", ({
    enumerable: true,
    get: function get() {
        return gigya_errors_1.GigyaFormatError;
    }
}));
Object.defineProperty(exports, "GigyaTimeoutError", ({
    enumerable: true,
    get: function get() {
        return gigya_errors_1.GigyaTimeoutError;
    }
}));
var iam_error_1 = __webpack_require__(8461);
Object.defineProperty(exports, "IAMError", ({
    enumerable: true,
    get: function get() {
        return iam_error_1.IAMError;
    }
}));
var iamService_1 = __webpack_require__(84);
Object.defineProperty(exports, "iamService", ({
    enumerable: true,
    get: function get() {
        return iamService_1.iamService;
    }
}));
var premiumService_1 = __webpack_require__(92706);
Object.defineProperty(exports, "premiumService", ({
    enumerable: true,
    get: function get() {
        return premiumService_1.premiumService;
    }
}));
var thirdPartyControllerService_1 = __webpack_require__(94984);
Object.defineProperty(exports, "thirdPartyControllerService", ({
    enumerable: true,
    get: function get() {
        return thirdPartyControllerService_1.thirdPartyControllerService;
    }
}));
var thirdPartyWithLayoutService_1 = __webpack_require__(67300);
Object.defineProperty(exports, "thirdPartyWithLayoutService", ({
    enumerable: true,
    get: function get() {
        return thirdPartyWithLayoutService_1.thirdPartyWithLayoutService;
    }
}));
exports.SUBSCRIPTION_STATUS = premium_constants_1.subscriptionStatus;
exports.PREMIUM_COUPON_STATUS = premium_constants_1.premiumCouponStatus;
var freemiumService_1 = __webpack_require__(88247);
Object.defineProperty(exports, "freemiumService", ({
    enumerable: true,
    get: function get() {
        return freemiumService_1.freemiumService;
    }
}));
exports.COUPON_STATUS = freemium_constants_1.couponStatus;
var utils_1 = __webpack_require__(72932);
Object.defineProperty(exports, "mergeWithConfig", ({
    enumerable: true,
    get: function get() {
        return utils_1.mergeWithConfig;
    }
}));
var broadcastliveService_1 = __webpack_require__(48339);
Object.defineProperty(exports, "broadcastliveService", ({
    enumerable: true,
    get: function get() {
        return broadcastliveService_1.broadcastliveService;
    }
}));
var liveService_1 = __webpack_require__(83545);
Object.defineProperty(exports, "liveService", ({
    enumerable: true,
    get: function get() {
        return liveService_1.liveService;
    }
}));
var fetch_error_1 = __webpack_require__(63378);
Object.defineProperty(exports, "FetchError", ({
    enumerable: true,
    get: function get() {
        return fetch_error_1.FetchError;
    }
}));
__exportStar(__webpack_require__(84052), exports);
var fido_middleware_1 = __webpack_require__(36014);
Object.defineProperty(exports, "buildFidoRequest", ({
    enumerable: true,
    get: function get() {
        return fido_middleware_1.buildFidoRequest;
    }
}));
Object.defineProperty(exports, "fidoMiddleware", ({
    enumerable: true,
    get: function get() {
        return fido_middleware_1.fidoMiddleware;
    }
}));


/***/ }),

/***/ 36014:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _async_to_generator = __webpack_require__(24146);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(65759);
var __rest = (void 0) && (void 0).__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++){
        if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.buildFidoRequest = exports.fidoMiddleware = void 0;
var defaultErrorHandler = function(param) {
    var error = param.error, next = param.next, outputAction = param.outputAction;
    next(Object.assign(Object.assign({}, outputAction), {
        error: error
    }));
    throw error;
};
var fidoMiddleware = function() {
    var onFidoError = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultErrorHandler;
    return function() {
        return function(next) {
            return function() {
                var _ref = _async_to_generator._(function(action) {
                    var _action_fido, service, method, params, transform, outputAction, rawData, data, _tmp, error;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!action.fido) return [
                                    3,
                                    7
                                ];
                                _action_fido = action.fido, service = _action_fido.service, method = _action_fido.method, params = _action_fido.params, transform = _action_fido.transform, outputAction = __rest(action, [
                                    "fido"
                                ]);
                                if (typeof service !== "object" || service === null) {
                                    throw new Error("Service is mandatory, received ".concat(service));
                                }
                                if (typeof service[method] !== "function") {
                                    throw new Error("Service in ".concat(outputAction.type, " action doesn't have a ").concat(method, " method"));
                                }
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    6,
                                    ,
                                    7
                                ]);
                                return [
                                    4,
                                    service[method](params)
                                ];
                            case 2:
                                rawData = _state.sent();
                                if (!(typeof transform === "function")) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    transform(rawData)
                                ];
                            case 3:
                                _tmp = _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                _tmp = rawData;
                                _state.label = 5;
                            case 5:
                                data = _tmp;
                                // Dispatch the action with data
                                next(Object.assign(Object.assign({}, outputAction), {
                                    data: data
                                }));
                                return [
                                    2,
                                    data
                                ];
                            case 6:
                                error = _state.sent();
                                onFidoError({
                                    error: error,
                                    next: next,
                                    outputAction: outputAction
                                });
                                return [
                                    3,
                                    7
                                ];
                            case 7:
                                return [
                                    2,
                                    next(action)
                                ];
                        }
                    });
                });
                return function(action) {
                    return _ref.apply(this, arguments);
                };
            }();
        };
    };
};
exports.fidoMiddleware = fidoMiddleware;
var buildFidoRequest = function(service, method, params, transform) {
    return {
        service: service,
        method: method,
        params: params,
        transform: transform
    };
};
exports.buildFidoRequest = buildFidoRequest;


/***/ }),

/***/ 46590:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(88801);
var __decorate = (void 0) && (void 0).__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __rest = (void 0) && (void 0).__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++){
        if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.adInterceptorService = exports.serializeData = void 0;
var fido_1 = __webpack_require__(6446);
var withJWT_1 = __webpack_require__(62782);
var fetcherService_1 = __webpack_require__(97269);
var withMonitoring_1 = __webpack_require__(89873);
var monitoring = (0, withMonitoring_1.withMonitoring)("adInterceptor");
var serializeData = function(_a) {
    var creativeIds = _a.creativeIds, rest = __rest(_a, [
        "creativeIds"
    ]);
    var serializedContent = new URLSearchParams();
    Object.keys(rest).forEach(function(key) {
        return serializedContent.append(key, rest[key]);
    });
    Object.keys(creativeIds).forEach(function(key) {
        return serializedContent.append("creativeIds[".concat(key, "]"), creativeIds[key]);
    });
    return serializedContent.toString();
};
exports.serializeData = serializeData;
var AdInterceptor = /*#__PURE__*/ function(_fetcherService_1_FetcherService) {
    _inherits._(AdInterceptor, _fetcherService_1_FetcherService);
    var _super = _create_super._(AdInterceptor);
    function AdInterceptor() {
        _class_call_check._(this, AdInterceptor);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.apiType = "interceptor";
        return _this;
    }
    _create_class._(AdInterceptor, [
        {
            key: "init",
            value: function init() {
                if (!this.isInitialized) {
                    this.basePath = "platforms/".concat(fido_1.fido.get("platformCode"), "/services");
                    this.isInitialized = true;
                }
            }
        },
        {
            key: "adSurveyIntercept",
            value: /**
     * Check if a content has to be displayed
     *
     * @async
     * @param {Object} params
     * @param {string} params.serviceCode Service code identifier
     * @param {Object} params.content Content data to send in the request body
     * @param {Object} [params.headers={}] Optional HTTP headers.
     * @returns An empty array if there is nothing to be played, or an object with the content to be played
     * @throws {Error} Throws an error if serviceCode is not provided or is null
     */ function adSurveyIntercept() {
                var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, serviceCode = _ref.serviceCode, _ref_content = _ref.content, content = _ref_content === void 0 ? {} : _ref_content, _ref_headers = _ref.headers, headers = _ref_headers === void 0 ? {} : _ref_headers;
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        if (!serviceCode) {
                            throw new Error("You should provide non null serviceCode");
                        }
                        return [
                            2,
                            _this.fetchWithoutVersionHeaders(_this.getRouteUrl("".concat(serviceCode, "/intercept?").concat((0, exports.serializeData)(content))), {
                                method: "GET",
                                headers: headers
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "adSurveySave",
            value: /**
     * Save the user answer to the survey
     *
     * @async
     * @param {Object} params
     * @param {string} params.serviceCode Service code identifier
     * @param {Object} params.content Content data to send in the request body
     * @param {Object} [params.headers={}] Optional HTTP headers.
     * @returns An empty 204 response if successful
     * @throws {Error} Throws an error if serviceCode is not provided or is null
     */ function adSurveySave() {
                var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, serviceCode = _ref.serviceCode, _ref_content = _ref.content, content = _ref_content === void 0 ? {} : _ref_content, _ref_headers = _ref.headers, headers = _ref_headers === void 0 ? {} : _ref_headers;
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        if (!serviceCode) {
                            throw new Error("You should provide non null serviceCode");
                        }
                        return [
                            2,
                            _this.fetchWithoutVersionHeaders(_this.getRouteUrl("".concat(serviceCode, "/survey/save")), {
                                method: "POST",
                                headers: headers,
                                body: content
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "adSurveySkip",
            value: /**
     * Skip an ad survey if the user didn't answer or chose to skip
     *
     * @async
     * @param {Object} params
     * @param {string} params.serviceCode Service code identifier
     * @param {Object} params.content Content data to send in the request body
     * @param {Object} [params.headers={}] Optional HTTP headers.
     * @returns An empty 204 response if successful
     * @throws {Error} Throws an error if serviceCode is not provided or is null
     */ function adSurveySkip() {
                var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, serviceCode = _ref.serviceCode, _ref_content = _ref.content, content = _ref_content === void 0 ? {} : _ref_content, _ref_headers = _ref.headers, headers = _ref_headers === void 0 ? {} : _ref_headers;
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        if (!serviceCode) {
                            throw new Error("You should provide non null serviceCode");
                        }
                        return [
                            2,
                            _this.fetchWithoutVersionHeaders(_this.getRouteUrl("".concat(serviceCode, "/survey/skip")), {
                                method: "POST",
                                headers: headers,
                                body: content
                            })
                        ];
                    });
                })();
            }
        }
    ]);
    return AdInterceptor;
}(fetcherService_1.FetcherService);
__decorate([
    withJWT_1.withJWT,
    monitoring
], AdInterceptor.prototype, "adSurveyIntercept", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], AdInterceptor.prototype, "adSurveySave", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], AdInterceptor.prototype, "adSurveySkip", null);
exports.adInterceptorService = new AdInterceptor();


/***/ }),

/***/ 45383:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(65759);
var __decorate = (void 0) && (void 0).__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.adgatewayService = void 0;
var fido_1 = __webpack_require__(6446);
var queryParamSerializer_1 = __webpack_require__(21413);
var withJWT_1 = __webpack_require__(62782);
var fetcherService_1 = __webpack_require__(97269);
var withMonitoring_1 = __webpack_require__(89873);
var monitoring = (0, withMonitoring_1.withMonitoring)("adgateway");
/**
 * @module Adgateway
 * @augments FetcherService
 * @description Service used to call the adserver Videoplaza
 * @tutorial ./doc/adgatewayService.md
 */ var Agdateway = /*#__PURE__*/ function(_fetcherService_1_FetcherService) {
    _inherits._(Agdateway, _fetcherService_1_FetcherService);
    var _super = _create_super._(Agdateway);
    function Agdateway() {
        _class_call_check._(this, Agdateway);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.apiType = "adgateway";
        return _this;
    }
    _create_class._(Agdateway, [
        {
            /**
     * Initialize the service. If you don't call this method, no other method can be called.
     *
     */ key: "init",
            value: function init() {
                if (!this.isInitialized) {
                    this.basePath = "platforms/".concat(fido_1.fido.get("platformCode"), "/services");
                    this.isInitialized = true;
                }
            }
        },
        {
            key: "fetchAdsPlaylist",
            value: /**
     * Fetches ads playlist for a specific video asset
     * Additional fields could be specified via the dataToFetch array.
     *
     * @async
     * @param {Object} options Options passed to adgateway: serviceCode, assetId, headers or queryParams
     * @param {string} options.serviceCode serviceCode of the service to what belongs the current asset
     * @param {number} options.assetId Id of the current video asset
     * @param {string} options.trackingmode Tracking mode: allows to trigger an event of tracking. Accepted values : serverfull, clientbytype, clientbyspot
     * @param {object} options.headers
     * @param {string} options.userOffer name of the offer - if any - that the user has subscribed to.
     * @tutorial ./doc/fetchAdsPlaylist.md
     */ function fetchAdsPlaylist(param) {
                var serviceCode = param.serviceCode, assetId = param.assetId, _param_trackingmode = param.trackingmode, trackingmode = _param_trackingmode === void 0 ? "serverfull" : _param_trackingmode, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers, userOffer = param.userOffer;
                var _this = this;
                return _async_to_generator._(function() {
                    var stringQueryParams;
                    return _ts_generator._(this, function(_state) {
                        _this.checkInit();
                        if (!serviceCode) {
                            throw new Error("You should provide a service code");
                        }
                        if (!assetId) {
                            throw new Error("You should provide an assetId");
                        }
                        stringQueryParams = (0, queryParamSerializer_1.serialize)({
                            trackingmode: trackingmode,
                            user_offer: userOffer
                        }, function(param) {
                            var value = param.value;
                            return !!value;
                        });
                        return [
                            2,
                            _this.fetchWithResponse(_this.getRouteUrl("".concat(serviceCode, "/playlist/asset/").concat(assetId, "?").concat(stringQueryParams)), {
                                method: "GET",
                                headers: headers
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "fetchAdsPlaylistWithClipId",
            value: /**
     * Fetches ads playlist for a specific video asset (with its clipId)
     *
     * @async
     * @param {Object} options Options passed to adgateway: serviceCode, clipId, headers or queryParams
     * @param {string} options.serviceCode serviceCode of the service to what belongs the current asset
     * @param {number} options.clipId clipId of the current video asset
     * @param {string} options.trackingmode Tracking mode: allows to trigger an event of tracking. Accepted values : serverfull, clientbytype, clientbyspot
     * @param {object} options.headers
     * @param {string} options.userOffer name of the offer - if any - that the user has subscribed to.
     * @tutorial ./doc/fetchAdsPlaylist.md
     */ function fetchAdsPlaylistWithClipId(param) {
                var serviceCode = param.serviceCode, clipId = param.clipId, _param_trackingmode = param.trackingmode, trackingmode = _param_trackingmode === void 0 ? "serverfull" : _param_trackingmode, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers, userOffer = param.userOffer;
                var _this = this;
                return _async_to_generator._(function() {
                    var stringQueryParams;
                    return _ts_generator._(this, function(_state) {
                        _this.checkInit();
                        if (!serviceCode) {
                            throw new Error("You should provide a service code");
                        }
                        if (!clipId) {
                            throw new Error("You should provide a clipId");
                        }
                        stringQueryParams = (0, queryParamSerializer_1.serialize)({
                            trackingmode: trackingmode,
                            user_offer: userOffer
                        }, function(param) {
                            var value = param.value;
                            return !!value;
                        });
                        return [
                            2,
                            _this.fetchWithResponse(_this.getRouteUrl("".concat(serviceCode, "/playlist/clip/").concat(clipId, "?").concat(stringQueryParams)), {
                                method: "GET",
                                headers: headers
                            })
                        ];
                    });
                })();
            }
        }
    ]);
    return Agdateway;
}(fetcherService_1.FetcherService);
__decorate([
    withJWT_1.withJWT,
    monitoring
], Agdateway.prototype, "fetchAdsPlaylist", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], Agdateway.prototype, "fetchAdsPlaylistWithClipId", null);
exports.adgatewayService = new Agdateway();


/***/ }),

/***/ 34616:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _assert_this_initialized = __webpack_require__(99561);
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(3009);
var __decorate = (void 0) && (void 0).__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (void 0) && (void 0).__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.applaunchService = exports.ApplaunchService = void 0;
var sortBy_1 = __importDefault(__webpack_require__(84715));
var sprintf_js_1 = __webpack_require__(24131);
var fido_1 = __webpack_require__(6446);
var withJWT_1 = __webpack_require__(62782);
var fetcherService_1 = __webpack_require__(97269);
var withMonitoring_1 = __webpack_require__(89873);
var utils_1 = __webpack_require__(72932);
var monitoring = (0, withMonitoring_1.withMonitoring)("applaunch");
var CUSTOMIZER_VARIANTS_TYPE = {
    DEVICE: "deviceCustomizerVariants",
    GIGYA: "gigyaCustomizerVariants",
    PROFILE: "profileCustomizerVariants"
};
/**
 * @module Applaunch
 * @description The applaunch service has been created to retrieve hot configuration from the Applaunch.
 * @tutorial ./doc/applaunch.md
 */ var ApplaunchService = /*#__PURE__*/ function(_fetcherService_1_FetcherService) {
    _inherits._(ApplaunchService, _fetcherService_1_FetcherService);
    var _super = _create_super._(ApplaunchService);
    function ApplaunchService() {
        _class_call_check._(this, ApplaunchService);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.apiType = "applaunch";
        _this.getCustomizerVariants = function() {
            var headers = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, key = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : CUSTOMIZER_VARIANTS_TYPE.DEVICE;
            var tmp = headers["x-customizer-variants"], variants = tmp === void 0 ? "" : tmp;
            var value = variants && variants.length ? variants.split(",") : [];
            value.sort();
            return {
                value: JSON.stringify(value),
                key: key,
                type: "jsonpath"
            };
        };
        _this.reset = function() {
            _this.data = _this.defaultData;
        };
        _this.reload = function() {
            var maxAge = _assert_this_initialized._(_this).maxAge;
            if (maxAge) {
                if (typeof maxAge === "string" && _this.data[maxAge]) {
                    maxAge = _this.data[maxAge];
                }
                if (typeof maxAge === "number" && maxAge >= 30) {
                    setTimeout(function() {
                        _this.getApplaunch();
                        _this.reload();
                    }, maxAge * 1000);
                }
            }
        };
        _this.mergeData = function(initialData, newData) {
            // Sorting keys is important to merge shallower jsonpath first, deeper ones last
            var sortedData = (0, sortBy_1.default)(newData, "key");
            _this.rawData = (0, utils_1.generateRawData)(sortedData, initialData);
            _this.data = (0, utils_1.mergeWithConfig)(_this.config.data, _this.rawData);
            return _this.data;
        };
        return _this;
    }
    _create_class._(ApplaunchService, [
        {
            key: "init",
            value: function init() {
                var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, data = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var serviceName = config.app, version = config.version, customizer = config.customizer, timeout = config.timeout, maxAge = config.maxAge;
                if (!serviceName) {
                    throw new Error("You should provide a service name");
                }
                if (!version) {
                    throw new Error("You should provide a version");
                }
                // this.basePath has to be defined if endpoint URL requested by this service contains a constant part
                this.applaunchEndPoint = "".concat(serviceName, "-").concat(version, ".json");
                this.config = config;
                this.customizer = customizer;
                this.timeout = timeout;
                this.maxAge = maxAge;
                this.defaultData = data;
                this.data = data;
                this.isInitialized = true;
                return this;
            }
        },
        {
            /**
     * Get the applaunch config.
     * @async
     *
     * @returns {Object} The remote applaunch config.
     * @tutorial ./doc/getApplaunch.md
     */ key: "getApplaunch",
            value: function getApplaunch() {
                var _this = this;
                if (this.config.disabled) {
                    return this.mergeData();
                }
                var url = this.getRouteUrl(this.applaunchEndPoint);
                return this.fetch(url, {
                    method: "GET"
                }).then(function(dataList) {
                    return _this.mergeData({}, dataList);
                });
            }
        },
        {
            key: "getCustomization",
            value: /**
     * Get the applaunch config by userId or deviceId.
     * @async
     *
     * @param {Object} params
     * @param {string=} params.uid The userId or deviceId.
     * @param {string=} params.localDeviceId The device id
     * @param {string=} params.profileId The profile id
     * @param {Object=} params.headers The headers of the request.
     * @returns {Object} A Jsonpath config who overwrite some fields.
     * @tutorial ./doc/getCustomization.md
     */ function getCustomization(param) {
                var uid = param.uid, localDeviceId = param.localDeviceId, profileId = param.profileId, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                var _this = this;
                return _async_to_generator._(function() {
                    var customizerUrl;
                    return _ts_generator._(this, function(_state) {
                        customizerUrl = (0, sprintf_js_1.sprintf)(_this.customizer, Object.assign({
                            uid: profileId || uid || localDeviceId,
                            platform: fido_1.fido.get("platformCode")
                        }, _this.config));
                        return [
                            2,
                            _this.fetchWithResponse(customizerUrl, {
                                method: "GET",
                                headers: headers
                            }).then(function(param) {
                                var tmp = param.headers, responseHeaders = tmp === void 0 ? {} : tmp, dataObject = param.body;
                                var dataList = Object.keys(dataObject).map(function(key) {
                                    return dataObject[key];
                                });
                                var variantType = "";
                                if (profileId) {
                                    variantType = CUSTOMIZER_VARIANTS_TYPE.PROFILE;
                                } else if (uid) {
                                    variantType = CUSTOMIZER_VARIANTS_TYPE.GIGYA;
                                } else {
                                    variantType = CUSTOMIZER_VARIANTS_TYPE.DEVICE;
                                }
                                dataList.push(_this.getCustomizerVariants(responseHeaders, variantType));
                                return _this.mergeData(_this.data, dataList);
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "getData",
            value: function getData() {
                return this.data;
            }
        },
        {
            key: "getRawData",
            value: function getRawData() {
                return this.rawData;
            }
        }
    ]);
    return ApplaunchService;
}(fetcherService_1.FetcherService);
exports.ApplaunchService = ApplaunchService;
__decorate([
    monitoring
], ApplaunchService.prototype, "getApplaunch", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], ApplaunchService.prototype, "getCustomization", null);
exports.applaunchService = new ApplaunchService();


/***/ }),

/***/ 27126:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(45538);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.configMerger = void 0;
var configMerger = function(objValue, srcValue) {
    // Null and undefined value are ignored
    if (srcValue === null || srcValue === undefined) {
        return objValue;
    }
    // Array are not merged but replaced
    if (Array.isArray(objValue)) {
        return srcValue;
    }
    return undefined;
};
exports.configMerger = configMerger;


/***/ }),

/***/ 72932:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _define_property = __webpack_require__(21228);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(65759);
var __importDefault = (void 0) && (void 0).__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.mergeWithConfig = exports.generateRawData = exports.parse = void 0;
var clone_1 = __importDefault(__webpack_require__(55824));
var mergeWith_1 = __importDefault(__webpack_require__(53954));
var setWith_1 = __importDefault(__webpack_require__(45943));
var config_merger_1 = __webpack_require__(27126);
var parse = function(value) {
    try {
        if (typeof value === "string") {
            return JSON.parse(value);
        }
        return value;
    } catch (_a) {
        return value;
    }
};
exports.parse = parse;
var generateRawData = function(sortedData, initialData) {
    return (sortedData || []).reduce(function(reducedData, param) {
        var key = param.key, type = param.type, value = param.value;
        var parsedValue = (0, exports.parse)(value);
        if (type === "jsonpath") {
            return (0, setWith_1.default)((0, clone_1.default)(reducedData), key, parsedValue, clone_1.default);
        }
        return Object.assign(Object.assign({}, reducedData), _define_property._({}, key, parsedValue));
    }, initialData || {});
};
exports.generateRawData = generateRawData;
var mergeWithConfig = function(configData, data) {
    return (0, mergeWith_1.default)({}, configData, data, config_merger_1.configMerger);
};
exports.mergeWithConfig = mergeWithConfig;


/***/ }),

/***/ 13177:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(52318);
var __decorate = (void 0) && (void 0).__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (void 0) && (void 0).__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.batService = void 0;
var jwt_decode_1 = __importDefault(__webpack_require__(30588));
var fido_1 = __webpack_require__(6446);
var caching_1 = __webpack_require__(48832);
var retryPromise_1 = __webpack_require__(99475);
var securityHeaderBuilder_1 = __webpack_require__(89222);
var fetcherService_1 = __webpack_require__(97269);
var withMonitoring_1 = __webpack_require__(89873);
var monitoring = (0, withMonitoring_1.withMonitoring)("bat");
/**
 * This service is used to retrieve a Bedrock Access Token.
 * Warning: use it only server side!
 * @module batService
 * @tutorial ./doc/batService.md
 */ var BatService = /*#__PURE__*/ function(_fetcherService_1_FetcherService) {
    _inherits._(BatService, _fetcherService_1_FetcherService);
    var _super = _create_super._(BatService);
    function BatService() {
        _class_call_check._(this, BatService);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.persistentToken = null;
        _this.credential = null;
        _this.retry = 0;
        _this.maxRetry = 0;
        _this.apiType = "bat";
        _this.retryCooldown = 50;
        return _this;
    }
    _create_class._(BatService, [
        {
            /**
     * Initialize the service.
     * @param {Object} initParams - init params of the service
     * @param {string} initParams.maxRetry - numeric option is to refetch token in case of failure
     * @param {string} initParams.persistentToken - default token to use
     * @param {string} initParams.credential - base64(login:password)
     * @param {number} initParams.retryCooldown - time to wait before two requests in ms
     * @see https://bedrock-enterprise.readme.io/learn/docs/token
     * @tutorial ./doc/batService.init.md
     */ key: "init",
            value: function init() {
                var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_maxRetry = _ref.maxRetry, maxRetry = _ref_maxRetry === void 0 ? 3 : _ref_maxRetry, _ref_persistentToken = _ref.persistentToken, persistentToken = _ref_persistentToken === void 0 ? null : _ref_persistentToken, credential = _ref.credential, _ref_retryCooldown = _ref.retryCooldown, retryCooldown = _ref_retryCooldown === void 0 ? 50 : _ref_retryCooldown;
                if (!this.isInitialized) {
                    this.maxRetry = maxRetry;
                    this.retryCooldown = retryCooldown;
                    this.isInitialized = true;
                    this.persistentToken = persistentToken;
                    this.credential = credential;
                }
            }
        },
        {
            /**
     * Reset the BAT.
     */ key: "resetToken",
            value: function resetToken() {
                this.checkInit();
                this.persistentToken = null;
            }
        },
        {
            key: "isTokenValid",
            value: function isTokenValid(token, realServerTime) {
                this.checkInit();
                try {
                    var exp = (0, jwt_decode_1.default)(token).exp;
                    return realServerTime < exp * 1000;
                } catch (_a) {
                    return false;
                }
            }
        },
        {
            key: "renewToken",
            value: function renewToken() {
                var _this = this;
                this.checkInit();
                var url = fido_1.fido.getBaseUrl(this.apiType);
                return (0, retryPromise_1.retryPromise)(function() {
                    return _this.fetch(url, {
                        method: "GET",
                        headers: Object.assign({
                            Authorization: "Basic ".concat(_this.credential)
                        }, (0, securityHeaderBuilder_1.getHeaders)({
                            path: "bat",
                            body: {}
                        }, {}))
                    });
                }, this.maxRetry, this.retryCooldown).then(function(param) {
                    var token = param.token;
                    _this.persistentToken = token;
                }).catch(function(error) {
                    throw new Error("batService:renewToken:fetch ".concat(error.status, " ").concat(error));
                });
            }
        },
        {
            key: "getToken",
            value: /**
     * Returns a valid BAT. If there is no current or valid BAT token, it gets a new one.
     * @returns {string} A valid BAT.
     * @async
     */ function getToken() {
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.checkInit();
                                if (_this.persistentToken && _this.isTokenValid(_this.persistentToken, fido_1.fido.get("getCurrentTime")())) {
                                    return [
                                        2,
                                        _this.persistentToken
                                    ];
                                }
                                return [
                                    4,
                                    _this.renewToken()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2,
                                    _this.persistentToken
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return BatService;
}(fetcherService_1.FetcherService);
__decorate([
    caching_1.withNoParallelRequest,
    monitoring
], BatService.prototype, "renewToken", null);
exports.batService = new BatService();


/***/ }),

/***/ 34436:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _to_consumable_array = __webpack_require__(30005);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(65759);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.createAddHeaderDecorator = void 0;
/**
 * Decorator builder wich add a header into an argument
 * @param {function} callback, should return an object of headers to be merged
 * @param {number} applyToArgument in which argument headers should be injected
 */ var createAddHeaderDecorator = function() {
    var callback = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {}, applyToArgument = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return function(target, name, descriptor) {
        var fn = descriptor.value;
        descriptor.value = function createAddHeaderDecorator() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var argument = args[applyToArgument] || {
                headers: {}
            };
            var headersToAdd = callback.apply(void 0, _to_consumable_array._(args));
            if (headersToAdd) {
                argument.headers = Object.assign(Object.assign({}, headersToAdd), argument.headers);
                args[applyToArgument] = argument;
            }
            return fn.apply(this, args);
        };
        return descriptor;
    };
};
exports.createAddHeaderDecorator = createAddHeaderDecorator;


/***/ }),

/***/ 44558:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(88801);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.withCustomerHeader = void 0;
var fido_utils_1 = __webpack_require__(88513);
var decorators_builder_1 = __webpack_require__(34436);
/**
 * A decorator which injects the customer header 'x-customer-name' with the configured customer
 * It injects the header in an object under the property 'headers'
 * @param {number} applyToArgument the argument in which it should be injected
 */ var withCustomerHeader = function() {
    var applyToArgument = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return (0, decorators_builder_1.createAddHeaderDecorator)((0, fido_utils_1.addFidoPropertyIfDefined)({}, "customerCode", "X-Customer-Name"), applyToArgument);
};
exports.withCustomerHeader = withCustomerHeader;


/***/ }),

/***/ 83809:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(45538);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.withDeviceHeaders = void 0;
var fido_1 = __webpack_require__(6446);
var withDeviceHeaders = function(target, name, descriptor) {
    var fn = descriptor.value;
    descriptor.value = function withDeviceHeaders() {
        var args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        var headers = Object.assign(Object.assign({}, args.headers), {
            "x-auth-device-id": fido_1.fido.get("localDeviceId"),
            "x-customer-name": fido_1.fido.get("customerCode")
        });
        return fn.apply(this, [
            Object.assign(Object.assign({}, args), {
                headers: headers
            })
        ]);
    };
    return descriptor;
};
exports.withDeviceHeaders = withDeviceHeaders;


/***/ }),

/***/ 62782:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _async_to_generator = __webpack_require__(24146);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(3009);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.withJWT = void 0;
var oidcService_1 = __webpack_require__(22285);
var tokenService_1 = __webpack_require__(9216);
var retrieveAndInjectToken = function() {
    var _ref = _async_to_generator._(function(context, fn) {
        var args, retrying, token, argsSaved, headers, oidcAccessToken;
        var _arguments = arguments;
        return _ts_generator._(this, function(_state) {
            switch(_state.label){
                case 0:
                    args = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : {}, retrying = _arguments.length > 3 ? _arguments[3] : void 0;
                    return [
                        4,
                        tokenService_1.tokenService.getToken()
                    ];
                case 1:
                    token = _state.sent();
                    argsSaved = Object.assign({}, args);
                    if (!oidcService_1.oidcService.isInitialized) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        oidcService_1.oidcService.getAccessToken()
                    ];
                case 2:
                    oidcAccessToken = _state.sent();
                    headers = Object.assign(Object.assign({}, args.headers), {
                        Authorization: "Bearer ".concat(oidcAccessToken),
                        "X-Bedrock-Token": token
                    });
                    return [
                        3,
                        4
                    ];
                case 3:
                    headers = Object.assign(Object.assign({}, args.headers), {
                        Authorization: "Bearer ".concat(token)
                    });
                    _state.label = 4;
                case 4:
                    return [
                        2,
                        fn.apply(context, [
                            Object.assign(Object.assign({}, args), {
                                headers: headers
                            })
                        ]).catch(function(error) {
                            if (error.status === 498 && !retrying) {
                                tokenService_1.tokenService.resetToken();
                                return retrieveAndInjectToken(context, fn, argsSaved, true);
                            }
                            throw error;
                        })
                    ];
            }
        });
    });
    return function retrieveAndInjectToken(context, fn) {
        return _ref.apply(this, arguments);
    };
}();
var withJWT = function(target, name, descriptor) {
    var fn = descriptor.value;
    descriptor.value = function withJWT(args) {
        return retrieveAndInjectToken(this, fn, args);
    };
    return descriptor;
};
exports.withJWT = withJWT;


/***/ }),

/***/ 28882:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(3009);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.withRequestTimeoutHeader = void 0;
var fido_1 = __webpack_require__(6446);
var decorators_builder_1 = __webpack_require__(34436);
var withRequestTimeoutHeader = function() {
    var applyToArgument = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
    return (0, decorators_builder_1.createAddHeaderDecorator)(function(url) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        return {
            "Request-Timeout": String(options.waitTimeout || fido_1.fido.get("waitTimeout"))
        };
    }, applyToArgument);
};
exports.withRequestTimeoutHeader = withRequestTimeoutHeader;


/***/ }),

/***/ 10474:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(88801);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.withVersionHeader = void 0;
var fido_utils_1 = __webpack_require__(88513);
var decorators_builder_1 = __webpack_require__(34436);
/**
 * A decorator which injects the customer header 'x-customer-name' with the configured customer
 * It injects the header in an object under the property 'headers'
 * @param {number} applyToArgument the argument in which it should be injected
 */ var withVersionHeader = function() {
    var applyToArgument = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return (0, decorators_builder_1.createAddHeaderDecorator)((0, fido_utils_1.addFidoPropertyIfDefined)({}, "appVersion", "X-Client-Release"), applyToArgument);
};
exports.withVersionHeader = withVersionHeader;


/***/ }),

/***/ 99136:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(42578);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.OidcApiClient = void 0;
var OidcApiClient = /*#__PURE__*/ function() {
    function OidcApiClient(param) {
        var endpoints = param.endpoints, clientId = param.clientId, clientSecret = param.clientSecret, getApiUrl = param.getApiUrl, getCustomApiUrl = param.getCustomApiUrl, externalFetch = param.externalFetch;
        _class_call_check._(this, OidcApiClient);
        this.endpoints = endpoints;
        this.clientId = clientId;
        this.clientSecret = clientSecret;
        this.getApiUrl = getApiUrl;
        this.getCustomApiUrl = getCustomApiUrl;
        this.externalFetch = externalFetch;
    }
    _create_class._(OidcApiClient, [
        {
            key: "fetchTokens",
            value: /**
     * Fetches the different tokens through Keycloak API, using the endpoint provided on init.
     * Do note that this method fetches tokens for a **CONNECTED** user.
     * @see `fetchAnonymousTokens` for fetching unlogged users tokens
     * @async
     * @param {Object} params The params to include in the body of the request
     * @param {string} [params.grant_type] The grant type to use for the token request
     * @param {string} [params.code] The authorization code to exchange for tokens (Web)
     * @param {string} [params.code_verifier] The PKCE code verifier used to generate the code challenge (Web)
     * @param {string} [params.redirect_uri] The redirect URI that define to which app URL to return after redirection (Web)
     * @param {string} [params.device_code] The code that correspond to the device identity (TVJS)
     * @returns {Promise<OidcTokens>} The token response containing: access token, ID token, and a refresh token.
     */ function fetchTokens() {
                var params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        return [
                            2,
                            _this.externalFetch(_this.getApiUrl(_this.endpoints.TOKEN), {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/x-www-form-urlencoded"
                                },
                                body: Object.assign({
                                    client_id: _this.clientId
                                }, params)
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "fetchAnonymousTokens",
            value: /**
     * Fetches the different tokens through Keycloak API, using the endpoint provided on init.
     * Do note that this method fetches tokens for an **UNLOGGED** user.
     * @see `fetchTokens` for fetching unlogged users tokens
     * @async
     * @returns {Promise<OidcTokens>} The token response containing: access token, ID token, and a refresh token.
     */ function fetchAnonymousTokens() {
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        return [
                            2,
                            _this.externalFetch(_this.getApiUrl(_this.endpoints.TOKEN), {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/x-www-form-urlencoded"
                                },
                                body: {
                                    client_id: "anonymous-user",
                                    client_secret: _this.clientSecret,
                                    grant_type: "client_credentials"
                                }
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "getUserInfo",
            value: /**
     * Retrieves user information from the userinfo endpoint provided on init.
     * @async
     * @param {string} accessToken The accessToken of the current user
     * @returns {Promise<Object>} A promise that resolves to the userinfo response.
     * @throws {Error} Can throw an error if :
     * - No access token was provided
     * - The API returns an error
     */ function getUserInfo(accessToken) {
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!accessToken || accessToken === "") {
                                    throw new Error("No access token to fetch user info");
                                }
                                return [
                                    4,
                                    _this.externalFetch(_this.getApiUrl(_this.endpoints.USERINFO), {
                                        method: "GET",
                                        headers: {
                                            Authorization: "Bearer ".concat(accessToken)
                                        }
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "authorizeDevice",
            value: /**
     * Try to authorize a given device with the given scopes (Only used by TVJS)
     * @async
     * @param {string} [scopes='openid profile offline_access'] The scopes requested for this device
     * @returns {Promise<Object>} The response of the API as-is
     * @throws {Error} Can throw an error if :
     * - The endpoint was not properly configured on init
     * - The API returns an error
     */ function authorizeDevice() {
                var scopes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "openid profile offline_access";
                var _this = this;
                return _async_to_generator._(function() {
                    var _a;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!((_a = _this.endpoints) === null || _a === void 0 ? void 0 : _a.DEVICE_AUTHORIZATION)) {
                                    throw new Error("Device authorization endpoint is not configured for the current provider.");
                                }
                                return [
                                    4,
                                    _this.externalFetch(_this.getApiUrl(_this.endpoints.DEVICE_AUTHORIZATION), {
                                        method: "POST",
                                        body: "scope=".concat(scopes, "&client_id=").concat(_this.clientId),
                                        headers: {
                                            "Content-Type": "application/x-www-form-urlencoded"
                                        }
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "logout",
            value: /**
     * Logs out the user from the OIDC provider (Only used by TVJS)
     * @async
     * @param {string} accessToken The current valid accessToken of this user
     * @param {string} refreshToken The refresh token that would be used to refresh that accessToken
     * @returns {Promise<Object>} The response from the logout request, as-is.
     * @throws {Error} Will throw an error if any of the following situations :
     * - The endpoint CUSTOM_LOGOUT wasn't configured
     * - No accessToken or refreshToken was provided
     * - The API throws an error
     */ function logout(accessToken, refreshToken) {
                var _this = this;
                return _async_to_generator._(function() {
                    var _a;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!((_a = _this.endpoints) === null || _a === void 0 ? void 0 : _a.CUSTOM_LOGOUT)) {
                                    throw new Error("Custom logout endpoint is not configured for the current provider.");
                                }
                                if (!accessToken || accessToken === "") {
                                    throw new Error("Access token is required to logout");
                                }
                                if (!refreshToken || refreshToken === "") {
                                    throw new Error("Refresh token is required to logout");
                                }
                                return [
                                    4,
                                    _this.externalFetch(_this.getCustomApiUrl(_this.endpoints.CUSTOM_LOGOUT), {
                                        method: "POST",
                                        headers: {
                                            Authorization: "Bearer ".concat(accessToken)
                                        },
                                        body: {
                                            clientId: _this.clientId,
                                            logoutMode: "CLIENT",
                                            refreshToken: refreshToken
                                        }
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return OidcApiClient;
}();
exports.OidcApiClient = OidcApiClient;


/***/ }),

/***/ 55902:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(3009);
var __importDefault = (void 0) && (void 0).__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.PkceService = void 0;
var enc_base64_1 = __importDefault(__webpack_require__(33490));
var sha256_1 = __importDefault(__webpack_require__(57735));
var CODE_VERIFIER_STORAGE_KEY = "oidcCodeVerifier";
var isClient = typeof window !== "undefined";
/**
 * This service handles all key generation for Proof Key for Code Exchange (PKCE)
 * It is used to generate unique keys that identify the user's computer as legitimate
 */ var PkceService = /*#__PURE__*/ function() {
    function PkceService() {
        _class_call_check._(this, PkceService);
        this.codeVerifier = null;
        this.codeChallenge = null;
    }
    _create_class._(PkceService, [
        {
            /**
     * Generate a new codeVerifier, that will be stored in `this.codeVerifier`
     */ key: "generateCodeVerifier",
            value: function generateCodeVerifier() {
                var randomArray = window.crypto.getRandomValues(new Uint32Array(32));
                this.codeVerifier = Array.from(randomArray, function(dec) {
                    return "0".concat(dec.toString(16)).substr(-2);
                }).join("");
            }
        },
        {
            /**
     * Returns the current code verifier to use.
     */ key: "getOrCreateCodeVerifier",
            value: function getOrCreateCodeVerifier() {
                if (this.codeVerifier) {
                    return this.codeVerifier;
                }
                if (isClient && sessionStorage.getItem(CODE_VERIFIER_STORAGE_KEY)) {
                    this.codeVerifier = sessionStorage.getItem(CODE_VERIFIER_STORAGE_KEY);
                    return this.codeVerifier;
                }
                this.generateCodeVerifier();
                if (isClient) {
                    sessionStorage.setItem(CODE_VERIFIER_STORAGE_KEY, this.codeVerifier);
                }
                return this.codeVerifier;
            }
        },
        {
            /**
     * Returns the current code challenge to use.
     */ key: "getOrCreateCodeChallenge",
            value: function getOrCreateCodeChallenge() {
                if (this.codeChallenge) {
                    return this.codeChallenge;
                }
                if (!this.codeVerifier) {
                    this.getOrCreateCodeVerifier();
                }
                var hash = (0, sha256_1.default)(this.codeVerifier);
                this.codeChallenge = enc_base64_1.default.stringify(hash).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
                return this.codeChallenge;
            }
        }
    ]);
    return PkceService;
}();
exports.PkceService = PkceService;


/***/ }),

/***/ 94916:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(37815);
var __importDefault = (void 0) && (void 0).__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.TokenManager = void 0;
var jwt_decode_1 = __importDefault(__webpack_require__(30588));
var STORAGE_KEYS = {
    ACCESS_TOKEN: "oidcAccessToken",
    REFRESH_TOKEN: "oidcRefreshToken",
    ID_TOKEN: "oidcIdToken"
};
var isClient = typeof window !== "undefined";
var TokenManager = /*#__PURE__*/ function() {
    function TokenManager() {
        var useLocalStorageFallback = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        _class_call_check._(this, TokenManager);
        this.shouldUseLocalStorageFallback = false;
        // This is a JWT token, used to communicate with DE (Not to be confused with BR's JWT token). Default validity time of 24h
        this.accessToken = null;
        // This is used to reset the duration of the accessToken, for example if we need to extend its validity time
        this.refreshToken = null;
        // This ID points to the accessToken/refreshToken duo that we generated. It will be used to revoke them once the user logs out
        this.idToken = null;
        this.shouldUseLocalStorageFallback = useLocalStorageFallback;
    }
    _create_class._(TokenManager, [
        {
            key: "getAccessToken",
            value: function getAccessToken() {
                return this.accessToken;
            }
        },
        {
            key: "getRefreshToken",
            value: function getRefreshToken() {
                return this.refreshToken;
            }
        },
        {
            key: "getIdToken",
            value: function getIdToken() {
                return this.idToken;
            }
        },
        {
            key: "setAccessToken",
            value: function setAccessToken(token) {
                this.accessToken = token;
                if (isClient && this.shouldUseLocalStorageFallback) {
                    localStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, token);
                }
            }
        },
        {
            key: "setRefreshToken",
            value: function setRefreshToken(token) {
                this.refreshToken = token;
                if (isClient && this.shouldUseLocalStorageFallback) {
                    localStorage.setItem(STORAGE_KEYS.REFRESH_TOKEN, token);
                }
            }
        },
        {
            key: "setIdToken",
            value: function setIdToken(token) {
                this.idToken = token;
                if (isClient && this.shouldUseLocalStorageFallback) {
                    localStorage.setItem(STORAGE_KEYS.ID_TOKEN, token);
                }
            }
        },
        {
            key: "clearTokens",
            value: function clearTokens() {
                this.accessToken = null;
                this.refreshToken = null;
                this.idToken = null;
                if (isClient && this.shouldUseLocalStorageFallback) {
                    localStorage.removeItem(STORAGE_KEYS.ACCESS_TOKEN);
                    localStorage.removeItem(STORAGE_KEYS.REFRESH_TOKEN);
                    localStorage.removeItem(STORAGE_KEYS.ID_TOKEN);
                }
            }
        },
        {
            key: "isTokenValid",
            value: function isTokenValid(token) {
                if (!token) {
                    return false;
                }
                try {
                    var decodedToken = (0, jwt_decode_1.default)(token);
                    // If the token expires in 10s or less, we deem it invalid (To avoid getting unnecessary 498s)
                    return new Date().getTime() < (decodedToken.exp - 10) * 1000;
                } catch (_a) {
                    return false;
                }
            }
        },
        {
            key: "clearInvalidTokensFromStorage",
            value: function clearInvalidTokensFromStorage() {
                var _this = this;
                [
                    STORAGE_KEYS.ACCESS_TOKEN,
                    STORAGE_KEYS.ID_TOKEN
                ].forEach(function(tokenKey) {
                    if (!_this.isTokenValid(localStorage.getItem(tokenKey))) {
                        localStorage.removeItem(tokenKey);
                    }
                });
            }
        },
        {
            key: "clearInvalidTokensFromMemory",
            value: function clearInvalidTokensFromMemory() {
                if (!this.isTokenValid(this.accessToken)) {
                    this.accessToken = null;
                }
                if (!this.isTokenValid(this.idToken)) {
                    this.idToken = null;
                }
            }
        },
        {
            key: "clearInvalidTokens",
            value: function clearInvalidTokens() {
                if (isClient && this.shouldUseLocalStorageFallback) {
                    this.clearInvalidTokensFromStorage();
                } else {
                    this.clearInvalidTokensFromMemory();
                }
            }
        }
    ]);
    return TokenManager;
}();
exports.TokenManager = TokenManager;


/***/ }),

/***/ 22285:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(3009);
var __decorate = (void 0) && (void 0).__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (void 0) && (void 0).__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.oidcService = void 0;
var jwt_decode_1 = __importDefault(__webpack_require__(30588));
var fido_1 = __webpack_require__(6446);
var fetcherService_1 = __webpack_require__(97269);
var withMonitoring_1 = __webpack_require__(89873);
var oidcApiClient_1 = __webpack_require__(99136);
var pkceService_1 = __webpack_require__(55902);
var tokenManager_1 = __webpack_require__(94916);
var monitoring = (0, withMonitoring_1.withMonitoring)("oidc");
var isClient = typeof window !== "undefined";
// Timings in milliseconds for the iframe lifetime & iframe checks frequency
var IFRAME_TIMEOUT_DURATION = 2000;
var IFRAME_CHECK_FREQUENCY = 200;
/**
 * The OIDC service is used to retrieve JWT from OIDC provider in order to use 6play's API.
 * @module Oidc
 */ var OIDCService = /*#__PURE__*/ function(_fetcherService_1_FetcherService) {
    _inherits._(OIDCService, _fetcherService_1_FetcherService);
    var _super = _create_super._(OIDCService);
    function OIDCService() {
        _class_call_check._(this, OIDCService);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.isInitialized = false;
        _this.deviceCode = null;
        return _this;
    }
    _create_class._(OIDCService, [
        {
            key: "init",
            value: /**
     * @async
     * @param {string} clientId The client ID for OIDC provider
     * @param {string} clientSecret The client secret for OIDC provider
     * @param {string} silentCheckSsoRedirectUri The redirect URI for silent SSO checks
     * @param {Object} endpoints The endpoints for the provider API
     * @param {string} endpoints.TOKEN The token endpoint
     * @param {string} endpoints.REVOCATION The revoke endpoint
     * @param {string} endpoints.USERINFO The user info endpoint
     * @param {string} [endpoints.AUTHORIZATION] The authentication endpoint (Web)
     * @param {string} [endpoints.LOGOUT] The logout endpoint (Web)
     * @param {string} [endpoints.CUSTOM_LOGOUT] The device code endpoint (TV)
     * @param {string} [endpoints.DEVICE_AUTHORIZATION] The device authentication endpoint (TV)
     * @param {string} [endpoints.THIRD_PARTY_COOKIES_IFRAME]  The thirdparty cookies iframe URL (required for thirdparty cookie validation)
     * @param {boolean} forceLocalStorage=true If `true`, disables keycloak and the iframe system entirely (Useful for legacy devices)
     */ function init(param) {
                var clientId = param.clientId, clientSecret = param.clientSecret, endpoints = param.endpoints, silentCheckSsoRedirectUri = param.silentCheckSsoRedirectUri, _param_forceLocalStorage = param.forceLocalStorage, forceLocalStorage = _param_forceLocalStorage === void 0 ? true : _param_forceLocalStorage;
                var _this = this;
                return _async_to_generator._(function() {
                    var _tmp;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!!_this.isInitialized) return [
                                    3,
                                    4
                                ];
                                _this.isInitialized = true;
                                _this.isThirdPartyCookieCheckDone = false;
                                _this.endpoints = endpoints;
                                _this.clientId = clientId;
                                _this.clientSecret = clientSecret;
                                _this.silentCheckSsoRedirectUri = "";
                                _this.pkceService = new pkceService_1.PkceService();
                                _this.tokenManager = new tokenManager_1.TokenManager();
                                _this.oidcApiClient = new oidcApiClient_1.OidcApiClient({
                                    endpoints: endpoints,
                                    clientId: clientId,
                                    clientSecret: clientSecret,
                                    getApiUrl: _this.getApiUrl.bind(_this),
                                    getCustomApiUrl: _this.getCustomApiUrl.bind(_this),
                                    externalFetch: _this.externalFetch
                                });
                                if (isClient && silentCheckSsoRedirectUri) {
                                    _this.silentCheckSsoRedirectUri = window.location.origin + "/" + silentCheckSsoRedirectUri;
                                }
                                if (!(forceLocalStorage || !endpoints.THIRD_PARTY_COOKIES_IFRAME)) return [
                                    3,
                                    1
                                ];
                                _tmp = false;
                                return [
                                    3,
                                    3
                                ];
                            case 1:
                                return [
                                    4,
                                    _this.checkThirdPartyCookiesSupported()
                                ];
                            case 2:
                                _tmp = _state.sent();
                                _state.label = 3;
                            case 3:
                                _this.areThirdPartyCookiesSupported = _tmp;
                                _this.tokenManager.shouldUseLocalStorageFallback = !_this.areThirdPartyCookiesSupported;
                                _this.isThirdPartyCookieCheckDone = true;
                                if (isClient && !_this.areThirdPartyCookiesSupported) {
                                    _this.setTokens({
                                        accessToken: localStorage.getItem("oidcAccessToken") || "",
                                        refreshToken: localStorage.getItem("oidcRefreshToken") || "",
                                        idToken: localStorage.getItem("oidcIdToken") || ""
                                    });
                                }
                                // After we're done saving tokens config, we ensure that they're valid (Otherwise they're removed)
                                _this.checkTokensValidity();
                                _state.label = 4;
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
     * Return the full API URL for the given endpoint
     * @param {string} endpoint The wanted endpoint
     * @returns {string} API URL
     */ key: "getApiUrl",
            value: function getApiUrl(endpoint) {
                return "".concat(fido_1.fido.getBaseUrl("oidc"), "/").concat(endpoint);
            }
        },
        {
            /**
     * Return the full custom API URL for the given endpoint
     * @param {string} endpoint The wanted endpoint
     * @returns {string} API URL
     */ key: "getCustomApiUrl",
            value: function getCustomApiUrl(endpoint) {
                return "".concat(fido_1.fido.getBaseUrl("oidcCustomApi"), "/").concat(endpoint);
            }
        },
        {
            /**
     * Decode the access token to check if the user is a guest
     * @returns {boolean} True if the user is a guest, false otherwise
     */ key: "isGuestUser",
            value: function isGuestUser() {
                var _a;
                var accessToken = this.getAccessToken();
                try {
                    return accessToken && ((_a = (0, jwt_decode_1.default)(accessToken)) === null || _a === void 0 ? void 0 : _a.isGuest);
                } catch (_b) {
                    return false;
                }
            }
        },
        {
            /**
     * Get or generate a code challenge if it doesn't exist
     * Converts the verifier code into a secure PKCE challenge code
     * Transform the hash into a Base64 safe URL-encoded string
     * @returns {string} The Base64 URL-encoded SHA-256 hash of the code verifier.
     */ key: "getOrCreateCodeChallenge",
            value: function getOrCreateCodeChallenge() {
                return this.pkceService.getOrCreateCodeChallenge();
            }
        },
        {
            key: "getOrCreateCodeVerifier",
            value: function getOrCreateCodeVerifier() {
                return this.pkceService.getOrCreateCodeVerifier();
            }
        },
        {
            /**
     * Get the device code
     * @returns {?string} A string that correspond to the device identity
     */ key: "getDeviceCode",
            value: function getDeviceCode() {
                return this.deviceCode;
            }
        },
        {
            key: "waitForThirdPartyCheck",
            value: /**
     * Blocks execution until the service is initialized, or after a max retry amount has been reached.
     * @param retryIteration=0 The current iteration number.
     * @returns {Promise<boolean>} Indicates `true` if the initialization is complete, or `false` if the maximum retry amount has been reached
     */ function waitForThirdPartyCheck() {
                var retryIteration = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (_this.isThirdPartyCookieCheckDone) {
                                    return [
                                        2,
                                        true
                                    ];
                                }
                                if (retryIteration >= IFRAME_TIMEOUT_DURATION / IFRAME_CHECK_FREQUENCY) {
                                    return [
                                        2,
                                        false
                                    ];
                                }
                                return [
                                    4,
                                    new Promise(function(resolve) {
                                        return setTimeout(resolve, IFRAME_CHECK_FREQUENCY);
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2,
                                    _this.waitForThirdPartyCheck(retryIteration + 1)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getOrFetchOidcTokens",
            value: /**
     * Get or fetch the OIDC access and refresh Tokens
     * If no access token is available, it will fetch a new one.
     * Ensures correct storage is used depending on third-party cookie support.
     * @returns {Object} The response containing: access token and refresh token.
     */ function getOrFetchOidcTokens() {
                var _this = this;
                return _async_to_generator._(function() {
                    var accessToken, accessToken1, tokens, ssoResult, refreshToken, _a, error;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!!isClient) return [
                                    3,
                                    3
                                ];
                                accessToken = _this.getAccessToken();
                                if (!(!accessToken || !_this.isTokenValid(accessToken))) return [
                                    3,
                                    2
                                ];
                                // On server-side, we will always use Anonymous tokens. If invalid, we need to refresh them
                                return [
                                    4,
                                    _this.fetchAnonymousTokens()
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2,
                                    {
                                        accessToken: _this.getAccessToken(),
                                        refreshToken: _this.getRefreshToken()
                                    }
                                ];
                            case 3:
                                return [
                                    4,
                                    _this.waitForThirdPartyCheck()
                                ];
                            case 4:
                                _state.sent();
                                if (!_this.areThirdPartyCookiesSupported) {
                                    // Make sure we'll use the tokens retrieved from the correct place
                                    _this.setTokens({
                                        accessToken: localStorage.getItem("oidcAccessToken"),
                                        refreshToken: localStorage.getItem("oidcRefreshToken"),
                                        idToken: localStorage.getItem("oidcIdToken")
                                    });
                                }
                                accessToken1 = _this.getAccessToken();
                                if (!(!accessToken1 || !_this.isTokenValid(accessToken1))) return [
                                    3,
                                    16
                                ];
                                _state.label = 5;
                            case 5:
                                _state.trys.push([
                                    5,
                                    14,
                                    ,
                                    15
                                ]);
                                if (!_this.areThirdPartyCookiesSupported) return [
                                    3,
                                    7
                                ];
                                return [
                                    4,
                                    _this.checkSsoSilently()
                                ];
                            case 6:
                                ssoResult = _state.sent();
                                // If we can retrieve an accessToken, then the user was indeed logged in
                                if (ssoResult === null || ssoResult === void 0 ? void 0 : ssoResult.access_token) {
                                    tokens = ssoResult;
                                }
                                return [
                                    3,
                                    11
                                ];
                            case 7:
                                refreshToken = _this.getRefreshToken();
                                if (!refreshToken) return [
                                    3,
                                    11
                                ];
                                _state.label = 8;
                            case 8:
                                _state.trys.push([
                                    8,
                                    10,
                                    ,
                                    11
                                ]);
                                return [
                                    4,
                                    _this.renewAccessToken()
                                ];
                            case 9:
                                _state.sent();
                                tokens = {
                                    access_token: _this.getAccessToken(),
                                    refresh_token: _this.getRefreshToken(),
                                    id_token: _this.getIdToken()
                                };
                                return [
                                    3,
                                    11
                                ];
                            case 10:
                                _a = _state.sent();
                                return [
                                    3,
                                    11
                                ];
                            case 11:
                                if (!!tokens) return [
                                    3,
                                    13
                                ];
                                return [
                                    4,
                                    _this.oidcApiClient.fetchAnonymousTokens()
                                ];
                            case 12:
                                // If the user isn't logged in, we retrieve anonymous tokens
                                tokens = _state.sent();
                                _state.label = 13;
                            case 13:
                                return [
                                    3,
                                    15
                                ];
                            case 14:
                                error = _state.sent();
                                throw new Error("Error fetching OIDC tokens from getOrFetchOidcTokens:", error);
                            case 15:
                                _this.setTokens({
                                    accessToken: tokens.access_token || "",
                                    refreshToken: tokens.refresh_token || "",
                                    idToken: tokens.id_token || ""
                                });
                                _state.label = 16;
                            case 16:
                                return [
                                    2,
                                    {
                                        accessToken: _this.getAccessToken(),
                                        refreshToken: _this.getRefreshToken()
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "fetchConnectedTokens",
            value: /**
     * Fetch access and refresh tokens for connected user
     * @async
     * @param {Object} params The params to include in the body of the request
     * @param {string} params.grant_type The grant type to use for the token request
     * @param {string} [params.code] The authorization code to exchange for tokens (Web)
     * @param {string} [params.code_verifier] The PKCE code verifier used to generate the code challenge (Web)
     * @param {string} [params.redirect_uri] The redirect URI that define to which app URL to return after redirection (Web)
     * @param {string} [params.device_code] The code that correspond to the device identity (TVJS)
     * @returns {Object} The token response containing: access token, ID token, and a refresh token.
     */ function fetchConnectedTokens() {
                var params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _async_to_generator._(function() {
                    var tokens;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.oidcApiClient.fetchTokens(params)
                                ];
                            case 1:
                                tokens = _state.sent();
                                _this.setTokens({
                                    accessToken: tokens.access_token,
                                    refreshToken: tokens.refresh_token,
                                    idToken: tokens.id_token
                                });
                                return [
                                    2,
                                    tokens
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "fetchAnonymousTokens",
            value: /**
     * Fetch access and refresh tokens for anonymous user
     * @async
     * @returns {Object} The token response containing: access token, ID token, and a refresh token.
     */ function fetchAnonymousTokens() {
                var _this = this;
                return _async_to_generator._(function() {
                    var tokens;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.oidcApiClient.fetchAnonymousTokens()
                                ];
                            case 1:
                                tokens = _state.sent();
                                _this.setTokens({
                                    accessToken: tokens.access_token,
                                    refreshToken: tokens.refresh_token || "",
                                    idToken: tokens.id_token || ""
                                });
                                return [
                                    2,
                                    tokens
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getUserInfo",
            value: /**
     * Retrieves user information from the userinfo endpoint.
     * @returns {Promise<Object>} A promise that resolves to the userinfo response.
     */ function getUserInfo() {
                var _this = this;
                return _async_to_generator._(function() {
                    var accessToken;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.getOrFetchOidcTokens()
                                ];
                            case 1:
                                accessToken = _state.sent().accessToken;
                                if (!accessToken || !_this.isTokenValid(accessToken)) {
                                    throw new Error("No valid access token to fetch user info");
                                }
                                if (_this.isGuestUser()) {
                                    return [
                                        2,
                                        Promise.resolve()
                                    ];
                                }
                                return [
                                    2,
                                    _this.oidcApiClient.getUserInfo(accessToken)
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
     * Retrieves the user's access token
     * @returns {string} The access token
     */ key: "getAccessToken",
            value: function getAccessToken() {
                return this.tokenManager.getAccessToken();
            }
        },
        {
            /**
     * Retrieves the user's refresh token
     * @returns {string} The refresh token
     */ key: "getRefreshToken",
            value: function getRefreshToken() {
                return this.tokenManager.getRefreshToken();
            }
        },
        {
            /**
     * Retrieves the user's id token
     * @returns {string} The id token
     */ key: "getIdToken",
            value: function getIdToken() {
                return this.tokenManager.getIdToken();
            }
        },
        {
            /**
     * Retrieves user information from the userinfo endpoint.
     *
     * @param {Object} options - The options for constructing the authorization URL.
     * @param {string|string[][]|Object} [options.params={}] - Parameters to build an URLSearchParams object of query parameters to include in the URL.
     * @param {string} [options.type='login'] - The type of authorization. Allowed values: `'login'` or `'registration'`.
     * @returns {string} The fully constructed authorization URL to be used for user redirection.
     * @throws {Error} Throws an error in the following cases :
     * - The provided type is not valid (Should be `'login'` or `'registration'`)
     * - The endpoint is not properly configured for the provided type
     */ key: "getAuthorizedUrl",
            value: function getAuthorizedUrl(param) {
                var _param_params = param.params, params = _param_params === void 0 ? {} : _param_params, _param_type = param.type, type = _param_type === void 0 ? "login" : _param_type;
                var _a, _b;
                var endpoint;
                if (type === "registration") {
                    endpoint = (_a = this.endpoints) === null || _a === void 0 ? void 0 : _a.AUTHORIZATION_WITH_REGISTRATION;
                } else if (type === "login") {
                    endpoint = (_b = this.endpoints) === null || _b === void 0 ? void 0 : _b.AUTHORIZATION_WITH_LOGIN;
                } else {
                    throw new Error("Invalid authorization type: ".concat(type, ". Use 'login' or 'registration'."));
                }
                if (!endpoint) {
                    throw new Error("Authorization endpoint for type '".concat(type, "' is not configured for the current provider."));
                }
                var url = new URL(this.getApiUrl(endpoint));
                var searchParams = new URLSearchParams(params);
                url.search = searchParams.toString();
                return url.toString();
            }
        },
        {
            key: "authorizeDevice",
            value: /**
     * Return the device_code and the verification_uri to authorize the device
     * @async
     * @param {string} [scopes='openid profile offline_access'] The scopes requested for this device
     * @returns {Object}
     */ function authorizeDevice() {
                var scopes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "openid profile offline_access";
                var _this = this;
                return _async_to_generator._(function() {
                    var body;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.oidcApiClient.authorizeDevice(scopes)
                                ];
                            case 1:
                                body = _state.sent();
                                _this.deviceCode = body.device_code;
                                return [
                                    2,
                                    body
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
     * Generate the authorized logout redirect URL. (Only used by WEB)
     * @param {string} postLogoutUrl - The URL to which the user should be redirected after logout.
     * @returns {string} - The fully constructed and authorized logout redirect URL.
     * @throws {Error} If:
     * - the logout endpoint is not configured.
     * - the ID Token is invalid.
     */ key: "getLogoutRedirectUrl",
            value: function getLogoutRedirectUrl(postLogoutUrl) {
                var _a;
                if (!((_a = this.endpoints) === null || _a === void 0 ? void 0 : _a.LOGOUT)) {
                    throw new Error("Logout endpoint is not configured for the current provider.");
                }
                var idToken = this.getIdToken();
                var params = new URLSearchParams({
                    id_token_hint: idToken,
                    client_id: this.clientId,
                    post_logout_redirect_uri: postLogoutUrl
                });
                return "".concat(this.getApiUrl(this.endpoints.LOGOUT), "?").concat(params);
            }
        },
        {
            /**
     * Saves all provided tokens into the tokenManager
     * @param {string} accessToken
     * @param {string} refreshToken
     * @param {string} idToken
     */ key: "setTokens",
            value: function setTokens(param) {
                var accessToken = param.accessToken, refreshToken = param.refreshToken, idToken = param.idToken;
                this.tokenManager.setAccessToken(accessToken);
                this.tokenManager.setRefreshToken(refreshToken);
                this.tokenManager.setIdToken(idToken);
            }
        },
        {
            /**
     * Removes all tokens currently saved within the oidcService.
     */ key: "clearTokens",
            value: function clearTokens() {
                this.tokenManager.clearTokens();
            }
        },
        {
            /**
     * Receives a token, and checks both the token format & the expiration dates.
     * @param {string} token The token that will be checked
     * @return {boolean} The status of the token passed as parameter.
     */ key: "isTokenValid",
            value: function isTokenValid(token) {
                return this.tokenManager.isTokenValid(token);
            }
        },
        {
            /**
     * Check if current tokens are valid, otherwise remove them from localStorage or memory
     * @returns {void}
     */ key: "checkTokensValidity",
            value: function checkTokensValidity() {
                this.tokenManager.clearInvalidTokens();
            }
        },
        {
            key: "renewAccessToken",
            value: /**
     * Renews the current access token using the refresh token.
     * @async
     * @throws {Error} This function can throw 2 kind of errors :
     * - If no refresh token is found, or if the token is invalid
     * - If the refresh request fails
     */ function renewAccessToken() {
                var _this = this;
                return _async_to_generator._(function() {
                    var refreshToken, response;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                refreshToken = _this.getRefreshToken();
                                if (!refreshToken) {
                                    throw new Error("No valid refresh token");
                                }
                                return [
                                    4,
                                    _this.oidcApiClient.fetchTokens({
                                        grant_type: "refresh_token",
                                        refresh_token: refreshToken
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                if (!response.access_token) {
                                    throw new Error("Invalid response");
                                }
                                _this.setTokens({
                                    accessToken: response.access_token,
                                    refreshToken: response.refresh_token,
                                    idToken: response.id_token
                                });
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "logout",
            value: /**
     * Logs out the user from the OIDC provider (Only used by TVJS)
     * @async
     * @returns {Object} The response from the logout request, as-is.
     */ function logout() {
                var _this = this;
                return _async_to_generator._(function() {
                    var accessToken, refreshToken, response;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                accessToken = _this.getAccessToken();
                                refreshToken = _this.getRefreshToken();
                                return [
                                    4,
                                    _this.oidcApiClient.logout(accessToken, refreshToken)
                                ];
                            case 1:
                                response = _state.sent();
                                _this.clearTokens();
                                return [
                                    2,
                                    response
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "checkThirdPartyCookiesSupported",
            value: /**
     * Checks if third-party cookies are supported using a dedicated iframe endpoint.
     * Will always return `false` on server-side.
     * @async
     * @returns {Promise<boolean>} Promise indicating whether thirdparty cookies are currently supported
     */ function checkThirdPartyCookiesSupported() {
                var _this = this;
                return _async_to_generator._(function() {
                    var iframe, thirdPartyCookieSupported, cleanedUp, messageCallback, cleanup, promise, result, _a;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!isClient) {
                                    return [
                                        2,
                                        Promise.resolve(false)
                                    ];
                                }
                                // Return cached result if check was already completed
                                if (_this.isThirdPartyCookieCheckDone) {
                                    return [
                                        2,
                                        Promise.resolve(_this.areThirdPartyCookiesSupported)
                                    ];
                                }
                                // If no redirect URI is configured, return unsupported
                                if (!_this.silentCheckSsoRedirectUri) {
                                    return [
                                        2,
                                        Promise.resolve(false)
                                    ];
                                }
                                thirdPartyCookieSupported = false;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                // We create & append the iframe that will do the check
                                iframe = document.createElement("iframe");
                                iframe.setAttribute("src", _this.getApiUrl(_this.endpoints.THIRD_PARTY_COOKIES_IFRAME));
                                iframe.setAttribute("sandbox", "allow-storage-access-by-user-activation allow-scripts allow-same-origin");
                                iframe.setAttribute("title", "oidc-3p-cookies-check-iframe");
                                iframe.setAttribute("id", "oidc-3p-cookies-check-iframe");
                                iframe.style.display = "none";
                                document.body.appendChild(iframe);
                                cleanedUp = false;
                                // This function will remove all eventListeners & iframes used to check the supported status
                                cleanup = function() {
                                    if (!cleanedUp) {
                                        cleanedUp = true;
                                        var targetIframe = document.getElementById("oidc-3p-cookies-check-iframe");
                                        if (targetIframe && document.body.contains(targetIframe)) {
                                            document.body.removeChild(targetIframe);
                                        }
                                        if (messageCallback) window.removeEventListener("message", messageCallback);
                                    }
                                };
                                promise = new Promise(function(resolve) {
                                    messageCallback = function(event) {
                                        var targetIframe = document.getElementById("oidc-3p-cookies-check-iframe");
                                        if (!targetIframe || targetIframe.contentWindow !== event.source) {
                                            return;
                                        }
                                        if (event.data !== "supported" && event.data !== "unsupported") {
                                            return;
                                        }
                                        thirdPartyCookieSupported = event.data === "supported";
                                        cleanup();
                                        resolve(thirdPartyCookieSupported);
                                    };
                                    window.addEventListener("message", messageCallback, false);
                                });
                                return [
                                    4,
                                    _this.applyTimeoutToPromise(promise, IFRAME_TIMEOUT_DURATION, "Timeout when waiting for 3rd party check iframe message.")
                                ];
                            case 2:
                                result = _state.sent();
                                cleanup();
                                return [
                                    2,
                                    Promise.resolve(result)
                                ];
                            case 3:
                                _a = _state.sent();
                                return [
                                    2,
                                    Promise.resolve(false)
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "checkSsoSilently",
            value: /**
     * Performs a silent SSO check using an iframe to see if the user has an active session
     * with the OIDC provider.
     * @async
     * @returns {Promise<void>} A promise that resolves if the SSO check is successful and tokens are updated,
     * or rejects if an error occurs or the user is not logged in.
     */ function checkSsoSilently() {
                var _this = this;
                return _async_to_generator._(function() {
                    var cleanedUp, iframe, messageCallback, cleanup, promise, result;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this.silentCheckSsoRedirectUri) {
                                    return [
                                        2,
                                        Promise.resolve()
                                    ];
                                }
                                cleanedUp = false;
                                cleanup = function() {
                                    if (!cleanedUp) {
                                        cleanedUp = true;
                                        var targetIframe = document.getElementById("oidc-silent-sso-check-iframe");
                                        if (targetIframe && document.body.contains(targetIframe)) {
                                            document.body.removeChild(targetIframe);
                                        }
                                        if (messageCallback) window.removeEventListener("message", messageCallback);
                                    }
                                };
                                promise = new Promise(function(resolve, reject) {
                                    var _a, _b;
                                    iframe = document.createElement("iframe");
                                    var authEndpoint = ((_a = _this.endpoints) === null || _a === void 0 ? void 0 : _a.AUTHORIZATION_WITH_LOGIN) || ((_b = _this.endpoints) === null || _b === void 0 ? void 0 : _b.AUTHORIZATION);
                                    if (!authEndpoint) {
                                        reject(new Error("No authorization endpoint configured for silent SSO check"));
                                        return;
                                    }
                                    var url = new URL(_this.getApiUrl(authEndpoint));
                                    var params = new URLSearchParams({
                                        prompt: "none",
                                        response_type: "code",
                                        client_id: _this.clientId,
                                        redirect_uri: _this.silentCheckSsoRedirectUri,
                                        scope: "openid profile",
                                        code_challenge: _this.getOrCreateCodeChallenge(),
                                        code_challenge_method: "S256"
                                    });
                                    url.search = params.toString();
                                    iframe.setAttribute("src", url.toString());
                                    iframe.setAttribute("sandbox", "allow-storage-access-by-user-activation allow-scripts allow-same-origin");
                                    iframe.setAttribute("title", "oidc-silent-sso-check-iframe");
                                    iframe.setAttribute("id", "oidc-silent-sso-check-iframe");
                                    iframe.style.display = "none";
                                    document.body.appendChild(iframe);
                                    messageCallback = function() {
                                        var _ref = _async_to_generator._(function(event) {
                                            var dataStr, data, tokens, error;
                                            return _ts_generator._(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        if (event.origin !== window.location.origin) {
                                                            return [
                                                                2
                                                            ];
                                                        }
                                                        if (!(typeof event.data === "string" && event.data.startsWith("oidc-silent-sso:"))) return [
                                                            3,
                                                            7
                                                        ];
                                                        cleanup();
                                                        dataStr = event.data.substring("oidc-silent-sso:".length);
                                                        _state.label = 1;
                                                    case 1:
                                                        _state.trys.push([
                                                            1,
                                                            6,
                                                            ,
                                                            7
                                                        ]);
                                                        data = JSON.parse(dataStr);
                                                        if (!data.error) return [
                                                            3,
                                                            2
                                                        ];
                                                        resolve();
                                                        return [
                                                            3,
                                                            5
                                                        ];
                                                    case 2:
                                                        if (!data.code) return [
                                                            3,
                                                            4
                                                        ];
                                                        return [
                                                            4,
                                                            _this.oidcApiClient.fetchTokens({
                                                                grant_type: "authorization_code",
                                                                code: data.code,
                                                                code_verifier: _this.getOrCreateCodeVerifier(),
                                                                redirect_uri: _this.silentCheckSsoRedirectUri
                                                            })
                                                        ];
                                                    case 3:
                                                        tokens = _state.sent();
                                                        resolve(tokens);
                                                        return [
                                                            3,
                                                            5
                                                        ];
                                                    case 4:
                                                        reject(new Error("Unexpected data received from silent SSO check: " + dataStr));
                                                        _state.label = 5;
                                                    case 5:
                                                        return [
                                                            3,
                                                            7
                                                        ];
                                                    case 6:
                                                        error = _state.sent();
                                                        reject(error);
                                                        return [
                                                            3,
                                                            7
                                                        ];
                                                    case 7:
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        });
                                        return function(event) {
                                            return _ref.apply(this, arguments);
                                        };
                                    }();
                                    window.addEventListener("message", messageCallback);
                                });
                                return [
                                    4,
                                    _this.applyTimeoutToPromise(promise, IFRAME_TIMEOUT_DURATION, "Silent SSO check timed out.")
                                ];
                            case 1:
                                result = _state.sent();
                                cleanup();
                                return [
                                    2,
                                    result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "applyTimeoutToPromise",
            value: /**
     * Apply timeout to a promise to prevent hanging
     * @async
     * @param {Promise} promise - The promise to apply timeout to
     * @param {number} timeout - Timeout ifn milliseconds
     * @param {string} errorMessage - Error message if timeout occurs
     * @returns {Promise} The promise with timeout applied
     */ function applyTimeoutToPromise(promise, timeout, errorMessage) {
                return _async_to_generator._(function() {
                    var timeoutHandle, timeoutPromise;
                    return _ts_generator._(this, function(_state) {
                        timeoutPromise = new Promise(function(resolve, reject) {
                            timeoutHandle = window.setTimeout(function() {
                                reject(new Error(errorMessage || "Promise is not settled within timeout of " + timeout + "ms"));
                            }, timeout);
                        });
                        return [
                            2,
                            Promise.race([
                                promise,
                                timeoutPromise
                            ]).finally(function() {
                                clearTimeout(timeoutHandle);
                            })
                        ];
                    });
                })();
            }
        }
    ]);
    return OIDCService;
}(fetcherService_1.FetcherService);
__decorate([
    monitoring
], OIDCService.prototype, "fetchAnonymousTokens", null);
__decorate([
    monitoring
], OIDCService.prototype, "authorizeDevice", null);
__decorate([
    monitoring
], OIDCService.prototype, "renewAccessToken", null);
__decorate([
    monitoring
], OIDCService.prototype, "logout", null);
exports.oidcService = new OIDCService();


/***/ }),

/***/ 9216:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(88801);
var __decorate = (void 0) && (void 0).__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (void 0) && (void 0).__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.tokenService = void 0;
var jwt_decode_1 = __importDefault(__webpack_require__(30588));
var get_1 = __importDefault(__webpack_require__(65439));
var fetch_error_1 = __webpack_require__(63378);
var fido_1 = __webpack_require__(6446);
var caching_1 = __webpack_require__(48832);
var retryPromise_1 = __webpack_require__(99475);
var securityHeaderBuilder_1 = __webpack_require__(89222);
var fetcherService_1 = __webpack_require__(97269);
var withMonitoring_1 = __webpack_require__(89873);
var oidcService_1 = __webpack_require__(22285);
var monitoring = (0, withMonitoring_1.withMonitoring)("token");
/**
 * The Token service is used to retrieve JWT in order to use 6play's API.
 * @module Token
 * @tutorial ./doc/token.md
 */ var TokenService = /*#__PURE__*/ function(_fetcherService_1_FetcherService) {
    _inherits._(TokenService, _fetcherService_1_FetcherService);
    var _super = _create_super._(TokenService);
    function TokenService() {
        _class_call_check._(this, TokenService);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.persistentToken = null;
        _this.decodedPersistentToken = null;
        _this.retry = 0;
        _this.maxRetry = 0;
        _this.advertisingId = null;
        _this.apiType = "auth";
        _this.subscriptionList = null;
        return _this;
    }
    _create_class._(TokenService, [
        {
            /**
     * Initialize the service.
     * @param {Object} options options to customise headers passed to token service. maxRetry numeric option is to refetch token in case of failure
     * @tutorial ./doc/tokenInit.md
     */ key: "init",
            value: function init() {
                var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, advertisingId = _ref.advertisingId, _ref_maxRetry = _ref.maxRetry, maxRetry = _ref_maxRetry === void 0 ? 3 : _ref_maxRetry, _ref_retryCooldown = _ref.retryCooldown, retryCooldown = _ref_retryCooldown === void 0 ? 50 : _ref_retryCooldown, _ref_persistentToken = _ref.persistentToken, persistentToken = _ref_persistentToken === void 0 ? null : _ref_persistentToken, _ref_boxId = _ref.boxId, boxId = _ref_boxId === void 0 ? null : _ref_boxId, _ref_boxType = _ref.boxType, boxType = _ref_boxType === void 0 ? null : _ref_boxType, _ref_deviceModel = _ref.deviceModel, deviceModel = _ref_deviceModel === void 0 ? null : _ref_deviceModel, _ref_deviceName = _ref.deviceName, deviceName = _ref_deviceName === void 0 ? null : _ref_deviceName, _ref_deviceVersion = _ref.deviceVersion, deviceVersion = _ref_deviceVersion === void 0 ? null : _ref_deviceVersion, _ref_frontStateAppVersion = _ref.frontStateAppVersion, frontStateAppVersion = _ref_frontStateAppVersion === void 0 ? null : _ref_frontStateAppVersion, _ref_subscriptionList = _ref.subscriptionList, subscriptionList = _ref_subscriptionList === void 0 ? null : _ref_subscriptionList;
                if (!this.isInitialized) {
                    this.advertisingId = advertisingId;
                    this.maxRetry = maxRetry;
                    this.retryCooldown = retryCooldown;
                    this.basePath = "platforms/".concat(fido_1.fido.get("platformCode"));
                    this.isInitialized = true;
                    this.boxId = boxId;
                    this.boxType = boxType;
                    this.deviceModel = deviceModel;
                    this.deviceName = deviceName;
                    this.deviceVersion = deviceVersion;
                    this.frontStateAppVersion = frontStateAppVersion;
                    this.subscriptionList = subscriptionList;
                    this.setToken(persistentToken);
                }
            }
        },
        {
            /**
     * Set the advertisingId property.
     * @param {string} advertisingId
     */ key: "setAdvertisingId",
            value: function setAdvertisingId(advertisingId) {
                this.resetToken();
                this.advertisingId = advertisingId;
            }
        },
        {
            /**
     * Set the user property.
     *
     * @param {Object} user The Gigya user used to generate the JWT.
     */ key: "setUser",
            value: function setUser(user) {
                this.resetToken();
                this.user = user;
            }
        },
        {
            /**
     * Set the profile property. Token is also reset.
     *
     * @param {Object} profile The user profile used to generate the JWT.
     */ key: "setProfile",
            value: function setProfile(profile) {
                this.resetToken();
                this.profile = profile;
            }
        },
        {
            /**
     * Set the subscriptionList property. Token is also reset.
     *
     * @param {Array} subscriptionList array of channels code that are subscribed
     */ key: "setSubscriptionList",
            value: function setSubscriptionList(subscriptionList) {
                this.resetToken();
                this.subscriptionList = subscriptionList;
            }
        },
        {
            /**
     * Reset profile property. Token is also reset.
     */ key: "resetProfile",
            value: function resetProfile() {
                this.setProfile(null);
            }
        },
        {
            /**
     * Reset the JWT.
     */ key: "resetToken",
            value: function resetToken() {
                this.persistentToken = null;
                this.decodedPersistentToken = null;
            }
        },
        {
            /**
     * Set the persistentToken property. Token is also decoded and set in
     * decodedPersistentToken property
     *
     * @param {String} token The JWT to be used
     */ key: "setToken",
            value: function setToken(token) {
                this.persistentToken = token;
                this.decodedPersistentToken = null;
                if (token) {
                    try {
                        this.decodedPersistentToken = (0, jwt_decode_1.default)(token);
                    } catch (_a) {
                    // Don't fail if jwtDecode fails
                    }
                }
            }
        },
        {
            /**
     * Reset the JWT and the user property.
     */ key: "resetUserAndToken",
            value: function resetUserAndToken() {
                this.resetToken();
                this.user = null;
                this.profile = null;
            }
        },
        {
            key: "isTokenValid",
            value: function isTokenValid() {
                if (!this.decodedPersistentToken) {
                    return false;
                }
                return fido_1.fido.get("getCurrentTime")() < (this.decodedPersistentToken.exp - 10) * 1000;
            }
        },
        {
            key: "getToken",
            value: /**
     * Returns a valid JWT. If there is no current or valid JWT token, it gets a new one.
     * @returns {token} A valid JWT.
     * @async
     */ function getToken() {
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (_this.persistentToken) {
                                    if (_this.isTokenValid()) {
                                        return [
                                            2,
                                            _this.persistentToken
                                        ];
                                    }
                                    _this.resetToken();
                                }
                                if (!oidcService_1.oidcService.isInitialized) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.renewOidcToken()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 2:
                                return [
                                    4,
                                    _this.renewToken()
                                ];
                            case 3:
                                _state.sent();
                                _state.label = 4;
                            case 4:
                                return [
                                    2,
                                    _this.persistentToken
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getTokenInformation",
            value: function getTokenInformation() {
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.getToken()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2,
                                    _this.decodedPersistentToken
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
     * Gigya method to retrieve token
     * @returns {Promise<any>} a promise that store the token in the service
     */ key: "renewToken",
            value: function renewToken() {
                var _this = this;
                var url = this.getRouteUrl("getJwt");
                var path = this.getRoutePath("getJwt", true);
                var _this1 = this, advertisingId = _this1.advertisingId, boxType = _this1.boxType, boxId = _this1.boxId, deviceVersion = _this1.deviceVersion, deviceModel = _this1.deviceModel, deviceName = _this1.deviceName, frontStateAppVersion = _this1.frontStateAppVersion;
                var innerWidth = null;
                var innerHeight = null;
                if (typeof window !== "undefined") {
                    innerWidth = (0, get_1.default)(window, "innerWidth", null);
                    innerHeight = (0, get_1.default)(window, "innerHeight", null);
                }
                return (0, retryPromise_1.retryPromise)(function() {
                    return _this.fetch(url, {
                        method: "GET",
                        headers: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, boxId && {
                            "x-auth-box-id": boxId
                        }), boxType && {
                            "x-auth-box-type": boxType
                        }), advertisingId ? {
                            "x-auth-advertising-id": advertisingId
                        } : null), deviceVersion ? {
                            "x-auth-device-version": deviceVersion
                        } : null), deviceName ? {
                            "x-auth-device-name": deviceName
                        } : null), deviceModel ? {
                            "x-auth-device-model": deviceModel
                        } : null), frontStateAppVersion ? {
                            "x-auth-frontstate-app-version": frontStateAppVersion
                        } : null), innerWidth ? {
                            "x-auth-device-player-size-width": innerWidth
                        } : null), innerHeight ? {
                            "x-auth-device-player-size-height": innerHeight
                        } : null), _this.subscriptionList ? {
                            "x-external-subscription-access": _this.subscriptionList
                        } : null), (0, securityHeaderBuilder_1.getHeaders)({
                            path: path,
                            body: {}
                        }, {
                            user: _this.user,
                            profile: _this.profile
                        }))
                    });
                }, this.maxRetry, this.retryCooldown).then(function(param) {
                    var token = param.token;
                    _this.setToken(token);
                }).catch(function(error) {
                    throw new fetch_error_1.FetchError("tokenService:getJwt:fetch ".concat(error.status, " ").concat(error), null, error.response);
                });
            }
        },
        {
            key: "renewOidcToken",
            value: /**
     * OIDC method to retrieve token
     * @returns {Promise<any>} a promise that store the token in the service
     */ function renewOidcToken() {
                var _this = this;
                return _async_to_generator._(function() {
                    var routePath, routeUrl, url, accessToken, advertisingId, boxType, boxId, deviceVersion, deviceModel, deviceName, frontStateAppVersion, innerWidth, innerHeight;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                /*
         * TODO: find a way to avoid this replacement, it's just a temp workaround
         * We need to call this endpoint https://front-auth.staging.rtlde.bedrock.tech/v2/rtlde/platforms/smarttv/token
         * and this.getRouteUrl('token') returns https://front-auth.staging.rtlde.bedrock.tech/v2/platforms/smarttv/token
         */ routePath = _this.getRoutePath("token");
                                routeUrl = _this.getRouteUrl("token");
                                url = routeUrl.replace(routePath, "/".concat(fido_1.fido.get("customerCode")).concat(routePath));
                                return [
                                    4,
                                    oidcService_1.oidcService.getOrFetchOidcTokens()
                                ];
                            case 1:
                                accessToken = _state.sent().accessToken;
                                advertisingId = _this.advertisingId, boxType = _this.boxType, boxId = _this.boxId, deviceVersion = _this.deviceVersion, deviceModel = _this.deviceModel, deviceName = _this.deviceName, frontStateAppVersion = _this.frontStateAppVersion;
                                innerWidth = null;
                                innerHeight = null;
                                if (typeof window !== "undefined") {
                                    innerWidth = (0, get_1.default)(window, "innerWidth", null);
                                    innerHeight = (0, get_1.default)(window, "innerHeight", null);
                                }
                                return [
                                    2,
                                    (0, retryPromise_1.retryPromise)(function() {
                                        return _this.fetch(url, {
                                            method: "GET",
                                            headers: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, boxId ? {
                                                "x-auth-box-id": boxId
                                            } : null), boxType ? {
                                                "x-auth-box-type": boxType
                                            } : null), advertisingId ? {
                                                "x-auth-advertising-id": advertisingId
                                            } : null), deviceVersion ? {
                                                "x-auth-device-version": deviceVersion
                                            } : null), deviceName ? {
                                                "x-auth-device-name": deviceName
                                            } : null), deviceModel ? {
                                                "x-auth-device-model": deviceModel
                                            } : null), frontStateAppVersion ? {
                                                "x-auth-frontstate-app-version": frontStateAppVersion
                                            } : null), innerWidth ? {
                                                "x-auth-device-player-size-width": innerWidth
                                            } : null), innerHeight ? {
                                                "x-auth-device-player-size-height": innerHeight
                                            } : null), _this.subscriptionList ? {
                                                "x-external-subscription-access": _this.subscriptionList
                                            } : null), {
                                                Authorization: "Bearer ".concat(accessToken)
                                            }), (0, securityHeaderBuilder_1.getHeaders)({
                                                body: {}
                                            }, {
                                                user: _this.user,
                                                profile: _this.profile
                                            }))
                                        });
                                    }, _this.maxRetry).then(function(param) {
                                        var token = param.token;
                                        _this.setToken(token);
                                    }).catch(function(error) {
                                        throw new fetch_error_1.FetchError("tokenService:token:fetch ".concat(error.status, " ").concat(error), null, error.response);
                                    })
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return TokenService;
}(fetcherService_1.FetcherService);
__decorate([
    caching_1.withNoParallelRequest,
    monitoring
], TokenService.prototype, "renewToken", null);
__decorate([
    caching_1.withNoParallelRequest,
    monitoring
], TokenService.prototype, "renewOidcToken", null);
exports.tokenService = new TokenService();


/***/ }),

/***/ 15868:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(42578);
var __decorate = (void 0) && (void 0).__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (void 0) && (void 0).__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.boxDataService = exports.BoxDataService = void 0;
var isObject_1 = __importDefault(__webpack_require__(36838));
var fido_1 = __webpack_require__(6446);
var securityHeaderBuilder_1 = __webpack_require__(89222);
var fetcherService_1 = __webpack_require__(97269);
var withMonitoring_1 = __webpack_require__(89873);
var monitoring = (0, withMonitoring_1.withMonitoring)("boxData");
function formatValue(value) {
    if ((0, isObject_1.default)(value)) {
        return JSON.stringify(value);
    }
    return "".concat(value);
}
function parseValue(value) {
    try {
        return JSON.parse(value);
    } catch (_a) {
        return value;
    }
}
/**
 * @module BoxDataService
 * @description The BoxData API is a very basic key/value remote storage mainly useful when storing data locally is not allowed by the platform
 * @tutorial ./doc/boxDataService.md
 */ var BoxDataService = /*#__PURE__*/ function(_fetcherService_1_FetcherService) {
    _inherits._(BoxDataService, _fetcherService_1_FetcherService);
    var _super = _create_super._(BoxDataService);
    function BoxDataService() {
        _class_call_check._(this, BoxDataService);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.apiType = "userv2";
        return _this;
    }
    _create_class._(BoxDataService, [
        {
            /**
     * Initialize the service.
     *
     * @tutorial ./doc/boxDataServiceInit.md
     */ key: "init",
            value: function init() {
                var boxType = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).boxType;
                if (!this.isInitialized) {
                    this.isInitialized = true;
                    this.basePath = "platforms/".concat(fido_1.fido.get("platformCode"), "/boxTypes/").concat(boxType, "/boxIds/").concat(this.getHomeOrDeviceId());
                    this.boxType = boxType;
                }
            }
        },
        {
            /**
     * Fetch all keys
     *
     * @async
     * @returns {Object[]}
     * @tutorial ./doc/boxDataServiceFetchKeys.md
     */ key: "fetchKeys",
            value: function fetchKeys() {
                var url = this.getRouteUrl("keys");
                var path = this.getRoutePath("keys", true);
                return this.fetch(url, {
                    method: "GET",
                    headers: (0, securityHeaderBuilder_1.getTimestampHeader)(path, {}, fido_1.fido.get("getCurrentTime")(), fido_1.fido.get("saltAndSugar"))
                }).then(function(data) {
                    if (!data || data.length <= 0) {
                        return [];
                    }
                    return data.map(function(item) {
                        return Object.assign(Object.assign({}, item), {
                            value: parseValue(item.value)
                        });
                    });
                });
            }
        },
        {
            /**
     * Fetch a specific key
     *
     * @async
     * @param {string} key Key's name
     * @returns {Object}
     * @tutorial ./doc/boxDataServiceFetchKey.md
     */ key: "fetchKey",
            value: function fetchKey(key) {
                var endpoint = "keys/".concat(key);
                var url = this.getRouteUrl(endpoint);
                var path = this.getRoutePath(endpoint, true);
                return this.fetch(url, {
                    method: "GET",
                    headers: (0, securityHeaderBuilder_1.getTimestampHeader)(path, {}, fido_1.fido.get("getCurrentTime")(), fido_1.fido.get("saltAndSugar"))
                }).then(function(item) {
                    return Object.assign(Object.assign({}, item), {
                        value: parseValue(item.value)
                    });
                });
            }
        },
        {
            /**
     * Add a new key
     *
     * @async
     * @param {string} key Key's name
     * @param {string|number|bool|object} key Key's value
     * @returns {Object}
     * @tutorial ./doc/boxDataServiceSaveKey.md
     */ key: "saveKey",
            value: function saveKey(key, value) {
                var url = this.getRouteUrl("keys");
                var path = this.getRoutePath("keys", true);
                var body = {
                    key: key,
                    value: formatValue(value)
                };
                return this.fetch(url, {
                    method: "POST",
                    body: body,
                    headers: (0, securityHeaderBuilder_1.getTimestampHeader)(path, body, fido_1.fido.get("getCurrentTime")(), fido_1.fido.get("saltAndSugar"))
                });
            }
        },
        {
            /**
     * Delete a key
     *
     * @async
     * @param {string} key Key's name
     * @returns {Object}
     * @tutorial ./doc/boxDataServiceDeleteKey.md
     */ key: "deleteKey",
            value: function deleteKey(key) {
                var endpoint = "keys/".concat(key);
                var url = this.getRouteUrl(endpoint);
                var path = this.getRoutePath(endpoint, true);
                return this.fetch(url, {
                    method: "DELETE",
                    headers: (0, securityHeaderBuilder_1.getTimestampHeader)(path, {}, fido_1.fido.get("getCurrentTime")(), fido_1.fido.get("saltAndSugar"))
                });
            }
        }
    ]);
    return BoxDataService;
}(fetcherService_1.FetcherService);
exports.BoxDataService = BoxDataService;
__decorate([
    monitoring
], BoxDataService.prototype, "fetchKeys", null);
__decorate([
    monitoring
], BoxDataService.prototype, "fetchKey", null);
__decorate([
    monitoring
], BoxDataService.prototype, "saveKey", null);
__decorate([
    monitoring
], BoxDataService.prototype, "deleteKey", null);
exports.boxDataService = new BoxDataService();


/***/ }),

/***/ 48339:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(42578);
var __decorate = (void 0) && (void 0).__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.broadcastliveService = void 0;
var fido_1 = __webpack_require__(6446);
var withJWT_1 = __webpack_require__(62782);
var fetcherService_1 = __webpack_require__(97269);
var withMonitoring_1 = __webpack_require__(89873);
var monitoring = (0, withMonitoring_1.withMonitoring)("broadcastlive");
/**
 * @module BroadcastLive
 * @augments FetcherService
 * @description This service is used to get live current broadcast program with preroll info.
 * @tutorial ./doc/broadcastlive.md
 */ var BroadcastLiveService = /*#__PURE__*/ function(_fetcherService_1_FetcherService) {
    _inherits._(BroadcastLiveService, _fetcherService_1_FetcherService);
    var _super = _create_super._(BroadcastLiveService);
    function BroadcastLiveService() {
        _class_call_check._(this, BroadcastLiveService);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.apiType = "middlewarev2";
        return _this;
    }
    _create_class._(BroadcastLiveService, [
        {
            /**
     * Initialize the service. If you don't call this method, no other method can be called.
     *
     * @tutorial ./doc/broadcastliveInit.md
     */ key: "init",
            value: function init() {
                if (!this.isInitialized) {
                    this.basePath = "platforms/".concat(fido_1.fido.get("platformCode"), "/services");
                    this.isInitialized = true;
                }
            }
        },
        {
            key: "fetchLiveProgram",
            value: /**
     * Get live current broadcast program with preroll info.
     *
     * @async
     * @param {Object} options Options passed to liveProgram serviceCode, channel, clientCode or headers
     * @returns {Object} Information about the live program
     * @tutorial ./doc/broadcastliveFetchLiveProgram.md
     */ function fetchLiveProgram(param) {
                var serviceCode = param.serviceCode, channel = param.channel, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers, clientCode = param.clientCode;
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        if (!channel) {
                            throw new Error("You should provide a non null channel string");
                        }
                        return [
                            2,
                            _this.fetch(_this.getRouteUrl("".concat(serviceCode, "/channels/").concat(channel, "/broadcasts/live"), clientCode), {
                                method: "GET",
                                headers: headers
                            })
                        ];
                    });
                })();
            }
        }
    ]);
    return BroadcastLiveService;
}(fetcherService_1.FetcherService);
__decorate([
    withJWT_1.withJWT,
    monitoring
], BroadcastLiveService.prototype, "fetchLiveProgram", null);
exports.broadcastliveService = new BroadcastLiveService();


/***/ }),

/***/ 12267:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(45538);
var __decorate = (void 0) && (void 0).__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.creditsService = void 0;
var withJWT_1 = __webpack_require__(62782);
var fetcherService_1 = __webpack_require__(97269);
var withMonitoring_1 = __webpack_require__(89873);
var monitoring = (0, withMonitoring_1.withMonitoring)("credits");
/**
 * @module Credits
 * @description Manage credit operations and balances
 * @tutorial ./doc/credits.md
 */ var CreditsService = /*#__PURE__*/ function(_fetcherService_1_FetcherService) {
    _inherits._(CreditsService, _fetcherService_1_FetcherService);
    var _super = _create_super._(CreditsService);
    function CreditsService() {
        _class_call_check._(this, CreditsService);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.apiType = "credits";
        return _this;
    }
    _create_class._(CreditsService, [
        {
            key: "init",
            value: function init() {
                if (!this.isInitialized) {
                    this.isInitialized = true;
                }
            }
        },
        {
            key: "fetchBalance",
            value: /**
     * Retrieves the credit balance for a specified user account
     *
     * @async
     * @param {Object} options - The options object
     * @param {string} options.userUid - The unique identifier of the user
     * @param {Object} [options.headers={}] - Additional HTTP headers to include in the request
     * @returns {Promise<number>} A promise that resolves to the user's available credit amount
     * @throws {Error} Throws an error if userUid is not provided
     */ function fetchBalance(param) {
                var userUid = param.userUid, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                var _this = this;
                return _async_to_generator._(function() {
                    var response;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!userUid) {
                                    throw new Error("You should provide a user uid");
                                }
                                return [
                                    4,
                                    _this.fetch(_this.getRouteUrl("".concat(userUid, "/balance")), {
                                        method: "GET",
                                        headers: headers
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                return [
                                    2,
                                    response.available_credit
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "redeemProduct",
            value: /**
     * Redeems a product using the user's available credits
     *
     * @async
     * @param {Object} options - The options object
     * @param {string} options.userUid - The unique identifier of the user
     * @param {string} options.productId - The identifier of the product to redeem
     * @param {Object} [options.headers={}] - Additional HTTP headers to include in the request
     * @returns {Promise<string>} A promise that resolves to "OK" when redemption is successful
     * @throws {Error} Throws an error if userUid or productId is missing
     */ function redeemProduct() {
                var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, userUid = _ref.userUid, productId = _ref.productId, _ref_headers = _ref.headers, headers = _ref_headers === void 0 ? {} : _ref_headers;
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        if (!userUid || !productId) {
                            throw new Error("You should provide a user uid and product id");
                        }
                        return [
                            2,
                            _this.fetch(_this.getRouteUrl("".concat(userUid, "/redeem")), {
                                method: "PUT",
                                body: {
                                    permission_id: productId
                                },
                                headers: headers
                            })
                        ];
                    });
                })();
            }
        }
    ]);
    return CreditsService;
}(fetcherService_1.FetcherService);
__decorate([
    withJWT_1.withJWT,
    monitoring
], CreditsService.prototype, "fetchBalance", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], CreditsService.prototype, "redeemProduct", null);
exports.creditsService = new CreditsService();


/***/ }),

/***/ 97269:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(3009);
var __decorate = (void 0) && (void 0).__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.FetcherService = void 0;
var fido_1 = __webpack_require__(6446);
var fetch_1 = __webpack_require__(4906);
var withCustomerHeader_1 = __webpack_require__(44558);
var withRequestTimeoutHeader_1 = __webpack_require__(28882);
var withVersionHeader_1 = __webpack_require__(10474);
var FetcherService = /*#__PURE__*/ function() {
    function FetcherService() {
        _class_call_check._(this, FetcherService);
        this.isInitialized = false;
        this.basePath = "";
        this.apiType = "";
        this.displayName = "";
    }
    _create_class._(FetcherService, [
        {
            key: "init",
            value: function init() {
                throw new Error("You should implement the init function of Fido's ".concat(this.getName()));
            }
        },
        {
            key: "externalFetch",
            value: /**
     * Fetch data from an external URL without adding custom headers and versions headers
     * @param {string} url to call
     * @param {Object} options (method, headers, body, etc.)
     * @returns {Promise<Object>}
     */ function externalFetch(url, options) {
                return _async_to_generator._(function() {
                    var body;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, fetch_1.fetch)(url, options)
                                ];
                            case 1:
                                body = _state.sent().body;
                                return [
                                    2,
                                    body
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "fetch",
            value: function fetch(url, options) {
                var _this = this;
                return _async_to_generator._(function() {
                    var body;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.fetchWithResponse(url, options)
                                ];
                            case 1:
                                body = _state.sent().body;
                                return [
                                    2,
                                    body
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "fetchWithoutVersionHeaders",
            value: function fetchWithoutVersionHeaders(url, options) {
                return _async_to_generator._(function() {
                    var body;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, fetch_1.fetch)(url, options)
                                ];
                            case 1:
                                body = _state.sent().body;
                                return [
                                    2,
                                    body
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "fetchWithResponse",
            value: function fetchWithResponse(url, options) {
                return (0, fetch_1.fetch)(url, options);
            }
        },
        {
            key: "fetchWithStatus",
            value: function fetchWithStatus(url, options) {
                return _async_to_generator._(function() {
                    var status, error, response;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    (0, fetch_1.fetch)(url, options)
                                ];
                            case 1:
                                status = _state.sent().status;
                                return [
                                    2,
                                    status
                                ];
                            case 2:
                                error = _state.sent();
                                response = error.response;
                                if (response) {
                                    return [
                                        2,
                                        response.status
                                    ];
                                }
                                return [
                                    2,
                                    0
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getName",
            value: function getName() {
                return this.displayName || this.constructor.name;
            }
        },
        {
            key: "getRoutePath",
            value: function getRoutePath(endpoint) {
                var withVersion = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var path = "/".concat(this.basePath ? "".concat(this.basePath, "/") : "").concat(endpoint);
                if (withVersion) {
                    var baseUrl = fido_1.fido.getBaseUrl(this.apiType);
                    var matches = baseUrl.match(/\/(v[0-9])$/);
                    if (matches) {
                        return "/".concat(matches[1]).concat(path);
                    }
                }
                return path;
            }
        },
        {
            key: "getRouteUrl",
            value: function getRouteUrl() {
                var endpoint = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", clientCode = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : fido_1.fido.get("clientCode"), platformCode = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : fido_1.fido.get("platformCode");
                this.checkInit();
                if (!this.apiType) {
                    throw new Error("You should define an API type for Fido's ".concat(this.getName()));
                }
                return "".concat(fido_1.fido.getBaseUrl(this.apiType).replace("%(clientCode)s", clientCode)).concat(this.getRoutePath(endpoint).replace("%(platformCode)s", platformCode));
            }
        },
        {
            key: "getHomeOrDeviceId",
            value: function getHomeOrDeviceId() {
                var prefixedId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                this.checkInit();
                var deviceId = fido_1.fido.get("localDeviceId");
                var homeId = fido_1.fido.get("localHomeId");
                if (homeId) {
                    return prefixedId ? "homeid-".concat(homeId) : "".concat(homeId);
                }
                return prefixedId ? "deviceid-".concat(deviceId) : "".concat(deviceId);
            }
        },
        {
            key: "checkInit",
            value: function checkInit(apiType) {
                if (!this.isInitialized) {
                    throw new Error("You should init Fido's ".concat(this.getName(), " before using it"));
                }
                if (!fido_1.fido.getBaseUrl(apiType || this.apiType)) {
                    throw new Error("You should set baseUrl for ".concat(this.getName(), " before using it"));
                }
            }
        }
    ]);
    return FetcherService;
}();
exports.FetcherService = FetcherService;
__decorate([
    (0, withVersionHeader_1.withVersionHeader)(1),
    (0, withCustomerHeader_1.withCustomerHeader)(1),
    (0, withRequestTimeoutHeader_1.withRequestTimeoutHeader)(1)
], FetcherService.prototype, "fetch", null);
__decorate([
    (0, withCustomerHeader_1.withCustomerHeader)(1),
    (0, withRequestTimeoutHeader_1.withRequestTimeoutHeader)(1)
], FetcherService.prototype, "fetchWithoutVersionHeaders", null);
__decorate([
    (0, withVersionHeader_1.withVersionHeader)(1),
    (0, withCustomerHeader_1.withCustomerHeader)(1),
    (0, withRequestTimeoutHeader_1.withRequestTimeoutHeader)(1)
], FetcherService.prototype, "fetchWithResponse", null);
__decorate([
    (0, withVersionHeader_1.withVersionHeader)(1),
    (0, withCustomerHeader_1.withCustomerHeader)(1),
    (0, withRequestTimeoutHeader_1.withRequestTimeoutHeader)(1)
], FetcherService.prototype, "fetchWithStatus", null);


/***/ }),

/***/ 29093:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
var __decorate = (void 0) && (void 0).__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.foldersService = void 0;
var fido_1 = __webpack_require__(6446);
var fetcherService_1 = __webpack_require__(97269);
var withMonitoring_1 = __webpack_require__(89873);
var monitoring = (0, withMonitoring_1.withMonitoring)("folders");
/**
 * @module Folders
 * @description This service is used to get folder list from middleware API
 */ var FoldersService = /*#__PURE__*/ function(_fetcherService_1_FetcherService) {
    _inherits._(FoldersService, _fetcherService_1_FetcherService);
    var _super = _create_super._(FoldersService);
    function FoldersService() {
        _class_call_check._(this, FoldersService);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.apiType = "middlewarev2";
        return _this;
    }
    _create_class._(FoldersService, [
        {
            /**
     * Initialize the service. If you don't call this method, no other method can be called.
     */ key: "init",
            value: function init() {
                if (!this.isInitialized) {
                    this.basePath = "platforms/".concat(fido_1.fido.get("platformCode"), "/services");
                    this.isInitialized = true;
                }
            }
        },
        {
            key: "fetchFolders",
            value: /**
     * Get a list of folders
     *
     * @async
     * @param {Object} options Options for fetching folders.
     * @param {string} options.serviceCode Service where the information should be retrieved from.
     * @param {number} options.offset Starting item for pagination.
     * @param {number} options.limit Maximum number of items to return for pagination.
     * @param {Object} [options.headers={}] Optional HTTP headers.
     * @returns {Promise<Array>} Returns a paginated array of folders, can be empty.
     * @throws {Error} Throws an error if serviceCode is not provided.
     * @throws {Error} Throws an error if offset is not a valid number.
     * @throws {Error} Throws an error if limit is not a valid number.
     */ function fetchFolders(param) {
                var serviceCode = param.serviceCode, offset = param.offset, limit = param.limit, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!serviceCode) {
                                    throw new Error("You should provide a service code");
                                }
                                if (typeof offset !== "number" || isNaN(offset)) {
                                    throw new Error("You should provide a valid numeric offset");
                                }
                                if (typeof limit !== "number" || isNaN(limit)) {
                                    throw new Error("You should provide a valid numeric limit");
                                }
                                return [
                                    4,
                                    _this.fetch(_this.getRouteUrl("".concat(serviceCode, "/folders?limit=").concat(limit, "&offset=").concat(offset)), {
                                        method: "GET",
                                        headers: headers
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return FoldersService;
}(fetcherService_1.FetcherService);
__decorate([
    monitoring
], FoldersService.prototype, "fetchFolders", null);
exports.foldersService = new FoldersService();


/***/ }),

/***/ 87444:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(65759);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.couponStatus = void 0;
exports.couponStatus = {
    VALID: "VALID",
    ALREADY_USED: "ALREADY_USED",
    INVALID: "INVALID"
};


/***/ }),

/***/ 88247:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(3009);
var __decorate = (void 0) && (void 0).__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (void 0) && (void 0).__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.freemiumService = exports.FreemiumService = void 0;
var get_1 = __importDefault(__webpack_require__(65439));
var fido_1 = __webpack_require__(6446);
var caching_1 = __webpack_require__(48832);
var securityHeaderBuilder_1 = __webpack_require__(89222);
var withJWT_1 = __webpack_require__(62782);
var fetcherService_1 = __webpack_require__(97269);
var withMonitoring_1 = __webpack_require__(89873);
var freemium_constants_1 = __webpack_require__(87444);
var monitoring = (0, withMonitoring_1.withMonitoring)("freemium");
/**
 * @module Freemium
 * @description The Freemium service is used for freemium in 6play app
 * @tutorial ./doc/freemium.md
 * @deprecated use PremiumService instead
 */ var FreemiumService = /*#__PURE__*/ function(_fetcherService_1_FetcherService) {
    _inherits._(FreemiumService, _fetcherService_1_FetcherService);
    var _super = _create_super._(FreemiumService);
    function FreemiumService() {
        _class_call_check._(this, FreemiumService);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.apiType = "coupons";
        return _this;
    }
    _create_class._(FreemiumService, [
        {
            /**
     * Initialize the service. If you don't call this method, no other method can be called.
     *
     * @tutorial ./doc/freemiumInit.md
     * @deprecated
     */ key: "init",
            value: function init() {
                if (!this.isInitialized) {
                    this.isInitialized = true;
                }
            }
        },
        {
            key: "getUserSubscriptions",
            value: /**
     * Get the user's freemium subscriptions
     * @async
     *
     * @param {Object} options Object containing the user whose subscriptions are requested
     * @returns {Object}
     * @deprecated Use PremiumService.getUserSubscriptions instead
     */ function getUserSubscriptions(param) {
                var user = param.user, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                var _this = this;
                return _async_to_generator._(function() {
                    var apiURL;
                    return _ts_generator._(this, function(_state) {
                        _this.checkInit("userv2");
                        if (!user.UID) {
                            throw new Error("You should provide a non null uid");
                        }
                        apiURL = "".concat(fido_1.fido.getBaseUrl("userv2"), "/platforms/").concat(fido_1.fido.get("platformCode"), "/users/").concat(user.UID, "/freemiumsubscriptions");
                        return [
                            2,
                            _this.fetch(apiURL, {
                                method: "GET",
                                headers: headers
                            })
                        ];
                    });
                })();
            }
        },
        {
            /**
     * @deprecated
     */ key: "validateSubscriptionWithReceipt",
            value: function validateSubscriptionWithReceipt(receipt, user, param) {
                var _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                this.checkInit("userv2");
                var receiptCheckURL = "".concat(fido_1.fido.getBaseUrl("userv2"), "/platforms/").concat(fido_1.fido.get("platformCode"), "/users/").concat(user.UID, "/stores/bedrock-freecoupons/receiptCheck");
                return this.fetch(receiptCheckURL, {
                    method: "POST",
                    headers: headers,
                    body: {
                        receiptData: receipt.data
                    }
                });
            }
        },
        {
            key: "verifyCoupon",
            value: /**
     * Verify if a couponCode is valid and return the offer id associated to it
     * or throw if it is invalid
     * @async
     *
     * @param {Object} options Contains the couponCode to verify and the
     * headers to transmit during the ajax request
     * @returns {Object} The offer
     * @tutorial ./doc/verifyCoupon.md
     * @deprecated use PremiumService.verifyCoupon instead
     */ function verifyCoupon() {
                var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, couponCode = _ref.couponCode, user = _ref.user;
                var _this = this;
                return _async_to_generator._(function() {
                    var couponVerificationURL, userHeaders, receipt, e, status, result;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.checkInit();
                                if (!couponCode) {
                                    throw new Error("You should provide a non null couponCode");
                                }
                                if (!user.UID) {
                                    throw new Error("You should provide a non null uid");
                                }
                                couponVerificationURL = "".concat(fido_1.fido.getBaseUrl("coupons"), "/platforms/").concat(fido_1.fido.get("platformCode"), "/users/").concat(user.UID, "/coupons");
                                userHeaders = (0, securityHeaderBuilder_1.getGigyaUserHeader)(user);
                                receipt = null;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    _this.fetch(couponVerificationURL, {
                                        method: "POST",
                                        headers: userHeaders,
                                        body: {
                                            code: couponCode
                                        }
                                    })
                                ];
                            case 2:
                                receipt = _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                e = _state.sent();
                                status = e.status;
                                return [
                                    2,
                                    {
                                        status: status === 400 ? freemium_constants_1.couponStatus.ALREADY_USED : freemium_constants_1.couponStatus.INVALID
                                    }
                                ];
                            case 4:
                                return [
                                    4,
                                    _this.validateSubscriptionWithReceipt(receipt, user, {
                                        headers: userHeaders
                                    }).catch(function() {
                                        return null;
                                    })
                                ];
                            case 5:
                                result = _state.sent();
                                return [
                                    2,
                                    {
                                        status: freemium_constants_1.couponStatus.VALID,
                                        subscribedPlanCode: (0, get_1.default)(result, "subscribed_pack.code", null)
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getOffers",
            value: /**
     * Get the freemium Offer list
     * @async
     * @deprecated use Premium.getOffers instead
     */ function getOffers() {
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        _this.checkInit();
                        return [
                            2,
                            _this.fetch("https://static.6cloud.fr/m6group_web/6play/".concat(fido_1.fido.get("customerCode"), "/subscription/plans.json"))
                        ];
                    });
                })();
            }
        },
        {
            key: "getOffersFromLocalServer",
            value: // WARNING: Test method while there is no middleware route to make the job for us
            function getOffersFromLocalServer() {
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        _this.checkInit();
                        return [
                            2,
                            _this.fetch("".concat(window.location.origin, "/get-offers"))
                        ];
                    });
                })();
            }
        }
    ]);
    return FreemiumService;
}(fetcherService_1.FetcherService);
exports.FreemiumService = FreemiumService;
__decorate([
    withJWT_1.withJWT,
    caching_1.withNoParallelRequest,
    monitoring
], FreemiumService.prototype, "getUserSubscriptions", null);
__decorate([
    monitoring
], FreemiumService.prototype, "validateSubscriptionWithReceipt", null);
__decorate([
    monitoring
], FreemiumService.prototype, "verifyCoupon", null);
__decorate([
    monitoring
], FreemiumService.prototype, "getOffers", null);
exports.freemiumService = new FreemiumService();


/***/ }),

/***/ 3692:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(45538);
var __decorate = (void 0) && (void 0).__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.qualifioService = exports.QualifioService = void 0;
var fetcherService_1 = __webpack_require__(97269);
var withMonitoring_1 = __webpack_require__(89873);
var monitoring = (0, withMonitoring_1.withMonitoring)("qualifio");
/**
 * @module Qualifio
 * @description The Qualifio service is used to get data from Qualifio
 * @tutorial ./doc/qualifio.md
 */ var QualifioService = /*#__PURE__*/ function(_fetcherService_1_FetcherService) {
    _inherits._(QualifioService, _fetcherService_1_FetcherService);
    var _super = _create_super._(QualifioService);
    function QualifioService() {
        _class_call_check._(this, QualifioService);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.apiType = "qualifio";
        return _this;
    }
    _create_class._(QualifioService, [
        {
            /**
     * Initialize the service. If you don't call this method, no other method can be called.
     * @tutorial ./doc/qualifioInit.md
     */ key: "init",
            value: function init() {
                if (!this.isInitialized) {
                    this.isInitialized = true;
                }
            }
        },
        {
            /**
     * Get the data from Qualifio API.
     *
     * @async
     * @param {Object} options parameters (campaignKey, clientId, headers)
     * @returns {Object} The JSON feed
     * @tutorial ./doc/fetchQualifioContests.md
     */ key: "fetchQualifioContests",
            value: function fetchQualifioContests(param) {
                var campaignKey = param.campaignKey, clientId = param.clientId, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                if (!campaignKey || !clientId) {
                    throw new Error("You should provide a campaign key and a client id");
                }
                var endpoint = "campaignfeed/channels/".concat(campaignKey, "/json?clientId=").concat(clientId);
                var route = this.getRouteUrl(endpoint);
                return this.fetch(route, {
                    method: "GET",
                    headers: headers
                });
            }
        }
    ]);
    return QualifioService;
}(fetcherService_1.FetcherService);
exports.QualifioService = QualifioService;
__decorate([
    monitoring
], QualifioService.prototype, "fetchQualifioContests", null);
exports.qualifioService = new QualifioService();


/***/ }),

/***/ 45112:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _get = __webpack_require__(60528);
var _get_prototype_of = __webpack_require__(35196);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(45538);
var __decorate = (void 0) && (void 0).__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.geoService = void 0;
var withDeviceHeaders_1 = __webpack_require__(83809);
var simpleFetcherService_1 = __webpack_require__(43889);
/**
 * @module Geo
 * @augments SimpleFetcherService
 * @description The Geo service is used to retrieve the geolocation data from the client.
 * @tutorial ./doc/geo.md
 */ var GeoService = /*#__PURE__*/ function(_simpleFetcherService_1_SimpleFetcherService) {
    _inherits._(GeoService, _simpleFetcherService_1_SimpleFetcherService);
    var _super = _create_super._(GeoService);
    function GeoService() {
        _class_call_check._(this, GeoService);
        return _super.apply(this, arguments);
    }
    _create_class._(GeoService, [
        {
            key: "fetch",
            value: function fetch(options) {
                return _get._(_get_prototype_of._(GeoService.prototype), "fetch", this).call(this, options);
            }
        }
    ]);
    return GeoService;
}(simpleFetcherService_1.SimpleFetcherService);
__decorate([
    withDeviceHeaders_1.withDeviceHeaders
], GeoService.prototype, "fetch", null);
exports.geoService = new GeoService("geo", "geoInfo");


/***/ }),

/***/ 35426:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(42578);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.getUserConfiguration = exports.isLiveSession = void 0;
var fido_1 = __webpack_require__(6446);
var isLiveSession = function(clipType) {
    try {
        return [
            "live",
            "startover"
        ].includes(clipType);
    } catch (_a) {
        throw new Error("Something is wrong with the clipType");
    }
};
exports.isLiveSession = isLiveSession;
var getUserConfiguration = function(user) {
    if (user && user.UID) {
        return {
            uid: user.UID,
            uidType: "gigya"
        };
    }
    return {
        uid: fido_1.fido.get("localDeviceId"),
        uidType: "deviceid"
    };
};
exports.getUserConfiguration = getUserConfiguration;


/***/ }),

/***/ 95029:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(45538);
var __decorate = (void 0) && (void 0).__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.heartbeatService = void 0;
var fido_1 = __webpack_require__(6446);
var syncFetch_1 = __webpack_require__(2884);
var withJWT_1 = __webpack_require__(62782);
var tokenService_1 = __webpack_require__(9216);
var fetcherService_1 = __webpack_require__(97269);
var withMonitoring_1 = __webpack_require__(89873);
var heartbeat_utils_1 = __webpack_require__(35426);
var monitoring = (0, withMonitoring_1.withMonitoring)("heartbeat");
/**
 * @module Heartbeat
 * @description The Heartbeat service is used to monitor the user's video consumption.
 * @tutorial ./doc/heartbeat.md
 */ var HeartbeatService = /*#__PURE__*/ function(_fetcherService_1_FetcherService) {
    _inherits._(HeartbeatService, _fetcherService_1_FetcherService);
    var _super = _create_super._(HeartbeatService);
    function HeartbeatService() {
        _class_call_check._(this, HeartbeatService);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.apiType = "heartbeatv2";
        return _this;
    }
    _create_class._(HeartbeatService, [
        {
            /**
     * Initialize the service. If you don't call this method, no other method can be called.
     *
     * @tutorial ./doc/heartbeatInit.md
     */ key: "init",
            value: function init() {
                if (!this.isInitialized) {
                    this.isInitialized = true;
                    this.basePath = "platforms/".concat(fido_1.fido.get("platformCode"), "/notify");
                    this.platformCode = fido_1.fido.get("platformCode");
                    this.monitoring = monitoring;
                }
            }
        },
        {
            /**
     * Start Heartbeat session for a given program/clip.
     *
     * @async
     * @param {Object} options like { sessionData, user, headers } where sessionData as described in [docs](https://integrateur-6play.m6web.fr/v2/doc_users-resume-video.html), user A Gigya user => `{ UID, UIDSignature, signatureTimestamp }`, headers of the request.
     * @returns {Promise} Resolving as an object with sessionId and sendView as properties.
     * @tutorial ./doc/heartbeatSession.md
     */ key: "createSession",
            value: function createSession() {
                var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_sessionData = _ref.sessionData, sessionData = _ref_sessionData === void 0 ? null : _ref_sessionData, _ref_user = _ref.user, user = _ref_user === void 0 ? null : _ref_user, _ref_headers = _ref.headers, headers = _ref_headers === void 0 ? {} : _ref_headers;
                var _this = this;
                if (!sessionData || !sessionData.clipType) {
                    throw new Error("You should provide a non null sessionData");
                }
                var isLive = (0, heartbeat_utils_1.isLiveSession)(sessionData.clipType);
                var endpoint = "session".concat(isLive ? "_live" : "");
                var url = this.getRouteUrl(endpoint);
                var body = Object.assign(Object.assign({
                    platformCode: this.platformCode
                }, (0, heartbeat_utils_1.getUserConfiguration)(user)), sessionData);
                return this.fetch(url, {
                    method: "POST",
                    body: body,
                    headers: headers
                }).then(function(param) {
                    var sessionId = param.sessionId;
                    return {
                        sessionId: sessionId,
                        sendView: _this.sendView({
                            user: user,
                            isLive: isLive,
                            sessionId: sessionId
                        })
                    };
                });
            }
        },
        {
            /**
     * Send view data to Heartbeat for a given session;
     *
     * @async
     * @param {Object} options like { user, isLive, sessionId, headers } user A Gigya user => `{ UID, UIDSignature, signatureTimestamp }`, isLive Whether the session is live, sessionId  The id for this heartbeat session, headers of the request.
     * @returns {Function} That triggers the http call to heartbeat view API.
     * @tutorial ./doc/heartbeatSendView.md
     */ key: "sendView",
            value: function sendView() {
                var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_user = _ref.user, user = _ref_user === void 0 ? null : _ref_user, _ref_isLive = _ref.isLive, isLive = _ref_isLive === void 0 ? false : _ref_isLive, _ref_sessionId = _ref.sessionId, sessionId = _ref_sessionId === void 0 ? null : _ref_sessionId;
                if (typeof isLive !== "boolean" || !sessionId) {
                    throw new Error("Something went wrong during the session creation");
                }
                var _this = this;
                return function() {
                    var _ref = _async_to_generator._(function(viewData) {
                        var isSync, endpoint, url, body, token, headers, urlWithHeaders, formData;
                        var _arguments = arguments;
                        return _ts_generator._(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    isSync = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : false;
                                    if (!viewData) {
                                        throw new Error("You should provide a non null viewData");
                                    }
                                    endpoint = "view".concat(isLive ? "_live" : "");
                                    url = _this.getRouteUrl(endpoint);
                                    body = Object.assign(Object.assign(Object.assign({
                                        platformCode: _this.platformCode
                                    }, (0, heartbeat_utils_1.getUserConfiguration)(user)), viewData), {
                                        sessionId: sessionId
                                    });
                                    return [
                                        4,
                                        tokenService_1.tokenService.getToken()
                                    ];
                                case 1:
                                    token = _state.sent();
                                    headers = {
                                        Authorization: "Bearer ".concat(token)
                                    };
                                    if (isSync) {
                                        if (navigator.sendBeacon && window.FormData && typeof window.URL === "function") {
                                            urlWithHeaders = new URL(url);
                                            urlWithHeaders.searchParams.append("authorization", token);
                                            urlWithHeaders.searchParams.append("customerName", fido_1.fido.get("customerCode"));
                                            urlWithHeaders.searchParams.append("clientRelease", fido_1.fido.get("appVersion"));
                                            formData = new FormData();
                                            Object.keys(body).forEach(function(key) {
                                                return formData.append(key, body[key]);
                                            });
                                            return [
                                                2,
                                                navigator.sendBeacon(urlWithHeaders.href, formData)
                                            ];
                                        }
                                        return [
                                            2,
                                            (0, syncFetch_1.fetchSync)(url, body, headers)
                                        ];
                                    }
                                    return [
                                        2,
                                        _this.monitoring(HeartbeatService.prototype, "sendView", {
                                            value: function() {
                                                return _this.fetch(url, {
                                                    method: "POST",
                                                    body: body,
                                                    headers: headers
                                                });
                                            }
                                        }).value()
                                    ];
                            }
                        });
                    });
                    return function(viewData) {
                        return _ref.apply(this, arguments);
                    };
                }();
            }
        }
    ]);
    return HeartbeatService;
}(fetcherService_1.FetcherService);
__decorate([
    withJWT_1.withJWT,
    monitoring
], HeartbeatService.prototype, "createSession", null);
exports.heartbeatService = new HeartbeatService();


/***/ }),

/***/ 69248:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(3009);
var __decorate = (void 0) && (void 0).__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.heartbeatServiceV3 = void 0;
var fido_1 = __webpack_require__(6446);
var syncFetch_1 = __webpack_require__(2884);
var withJWT_1 = __webpack_require__(62782);
var tokenService_1 = __webpack_require__(9216);
var fetcherService_1 = __webpack_require__(97269);
var withMonitoring_1 = __webpack_require__(89873);
var monitoring = (0, withMonitoring_1.withMonitoring)("heartbeat");
/**
 * @module Heartbeat
 * @description The Heartbeat service is used to monitor the user's video consumption.
 * @tutorial ./doc/heartbeat.md
 */ var HeartbeatService = /*#__PURE__*/ function(_fetcherService_1_FetcherService) {
    _inherits._(HeartbeatService, _fetcherService_1_FetcherService);
    var _super = _create_super._(HeartbeatService);
    function HeartbeatService() {
        _class_call_check._(this, HeartbeatService);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.apiType = "heartbeatv3";
        return _this;
    }
    _create_class._(HeartbeatService, [
        {
            /**
     * Initialize the service. If you don't call this method, no other method can be called.
     *
     * @tutorial ./doc/heartbeatInit.md
     */ key: "init",
            value: function init() {
                if (!this.isInitialized) {
                    this.isInitialized = true;
                    this.basePath = "".concat(fido_1.fido.get("customerCode"), "/").concat(fido_1.fido.get("platformCode"));
                }
            }
        },
        {
            key: "videoStart",
            value: /**
     * Start Heartbeat session for a given program/clip.
     *
     * @async
     * @param {Object} options like { layoutData, metrics, headers } where layoutData as described in [docs](https://integrateur-6play.m6web.fr/v3/openapi/index.html?urls.primaryName=heartbeat-v3#/heartbeat/post__customerCode___platformCode__video_start), user A Gigya user => `{ UID, UIDSignature, signatureTimestamp }`, headers of the request.
     * @returns {Promise} Resolving as an object with refToken and polling as properties. "polling" is the number of seconds on which we'll base he polling. "refToken" needs to be sent back with each following calls, to identify the session.
     * @tutorial ./doc/heartbeatVideoStart.md
     */ function videoStart() {
                var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_layoutData = _ref.layoutData, layoutData = _ref_layoutData === void 0 ? null : _ref_layoutData, _ref_metrics = _ref.metrics, metrics = _ref_metrics === void 0 ? {} : _ref_metrics, _ref_headers = _ref.headers, headers = _ref_headers === void 0 ? {} : _ref_headers;
                var _this = this;
                return _async_to_generator._(function() {
                    var _sourceType, body, url;
                    return _ts_generator._(this, function(_state) {
                        if (!layoutData || !layoutData.contentType) {
                            throw new Error("You should provide a non null contentType");
                        }
                        /*
         * There is a break between layout and heartbeat. In Layout the sourceType for vod is 'video', and in heartbeat it's 'vod'.
         * A fix is currently in review, and will be merged within the week. This line should be removed
         */ _sourceType = layoutData.contentType === "live" ? layoutData.contentType : "vod";
                        body = Object.assign({
                            sourceType: _sourceType,
                            playerContext: _this.createPlayerContext(metrics)
                        }, layoutData);
                        url = _this.getServiceRouteUrl(_this.basePath, "video_start");
                        return [
                            2,
                            _this.fetch(url, {
                                method: "POST",
                                body: body,
                                headers: headers
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "videoConsuming",
            value: /**
     * Send view data to Heartbeat for a given session
     * Data can be sent with sync beacon API, if no response is needed.
     *
     * @async
     * @param {Object} options like { eventType, refToken, timecode, metrics, headers, isSync } where refToken is the data sent back from videoStart call. user A Gigya user => `{ UID, UIDSignature, signatureTimestamp }`, isLive Whether the session is live, sessionId  The id for this heartbeat session, headers of the request.
     * @returns {Promise} That triggers the http call to heartbeat view API.
     * @tutorial ./doc/heartbeatSendView.md
     */ function videoConsuming() {
                var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, eventType = _ref.eventType, refToken = _ref.refToken, timecode = _ref.timecode, metrics = _ref.metrics, _ref_headers = _ref.headers, headers = _ref_headers === void 0 ? {} : _ref_headers, _ref_isSync = _ref.isSync, isSync = _ref_isSync === void 0 ? false : _ref_isSync;
                var _this = this;
                return _async_to_generator._(function() {
                    var body, url, token, urlWithHeaders, formData;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!refToken) {
                                    throw new Error("You should create a session with videoStart before sending events");
                                }
                                body = {
                                    playerContext: _this.createPlayerContext(metrics),
                                    refToken: refToken,
                                    timecode: timecode
                                };
                                url = _this.getServiceRouteUrl(_this.basePath, "video_consuming/".concat(eventType));
                                if (!isSync) {
                                    return [
                                        2,
                                        _this.fetch(url, {
                                            method: "POST",
                                            body: body,
                                            headers: headers
                                        })
                                    ];
                                }
                                if (!navigator.sendBeacon || !window.FormData || typeof window.URL !== "function") {
                                    return [
                                        2,
                                        (0, syncFetch_1.fetchSync)(url, body, headers)
                                    ];
                                }
                                return [
                                    4,
                                    tokenService_1.tokenService.getToken()
                                ];
                            case 1:
                                token = _state.sent();
                                urlWithHeaders = new URL(url);
                                urlWithHeaders.searchParams.append("authorization", token);
                                urlWithHeaders.searchParams.append("customerName", fido_1.fido.get("customerCode"));
                                urlWithHeaders.searchParams.append("clientRelease", fido_1.fido.get("appVersion"));
                                formData = new FormData();
                                formData.append("body", JSON.stringify(body));
                                return [
                                    2,
                                    navigator.sendBeacon(urlWithHeaders.href, formData)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "createPlayerContext",
            value: function createPlayerContext(metrics) {
                return Object.assign({
                    bandwidth: 0,
                    bitrate: 0,
                    bufferSize: 0,
                    droppedFrames: 0,
                    resolution: 0
                }, metrics);
            }
        },
        {
            key: "getServiceRouteUrl",
            value: function getServiceRouteUrl() {
                var basePath = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", endpoint = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", clientCode = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : fido_1.fido.get("clientCode");
                this.checkInit();
                if (!this.apiType) {
                    throw new Error("You should define an API type for Fido's ".concat(this.getName()));
                }
                return "".concat(fido_1.fido.getBaseUrl(this.apiType).replace("%(clientCode)s", clientCode), "/").concat(basePath, "/").concat(endpoint);
            }
        }
    ]);
    return HeartbeatService;
}(fetcherService_1.FetcherService);
__decorate([
    withJWT_1.withJWT,
    monitoring
], HeartbeatService.prototype, "videoStart", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], HeartbeatService.prototype, "videoConsuming", null);
exports.heartbeatServiceV3 = new HeartbeatService();


/***/ }),

/***/ 83255:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _class_call_check = __webpack_require__(67818);
var _inherits = __webpack_require__(71648);
var _wrap_native_super = __webpack_require__(69349);
var _create_super = __webpack_require__(6400);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(65759);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.GigyaFormatError = exports.GigyaTimeoutError = void 0;
/* eslint-disable max-classes-per-file */ var GigyaTimeoutError = /*#__PURE__*/ function(Error1) {
    _inherits._(GigyaTimeoutError, Error1);
    var _super = _create_super._(GigyaTimeoutError);
    function GigyaTimeoutError(message) {
        _class_call_check._(this, GigyaTimeoutError);
        var _this;
        _this = _super.call(this);
        _this.name = _this.constructor.name;
        _this.message = "GigyaTimeoutError: ".concat(message || "unknown error");
        _this.stack = new Error().stack;
        return _this;
    }
    return GigyaTimeoutError;
}(_wrap_native_super._(Error));
exports.GigyaTimeoutError = GigyaTimeoutError;
var GigyaFormatError = /*#__PURE__*/ function(Error1) {
    _inherits._(GigyaFormatError, Error1);
    var _super = _create_super._(GigyaFormatError);
    function GigyaFormatError(message) {
        _class_call_check._(this, GigyaFormatError);
        var _this;
        _this = _super.call(this);
        _this.name = _this.constructor.name;
        _this.message = "GigyaFormatError: ".concat(message || "unknown error");
        _this.stack = new Error().stack;
        return _this;
    }
    return GigyaFormatError;
}(_wrap_native_super._(Error));
exports.GigyaFormatError = GigyaFormatError;


/***/ }),

/***/ 8461:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _assert_this_initialized = __webpack_require__(99561);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _wrap_native_super = __webpack_require__(69349);
var _create_super = __webpack_require__(6400);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(42578);
var __importDefault = (void 0) && (void 0).__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.IAMError = void 0;
var values_1 = __importDefault(__webpack_require__(61017));
var IAMError = /*#__PURE__*/ function(Error1) {
    _inherits._(IAMError, Error1);
    var _super = _create_super._(IAMError);
    function IAMError(message, extraData, code, listErrors) {
        _class_call_check._(this, IAMError);
        var _this;
        _this = _super.call(this);
        _this.message = message;
        if (typeof Error.captureStackTrace === "function") {
            Error.captureStackTrace(_assert_this_initialized._(_this), _this.constructor);
        } else {
            _this.stack = new Error(_this.message).stack;
        }
        _this.extraData = extraData;
        _this.code = code;
        _this.listErrors = listErrors;
        return _this;
    }
    _create_class._(IAMError, null, [
        {
            key: "create",
            value: function create(request, response, additionalInfo) {
                var listErrors = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [];
                var message = response.errorMessage || "Gigya API error";
                var errorGigya = listErrors.find(function(error) {
                    return IAMError.isGigyaError(error.errorCode);
                });
                [
                    "password",
                    "secret"
                ].forEach(function(key) {
                    if (request.params) {
                        request.params[key] = "hidden";
                    }
                });
                var extraData = {
                    request: request,
                    response: errorGigya ? Object.assign(Object.assign({}, response), {
                        errorCode: errorGigya.errorCode.toString()
                    }) : response,
                    additionalInfo: additionalInfo
                };
                return new IAMError(message, extraData, response.errorCode, listErrors);
            }
        }
    ]);
    return IAMError;
}(_wrap_native_super._(Error));
exports.IAMError = IAMError;
IAMError.errorCodes = {
    CODE_OPERATION_CANCELED: "200001",
    CODE_UNIQUE_IDENTIFIER_EXISTS: "400003",
    CODE_INVALID_LOGIN_ID: "403042",
    CODE_LOGIN_IDENTIFIER_EXISTS: "403043",
    CODE_LOGIN_IDENTIFIER_DOESNT_EXISTS: "403047"
};
IAMError.errorCodesArray = (0, values_1.default)(IAMError.errorCodes);
IAMError.isGigyaError = function(errorCode) {
    return IAMError.errorCodesArray.includes(errorCode.toString());
};
IAMError.reject = function(request, response, additionalInfo) {
    var listErrors = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [];
    return Promise.reject(IAMError.create(request, response, additionalInfo, listErrors));
};


/***/ }),

/***/ 84:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(45538);
var __decorate = (void 0) && (void 0).__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (void 0) && (void 0).__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.iamService = exports.IAMService = void 0;
var get_1 = __importDefault(__webpack_require__(65439));
var fido_1 = __webpack_require__(6446);
var withMonitoring_1 = __webpack_require__(89873);
var gigya_errors_1 = __webpack_require__(83255);
var iam_error_1 = __webpack_require__(8461);
var utils_1 = __webpack_require__(82213);
var monitoring = (0, withMonitoring_1.withMonitoring)("iam");
/**
 * @module IAM Identity Access Management
 * @description The IAM Service is used to interact with our IAM service provider to manage end-user authentication
 * @tutorial ./doc/iam.md
 */ var IAMService = /*#__PURE__*/ function() {
    function IAMService() {
        _class_call_check._(this, IAMService);
        this.isInitialized = false;
        this.options = {
            httpUserTokenMaxAge: 14400000
        };
        this.state = {
            currentUserInfo: null,
            lastLoginCall: null
        };
    }
    _create_class._(IAMService, [
        {
            key: "handleGigyaResponse",
            value: function handleGigyaResponse(sdkFunction, args) {
                return Promise.race([
                    new Promise(function(resolve, reject) {
                        sdkFunction(Object.assign(Object.assign({}, args), {
                            callback: (0, utils_1.handleCallbackRequest)(resolve, reject)
                        }));
                    }),
                    new Promise(function(_, reject) {
                        return setTimeout(function() {
                            return reject(new gigya_errors_1.GigyaTimeoutError("Timeout in handleGigyaResponse"));
                        }, fido_1.fido.get("waitTimeout"));
                    })
                ]);
            }
        },
        {
            /**
     * Initialize the service.
     *
     * @param {Object} sdk Gigya SDK
     * @param {Object} options Contains a set of options to be applied when calling some methods of the service
     * @tutorial ./doc/iamInit.md
     */ key: "init",
            value: function init(sdk) {
                var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                this.sdk = sdk;
                this.options = Object.assign(Object.assign({}, this.options), options);
                this.isInitialized = !!this.sdk;
            }
        },
        {
            /**
     * Set the options to be applied when calling some methods of the service
     *
     * @param {Object} options
     * @tutorial ./doc/iamSetOptions.md
     */ key: "setOptions",
            value: function setOptions() {
                var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                this.options = Object.assign(Object.assign({}, this.options), options);
            }
        },
        {
            /**
     * @private
     */ key: "hasLoginToken",
            value: function hasLoginToken() {
                return (0, utils_1.hasCookie)(this.options.loginTokenCookieName);
            }
        },
        {
            key: "login",
            value: /**
     * Login an user
     *
     * @async
     * @param {string} loginID The login identifier to use, can be an email
     * @param {string} password Password of the user
     * @tutorial ./doc/iamLogin.md
     * @returns {UserInfo}
     */ function login(loginID, password) {
                var _this = this;
                return _async_to_generator._(function() {
                    var userInfo;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.handleGigyaResponse(_this.sdk.accounts.login, {
                                        loginID: loginID,
                                        password: password,
                                        include: _this.options.include,
                                        ignoreInterruptions: true
                                    })
                                ];
                            case 1:
                                userInfo = _state.sent();
                                if (!userInfo || !userInfo.UID) {
                                    throw new gigya_errors_1.GigyaFormatError("Error during login, no UID in response");
                                }
                                _this.storeUserInfo(userInfo);
                                return [
                                    2,
                                    userInfo
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
     * Verify the correctness of a password
     *
     * @async
     * @param {string} password Password
     * @tutorial ./doc/iamVerifyPassword.md
     */ key: "verifyPassword",
            value: function verifyPassword(password) {
                return this.handleGigyaResponse(this.sdk.accounts.login, {
                    password: password,
                    loginMode: "reAuth"
                });
            }
        },
        {
            key: "autoConnect",
            value: /**
     * Auto-connect an user
     *
     * @async
     * @tutorial ./doc/iamAutoConnect.md
     * @returns {UserInfo}
     */ function autoConnect() {
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        if (!_this.hasLoginToken()) {
                            return [
                                2,
                                null
                            ];
                        }
                        return [
                            2,
                            _this.getUpdatedUserInfo()
                        ];
                    });
                })();
            }
        },
        {
            key: "getUpdatedUserInfo",
            value: /**
     * Recall gigya to check new user info that can change, for ex.: `isVerified`
     *
     * @returns Get updated user info
     */ function getUpdatedUserInfo() {
                var _this = this;
                return _async_to_generator._(function() {
                    var userInfo;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.handleGigyaResponse(_this.sdk.accounts.getAccountInfo, {
                                        include: _this.options.include
                                    })
                                ];
                            case 1:
                                userInfo = _state.sent();
                                /**
         * User with a proper UID should always be defined in Gigya responses, otherwise it's a failure
         * https://help.sap.com/viewer/8b8d6fffe113457094a17701f63e3d6a/GIGYA/en-US/417de3e270b21014bbc5a10ce4041860.html
         */ if (!userInfo || !userInfo.UID) {
                                    throw new gigya_errors_1.GigyaFormatError("Error during autoConnect, no UID in response");
                                }
                                _this.storeUserInfo(userInfo);
                                return [
                                    2,
                                    userInfo
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
     * Logout an user
     *
     * @async
     * @tutorial ./doc/iamLogout.md
     */ key: "logout",
            value: function logout() {
                this.clearUserInfo();
                return this.handleGigyaResponse(this.sdk.accounts.logout, {});
            }
        },
        {
            /**
     * Ask to send the account verification code to the specified email
     *
     * @async
     * @param {string} email Email to send the verification code to
     * @tutorial ./doc/iamResendVerificationCode.md
     */ key: "resendVerificationCode",
            value: function resendVerificationCode(email) {
                return this.handleGigyaResponse(this.sdk.accounts.resendVerificationCode, {
                    email: email
                });
            }
        },
        {
            /**
     * @private
     */ key: "initRegistration",
            value: function initRegistration() {
                return this.handleGigyaResponse(this.sdk.accounts.initRegistration, {});
            }
        },
        {
            /**
     * @private
     */ key: "register",
            value: function register(regToken, email, password) {
                var data = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, profile = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
                return this.handleGigyaResponse(this.sdk.accounts.register, {
                    regToken: regToken,
                    email: email,
                    password: password,
                    profile: JSON.stringify(profile),
                    data: JSON.stringify(data),
                    finalizeRegistration: true
                });
            }
        },
        {
            /**
     * @private
     */ key: "finalizeRegistration",
            value: function finalizeRegistration(regToken) {
                return this.handleGigyaResponse(this.sdk.accounts.finalizeRegistration, {
                    regToken: regToken
                });
            }
        },
        {
            key: "registration",
            value: /**
     * Register an user into the IAM provider
     *
     * @async
     * @param {string} email Email
     * @param {string} password Password
     * @param {Object} data A set of useful information not directly linked to the user
     * @param {Object} profile User profile data
     * @tutorial ./doc/iamRegistration.md
     * @returns {UserInfo}
     */ function registration(email, password, data, profile) {
                var _this = this;
                return _async_to_generator._(function() {
                    var responseInitRegistration, responseRegister, errorResponse, errorResponseCode, resp, error, errorCode, isInvalidLogin;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    3,
                                    ,
                                    8
                                ]);
                                return [
                                    4,
                                    _this.initRegistration()
                                ];
                            case 1:
                                responseInitRegistration = _state.sent();
                                return [
                                    4,
                                    _this.register(responseInitRegistration.regToken, email, password, data, profile)
                                ];
                            case 2:
                                responseRegister = _state.sent();
                                _this.storeUserInfo(responseRegister);
                                return [
                                    2,
                                    Object.assign({
                                        action: "REGISTRATION"
                                    }, responseRegister)
                                ];
                            case 3:
                                errorResponse = _state.sent();
                                errorResponseCode = (0, get_1.default)(errorResponse, "extraData.response.errorCode");
                                if (!(iam_error_1.IAMError.errorCodes.CODE_UNIQUE_IDENTIFIER_EXISTS === errorResponseCode)) return [
                                    3,
                                    7
                                ];
                                _state.label = 4;
                            case 4:
                                _state.trys.push([
                                    4,
                                    6,
                                    ,
                                    7
                                ]);
                                return [
                                    4,
                                    _this.login(email, password)
                                ];
                            case 5:
                                resp = _state.sent();
                                return [
                                    2,
                                    resp
                                ];
                            case 6:
                                error = _state.sent();
                                errorCode = (0, get_1.default)(error, "extraData.response.errorCode");
                                isInvalidLogin = iam_error_1.IAMError.errorCodes.CODE_INVALID_LOGIN_ID === errorCode;
                                if (isInvalidLogin) {
                                    throw errorResponse;
                                }
                                throw error;
                            case 7:
                                throw errorResponse;
                            case 8:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "socialRegistration",
            value: /**
     * Social register an user into the IAM provider
     *
     * @async
     * @param {string} provider Social provider to use
     * @tutorial ./doc/iamRegistration.md
     */ function socialRegistration(provider) {
                var _this = this;
                return _async_to_generator._(function() {
                    var _ref, newUser, accountInfo;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    new Promise(function(resolve, reject) {
                                        _this.sdk.socialize.login({
                                            provider: provider,
                                            callback: (0, utils_1.handleCallbackRequest)(resolve, reject)
                                        });
                                    })
                                ];
                            case 1:
                                _ref = _state.sent(), newUser = _ref.user.newUser;
                                return [
                                    4,
                                    _this.autoConnect()
                                ];
                            case 2:
                                accountInfo = _state.sent();
                                return [
                                    2,
                                    Object.assign(Object.assign({}, accountInfo), {
                                        isNewUser: newUser
                                    })
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
     * Link a social account with a standard email account
     *
     * @async
     * @param {string} loginID The login identifier to use, can be an email
     * @param {string} password Password
     * @param {string} regToken Registration token issued when trying to link account
     * @tutorial ./doc/iamLinkSocialAccount.md
     */ key: "linkSocialAccount",
            value: function linkSocialAccount(loginID, password, regToken) {
                return this.handleGigyaResponse(this.sdk.accounts.linkAccounts, {
                    regToken: regToken,
                    loginID: loginID,
                    password: password
                });
            }
        },
        {
            /**
     * Set the user password to a new one if the previous was not known
     *
     * @async
     * @param {string} passwordResetToken Password reset token issued
     * @param {string} newPassword Password to be used
     * @tutorial ./doc/iamResetPassword.md
     */ key: "resetPassword",
            value: function resetPassword(passwordResetToken, newPassword) {
                return this.handleGigyaResponse(this.sdk.accounts.resetPassword, {
                    passwordResetToken: passwordResetToken,
                    newPassword: newPassword
                });
            }
        },
        {
            /**
     * Start the procedure to reset the password
     *
     * @async
     * @param {string} loginID The login identifier to use, can be an email
     * @tutorial ./doc/iamForgotPassword.md
     */ key: "forgotPassword",
            value: function forgotPassword(loginID) {
                return this.handleGigyaResponse(this.sdk.accounts.resetPassword, {
                    loginID: loginID
                });
            }
        },
        {
            /**
     * Update previous password with a new password
     *
     * @async
     * @param {string} password Password in use
     * @param {string} newPassword Password to be used
     * @tutorial ./doc/iamUpdatePassword.md
     */ key: "updatePassword",
            value: function updatePassword(password, newPassword) {
                return this.handleGigyaResponse(this.sdk.accounts.setAccountInfo, {
                    password: password,
                    newPassword: newPassword
                });
            }
        },
        {
            /**
     * Update account info for the connected user
     *
     * @async
     * @param {Object} data Data A set of useful information not directly linked to the user - OBJECT IN DATABASE WON'T BE MERGED
     * @param {Object} profile User profile data - OBJECT IN DATABASE WON'T BE MERGED
     * @param {Object[]} removeLoginEmails Subset of login emails to remove from the user
     * @tutorial ./doc/iamSetAccountInfo.md
     */ key: "setAccountInfo",
            value: function setAccountInfo() {
                var data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, profile = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, removeLoginEmails = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], regToken = arguments.length > 3 ? arguments[3] : void 0;
                return this.handleGigyaResponse(this.sdk.accounts.setAccountInfo, {
                    data: JSON.stringify(data),
                    profile: JSON.stringify(profile),
                    removeLoginEmails: removeLoginEmails.join(","),
                    regToken: regToken
                });
            }
        },
        {
            key: "isLoginAvailable",
            value: /**
     * Tell if a loginId is already registered into the IAM Provider
     *
     * @async
     * @param {string} loginID The login identifier to use, can be an email
     * @tutorial ./doc/iamIsLoginAvailable.md
     */ function isLoginAvailable(loginID) {
                var _this = this;
                return _async_to_generator._(function() {
                    var response;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.handleGigyaResponse(_this.sdk.accounts.isAvailableLoginID, {
                                        loginID: loginID
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                return [
                                    2,
                                    response.isAvailable
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
     * @private
     */ key: "isCurrentUserExpired",
            value: function isCurrentUserExpired() {
                if (!this.state.lastLoginCall || !this.state.currentUserInfo) {
                    return true;
                }
                var httpUserTokenMaxAge = this.options.httpUserTokenMaxAge;
                return Date.now() - this.state.lastLoginCall > httpUserTokenMaxAge;
            }
        },
        {
            /**
     * @private
     */ key: "storeUserInfo",
            value: function storeUserInfo(currentUserInfo) {
                this.state = {
                    currentUserInfo: currentUserInfo,
                    lastLoginCall: new Date()
                };
            }
        },
        {
            /**
     * @private
     */ key: "clearUserInfo",
            value: function clearUserInfo() {
                this.state = {
                    currentUserInfo: null,
                    lastLoginCall: null
                };
            }
        },
        {
            key: "getUser",
            value: /**
     * give the current user
     * if the user is not connected or info expired, it try the autoConnect
     *
     * @async
     * @returns {UserInfo}
     */ function getUser() {
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        if (_this.isCurrentUserExpired()) {
                            return [
                                2,
                                _this.autoConnect()
                            ];
                        }
                        return [
                            2,
                            _this.state.currentUserInfo
                        ];
                    });
                })();
            }
        },
        {
            key: "connectDevice",
            value: /**
     * Create a session on external device
     * https://help.sap.com/docs/SAP_CUSTOMER_DATA_CLOUD/8b8d6fffe113457094a17701f63e3d6a/417729f470b21014bbc5a10ce4041860.html?q=notifyLogin
     *
     * @param UID
     * @param UIDSignature
     * @param UIDSignatureTimestamp
     *
     * @async
     * @returns {Object}
     */ function connectDevice(param) {
                var UID = param.UID, UIDSignature = param.UIDSignature, signatureTimestamp = param.signatureTimestamp;
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.handleGigyaResponse(_this.sdk.socialize.notifyLogin, {
                                        siteUID: UID,
                                        UIDSig: UIDSignature,
                                        UIDTimestamp: signatureTimestamp,
                                        // -2 : it will prevent the expiration of the user
                                        sessionExpiration: -2
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2,
                                    _this.autoConnect()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "sendCode",
            value: /**
     * Send connection code in user mail box
     * @param {Object} param sendCode options
     * @param {string} param.apiKey gigya public api key
     * @param {string} param.email user email address
     * @param {string} param.lang language code
     *
     * @async
     * @returns {string} token use for verify code on the frontend
     */ function sendCode(param) {
                var apiKey = param.apiKey, email = param.email, lang = param.lang;
                var _this = this;
                return _async_to_generator._(function() {
                    var _ref, iamVerificationToken;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.handleGigyaResponse(_this.sdk.accounts.otp.sendCode, {
                                        apiKey: apiKey,
                                        email: email,
                                        lang: lang
                                    })
                                ];
                            case 1:
                                _ref = _state.sent(), iamVerificationToken = _ref.vToken;
                                return [
                                    2,
                                    iamVerificationToken
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "verifyCode",
            value: /**
     * Verify the code the user received by email
     * @param {Object} param verifyCode options
     * @param {string} param.iamVerificationToken token returned by sendCode method
     * @param {string} param.code code received in email for the user
     * @param {string} param.apiKey gigya public api key
     *
     * @async
     * @returns {boolean} true if the validation is successful
     */ function verifyCode(param) {
                var iamVerificationToken = param.iamVerificationToken, code = param.code, apiKey = param.apiKey;
                var _this = this;
                return _async_to_generator._(function() {
                    var status;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.handleGigyaResponse(_this.sdk.accounts.otp.update, {
                                        vToken: iamVerificationToken,
                                        code: code,
                                        apiKey: apiKey
                                    })
                                ];
                            case 1:
                                status = _state.sent().status;
                                return [
                                    2,
                                    status === "OK"
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return IAMService;
}();
exports.IAMService = IAMService;
__decorate([
    monitoring
], IAMService.prototype, "login", null);
__decorate([
    monitoring
], IAMService.prototype, "verifyPassword", null);
__decorate([
    monitoring
], IAMService.prototype, "getUpdatedUserInfo", null);
__decorate([
    monitoring
], IAMService.prototype, "logout", null);
__decorate([
    monitoring
], IAMService.prototype, "resendVerificationCode", null);
__decorate([
    monitoring
], IAMService.prototype, "initRegistration", null);
__decorate([
    monitoring
], IAMService.prototype, "register", null);
__decorate([
    monitoring
], IAMService.prototype, "finalizeRegistration", null);
__decorate([
    monitoring
], IAMService.prototype, "registration", null);
__decorate([
    monitoring
], IAMService.prototype, "socialRegistration", null);
__decorate([
    monitoring
], IAMService.prototype, "linkSocialAccount", null);
__decorate([
    monitoring
], IAMService.prototype, "resetPassword", null);
__decorate([
    monitoring
], IAMService.prototype, "forgotPassword", null);
__decorate([
    monitoring
], IAMService.prototype, "updatePassword", null);
__decorate([
    monitoring
], IAMService.prototype, "setAccountInfo", null);
__decorate([
    monitoring
], IAMService.prototype, "isLoginAvailable", null);
__decorate([
    monitoring
], IAMService.prototype, "connectDevice", null);
__decorate([
    monitoring
], IAMService.prototype, "sendCode", null);
__decorate([
    monitoring
], IAMService.prototype, "verifyCode", null);
exports.iamService = new IAMService();


/***/ }),

/***/ 82213:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(42578);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.hasCookie = exports.handleCallbackRequest = void 0;
var iam_error_1 = __webpack_require__(8461);
var handleCallbackRequest = function(resolve, reject) {
    return function(result) {
        var errorCode = result.errorCode, _result_validationErrors = result.validationErrors, validationErrors = _result_validationErrors === void 0 ? [] : _result_validationErrors;
        if (errorCode === 0) {
            return resolve(result);
        }
        validationErrors.push({
            errorCode: errorCode
        });
        return reject(iam_error_1.IAMError.create(result.requestParams, result, result.errorMessage, validationErrors));
    };
};
exports.handleCallbackRequest = handleCallbackRequest;
var hasCookie = function(cookieName) {
    if (document && document.cookie) {
        return document.cookie.includes(cookieName);
    }
    return false;
};
exports.hasCookie = hasCookie;


/***/ }),

/***/ 25335:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(65759);
var __importDefault = (void 0) && (void 0).__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.iconService = void 0;
var superagent_1 = __importDefault(__webpack_require__(54247));
var fetcherService_1 = __webpack_require__(97269);
/**
 * The Icon Service is used to fetch the icon manifest from app-bedrock-bundle.
 * @module Icon
 * @tutorial ./doc/icon.md
 */ var IconService = /*#__PURE__*/ function(_fetcherService_1_FetcherService) {
    _inherits._(IconService, _fetcherService_1_FetcherService);
    var _super = _create_super._(IconService);
    function IconService() {
        _class_call_check._(this, IconService);
        return _super.apply(this, arguments);
    }
    _create_class._(IconService, [
        {
            key: "init",
            value: function init() {
                this.isInitialized = true;
            }
        },
        {
            key: "fetchManifest",
            value: function fetchManifest(param) {
                var baseUrl = param.baseUrl;
                return _async_to_generator._(function() {
                    var url, _ref, manifest, _a;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                url = "".concat(baseUrl, "/manifest.json");
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    superagent_1.default.get(url)
                                ];
                            case 2:
                                _ref = _state.sent(), manifest = _ref.body;
                                return [
                                    2,
                                    manifest
                                ];
                            case 3:
                                _a = _state.sent();
                                return [
                                    2,
                                    {}
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return IconService;
}(fetcherService_1.FetcherService);
exports.iconService = new IconService();


/***/ }),

/***/ 52537:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(45538);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.minimumWidthForAvifInPixels = exports.sizes = exports.ratios = exports.portraitSizes = exports.panoramicSizes = void 0;
/*
 * Those sizes are use as width of panoramic images. The height is calculated by dividing the width by the image ratio.
 * It will be used for all images with a ratio > 1.
 */ exports.panoramicSizes = [
    320,
    480,
    640,
    800,
    960,
    1120,
    1440,
    1760,
    2080,
    2560
];
/*
 * Those sizes are use as height of portrait images. The width is calculated by multiplying the height by the image ratio.
 * It will be used for all images with a ratio < 1.
 * Because the image API actually return an error if the image height is greater than 2048, we do not support taller images.
 */ exports.portraitSizes = [
    320,
    480,
    600,
    768,
    960,
    1080,
    1200,
    1440,
    1600,
    2048
];
exports.ratios = {
    "15:4": 15 / 4,
    "16:9": 16 / 9,
    "5:3": 5 / 3,
    "3:1": 3,
    "4:1": 4,
    "3:4": 3 / 4,
    "9:16": 9 / 16,
    "2:5": 2 / 5,
    "2:3": 2 / 3,
    "1:1": 1,
    default: 16 / 9
};
exports.sizes = {
    "15:4": exports.panoramicSizes,
    "16:9": exports.panoramicSizes,
    "5:3": exports.panoramicSizes,
    "3:1": exports.panoramicSizes,
    "4:1": exports.panoramicSizes,
    "3:4": exports.portraitSizes,
    "9:16": exports.portraitSizes,
    "2:5": exports.portraitSizes,
    "2:3": exports.portraitSizes,
    "1:1": exports.portraitSizes,
    default: exports.panoramicSizes
};
exports.minimumWidthForAvifInPixels = 1080;


/***/ }),

/***/ 75933:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _define_property = __webpack_require__(21228);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(65759);
var __importDefault = (void 0) && (void 0).__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.imageService = void 0;
var sha1_1 = __importDefault(__webpack_require__(99968));
var forEach_1 = __importDefault(__webpack_require__(17489));
var get_1 = __importDefault(__webpack_require__(65439));
var isInteger_1 = __importDefault(__webpack_require__(96789));
var map_1 = __importDefault(__webpack_require__(65512));
var omit_1 = __importDefault(__webpack_require__(59245));
var set_1 = __importDefault(__webpack_require__(35609));
var fido_1 = __webpack_require__(6446);
var queryParamSerializer_1 = __webpack_require__(21413);
var fetcherService_1 = __webpack_require__(97269);
var image_constants_1 = __webpack_require__(52537);
/**
 * The Image Service is used to build the URL of images on the 6play's platform.
 * @module Image
 * @tutorial ./doc/image.md
 */ var ImageService = /*#__PURE__*/ function(_fetcherService_1_FetcherService) {
    _inherits._(ImageService, _fetcherService_1_FetcherService);
    var _super = _create_super._(ImageService);
    function ImageService() {
        _class_call_check._(this, ImageService);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.apiType = "image";
        return _this;
    }
    _create_class._(ImageService, [
        {
            /**
     * Initialize the service.
     * @tutorial ./doc/imageInit.md
     */ key: "init",
            value: function init() {
                if (!this.isInitialized) {
                    this.basePath = "images";
                    this.isInitialized = true;
                }
            }
        },
        {
            /**
     * Return the formatted URL of the image.
     *
     * @param {string} id Image id.
     * @param {number} width Image width in pixels.
     * @param {number} height Image height in pixels.
     * @param {Object=} params Image params (ex: format, optimize, fit, ...). See [available parameters](https://integrateur-6play.m6web.fr/v2/doc_image.html).
     * @returns {string} Url of the image.
     * @tutorial ./doc/imageGetUrl.md
     */ key: "getUrl",
            value: function getUrl(id, width, height, params) {
                var integerId = parseInt(id, 10);
                if (!(0, isInteger_1.default)(integerId)) {
                    return "";
                }
                var rawUrl = this.getRouteUrl("".concat(integerId, "/raw"));
                var builtParams = Object.assign({
                    width: width,
                    height: height,
                    blur: 0,
                    fit: "scale_crop",
                    interlace: 1
                }, params);
                if (builtParams.optimize) {
                    delete builtParams.quality;
                } else if (!builtParams.quality) {
                    builtParams.optimize = builtParams.optimize || "high";
                }
                var defineImageFormat = function(imageParams) {
                    if (imageParams.width >= image_constants_1.minimumWidthForAvifInPixels) {
                        return "avif";
                    }
                    return "webp";
                };
                if (!builtParams.format) {
                    builtParams.auto = defineImageFormat(builtParams);
                }
                var queryString = (0, queryParamSerializer_1.serialize)(builtParams, function(param) {
                    var value = param.value;
                    return value || value === 0;
                });
                if (queryString) {
                    var path = this.getRoutePath("".concat(integerId, "/raw?").concat(queryString), true);
                    var hash = (0, sha1_1.default)("".concat(path).concat(fido_1.fido.get("imageSalt")));
                    return "".concat(rawUrl, "?").concat(queryString, "&hash=").concat(hash);
                }
                return rawUrl;
            }
        },
        {
            /**
     * Receives a ratio as a parameter (such as 0.459123), and returns the closest ratio from the list of predefined ratios that Fastly can handle.
     * The return value may then be passed to prepareImage as-is.
     * If no ratio was provided, the default ratio is used.
     *
     * @param {number} initialRatio The current ratio of the image.
     * @returns {string} The ratio to use when calling imageService.
     */ key: "findBestRatio",
            value: function findBestRatio() {
                var initialRatio = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : image_constants_1.ratios.default;
                return Object.keys(image_constants_1.ratios).reduce(function(prev, curr) {
                    return Math.abs(image_constants_1.ratios[curr] - initialRatio) < Math.abs(image_constants_1.ratios[prev] - initialRatio) ? curr : prev;
                });
            }
        },
        {
            key: "getSources",
            value: function getSources(id, ratio, params) {
                var _this = this;
                var sizeList = image_constants_1.sizes[ratio] || image_constants_1.sizes.default;
                return sizeList.reduce(function(acc, size) {
                    var tau = image_constants_1.ratios[ratio] || image_constants_1.ratios.default;
                    var width;
                    var height;
                    if (tau > 1) {
                        width = size;
                        height = Math.floor(size / tau);
                    } else {
                        width = Math.floor(size * tau);
                        height = size;
                    }
                    return Object.assign(Object.assign({}, acc), _define_property._({}, width, _this.getUrl(id, width, height, params)));
                }, {});
            }
        },
        {
            /**
     * Transform the image sub-object to an usable object within a HTML context. The latter will include `src` and `srcset` props which are calcuted based on the image's ratio.
     *
     * @param {Object} item Item to prepare.
     * @param {Object} options A key-value pairs object where key is the property name of the image item to prepare and value the params that service will use.
     * You can also use a lodash-type path like 'channel.image' or 'epgBox.0.image' as a key.
     * @param {Object} meta A key-value pairs object where meta props are passed to image object
     * @param {Boolean} withWebp when passed, it generates srcSetWebp for Item.
     * @returns {Object} Item with `src` and `srcset`.
     * @tutorial ./doc/imagePrepareItem.md
     */ key: "prepareItem",
            value: function prepareItem(item) {
                var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, meta = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, withWebp = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
                var _this = this;
                var itemContent = (0, get_1.default)(item, "itemContent", item);
                var preparedItem = Object.assign(Object.assign({}, itemContent), Object.keys(options).reduce(function(acc, key) {
                    var itemContentField = (0, get_1.default)(itemContent, key);
                    if (itemContentField) {
                        var option = (0, get_1.default)(options, key);
                        var imageOptions = (0, omit_1.default)(option, [
                            "rotating",
                            "rotatingOptions"
                        ]);
                        var image = _this.prepareImage(itemContentField, imageOptions);
                        if (withWebp) {
                            var imageWebp = _this.prepareImage(itemContentField, Object.assign(Object.assign({}, imageOptions), {
                                format: "webp"
                            }));
                            image.srcSetWebp = imageWebp.srcSet;
                        }
                        if (itemContentField.idsByRatio) {
                            image.srcSetsByRatio = {};
                            (0, forEach_1.default)(itemContentField.idsByRatio, function(id, ratio) {
                                image.srcSetsByRatio[ratio] = _this.prepareImage({
                                    id: id,
                                    ratio: ratio
                                }, imageOptions).srcSet;
                            });
                        }
                        if (option.rotating) {
                            var portrait = _this.prepareImage(Object.assign(Object.assign({}, itemContentField), {
                                ratio: "3:4"
                            }), Object.assign(Object.assign({}, imageOptions), (0, get_1.default)(option, "rotatingOptions", {})));
                            if (withWebp) {
                                var imageWebp1 = _this.prepareImage(Object.assign(Object.assign({}, itemContentField), {
                                    ratio: "3:4"
                                }), Object.assign(Object.assign(Object.assign({}, imageOptions), (0, get_1.default)(option, "rotatingOptions", {})), {
                                    format: "webp"
                                }));
                                portrait.srcSetWebp = imageWebp1.srcSet;
                            }
                            (0, set_1.default)(acc, key, {
                                landscape: image,
                                portrait: portrait
                            });
                        } else {
                            (0, set_1.default)(acc, key, image);
                        }
                        (0, set_1.default)(acc, key, Object.assign(Object.assign({}, (0, get_1.default)(acc, key)), meta));
                    }
                    return acc;
                }, {}));
                return Object.assign(Object.assign({}, preparedItem), {
                    itemContent: preparedItem
                });
            }
        },
        {
            key: "prepareImage",
            value: function prepareImage(param, params) {
                var id = param.id, _param_caption = param.caption, caption = _param_caption === void 0 ? "" : _param_caption, _param_ratio = param.ratio, ratio = _param_ratio === void 0 ? "16:9" : _param_ratio;
                var sources = this.getSources(id, ratio, params);
                return {
                    srcSet: (0, map_1.default)(sources, function(url, width) {
                        return "".concat(url, " ").concat(width, "w");
                    }).join(", "),
                    src: sources[Object.keys(sources)[0]],
                    caption: caption
                };
            }
        },
        {
            /**
     * Same as prepareItem but with an array of items.
     *
     * @param {Object[]} items Collection of items to prepare.
     * @param {Object} options A key-value pairs object where key is the property of the item to prepare and value the params that service will use.
     * @param {Object} meta A key-value pairs object where meta props are passed to image object
     * @param {Boolean} withWebp when passed, it generates srcSetWebp for each Item.
     * @returns {Object[]} Items with `src` and `srcset` defined.
     */ key: "prepareItems",
            value: function prepareItems(items, options) {
                var meta = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, withWebp = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
                var _this = this;
                return items.map(function(item) {
                    return _this.prepareItem(item, options, meta, withWebp);
                });
            }
        }
    ]);
    return ImageService;
}(fetcherService_1.FetcherService);
exports.imageService = new ImageService();


/***/ }),

/***/ 50066:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.withLocationHeader = void 0;
var decorators_builder_1 = __webpack_require__(34436);
/**
 * A decorator which injects the header `X-Location`, which contains the current full URL (including query params).
 * It doesn't add the header if window is not defined.
 * @param {number} applyToArgument the argument in which it should be injected.
 */ var withLocationHeader = function() {
    var applyToArgument = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return (0, decorators_builder_1.createAddHeaderDecorator)(function() {
        if (typeof window === "undefined") return;
        /*
         * Note: If the usage expands outside of client side web app, it could be useful to have a config in
         * fido to provide the location value
         */ return {
            "X-Location": window.location.href
        };
    }, applyToArgument);
};
exports.withLocationHeader = withLocationHeader;


/***/ }),

/***/ 28504:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(37815);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.appPages = exports.navigationTargets = exports.frontspaces = exports.aliases = exports.entities = void 0;
exports.entities = {
    service: "service",
    program: "program",
    folder: "folder",
    frontspace: "frontspace",
    alias: "alias",
    video: "video",
    audio: "audio",
    live: "live",
    radio: "radio",
    app: "app",
    article: "article",
    season: "season",
    details: "details"
};
exports.aliases = {
    home: "home",
    kids: "kids"
};
exports.frontspaces = {
    bookmarks: "bookmarks",
    landing: "landing",
    offers: "offers",
    profilesgate: "profilesgate",
    search: "search",
    tvapppreview: "tvapppreview",
    screensaver: "screensaver",
    devicesmanagementcenter: "devicesmanagementcenter",
    devicesgate: "devicesgate",
    epggrid: "epggrid"
};
exports.navigationTargets = {
    desktop: "desktop",
    mobile: "mobile",
    smarttv: "smarttv",
    tv: "tv",
    tvwithoutlive: "tvwithoutlive",
    tvwithoutmax: "tvwithoutmax",
    webview: "webview"
};
exports.appPages = {
    account: "account",
    account_billing: "account_billing",
    account_bookmarks: "account_bookmarks",
    account_informations: "account_informations",
    account_legalconditions: "account_legalconditions",
    account_pairing: "account_pairing",
    account_newsletters: "account_newsletters",
    account_overview: "account_overview",
    account_parentalcontrol: "account_parentalcontrol",
    account_parentalfilter: "account_parentalfilter",
    account_profilesmanagement: "account_profilesmanagement",
    account_profilesmanagement_profilecreation: "account_profilesmanagement_profilecreation",
    account_preferences: "account_preferences",
    consentsmanagement_account: "consentsmanagement_account",
    consentsmanagement_device: "consentsmanagement_device",
    privacy_policy: "privacy_policy"
};


/***/ }),

/***/ 65857:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _get = __webpack_require__(60528);
var _get_prototype_of = __webpack_require__(35196);
var _inherits = __webpack_require__(71648);
var _to_consumable_array = __webpack_require__(30005);
var _create_super = __webpack_require__(6400);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
var __importDefault = (void 0) && (void 0).__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.layoutForThirdPartyService = void 0;
var get_1 = __importDefault(__webpack_require__(65439));
var isArray_1 = __importDefault(__webpack_require__(24669));
var map_1 = __importDefault(__webpack_require__(65512));
var merge_1 = __importDefault(__webpack_require__(67929));
var thirdPartyWithLayoutService_1 = __webpack_require__(67300);
var layoutService_1 = __webpack_require__(34217);
/**
 * @module LayoutForThirdParty
 * @augments LayoutService
 * @description Same as the Layout service but has to be used in combination with the ThirdPartyWithLayoutService to add layout custom attributes automatically to the third party requests.
 * It also prepares analytics data of each block items in the fetched layout.
 * @tutorial ./doc/layoutForThirdPartyService.md
 */ var LayoutForThirdPartyService = /*#__PURE__*/ function(_layoutService_1_LayoutService) {
    _inherits._(LayoutForThirdPartyService, _layoutService_1_LayoutService);
    var _super = _create_super._(LayoutForThirdPartyService);
    function LayoutForThirdPartyService() {
        _class_call_check._(this, LayoutForThirdPartyService);
        return _super.apply(this, arguments);
    }
    _create_class._(LayoutForThirdPartyService, [
        {
            /**
     * Set the initial layout to use good third party data for the first rendered page with SSR
     *
     * @param {Object} layout Initial layout data.
     */ key: "setInitialLayout",
            value: function setInitialLayout(layout) {
                thirdPartyWithLayoutService_1.thirdPartyWithLayoutService.waitForPromise(Promise.resolve(layout));
            }
        },
        {
            key: "resetLayoutPromise",
            value: function resetLayoutPromise() {
                thirdPartyWithLayoutService_1.thirdPartyWithLayoutService.waitForPromise(Promise.resolve());
            }
        },
        {
            key: "getAlternativeContentAnalytics",
            value: function getAlternativeContentAnalytics(block, blockAnalytics) {
                var alternativeContentAnalytics = (0, get_1.default)(block, "alternativeContent.analytics", {});
                return block.alternativeContent ? Object.assign(Object.assign({}, block.alternativeContent), {
                    analytics: (0, merge_1.default)({}, blockAnalytics, alternativeContentAnalytics),
                    concurrentBlocks: (0, get_1.default)(block, "alternativeContent.concurrentBlocks", []).map(function(alternativeBlock) {
                        return Object.assign(Object.assign({}, alternativeBlock), {
                            analytics: (0, merge_1.default)({}, blockAnalytics, alternativeContentAnalytics, (0, get_1.default)(alternativeBlock, "analytics"))
                        });
                    })
                }) : null;
            }
        },
        {
            key: "mapToBlock",
            value: function mapToBlock(block) {
                var blockAnalytics = (0, get_1.default)(block, "analytics", {});
                var getItemAnalytics = function(item) {
                    return (0, merge_1.default)({}, blockAnalytics, (0, get_1.default)(item, "analytics"));
                };
                var items = (0, get_1.default)(block, "content.items", []).map(function(item) {
                    var itemContent = (0, get_1.default)(item, "itemContent");
                    return Object.assign(Object.assign({}, item), {
                        bookmark: item.bookmark ? Object.assign(Object.assign({}, (0, get_1.default)(item, "bookmark", {})), {
                            analytics: (0, merge_1.default)({}, getItemAnalytics(item), (0, get_1.default)(item, "bookmark.analytics"))
                        }) : null,
                        itemContent: Object.assign(Object.assign({}, itemContent), {
                            bookmark: itemContent.bookmark ? Object.assign(Object.assign({}, (0, get_1.default)(itemContent, "bookmark", {})), {
                                analytics: (0, merge_1.default)({}, getItemAnalytics(itemContent), (0, get_1.default)(itemContent, "bookmark.analytics"))
                            }) : null
                        })
                    });
                });
                return Object.assign(Object.assign({}, block), {
                    content: Object.assign(Object.assign({}, (0, get_1.default)(block, "content")), {
                        items: items
                    })
                });
            }
        },
        {
            key: "mapEntriesV1",
            value: function mapEntriesV1(data) {
                return {
                    entries: (0, map_1.default)(data.entries, function(param) {
                        var entry = param.entry, subEntries = param.subEntries;
                        var entryAnalytics = (0, get_1.default)(entry, "target.analytics", {});
                        var getSubEntryAnalytics = function(object) {
                            return (0, merge_1.default)({}, entryAnalytics, (0, get_1.default)(object, "target.analytics"));
                        };
                        var itemSubEntries = subEntries.map(function(subEntry) {
                            return Object.assign(Object.assign({}, subEntry), {
                                target: Object.assign(Object.assign({}, subEntry.target), {
                                    analytics: getSubEntryAnalytics(subEntry)
                                }),
                                action: subEntry.action ? Object.assign(Object.assign({}, subEntry.action), {
                                    target: Object.assign(Object.assign({}, subEntry.target), {
                                        analytics: getSubEntryAnalytics(subEntry)
                                    })
                                }) : null
                            });
                        });
                        var actionList = itemSubEntries.map(function(subEntry) {
                            return Object.assign(Object.assign({}, subEntry), {
                                action: subEntry.action ? Object.assign(Object.assign({}, subEntry.action), {
                                    target: subEntry.target
                                }) : {
                                    target: subEntry.target
                                }
                            });
                        });
                        var target = Object.assign(Object.assign({}, entry.target), {
                            analytics: entryAnalytics
                        });
                        return {
                            entry: Object.assign(Object.assign({}, entry), {
                                target: target,
                                actionList: actionList
                            }),
                            subEntries: itemSubEntries
                        };
                    })
                };
            }
        },
        {
            /*
     * Link third party events with the layout fetching
     * Inject block analytics in each block item
     * DON'T USE ASYNC/AWAIT HERE WHILE https://github.com/babel/babel/pull/9939 ISN'T MERGED
     */ key: "fetchByEntity",
            value: function fetchByEntity() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var _this = this;
                var _$_get;
                return thirdPartyWithLayoutService_1.thirdPartyWithLayoutService.waitForPromise((_$_get = _get._(_get_prototype_of._(LayoutForThirdPartyService.prototype), "fetchByEntity", this)).call.apply(_$_get, [
                    this
                ].concat(_to_consumable_array._(args)))).then(function(data) {
                    return Object.assign(Object.assign({}, data), {
                        blocks: data.blocks.map(function(block) {
                            return _this.mapToBlock(block);
                        })
                    });
                });
            }
        },
        {
            /*
     * DON'T USE ASYNC/AWAIT HERE WHILE https://github.com/babel/babel/pull/9939 ISN'T MERGED
     * `thirdPartyWithLayoutService.waitForPromise` remove here because there is a conflict with `fetchByEntity`
     * In `fetchByEntity`, we wait the promise of `fetchBlockPage` and vice versa
     * Futhermore, we don't need to wait this promise
     * If we want to send a third party event because we can't send one before the promise be resolved
     */ key: "fetchBlockPage",
            value: function fetchBlockPage() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var _this = this;
                var _$_get;
                return (_$_get = _get._(_get_prototype_of._(LayoutForThirdPartyService.prototype), "fetchBlockPage", this)).call.apply(_$_get, [
                    this
                ].concat(_to_consumable_array._(args))).then(function(data) {
                    return _this.mapToBlock(data);
                });
            }
        },
        {
            /*
     * Link third party events with the layout fetching
     * Inject analytics in each entries and subEntries
     * DON'T USE ASYNC/AWAIT HERE WHILE https://github.com/babel/babel/pull/9939 ISN'T MERGED
     */ key: "fetchNavigation",
            value: function fetchNavigation() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var _this = this;
                var _$_get;
                return (_$_get = _get._(_get_prototype_of._(LayoutForThirdPartyService.prototype), "fetchNavigation", this)).call.apply(_$_get, [
                    this
                ].concat(_to_consumable_array._(args))).then(function(data) {
                    if ((0, isArray_1.default)(data)) {
                        return data;
                    }
                    return _this.mapEntriesV1(data);
                });
            }
        }
    ]);
    return LayoutForThirdPartyService;
}(layoutService_1.LayoutService);
exports.layoutForThirdPartyService = new LayoutForThirdPartyService();


/***/ }),

/***/ 34217:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
var __decorate = (void 0) && (void 0).__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (void 0) && (void 0).__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.layoutService = exports.LayoutService = void 0;
var get_1 = __importDefault(__webpack_require__(65439));
var includes_1 = __importDefault(__webpack_require__(44840));
var isEmpty_1 = __importDefault(__webpack_require__(82691));
var set_1 = __importDefault(__webpack_require__(35609));
var fido_1 = __webpack_require__(6446);
var queryParamSerializer_1 = __webpack_require__(21413);
var retryRequest_1 = __webpack_require__(25991);
var withJWT_1 = __webpack_require__(62782);
var fetcherService_1 = __webpack_require__(97269);
var withMonitoring_1 = __webpack_require__(89873);
var withLocationDecorator_1 = __webpack_require__(50066);
var layout_constants_1 = __webpack_require__(28504);
var monitoring = (0, withMonitoring_1.withMonitoring)("layout");
var withLocationHeader = (0, withLocationDecorator_1.withLocationHeader)();
/**
 * @module Layout
 * @description The Layout service is used to build the page of a 6play entity (service, program, etc.) on a platform. You can use Fido to retrieve the Layout data of an entity. Then you are responsible to take these data and display the page.
 * @tutorial ./doc/layout.md
 */ var LayoutService = /*#__PURE__*/ function(_fetcherService_1_FetcherService) {
    _inherits._(LayoutService, _fetcherService_1_FetcherService);
    var _super = _create_super._(LayoutService);
    function LayoutService() {
        _class_call_check._(this, LayoutService);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.apiType = "layout";
        _this.defaultSectionCode = "main";
        _this.checkEntity = function(entityId, entityType) {
            if (!entityId) {
                throw new Error("You should provide a non null entityId");
            }
            if (!entityType) {
                throw new Error("You should provide a non null entityType!");
            }
        };
        return _this;
    }
    _create_class._(LayoutService, [
        {
            /**
     * Initialize the service. If you don't call this method, no other method can be called.
     *
     * @param {string} capacityToken A backend generated token that describes the platform capacity.
     * @param {options} options Some additional config parameters.
     * @tutorial ./doc/layoutInit.md
     */ key: "init",
            value: function init(capacityToken) {
                var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_defaultLayoutTheme = _ref.defaultLayoutTheme, defaultLayoutTheme = _ref_defaultLayoutTheme === void 0 ? {} : _ref_defaultLayoutTheme, _ref_retry = _ref.retry, retry = _ref_retry === void 0 ? 0 : _ref_retry;
                if (!this.isInitialized) {
                    this.basePath = "".concat(fido_1.fido.get("customerCode"), "/%(platformCode)s");
                    this.capacityToken = capacityToken;
                    this.defaultLayoutTheme = defaultLayoutTheme;
                    this.isInitialized = true;
                    this.retryOptions = (0, retryRequest_1.buildRetryOptions)({
                        apiType: this.apiType,
                        count: retry
                    });
                }
            }
        },
        {
            /**
     * Set the default layout theme which will be apply if the API return a null backgroundColor or colorScheme
     * @param {Object} layoutTheme Contains the default backgroundColor (Hexa) and the default colorScheme of the layout
     * * @tutorial ./doc/setDefaultLayoutTheme.md
     */ key: "setDefaultLayoutTheme",
            value: function setDefaultLayoutTheme(layoutTheme) {
                if (layoutTheme && layoutTheme.backgroundColor && layoutTheme.colorScheme) {
                    this.defaultLayoutTheme = layoutTheme;
                }
            }
        },
        {
            key: "fetchByEntity",
            value: /**
     * Get a layout for an entity.
     * @async
     *
     * @param {Object} options Contains "entityType (The layout type we want (see Layout Entity part for more info)), entitytId (Entity identifier) and headers (list of headers to add in network call)" values.
     * @returns {Object} The layout retrieved from the API.
     * @tutorial ./doc/layoutFetch.md
     */ function fetchByEntity(param) {
                var entityType = param.entityType, entityId = param.entityId, _param_sectionCode = param.sectionCode, sectionCode = _param_sectionCode === void 0 ? this.defaultSectionCode : _param_sectionCode, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers, _param_nbPages = param.nbPages, nbPages = _param_nbPages === void 0 ? 2 : _param_nbPages, _param_queryParameters = param.queryParameters, queryParameters = _param_queryParameters === void 0 ? {} : _param_queryParameters, _param_withCredentials = param.withCredentials, withCredentials = _param_withCredentials === void 0 ? false : _param_withCredentials, _param_signal = param.signal, signal = _param_signal === void 0 ? undefined : _param_signal, _param_platformCode = param.platformCode, platformCode = _param_platformCode === void 0 ? fido_1.fido.get("platformCode") : _param_platformCode;
                var _this = this;
                return _async_to_generator._(function() {
                    var token, serializedQueryParameters, layout, articleTarget;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.checkEntity(entityId, entityType);
                                token = fido_1.fido.get("usedCapacityToken") || _this.capacityToken;
                                if (token === "beta-all-available") {
                                    queryParameters.blockPage = 1;
                                }
                                serializedQueryParameters = (0, queryParamSerializer_1.serialize)(Object.assign({
                                    nbPages: nbPages
                                }, queryParameters));
                                if (!(entityType === "article")) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.fetch(_this.getRouteUrl("".concat(sectionCode, "/").concat(fido_1.fido.get("usedCapacityToken") || _this.capacityToken, "/video/clip_52/layout?").concat(serializedQueryParameters), platformCode), {
                                        method: "GET",
                                        headers: headers,
                                        retry: _this.retryOptions,
                                        withCredentials: withCredentials,
                                        signal: signal
                                    })
                                ];
                            case 1:
                                layout = _state.sent();
                                articleTarget = {
                                    type: "layout",
                                    value_layout: {
                                        section: "main",
                                        type: "article",
                                        id: entityId,
                                        seo: "this-is-article",
                                        parent: {
                                            id: "12345",
                                            type: "magazine",
                                            seo: "this-is-magazine"
                                        }
                                    }
                                };
                                (0, set_1.default)(layout, "entity.id", entityId);
                                (0, set_1.default)(layout, "layout.blocks[0].content.items[0].itemContent.action.target", articleTarget);
                                return [
                                    3,
                                    4
                                ];
                            case 2:
                                return [
                                    4,
                                    _this.fetch(_this.getRouteUrl("".concat(sectionCode, "/").concat(fido_1.fido.get("usedCapacityToken") || _this.capacityToken, "/").concat(entityType, "/").concat(entityId, "/layout?").concat(serializedQueryParameters)), {
                                        method: "GET",
                                        headers: headers,
                                        retry: _this.retryOptions,
                                        withCredentials: withCredentials,
                                        signal: signal
                                    })
                                ];
                            case 3:
                                layout = _state.sent();
                                _state.label = 4;
                            case 4:
                                // TODO : ...to this line. Then uncomment the block right below :)
                                /*
         * const layout = await this.fetch(
         *   this.getRouteUrl(
         *     `${sectionCode}/${
         *       fido.get('usedCapacityToken') || this.capacityToken
         *     }/${entityType}/${entityId}/layout?${serializedQueryParameters}`,
         *   ),
         *   {
         *     method: 'GET',
         *     headers,
         *     retry: this.retryOptions,
         *     withCredentials,
         *     signal,
         *   },
         * );
         */ return [
                                    2,
                                    _this.applyDefaultLayoutThemeOnLayout(layout)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "fetchHeadByEntity",
            value: /**
     * Head a layout for an entity.
     * @async
     *
     * @param {Object} options Contains "entityType (The layout type we want (see Layout Entity part for more info)), entitytId (Entity identifier) and headers (list of headers to add in network call)" values.
     * @returns {Object} The layout retrieved from the head request.
     * @tutorial ./doc/layoutFetchHead.md
     */ function fetchHeadByEntity(param) {
                var entityType = param.entityType, entityId = param.entityId, _param_sectionCode = param.sectionCode, sectionCode = _param_sectionCode === void 0 ? this.defaultSectionCode : _param_sectionCode, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers, _param_nbPages = param.nbPages, nbPages = _param_nbPages === void 0 ? 2 : _param_nbPages, _param_platformCode = param.platformCode, platformCode = _param_platformCode === void 0 ? fido_1.fido.get("platformCode") : _param_platformCode, _param_withCredentials = param.withCredentials, withCredentials = _param_withCredentials === void 0 ? false : _param_withCredentials;
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        _this.checkEntity(entityId, entityType);
                        return [
                            2,
                            _this.fetchWithStatus(_this.getRouteUrl("".concat(sectionCode, "/").concat(fido_1.fido.get("usedCapacityToken") || _this.capacityToken, "/").concat(entityType, "/").concat(entityId, "/layout?").concat((0, queryParamSerializer_1.serialize)({
                                nbPages: nbPages
                            })), fido_1.fido.get("clientCode"), platformCode), {
                                method: "HEAD",
                                headers: headers,
                                retry: _this.retryOptions,
                                withCredentials: withCredentials
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "fetchBlockPage",
            value: /**
     * Get a block items page for a block in an entity.
     * @async
     *
     * @param {Object} options Contains "entityType (The layout type we want (see Layout Entity part for more info)), entitytId (Entity identifier), blockId, pagination data and headers (list of headers to add in network call)" values.
     * @returns {Object} The block retrieved from the API.
     * @tutorial ./doc/fetchBlockPage.md
     */ function fetchBlockPage(param) {
                var entityType = param.entityType, entityId = param.entityId, blockId = param.blockId, _param_sectionCode = param.sectionCode, sectionCode = _param_sectionCode === void 0 ? this.defaultSectionCode : _param_sectionCode, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers, page = param.page, _param_nbPages = param.nbPages, nbPages = _param_nbPages === void 0 ? 1 : _param_nbPages, _param_queryParameters = param.queryParameters, queryParameters = _param_queryParameters === void 0 ? {} : _param_queryParameters;
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        if (!entityId) {
                            throw new Error("You should provide a non null entityId");
                        }
                        if (!entityType) {
                            throw new Error("You should provide a non null entityType!");
                        }
                        if (!blockId) {
                            throw new Error("You should provide a non null blockId !");
                        }
                        return [
                            2,
                            _this.fetch(_this.getRouteUrl("".concat(sectionCode, "/").concat(fido_1.fido.get("usedCapacityToken") || _this.capacityToken, "/").concat(entityType, "/").concat(entityId, "/block/").concat(blockId, "?").concat((0, queryParamSerializer_1.serialize)(Object.assign({
                                page: page,
                                nbPages: nbPages
                            }, queryParameters)))), {
                                method: "GET",
                                headers: headers,
                                retry: _this.retryOptions
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "fetchNavigation",
            value: /**
     * Get the navigation from the layout API.
     * @async
     *
     * @param {Object} options Contains target (corresponding platform) and "headers (list of headers to add in network call)".
     * @returns {Object} The navigation retrieved from the layout API.
     * @tutorial ./doc/fetchNavigation.md
     */ function fetchNavigation(param) {
                var target = param.target, _param_sectionCode = param.sectionCode, sectionCode = _param_sectionCode === void 0 ? this.defaultSectionCode : _param_sectionCode, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        if (!Object.values(layout_constants_1.navigationTargets).includes(target)) {
                            throw new Error('Parameter "target" must be one of '.concat(Object.values(layout_constants_1.navigationTargets).join(" | ")));
                        }
                        return [
                            2,
                            _this.fetch(_this.getRouteUrl("".concat(sectionCode, "/").concat(fido_1.fido.get("usedCapacityToken") || _this.capacityToken, "/navigation/").concat(target)), {
                                method: "GET",
                                headers: headers,
                                retry: _this.retryOptions
                            })
                        ];
                    });
                })();
            }
        },
        {
            /**
     * Replace the backgroundColor and the colorScheme attributes in `layout.theme` if one is not defined
     * @param {Object} layout the full layout object
     */ key: "applyDefaultLayoutThemeOnLayout",
            value: function applyDefaultLayoutThemeOnLayout(layout) {
                var _ref = (0, get_1.default)(layout, "layout.theme", {}), backgroundColor = _ref.backgroundColor, colorScheme = _ref.colorScheme;
                if ((0, isEmpty_1.default)(this.defaultLayoutTheme) || backgroundColor && colorScheme) {
                    return layout;
                }
                return (0, set_1.default)(layout, "layout.theme", this.defaultLayoutTheme);
            }
        },
        {
            key: "fetchEpgGrid",
            value: /**
     * Get an EPG block content for a given date
     * @async
     *
     * @param {Object} options Contains query parameters (day), nbPages and headers (list of headers to add in network call).
     * @returns {Object} The EPG block from the layout API.
     * @tutorial ./doc/fetchEpgGrid.md
     */ function fetchEpgGrid(param) {
                var _param_sectionCode = param.sectionCode, sectionCode = _param_sectionCode === void 0 ? this.defaultSectionCode : _param_sectionCode, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers, _param_nbPages = param.nbPages, nbPages = _param_nbPages === void 0 ? 2 : _param_nbPages, queryParameters = param.queryParameters;
                var _this = this;
                return _async_to_generator._(function() {
                    var token, serializedQueryParameters;
                    return _ts_generator._(this, function(_state) {
                        token = fido_1.fido.get("usedCapacityToken") || _this.capacityToken;
                        serializedQueryParameters = (0, queryParamSerializer_1.serialize)(Object.assign({
                            nbPages: nbPages
                        }, queryParameters));
                        return [
                            2,
                            _this.fetch(_this.getRouteUrl("".concat(sectionCode, "/").concat(token, "/epg_grid?").concat(serializedQueryParameters)), {
                                method: "GET",
                                headers: headers,
                                retry: _this.retryOptions
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "fetchEpgModal",
            value: /**
     * Get an EPG modal content for a given modal id
     * @async
     *
     * @param {Object} options Contains query parameters, an abort signal and headers (list of headers to add in network call).
     * @returns {Object} A layout of the EPG modal content
     * @tutorial ./doc/fetchEpgModal.md
     */ function fetchEpgModal(param) {
                var _param_sectionCode = param.sectionCode, sectionCode = _param_sectionCode === void 0 ? this.defaultSectionCode : _param_sectionCode, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers, queryParameters = param.queryParameters, id = param.id, signal = param.signal;
                var _this = this;
                return _async_to_generator._(function() {
                    var token, serializedQueryParameters;
                    return _ts_generator._(this, function(_state) {
                        token = fido_1.fido.get("usedCapacityToken") || _this.capacityToken;
                        serializedQueryParameters = (0, queryParamSerializer_1.serialize)(queryParameters);
                        return [
                            2,
                            _this.fetch(_this.getRouteUrl("".concat(sectionCode, "/").concat(token, "/epg_grid/").concat(id, "/modal?").concat(serializedQueryParameters)), {
                                method: "GET",
                                headers: headers,
                                retry: _this.retryOptions,
                                signal: signal
                            })
                        ];
                    });
                })();
            }
        }
    ]);
    return LayoutService;
}(fetcherService_1.FetcherService);
exports.LayoutService = LayoutService;
__decorate([
    withJWT_1.withJWT,
    withLocationHeader,
    monitoring
], LayoutService.prototype, "fetchByEntity", null);
__decorate([
    withJWT_1.withJWT,
    withLocationHeader,
    monitoring
], LayoutService.prototype, "fetchHeadByEntity", null);
__decorate([
    withJWT_1.withJWT,
    withLocationHeader,
    monitoring
], LayoutService.prototype, "fetchBlockPage", null);
__decorate([
    withJWT_1.withJWT,
    withLocationHeader,
    monitoring
], LayoutService.prototype, "fetchNavigation", null);
__decorate([
    withJWT_1.withJWT,
    withLocationHeader,
    monitoring
], LayoutService.prototype, "fetchEpgGrid", null);
__decorate([
    withJWT_1.withJWT,
    withLocationHeader,
    monitoring
], LayoutService.prototype, "fetchEpgModal", null);
exports.layoutService = new LayoutService();


/***/ }),

/***/ 83545:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(42578);
var __decorate = (void 0) && (void 0).__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.liveService = void 0;
var fido_1 = __webpack_require__(6446);
var queryParamSerializer_1 = __webpack_require__(21413);
var withJWT_1 = __webpack_require__(62782);
var fetcherService_1 = __webpack_require__(97269);
var withMonitoring_1 = __webpack_require__(89873);
var monitoring = (0, withMonitoring_1.withMonitoring)("live");
/**
 * @module Live
 * @augments FetcherService
 * @description Service to interact with Live channels middleware
 * @tutorial ./doc/live.md
 */ var LiveService = /*#__PURE__*/ function(_fetcherService_1_FetcherService) {
    _inherits._(LiveService, _fetcherService_1_FetcherService);
    var _super = _create_super._(LiveService);
    function LiveService() {
        _class_call_check._(this, LiveService);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.apiType = "middlewarev2";
        return _this;
    }
    _create_class._(LiveService, [
        {
            /**
     * Initialize the service. If you don't call this method, no other method can be called.
     *
     * @tutorial ./doc/liveInit.md
     */ key: "init",
            value: function init() {
                if (!this.isInitialized) {
                    this.basePath = "platforms/".concat(fido_1.fido.get("platformCode"), "/services");
                    this.isInitialized = true;
                }
            }
        },
        {
            key: "validateChannels",
            value: function validateChannels(channels) {
                if (!Array.isArray(channels) || !channels.length) {
                    throw new Error("You should provide an array containing at least one channel");
                }
            }
        },
        {
            key: "fetchLiveChannels",
            value: /**
     * Fetches Live data for specified channels. Returns an object containing metadata for each requested channel.
     * Additional fields could be specified via the dataToFetch array.
     *
     * @async
     * @param {Object} options Options passed to liveProgram serviceCode, channel, clientCode or headers
     * @param {string} options.serviceCode Should be retrieved from application config
     * @param {string[]} options.channels Channels that should be fetched. Usually this array will contain a single element
     * @param {string[]} options.dataToFetch Additional fields to be fetched, for example: ['freemiumpacks', 'service_display_images', 'nextdiffusion', 'extra_data']
     * @param {String} options.clientCode middleware client code: pc, hbbtv, and so on.
     * @param {Object=} options.headers HTTP headers to add or overwrite, optional parameter
     * @returns {Object} Information about the live channels
     * @tutorial ./doc/fetchLiveChannels.md
     */ function fetchLiveChannels(param) {
                var serviceCode = param.serviceCode, channels = param.channels, _param_dataToFetch = param.dataToFetch, dataToFetch = _param_dataToFetch === void 0 ? [] : _param_dataToFetch, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers, clientCode = param.clientCode;
                var _this = this;
                return _async_to_generator._(function() {
                    var queryParams;
                    return _ts_generator._(this, function(_state) {
                        _this.validateChannels(channels);
                        queryParams = {
                            channel: channels.join(",")
                        };
                        if (Array.isArray(dataToFetch) && Boolean(dataToFetch.length)) {
                            queryParams.with = dataToFetch.join(",");
                        }
                        return [
                            2,
                            _this.fetch(_this.getRouteUrl("".concat(serviceCode, "/live?").concat((0, queryParamSerializer_1.serialize)(queryParams)), clientCode), {
                                method: "GET",
                                headers: headers
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "fetchGuide",
            value: /**
     * Fetches EPG for specified period of time
     *
     * @async
     * @param {Object} options Configuration of the request
     * @param {string} options.serviceCode Should be retrieved from application config
     * @param {string[]} options.channels Channels that should be fetched
     * @param {Date} options.from Start date of schedule
     * @param {Date} options.to End date of schedule
     * @param {Number} options.limit Page limit, maximal amount of items to fetch
     * @param {Number} options.offset Page offset, should be used along with the limit parameter
     * @param {string[]} options.dataToFetch Additional fields to be fetched
     * @param {Object=} options.headers HTTP headers to add or overwrite, optional parameter
     * @param {String} options.clientCode middleware client code: pc, hbbtv, and so on.
     * @returns {Object} Information about the live channels schedule
     * @tutorial ./doc/fetchGuide.md
     */ function fetchGuide(param) {
                var serviceCode = param.serviceCode, channels = param.channels, from = param.from, to = param.to, _param_limit = param.limit, limit = _param_limit === void 0 ? 1 : _param_limit, _param_offset = param.offset, offset = _param_offset === void 0 ? 0 : _param_offset, _param_dataToFetch = param.dataToFetch, dataToFetch = _param_dataToFetch === void 0 ? [] : _param_dataToFetch, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers, clientCode = param.clientCode;
                var _this = this;
                return _async_to_generator._(function() {
                    var queryParams;
                    return _ts_generator._(this, function(_state) {
                        _this.validateChannels(channels);
                        queryParams = {
                            channel: channels.join(","),
                            from: (0, queryParamSerializer_1.formatDate)(from),
                            to: (0, queryParamSerializer_1.formatDate)(to),
                            limit: limit,
                            offset: offset
                        };
                        if (Array.isArray(dataToFetch) && Boolean(dataToFetch.length)) {
                            queryParams.with = dataToFetch.join(",");
                        }
                        return [
                            2,
                            _this.fetch(_this.getRouteUrl("".concat(serviceCode, "/guidetv?").concat((0, queryParamSerializer_1.serialize)(queryParams)), clientCode), {
                                method: "GET",
                                headers: headers
                            })
                        ];
                    });
                })();
            }
        }
    ]);
    return LiveService;
}(fetcherService_1.FetcherService);
__decorate([
    withJWT_1.withJWT,
    monitoring
], LiveService.prototype, "fetchLiveChannels", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], LiveService.prototype, "fetchGuide", null);
exports.liveService = new LiveService();


/***/ }),

/***/ 26380:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _to_consumable_array = __webpack_require__(30005);
var _create_super = __webpack_require__(6400);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(3009);
var __decorate = (void 0) && (void 0).__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (void 0) && (void 0).__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.logCollectorService = void 0;
var enc_hex_1 = __importDefault(__webpack_require__(2447));
var md5_1 = __importDefault(__webpack_require__(59834));
var fido_1 = __webpack_require__(6446);
var fetcherService_1 = __webpack_require__(97269);
var withMonitoring_1 = __webpack_require__(89873);
var monitoring = (0, withMonitoring_1.withMonitoring)("logCollector");
/**
 * @module LogCollector
 * @description Gelf log service is used to track error log.
 * @tutorial ./doc/logCollector.md
 */ var LogCollectorService = /*#__PURE__*/ function(_fetcherService_1_FetcherService) {
    _inherits._(LogCollectorService, _fetcherService_1_FetcherService);
    var _super = _create_super._(LogCollectorService);
    function LogCollectorService() {
        _class_call_check._(this, LogCollectorService);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.apiType = "gelf";
        return _this;
    }
    _create_class._(LogCollectorService, [
        {
            /**
     * Initialize the service. If you don't call this method, no other method can be called.
     *
     * @param {string} salt Salt used to generate request token.
     * @tutorial ./doc/logCollectorInit.md
     */ key: "init",
            value: function init(salt) {
                var platformCode = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : fido_1.fido.get("platformCode");
                if (!this.isInitialized) {
                    this.salt = salt;
                    this.platformCode = platformCode;
                    this.basePath = "gelf/log/pc";
                    this.isInitialized = true;
                }
            }
        },
        {
            key: "generateToken",
            value: function generateToken(node) {
                var hash = (0, md5_1.default)("pc".concat(node).concat(this.salt));
                return hash.toString(enc_hex_1.default);
            }
        },
        {
            /**
     * Send Error to log Collector with nodes.
     *
     * @param {Object[]} nodes Nodes to tag the error.
     * @param {Object} objectToLog Elements to log.
     * @tutorial ./doc/logCollectorSend.md
     */ key: "send",
            value: function send() {
                var nodes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], objectToLog = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var prefixedNodes = [
                    fido_1.fido.get("customerCode"),
                    this.platformCode
                ].concat(_to_consumable_array._(nodes)).join(".");
                var url = this.getRouteUrl("".concat(prefixedNodes, "/?token=").concat(this.generateToken(prefixedNodes)));
                return this.fetch(url, {
                    method: "POST",
                    body: objectToLog
                });
            }
        }
    ]);
    return LogCollectorService;
}(fetcherService_1.FetcherService);
__decorate([
    monitoring
], LogCollectorService.prototype, "send", null);
exports.logCollectorService = new LogCollectorService();


/***/ }),

/***/ 89873:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _async_to_generator = __webpack_require__(24146);
var _to_consumable_array = __webpack_require__(30005);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(42578);
var __importDefault = (void 0) && (void 0).__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.withMonitoring = void 0;
var get_1 = __importDefault(__webpack_require__(65439));
var fetch_error_1 = __webpack_require__(63378);
var statsdMonitoringService_1 = __webpack_require__(46261);
var timer_util_1 = __webpack_require__(65920);
// For unknown status like timeout
var DEFAULT_STATUS_CODE = 0;
/**
 * This decorator allow you to monitor a method
 * IMPORTANT : If you use others decorators with this one then it MUST be at the LAST position
 * To avoid monitoring the others decorators
 * @param  {...any} tags Label of the monitoring's info
 */ var withMonitoring = function() {
    for(var _len = arguments.length, tags = new Array(_len), _key = 0; _key < _len; _key++){
        tags[_key] = arguments[_key];
    }
    return function(target, key, descriptor) {
        var fn = descriptor.value;
        descriptor.value = /*#__PURE__*/ _async_to_generator._(function() {
            var _len, args, _key, returnValue, timer, error;
            var _arguments = arguments;
            return _ts_generator._(this, function(_state) {
                switch(_state.label){
                    case 0:
                        for(_len = _arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                            args[_key] = _arguments[_key];
                        }
                        timer = new timer_util_1.Timer(statsdMonitoringService_1.statsdMonitoringService.getCurrentTime);
                        timer.start();
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            fn.apply(this, args)
                        ];
                    case 2:
                        returnValue = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        if (error instanceof fetch_error_1.FetchError) {
                            statsdMonitoringService_1.statsdMonitoringService.sendIncrement([
                                "error",
                                "fido"
                            ].concat(_to_consumable_array._(tags), [
                                key,
                                (0, get_1.default)(error, "response.status", DEFAULT_STATUS_CODE)
                            ]));
                        } else {
                            statsdMonitoringService_1.statsdMonitoringService.sendIncrement([
                                "error",
                                "fido"
                            ].concat(_to_consumable_array._(tags), [
                                key,
                                "custom_error"
                            ]));
                        }
                        throw error;
                    case 4:
                        timer.stop();
                        statsdMonitoringService_1.statsdMonitoringService.sendTiming([
                            "fido"
                        ].concat(_to_consumable_array._(tags), [
                            key
                        ]), timer.duration());
                        return [
                            2,
                            returnValue
                        ];
                }
            });
        });
        return descriptor;
    };
};
exports.withMonitoring = withMonitoring;


/***/ }),

/***/ 46261:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _sliced_to_array = __webpack_require__(28966);
var _to_consumable_array = __webpack_require__(30005);
var _create_super = __webpack_require__(6400);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(65759);
var __importDefault = (void 0) && (void 0).__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.statsdMonitoringService = void 0;
var enc_base64_1 = __importDefault(__webpack_require__(33490));
var enc_hex_1 = __importDefault(__webpack_require__(2447));
var enc_utf8_1 = __importDefault(__webpack_require__(26551));
var md5_1 = __importDefault(__webpack_require__(59834));
var fido_1 = __webpack_require__(6446);
var fetch_1 = __webpack_require__(4906);
var fetcherService_1 = __webpack_require__(97269);
/**
 * @module StatsdMonitoring
 * @description The Statsd Monitoring service is used to call graphite node in order to count api calls.
 * @tutorial ./doc/statsd.md
 */ var StatsdMonitoringService = /*#__PURE__*/ function(_fetcherService_1_FetcherService) {
    _inherits._(StatsdMonitoringService, _fetcherService_1_FetcherService);
    var _super = _create_super._(StatsdMonitoringService);
    function StatsdMonitoringService() {
        _class_call_check._(this, StatsdMonitoringService);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.apiType = "monitoring";
        _this.stack = [];
        _this.buildPattern = function(basePattern, encoded) {
            return encoded ? "".concat(basePattern, "&encoded=1") : basePattern;
        };
        _this.buildEncodedNode = function(originalNode) {
            return encodeURIComponent(enc_base64_1.default.stringify(enc_utf8_1.default.parse(originalNode)));
        };
        _this.buildNodes = function(tags, encoded) {
            var scope = _this.isClientSide ? "client" : "server";
            var prefixedTags = [
                fido_1.fido.get("customerCode"),
                _this.platformCode,
                scope
            ].concat(_to_consumable_array._(tags));
            var node = prefixedTags.join(".");
            return {
                originalNode: node,
                encodedNode: encoded ? _this.buildEncodedNode(node) : node
            };
        };
        return _this;
    }
    _create_class._(StatsdMonitoringService, [
        {
            /**
     * Initialize the service. If you don't call this method, no other method can be called.
     *
     * @param {boolean} isClientSide Flag to tell if this service is client or server side.
     * @param {Object} options Options to pass to the service. See the example to discover the list of available options.
     * @tutorial ./doc/statsdInit.md
     */ key: "init",
            value: function init(isClientSide, param) {
                var enabled = param.enabled, salt = param.salt, platformCode = param.platformCode;
                this.isClientSide = isClientSide;
                this.enabled = enabled;
                if (!this.isInitialized) {
                    this.basePath = "statsd";
                    this.salt = salt;
                    this.getCurrentTime = fido_1.fido.get("getCurrentTime");
                    this.platformCode = platformCode || fido_1.fido.get("platformCode");
                    this.isInitialized = true;
                    this.processStack();
                }
            }
        },
        {
            key: "generateToken",
            value: function generateToken(node) {
                var isTimingToken = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var template = isTimingToken ? "".concat(node).concat(this.salt) : "".concat(node, "1").concat(this.salt);
                var hash = (0, md5_1.default)(template);
                return hash.toString(enc_hex_1.default);
            }
        },
        {
            /**
     * Send an increment on a specific tag list.
     *
     * @param {string[]} tags List of tags for increment hit.
     * @param {string=} token Increment token.
     * @param {boolean=} [encoded=false] Encoded flag to indicate if the hit is encoded.
     * @tutorial ./doc/statsdIncrement.md
     */ key: "sendIncrement",
            value: function sendIncrement() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var _this = this;
                var _args = _sliced_to_array._(args, 3), tags = _args[0], token = _args[1], tmp = _args[2], encoded = tmp === void 0 ? false : tmp;
                if (!this.isInitialized) {
                    this.stack.push(function() {
                        return _this.sendIncrement.apply(_this, _to_consumable_array._(args));
                    });
                    return;
                }
                if (!this.enabled) {
                    return;
                }
                var _this_buildNodes = this.buildNodes(tags, encoded), originalNode = _this_buildNodes.originalNode, encodedNode = _this_buildNodes.encodedNode;
                var url = this.getRouteUrl("".concat(encodedNode, "/increment?token=").concat(token || this.generateToken(originalNode)));
                (0, fetch_1.fetch)(this.buildPattern(url, encoded)).catch(function() {
                // Fail silently
                });
            }
        },
        {
            /**
     * Send a timing on a specific tag list.
     *
     * @param {string[]} tags List of tags for timing hit.
     * @param {number} duration Timing value.
     * @param {string=} token Timing token.
     * @param {boolean=} [encoded=false] Encoded flag to indicate if the hit is encoded.
     * @tutorial ./doc/statsdTiming.md
     */ key: "sendTiming",
            value: function sendTiming() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var _this = this;
                var _args = _sliced_to_array._(args, 4), tags = _args[0], duration = _args[1], token = _args[2], tmp = _args[3], encoded = tmp === void 0 ? false : tmp;
                if (!this.isInitialized) {
                    this.stack.push(function() {
                        return _this.sendTiming.apply(_this, _to_consumable_array._(args));
                    });
                    return;
                }
                if (!this.enabled) {
                    return;
                }
                var _this_buildNodes = this.buildNodes(tags, encoded), originalNode = _this_buildNodes.originalNode, encodedNode = _this_buildNodes.encodedNode;
                var url = this.getRouteUrl("".concat(encodedNode, "/timer/").concat(duration, "?token=").concat(token || this.generateToken(originalNode, true)));
                // Don't use this.fetch to avoid auto injection of headers
                (0, fetch_1.fetch)(this.buildPattern(url, encoded)).catch(function() {
                // Fail silently
                });
            }
        },
        {
            key: "processStack",
            value: function processStack() {
                if (this.isInitialized) {
                    this.stack.forEach(function(sendTags) {
                        return sendTags();
                    });
                    this.stack = [];
                }
            }
        },
        {
            /**
     * Send tracking hit to monitor app start.
     *
     * @param version string representation of the currently deployed release.
     * @tutorial ./doc/appStart.md
     */ key: "sendAppStart",
            value: function sendAppStart(version) {
                this.sendIncrement([
                    version,
                    "frontend_app_startup_total"
                ]);
            }
        },
        {
            /**
     * Send tracking hit to monitor silent error.
     *
     * @tutorial ./doc/silentError.md
     */ key: "sendSilentError",
            value: function sendSilentError() {
                this.sendIncrement([
                    "frontend_silent_error_total"
                ]);
            }
        },
        {
            /**
     * Send tracking hit to monitor fatal errors.
     *
     * @tutorial ./doc/fatalError.md
     */ key: "sendFatalError",
            value: function sendFatalError() {
                this.sendIncrement([
                    "frontend_fatal_error_total"
                ]);
            }
        },
        {
            /**
     * Send tracking hit to monitor manual login sucess.
     *
     * @tutorial ./doc/manualLoginSuccess.md
     */ key: "sendManualLoginSuccess",
            value: function sendManualLoginSuccess() {
                this.sendIncrement([
                    "frontend_login_total"
                ]);
            }
        },
        {
            /**
     * Send tracking hit to monitor auto login.
     *
     * @tutorial ./doc/autoLoginSuccess.md
     */ key: "sendAutoLoginSuccess",
            value: function sendAutoLoginSuccess() {
                this.sendIncrement([
                    "frontend_auto_login_total"
                ]);
            }
        },
        {
            /**
     * Send tracking hit to monitor manual login errors.
     *
     * @tutorial ./doc/manualLoginError.md
     */ key: "sendManualLoginError",
            value: function sendManualLoginError() {
                this.sendIncrement([
                    "frontend_login_error_total"
                ]);
            }
        },
        {
            /**
     * Send tracking hit to monitor register success.
     *
     * @tutorial ./doc/registerSuccess.md
     */ key: "sendRegisterSuccess",
            value: function sendRegisterSuccess() {
                this.sendIncrement([
                    "frontend_register_total"
                ]);
            }
        },
        {
            /**
     * Send tracking hit to monitor register errors.
     *
     * @tutorial ./doc/registerError.md
     */ key: "sendRegisterError",
            value: function sendRegisterError() {
                this.sendIncrement([
                    "frontend_register_error_total"
                ]);
            }
        },
        {
            /**
     * Send tracking hit to monitor complete registration success.
     *
     * @tutorial ./doc/completeRegistrationSuccess.md
     */ key: "sendCompleteRegistrationSuccess",
            value: function sendCompleteRegistrationSuccess() {
                this.sendIncrement([
                    "frontend_complete_registration_total"
                ]);
            }
        },
        {
            /**
     * Send tracking hit to monitor complete registration errors.
     *
     * @tutorial ./doc/completeRegistrationError.md
     */ key: "sendCompleteRegistrationError",
            value: function sendCompleteRegistrationError() {
                this.sendIncrement([
                    "frontend_complete_registration_error_total"
                ]);
            }
        },
        {
            /**
     * Send tracking hit to monitor when payment is done successfully.
     *
     * @param {string} payment The payment method used.
     * @tutorial ./doc/sendPaymentDone.md
     */ key: "sendPaymentDone",
            value: function sendPaymentDone(payment) {
                this.sendIncrement([
                    payment,
                    "frontend_payment_done_total"
                ]);
            }
        },
        {
            /**
     * Send tracking hit to monitor when payment failed.
     *
     * @param {string} payment The payment method used.
     * @tutorial ./doc/sendPaymentFailure.md
     */ key: "sendPaymentFailure",
            value: function sendPaymentFailure(payment, failure) {
                this.sendIncrement([
                    payment,
                    failure,
                    "frontend_payment_failure_total"
                ]);
            }
        },
        {
            /**
     * Send tracking hit to monitor layout redirection
     *
     * @param {string} frontspace The frontspace we redirect to.
     * @tutorial ./doc/sendLayoutRedirection.md
     */ key: "sendLayoutRedirection",
            value: function sendLayoutRedirection(frontspace) {
                this.sendIncrement([
                    "frontend_layout",
                    frontspace,
                    "redirect_total"
                ]);
            }
        },
        {
            /**
     * Send tracking hit to monitor profile selection.
     *
     * @tutorial ./doc/sendProfileSelection.md
     */ key: "sendProfileSelection",
            value: function sendProfileSelection() {
                this.sendIncrement([
                    "frontend_profile_selection_total"
                ]);
            }
        },
        {
            /**
     * Send tracking hit to monitor profile selection failure.
     *
     * @tutorial ./doc/sendProfileSelectionFailure.md
     */ key: "sendProfileSelectionFailure",
            value: function sendProfileSelectionFailure() {
                this.sendIncrement([
                    "frontend_profile_selection_failure_total"
                ]);
            }
        },
        {
            /**
     * Send tracking hit to monitor profile auto selection.
     *
     * @tutorial ./doc/sendProfileAutoSelection.md
     */ key: "sendProfileAutoSelection",
            value: function sendProfileAutoSelection() {
                this.sendIncrement([
                    "frontend_profile_autoselection_total"
                ]);
            }
        },
        {
            /**
     * Send tracking hit to monitor profile auto selection failure.
     *
     * @tutorial ./doc/sendProfileAutoSelectionFailure.md
     */ key: "sendProfileAutoSelectionFailure",
            value: function sendProfileAutoSelectionFailure() {
                this.sendIncrement([
                    "frontend_profile_autoselection_failure_total"
                ]);
            }
        },
        {
            /**
     * Send tracking hit to monitor algolia search requests.
     *
     * @tutorial ./doc/sendSearchBatchHit.md
     */ key: "sendSearchBatchHit",
            value: function sendSearchBatchHit() {
                this.sendIncrement([
                    "frontend_search_total"
                ]);
            }
        },
        {
            /**
     * Send tracking hit to monitor password succesfully update.
     *
     * @tutorial ./doc/sendUpdatePassword.md
     */ key: "sendUpdatePassword",
            value: function sendUpdatePassword() {
                this.sendIncrement([
                    "frontend_update_password"
                ]);
            }
        }
    ]);
    return StatsdMonitoringService;
}(fetcherService_1.FetcherService);
exports.statsdMonitoringService = new StatsdMonitoringService();


/***/ }),

/***/ 65920:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.Timer = void 0;
var Timer = /*#__PURE__*/ function() {
    function Timer() {
        var getCurrentTime = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Date.now;
        _class_call_check._(this, Timer);
        this.getCurrentTime = getCurrentTime;
        this.startTime = null;
        this.endTime = null;
    }
    _create_class._(Timer, [
        {
            key: "start",
            value: function start() {
                this.startTime = this.getCurrentTime();
            }
        },
        {
            key: "stop",
            value: function stop() {
                this.endTime = this.getCurrentTime();
            }
        },
        {
            key: "duration",
            value: function duration() {
                if (this.startTime === null || this.endTime === null) {
                    throw new Error("You should start and stop the timer before getting duration");
                }
                return this.endTime - this.startTime;
            }
        }
    ]);
    return Timer;
}();
exports.Timer = Timer;


/***/ }),

/***/ 78808:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(37815);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.premiumCouponStatus = exports.subscriptionStatus = void 0;
exports.subscriptionStatus = {
    VALID: "VALID",
    INVALID: "INVALID",
    ALREADY_USED_PAYMENT_METHOD: "ALREADY_USED_PAYMENT_METHOD"
};
exports.premiumCouponStatus = {
    VALID: "VALID",
    INVALID: "INVALID",
    ALREADY_SUBSCRIBED: "ERR_USER_ALREADY_SUBSCRIBED",
    USED: "USED",
    EXPIRED: "EXPIRED",
    LIMIT_REACHED: "LIMIT_REACHED"
};


/***/ }),

/***/ 92706:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _define_property = __webpack_require__(21228);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(65759);
var __decorate = (void 0) && (void 0).__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (void 0) && (void 0).__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.premiumService = exports.PremiumService = void 0;
var pickBy_1 = __importDefault(__webpack_require__(12557));
var snakeCase_1 = __importDefault(__webpack_require__(69113));
var fido_1 = __webpack_require__(6446);
var caching_1 = __webpack_require__(48832);
var withJWT_1 = __webpack_require__(62782);
var fetcherService_1 = __webpack_require__(97269);
var withMonitoring_1 = __webpack_require__(89873);
var premium_constants_1 = __webpack_require__(78808);
var monitoring = (0, withMonitoring_1.withMonitoring)("premium");
/**
 * @module Premium
 * @description The Premium service is used for premium in 6play app
 * @tutorial ./doc/premium.md
 */ var PremiumService = /*#__PURE__*/ function(_fetcherService_1_FetcherService) {
    _inherits._(PremiumService, _fetcherService_1_FetcherService);
    var _super = _create_super._(PremiumService);
    function PremiumService() {
        _class_call_check._(this, PremiumService);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.apiType = "stores";
        return _this;
    }
    _create_class._(PremiumService, [
        {
            /**
     * Initialize the service. If you don't call this method, no other method can be called.
     *
     * @tutorial ./doc/premiumInit.md
     */ key: "init",
            value: function init() {
                if (!this.isInitialized) {
                    this.isInitialized = true;
                }
            }
        },
        {
            key: "getOffers",
            value: /**
     * Get offers list
     * @async
     *
     * @param {Object} options Offers parameters (products: string array of products id, countryCode: ISO country code for offers filtering)
     *
     * @returns {Object[]}
     */ function getOffers(param) {
                var headers = param.headers, products = param.products, countryCode = param.countryCode;
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        _this.checkInit();
                        return [
                            2,
                            _this.fetch("".concat(fido_1.fido.getBaseUrl("stores"), "/customers/").concat(fido_1.fido.get("customerCode"), "/platforms/").concat(fido_1.fido.get("platformCode"), "/offers"), {
                                method: "GET",
                                headers: headers,
                                query: {
                                    products: products === null || products === void 0 ? void 0 : products.join(","),
                                    countryCode: countryCode
                                }
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "getOrder",
            value: /**
     * Generate an order on server side
     * @async
     *
     * @param {Object} options Order parameters
     * @returns {Object}
     * @tutorial ./doc/getOrder.md
     */ function getOrder(param) {
                var locale = param.locale, variantId = param.variantId, couponCode = param.couponCode, user = param.user, headers = param.headers;
                var _this = this;
                return _async_to_generator._(function() {
                    var prepareURL;
                    return _ts_generator._(this, function(_state) {
                        _this.checkInit();
                        prepareURL = "".concat(fido_1.fido.getBaseUrl("stores"), "/customers/").concat(fido_1.fido.get("customerCode"), "/platforms/").concat(fido_1.fido.get("platformCode"), "/users/").concat(user.UID, "/prepare");
                        return [
                            2,
                            _this.fetch(prepareURL, {
                                method: "POST",
                                body: {
                                    locale: locale,
                                    offer_variant_id: variantId,
                                    coupon_code: couponCode
                                },
                                headers: headers
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "changeOffer",
            value: /**
     * Change an offer subscription.
     * @async
     *
     * @param {Object} options Change offer parameter (offerCode, variantId, user, headers)
     * @returns {Object}
     * @tutorial ./doc/changeOffer.md
     */ function changeOffer(param) {
                var offerCode = param.offerCode, variantId = param.variantId, user = param.user, headers = param.headers;
                var _this = this;
                return _async_to_generator._(function() {
                    var prepareURL;
                    return _ts_generator._(this, function(_state) {
                        _this.checkInit();
                        prepareURL = "".concat(fido_1.fido.getBaseUrl("stores"), "/customers/").concat(fido_1.fido.get("customerCode"), "/platforms/").concat(fido_1.fido.get("platformCode"), "/users/").concat(user.UID, "/offers/").concat(offerCode, "/change");
                        return [
                            2,
                            _this.fetch(prepareURL, {
                                method: "POST",
                                body: {
                                    offer_variant_id: variantId
                                },
                                headers: headers
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "cancelDowngrade",
            value: /**
     * Cancel downgrade
     * @async
     *
     * @param {Object} options parameters (offerCode, user, headers)
     * @returns {Object}
     * @tutorial ./doc/cancelDowngrade.md
     */ function cancelDowngrade(param) {
                var offerCode = param.offerCode, user = param.user, headers = param.headers;
                var _this = this;
                return _async_to_generator._(function() {
                    var prepareURL;
                    return _ts_generator._(this, function(_state) {
                        _this.checkInit();
                        prepareURL = "".concat(fido_1.fido.getBaseUrl("stores"), "/customers/").concat(fido_1.fido.get("customerCode"), "/platforms/").concat(fido_1.fido.get("platformCode"), "/users/").concat(user.UID, "/offers/").concat(offerCode, "/change/cancel");
                        return [
                            2,
                            _this.fetch(prepareURL, {
                                method: "POST",
                                headers: headers
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "getUserAccess",
            value: /**
     * Get the user's accesses
     * @async
     *
     * @param user User
     * @returns {Object}
     * @tutorial ./doc/getUserAccess.md
     */ function getUserAccess(param) {
                var user = param.user, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                var _this = this;
                return _async_to_generator._(function() {
                    var prepareURL;
                    return _ts_generator._(this, function(_state) {
                        _this.checkInit();
                        prepareURL = "".concat(fido_1.fido.getBaseUrl("stores"), "/customers/").concat(fido_1.fido.get("customerCode"), "/platforms/").concat(fido_1.fido.get("platformCode"), "/users/").concat(user.UID, "/access");
                        return [
                            2,
                            _this.fetch(prepareURL, {
                                method: "GET",
                                headers: headers
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "getUserSubscriptions",
            value: /**
     * Get the user's subscriptions
     * @async
     *
     * @param {Object} options Object containing the user whose subscriptions are requested
     * @returns {Object}
     * @tutorial ./doc/getUserSubscriptions.md
     */ function getUserSubscriptions(param) {
                var user = param.user, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                var _this = this;
                return _async_to_generator._(function() {
                    var apiURL;
                    return _ts_generator._(this, function(_state) {
                        _this.checkInit();
                        if (!user.UID) {
                            throw new Error("You should provide a non null uid");
                        }
                        apiURL = "".concat(fido_1.fido.getBaseUrl("stores"), "/customers/").concat(fido_1.fido.get("customerCode"), "/platforms/").concat(fido_1.fido.get("platformCode"), "/users/").concat(user.UID, "/subscriptions");
                        return [
                            2,
                            _this.fetch(apiURL, {
                                method: "GET",
                                headers: headers
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "getUserSubscriptionsAfterPaymentUpdate",
            value: /**
     * Get the user's subscription after payment update
     * @async
     *
     * @param {Object} options Object containing the user whose subscriptions are requested
     * @returns {Object}
     * @tutorial ./doc/getUserSubscriptionsAfterPaymentUpdate.md
     */ function getUserSubscriptionsAfterPaymentUpdate(param) {
                var user = param.user, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        headers["X-Refresh"] = true;
                        return [
                            2,
                            _this.getUserSubscriptions({
                                user: user,
                                headers: headers
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "getUserInvoices",
            value: /**
     * Get the user's invoices
     * @async
     *
     * @param {Object} options Object containing the user whose invoices are requested
     * @returns {Object}
     * @tutorial ./doc/getUserInvoices.md
     */ function getUserInvoices(param) {
                var user = param.user, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                var _this = this;
                return _async_to_generator._(function() {
                    var apiURL;
                    return _ts_generator._(this, function(_state) {
                        _this.checkInit();
                        if (!user.UID) {
                            throw new Error("You should provide a non null uid");
                        }
                        apiURL = "".concat(fido_1.fido.getBaseUrl("stores"), "/customers/").concat(fido_1.fido.get("customerCode"), "/platforms/").concat(fido_1.fido.get("platformCode"), "/users/").concat(user.UID, "/invoices");
                        return [
                            2,
                            _this.fetch(apiURL, {
                                method: "GET",
                                headers: headers
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "downloadInvoice",
            value: /**
     * Download the given invoice
     * @async
     *
     * @param {Object} options Object containing the url of the invoice to download
     * @returns {Object}
     * @tutorial ./doc/downloadInvoice.md
     */ function downloadInvoice(param) {
                var url = param.url, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                var _this = this;
                return _async_to_generator._(function() {
                    var downloadWithRedirect, downloadWithManualRedirect, _a;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.checkInit();
                                downloadWithRedirect = function() {
                                    var _ref = _async_to_generator._(function() {
                                        return _ts_generator._(this, function(_state) {
                                            return [
                                                2,
                                                _this.fetch(url, {
                                                    method: "GET",
                                                    headers: headers,
                                                    responseType: "blob"
                                                })
                                            ];
                                        });
                                    });
                                    return function downloadWithRedirect() {
                                        return _ref.apply(this, arguments);
                                    };
                                }();
                                downloadWithManualRedirect = function() {
                                    var _ref = _async_to_generator._(function() {
                                        var returnUrl;
                                        return _ts_generator._(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    return [
                                                        4,
                                                        _this.fetch(url, {
                                                            method: "GET",
                                                            headers: Object.assign(Object.assign({}, headers), {
                                                                "Content-Type": "application/json"
                                                            })
                                                        })
                                                    ];
                                                case 1:
                                                    returnUrl = _state.sent();
                                                    return [
                                                        2,
                                                        _this.fetch(returnUrl.location, {
                                                            method: "GET",
                                                            headers: headers,
                                                            responseType: "blob"
                                                        })
                                                    ];
                                            }
                                        });
                                    });
                                    return function downloadWithManualRedirect() {
                                        return _ref.apply(this, arguments);
                                    };
                                }();
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    downloadWithRedirect()
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 3:
                                _a = _state.sent();
                                return [
                                    2,
                                    downloadWithManualRedirect()
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "cancelSubscription",
            value: /**
     * Cancel user subscription
     * @async
     *
     * @param {Object} options Object containing the user who request the cancellation and the subscription to cancel
     * @returns {Object}
     * @tutorial ./doc/cancelSubscription.md
     */ function cancelSubscription(param) {
                var user = param.user, offerCode = param.offerCode, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                var _this = this;
                return _async_to_generator._(function() {
                    var apiURL;
                    return _ts_generator._(this, function(_state) {
                        _this.checkInit();
                        if (!user.UID) {
                            throw new Error("You should provide a non null user uid");
                        }
                        if (!offerCode) {
                            throw new Error("You should provide a non null offer code");
                        }
                        apiURL = "".concat(fido_1.fido.getBaseUrl("stores"), "/customers/").concat(fido_1.fido.get("customerCode"), "/platforms/").concat(fido_1.fido.get("platformCode"), "/users/").concat(user.UID, "/offers/").concat(offerCode, "/unsubscribe");
                        return [
                            2,
                            _this.fetch(apiURL, {
                                method: "POST",
                                headers: headers
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "resumeSubscription",
            value: /**
     * Resume user subscription
     * @async
     *
     * @param {Object} options Object containing the user who request to resume and the canceled subscription to resume
     * @returns {Object}
     * @tutorial ./doc/resumeSubscription.md
     */ function resumeSubscription(param) {
                var user = param.user, offerCode = param.offerCode, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                var _this = this;
                return _async_to_generator._(function() {
                    var apiURL;
                    return _ts_generator._(this, function(_state) {
                        _this.checkInit();
                        if (!user.UID) {
                            throw new Error("You should provide a non null user uid");
                        }
                        if (!offerCode) {
                            throw new Error("You should provide a non null offer code");
                        }
                        apiURL = "".concat(fido_1.fido.getBaseUrl("stores"), "/customers/").concat(fido_1.fido.get("customerCode"), "/platforms/").concat(fido_1.fido.get("platformCode"), "/users/").concat(user.UID, "/offers/").concat(offerCode, "/resume");
                        return [
                            2,
                            _this.fetch(apiURL, {
                                method: "POST",
                                headers: headers
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "consumeCouponCode",
            value: function consumeCouponCode(param) {
                var user = param.user, couponCode = param.couponCode, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                var _this = this;
                return _async_to_generator._(function() {
                    var response, e, status, receiptResult, e1, status1;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!user) {
                                    throw new Error("You should provide a non null uid");
                                }
                                if (!couponCode) {
                                    throw new Error("You should provide a non null couponCode");
                                }
                                response = null;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    _this.fetchWithResponse("".concat(fido_1.fido.getBaseUrl("coupons"), "/customers/").concat(fido_1.fido.get("customerCode"), "/platforms/").concat(fido_1.fido.get("platformCode"), "/users/").concat(user.UID, "/coupons"), {
                                        method: "POST",
                                        headers: headers,
                                        body: {
                                            code: couponCode
                                        }
                                    })
                                ];
                            case 2:
                                response = _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                e = _state.sent();
                                status = e.status;
                                if (status === 400 || status === 404) return [
                                    2,
                                    {
                                        status: premium_constants_1.premiumCouponStatus.INVALID
                                    }
                                ];
                                throw e;
                            case 4:
                                _state.trys.push([
                                    4,
                                    6,
                                    ,
                                    7
                                ]);
                                return [
                                    4,
                                    _this.fetch("".concat(fido_1.fido.getBaseUrl("stores"), "/customers/").concat(fido_1.fido.get("customerCode"), "/platforms/").concat(fido_1.fido.get("platformCode"), "/users/").concat(user.UID, "/stores/freecoupons/check"), {
                                        method: "POST",
                                        headers: headers,
                                        body: {
                                            receipt: response.text
                                        }
                                    })
                                ];
                            case 5:
                                receiptResult = _state.sent();
                                return [
                                    3,
                                    7
                                ];
                            case 6:
                                e1 = _state.sent();
                                status1 = e1.status;
                                if (status1 === 400) return [
                                    2,
                                    {
                                        status: premium_constants_1.premiumCouponStatus.INVALID
                                    }
                                ];
                                if (status1 === 409) return [
                                    2,
                                    {
                                        status: premium_constants_1.premiumCouponStatus.ALREADY_SUBSCRIBED
                                    }
                                ];
                                throw e1;
                            case 7:
                                return [
                                    2,
                                    {
                                        status: premium_constants_1.premiumCouponStatus.VALID,
                                        subscribedOffer: receiptResult.offer
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "verifyCoupon",
            value: /**
     * Check couponCode status and return the associated offer
     * or throw if no coupon code is provided
     * @async
     *
     * @param {Object} options Contains the couponCode to verify and the
     * headers to transmit during the ajax request
     * @returns {Object} coupon data
     * @tutorial ./doc/verifyCoupon.md
     */ function verifyCoupon(param) {
                var couponCode = param.couponCode, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                var _this = this;
                return _async_to_generator._(function() {
                    var couponVerificationURL, coupon, _a;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.checkInit();
                                if (!couponCode) {
                                    throw new Error("You should provide a non null couponCode");
                                }
                                couponVerificationURL = "".concat(fido_1.fido.getBaseUrl("coupons"), "/premium/platforms/").concat(fido_1.fido.get("platformCode"), "/coupon/").concat(couponCode, "/expose");
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    _this.fetch(couponVerificationURL, {
                                        method: "GET",
                                        headers: headers
                                    })
                                ];
                            case 2:
                                coupon = _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                _a = _state.sent();
                                return [
                                    2,
                                    {
                                        status: premium_constants_1.premiumCouponStatus.INVALID
                                    }
                                ];
                            case 4:
                                return [
                                    2,
                                    coupon
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "pay",
            value: /**
     * Pay order.
     *
     * See {@link https://integrateur-6play.m6web.fr/v2/openapi/index.html?urls.primaryName=stores#/subscription/post_premium_v4_customers__customerCode__platforms__platformCode__users__uid__stores__storeCode__pay|API documentation}.
     *
     * @async
     * @param {Object} options Payment parameters (user, storeCode, returnUrl, paymentMethodType, paymentMethodCode, orderId)
     * @returns {Object}
     * @tutorial ./doc/pay.md
     */ function pay(param) {
                var force = param.force, user = param.user, storeCode = param.storeCode, returnUrl = param.returnUrl, paymentMethodType = param.paymentMethodType, paymentMethodCode = param.paymentMethodCode, orderId = param.orderId, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                var _this = this;
                return _async_to_generator._(function() {
                    var payEndpoint, body, payURL;
                    return _ts_generator._(this, function(_state) {
                        _this.checkInit();
                        if (!user.UID) {
                            throw new Error("You should provide a non null uid");
                        }
                        payEndpoint = force ? "forcePay" : "pay";
                        body = (0, pickBy_1.default)({
                            order_id: orderId,
                            return_url: returnUrl,
                            payment_method_type: paymentMethodType,
                            payment_method_code: paymentMethodCode
                        });
                        payURL = "".concat(fido_1.fido.getBaseUrl("stores"), "/customers/").concat(fido_1.fido.get("customerCode"), "/platforms/").concat(fido_1.fido.get("platformCode"), "/users/").concat(user.UID, "/stores/").concat(storeCode, "/").concat(payEndpoint);
                        return [
                            2,
                            _this.fetch(payURL, {
                                method: "POST",
                                body: body,
                                headers: headers
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "check",
            value: /**
     * Check subscription.
     *
     * See {@link https://integrateur-6play.m6web.fr/v2/openapi/index.html?urls.primaryName=stores#/subscription/post_premium_v4_customers__customerCode__platforms__platformCode__users__uid__stores__storeCode__check|API documentation}.
     *
     * @async
     * @param {Object} options Check parameters (user, storeCode, receipt)
     * @returns {Object}
     * @tutorial ./doc/check.md
     */ function check(param) {
                var UID = param.UID, storeCode = param.storeCode, receipt = param.receipt, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                var _this = this;
                return _async_to_generator._(function() {
                    var body, checkURL;
                    return _ts_generator._(this, function(_state) {
                        _this.checkInit();
                        if (!UID) {
                            throw new Error("You should provide a non null uid");
                        }
                        body = (0, pickBy_1.default)({
                            receipt: receipt
                        });
                        checkURL = "".concat(fido_1.fido.getBaseUrl("stores"), "/customers/").concat(fido_1.fido.get("customerCode"), "/platforms/").concat(fido_1.fido.get("platformCode"), "/users/").concat(UID, "/stores/").concat(storeCode, "/check");
                        return [
                            2,
                            _this.fetch(checkURL, {
                                method: "POST",
                                body: body,
                                headers: headers
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "initPaymentMeanChange",
            value: /**
     * Initiate change of payment mean
     * @async
     *
     * @param {Object} options Object containing the user and the store code
     * @returns {Object}
     * @tutorial ./doc/initPaymentMeanChange.md
     */ function initPaymentMeanChange(param) {
                var user = param.user, offerCode = param.offerCode, storeCode = param.storeCode, returnUrl = param.returnUrl, paymentMethodType = param.paymentMethodType, paymentMethodCode = param.paymentMethodCode, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                var _this = this;
                return _async_to_generator._(function() {
                    var apiURL, filteredParams, body;
                    return _ts_generator._(this, function(_state) {
                        _this.checkInit();
                        if (!user.UID) {
                            throw new Error("You should provide a non null user uid");
                        }
                        if (!storeCode) {
                            throw new Error("You should provide a non null store code");
                        }
                        apiURL = "".concat(fido_1.fido.getBaseUrl("stores"), "/customers/").concat(fido_1.fido.get("customerCode"), "/platforms/").concat(fido_1.fido.get("platformCode"), "/users/").concat(user.UID, "/stores/").concat(storeCode, "/initPaymentChange");
                        // remove unnecessary falsy values
                        filteredParams = (0, pickBy_1.default)({
                            returnUrl: returnUrl,
                            paymentMethodType: paymentMethodType,
                            paymentMethodCode: paymentMethodCode,
                            offerCode: offerCode
                        });
                        body = Object.keys(filteredParams).reduce(function(acc, paramKey) {
                            return Object.assign(Object.assign({}, acc), _define_property._({}, (0, snakeCase_1.default)(paramKey), filteredParams[paramKey]));
                        }, {});
                        return [
                            2,
                            _this.fetch(apiURL, {
                                method: "POST",
                                headers: headers,
                                body: body
                            })
                        ];
                    });
                })();
            }
        }
    ]);
    return PremiumService;
}(fetcherService_1.FetcherService);
exports.PremiumService = PremiumService;
__decorate([
    withJWT_1.withJWT,
    monitoring
], PremiumService.prototype, "getOffers", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], PremiumService.prototype, "getOrder", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], PremiumService.prototype, "changeOffer", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], PremiumService.prototype, "cancelDowngrade", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], PremiumService.prototype, "getUserAccess", null);
__decorate([
    withJWT_1.withJWT,
    caching_1.withNoParallelRequest,
    monitoring
], PremiumService.prototype, "getUserSubscriptions", null);
__decorate([
    withJWT_1.withJWT,
    caching_1.withNoParallelRequest,
    monitoring
], PremiumService.prototype, "getUserSubscriptionsAfterPaymentUpdate", null);
__decorate([
    withJWT_1.withJWT,
    caching_1.withNoParallelRequest,
    monitoring
], PremiumService.prototype, "getUserInvoices", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], PremiumService.prototype, "downloadInvoice", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], PremiumService.prototype, "cancelSubscription", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], PremiumService.prototype, "resumeSubscription", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], PremiumService.prototype, "consumeCouponCode", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], PremiumService.prototype, "verifyCoupon", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], PremiumService.prototype, "pay", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], PremiumService.prototype, "check", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], PremiumService.prototype, "initPaymentMeanChange", null);
exports.premiumService = new PremiumService();


/***/ }),

/***/ 6430:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(3009);
var __decorate = (void 0) && (void 0).__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.programService = void 0;
var fido_1 = __webpack_require__(6446);
var queryParamSerializer_1 = __webpack_require__(21413);
var withJWT_1 = __webpack_require__(62782);
var fetcherService_1 = __webpack_require__(97269);
var withMonitoring_1 = __webpack_require__(89873);
var monitoring = (0, withMonitoring_1.withMonitoring)("program");
/**
 * @module Program
 * @description This service is used to get program details from middleware API
 * @tutorial ./doc/program.md
 */ var ProgramService = /*#__PURE__*/ function(_fetcherService_1_FetcherService) {
    _inherits._(ProgramService, _fetcherService_1_FetcherService);
    var _super = _create_super._(ProgramService);
    function ProgramService() {
        _class_call_check._(this, ProgramService);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.apiType = "middlewarev2";
        return _this;
    }
    _create_class._(ProgramService, [
        {
            /**
     * Initialize the service. If you don't call this method, no other method can be called.
     * @tutorial ./doc/programInit.md
     */ key: "init",
            value: function init() {
                if (!this.isInitialized) {
                    this.basePath = "platforms/".concat(fido_1.fido.get("platformCode"), "/services");
                    this.isInitialized = true;
                }
            }
        },
        {
            key: "fetchByProgramId",
            value: /**
     * Get information about the program designated by the programId.
     *
     * @async
     * @param {Object} options Options for fetching program by ID.
     * @param {string} options.programId Requested program id.
     * @param {string} options.serviceCode Service where the information should be retrieved from.
     * @param {Object} [options.queryParams={}] Extra query parameters. Uses keys/values literally as provided in the object.
     * @param {Object} [options.headers={}] Optional HTTP headers.
     * @returns {Object} Informations about the program.
     * @tutorial ./doc/programFetchByProgramId.md
     */ function fetchByProgramId(param) {
                var programId = param.programId, serviceCode = param.serviceCode, _param_queryParams = param.queryParams, queryParams = _param_queryParams === void 0 ? {} : _param_queryParams, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        if (!programId) {
                            throw new Error("You should provide a non null programId");
                        }
                        return [
                            2,
                            _this.fetch(_this.getRouteUrl("".concat(serviceCode, "/programs/").concat(programId, "?").concat((0, queryParamSerializer_1.serialize)(queryParams))), {
                                method: "GET",
                                headers: headers
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "fetchPrograms",
            value: /**
     * Get a list of programs
     *
     * @async
     * @param {Object} options Options for fetching programs.
     * @param {string} options.serviceCode Service where the information should be retrieved from.
     * @param {string} options.csa Age rating parameter.
     * @param {number} options.offset Starting item for pagination.
     * @param {number} options.limit Maximum number of items to return for pagination.
     * @param {string} [options.firstLetter] Filter programs by their first letter.
     * @param {boolean} [options.withRights=false] Whether to include user rights information.
     * @param {Object} [options.headers={}] Optional HTTP headers.
     * @returns {Object} List of programs.
     * @tutorial ./doc/programFetchPrograms.md
     */ function fetchPrograms(param) {
                var serviceCode = param.serviceCode, csa = param.csa, offset = param.offset, limit = param.limit, firstLetter = param.firstLetter, _param_withRights = param.withRights, withRights = _param_withRights === void 0 ? false : _param_withRights, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!serviceCode) {
                                    throw new Error("You should provide a service code");
                                }
                                if (!csa) {
                                    throw new Error("You should provide a csa code");
                                }
                                if (typeof offset !== "number" || isNaN(offset)) {
                                    throw new Error("You should provide a valid numeric offset");
                                }
                                if (typeof limit !== "number" || isNaN(limit)) {
                                    throw new Error("You should provide a valid numeric limit");
                                }
                                return [
                                    4,
                                    _this.fetchWithResponse(_this.getRouteUrl("".concat(serviceCode, "/programs?csa=").concat(csa, "&offset=").concat(offset, "&limit=").concat(limit).concat(firstLetter ? "&firstLetter=".concat(firstLetter) : "").concat(withRights ? "&with=rights" : "")), {
                                        method: "GET",
                                        headers: headers
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "fetchProgramCountsByLetter",
            value: /**
     * Returns an object containing the numbers of programs for each letter of the alphabet and "@".
     *
     * @async
     * @param {Object} options Options for fetching program counts by letter.
     * @param {string} options.serviceCode Service where the information should be retrieved from.
     * @param {string} options.csa Age rating parameter.
     * @param {Object} [options.headers={}] Optional HTTP headers.
     * @returns {Object} List of programs.
     * @tutorial ./doc/programFetchProgramCountsByLetter.md
     */ function fetchProgramCountsByLetter(param) {
                var serviceCode = param.serviceCode, csa = param.csa, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!serviceCode) {
                                    throw new Error("You should provide a service code");
                                }
                                if (!csa) {
                                    throw new Error("You should provide a csa code");
                                }
                                return [
                                    4,
                                    _this.fetch(_this.getRouteUrl("".concat(serviceCode, "/programs/first-letters?csa=").concat(csa)), {
                                        method: "GET",
                                        headers: headers
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return ProgramService;
}(fetcherService_1.FetcherService);
__decorate([
    withJWT_1.withJWT,
    monitoring
], ProgramService.prototype, "fetchByProgramId", null);
__decorate([
    monitoring
], ProgramService.prototype, "fetchPrograms", null);
__decorate([
    monitoring
], ProgramService.prototype, "fetchProgramCountsByLetter", null);
exports.programService = new ProgramService();


/***/ }),

/***/ 87464:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(65759);
var __decorate = (void 0) && (void 0).__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.searchAiService = exports.SearchAiService = void 0;
var fido_1 = __webpack_require__(6446);
var withJWT_1 = __webpack_require__(62782);
var fetcherService_1 = __webpack_require__(97269);
var withMonitoring_1 = __webpack_require__(89873);
var monitoring = (0, withMonitoring_1.withMonitoring)("searchAi");
/**
 * @module SearchAi
 * @description The Search Ai service will return a query and filters
 * @tutorial ./doc/searchAi.md
 */ var SearchAiService = /*#__PURE__*/ function(_fetcherService_1_FetcherService) {
    _inherits._(SearchAiService, _fetcherService_1_FetcherService);
    var _super = _create_super._(SearchAiService);
    function SearchAiService() {
        _class_call_check._(this, SearchAiService);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.apiType = "searchAi";
        return _this;
    }
    _create_class._(SearchAiService, [
        {
            key: "init",
            value: function init() {
                if (!this.isInitialized) {
                    this.isInitialized = true;
                }
            }
        },
        {
            key: "getSearchAiResults",
            value: function getSearchAiResults(param) {
                var headers = param.headers, query = param.query, filters = param.filters, waitTimeout = param.waitTimeout;
                var _this = this;
                return _async_to_generator._(function() {
                    var searchAiUrl;
                    return _ts_generator._(this, function(_state) {
                        _this.checkInit();
                        searchAiUrl = fido_1.fido.getBaseUrl(_this.apiType);
                        return [
                            2,
                            _this.fetch(searchAiUrl, {
                                method: "POST",
                                headers: headers,
                                body: {
                                    query: query,
                                    filters: filters
                                },
                                waitTimeout: waitTimeout
                            })
                        ];
                    });
                })();
            }
        }
    ]);
    return SearchAiService;
}(fetcherService_1.FetcherService);
exports.SearchAiService = SearchAiService;
__decorate([
    withJWT_1.withJWT,
    monitoring
], SearchAiService.prototype, "getSearchAiResults", null);
exports.searchAiService = new SearchAiService();


/***/ }),

/***/ 30007:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(65759);
__webpack_require__(3009);
var __decorate = (void 0) && (void 0).__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.servicesService = void 0;
var fido_1 = __webpack_require__(6446);
var fetcherService_1 = __webpack_require__(97269);
var withMonitoring_1 = __webpack_require__(89873);
var monitoring = (0, withMonitoring_1.withMonitoring)("services");
/**
 * @module Services
 * @description This service is used to get the service list from middleware API
 */ var ServicesService = /*#__PURE__*/ function(_fetcherService_1_FetcherService) {
    _inherits._(ServicesService, _fetcherService_1_FetcherService);
    var _super = _create_super._(ServicesService);
    function ServicesService() {
        _class_call_check._(this, ServicesService);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.apiType = "middlewarev2";
        return _this;
    }
    _create_class._(ServicesService, [
        {
            /**
     * Initialize the service. If you don't call this method, no other method can be called.
     */ key: "init",
            value: function init() {
                if (!this.isInitialized) {
                    this.basePath = "platforms/".concat(fido_1.fido.get("platformCode"), "/services");
                    this.isInitialized = true;
                }
            }
        },
        {
            key: "fetchServices",
            value: /**
     * Get a list of children services of your root service
     *
     * @async
     * @param {Object} options Options for fetching services.
     * @param {string} options.rootServiceCode Root service code (main entry point of the application, e.g., "6play").
     * @param {boolean} [options.includeAliased] Filter aliased services. If not provided, only not aliased services are returned.
     *   0: Return only not aliased services. 1: Return all the services.
     * @param {Object} [options.headers={}] Optional HTTP headers.
     * @returns {Promise<Array>} Returns an array of services sorted by priority with channels information, can be empty.
     * @throws {Error} Throws an error if rootServiceCode is not provided.
     * @throws {Error} Throws an error with status 404 if root service is not found.
     */ function fetchServices(param) {
                var rootServiceCode = param.rootServiceCode, includeAliased = param.includeAliased, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!rootServiceCode) {
                                    throw new Error("You should provide a root service code");
                                }
                                return [
                                    4,
                                    _this.fetch(_this.getRouteUrl("".concat(rootServiceCode, "/services?sort=priority&with=channels").concat(includeAliased !== undefined ? "&include_aliased=".concat(includeAliased ? 1 : 0) : "")), {
                                        method: "GET",
                                        headers: headers
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "fetchService",
            value: /**
     * Get a single service from its code
     *
     * @async
     * @param {Object} options Options for fetching a service.
     * @param {string} options.serviceCode Service code to retrieve.
     * @param {Object} [options.headers={}] Optional HTTP headers.
     * @returns {Promise<Object>} Returns a single service with channels information.
     * @throws {Error} Throws an error if serviceCode is not provided.
     * @throws {Error} Throws an error with status 404 if service is not found.
     */ function fetchService(param) {
                var serviceCode = param.serviceCode, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!serviceCode) {
                                    throw new Error("You should provide a service code");
                                }
                                return [
                                    4,
                                    _this.fetch(_this.getRouteUrl("".concat(serviceCode, "?with=channels")), {
                                        method: "GET",
                                        headers: headers
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return ServicesService;
}(fetcherService_1.FetcherService);
__decorate([
    monitoring
], ServicesService.prototype, "fetchServices", null);
__decorate([
    monitoring
], ServicesService.prototype, "fetchService", null);
exports.servicesService = new ServicesService();


/***/ }),

/***/ 43889:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(65759);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.SimpleFetcherService = void 0;
var fetch_1 = __webpack_require__(4906);
var withMonitoring_1 = __webpack_require__(89873);
var fetcherService_1 = __webpack_require__(97269);
var SimpleFetcherService = /*#__PURE__*/ function(_fetcherService_1_FetcherService) {
    _inherits._(SimpleFetcherService, _fetcherService_1_FetcherService);
    var _super = _create_super._(SimpleFetcherService);
    function SimpleFetcherService(serviceName) {
        var basePath = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
        _class_call_check._(this, SimpleFetcherService);
        var _this;
        _this = _super.call(this);
        if (!serviceName) {
            throw new Error("You have to instantiate this Fido's service with its name before using it");
        }
        _this.displayName = "".concat(serviceName.charAt(0).toUpperCase() + serviceName.slice(1), "Service");
        _this.apiType = serviceName;
        _this.basePath = basePath;
        return _this;
    }
    _create_class._(SimpleFetcherService, [
        {
            /**
     * Initialize the service. If you don't call this method, no other method can be called.
     */ key: "init",
            value: function init() {
                if (!this.isInitialized) {
                    this.isInitialized = true;
                    this.monitored = (0, withMonitoring_1.withMonitoring)(this.apiType);
                }
            }
        },
        {
            /**
     * Call the endpoint of the service and return the response.
     *
     * @async
     * @param {Object=} options Contains a `headers` key to add some headers in the request.
     * @returns {Object} The response object.
     */ key: "fetch",
            value: function fetch() {
                var headers = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).headers;
                var url = this.getRouteUrl();
                return this.monitored(SimpleFetcherService.prototype, "fetch", {
                    value: function() {
                        return (0, fetch_1.fetch)(url, {
                            method: "GET",
                            headers: headers
                        }).then(function(param) {
                            var body = param.body;
                            return body;
                        });
                    }
                }).value();
            }
        }
    ]);
    return SimpleFetcherService;
}(fetcherService_1.FetcherService);
exports.SimpleFetcherService = SimpleFetcherService;


/***/ }),

/***/ 20160:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _to_consumable_array = __webpack_require__(30005);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(42578);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.AbstractThirdPartyInterface = void 0;
var constants_1 = __webpack_require__(67694);
/**
 * @module AbstractThirdPartyInterface
 * @description ThirdPartyController engines methods subscriptions.
 * @abstract
 */ // eslint-disable-next-line @typescript-eslint/no-unsafe-declaration-merging
var AbstractThirdPartyInterface = /*#__PURE__*/ function() {
    function AbstractThirdPartyInterface() {
        _class_call_check._(this, AbstractThirdPartyInterface);
    }
    _create_class._(AbstractThirdPartyInterface, [
        {
            key: "getAdTargeting",
            value: /**
     * Triggers every getAdTargeting methods in initialized engines.
     */ function getAdTargeting() {
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        return [
                            2,
                            Promise.all(_this.callEnginesMethod("getAdTargeting")()).then(function(targetings) {
                                return targetings.reduce(function(finalTargeting, targeting) {
                                    return Object.assign(Object.assign({}, finalTargeting), targeting);
                                }, {});
                            })
                        ];
                    });
                })();
            }
        }
    ]);
    return AbstractThirdPartyInterface;
}();
exports.AbstractThirdPartyInterface = AbstractThirdPartyInterface;
Object.keys(constants_1.ENGINES_EVENT_METHODS).forEach(function(key) {
    AbstractThirdPartyInterface.prototype[key] = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return this.callEnginesEventMethod(constants_1.ENGINES_EVENT_METHODS[key]).apply(this, _to_consumable_array._(args));
    };
});
Object.keys(constants_1.ENGINES_METHODS).forEach(function(key) {
    AbstractThirdPartyInterface.prototype[key] = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return this.callEnginesMethod(constants_1.ENGINES_METHODS[key]).apply(this, _to_consumable_array._(args));
    };
});


/***/ }),

/***/ 67694:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(45538);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.TEALIUM_MAPPING = exports.ENGINES_METHODS = exports.ENGINES_EVENT_METHODS = exports.DEPENDANT_ENGINES = exports.DEFAULT_INIT_DELAY_IN_MS = exports.NAMESPACE_ERROR = exports.MOCK_THIRDPARTY_OBJECT_KEY = void 0;
exports.MOCK_THIRDPARTY_OBJECT_KEY = "thirdParties";
exports.NAMESPACE_ERROR = "app:thirdParties:error";
exports.DEFAULT_INIT_DELAY_IN_MS = 5000;
exports.DEPENDANT_ENGINES = [
    "googleAds"
];
exports.ENGINES_EVENT_METHODS = {
    sendEvent: "sendEvent",
    sendClickEvent: "sendClickEvent",
    sendPrintEvent: "sendPrintEvent",
    sendImpressionTrackingEvent: "sendImpressionTrackingEvent"
};
exports.ENGINES_METHODS = {
    // Send an error event to the third party engine
    sendErrorEvent: "sendErrorEvent",
    // Track a page display.
    sendPageViewEvent: "sendPageViewEvent",
    // disabledEngine seems to be used to disallow engines when user optout
    disableEngine: "disableEngine",
    getEpics: "getEpics",
    // Called when you login / logout / change profil and provides some data specific for the user like ABTests, UUID, ...
    userChange: "setUser",
    // Called chen the gdpr consents changed
    gdprChange: "gdprChange",
    // Calls the GA engine setContentGroup method with data coming from layout
    setContentGroup: "setContentGroup",
    // Set specific attribute sent to all events
    setCustomAttributes: "setCustomAttributes",
    getCustomAttributes: "getCustomAttributes",
    setEnhancedECommerceAction: "setEnhancedECommerceAction",
    setEnhancedECommerceAddProduct: "setEnhancedECommerceAddProduct",
    setEnhancedECommerceProductCheckout: "setEnhancedECommerceProductCheckout",
    setEnhancedECommerceProductPurchase: "setEnhancedECommerceProductPurchase"
};
/**
 * Definition of mapping between analytics.googleAnalytics parameters to tealium attributes.
 * As Bff is not currently able to return a dedicate analytic node for Server Side Analytics Tealium for now,
 * we need to map attributes names.
 */ exports.TEALIUM_MAPPING = {
    dimension1: "gigya_id",
    dimension2: "device_id",
    dimension3: "ip_hashed",
    dimension4: "bedrock_platform_code",
    dimension5: "authenticated",
    dimension6: "user_type",
    dimension7: "freemium_pack",
    dimension8: "persona",
    dimension9: "auth_method",
    dimension10: "current_entity_type",
    dimension11: "service",
    dimension12: "publication_type",
    dimension13: "clip_type",
    dimension14: "program_category",
    dimension15: "program_title",
    dimension16: "clip_title",
    dimension17: "clip_id",
    dimension18: "player_audio",
    dimension19: "player_subtitles",
    dimension20: "position",
    dimension21: "first_connexion",
    dimension22: "player_screen_mode",
    dimension23: "support",
    dimension24: "template_name",
    dimension25: "cast",
    dimension26: "autoplay",
    dimension27: "switch_language",
    dimension28: "subtitle_active",
    dimension29: "from",
    dimension30: "ad_blocker",
    dimension31: "block_title",
    dimension32: "profile_id",
    dimension33: "layout_id",
    dimension34: "user_status",
    dimension35: "section",
    dimension36: "user_segments",
    dimension37: "operator",
    dimension38: "tv_brand",
    dimension39: "user_agent",
    dimension40: "tv_year",
    dimension41: "connection_type",
    dimension42: "device_orientation",
    dimension43: "app_version",
    dimension44: "app_os_version",
    dimension45: "network_id",
    dimension46: "block_rank",
    dimension47: "box_type",
    dimension48: "survey_id",
    dimension49: "app_referer",
    dimension50: "heartbeat_session",
    dimension51: "a_b_test",
    dimension52: "next_video",
    dimension53: "current_entity_id",
    dimension54: "player_current_timecode",
    dimension55: "airplay",
    dimension56: "picture_in_picture",
    dimension57: "offers_name",
    dimension58: "previous_offers",
    dimension59: "user_age",
    dimension60: "user_gender",
    dimension61: "user_offer",
    dimension62: "user_offers_number",
    dimension63: "gdpr_consent_tracking",
    dimension64: "gdpr_consent_adtargeting",
    dimension65: "age_restriction",
    dimension66: "consent_level",
    dimension67: "timestamp",
    dimension68: "analytics_cookie_value",
    dimension69: "current_page_group_types",
    dimension70: "device_model",
    dimension71: "content_status",
    dimension72: "salesforce_user_id",
    dimension73: "program_customer_key_id",
    dimension74: "special_event_name",
    dimension75: "clip_customer_key_id",
    eventAction: "event_action",
    eventLabel: "event_label",
    eventCategory: "event_category",
    listOfBlockViewed: "list_of_block_viewed",
    listOfItemViewed: "list_of_item_viewed",
    pageName: "page_name"
};


/***/ }),

/***/ 11067:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(52318);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.eventQueue = exports.EventQueue = void 0;
/**
 * @module EventQueue
 * @description EventQueue is dealing with the third party events queuing.
 * @abstract
 */ var EventQueue = /*#__PURE__*/ function() {
    function EventQueue() {
        var _this = this;
        _class_call_check._(this, EventQueue);
        /**
         * @param {ThirdParty} thirdParty
         * @returns {Boolean}
         */ this.commitEventQueueIfReady = function(thirdParty) {
            if (typeof thirdParty.engine !== "function" && (typeof thirdParty.engine.isReady !== "function" || thirdParty.engine.isReady() && thirdParty.eventQueue.length)) {
                if (thirdParty.eventQueueTimeout) {
                    clearTimeout(thirdParty.eventQueueTimeout);
                }
                while(thirdParty.eventQueue.length > 0){
                    thirdParty.eventQueue.pop()(thirdParty);
                }
                return true;
            }
            return false;
        };
        /**
         * Push an event to the third party queue
         * @param {ThirdParty} thirdParty
         * @param {any} e event
         */ this.queueEvent = function(thirdParty, e) {
            thirdParty.eventQueue.push(e);
            if (typeof thirdParty.engine !== "function" && typeof thirdParty.engine.isReady === "function" && !thirdParty.engine.isReady() && !thirdParty.eventQueueTimeout) {
                thirdParty.eventQueueTimeout = setTimeout(function() {
                    return _this.commitEventQueueIfReady(thirdParty);
                }, _this.queueDelay);
            }
        };
        /**
         * Clear event queue for each third party
         */ this.flushEvents = function() {
            var thirdParties = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
            return thirdParties.forEach(function(thirdParty) {
                thirdParty.eventQueue = [];
            });
        };
    }
    _create_class._(EventQueue, [
        {
            key: "init",
            value: function init(param) {
                var trackingInitDelay = param.trackingInitDelay;
                this.queueDelay = trackingInitDelay;
            }
        }
    ]);
    return EventQueue;
}();
exports.EventQueue = EventQueue;
exports.eventQueue = new EventQueue();


/***/ }),

/***/ 94984:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _assert_this_initialized = __webpack_require__(99561);
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _to_consumable_array = __webpack_require__(30005);
var _create_super = __webpack_require__(6400);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
var __rest = (void 0) && (void 0).__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++){
        if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var __importDefault = (void 0) && (void 0).__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.thirdPartyControllerService = exports.ThirdPartyControllerService = exports.ENGINE_OVERRIDE_ERROR_MESSAGE = exports.INIT_ERROR_MESSAGE = void 0;
var get_1 = __importDefault(__webpack_require__(65439));
var has_1 = __importDefault(__webpack_require__(56611));
var noop_1 = __importDefault(__webpack_require__(43226));
var set_1 = __importDefault(__webpack_require__(35609));
var uuid_1 = __webpack_require__(16060);
var abstractThirdPartyInterface_1 = __webpack_require__(20160);
var constants_1 = __webpack_require__(67694);
var eventQueue_1 = __webpack_require__(11067);
var utils_1 = __webpack_require__(65844);
var DEFAULT_OPTIONS = {
    // eslint-disable-next-line no-console
    logger: console.info,
    sendErrorToMonitoring: noop_1.default,
    isRecording: false,
    detectBlocker: noop_1.default
};
var DEFAULT_CONFIG = {
    taggingPlans: {},
    initTrackingDelay: constants_1.DEFAULT_INIT_DELAY_IN_MS
};
exports.INIT_ERROR_MESSAGE = 'Every third party should be given a "name" and a "key" property';
exports.ENGINE_OVERRIDE_ERROR_MESSAGE = 'When thirdparty has a pre-defined "engine" property, it must be a function';
/**
 * A third party
 * @typedef {{
 *  name: string,
 *  key: string,
 *  bootMethod: function|Promise<function>,
 *  bootModule: object,
 *  taggingPlan: object,
 *  initParams: object|function,
 *  engine: function
 * }} ThirdParty
 */ /**
 * @module ThirdPartyControllerService
 * @description Third party services controller
 * @tutorial ./doc/thirdPartyControllerService.md
 */ var ThirdPartyControllerService = /*#__PURE__*/ function(_abstractThirdPartyInterface_1_AbstractThirdPartyInterface) {
    _inherits._(ThirdPartyControllerService, _abstractThirdPartyInterface_1_AbstractThirdPartyInterface);
    var _super = _create_super._(ThirdPartyControllerService);
    function ThirdPartyControllerService() {
        var _this = this;
        _class_call_check._(this, ThirdPartyControllerService);
        var _this1;
        _this1 = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this1.thirdParties = [];
        /**
         * Initialize third parties
         * @param {Object[]} thirdParties Third parties objects.
         * @returns {ThirdParty[]}
         */ _this1.initializeThirdParties = function(thirdParties) {
            return thirdParties.map(function(_a) {
                var name = _a.name, bootMethod = _a.bootMethod, engine = _a.engine, rest = __rest(_a, [
                    "name",
                    "bootMethod",
                    "engine"
                ]);
                return Object.assign({
                    name: name,
                    initialized: false,
                    rejected: false,
                    boot: bootMethod,
                    engine: engine || (0, utils_1.lazyLoadEngine)(name),
                    eventQueue: [],
                    eventQueueTimeout: null
                }, rest);
            });
        };
        var _this2 = _assert_this_initialized._(_this1);
        /**
         * The method to use to load and activate engines.
         * @param {string[]} acceptedThirdParties The accepted engines (gdpr consented) to init.
         * @returns {Promise<Object[]>} An array of engines objects.
         */ _this1.initThirdPartyEngines = function() {
            var _ref = _async_to_generator._(function(acceptedThirdParties) {
                var enginesStarting, higherPriorityEngines, lowerPriorityEngines;
                return _ts_generator._(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            enginesStarting = _this2.thirdParties.filter(function(param) {
                                var name = param.name, initialized = param.initialized;
                                return acceptedThirdParties.includes(name) && !initialized;
                            });
                            _this2.logger("Starting engines", enginesStarting);
                            higherPriorityEngines = enginesStarting.filter(function(param) {
                                var name = param.name;
                                return !constants_1.DEPENDANT_ENGINES.includes(name);
                            });
                            lowerPriorityEngines = enginesStarting.filter(function(param) {
                                var name = param.name;
                                return constants_1.DEPENDANT_ENGINES.includes(name);
                            });
                            return [
                                4,
                                _this2.loadThirdParties(higherPriorityEngines)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                4,
                                _this2.loadThirdParties(lowerPriorityEngines)
                            ];
                        case 2:
                            _state.sent();
                            return [
                                2,
                                _to_consumable_array._(higherPriorityEngines).concat(_to_consumable_array._(lowerPriorityEngines)).map(function(thirdParty) {
                                    return eventQueue_1.eventQueue.commitEventQueueIfReady(thirdParty);
                                })
                            ];
                    }
                });
            });
            return function(acceptedThirdParties) {
                return _ref.apply(this, arguments);
            };
        }();
        /**
         * Set engines passed as params as rejected.
         * They will not be called
         * @param {string[]} rejectedThirdParties
         */ _this1.rejectThirdPartyEngines = function(rejectedThirdParties) {
            _this1.thirdParties.filter(function(param) {
                var name = param.name;
                return rejectedThirdParties.includes(name);
            }).forEach(function(engine) {
                engine.rejected = true;
                engine.eventQueue = [];
            });
        };
        /**
         * callEnginesEventMethod is a bridge to every engines "event" methods.
         * It will call every engines that implement the requested method.
         *
         * @param {string} method the method name.
         * @returns {false|undefined}
         */ _this1.callEnginesEventMethod = function(method) {
            return function(taggingEvent, action, customAttributes) {
                return (0, utils_1.getActiveEngineWithMethod)(_this1.thirdParties, method).map(function(thirdParty) {
                    var taggingPlan = thirdParty.taggingPlan || _this1.config.taggingPlans;
                    var stdEvent = (0, utils_1.getFormattedEvent)(taggingEvent, thirdParty);
                    eventQueue_1.eventQueue.queueEvent(thirdParty, function(latestThirdParty) {
                        if (_this1.isRecording) {
                            (0, utils_1.storeCallForMock)(thirdParty.name, method, stdEvent, action, {
                                eventKey: (0, get_1.default)(taggingPlan, stdEvent.key)
                            }, customAttributes);
                        }
                        // It is important to use latestThirdParty.engine[method] directly otherwise we loose reference of the engine's "this"
                        return (0, get_1.default)(latestThirdParty.engine, method) && latestThirdParty.engine[method](stdEvent, action, (0, get_1.default)(taggingPlan, stdEvent.key), customAttributes);
                    });
                    if (thirdParty.initialized) {
                        return eventQueue_1.eventQueue.commitEventQueueIfReady(thirdParty);
                    }
                    return false;
                });
            };
        };
        _this1.callEnginesMethod = function(method) {
            return function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                return (0, utils_1.getActiveEngineWithMethod)(_this1.thirdParties, method).map(function(thirdParty) {
                    var engine = thirdParty.engine, initialized = thirdParty.initialized, name = thirdParty.name;
                    var engineArgs = (0, get_1.default)(args, [
                        name
                    ], args);
                    if (_this1.isRecording) {
                        engineArgs.push({
                            uuid: (0, uuid_1.v4)()
                        });
                    }
                    if (initialized || engine.doNotQueue) {
                        var _engine;
                        if (_this1.isRecording) {
                            (0, utils_1.storeCallForMock).apply(_this, [
                                name,
                                method
                            ].concat(_to_consumable_array._(engineArgs)));
                        }
                        return (_engine = engine)[method].apply(_engine, _to_consumable_array._(engineArgs));
                    }
                    return eventQueue_1.eventQueue.queueEvent(thirdParty, function(latestThirdParty) {
                        var _latestThirdParty_engine;
                        if (_this1.isRecording) {
                            (0, utils_1.storeCallForMock).apply(_this, [
                                name,
                                method
                            ].concat(_to_consumable_array._(engineArgs)));
                        }
                        // It is important to use latestThirdParty.engine[method] directly otherwise we loose reference of the engine's "this"
                        return (0, get_1.default)(latestThirdParty.engine, method) && (_latestThirdParty_engine = latestThirdParty.engine)[method].apply(_latestThirdParty_engine, _to_consumable_array._(engineArgs));
                    });
                });
            };
        };
        return _this1;
    }
    _create_class._(ThirdPartyControllerService, [
        {
            /**
     * Initialize the service.
     *
     * @param {Object} param The only argument.
     * @param {ThirdParty[]} param.thirdParties A list of third parties object.
     * @param {{taggingPlans: Object, initTrackingDelay: number}} param.config The service config.
     * @param {{logger: Function, sendErrorToMonitoring: Function, isRecording: boolean}} param.options The service options.
     * @return {Promise<void>}
     * @tutorial ./doc/thirdPartyControllerService.md
     */ key: "init",
            value: function init(param) {
                var _param_thirdParties = param.thirdParties, thirdParties = _param_thirdParties === void 0 ? this.thirdParties : _param_thirdParties, _param_config = param.config, config = _param_config === void 0 ? DEFAULT_CONFIG : _param_config, options = param.options;
                this.checkInitParams(thirdParties);
                var mergedOptions = Object.assign(Object.assign({}, DEFAULT_OPTIONS), options);
                this.config = config;
                this.logger = mergedOptions.logger;
                this.isRecording = mergedOptions.isRecording;
                eventQueue_1.eventQueue.init(this.config);
                this.monitoring = function(name) {
                    return function(error, eventType) {
                        var sentryParams = {
                            tags: {
                                context: name
                            }
                        };
                        var statsdParams = [
                            name,
                            "error",
                            eventType
                        ];
                        mergedOptions.sendErrorToMonitoring(constants_1.NAMESPACE_ERROR, error, sentryParams, statsdParams);
                    };
                };
                this.detectBlocker = function(name) {
                    return function(value) {
                        mergedOptions.detectBlocker(name, value);
                    };
                };
                this.thirdParties = this.initializeThirdParties(thirdParties);
            }
        },
        {
            /**
     * Verify third parties contains keys `key` and `name`
     * @param {ThirdParty[]} thirdParties
     */ key: "checkInitParams",
            value: function checkInitParams(thirdParties) {
                thirdParties.forEach(function(_a) {
                    var name = _a.name, key = _a.key, thirdParty = __rest(_a, [
                        "name",
                        "key"
                    ]);
                    if (!key || !name) {
                        throw new Error(exports.INIT_ERROR_MESSAGE);
                    }
                    // make sure engine is not overriden by a falsy value
                    if ((0, has_1.default)(thirdParty, "engine") && typeof thirdParty.engine !== "function") {
                        throw new Error(exports.ENGINE_OVERRIDE_ERROR_MESSAGE);
                    }
                });
            }
        },
        {
            /**
     * Load third parties engines
     * @param enginesStarting
     * @returns {Promise<void>}
     */ key: "loadThirdParties",
            value: function loadThirdParties(enginesStarting) {
                var _this = this;
                return Promise.all(enginesStarting.map(function() {
                    var _ref = _async_to_generator._(function(thirdParty) {
                        var engine, bootModule, boot, name, initParams, key, builtInitParams;
                        return _ts_generator._(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        thirdParty.engine()
                                    ];
                                case 1:
                                    // Load the engine first
                                    thirdParty.engine = _state.sent();
                                    engine = thirdParty.engine, bootModule = thirdParty.bootModule, boot = thirdParty.boot, name = thirdParty.name, initParams = thirdParty.initParams, key = thirdParty.key;
                                    // augments the engine with necessary properties and methods
                                    engine.thirdPartyKey = key;
                                    engine.isRecording = _this.isRecording;
                                    engine.sendErrorToMonitoring = _this.monitoring(name);
                                    engine.detectBlocker = _this.detectBlocker(name);
                                    builtInitParams = typeof initParams === "function" ? initParams() : initParams;
                                    if (!(bootModule && bootModule.default && typeof bootModule.default === "function")) return [
                                        3,
                                        2
                                    ];
                                    bootModule.default(builtInitParams);
                                    return [
                                        3,
                                        4
                                    ];
                                case 2:
                                    if (!boot) return [
                                        3,
                                        4
                                    ];
                                    return [
                                        4,
                                        boot()
                                    ];
                                case 3:
                                    _state.sent();
                                    _state.label = 4;
                                case 4:
                                    _this.logger("app:thirdparty:boot: ".concat(name));
                                    if (_this.isRecording) {
                                        (0, set_1.default)(window, "".concat(constants_1.MOCK_THIRDPARTY_OBJECT_KEY, ".").concat(name), []);
                                    }
                                    if (!(typeof engine.init === "function")) return [
                                        3,
                                        6
                                    ];
                                    if (_this.isRecording) {
                                        (0, utils_1.storeCallForMock)(name, "fido:boot", builtInitParams);
                                    }
                                    return [
                                        4,
                                        engine.init(builtInitParams)
                                    ];
                                case 5:
                                    _state.sent();
                                    return [
                                        3,
                                        7
                                    ];
                                case 6:
                                    if (_this.isRecording) {
                                        (0, utils_1.storeCallForMock)(name, "fido:boot:no-init");
                                    }
                                    _state.label = 7;
                                case 7:
                                    thirdParty.initialized = true;
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(thirdParty) {
                        return _ref.apply(this, arguments);
                    };
                }()));
            }
        },
        {
            key: "flushEvents",
            value: function flushEvents() {
                return eventQueue_1.eventQueue.flushEvents(this.thirdParties);
            }
        }
    ]);
    return ThirdPartyControllerService;
}(abstractThirdPartyInterface_1.AbstractThirdPartyInterface);
exports.ThirdPartyControllerService = ThirdPartyControllerService;
exports.thirdPartyControllerService = new ThirdPartyControllerService();


/***/ }),

/***/ 67300:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _assert_this_initialized = __webpack_require__(99561);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _get = __webpack_require__(60528);
var _get_prototype_of = __webpack_require__(35196);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(37815);
var __importDefault = (void 0) && (void 0).__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.thirdPartyWithLayoutService = void 0;
var get_1 = __importDefault(__webpack_require__(65439));
var merge_1 = __importDefault(__webpack_require__(67929));
var connectAction_1 = __webpack_require__(24432);
var thirdPartyControllerService_1 = __webpack_require__(94984);
/**
 * @module ThirdPartyWithLayout
 * @description Same as the Third Party service but has to be used in combination with the LayoutForThirdPartyService to add layout custom attributes automatically to the third party requests.
 * @tutorial ./doc/thirdPartyWithLayoutService.md
 */ var ThirdPartyWithLayoutService = /*#__PURE__*/ function(_thirdPartyControllerService_1_ThirdPartyControllerService) {
    _inherits._(ThirdPartyWithLayoutService, _thirdPartyControllerService_1_ThirdPartyControllerService);
    var _super = _create_super._(ThirdPartyWithLayoutService);
    function ThirdPartyWithLayoutService() {
        _class_call_check._(this, ThirdPartyWithLayoutService);
        var _this;
        _this = _super.call(this);
        var _ref = (0, connectAction_1.connectAction)(_this.sendEventWithLayoutThirdPartyData.bind(_assert_this_initialized._(_this))), connectedSendEvent = _ref.connectedAction, waitForSendEventPromise = _ref.waitForPromise;
        var _ref1 = (0, connectAction_1.connectAction)(_this.sendPageViewEventWithLayoutThirdPartyData.bind(_assert_this_initialized._(_this))), connectedSendPageViewEvent = _ref1.connectedAction, waitForSendPageViewEventPromise = _ref1.waitForPromise;
        var _ref2 = (0, connectAction_1.connectAction)(_this.sendClickEventWithLayoutThirdPartyData.bind(_assert_this_initialized._(_this))), connectedSendClickEvent = _ref2.connectedAction, waitForSendClickEvent = _ref2.waitForPromise;
        var _ref3 = (0, connectAction_1.connectAction)(_this.sendPrintEventWithLayoutThirdPartyData.bind(_assert_this_initialized._(_this))), connectedSendPrintEvent = _ref3.connectedAction, waitForSendPrintEvent = _ref3.waitForPromise;
        var _ref4 = (0, connectAction_1.connectAction)(_this.sendImpressionTrackingEventWithLayoutThirdPartyData.bind(_assert_this_initialized._(_this))), connectedSendImpressionTrackingEvent = _ref4.connectedAction, waitForSendImpressionTrackingEvent = _ref4.waitForPromise;
        _this.sendEvent = connectedSendEvent;
        _this.sendPageViewEvent = connectedSendPageViewEvent;
        _this.sendClickEvent = connectedSendClickEvent;
        _this.sendPrintEvent = connectedSendPrintEvent;
        _this.sendImpressionTrackingEvent = connectedSendImpressionTrackingEvent;
        _this.waitForPromise = function(promise) {
            waitForSendEventPromise(promise);
            waitForSendPageViewEventPromise(promise);
            waitForSendClickEvent(promise);
            waitForSendPrintEvent(promise);
            waitForSendImpressionTrackingEvent(promise);
            return promise;
        };
        return _this;
    }
    _create_class._(ThirdPartyWithLayoutService, [
        {
            /**
     * DON'T USE, use sendEvent instead
     * @param {*} data
     * @param {*} params
     * @param {*} action
     * @param {*} layoutThirdPartyData
     */ key: "sendEventWithLayoutThirdPartyData",
            value: function sendEventWithLayoutThirdPartyData(data, params, action, layoutThirdPartyData) {
                var _this = this;
                setTimeout(function() {
                    _get._(_get_prototype_of._(ThirdPartyWithLayoutService.prototype), "sendEvent", _this).call(_this, params, action, _this.mergeLayoutThirdPartyData(data, layoutThirdPartyData));
                }, 0);
            }
        },
        {
            /**
     * DON'T USE, use sendPageViewEvent instead
     * @param {*} data
     * @param {*} location
     * @param {*} layoutThirdPartyData
     */ key: "sendPageViewEventWithLayoutThirdPartyData",
            value: function sendPageViewEventWithLayoutThirdPartyData(data, params, location, layoutThirdPartyData) {
                var mergedLayoutThirdPartyData = this.mergeLayoutThirdPartyData(data, layoutThirdPartyData);
                this.callEnginesMethod("setContentGroupsFromLayout")(data, mergedLayoutThirdPartyData);
                _get._(_get_prototype_of._(ThirdPartyWithLayoutService.prototype), "sendPageViewEvent", this).call(this, params, location, mergedLayoutThirdPartyData);
            }
        },
        {
            /**
     * DON'T USE, use sendClickEvent instead
     * @param {*} data
     * @param {*} params
     * @param {*} layoutThirdPartyData
     */ key: "sendClickEventWithLayoutThirdPartyData",
            value: function sendClickEventWithLayoutThirdPartyData(data, params, action, layoutThirdPartyData) {
                var _this = this;
                setTimeout(function() {
                    _get._(_get_prototype_of._(ThirdPartyWithLayoutService.prototype), "sendClickEvent", _this).call(_this, params, action, _this.mergeLayoutThirdPartyData(data, layoutThirdPartyData));
                }, 0);
            }
        },
        {
            /**
     * DON'T USE, use sendPrintEvent instead
     * @param {*} data
     * @param {*} params
     * @param {*} layoutThirdPartyData
     */ key: "sendPrintEventWithLayoutThirdPartyData",
            value: function sendPrintEventWithLayoutThirdPartyData(data, params, action, layoutThirdPartyData) {
                var _this = this;
                setTimeout(function() {
                    _get._(_get_prototype_of._(ThirdPartyWithLayoutService.prototype), "sendPrintEvent", _this).call(_this, params, action, _this.mergeLayoutThirdPartyData(data, layoutThirdPartyData));
                }, 0);
            }
        },
        {
            /**
     * DON'T USE, use sendImpressionTrackingEvent instead
     * @param {*} data
     * @param {*} params
     * @param {*} layoutThirdPartyData
     */ key: "sendImpressionTrackingEventWithLayoutThirdPartyData",
            value: function sendImpressionTrackingEventWithLayoutThirdPartyData(data, params, action, layoutThirdPartyData) {
                var _this = this;
                setTimeout(function() {
                    _get._(_get_prototype_of._(ThirdPartyWithLayoutService.prototype), "sendImpressionTrackingEvent", _this).call(_this, params, action, _this.mergeLayoutThirdPartyData(data, layoutThirdPartyData));
                }, 0);
            }
        },
        {
            /**
     * Merge layout data and third party data
     * @param {{ analytics: object }} layout
     * @param {object} thirdPartyData
     * @returns {object}
     */ key: "mergeLayoutThirdPartyData",
            value: function mergeLayoutThirdPartyData(layout, thirdPartyData) {
                var layoutAnalytics = (0, get_1.default)(layout, "analytics", {});
                return layout ? (0, merge_1.default)({}, layoutAnalytics, thirdPartyData) : thirdPartyData;
            }
        }
    ]);
    return ThirdPartyWithLayoutService;
}(thirdPartyControllerService_1.ThirdPartyControllerService);
exports.thirdPartyWithLayoutService = new ThirdPartyWithLayoutService();


/***/ }),

/***/ 65844:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _async_to_generator = __webpack_require__(24146);
var _define_property = __webpack_require__(21228);
var _interop_require_wildcard = __webpack_require__(95316);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(3009);
var __importDefault = (void 0) && (void 0).__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.waitForGlobal = exports.storeThirdpartyCallForPlayground = exports.sortObject = exports.getCustomAttribute = exports.transformAttributes = exports.getFormattedEvent = exports.getActiveEngineWithMethod = exports.updateMockEvent = exports.storeCallForMock = exports.lazyLoadEngine = exports.generateImagePixel = void 0;
var get_1 = __importDefault(__webpack_require__(65439));
var identity_1 = __importDefault(__webpack_require__(48148));
var isObject_1 = __importDefault(__webpack_require__(36838));
var merge_1 = __importDefault(__webpack_require__(67929));
var omit_1 = __importDefault(__webpack_require__(59245));
var reduce_1 = __importDefault(__webpack_require__(6355));
var set_1 = __importDefault(__webpack_require__(35609));
var uniqueId_1 = __importDefault(__webpack_require__(53274));
var sprintf_js_1 = __webpack_require__(24131);
var fido_1 = __webpack_require__(6446);
var constants_1 = __webpack_require__(67694);
/**
 * Generate a Image object in memory in order to track user with a pixel way.
 *
 * @param url url of the pixel you want to fetch
 */ var generateImagePixel = function(url) {
    new Image().src = url;
};
exports.generateImagePixel = generateImagePixel;
/**
 * Lazy load engine module, same as `requireEngine` but using async import
 * @param {string} name The name of the engine
 * @returns {Object|undefined} The loaded module
 */ var lazyLoadEngine = function(name) {
    return /*#__PURE__*/ _async_to_generator._(function() {
        var module, _a;
        return _ts_generator._(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        Promise.resolve("./engines/".concat(name, ".engine.js")).then(function(p) {
                            return /*#__PURE__*/ _interop_require_wildcard._(__webpack_require__(97978)(p));
                        })
                    ];
                case 1:
                    module = _state.sent();
                    return [
                        2,
                        module.default
                    ];
                case 2:
                    _a = _state.sent();
                    return [
                        2,
                        undefined
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
};
exports.lazyLoadEngine = lazyLoadEngine;
var mergeObject = function(array) {
    return (0, reduce_1.default)(array, function(accumulator, value) {
        if (!value) return accumulator;
        var param = (0, isObject_1.default)(value) ? value : {
            value: value
        };
        return Object.assign(Object.assign({}, accumulator), param);
    }, {});
};
/**
 * Store calls into a global mock on window object
 * @param {string} name
 * @param {string} method
 * @param  {...any} engineArgs
 */ var storeCallForMock = function(name, method) {
    for(var _len = arguments.length, engineArgs = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
        engineArgs[_key - 2] = arguments[_key];
    }
    if (!(0, isObject_1.default)(window[constants_1.MOCK_THIRDPARTY_OBJECT_KEY])) {
        return;
    }
    if (!window[constants_1.MOCK_THIRDPARTY_OBJECT_KEY][name]) {
        (0, set_1.default)(window[constants_1.MOCK_THIRDPARTY_OBJECT_KEY], name, []);
    }
    var timestamp = fido_1.fido.get("getCurrentTime")();
    var finalArgs = engineArgs.map(function(arg) {
        var eventKey = (0, get_1.default)(arg, "eventKey");
        if (!(0, isObject_1.default)(eventKey)) return arg;
        var stdEvent = engineArgs[0];
        return {
            eventKey: Object.assign(Object.assign({}, eventKey), {
                label: (0, sprintf_js_1.sprintf)(eventKey.label, stdEvent),
                action: (0, sprintf_js_1.sprintf)(eventKey.action, stdEvent)
            })
        };
    });
    window[constants_1.MOCK_THIRDPARTY_OBJECT_KEY][name].push(Object.assign({
        mockUID: (0, uniqueId_1.default)(),
        name: name,
        timestamp: timestamp,
        method: method
    }, mergeObject(finalArgs)));
};
exports.storeCallForMock = storeCallForMock;
/**
 * Update mocked events by id
 * @param {string} uuid
 * @param {object} data
 */ var updateMockEvent = function(param, data) {
    var uuid = param.uuid;
    var mockedEvent = Object.values(window[constants_1.MOCK_THIRDPARTY_OBJECT_KEY]).flat().find(function(event) {
        return event.uuid === uuid;
    });
    (0, merge_1.default)(mockedEvent, data);
};
exports.updateMockEvent = updateMockEvent;
/**
 *
 * @param {ThirdParty[]} thirdParties
 * @param {string} method
 * @returns {ThirdParty[]} Third parties that are allowed by user consents and possess method
 */ var getActiveEngineWithMethod = function() {
    var thirdParties = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], method = arguments.length > 1 ? arguments[1] : void 0;
    return thirdParties.filter(function(param) {
        var engine = param.engine, rejected = param.rejected, initialized = param.initialized;
        return engine && (!initialized || typeof engine[method] === "function") && !rejected;
    });
};
exports.getActiveEngineWithMethod = getActiveEngineWithMethod;
/**
 *
 * @param {any} event
 * @param {ThirdParty} thirdParty
 * @returns {Object} The std event.
 */ var getFormattedEvent = function(event, thirdParty) {
    // We only need to search in the thirdParty static taggingPlan later
    if (typeof event === "string") {
        return {
            key: event
        };
    }
    var eventEngineAnalytics = (0, get_1.default)(event, [
        "analytics",
        thirdParty.key
    ]);
    // We get the event from the layout analytics node, but just in case we spread the event
    if (eventEngineAnalytics) {
        return Object.assign(Object.assign({}, (0, omit_1.default)(event, [
            "analytics"
        ])), eventEngineAnalytics);
    }
    return (0, get_1.default)(event, [
        thirdParty.key
    ], event);
};
exports.getFormattedEvent = getFormattedEvent;
/**
 * Transforms given customAttributes to match the engine schema needs.
 *
 * @param {Object} customAttributes The attributes passed to setCustomAttributes method.
 * @param {Object} attributesKeysMapping An attribute key to engine attribute's key mapping.
 * @param {Object} attributesValuesMapping An attribute key to transformer mapping.
 * @returns {Object} The formatted attributes for a given engines.
 *
 * @tutorial ../doc/transformAttributes.md
 */ var transformAttributes = function(customAttributes, attributesKeysMapping, attributesValuesMapping) {
    return (0, reduce_1.default)(customAttributes, function(acc, attributeValue, attributeKey) {
        var correspondingKey = attributesKeysMapping[attributeKey];
        if (!correspondingKey) return acc;
        var correponspondingValue = (0, get_1.default)(attributesValuesMapping, attributeKey, identity_1.default)(attributeValue);
        return Object.assign(Object.assign({}, acc), _define_property._({}, correspondingKey, correponspondingValue));
    }, {});
};
exports.transformAttributes = transformAttributes;
var getCustomAttribute = function(key, customAttributes, attributesKeysMapping) {
    var targetKey = (0, get_1.default)(attributesKeysMapping, key, key);
    return customAttributes[targetKey] ? customAttributes[targetKey] : undefined;
};
exports.getCustomAttribute = getCustomAttribute;
var sortObject = function(unorderedObject) {
    return Object.keys(unorderedObject).sort().reduce(function(object, key) {
        object[key] = unorderedObject[key];
        return object;
    }, {});
};
exports.sortObject = sortObject;
var storeThirdpartyCallForPlayground = function(param) {
    var name = param.name, isRecording = param.isRecording, status = param.status, data = param.data;
    if (!isRecording) {
        return;
    }
    var THIRD_PARTY_OBJECT = "".concat(name, "Calls");
    if (!(0, isObject_1.default)(window[THIRD_PARTY_OBJECT])) {
        (0, set_1.default)(window, THIRD_PARTY_OBJECT, []);
    }
    var timestamp = fido_1.fido.get("getCurrentTime")();
    window[THIRD_PARTY_OBJECT].push({
        mockUID: (0, uniqueId_1.default)(),
        timestamp: timestamp,
        status: status,
        data: data
    });
};
exports.storeThirdpartyCallForPlayground = storeThirdpartyCallForPlayground;
var waitForGlobal = function(globalKey) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_iterationTime = _ref.iterationTime, iterationTime = _ref_iterationTime === void 0 ? 200 : _ref_iterationTime, _ref_retries = _ref.retries, retries = _ref_retries === void 0 ? 10 : _ref_retries;
    return new Promise(function(resolve, reject) {
        var iterations = retries;
        var intervalId = setInterval(function() {
            if (window[globalKey]) {
                clearInterval(intervalId);
                resolve();
            } else {
                iterations -= 1;
                if (iterations === 0) {
                    clearInterval(intervalId);
                    // eslint-disable-next-line prefer-promise-reject-errors
                    reject();
                }
            }
        }, iterationTime);
    });
};
exports.waitForGlobal = waitForGlobal;


/***/ }),

/***/ 27059:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(65759);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.timeService = void 0;
var simpleFetcherService_1 = __webpack_require__(43889);
/**
 * @module Time
 * @augments SimpleFetcherService
 * @description The Time service is used to retrieve the server time.
 * @tutorial ./doc/time.md
 */ exports.timeService = new simpleFetcherService_1.SimpleFetcherService("time");


/***/ }),

/***/ 79978:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(52318);
var __decorate = (void 0) && (void 0).__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.upFrontTokenService = void 0;
var fido_1 = __webpack_require__(6446);
var queryParamSerializer_1 = __webpack_require__(21413);
var retryRequest_1 = __webpack_require__(25991);
var security_1 = __webpack_require__(6790);
var withJWT_1 = __webpack_require__(62782);
var fetcherService_1 = __webpack_require__(97269);
var withMonitoring_1 = __webpack_require__(89873);
var monitoring = (0, withMonitoring_1.withMonitoring)("token");
/**
 * @module UpFrontToken
 * @description The UpFrontToken service is used to fetch upFrontToken Token for DRM.
 * @tutorial ./doc/upFrontTokenService.md
 */ var UpFrontTokenService = /*#__PURE__*/ function(_fetcherService_1_FetcherService) {
    _inherits._(UpFrontTokenService, _fetcherService_1_FetcherService);
    var _super = _create_super._(UpFrontTokenService);
    function UpFrontTokenService() {
        _class_call_check._(this, UpFrontTokenService);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.apiType = "drm";
        return _this;
    }
    _create_class._(UpFrontTokenService, [
        {
            /**
     * Initialize the service. If you don't call this method, no other method can be called.
     * This init method will construct an attribute `deviceid`, which will be used to replace the missing user.UID
     * Init also the base path with the current platform
     */ key: "init",
            value: function init() {
                var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_retry = _ref.retry, retry = _ref_retry === void 0 ? 0 : _ref_retry;
                if (!this.isInitialized) {
                    this.basePath = "customers/".concat(fido_1.fido.get("customerCode"), "/platforms/").concat(fido_1.fido.get("platformCode"));
                    this.getCurrentTime = fido_1.fido.get("getCurrentTime");
                    this.isInitialized = true;
                    this.retryOptions = (0, retryRequest_1.buildRetryOptions)({
                        apiType: this.apiType,
                        count: retry
                    });
                }
            }
        },
        {
            /**
     * Fetch a up front token for video
     * @async
     * @param {Object} param to fetch the token
     * @return {Object} with token props
     */ key: "getVideoToken",
            value: function getVideoToken(param) {
                var videoId = param.videoId;
                return this.getToken("/videos/".concat(videoId, "/upfront-token"), param);
            }
        },
        {
            /**
     * Fetch a up front token for live
     * @async
     * @param {Object} param to fetch the token
     * @return {Object} with token props
     */ key: "getLiveToken",
            value: function getLiveToken(param) {
                var channelCode = param.channelCode;
                return this.getToken("/live/".concat(channelCode, "/upfront-token"), param);
            }
        },
        {
            /**
     * Fetch a up front token
     * @async
     * @param {Object} target service to call
     * @param {Object} param to fetch the token
     * @return {Object} with token props
     */ key: "getToken",
            value: function getToken(target, param) {
                var user = param.user, service = param.service, _param_randomize = param.randomize, randomize = _param_randomize === void 0 ? false : _param_randomize, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                var userId = user ? user.UID : this.getHomeOrDeviceId(true);
                var query = randomize ? "?".concat((0, queryParamSerializer_1.serialize)({
                    random: (0, security_1.genGuid)()
                })) : "";
                var endpoint = "services/".concat(service, "/users/").concat(userId);
                var url = this.getRouteUrl(endpoint + target + query);
                return this.fetch(url, {
                    method: "GET",
                    headers: headers,
                    retry: this.retryOptions
                }).then(function(param) {
                    var token = param.token;
                    return token;
                });
            }
        }
    ]);
    return UpFrontTokenService;
}(fetcherService_1.FetcherService);
__decorate([
    withJWT_1.withJWT,
    monitoring
], UpFrontTokenService.prototype, "getVideoToken", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], UpFrontTokenService.prototype, "getLiveToken", null);
exports.upFrontTokenService = new UpFrontTokenService();


/***/ }),

/***/ 18632:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(37815);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.urlHitterService = exports.UrlHitterService = void 0;
var fido_1 = __webpack_require__(6446);
var fetcherService_1 = __webpack_require__(97269);
/**
 * @module UrlHitterService
 * @description The url-hitter service makes possible to group several urls of tracking to hitter in a single call. Convenient for IPTV or mobiles wanting to save calls. You should use one of two routes version : - `/v1` If you send urls through a proxy - `/v2` If you send urls from public IP
 * @tutorial ./doc/urlHitterService.md
 */ var UrlHitterService = /*#__PURE__*/ function(_fetcherService_1_FetcherService) {
    _inherits._(UrlHitterService, _fetcherService_1_FetcherService);
    var _super = _create_super._(UrlHitterService);
    function UrlHitterService() {
        _class_call_check._(this, UrlHitterService);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.apiType = "urlhitter";
        return _this;
    }
    _create_class._(UrlHitterService, [
        {
            /**
     * Initialize the service.
     */ key: "init",
            value: function init() {
                if (!this.isInitialized) {
                    this.isInitialized = true;
                }
            }
        },
        {
            /**
     * Format url to be compatible with urlhitter v1
     *
     * @param {string} url Url to format.
     * @returns {string} formatted url.
     */ key: "formatUrl",
            value: function formatUrl(url) {
                return url.replace(/%/g, "%25").replace(/:/g, "%3A").replace(/\//g, "%2F").replace(/\?/g, "%3F").replace(/=/g, "%3D").replace(/&/g, "%26");
            }
        },
        {
            /**
     * Send hits with v1 through a proxy
     *
     * @param {string[]} urls List of url to hit.
     * @param {string} userAgent of the current platform.
     * @returns {Promise}
     */ key: "hitV1",
            value: function hitV1(urls, userAgent) {
                var _this = this;
                var body = urls.map(function(url) {
                    return "hitUrl[url][]=".concat(_this.formatUrl(url));
                }).join("&");
                body = "".concat(body, "&hitUrl[userAgent]=").concat(userAgent);
                body = body.replace(/\[/g, "%5B").replace(/\]/g, "%5D");
                return this.fetch(this.getRouteUrl("hits"), {
                    method: "POST",
                    body: body,
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded"
                    }
                });
            }
        },
        {
            /**
     * Send hits with v2 from public IP
     *
     * @param {string[]} urls List of url to hit.
     * @param {string} userAgent of the current platform.
     * @returns {Promise}
     */ key: "hitV2",
            value: function hitV2(urls, userAgent) {
                var url = this.getRouteUrl("platforms/".concat(fido_1.fido.get("platformCode"), "/hits"));
                return this.fetch(url, {
                    method: "POST",
                    body: JSON.stringify({
                        userAgent: userAgent,
                        urls: urls
                    })
                });
            }
        },
        {
            /**
     * Dispatch to send hit with v1 or v2 of urlhitter
     *
     * @param {string[]} urls List of url to hit.
     * @param {string} userAgent of the current platform.
     * @returns {Promise}
     */ key: "hit",
            value: function hit() {
                var urls = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], userAgent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : fido_1.fido.get("platformCode");
                this.checkInit();
                if (fido_1.fido.getBaseUrl("urlhitter").includes("/v1")) {
                    return this.hitV1(urls, userAgent);
                }
                return this.hitV2(urls, userAgent);
            }
        }
    ]);
    return UrlHitterService;
}(fetcherService_1.FetcherService);
exports.UrlHitterService = UrlHitterService;
exports.urlHitterService = new UrlHitterService();


/***/ }),

/***/ 74552:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(37815);
var __decorate = (void 0) && (void 0).__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.ageRatingService = void 0;
var fido_1 = __webpack_require__(6446);
var withJWT_1 = __webpack_require__(62782);
var fetcherService_1 = __webpack_require__(97269);
var withMonitoring_1 = __webpack_require__(89873);
var monitoring = (0, withMonitoring_1.withMonitoring)("ageRating");
/**
 * @module AgeRating
 * @description The AgeProfil service is used to age ratings details from middleware API
 * @tutorial ./doc/ageRating.md
 */ var AgeRatingService = /*#__PURE__*/ function(_fetcherService_1_FetcherService) {
    _inherits._(AgeRatingService, _fetcherService_1_FetcherService);
    var _super = _create_super._(AgeRatingService);
    function AgeRatingService() {
        _class_call_check._(this, AgeRatingService);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.apiType = "middlewarev2";
        return _this;
    }
    _create_class._(AgeRatingService, [
        {
            /**
     * Initialize the service. If you don't call this method, no other method can be called.
     * @tutorial ./doc/ageRatingInit.md
     */ key: "init",
            value: function init() {
                if (!this.isInitialized) {
                    this.basePath = "platforms/".concat(fido_1.fido.get("platformCode"), "/services");
                    this.isInitialized = true;
                }
            }
        },
        {
            key: "fetchAgeRatings",
            value: /**
     * Get the list of available age ratings.
     *
     * @async
     * @param {Object} params Must contains the service code. Other params are optionals.
     * @returns {Object} The list of available age ratings.
     * @tutorial ./doc/ageRatingList.md
     */ function fetchAgeRatings(param) {
                var _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers, serviceCode = param.serviceCode;
                var _this = this;
                return _async_to_generator._(function() {
                    var route;
                    return _ts_generator._(this, function(_state) {
                        _this.checkInit();
                        if (!serviceCode) {
                            throw new Error("You should provide a service code");
                        }
                        route = _this.getRouteUrl("".concat(serviceCode, "/csas"));
                        return [
                            2,
                            _this.fetch(route, {
                                method: "GET",
                                headers: headers
                            })
                        ];
                    });
                })();
            }
        }
    ]);
    return AgeRatingService;
}(fetcherService_1.FetcherService);
__decorate([
    withJWT_1.withJWT,
    monitoring
], AgeRatingService.prototype, "fetchAgeRatings", null);
exports.ageRatingService = new AgeRatingService();


/***/ }),

/***/ 6360:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(52318);
var __decorate = (void 0) && (void 0).__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.gdprService = void 0;
var fido_1 = __webpack_require__(6446);
var withJWT_1 = __webpack_require__(62782);
var fetcherService_1 = __webpack_require__(97269);
var withMonitoring_1 = __webpack_require__(89873);
var monitoring = (0, withMonitoring_1.withMonitoring)("user");
/**
 * @module Gdpr
 * @description The Gdpr service is used to interact with the 6play user middleware.
 * @tutorial ./doc/gdpr.md
 */ var GdprService = /*#__PURE__*/ function(_fetcherService_1_FetcherService) {
    _inherits._(GdprService, _fetcherService_1_FetcherService);
    var _super = _create_super._(GdprService);
    function GdprService() {
        _class_call_check._(this, GdprService);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.apiType = "userv2";
        return _this;
    }
    _create_class._(GdprService, [
        {
            /**
     * Initialize the service. If you don't call this method, no other method can be called.
     * @tutorial ./doc/gdprInit.md
     */ key: "init",
            value: function init() {
                if (!this.isInitialized) {
                    this.basePath = "platforms/".concat(fido_1.fido.get("platformCode"));
                    this.isInitialized = true;
                }
            }
        },
        {
            /**
     * Sets the user's gdpr preferences.
     *
     * @async
     * @param {Object} options Must contain uid and consents, can contain a headers key, for additionnal headers to attach to the request.
     * @tutorial ./doc/gdprSetUserConsents.md
     */ key: "setUserConsents",
            value: function setUserConsents(param) {
                var uid = param.uid, consents = param.consents, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                if (!uid || !consents) {
                    throw new Error("You should provide an uid and a consents object");
                }
                var endpoint = "users/".concat(uid, "/consents");
                var url = this.getRouteUrl(endpoint);
                return this.fetch(url, {
                    method: "POST",
                    headers: headers,
                    body: consents
                });
            }
        },
        {
            /**
     * Gets the user's gdpr preferences.
     *
     * @async
     * @param {Object} options Must contain uid, can contain a headers key, for additionnal headers to attach to the request.
     * @tutorial ./doc/gdprGetUserConsents.md
     */ key: "getUserConsents",
            value: function getUserConsents(param) {
                var uid = param.uid, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                if (!uid) {
                    throw new Error("You should provide an uid");
                }
                var endpoint = "users/".concat(uid, "/consents");
                var url = this.getRouteUrl(endpoint);
                return this.fetch(url, {
                    method: "GET",
                    headers: headers
                });
            }
        }
    ]);
    return GdprService;
}(fetcherService_1.FetcherService);
__decorate([
    withJWT_1.withJWT,
    monitoring
], GdprService.prototype, "setUserConsents", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], GdprService.prototype, "getUserConsents", null);
exports.gdprService = new GdprService();


/***/ }),

/***/ 17994:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(37815);
var __decorate = (void 0) && (void 0).__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.pairingService = void 0;
var fido_1 = __webpack_require__(6446);
var withJWT_1 = __webpack_require__(62782);
var fetcherService_1 = __webpack_require__(97269);
var withMonitoring_1 = __webpack_require__(89873);
var monitoring = (0, withMonitoring_1.withMonitoring)("user");
/**
 * @module Pairing
 * @description The Pairing service implements methods to deal with users' pairing feature.
 * @tutorial ./doc/pairing.md
 */ var PairingService = /*#__PURE__*/ function(_fetcherService_1_FetcherService) {
    _inherits._(PairingService, _fetcherService_1_FetcherService);
    var _super = _create_super._(PairingService);
    function PairingService() {
        _class_call_check._(this, PairingService);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.apiType = "userv2";
        return _this;
    }
    _create_class._(PairingService, [
        {
            /**
     * Initialize the service. If you don't call this method, no other method can be called.
     *
     * @param {Object} options Service configuration
     * @param {string=} options.boxType Box type used in routes. `clientCode` is used by default
     * @param {boolean=} options.prefixedBoxId Enable prefixing `boxId`
     * @tutorial ./doc/pairingInit.md
     */ key: "init",
            value: function init() {
                var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_boxType = _ref.boxType, boxType = _ref_boxType === void 0 ? fido_1.fido.get("clientCode") : _ref_boxType, _ref_prefixedBoxId = _ref.prefixedBoxId, prefixedBoxId = _ref_prefixedBoxId === void 0 ? false : _ref_prefixedBoxId;
                if (!this.isInitialized) {
                    this.basePath = "platforms/".concat(fido_1.fido.get("platformCode"));
                    this.boxType = boxType;
                    this.prefixedBoxId = prefixedBoxId;
                    this.isInitialized = true;
                }
            }
        },
        {
            /**
     * Return the box ID properly formatted depending on `prefixedBoxId`
     *
     * @return {string} The box ID
     * @tutorial ./doc/pairingGetBoxId.md
     */ key: "getBoxId",
            value: function getBoxId() {
                return this.getHomeOrDeviceId(this.prefixedBoxId);
            }
        },
        {
            /**
     * Get a 5 chars token to show on users device.
     *
     * @async
     * @param {Object=} options Can contain a headers key, with headers to attach to the network call.
     * @param {Object=} options.headers headers to attach to the network call (Optional)
     * @param {String} options.phoneNumber phone number, made of digits, prefixed or not by + (Optional)
     * @param {String} options.boxName Name of the box - will be shown in the account page as the name of the device (Optional)
     * @return {Object} Contains a token key holding the requested token.
     * @tutorial ./doc/pairingGetPairingToken.md
     */ key: "getPairingToken",
            value: function getPairingToken() {
                var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_headers = _ref.headers, headers = _ref_headers === void 0 ? {} : _ref_headers, phoneNumber = _ref.phoneNumber, boxName = _ref.boxName, tokenValidityDurationInMin = _ref.tokenValidityDurationInMin;
                var endpoint = "box";
                var url = this.getRouteUrl(endpoint);
                var body = Object.assign(Object.assign(Object.assign({
                    boxType: this.boxType,
                    boxId: this.getBoxId()
                }, phoneNumber && {
                    phoneNumber: phoneNumber
                }), boxName && {
                    boxName: boxName
                }), tokenValidityDurationInMin && {
                    tokenValidityDurationInMin: tokenValidityDurationInMin
                });
                return this.fetch(url, {
                    method: "POST",
                    body: body,
                    headers: headers
                });
            }
        },
        {
            /**
     * Get the current pairing status of a given token.
     *
     * @async
     * @param {Object} options Contains the token string displayed to the user, and a object of headers to attach to the http request.
     * @return {Object} Contains a status key, eventually an uid, or even a single error object.
     * @tutorial ./doc/pairingGetPairingStatus.md
     */ key: "getPairingStatus",
            value: function getPairingStatus(param) {
                var token = param.token, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                var endpoint = "boxTypes/".concat(this.boxType, "/boxIds/").concat(this.getBoxId(), "/tokens/").concat(token, "/status");
                var url = this.getRouteUrl(endpoint);
                return this.fetch(url, {
                    method: "GET",
                    headers: headers
                });
            }
        },
        {
            /**
     * Add pairing between the given user and the device which received the token.
     *
     * @async
     * @param {Object} params
     * @param {string} params.uid Contains an uid key, the User ID concerned.
     * @param {string} params.token Contains the token string needed to pair the user with the device.
     * @returns {Object} The information about the box paired, including the boxId, boxName and boxType.
     * @tutorial ./doc/pairingPair.md
     */ key: "pair",
            value: function pair(param) {
                var _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers, uid = param.uid, token = param.token;
                if (!uid) {
                    throw new Error("You should provide an uid");
                }
                var endpoint = "users/".concat(uid, "/box");
                var url = this.getRouteUrl(endpoint);
                var body = Object.assign({}, token && {
                    pair_token: token
                });
                return this.fetch(url, {
                    method: "POST",
                    body: body,
                    headers: headers
                });
            }
        },
        {
            /**
     * Delete pairing between the given user and the device running the request. Expect nothing returned but the promise resolution as a confirmation.
     *
     * @async
     * @param {Object} options Contains an uid key, the User ID concerned and can contain a headers key, for additionnal headers to attach to the request.
     * @tutorial ./doc/pairingUnpair.md
     */ key: "unpair",
            value: function unpair(param) {
                var uid = param.uid, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                if (!uid) {
                    throw new Error("You should provide an uid");
                }
                var endpoint = "users/".concat(uid, "/boxTypes/").concat(this.boxType, "/boxIds/").concat(this.getBoxId());
                var url = this.getRouteUrl(endpoint);
                return this.fetch(url, {
                    method: "DELETE",
                    headers: headers
                });
            }
        },
        {
            /**
     * Unpair all devices for the given user
     *
     * @async
     * @param {Object} options Contains an uid key, the User ID concerned and can contain a headers key, for additionnal headers to attach to the request.
     * @tutorial ./doc/pairingUnpairAll.md
     */ key: "unpairAll",
            value: function unpairAll(param) {
                var uid = param.uid, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                if (!uid) {
                    throw new Error("You should provide an uid");
                }
                var endpoint = "users/".concat(uid, "/boxes");
                var url = this.getRouteUrl(endpoint);
                return this.fetch(url, {
                    method: "DELETE",
                    headers: headers
                });
            }
        },
        {
            /**
     * Retrieves the users paired to the deviceId.
     *
     * @async
     * @param {Object} options Can contain a headers key, for additionnal headers to attach to the request.
     * @returns {Object[]} Users paired to this device, as objects.
     * @tutorial ./doc/pairingGetPairedUsers.md
     */ key: "getPairedUsers",
            value: function getPairedUsers(param) {
                var _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                var endpoint = "boxTypes/".concat(this.boxType, "/boxIds/").concat(this.getBoxId(), "/users");
                var url = this.getRouteUrl(endpoint);
                return this.fetch(url, {
                    method: "GET",
                    headers: headers
                });
            }
        },
        {
            /**
     * Retrieves the user profile picture url.
     *
     * @async
     * @param {Object} options Contains an uid key, the User ID concerned and can contain a headers key, for additionnal headers to attach to the request.
     * @returns {string} The user's profile picture url.
     * @tutorial ./doc/pairingGetThumbnail.md
     */ key: "getThumbnail",
            value: function getThumbnail(param) {
                var uid = param.uid, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                if (!uid) {
                    throw new Error("You should provide an uid");
                }
                var endpoint = "boxTypes/".concat(this.boxType, "/boxIds/").concat(this.getBoxId(), "/users/").concat(uid, "/thumbnail");
                var url = this.getRouteUrl(endpoint);
                return this.fetch(url, {
                    method: "GET",
                    headers: headers
                });
            }
        }
    ]);
    return PairingService;
}(fetcherService_1.FetcherService);
__decorate([
    withJWT_1.withJWT,
    monitoring
], PairingService.prototype, "getPairingToken", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], PairingService.prototype, "getPairingStatus", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], PairingService.prototype, "pair", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], PairingService.prototype, "unpair", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], PairingService.prototype, "unpairAll", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], PairingService.prototype, "getPairedUsers", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], PairingService.prototype, "getThumbnail", null);
exports.pairingService = new PairingService();


/***/ }),

/***/ 17989:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(65759);
var __decorate = (void 0) && (void 0).__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.parentalControlService = void 0;
var fido_1 = __webpack_require__(6446);
var withJWT_1 = __webpack_require__(62782);
var fetcherService_1 = __webpack_require__(97269);
var withMonitoring_1 = __webpack_require__(89873);
var monitoring = (0, withMonitoring_1.withMonitoring)("parentalControl");
/**
 * @module ParentalControl
 * @description The ParentalControl service is used to configure the user parental control.
 * @tutorial ./doc/parentalControl.md
 */ var ParentalControlService = /*#__PURE__*/ function(_fetcherService_1_FetcherService) {
    _inherits._(ParentalControlService, _fetcherService_1_FetcherService);
    var _super = _create_super._(ParentalControlService);
    function ParentalControlService() {
        _class_call_check._(this, ParentalControlService);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.apiType = "userv2";
        return _this;
    }
    _create_class._(ParentalControlService, [
        {
            /**
     * Initialize the service. If you don't call this method, no other method can be called.
     * @tutorial ./doc/parentalControlInit.md
     */ key: "init",
            value: function init() {
                if (!this.isInitialized) {
                    this.basePath = "platforms/".concat(fido_1.fido.get("platformCode"));
                    this.isInitialized = true;
                }
            }
        },
        {
            key: "fetchParentalRestriction",
            value: /**
     * Get the current parental restriction applied to the user account
     *
     * @async
     * @param {Object} params Must contains the uid. Other params are optionals.
     * @returns {Object} An object containing the max age rating id and the parental code.
     * @tutorial ./doc/fetchParentalRestriction.md
     */ function fetchParentalRestriction(param) {
                var _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers, uid = param.uid;
                var _this = this;
                return _async_to_generator._(function() {
                    var endpoint, route;
                    return _ts_generator._(this, function(_state) {
                        if (!uid) {
                            throw new Error("You should provide an uid");
                        }
                        endpoint = "users/".concat(uid, "/parentalRestriction?with=code");
                        route = _this.getRouteUrl(endpoint);
                        return [
                            2,
                            _this.fetch(route, {
                                method: "GET",
                                headers: headers
                            }).then(function(data) {
                                return {
                                    code: data.code,
                                    maxCsaCode: data.maxCsaCode,
                                    maxCsaId: data.max_csa_id
                                };
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "applyParentalRestriction",
            value: /**
     * Apply the current parental restriction applied to the user account
     *
     * @async
     * @param {Object} params Must contains the uid of the user, the parental code, the csa max age id and the csa max age code. Other params are optionals.
     * @tutorial ./doc/applyParentalRestriction.md
     */ function applyParentalRestriction(param) {
                var _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers, uid = param.uid, code = param.code, maxCsaCode = param.maxCsaCode, maxCsaId = param.maxCsaId;
                var _this = this;
                return _async_to_generator._(function() {
                    var endpoint, route;
                    return _ts_generator._(this, function(_state) {
                        if (!uid) {
                            throw new Error("You should provide an uid");
                        }
                        endpoint = "users/".concat(uid, "/parentalRestriction");
                        route = _this.getRouteUrl(endpoint);
                        return [
                            2,
                            _this.fetch(route, {
                                method: "POST",
                                headers: headers,
                                body: {
                                    code: code,
                                    maxCsaCode: maxCsaCode,
                                    max_csa_id: maxCsaId
                                }
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "removeParentalRestriction",
            value: /**
     * Remove the current parental restriction applied to the user account
     *
     * @async
     * @param {Object} params Must contains the uid of the user. Other params are optionals.
     * @tutorial ./doc/removeParentalRestriction.md
     */ function removeParentalRestriction(param) {
                var _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers, uid = param.uid;
                var _this = this;
                return _async_to_generator._(function() {
                    var endpoint, route;
                    return _ts_generator._(this, function(_state) {
                        if (!uid) {
                            throw new Error("You should provide an uid");
                        }
                        endpoint = "users/".concat(uid, "/parentalRestriction");
                        route = _this.getRouteUrl(endpoint);
                        return [
                            2,
                            _this.fetch(route, {
                                method: "DELETE",
                                headers: headers
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "checkParentalRestrictionCode",
            value: /**
     * Checks if given code if correct against parental restriction.
     *
     * @async
     * @param {Object} params Must contains the uid, a parental code.
     * @tutorial ./doc/checkParentalRestrictionCode.md
     */ function checkParentalRestrictionCode(param) {
                var _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers, uid = param.uid, code = param.code;
                var _this = this;
                return _async_to_generator._(function() {
                    var endpoint, route;
                    return _ts_generator._(this, function(_state) {
                        if (!uid) {
                            throw new Error("You should provide an uid");
                        }
                        endpoint = "users/".concat(uid, "/parentalRestriction/checkCode");
                        route = _this.getRouteUrl(endpoint);
                        return [
                            2,
                            _this.fetch(route, {
                                method: "POST",
                                headers: headers,
                                body: {
                                    code: code
                                }
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "fetchParentalFilter",
            value: /**
     * Get the current parental filter state applied to the user account
     *
     * @async
     * @param {Object} params Must contains the uid. Other params are optionals.
     * @returns {Object} An object containing the parental filter state
     * @tutorial ./doc/fetchParentalFilter.md
     */ function fetchParentalFilter(param) {
                var _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers, uid = param.uid;
                var _this = this;
                return _async_to_generator._(function() {
                    var endpoint, route;
                    return _ts_generator._(this, function(_state) {
                        if (!uid) {
                            throw new Error("You should provide an uid");
                        }
                        endpoint = "users/".concat(uid, "/parentalfilter");
                        route = _this.getRouteUrl(endpoint);
                        return [
                            2,
                            _this.fetch(route, {
                                method: "GET",
                                headers: headers
                            }).then(function(data) {
                                return {
                                    parentalFilter: data.parental_filter
                                };
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "updateParentalFilter",
            value: /**
     * Change the parental filter applied to the user account
     *
     * @async
     * @param {Object} params Must contains the uid of the user and the parental filter state. Other params are optionals.
     * @tutorial ./doc/updateParentalFilter.md
     */ function updateParentalFilter(param) {
                var _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers, uid = param.uid, parentalFilter = param.parentalFilter;
                var _this = this;
                return _async_to_generator._(function() {
                    var endpoint, route;
                    return _ts_generator._(this, function(_state) {
                        if (!uid) {
                            throw new Error("You should provide an uid");
                        }
                        endpoint = "users/".concat(uid, "/parentalfilter");
                        route = _this.getRouteUrl(endpoint);
                        return [
                            2,
                            _this.fetch(route, {
                                method: "POST",
                                headers: headers,
                                body: {
                                    parental_filter: parentalFilter
                                }
                            })
                        ];
                    });
                })();
            }
        }
    ]);
    return ParentalControlService;
}(fetcherService_1.FetcherService);
__decorate([
    withJWT_1.withJWT,
    monitoring
], ParentalControlService.prototype, "fetchParentalRestriction", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], ParentalControlService.prototype, "applyParentalRestriction", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], ParentalControlService.prototype, "removeParentalRestriction", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], ParentalControlService.prototype, "checkParentalRestrictionCode", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], ParentalControlService.prototype, "fetchParentalFilter", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], ParentalControlService.prototype, "updateParentalFilter", null);
exports.parentalControlService = new ParentalControlService();


/***/ }),

/***/ 27389:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(65759);
var __decorate = (void 0) && (void 0).__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.profileService = void 0;
var profile_errors_1 = __webpack_require__(84052);
var fido_1 = __webpack_require__(6446);
var withJWT_1 = __webpack_require__(62782);
var fetcherService_1 = __webpack_require__(97269);
var withMonitoring_1 = __webpack_require__(89873);
var monitoring = (0, withMonitoring_1.withMonitoring)("user");
var buildUserEndpoint = function(uid) {
    return "users/".concat(uid, "/profiles");
};
/**
 * @module User
 * @description The Profile service is used to interact with the user profile middleware.
 * @tutorial ./doc/profile.md
 */ var ProfileService = /*#__PURE__*/ function(_fetcherService_1_FetcherService) {
    _inherits._(ProfileService, _fetcherService_1_FetcherService);
    var _super = _create_super._(ProfileService);
    function ProfileService() {
        _class_call_check._(this, ProfileService);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.apiType = "userv2";
        return _this;
    }
    _create_class._(ProfileService, [
        {
            /**
     * Initialize the service. If you don't call this method, no other method can be called.
     * @tutorial ./doc/profileInit.md
     */ key: "init",
            value: function init() {
                if (!this.isInitialized) {
                    this.basePath = "platforms/".concat(fido_1.fido.get("platformCode"));
                    this.isInitialized = true;
                }
            }
        },
        {
            /**
     * Returns information about a specific user profile.
     *
     * @async
     * @param {Object} params Parameters passed to the function.
     * @param {string} params.profileUid UID of the profile to fetch
     * @param {string} params.userUid UID of the associated user
     * @tutorial ./doc/profileGetProfile.md
     */ key: "getProfile",
            value: function getProfile(param) {
                var profileUid = param.profileUid, userUid = param.userUid, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                if (!profileUid || !userUid) {
                    throw new Error("You must provide a profileUid and a userUid");
                }
                var endpoint = "".concat(buildUserEndpoint(userUid), "/").concat(profileUid);
                var url = this.getRouteUrl(endpoint);
                return this.fetch(url, {
                    method: "GET",
                    headers: headers
                });
            }
        },
        {
            /**
     * Create a new profile
     *
     * @async
     * @param {Object} params Must contains gigya uid, user name. Other params are optionals.
     * @tutorial ./doc/profileCreateProfile.md
     */ key: "createProfile",
            value: function createProfile(param) {
                var uid = param.uid, profileName = param.profileName, profileType = param.profileType, birthDate = param.birthDate, gender = param.gender, avatarId = param.avatarId, headers = param.headers;
                var endpoint = buildUserEndpoint(uid);
                var url = this.getRouteUrl(endpoint);
                return this.fetch(url, {
                    method: "POST",
                    headers: headers,
                    body: {
                        username: profileName,
                        profile_type: profileType,
                        birthdate: birthDate,
                        gender: gender,
                        avatar_id: avatarId
                    }
                }).catch(function(err) {
                    if (err.status === 403) {
                        throw new profile_errors_1.UserFirstProfileCannotBeKidError();
                    }
                    if (err.status === 423) {
                        throw new profile_errors_1.UserMaxAuthorizedProfilesCreatedError();
                    }
                    throw err;
                });
            }
        },
        {
            /**
     * Create a new profile
     *
     * @async
     * @param {Object} params Must contains gigya uid. Other params are optionals.
     * @tutorial ./doc/profileListProfiles.md
     */ key: "listProfiles",
            value: function listProfiles(param) {
                var uid = param.uid, headers = param.headers;
                var endpoint = buildUserEndpoint(uid);
                var url = this.getRouteUrl(endpoint);
                if (!uid) {
                    throw new Error("You must provide a uid");
                }
                return this.fetch(url, {
                    method: "GET",
                    headers: headers
                });
            }
        },
        {
            /**
     * Get the list of available avatar.
     *
     * @async
     * @param {Object} params Must contains gigya uid. Other params are optionals.
     * @tutorial ./doc/getAvailableAvatars.md
     */ key: "getAvailableAvatars",
            value: function getAvailableAvatars(param) {
                var uid = param.uid, headers = param.headers, _param_profileType = param.profileType, profileType = _param_profileType === void 0 ? "adult" : _param_profileType;
                var endpoint = "users/".concat(uid, "/avatars/").concat(profileType);
                var url = this.getRouteUrl(endpoint);
                return this.fetch(url, {
                    method: "GET",
                    headers: headers
                });
            }
        },
        {
            /**
     * Update a profile
     *
     * @async
     * @param {Object} params Must contains gigya uid, profile uid, user name. Other params are optionals.
     * @tutorial ./doc/profileUpdateProfile.md
     */ key: "updateProfile",
            value: function updateProfile(param) {
                var uid = param.uid, profileUid = param.profileUid, profileName = param.profileName, profileType = param.profileType, birthDate = param.birthDate, gender = param.gender, avatarId = param.avatarId, headers = param.headers;
                var endpoint = buildUserEndpoint(uid);
                var url = "".concat(this.getRouteUrl(endpoint), "/").concat(profileUid);
                return this.fetch(url, {
                    method: "PUT",
                    headers: headers,
                    body: {
                        username: profileName,
                        profile_type: profileType,
                        birthdate: birthDate,
                        gender: gender,
                        avatar_id: avatarId
                    }
                }).catch(function(err) {
                    if (err.status === 403) {
                        throw new profile_errors_1.UserLastProfileCannotBeKidError();
                    }
                    throw err;
                });
            }
        },
        {
            /**
     * Delete a profile
     *
     * @async
     * @param {Object} params Must contains gigya uid, profile uid.
     * @tutorial ./doc/profileDeleteProfile.md
     */ key: "deleteProfile",
            value: function deleteProfile(param) {
                var uid = param.uid, profileUid = param.profileUid, headers = param.headers;
                var endpoint = buildUserEndpoint(uid);
                var url = "".concat(this.getRouteUrl(endpoint), "/").concat(profileUid);
                return this.fetch(url, {
                    method: "DELETE",
                    headers: headers
                }).catch(function(err) {
                    if (err.status === 403) {
                        throw new profile_errors_1.UserLastAdultProfileCannotBeDeletedError();
                    }
                    throw err;
                });
            }
        }
    ]);
    return ProfileService;
}(fetcherService_1.FetcherService);
__decorate([
    withJWT_1.withJWT,
    monitoring
], ProfileService.prototype, "getProfile", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], ProfileService.prototype, "createProfile", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], ProfileService.prototype, "listProfiles", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], ProfileService.prototype, "getAvailableAvatars", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], ProfileService.prototype, "updateProfile", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], ProfileService.prototype, "deleteProfile", null);
exports.profileService = new ProfileService();


/***/ }),

/***/ 19092:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(45538);
var __decorate = (void 0) && (void 0).__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (void 0) && (void 0).__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.userService = void 0;
var map_1 = __importDefault(__webpack_require__(65512));
var fido_1 = __webpack_require__(6446);
var securityHeaderBuilder_1 = __webpack_require__(89222);
var withJWT_1 = __webpack_require__(62782);
var fetcherService_1 = __webpack_require__(97269);
var withMonitoring_1 = __webpack_require__(89873);
var monitoring = (0, withMonitoring_1.withMonitoring)("user");
var buildUserEndpoint = function(uid, submodule, action) {
    return "users/".concat(uid, "/").concat(submodule, "/").concat(action);
};
/**
 * @module User
 * @description The User service is used to interact with the 6play user middleware.
 * @tutorial ./doc/user.md
 */ var UserService = /*#__PURE__*/ function(_fetcherService_1_FetcherService) {
    _inherits._(UserService, _fetcherService_1_FetcherService);
    var _super = _create_super._(UserService);
    function UserService() {
        _class_call_check._(this, UserService);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.apiType = "userv2";
        return _this;
    }
    _create_class._(UserService, [
        {
            /**
     * Initialize the service. If you don't call this method, no other method can be called.
     * @param {Object} boxType Used to identify on which device the client is.
     * @tutorial ./doc/userInit.md
     */ key: "init",
            value: function init() {
                var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_boxType = _ref.boxType, boxType = _ref_boxType === void 0 ? fido_1.fido.get("clientCode") : _ref_boxType;
                if (!this.isInitialized) {
                    this.basePath = "platforms/".concat(fido_1.fido.get("platformCode"));
                    this.boxType = boxType;
                    this.isInitialized = true;
                }
            }
        },
        {
            /**
     * Modify the user newsletter status.
     *
     * @async
     * @param {string} uid User ID.
     * @param {string} action Action ('subscribe', 'unsubscribe').
     * @param {Object[]} newsletters to subscribe/unsubscribe.
     * @returns {string} Email of the user.
     * @tutorial ./doc/userPostNewsletter.md
     */ key: "postNewsletter",
            value: function postNewsletter(uid, action, newsletters) {
                var endpoint = buildUserEndpoint(uid, "newsletters", action);
                var url = this.getRouteUrl(endpoint);
                var path = this.getRoutePath(endpoint, true);
                return this.fetch(url, {
                    method: "POST",
                    body: newsletters,
                    headers: (0, securityHeaderBuilder_1.getTimestampHeader)(path, newsletters, fido_1.fido.get("getCurrentTime")(), fido_1.fido.get("saltAndSugar"))
                });
            }
        },
        {
            /**
     * Fetch newsletter subscriptions
     *
     * @async
     * @param {Object} params
     * @param {string} params.uid User ID.
     * @param {Object=} params.headers
     * @tutorial ./doc/getNewsletterSubscriptions.md
     */ key: "getNewsletterSubscriptions",
            value: function getNewsletterSubscriptions(param) {
                var uid = param.uid, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                if (!uid) {
                    throw new Error("You should provide an uid");
                }
                var endpoint = "users/".concat(uid, "/newsletters");
                var url = this.getRouteUrl(endpoint);
                return this.fetch(url, {
                    method: "GET",
                    headers: headers
                });
            }
        },
        {
            /**
     * Set newsletter subscriptions
     *
     * @async
     * @param {Object} params
     * @param {string} params.uid User ID.
     * @param {object} params.newsletters User newsletter subscriptions.
     * @param {Object=} params.headers
     * @tutorial ./doc/setNewsletterSubscriptions.md
     */ key: "setNewsletterSubscriptions",
            value: function setNewsletterSubscriptions(param) {
                var uid = param.uid, newsletters = param.newsletters, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                if (!uid) {
                    throw new Error("You should provide an uid");
                }
                var endpoint = "users/".concat(uid, "/newsletters");
                var url = this.getRouteUrl(endpoint);
                return this.fetch(url, {
                    method: "POST",
                    headers: headers,
                    body: {
                        newsletters: (0, map_1.default)(newsletters, function(value, key) {
                            return {
                                code: key,
                                subscribed: value
                            };
                        })
                    }
                });
            }
        },
        {
            /**
     * Fetch the last recent viewed clips. Items contain some clip and program information but mainly the last timecode seen.
     *
     * @async
     * @param {Object} options Contains an uid key (mandatory), some optionnal headers to link to the request, and a limit (default to 50 items).
     * @return {Object[]} Clips seens lastly, with clipId, programId, clipType, lasttcseen and more.
     * @tutorial ./doc/userGetLastViewedClips.md
     */ key: "getLastViewedClips",
            value: function getLastViewedClips(param) {
                var uid = param.uid, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers, _param_limit = param.limit, limit = _param_limit === void 0 ? 50 : _param_limit;
                if (!uid) {
                    throw new Error("You should provide an uid");
                }
                var endpoint = "users/".concat(uid, "/videos?limit=").concat(limit);
                var url = this.getRouteUrl(endpoint);
                return this.fetch(url, {
                    method: "GET",
                    headers: headers
                });
            }
        },
        {
            /**
     * Add a notifier to the user's list.
     *
     * @async
     * @param {Object} options Must contain entityId and entityType, can contain a headers key, for additionnal headers to attach to the request.
     * @param {string} [options.entityId]
     * @param {number} [options.entityType]
     * @param {Object} [options.headers={}]
     * tutorial ./doc/userAddNotifier.md
     */ key: "addNotifier",
            value: function addNotifier(param) {
                var entityId = param.entityId, entityType = param.entityType, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                if (!entityId || !entityType) {
                    throw new Error("You should provide an entityId and a entityType");
                }
                var url = "".concat(fido_1.fido.getBaseUrl("userv4"), "/").concat(fido_1.fido.get("customerCode"), "/").concat(fido_1.fido.get("platformCode"), "/bookmark/notify");
                return this.fetch(url, {
                    method: "PUT",
                    body: {
                        entityId: entityId,
                        entityType: entityType,
                        notified: true
                    },
                    headers: headers
                });
            }
        },
        {
            /**
     * Remove a notifier from the user's list.
     *
     * @async
     * @param {Object} options Must contain entityId and entityType, can contain a headers key, for additionnal headers to attach to the request.
     * @param {string} [options.entityId]
     * @param {number} [options.entityType]
     * @param {Object} [options.headers={}]
     * @tutorial ./doc/userRemoveNotifier.md
     */ key: "removeNotifier",
            value: function removeNotifier(param) {
                var entityId = param.entityId, entityType = param.entityType, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                if (!entityId || !entityType) {
                    throw new Error("You should provide an entityId and a entityType");
                }
                var url = "".concat(fido_1.fido.getBaseUrl("userv4"), "/").concat(fido_1.fido.get("customerCode"), "/").concat(fido_1.fido.get("platformCode"), "/bookmark/notify");
                return this.fetch(url, {
                    method: "PUT",
                    body: {
                        entityId: entityId,
                        entityType: entityType,
                        notified: false
                    },
                    headers: headers
                });
            }
        },
        {
            /**
     * Add a bookmark to the user's list.
     *
     * @async
     * @param {Object} options Must contain uid and programId, can contain a headers key, for additionnal headers to attach to the request.
     * @tutorial ./doc/userAddBookmark.md
     */ key: "addBookmark",
            value: function addBookmark(param) {
                var entityId = param.entityId, entityType = param.entityType, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                if (!entityId || !entityType) {
                    throw new Error("You should provide an entityId and a entityType");
                }
                var url = "".concat(fido_1.fido.getBaseUrl("userv4"), "/").concat(fido_1.fido.get("customerCode"), "/").concat(fido_1.fido.get("platformCode"), "/bookmark");
                return this.fetch(url, {
                    method: "PUT",
                    body: {
                        entityId: entityId,
                        entityType: entityType,
                        subscribed: true
                    },
                    headers: headers
                });
            }
        },
        {
            /**
     * Remove a bookmark from the user's list.
     *
     * @async
     * @param {Object} options Must contain uid and programId, can contain a headers key, for additionnal headers to attach to the request.
     * @tutorial ./doc/userRemoveBookmark.md
     */ key: "removeBookmark",
            value: function removeBookmark(param) {
                var entityId = param.entityId, entityType = param.entityType, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                if (!entityId || !entityType) {
                    throw new Error("You should provide an entityId and a entityType");
                }
                var url = "".concat(fido_1.fido.getBaseUrl("userv4"), "/").concat(fido_1.fido.get("customerCode"), "/").concat(fido_1.fido.get("platformCode"), "/bookmark");
                return this.fetch(url, {
                    method: "PUT",
                    body: {
                        entityId: entityId,
                        entityType: entityType,
                        subscribed: false
                    },
                    headers: headers
                });
            }
        },
        {
            /**
     * Retrieves the user's bookmarks.
     *
     * @async
     * @param {Object} options Must contain uid, can contain offset, limit or headers key, for additionnal headers to attach to the request.
     * @returns {Object[]} List of programs.
     * @tutorial ./doc/userGetBookmarks.md
     */ key: "getBookmarks",
            value: function getBookmarks(param) {
                var uid = param.uid, _param_offset = param.offset, offset = _param_offset === void 0 ? 0 : _param_offset, _param_limit = param.limit, limit = _param_limit === void 0 ? 50 : _param_limit, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                if (!uid) {
                    throw new Error("You should provide an uid");
                }
                var endpoint = "users/".concat(uid, "/programsubscriptions/programs?offset=").concat(offset, "&limit=").concat(limit);
                var url = this.getRouteUrl(endpoint);
                return this.fetch(url, {
                    method: "GET",
                    headers: headers
                });
            }
        },
        {
            /**
     * Retrieves the user's bookmarks ids.
     *
     * @async
     * @param {Object} options Must contain uid, can contain a headers key, for additionnal headers to attach to the request.
     * @returns {Object[]} A list of program ids.
     * @tutorial ./doc/userGetBookmarksIds.md
     */ key: "getBookmarksIds",
            value: function getBookmarksIds(param) {
                var uid = param.uid, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                if (!uid) {
                    throw new Error("You should provide an uid");
                }
                var endpoint = "users/".concat(uid, "/programsubscriptions");
                var url = this.getRouteUrl(endpoint);
                return this.fetch(url, {
                    method: "GET",
                    headers: headers
                });
            }
        },
        {
            /**
     * Retrieves the user's custom segments
     *
     * @async
     * @param {Object} options Must contain uid and destination
     * @tutorial ./doc/userGetCustomSegments.md
     */ key: "getUserCustomSegments",
            value: function getUserCustomSegments(param) {
                var uid = param.uid, destination = param.destination, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                if (!uid || !destination) {
                    throw new Error("You must provide a valid uid and a destination");
                }
                var endpoint = "users/".concat(uid, "/destinations/").concat(destination, "/segments");
                var url = this.getRouteUrl(endpoint);
                return this.fetch(url, {
                    method: "GET",
                    headers: headers
                });
            }
        },
        {
            /**
     * Retrieves the user's setttings
     * It must use v3 endpoint because there is no v2 endpoint for it.
     * The main difference between v2 and v3 is that uid is removed (to force the use of jwt).
     *
     * @async
     * @tutorial ./doc/userGetUserSettings.md
     */ key: "getUserSettings",
            value: function getUserSettings() {
                var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_headers = _ref.headers, headers = _ref_headers === void 0 ? {} : _ref_headers;
                var route = "".concat(fido_1.fido.getBaseUrl("userv3"), "/").concat(fido_1.fido.get("customerCode"), "/").concat(fido_1.fido.get("platformCode"), "/account");
                return this.fetch(route, {
                    method: "GET",
                    headers: headers
                });
            }
        },
        {
            /**
     * Update the user's settings.
     * It must use v3 endpoint because there is no v2 endpoint for it.
     * The main difference between v2 and v3 is that uid is removed (to force the use of jwt).
     *
     * @async
     * @param {Object} options Must contain greenMode, autoplay, quality, can contain a headers key, for additionnal headers to attach to the request.
     * @tutorial ./doc/userSetUserSettings.md
     */ key: "setUserSettings",
            value: function setUserSettings(param) {
                var greenModeActivated = param.greenModeActivated, videoSettings = param.videoSettings, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                var route = "".concat(fido_1.fido.getBaseUrl("userv3"), "/").concat(fido_1.fido.get("customerCode"), "/").concat(fido_1.fido.get("platformCode"), "/account");
                return this.fetch(route, {
                    method: "PATCH",
                    headers: headers,
                    body: {
                        greenModeActivated: greenModeActivated,
                        videoSettings: {
                            videoMaxQuality: videoSettings && videoSettings.videoMaxQuality,
                            autoplay: videoSettings && videoSettings.autoplay
                        }
                    }
                });
            }
        },
        {
            /**
     * Update the video settings.
     * It must use v3 endpoint because there is no v2 endpoint for it.
     *
     * @async
     * @param {Object} options Must contain videoMaxQuality, autoplay, can contain a headers key, for additionnal headers to attach to the request and trackPreferences.
     * @tutorial ./doc/setVideoSettings.md
     */ key: "setVideoSettings",
            value: function setVideoSettings(param) {
                var videoMaxQuality = param.videoMaxQuality, autoplay = param.autoplay, trackPreferences = param.trackPreferences, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                var route = "".concat(fido_1.fido.getBaseUrl("userv3"), "/").concat(fido_1.fido.get("customerCode"), "/").concat(fido_1.fido.get("platformCode"), "/videoSettings");
                return this.fetch(route, {
                    method: "PATCH",
                    headers: headers,
                    body: {
                        videoMaxQuality: videoMaxQuality,
                        autoplay: autoplay,
                        trackPreferences: trackPreferences && trackPreferences.length > 0 ? trackPreferences : undefined
                    }
                });
            }
        },
        {
            /**
     * @param {Object} params
     * @param {{ audioLanguage: string, audioDescription: boolean } | undefined} params.audioPreference
     * @param {{ subtitleLanguage: string, role: string } | null} params.subtitlesPreference
     * @param {string} params.originalLanguage
     * @param {Object=} params.headers
     *
     * the language code must have 3 characters and respect the standard ISO 639-3
     * subtitlePreference can be null if no track is selected
     *
     * @returns {Promise<*>}
     */ key: "setTrackPreferences",
            value: function setTrackPreferences(param) {
                var audioPreference = param.audioPreference, subtitlesPreference = param.subtitlesPreference, originalLanguage = param.originalLanguage, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers;
                var route = "".concat(fido_1.fido.getBaseUrl("userv3"), "/").concat(fido_1.fido.get("customerCode"), "/").concat(fido_1.fido.get("platformCode"), "/videoSettings");
                return this.fetch(route, {
                    method: "PATCH",
                    headers: headers,
                    body: {
                        trackPreferences: [
                            {
                                originalLanguage: originalLanguage,
                                audioPreference: audioPreference,
                                subtitlesPreference: subtitlesPreference
                            }
                        ]
                    }
                });
            }
        },
        {
            /**
     * Revoke a device.
     *
     * @async
     * @param {Object} params
     * @param {string} params.deviceId the infos about the device to revoke, e.g. "orange_newbox|deviceid-01bbaf51f1b2a050faf2c1bcdc768d66206710f6-1655887222150-Z-154395"
     * @param {Object=} params.headers
     */ key: "revokeDevice",
            value: function revokeDevice() {
                var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, deviceId = _ref.deviceId, _ref_headers = _ref.headers, headers = _ref_headers === void 0 ? {} : _ref_headers;
                var route = "".concat(fido_1.fido.getBaseUrl("userv3"), "/").concat(fido_1.fido.get("customerCode"), "/").concat(fido_1.fido.get("platformCode"), "/devices/toRevoke");
                return this.fetch(route, {
                    method: "PATCH",
                    headers: headers,
                    body: {
                        deviceId: deviceId
                    }
                });
            }
        },
        {
            /**
     * Revoke the current device.
     *
     * @async
     */ key: "revokeCurrentDevice",
            value: function revokeCurrentDevice() {
                var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_headers = _ref.headers, headers = _ref_headers === void 0 ? {} : _ref_headers;
                var route = "".concat(fido_1.fido.getBaseUrl("userv3"), "/").concat(fido_1.fido.get("customerCode"), "/").concat(fido_1.fido.get("platformCode"), "/devices/revokeCurrentDevice");
                return this.fetch(route, {
                    method: "PATCH",
                    headers: headers
                });
            }
        },
        {
            /**
     * Get user subscription type.
     *
     * @async
     */ key: "getUserSubscriptionType",
            value: function getUserSubscriptionType() {
                var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_headers = _ref.headers, headers = _ref_headers === void 0 ? {} : _ref_headers;
                var route = "".concat(fido_1.fido.getBaseUrl("userv3"), "/").concat(fido_1.fido.get("customerCode"), "/").concat(fido_1.fido.get("platformCode"), "/account/subscriptionType");
                return this.fetch(route, {
                    method: "GET",
                    headers: headers
                });
            }
        },
        {
            /**
     * Delete user account
     * Remove account from authentication provider and Bedrock database.
     *
     * @async
     */ key: "deleteAccount",
            value: function deleteAccount() {
                var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_headers = _ref.headers, headers = _ref_headers === void 0 ? {} : _ref_headers;
                var route = "".concat(fido_1.fido.getBaseUrl("userv3"), "/").concat(fido_1.fido.get("customerCode"), "/").concat(fido_1.fido.get("platformCode"), "/account");
                return this.fetch(route, {
                    method: "DELETE",
                    headers: headers
                });
            }
        }
    ]);
    return UserService;
}(fetcherService_1.FetcherService);
__decorate([
    monitoring
], UserService.prototype, "postNewsletter", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], UserService.prototype, "getNewsletterSubscriptions", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], UserService.prototype, "setNewsletterSubscriptions", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], UserService.prototype, "getLastViewedClips", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], UserService.prototype, "addNotifier", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], UserService.prototype, "removeNotifier", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], UserService.prototype, "addBookmark", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], UserService.prototype, "removeBookmark", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], UserService.prototype, "getBookmarks", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], UserService.prototype, "getBookmarksIds", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], UserService.prototype, "getUserCustomSegments", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], UserService.prototype, "getUserSettings", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], UserService.prototype, "setUserSettings", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], UserService.prototype, "setVideoSettings", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], UserService.prototype, "setTrackPreferences", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], UserService.prototype, "revokeDevice", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], UserService.prototype, "revokeCurrentDevice", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], UserService.prototype, "getUserSubscriptionType", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], UserService.prototype, "deleteAccount", null);
exports.userService = new UserService();


/***/ }),

/***/ 17320:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(3009);
var __decorate = (void 0) && (void 0).__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.videoService = void 0;
var fido_1 = __webpack_require__(6446);
var queryParamSerializer_1 = __webpack_require__(21413);
var withJWT_1 = __webpack_require__(62782);
var fetcherService_1 = __webpack_require__(97269);
var withMonitoring_1 = __webpack_require__(89873);
var monitoring = (0, withMonitoring_1.withMonitoring)("video");
/**
 * @module Video
 * @description This service is used to get a video from middleware API
 * @tutorial ./doc/video.md
 */ var VideoService = /*#__PURE__*/ function(_fetcherService_1_FetcherService) {
    _inherits._(VideoService, _fetcherService_1_FetcherService);
    var _super = _create_super._(VideoService);
    function VideoService() {
        _class_call_check._(this, VideoService);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.apiType = "middlewarev2";
        return _this;
    }
    _create_class._(VideoService, [
        {
            /**
     * Initialize the service. If you don't call this method, no other method can be called.
     * @tutorial ./doc/videoInit.md
     */ key: "init",
            value: function init() {
                if (!this.isInitialized) {
                    this.basePath = "platforms/".concat(fido_1.fido.get("platformCode"), "/services");
                    this.isInitialized = true;
                }
            }
        },
        {
            key: "fetchByVideoId",
            value: /**
     * Get information about the video designated by the requested videoId.
     *
     * @async
     * @param {Object} options videoId Requested video id, serviceCode Service where the informations should be retrieved from, queryParams Extra query parameters. Uses keys / values literally as provided in the object.
     * @returns {Object} Informations about the video
     * @tutorial ./doc/videoFetchByVideoId.md
     */ function fetchByVideoId() {
                var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, videoId = _ref.videoId, serviceCode = _ref.serviceCode, _ref_queryParams = _ref.queryParams, queryParams = _ref_queryParams === void 0 ? {} : _ref_queryParams, _ref_headers = _ref.headers, headers = _ref_headers === void 0 ? {} : _ref_headers;
                var _this = this;
                return _async_to_generator._(function() {
                    var error;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!videoId || !serviceCode) {
                                    throw new Error("You should provide non null videoId and serviceCode");
                                }
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    _this.fetch(_this.getRouteUrl("".concat(serviceCode, "/videos/").concat(videoId, "?").concat((0, queryParamSerializer_1.serialize)(queryParams))), {
                                        method: "GET",
                                        headers: headers
                                    })
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 3:
                                error = _state.sent();
                                if (error.response && error.response.status === 410) {
                                    return [
                                        2,
                                        error.response.body
                                    ];
                                }
                                throw error;
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "fetchVideos",
            value: /**
     * Get a list of all available videos.
     *
     * @async
     * @param {Object} options Options for fetching videos.
     * @param {string} options.serviceCode Service where the information should be retrieved from.
     * @param {string} options.csa Age rating parameter.
     * @param {number} options.offset Starting item for pagination.
     * @param {number} options.limit Maximum number of items to return for pagination.
     * @param {string} options.type Filter on video types.
     * @param {string} [options.with] Adds new data nodes to data initially sent (comma-separated values: freemiumpacks, inactivefreemiumpacks, clips, tags, expiration, program_details, program_images, related_content).
     * @param {Object} [options.headers={}] Optional HTTP headers.
     * @returns {Object} Response object with body containing an array of videos (can be empty).
     * @throws Will throw an error if serviceCode is not provided.
     * @throws Will throw an error if csa is not provided.
     * @throws Will throw an error if offset is not a valid number.
     * @throws Will throw an error if limit is not a valid number.
     * @throws Will throw an error if type is not provided.
     */ function fetchVideos() {
                var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, serviceCode = _ref.serviceCode, csa = _ref.csa, offset = _ref.offset, limit = _ref.limit, type = _ref.type, withParam = _ref.with, _ref_headers = _ref.headers, headers = _ref_headers === void 0 ? {} : _ref_headers;
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!serviceCode) {
                                    throw new Error("You should provide a service code");
                                }
                                if (!csa) {
                                    throw new Error("You should provide a csa code");
                                }
                                if (typeof offset !== "number" || isNaN(offset)) {
                                    throw new Error("You should provide a valid numeric offset");
                                }
                                if (typeof limit !== "number" || isNaN(limit)) {
                                    throw new Error("You should provide a valid numeric limit");
                                }
                                if (!type) {
                                    throw new Error("You should provide a video type");
                                }
                                return [
                                    4,
                                    _this.fetchWithResponse(_this.getRouteUrl("".concat(serviceCode, "/videos?csa=").concat(csa, "&offset=").concat(offset, "&limit=").concat(limit, "&type=").concat(type).concat(withParam ? "&with=".concat(withParam) : "")), {
                                        method: "GET",
                                        headers: headers
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "fetchNextVideos",
            value: /**
     *
     * @async
     * @param {Object} options videoId Current video id, serviceCode Service where the informations should be retrieved from, queryParams Extra query parameters. Uses keys / values literally as provided in the object.
     * @return {Object}
     * @tutorial ./doc/videoFetchNextVideos.md
     */ function fetchNextVideos() {
                var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, videoId = _ref.videoId, serviceCode = _ref.serviceCode, _ref_queryParams = _ref.queryParams, queryParams = _ref_queryParams === void 0 ? {
                    csa: 0,
                    type: "vi",
                    with: "clips,freemiumpacks,program_images"
                } : _ref_queryParams, _ref_headers = _ref.headers, headers = _ref_headers === void 0 ? {} : _ref_headers;
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        if (!videoId || !serviceCode) {
                            throw new Error("You should provide non null videoId and serviceCode");
                        }
                        return [
                            2,
                            _this.fetch(_this.getRouteUrl("".concat(serviceCode, "/videos/").concat(videoId, "/nextvideos?").concat((0, queryParamSerializer_1.serialize)(queryParams))), {
                                method: "GET",
                                headers: headers
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "fetchVideosByProgramId",
            value: /**
     * List all videos of a program. Used for example to build recommandations in players.
     *
     * @async
     * @param {Object} options programId Program to fetch videos from, service Service where the informations should be retrieved from, queryParams Extra query parameters. Uses keys / values literally as provided in the object.
     * @return {Object}
     * @tutorial ./doc/videoFetchVideosByProgramId.md
     */ function fetchVideosByProgramId() {
                var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, programId = _ref.programId, serviceCode = _ref.serviceCode, _ref_queryParams = _ref.queryParams, queryParams = _ref_queryParams === void 0 ? {
                    csa: 0,
                    offset: 0,
                    limit: 20,
                    type: "vi"
                } : _ref_queryParams, _ref_headers = _ref.headers, headers = _ref_headers === void 0 ? {} : _ref_headers;
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        if (!programId || !serviceCode) {
                            throw new Error("You should provide non null programId and serviceCode");
                        }
                        return [
                            2,
                            _this.fetch(_this.getRouteUrl("".concat(serviceCode, "/programs/").concat(programId, "/videos?").concat((0, queryParamSerializer_1.serialize)(queryParams))), {
                                method: "GET",
                                headers: headers
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "fetchByExternalKey",
            value: /**
     * Get information about the video with an external key.
     *
     * @async
     * @param {Object} externalKey An external key which allows to identity the video (ex: asset reference)
     * @param {Object} serviceCode Service where the informations should be retrieved from
     * @param {Object} queryParams Extra query parameters (ex: csa)
     * @return {Object} Informations about the video
     * @throws Will throw an error if externalKey or serviceCode are not provided
     * @tutorial ./doc/videoFetchByExternalKey.md
     */ function fetchByExternalKey() {
                var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, externalKey = _ref.externalKey, serviceCode = _ref.serviceCode, _ref_queryParams = _ref.queryParams, queryParams = _ref_queryParams === void 0 ? {
                    csa: 0
                } : _ref_queryParams, _ref_headers = _ref.headers, headers = _ref_headers === void 0 ? {} : _ref_headers;
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        if (!externalKey || !serviceCode) {
                            throw new Error("You should provide non null externalKey or serviceCode");
                        }
                        return [
                            2,
                            _this.fetch(_this.getRouteUrl("".concat(serviceCode, "/videos/external_asset/").concat(externalKey, "?").concat((0, queryParamSerializer_1.serialize)(queryParams))), {
                                method: "GET",
                                headers: headers
                            })
                        ];
                    });
                })();
            }
        }
    ]);
    return VideoService;
}(fetcherService_1.FetcherService);
__decorate([
    withJWT_1.withJWT,
    monitoring
], VideoService.prototype, "fetchByVideoId", null);
__decorate([
    monitoring
], VideoService.prototype, "fetchVideos", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], VideoService.prototype, "fetchNextVideos", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], VideoService.prototype, "fetchVideosByProgramId", null);
__decorate([
    withJWT_1.withJWT,
    monitoring
], VideoService.prototype, "fetchByExternalKey", null);
exports.videoService = new VideoService();


/***/ }),

/***/ 63337:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(88801);
var __decorate = (void 0) && (void 0).__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.videolandPaymentService = void 0;
var fetcherService_1 = __webpack_require__(97269);
var withMonitoring_1 = __webpack_require__(89873);
var monitoring = (0, withMonitoring_1.withMonitoring)("videolandPayment");
/**
 * @module Videoland payment
 * @description The Videoland payment service is used to get the supported payment methods.
 * @tutorial ./doc/videolandPayment.md
 */ var VideolandPaymentService = /*#__PURE__*/ function(_fetcherService_1_FetcherService) {
    _inherits._(VideolandPaymentService, _fetcherService_1_FetcherService);
    var _super = _create_super._(VideolandPaymentService);
    function VideolandPaymentService() {
        _class_call_check._(this, VideolandPaymentService);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.apiType = "videolandApi";
        return _this;
    }
    _create_class._(VideolandPaymentService, [
        {
            /**
     * Initialize the service. If you don't call this method, no other method can be called.
     * @tutorial ./doc/videolandPaymentInit.md
     */ key: "init",
            value: function init() {
                if (!this.isInitialized) {
                    this.basePath = "subscribe/payment/v1/payment-methods";
                    this.isInitialized = true;
                }
            }
        },
        {
            /**
     * Gets the list of supported credit card types
     *
     * @async
     * @tutorial ./doc/videolandPaymentGetCreditCards.md
     */ key: "getCreditCards",
            value: function getCreditCards() {
                var endpoint = "creditcard/types";
                var url = this.getRouteUrl(endpoint);
                return this.fetch(url, {
                    method: "GET"
                });
            }
        },
        {
            /**
     * Gets the list of supported banks.
     *
     * @async
     * @tutorial ./doc/videolandPaymentGetBanks.md
     */ key: "getBanks",
            value: function getBanks() {
                var endpoint = "ideal/banks";
                var url = this.getRouteUrl(endpoint);
                return this.fetch(url, {
                    method: "GET"
                });
            }
        }
    ]);
    return VideolandPaymentService;
}(fetcherService_1.FetcherService);
__decorate([
    monitoring
], VideolandPaymentService.prototype, "getCreditCards", null);
__decorate([
    monitoring
], VideolandPaymentService.prototype, "getBanks", null);
exports.videolandPaymentService = new VideolandPaymentService();


/***/ }),

/***/ 82279:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _define_property = __webpack_require__(21228);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
var __decorate = (void 0) && (void 0).__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.watchedContentsVisibilityService = exports.WatchedContentsVisibilityService = void 0;
var fido_1 = __webpack_require__(6446);
var withJWT_1 = __webpack_require__(62782);
var fetcherService_1 = __webpack_require__(97269);
var withMonitoring_1 = __webpack_require__(89873);
var monitoring = (0, withMonitoring_1.withMonitoring)("watchedContentsVisibility");
/**
 * @module Heartbeat
 * @description A temporary service, needs to be removed when heartbeatv3 service will be production ready
 */ var WatchedContentsVisibilityService = /*#__PURE__*/ function(_fetcherService_1_FetcherService) {
    _inherits._(WatchedContentsVisibilityService, _fetcherService_1_FetcherService);
    var _super = _create_super._(WatchedContentsVisibilityService);
    function WatchedContentsVisibilityService() {
        _class_call_check._(this, WatchedContentsVisibilityService);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.apiType = "heartbeatv3";
        return _this;
    }
    _create_class._(WatchedContentsVisibilityService, [
        {
            key: "init",
            value: function init() {
                if (!this.isInitialized) {
                    this.isInitialized = true;
                    this.basePath = "".concat(fido_1.fido.get("customerCode"), "/").concat(fido_1.fido.get("platformCode"));
                    this.monitoring = monitoring;
                }
            }
        },
        {
            /**
     * Exclude contents from the resume watching list
     * @async
     *
     * @param {Object} headers The headers of the request
     * @param {array} contentIds An array containing content ids of content to remove
     * @returns {Object}
     */ key: "removeContentsFromList",
            value: function removeContentsFromList(param) {
                var _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers, contentIds = param.contentIds;
                if (!Array.isArray(contentIds) || contentIds.length === 0) {
                    throw new Error("You should provide a non-empty array of content IDs");
                }
                var body = contentIds.reduce(function(acc, contentId) {
                    return Object.assign(Object.assign({}, acc), _define_property._({}, contentId, true));
                }, {});
                return this.fetch(this.getRouteUrl("watched_contents_visibility"), {
                    method: "POST",
                    headers: headers,
                    body: body
                });
            }
        }
    ]);
    return WatchedContentsVisibilityService;
}(fetcherService_1.FetcherService);
exports.WatchedContentsVisibilityService = WatchedContentsVisibilityService;
__decorate([
    withJWT_1.withJWT,
    monitoring
], WatchedContentsVisibilityService.prototype, "removeContentsFromList", null);
exports.watchedContentsVisibilityService = new WatchedContentsVisibilityService();


/***/ }),

/***/ 48832:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _to_consumable_array = __webpack_require__(30005);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(88801);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.withNoParallelRequest = exports.generateCachingKey = void 0;
var generateCachingKey = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return JSON.stringify(args);
};
exports.generateCachingKey = generateCachingKey;
var withNoParallelRequest = function(target, key, descriptor) {
    var cachedValues = {};
    var decoratedFunction = descriptor.value;
    descriptor.value = function withNoParallelRequest() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _decoratedFunction;
        var cachingKey = (0, exports.generateCachingKey)(args);
        var cachedValue = cachedValues[cachingKey];
        if (cachedValue !== undefined) {
            return cachedValue;
        }
        var resultingPromise = (_decoratedFunction = decoratedFunction).call.apply(_decoratedFunction, [
            this
        ].concat(_to_consumable_array._(args)));
        cachedValues[cachingKey] = resultingPromise;
        return resultingPromise.finally(function() {
            delete cachedValues[cachingKey];
        });
    };
};
exports.withNoParallelRequest = withNoParallelRequest;


/***/ }),

/***/ 24432:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _async_to_generator = __webpack_require__(24146);
var _to_consumable_array = __webpack_require__(30005);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(42578);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(88801);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.connectAction = void 0;
var connectAction = function(resolver) {
    var promise = Promise.resolve();
    var waitForPromise = function(awaitedPromise) {
        promise = awaitedPromise;
        return awaitedPromise;
    };
    var connectedAction = function() {
        var _ref = _async_to_generator._(function() {
            var _len, args, _key, data;
            var _arguments = arguments;
            return _ts_generator._(this, function(_state) {
                switch(_state.label){
                    case 0:
                        for(_len = _arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                            args[_key] = _arguments[_key];
                        }
                        return [
                            4,
                            function() {
                                return promise;
                            }()
                        ];
                    case 1:
                        data = _state.sent();
                        resolver.apply(void 0, [
                            data
                        ].concat(_to_consumable_array._(args)));
                        return [
                            2
                        ];
                }
            });
        });
        return function connectedAction() {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        connectedAction: connectedAction,
        waitForPromise: waitForPromise
    };
};
exports.connectAction = connectAction;


/***/ }),

/***/ 4906:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(45538);
var __importDefault = (void 0) && (void 0).__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.fetch = void 0;
var superagent_1 = __importDefault(__webpack_require__(54247));
var fetch_error_1 = __webpack_require__(63378);
var fido_1 = __webpack_require__(6446);
var canSendBody = {
    PATCH: true,
    POST: true,
    PUT: true
};
var buildRequest = function(url, param) {
    var method = param.method, _param_body = param.body, body = _param_body === void 0 ? {} : _param_body, query = param.query, headers = param.headers, responseType = param.responseType;
    var req = (0, superagent_1.default)(method, url);
    if (headers) {
        req.set(headers);
    }
    if (query) {
        req.query(query);
    }
    if (responseType) {
        req.responseType(responseType);
    }
    if (canSendBody[method]) {
        return req.send(body);
    }
    return req;
};
var fetch = function(url) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return new Promise(function(resolve, reject) {
        options.method = options.method || "GET";
        options.maxTimeout = options.maxTimeout || fido_1.fido.get("maxTimeout");
        options.waitTimeout = options.waitTimeout || fido_1.fido.get("waitTimeout");
        var req = buildRequest(url, options);
        if (options.withCredentials) {
            req.withCredentials();
        }
        if (options.signal) {
            options.signal.addEventListener("abort", function() {
                req.abort();
            });
        }
        if (options.retry) {
            req.retry(options.retry.count, options.retry.callback(options.retry.apiType, options.method));
        }
        req.timeout({
            response: options.waitTimeout,
            deadline: options.maxTimeout
        }).end(function(err, response) {
            if (err) {
                return reject(new fetch_error_1.FetchError(err, {
                    url: url,
                    options: options
                }, response));
            }
            if (response.ok) {
                return resolve(response);
            }
            var error = new fetch_error_1.FetchError("".concat(response.statusText, ":").concat(response.status), {
                url: url,
                options: options
            }, response);
            return reject(error);
        });
    });
};
exports.fetch = fetch;


/***/ }),

/***/ 88513:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.addFidoPropertyIfDefined = void 0;
var fido_1 = __webpack_require__(6446);
var addFidoPropertyIfDefined = function() {
    var target = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, fidoConfigKey = arguments.length > 1 ? arguments[1] : void 0, targetPropertyName = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : fidoConfigKey;
    return function() {
        var cloneTarget = Object.assign({}, target);
        if (fido_1.fido.get(fidoConfigKey)) {
            cloneTarget[targetPropertyName] = fido_1.fido.get(fidoConfigKey);
        }
        return cloneTarget;
    };
};
exports.addFidoPropertyIfDefined = addFidoPropertyIfDefined;


/***/ }),

/***/ 21413:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.formatDate = exports.serialize = void 0;
/**
 * Serialize params passed in the map to queryParam structure
 *
 * @returns {string} queryparams string matching params
 */ var serialize = function() {
    var params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, filter = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function() {
        return true;
    };
    var paramKeys = Object.keys(params);
    if (!paramKeys.length) {
        return "";
    }
    return paramKeys.map(function(key) {
        return {
            key: key,
            value: params[key]
        };
    }).filter(filter).sort(function(param, param1) {
        var key1 = param.key, key2 = param1.key;
        return key1 <= key2 ? -1 : 1;
    }).map(function(param) {
        var key = param.key, value = param.value;
        return "".concat(key, "=").concat(encodeURIComponent(value));
    }).join("&");
};
exports.serialize = serialize;
var dateElementToString = function(element) {
    return "".concat(element < 10 ? "0" : "").concat(element);
};
/**
 * Converts Date into a string with YYYY-MM-DD HH:MM:SS format
 *
 * @param {Date} date
 */ var formatDate = function(date) {
    if (!(date instanceof Date)) {
        throw Error("The argument should be an instance of Date");
    }
    var dateParts = [
        date.getMonth() + 1,
        date.getDate()
    ].map(dateElementToString);
    dateParts.unshift(date.getFullYear());
    var timeParts = [
        date.getHours(),
        date.getMinutes(),
        date.getSeconds()
    ].map(dateElementToString);
    return "".concat(dateParts.join("-"), " ").concat(timeParts.join(":"));
};
exports.formatDate = formatDate;


/***/ }),

/***/ 99475:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(37815);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.retryPromise = retryPromise;
function retryPromise(fn) {
    var retriesLeft = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 3, delay = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    return new Promise(function(resolve, reject) {
        return fn().then(resolve).catch(function(error) {
            if (retriesLeft <= 1) {
                reject(error);
                return;
            }
            setTimeout(function() {
                retryPromise(fn, retriesLeft - 1, delay * 2).then(resolve, reject);
            }, delay);
        });
    });
}


/***/ }),

/***/ 25991:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(3009);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.buildRetryOptions = exports.retryRequestCallback = exports.RETRY_OPTIONS_ERROR_MESSAGE = exports.MAX_RETRY_COUNT = void 0;
var statsdMonitoringService_1 = __webpack_require__(46261);
exports.MAX_RETRY_COUNT = 2;
exports.RETRY_OPTIONS_ERROR_MESSAGE = "You should provide correct retry options parameters";
var retryRequestCallback = function(apiType, method) {
    return function(error) {
        statsdMonitoringService_1.statsdMonitoringService.sendIncrement([
            "fido",
            "retry",
            error ? "error" : "success",
            method,
            apiType
        ]);
    };
};
exports.retryRequestCallback = retryRequestCallback;
/**
 * @param {{apiType:string, count:Number}} params The build retry options params.
 * @returns {{apiType:string, count:Number, callback:Function}} The retry options.
 */ var buildRetryOptions = function(param) {
    var apiType = param.apiType, count = param.count;
    if (!apiType || typeof count !== "number" || count > exports.MAX_RETRY_COUNT) {
        throw new Error(exports.RETRY_OPTIONS_ERROR_MESSAGE);
    }
    return {
        apiType: apiType,
        count: count,
        callback: exports.retryRequestCallback
    };
};
exports.buildRetryOptions = buildRetryOptions;


/***/ }),

/***/ 6790:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(42578);
var __importDefault = (void 0) && (void 0).__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.genGuid = exports.TOKEN = exports.FREEMIUM = exports.GIGYA = exports.TIMESTAMP = exports.DEVICE = exports.UNSIGNED = void 0;
exports.getParamsString = getParamsString;
exports.genTimestampToken = genTimestampToken;
var hmac_sha1_1 = __importDefault(__webpack_require__(69764));
var flow_1 = __importDefault(__webpack_require__(14459));
var map_1 = __importDefault(__webpack_require__(65512));
var reject_1 = __importDefault(__webpack_require__(8207));
var sortBy_1 = __importDefault(__webpack_require__(84715));
exports.UNSIGNED = "UNSIGNED";
exports.DEVICE = "DEVICE";
exports.TIMESTAMP = "TIMESTAMP";
exports.GIGYA = "GIGYA";
exports.FREEMIUM = "FREEMIUM";
exports.TOKEN = "TOKEN";
function getParamsString(params, prefix) {
    return (0, flow_1.default)(function(x) {
        return (0, map_1.default)(x, function(value, key) {
            return {
                key: key,
                value: value
            };
        });
    }, function(x) {
        return (0, reject_1.default)(x, function(param) {
            var value = param.value;
            return value === undefined;
        });
    }, function(x) {
        return (0, sortBy_1.default)(x, "key");
    }, function(x) {
        return x.reduce(function(result, param) {
            var value = param.value, key = param.key;
            var prefixedKey = prefix ? "".concat(prefix, "[").concat(key, "]") : key;
            var safeValue = typeof value === "boolean" ? Number(value) : value;
            return result.concat(safeValue !== null && typeof safeValue === "object" ? getParamsString(safeValue, prefixedKey) : "".concat(encodeURIComponent(prefixedKey), "=").concat(encodeURIComponent(safeValue)));
        }, []);
    })(params).join("&");
}
function genTimestampToken(path, params, currentTime, saltAndSugar) {
    if (!saltAndSugar) {
        throw new Error("Fido saltAndSugar parameter should be defined to generate token, received: ".concat(saltAndSugar));
    }
    var paramsString = getParamsString(params);
    var timestamp = Math.floor(parseInt(currentTime, 10) / 1000);
    return {
        token: (0, hmac_sha1_1.default)("".concat(path).concat(paramsString).concat(Math.floor(timestamp / 60)), saltAndSugar).toString(),
        timestamp: timestamp
    };
}
var genGuid = function() {
    var time = new Date().getTime();
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(char) {
        // eslint-disable-next-line no-bitwise
        var replacement = (time + Math.random() * 16) % 16 | 0;
        time = Math.floor(time / 16);
        if (char === "x") {
            return replacement.toString(16);
        }
        // eslint-disable-next-line no-bitwise
        return (replacement & 0x3 | 0x8).toString(16);
    });
};
exports.genGuid = genGuid;


/***/ }),

/***/ 89222:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(37815);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.getHeaders = exports.getUidTimestampHeader = exports.hasProfile = exports.isSignedGigyaUser = exports.getGigyaUserHeader = exports.getTimestampHeader = void 0;
var fido_1 = __webpack_require__(6446);
var security_1 = __webpack_require__(6790);
var getTimestampHeader = function(path, params, time, saltAndSugar) {
    var timestampToken = (0, security_1.genTimestampToken)(path, params, time, saltAndSugar);
    return {
        "X-Auth-Token": timestampToken.token,
        "X-Auth-Token-Timestamp": timestampToken.timestamp
    };
};
exports.getTimestampHeader = getTimestampHeader;
var getGigyaUserHeader = function(param) {
    var UID = param.UID, UIDSignature = param.UIDSignature, signatureTimestamp = param.signatureTimestamp;
    return {
        "X-Auth-gigya-uid": UID,
        "X-Auth-gigya-signature": UIDSignature,
        "X-Auth-gigya-signature-timestamp": signatureTimestamp
    };
};
exports.getGigyaUserHeader = getGigyaUserHeader;
var isSignedGigyaUser = function(user) {
    return !!(user && user.UIDSignature);
};
exports.isSignedGigyaUser = isSignedGigyaUser;
var hasProfile = function(profile) {
    return !!(profile && profile.profileUid);
};
exports.hasProfile = hasProfile;
var getUidTimestampHeader = function(path, params, time, saltAndSugar, user) {
    var timestampToken = (0, security_1.genTimestampToken)(path, params, time, saltAndSugar);
    var UID = user.UID;
    return {
        "X-Auth-Token": timestampToken.token,
        "X-Auth-Token-Timestamp": timestampToken.timestamp,
        "X-Auth-gigya-uid": UID
    };
};
exports.getUidTimestampHeader = getUidTimestampHeader;
/**
 * Build Headers for authenticated api requests.
 *
 * @param {Object} requestParams An object containing the body and the route path.
 * @param {Object} idParams An object that could contain the connected user
 * @returns {Object}
 */ var getHeaders = function(param, param1) {
    var path = param.path, body = param.body, user = param1.user, profile = param1.profile;
    var baseHeaders = {
        "X-Customer-Name": fido_1.fido.get("customerCode"),
        "X-Client-Release": fido_1.fido.get("appVersion")
    };
    if (fido_1.fido.get("localDeviceId")) {
        baseHeaders["x-auth-device-id"] = fido_1.fido.get("localDeviceId");
    } else if (fido_1.fido.get("localHomeId")) {
        baseHeaders["x-auth-home-id"] = fido_1.fido.get("localHomeId");
    }
    try {
        if ((0, exports.hasProfile)(profile)) {
            baseHeaders["X-Auth-profile-id"] = profile.profileUid;
        }
        if (!user) {
            return Object.assign(Object.assign({}, baseHeaders), (0, exports.getTimestampHeader)(path, body, fido_1.fido.get("getCurrentTime")(), fido_1.fido.get("saltAndSugar")));
        }
        if ((0, exports.isSignedGigyaUser)(user)) {
            return Object.assign(Object.assign({}, baseHeaders), (0, exports.getGigyaUserHeader)(user));
        }
        return Object.assign(Object.assign({}, baseHeaders), (0, exports.getUidTimestampHeader)(path, body, fido_1.fido.get("getCurrentTime")(), fido_1.fido.get("saltAndSugar"), user));
    } catch (e) {
        throw new Error("Something went wrong while generating headers: ".concat(e.message));
    }
};
exports.getHeaders = getHeaders;


/***/ }),

/***/ 2884:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(45538);
var __importDefault = (void 0) && (void 0).__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.fetchSync = void 0;
var forOwn_1 = __importDefault(__webpack_require__(14287));
/**
 * A Synchronous fetcher, to be used whenever you can't do otherwise.
 *
 * @param {string} url The full url of the resource.
 * @param {Object} body The payload to send.
 * @param {Object} headers All necessary headers.
 */ var fetchSync = function(url, body, headers) {
    var xhr = new XMLHttpRequest();
    xhr.open("POST", url, false);
    xhr.setRequestHeader("Content-Type", "application/json");
    (0, forOwn_1.default)(headers, function(headerValue, headerName) {
        xhr.setRequestHeader(headerName, headerValue);
    });
    return xhr.send(JSON.stringify(body));
};
exports.fetchSync = fetchSync;


/***/ }),

/***/ 9252:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    MEDIA_ERR_ABORTED: function() {
        return MEDIA_ERR_ABORTED;
    },
    MEDIA_ERR_DECODE: function() {
        return MEDIA_ERR_DECODE;
    },
    MEDIA_ERR_NETWORK: function() {
        return MEDIA_ERR_NETWORK;
    },
    MEDIA_ERR_SRC_NOT_SUPPORTED: function() {
        return MEDIA_ERR_SRC_NOT_SUPPORTED;
    }
});
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(88801);
var MEDIA_ERR_ABORTED = 1;
var MEDIA_ERR_NETWORK = 2;
var MEDIA_ERR_DECODE = 3;
var MEDIA_ERR_SRC_NOT_SUPPORTED = 4;


/***/ }),

/***/ 55013:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "HTML5Engine", ({
    enumerable: true,
    get: function() {
        return HTML5Engine;
    }
}));
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _define_property = __webpack_require__(21228);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _to_consumable_array = __webpack_require__(30005);
var _create_super = __webpack_require__(6400);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(42578);
var _lodash = /*#__PURE__*/ _interop_require_default._(__webpack_require__(32699));
var _isValid = /*#__PURE__*/ _interop_require_default._(__webpack_require__(43842));
var _getUnixTime = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81843));
var _mediaengine = __webpack_require__(62221);
var _HTML5Error = __webpack_require__(9252);
var filterNull = _mediaengine.TracksUtils.filterNull, getTrackLabel = _mediaengine.TracksUtils.getTrackLabel, compareLanguage = _mediaengine.TracksUtils.compareLanguage;
var AUTOPLAY_PREVENTED_ERROR = _mediaengine.ERROR_DETAILS.AUTOPLAY_PREVENTED_ERROR;
var DEFAULT_FRAGMENT_DURATION = _mediaengine.ASSET_CONSTANTS.DEFAULT_FRAGMENT_DURATION;
var PROGRESS_THROTTLE = _mediaengine.VIDEO_EVENTS_THROTTLE.PROGRESS_THROTTLE, TIME_UPDATE_THROTTLE = _mediaengine.VIDEO_EVENTS_THROTTLE.TIME_UPDATE_THROTTLE, SEEKING_THROTTLE = _mediaengine.VIDEO_EVENTS_THROTTLE.SEEKING_THROTTLE, VOLUME_CHANGE_THROTTLE = _mediaengine.VIDEO_EVENTS_THROTTLE.VOLUME_CHANGE_THROTTLE, PLAYER_THROTTLE_OPTIONS = _mediaengine.VIDEO_EVENTS_THROTTLE.PLAYER_THROTTLE_OPTIONS, RETRY_RESET_TIME = _mediaengine.VIDEO_EVENTS_THROTTLE.RETRY_RESET_TIME;
var mapAudioTrack = function(audioTrack, id) {
    var originalLanguage = audioTrack.language || audioTrack.label;
    var language = getTrackLabel(audioTrack.language || audioTrack.label);
    var lang = _mediaengine.mediaEngineConfig.get("lang");
    return {
        id: id,
        language: language,
        originalLanguage: originalLanguage,
        main: language === lang,
        roles: [
            audioTrack.label === "AD" ? "alternate" : audioTrack.kind
        ],
        active: audioTrack.enabled
    };
};
var mapTextTrack = function(track, id) {
    var kind = track.kind, language = track.language, mode = track.mode;
    return {
        id: id,
        language: language,
        originalLanguage: language,
        roles: filterNull(kind === "captions" ? "caption" : null, "subtitle"),
        active: mode === "showing",
        forced: kind === "forced"
    };
};
var HTML5Engine = /*#__PURE__*/ function(Engine) {
    "use strict";
    _inherits._(HTML5Engine, Engine);
    var _super = _create_super._(HTML5Engine);
    function HTML5Engine() {
        _class_call_check._(this, HTML5Engine);
        var _this;
        _this = _super.call(this);
        _this.defaultHandler = function(event) {
            event.stopPropagation();
            event.preventDefault();
            _this.options.dispatcher(event.type, event.target);
        };
        _this.onProgress = _lodash.default.throttle(_this.defaultHandler, PROGRESS_THROTTLE, PLAYER_THROTTLE_OPTIONS);
        _this.onSeeking = _lodash.default.throttle(_this.defaultHandler, SEEKING_THROTTLE, PLAYER_THROTTLE_OPTIONS);
        _this.onVolumeChange = _lodash.default.throttle(_this.defaultHandler, VOLUME_CHANGE_THROTTLE, PLAYER_THROTTLE_OPTIONS);
        _this.getPresentationStartTime = function() {
            if (_this.engine && typeof _this.engine.getStartDate === "function") {
                var date = _this.engine.getStartDate();
                if ((0, _isValid.default)(date)) {
                    return (0, _getUnixTime.default)(date);
                }
            }
            return _this.availabilityStartTime;
        };
        _this.onPlaying = function(event) {
            _this.paused = false;
            _this.options.dispatcher(event.type, event.target);
        };
        _this.onError = function(event) {
            if (_this.source) {
                var errorCode = _lodash.default.get(event, "target.error.code");
                if ([
                    _HTML5Error.MEDIA_ERR_DECODE,
                    _HTML5Error.MEDIA_ERR_NETWORK,
                    _HTML5Error.MEDIA_ERR_SRC_NOT_SUPPORTED
                ].includes(errorCode)) {
                    _this.debouncedRetry(event);
                    return;
                }
                if (_this.retryOnFallbackSource()) {
                    _this.options.dispatcher(_mediaengine.VIDEO_EVENTS.FALLBACK_SOURCE, _this.source);
                    return;
                }
                _this.options.dispatcher(event.type, event.target);
            }
        };
        _this.manageId3 = function() {
            if (_this.source && _this.source.format) {
                return !!(_this.source.format.includes("hls") && _this.engine && _this.engine.textTracks);
            }
            return false;
        };
        _this.onLoadedMetadata = function(event) {
            if (_this.manageId3()) {
                _this.engine.textTracks.addEventListener("addtrack", _this.onAddTrack);
            }
            _this.options.dispatcher(event.type, event.target);
        };
        _this.onAddTrack = function(event) {
            var track = event.track;
            if (track.kind === "metadata") {
                track.mode = "hidden";
                track.addEventListener("cuechange", _this.onCueChange);
                // In Safari the initial assignment does not always work, so we schedule
                // this process to be repeated several times to ensure that it has been put
                // in the correct mode.
                _lodash.default.delay(function() {
                    if (_this.engine) {
                        var textTracks = Object.values(_this.engine.textTracks);
                        textTracks.forEach(function(textTrack) {
                            if (textTrack.kind === "metadata") {
                                textTrack.mode = "hidden";
                            }
                        });
                    }
                }, 500);
            }
        };
        _this.onCueChange = function(event) {
            var _this_options = _this.options, logger = _this_options.logger, dispatcher = _this_options.dispatcher;
            logger.debug("HTML5Engine", "onCueChange", event);
            var activeTrack = event.target;
            var metadata = {};
            if (!activeTrack || !activeTrack.activeCues || activeTrack.activeCues.length < 1) {
                return;
            }
            var _activeTrack_activeCues_ = activeTrack.activeCues[0], id = _activeTrack_activeCues_.id, endTime = _activeTrack_activeCues_.endTime, startTime = _activeTrack_activeCues_.startTime;
            var id3Data = Array.from(activeTrack.activeCues).reduce(function(acc, cue) {
                var _String;
                var _cue_value = cue.value, key = _cue_value.key, info = _cue_value.info, data = _cue_value.data;
                if (key === "PRIV") {
                    var _String1;
                    return _object_spread_props._(_object_spread._({}, acc), _define_property._({}, key, {
                        value: (_String1 = String).fromCharCode.apply(_String1, _to_consumable_array._(new Uint8Array(data))),
                        owner: info
                    }));
                }
                return _object_spread_props._(_object_spread._({}, acc), _define_property._({}, key, (_String = String).fromCharCode.apply(_String, _to_consumable_array._(new Uint8Array(data))).slice(1)));
            }, {});
            if (_this.metadataQueue.includes(id3Data)) {
                return;
            }
            _this.metadataQueue.push(id3Data);
            metadata = {
                id: id,
                endTime: endTime,
                startTime: startTime,
                startStream: 0,
                id3Data: id3Data
            };
            dispatcher(_mediaengine.VIDEO_EVENTS.TIMED_METADATA, metadata);
        };
        _this.onCanPlay = function(event) {
            if (_this.firstTime) {
                _this.setStartUpTrack();
                _this.firstTime = false;
            }
            if (_this.source.live && !_this.getPresentationStartTime()) {
                var end = _this.getSeekWindow().end;
                _this.availabilityStartTime = _mediaengine.mediaEngineConfig.get("getTime")() - end;
            }
            _this.options.dispatcher(event.type, event.target);
        };
        _this.onTimeUpdate = _lodash.default.throttle(function(event) {
            var _this_options = _this.options, tmp = _this_options.streaming, needPauseFallback = (tmp === void 0 ? {} : tmp).needPauseFallback;
            // resetting retries as the video succeed to load
            if (_this.retries > 0) {
                _this.timeSinceReset += TIME_UPDATE_THROTTLE;
                if (_this.timeSinceReset > RETRY_RESET_TIME) {
                    _this.options.dispatcher(_mediaengine.VIDEO_EVENTS.RETRY_SUCCESS, event.target);
                    _this.retries = 0;
                    _this.timeSinceReset = 0;
                }
            }
            if (needPauseFallback) {
                clearTimeout(_this.needPauseFallbackTimeout);
            }
            if (_this.engine) {
                _this.options.dispatcher(event.type, {
                    currentTime: _this.getCurrentTime(),
                    playhead: _this.engine.currentTime
                });
                /**
                 * On iOS / Safari, un-plugging headphones would pause the video without triggering the "pause" event
                 */ if (needPauseFallback) {
                    _this.paused = false;
                    _this.needPauseFallbackTimeout = setTimeout(function() {
                        if (!_this.paused) {
                            _this.onPause(new Event("pause"));
                        }
                    }, 1000);
                }
                _this.dispatchMetrics();
            }
        }, TIME_UPDATE_THROTTLE, PLAYER_THROTTLE_OPTIONS);
        _this.onPlay = function(event) {
            var _this_options = _this.options, tmp = _this_options.streaming, needPauseFallback = (tmp === void 0 ? {} : tmp).needPauseFallback;
            if (needPauseFallback) {
                clearTimeout(_this.needPauseFallbackTimeout);
            }
            _this.paused = false;
            _this.options.dispatcher(event.type, _this.engine);
        };
        _this.onPause = function(event) {
            var _this_options = _this.options, tmp = _this_options.streaming, needPauseFallback = (tmp === void 0 ? {} : tmp).needPauseFallback;
            if (needPauseFallback) {
                clearTimeout(_this.needPauseFallbackTimeout);
            }
            _this.paused = true;
            _this.options.dispatcher(event.type, _this.engine);
        };
        _this.onSeeked = function(event) {
            _this.options.dispatcher(event.type, _this.getCurrentTime());
        };
        _this.onTextTracksChange = _lodash.default.throttle(function(param) {
            var target = param.target;
            _this.options.dispatcher(_mediaengine.VIDEO_EVENTS.CAN_PLAY, target);
        }, 500, PLAYER_THROTTLE_OPTIONS);
        _this.name = "HTML5Engine";
        _this.metadataQueue = [];
        _this.timeSinceReset = 0;
        return _this;
    }
    _create_class._(HTML5Engine, [
        {
            key: "getMetrics",
            value: function getMetrics() {
                var _this_source;
                // Use currentTime from the start to calculate bufferLength
                var _this_engine = this.engine, videoHeight = _this_engine.videoHeight, videoWidth = _this_engine.videoWidth;
                var _this_getCurrentBufferSlice = this.getCurrentBufferSlice(), bufferLength = _this_getCurrentBufferSlice.bufferLength, bufferEnd = _this_getCurrentBufferSlice.bufferEnd, bufferStart = _this_getCurrentBufferSlice.bufferStart;
                var time = _mediaengine.mediaEngineConfig.get("getTime")();
                return {
                    bufferLength: bufferLength,
                    bufferEnd: bufferEnd,
                    bufferStart: bufferStart,
                    // Use a unix currentTime to get the live latency
                    latency: ((_this_source = this.source) === null || _this_source === void 0 ? void 0 : _this_source.live) ? time - this.getCurrentTime() : null,
                    time: time,
                    bufferLevel: null,
                    droppedFrames: null,
                    bitrate: null,
                    networkBandwith: null,
                    drmInfo: this.getDrmInfo(),
                    videoHeight: videoHeight,
                    videoWidth: videoWidth
                };
            }
        },
        {
            key: "init",
            value: function init(engineTag) {
                this.engine = engineTag;
                this.startTime = 0;
                this.debouncedRetry = _lodash.default.debounce(this.retry, this.options.streaming.retry.delay);
                if (window && _mediaengine.mediaEngineConfig.get("isMocked")) {
                    _lodash.default.set(window, "currentEngine", this);
                    _lodash.default.set(window, "currentEnginePlayer", engineTag);
                }
            }
        },
        {
            key: "setVolume",
            value: function setVolume(volume) {
                this.engine.volume = volume;
            }
        },
        {
            key: "setSpeed",
            value: function setSpeed(speed) {
                this.engine.playbackRate = speed;
            }
        },
        {
            key: "isEnded",
            value: function isEnded() {
                return this.engine.ended;
            }
        },
        {
            key: "isMuted",
            value: function isMuted() {
                return this.engine.hasAttribute("muted");
            }
        },
        {
            key: "setMuted",
            value: function setMuted(muted) {
                this.engine.muted = muted;
                if (muted) {
                    this.engine.setAttribute("muted", "");
                } else {
                    this.engine.removeAttribute("muted");
                }
            }
        },
        {
            key: "setSource",
            value: function setSource(source) {
                var _this = this;
                return _async_to_generator._(function() {
                    var src;
                    return _ts_generator._(this, function(_state) {
                        _this.source = source;
                        _this.firstTime = true;
                        src = _this.source.src;
                        if (_this.startTime) {
                            src = "".concat(_this.source.src, "#t=").concat(_this.startTime);
                        }
                        _this.engine.src = src;
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "getVolume",
            value: function getVolume() {
                return this.engine.volume;
            }
        },
        {
            key: "getDuration",
            value: function getDuration() {
                return this.engine.duration;
            }
        },
        {
            key: "getCurrentTime",
            value: function getCurrentTime() {
                var live = (this.source || {}).live;
                if (live) {
                    return this.getPresentationStartTime() + this.engine.currentTime;
                }
                return this.engine.currentTime;
            }
        },
        {
            key: "getBufferProgress",
            value: function getBufferProgress() {
                var buffered = this.engine.buffered;
                if (buffered.length !== 0) {
                    return buffered.end(buffered.length - 1);
                }
                return 0;
            }
        },
        {
            key: "getCurrentBufferSlice",
            value: function getCurrentBufferSlice() {
                return _mediaengine.EngineUtils.getCurrentBufferSlice(this.engine);
            }
        },
        {
            key: "getBufferStart",
            value: function getBufferStart() {
                var bufferStart = this.getCurrentBufferSlice().bufferStart;
                return bufferStart;
            }
        },
        {
            // Hard-coded value which is at the time-being a bedrock fragment duration
            key: "getAttainableLiveLatency",
            value: function getAttainableLiveLatency() {
                return DEFAULT_FRAGMENT_DURATION;
            }
        },
        {
            key: "getSeekWindow",
            value: function getSeekWindow() {
                return {
                    start: this.engine.seekable.start(0),
                    end: this.engine.seekable.end(0)
                };
            }
        },
        {
            key: "seek",
            value: function seek(position) {
                var _this_getSeekWindow = this.getSeekWindow(), start = _this_getSeekWindow.start, end = _this_getSeekWindow.end;
                if (this.source.live) {
                    var logger = this.options.logger;
                    var seekPosition = position - this.getPresentationStartTime();
                    logger.debug("HTML5Engine", "seek", {
                        start: start,
                        end: end,
                        depth: end - start,
                        pointZero: this.getPresentationStartTime(),
                        currentTime: this.engine.currentTime,
                        position: position,
                        seekPosition: seekPosition,
                        newCurrentTime: Math.max(start, Math.min(seekPosition, end))
                    });
                    this.engine.currentTime = Math.max(start, Math.min(seekPosition, end));
                } else {
                    this.engine.currentTime = Math.max(start, Math.min(position, end - 0.5));
                }
            }
        },
        {
            key: "goToLive",
            value: function goToLive() {
                if (this.source.live) {
                    this.engine.currentTime = this.getSeekWindow().end;
                }
            }
        },
        {
            key: "play",
            value: function play() {
                var _this = this;
                return _async_to_generator._(function() {
                    var error;
                    return _ts_generator._(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _this.engine.play()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                error = _state.sent();
                                if (error && error.name === "NotAllowedError") {
                                    _this.options.dispatcher(_mediaengine.VIDEO_EVENTS.ERROR, new _mediaengine.PlayerError(AUTOPLAY_PREVENTED_ERROR, error.message, false, _this.name));
                                }
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "pause",
            value: function pause() {
                this.engine.pause();
            }
        },
        {
            /**
     * Check if the engine is in pause
     *
     * @returns {boolean}
     */ key: "isPaused",
            value: function isPaused() {
                return this.paused;
            }
        },
        {
            key: "restart",
            value: function restart() {
                this.seek(0);
                this.play();
            }
        },
        {
            /**
     * Getting the event listeners of the engine
     * (those are presents directly in video.events.js
     * as we map all events to native HTML5 events)
     */ key: "setEventListeners",
            value: function setEventListeners() {
                var _this = this;
                this.removeEventListeners();
                _lodash.default.forOwn(_mediaengine.VIDEO_EVENTS, function(event, key) {
                    if (key.indexOf("RETRY") === -1) {
                        _this.engine.addEventListener(event, _this.getEventHandler(key));
                    }
                });
                if (this.engine && this.engine.textTracks) {
                    this.engine.textTracks.addEventListener("change", this.onTextTracksChange);
                }
            }
        },
        {
            key: "setVideoQuality",
            value: function setVideoQuality() {
            // TODO: We need CMAF to handle that case
            }
        },
        {
            key: "getEventHandler",
            value: function getEventHandler(event) {
                var handler = this.defaultHandler;
                var handlerName = "on".concat(_lodash.default.upperFirst(_lodash.default.camelCase(event)));
                if (typeof this[handlerName] === "function") {
                    handler = this[handlerName];
                }
                return handler;
            }
        },
        {
            key: "removeEventListeners",
            value: function removeEventListeners() {
                var _this = this;
                _lodash.default.forOwn(_mediaengine.VIDEO_EVENTS, function(event, key) {
                    if (key.indexOf("RETRY") === -1) {
                        _this.engine.removeEventListener(event, _this.getEventHandler(key));
                    }
                });
                if (this.engine && this.engine.textTracks) {
                    this.engine.textTracks.removeEventListener("change", this.onTextTracksChange);
                }
                if (this.manageId3()) {
                    this.engine.textTracks.removeEventListener("addtrack", this.onAddTrack);
                }
            }
        },
        {
            key: "getActiveSubtitleTrack",
            value: function getActiveSubtitleTrack() {
                if (!this.engine.textTracks || !this.engine.textTracks.length) {
                    return null;
                }
                var textTracks = Array.from(this.engine.textTracks);
                var track = textTracks.find(function(param) {
                    var mode = param.mode;
                    return mode === "showing";
                });
                if (!track) {
                    return null;
                }
                return mapTextTrack(track, textTracks.indexOf(track));
            }
        },
        {
            key: "getSubtitleTracks",
            value: function getSubtitleTracks() {
                if (!this.engine) {
                    return [];
                }
                return Array.from(this.engine.textTracks).map(mapTextTrack);
            }
        },
        {
            key: "setSubtitleTrack",
            value: function setSubtitleTrack(param) {
                var id = param.id;
                if (!this.engine) {
                    return;
                }
                var textTracks = Array.from(this.engine.textTracks);
                textTracks.forEach(function(textTrack, index) {
                    // 'forced' is not a common enough value to be in the TextTrackKind type
                    var disabledRole = textTrack.kind === "forced" ? "disabled" : "hidden";
                    textTrack.mode = index === id ? "showing" : disabledRole;
                });
                this.onTracksChanged("textTrack");
            }
        },
        {
            /**
     * Rules of forced text tracks:
     *
     * - The user loads a stream that does not have forced subtitles
     *   --> The player must continue working as before
     *
     * - The user loads a stream that only has forced subtitles
     *   --> The player must select by default the forced track of the audio language.
     *
     * - The user load a stream that has both forced and unforced subtitles.
     *   --> The player should select by default the forced track of the audio language
     *       only if the user has not selected another language/role
     *
     * WARNING WARNING WARNING
     * This method is used in extended classes of HTML5Engine. Please do not make anything specific to HTML5 in here
     * WARNING WARNING WARNING
     */ key: "setForcedTextTrack",
            value: function setForcedTextTrack() {
                if (!this.engine) {
                    return;
                }
                var activeAudioTrack = this.getActiveAudioTrack();
                var activeTextTrack = this.getActiveSubtitleTrack();
                var textTracks = this.getSubtitleTracks();
                // If there are no non-forced active text track,
                // we should select into the forced text tracks with the same language as the audio
                if (activeTextTrack && !activeTextTrack.forced || !activeAudioTrack) {
                    return;
                }
                var forcedTextTrack = textTracks.find(function(param) {
                    var forced = param.forced, language = param.language;
                    return forced && compareLanguage(language, activeAudioTrack.originalLanguage);
                });
                if (forcedTextTrack) {
                    this.setSubtitleTrack(forcedTextTrack);
                } else {
                    this.removeSubtitleTrack();
                }
            }
        },
        {
            key: "removeSubtitleTrack",
            value: function removeSubtitleTrack() {
                if (!this.engine) {
                    return;
                }
                Array.from(this.engine.textTracks).forEach(function(textTrack) {
                    textTrack.mode = "hidden";
                });
                this.onTracksChanged("textTrack");
            }
        },
        {
            key: "getActiveAudioTrack",
            value: function getActiveAudioTrack() {
                if (!this.engine.audioTracks || !this.engine.audioTracks.length) {
                    return null;
                }
                var audioTracks = Array.from(this.engine.audioTracks);
                var track = audioTracks.find(function(audioTrack) {
                    return audioTrack.enabled;
                });
                if (!track) {
                    return null;
                }
                return mapAudioTrack(track, audioTracks.indexOf(track));
            }
        },
        {
            key: "getAudioTracks",
            value: function getAudioTracks() {
                if (!this.engine.audioTracks || !this.engine.audioTracks.length) {
                    return [];
                }
                return Array.from(this.engine.audioTracks).map(mapAudioTrack);
            }
        },
        {
            key: "setAudioTrack",
            value: function setAudioTrack(track) {
                if (!this.engine.audioTracks || !this.engine.audioTracks.length) {
                    return;
                }
                Array.from(this.engine.audioTracks).forEach(function(audioTrack, id) {
                    audioTrack.enabled = track.id === id;
                });
                /**
         * This could cause the video to have a "false" pause.
         * When switching tracks, we have to load the new audio track, therefore waiting more
         * than 1 second before the next time update.
         */ clearTimeout(this.needPauseFallbackTimeout);
            }
        },
        {
            /**
     * Getting HTML5 engine instance
     */ key: "getInstance",
            value: function getInstance() {
                return this.engine;
            }
        },
        {
            key: "release",
            value: function release() {
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        _this.engine.pause();
                        _this.engine.removeAttribute("src");
                        // Some platforms do not support load() on video elements
                        if (_this.engine.load) {
                            _this.engine.load();
                        }
                        _this.cancelThrottled();
                        _this.removeEventListeners();
                        _this.metadataQueue = [];
                        _this.engine = null;
                        clearTimeout(_this.needPauseFallbackTimeout);
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "cancelThrottled",
            value: function cancelThrottled() {
                // Cancel any throttled activity since we could have removed the source but not the listeners
                this.onProgress.cancel();
                this.onSeeking.cancel();
                this.onVolumeChange.cancel();
                this.onTimeUpdate.cancel();
                this.onTextTracksChange.cancel();
                this.dispatchMetrics.cancel();
            }
        },
        {
            key: "reset",
            value: function reset() {
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        _this.cancelThrottled();
                        if (_this.engine) {
                            _this.engine.removeAttribute("src");
                            // Some platforms do not support load() on video elements
                            if (_this.engine.load) {
                                _this.engine.load();
                            }
                        }
                        _this.source = null;
                        _this.availabilityStartTime = null;
                        _this.metadataQueue = [];
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "getDrmInfo",
            value: function getDrmInfo() {
                return {};
            }
        },
        {
            key: "setStartUpTrack",
            value: function setStartUpTrack() {
                var _this = this;
                var defaultAudioTrack = this.getDefaultTrack(this.getAudioTracks(), _lodash.default.get(this.options, "streaming.preferredTrack.audio"));
                if (defaultAudioTrack) {
                    this.setAudioTrack(defaultAudioTrack);
                }
                /*
         * Applying the text preference too soon can result in it being reverted.
         * Thank you HTML5 :mindblown:
         */ setTimeout(function() {
                    // Engine could have been released in the mean time
                    if (!_this.engine) {
                        return;
                    }
                    var defaultSubtitleTrack = _this.getDefaultTrack(_this.getSubtitleTracks(), _lodash.default.get(_this.options, "streaming.preferredTrack.subtitle"));
                    if (defaultSubtitleTrack) {
                        _this.setSubtitleTrack(defaultSubtitleTrack);
                    } else {
                        _this.setForcedTextTrack();
                    }
                }, 1000);
            }
        },
        {
            /*
     * WARNING WARNING WARNING
     * This method is used in extended classes of HTML5Engine. Please do not make anything specific to HTML5 in here
     * WARNING WARNING WARNING
     */ key: "getDefaultTrack",
            value: function getDefaultTrack(tracks, preferredTrack) {
                if (!preferredTrack || !tracks.length) {
                    return null;
                }
                var languageFilteredTracks = tracks.filter(function(param) {
                    var originalLanguage = param.originalLanguage, forced = param.forced;
                    return !forced && compareLanguage(originalLanguage, preferredTrack.originalLanguage);
                });
                return(// First check if we match the preferred roles
                languageFilteredTracks.find(function(param) {
                    var roles = param.roles;
                    return _lodash.default.isEqual(roles, preferredTrack.roles);
                }) || // Then try to start with the correct language
                languageFilteredTracks[0]);
            }
        }
    ]);
    return HTML5Engine;
}(_mediaengine.Engine);


/***/ }),

/***/ 93344:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    HTML5Engine: function() {
        return _HTML5Engine.HTML5Engine;
    },
    HTML5_ERROR: function() {
        return _HTML5Error;
    }
});
var _interop_require_wildcard = __webpack_require__(95316);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(52318);
var _HTML5Error = /*#__PURE__*/ _interop_require_wildcard._(__webpack_require__(9252));
var _HTML5Engine = __webpack_require__(55013);


/***/ }),

/***/ 22624:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    CONTAINER_HLS: function() {
        return CONTAINER_HLS;
    },
    CONTAINER_PROGRESSIVE_DOWNLOAD: function() {
        return CONTAINER_PROGRESSIVE_DOWNLOAD;
    },
    DEFAULT_FRAGMENT_DURATION: function() {
        return DEFAULT_FRAGMENT_DURATION;
    },
    FORMAT_DASH_CENC: function() {
        return FORMAT_DASH_CENC;
    },
    FORMAT_DASH_CENC_MULTI_PERIODS: function() {
        return FORMAT_DASH_CENC_MULTI_PERIODS;
    },
    FORMAT_DASH_UNPROTECTED: function() {
        return FORMAT_DASH_UNPROTECTED;
    },
    FORMAT_HLS: function() {
        return FORMAT_HLS;
    },
    FORMAT_HLS_FAIRPLAY: function() {
        return FORMAT_HLS_FAIRPLAY;
    },
    FORMAT_PROGRESSIVE_DOWNLOAD: function() {
        return FORMAT_PROGRESSIVE_DOWNLOAD;
    },
    FORMAT_WEBVIEW_HLS: function() {
        return FORMAT_WEBVIEW_HLS;
    },
    TYPE_SUBTITLE: function() {
        return TYPE_SUBTITLE;
    },
    TYPE_SUBTITLE_SM: function() {
        return TYPE_SUBTITLE_SM;
    }
});
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(3009);
var FORMAT_PROGRESSIVE_DOWNLOAD = "http";
var FORMAT_HLS = "hls";
var FORMAT_WEBVIEW_HLS = "wvhls";
var FORMAT_HLS_FAIRPLAY = "hlsfp";
var FORMAT_DASH_UNPROTECTED = "dash";
var FORMAT_DASH_CENC = "dashcenc";
var FORMAT_DASH_CENC_MULTI_PERIODS = "dashcencmp";
var TYPE_SUBTITLE = "http_subtitle";
var TYPE_SUBTITLE_SM = "http_subtitle_vtt_sm";
var CONTAINER_HLS = "m3u8";
var CONTAINER_PROGRESSIVE_DOWNLOAD = "mp4";
var DEFAULT_FRAGMENT_DURATION = 6;


/***/ }),

/***/ 51209:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    INTERNAL_ERROR_GET_PLAYER: function() {
        return INTERNAL_ERROR_GET_PLAYER;
    },
    INTERNAL_ERROR_NO_CONTAINER: function() {
        return INTERNAL_ERROR_NO_CONTAINER;
    },
    INTERNAL_ERROR_NO_SOURCE: function() {
        return INTERNAL_ERROR_NO_SOURCE;
    },
    INTERNAL_ERROR_OVERLOAD: function() {
        return INTERNAL_ERROR_OVERLOAD;
    },
    INTERNAL_ERROR_SET_SOURCE: function() {
        return INTERNAL_ERROR_SET_SOURCE;
    },
    INTERNAL_ERROR_UNKNOWN: function() {
        return INTERNAL_ERROR_UNKNOWN;
    }
});
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(52318);
var INTERNAL_ERROR_OVERLOAD = "INTERNAL_ERROR_OVERLOAD";
var INTERNAL_ERROR_NO_CONTAINER = "INTERNAL_ERROR_NO_CONTAINER";
var INTERNAL_ERROR_UNKNOWN = "INTERNAL_ERROR_UNKNOWN";
var INTERNAL_ERROR_NO_SOURCE = "INTERNAL_ERROR_NO_SOURCE";
var INTERNAL_ERROR_GET_PLAYER = "INTERNAL_ERROR_GET_PLAYER";
var INTERNAL_ERROR_SET_SOURCE = "INTERNAL_ERROR_SET_SOURCE";


/***/ }),

/***/ 67661:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "PlayerError", ({
    enumerable: true,
    get: function() {
        return PlayerError;
    }
}));
var _class_call_check = __webpack_require__(67818);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
var _types = __webpack_require__(87187);
var _details = __webpack_require__(48560);
var PlayerError = function PlayerError() {
    "use strict";
    var type = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : _types.UNKNOWN_ERROR, details = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _details.UNKNOWN, fatal = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true, context = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", reason = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "", content = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "", monitored = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : true;
    _class_call_check._(this, PlayerError);
    this.type = type;
    this.details = details;
    this.fatal = fatal;
    this.context = context;
    this.reason = reason;
    this.content = content;
    this.monitored = monitored;
};


/***/ }),

/***/ 48560:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    AD_COULD_NOT_PLAY: function() {
        return AD_COULD_NOT_PLAY;
    },
    AD_NO_AD_RESPONSE: function() {
        return AD_NO_AD_RESPONSE;
    },
    AD_NO_SUPPORTED_MEDIA_FILE: function() {
        return AD_NO_SUPPORTED_MEDIA_FILE;
    },
    AD_REQUEST_FAILED: function() {
        return AD_REQUEST_FAILED;
    },
    AD_TIMED_OUT: function() {
        return AD_TIMED_OUT;
    },
    AD_UNKNOWN_ERROR: function() {
        return AD_UNKNOWN_ERROR;
    },
    AUTOPLAY_PREVENTED_ERROR: function() {
        return AUTOPLAY_PREVENTED_ERROR;
    },
    CPC_GONE_ERROR: function() {
        return CPC_GONE_ERROR;
    },
    CPC_HTTP_ERROR: function() {
        return CPC_HTTP_ERROR;
    },
    CSL_CONCURENT_STREAM_LIMIT: function() {
        return CSL_CONCURENT_STREAM_LIMIT;
    },
    CSL_USER_HAS_NO_CSL_ACCESS: function() {
        return CSL_USER_HAS_NO_CSL_ACCESS;
    },
    DASH_CAPABILITY_ERROR: function() {
        return DASH_CAPABILITY_ERROR;
    },
    DASH_DOWNLOAD_ERROR: function() {
        return DASH_DOWNLOAD_ERROR;
    },
    DASH_KEY_MESSAGE_ERROR: function() {
        return DASH_KEY_MESSAGE_ERROR;
    },
    DASH_KEY_SESSION_ERROR: function() {
        return DASH_KEY_SESSION_ERROR;
    },
    DASH_MANIFEST_ERROR: function() {
        return DASH_MANIFEST_ERROR;
    },
    DASH_MEDIA_SOURCE_ERROR: function() {
        return DASH_MEDIA_SOURCE_ERROR;
    },
    DASH_OTHER_ERROR: function() {
        return DASH_OTHER_ERROR;
    },
    DASH_TIMED_TEXT_ERROR: function() {
        return DASH_TIMED_TEXT_ERROR;
    },
    DRM_CERTIFICATE_ERROR: function() {
        return DRM_CERTIFICATE_ERROR;
    },
    DRM_CERTIFICATE_FETCHING_ERROR: function() {
        return DRM_CERTIFICATE_FETCHING_ERROR;
    },
    DRM_CREATE_KEY_SESSION_ERROR: function() {
        return DRM_CREATE_KEY_SESSION_ERROR;
    },
    DRM_CREATE_MEDIA_KEYS_ERROR: function() {
        return DRM_CREATE_MEDIA_KEYS_ERROR;
    },
    DRM_HDCP_ERROR: function() {
        return DRM_HDCP_ERROR;
    },
    DRM_KEY_SESSION_ERROR: function() {
        return DRM_KEY_SESSION_ERROR;
    },
    DRM_LICENSE_FETCHING_ERROR: function() {
        return DRM_LICENSE_FETCHING_ERROR;
    },
    ENGINE_DRM_ERROR: function() {
        return ENGINE_DRM_ERROR;
    },
    ENGINE_MANIFEST_ERROR: function() {
        return ENGINE_MANIFEST_ERROR;
    },
    ENGINE_MEDIA_ERROR: function() {
        return ENGINE_MEDIA_ERROR;
    },
    ENGINE_NETWORK_ERROR: function() {
        return ENGINE_NETWORK_ERROR;
    },
    ENGINE_PLAYER_ERROR: function() {
        return ENGINE_PLAYER_ERROR;
    },
    ENGINE_STORAGE_ERROR: function() {
        return ENGINE_STORAGE_ERROR;
    },
    ENGINE_STREAMING_ERROR: function() {
        return ENGINE_STREAMING_ERROR;
    },
    ENGINE_TEXT_ERROR: function() {
        return ENGINE_TEXT_ERROR;
    },
    ENGINE_UNKNOWN_ERROR: function() {
        return ENGINE_UNKNOWN_ERROR;
    },
    EVENT_UNKNOWN: function() {
        return EVENT_UNKNOWN;
    },
    LAYOUT_FETCHING_ERROR: function() {
        return LAYOUT_FETCHING_ERROR;
    },
    MEDIA_PLAYER_LIBRARY_ERROR: function() {
        return MEDIA_PLAYER_LIBRARY_ERROR;
    },
    METHOD_MUST_BE_OVERLOADED: function() {
        return METHOD_MUST_BE_OVERLOADED;
    },
    NETWORK_ERROR: function() {
        return NETWORK_ERROR;
    },
    NO_CONTAINER: function() {
        return NO_CONTAINER;
    },
    NO_PLAYER: function() {
        return NO_PLAYER;
    },
    NO_SOURCE: function() {
        return NO_SOURCE;
    },
    NO_VIDEO_QUALITIES_SUPPORTED: function() {
        return NO_VIDEO_QUALITIES_SUPPORTED;
    },
    SDK_ERROR: function() {
        return SDK_ERROR;
    },
    UNKNOWN: function() {
        return UNKNOWN;
    },
    UPFRONT_TOKEN_ERROR: function() {
        return UPFRONT_TOKEN_ERROR;
    }
});
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(3009);
var UNKNOWN = "UNKNOWN";
var METHOD_MUST_BE_OVERLOADED = "METHOD_MUST_BE_OVERLOADED";
var NO_CONTAINER = "NO_CONTAINER";
var NO_SOURCE = "NO_SOURCE";
var NO_VIDEO_QUALITIES_SUPPORTED = "NO_VIDEO_QUALITIES_SUPPORTED";
var EVENT_UNKNOWN = "EVENT_UNKNOWN";
var NO_PLAYER = "NO_PLAYER";
var CPC_HTTP_ERROR = "CPC_HTTP_ERROR";
var CPC_GONE_ERROR = "CPC_GONE_ERROR";
var LAYOUT_FETCHING_ERROR = "LAYOUT_FETCHING_ERROR";
var AD_UNKNOWN_ERROR = "AD_UNKNOWN_ERROR";
var AD_REQUEST_FAILED = "AD_REQUEST_FAILED";
var AD_TIMED_OUT = "AD_TIMED_OUT";
var AD_NO_SUPPORTED_MEDIA_FILE = "AD_NO_SUPPORTED_MEDIA_FILE";
var AD_COULD_NOT_PLAY = "AD_COULD_NOT_PLAY";
var AD_NO_AD_RESPONSE = "AD_NO_AD_RESPONSE";
var ENGINE_NETWORK_ERROR = "ENGINE_NETWORK_ERROR";
var ENGINE_UNKNOWN_ERROR = "ENGINE_UNKNOWN_ERROR";
var ENGINE_TEXT_ERROR = "ENGINE_TEXT_ERROR";
var ENGINE_MEDIA_ERROR = "ENGINE_MEDIA_ERROR";
var ENGINE_MANIFEST_ERROR = "ENGINE_MANIFEST_ERROR";
var ENGINE_STREAMING_ERROR = "ENGINE_STREAMING_ERROR";
var ENGINE_DRM_ERROR = "ENGINE_DRM_ERROR";
var ENGINE_PLAYER_ERROR = "ENGINE_PLAYER_ERROR";
var ENGINE_STORAGE_ERROR = "ENGINE_STORAGE_ERROR";
var DASH_CAPABILITY_ERROR = "DASH_CAPABILITY_ERROR";
var DASH_DOWNLOAD_ERROR = "DASH_DOWNLOAD_ERROR";
var DASH_MANIFEST_ERROR = "DASH_MANIFEST_ERROR";
var DASH_MEDIA_SOURCE_ERROR = "DASH_MEDIA_SOURCE_ERROR";
var DASH_KEY_SESSION_ERROR = "DASH_KEY_SESSION_ERROR";
var DASH_KEY_MESSAGE_ERROR = "DASH_KEY_MESSAGE_ERROR";
var DASH_TIMED_TEXT_ERROR = "DASH_TIMED_TEXT_ERROR";
var DASH_OTHER_ERROR = "DASH_OTHER_ERROR";
var UPFRONT_TOKEN_ERROR = "UPFRONT_TOKEN_ERROR";
var CSL_CONCURENT_STREAM_LIMIT = "CSL_CONCURENT_STREAM_LIMIT";
var CSL_USER_HAS_NO_CSL_ACCESS = "CSL_USER_HAS_NO_CSL_ACCESS";
var DRM_LICENSE_FETCHING_ERROR = "DRM_LICENSE_FETCHING_ERROR";
var DRM_CERTIFICATE_FETCHING_ERROR = "DRM_CERTIFICATE_FETCHING_ERROR";
var DRM_CREATE_MEDIA_KEYS_ERROR = "DRM_CREATE_MEDIA_KEYS_ERROR";
var DRM_CREATE_KEY_SESSION_ERROR = "DRM_CREATE_KEY_SESSION_ERROR";
var DRM_KEY_SESSION_ERROR = "DRM_KEY_SESSION_ERROR";
var DRM_HDCP_ERROR = "DRM_HDCP_ERROR";
var DRM_CERTIFICATE_ERROR = "DRM_CERTIFICATE_ERROR";
var AUTOPLAY_PREVENTED_ERROR = "AUTOPLAY_PREVENTED_ERROR";
var MEDIA_PLAYER_LIBRARY_ERROR = "MEDIA_PLAYER_LIBRARY_ERROR";
var SDK_ERROR = "SDK_ERROR";
var NETWORK_ERROR = "NEWTORK_ERROR";


/***/ }),

/***/ 87187:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    AD_ERROR: function() {
        return AD_ERROR;
    },
    BRIDGE_ERROR: function() {
        return BRIDGE_ERROR;
    },
    CPC_ERROR: function() {
        return CPC_ERROR;
    },
    CSL_ERROR: function() {
        return CSL_ERROR;
    },
    DASH_ERROR: function() {
        return DASH_ERROR;
    },
    DRM_DEVICE_REVOKED_ERROR: function() {
        return DRM_DEVICE_REVOKED_ERROR;
    },
    DRM_ERROR: function() {
        return DRM_ERROR;
    },
    ENGINE_ERROR: function() {
        return ENGINE_ERROR;
    },
    HLS_ERROR: function() {
        return HLS_ERROR;
    },
    IMPLEMENTATION_ERROR: function() {
        return IMPLEMENTATION_ERROR;
    },
    JS_ERROR: function() {
        return JS_ERROR;
    },
    LOAD_ERROR: function() {
        return LOAD_ERROR;
    },
    SMOOTH_ERROR: function() {
        return SMOOTH_ERROR;
    },
    UNKNOWN_ERROR: function() {
        return UNKNOWN_ERROR;
    }
});
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(3009);
var UNKNOWN_ERROR = "UNKNOWN_ERROR";
var JS_ERROR = "JS_ERROR";
var IMPLEMENTATION_ERROR = "IMPLEMENTATION_ERROR";
var BRIDGE_ERROR = "BRIDGE_ERROR";
var ENGINE_ERROR = "ENGINE_ERROR";
var CPC_ERROR = "CPC_ERROR";
var AD_ERROR = "AD_ERROR";
var DRM_ERROR = "DRM_ERROR";
var CSL_ERROR = "CSL_ERROR";
var DRM_DEVICE_REVOKED_ERROR = "DRM_DEVICE_REVOKED_ERROR";
var HLS_ERROR = "HLS_ERROR";
var DASH_ERROR = "DASH_ERROR";
var SMOOTH_ERROR = "SMOOTH_ERROR";
var LOAD_ERROR = "LOAD_ERROR";


/***/ }),

/***/ 24078:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
// Converts language codes from ISO693-3 to ISO693-1

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "ISO693Codes", ({
    enumerable: true,
    get: function() {
        return ISO693Codes;
    }
}));
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(45538);
var ISO693Codes = {
    aar: "aa",
    abk: "ab",
    afr: "af",
    aka: "ak",
    amh: "am",
    ara: "ar",
    arg: "an",
    asm: "as",
    ava: "av",
    ave: "ae",
    aym: "ay",
    aze: "az",
    bak: "ba",
    bam: "bm",
    bel: "be",
    ben: "bn",
    bis: "bi",
    bod: "bo",
    bos: "bs",
    bre: "br",
    bul: "bg",
    cat: "ca",
    ces: "cs",
    cha: "ch",
    che: "ce",
    chu: "cu",
    chv: "cv",
    cor: "kw",
    cos: "co",
    cre: "cr",
    cym: "cy",
    dan: "da",
    deu: "de",
    div: "dv",
    dzo: "dz",
    ell: "el",
    eng: "en",
    epo: "eo",
    est: "et",
    eus: "eu",
    ewe: "ee",
    fao: "fo",
    fas: "fa",
    fij: "fj",
    fin: "fi",
    fra: "fr",
    fry: "fy",
    ful: "ff",
    gla: "gd",
    gle: "ga",
    glg: "gl",
    glv: "gv",
    grn: "gn",
    guj: "gu",
    hat: "ht",
    hau: "ha",
    hbs: "sh",
    heb: "he",
    her: "hz",
    hin: "hi",
    hmo: "ho",
    hrv: "hr",
    hun: "hu",
    hye: "hy",
    ibo: "ig",
    ido: "io",
    iii: "ii",
    iku: "iu",
    ile: "ie",
    ina: "ia",
    ind: "id",
    ipk: "ik",
    isl: "is",
    ita: "it",
    jav: "jv",
    jpn: "ja",
    kal: "kl",
    kan: "kn",
    kas: "ks",
    kat: "ka",
    kau: "kr",
    kaz: "kk",
    khm: "km",
    kik: "ki",
    kin: "rw",
    kir: "ky",
    kom: "kv",
    kon: "kg",
    kor: "ko",
    kua: "kj",
    kur: "ku",
    lao: "lo",
    lat: "la",
    lav: "lv",
    lim: "li",
    lin: "ln",
    lit: "lt",
    ltz: "lb",
    lub: "lu",
    lug: "lg",
    mah: "mh",
    mal: "ml",
    mar: "mr",
    mkd: "mk",
    mlg: "mg",
    mlt: "mt",
    mon: "mn",
    mri: "mi",
    msa: "ms",
    mya: "my",
    nau: "na",
    nav: "nv",
    nbl: "nr",
    nde: "nd",
    ndo: "ng",
    nep: "ne",
    nld: "nl",
    nno: "nn",
    nob: "nb",
    nor: "no",
    nya: "ny",
    oci: "oc",
    oji: "oj",
    ori: "or",
    orm: "om",
    oss: "os",
    pan: "pa",
    pli: "pi",
    pol: "pl",
    por: "pt",
    pus: "ps",
    que: "qu",
    roh: "rm",
    ron: "ro",
    run: "rn",
    rus: "ru",
    sag: "sg",
    san: "sa",
    sin: "si",
    slk: "sk",
    slv: "sl",
    sme: "se",
    smo: "sm",
    sna: "sn",
    snd: "sd",
    som: "so",
    sot: "st",
    spa: "es",
    sqi: "sq",
    srd: "sc",
    srp: "sr",
    ssw: "ss",
    sun: "su",
    swa: "sw",
    swe: "sv",
    tah: "ty",
    tam: "ta",
    tat: "tt",
    tel: "te",
    tgk: "tg",
    tgl: "tl",
    tha: "th",
    tir: "ti",
    ton: "to",
    tsn: "tn",
    tso: "ts",
    tuk: "tk",
    tur: "tr",
    twi: "tw",
    uig: "ug",
    ukr: "uk",
    urd: "ur",
    uzb: "uz",
    ven: "ve",
    vie: "vi",
    vol: "vo",
    wln: "wa",
    wol: "wo",
    xho: "xh",
    yid: "yi",
    yor: "yo",
    zha: "za",
    zho: "zh",
    zul: "zu"
};


/***/ }),

/***/ 43585:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    APPLE_HLS: function() {
        return APPLE_HLS;
    },
    APPLICATION_DASH: function() {
        return APPLICATION_DASH;
    },
    DEFAULT_MIME_TYPE: function() {
        return DEFAULT_MIME_TYPE;
    },
    VIDEO_MP4: function() {
        return VIDEO_MP4;
    }
});
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
var VIDEO_MP4 = "video/mp4";
var APPLE_HLS = "application/vnd.apple.mpegURL";
var APPLICATION_DASH = "application/dash+xml";
var DEFAULT_MIME_TYPE = "application/octet-stream";


/***/ }),

/***/ 16428:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    EXT_X_CUE: function() {
        return EXT_X_CUE;
    },
    EXT_X_CUE_IN: function() {
        return EXT_X_CUE_IN;
    },
    EXT_X_CUE_OUT: function() {
        return EXT_X_CUE_OUT;
    },
    EXT_X_CUE_OUT_CONT: function() {
        return EXT_X_CUE_OUT_CONT;
    },
    REGEX_OATCLS_SCTE35: function() {
        return REGEX_OATCLS_SCTE35;
    }
});
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(88801);
var EXT_X_CUE = "EXT-X-CUE";
var EXT_X_CUE_OUT = "".concat(EXT_X_CUE, "-OUT");
var EXT_X_CUE_OUT_CONT = "".concat(EXT_X_CUE_OUT, "-CONT");
var EXT_X_CUE_IN = "".concat(EXT_X_CUE, "-IN");
var REGEX_OATCLS_SCTE35 = /^EXT-(?:X-)?OATCLS-SCTE35$/;


/***/ }),

/***/ 84281:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "VIDEO_EVENTS", ({
    enumerable: true,
    get: function() {
        return VIDEO_EVENTS;
    }
}));
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(65759);
var VIDEO_EVENTS = {
    // Fires when the loading of an audio/video is aborted
    ABORT: "abort",
    // Fires when the browser can start playing the audio/video
    CAN_PLAY: "canplay",
    // Fires when the browser can play through the audio/video without stopping for buffering
    CAN_PLAY_THROUGH: "canplaythrough",
    // Fires when the duration of the audio/video is changed
    DURATION_CHANGE: "durationchange",
    // Fires when the current playlist is empty
    EMPTIED: "emptied",
    // Fires when the current playlist is ended
    ENDED: "ended",
    // Fires when an error occurred during the loading of an audio/video
    ERROR: "error",
    // Fires when the browser has loaded the current frame of the audio/video
    LOADED_DATA: "loadeddata",
    // Fires when the browser has loaded meta data for the audio/video
    LOADED_METADATA: "loadedmetadata",
    // Fires when parsing id3 is completed
    TIMED_METADATA: "timedmetadata",
    // Fires when parsing scte tags is completed
    SCTE: "scte",
    // Fires when the browser starts looking for the audio/video
    LOAD_START: "loadstart",
    // Fires when the audio/video has been paused
    PAUSE: "pause",
    // Fires when the audio/video has been started or is no longer paused
    PLAY: "play",
    // Fires when the audio/video is playing after having been paused or stopped for buffering
    PLAYING: "playing",
    // Fires when the browser is downloading the audio/video
    PROGRESS: "progress",
    // Fires when the playing speed of the audio/video is changed
    RATE_CHANGE: "ratechange",
    // Fires when the user is finished moving/skipping to a new position in the audio/video
    SEEKED: "seeked",
    // Fires when the user starts moving/skipping to a new position in the audio/video
    SEEKING: "seeking",
    // Fires when the browser is trying to get media data, but data is not available
    STALLED: "stalled",
    // Fires when the browser is intentionally not getting media data
    SUSPEND: "suspend",
    // Fires when the current playback position has changed
    TIME_UPDATE: "timeupdate",
    // Fires when the volume has been changed
    VOLUME_CHANGE: "volumechange",
    // Fires when the video stops because it needs to buffer the next frame
    WAITING: "waiting",
    // Fires when the video detects an encrypted stream
    ENCRYPTED: "encrypted",
    // Fires when the video retries because the load has failed
    RETRY: "retry",
    // Fires when the video has reached the max retries
    RETRY_FAILED: "retryfailed",
    // Fires when the video has successfully retry
    RETRY_SUCCESS: "retrysuccess",
    // Fires when the engine has loaded the license
    LOADED_DRM_LICENSE_DATA: "license",
    // Fires when the engine changes the quality to an upper or lower one
    FALLBACK_QUALITY: "fallback_quality",
    // Fires when the source is set to the fallback source
    FALLBACK_SOURCE: "fallback_source",
    // Fires when the engine retry a fragment load because it failed
    FRAGMENT_RETRY: "fragment_retry",
    // Fires when the engine has loaded a new fragment successfully
    FRAGMENT_CHANGED: "fragment_changed",
    // Fires when the engine retried fragment works well
    FRAGMENT_RETRY_SUCCESS: "fragment_retry_success",
    // Fires when the engine retried fragment has failed
    FRAGMENT_RETRY_FAILED: "fragment_retry_failed",
    // Fires when a faulty segment is recovered
    RECOVER_FAULTY_SEGMENT: "recover_faulty_segment",
    // Fires when a track change
    TRACKS_CHANGE: "tracksChange",
    // Fires when a quality change
    QUALITY_CHANGE: "qualityChange",
    // Fires when a quality change
    PREFERRED_QUALITY_CHANGE: "preferredQualityChange"
};


/***/ }),

/***/ 62554:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    PLAYER_THROTTLE_OPTIONS: function() {
        return PLAYER_THROTTLE_OPTIONS;
    },
    PROGRESS_THROTTLE: function() {
        return PROGRESS_THROTTLE;
    },
    RETRY_RESET_TIME: function() {
        return RETRY_RESET_TIME;
    },
    SEEKING_THROTTLE: function() {
        return SEEKING_THROTTLE;
    },
    TIME_UPDATE_THROTTLE: function() {
        return TIME_UPDATE_THROTTLE;
    },
    VOLUME_CHANGE_THROTTLE: function() {
        return VOLUME_CHANGE_THROTTLE;
    }
});
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(88801);
var PROGRESS_THROTTLE = 1000;
var SEEKING_THROTTLE = 150;
var TIME_UPDATE_THROTTLE = 500;
var RETRY_RESET_TIME = 10000;
var VOLUME_CHANGE_THROTTLE = 100;
var PLAYER_THROTTLE_OPTIONS = {
    leading: true,
    trailing: false
};


/***/ }),

/***/ 90940:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "BaseEngine", ({
    enumerable: true,
    get: function() {
        return BaseEngine;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(42578);
var _lodash = /*#__PURE__*/ _interop_require_default._(__webpack_require__(32699));
var _videoeventsthrottle = __webpack_require__(62554);
var BaseEngine = /*#__PURE__*/ function() {
    "use strict";
    function BaseEngine() {
        var _this = this;
        _class_call_check._(this, BaseEngine);
        this.name = "AbstractBaseEngine";
        // Using Partial to enable the use of multiple Source types between apps
        // Could be changed in the futur once the Source types have merged
        this.source = null;
        this.paused = true;
        this.seeking = false;
        this.startTime = 0;
        this.retries = 0;
        this.needSeekPosition = null;
        this.dispatchMetrics = _lodash.default.throttle(function() {
            var _this_options_metrics = _this.options.metrics, enabled = _this_options_metrics.enabled, handler = _this_options_metrics.handler;
            if (enabled) {
                handler(_this.getMetrics());
            }
        }, 1000, _videoeventsthrottle.PLAYER_THROTTLE_OPTIONS);
    }
    _create_class._(BaseEngine, [
        {
            key: "onSeeked",
            value: function onSeeked(event) {
                this.options.dispatcher(event.type, {
                    currentTime: this.getCurrentTime()
                });
            }
        },
        {
            key: "clearNeedSeekPosition",
            value: function clearNeedSeekPosition(currentTime) {
                if (currentTime !== undefined && this.needSeekPosition !== null && currentTime > this.needSeekPosition) {
                    this.needSeekPosition = null;
                }
            }
        }
    ], [
        {
            key: "seekDirection",
            value: /**
     * Static methods
     */ function seekDirection(position, currentTime) {
                return currentTime < position ? "forward" /* SeekDirection.FORWARD */  : "backward" /* SeekDirection.BACKWARD */ ;
            }
        },
        {
            key: "safeSeekPosition",
            value: function safeSeekPosition(position, param) {
                var start = param.start, end = param.end;
                return Math.max(start, Math.min(position, end - 1));
            }
        },
        {
            key: "getVersion",
            value: function getVersion() {
                return null;
            }
        }
    ]);
    return BaseEngine;
}();


/***/ }),

/***/ 35425:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "Engine", ({
    enumerable: true,
    get: function() {
        return Engine;
    }
}));
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _interop_require_wildcard = __webpack_require__(95316);
var _create_super = __webpack_require__(6400);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(45538);
var _lodash = /*#__PURE__*/ _interop_require_default._(__webpack_require__(32699));
var _MediaEngineInternalErrors = /*#__PURE__*/ _interop_require_wildcard._(__webpack_require__(51209));
var _details = /*#__PURE__*/ _interop_require_wildcard._(__webpack_require__(48560));
var _types = __webpack_require__(87187);
var _PlayerError = __webpack_require__(67661);
var _defaultOptions = __webpack_require__(77291);
var _videoevents = __webpack_require__(84281);
var _BaseEngine = __webpack_require__(90940);
var Engine = /*#__PURE__*/ function(BaseEngine) {
    "use strict";
    _inherits._(Engine, BaseEngine);
    var _super = _create_super._(Engine);
    function Engine() {
        _class_call_check._(this, Engine);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.name = "AbstractEngine";
        _this.options = _defaultOptions.defaultEngineOptions;
        _this.source = null;
        return _this;
    }
    _create_class._(Engine, [
        {
            key: "configure",
            value: function configure(options) {
                this.options = _lodash.default.merge({}, _defaultOptions.defaultEngineOptions, this.options, options);
            }
        },
        {
            key: "setEventListeners",
            value: function setEventListeners() {}
        },
        {
            key: "removeEventListeners",
            value: function removeEventListeners() {}
        },
        {
            key: "dispatchInternalError",
            value: function dispatchInternalError(internalErrorType, reason) {
                var content = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
                var error;
                switch(internalErrorType){
                    case _MediaEngineInternalErrors.INTERNAL_ERROR_OVERLOAD:
                        error = new _PlayerError.PlayerError(_types.IMPLEMENTATION_ERROR, _details.METHOD_MUST_BE_OVERLOADED, true, this.name, reason, content);
                        break;
                    case _MediaEngineInternalErrors.INTERNAL_ERROR_GET_PLAYER:
                        error = new _PlayerError.PlayerError(_types.IMPLEMENTATION_ERROR, _details.NO_PLAYER, true, this.name, reason, content);
                        break;
                    default:
                        error = new _PlayerError.PlayerError(_types.ENGINE_ERROR, _details.UNKNOWN, true, this.name, reason, content);
                        break;
                }
                this.options.dispatcher(_videoevents.VIDEO_EVENTS.ERROR, error);
            }
        },
        {
            key: "setStartTime",
            value: function setStartTime(startTime) {
                this.startTime = startTime;
            }
        },
        {
            key: "setSource",
            value: function setSource(source) {
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        _this.source = source;
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "retryOnFallbackSource",
            value: function retryOnFallbackSource() {
                if (this.source.fallbackSource) {
                    this.source = this.source.fallbackSource;
                    this.setSource(this.source);
                    return true;
                }
                return false;
            }
        },
        {
            /**
     * Retry strategy
     * Check token expiration and update source (by calling middleware) if it is expired
     *
     * @param event
     * @returns {boolean}
     */ key: "retry",
            value: function retry(event) {
                var max = this.options.streaming.retry.max;
                this.retries++;
                // Trying to reload the video three times
                if (this.retries <= max) {
                    this.options.logger.debug(this.name, "retry", "Tentative ".concat(this.retries, " / ").concat(max));
                    var source = this.source;
                    // ⚠️ Always set the startTime before the source ⚠️
                    if (source && !source.live) {
                        this.setStartTime(this.getCurrentTime() || 0);
                    }
                    this.options.dispatcher(_videoevents.VIDEO_EVENTS.RETRY, event.target);
                    return true;
                }
                this.options.dispatcher(_videoevents.VIDEO_EVENTS.RETRY_FAILED, event.target);
                if (this.retryOnFallbackSource()) {
                    this.options.dispatcher(_videoevents.VIDEO_EVENTS.FALLBACK_SOURCE, this.source);
                    return true;
                }
                this.options.dispatcher(event.type, event.target);
                return false;
            }
        },
        {
            /**
     * Rules of forced text tracks:
     *
     * - The user loads a stream that does not have forced subtitles
     *   --> The player must continue working as before
     *
     * - The user loads a stream that only has forced subtitles
     *   --> The player must select by default the forced track of the audio language.
     *
     * - The user load a stream that has both forced and unforced subtitles.
     *   --> The player should select by default the forced track of the audio language
     *       only if the user has not selected another language/role
     */ key: "setForcedTextTrack",
            value: function setForcedTextTrack() {
                if (!this.engine) {
                    return;
                }
                var activeAudioTrack = this.getActiveAudioTrack();
                var activeTextTrack = this.getActiveSubtitleTrack();
                var textTracks = this.getSubtitleTracks();
                /*
         * If there are no non-forced active text track, we should select into the forced
         * text tracks with the same language as the audio
         */ if (activeTextTrack && !activeTextTrack.forced || !activeAudioTrack) {
                    return;
                }
                var forcedTextTrack = textTracks.find(function(param) {
                    var forced = param.forced, language = param.language;
                    return forced && language === activeAudioTrack.language;
                });
                if (forcedTextTrack) {
                    this.setSubtitleTrack(forcedTextTrack);
                } else {
                    this.removeSubtitleTrack();
                }
            }
        },
        {
            /**
     * Match the stream tracks against a preferredTrack to get default startup track
     * Works for both text & audio tracks
     */ key: "getDefaultTrack",
            value: function getDefaultTrack(tracks, preferredTrack) {
                if (!preferredTrack || !tracks.length) {
                    return null;
                }
                var languageFilteredTracks = tracks.filter(function(param) {
                    var language = param.language, forced = param.forced;
                    return !forced && language === preferredTrack.language;
                });
                return(// First check if we match the preferred roles
                languageFilteredTracks.find(function(param) {
                    var roles = param.roles;
                    return _lodash.default.isEqual(roles, preferredTrack.roles);
                }) || // Then try to start with the correct language
                languageFilteredTracks[0]);
            }
        },
        {
            key: "getCurrentTime",
            value: function getCurrentTime() {
                var instance = this.getInstance();
                if (!instance) {
                    return undefined;
                }
                return instance.currentTime;
            }
        },
        {
            key: "getSubtitleTracks",
            value: function getSubtitleTracks() {
                return [];
            }
        },
        {
            key: "getActiveAudioTrack",
            value: function getActiveAudioTrack() {
                return undefined;
            }
        },
        {
            key: "getVideoQualities",
            value: function getVideoQualities() {
                return [];
            }
        },
        {
            key: "getDrmInfo",
            value: function getDrmInfo() {
                return {};
            }
        },
        {
            key: "reset",
            value: function reset() {
                var _this = this;
                return _async_to_generator._(function() {
                    return _ts_generator._(this, function(_state) {
                        _this.source = null;
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "onTracksChanged",
            value: function onTracksChanged(trackType) {
                var audioTracks = this.getAudioTracks();
                var subtitleTracks = this.getSubtitleTracks();
                this.options.dispatcher(_videoevents.VIDEO_EVENTS.TRACKS_CHANGE, {
                    audioTracks: audioTracks,
                    subtitleTracks: subtitleTracks,
                    trackType: trackType
                });
            }
        },
        {
            /**
     * Check if the currentTime (of a seek action)is different of the original seek time sent by tvjs
     * Return the correct time to stick with the tvjs seek time
     */ key: "getFixedCurrentTime",
            value: function getFixedCurrentTime(currentTime) {
                return this.needSeekPosition !== null && currentTime < this.needSeekPosition ? this.needSeekPosition : currentTime;
            }
        }
    ]);
    return Engine;
}(_BaseEngine.BaseEngine);


/***/ }),

/***/ 55213:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "youboraManager", ({
    enumerable: true,
    get: function() {
        return youboraManager;
    }
}));
var _async_to_generator = __webpack_require__(24146);
var _class_call_check = __webpack_require__(67818);
var _interop_require_wildcard = __webpack_require__(95316);
var _to_consumable_array = __webpack_require__(30005);
var _ts_generator = __webpack_require__(63365);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(3009);
var YouboraManager = function YouboraManager() {
    "use strict";
    var _this = this;
    _class_call_check._(this, YouboraManager);
    this.instance = null;
    var _this1 = this;
    this.preload = /*#__PURE__*/ _async_to_generator._(function() {
        var _ref, NpawPlugin;
        return _ts_generator._(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        Promise.resolve().then(function() {
                            return /*#__PURE__*/ _interop_require_wildcard._(__webpack_require__(12611));
                        })
                    ];
                case 1:
                    _ref = _state.sent(), NpawPlugin = _ref.default;
                    _this1.Lib = NpawPlugin;
                    return [
                        2
                    ];
            }
        });
    });
    this.init = function(options) {
        try {
            var _this_instance;
            if ((_this_instance = _this.instance) === null || _this_instance === void 0 ? void 0 : _this_instance.getAdapter()) {
                // Let's fire stop preventively if there was a previous session
                _this.callAdapterFunction("fireStop");
                _this.setOptions(options);
            } else {
                var accountCode = options.accountCode;
                if (!accountCode || !_this.Lib) {
                    console.warn("Youbora V7 - Init: Missing account code or library not loaded");
                    return;
                }
                _this.instance = new _this.Lib(accountCode);
                // Set default adapter to start join time calculation as early as possible
                // Custom adapter will be initialized after
                _this.instance.registerDefaultAdapter(undefined, options);
                _this.instance.getAdapter().fireInit();
                // @TODO: Remove when all device adapters are migrated
                _this.instance.diagnostic.setVideoAnalyticsEnabled(true);
                _this.instance.diagnostic.setBalancerEnabled(false);
                _this.instance.diagnostic.setAdsAnalyticsEnabled(false);
            }
        } catch (error) {
            console.error("Youbora V7 - Init", error);
        }
    };
    this.setOptions = function(options) {
        var _this_instance;
        (_this_instance = _this.instance) === null || _this_instance === void 0 ? void 0 : _this_instance.setAnalyticsOptions(options);
    };
    this.isDefined = function() {
        return !!_this.instance;
    };
    this.release = function() {
        if (_this.isDefined()) {
            var _this_instance;
            _this.fireStop();
            _this.removeAdapter();
            (_this_instance = _this.instance) === null || _this_instance === void 0 ? void 0 : _this_instance.diagnostic.report();
            _this.instance = null;
        }
    };
    this.setAdapter = function(player, Adapter) {
        var _this_instance;
        (_this_instance = _this.instance) === null || _this_instance === void 0 ? void 0 : _this_instance.registerAdapterFromClass(player, Adapter);
    };
    this.setAdsAdapter = function(player, Adapter) {
        var _this_instance;
        (_this_instance = _this.instance) === null || _this_instance === void 0 ? void 0 : _this_instance.registerAdsAdapterFromClass(player, Adapter);
    };
    this.getAdapter = function() {
        var _this_instance;
        return ((_this_instance = _this.instance) === null || _this_instance === void 0 ? void 0 : _this_instance.getAdapter()) || null;
    };
    this.getAdsAdapter = function() {
        var _this_instance;
        return ((_this_instance = _this.instance) === null || _this_instance === void 0 ? void 0 : _this_instance.getAdsAdapter()) || null;
    };
    this.removeAdapter = function() {
        var _this_instance;
        (_this_instance = _this.instance) === null || _this_instance === void 0 ? void 0 : _this_instance.removeAdapter();
    };
    this.removeAdsAdapter = function() {
        var _this_instance;
        (_this_instance = _this.instance) === null || _this_instance === void 0 ? void 0 : _this_instance.removeAdsAdapter();
    };
    this.fireFatalError = function(errorName, message) {
        _this.callAdapterFunction("fireError", errorName, message, undefined, undefined, undefined, true);
    };
    this.fireStop = function() {
        _this.callAdapterFunction("fireStop");
    };
    this.destroy = function() {
        var _this_instance;
        (_this_instance = _this.instance) === null || _this_instance === void 0 ? void 0 : _this_instance.destroy();
    };
    this.callAdsAdapterFunction = function(method) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        var adapter = _this.getAdsAdapter();
        if (adapter && method in adapter) {
            adapter[method].bind(adapter).apply(_this, _to_consumable_array._(args));
        }
    };
    this.callAdapterFunction = function(method) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        var adapter = _this.getAdapter();
        if (adapter && method in adapter) {
            adapter[method].bind(adapter).apply(_this, _to_consumable_array._(args));
        }
    };
};
var youboraManager = new YouboraManager();


/***/ }),

/***/ 77291:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "defaultEngineOptions", ({
    enumerable: true,
    get: function() {
        return defaultEngineOptions;
    }
}));
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(45538);
var _lodash = /*#__PURE__*/ _interop_require_default._(__webpack_require__(32699));
var defaultEngineOptions = {
    contentId: undefined,
    metrics: {
        enabled: false,
        handler: _lodash.default.noop
    },
    logger: {
        debug: _lodash.default.noop,
        warn: _lodash.default.noop,
        info: _lodash.default.noop,
        error: _lodash.default.noop
    },
    notifier: _lodash.default.noop,
    dispatcher: _lodash.default.noop,
    plugins: {},
    engine: {
        autoplay: true
    },
    storage: {
        get: function(name) {
            return window.localStorage.getItem(name);
        },
        set: function(name, value) {
            return window.localStorage.setItem(name, value);
        },
        remove: function(name) {
            return window.localStorage.removeItem(name);
        }
    },
    drm: {
        reusePersistentSessions: false,
        reusePersistentSessionsExpiration: 3600 * 24 * 7,
        token: {
            handler: function() {
                return Promise.reject(new Error("Not implemented"));
            }
        }
    },
    streaming: {
        needPauseFallback: false,
        delayMediaSourceInit: false,
        segmentPrefetchLimit: undefined,
        abr: {
            downgradeBufferBelow: undefined,
            initialBitrate: 800,
            maxBitrate: undefined,
            bufferTime: 30,
            strategy: "abrDynamic"
        },
        retry: {
            delay: 500,
            handler: _lodash.default.noop,
            max: 0
        },
        fragment: {
            fallbackQualityOnError: true,
            retry: {
                max: 3,
                delay: 2000,
                timeout: 15000
            }
        },
        manifest: {
            liveUseSuggestedDelay: true,
            liveDefaultPresentationDelay: 12,
            retry: {
                timeout: 15000,
                max: 3
            },
            dash: {
                keySystemsByURI: {
                    "urn:uuid:9a04f079-9840-4286-ab92-e65be0885f95": "com.microsoft.playready.recommendation",
                    "urn:uuid:79f0049a-4098-8642-ab92-e65be0885f95": "com.microsoft.playready.recommendation"
                }
            },
            crossSiteCredentials: false
        },
        preferredTrack: {
            subtitle: null,
            audio: null
        }
    }
};


/***/ }),

/***/ 62221:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ASSET_CONSTANTS: function() {
        return _assetconstants;
    },
    BaseEngine: function() {
        return _BaseEngine.BaseEngine;
    },
    DrmUtils: function() {
        return _index1;
    },
    ERROR_DETAILS: function() {
        return _details;
    },
    ERROR_TYPES: function() {
        return _types;
    },
    Engine: function() {
        return _Engine.Engine;
    },
    EngineUtils: function() {
        return _engineutils;
    },
    Id3Utils: function() {
        return _index;
    },
    LANG_CONSTANTS: function() {
        return _langconstants;
    },
    MEDIA_ENGINE_INTERAL_ERRORS: function() {
        return _MediaEngineInternalErrors;
    },
    MIME_TYPE_CONSTANTS: function() {
        return _mimeTypeconstants;
    },
    Mp4Utils: function() {
        return _mp4utils;
    },
    SCTE_EVENTS: function() {
        return _scteevents;
    },
    TracksUtils: function() {
        return _tracksutils;
    },
    VIDEO_EVENTS: function() {
        return _videoevents.VIDEO_EVENTS;
    },
    VIDEO_EVENTS_THROTTLE: function() {
        return _videoeventsthrottle;
    },
    YOUBORA_TYPES: function() {
        return _youboratypes;
    },
    defaultEngineOptions: function() {
        return _defaultOptions.defaultEngineOptions;
    },
    mediaEngineConfig: function() {
        return _mediaEngineConfig.mediaEngineConfig;
    },
    youboraManager: function() {
        return _Youbora.youboraManager;
    }
});
var _export_star = __webpack_require__(37668);
var _interop_require_wildcard = __webpack_require__(95316);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(42578);
var _assetconstants = /*#__PURE__*/ _interop_require_wildcard._(__webpack_require__(22624));
var _mimeTypeconstants = /*#__PURE__*/ _interop_require_wildcard._(__webpack_require__(43585));
var _scteevents = /*#__PURE__*/ _interop_require_wildcard._(__webpack_require__(16428));
var _videoevents = __webpack_require__(84281);
var _videoeventsthrottle = /*#__PURE__*/ _interop_require_wildcard._(__webpack_require__(62554));
var _langconstants = /*#__PURE__*/ _interop_require_wildcard._(__webpack_require__(24078));
var _MediaEngineInternalErrors = /*#__PURE__*/ _interop_require_wildcard._(__webpack_require__(51209));
var _details = /*#__PURE__*/ _interop_require_wildcard._(__webpack_require__(48560));
var _types = /*#__PURE__*/ _interop_require_wildcard._(__webpack_require__(87187));
var _youboratypes = /*#__PURE__*/ _interop_require_wildcard._(__webpack_require__(43652));
var _index = /*#__PURE__*/ _interop_require_wildcard._(__webpack_require__(12817));
var _index1 = /*#__PURE__*/ _interop_require_wildcard._(__webpack_require__(73608));
var _engineutils = /*#__PURE__*/ _interop_require_wildcard._(__webpack_require__(57943));
var _mp4utils = /*#__PURE__*/ _interop_require_wildcard._(__webpack_require__(78708));
var _tracksutils = /*#__PURE__*/ _interop_require_wildcard._(__webpack_require__(94478));
_export_star._(__webpack_require__(67661), exports);
var _Engine = __webpack_require__(35425);
var _BaseEngine = __webpack_require__(90940);
var _Youbora = __webpack_require__(55213);
var _mediaEngineConfig = __webpack_require__(40190);
var _defaultOptions = __webpack_require__(77291);


/***/ }),

/***/ 40190:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "mediaEngineConfig", ({
    enumerable: true,
    get: function() {
        return mediaEngineConfig;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(52318);
var _forEach = /*#__PURE__*/ _interop_require_default._(__webpack_require__(17489));
var _getUnixTime = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81843));
var mediaEngineConfig = new /*#__PURE__*/ (function() {
    "use strict";
    function MediaEngineConfig() {
        _class_call_check._(this, MediaEngineConfig);
        this._lang = null;
        this._isMocked = false;
        this._isDebug = false;
        this._getTime = function() {
            return (0, _getUnixTime.default)(Date.now());
        };
        this.isInitialized = false;
    }
    _create_class._(MediaEngineConfig, [
        {
            /**
     * Initialize MediaEngineConfig.
     *
     * @param {Object} immutableProps Contains all immutable properties of the app.
     * See the example to view available properties.
     */ key: "init",
            value: function init() {
                var immutableProps = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                if (!this.isInitialized) {
                    (0, _forEach.default)(immutableProps, function(value, key) {
                        var privateKey = "_".concat(key);
                        if (key !== "isInitialized" && _this[privateKey] !== undefined) {
                            _this[privateKey] = value;
                        }
                    });
                    this.isInitialized = true;
                }
            }
        },
        {
            /**
     * Get the value of an immutable property of the app.
     *
     * @param {string} key Name of the property.
     * @returns {string} Value of the property.
     */ key: "get",
            value: function get(key) {
                this.checkInit();
                var privateKey = "_".concat(key);
                return this[privateKey];
            }
        },
        {
            key: "set",
            value: function set(key, value) {
                this.checkInit();
                var privateKey = "_".concat(key);
                this[privateKey] = value;
            }
        },
        {
            key: "checkInit",
            value: function checkInit() {
                if (!this.isInitialized) {
                    throw new Error("You should init MediaEngineConfig before using it");
                }
            }
        }
    ]);
    return MediaEngineConfig;
}())();


/***/ }),

/***/ 43652:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(42578);


/***/ }),

/***/ 71601:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    CertificateCacheService: function() {
        return CertificateCacheService;
    },
    jsonSerializer: function() {
        return jsonSerializer;
    }
});
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _object_without_properties = __webpack_require__(46537);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
var _lodash = /*#__PURE__*/ _interop_require_default._(__webpack_require__(32699));
var _getUnixTime = /*#__PURE__*/ _interop_require_default._(__webpack_require__(81843));
var defaultKeyTransform = function(drmKey) {
    return "PLAYER_DRM_CERT/".concat(drmKey);
};
var defaultLogger = {
    debug: _lodash.default.noop,
    error: _lodash.default.noop
};
var jsonSerializer = {
    from: function(json) {
        var _JSON_parse = JSON.parse(json), data = _JSON_parse.data, rest = _object_without_properties._(_JSON_parse, [
            "data"
        ]);
        return _object_spread_props._(_object_spread._({}, rest), {
            data: Uint8Array.from(atob(data), function(c) {
                return c.charCodeAt(0);
            })
        });
    },
    to: function(_param) {
        var data = _param.data, rest = _object_without_properties._(_param, [
            "data"
        ]);
        return JSON.stringify(_object_spread._({
            data: btoa(String.fromCharCode.apply(null, data))
        }, rest));
    }
};
var defaultOptions = {
    logger: defaultLogger,
    keyTransform: defaultKeyTransform,
    serializer: jsonSerializer,
    drm: {
        serviceCacheDuration: 2000
    }
};
var CertificateCacheService = /*#__PURE__*/ function() {
    "use strict";
    function CertificateCacheService() {
        _class_call_check._(this, CertificateCacheService);
    }
    _create_class._(CertificateCacheService, [
        {
            key: "configure",
            value: function configure(options) {
                this.options = _lodash.default.merge({}, defaultOptions, this.options, options);
            }
        },
        {
            key: "has",
            value: function has(drmKey) {
                try {
                    return !!window.localStorage.getItem(this.options.keyTransform(drmKey));
                } catch (error) {
                    this.options.logger.error("DRM", "CertificateCacheService@get", error);
                    return false;
                }
            }
        },
        {
            key: "get",
            value: function get(drmKey) {
                try {
                    var certificate = window.localStorage.getItem(this.options.keyTransform(drmKey));
                    if (!certificate) {
                        return undefined;
                    }
                    var _this_options_serializer_from = this.options.serializer.from(certificate), createdAt = _this_options_serializer_from.createdAt, data = _this_options_serializer_from.data;
                    var now = (0, _getUnixTime.default)(Date.now());
                    if (createdAt + this.options.drm.serviceCacheDuration <= now) {
                        this.options.logger.debug("DRM", "CertificateCacheService@get", "Cached ".concat(drmKey, " certificate is expired, invalidating it"));
                        window.localStorage.removeItem(this.options.keyTransform(drmKey));
                        return undefined;
                    }
                    return data;
                } catch (error) {
                    this.options.logger.error("DRM", "CertificateCacheService@get", error);
                    return undefined;
                }
            }
        },
        {
            /**
     * @param {string} drmKey - drmKey name of the drm that is cached
     * @param {Uint8Array} certificate - that will be stored by the service
     * @param {{ months: number, days: number, hours: number, minutes: number }} [expiration=defaultExpiration]
     */ key: "set",
            value: function set(drmKey, certificate) {
                try {
                    window.localStorage.setItem(this.options.keyTransform(drmKey), this.options.serializer.to({
                        createdAt: (0, _getUnixTime.default)(Date.now()),
                        data: certificate
                    }));
                    this.options.logger.debug("DRM", "CertificateCacheService@set", "Caching ".concat(drmKey, " certificate for one month"));
                } catch (error) {
                    this.options.logger.error("DRM", "CertificateCacheService@set", error);
                // Fail silently
                }
            }
        },
        {
            /**
     * @param {string} drmKey name of the drm that is cached
     */ key: "remove",
            value: function remove(drmKey) {
                try {
                    this.options.logger.debug("DRM", "CertificateCacheService@onError", "Error with Cached ".concat(drmKey, " certificate, invalidating it"));
                    window.localStorage.removeItem(this.options.keyTransform(drmKey));
                } catch (error) {
                    this.options.logger.error("DRM", "CertificateCacheService@onError", error);
                // Fail silently
                }
            }
        }
    ]);
    return CertificateCacheService;
}();


/***/ }),

/***/ 73608:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _export_star = __webpack_require__(37668);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(42578);
_export_star._(__webpack_require__(71601), exports);
_export_star._(__webpack_require__(65153), exports);


/***/ }),

/***/ 65153:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "PersistentSessionCacheService", ({
    enumerable: true,
    get: function() {
        return PersistentSessionCacheService;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(45538);
var _defaultOptions = __webpack_require__(77291);
var _mediaEngineConfig = __webpack_require__(40190);
var STORAGE_KEY = "drm/persistent-sessions";
var PersistentSessionCacheService = /*#__PURE__*/ function() {
    "use strict";
    function PersistentSessionCacheService() {
        _class_call_check._(this, PersistentSessionCacheService);
        this.options = _defaultOptions.defaultEngineOptions;
    }
    _create_class._(PersistentSessionCacheService, [
        {
            key: "configure",
            value: function configure(options) {
                this.options = options;
            }
        },
        {
            key: "isExpired",
            value: function isExpired(param) {
                var createdAt = param.createdAt, now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _mediaEngineConfig.mediaEngineConfig.get("getTime")();
                return createdAt + this.options.drm.reusePersistentSessionsExpiration <= now;
            }
        },
        {
            key: "persistStore",
            value: function persistStore() {
                var _this = this;
                try {
                    var now = _mediaEngineConfig.mediaEngineConfig.get("getTime")();
                    this.localStore = Object.keys(this.localStore).reduce(function(accumulator, persistentId) {
                        var persistentData = _this.localStore[persistentId];
                        if (!_this.isExpired(persistentData, now)) {
                            accumulator[persistentId] = persistentData;
                        }
                        return accumulator;
                    }, {});
                    this.options.storage.set(STORAGE_KEY, JSON.stringify(this.localStore));
                } catch (error) {
                    this.options.logger.error(error);
                }
            }
        },
        {
            key: "getStore",
            value: function getStore() {
                try {
                    var store = JSON.parse(this.options.storage.get(STORAGE_KEY));
                    return store || {};
                } catch (error) {
                    this.options.logger.error(error);
                }
                return {};
            }
        },
        {
            key: "checkForLocalStore",
            value: function checkForLocalStore() {
                if (!this.localStore) {
                    this.localStore = this.getStore();
                }
            }
        },
        {
            key: "get",
            value: function get(persistentId) {
                this.checkForLocalStore();
                var persistentData = this.localStore[persistentId];
                if (persistentData && !this.isExpired(persistentData)) {
                    return persistentData.sessions.map(function(session) {
                        return _object_spread_props._(_object_spread._({}, session), {
                            initData: Uint8Array.from(atob(session.initData), function(c) {
                                return c.charCodeAt(0);
                            }),
                            initDataType: "cenc"
                        });
                    });
                }
                return [];
            }
        },
        {
            key: "set",
            value: function set(persistentId, sessions) {
                this.checkForLocalStore();
                /**
         * There are no persistent sessions reported, we do nothing and keep the previous references stored.
         * This could be because:
         *   - we are using temporary sessions
         *   - another tab/window is streaming the same content with the persistent session, so this tab/window cannot use
         *     it, and has fallback to temporary sessions
         */ if (!sessions.length) {
                    return;
                }
                var incomingPersistentData = {
                    sessions: sessions.map(function(param) {
                        var sessionId = param.sessionId, initData = param.initData;
                        return {
                            // Prevent spreading session directly to reduce local storage data size
                            sessionId: sessionId,
                            initData: btoa(String.fromCharCode.apply(null, initData))
                        };
                    }),
                    createdAt: _mediaEngineConfig.mediaEngineConfig.get("getTime")()
                };
                var storedPersistentData = this.localStore[persistentId];
                var sessionsDifference = [];
                if (storedPersistentData) {
                    // We check for difference between incoming & stored sessions. Incoming sessions are value of truth
                    sessionsDifference = incomingPersistentData.sessions.filter(function(param) {
                        var storedSessionId = param.sessionId, storedInitData = param.initData;
                        return !storedPersistentData.sessions.find(function(param) {
                            var sessionId = param.sessionId, initData = param.initData;
                            return storedSessionId === sessionId && storedInitData === initData;
                        });
                    });
                }
                // If there are some differences or no previous data, persist store with the incoming data
                if (!storedPersistentData || sessionsDifference.length) {
                    this.localStore[persistentId] = incomingPersistentData;
                    this.persistStore();
                }
            }
        },
        {
            key: "remove",
            value: function remove(persistentId) {
                this.checkForLocalStore();
                if (!this.localStore[persistentId]) {
                    return;
                }
                this.localStore[persistentId] = undefined;
                delete this.localStore[persistentId];
                this.persistStore();
            }
        }
    ]);
    return PersistentSessionCacheService;
}();


/***/ }),

/***/ 57943:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "getCurrentBufferSlice", ({
    enumerable: true,
    get: function() {
        return getCurrentBufferSlice;
    }
}));
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
var getCurrentBufferSlice = function(videoTag) {
    var _ref = videoTag || {}, buffered = _ref.buffered, currentTime = _ref.currentTime;
    var bufferEnd;
    var bufferStart;
    if (currentTime && buffered) {
        for(var i = 0; i < buffered.length; i++){
            if (currentTime >= buffered.start(i) && currentTime < buffered.end(i)) {
                bufferEnd = buffered.end(i);
                bufferStart = buffered.start(i);
            }
        }
    }
    var bufferLength = bufferEnd && currentTime ? bufferEnd - currentTime : 0;
    return {
        bufferEnd: bufferEnd,
        bufferStart: bufferStart,
        bufferLength: bufferLength
    };
};


/***/ }),

/***/ 72382:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/* eslint-disable */ /* This is an util comming from yospace third-party */ // ID3 tag flag

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "ID3Parser", ({
    enumerable: true,
    get: function() {
        return ID3Parser;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(45538);
var ID3SYNC = 0x49443300;
// Unsynchronise flag
var UNSYNC = 0x80;
// Extended header flag
var EXTHDR = 0x40;
// Sync safe int
var SYNCSAFE_INT = 0x7f;
var ID3Parser = /*#__PURE__*/ function() {
    "use strict";
    function ID3Parser() {
        _class_call_check._(this, ID3Parser);
    }
    _create_class._(ID3Parser, null, [
        {
            key: "getU32",
            value: function getU32(source, offset) {
                return ID3Parser.getU16(source, offset) << 16 | ID3Parser.getU16(source, offset + 2);
            }
        },
        {
            key: "getU16",
            value: function getU16(source, offset) {
                return ID3Parser.getU8(source, offset) << 8 | ID3Parser.getU8(source, offset + 1);
            }
        },
        {
            key: "getU8",
            value: function getU8(source, offset) {
                return source[offset];
            }
        },
        {
            key: "extractLen",
            value: function extractLen(source, offset) {
                return ((ID3Parser.getU8(source, offset) & SYNCSAFE_INT) << 21) + ((ID3Parser.getU8(source, offset + 1) & SYNCSAFE_INT) << 14) + ((ID3Parser.getU8(source, offset + 2) & SYNCSAFE_INT) << 7) + (ID3Parser.getU8(source, offset + 3) & SYNCSAFE_INT);
            }
        },
        {
            key: "parseCommaSeparatedString",
            value: function parseCommaSeparatedString(source) {
                var id3 = {};
                var keys = String(source).split(",");
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key = _step.value;
                        var packet = key.split("=");
                        id3[packet[0]] = packet[1];
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return id3;
            }
        },
        {
            key: "parseArray",
            value: function parseArray(source) {
                var ta = new Uint8Array(source);
                return ID3Parser.parseUint8Array(ta);
            }
        },
        {
            key: "parseUint8Array",
            value: function parseUint8Array(source) {
                var tag = {};
                var offset = 0;
                // Check header
                var sync = ID3Parser.getU32(source, offset);
                offset += 3;
                if ((sync & 0xffffff00) != ID3SYNC) {
                    console.log("[yospace.id3Parser] Source data is not an ID3 tag");
                    return null;
                }
                var ver = ID3Parser.getU16(source, offset);
                offset += 2;
                if (ver > 0x0400) {
                    console.log("[yospace.id3Parser] ID3 tag version too new - not supported");
                    return null;
                }
                var flags = ID3Parser.getU8(source, offset++);
                // Check for features that we don't support
                if (flags & UNSYNC || flags & EXTHDR) {
                    return null;
                }
                var len = this.extractLen(source, offset);
                offset += 4;
                // Loop through this tag picking up frames
                while(offset < len){
                    var frameID = String.fromCharCode(ID3Parser.getU8(source, offset++)) + String.fromCharCode(ID3Parser.getU8(source, offset++)) + String.fromCharCode(ID3Parser.getU8(source, offset++)) + String.fromCharCode(ID3Parser.getU8(source, offset++));
                    var frameLen = this.extractLen(source, offset);
                    offset += 4;
                    if (frameLen == 0) {
                        break;
                    }
                    // Skip the type markers
                    offset += 2;
                    var frameValue = void 0;
                    if (frameID === "PRIV") {
                        frameValue = {
                            owner: "",
                            value: ""
                        };
                    } else {
                        frameValue = "";
                    }
                    var keys = typeof frameValue === "object" ? Object.keys(frameValue) : undefined;
                    var i = 0;
                    // For each frame, extract the frame value
                    for(var j = 0; j < frameLen; j++){
                        var c = ID3Parser.getU8(source, offset++);
                        // Filter out unprintable characters as they're not needed
                        if (c >= 0x20 && c < 0x7f) {
                            if (keys) {
                                frameValue[keys[i]] += String.fromCharCode(c);
                            } else {
                                frameValue += String.fromCharCode(c);
                            }
                        } else {
                            i++;
                        }
                    }
                    tag[frameID] = frameValue;
                }
                return tag;
            }
        }
    ]);
    return ID3Parser;
}();


/***/ }),

/***/ 12817:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _export_star = __webpack_require__(37668);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(88801);
_export_star._(__webpack_require__(72382), exports);


/***/ }),

/***/ 78708:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/**
 * Writes the name of the mp4 box as binary on 32 bits (8 bits per character)
 * MP4 boxes are only 4 characters long
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    binaryToHex: function() {
        return binaryToHex;
    },
    binarytoMp4BoxName: function() {
        return binarytoMp4BoxName;
    },
    getMP4Box: function() {
        return getMP4Box;
    },
    mp4BoxNameToBinary: function() {
        return mp4BoxNameToBinary;
    },
    stringToBinaryArray: function() {
        return stringToBinaryArray;
    }
});
var _to_consumable_array = __webpack_require__(30005);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(37815);
var mp4BoxNameToBinary = function(name) {
    var part1 = name.charCodeAt(0) << 24;
    var part2 = name.charCodeAt(1) << 16;
    var part3 = name.charCodeAt(2) << 8;
    var part4 = name.charCodeAt(3);
    return part1 + part2 + part3 + part4;
};
var binarytoMp4BoxName = function(binary) {
    var _String;
    // Get the first byte
    var data = [
        binary & 0xff
    ];
    // Remove 8 bits and get the first byte again
    var edit = binary >> 8;
    data.push(edit & 0xff);
    edit >>= 8;
    data.push(edit & 0xff);
    edit >>= 8;
    data.push(edit & 0xff);
    // Get the string with retrieved char codes
    return (_String = String).fromCharCode.apply(_String, _to_consumable_array._(data.reverse()));
};
var getMP4Box = function(data, name) {
    var buffer = data.buffer, byteOffset = data.byteOffset, byteLength = data.byteLength;
    var dataView = new DataView(buffer, byteOffset, byteLength);
    var nameAsBinary = mp4BoxNameToBinary(name);
    for(var offset = 0; offset < byteLength;){
        // From MP4 RFC: the box begins w/
        // 8 bytes: long unsigned offset (4 bytes) + long ASCII text string (4 bytes)
        // Uint 32 is 32 bits, so 4 bytes
        // Defines the total length of the box (gets the 4 bytes after the offset)
        var boxLength = dataView.getUint32(offset);
        // Get the box string name as per RFC
        var boxName = dataView.getUint32(offset + 4);
        if (boxName === nameAsBinary) {
            // We found the box we wanted, return the data minus the headers (offset + name)
            return data.subarray(offset + 8, offset + boxLength);
        }
        // We jump to the next mp4 box
        offset += boxLength;
    }
    return new Uint8Array();
};
var stringToBinaryArray = function(string) {
    var size = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 16;
    var length = string.length;
    var ArrayType = size === 16 ? Uint16Array : Uint8Array;
    var array = new ArrayType(length * (size / 8));
    for(var i = 0; i < length; i++){
        array[i] = string.charCodeAt(i);
    }
    return array;
};
var binaryToHex = function(data) {
    var hex = "";
    for(var offset = 0; offset < data.length; offset++){
        var stringValue = data[offset].toString(16);
        // We have two bytes for each value, if the value contains only one char,
        // then we prepend a 0 to take the empty place
        // 5 => 05
        if (stringValue.length === 1) {
            stringValue = "0".concat(stringValue);
        }
        hex += stringValue;
    }
    return hex;
};


/***/ }),

/***/ 94478:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    applyLocalPreferenceOnTrack: function() {
        return applyLocalPreferenceOnTrack;
    },
    compareLanguage: function() {
        return compareLanguage;
    },
    concatTrackRoles: function() {
        return concatTrackRoles;
    },
    filterNull: function() {
        return filterNull;
    },
    formatAudioTracks: function() {
        return formatAudioTracks;
    },
    formatSubtitles: function() {
        return formatSubtitles;
    },
    getPreferredAudioTrack: function() {
        return getPreferredAudioTrack;
    },
    getPreferredSubtitleTrack: function() {
        return getPreferredSubtitleTrack;
    },
    getTrackLabel: function() {
        return getTrackLabel;
    },
    isForcedTrack: function() {
        return isForcedTrack;
    },
    roleFilter: function() {
        return roleFilter;
    },
    setPreferredAudioTrack: function() {
        return setPreferredAudioTrack;
    },
    setPreferredSubtitleTrack: function() {
        return setPreferredSubtitleTrack;
    },
    sortTracksByLabel: function() {
        return sortTracksByLabel;
    },
    trackEquals: function() {
        return trackEquals;
    }
});
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _object_spread_props = __webpack_require__(15184);
var _object_without_properties = __webpack_require__(46537);
var _to_consumable_array = __webpack_require__(30005);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(52318);
var _lodash = /*#__PURE__*/ _interop_require_default._(__webpack_require__(32699));
var _mediaEngineConfig = __webpack_require__(40190);
var _langconstants = __webpack_require__(24078);
var PREFERRED_AUDIO_TRACK_KEY = "preferredAudioTrack";
var PREFERRED_SUBTITLE_TRACK_KEY = "preferredSubtitleTrack";
var isForcedTrack = function(param) {
    var roles = param.roles;
    return roles.includes("forced_subtitle") || roles.includes("forced-subtitle");
};
var getObjectFromStorage = function(key) {
    try {
        return JSON.parse(window.localStorage.getItem(key)) || {};
    } catch (e) {
        return {};
    }
};
var setObjectFromStorage = function(key, value) {
    try {
        window.localStorage.setItem(key, value);
    } catch (e) {
    // Ignore the value
    }
};
var getPreferredSubtitleTrack = function() {
    return getObjectFromStorage(PREFERRED_SUBTITLE_TRACK_KEY);
};
var getPreferredAudioTrack = function() {
    return getObjectFromStorage(PREFERRED_AUDIO_TRACK_KEY);
};
var setPreferredSubtitleTrack = function(value) {
    return setObjectFromStorage(PREFERRED_SUBTITLE_TRACK_KEY, value);
};
var setPreferredAudioTrack = function(value) {
    return setObjectFromStorage(PREFERRED_AUDIO_TRACK_KEY, value);
};
var filteredRoles = [
    "main",
    "subtitle"
];
var roleFilter = function(roles) {
    return roles ? roles.filter(function(role) {
        return !filteredRoles.includes(role);
    }) : roles;
};
var trackEquals = function(track1) {
    return function(track2) {
        if (!track1 || !track2) {
            return false;
        }
        var rolesTrack1 = roleFilter(track1.roles);
        var rolesTrack2 = roleFilter(track2.roles);
        return track1.language === track2.language && rolesTrack1.length === rolesTrack2.length && _lodash.default.difference(rolesTrack1, rolesTrack2).length < 1;
    };
};
var applyLocalPreferenceOnTrack = function(key, tracks) {
    if (!tracks) {
        return tracks;
    }
    var storedTrack = getObjectFromStorage(key);
    var preferredTrack = tracks.find(trackEquals(storedTrack));
    if (preferredTrack && !preferredTrack.active) {
        tracks.forEach(function(track) {
            track.active = false;
        });
        preferredTrack.active = true;
    }
    return tracks;
};
var getTrackLabel = function(label) {
    var labelLower = label.toLowerCase();
    switch(labelLower){
        // original version codes
        case "vo":
        case "ov":
        case "qtz":
        case "und":
        case "qaa":
            return "ov";
        // audio description codes
        case "mis":
        case "qad":
            return "ad";
        case "lv":
        case "vf":
            return _mediaEngineConfig.mediaEngineConfig.get("lang");
        default:
            return labelLower;
    }
};
var sortTracksByLabel = function(tracks) {
    return tracks.sort(function(param, param1) {
        var label1 = param.label, label2 = param1.label;
        return label1.localeCompare(label2);
    });
};
var filterNull = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return args.filter(function(item) {
        return !!item;
    });
};
var concatTrackRoles = function() {
    var roles1 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], roles2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    return _lodash.default.uniq(_to_consumable_array._(roles1).concat(_to_consumable_array._(roles2)));
};
var formatSubtitles = function(tracks) {
    return tracks ? tracks.map(function(_param) {
        var roles = _param.roles, language = _param.language, track = _object_without_properties._(_param, [
            "roles",
            "language"
        ]);
        return _object_spread_props._(_object_spread._({}, track), {
            language: language.length === 3 ? _langconstants.ISO693Codes[language] || language : language,
            roles: roles || []
        });
    }) : [];
};
var formatAudioTracks = function(tracks) {
    return tracks ? tracks.map(function(_param) {
        var roles = _param.roles, language = _param.language, track = _object_without_properties._(_param, [
            "roles",
            "language"
        ]);
        var isAd = getTrackLabel(language) === "ad";
        var lang = isAd ? _mediaEngineConfig.mediaEngineConfig.get("lang") : language;
        return _object_spread_props._(_object_spread._({}, track), {
            language: lang.length === 3 ? _langconstants.ISO693Codes[lang] || lang : lang,
            roles: concatTrackRoles(roles, filterNull(isAd && "alternate", track.main && "main"))
        });
    }) : [];
};
// https://fr.wikipedia.org/wiki/Liste_des_codes_ISO_639-1
// see incident room #inc-2024-09-26-open-caption-missing-safari-videoland_17595
var LANG_ALIAS = {
    // safari convert nor to nb that is Norwegian Bokmål but it's should be no. i added other Norwegian possibility.
    nb: "no",
    nn: "no"
};
var getAlias = function(lang) {
    return LANG_ALIAS[lang] || lang;
};
var compareISO693_1AndISO693_3 = function(lang693_1, lang693_3) {
    return _langconstants.ISO693Codes[lang693_3] === lang693_1 || _langconstants.ISO693Codes[lang693_3] === getAlias(lang693_1);
};
var compareLanguage = function(givenLanguage, expectedLanguage) {
    if (!givenLanguage || !expectedLanguage) {
        return false;
    }
    switch("".concat(givenLanguage.length, "/").concat(expectedLanguage.length)){
        case "3/2":
            return compareISO693_1AndISO693_3(expectedLanguage, givenLanguage);
        case "2/3":
            return compareISO693_1AndISO693_3(givenLanguage, expectedLanguage);
        case "3/3":
            return givenLanguage === expectedLanguage;
        case "2/2":
            return givenLanguage === expectedLanguage || getAlias(givenLanguage) === getAlias(expectedLanguage);
        default:
            return false;
    }
};


/***/ }),

/***/ 2161:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "YouboraLegacyAdsAdapter", ({
    enumerable: true,
    get: function() {
        return YouboraLegacyAdsAdapter;
    }
}));
var _interop_require_default = __webpack_require__(81200);
var _to_consumable_array = __webpack_require__(30005);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(88801);
var _youboralib = /*#__PURE__*/ _interop_require_default._(__webpack_require__(46847));
var _packagejson = /*#__PURE__*/ _interop_require_default._(__webpack_require__(43329));
var _adengine = __webpack_require__(25854);
var YouboraLegacyAdsAdapter = _youboralib.default.Adapter.extend({
    /** Override to return current plugin version */ getVersion: function getVersion() {
        return _packagejson.default.version;
    },
    /** Override to return current playhead of the video */ getPlayhead: function getPlayhead() {
        return this.player.getCurrentTime();
    },
    /** Override to return current playrate */ getPlayrate: function getPlayrate() {
        return this.player.getPlayrate();
    },
    /** Override to return video duration */ getDuration: function getDuration() {
        return this.player.getDuration();
    },
    /** Override to return current bitrate */ getBitrate: function getBitrate() {
        var currentAsset = this.player.getCurrentAsset();
        return currentAsset === null || currentAsset === void 0 ? void 0 : currentAsset.bitrate;
    },
    /** Override to return rendition */ getRendition: function() {
        var currentAsset = this.player.getCurrentAsset();
        if (currentAsset) {
            return _youboralib.default.Util.buildRenditionString(currentAsset.width, currentAsset.height, this.getBitrate());
        }
        return "";
    },
    /** Override to return title */ getTitle: function getTitle() {
        return this.player.getTitle();
    },
    /** Override to return resource URL. */ getResource: function getResource() {
        return this.player.getResource();
    },
    /** Override to return player version */ getPlayerVersion: function getPlayerVersion() {
        return this.player.getVersion();
    },
    /** Override to return player's name */ getPlayerName: function getPlayerName() {
        return "Bedrock-Ad-Engine";
    },
    /** Override to return current ad position (only ads) */ getPosition: function getPosition() {
        return this.position;
    },
    /** Override to return the given ad structure (list with number of pre, mid, and post breaks) (only ads) */ getGivenBreaks: function getGivenBreaks() {
        return this.player.getSlots().length;
    },
    /** Override to return a list of playheads of ad breaks begin time (only ads) */ getBreaksTime: function getBreaksTime() {
        return this.player.getCurrentSlot().ads.reduce(function(acc, currentAd) {
            return acc + currentAd.creatives[0].duration;
        }, 0);
    },
    /** Override to return the number of ads requested for the break (only ads) */ getExpectedAds: function getExpectedAds() {
        return this.player.getCurrentSlot().ads.length;
    },
    /** Override to return the number of ads given for the break (only ads) */ getGivenAds: function getGivenAds() {
        return this.getExpectedAds();
    },
    /** Override to return if the ad is being shown in the screen or not
     * The standard definition is: more than 50% of the pixels of the ad are on the screen
     * (only ads)
     */ getIsVisible: function getIsVisible() {
        return _youboralib.default.Util.calculateAdViewability(this.player.display.video);
    },
    /** Override to return a boolean showing if the audio is enabled when the ad begins (only ads) */ getAudioEnabled: function getAudioEnabled() {
        return this.player.getAudioEnabled();
    },
    /** Override to return if the ad is skippable (only ads) */ getIsSkippable: function getIsSkippable() {
        return false;
    },
    /** Override to return a boolean showing if the player is in fullscreen mode when the ad begins (only ads) */ getIsFullscreen: function getIsFullscreen() {
        return !!document.fullscreenElement;
    },
    /** Override to return the ad creative id (only ads) */ getCreativeId: function getCreativeId() {
        return this.player.getContentId();
    },
    /** Register listeners to this.player. */ registerListeners: function registerListeners() {
        // Enable playhead monitor (buffer = true, seek = false)
        this.monitorPlayhead(true, false);
        this.references = {};
        this.references[_adengine.adEvents.AD_INIT] = this.initListener.bind(this);
        this.references[_adengine.adEvents.AD_PAUSED] = this.pauseListener.bind(this);
        this.references[_adengine.adEvents.AD_PLAYING] = this.playingListener.bind(this);
        this.references[_adengine.adEvents.AD_ERROR] = this.errorListener.bind(this);
        this.references[_adengine.adEvents.AD_STOPPED] = this.endedListener.bind(this);
        this.references[_adengine.adEvents.AD_SKIPPED] = this.skippedListener.bind(this);
        this.references[_adengine.adEvents.AD_IMPRESSION] = this.impressionListener.bind(this);
        this.references[_adengine.adEvents.AD_VIDEO_FIRST_QUARTILE] = this.firstQuartileListener.bind(this);
        this.references[_adengine.adEvents.AD_VIDEO_MIDPOINT] = this.midpointListener.bind(this);
        this.references[_adengine.adEvents.AD_VIDEO_THIRD_QUARTILE] = this.thirdQuartileListener.bind(this);
        this.references[_adengine.adEvents.AD_VIDEO_COMPLETE] = this.videoCompleteListener.bind(this);
        this.references[_adengine.adEvents.SLOT_START] = this.slotStartListener.bind(this);
        this.references[_adengine.adEvents.SLOT_ENDED] = this.slotEndedListener.bind(this);
        this.references[_adengine.adEvents.REQUEST_COMPLETE] = this.requestCompleteListener.bind(this);
        this.references[_adengine.adEvents.NO_DURATION_IN_CREATIVE] = this.noDurationListener.bind(this);
        this.references[_adengine.jingleEvents.JINGLE_STARTED] = this.playingListener.bind(this);
        this.references[_adengine.jingleEvents.JINGLE_PLAYING] = this.playingListener.bind(this);
        this.references[_adengine.jingleEvents.JINGLE_PAUSED] = this.pauseListener.bind(this);
        this.references[_adengine.jingleEvents.JINGLE_STOPPED] = this.endedListener.bind(this);
        this.references[_adengine.jingleEvents.JINGLE_ERROR] = this.errorListener.bind(this);
        // Register listeners
        if (this.player && this.references) {
            for(var key in this.references){
                this.player.addEventListener(key, this.references[key]);
            }
        }
    },
    /** Unregister listeners to this.player. */ unregisterListeners: function unregisterListeners() {
        // Disable playhead monitoring
        if (this.monitor) this.monitor.stop();
        if (this.player && this.references) {
            for(var key in this.references){
                this.player.removeEventListener(key, this.references[key]);
                delete this.references[key];
            }
        }
    },
    initListener: function initListener() {
        if (!this.disable) {
            this.fireStart();
        }
    },
    requestCompleteListener: function requestCompleteListener(response) {
        this.fireInit();
        if (response.success) {
            if (!response.slots.length) {
                this.fireManifest(_youboralib.default.Constants.ManifestError.EMPTY, "Empty manifest");
            }
        } else {
            this.fireManifest(_youboralib.default.Constants.ManifestError.NO_RESPONSE, "No response");
        }
    },
    slotStartListener: function slotStartListener() {
        this.disable = false;
        var slot = this.player.getCurrentSlot();
        switch(slot.type){
            case _adengine.adTypes.MIDROLL:
                this.position = _youboralib.default.Constants.AdPosition.Midroll;
                break;
            case _adengine.adTypes.PREROLL:
                this.position = _youboralib.default.Constants.AdPosition.Preroll;
                break;
            default:
                this.disable = true;
        }
        if (!this.disable) {
            this.fireBreakStart();
        }
    },
    /** Listener for 'endSlot' event. */ slotEndedListener: function slotEndedListener() {
        if (!this.disable) {
            this.fireBreakStop();
            this.position = _youboralib.default.Constants.AdPosition.Midroll;
        }
    },
    /** Listener for 'pause' event. */ pauseListener: function pauseListener() {
        if (!this.disable) {
            this.firePause();
        }
    },
    /** Listener for 'playing' event. */ playingListener: function playingListener() {
        if (!this.disable) {
            this.fireStart();
            this.fireJoin();
            this.fireResume();
        }
    },
    /** Listener for 'error' event. */ errorListener: function errorListener(event) {
        var _event_error = event.error, message = _event_error.message, code = _event_error.code, fatal = _event_error.fatal;
        var fireArgs = [
            code,
            message,
            undefined,
            fatal ? "fatal" : "error"
        ];
        if (fatal) {
            this.fireFatalError.apply(this, _to_consumable_array._(fireArgs));
        } else {
            this.fireError.apply(this, _to_consumable_array._(fireArgs));
        }
    },
    /** Listener for 'ended' event. */ endedListener: function endedListener() {
        if (!this.disable) {
            this.fireStop();
        }
    },
    /** Listener for 'skipped' event. */ skippedListener: function skippedListener() {
        if (!this.disable) {
            this.fireSkip();
        }
    },
    impressionListener: function impressionListener() {
        if (!this.disable) {
            this.fireStart();
            this.fireJoin();
            this.fireResume();
        }
    },
    firstQuartileListener: function firstQuartileListener() {
        if (!this.disable) {
            this.fireQuartile(1);
        }
    },
    midpointListener: function midpointListener() {
        if (!this.disable) {
            this.fireQuartile(2);
        }
    },
    thirdQuartileListener: function thirdQuartileListener() {
        if (!this.disable) {
            this.fireQuartile(3);
        }
    },
    videoCompleteListener: function videoCompleteListener() {
        if (!this.disable) {
            this.fireStop();
        }
    },
    noDurationListener: function noDurationListener(event) {
        if (!this.disable) {
            this.errorListener(event);
        }
    }
});


/***/ }),

/***/ 19783:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "Advertising", ({
    enumerable: true,
    get: function() {
        return _Advertising;
    }
}));
var _interop_require_wildcard = __webpack_require__(95316);
__webpack_require__(42578);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(88801);
var _Advertising = /*#__PURE__*/ _interop_require_wildcard._(__webpack_require__(1686));


/***/ }),

/***/ 29931:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "AD_FORMAT", ({
    enumerable: true,
    get: function() {
        return AD_FORMAT;
    }
}));
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(88801);
var AD_FORMAT;
(function(AD_FORMAT) {
    AD_FORMAT["VAST"] = "vast";
    AD_FORMAT["VMAP"] = "vmap:vmap";
    AD_FORMAT["UNKNOWN"] = "unknown";
})(AD_FORMAT || (AD_FORMAT = {}));


/***/ }),

/***/ 96488:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "SlotType", ({
    enumerable: true,
    get: function() {
        return SlotType;
    }
}));
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(37815);
var SlotType;
(function(SlotType) {
    SlotType["PREROLL"] = "preroll";
    SlotType["MIDROLL"] = "midroll";
    SlotType["POSTROLL"] = "postroll";
    SlotType["DISPLAY"] = "display";
    SlotType["OVERLAY"] = "overlay";
    SlotType["SPONSOR"] = "sponsor";
    SlotType["LBANNER"] = "lbanner";
    SlotType["UNKNOWN"] = "unknown";
})(SlotType || (SlotType = {}));


/***/ }),

/***/ 38261:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "TrackingEvent", ({
    enumerable: true,
    get: function() {
        return TrackingEvent;
    }
}));
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(3009);
__webpack_require__(52318);
var TrackingEvent;
(function(TrackingEvent) {
    // Global
    TrackingEvent["Error"] = "error";
    // Break Event
    TrackingEvent["BreakStart"] = "breakStart";
    TrackingEvent["BreakEnd"] = "breakEnd";
    // Ad Event
    TrackingEvent["Start"] = "start";
    TrackingEvent["Click"] = "click";
    TrackingEvent["ImpressionEnd"] = "impressionEnd";
    TrackingEvent["Impression"] = "impression";
    TrackingEvent["Complete"] = "complete";
    TrackingEvent["FirstQuartile"] = "firstQuartile";
    TrackingEvent["Midpoint"] = "midpoint";
    TrackingEvent["ThirdQuartile"] = "thirdQuartile";
    TrackingEvent["Mute"] = "mute";
    TrackingEvent["Unmute"] = "unmute";
    TrackingEvent["Fullscreen"] = "fullscreen";
    TrackingEvent["Skip"] = "skip";
    TrackingEvent["EngagedView"] = "engagedView";
    TrackingEvent["Collapse"] = "collapse";
    TrackingEvent["Expand"] = "expand";
    TrackingEvent["Pause"] = "pause";
    TrackingEvent["Resume"] = "resume";
    TrackingEvent["Rewind"] = "rewind";
    TrackingEvent["AcceptInvitation"] = "acceptInvitation";
    TrackingEvent["Close"] = "close";
    TrackingEvent["CloseLinear"] = "closeLinear";
    TrackingEvent["CreativeView"] = "creativeView";
    // Ad Verification ( OmSdk )
    TrackingEvent["VerificationNotExecuted"] = "verificationNotExecuted";
})(TrackingEvent || (TrackingEvent = {}));


/***/ }),

/***/ 1686:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    AD_FORMAT: function() {
        return _Parser.AD_FORMAT;
    },
    SlotType: function() {
        return _Slot.SlotType;
    },
    TrackingEvent: function() {
        return _Tracking.TrackingEvent;
    }
});
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(42578);
var _Parser = __webpack_require__(29931);
var _Slot = __webpack_require__(96488);
var _Tracking = __webpack_require__(38261);


/***/ }),

/***/ 42976:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/*
 * If not stated otherwise in this file or this component's LICENSE file the
 * following copyright and licenses apply:
 *
 * Copyright 2020 Metrological
 *
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Metadata: function() {
        return _Metadata.default;
    },
    Metrics: function() {
        return _Metrics.default;
    },
    Pin: function() {
        return _Pin.default;
    },
    Profile: function() {
        return _Profile.default;
    },
    Purchase: function() {
        return _Purchase.default;
    },
    TV: function() {
        return _TV.default;
    },
    VideoPlayer: function() {
        return _VideoPlayer.default;
    },
    initLightningSdkPlugin: function() {
        return _LightningSdkPlugins.initLightningSdkPlugin;
    },
    initMetadata: function() {
        return _Metadata.initMetadata;
    },
    initMetrics: function() {
        return _Metrics.initMetrics;
    },
    initPin: function() {
        return _Pin.initPin;
    },
    initProfile: function() {
        return _Profile.initProfile;
    },
    initPurchase: function() {
        return _Purchase.initPurchase;
    },
    initTV: function() {
        return _TV.initTV;
    },
    initVideoPlayer: function() {
        return _VideoPlayer.initVideoPlayer;
    },
    mediaUrl: function() {
        return _VideoPlayer.mediaUrl;
    }
});
var _interop_require_wildcard = __webpack_require__(95316);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(37815);
var _Metadata = /*#__PURE__*/ _interop_require_wildcard._(__webpack_require__(59427));
var _Metrics = /*#__PURE__*/ _interop_require_wildcard._(__webpack_require__(58336));
var _Profile = /*#__PURE__*/ _interop_require_wildcard._(__webpack_require__(39137));
var _Purchase = /*#__PURE__*/ _interop_require_wildcard._(__webpack_require__(55403));
var _TV = /*#__PURE__*/ _interop_require_wildcard._(__webpack_require__(35031));
var _Pin = /*#__PURE__*/ _interop_require_wildcard._(__webpack_require__(31102));
var _VideoPlayer = /*#__PURE__*/ _interop_require_wildcard._(__webpack_require__(2016));
var _LightningSdkPlugins = __webpack_require__(62476);


/***/ }),

/***/ 62476:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/*
 * If not stated otherwise in this file or this component's LICENSE file the
 * following copyright and licenses apply:
 *
 * Copyright 2020 Metrological
 *
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Ads: function() {
        return Ads;
    },
    ApplicationInstance: function() {
        return ApplicationInstance;
    },
    Lightning: function() {
        return Lightning;
    },
    Log: function() {
        return Log;
    },
    Settings: function() {
        return Settings;
    },
    initLightningSdkPlugin: function() {
        return initLightningSdkPlugin;
    }
});
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
var Log;
var Settings;
var ApplicationInstance;
var Ads;
var Lightning;
var initLightningSdkPlugin = {
    set log (v){
        Log = v;
    },
    set settings (v){
        Settings = v;
    },
    set ads (v){
        Ads = v;
    },
    set lightning (v){
        Lightning = v;
    },
    set appInstance (v){
        ApplicationInstance = v;
    }
};


/***/ }),

/***/ 59427:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/*
 * If not stated otherwise in this file or this component's LICENSE file the
 * following copyright and licenses apply:
 *
 * Copyright 2020 Metrological
 *
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    default: function() {
        return _default;
    },
    initMetadata: function() {
        return initMetadata;
    }
});
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(52318);
var metadata = {};
var initMetadata = function(metadataObj) {
    metadata = metadataObj;
};
var _default = {
    get: function(key) {
        var fallback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : undefined;
        return key in metadata ? metadata[key] : fallback;
    },
    appId: function() {
        return this.get("id");
    },
    safeAppId: function() {
        return this.get("id").replace(/[^0-9a-zA-Z_$]/g, "_");
    },
    appName: function() {
        return this.get("name");
    },
    appVersion: function() {
        return (this.get("version") || "").split("-").shift();
    },
    appIcon: function() {
        return this.get("icon");
    },
    // Version from app store (with commit hash)
    appFullVersion: function() {
        return this.get("version");
    }
};


/***/ }),

/***/ 58336:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/*
 * If not stated otherwise in this file or this component's LICENSE file the
 * following copyright and licenses apply:
 *
 * Copyright 2020 Metrological
 *
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    default: function() {
        return _default;
    },
    initMetrics: function() {
        return initMetrics;
    }
});
var _object_spread = __webpack_require__(76247);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
var _LightningSdkPlugins = __webpack_require__(62476);
var initMetrics = function(config) {
    sendMetric = config.sendMetric;
};
var sendMetric = function(type, event, params) {
    _LightningSdkPlugins.Log.info("Sending metric", type, event, params);
};
// available metric per category
var metrics = {
    app: [
        "launch",
        "loaded",
        "ready",
        "close"
    ],
    page: [
        "view",
        "leave"
    ],
    user: [
        "click",
        "input"
    ],
    media: [
        "abort",
        "canplay",
        "ended",
        "pause",
        "play",
        // with some videos there occur almost constant suspend events ... should investigate
        // 'suspend',
        "volumechange",
        "waiting",
        "seeking",
        "seeked"
    ]
};
// error metric function (added to each category)
var errorMetric = function(type, message, code, visible) {
    var params = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
    params = _object_spread._({
        params: params
    }, {
        message: message,
        code: code,
        visible: visible
    });
    sendMetric(type, "error", params);
};
var Metric = function(type, events) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return events.reduce(function(obj, event) {
        obj[event] = function(name) {
            var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            params = _object_spread._({}, options, name ? {
                name: name
            } : {}, params);
            sendMetric(type, event, params);
        };
        return obj;
    }, {
        error: function(message, code, params) {
            errorMetric(type, message, code, params);
        },
        event: function(name, params) {
            sendMetric(type, name, params);
        }
    });
};
var Metrics = function(types) {
    return Object.keys(types).reduce(function(obj, type) {
        // media metric works a bit different!
        // it's a function that accepts a url and returns an object with the available metrics
        // url is automatically passed as a param in every metric
        type === "media" ? obj[type] = function(url) {
            return Metric(type, types[type], {
                url: url
            });
        } : obj[type] = Metric(type, types[type]);
        return obj;
    }, {
        error: errorMetric,
        event: sendMetric
    });
};
var _default = Metrics(metrics);


/***/ }),

/***/ 5723:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/*
 * If not stated otherwise in this file or this component's LICENSE file the
 * following copyright and licenses apply:
 *
 * Copyright 2020 Metrological
 *
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _interop_require_default = __webpack_require__(81200);
var _create_super = __webpack_require__(6400);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(42578);
var _LightningSdkPlugins = __webpack_require__(62476);
var _Pin = /*#__PURE__*/ _interop_require_default._(__webpack_require__(31102));
var PinInput = function() {
    return /*#__PURE__*/ function(_Lightning_Component) {
        "use strict";
        _inherits._(PinInput, _Lightning_Component);
        var _super = _create_super._(PinInput);
        function PinInput() {
            _class_call_check._(this, PinInput);
            return _super.apply(this, arguments);
        }
        _create_class._(PinInput, [
            {
                key: "index",
                set: function set(v) {
                    this.x = v * (120 + 24);
                }
            },
            {
                key: "nr",
                set: function set(v) {
                    var _this = this;
                    this._timeout && clearTimeout(this._timeout);
                    if (v) {
                        this.setSmooth("alpha", 1);
                    } else {
                        this.setSmooth("alpha", 0.5);
                    }
                    this.tag("Nr").patch({
                        text: {
                            text: v && v.toString() || "",
                            fontSize: v === "*" ? 120 : 80
                        }
                    });
                    if (v && v !== "*") {
                        this._timeout = setTimeout(function() {
                            _this._timeout = null;
                            _this.nr = "*";
                        }, 750);
                    }
                }
            }
        ], [
            {
                key: "_template",
                value: function _template() {
                    return {
                        w: 120,
                        h: 150,
                        rect: true,
                        color: 0xff949393,
                        alpha: 0.5,
                        shader: {
                            type: _LightningSdkPlugins.Lightning.shaders.RoundedRectangle,
                            radius: 10
                        },
                        Nr: {
                            w: function(w) {
                                return w;
                            },
                            y: 24,
                            text: {
                                text: "",
                                textColor: 0xff333333,
                                fontSize: 80,
                                textAlign: "center",
                                verticalAlign: "middle"
                            }
                        }
                    };
                }
            }
        ]);
        return PinInput;
    }(_LightningSdkPlugins.Lightning.Component);
};
var _default = function() {
    return /*#__PURE__*/ function(_Lightning_Component) {
        "use strict";
        _inherits._(PinDialog, _Lightning_Component);
        var _super = _create_super._(PinDialog);
        function PinDialog() {
            _class_call_check._(this, PinDialog);
            return _super.apply(this, arguments);
        }
        _create_class._(PinDialog, [
            {
                key: "_init",
                value: function _init() {
                    var children = [];
                    for(var i = 0; i < 4; i++){
                        children.push({
                            type: PinInput(),
                            index: i
                        });
                    }
                    this.tag("Code").children = children;
                }
            },
            {
                key: "pin",
                get: function get() {
                    if (!this._pin) this._pin = "";
                    return this._pin;
                },
                set: function set(v) {
                    if (v.length <= 4) {
                        var maskedPin = new Array(Math.max(v.length - 1, 0)).fill("*", 0, v.length - 1);
                        v.length && maskedPin.push(v.length > this._pin.length ? v.slice(-1) : "*");
                        for(var i = 0; i < 4; i++){
                            this.tag("Code").children[i].nr = maskedPin[i] || "";
                        }
                        this._pin = v;
                    }
                }
            },
            {
                key: "msg",
                get: function get() {
                    if (!this._msg) this._msg = "";
                    return this._msg;
                },
                set: function set(v) {
                    var _this = this;
                    this._timeout && clearTimeout(this._timeout);
                    this._msg = v;
                    if (this._msg) {
                        this.tag("Msg").text = this._msg;
                        this.tag("Info").setSmooth("alpha", 0.5);
                        this.tag("Code").setSmooth("alpha", 0.5);
                    } else {
                        this.tag("Msg").text = "";
                        this.tag("Info").setSmooth("alpha", 1);
                        this.tag("Code").setSmooth("alpha", 1);
                    }
                    this._timeout = setTimeout(function() {
                        _this.msg = "";
                    }, 2000);
                }
            },
            {
                key: "_firstActive",
                value: function _firstActive() {
                    this.setSmooth("alpha", 1);
                }
            },
            {
                key: "_handleKey",
                value: function _handleKey(event) {
                    if (this.msg) {
                        this.msg = false;
                    } else {
                        var val = parseInt(event.key);
                        if (val > -1) {
                            this.pin += val;
                        }
                    }
                }
            },
            {
                key: "_handleBack",
                value: function _handleBack() {
                    if (this.msg) {
                        this.msg = false;
                    } else {
                        if (this.pin.length) {
                            this.pin = this.pin.slice(0, this.pin.length - 1);
                        } else {
                            _Pin.default.hide();
                            this.resolve(false);
                        }
                    }
                }
            },
            {
                key: "_handleEnter",
                value: function _handleEnter() {
                    var _this = this;
                    if (this.msg) {
                        this.msg = false;
                    } else {
                        _Pin.default.submit(this.pin).then(function(val) {
                            _this.msg = "Unlocking ...";
                            setTimeout(function() {
                                _Pin.default.hide();
                            }, 1000);
                            _this.resolve(val);
                        }).catch(function(e) {
                            _this.msg = e;
                            _this.reject(e);
                        });
                    }
                }
            }
        ], [
            {
                key: "_template",
                value: function _template() {
                    return {
                        zIndex: 1,
                        w: function(w) {
                            return w;
                        },
                        h: function(h) {
                            return h;
                        },
                        rect: true,
                        color: 0xdd000000,
                        alpha: 0.000001,
                        Dialog: {
                            w: 648,
                            h: 320,
                            y: function(h) {
                                return (h - 320) / 2;
                            },
                            x: function(w) {
                                return (w - 648) / 2;
                            },
                            rect: true,
                            color: 0xdd333333,
                            shader: {
                                type: _LightningSdkPlugins.Lightning.shaders.RoundedRectangle,
                                radius: 10
                            },
                            Info: {
                                y: 24,
                                x: 48,
                                text: {
                                    text: "Please enter your PIN",
                                    fontSize: 32
                                }
                            },
                            Msg: {
                                y: 260,
                                x: 48,
                                text: {
                                    text: "",
                                    fontSize: 28,
                                    textColor: 0xffffffff
                                }
                            },
                            Code: {
                                x: 48,
                                y: 96
                            }
                        }
                    };
                }
            }
        ]);
        return PinDialog;
    }(_LightningSdkPlugins.Lightning.Component);
};


/***/ }),

/***/ 31102:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/*
 * If not stated otherwise in this file or this component's LICENSE file the
 * following copyright and licenses apply:
 *
 * Copyright 2020 Metrological
 *
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    // Public API
    default: function() {
        return _default;
    },
    initPin: function() {
        return initPin;
    }
});
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
var _LightningSdkPlugins = __webpack_require__(62476);
var _dialog = /*#__PURE__*/ _interop_require_default._(__webpack_require__(5723));
// only used during local development
var unlocked = false;
var contextItems = [
    "purchase",
    "parental"
];
var submit = function(pin, context) {
    return new Promise(function(resolve, reject) {
        if (pin.toString() === _LightningSdkPlugins.Settings.get("platform", "pin", "0000").toString()) {
            unlocked = true;
            resolve(unlocked);
        } else {
            reject("Incorrect pin");
        }
    });
};
var check = function(context) {
    return new Promise(function(resolve) {
        resolve(unlocked);
    });
};
var initPin = function(config) {
    if (config.submit && typeof config.submit === "function") {
        submit = config.submit;
    }
    if (config.check && typeof config.check === "function") {
        check = config.check;
    }
};
var pinDialog = null;
var contextCheck = function(context) {
    if (context === undefined) {
        _LightningSdkPlugins.Log.info("Please provide context explicitly");
        return contextItems[0];
    } else if (!contextItems.includes(context)) {
        _LightningSdkPlugins.Log.warn("Incorrect context provided");
        return false;
    }
    return context;
};
var _default = {
    show: function() {
        return new Promise(function(resolve, reject) {
            pinDialog = _LightningSdkPlugins.ApplicationInstance.stage.c({
                ref: "PinDialog",
                type: (0, _dialog.default)(),
                resolve: resolve,
                reject: reject
            });
            _LightningSdkPlugins.ApplicationInstance.childList.a(pinDialog);
            _LightningSdkPlugins.ApplicationInstance.focus = pinDialog;
        });
    },
    hide: function() {
        _LightningSdkPlugins.ApplicationInstance.focus = null;
        _LightningSdkPlugins.ApplicationInstance.children = _LightningSdkPlugins.ApplicationInstance.children.map(function(child) {
            return child !== pinDialog && child;
        });
        pinDialog = null;
    },
    submit: function(pin, context) {
        return new Promise(function(resolve, reject) {
            try {
                context = contextCheck(context);
                if (context) {
                    submit(pin, context).then(resolve).catch(reject);
                } else {
                    reject("Incorrect Context provided");
                }
            } catch (e) {
                reject(e);
            }
        });
    },
    unlocked: function(context) {
        return new Promise(function(resolve, reject) {
            try {
                context = contextCheck(context);
                if (context) {
                    check(context).then(resolve).catch(reject);
                } else {
                    reject("Incorrect Context provided");
                }
            } catch (e) {
                reject(e);
            }
        });
    },
    locked: function(context) {
        return new Promise(function(resolve, reject) {
            try {
                context = contextCheck(context);
                if (context) {
                    check(context).then(function(unlocked) {
                        return resolve(!!!unlocked);
                    }).catch(reject);
                } else {
                    reject("Incorrect Context provided");
                }
            } catch (e) {
                reject(e);
            }
        });
    }
};


/***/ }),

/***/ 95185:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/*
 * If not stated otherwise in this file or this component's LICENSE file the
 * following copyright and licenses apply:
 *
 * Copyright 2020 Metrological
 *
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "defaultProfile", ({
    enumerable: true,
    get: function() {
        return defaultProfile;
    }
}));
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(42578);
var _helpers = __webpack_require__(58623);
var defaultProfile = {
    ageRating: "adult",
    city: "New York",
    zipCode: "27505",
    countryCode: function() {
        return (0, _helpers.getCountryCode)("US");
    },
    ip: "127.0.0.1",
    household: "b2244e9d4c04826ccd5a7b2c2a50e7d4",
    language: function() {
        return (0, _helpers.getLanguage)("en");
    },
    latlon: function() {
        return (0, _helpers.getLatLon)([
            40.7128,
            74.006
        ]);
    },
    locale: function() {
        return (0, _helpers.getLocale)("en-US");
    },
    mac: "00:00:00:00:00:00",
    operator: "metrological",
    platform: "metrological",
    packages: [],
    uid: "ee6723b8-7ab3-462c-8d93-dbf61227998e",
    stbType: "metrological"
};


/***/ }),

/***/ 58623:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/*
 * If not stated otherwise in this file or this component's LICENSE file the
 * following copyright and licenses apply:
 *
 * Copyright 2020 Metrological
 *
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    getCountryCode: function() {
        return getCountryCode;
    },
    getLanguage: function() {
        return getLanguage;
    },
    getLatLon: function() {
        return getLatLon;
    },
    getLocale: function() {
        return getLocale;
    }
});
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(65759);
var _LightningSdkPlugins = __webpack_require__(62476);
var formatLocale = function(locale) {
    if (locale && locale.length === 2) {
        return "".concat(locale.toLowerCase(), "-").concat(locale.toUpperCase());
    } else {
        return locale;
    }
};
var getLocale = function(defaultValue) {
    if ("language" in navigator) {
        var locale = formatLocale(navigator.language);
        return Promise.resolve(locale);
    } else {
        return Promise.resolve(defaultValue);
    }
};
var getLanguage = function(defaultValue) {
    if ("language" in navigator) {
        var language = formatLocale(navigator.language).slice(0, 2);
        return Promise.resolve(language);
    } else {
        return Promise.resolve(defaultValue);
    }
};
var getCountryCode = function(defaultValue) {
    if ("language" in navigator) {
        var countryCode = formatLocale(navigator.language).slice(3, 5);
        return Promise.resolve(countryCode);
    } else {
        return Promise.resolve(defaultValue);
    }
};
var hasOrAskForGeoLocationPermission = function() {
    return new Promise(function(resolve) {
        // force to prompt for location permission
        if (_LightningSdkPlugins.Settings.get("platform", "forceBrowserGeolocation") === true) resolve(true);
        if ("permissions" in navigator && typeof navigator.permissions.query === "function") {
            navigator.permissions.query({
                name: "geolocation"
            }).then(function(status) {
                resolve(status.state === "granted" || status.status === "granted");
            });
        } else {
            resolve(false);
        }
    });
};
var getLatLon = function(defaultValue) {
    return new Promise(function(resolve) {
        hasOrAskForGeoLocationPermission().then(function(granted) {
            if (granted === true) {
                if ("geolocation" in navigator) {
                    navigator.geolocation.getCurrentPosition(// success
                    function(result) {
                        return result && result.coords && resolve([
                            result.coords.latitude,
                            result.coords.longitude
                        ]);
                    }, // error
                    function() {
                        return resolve(defaultValue);
                    }, // options
                    {
                        enableHighAccuracy: true,
                        timeout: 5000,
                        maximumAge: 0
                    });
                } else {
                    return queryForLatLon().then(function(result) {
                        return resolve(result || defaultValue);
                    });
                }
            } else {
                return queryForLatLon().then(function(result) {
                    return resolve(result || defaultValue);
                });
            }
        });
    });
};
var queryForLatLon = function() {
    return new Promise(function(resolve) {
        fetch("https://geolocation-db.com/json/").then(function(response) {
            return response.json();
        }).then(function(param) {
            var latitude = param.latitude, longitude = param.longitude;
            return latitude && longitude ? resolve([
                latitude,
                longitude
            ]) : resolve(false);
        }).catch(function() {
            return resolve(false);
        });
    });
};


/***/ }),

/***/ 39137:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/*
 * If not stated otherwise in this file or this component's LICENSE file the
 * following copyright and licenses apply:
 *
 * Copyright 2020 Metrological
 *
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    // public API
    default: function() {
        return _default;
    },
    initProfile: function() {
        return initProfile;
    }
});
var _object_spread = __webpack_require__(76247);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(45538);
var _LightningSdkPlugins = __webpack_require__(62476);
var _defaults = __webpack_require__(95185);
var getInfo = function(key) {
    var profile = _object_spread._({}, _defaults.defaultProfile, _LightningSdkPlugins.Settings.get("platform", "profile"));
    return Promise.resolve(typeof profile[key] === "function" ? profile[key]() : profile[key]);
};
var setInfo = function(key, params) {
    if (key in _defaults.defaultProfile) return _defaults.defaultProfile[key] = params;
};
var initProfile = function(config) {
    getInfo = config.getInfo ? config.getInfo : getInfo;
    setInfo = config.setInfo ? config.setInfo : setInfo;
};
var getOrSet = function(key, params) {
    return params ? setInfo(key, params) : getInfo(key);
};
var _default = {
    ageRating: function(params) {
        return getOrSet("ageRating", params);
    },
    city: function(params) {
        return getOrSet("city", params);
    },
    zipCode: function(params) {
        return getOrSet("zipCode", params);
    },
    countryCode: function(params) {
        return getOrSet("countryCode", params);
    },
    ip: function(params) {
        return getOrSet("ip", params);
    },
    household: function(params) {
        return getOrSet("household", params);
    },
    language: function(params) {
        return getOrSet("language", params);
    },
    latlon: function(params) {
        return getOrSet("latlon", params);
    },
    locale: function(params) {
        return getOrSet("locale", params);
    },
    mac: function(params) {
        return getOrSet("mac", params);
    },
    operator: function(params) {
        return getOrSet("operator", params);
    },
    platform: function(params) {
        return getOrSet("platform", params);
    },
    packages: function(params) {
        return getOrSet("packages", params);
    },
    uid: function(params) {
        return getOrSet("uid", params);
    },
    stbType: function(params) {
        return getOrSet("stbType", params);
    }
};


/***/ }),

/***/ 55403:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/*
 * If not stated otherwise in this file or this component's LICENSE file the
 * following copyright and licenses apply:
 *
 * Copyright 2020 Metrological
 *
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    default: function() {
        return _default;
    },
    initPurchase: function() {
        return initPurchase;
    }
});
var _interop_require_default = __webpack_require__(81200);
var _object_spread = __webpack_require__(76247);
var _sliced_to_array = __webpack_require__(28966);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(3009);
__webpack_require__(42578);
var _Profile = /*#__PURE__*/ _interop_require_default._(__webpack_require__(39137));
var _LightningSdkPlugins = __webpack_require__(62476);
var _sequence = /*#__PURE__*/ _interop_require_default._(__webpack_require__(28398));
var cspUrl = "http://payment-csp-example.metrological.com:8080/";
var billingUrl = "https://payment-sdk.metrological.com/";
var cspEndpoints = {
    assets: {
        uri: "/assets",
        method: "GET"
    },
    asset: {
        uri: "/assets/:id",
        method: "GET"
    },
    signature: {
        uri: "/assets/:id/signature",
        method: "POST"
    },
    subscribe: {
        uri: "/assets/:id/subscribe",
        method: "POST"
    },
    unsubscribe: {
        uri: "/assets/:id/unsubscribe",
        method: "POST"
    }
};
var initPurchase = function(config) {
    if (config.billingUrl) billingUrl = config.billingUrl;
};
var createUrl = function(uri, baseUrl) {
    var params = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return new URL(// sprinkle in the params
    Object.keys(params).reduce(function(res, key) {
        return res.replace(new RegExp(":" + key, "g"), params[key]);
    }, uri)// remove any leading slash from uri
    .replace(/^\//, ""), // make sure baseUrl always has a trailing slash
    /\/$/.test(baseUrl) ? baseUrl : baseUrl.replace(/$/, "/"));
};
var request = function(url) {
    var method = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "GET", data = arguments.length > 2 ? arguments[2] : void 0, headers = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    if (method === "GET" && data) {
        url.search = new URLSearchParams(data);
    }
    return new Promise(function(resolve, reject) {
        fetch(url, {
            headers: _object_spread._({}, {
                Accept: "application/json",
                "Content-Type": "application/json"
            }, headers),
            method: method,
            body: method !== "GET" && data ? JSON.stringify(data) : null
        }).then(function(response) {
            return response.ok ? resolve(response.json()) : reject(response.statusText);
        }).catch(reject);
    });
};
var cspRequest = function(type) {
    var data = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, params = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return new Promise(function(resolve, reject) {
        var endpoint = cspEndpoints[type];
        if (!endpoint) {
            reject('No endpoint found for "' + type + '" call');
        } else {
            if (endpoint.callback && typeof endpoint.callback === "function") {
                endpoint.callback(data, params).then(resolve).catch(reject);
            } else {
                request(createUrl(endpoint.uri, cspUrl, params), endpoint.method, _object_spread._({}, endpoint.data || {}, data), endpoint.headers || {}).then(resolve).catch(reject);
            }
        }
    });
};
var billingRequest = function(uri, data) {
    var method = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "POST";
    return new Promise(function(resolve, reject) {
        request(createUrl(uri, billingUrl), method, data).then(resolve).catch(reject);
    });
};
var _default = {
    setup: function(config) {
        if (config.cspUrl) cspUrl = config.cspUrl;
        if (config.endpoints) cspEndpoints = _object_spread._({
            cspEndpoints: cspEndpoints
        }, config.endpoints);
    },
    assets: function() {
        return new Promise(function(resolve, reject) {
            _Profile.default.household().then(function(household) {
                cspRequest("assets", {
                    household: household
                }).then(resolve).catch(reject);
            });
        });
    },
    asset: function(id) {
        return new Promise(function(resolve, reject) {
            _Profile.default.household().then(function(household) {
                cspRequest("asset", {
                    household: household
                }, {
                    id: id
                }).then(resolve).catch(reject);
            });
        });
    },
    signature: function(id) {
        return new Promise(function(resolve, reject) {
            Promise.all([
                _Profile.default.household()
            ]).then(function(param) {
                var _param = _sliced_to_array._(param, 1), household = _param[0];
                cspRequest("signature", {
                    household: household
                }, {
                    id: id
                }).then(resolve).catch(reject);
            });
        });
    },
    subscribe: function(id, transaction) {
        return new Promise(function(resolve, reject) {
            cspRequest("subscribe", _object_spread._({}, transaction), {
                id: id
            }).then(resolve).catch(reject);
        });
    },
    unsubscribe: function(id) {
        return new Promise(function(resolve, reject) {
            _Profile.default.household().then(function(household) {
                cspRequest("unsubscribe", {
                    household: household
                }, {
                    id: id
                }).then(resolve).catch(reject);
            });
        });
    },
    payment: function() {
        var signature = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "in-app";
        return new Promise(function(resolve, reject) {
            Promise.all([
                _Profile.default.household(),
                _Profile.default.countryCode(),
                _Profile.default.operator(),
                _Profile.default.mac(),
                _Profile.default.uid()
            ]).then(function(param) {
                var _param = _sliced_to_array._(param, 5), household = _param[0], country = _param[1], operator = _param[2], mac = _param[3], uid = _param[4];
                billingRequest("/", {
                    purchase: signature,
                    identifier: _LightningSdkPlugins.Settings.get("app", "id"),
                    name: _LightningSdkPlugins.Settings.get("app", "id"),
                    household: household,
                    country: country,
                    operator: operator,
                    mac: mac,
                    uid: uid,
                    type: type
                }).then(resolve).catch(reject);
            }).catch(reject);
        });
    },
    confirm: function(transactionId) {
        return new Promise(function(resolve, reject) {
            billingRequest("/confirm", {
                transactionId: transactionId
            }).then(resolve).catch(reject);
        });
    },
    buy: function(assetId, type) {
        var _this = this;
        return new Promise(function(resolve, reject) {
            var transactionId;
            (0, _sequence.default)([
                function() {
                    return _this.signature(assetId);
                },
                function(signature) {
                    return _this.payment(signature, type);
                },
                function(transaction) {
                    transactionId = transaction.transactionId;
                    return _this.subscribe(assetId, transaction);
                },
                function() {
                    return _this.confirm(transactionId);
                }
            ]).then(resolve).catch(reject);
        });
    }
};


/***/ }),

/***/ 30854:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/*
 * If not stated otherwise in this file or this component's LICENSE file the
 * following copyright and licenses apply:
 *
 * Copyright 2020 Metrological
 *
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    channels: function() {
        return channels;
    },
    randomChannel: function() {
        return randomChannel;
    }
});
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(65759);
var _LightningSdkPlugins = __webpack_require__(62476);
var defaultChannels = [
    {
        number: 1,
        name: "Metro News 1",
        description: "New York Cable News Channel",
        entitled: true,
        program: {
            title: "The Morning Show",
            description: "New York's best morning show",
            startTime: new Date(new Date() - 60 * 5 * 1000).toUTCString(),
            duration: 60 * 30,
            ageRating: 0
        }
    },
    {
        number: 2,
        name: "MTV",
        description: "Music Television",
        entitled: true,
        program: {
            title: "Beavis and Butthead",
            description: "American adult animated sitcom created by Mike Judge",
            startTime: new Date(new Date() - 60 * 20 * 1000).toUTCString(),
            duration: 60 * 45,
            ageRating: 18
        }
    },
    {
        number: 3,
        name: "NBC",
        description: "NBC TV Network",
        entitled: false,
        program: {
            title: "The Tonight Show Starring Jimmy Fallon",
            description: "Late-night talk show hosted by Jimmy Fallon on NBC",
            startTime: new Date(new Date() - 60 * 10 * 1000).toUTCString(),
            duration: 60 * 60,
            ageRating: 10
        }
    }
];
var channels = function() {
    return _LightningSdkPlugins.Settings.get("platform", "tv", defaultChannels);
};
var randomChannel = function() {
    return channels()[~~(channels.length * Math.random())];
};


/***/ }),

/***/ 35031:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/*
 * If not stated otherwise in this file or this component's LICENSE file the
 * following copyright and licenses apply:
 *
 * Copyright 2020 Metrological
 *
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    // public API
    default: function() {
        return _default;
    },
    initTV: function() {
        return initTV;
    }
});
var _object_spread = __webpack_require__(76247);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(88801);
var _LightningSdkPlugins = __webpack_require__(62476);
var _defaults = __webpack_require__(30854);
var currentChannel;
var callbacks = {};
var emit = function(event) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    callbacks[event] && callbacks[event].forEach(function(cb) {
        cb.apply(null, args);
    });
};
// local mock methods
var methods = {
    getChannel: function() {
        if (!currentChannel) currentChannel = (0, _defaults.randomChannel)();
        return new Promise(function(resolve, reject) {
            if (currentChannel) {
                var channel = _object_spread._({}, currentChannel);
                delete channel.program;
                resolve(channel);
            } else {
                reject("No channel found");
            }
        });
    },
    getProgram: function() {
        if (!currentChannel) currentChannel = (0, _defaults.randomChannel)();
        return new Promise(function(resolve, reject) {
            currentChannel.program ? resolve(currentChannel.program) : reject("No program found");
        });
    },
    setChannel: function(number) {
        return new Promise(function(resolve, reject) {
            if (number) {
                var newChannel = (0, _defaults.channels)().find(function(c) {
                    return c.number === number;
                });
                if (newChannel) {
                    currentChannel = newChannel;
                    var channel = _object_spread._({}, currentChannel);
                    delete channel.program;
                    emit("channelChange", channel);
                    resolve(channel);
                } else {
                    reject("Channel not found");
                }
            } else {
                reject("No channel number supplied");
            }
        });
    }
};
var initTV = function(config) {
    methods = {};
    if (config.getChannel && typeof config.getChannel === "function") {
        methods.getChannel = config.getChannel;
    }
    if (config.getProgram && typeof config.getProgram === "function") {
        methods.getProgram = config.getProgram;
    }
    if (config.setChannel && typeof config.setChannel === "function") {
        methods.setChannel = config.setChannel;
    }
    if (config.emit && typeof config.emit === "function") {
        config.emit(emit);
    }
};
var _default = {
    channel: function() {
        var number = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
        return new Promise(function(resolve, reject) {
            try {
                // call setChannel when number argument is passed, otherwise getChannel
                methods[number ? "setChannel" : "getChannel"](number).then(function(channel) {
                    // to do: ensure consistent formatting of channel info here?
                    resolve(channel);
                }).catch(reject);
            } catch (e) {
                reject(e);
            }
        });
    },
    program: function() {
        return new Promise(function(resolve, reject) {
            try {
                methods.getProgram().then(function(program) {
                    // to do: ensure consistent formatting of program info here?
                    resolve(program);
                }).catch(reject);
            } catch (e) {
                reject(e);
            }
        });
    },
    entitled: function() {
        return new Promise(function(resolve, reject) {
            try {
                methods.getChannel().then(function(channel) {
                    "entitled" in channel ? resolve(!!channel.entitled) : reject();
                }).catch(reject);
            } catch (e) {
                reject(e);
            }
        });
    },
    addEventListener: function(event, cb) {
        if (typeof cb === "function") {
            callbacks[event] = callbacks[event] || [];
            callbacks[event].push(cb);
        } else {
            _LightningSdkPlugins.Log.error("Please provide a function as a callback");
        }
    },
    removeEventListener: function(event) {
        var cb = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        if (callbacks[event] && callbacks[event].length) {
            callbacks[event] = cb ? callbacks[event].filter(function(_cb) {
                return _cb === cb;
            }) : [];
        }
    }
};


/***/ }),

/***/ 24750:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/*
 * If not stated otherwise in this file or this component's LICENSE file the
 * following copyright and licenses apply:
 *
 * Copyright 2020 Metrological
 *
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
var _inherits = __webpack_require__(71648);
var _create_super = __webpack_require__(6400);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(88801);
var _LightningSdkPlugins = __webpack_require__(62476);
var _default = function() {
    return /*#__PURE__*/ function(_Lightning_Component) {
        "use strict";
        _inherits._(VideoTexture, _Lightning_Component);
        var _super = _create_super._(VideoTexture);
        function VideoTexture() {
            _class_call_check._(this, VideoTexture);
            return _super.apply(this, arguments);
        }
        _create_class._(VideoTexture, [
            {
                key: "videoEl",
                get: function get() {
                    return this._videoEl;
                },
                set: function set(v) {
                    this._videoEl = v;
                }
            },
            {
                key: "videoView",
                get: function get() {
                    return this.tag("Video");
                }
            },
            {
                key: "videoTexture",
                get: function get() {
                    return this.videoView.texture;
                }
            },
            {
                key: "isVisible",
                get: function get() {
                    return this.videoView.alpha === 1 && this.videoView.visible === true;
                }
            },
            {
                key: "_init",
                value: function _init() {
                    this._createVideoTexture();
                }
            },
            {
                key: "_createVideoTexture",
                value: function _createVideoTexture() {
                    var stage = this.stage;
                    var gl = stage.gl;
                    var glTexture = gl.createTexture();
                    gl.bindTexture(gl.TEXTURE_2D, glTexture);
                    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
                    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
                    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
                    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
                    this.videoTexture.options = {
                        source: glTexture,
                        w: this.videoEl.width,
                        h: this.videoEl.height
                    };
                    this.videoView.w = this.videoEl.width / this.stage.getRenderPrecision();
                    this.videoView.h = this.videoEl.height / this.stage.getRenderPrecision();
                }
            },
            {
                key: "start",
                value: function start() {
                    var _this = this;
                    var stage = this.stage;
                    this._lastTime = 0;
                    if (!this._updateVideoTexture) {
                        this._updateVideoTexture = function() {
                            if (_this.videoTexture.options.source && _this.videoEl.videoWidth && _this.active) {
                                var gl = stage.gl;
                                var currentTime = new Date().getTime();
                                var getVideoPlaybackQuality = _this.videoEl.getVideoPlaybackQuality();
                                // When BR2_PACKAGE_GST1_PLUGINS_BAD_PLUGIN_DEBUGUTILS is not set in WPE, webkitDecodedFrameCount will not be available.
                                // We'll fallback to fixed 30fps in this case.
                                // As 'webkitDecodedFrameCount' is about to deprecate, check for the 'totalVideoFrames'
                                var frameCount = getVideoPlaybackQuality ? getVideoPlaybackQuality.totalVideoFrames : _this.videoEl.webkitDecodedFrameCount;
                                var mustUpdate = frameCount ? _this._lastFrame !== frameCount : _this._lastTime < currentTime - 30;
                                if (mustUpdate) {
                                    _this._lastTime = currentTime;
                                    _this._lastFrame = frameCount;
                                    try {
                                        gl.bindTexture(gl.TEXTURE_2D, _this.videoTexture.options.source);
                                        gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, false);
                                        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, _this.videoEl);
                                        _this._lastFrame = _this.videoEl.webkitDecodedFrameCount;
                                        _this.videoView.visible = true;
                                        _this.videoTexture.options.w = _this.videoEl.width;
                                        _this.videoTexture.options.h = _this.videoEl.height;
                                        var expectedAspectRatio = _this.videoView.w / _this.videoView.h;
                                        var realAspectRatio = _this.videoEl.width / _this.videoEl.height;
                                        if (expectedAspectRatio > realAspectRatio) {
                                            _this.videoView.scaleX = realAspectRatio / expectedAspectRatio;
                                            _this.videoView.scaleY = 1;
                                        } else {
                                            _this.videoView.scaleY = expectedAspectRatio / realAspectRatio;
                                            _this.videoView.scaleX = 1;
                                        }
                                    } catch (e) {
                                        _LightningSdkPlugins.Log.error("texImage2d video", e);
                                        _this.stop();
                                    }
                                    _this.videoTexture.source.forceRenderUpdate();
                                }
                            }
                        };
                    }
                    if (!this._updatingVideoTexture) {
                        stage.on("frameStart", this._updateVideoTexture);
                        this._updatingVideoTexture = true;
                    }
                }
            },
            {
                key: "stop",
                value: function stop() {
                    var stage = this.stage;
                    stage.removeListener("frameStart", this._updateVideoTexture);
                    this._updatingVideoTexture = false;
                    this.videoView.visible = false;
                    if (this.videoTexture.options.source) {
                        var gl = stage.gl;
                        gl.bindTexture(gl.TEXTURE_2D, this.videoTexture.options.source);
                        gl.clearColor(0, 0, 0, 1);
                        gl.clear(gl.COLOR_BUFFER_BIT);
                    }
                }
            },
            {
                key: "position",
                value: function position(top, left) {
                    this.videoView.patch({
                        x: left,
                        y: top
                    });
                }
            },
            {
                key: "size",
                value: function size(width, height) {
                    this.videoView.patch({
                        w: width,
                        h: height
                    });
                }
            },
            {
                key: "show",
                value: function show() {
                    this.videoView.alpha = 1;
                }
            },
            {
                key: "hide",
                value: function hide() {
                    this.videoView.alpha = 0;
                }
            }
        ], [
            {
                key: "_template",
                value: function _template() {
                    return {
                        Video: {
                            alpha: 1,
                            visible: false,
                            pivot: 0.5,
                            texture: {
                                type: _LightningSdkPlugins.Lightning.textures.StaticTexture,
                                options: {}
                            }
                        }
                    };
                }
            }
        ]);
        return VideoTexture;
    }(_LightningSdkPlugins.Lightning.Component);
};


/***/ }),

/***/ 34843:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/*
 * If not stated otherwise in this file or this component's LICENSE file the
 * following copyright and licenses apply:
 *
 * Copyright 2020 Metrological
 *
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(37815);
var _default = {
    abort: "Abort",
    canplay: "CanPlay",
    canplaythrough: "CanPlayThrough",
    durationchange: "DurationChange",
    emptied: "Emptied",
    encrypted: "Encrypted",
    ended: "Ended",
    error: "Error",
    interruptbegin: "InterruptBegin",
    interruptend: "InterruptEnd",
    loadeddata: "LoadedData",
    loadedmetadata: "LoadedMetadata",
    loadstart: "LoadStart",
    pause: "Pause",
    play: "Play",
    playing: "Playing",
    progress: "Progress",
    ratechange: "Ratechange",
    seeked: "Seeked",
    seeking: "Seeking",
    stalled: "Stalled",
    // suspend: 'Suspend', // this one is called a looooot for some videos
    timeupdate: "TimeUpdate",
    volumechange: "VolumeChange",
    waiting: "Waiting"
};


/***/ }),

/***/ 2016:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/*
 * If not stated otherwise in this file or this component's LICENSE file the
 * following copyright and licenses apply:
 *
 * Copyright 2020 Metrological
 *
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    default: function() {
        return _default;
    },
    initVideoPlayer: function() {
        return initVideoPlayer;
    },
    mediaUrl: function() {
        return mediaUrl;
    },
    setUpVideoTexture: function() {
        return setUpVideoTexture;
    },
    setupVideoTag: function() {
        return setupVideoTag;
    }
});
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(88801);
var _executeaspromise = /*#__PURE__*/ _interop_require_default._(__webpack_require__(71864));
var _Metrics = /*#__PURE__*/ _interop_require_default._(__webpack_require__(58336));
var _LightningSdkPlugins = __webpack_require__(62476);
var _events = /*#__PURE__*/ _interop_require_default._(__webpack_require__(34843));
var _autoSetupMixin = /*#__PURE__*/ _interop_require_default._(__webpack_require__(74982));
var _easeExecution = /*#__PURE__*/ _interop_require_default._(__webpack_require__(70629));
var _VideoTexture = /*#__PURE__*/ _interop_require_default._(__webpack_require__(24750));
var mediaUrl = function(url) {
    return url;
};
var videoEl;
var videoTexture;
var metrics;
var consumer;
var precision = 1;
var textureMode = false;
var initVideoPlayer = function(config) {
    if (config.mediaUrl) {
        mediaUrl = config.mediaUrl;
    }
};
// todo: add this in a 'Registry' plugin
// to be able to always clean this up on app close
var eventHandlers = {};
var state = {
    adsEnabled: false,
    playing: false,
    _playingAds: false,
    get playingAds () {
        return this._playingAds;
    },
    set playingAds (val){
        if (this._playingAds !== val) {
            this._playingAds = val;
            fireOnConsumer(val === true ? "AdStart" : "AdEnd");
        }
    },
    skipTime: false,
    playAfterSeek: null
};
var hooks = {
    play: function() {
        state.playing = true;
    },
    pause: function() {
        state.playing = false;
    },
    seeked: function() {
        state.playAfterSeek === true && videoPlayerPlugin.play();
        state.playAfterSeek = null;
    },
    abort: function() {
        deregisterEventListeners();
    }
};
var withPrecision = function(val1) {
    return Math.round(precision * val1) + "px";
};
var fireOnConsumer = function(event, args) {
    if (consumer) {
        consumer.fire("$videoPlayer" + event, args, videoEl.currentTime);
        consumer.fire("$videoPlayerEvent", event, args, videoEl.currentTime);
    }
};
var fireHook = function(event, args) {
    hooks[event] && typeof hooks[event] === "function" && hooks[event].call(null, event, args);
};
var customLoader = null;
var customUnloader = null;
var loader = function(url, videoEl, config) {
    return customLoader && typeof customLoader === "function" ? customLoader(url, videoEl, config) : new Promise(function(resolve) {
        url = mediaUrl(url);
        videoEl.setAttribute("src", url);
        videoEl.load();
        resolve();
    });
};
var unloader = function(videoEl) {
    return customUnloader && typeof customUnloader === "function" ? customUnloader(videoEl) : new Promise(function(resolve) {
        videoEl.removeAttribute("src");
        videoEl.load();
        resolve();
    });
};
var setupVideoTag = function() {
    var videoEls = document.getElementsByTagName("video");
    if (videoEls && videoEls.length) {
        return videoEls[0];
    } else {
        var videoEl = document.createElement("video");
        var platformSettingsWidth = _LightningSdkPlugins.Settings.get("platform", "width") ? _LightningSdkPlugins.Settings.get("platform", "width") : 1920;
        var platformSettingsHeight = _LightningSdkPlugins.Settings.get("platform", "height") ? _LightningSdkPlugins.Settings.get("platform", "height") : 1080;
        videoEl.setAttribute("id", "video-player");
        videoEl.setAttribute("width", withPrecision(platformSettingsWidth));
        videoEl.setAttribute("height", withPrecision(platformSettingsHeight));
        videoEl.style.position = "absolute";
        videoEl.style.zIndex = "1";
        videoEl.style.display = "none";
        videoEl.style.visibility = "hidden";
        videoEl.style.top = withPrecision(0);
        videoEl.style.left = withPrecision(0);
        videoEl.style.width = withPrecision(platformSettingsWidth);
        videoEl.style.height = withPrecision(platformSettingsHeight);
        document.body.appendChild(videoEl);
        return videoEl;
    }
};
var setUpVideoTexture = function() {
    if (!_LightningSdkPlugins.ApplicationInstance.tag("VideoTexture")) {
        var el = _LightningSdkPlugins.ApplicationInstance.stage.c({
            type: (0, _VideoTexture.default)(),
            ref: "VideoTexture",
            zIndex: 0,
            videoEl: videoEl
        });
        _LightningSdkPlugins.ApplicationInstance.childList.addAt(el, 0);
    }
    return _LightningSdkPlugins.ApplicationInstance.tag("VideoTexture");
};
var registerEventListeners = function() {
    _LightningSdkPlugins.Log.info("VideoPlayer", "Registering event listeners");
    Object.keys(_events.default).forEach(function(event) {
        var handler = function(e) {
            // Fire a metric for each event (if it exists on the metrics object)
            if (metrics && metrics[event] && typeof metrics[event] === "function") {
                metrics[event]({
                    currentTime: videoEl.currentTime
                });
            }
            // fire an internal hook
            fireHook(event, {
                videoElement: videoEl,
                event: e
            });
            // fire the event (with human friendly event name) to the consumer of the VideoPlayer
            fireOnConsumer(_events.default[event], {
                videoElement: videoEl,
                event: e
            });
        };
        eventHandlers[event] = handler;
        videoEl.addEventListener(event, handler);
    });
};
var deregisterEventListeners = function() {
    _LightningSdkPlugins.Log.info("VideoPlayer", "Deregistering event listeners");
    Object.keys(eventHandlers).forEach(function(event) {
        videoEl.removeEventListener(event, eventHandlers[event]);
    });
    eventHandlers = {};
};
var videoPlayerPlugin = {
    consumer: function(component) {
        consumer = component;
    },
    loader: function(loaderFn) {
        customLoader = loaderFn;
    },
    unloader: function(unloaderFn) {
        customUnloader = unloaderFn;
    },
    position: function() {
        var top = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, left = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        videoEl.style.left = withPrecision(left);
        videoEl.style.top = withPrecision(top);
        if (textureMode === true) {
            videoTexture.position(top, left);
        }
    },
    size: function() {
        var width = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1920, height = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1080;
        videoEl.style.width = withPrecision(width);
        videoEl.style.height = withPrecision(height);
        videoEl.width = parseFloat(videoEl.style.width);
        videoEl.height = parseFloat(videoEl.style.height);
        if (textureMode === true) {
            videoTexture.size(width, height);
        }
    },
    area: function() {
        var top = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, right = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1920, bottom = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1080, left = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
        this.position(top, left);
        this.size(right - left, bottom - top);
    },
    open: function(url) {
        var config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var _this = this;
        if (!this.canInteract) return;
        metrics = _Metrics.default.media(url);
        this.hide();
        deregisterEventListeners();
        if (this.src == url) {
            this.clear().then(this.open(url, config));
        } else {
            var adConfig = {
                enabled: state.adsEnabled,
                duration: 300
            };
            if (config.videoId) {
                adConfig.caid = config.videoId;
            }
            _LightningSdkPlugins.Ads.get(adConfig, consumer).then(function(ads) {
                state.playingAds = true;
                ads.prerolls().then(function() {
                    state.playingAds = false;
                    loader(url, videoEl, config).then(function() {
                        registerEventListeners();
                        _this.show();
                        _this.play();
                    }).catch(function(e) {
                        fireOnConsumer("Error", {
                            videoElement: videoEl,
                            event: e
                        });
                        // This is not API-compliant, as it results in firing "$videoPlayererror" rather than "$videoPlayerError".
                        // See docs here for API-compliant events -> https://github.com/Metrological/metrological-sdk/blob/master/docs/plugins/videoplayer.md#event-overview
                        // It has been kept for backwards compatability for library consumers who may have already written handler functions to match it.
                        fireOnConsumer("error", {
                            videoElement: videoEl,
                            event: e
                        });
                    });
                });
            });
        }
    },
    reload: function() {
        if (!this.canInteract) return;
        var url = videoEl.getAttribute("src");
        this.close();
        this.open(url);
    },
    close: function() {
        var _this = this;
        _LightningSdkPlugins.Ads.cancel();
        if (state.playingAds) {
            state.playingAds = false;
            _LightningSdkPlugins.Ads.stop();
            // call self in next tick
            setTimeout(function() {
                _this.close();
            });
        }
        if (!this.canInteract) return;
        this.clear();
        this.hide();
        deregisterEventListeners();
    },
    clear: function() {
        if (!this.canInteract) return;
        // pause the video first to disable sound
        this.pause();
        if (textureMode === true) videoTexture.stop();
        return unloader(videoEl).then(function() {
            fireOnConsumer("Clear", {
                videoElement: videoEl
            });
        });
    },
    play: function() {
        if (!this.canInteract) return;
        if (textureMode === true) videoTexture.start();
        (0, _executeaspromise.default)(videoEl.play, null, videoEl).catch(function(e) {
            fireOnConsumer("Error", {
                videoElement: videoEl,
                event: e
            });
            // This is not API-compliant, as it results in firing "$videoPlayererror" rather than "$videoPlayerError".
            // See docs here for API-compliant events -> https://github.com/Metrological/metrological-sdk/blob/master/docs/plugins/videoplayer.md#event-overview
            // It has been kept for backwards compatability for library consumers who may have already written handler functions to match it.
            fireOnConsumer("error", {
                videoElement: videoEl,
                event: e
            });
        });
    },
    pause: function() {
        if (!this.canInteract) return;
        videoEl.pause();
    },
    playPause: function() {
        if (!this.canInteract) return;
        this.playing === true ? this.pause() : this.play();
    },
    mute: function() {
        var muted = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
        if (!this.canInteract) return;
        videoEl.muted = muted;
    },
    loop: function() {
        var looped = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
        videoEl.loop = looped;
    },
    seek: function(time) {
        if (!this.canInteract) return;
        if (!this.src) return;
        // define whether should continue to play after seek is complete (in seeked hook)
        if (state.playAfterSeek === null) {
            state.playAfterSeek = !!state.playing;
        }
        // pause before actually seeking
        this.pause();
        // currentTime always between 0 and the duration of the video (minus 0.1s to not set to the final frame and stall the video)
        videoEl.currentTime = Math.max(0, Math.min(time, this.duration - 0.1));
    },
    skip: function(seconds) {
        var _this = this;
        if (!this.canInteract) return;
        if (!this.src) return;
        state.skipTime = (state.skipTime || videoEl.currentTime) + seconds;
        (0, _easeExecution.default)(function() {
            _this.seek(state.skipTime);
            state.skipTime = false;
        }, 300);
    },
    show: function() {
        if (!this.canInteract) return;
        if (textureMode === true) {
            videoTexture.show();
        } else {
            videoEl.style.display = "block";
            videoEl.style.visibility = "visible";
        }
    },
    hide: function() {
        if (!this.canInteract) return;
        if (textureMode === true) {
            videoTexture.hide();
        } else {
            videoEl.style.display = "none";
            videoEl.style.visibility = "hidden";
        }
    },
    enableAds: function() {
        var enabled = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
        state.adsEnabled = enabled;
    },
    /* Public getters */ get duration () {
        return videoEl && (isNaN(videoEl.duration) ? Infinity : videoEl.duration);
    },
    get currentTime () {
        return videoEl && videoEl.currentTime;
    },
    get muted () {
        return videoEl && videoEl.muted;
    },
    get looped () {
        return videoEl && videoEl.loop;
    },
    get src () {
        return videoEl && videoEl.getAttribute("src");
    },
    get playing () {
        return state.playing;
    },
    get playingAds () {
        return state.playingAds;
    },
    get canInteract () {
        // todo: perhaps add an extra flag wether we allow interactions (i.e. pauze, mute, etc.) during ad playback
        return state.playingAds === false;
    },
    get top () {
        return videoEl && parseFloat(videoEl.style.top);
    },
    get left () {
        return videoEl && parseFloat(videoEl.style.left);
    },
    get bottom () {
        return videoEl && parseFloat(videoEl.style.top - videoEl.style.height);
    },
    get right () {
        return videoEl && parseFloat(videoEl.style.left - videoEl.style.width);
    },
    get width () {
        return videoEl && parseFloat(videoEl.style.width);
    },
    get height () {
        return videoEl && parseFloat(videoEl.style.height);
    },
    get visible () {
        if (textureMode === true) {
            return videoTexture.isVisible;
        } else {
            return videoEl && videoEl.style.display === "block";
        }
    },
    get adsEnabled () {
        return state.adsEnabled;
    },
    // prefixed with underscore to indicate 'semi-private'
    // because it's not recommended to interact directly with the video element
    get _videoEl () {
        return videoEl;
    },
    get _consumer () {
        return consumer;
    }
};
var _default = (0, _autoSetupMixin.default)(videoPlayerPlugin, function() {
    precision = _LightningSdkPlugins.ApplicationInstance && _LightningSdkPlugins.ApplicationInstance.stage && _LightningSdkPlugins.ApplicationInstance.stage.getRenderPrecision() || precision;
    videoEl = setupVideoTag();
    textureMode = _LightningSdkPlugins.Settings.get("platform", "textureMode", false);
    if (textureMode === true) {
        videoEl.setAttribute("crossorigin", "anonymous");
        videoTexture = setUpVideoTexture();
    }
});


/***/ }),

/***/ 74982:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/*
 * If not stated otherwise in this file or this component's LICENSE file the
 * following copyright and licenses apply:
 *
 * Copyright 2020 Metrological
 *
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(37815);
var _default = function(sourceObject) {
    var setup = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function() {};
    var ready = false;
    var doSetup = function() {
        if (ready === false) {
            setup();
            ready = true;
        }
    };
    return Object.keys(sourceObject).reduce(function(obj, key) {
        if (typeof sourceObject[key] === "function") {
            obj[key] = function() {
                doSetup();
                return sourceObject[key].apply(sourceObject, arguments);
            };
        } else if (typeof Object.getOwnPropertyDescriptor(sourceObject, key).get === "function") {
            obj.__defineGetter__(key, function() {
                doSetup();
                return Object.getOwnPropertyDescriptor(sourceObject, key).get.apply(sourceObject);
            });
        } else if (typeof Object.getOwnPropertyDescriptor(sourceObject, key).set === "function") {
            obj.__defineSetter__(key, function() {
                doSetup();
                return Object.getOwnPropertyDescriptor(sourceObject, key).set.sourceObject[key].apply(sourceObject, arguments);
            });
        } else {
            obj[key] = sourceObject[key];
        }
        return obj;
    }, {});
};


/***/ }),

/***/ 70629:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/*
 * If not stated otherwise in this file or this component's LICENSE file the
 * following copyright and licenses apply:
 *
 * Copyright 2020 Metrological
 *
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(42578);
__webpack_require__(3009);
var timeout = null;
var _default = function(cb, delay) {
    clearTimeout(timeout);
    timeout = setTimeout(function() {
        cb();
    }, delay);
};


/***/ }),

/***/ 28398:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/*
 * If not stated otherwise in this file or this component's LICENSE file the
 * following copyright and licenses apply:
 *
 * Copyright 2020 Metrological
 *
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
__webpack_require__(88801);
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(52318);
var _default = function(steps) {
    return steps.reduce(function(promise, method) {
        return promise.then(function() {
            return method.apply(void 0, arguments);
        }).catch(function(e) {
            return Promise.reject(e);
        });
    }, Promise.resolve(null));
};


/***/ }),

/***/ 71864:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(3009);
var _default = function(method) {
    var args = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, context = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    var result;
    if (method && typeof method === "function") {
        try {
            result = method.apply(context, args);
        } catch (e) {
            result = e;
        }
    } else {
        result = method;
    }
    // if it looks like a duck .. ehm ... promise and talks like a promise, let's assume it's a promise
    if (result !== null && typeof result === "object" && result.then && typeof result.then === "function") {
        return result;
    } else {
        return new Promise(function(resolve, reject) {
            if (result instanceof Error) {
                reject(result);
            } else {
                resolve(result);
            }
        });
    }
};


/***/ }),

/***/ 32573:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _class_call_check = __webpack_require__(67818);
var _create_class = __webpack_require__(851);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(37815);
var localCookie = /*#__PURE__*/ function() {
    "use strict";
    function localCookie(e) {
        _class_call_check._(this, localCookie);
        return e = e || {}, this.forceCookies = e.forceCookies || !1, !0 === this._checkIfLocalStorageWorks() && !0 !== e.forceCookies ? {
            getItem: this._getItemLocalStorage,
            setItem: this._setItemLocalStorage,
            removeItem: this._removeItemLocalStorage,
            clear: this._clearLocalStorage,
            keys: this._getLocalStorageKeys
        } : {
            getItem: this._getItemCookie,
            setItem: this._setItemCookie,
            removeItem: this._removeItemCookie,
            clear: this._clearCookies,
            keys: this._getCookieKeys
        };
    }
    _create_class._(localCookie, [
        {
            key: "_checkIfLocalStorageWorks",
            value: function _checkIfLocalStorageWorks() {
                if ("undefined" == typeof localStorage) return !1;
                try {
                    return localStorage.setItem("feature_test", "yes"), "yes" === localStorage.getItem("feature_test") && (localStorage.removeItem("feature_test"), !0);
                } catch (e) {
                    return !1;
                }
            }
        },
        {
            key: "_getItemLocalStorage",
            value: function _getItemLocalStorage(e) {
                return window.localStorage.getItem(e);
            }
        },
        {
            key: "_setItemLocalStorage",
            value: function _setItemLocalStorage(e, t) {
                return window.localStorage.setItem(e, t);
            }
        },
        {
            key: "_removeItemLocalStorage",
            value: function _removeItemLocalStorage(e) {
                return window.localStorage.removeItem(e);
            }
        },
        {
            key: "_clearLocalStorage",
            value: function _clearLocalStorage() {
                return window.localStorage.clear();
            }
        },
        {
            key: "_getLocalStorageKeys",
            value: function _getLocalStorageKeys() {
                return Object.keys(window.localStorage);
            }
        },
        {
            key: "_getItemCookie",
            value: function _getItemCookie(e) {
                var t = document.cookie.match(RegExp("(?:^|;\\s*)" + function(e) {
                    return e.replace(/([.*+?\^${}()|\[\]\/\\])/g, "\\$1");
                }(e) + "=([^;]*)"));
                return t && "" === t[1] && (t[1] = null), t ? t[1] : null;
            }
        },
        {
            key: "_setItemCookie",
            value: function _setItemCookie(e, t) {
                var o = new Date, r = new Date(o.getTime() + 15768e7);
                document.cookie = "".concat(e, "=").concat(t, "; expires=").concat(r.toUTCString(), ";");
            }
        },
        {
            key: "_removeItemCookie",
            value: function _removeItemCookie(e) {
                document.cookie = "".concat(e, "=;Max-Age=-99999999;");
            }
        },
        {
            key: "_clearCookies",
            value: function _clearCookies() {
                document.cookie.split(";").forEach(function(e) {
                    document.cookie = e.replace(/^ +/, "").replace(/=.*/, "=;expires=Max-Age=-99999999");
                });
            }
        },
        {
            key: "_getCookieKeys",
            value: function _getCookieKeys() {
                return document.cookie.split(";").map(function(e) {
                    return e.split("=")[0];
                });
            }
        }
    ]);
    return localCookie;
}();
var _default = localCookie;


/***/ }),

/***/ 79711:
/***/ ((module, exports, __webpack_require__) => {

"use strict";
/* module decorator */ module = __webpack_require__.nmd(module);
var __WEBPACK_AMD_DEFINE_RESULT__;
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(37815);
(function(root) {
    /** Detect free variables */ var freeExports =  true && exports && !exports.nodeType && exports;
    var freeModule =  true && module && !module.nodeType && module;
    var freeGlobal = typeof __webpack_require__.g == "object" && __webpack_require__.g;
    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) {
        root = freeGlobal;
    }
    /**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */ var punycode, /** Highest positive signed 32-bit float value */ maxInt = 2147483647, /** Bootstring parameters */ base = 36, tMin = 1, tMax = 26, skew = 38, damp = 700, initialBias = 72, initialN = 128, delimiter = "-", /** Regular expressions */ regexPunycode = /^xn--/, regexNonASCII = /[^\x20-\x7E]/, regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, /** Error messages */ errors = {
        "overflow": "Overflow: input needs wider integers to process",
        "not-basic": "Illegal input >= 0x80 (not a basic code point)",
        "invalid-input": "Invalid input"
    }, /** Convenience shortcuts */ baseMinusTMin = base - tMin, floor = Math.floor, stringFromCharCode = String.fromCharCode, /** Temporary variable */ key;
    /*--------------------------------------------------------------------------*/ /**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */ function error(type) {
        throw new RangeError(errors[type]);
    }
    /**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */ function map(array, fn) {
        var length = array.length;
        var result = [];
        while(length--){
            result[length] = fn(array[length]);
        }
        return result;
    }
    /**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */ function mapDomain(string, fn) {
        var parts = string.split("@");
        var result = "";
        if (parts.length > 1) {
            // In email addresses, only the domain name should be punycoded. Leave
            // the local part (i.e. everything up to `@`) intact.
            result = parts[0] + "@";
            string = parts[1];
        }
        // Avoid `split(regex)` for IE8 compatibility. See #17.
        string = string.replace(regexSeparators, ".");
        var labels = string.split(".");
        var encoded = map(labels, fn).join(".");
        return result + encoded;
    }
    /**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */ function ucs2decode(string) {
        var output = [], counter = 0, length = string.length, value, extra;
        while(counter < length){
            value = string.charCodeAt(counter++);
            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                // high surrogate, and there is a next character
                extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) {
                    output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                } else {
                    // unmatched surrogate; only append this code unit, in case the next
                    // code unit is the high surrogate of a surrogate pair
                    output.push(value);
                    counter--;
                }
            } else {
                output.push(value);
            }
        }
        return output;
    }
    /**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */ function ucs2encode(array) {
        return map(array, function(value) {
            var output = "";
            if (value > 0xFFFF) {
                value -= 0x10000;
                output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
                value = 0xDC00 | value & 0x3FF;
            }
            output += stringFromCharCode(value);
            return output;
        }).join("");
    }
    /**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */ function basicToDigit(codePoint) {
        if (codePoint - 48 < 10) {
            return codePoint - 22;
        }
        if (codePoint - 65 < 26) {
            return codePoint - 65;
        }
        if (codePoint - 97 < 26) {
            return codePoint - 97;
        }
        return base;
    }
    /**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */ function digitToBasic(digit, flag) {
        //  0..25 map to ASCII a..z or A..Z
        // 26..35 map to ASCII 0..9
        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
    }
    /**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */ function adapt(delta, numPoints, firstTime) {
        var k = 0;
        delta = firstTime ? floor(delta / damp) : delta >> 1;
        delta += floor(delta / numPoints);
        for(; delta > baseMinusTMin * tMax >> 1; k += base){
            delta = floor(delta / baseMinusTMin);
        }
        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
    }
    /**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */ function decode(input) {
        // Don't use UCS-2
        var output = [], inputLength = input.length, out, i = 0, n = initialN, bias = initialBias, basic, j, index, oldi, w, k, digit, t, /** Cached calculation results */ baseMinusT;
        // Handle the basic code points: let `basic` be the number of input code
        // points before the last delimiter, or `0` if there is none, then copy
        // the first basic code points to the output.
        basic = input.lastIndexOf(delimiter);
        if (basic < 0) {
            basic = 0;
        }
        for(j = 0; j < basic; ++j){
            // if it's not a basic code point
            if (input.charCodeAt(j) >= 0x80) {
                error("not-basic");
            }
            output.push(input.charCodeAt(j));
        }
        // Main decoding loop: start just after the last delimiter if any basic code
        // points were copied; start at the beginning otherwise.
        for(index = basic > 0 ? basic + 1 : 0; index < inputLength;){
            // `index` is the index of the next character to be consumed.
            // Decode a generalized variable-length integer into `delta`,
            // which gets added to `i`. The overflow checking is easier
            // if we increase `i` as we go, then subtract off its starting
            // value at the end to obtain `delta`.
            for(oldi = i, w = 1, k = base;; k += base){
                if (index >= inputLength) {
                    error("invalid-input");
                }
                digit = basicToDigit(input.charCodeAt(index++));
                if (digit >= base || digit > floor((maxInt - i) / w)) {
                    error("overflow");
                }
                i += digit * w;
                t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                if (digit < t) {
                    break;
                }
                baseMinusT = base - t;
                if (w > floor(maxInt / baseMinusT)) {
                    error("overflow");
                }
                w *= baseMinusT;
            }
            out = output.length + 1;
            bias = adapt(i - oldi, out, oldi == 0);
            // `i` was supposed to wrap around from `out` to `0`,
            // incrementing `n` each time, so we'll fix that now:
            if (floor(i / out) > maxInt - n) {
                error("overflow");
            }
            n += floor(i / out);
            i %= out;
            // Insert `n` at position `i` of the output
            output.splice(i++, 0, n);
        }
        return ucs2encode(output);
    }
    /**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */ function encode(input) {
        var n, delta, handledCPCount, basicLength, bias, j, m, q, k, t, currentValue, output = [], /** `inputLength` will hold the number of code points in `input`. */ inputLength, /** Cached calculation results */ handledCPCountPlusOne, baseMinusT, qMinusT;
        // Convert the input in UCS-2 to Unicode
        input = ucs2decode(input);
        // Cache the length
        inputLength = input.length;
        // Initialize the state
        n = initialN;
        delta = 0;
        bias = initialBias;
        // Handle the basic code points
        for(j = 0; j < inputLength; ++j){
            currentValue = input[j];
            if (currentValue < 0x80) {
                output.push(stringFromCharCode(currentValue));
            }
        }
        handledCPCount = basicLength = output.length;
        // `handledCPCount` is the number of code points that have been handled;
        // `basicLength` is the number of basic code points.
        // Finish the basic string - if it is not empty - with a delimiter
        if (basicLength) {
            output.push(delimiter);
        }
        // Main encoding loop:
        while(handledCPCount < inputLength){
            // All non-basic code points < n have been handled already. Find the next
            // larger one:
            for(m = maxInt, j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue >= n && currentValue < m) {
                    m = currentValue;
                }
            }
            // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
            // but guard against overflow
            handledCPCountPlusOne = handledCPCount + 1;
            if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
                error("overflow");
            }
            delta += (m - n) * handledCPCountPlusOne;
            n = m;
            for(j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue < n && ++delta > maxInt) {
                    error("overflow");
                }
                if (currentValue == n) {
                    // Represent delta as a generalized variable-length integer
                    for(q = delta, k = base;; k += base){
                        t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                        if (q < t) {
                            break;
                        }
                        qMinusT = q - t;
                        baseMinusT = base - t;
                        output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                        q = floor(qMinusT / baseMinusT);
                    }
                    output.push(stringFromCharCode(digitToBasic(q, 0)));
                    bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                    delta = 0;
                    ++handledCPCount;
                }
            }
            ++delta;
            ++n;
        }
        return output.join("");
    }
    /**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */ function toUnicode(input) {
        return mapDomain(input, function(string) {
            return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
        });
    }
    /**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */ function toASCII(input) {
        return mapDomain(input, function(string) {
            return regexNonASCII.test(string) ? "xn--" + encode(string) : string;
        });
    }
    /*--------------------------------------------------------------------------*/ /** Define the public API */ punycode = {
        /**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */ "version": "1.4.1",
        /**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */ "ucs2": {
            "decode": ucs2decode,
            "encode": ucs2encode
        },
        "decode": decode,
        "encode": encode,
        "toASCII": toASCII,
        "toUnicode": toUnicode
    };
    /** Expose `punycode` */ // Some AMD build optimizers, like r.js, check for specific condition patterns
    // like the following:
    if (true) {
        !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
            return punycode;
        }).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else {}
})(void 0);


/***/ }),

/***/ 16060:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    NIL: function() {
        return _nil.default;
    },
    parse: function() {
        return _parse.default;
    },
    stringify: function() {
        return _stringify.default;
    },
    v1: function() {
        return _v1.default;
    },
    v3: function() {
        return _v3.default;
    },
    v4: function() {
        return _v4.default;
    },
    v5: function() {
        return _v5.default;
    },
    validate: function() {
        return _validate.default;
    },
    version: function() {
        return _version.default;
    }
});
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(42578);
__webpack_require__(3009);
var _v1 = /*#__PURE__*/ _interop_require_default._(__webpack_require__(99162));
var _v3 = /*#__PURE__*/ _interop_require_default._(__webpack_require__(25089));
var _v4 = /*#__PURE__*/ _interop_require_default._(__webpack_require__(73520));
var _v5 = /*#__PURE__*/ _interop_require_default._(__webpack_require__(34213));
var _nil = /*#__PURE__*/ _interop_require_default._(__webpack_require__(26269));
var _version = /*#__PURE__*/ _interop_require_default._(__webpack_require__(45933));
var _validate = /*#__PURE__*/ _interop_require_default._(__webpack_require__(38070));
var _stringify = /*#__PURE__*/ _interop_require_default._(__webpack_require__(78726));
var _parse = /*#__PURE__*/ _interop_require_default._(__webpack_require__(45203));


/***/ }),

/***/ 20274:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/*
 * Browser-compatible JavaScript MD5
 *
 * Modification of JavaScript MD5
 * https://github.com/blueimp/JavaScript-MD5
 *
 * Copyright 2011, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 *
 * Based on
 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
 * Digest Algorithm, as defined in RFC 1321.
 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for more info.
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(3009);
function md5(bytes) {
    if (typeof bytes === "string") {
        var msg = unescape(encodeURIComponent(bytes)); // UTF8 escape
        bytes = new Uint8Array(msg.length);
        for(var i = 0; i < msg.length; ++i){
            bytes[i] = msg.charCodeAt(i);
        }
    }
    return md5ToHexEncodedArray(wordsToMd5(bytesToWords(bytes), bytes.length * 8));
}
/*
 * Convert an array of little-endian words to an array of bytes
 */ function md5ToHexEncodedArray(input) {
    var output = [];
    var length32 = input.length * 32;
    var hexTab = "0123456789abcdef";
    for(var i = 0; i < length32; i += 8){
        var x = input[i >> 5] >>> i % 32 & 0xff;
        var hex = parseInt(hexTab.charAt(x >>> 4 & 0x0f) + hexTab.charAt(x & 0x0f), 16);
        output.push(hex);
    }
    return output;
}
/**
 * Calculate output length with padding and bit length
 */ function getOutputLength(inputLength8) {
    return (inputLength8 + 64 >>> 9 << 4) + 14 + 1;
}
/*
 * Calculate the MD5 of an array of little-endian words, and a bit length.
 */ function wordsToMd5(x, len) {
    /* append padding */ x[len >> 5] |= 0x80 << len % 32;
    x[getOutputLength(len) - 1] = len;
    var a = 1732584193;
    var b = -271733879;
    var c = -1732584194;
    var d = 271733878;
    for(var i = 0; i < x.length; i += 16){
        var olda = a;
        var oldb = b;
        var oldc = c;
        var oldd = d;
        a = md5ff(a, b, c, d, x[i], 7, -680876936);
        d = md5ff(d, a, b, c, x[i + 1], 12, -389564586);
        c = md5ff(c, d, a, b, x[i + 2], 17, 606105819);
        b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330);
        a = md5ff(a, b, c, d, x[i + 4], 7, -176418897);
        d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426);
        c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341);
        b = md5ff(b, c, d, a, x[i + 7], 22, -45705983);
        a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416);
        d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417);
        c = md5ff(c, d, a, b, x[i + 10], 17, -42063);
        b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162);
        a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682);
        d = md5ff(d, a, b, c, x[i + 13], 12, -40341101);
        c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290);
        b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329);
        a = md5gg(a, b, c, d, x[i + 1], 5, -165796510);
        d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632);
        c = md5gg(c, d, a, b, x[i + 11], 14, 643717713);
        b = md5gg(b, c, d, a, x[i], 20, -373897302);
        a = md5gg(a, b, c, d, x[i + 5], 5, -701558691);
        d = md5gg(d, a, b, c, x[i + 10], 9, 38016083);
        c = md5gg(c, d, a, b, x[i + 15], 14, -660478335);
        b = md5gg(b, c, d, a, x[i + 4], 20, -405537848);
        a = md5gg(a, b, c, d, x[i + 9], 5, 568446438);
        d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690);
        c = md5gg(c, d, a, b, x[i + 3], 14, -187363961);
        b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501);
        a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467);
        d = md5gg(d, a, b, c, x[i + 2], 9, -51403784);
        c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473);
        b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734);
        a = md5hh(a, b, c, d, x[i + 5], 4, -378558);
        d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463);
        c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562);
        b = md5hh(b, c, d, a, x[i + 14], 23, -35309556);
        a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060);
        d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353);
        c = md5hh(c, d, a, b, x[i + 7], 16, -155497632);
        b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640);
        a = md5hh(a, b, c, d, x[i + 13], 4, 681279174);
        d = md5hh(d, a, b, c, x[i], 11, -358537222);
        c = md5hh(c, d, a, b, x[i + 3], 16, -722521979);
        b = md5hh(b, c, d, a, x[i + 6], 23, 76029189);
        a = md5hh(a, b, c, d, x[i + 9], 4, -640364487);
        d = md5hh(d, a, b, c, x[i + 12], 11, -421815835);
        c = md5hh(c, d, a, b, x[i + 15], 16, 530742520);
        b = md5hh(b, c, d, a, x[i + 2], 23, -995338651);
        a = md5ii(a, b, c, d, x[i], 6, -198630844);
        d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415);
        c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905);
        b = md5ii(b, c, d, a, x[i + 5], 21, -57434055);
        a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571);
        d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606);
        c = md5ii(c, d, a, b, x[i + 10], 15, -1051523);
        b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799);
        a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359);
        d = md5ii(d, a, b, c, x[i + 15], 10, -30611744);
        c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380);
        b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649);
        a = md5ii(a, b, c, d, x[i + 4], 6, -145523070);
        d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379);
        c = md5ii(c, d, a, b, x[i + 2], 15, 718787259);
        b = md5ii(b, c, d, a, x[i + 9], 21, -343485551);
        a = safeAdd(a, olda);
        b = safeAdd(b, oldb);
        c = safeAdd(c, oldc);
        d = safeAdd(d, oldd);
    }
    return [
        a,
        b,
        c,
        d
    ];
}
/*
 * Convert an array bytes to an array of little-endian words
 * Characters >255 have their high-byte silently ignored.
 */ function bytesToWords(input) {
    if (input.length === 0) {
        return [];
    }
    var length8 = input.length * 8;
    var output = new Uint32Array(getOutputLength(length8));
    for(var i = 0; i < length8; i += 8){
        output[i >> 5] |= (input[i / 8] & 0xff) << i % 32;
    }
    return output;
}
/*
 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
 * to work around bugs in some JS interpreters.
 */ function safeAdd(x, y) {
    var lsw = (x & 0xffff) + (y & 0xffff);
    var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
    return msw << 16 | lsw & 0xffff;
}
/*
 * Bitwise rotate a 32-bit number to the left.
 */ function bitRotateLeft(num, cnt) {
    return num << cnt | num >>> 32 - cnt;
}
/*
 * These functions implement the four basic operations the algorithm uses.
 */ function md5cmn(q, a, b, x, s, t) {
    return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b);
}
function md5ff(a, b, c, d, x, s, t) {
    return md5cmn(b & c | ~b & d, a, b, x, s, t);
}
function md5gg(a, b, c, d, x, s, t) {
    return md5cmn(b & d | c & ~d, a, b, x, s, t);
}
function md5hh(a, b, c, d, x, s, t) {
    return md5cmn(b ^ c ^ d, a, b, x, s, t);
}
function md5ii(a, b, c, d, x, s, t) {
    return md5cmn(c ^ (b | ~d), a, b, x, s, t);
}
var _default = md5;


/***/ }),

/***/ 26269:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
var _default = "00000000-0000-0000-0000-000000000000";


/***/ }),

/***/ 45203:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(65759);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(45538);
var _validate = /*#__PURE__*/ _interop_require_default._(__webpack_require__(38070));
function parse(uuid) {
    if (!(0, _validate.default)(uuid)) {
        throw TypeError("Invalid UUID");
    }
    var v;
    var arr = new Uint8Array(16); // Parse ########-....-....-....-............
    arr[0] = (v = parseInt(uuid.slice(0, 8), 16)) >>> 24;
    arr[1] = v >>> 16 & 0xff;
    arr[2] = v >>> 8 & 0xff;
    arr[3] = v & 0xff; // Parse ........-####-....-....-............
    arr[4] = (v = parseInt(uuid.slice(9, 13), 16)) >>> 8;
    arr[5] = v & 0xff; // Parse ........-....-####-....-............
    arr[6] = (v = parseInt(uuid.slice(14, 18), 16)) >>> 8;
    arr[7] = v & 0xff; // Parse ........-....-....-####-............
    arr[8] = (v = parseInt(uuid.slice(19, 23), 16)) >>> 8;
    arr[9] = v & 0xff; // Parse ........-....-....-....-############
    // (Use "/" to avoid 32-bit truncation when bit-shifting high-order bytes)
    arr[10] = (v = parseInt(uuid.slice(24, 36), 16)) / 0x10000000000 & 0xff;
    arr[11] = v / 0x100000000 & 0xff;
    arr[12] = v >>> 24 & 0xff;
    arr[13] = v >>> 16 & 0xff;
    arr[14] = v >>> 8 & 0xff;
    arr[15] = v & 0xff;
    return arr;
}
var _default = parse;


/***/ }),

/***/ 84827:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
__webpack_require__(45538);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(37815);
var _default = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;


/***/ }),

/***/ 67539:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return rng;
    }
}));
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
var getRandomValues;
var rnds8 = new Uint8Array(16);
function rng() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
        // find the complete implementation of crypto (msCrypto) on IE11.
        getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== "undefined" && typeof msCrypto.getRandomValues === "function" && msCrypto.getRandomValues.bind(msCrypto);
        if (!getRandomValues) {
            throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
        }
    }
    return getRandomValues(rnds8);
}


/***/ }),

/***/ 2651:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
// Adapted from Chris Veness' SHA1 code at
// http://www.movable-type.co.uk/scripts/sha1.html

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(3009);
__webpack_require__(45538);
function f(s, x, y, z) {
    switch(s){
        case 0:
            return x & y ^ ~x & z;
        case 1:
            return x ^ y ^ z;
        case 2:
            return x & y ^ x & z ^ y & z;
        case 3:
            return x ^ y ^ z;
    }
}
function ROTL(x, n) {
    return x << n | x >>> 32 - n;
}
function sha1(bytes) {
    var K = [
        0x5a827999,
        0x6ed9eba1,
        0x8f1bbcdc,
        0xca62c1d6
    ];
    var H = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    if (typeof bytes === "string") {
        var msg = unescape(encodeURIComponent(bytes)); // UTF8 escape
        bytes = [];
        for(var i = 0; i < msg.length; ++i){
            bytes.push(msg.charCodeAt(i));
        }
    } else if (!Array.isArray(bytes)) {
        // Convert Array-like to Array
        bytes = Array.prototype.slice.call(bytes);
    }
    bytes.push(0x80);
    var l = bytes.length / 4 + 2;
    var N = Math.ceil(l / 16);
    var M = new Array(N);
    for(var _i = 0; _i < N; ++_i){
        var arr = new Uint32Array(16);
        for(var j = 0; j < 16; ++j){
            arr[j] = bytes[_i * 64 + j * 4] << 24 | bytes[_i * 64 + j * 4 + 1] << 16 | bytes[_i * 64 + j * 4 + 2] << 8 | bytes[_i * 64 + j * 4 + 3];
        }
        M[_i] = arr;
    }
    M[N - 1][14] = (bytes.length - 1) * 8 / Math.pow(2, 32);
    M[N - 1][14] = Math.floor(M[N - 1][14]);
    M[N - 1][15] = (bytes.length - 1) * 8 & 0xffffffff;
    for(var _i2 = 0; _i2 < N; ++_i2){
        var W = new Uint32Array(80);
        for(var t = 0; t < 16; ++t){
            W[t] = M[_i2][t];
        }
        for(var _t = 16; _t < 80; ++_t){
            W[_t] = ROTL(W[_t - 3] ^ W[_t - 8] ^ W[_t - 14] ^ W[_t - 16], 1);
        }
        var a = H[0];
        var b = H[1];
        var c = H[2];
        var d = H[3];
        var e = H[4];
        for(var _t2 = 0; _t2 < 80; ++_t2){
            var s = Math.floor(_t2 / 20);
            var T = ROTL(a, 5) + f(s, b, c, d) + e + K[s] + W[_t2] >>> 0;
            e = d;
            d = c;
            c = ROTL(b, 30) >>> 0;
            b = a;
            a = T;
        }
        H[0] = H[0] + a >>> 0;
        H[1] = H[1] + b >>> 0;
        H[2] = H[2] + c >>> 0;
        H[3] = H[3] + d >>> 0;
        H[4] = H[4] + e >>> 0;
    }
    return [
        H[0] >> 24 & 0xff,
        H[0] >> 16 & 0xff,
        H[0] >> 8 & 0xff,
        H[0] & 0xff,
        H[1] >> 24 & 0xff,
        H[1] >> 16 & 0xff,
        H[1] >> 8 & 0xff,
        H[1] & 0xff,
        H[2] >> 24 & 0xff,
        H[2] >> 16 & 0xff,
        H[2] >> 8 & 0xff,
        H[2] & 0xff,
        H[3] >> 24 & 0xff,
        H[3] >> 16 & 0xff,
        H[3] >> 8 & 0xff,
        H[3] & 0xff,
        H[4] >> 24 & 0xff,
        H[4] >> 16 & 0xff,
        H[4] >> 8 & 0xff,
        H[4] & 0xff
    ];
}
var _default = sha1;


/***/ }),

/***/ 78726:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(52318);
__webpack_require__(37815);
var _validate = /*#__PURE__*/ _interop_require_default._(__webpack_require__(38070));
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var byteToHex = [];
for(var i = 0; i < 256; ++i){
    byteToHex.push((i + 0x100).toString(16).substr(1));
}
function stringify(arr) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    var uuid = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + "-" + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + "-" + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + "-" + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + "-" + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, _validate.default)(uuid)) {
        throw TypeError("Stringified UUID is invalid");
    }
    return uuid;
}
var _default = stringify;


/***/ }),

/***/ 99162:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(37815);
var _rng = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67539));
var _stringify = /*#__PURE__*/ _interop_require_default._(__webpack_require__(78726));
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
var _nodeId;
var _clockseq; // Previous uuid creation time
var _lastMSecs = 0;
var _lastNSecs = 0; // See https://github.com/uuidjs/uuid for API details
function v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || new Array(16);
    options = options || {};
    var node = options.node || _nodeId;
    var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq; // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        var seedBytes = options.random || (options.rng || _rng.default)();
        if (node == null) {
            // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
            node = _nodeId = [
                seedBytes[0] | 0x01,
                seedBytes[1],
                seedBytes[2],
                seedBytes[3],
                seedBytes[4],
                seedBytes[5]
            ];
        }
        if (clockseq == null) {
            // Per 4.2.2, randomize (14 bit) clockseq
            clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
        }
    } // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : Date.now(); // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1; // Time since last uuid creation (in msecs)
    var dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 10000; // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) {
        clockseq = clockseq + 1 & 0x3fff;
    } // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
        nsecs = 0;
    } // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) {
        throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
    }
    _lastMSecs = msecs;
    _lastNSecs = nsecs;
    _clockseq = clockseq; // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000; // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff; // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff; // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff; // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80; // `clock_seq_low`
    b[i++] = clockseq & 0xff; // `node`
    for(var n = 0; n < 6; ++n){
        b[i + n] = node[n];
    }
    return buf || (0, _stringify.default)(b);
}
var _default = v1;


/***/ }),

/***/ 25089:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(42578);
var _v35 = /*#__PURE__*/ _interop_require_default._(__webpack_require__(61560));
var _md5 = /*#__PURE__*/ _interop_require_default._(__webpack_require__(20274));
var v3 = (0, _v35.default)("v3", 0x30, _md5.default);
var _default = v3;


/***/ }),

/***/ 61560:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    DNS: function() {
        return DNS;
    },
    URL: function() {
        return URL;
    },
    default: function() {
        return _default;
    }
});
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(65759);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(52318);
__webpack_require__(88801);
var _stringify = /*#__PURE__*/ _interop_require_default._(__webpack_require__(78726));
var _parse = /*#__PURE__*/ _interop_require_default._(__webpack_require__(45203));
function stringToBytes(str) {
    str = unescape(encodeURIComponent(str)); // UTF8 escape
    var bytes = [];
    for(var i = 0; i < str.length; ++i){
        bytes.push(str.charCodeAt(i));
    }
    return bytes;
}
var DNS = "6ba7b810-9dad-11d1-80b4-00c04fd430c8";
var URL = "6ba7b811-9dad-11d1-80b4-00c04fd430c8";
function _default(name, version, hashfunc) {
    function generateUUID(value, namespace, buf, offset) {
        if (typeof value === "string") {
            value = stringToBytes(value);
        }
        if (typeof namespace === "string") {
            namespace = (0, _parse.default)(namespace);
        }
        if (namespace.length !== 16) {
            throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
        } // Compute hash of namespace and value, Per 4.3
        // Future: Use spread syntax when supported on all platforms, e.g. `bytes =
        // hashfunc([...namespace, ... value])`
        var bytes = new Uint8Array(16 + value.length);
        bytes.set(namespace);
        bytes.set(value, namespace.length);
        bytes = hashfunc(bytes);
        bytes[6] = bytes[6] & 0x0f | version;
        bytes[8] = bytes[8] & 0x3f | 0x80;
        if (buf) {
            offset = offset || 0;
            for(var i = 0; i < 16; ++i){
                buf[offset + i] = bytes[i];
            }
            return buf;
        }
        return (0, _stringify.default)(bytes);
    } // Function#name is not settable on some platforms (#270)
    try {
        generateUUID.name = name; // eslint-disable-next-line no-empty
    } catch (err) {} // For CommonJS default export support
    generateUUID.DNS = DNS;
    generateUUID.URL = URL;
    return generateUUID;
}


/***/ }),

/***/ 73520:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(52318);
__webpack_require__(37815);
__webpack_require__(45538);
__webpack_require__(88801);
__webpack_require__(65759);
var _rng = /*#__PURE__*/ _interop_require_default._(__webpack_require__(67539));
var _stringify = /*#__PURE__*/ _interop_require_default._(__webpack_require__(78726));
function v4(options, buf, offset) {
    options = options || {};
    var rnds = options.random || (options.rng || _rng.default)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(var i = 0; i < 16; ++i){
            buf[offset + i] = rnds[i];
        }
        return buf;
    }
    return (0, _stringify.default)(rnds);
}
var _default = v4;


/***/ }),

/***/ 34213:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(65759);
__webpack_require__(88801);
__webpack_require__(3009);
__webpack_require__(42578);
__webpack_require__(52318);
var _v35 = /*#__PURE__*/ _interop_require_default._(__webpack_require__(61560));
var _sha1 = /*#__PURE__*/ _interop_require_default._(__webpack_require__(2651));
var v5 = (0, _v35.default)("v5", 0x50, _sha1.default);
var _default = v5;


/***/ }),

/***/ 38070:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(88801);
__webpack_require__(42578);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
var _regex = /*#__PURE__*/ _interop_require_default._(__webpack_require__(84827));
function validate(uuid) {
    return typeof uuid === "string" && _regex.default.test(uuid);
}
var _default = validate;


/***/ }),

/***/ 45933:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _interop_require_default = __webpack_require__(81200);
__webpack_require__(65759);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(37815);
__webpack_require__(52318);
__webpack_require__(42578);
__webpack_require__(45538);
var _validate = /*#__PURE__*/ _interop_require_default._(__webpack_require__(38070));
function version(uuid) {
    if (!(0, _validate.default)(uuid)) {
        throw TypeError("Invalid UUID");
    }
    return parseInt(uuid.substr(14, 1), 16);
}
var _default = version;


/***/ }),

/***/ 61268:
/***/ ((module, exports, __webpack_require__) => {

"use strict";
/* global shaka */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__webpack_require__(42578);
__webpack_require__(3009);
__webpack_require__(88801);
__webpack_require__(65759);
__webpack_require__(45538);
__webpack_require__(37815);
__webpack_require__(52318);
var youbora = __webpack_require__(46847);
var manifest = __webpack_require__(96808);
youbora.adapters.Shaka = youbora.Adapter.extend({
    constructor: function constructor(player, tag) {
        youbora.adapters.Shaka.__super__.constructor.call(this, player);
        this.tag = tag ? tag : null;
    },
    /** Override to return current plugin version */ getVersion: function getVersion() {
        return manifest.version + "-" + manifest.name + "-" + manifest.tech;
    },
    /** Override to return current playhead of the video */ getPlayhead: function getPlayhead() {
        var tag = this.tag || this._getTagFromPlayer();
        return tag ? tag.currentTime : null;
    },
    /** Override to return current playrate */ getPlayrate: function getPlayrate() {
        if (typeof this.player.getPlaybackRate === "function") {
            return this.player.getPlaybackRate() || 1;
        }
        return 1;
    },
    /** Override to return Frames Per Secon (FPS) */ getFramesPerSecond: function getFramesPerSecond() {
        var track = this._getActiveTrack();
        return track ? track.frameRate : null;
    },
    /** Override to return dropped frames since start */ getDroppedFrames: function getDroppedFrames() {
        return this.player.getStats().droppedFrames;
    },
    /** Override to return the live latency */ getLatency: function getLatency() {
        // Only for shaka 3.0+
        var latency = this.player.getStats().liveLatency;
        return latency ? latency * 1000 : undefined;
    },
    /** Override to return video duration */ getDuration: function getDuration() {
        var tag = this.tag || this._getTagFromPlayer();
        return tag ? tag.duration : null;
    },
    /** Override to return current bitrate */ getBitrate: function getBitrate() {
        var stats = this.player.getStats();
        var ret = null;
        if (typeof stats.streamBandwidth !== "undefined") {
            ret = stats.streamBandwidth;
        }
        if (typeof stats.streamStats !== "undefined") {
            ret = stats.streamStats.videoBandwidth;
        }
        return ret;
    },
    /** Override to return rendition */ getRendition: function getRendition() {
        var track = this._getActiveTrack();
        return track ? youbora.Util.buildRenditionString(track.width, track.height, track.bandwidth) : null;
    },
    /** Override to return user bandwidth throughput */ getThroughput: function getThroughput() {
        return this.player.getStats().estimatedBandwidth;
    },
    /** Override to return title */ getTitle: function getTitle() {
        var tag = this.tag || this._getTagFromPlayer();
        return tag ? tag.title : null;
    },
    /** Override to recurn true if live and false if VOD */ getIsLive: function getIsLive() {
        return this.player.isLive() ? true : !this.getDuration();
    },
    /** Override to return resource URL. */ getResource: function getResource() {
        var tag = this.tag || this._getTagFromPlayer();
        var ret = tag ? tag.currentSrc : null;
        if (this.player.getAssetUri && this.player.getAssetUri()) {
            ret = this.player.getAssetUri();
        } else if (this.player.getManifestUri && this.player.getManifestUri()) {
            ret = this.player.getManifestUri();
        }
        return ret;
    },
    /** Override to return player version */ getPlayerVersion: function getPlayerVersion() {
        var ret = null;
        if (typeof shaka !== "undefined") {
            if (shaka.Player) {
                ret = shaka.Player.version;
            }
            if (shaka.player) {
                ret = shaka.player.Player.version;
            }
        }
        return ret;
    },
    /** Override to return player's name */ getPlayerName: function getPlayerName() {
        return "Shaka";
    },
    /** Get the active track, to get playrate, rendition... */ _getActiveTrack: function _getActiveTrack() {
        var ret = null;
        if (this.player.getVariantTracks) {
            var tracks = this.player.getVariantTracks();
            for(var i in tracks){
                var track = tracks[i];
                if (track.active && (track.type === "video" || track.type === "variant")) {
                    ret = track;
                }
            }
        } else if (this.player.getVideoTracks) {
            var tracks2 = this.player.getVideoTracks();
            for(var j in tracks2){
                var track2 = tracks2[j];
                if (track2.active) {
                    ret = track2;
                }
            }
        }
        return ret;
    },
    /** Register listeners to this.player. */ registerListeners: function registerListeners() {
        // Enable playhead monitor (buffer = true, seek = false)
        this.monitorPlayhead(true, true);
        // References
        this.references = {
            play: this.playListener.bind(this),
            loadstart: this.autoplayListener.bind(this),
            pause: this.pauseListener.bind(this),
            playing: this.playingListener.bind(this),
            seeking: this.seekingListener.bind(this),
            seeked: this.seekedListener.bind(this),
            ended: this.endedListener.bind(this),
            timeupdate: this.timeupdateListener.bind(this),
            waiting: this.bufferingListener.bind(this)
        };
        this.referencesPlayer = {
            error: this.errorListener.bind(this)
        };
        // Register listeners
        this.tag = null;
        this._registerTag();
        for(var key2 in this.referencesPlayer){
            this.player.addEventListener(key2, this.referencesPlayer[key2]);
        }
    },
    _registerTag: function _registerTag() {
        this.tag = this.tag || this._getTagFromPlayer();
        if (this.tag) {
            for(var key in this.references){
                this.tag.addEventListener(key, this.references[key]);
            }
        } else {
            setTimeout(this._registerTag.bind(this), 50);
        }
    },
    _getTagFromPlayer: function _getTagFromPlayer() {
        return this.player.getMediaElement ? this.player.getMediaElement() : this.player.a;
    },
    /** Unregister listeners to this.player. */ unregisterListeners: function unregisterListeners() {
        // Disable playhead monitoring
        if (this.monitor) this.monitor.stop();
        var tag = this.tag || this._getTagFromPlayer();
        // unregister listeners
        if (tag && this.references) {
            for(var key in this.references){
                tag.removeEventListener(key, this.references[key]);
            }
            delete this.references;
        }
        if (this.player && this.referencesPlayer) {
            for(var key2 in this.referencesPlayer){
                this.player.removeEventListener(key2, this.referencesPlayer[key2]);
            }
            delete this.referencesPlayer;
        }
    },
    /** Listener for 'play' event. */ playListener: function playListener(e) {
        this._callStart();
    },
    /** Listener for 'play' event. */ autoplayListener: function autoplayListener(e) {
        var tag = this.tag || this._getTagFromPlayer();
        if (tag && tag.autoplay) {
            this._callStart();
        }
    },
    /** Listener for 'pause' event. */ pauseListener: function pauseListener(e) {
        this.firePause();
    },
    /** Listener for 'playing' event. */ playingListener: function playingListener(e) {
        this.fireResume();
        this._callStart();
        this.fireJoin();
        if (this.flags.isBuffering && this.monitor && typeof this.monitor.canBeUsed === "function" && !this.monitor.canBeUsed()) {
            this.fireBufferEnd();
        }
    },
    /** Listener for 'error' event. */ errorListener: function errorListener(e) {
        // Error codes: https://shaka-player-demo.appspot.com/docs/api/shaka.util.Error.html
        var code = e.detail && e.detail.code ? e.detail.code : e.code;
        var msg = e.detail && e.detail.message ? e.detail.message : "unknown";
        var category = e.detail && e.detail.category ? e.detail.category : e.category;
        var severity = e.detail && e.detail.severity ? e.detail.severity : e.severity;
        if (category && category < 10 && category > 0) {
            var typeDicc = {
                1: "network",
                2: "text",
                3: "media",
                4: "manifest",
                5: "streaming",
                6: "drm",
                7: "player",
                8: "cast",
                9: "storage"
            };
            msg = typeDicc[category] || msg;
        }
        if (severity === 2 && [
            1002,
            3016
        ].indexOf(code) === -1) {
            this.fireFatalError(code, msg) // code is not on the list and severity is 2: fatal
            ;
        } else {
            this.fireError(code, msg) // not severity 2, or in the list: nonfatal
            ;
        }
    },
    /** Listener for 'seeking' event. */ seekingListener: function seekingListener(e) {
        this.fireSeekBegin();
        if (this.plugin && this.plugin.getIsLive()) this.autoplayListener();
    },
    /** Listener for 'seeked' event. */ seekedListener: function seekedListener(e) {
        if (this.flags.isBuffering) {
            this.fireBufferEnd();
        } else if (this.flags.isSeeking) {
            this.fireSeekEnd();
        }
    },
    /** Listener for 'ended' event. */ endedListener: function endedListener(e) {
        this.fireStop();
    },
    timeupdateListener: function timeupdateListener(e) {
        if (this.getPlayhead() !== this.initialPlayhead && typeof this.initialPlayhead === "number") {
            this._callStart();
        } else {
            this.initialPlayhead = this.getPlayhead();
        }
    },
    bufferingListener: function bufferingListener(e) {
        if (this.monitor && typeof this.monitor.canBeUsed === "function" && !this.monitor.canBeUsed()) {
            this.fireBufferBegin();
        }
    },
    _callStart: function _callStart() {
        if (!this.flags.isStarted) {
            this.fireStart();
            this.initialPlayhead = this.getPlayhead();
        }
        if (this._initialPlayheadChanged()) this.fireJoin();
    },
    _initialPlayheadChanged: function _initialPlayheadChanged() {
        var ret = false;
        if (!this.flags.isJoined) {
            var current = this.getPlayhead();
            var initial = this.initialPlayhead || 0;
            var live = this.plugin ? this.plugin.getIsLive() : this.getIsLive();
            if ((initial !== 0 && live || !live) && current > initial) {
                ret = true;
            } else if (live) {
                this.initialPlayhead = current;
            }
        }
        return ret;
    }
});
module.exports = youbora.adapters.Shaka;


/***/ }),

/***/ 61603:
/***/ ((module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ es)
});

;// CONCATENATED MODULE: ./node_modules/.pnpm/symbol-observable@1.2.0/node_modules/symbol-observable/es/ponyfill.js
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/symbol-observable@1.2.0/node_modules/symbol-observable/es/index.js
/* module decorator */ module = __webpack_require__.hmd(module);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof __webpack_require__.g !== 'undefined') {
  root = __webpack_require__.g;
} else if (true) {
  root = module;
} else {}

var result = symbolObservablePonyfill(root);
/* harmony default export */ const es = (result);


/***/ }),

/***/ 18436:
/***/ ((module) => {

module.exports=/[\0-\x1F\x7F-\x9F]/

/***/ }),

/***/ 74163:
/***/ ((module) => {

module.exports=/[\xAD\u0600-\u0605\u061C\u06DD\u070F\u08E2\u180E\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u206F\uFEFF\uFFF9-\uFFFB]|\uD804[\uDCBD\uDCCD]|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|\uDB40[\uDC01\uDC20-\uDC7F]/

/***/ }),

/***/ 97942:
/***/ ((module) => {

module.exports=/[!-#%-\*,-\/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4E\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDF55-\uDF59]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3E]|\uD806[\uDC3B\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/

/***/ }),

/***/ 87613:
/***/ ((module) => {

module.exports=/[ \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/

/***/ }),

/***/ 21977:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


exports.Any = __webpack_require__(50757);
exports.Cc = __webpack_require__(18436);
exports.Cf = __webpack_require__(74163);
exports.P = __webpack_require__(97942);
exports.Z = __webpack_require__(87613);


/***/ }),

/***/ 50757:
/***/ ((module) => {

module.exports=/[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/

/***/ }),

/***/ 30403:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


/**
 * For Node.js, simply re-export the core `util.deprecate` function.
 */

module.exports = __webpack_require__(94823).deprecate;


/***/ }),

/***/ 91912:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


exports._ = exports._array_like_to_array = _array_like_to_array;
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

    return arr2;
}


/***/ }),

/***/ 35148:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


exports._ = exports._array_with_holes = _array_with_holes;
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}


/***/ }),

/***/ 65914:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _array_like_to_array = __webpack_require__(91912);

exports._ = exports._array_without_holes = _array_without_holes;
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array._(arr);
}


/***/ }),

/***/ 99561:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


exports._ = exports._assert_this_initialized = _assert_this_initialized;
function _assert_this_initialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");

    return self;
}


/***/ }),

/***/ 24146:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
exports._ = exports._async_to_generator = _async_to_generator;
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;

        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);

            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }

            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }

            _next(undefined);
        });
    };
}


/***/ }),

/***/ 67818:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


exports._ = exports._class_call_check = _class_call_check;
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


/***/ }),

/***/ 1741:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _is_native_reflect_construct = __webpack_require__(38684);
var _set_prototype_of = __webpack_require__(94912);
exports._ = exports._construct = _construct;
function _construct(Parent, args, Class) {
    if (_is_native_reflect_construct._()) exports._ = exports._construct = _construct = Reflect.construct;
    else {
        exports._ = exports._construct = _construct = function construct(Parent, args, Class) {
            var a = [null];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();

            if (Class) _set_prototype_of._(instance, Class.prototype);

            return instance;
        };
    }

    return _construct.apply(null, arguments);
}


/***/ }),

/***/ 851:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;

        if ("value" in descriptor) descriptor.writable = true;

        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
exports._ = exports._create_class = _create_class;
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);

    return Constructor;
}


/***/ }),

/***/ 6400:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _get_prototype_of = __webpack_require__(35196);
var _is_native_reflect_construct = __webpack_require__(38684);
var _possible_constructor_return = __webpack_require__(80745);

exports._ = exports._create_super = _create_super;
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct._();

    return function _createSuperInternal() {
        var Super = _get_prototype_of._(Derived), result;

        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of._(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }

        return _possible_constructor_return._(this, result);
    };
}


/***/ }),

/***/ 21228:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


exports._ = exports._define_property = _define_property;
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
    } else obj[key] = value;

    return obj;
}


/***/ }),

/***/ 37668:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


exports._ = exports._export_star = _export_star;
function _export_star(from, to) {
    Object.keys(from).forEach(function(k) {
        if (k !== "default" && !Object.prototype.hasOwnProperty.call(to, k)) {
            Object.defineProperty(to, k, {
                enumerable: true,
                get: function() {
                    return from[k];
                }
            });
        }
    });

    return from;
}


/***/ }),

/***/ 60528:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _super_prop_base = __webpack_require__(21787);

exports._ = exports._get = _get;
function _get(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) exports._ = exports._get = _get = Reflect.get;
    else {
        exports._ = exports._get = _get = function get(target, property, receiver) {
            var base = _super_prop_base._(target, property);

            if (!base) return;

            var desc = Object.getOwnPropertyDescriptor(base, property);

            if (desc.get) return desc.get.call(receiver || target);

            return desc.value;
        };
    }

    return _get(target, property, receiver || target);
}


/***/ }),

/***/ 35196:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


exports._ = exports._get_prototype_of = _get_prototype_of;
function _get_prototype_of(o) {
    exports._ = exports._get_prototype_of = _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };

    return _get_prototype_of(o);
}


/***/ }),

/***/ 71648:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _set_prototype_of = __webpack_require__(94912);

exports._ = exports._inherits = _inherits;
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });

    if (superClass) _set_prototype_of._(subClass, superClass);
}


/***/ }),

/***/ 81200:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


exports._ = exports._interop_require_default = _interop_require_default;
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}


/***/ }),

/***/ 95316:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;

    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();

    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
exports._ = exports._interop_require_wildcard = _interop_require_wildcard;
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return { default: obj };

    var cache = _getRequireWildcardCache(nodeInterop);

    if (cache && cache.has(obj)) return cache.get(obj);

    var newObj = { __proto__: null };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
            else newObj[key] = obj[key];
        }
    }

    newObj.default = obj;

    if (cache) cache.set(obj, newObj);

    return newObj;
}


/***/ }),

/***/ 62857:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


exports._ = exports._is_native_function = _is_native_function;
function _is_native_function(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}


/***/ }),

/***/ 38684:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


exports._ = exports._is_native_reflect_construct = _is_native_reflect_construct;
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));

        return true;
    } catch (e) {
        return false;
    }
}


/***/ }),

/***/ 50018:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


exports._ = exports._iterable_to_array = _iterable_to_array;
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) {
        return Array.from(iter);
    }
}


/***/ }),

/***/ 16557:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


exports._ = exports._iterable_to_array_limit = _iterable_to_array_limit;
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

    if (_i == null) return;

    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;

    try {
        for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally {
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally {
            if (_d) throw _e;
        }
    }

    return _arr;
}


/***/ }),

/***/ 96818:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


exports._ = exports._non_iterable_rest = _non_iterable_rest;
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


/***/ }),

/***/ 42577:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


exports._ = exports._non_iterable_spread = _non_iterable_spread;
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


/***/ }),

/***/ 76247:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _define_property = __webpack_require__(21228);

exports._ = exports._object_spread = _object_spread;
function _object_spread(target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);

        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(
                Object.getOwnPropertySymbols(source).filter(function(sym) {
                    return Object.getOwnPropertyDescriptor(source, sym).enumerable;
                })
            );
        }

        ownKeys.forEach(function(key) {
            _define_property._(target, key, source[key]);
        });
    }

    return target;
}


/***/ }),

/***/ 15184:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }

    return keys;
}
exports._ = exports._object_spread_props = _object_spread_props;
function _object_spread_props(target, source) {
    source = source != null ? source : {};

    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }

    return target;
}


/***/ }),

/***/ 46537:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _object_without_properties_loose = __webpack_require__(15245);

exports._ = exports._object_without_properties = _object_without_properties;
function _object_without_properties(source, excluded) {
    if (source == null) return {};

    var target = _object_without_properties_loose._(source, excluded);
    var key, i;

    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for (i = 0; i < sourceSymbolKeys.length; i++) {
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }

    return target;
}


/***/ }),

/***/ 15245:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


exports._ = exports._object_without_properties_loose = _object_without_properties_loose;
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};

    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }

    return target;
}


/***/ }),

/***/ 80745:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _assert_this_initialized = __webpack_require__(99561);
var _type_of = __webpack_require__(99010);

exports._ = exports._possible_constructor_return = _possible_constructor_return;
function _possible_constructor_return(self, call) {
    if (call && (_type_of._(call) === "object" || typeof call === "function")) return call;

    return _assert_this_initialized._(self);
}


/***/ }),

/***/ 81364:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _define_property = __webpack_require__(21228);
var _super_prop_base = __webpack_require__(21787);

function set(target, property, value, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.set) set = Reflect.set;
    else {
        set = function set(target, property, value, receiver) {
            var base = _super_prop_base._(target, property);
            var desc;
            if (base) {
                desc = Object.getOwnPropertyDescriptor(base, property);
                if (desc.set) {
                    desc.set.call(receiver, value);

                    return true;
                } else if (!desc.writable) {
                    return false;
                }
            }
            desc = Object.getOwnPropertyDescriptor(receiver, property);
            if (desc) {
                if (!desc.writable) return false;
                desc.value = value;
                Object.defineProperty(receiver, property, desc);
            } else {
                _define_property._(receiver, property, value);
            }

            return true;
        };
    }

    return set(target, property, value, receiver);
}

exports._ = exports._set = _set;
function _set(target, property, value, receiver, isStrict) {
    var s = set(target, property, value, receiver || target);
    if (!s && isStrict) throw new Error("failed to set property");

    return value;
}


/***/ }),

/***/ 94912:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


exports._ = exports._set_prototype_of = _set_prototype_of;
function _set_prototype_of(o, p) {
    exports._ = exports._set_prototype_of = _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;

        return o;
    };

    return _set_prototype_of(o, p);
}


/***/ }),

/***/ 28966:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _array_with_holes = __webpack_require__(35148);
var _iterable_to_array_limit = __webpack_require__(16557);
var _non_iterable_rest = __webpack_require__(96818);
var _unsupported_iterable_to_array = __webpack_require__(46657);

exports._ = exports._sliced_to_array = _sliced_to_array;
function _sliced_to_array(arr, i) {
    return _array_with_holes._(arr) || _iterable_to_array_limit._(arr, i) || _unsupported_iterable_to_array._(arr, i) || _non_iterable_rest._();
}


/***/ }),

/***/ 21787:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _get_prototype_of = __webpack_require__(35196);

exports._ = exports._super_prop_base = _super_prop_base;
function _super_prop_base(object, property) {
    while (!Object.prototype.hasOwnProperty.call(object, property)) {
        object = _get_prototype_of._(object);
        if (object === null) break;
    }

    return object;
}


/***/ }),

/***/ 30005:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _array_without_holes = __webpack_require__(65914);
var _iterable_to_array = __webpack_require__(50018);
var _non_iterable_spread = __webpack_require__(42577);
var _unsupported_iterable_to_array = __webpack_require__(46657);

exports._ = exports._to_consumable_array = _to_consumable_array;
function _to_consumable_array(arr) {
    return _array_without_holes._(arr) || _iterable_to_array._(arr) || _unsupported_iterable_to_array._(arr) || _non_iterable_spread._();
}


/***/ }),

/***/ 63365:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


exports._ = exports._ts_generator = __webpack_require__(15767).__generator;


/***/ }),

/***/ 99010:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


exports._ = exports._type_of = _type_of;
function _type_of(obj) {
    "@swc/helpers - typeof";

    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}


/***/ }),

/***/ 46657:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _array_like_to_array = __webpack_require__(91912);

exports._ = exports._unsupported_iterable_to_array = _unsupported_iterable_to_array;
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array._(o, minLen);

    var n = Object.prototype.toString.call(o).slice(8, -1);

    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array._(o, minLen);
}


/***/ }),

/***/ 69349:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _construct = __webpack_require__(1741);
var _get_prototype_of = __webpack_require__(35196);
var _is_native_function = __webpack_require__(62857);
var _set_prototype_of = __webpack_require__(94912);

exports._ = exports._wrap_native_super = _wrap_native_super;
function _wrap_native_super(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    exports._ = exports._wrap_native_super = _wrap_native_super = function(Class) {
        if (Class === null || !_is_native_function._(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }

        function Wrapper() {
            return _construct._(Class, arguments, _get_prototype_of._(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } });

        return _set_prototype_of._(Wrapper, Class);
    };

    return _wrap_native_super(Class);
}


/***/ }),

/***/ 15767:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   __generator: () => (/* binding */ __generator)
/* harmony export */ });
/* unused harmony exports __extends, __assign, __rest, __decorate, __param, __esDecorate, __runInitializers, __propKey, __setFunctionName, __metadata, __awaiter, __createBinding, __exportStar, __values, __read, __spread, __spreadArrays, __spreadArray, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __makeTemplateObject, __importStar, __importDefault, __classPrivateFieldGet, __classPrivateFieldSet, __classPrivateFieldIn, __addDisposableResource, __disposeResources, __rewriteRelativeImportExtension */
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */

var extendStatics = function(d, b) {
  extendStatics = Object.setPrototypeOf ||
      ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
      function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
  return extendStatics(d, b);
};

function __extends(d, b) {
  if (typeof b !== "function" && b !== null)
      throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  extendStatics(d, b);
  function __() { this.constructor = d; }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
  __assign = Object.assign || function __assign(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
  }
  return __assign.apply(this, arguments);
}

function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
      t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
              t[p[i]] = s[p[i]];
      }
  return t;
}

function __decorate(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
  return function (target, key) { decorator(target, key, paramIndex); }
}

function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
  function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
  var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
  var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
  var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
  var _, done = false;
  for (var i = decorators.length - 1; i >= 0; i--) {
      var context = {};
      for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
      for (var p in contextIn.access) context.access[p] = contextIn.access[p];
      context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
      var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
      if (kind === "accessor") {
          if (result === void 0) continue;
          if (result === null || typeof result !== "object") throw new TypeError("Object expected");
          if (_ = accept(result.get)) descriptor.get = _;
          if (_ = accept(result.set)) descriptor.set = _;
          if (_ = accept(result.init)) initializers.unshift(_);
      }
      else if (_ = accept(result)) {
          if (kind === "field") initializers.unshift(_);
          else descriptor[key] = _;
      }
  }
  if (target) Object.defineProperty(target, contextIn.name, descriptor);
  done = true;
};

function __runInitializers(thisArg, initializers, value) {
  var useValue = arguments.length > 2;
  for (var i = 0; i < initializers.length; i++) {
      value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
  }
  return useValue ? value : void 0;
};

function __propKey(x) {
  return typeof x === "symbol" ? x : "".concat(x);
};

function __setFunctionName(f, name, prefix) {
  if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
  return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};

function __metadata(metadataKey, metadataValue) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
  return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
      function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
      function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function __generator(thisArg, body) {
  var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
  return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
  function verb(n) { return function (v) { return step([n, v]); }; }
  function step(op) {
      if (f) throw new TypeError("Generator is already executing.");
      while (g && (g = 0, op[0] && (_ = 0)), _) try {
          if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
          if (y = 0, t) op = [op[0] & 2, t.value];
          switch (op[0]) {
              case 0: case 1: t = op; break;
              case 4: _.label++; return { value: op[1], done: false };
              case 5: _.label++; y = op[1]; op = [0]; continue;
              case 7: op = _.ops.pop(); _.trys.pop(); continue;
              default:
                  if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                  if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                  if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                  if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                  if (t[2]) _.ops.pop();
                  _.trys.pop(); continue;
          }
          op = body.call(thisArg, _);
      } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
      if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
  }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
  }
  Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

function __exportStar(m, o) {
  for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
      next: function () {
          if (o && i >= o.length) o = void 0;
          return { value: o && o[i++], done: !o };
      }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
      while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  }
  catch (error) { e = { error: error }; }
  finally {
      try {
          if (r && !r.done && (m = i["return"])) m.call(i);
      }
      finally { if (e) throw e.error; }
  }
  return ar;
}

/** @deprecated */
function __spread() {
  for (var ar = [], i = 0; i < arguments.length; i++)
      ar = ar.concat(__read(arguments[i]));
  return ar;
}

/** @deprecated */
function __spreadArrays() {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++)
      for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
          r[k] = a[j];
  return r;
}

function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
      if (ar || !(i in from)) {
          if (!ar) ar = Array.prototype.slice.call(from, 0, i);
          ar[i] = from[i];
      }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
  return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var g = generator.apply(thisArg, _arguments || []), i, q = [];
  return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function () { return this; }, i;
  function awaitReturn(f) { return function (v) { return Promise.resolve(v).then(f, reject); }; }
  function verb(n, f) { if (g[n]) { i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; if (f) i[n] = f(i[n]); } }
  function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
  function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
  function fulfill(value) { resume("next", value); }
  function reject(value) { resume("throw", value); }
  function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
  var i, p;
  return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
  function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: false } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var m = o[Symbol.asyncIterator], i;
  return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
  function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
  function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
  if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
  return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
  Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
  o["default"] = v;
};

var ownKeys = function(o) {
  ownKeys = Object.getOwnPropertyNames || function (o) {
    var ar = [];
    for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
    return ar;
  };
  return ownKeys(o);
};

function __importStar(mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
  __setModuleDefault(result, mod);
  return result;
}

function __importDefault(mod) {
  return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
  if (kind === "m") throw new TypeError("Private method is not writable");
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
  if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
  return typeof state === "function" ? receiver === state : state.has(receiver);
}

function __addDisposableResource(env, value, async) {
  if (value !== null && value !== void 0) {
    if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
    var dispose, inner;
    if (async) {
      if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
      dispose = value[Symbol.asyncDispose];
    }
    if (dispose === void 0) {
      if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
      dispose = value[Symbol.dispose];
      if (async) inner = dispose;
    }
    if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
    if (inner) dispose = function() { try { inner.call(this); } catch (e) { return Promise.reject(e); } };
    env.stack.push({ value: value, dispose: dispose, async: async });
  }
  else if (async) {
    env.stack.push({ async: true });
  }
  return value;
}

var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function __disposeResources(env) {
  function fail(e) {
    env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
    env.hasError = true;
  }
  var r, s = 0;
  function next() {
    while (r = env.stack.pop()) {
      try {
        if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
        if (r.dispose) {
          var result = r.dispose.call(r.value);
          if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) { fail(e); return next(); });
        }
        else s |= 1;
      }
      catch (e) {
        fail(e);
      }
    }
    if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
    if (env.hasError) throw env.error;
  }
  return next();
}

function __rewriteRelativeImportExtension(path, preserveJsx) {
  if (typeof path === "string" && /^\.\.?\//.test(path)) {
      return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function (m, tsx, d, ext, cm) {
          return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : (d + ext + "." + cm.toLowerCase() + "js");
      });
  }
  return path;
}

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
  __extends,
  __assign,
  __rest,
  __decorate,
  __param,
  __esDecorate,
  __runInitializers,
  __propKey,
  __setFunctionName,
  __metadata,
  __awaiter,
  __generator,
  __createBinding,
  __exportStar,
  __values,
  __read,
  __spread,
  __spreadArrays,
  __spreadArray,
  __await,
  __asyncGenerator,
  __asyncDelegator,
  __asyncValues,
  __makeTemplateObject,
  __importStar,
  __importDefault,
  __classPrivateFieldGet,
  __classPrivateFieldSet,
  __classPrivateFieldIn,
  __addDisposableResource,
  __disposeResources,
  __rewriteRelativeImportExtension,
});


/***/ }),

/***/ 13700:
/***/ ((module) => {

"use strict";
module.exports = JSON.parse('{"name":"@bedrock/ad-engine","version":"5.39.0","description":"Utils to simplify working with advertising formats","license":"m6web","main":"./lib/index.js","files":["lib","dist"],"sideEffects":false,"peerDependencies":{"@bedrock/html5-engine":">=3.6.0","@bedrock/media-engine":">=4.4.0"},"dependencies":{"@bedrock-player/types":"^0.25.0","date-fns":"2.28.0","lodash":"4.17.21","sax":"1.2.4","superagent":"8.0.9"},"devDependencies":{"@bedrock-player/config":"^0.0.2","@bedrock/html5-engine":"^3.7.2","@bedrock/media-engine":"^4.20.1","@types/lodash":"4.14.186","jest":"29.3.1","stream-browserify":"3.0.0","ts-loader":"9.5.0","webpack":"5.88.2","webpack-cli":"5.1.4"},"repository":{"type":"git","url":"git@github.m6web.fr:m6web/bedrock-player.git"},"scripts":{"lint":"eslint \'./**/*.js\'","test":"jest","test:ci":"jest --maxWorkers=2 --ci","build":"pnpm build:dist && rm -rf lib && tsc -p .","build:dist":"webpack --mode=production --config webpack.config.js","change-main":"node ../../scripts/changeMain.js"},"gitHead":"6242b4b4549fe14159a704a3552546d964842fda","types":"./lib/index.d.ts"}');

/***/ }),

/***/ 43329:
/***/ ((module) => {

"use strict";
module.exports = JSON.parse('{"name":"@bedrock/youbora-adapter-adengine","version":"1.9.9","description":"Youbora adapter for our custom ad-engine","main":"src/index.ts","mainLib":"./lib/src/index.js","typesLib":"./lib/src/index.d.ts","license":"m6web","repository":"git@github.m6web.fr:m6web/bedrock-player.git","author":"Bedrock Streaming","sideEffects":false,"files":["lib","dist"],"scripts":{"lint":"eslint --ext ts,tsx,js,jsx --ignore-pattern \'*.d.ts\'","build":"pnpm build:dist && rm -rf lib && tsc -p .","build:dist":"webpack --mode=production --config webpack.config.js","change-main":"node ../../scripts/changeMain.js","test":"jest","test:ci":"jest --maxWorkers=2 --ci"},"peerDependencies":{"@bedrock/ad-engine":"^5.11.0","youboralib":"^6.8.0"},"dependencies":{"npaw-plugin-adapters-es5":"7.3.8"},"devDependencies":{"@bedrock-player/config":"^0.0.2","@bedrock/ad-engine":"^5.39.0","jest":"29.3.1","stream-browserify":"3.0.0","ts-loader":"9.5.0","webpack":"5.88.2","webpack-cli":"5.1.4","youboralib":"^6.8.27"},"gitHead":"6242b4b4549fe14159a704a3552546d964842fda"}');

/***/ }),

/***/ 83992:
/***/ ((module) => {

"use strict";
module.exports = JSON.parse('{"Aacute":"Á","aacute":"á","Abreve":"Ă","abreve":"ă","ac":"∾","acd":"∿","acE":"∾̳","Acirc":"Â","acirc":"â","acute":"´","Acy":"А","acy":"а","AElig":"Æ","aelig":"æ","af":"⁡","Afr":"𝔄","afr":"𝔞","Agrave":"À","agrave":"à","alefsym":"ℵ","aleph":"ℵ","Alpha":"Α","alpha":"α","Amacr":"Ā","amacr":"ā","amalg":"⨿","amp":"&","AMP":"&","andand":"⩕","And":"⩓","and":"∧","andd":"⩜","andslope":"⩘","andv":"⩚","ang":"∠","ange":"⦤","angle":"∠","angmsdaa":"⦨","angmsdab":"⦩","angmsdac":"⦪","angmsdad":"⦫","angmsdae":"⦬","angmsdaf":"⦭","angmsdag":"⦮","angmsdah":"⦯","angmsd":"∡","angrt":"∟","angrtvb":"⊾","angrtvbd":"⦝","angsph":"∢","angst":"Å","angzarr":"⍼","Aogon":"Ą","aogon":"ą","Aopf":"𝔸","aopf":"𝕒","apacir":"⩯","ap":"≈","apE":"⩰","ape":"≊","apid":"≋","apos":"\'","ApplyFunction":"⁡","approx":"≈","approxeq":"≊","Aring":"Å","aring":"å","Ascr":"𝒜","ascr":"𝒶","Assign":"≔","ast":"*","asymp":"≈","asympeq":"≍","Atilde":"Ã","atilde":"ã","Auml":"Ä","auml":"ä","awconint":"∳","awint":"⨑","backcong":"≌","backepsilon":"϶","backprime":"‵","backsim":"∽","backsimeq":"⋍","Backslash":"∖","Barv":"⫧","barvee":"⊽","barwed":"⌅","Barwed":"⌆","barwedge":"⌅","bbrk":"⎵","bbrktbrk":"⎶","bcong":"≌","Bcy":"Б","bcy":"б","bdquo":"„","becaus":"∵","because":"∵","Because":"∵","bemptyv":"⦰","bepsi":"϶","bernou":"ℬ","Bernoullis":"ℬ","Beta":"Β","beta":"β","beth":"ℶ","between":"≬","Bfr":"𝔅","bfr":"𝔟","bigcap":"⋂","bigcirc":"◯","bigcup":"⋃","bigodot":"⨀","bigoplus":"⨁","bigotimes":"⨂","bigsqcup":"⨆","bigstar":"★","bigtriangledown":"▽","bigtriangleup":"△","biguplus":"⨄","bigvee":"⋁","bigwedge":"⋀","bkarow":"⤍","blacklozenge":"⧫","blacksquare":"▪","blacktriangle":"▴","blacktriangledown":"▾","blacktriangleleft":"◂","blacktriangleright":"▸","blank":"␣","blk12":"▒","blk14":"░","blk34":"▓","block":"█","bne":"=⃥","bnequiv":"≡⃥","bNot":"⫭","bnot":"⌐","Bopf":"𝔹","bopf":"𝕓","bot":"⊥","bottom":"⊥","bowtie":"⋈","boxbox":"⧉","boxdl":"┐","boxdL":"╕","boxDl":"╖","boxDL":"╗","boxdr":"┌","boxdR":"╒","boxDr":"╓","boxDR":"╔","boxh":"─","boxH":"═","boxhd":"┬","boxHd":"╤","boxhD":"╥","boxHD":"╦","boxhu":"┴","boxHu":"╧","boxhU":"╨","boxHU":"╩","boxminus":"⊟","boxplus":"⊞","boxtimes":"⊠","boxul":"┘","boxuL":"╛","boxUl":"╜","boxUL":"╝","boxur":"└","boxuR":"╘","boxUr":"╙","boxUR":"╚","boxv":"│","boxV":"║","boxvh":"┼","boxvH":"╪","boxVh":"╫","boxVH":"╬","boxvl":"┤","boxvL":"╡","boxVl":"╢","boxVL":"╣","boxvr":"├","boxvR":"╞","boxVr":"╟","boxVR":"╠","bprime":"‵","breve":"˘","Breve":"˘","brvbar":"¦","bscr":"𝒷","Bscr":"ℬ","bsemi":"⁏","bsim":"∽","bsime":"⋍","bsolb":"⧅","bsol":"\\\\","bsolhsub":"⟈","bull":"•","bullet":"•","bump":"≎","bumpE":"⪮","bumpe":"≏","Bumpeq":"≎","bumpeq":"≏","Cacute":"Ć","cacute":"ć","capand":"⩄","capbrcup":"⩉","capcap":"⩋","cap":"∩","Cap":"⋒","capcup":"⩇","capdot":"⩀","CapitalDifferentialD":"ⅅ","caps":"∩︀","caret":"⁁","caron":"ˇ","Cayleys":"ℭ","ccaps":"⩍","Ccaron":"Č","ccaron":"č","Ccedil":"Ç","ccedil":"ç","Ccirc":"Ĉ","ccirc":"ĉ","Cconint":"∰","ccups":"⩌","ccupssm":"⩐","Cdot":"Ċ","cdot":"ċ","cedil":"¸","Cedilla":"¸","cemptyv":"⦲","cent":"¢","centerdot":"·","CenterDot":"·","cfr":"𝔠","Cfr":"ℭ","CHcy":"Ч","chcy":"ч","check":"✓","checkmark":"✓","Chi":"Χ","chi":"χ","circ":"ˆ","circeq":"≗","circlearrowleft":"↺","circlearrowright":"↻","circledast":"⊛","circledcirc":"⊚","circleddash":"⊝","CircleDot":"⊙","circledR":"®","circledS":"Ⓢ","CircleMinus":"⊖","CirclePlus":"⊕","CircleTimes":"⊗","cir":"○","cirE":"⧃","cire":"≗","cirfnint":"⨐","cirmid":"⫯","cirscir":"⧂","ClockwiseContourIntegral":"∲","CloseCurlyDoubleQuote":"”","CloseCurlyQuote":"’","clubs":"♣","clubsuit":"♣","colon":":","Colon":"∷","Colone":"⩴","colone":"≔","coloneq":"≔","comma":",","commat":"@","comp":"∁","compfn":"∘","complement":"∁","complexes":"ℂ","cong":"≅","congdot":"⩭","Congruent":"≡","conint":"∮","Conint":"∯","ContourIntegral":"∮","copf":"𝕔","Copf":"ℂ","coprod":"∐","Coproduct":"∐","copy":"©","COPY":"©","copysr":"℗","CounterClockwiseContourIntegral":"∳","crarr":"↵","cross":"✗","Cross":"⨯","Cscr":"𝒞","cscr":"𝒸","csub":"⫏","csube":"⫑","csup":"⫐","csupe":"⫒","ctdot":"⋯","cudarrl":"⤸","cudarrr":"⤵","cuepr":"⋞","cuesc":"⋟","cularr":"↶","cularrp":"⤽","cupbrcap":"⩈","cupcap":"⩆","CupCap":"≍","cup":"∪","Cup":"⋓","cupcup":"⩊","cupdot":"⊍","cupor":"⩅","cups":"∪︀","curarr":"↷","curarrm":"⤼","curlyeqprec":"⋞","curlyeqsucc":"⋟","curlyvee":"⋎","curlywedge":"⋏","curren":"¤","curvearrowleft":"↶","curvearrowright":"↷","cuvee":"⋎","cuwed":"⋏","cwconint":"∲","cwint":"∱","cylcty":"⌭","dagger":"†","Dagger":"‡","daleth":"ℸ","darr":"↓","Darr":"↡","dArr":"⇓","dash":"‐","Dashv":"⫤","dashv":"⊣","dbkarow":"⤏","dblac":"˝","Dcaron":"Ď","dcaron":"ď","Dcy":"Д","dcy":"д","ddagger":"‡","ddarr":"⇊","DD":"ⅅ","dd":"ⅆ","DDotrahd":"⤑","ddotseq":"⩷","deg":"°","Del":"∇","Delta":"Δ","delta":"δ","demptyv":"⦱","dfisht":"⥿","Dfr":"𝔇","dfr":"𝔡","dHar":"⥥","dharl":"⇃","dharr":"⇂","DiacriticalAcute":"´","DiacriticalDot":"˙","DiacriticalDoubleAcute":"˝","DiacriticalGrave":"`","DiacriticalTilde":"˜","diam":"⋄","diamond":"⋄","Diamond":"⋄","diamondsuit":"♦","diams":"♦","die":"¨","DifferentialD":"ⅆ","digamma":"ϝ","disin":"⋲","div":"÷","divide":"÷","divideontimes":"⋇","divonx":"⋇","DJcy":"Ђ","djcy":"ђ","dlcorn":"⌞","dlcrop":"⌍","dollar":"$","Dopf":"𝔻","dopf":"𝕕","Dot":"¨","dot":"˙","DotDot":"⃜","doteq":"≐","doteqdot":"≑","DotEqual":"≐","dotminus":"∸","dotplus":"∔","dotsquare":"⊡","doublebarwedge":"⌆","DoubleContourIntegral":"∯","DoubleDot":"¨","DoubleDownArrow":"⇓","DoubleLeftArrow":"⇐","DoubleLeftRightArrow":"⇔","DoubleLeftTee":"⫤","DoubleLongLeftArrow":"⟸","DoubleLongLeftRightArrow":"⟺","DoubleLongRightArrow":"⟹","DoubleRightArrow":"⇒","DoubleRightTee":"⊨","DoubleUpArrow":"⇑","DoubleUpDownArrow":"⇕","DoubleVerticalBar":"∥","DownArrowBar":"⤓","downarrow":"↓","DownArrow":"↓","Downarrow":"⇓","DownArrowUpArrow":"⇵","DownBreve":"̑","downdownarrows":"⇊","downharpoonleft":"⇃","downharpoonright":"⇂","DownLeftRightVector":"⥐","DownLeftTeeVector":"⥞","DownLeftVectorBar":"⥖","DownLeftVector":"↽","DownRightTeeVector":"⥟","DownRightVectorBar":"⥗","DownRightVector":"⇁","DownTeeArrow":"↧","DownTee":"⊤","drbkarow":"⤐","drcorn":"⌟","drcrop":"⌌","Dscr":"𝒟","dscr":"𝒹","DScy":"Ѕ","dscy":"ѕ","dsol":"⧶","Dstrok":"Đ","dstrok":"đ","dtdot":"⋱","dtri":"▿","dtrif":"▾","duarr":"⇵","duhar":"⥯","dwangle":"⦦","DZcy":"Џ","dzcy":"џ","dzigrarr":"⟿","Eacute":"É","eacute":"é","easter":"⩮","Ecaron":"Ě","ecaron":"ě","Ecirc":"Ê","ecirc":"ê","ecir":"≖","ecolon":"≕","Ecy":"Э","ecy":"э","eDDot":"⩷","Edot":"Ė","edot":"ė","eDot":"≑","ee":"ⅇ","efDot":"≒","Efr":"𝔈","efr":"𝔢","eg":"⪚","Egrave":"È","egrave":"è","egs":"⪖","egsdot":"⪘","el":"⪙","Element":"∈","elinters":"⏧","ell":"ℓ","els":"⪕","elsdot":"⪗","Emacr":"Ē","emacr":"ē","empty":"∅","emptyset":"∅","EmptySmallSquare":"◻","emptyv":"∅","EmptyVerySmallSquare":"▫","emsp13":" ","emsp14":" ","emsp":" ","ENG":"Ŋ","eng":"ŋ","ensp":" ","Eogon":"Ę","eogon":"ę","Eopf":"𝔼","eopf":"𝕖","epar":"⋕","eparsl":"⧣","eplus":"⩱","epsi":"ε","Epsilon":"Ε","epsilon":"ε","epsiv":"ϵ","eqcirc":"≖","eqcolon":"≕","eqsim":"≂","eqslantgtr":"⪖","eqslantless":"⪕","Equal":"⩵","equals":"=","EqualTilde":"≂","equest":"≟","Equilibrium":"⇌","equiv":"≡","equivDD":"⩸","eqvparsl":"⧥","erarr":"⥱","erDot":"≓","escr":"ℯ","Escr":"ℰ","esdot":"≐","Esim":"⩳","esim":"≂","Eta":"Η","eta":"η","ETH":"Ð","eth":"ð","Euml":"Ë","euml":"ë","euro":"€","excl":"!","exist":"∃","Exists":"∃","expectation":"ℰ","exponentiale":"ⅇ","ExponentialE":"ⅇ","fallingdotseq":"≒","Fcy":"Ф","fcy":"ф","female":"♀","ffilig":"ﬃ","fflig":"ﬀ","ffllig":"ﬄ","Ffr":"𝔉","ffr":"𝔣","filig":"ﬁ","FilledSmallSquare":"◼","FilledVerySmallSquare":"▪","fjlig":"fj","flat":"♭","fllig":"ﬂ","fltns":"▱","fnof":"ƒ","Fopf":"𝔽","fopf":"𝕗","forall":"∀","ForAll":"∀","fork":"⋔","forkv":"⫙","Fouriertrf":"ℱ","fpartint":"⨍","frac12":"½","frac13":"⅓","frac14":"¼","frac15":"⅕","frac16":"⅙","frac18":"⅛","frac23":"⅔","frac25":"⅖","frac34":"¾","frac35":"⅗","frac38":"⅜","frac45":"⅘","frac56":"⅚","frac58":"⅝","frac78":"⅞","frasl":"⁄","frown":"⌢","fscr":"𝒻","Fscr":"ℱ","gacute":"ǵ","Gamma":"Γ","gamma":"γ","Gammad":"Ϝ","gammad":"ϝ","gap":"⪆","Gbreve":"Ğ","gbreve":"ğ","Gcedil":"Ģ","Gcirc":"Ĝ","gcirc":"ĝ","Gcy":"Г","gcy":"г","Gdot":"Ġ","gdot":"ġ","ge":"≥","gE":"≧","gEl":"⪌","gel":"⋛","geq":"≥","geqq":"≧","geqslant":"⩾","gescc":"⪩","ges":"⩾","gesdot":"⪀","gesdoto":"⪂","gesdotol":"⪄","gesl":"⋛︀","gesles":"⪔","Gfr":"𝔊","gfr":"𝔤","gg":"≫","Gg":"⋙","ggg":"⋙","gimel":"ℷ","GJcy":"Ѓ","gjcy":"ѓ","gla":"⪥","gl":"≷","glE":"⪒","glj":"⪤","gnap":"⪊","gnapprox":"⪊","gne":"⪈","gnE":"≩","gneq":"⪈","gneqq":"≩","gnsim":"⋧","Gopf":"𝔾","gopf":"𝕘","grave":"`","GreaterEqual":"≥","GreaterEqualLess":"⋛","GreaterFullEqual":"≧","GreaterGreater":"⪢","GreaterLess":"≷","GreaterSlantEqual":"⩾","GreaterTilde":"≳","Gscr":"𝒢","gscr":"ℊ","gsim":"≳","gsime":"⪎","gsiml":"⪐","gtcc":"⪧","gtcir":"⩺","gt":">","GT":">","Gt":"≫","gtdot":"⋗","gtlPar":"⦕","gtquest":"⩼","gtrapprox":"⪆","gtrarr":"⥸","gtrdot":"⋗","gtreqless":"⋛","gtreqqless":"⪌","gtrless":"≷","gtrsim":"≳","gvertneqq":"≩︀","gvnE":"≩︀","Hacek":"ˇ","hairsp":" ","half":"½","hamilt":"ℋ","HARDcy":"Ъ","hardcy":"ъ","harrcir":"⥈","harr":"↔","hArr":"⇔","harrw":"↭","Hat":"^","hbar":"ℏ","Hcirc":"Ĥ","hcirc":"ĥ","hearts":"♥","heartsuit":"♥","hellip":"…","hercon":"⊹","hfr":"𝔥","Hfr":"ℌ","HilbertSpace":"ℋ","hksearow":"⤥","hkswarow":"⤦","hoarr":"⇿","homtht":"∻","hookleftarrow":"↩","hookrightarrow":"↪","hopf":"𝕙","Hopf":"ℍ","horbar":"―","HorizontalLine":"─","hscr":"𝒽","Hscr":"ℋ","hslash":"ℏ","Hstrok":"Ħ","hstrok":"ħ","HumpDownHump":"≎","HumpEqual":"≏","hybull":"⁃","hyphen":"‐","Iacute":"Í","iacute":"í","ic":"⁣","Icirc":"Î","icirc":"î","Icy":"И","icy":"и","Idot":"İ","IEcy":"Е","iecy":"е","iexcl":"¡","iff":"⇔","ifr":"𝔦","Ifr":"ℑ","Igrave":"Ì","igrave":"ì","ii":"ⅈ","iiiint":"⨌","iiint":"∭","iinfin":"⧜","iiota":"℩","IJlig":"Ĳ","ijlig":"ĳ","Imacr":"Ī","imacr":"ī","image":"ℑ","ImaginaryI":"ⅈ","imagline":"ℐ","imagpart":"ℑ","imath":"ı","Im":"ℑ","imof":"⊷","imped":"Ƶ","Implies":"⇒","incare":"℅","in":"∈","infin":"∞","infintie":"⧝","inodot":"ı","intcal":"⊺","int":"∫","Int":"∬","integers":"ℤ","Integral":"∫","intercal":"⊺","Intersection":"⋂","intlarhk":"⨗","intprod":"⨼","InvisibleComma":"⁣","InvisibleTimes":"⁢","IOcy":"Ё","iocy":"ё","Iogon":"Į","iogon":"į","Iopf":"𝕀","iopf":"𝕚","Iota":"Ι","iota":"ι","iprod":"⨼","iquest":"¿","iscr":"𝒾","Iscr":"ℐ","isin":"∈","isindot":"⋵","isinE":"⋹","isins":"⋴","isinsv":"⋳","isinv":"∈","it":"⁢","Itilde":"Ĩ","itilde":"ĩ","Iukcy":"І","iukcy":"і","Iuml":"Ï","iuml":"ï","Jcirc":"Ĵ","jcirc":"ĵ","Jcy":"Й","jcy":"й","Jfr":"𝔍","jfr":"𝔧","jmath":"ȷ","Jopf":"𝕁","jopf":"𝕛","Jscr":"𝒥","jscr":"𝒿","Jsercy":"Ј","jsercy":"ј","Jukcy":"Є","jukcy":"є","Kappa":"Κ","kappa":"κ","kappav":"ϰ","Kcedil":"Ķ","kcedil":"ķ","Kcy":"К","kcy":"к","Kfr":"𝔎","kfr":"𝔨","kgreen":"ĸ","KHcy":"Х","khcy":"х","KJcy":"Ќ","kjcy":"ќ","Kopf":"𝕂","kopf":"𝕜","Kscr":"𝒦","kscr":"𝓀","lAarr":"⇚","Lacute":"Ĺ","lacute":"ĺ","laemptyv":"⦴","lagran":"ℒ","Lambda":"Λ","lambda":"λ","lang":"⟨","Lang":"⟪","langd":"⦑","langle":"⟨","lap":"⪅","Laplacetrf":"ℒ","laquo":"«","larrb":"⇤","larrbfs":"⤟","larr":"←","Larr":"↞","lArr":"⇐","larrfs":"⤝","larrhk":"↩","larrlp":"↫","larrpl":"⤹","larrsim":"⥳","larrtl":"↢","latail":"⤙","lAtail":"⤛","lat":"⪫","late":"⪭","lates":"⪭︀","lbarr":"⤌","lBarr":"⤎","lbbrk":"❲","lbrace":"{","lbrack":"[","lbrke":"⦋","lbrksld":"⦏","lbrkslu":"⦍","Lcaron":"Ľ","lcaron":"ľ","Lcedil":"Ļ","lcedil":"ļ","lceil":"⌈","lcub":"{","Lcy":"Л","lcy":"л","ldca":"⤶","ldquo":"“","ldquor":"„","ldrdhar":"⥧","ldrushar":"⥋","ldsh":"↲","le":"≤","lE":"≦","LeftAngleBracket":"⟨","LeftArrowBar":"⇤","leftarrow":"←","LeftArrow":"←","Leftarrow":"⇐","LeftArrowRightArrow":"⇆","leftarrowtail":"↢","LeftCeiling":"⌈","LeftDoubleBracket":"⟦","LeftDownTeeVector":"⥡","LeftDownVectorBar":"⥙","LeftDownVector":"⇃","LeftFloor":"⌊","leftharpoondown":"↽","leftharpoonup":"↼","leftleftarrows":"⇇","leftrightarrow":"↔","LeftRightArrow":"↔","Leftrightarrow":"⇔","leftrightarrows":"⇆","leftrightharpoons":"⇋","leftrightsquigarrow":"↭","LeftRightVector":"⥎","LeftTeeArrow":"↤","LeftTee":"⊣","LeftTeeVector":"⥚","leftthreetimes":"⋋","LeftTriangleBar":"⧏","LeftTriangle":"⊲","LeftTriangleEqual":"⊴","LeftUpDownVector":"⥑","LeftUpTeeVector":"⥠","LeftUpVectorBar":"⥘","LeftUpVector":"↿","LeftVectorBar":"⥒","LeftVector":"↼","lEg":"⪋","leg":"⋚","leq":"≤","leqq":"≦","leqslant":"⩽","lescc":"⪨","les":"⩽","lesdot":"⩿","lesdoto":"⪁","lesdotor":"⪃","lesg":"⋚︀","lesges":"⪓","lessapprox":"⪅","lessdot":"⋖","lesseqgtr":"⋚","lesseqqgtr":"⪋","LessEqualGreater":"⋚","LessFullEqual":"≦","LessGreater":"≶","lessgtr":"≶","LessLess":"⪡","lesssim":"≲","LessSlantEqual":"⩽","LessTilde":"≲","lfisht":"⥼","lfloor":"⌊","Lfr":"𝔏","lfr":"𝔩","lg":"≶","lgE":"⪑","lHar":"⥢","lhard":"↽","lharu":"↼","lharul":"⥪","lhblk":"▄","LJcy":"Љ","ljcy":"љ","llarr":"⇇","ll":"≪","Ll":"⋘","llcorner":"⌞","Lleftarrow":"⇚","llhard":"⥫","lltri":"◺","Lmidot":"Ŀ","lmidot":"ŀ","lmoustache":"⎰","lmoust":"⎰","lnap":"⪉","lnapprox":"⪉","lne":"⪇","lnE":"≨","lneq":"⪇","lneqq":"≨","lnsim":"⋦","loang":"⟬","loarr":"⇽","lobrk":"⟦","longleftarrow":"⟵","LongLeftArrow":"⟵","Longleftarrow":"⟸","longleftrightarrow":"⟷","LongLeftRightArrow":"⟷","Longleftrightarrow":"⟺","longmapsto":"⟼","longrightarrow":"⟶","LongRightArrow":"⟶","Longrightarrow":"⟹","looparrowleft":"↫","looparrowright":"↬","lopar":"⦅","Lopf":"𝕃","lopf":"𝕝","loplus":"⨭","lotimes":"⨴","lowast":"∗","lowbar":"_","LowerLeftArrow":"↙","LowerRightArrow":"↘","loz":"◊","lozenge":"◊","lozf":"⧫","lpar":"(","lparlt":"⦓","lrarr":"⇆","lrcorner":"⌟","lrhar":"⇋","lrhard":"⥭","lrm":"‎","lrtri":"⊿","lsaquo":"‹","lscr":"𝓁","Lscr":"ℒ","lsh":"↰","Lsh":"↰","lsim":"≲","lsime":"⪍","lsimg":"⪏","lsqb":"[","lsquo":"‘","lsquor":"‚","Lstrok":"Ł","lstrok":"ł","ltcc":"⪦","ltcir":"⩹","lt":"<","LT":"<","Lt":"≪","ltdot":"⋖","lthree":"⋋","ltimes":"⋉","ltlarr":"⥶","ltquest":"⩻","ltri":"◃","ltrie":"⊴","ltrif":"◂","ltrPar":"⦖","lurdshar":"⥊","luruhar":"⥦","lvertneqq":"≨︀","lvnE":"≨︀","macr":"¯","male":"♂","malt":"✠","maltese":"✠","Map":"⤅","map":"↦","mapsto":"↦","mapstodown":"↧","mapstoleft":"↤","mapstoup":"↥","marker":"▮","mcomma":"⨩","Mcy":"М","mcy":"м","mdash":"—","mDDot":"∺","measuredangle":"∡","MediumSpace":" ","Mellintrf":"ℳ","Mfr":"𝔐","mfr":"𝔪","mho":"℧","micro":"µ","midast":"*","midcir":"⫰","mid":"∣","middot":"·","minusb":"⊟","minus":"−","minusd":"∸","minusdu":"⨪","MinusPlus":"∓","mlcp":"⫛","mldr":"…","mnplus":"∓","models":"⊧","Mopf":"𝕄","mopf":"𝕞","mp":"∓","mscr":"𝓂","Mscr":"ℳ","mstpos":"∾","Mu":"Μ","mu":"μ","multimap":"⊸","mumap":"⊸","nabla":"∇","Nacute":"Ń","nacute":"ń","nang":"∠⃒","nap":"≉","napE":"⩰̸","napid":"≋̸","napos":"ŉ","napprox":"≉","natural":"♮","naturals":"ℕ","natur":"♮","nbsp":" ","nbump":"≎̸","nbumpe":"≏̸","ncap":"⩃","Ncaron":"Ň","ncaron":"ň","Ncedil":"Ņ","ncedil":"ņ","ncong":"≇","ncongdot":"⩭̸","ncup":"⩂","Ncy":"Н","ncy":"н","ndash":"–","nearhk":"⤤","nearr":"↗","neArr":"⇗","nearrow":"↗","ne":"≠","nedot":"≐̸","NegativeMediumSpace":"​","NegativeThickSpace":"​","NegativeThinSpace":"​","NegativeVeryThinSpace":"​","nequiv":"≢","nesear":"⤨","nesim":"≂̸","NestedGreaterGreater":"≫","NestedLessLess":"≪","NewLine":"\\n","nexist":"∄","nexists":"∄","Nfr":"𝔑","nfr":"𝔫","ngE":"≧̸","nge":"≱","ngeq":"≱","ngeqq":"≧̸","ngeqslant":"⩾̸","nges":"⩾̸","nGg":"⋙̸","ngsim":"≵","nGt":"≫⃒","ngt":"≯","ngtr":"≯","nGtv":"≫̸","nharr":"↮","nhArr":"⇎","nhpar":"⫲","ni":"∋","nis":"⋼","nisd":"⋺","niv":"∋","NJcy":"Њ","njcy":"њ","nlarr":"↚","nlArr":"⇍","nldr":"‥","nlE":"≦̸","nle":"≰","nleftarrow":"↚","nLeftarrow":"⇍","nleftrightarrow":"↮","nLeftrightarrow":"⇎","nleq":"≰","nleqq":"≦̸","nleqslant":"⩽̸","nles":"⩽̸","nless":"≮","nLl":"⋘̸","nlsim":"≴","nLt":"≪⃒","nlt":"≮","nltri":"⋪","nltrie":"⋬","nLtv":"≪̸","nmid":"∤","NoBreak":"⁠","NonBreakingSpace":" ","nopf":"𝕟","Nopf":"ℕ","Not":"⫬","not":"¬","NotCongruent":"≢","NotCupCap":"≭","NotDoubleVerticalBar":"∦","NotElement":"∉","NotEqual":"≠","NotEqualTilde":"≂̸","NotExists":"∄","NotGreater":"≯","NotGreaterEqual":"≱","NotGreaterFullEqual":"≧̸","NotGreaterGreater":"≫̸","NotGreaterLess":"≹","NotGreaterSlantEqual":"⩾̸","NotGreaterTilde":"≵","NotHumpDownHump":"≎̸","NotHumpEqual":"≏̸","notin":"∉","notindot":"⋵̸","notinE":"⋹̸","notinva":"∉","notinvb":"⋷","notinvc":"⋶","NotLeftTriangleBar":"⧏̸","NotLeftTriangle":"⋪","NotLeftTriangleEqual":"⋬","NotLess":"≮","NotLessEqual":"≰","NotLessGreater":"≸","NotLessLess":"≪̸","NotLessSlantEqual":"⩽̸","NotLessTilde":"≴","NotNestedGreaterGreater":"⪢̸","NotNestedLessLess":"⪡̸","notni":"∌","notniva":"∌","notnivb":"⋾","notnivc":"⋽","NotPrecedes":"⊀","NotPrecedesEqual":"⪯̸","NotPrecedesSlantEqual":"⋠","NotReverseElement":"∌","NotRightTriangleBar":"⧐̸","NotRightTriangle":"⋫","NotRightTriangleEqual":"⋭","NotSquareSubset":"⊏̸","NotSquareSubsetEqual":"⋢","NotSquareSuperset":"⊐̸","NotSquareSupersetEqual":"⋣","NotSubset":"⊂⃒","NotSubsetEqual":"⊈","NotSucceeds":"⊁","NotSucceedsEqual":"⪰̸","NotSucceedsSlantEqual":"⋡","NotSucceedsTilde":"≿̸","NotSuperset":"⊃⃒","NotSupersetEqual":"⊉","NotTilde":"≁","NotTildeEqual":"≄","NotTildeFullEqual":"≇","NotTildeTilde":"≉","NotVerticalBar":"∤","nparallel":"∦","npar":"∦","nparsl":"⫽⃥","npart":"∂̸","npolint":"⨔","npr":"⊀","nprcue":"⋠","nprec":"⊀","npreceq":"⪯̸","npre":"⪯̸","nrarrc":"⤳̸","nrarr":"↛","nrArr":"⇏","nrarrw":"↝̸","nrightarrow":"↛","nRightarrow":"⇏","nrtri":"⋫","nrtrie":"⋭","nsc":"⊁","nsccue":"⋡","nsce":"⪰̸","Nscr":"𝒩","nscr":"𝓃","nshortmid":"∤","nshortparallel":"∦","nsim":"≁","nsime":"≄","nsimeq":"≄","nsmid":"∤","nspar":"∦","nsqsube":"⋢","nsqsupe":"⋣","nsub":"⊄","nsubE":"⫅̸","nsube":"⊈","nsubset":"⊂⃒","nsubseteq":"⊈","nsubseteqq":"⫅̸","nsucc":"⊁","nsucceq":"⪰̸","nsup":"⊅","nsupE":"⫆̸","nsupe":"⊉","nsupset":"⊃⃒","nsupseteq":"⊉","nsupseteqq":"⫆̸","ntgl":"≹","Ntilde":"Ñ","ntilde":"ñ","ntlg":"≸","ntriangleleft":"⋪","ntrianglelefteq":"⋬","ntriangleright":"⋫","ntrianglerighteq":"⋭","Nu":"Ν","nu":"ν","num":"#","numero":"№","numsp":" ","nvap":"≍⃒","nvdash":"⊬","nvDash":"⊭","nVdash":"⊮","nVDash":"⊯","nvge":"≥⃒","nvgt":">⃒","nvHarr":"⤄","nvinfin":"⧞","nvlArr":"⤂","nvle":"≤⃒","nvlt":"<⃒","nvltrie":"⊴⃒","nvrArr":"⤃","nvrtrie":"⊵⃒","nvsim":"∼⃒","nwarhk":"⤣","nwarr":"↖","nwArr":"⇖","nwarrow":"↖","nwnear":"⤧","Oacute":"Ó","oacute":"ó","oast":"⊛","Ocirc":"Ô","ocirc":"ô","ocir":"⊚","Ocy":"О","ocy":"о","odash":"⊝","Odblac":"Ő","odblac":"ő","odiv":"⨸","odot":"⊙","odsold":"⦼","OElig":"Œ","oelig":"œ","ofcir":"⦿","Ofr":"𝔒","ofr":"𝔬","ogon":"˛","Ograve":"Ò","ograve":"ò","ogt":"⧁","ohbar":"⦵","ohm":"Ω","oint":"∮","olarr":"↺","olcir":"⦾","olcross":"⦻","oline":"‾","olt":"⧀","Omacr":"Ō","omacr":"ō","Omega":"Ω","omega":"ω","Omicron":"Ο","omicron":"ο","omid":"⦶","ominus":"⊖","Oopf":"𝕆","oopf":"𝕠","opar":"⦷","OpenCurlyDoubleQuote":"“","OpenCurlyQuote":"‘","operp":"⦹","oplus":"⊕","orarr":"↻","Or":"⩔","or":"∨","ord":"⩝","order":"ℴ","orderof":"ℴ","ordf":"ª","ordm":"º","origof":"⊶","oror":"⩖","orslope":"⩗","orv":"⩛","oS":"Ⓢ","Oscr":"𝒪","oscr":"ℴ","Oslash":"Ø","oslash":"ø","osol":"⊘","Otilde":"Õ","otilde":"õ","otimesas":"⨶","Otimes":"⨷","otimes":"⊗","Ouml":"Ö","ouml":"ö","ovbar":"⌽","OverBar":"‾","OverBrace":"⏞","OverBracket":"⎴","OverParenthesis":"⏜","para":"¶","parallel":"∥","par":"∥","parsim":"⫳","parsl":"⫽","part":"∂","PartialD":"∂","Pcy":"П","pcy":"п","percnt":"%","period":".","permil":"‰","perp":"⊥","pertenk":"‱","Pfr":"𝔓","pfr":"𝔭","Phi":"Φ","phi":"φ","phiv":"ϕ","phmmat":"ℳ","phone":"☎","Pi":"Π","pi":"π","pitchfork":"⋔","piv":"ϖ","planck":"ℏ","planckh":"ℎ","plankv":"ℏ","plusacir":"⨣","plusb":"⊞","pluscir":"⨢","plus":"+","plusdo":"∔","plusdu":"⨥","pluse":"⩲","PlusMinus":"±","plusmn":"±","plussim":"⨦","plustwo":"⨧","pm":"±","Poincareplane":"ℌ","pointint":"⨕","popf":"𝕡","Popf":"ℙ","pound":"£","prap":"⪷","Pr":"⪻","pr":"≺","prcue":"≼","precapprox":"⪷","prec":"≺","preccurlyeq":"≼","Precedes":"≺","PrecedesEqual":"⪯","PrecedesSlantEqual":"≼","PrecedesTilde":"≾","preceq":"⪯","precnapprox":"⪹","precneqq":"⪵","precnsim":"⋨","pre":"⪯","prE":"⪳","precsim":"≾","prime":"′","Prime":"″","primes":"ℙ","prnap":"⪹","prnE":"⪵","prnsim":"⋨","prod":"∏","Product":"∏","profalar":"⌮","profline":"⌒","profsurf":"⌓","prop":"∝","Proportional":"∝","Proportion":"∷","propto":"∝","prsim":"≾","prurel":"⊰","Pscr":"𝒫","pscr":"𝓅","Psi":"Ψ","psi":"ψ","puncsp":" ","Qfr":"𝔔","qfr":"𝔮","qint":"⨌","qopf":"𝕢","Qopf":"ℚ","qprime":"⁗","Qscr":"𝒬","qscr":"𝓆","quaternions":"ℍ","quatint":"⨖","quest":"?","questeq":"≟","quot":"\\"","QUOT":"\\"","rAarr":"⇛","race":"∽̱","Racute":"Ŕ","racute":"ŕ","radic":"√","raemptyv":"⦳","rang":"⟩","Rang":"⟫","rangd":"⦒","range":"⦥","rangle":"⟩","raquo":"»","rarrap":"⥵","rarrb":"⇥","rarrbfs":"⤠","rarrc":"⤳","rarr":"→","Rarr":"↠","rArr":"⇒","rarrfs":"⤞","rarrhk":"↪","rarrlp":"↬","rarrpl":"⥅","rarrsim":"⥴","Rarrtl":"⤖","rarrtl":"↣","rarrw":"↝","ratail":"⤚","rAtail":"⤜","ratio":"∶","rationals":"ℚ","rbarr":"⤍","rBarr":"⤏","RBarr":"⤐","rbbrk":"❳","rbrace":"}","rbrack":"]","rbrke":"⦌","rbrksld":"⦎","rbrkslu":"⦐","Rcaron":"Ř","rcaron":"ř","Rcedil":"Ŗ","rcedil":"ŗ","rceil":"⌉","rcub":"}","Rcy":"Р","rcy":"р","rdca":"⤷","rdldhar":"⥩","rdquo":"”","rdquor":"”","rdsh":"↳","real":"ℜ","realine":"ℛ","realpart":"ℜ","reals":"ℝ","Re":"ℜ","rect":"▭","reg":"®","REG":"®","ReverseElement":"∋","ReverseEquilibrium":"⇋","ReverseUpEquilibrium":"⥯","rfisht":"⥽","rfloor":"⌋","rfr":"𝔯","Rfr":"ℜ","rHar":"⥤","rhard":"⇁","rharu":"⇀","rharul":"⥬","Rho":"Ρ","rho":"ρ","rhov":"ϱ","RightAngleBracket":"⟩","RightArrowBar":"⇥","rightarrow":"→","RightArrow":"→","Rightarrow":"⇒","RightArrowLeftArrow":"⇄","rightarrowtail":"↣","RightCeiling":"⌉","RightDoubleBracket":"⟧","RightDownTeeVector":"⥝","RightDownVectorBar":"⥕","RightDownVector":"⇂","RightFloor":"⌋","rightharpoondown":"⇁","rightharpoonup":"⇀","rightleftarrows":"⇄","rightleftharpoons":"⇌","rightrightarrows":"⇉","rightsquigarrow":"↝","RightTeeArrow":"↦","RightTee":"⊢","RightTeeVector":"⥛","rightthreetimes":"⋌","RightTriangleBar":"⧐","RightTriangle":"⊳","RightTriangleEqual":"⊵","RightUpDownVector":"⥏","RightUpTeeVector":"⥜","RightUpVectorBar":"⥔","RightUpVector":"↾","RightVectorBar":"⥓","RightVector":"⇀","ring":"˚","risingdotseq":"≓","rlarr":"⇄","rlhar":"⇌","rlm":"‏","rmoustache":"⎱","rmoust":"⎱","rnmid":"⫮","roang":"⟭","roarr":"⇾","robrk":"⟧","ropar":"⦆","ropf":"𝕣","Ropf":"ℝ","roplus":"⨮","rotimes":"⨵","RoundImplies":"⥰","rpar":")","rpargt":"⦔","rppolint":"⨒","rrarr":"⇉","Rrightarrow":"⇛","rsaquo":"›","rscr":"𝓇","Rscr":"ℛ","rsh":"↱","Rsh":"↱","rsqb":"]","rsquo":"’","rsquor":"’","rthree":"⋌","rtimes":"⋊","rtri":"▹","rtrie":"⊵","rtrif":"▸","rtriltri":"⧎","RuleDelayed":"⧴","ruluhar":"⥨","rx":"℞","Sacute":"Ś","sacute":"ś","sbquo":"‚","scap":"⪸","Scaron":"Š","scaron":"š","Sc":"⪼","sc":"≻","sccue":"≽","sce":"⪰","scE":"⪴","Scedil":"Ş","scedil":"ş","Scirc":"Ŝ","scirc":"ŝ","scnap":"⪺","scnE":"⪶","scnsim":"⋩","scpolint":"⨓","scsim":"≿","Scy":"С","scy":"с","sdotb":"⊡","sdot":"⋅","sdote":"⩦","searhk":"⤥","searr":"↘","seArr":"⇘","searrow":"↘","sect":"§","semi":";","seswar":"⤩","setminus":"∖","setmn":"∖","sext":"✶","Sfr":"𝔖","sfr":"𝔰","sfrown":"⌢","sharp":"♯","SHCHcy":"Щ","shchcy":"щ","SHcy":"Ш","shcy":"ш","ShortDownArrow":"↓","ShortLeftArrow":"←","shortmid":"∣","shortparallel":"∥","ShortRightArrow":"→","ShortUpArrow":"↑","shy":"­","Sigma":"Σ","sigma":"σ","sigmaf":"ς","sigmav":"ς","sim":"∼","simdot":"⩪","sime":"≃","simeq":"≃","simg":"⪞","simgE":"⪠","siml":"⪝","simlE":"⪟","simne":"≆","simplus":"⨤","simrarr":"⥲","slarr":"←","SmallCircle":"∘","smallsetminus":"∖","smashp":"⨳","smeparsl":"⧤","smid":"∣","smile":"⌣","smt":"⪪","smte":"⪬","smtes":"⪬︀","SOFTcy":"Ь","softcy":"ь","solbar":"⌿","solb":"⧄","sol":"/","Sopf":"𝕊","sopf":"𝕤","spades":"♠","spadesuit":"♠","spar":"∥","sqcap":"⊓","sqcaps":"⊓︀","sqcup":"⊔","sqcups":"⊔︀","Sqrt":"√","sqsub":"⊏","sqsube":"⊑","sqsubset":"⊏","sqsubseteq":"⊑","sqsup":"⊐","sqsupe":"⊒","sqsupset":"⊐","sqsupseteq":"⊒","square":"□","Square":"□","SquareIntersection":"⊓","SquareSubset":"⊏","SquareSubsetEqual":"⊑","SquareSuperset":"⊐","SquareSupersetEqual":"⊒","SquareUnion":"⊔","squarf":"▪","squ":"□","squf":"▪","srarr":"→","Sscr":"𝒮","sscr":"𝓈","ssetmn":"∖","ssmile":"⌣","sstarf":"⋆","Star":"⋆","star":"☆","starf":"★","straightepsilon":"ϵ","straightphi":"ϕ","strns":"¯","sub":"⊂","Sub":"⋐","subdot":"⪽","subE":"⫅","sube":"⊆","subedot":"⫃","submult":"⫁","subnE":"⫋","subne":"⊊","subplus":"⪿","subrarr":"⥹","subset":"⊂","Subset":"⋐","subseteq":"⊆","subseteqq":"⫅","SubsetEqual":"⊆","subsetneq":"⊊","subsetneqq":"⫋","subsim":"⫇","subsub":"⫕","subsup":"⫓","succapprox":"⪸","succ":"≻","succcurlyeq":"≽","Succeeds":"≻","SucceedsEqual":"⪰","SucceedsSlantEqual":"≽","SucceedsTilde":"≿","succeq":"⪰","succnapprox":"⪺","succneqq":"⪶","succnsim":"⋩","succsim":"≿","SuchThat":"∋","sum":"∑","Sum":"∑","sung":"♪","sup1":"¹","sup2":"²","sup3":"³","sup":"⊃","Sup":"⋑","supdot":"⪾","supdsub":"⫘","supE":"⫆","supe":"⊇","supedot":"⫄","Superset":"⊃","SupersetEqual":"⊇","suphsol":"⟉","suphsub":"⫗","suplarr":"⥻","supmult":"⫂","supnE":"⫌","supne":"⊋","supplus":"⫀","supset":"⊃","Supset":"⋑","supseteq":"⊇","supseteqq":"⫆","supsetneq":"⊋","supsetneqq":"⫌","supsim":"⫈","supsub":"⫔","supsup":"⫖","swarhk":"⤦","swarr":"↙","swArr":"⇙","swarrow":"↙","swnwar":"⤪","szlig":"ß","Tab":"\\t","target":"⌖","Tau":"Τ","tau":"τ","tbrk":"⎴","Tcaron":"Ť","tcaron":"ť","Tcedil":"Ţ","tcedil":"ţ","Tcy":"Т","tcy":"т","tdot":"⃛","telrec":"⌕","Tfr":"𝔗","tfr":"𝔱","there4":"∴","therefore":"∴","Therefore":"∴","Theta":"Θ","theta":"θ","thetasym":"ϑ","thetav":"ϑ","thickapprox":"≈","thicksim":"∼","ThickSpace":"  ","ThinSpace":" ","thinsp":" ","thkap":"≈","thksim":"∼","THORN":"Þ","thorn":"þ","tilde":"˜","Tilde":"∼","TildeEqual":"≃","TildeFullEqual":"≅","TildeTilde":"≈","timesbar":"⨱","timesb":"⊠","times":"×","timesd":"⨰","tint":"∭","toea":"⤨","topbot":"⌶","topcir":"⫱","top":"⊤","Topf":"𝕋","topf":"𝕥","topfork":"⫚","tosa":"⤩","tprime":"‴","trade":"™","TRADE":"™","triangle":"▵","triangledown":"▿","triangleleft":"◃","trianglelefteq":"⊴","triangleq":"≜","triangleright":"▹","trianglerighteq":"⊵","tridot":"◬","trie":"≜","triminus":"⨺","TripleDot":"⃛","triplus":"⨹","trisb":"⧍","tritime":"⨻","trpezium":"⏢","Tscr":"𝒯","tscr":"𝓉","TScy":"Ц","tscy":"ц","TSHcy":"Ћ","tshcy":"ћ","Tstrok":"Ŧ","tstrok":"ŧ","twixt":"≬","twoheadleftarrow":"↞","twoheadrightarrow":"↠","Uacute":"Ú","uacute":"ú","uarr":"↑","Uarr":"↟","uArr":"⇑","Uarrocir":"⥉","Ubrcy":"Ў","ubrcy":"ў","Ubreve":"Ŭ","ubreve":"ŭ","Ucirc":"Û","ucirc":"û","Ucy":"У","ucy":"у","udarr":"⇅","Udblac":"Ű","udblac":"ű","udhar":"⥮","ufisht":"⥾","Ufr":"𝔘","ufr":"𝔲","Ugrave":"Ù","ugrave":"ù","uHar":"⥣","uharl":"↿","uharr":"↾","uhblk":"▀","ulcorn":"⌜","ulcorner":"⌜","ulcrop":"⌏","ultri":"◸","Umacr":"Ū","umacr":"ū","uml":"¨","UnderBar":"_","UnderBrace":"⏟","UnderBracket":"⎵","UnderParenthesis":"⏝","Union":"⋃","UnionPlus":"⊎","Uogon":"Ų","uogon":"ų","Uopf":"𝕌","uopf":"𝕦","UpArrowBar":"⤒","uparrow":"↑","UpArrow":"↑","Uparrow":"⇑","UpArrowDownArrow":"⇅","updownarrow":"↕","UpDownArrow":"↕","Updownarrow":"⇕","UpEquilibrium":"⥮","upharpoonleft":"↿","upharpoonright":"↾","uplus":"⊎","UpperLeftArrow":"↖","UpperRightArrow":"↗","upsi":"υ","Upsi":"ϒ","upsih":"ϒ","Upsilon":"Υ","upsilon":"υ","UpTeeArrow":"↥","UpTee":"⊥","upuparrows":"⇈","urcorn":"⌝","urcorner":"⌝","urcrop":"⌎","Uring":"Ů","uring":"ů","urtri":"◹","Uscr":"𝒰","uscr":"𝓊","utdot":"⋰","Utilde":"Ũ","utilde":"ũ","utri":"▵","utrif":"▴","uuarr":"⇈","Uuml":"Ü","uuml":"ü","uwangle":"⦧","vangrt":"⦜","varepsilon":"ϵ","varkappa":"ϰ","varnothing":"∅","varphi":"ϕ","varpi":"ϖ","varpropto":"∝","varr":"↕","vArr":"⇕","varrho":"ϱ","varsigma":"ς","varsubsetneq":"⊊︀","varsubsetneqq":"⫋︀","varsupsetneq":"⊋︀","varsupsetneqq":"⫌︀","vartheta":"ϑ","vartriangleleft":"⊲","vartriangleright":"⊳","vBar":"⫨","Vbar":"⫫","vBarv":"⫩","Vcy":"В","vcy":"в","vdash":"⊢","vDash":"⊨","Vdash":"⊩","VDash":"⊫","Vdashl":"⫦","veebar":"⊻","vee":"∨","Vee":"⋁","veeeq":"≚","vellip":"⋮","verbar":"|","Verbar":"‖","vert":"|","Vert":"‖","VerticalBar":"∣","VerticalLine":"|","VerticalSeparator":"❘","VerticalTilde":"≀","VeryThinSpace":" ","Vfr":"𝔙","vfr":"𝔳","vltri":"⊲","vnsub":"⊂⃒","vnsup":"⊃⃒","Vopf":"𝕍","vopf":"𝕧","vprop":"∝","vrtri":"⊳","Vscr":"𝒱","vscr":"𝓋","vsubnE":"⫋︀","vsubne":"⊊︀","vsupnE":"⫌︀","vsupne":"⊋︀","Vvdash":"⊪","vzigzag":"⦚","Wcirc":"Ŵ","wcirc":"ŵ","wedbar":"⩟","wedge":"∧","Wedge":"⋀","wedgeq":"≙","weierp":"℘","Wfr":"𝔚","wfr":"𝔴","Wopf":"𝕎","wopf":"𝕨","wp":"℘","wr":"≀","wreath":"≀","Wscr":"𝒲","wscr":"𝓌","xcap":"⋂","xcirc":"◯","xcup":"⋃","xdtri":"▽","Xfr":"𝔛","xfr":"𝔵","xharr":"⟷","xhArr":"⟺","Xi":"Ξ","xi":"ξ","xlarr":"⟵","xlArr":"⟸","xmap":"⟼","xnis":"⋻","xodot":"⨀","Xopf":"𝕏","xopf":"𝕩","xoplus":"⨁","xotime":"⨂","xrarr":"⟶","xrArr":"⟹","Xscr":"𝒳","xscr":"𝓍","xsqcup":"⨆","xuplus":"⨄","xutri":"△","xvee":"⋁","xwedge":"⋀","Yacute":"Ý","yacute":"ý","YAcy":"Я","yacy":"я","Ycirc":"Ŷ","ycirc":"ŷ","Ycy":"Ы","ycy":"ы","yen":"¥","Yfr":"𝔜","yfr":"𝔶","YIcy":"Ї","yicy":"ї","Yopf":"𝕐","yopf":"𝕪","Yscr":"𝒴","yscr":"𝓎","YUcy":"Ю","yucy":"ю","yuml":"ÿ","Yuml":"Ÿ","Zacute":"Ź","zacute":"ź","Zcaron":"Ž","zcaron":"ž","Zcy":"З","zcy":"з","Zdot":"Ż","zdot":"ż","zeetrf":"ℨ","ZeroWidthSpace":"​","Zeta":"Ζ","zeta":"ζ","zfr":"𝔷","Zfr":"ℨ","ZHcy":"Ж","zhcy":"ж","zigrarr":"⇝","zopf":"𝕫","Zopf":"ℤ","Zscr":"𝒵","zscr":"𝓏","zwj":"‍","zwnj":"‌"}');

/***/ }),

/***/ 96808:
/***/ ((module) => {

"use strict";
module.exports = JSON.parse('{"name":"shaka","type":"adapter","tech":"js","author":"Nice People At Work","version":"6.8.11","built":"2024-08-21","repo":"https://bitbucket.org/npaw/shaka-adapter-js","libVersion":"^6.8.57","features":{"buffer":"native","seek":"native","error":true,"stop":true,"pause":true,"resume":true,"getters":["getPlayhead","getPlayrate","getFramesPerSecond","getDroppedFrames","getDuration","getBitrate","getThroughput","getRendition","getTitle","getIsLive","getResource","getPlayerVersion","getLatency"]},"ads":[]}');

/***/ })

}]);